(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire50de"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire50de"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g8xkP", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bbf74056e2102bf6$export$ffb0004e005737fa; }, function (v) { return $bbf74056e2102bf6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bbf74056e2102bf6$export$34b9dba7ce09269b; }, function (v) { return $bbf74056e2102bf6$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bbf74056e2102bf6$export$25062201e9e25d76; }, function (v) { return $bbf74056e2102bf6$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bbf74056e2102bf6$export$ffb0004e005737fa;
var $bbf74056e2102bf6$export$34b9dba7ce09269b;
var $bbf74056e2102bf6$export$25062201e9e25d76;
'use strict';

var $igtsr = parcelRequire("igtsr");
var $bbf74056e2102bf6$var$k = Symbol.for("react.element"), $bbf74056e2102bf6$var$l = Symbol.for("react.fragment"), $bbf74056e2102bf6$var$m = Object.prototype.hasOwnProperty, $bbf74056e2102bf6$var$n = $igtsr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bbf74056e2102bf6$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bbf74056e2102bf6$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$bbf74056e2102bf6$var$m.call(a, b) && !$bbf74056e2102bf6$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bbf74056e2102bf6$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $bbf74056e2102bf6$var$n.current
    };
}
$bbf74056e2102bf6$export$ffb0004e005737fa = $bbf74056e2102bf6$var$l;
$bbf74056e2102bf6$export$34b9dba7ce09269b = $bbf74056e2102bf6$var$q;
$bbf74056e2102bf6$export$25062201e9e25d76 = $bbf74056e2102bf6$var$q;

});
parcelRegister("igtsr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4B5rv"));

});
parcelRegister("4B5rv", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $358ed6eb33870a91$export$dca3b0875bd9a954; }, function (v) { return $358ed6eb33870a91$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $358ed6eb33870a91$export$16fa2f45be04daa8; }, function (v) { return $358ed6eb33870a91$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $358ed6eb33870a91$export$ffb0004e005737fa; }, function (v) { return $358ed6eb33870a91$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $358ed6eb33870a91$export$e2c29f18771995cb; }, function (v) { return $358ed6eb33870a91$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $358ed6eb33870a91$export$221d75b3f55bb0bd; }, function (v) { return $358ed6eb33870a91$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $358ed6eb33870a91$export$5f8d39834fd61797; }, function (v) { return $358ed6eb33870a91$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $358ed6eb33870a91$export$74bf444e3cd11ea5; }, function (v) { return $358ed6eb33870a91$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $358ed6eb33870a91$export$ae55be85d98224ed; }, function (v) { return $358ed6eb33870a91$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $358ed6eb33870a91$export$3ba232387fd5d6dd; }, function (v) { return $358ed6eb33870a91$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $358ed6eb33870a91$export$e530037191fcd5d7; }, function (v) { return $358ed6eb33870a91$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $358ed6eb33870a91$export$fd42f52fd3ae1109; }, function (v) { return $358ed6eb33870a91$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $358ed6eb33870a91$export$c8a8987d4410bf2d; }, function (v) { return $358ed6eb33870a91$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $358ed6eb33870a91$export$d38cd72104c1f0e9; }, function (v) { return $358ed6eb33870a91$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $358ed6eb33870a91$export$7d1e3a5e95ceca43; }, function (v) { return $358ed6eb33870a91$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $358ed6eb33870a91$export$257a8862b851cb5b; }, function (v) { return $358ed6eb33870a91$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $358ed6eb33870a91$export$a8257692ac88316c; }, function (v) { return $358ed6eb33870a91$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $358ed6eb33870a91$export$488013bae63b21da; }, function (v) { return $358ed6eb33870a91$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $358ed6eb33870a91$export$7c73462e0d25e514; }, function (v) { return $358ed6eb33870a91$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $358ed6eb33870a91$export$7568632d0d33d16d; }, function (v) { return $358ed6eb33870a91$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $358ed6eb33870a91$export$88948ce120ea2619; }, function (v) { return $358ed6eb33870a91$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $358ed6eb33870a91$export$35808ee640e87ca7; }, function (v) { return $358ed6eb33870a91$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $358ed6eb33870a91$export$fae74005e78b1a27; }, function (v) { return $358ed6eb33870a91$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $358ed6eb33870a91$export$dc8fbce3eb94dc1e; }, function (v) { return $358ed6eb33870a91$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $358ed6eb33870a91$export$6a7bc4e911dc01cf; }, function (v) { return $358ed6eb33870a91$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $358ed6eb33870a91$export$6d9c69b0de29b591; }, function (v) { return $358ed6eb33870a91$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $358ed6eb33870a91$export$f680877a34711e37; }, function (v) { return $358ed6eb33870a91$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $358ed6eb33870a91$export$d5a552a76deda3c2; }, function (v) { return $358ed6eb33870a91$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $358ed6eb33870a91$export$aaabe4eda9ed9969; }, function (v) { return $358ed6eb33870a91$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $358ed6eb33870a91$export$e5c5a5f917a5871c; }, function (v) { return $358ed6eb33870a91$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $358ed6eb33870a91$export$1538c33de8887b59; }, function (v) { return $358ed6eb33870a91$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $358ed6eb33870a91$export$13e3392192263954; }, function (v) { return $358ed6eb33870a91$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $358ed6eb33870a91$export$b8f5890fc79d6aca; }, function (v) { return $358ed6eb33870a91$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $358ed6eb33870a91$export$60241385465d0a34; }, function (v) { return $358ed6eb33870a91$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $358ed6eb33870a91$export$306c0aa65ff9ec16; }, function (v) { return $358ed6eb33870a91$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $358ed6eb33870a91$export$7b286972b8d8ccbf; }, function (v) { return $358ed6eb33870a91$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $358ed6eb33870a91$export$83d89fbfd8236492; }, function (v) { return $358ed6eb33870a91$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $358ed6eb33870a91$export$dca3b0875bd9a954;
var $358ed6eb33870a91$export$16fa2f45be04daa8;
var $358ed6eb33870a91$export$ffb0004e005737fa;
var $358ed6eb33870a91$export$e2c29f18771995cb;
var $358ed6eb33870a91$export$221d75b3f55bb0bd;
var $358ed6eb33870a91$export$5f8d39834fd61797;
var $358ed6eb33870a91$export$74bf444e3cd11ea5;
var $358ed6eb33870a91$export$ae55be85d98224ed;
var $358ed6eb33870a91$export$3ba232387fd5d6dd;
var $358ed6eb33870a91$export$e530037191fcd5d7;
var $358ed6eb33870a91$export$fd42f52fd3ae1109;
var $358ed6eb33870a91$export$c8a8987d4410bf2d;
var $358ed6eb33870a91$export$d38cd72104c1f0e9;
var $358ed6eb33870a91$export$7d1e3a5e95ceca43;
var $358ed6eb33870a91$export$257a8862b851cb5b;
var $358ed6eb33870a91$export$a8257692ac88316c;
var $358ed6eb33870a91$export$488013bae63b21da;
var $358ed6eb33870a91$export$7c73462e0d25e514;
var $358ed6eb33870a91$export$7568632d0d33d16d;
var $358ed6eb33870a91$export$88948ce120ea2619;
var $358ed6eb33870a91$export$35808ee640e87ca7;
var $358ed6eb33870a91$export$fae74005e78b1a27;
var $358ed6eb33870a91$export$dc8fbce3eb94dc1e;
var $358ed6eb33870a91$export$6a7bc4e911dc01cf;
var $358ed6eb33870a91$export$6d9c69b0de29b591;
var $358ed6eb33870a91$export$f680877a34711e37;
var $358ed6eb33870a91$export$d5a552a76deda3c2;
var $358ed6eb33870a91$export$aaabe4eda9ed9969;
var $358ed6eb33870a91$export$e5c5a5f917a5871c;
var $358ed6eb33870a91$export$1538c33de8887b59;
var $358ed6eb33870a91$export$13e3392192263954;
var $358ed6eb33870a91$export$b8f5890fc79d6aca;
var $358ed6eb33870a91$export$60241385465d0a34;
var $358ed6eb33870a91$export$306c0aa65ff9ec16;
var $358ed6eb33870a91$export$7b286972b8d8ccbf;
var $358ed6eb33870a91$export$83d89fbfd8236492;
'use strict';
var $358ed6eb33870a91$var$l = Symbol.for("react.element"), $358ed6eb33870a91$var$n = Symbol.for("react.portal"), $358ed6eb33870a91$var$p = Symbol.for("react.fragment"), $358ed6eb33870a91$var$q = Symbol.for("react.strict_mode"), $358ed6eb33870a91$var$r = Symbol.for("react.profiler"), $358ed6eb33870a91$var$t = Symbol.for("react.provider"), $358ed6eb33870a91$var$u = Symbol.for("react.context"), $358ed6eb33870a91$var$v = Symbol.for("react.forward_ref"), $358ed6eb33870a91$var$w = Symbol.for("react.suspense"), $358ed6eb33870a91$var$x = Symbol.for("react.memo"), $358ed6eb33870a91$var$y = Symbol.for("react.lazy"), $358ed6eb33870a91$var$z = Symbol.iterator;
function $358ed6eb33870a91$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $358ed6eb33870a91$var$z && a[$358ed6eb33870a91$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $358ed6eb33870a91$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $358ed6eb33870a91$var$C = Object.assign, $358ed6eb33870a91$var$D = {};
function $358ed6eb33870a91$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $358ed6eb33870a91$var$D;
    this.updater = e || $358ed6eb33870a91$var$B;
}
$358ed6eb33870a91$var$E.prototype.isReactComponent = {};
$358ed6eb33870a91$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$358ed6eb33870a91$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $358ed6eb33870a91$var$F() {}
$358ed6eb33870a91$var$F.prototype = $358ed6eb33870a91$var$E.prototype;
function $358ed6eb33870a91$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $358ed6eb33870a91$var$D;
    this.updater = e || $358ed6eb33870a91$var$B;
}
var $358ed6eb33870a91$var$H = $358ed6eb33870a91$var$G.prototype = new $358ed6eb33870a91$var$F;
$358ed6eb33870a91$var$H.constructor = $358ed6eb33870a91$var$G;
$358ed6eb33870a91$var$C($358ed6eb33870a91$var$H, $358ed6eb33870a91$var$E.prototype);
$358ed6eb33870a91$var$H.isPureReactComponent = !0;
var $358ed6eb33870a91$var$I = Array.isArray, $358ed6eb33870a91$var$J = Object.prototype.hasOwnProperty, $358ed6eb33870a91$var$K = {
    current: null
}, $358ed6eb33870a91$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $358ed6eb33870a91$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$358ed6eb33870a91$var$J.call(b, d) && !$358ed6eb33870a91$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $358ed6eb33870a91$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $358ed6eb33870a91$var$K.current
    };
}
function $358ed6eb33870a91$var$N(a, b) {
    return {
        $$typeof: $358ed6eb33870a91$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $358ed6eb33870a91$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $358ed6eb33870a91$var$l;
}
function $358ed6eb33870a91$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $358ed6eb33870a91$var$P = /\/+/g;
function $358ed6eb33870a91$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $358ed6eb33870a91$var$escape("" + a.key) : b.toString(36);
}
function $358ed6eb33870a91$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $358ed6eb33870a91$var$l:
                case $358ed6eb33870a91$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $358ed6eb33870a91$var$Q(h, 0) : d, $358ed6eb33870a91$var$I(c) ? (e = "", null != a && (e = a.replace($358ed6eb33870a91$var$P, "$&/") + "/"), $358ed6eb33870a91$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($358ed6eb33870a91$var$O(c) && (c = $358ed6eb33870a91$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($358ed6eb33870a91$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($358ed6eb33870a91$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $358ed6eb33870a91$var$Q(k, g);
        h += $358ed6eb33870a91$var$R(k, b, e, f, c);
    }
    else if (f = $358ed6eb33870a91$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $358ed6eb33870a91$var$Q(k, g++), h += $358ed6eb33870a91$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $358ed6eb33870a91$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $358ed6eb33870a91$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $358ed6eb33870a91$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $358ed6eb33870a91$var$U = {
    current: null
}, $358ed6eb33870a91$var$V = {
    transition: null
}, $358ed6eb33870a91$var$W = {
    ReactCurrentDispatcher: $358ed6eb33870a91$var$U,
    ReactCurrentBatchConfig: $358ed6eb33870a91$var$V,
    ReactCurrentOwner: $358ed6eb33870a91$var$K
};
function $358ed6eb33870a91$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$358ed6eb33870a91$export$dca3b0875bd9a954 = {
    map: $358ed6eb33870a91$var$S,
    forEach: function(a, b, e) {
        $358ed6eb33870a91$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $358ed6eb33870a91$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $358ed6eb33870a91$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$358ed6eb33870a91$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$358ed6eb33870a91$export$16fa2f45be04daa8 = $358ed6eb33870a91$var$E;
$358ed6eb33870a91$export$ffb0004e005737fa = $358ed6eb33870a91$var$p;
$358ed6eb33870a91$export$e2c29f18771995cb = $358ed6eb33870a91$var$r;
$358ed6eb33870a91$export$221d75b3f55bb0bd = $358ed6eb33870a91$var$G;
$358ed6eb33870a91$export$5f8d39834fd61797 = $358ed6eb33870a91$var$q;
$358ed6eb33870a91$export$74bf444e3cd11ea5 = $358ed6eb33870a91$var$w;
$358ed6eb33870a91$export$ae55be85d98224ed = $358ed6eb33870a91$var$W;
$358ed6eb33870a91$export$3ba232387fd5d6dd = $358ed6eb33870a91$var$X;
$358ed6eb33870a91$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $358ed6eb33870a91$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $358ed6eb33870a91$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$358ed6eb33870a91$var$J.call(b, f) && !$358ed6eb33870a91$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $358ed6eb33870a91$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$358ed6eb33870a91$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $358ed6eb33870a91$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $358ed6eb33870a91$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$358ed6eb33870a91$export$c8a8987d4410bf2d = $358ed6eb33870a91$var$M;
$358ed6eb33870a91$export$d38cd72104c1f0e9 = function(a) {
    var b = $358ed6eb33870a91$var$M.bind(null, a);
    b.type = a;
    return b;
};
$358ed6eb33870a91$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$358ed6eb33870a91$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $358ed6eb33870a91$var$v,
        render: a
    };
};
$358ed6eb33870a91$export$a8257692ac88316c = $358ed6eb33870a91$var$O;
$358ed6eb33870a91$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $358ed6eb33870a91$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $358ed6eb33870a91$var$T
    };
};
$358ed6eb33870a91$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $358ed6eb33870a91$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$358ed6eb33870a91$export$7568632d0d33d16d = function(a) {
    var b = $358ed6eb33870a91$var$V.transition;
    $358ed6eb33870a91$var$V.transition = {};
    try {
        a();
    } finally{
        $358ed6eb33870a91$var$V.transition = b;
    }
};
$358ed6eb33870a91$export$88948ce120ea2619 = $358ed6eb33870a91$var$X;
$358ed6eb33870a91$export$35808ee640e87ca7 = function(a, b) {
    return $358ed6eb33870a91$var$U.current.useCallback(a, b);
};
$358ed6eb33870a91$export$fae74005e78b1a27 = function(a) {
    return $358ed6eb33870a91$var$U.current.useContext(a);
};
$358ed6eb33870a91$export$dc8fbce3eb94dc1e = function() {};
$358ed6eb33870a91$export$6a7bc4e911dc01cf = function(a) {
    return $358ed6eb33870a91$var$U.current.useDeferredValue(a);
};
$358ed6eb33870a91$export$6d9c69b0de29b591 = function(a, b) {
    return $358ed6eb33870a91$var$U.current.useEffect(a, b);
};
$358ed6eb33870a91$export$f680877a34711e37 = function() {
    return $358ed6eb33870a91$var$U.current.useId();
};
$358ed6eb33870a91$export$d5a552a76deda3c2 = function(a, b, e) {
    return $358ed6eb33870a91$var$U.current.useImperativeHandle(a, b, e);
};
$358ed6eb33870a91$export$aaabe4eda9ed9969 = function(a, b) {
    return $358ed6eb33870a91$var$U.current.useInsertionEffect(a, b);
};
$358ed6eb33870a91$export$e5c5a5f917a5871c = function(a, b) {
    return $358ed6eb33870a91$var$U.current.useLayoutEffect(a, b);
};
$358ed6eb33870a91$export$1538c33de8887b59 = function(a, b) {
    return $358ed6eb33870a91$var$U.current.useMemo(a, b);
};
$358ed6eb33870a91$export$13e3392192263954 = function(a, b, e) {
    return $358ed6eb33870a91$var$U.current.useReducer(a, b, e);
};
$358ed6eb33870a91$export$b8f5890fc79d6aca = function(a) {
    return $358ed6eb33870a91$var$U.current.useRef(a);
};
$358ed6eb33870a91$export$60241385465d0a34 = function(a) {
    return $358ed6eb33870a91$var$U.current.useState(a);
};
$358ed6eb33870a91$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $358ed6eb33870a91$var$U.current.useSyncExternalStore(a, b, e);
};
$358ed6eb33870a91$export$7b286972b8d8ccbf = function() {
    return $358ed6eb33870a91$var$U.current.useTransition();
};
$358ed6eb33870a91$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("ccHvx", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8e285ac053bcfb61$export$ae55be85d98224ed; }, function (v) { return $8e285ac053bcfb61$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $8e285ac053bcfb61$export$d39a5bbd09211389; }, function (v) { return $8e285ac053bcfb61$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $8e285ac053bcfb61$export$882461b6382ed46c; }, function (v) { return $8e285ac053bcfb61$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $8e285ac053bcfb61$export$466bfc07425424d5; }, function (v) { return $8e285ac053bcfb61$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $8e285ac053bcfb61$export$cd75ccfd720a3cd4; }, function (v) { return $8e285ac053bcfb61$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $8e285ac053bcfb61$export$fa8d919ba61d84db; }, function (v) { return $8e285ac053bcfb61$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8e285ac053bcfb61$export$757ceba2d55c277e; }, function (v) { return $8e285ac053bcfb61$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $8e285ac053bcfb61$export$b3890eb0ae9dca99; }, function (v) { return $8e285ac053bcfb61$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $8e285ac053bcfb61$export$502457920280e6be; }, function (v) { return $8e285ac053bcfb61$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $8e285ac053bcfb61$export$c78a37762a8d58e1; }, function (v) { return $8e285ac053bcfb61$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $8e285ac053bcfb61$export$dc54d992c10e8a18; }, function (v) { return $8e285ac053bcfb61$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $8e285ac053bcfb61$export$83d89fbfd8236492; }, function (v) { return $8e285ac053bcfb61$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8e285ac053bcfb61$export$ae55be85d98224ed;
var $8e285ac053bcfb61$export$d39a5bbd09211389;
var $8e285ac053bcfb61$export$882461b6382ed46c;
var $8e285ac053bcfb61$export$466bfc07425424d5;
var $8e285ac053bcfb61$export$cd75ccfd720a3cd4;
var $8e285ac053bcfb61$export$fa8d919ba61d84db;
var $8e285ac053bcfb61$export$757ceba2d55c277e;
var $8e285ac053bcfb61$export$b3890eb0ae9dca99;
var $8e285ac053bcfb61$export$502457920280e6be;
var $8e285ac053bcfb61$export$c78a37762a8d58e1;
var $8e285ac053bcfb61$export$dc54d992c10e8a18;
var $8e285ac053bcfb61$export$83d89fbfd8236492;
'use strict';

var $igtsr = parcelRequire("igtsr");

var $2m3dj = parcelRequire("2m3dj");
function $8e285ac053bcfb61$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8e285ac053bcfb61$var$da = new Set, $8e285ac053bcfb61$var$ea = {};
function $8e285ac053bcfb61$var$fa(a, b) {
    $8e285ac053bcfb61$var$ha(a, b);
    $8e285ac053bcfb61$var$ha(a + "Capture", b);
}
function $8e285ac053bcfb61$var$ha(a, b) {
    $8e285ac053bcfb61$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$8e285ac053bcfb61$var$da.add(b[a]);
}
var $8e285ac053bcfb61$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8e285ac053bcfb61$var$ja = Object.prototype.hasOwnProperty, $8e285ac053bcfb61$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $8e285ac053bcfb61$var$la = {}, $8e285ac053bcfb61$var$ma = {};
function $8e285ac053bcfb61$var$oa(a) {
    if ($8e285ac053bcfb61$var$ja.call($8e285ac053bcfb61$var$ma, a)) return !0;
    if ($8e285ac053bcfb61$var$ja.call($8e285ac053bcfb61$var$la, a)) return !1;
    if ($8e285ac053bcfb61$var$ka.test(a)) return $8e285ac053bcfb61$var$ma[a] = !0;
    $8e285ac053bcfb61$var$la[a] = !0;
    return !1;
}
function $8e285ac053bcfb61$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $8e285ac053bcfb61$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $8e285ac053bcfb61$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $8e285ac053bcfb61$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $8e285ac053bcfb61$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $8e285ac053bcfb61$var$z[b] = new $8e285ac053bcfb61$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $8e285ac053bcfb61$var$ra = /[\-:]([a-z])/g;
function $8e285ac053bcfb61$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($8e285ac053bcfb61$var$ra, $8e285ac053bcfb61$var$sa);
    $8e285ac053bcfb61$var$z[b] = new $8e285ac053bcfb61$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($8e285ac053bcfb61$var$ra, $8e285ac053bcfb61$var$sa);
    $8e285ac053bcfb61$var$z[b] = new $8e285ac053bcfb61$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($8e285ac053bcfb61$var$ra, $8e285ac053bcfb61$var$sa);
    $8e285ac053bcfb61$var$z[b] = new $8e285ac053bcfb61$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$8e285ac053bcfb61$var$z.xlinkHref = new $8e285ac053bcfb61$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $8e285ac053bcfb61$var$z[a] = new $8e285ac053bcfb61$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $8e285ac053bcfb61$var$ta(a, b, c, d) {
    var e = $8e285ac053bcfb61$var$z.hasOwnProperty(b) ? $8e285ac053bcfb61$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $8e285ac053bcfb61$var$qa(b, c, e, d) && (c = null), d || null === e ? $8e285ac053bcfb61$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $8e285ac053bcfb61$var$ua = $igtsr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $8e285ac053bcfb61$var$va = Symbol.for("react.element"), $8e285ac053bcfb61$var$wa = Symbol.for("react.portal"), $8e285ac053bcfb61$var$ya = Symbol.for("react.fragment"), $8e285ac053bcfb61$var$za = Symbol.for("react.strict_mode"), $8e285ac053bcfb61$var$Aa = Symbol.for("react.profiler"), $8e285ac053bcfb61$var$Ba = Symbol.for("react.provider"), $8e285ac053bcfb61$var$Ca = Symbol.for("react.context"), $8e285ac053bcfb61$var$Da = Symbol.for("react.forward_ref"), $8e285ac053bcfb61$var$Ea = Symbol.for("react.suspense"), $8e285ac053bcfb61$var$Fa = Symbol.for("react.suspense_list"), $8e285ac053bcfb61$var$Ga = Symbol.for("react.memo"), $8e285ac053bcfb61$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $8e285ac053bcfb61$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $8e285ac053bcfb61$var$Ja = Symbol.iterator;
function $8e285ac053bcfb61$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8e285ac053bcfb61$var$Ja && a[$8e285ac053bcfb61$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8e285ac053bcfb61$var$A = Object.assign, $8e285ac053bcfb61$var$La;
function $8e285ac053bcfb61$var$Ma(a) {
    if (void 0 === $8e285ac053bcfb61$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $8e285ac053bcfb61$var$La = b && b[1] || "";
    }
    return "\n" + $8e285ac053bcfb61$var$La + a;
}
var $8e285ac053bcfb61$var$Na = !1;
function $8e285ac053bcfb61$var$Oa(a, b) {
    if (!a || $8e285ac053bcfb61$var$Na) return "";
    $8e285ac053bcfb61$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $8e285ac053bcfb61$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $8e285ac053bcfb61$var$Ma(a) : "";
}
function $8e285ac053bcfb61$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $8e285ac053bcfb61$var$Ma(a.type);
        case 16:
            return $8e285ac053bcfb61$var$Ma("Lazy");
        case 13:
            return $8e285ac053bcfb61$var$Ma("Suspense");
        case 19:
            return $8e285ac053bcfb61$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $8e285ac053bcfb61$var$Oa(a.type, !1), a;
        case 11:
            return a = $8e285ac053bcfb61$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $8e285ac053bcfb61$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $8e285ac053bcfb61$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $8e285ac053bcfb61$var$ya:
            return "Fragment";
        case $8e285ac053bcfb61$var$wa:
            return "Portal";
        case $8e285ac053bcfb61$var$Aa:
            return "Profiler";
        case $8e285ac053bcfb61$var$za:
            return "StrictMode";
        case $8e285ac053bcfb61$var$Ea:
            return "Suspense";
        case $8e285ac053bcfb61$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $8e285ac053bcfb61$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $8e285ac053bcfb61$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $8e285ac053bcfb61$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $8e285ac053bcfb61$var$Ga:
            return b = a.displayName || null, null !== b ? b : $8e285ac053bcfb61$var$Qa(a.type) || "Memo";
        case $8e285ac053bcfb61$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $8e285ac053bcfb61$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $8e285ac053bcfb61$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $8e285ac053bcfb61$var$Qa(b);
        case 8:
            return b === $8e285ac053bcfb61$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $8e285ac053bcfb61$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $8e285ac053bcfb61$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $8e285ac053bcfb61$var$Ua(a) {
    var b = $8e285ac053bcfb61$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $8e285ac053bcfb61$var$Va(a) {
    a._valueTracker || (a._valueTracker = $8e285ac053bcfb61$var$Ua(a));
}
function $8e285ac053bcfb61$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $8e285ac053bcfb61$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $8e285ac053bcfb61$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $8e285ac053bcfb61$var$Ya(a, b) {
    var c = b.checked;
    return $8e285ac053bcfb61$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $8e285ac053bcfb61$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $8e285ac053bcfb61$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $8e285ac053bcfb61$var$ab(a, b) {
    b = b.checked;
    null != b && $8e285ac053bcfb61$var$ta(a, "checked", b, !1);
}
function $8e285ac053bcfb61$var$bb(a, b) {
    $8e285ac053bcfb61$var$ab(a, b);
    var c = $8e285ac053bcfb61$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $8e285ac053bcfb61$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $8e285ac053bcfb61$var$cb(a, b.type, $8e285ac053bcfb61$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $8e285ac053bcfb61$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $8e285ac053bcfb61$var$cb(a, b, c) {
    if ("number" !== b || $8e285ac053bcfb61$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $8e285ac053bcfb61$var$eb = Array.isArray;
function $8e285ac053bcfb61$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $8e285ac053bcfb61$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $8e285ac053bcfb61$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($8e285ac053bcfb61$var$p(91));
    return $8e285ac053bcfb61$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $8e285ac053bcfb61$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($8e285ac053bcfb61$var$p(92));
            if ($8e285ac053bcfb61$var$eb(c)) {
                if (1 < c.length) throw Error($8e285ac053bcfb61$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $8e285ac053bcfb61$var$Sa(c)
    };
}
function $8e285ac053bcfb61$var$ib(a, b) {
    var c = $8e285ac053bcfb61$var$Sa(b.value), d = $8e285ac053bcfb61$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $8e285ac053bcfb61$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $8e285ac053bcfb61$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $8e285ac053bcfb61$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $8e285ac053bcfb61$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $8e285ac053bcfb61$var$mb, $8e285ac053bcfb61$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $8e285ac053bcfb61$var$mb = $8e285ac053bcfb61$var$mb || document.createElement("div");
        $8e285ac053bcfb61$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $8e285ac053bcfb61$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $8e285ac053bcfb61$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $8e285ac053bcfb61$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $8e285ac053bcfb61$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($8e285ac053bcfb61$var$pb).forEach(function(a) {
    $8e285ac053bcfb61$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $8e285ac053bcfb61$var$pb[b] = $8e285ac053bcfb61$var$pb[a];
    });
});
function $8e285ac053bcfb61$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $8e285ac053bcfb61$var$pb.hasOwnProperty(a) && $8e285ac053bcfb61$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $8e285ac053bcfb61$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $8e285ac053bcfb61$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $8e285ac053bcfb61$var$tb = $8e285ac053bcfb61$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $8e285ac053bcfb61$var$ub(a, b) {
    if (b) {
        if ($8e285ac053bcfb61$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($8e285ac053bcfb61$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($8e285ac053bcfb61$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($8e285ac053bcfb61$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($8e285ac053bcfb61$var$p(62));
    }
}
function $8e285ac053bcfb61$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8e285ac053bcfb61$var$wb = null;
function $8e285ac053bcfb61$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $8e285ac053bcfb61$var$yb = null, $8e285ac053bcfb61$var$zb = null, $8e285ac053bcfb61$var$Ab = null;
function $8e285ac053bcfb61$var$Bb(a) {
    if (a = $8e285ac053bcfb61$var$Cb(a)) {
        if ("function" !== typeof $8e285ac053bcfb61$var$yb) throw Error($8e285ac053bcfb61$var$p(280));
        var b = a.stateNode;
        b && (b = $8e285ac053bcfb61$var$Db(b), $8e285ac053bcfb61$var$yb(a.stateNode, a.type, b));
    }
}
function $8e285ac053bcfb61$var$Eb(a) {
    $8e285ac053bcfb61$var$zb ? $8e285ac053bcfb61$var$Ab ? $8e285ac053bcfb61$var$Ab.push(a) : $8e285ac053bcfb61$var$Ab = [
        a
    ] : $8e285ac053bcfb61$var$zb = a;
}
function $8e285ac053bcfb61$var$Fb() {
    if ($8e285ac053bcfb61$var$zb) {
        var a = $8e285ac053bcfb61$var$zb, b = $8e285ac053bcfb61$var$Ab;
        $8e285ac053bcfb61$var$Ab = $8e285ac053bcfb61$var$zb = null;
        $8e285ac053bcfb61$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$8e285ac053bcfb61$var$Bb(b[a]);
    }
}
function $8e285ac053bcfb61$var$Gb(a, b) {
    return a(b);
}
function $8e285ac053bcfb61$var$Hb() {}
var $8e285ac053bcfb61$var$Ib = !1;
function $8e285ac053bcfb61$var$Jb(a, b, c) {
    if ($8e285ac053bcfb61$var$Ib) return a(b, c);
    $8e285ac053bcfb61$var$Ib = !0;
    try {
        return $8e285ac053bcfb61$var$Gb(a, b, c);
    } finally{
        if ($8e285ac053bcfb61$var$Ib = !1, null !== $8e285ac053bcfb61$var$zb || null !== $8e285ac053bcfb61$var$Ab) $8e285ac053bcfb61$var$Hb(), $8e285ac053bcfb61$var$Fb();
    }
}
function $8e285ac053bcfb61$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $8e285ac053bcfb61$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($8e285ac053bcfb61$var$p(231, b, typeof c));
    return c;
}
var $8e285ac053bcfb61$var$Lb = !1;
if ($8e285ac053bcfb61$var$ia) try {
    var $8e285ac053bcfb61$var$Mb = {};
    Object.defineProperty($8e285ac053bcfb61$var$Mb, "passive", {
        get: function() {
            $8e285ac053bcfb61$var$Lb = !0;
        }
    });
    window.addEventListener("test", $8e285ac053bcfb61$var$Mb, $8e285ac053bcfb61$var$Mb);
    window.removeEventListener("test", $8e285ac053bcfb61$var$Mb, $8e285ac053bcfb61$var$Mb);
} catch (a) {
    $8e285ac053bcfb61$var$Lb = !1;
}
function $8e285ac053bcfb61$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $8e285ac053bcfb61$var$Ob = !1, $8e285ac053bcfb61$var$Pb = null, $8e285ac053bcfb61$var$Qb = !1, $8e285ac053bcfb61$var$Rb = null, $8e285ac053bcfb61$var$Sb = {
    onError: function(a) {
        $8e285ac053bcfb61$var$Ob = !0;
        $8e285ac053bcfb61$var$Pb = a;
    }
};
function $8e285ac053bcfb61$var$Tb(a, b, c, d, e, f, g, h, k) {
    $8e285ac053bcfb61$var$Ob = !1;
    $8e285ac053bcfb61$var$Pb = null;
    $8e285ac053bcfb61$var$Nb.apply($8e285ac053bcfb61$var$Sb, arguments);
}
function $8e285ac053bcfb61$var$Ub(a, b, c, d, e, f, g, h, k) {
    $8e285ac053bcfb61$var$Tb.apply(this, arguments);
    if ($8e285ac053bcfb61$var$Ob) {
        if ($8e285ac053bcfb61$var$Ob) {
            var l = $8e285ac053bcfb61$var$Pb;
            $8e285ac053bcfb61$var$Ob = !1;
            $8e285ac053bcfb61$var$Pb = null;
        } else throw Error($8e285ac053bcfb61$var$p(198));
        $8e285ac053bcfb61$var$Qb || ($8e285ac053bcfb61$var$Qb = !0, $8e285ac053bcfb61$var$Rb = l);
    }
}
function $8e285ac053bcfb61$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $8e285ac053bcfb61$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $8e285ac053bcfb61$var$Xb(a) {
    if ($8e285ac053bcfb61$var$Vb(a) !== a) throw Error($8e285ac053bcfb61$var$p(188));
}
function $8e285ac053bcfb61$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $8e285ac053bcfb61$var$Vb(a);
        if (null === b) throw Error($8e285ac053bcfb61$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $8e285ac053bcfb61$var$Xb(e), a;
                if (f === d) return $8e285ac053bcfb61$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($8e285ac053bcfb61$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($8e285ac053bcfb61$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($8e285ac053bcfb61$var$p(190));
    }
    if (3 !== c.tag) throw Error($8e285ac053bcfb61$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $8e285ac053bcfb61$var$Zb(a) {
    a = $8e285ac053bcfb61$var$Yb(a);
    return null !== a ? $8e285ac053bcfb61$var$$b(a) : null;
}
function $8e285ac053bcfb61$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $8e285ac053bcfb61$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $8e285ac053bcfb61$var$ac = $2m3dj.unstable_scheduleCallback, $8e285ac053bcfb61$var$bc = $2m3dj.unstable_cancelCallback, $8e285ac053bcfb61$var$cc = $2m3dj.unstable_shouldYield, $8e285ac053bcfb61$var$dc = $2m3dj.unstable_requestPaint, $8e285ac053bcfb61$var$B = $2m3dj.unstable_now, $8e285ac053bcfb61$var$ec = $2m3dj.unstable_getCurrentPriorityLevel, $8e285ac053bcfb61$var$fc = $2m3dj.unstable_ImmediatePriority, $8e285ac053bcfb61$var$gc = $2m3dj.unstable_UserBlockingPriority, $8e285ac053bcfb61$var$hc = $2m3dj.unstable_NormalPriority, $8e285ac053bcfb61$var$ic = $2m3dj.unstable_LowPriority, $8e285ac053bcfb61$var$jc = $2m3dj.unstable_IdlePriority, $8e285ac053bcfb61$var$kc = null, $8e285ac053bcfb61$var$lc = null;
function $8e285ac053bcfb61$var$mc(a) {
    if ($8e285ac053bcfb61$var$lc && "function" === typeof $8e285ac053bcfb61$var$lc.onCommitFiberRoot) try {
        $8e285ac053bcfb61$var$lc.onCommitFiberRoot($8e285ac053bcfb61$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $8e285ac053bcfb61$var$oc = Math.clz32 ? Math.clz32 : $8e285ac053bcfb61$var$nc, $8e285ac053bcfb61$var$pc = Math.log, $8e285ac053bcfb61$var$qc = Math.LN2;
function $8e285ac053bcfb61$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($8e285ac053bcfb61$var$pc(a) / $8e285ac053bcfb61$var$qc | 0) | 0;
}
var $8e285ac053bcfb61$var$rc = 64, $8e285ac053bcfb61$var$sc = 4194304;
function $8e285ac053bcfb61$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $8e285ac053bcfb61$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $8e285ac053bcfb61$var$tc(h) : (f &= g, 0 !== f && (d = $8e285ac053bcfb61$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $8e285ac053bcfb61$var$tc(g) : 0 !== f && (d = $8e285ac053bcfb61$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $8e285ac053bcfb61$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $8e285ac053bcfb61$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8e285ac053bcfb61$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $8e285ac053bcfb61$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $8e285ac053bcfb61$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $8e285ac053bcfb61$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $8e285ac053bcfb61$var$yc() {
    var a = $8e285ac053bcfb61$var$rc;
    $8e285ac053bcfb61$var$rc <<= 1;
    0 === ($8e285ac053bcfb61$var$rc & 4194240) && ($8e285ac053bcfb61$var$rc = 64);
    return a;
}
function $8e285ac053bcfb61$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $8e285ac053bcfb61$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $8e285ac053bcfb61$var$oc(b);
    a[b] = c;
}
function $8e285ac053bcfb61$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $8e285ac053bcfb61$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $8e285ac053bcfb61$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $8e285ac053bcfb61$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $8e285ac053bcfb61$var$C = 0;
function $8e285ac053bcfb61$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $8e285ac053bcfb61$var$Ec, $8e285ac053bcfb61$var$Fc, $8e285ac053bcfb61$var$Gc, $8e285ac053bcfb61$var$Hc, $8e285ac053bcfb61$var$Ic, $8e285ac053bcfb61$var$Jc = !1, $8e285ac053bcfb61$var$Kc = [], $8e285ac053bcfb61$var$Lc = null, $8e285ac053bcfb61$var$Mc = null, $8e285ac053bcfb61$var$Nc = null, $8e285ac053bcfb61$var$Oc = new Map, $8e285ac053bcfb61$var$Pc = new Map, $8e285ac053bcfb61$var$Qc = [], $8e285ac053bcfb61$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $8e285ac053bcfb61$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $8e285ac053bcfb61$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $8e285ac053bcfb61$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $8e285ac053bcfb61$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $8e285ac053bcfb61$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8e285ac053bcfb61$var$Pc.delete(b.pointerId);
    }
}
function $8e285ac053bcfb61$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $8e285ac053bcfb61$var$Cb(b), null !== b && $8e285ac053bcfb61$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $8e285ac053bcfb61$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $8e285ac053bcfb61$var$Lc = $8e285ac053bcfb61$var$Tc($8e285ac053bcfb61$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $8e285ac053bcfb61$var$Mc = $8e285ac053bcfb61$var$Tc($8e285ac053bcfb61$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $8e285ac053bcfb61$var$Nc = $8e285ac053bcfb61$var$Tc($8e285ac053bcfb61$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $8e285ac053bcfb61$var$Oc.set(f, $8e285ac053bcfb61$var$Tc($8e285ac053bcfb61$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $8e285ac053bcfb61$var$Pc.set(f, $8e285ac053bcfb61$var$Tc($8e285ac053bcfb61$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $8e285ac053bcfb61$var$Vc(a) {
    var b = $8e285ac053bcfb61$var$Wc(a.target);
    if (null !== b) {
        var c = $8e285ac053bcfb61$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $8e285ac053bcfb61$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $8e285ac053bcfb61$var$Ic(a.priority, function() {
                        $8e285ac053bcfb61$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $8e285ac053bcfb61$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $8e285ac053bcfb61$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $8e285ac053bcfb61$var$wb = d;
            c.target.dispatchEvent(d);
            $8e285ac053bcfb61$var$wb = null;
        } else return b = $8e285ac053bcfb61$var$Cb(c), null !== b && $8e285ac053bcfb61$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $8e285ac053bcfb61$var$Zc(a, b, c) {
    $8e285ac053bcfb61$var$Xc(a) && c.delete(b);
}
function $8e285ac053bcfb61$var$$c() {
    $8e285ac053bcfb61$var$Jc = !1;
    null !== $8e285ac053bcfb61$var$Lc && $8e285ac053bcfb61$var$Xc($8e285ac053bcfb61$var$Lc) && ($8e285ac053bcfb61$var$Lc = null);
    null !== $8e285ac053bcfb61$var$Mc && $8e285ac053bcfb61$var$Xc($8e285ac053bcfb61$var$Mc) && ($8e285ac053bcfb61$var$Mc = null);
    null !== $8e285ac053bcfb61$var$Nc && $8e285ac053bcfb61$var$Xc($8e285ac053bcfb61$var$Nc) && ($8e285ac053bcfb61$var$Nc = null);
    $8e285ac053bcfb61$var$Oc.forEach($8e285ac053bcfb61$var$Zc);
    $8e285ac053bcfb61$var$Pc.forEach($8e285ac053bcfb61$var$Zc);
}
function $8e285ac053bcfb61$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $8e285ac053bcfb61$var$Jc || ($8e285ac053bcfb61$var$Jc = !0, $2m3dj.unstable_scheduleCallback($2m3dj.unstable_NormalPriority, $8e285ac053bcfb61$var$$c)));
}
function $8e285ac053bcfb61$var$bd(a) {
    function b(b) {
        return $8e285ac053bcfb61$var$ad(b, a);
    }
    if (0 < $8e285ac053bcfb61$var$Kc.length) {
        $8e285ac053bcfb61$var$ad($8e285ac053bcfb61$var$Kc[0], a);
        for(var c = 1; c < $8e285ac053bcfb61$var$Kc.length; c++){
            var d = $8e285ac053bcfb61$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $8e285ac053bcfb61$var$Lc && $8e285ac053bcfb61$var$ad($8e285ac053bcfb61$var$Lc, a);
    null !== $8e285ac053bcfb61$var$Mc && $8e285ac053bcfb61$var$ad($8e285ac053bcfb61$var$Mc, a);
    null !== $8e285ac053bcfb61$var$Nc && $8e285ac053bcfb61$var$ad($8e285ac053bcfb61$var$Nc, a);
    $8e285ac053bcfb61$var$Oc.forEach(b);
    $8e285ac053bcfb61$var$Pc.forEach(b);
    for(c = 0; c < $8e285ac053bcfb61$var$Qc.length; c++)d = $8e285ac053bcfb61$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $8e285ac053bcfb61$var$Qc.length && (c = $8e285ac053bcfb61$var$Qc[0], null === c.blockedOn);)$8e285ac053bcfb61$var$Vc(c), null === c.blockedOn && $8e285ac053bcfb61$var$Qc.shift();
}
var $8e285ac053bcfb61$var$cd = $8e285ac053bcfb61$var$ua.ReactCurrentBatchConfig, $8e285ac053bcfb61$var$dd = !0;
function $8e285ac053bcfb61$var$ed(a, b, c, d) {
    var e = $8e285ac053bcfb61$var$C, f = $8e285ac053bcfb61$var$cd.transition;
    $8e285ac053bcfb61$var$cd.transition = null;
    try {
        $8e285ac053bcfb61$var$C = 1, $8e285ac053bcfb61$var$fd(a, b, c, d);
    } finally{
        $8e285ac053bcfb61$var$C = e, $8e285ac053bcfb61$var$cd.transition = f;
    }
}
function $8e285ac053bcfb61$var$gd(a, b, c, d) {
    var e = $8e285ac053bcfb61$var$C, f = $8e285ac053bcfb61$var$cd.transition;
    $8e285ac053bcfb61$var$cd.transition = null;
    try {
        $8e285ac053bcfb61$var$C = 4, $8e285ac053bcfb61$var$fd(a, b, c, d);
    } finally{
        $8e285ac053bcfb61$var$C = e, $8e285ac053bcfb61$var$cd.transition = f;
    }
}
function $8e285ac053bcfb61$var$fd(a, b, c, d) {
    if ($8e285ac053bcfb61$var$dd) {
        var e = $8e285ac053bcfb61$var$Yc(a, b, c, d);
        if (null === e) $8e285ac053bcfb61$var$hd(a, b, d, $8e285ac053bcfb61$var$id, c), $8e285ac053bcfb61$var$Sc(a, d);
        else if ($8e285ac053bcfb61$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($8e285ac053bcfb61$var$Sc(a, d), b & 4 && -1 < $8e285ac053bcfb61$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $8e285ac053bcfb61$var$Cb(e);
                null !== f && $8e285ac053bcfb61$var$Ec(f);
                f = $8e285ac053bcfb61$var$Yc(a, b, c, d);
                null === f && $8e285ac053bcfb61$var$hd(a, b, d, $8e285ac053bcfb61$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $8e285ac053bcfb61$var$hd(a, b, d, null, c);
    }
}
var $8e285ac053bcfb61$var$id = null;
function $8e285ac053bcfb61$var$Yc(a, b, c, d) {
    $8e285ac053bcfb61$var$id = null;
    a = $8e285ac053bcfb61$var$xb(d);
    a = $8e285ac053bcfb61$var$Wc(a);
    if (null !== a) {
        if (b = $8e285ac053bcfb61$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $8e285ac053bcfb61$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $8e285ac053bcfb61$var$id = a;
    return null;
}
function $8e285ac053bcfb61$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($8e285ac053bcfb61$var$ec()){
                case $8e285ac053bcfb61$var$fc:
                    return 1;
                case $8e285ac053bcfb61$var$gc:
                    return 4;
                case $8e285ac053bcfb61$var$hc:
                case $8e285ac053bcfb61$var$ic:
                    return 16;
                case $8e285ac053bcfb61$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $8e285ac053bcfb61$var$kd = null, $8e285ac053bcfb61$var$ld = null, $8e285ac053bcfb61$var$md = null;
function $8e285ac053bcfb61$var$nd() {
    if ($8e285ac053bcfb61$var$md) return $8e285ac053bcfb61$var$md;
    var a, b = $8e285ac053bcfb61$var$ld, c = b.length, d, e = "value" in $8e285ac053bcfb61$var$kd ? $8e285ac053bcfb61$var$kd.value : $8e285ac053bcfb61$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $8e285ac053bcfb61$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $8e285ac053bcfb61$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $8e285ac053bcfb61$var$pd() {
    return !0;
}
function $8e285ac053bcfb61$var$qd() {
    return !1;
}
function $8e285ac053bcfb61$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $8e285ac053bcfb61$var$pd : $8e285ac053bcfb61$var$qd;
        this.isPropagationStopped = $8e285ac053bcfb61$var$qd;
        return this;
    }
    $8e285ac053bcfb61$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $8e285ac053bcfb61$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $8e285ac053bcfb61$var$pd);
        },
        persist: function() {},
        isPersistent: $8e285ac053bcfb61$var$pd
    });
    return b;
}
var $8e285ac053bcfb61$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8e285ac053bcfb61$var$td = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$sd), $8e285ac053bcfb61$var$ud = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$sd, {
    view: 0,
    detail: 0
}), $8e285ac053bcfb61$var$vd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$ud), $8e285ac053bcfb61$var$wd, $8e285ac053bcfb61$var$xd, $8e285ac053bcfb61$var$yd, $8e285ac053bcfb61$var$Ad = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8e285ac053bcfb61$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $8e285ac053bcfb61$var$yd && ($8e285ac053bcfb61$var$yd && "mousemove" === a.type ? ($8e285ac053bcfb61$var$wd = a.screenX - $8e285ac053bcfb61$var$yd.screenX, $8e285ac053bcfb61$var$xd = a.screenY - $8e285ac053bcfb61$var$yd.screenY) : $8e285ac053bcfb61$var$xd = $8e285ac053bcfb61$var$wd = 0, $8e285ac053bcfb61$var$yd = a);
        return $8e285ac053bcfb61$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $8e285ac053bcfb61$var$xd;
    }
}), $8e285ac053bcfb61$var$Bd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Ad), $8e285ac053bcfb61$var$Cd = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$Ad, {
    dataTransfer: 0
}), $8e285ac053bcfb61$var$Dd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Cd), $8e285ac053bcfb61$var$Ed = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$ud, {
    relatedTarget: 0
}), $8e285ac053bcfb61$var$Fd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Ed), $8e285ac053bcfb61$var$Gd = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8e285ac053bcfb61$var$Hd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Gd), $8e285ac053bcfb61$var$Id = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $8e285ac053bcfb61$var$Jd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Id), $8e285ac053bcfb61$var$Kd = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$sd, {
    data: 0
}), $8e285ac053bcfb61$var$Ld = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Kd), $8e285ac053bcfb61$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8e285ac053bcfb61$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8e285ac053bcfb61$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8e285ac053bcfb61$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $8e285ac053bcfb61$var$Od[a]) ? !!b[a] : !1;
}
function $8e285ac053bcfb61$var$zd() {
    return $8e285ac053bcfb61$var$Pd;
}
var $8e285ac053bcfb61$var$Qd = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $8e285ac053bcfb61$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $8e285ac053bcfb61$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $8e285ac053bcfb61$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8e285ac053bcfb61$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $8e285ac053bcfb61$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $8e285ac053bcfb61$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $8e285ac053bcfb61$var$Rd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Qd), $8e285ac053bcfb61$var$Sd = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8e285ac053bcfb61$var$Td = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Sd), $8e285ac053bcfb61$var$Ud = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8e285ac053bcfb61$var$zd
}), $8e285ac053bcfb61$var$Vd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Ud), $8e285ac053bcfb61$var$Wd = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8e285ac053bcfb61$var$Xd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Wd), $8e285ac053bcfb61$var$Yd = $8e285ac053bcfb61$var$A({}, $8e285ac053bcfb61$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8e285ac053bcfb61$var$Zd = $8e285ac053bcfb61$var$rd($8e285ac053bcfb61$var$Yd), $8e285ac053bcfb61$var$$d = [
    9,
    13,
    27,
    32
], $8e285ac053bcfb61$var$ae = $8e285ac053bcfb61$var$ia && "CompositionEvent" in window, $8e285ac053bcfb61$var$be = null;
$8e285ac053bcfb61$var$ia && "documentMode" in document && ($8e285ac053bcfb61$var$be = document.documentMode);
var $8e285ac053bcfb61$var$ce = $8e285ac053bcfb61$var$ia && "TextEvent" in window && !$8e285ac053bcfb61$var$be, $8e285ac053bcfb61$var$de = $8e285ac053bcfb61$var$ia && (!$8e285ac053bcfb61$var$ae || $8e285ac053bcfb61$var$be && 8 < $8e285ac053bcfb61$var$be && 11 >= $8e285ac053bcfb61$var$be), $8e285ac053bcfb61$var$ee = String.fromCharCode(32), $8e285ac053bcfb61$var$fe = !1;
function $8e285ac053bcfb61$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $8e285ac053bcfb61$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8e285ac053bcfb61$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $8e285ac053bcfb61$var$ie = !1;
function $8e285ac053bcfb61$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $8e285ac053bcfb61$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $8e285ac053bcfb61$var$fe = !0;
            return $8e285ac053bcfb61$var$ee;
        case "textInput":
            return a = b.data, a === $8e285ac053bcfb61$var$ee && $8e285ac053bcfb61$var$fe ? null : a;
        default:
            return null;
    }
}
function $8e285ac053bcfb61$var$ke(a, b) {
    if ($8e285ac053bcfb61$var$ie) return "compositionend" === a || !$8e285ac053bcfb61$var$ae && $8e285ac053bcfb61$var$ge(a, b) ? (a = $8e285ac053bcfb61$var$nd(), $8e285ac053bcfb61$var$md = $8e285ac053bcfb61$var$ld = $8e285ac053bcfb61$var$kd = null, $8e285ac053bcfb61$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $8e285ac053bcfb61$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $8e285ac053bcfb61$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8e285ac053bcfb61$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$8e285ac053bcfb61$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $8e285ac053bcfb61$var$ne(a, b, c, d) {
    $8e285ac053bcfb61$var$Eb(d);
    b = $8e285ac053bcfb61$var$oe(b, "onChange");
    0 < b.length && (c = new $8e285ac053bcfb61$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $8e285ac053bcfb61$var$pe = null, $8e285ac053bcfb61$var$qe = null;
function $8e285ac053bcfb61$var$re(a) {
    $8e285ac053bcfb61$var$se(a, 0);
}
function $8e285ac053bcfb61$var$te(a) {
    var b = $8e285ac053bcfb61$var$ue(a);
    if ($8e285ac053bcfb61$var$Wa(b)) return a;
}
function $8e285ac053bcfb61$var$ve(a, b) {
    if ("change" === a) return b;
}
var $8e285ac053bcfb61$var$we = !1;
if ($8e285ac053bcfb61$var$ia) {
    var $8e285ac053bcfb61$var$xe;
    if ($8e285ac053bcfb61$var$ia) {
        var $8e285ac053bcfb61$var$ye = "oninput" in document;
        if (!$8e285ac053bcfb61$var$ye) {
            var $8e285ac053bcfb61$var$ze = document.createElement("div");
            $8e285ac053bcfb61$var$ze.setAttribute("oninput", "return;");
            $8e285ac053bcfb61$var$ye = "function" === typeof $8e285ac053bcfb61$var$ze.oninput;
        }
        $8e285ac053bcfb61$var$xe = $8e285ac053bcfb61$var$ye;
    } else $8e285ac053bcfb61$var$xe = !1;
    $8e285ac053bcfb61$var$we = $8e285ac053bcfb61$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $8e285ac053bcfb61$var$Ae() {
    $8e285ac053bcfb61$var$pe && ($8e285ac053bcfb61$var$pe.detachEvent("onpropertychange", $8e285ac053bcfb61$var$Be), $8e285ac053bcfb61$var$qe = $8e285ac053bcfb61$var$pe = null);
}
function $8e285ac053bcfb61$var$Be(a) {
    if ("value" === a.propertyName && $8e285ac053bcfb61$var$te($8e285ac053bcfb61$var$qe)) {
        var b = [];
        $8e285ac053bcfb61$var$ne(b, $8e285ac053bcfb61$var$qe, a, $8e285ac053bcfb61$var$xb(a));
        $8e285ac053bcfb61$var$Jb($8e285ac053bcfb61$var$re, b);
    }
}
function $8e285ac053bcfb61$var$Ce(a, b, c) {
    "focusin" === a ? ($8e285ac053bcfb61$var$Ae(), $8e285ac053bcfb61$var$pe = b, $8e285ac053bcfb61$var$qe = c, $8e285ac053bcfb61$var$pe.attachEvent("onpropertychange", $8e285ac053bcfb61$var$Be)) : "focusout" === a && $8e285ac053bcfb61$var$Ae();
}
function $8e285ac053bcfb61$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $8e285ac053bcfb61$var$te($8e285ac053bcfb61$var$qe);
}
function $8e285ac053bcfb61$var$Ee(a, b) {
    if ("click" === a) return $8e285ac053bcfb61$var$te(b);
}
function $8e285ac053bcfb61$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $8e285ac053bcfb61$var$te(b);
}
function $8e285ac053bcfb61$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8e285ac053bcfb61$var$He = "function" === typeof Object.is ? Object.is : $8e285ac053bcfb61$var$Ge;
function $8e285ac053bcfb61$var$Ie(a, b) {
    if ($8e285ac053bcfb61$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$8e285ac053bcfb61$var$ja.call(b, e) || !$8e285ac053bcfb61$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $8e285ac053bcfb61$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $8e285ac053bcfb61$var$Ke(a, b) {
    var c = $8e285ac053bcfb61$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $8e285ac053bcfb61$var$Je(c);
    }
}
function $8e285ac053bcfb61$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $8e285ac053bcfb61$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $8e285ac053bcfb61$var$Me() {
    for(var a = window, b = $8e285ac053bcfb61$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $8e285ac053bcfb61$var$Xa(a.document);
    }
    return b;
}
function $8e285ac053bcfb61$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $8e285ac053bcfb61$var$Oe(a) {
    var b = $8e285ac053bcfb61$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $8e285ac053bcfb61$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $8e285ac053bcfb61$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $8e285ac053bcfb61$var$Ke(c, f);
                var g = $8e285ac053bcfb61$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $8e285ac053bcfb61$var$Pe = $8e285ac053bcfb61$var$ia && "documentMode" in document && 11 >= document.documentMode, $8e285ac053bcfb61$var$Qe = null, $8e285ac053bcfb61$var$Re = null, $8e285ac053bcfb61$var$Se = null, $8e285ac053bcfb61$var$Te = !1;
function $8e285ac053bcfb61$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $8e285ac053bcfb61$var$Te || null == $8e285ac053bcfb61$var$Qe || $8e285ac053bcfb61$var$Qe !== $8e285ac053bcfb61$var$Xa(d) || (d = $8e285ac053bcfb61$var$Qe, "selectionStart" in d && $8e285ac053bcfb61$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $8e285ac053bcfb61$var$Se && $8e285ac053bcfb61$var$Ie($8e285ac053bcfb61$var$Se, d) || ($8e285ac053bcfb61$var$Se = d, d = $8e285ac053bcfb61$var$oe($8e285ac053bcfb61$var$Re, "onSelect"), 0 < d.length && (b = new $8e285ac053bcfb61$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $8e285ac053bcfb61$var$Qe)));
}
function $8e285ac053bcfb61$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $8e285ac053bcfb61$var$We = {
    animationend: $8e285ac053bcfb61$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $8e285ac053bcfb61$var$Ve("Animation", "AnimationIteration"),
    animationstart: $8e285ac053bcfb61$var$Ve("Animation", "AnimationStart"),
    transitionend: $8e285ac053bcfb61$var$Ve("Transition", "TransitionEnd")
}, $8e285ac053bcfb61$var$Xe = {}, $8e285ac053bcfb61$var$Ye = {};
$8e285ac053bcfb61$var$ia && ($8e285ac053bcfb61$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $8e285ac053bcfb61$var$We.animationend.animation, delete $8e285ac053bcfb61$var$We.animationiteration.animation, delete $8e285ac053bcfb61$var$We.animationstart.animation), "TransitionEvent" in window || delete $8e285ac053bcfb61$var$We.transitionend.transition);
function $8e285ac053bcfb61$var$Ze(a) {
    if ($8e285ac053bcfb61$var$Xe[a]) return $8e285ac053bcfb61$var$Xe[a];
    if (!$8e285ac053bcfb61$var$We[a]) return a;
    var b = $8e285ac053bcfb61$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $8e285ac053bcfb61$var$Ye) return $8e285ac053bcfb61$var$Xe[a] = b[c];
    return a;
}
var $8e285ac053bcfb61$var$$e = $8e285ac053bcfb61$var$Ze("animationend"), $8e285ac053bcfb61$var$af = $8e285ac053bcfb61$var$Ze("animationiteration"), $8e285ac053bcfb61$var$bf = $8e285ac053bcfb61$var$Ze("animationstart"), $8e285ac053bcfb61$var$cf = $8e285ac053bcfb61$var$Ze("transitionend"), $8e285ac053bcfb61$var$df = new Map, $8e285ac053bcfb61$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $8e285ac053bcfb61$var$ff(a, b) {
    $8e285ac053bcfb61$var$df.set(a, b);
    $8e285ac053bcfb61$var$fa(b, [
        a
    ]);
}
for(var $8e285ac053bcfb61$var$gf = 0; $8e285ac053bcfb61$var$gf < $8e285ac053bcfb61$var$ef.length; $8e285ac053bcfb61$var$gf++){
    var $8e285ac053bcfb61$var$hf = $8e285ac053bcfb61$var$ef[$8e285ac053bcfb61$var$gf], $8e285ac053bcfb61$var$jf = $8e285ac053bcfb61$var$hf.toLowerCase(), $8e285ac053bcfb61$var$kf = $8e285ac053bcfb61$var$hf[0].toUpperCase() + $8e285ac053bcfb61$var$hf.slice(1);
    $8e285ac053bcfb61$var$ff($8e285ac053bcfb61$var$jf, "on" + $8e285ac053bcfb61$var$kf);
}
$8e285ac053bcfb61$var$ff($8e285ac053bcfb61$var$$e, "onAnimationEnd");
$8e285ac053bcfb61$var$ff($8e285ac053bcfb61$var$af, "onAnimationIteration");
$8e285ac053bcfb61$var$ff($8e285ac053bcfb61$var$bf, "onAnimationStart");
$8e285ac053bcfb61$var$ff("dblclick", "onDoubleClick");
$8e285ac053bcfb61$var$ff("focusin", "onFocus");
$8e285ac053bcfb61$var$ff("focusout", "onBlur");
$8e285ac053bcfb61$var$ff($8e285ac053bcfb61$var$cf, "onTransitionEnd");
$8e285ac053bcfb61$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8e285ac053bcfb61$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8e285ac053bcfb61$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8e285ac053bcfb61$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8e285ac053bcfb61$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8e285ac053bcfb61$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8e285ac053bcfb61$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8e285ac053bcfb61$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8e285ac053bcfb61$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8e285ac053bcfb61$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8e285ac053bcfb61$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8e285ac053bcfb61$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($8e285ac053bcfb61$var$lf));
function $8e285ac053bcfb61$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $8e285ac053bcfb61$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $8e285ac053bcfb61$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8e285ac053bcfb61$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8e285ac053bcfb61$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($8e285ac053bcfb61$var$Qb) throw a = $8e285ac053bcfb61$var$Rb, $8e285ac053bcfb61$var$Qb = !1, $8e285ac053bcfb61$var$Rb = null, a;
}
function $8e285ac053bcfb61$var$D(a, b) {
    var c = b[$8e285ac053bcfb61$var$of];
    void 0 === c && (c = b[$8e285ac053bcfb61$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($8e285ac053bcfb61$var$pf(b, a, 2, !1), c.add(d));
}
function $8e285ac053bcfb61$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $8e285ac053bcfb61$var$pf(c, a, d, b);
}
var $8e285ac053bcfb61$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $8e285ac053bcfb61$var$sf(a) {
    if (!a[$8e285ac053bcfb61$var$rf]) {
        a[$8e285ac053bcfb61$var$rf] = !0;
        $8e285ac053bcfb61$var$da.forEach(function(b) {
            "selectionchange" !== b && ($8e285ac053bcfb61$var$mf.has(b) || $8e285ac053bcfb61$var$qf(b, !1, a), $8e285ac053bcfb61$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$8e285ac053bcfb61$var$rf] || (b[$8e285ac053bcfb61$var$rf] = !0, $8e285ac053bcfb61$var$qf("selectionchange", !1, b));
    }
}
function $8e285ac053bcfb61$var$pf(a, b, c, d) {
    switch($8e285ac053bcfb61$var$jd(b)){
        case 1:
            var e = $8e285ac053bcfb61$var$ed;
            break;
        case 4:
            e = $8e285ac053bcfb61$var$gd;
            break;
        default:
            e = $8e285ac053bcfb61$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$8e285ac053bcfb61$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $8e285ac053bcfb61$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $8e285ac053bcfb61$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $8e285ac053bcfb61$var$Jb(function() {
        var d = f, e = $8e285ac053bcfb61$var$xb(c), g = [];
        a: {
            var h = $8e285ac053bcfb61$var$df.get(a);
            if (void 0 !== h) {
                var k = $8e285ac053bcfb61$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $8e285ac053bcfb61$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $8e285ac053bcfb61$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $8e285ac053bcfb61$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $8e285ac053bcfb61$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $8e285ac053bcfb61$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $8e285ac053bcfb61$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $8e285ac053bcfb61$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $8e285ac053bcfb61$var$Vd;
                        break;
                    case $8e285ac053bcfb61$var$$e:
                    case $8e285ac053bcfb61$var$af:
                    case $8e285ac053bcfb61$var$bf:
                        k = $8e285ac053bcfb61$var$Hd;
                        break;
                    case $8e285ac053bcfb61$var$cf:
                        k = $8e285ac053bcfb61$var$Xd;
                        break;
                    case "scroll":
                        k = $8e285ac053bcfb61$var$vd;
                        break;
                    case "wheel":
                        k = $8e285ac053bcfb61$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $8e285ac053bcfb61$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $8e285ac053bcfb61$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $8e285ac053bcfb61$var$Kb(w, x), null != F && t.push($8e285ac053bcfb61$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $8e285ac053bcfb61$var$wb && (n = c.relatedTarget || c.fromElement) && ($8e285ac053bcfb61$var$Wc(n) || n[$8e285ac053bcfb61$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $8e285ac053bcfb61$var$Wc(n) : null, null !== n && (J = $8e285ac053bcfb61$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $8e285ac053bcfb61$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $8e285ac053bcfb61$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $8e285ac053bcfb61$var$ue(k);
                        u = null == n ? h : $8e285ac053bcfb61$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $8e285ac053bcfb61$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $8e285ac053bcfb61$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $8e285ac053bcfb61$var$vf(F))u++;
                            for(; 0 < w - u;)t = $8e285ac053bcfb61$var$vf(t), w--;
                            for(; 0 < u - w;)x = $8e285ac053bcfb61$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $8e285ac053bcfb61$var$vf(t);
                                x = $8e285ac053bcfb61$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $8e285ac053bcfb61$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $8e285ac053bcfb61$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $8e285ac053bcfb61$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $8e285ac053bcfb61$var$ve;
                else if ($8e285ac053bcfb61$var$me(h)) {
                    if ($8e285ac053bcfb61$var$we) na = $8e285ac053bcfb61$var$Fe;
                    else {
                        na = $8e285ac053bcfb61$var$De;
                        var xa = $8e285ac053bcfb61$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $8e285ac053bcfb61$var$Ee);
                if (na && (na = na(a, d))) {
                    $8e285ac053bcfb61$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $8e285ac053bcfb61$var$cb(h, "number", h.value);
            }
            xa = d ? $8e285ac053bcfb61$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($8e285ac053bcfb61$var$me(xa) || "true" === xa.contentEditable) $8e285ac053bcfb61$var$Qe = xa, $8e285ac053bcfb61$var$Re = d, $8e285ac053bcfb61$var$Se = null;
                    break;
                case "focusout":
                    $8e285ac053bcfb61$var$Se = $8e285ac053bcfb61$var$Re = $8e285ac053bcfb61$var$Qe = null;
                    break;
                case "mousedown":
                    $8e285ac053bcfb61$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8e285ac053bcfb61$var$Te = !1;
                    $8e285ac053bcfb61$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($8e285ac053bcfb61$var$Pe) break;
                case "keydown":
                case "keyup":
                    $8e285ac053bcfb61$var$Ue(g, c, e);
            }
            var $a;
            if ($8e285ac053bcfb61$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $8e285ac053bcfb61$var$ie ? $8e285ac053bcfb61$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($8e285ac053bcfb61$var$de && "ko" !== c.locale && ($8e285ac053bcfb61$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $8e285ac053bcfb61$var$ie && ($a = $8e285ac053bcfb61$var$nd()) : ($8e285ac053bcfb61$var$kd = e, $8e285ac053bcfb61$var$ld = "value" in $8e285ac053bcfb61$var$kd ? $8e285ac053bcfb61$var$kd.value : $8e285ac053bcfb61$var$kd.textContent, $8e285ac053bcfb61$var$ie = !0)), xa = $8e285ac053bcfb61$var$oe(d, ba), 0 < xa.length && (ba = new $8e285ac053bcfb61$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $8e285ac053bcfb61$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $8e285ac053bcfb61$var$ce ? $8e285ac053bcfb61$var$je(a, c) : $8e285ac053bcfb61$var$ke(a, c)) d = $8e285ac053bcfb61$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $8e285ac053bcfb61$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $8e285ac053bcfb61$var$se(g, b);
    });
}
function $8e285ac053bcfb61$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $8e285ac053bcfb61$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $8e285ac053bcfb61$var$Kb(a, c), null != f && d.unshift($8e285ac053bcfb61$var$tf(a, f, e)), f = $8e285ac053bcfb61$var$Kb(a, b), null != f && d.push($8e285ac053bcfb61$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $8e285ac053bcfb61$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $8e285ac053bcfb61$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $8e285ac053bcfb61$var$Kb(c, f), null != k && g.unshift($8e285ac053bcfb61$var$tf(c, k, h))) : e || (k = $8e285ac053bcfb61$var$Kb(c, f), null != k && g.push($8e285ac053bcfb61$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $8e285ac053bcfb61$var$xf = /\r\n?/g, $8e285ac053bcfb61$var$yf = /\u0000|\uFFFD/g;
function $8e285ac053bcfb61$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($8e285ac053bcfb61$var$xf, "\n").replace($8e285ac053bcfb61$var$yf, "");
}
function $8e285ac053bcfb61$var$Af(a, b, c) {
    b = $8e285ac053bcfb61$var$zf(b);
    if ($8e285ac053bcfb61$var$zf(a) !== b && c) throw Error($8e285ac053bcfb61$var$p(425));
}
function $8e285ac053bcfb61$var$Bf() {}
var $8e285ac053bcfb61$var$Cf = null, $8e285ac053bcfb61$var$Df = null;
function $8e285ac053bcfb61$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $8e285ac053bcfb61$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $8e285ac053bcfb61$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $8e285ac053bcfb61$var$Hf = "function" === typeof Promise ? Promise : void 0, $8e285ac053bcfb61$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8e285ac053bcfb61$var$Hf ? function(a) {
    return $8e285ac053bcfb61$var$Hf.resolve(null).then(a).catch($8e285ac053bcfb61$var$If);
} : $8e285ac053bcfb61$var$Ff;
function $8e285ac053bcfb61$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $8e285ac053bcfb61$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $8e285ac053bcfb61$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $8e285ac053bcfb61$var$bd(b);
}
function $8e285ac053bcfb61$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $8e285ac053bcfb61$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $8e285ac053bcfb61$var$Nf = Math.random().toString(36).slice(2), $8e285ac053bcfb61$var$Of = "__reactFiber$" + $8e285ac053bcfb61$var$Nf, $8e285ac053bcfb61$var$Pf = "__reactProps$" + $8e285ac053bcfb61$var$Nf, $8e285ac053bcfb61$var$uf = "__reactContainer$" + $8e285ac053bcfb61$var$Nf, $8e285ac053bcfb61$var$of = "__reactEvents$" + $8e285ac053bcfb61$var$Nf, $8e285ac053bcfb61$var$Qf = "__reactListeners$" + $8e285ac053bcfb61$var$Nf, $8e285ac053bcfb61$var$Rf = "__reactHandles$" + $8e285ac053bcfb61$var$Nf;
function $8e285ac053bcfb61$var$Wc(a) {
    var b = a[$8e285ac053bcfb61$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$8e285ac053bcfb61$var$uf] || c[$8e285ac053bcfb61$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $8e285ac053bcfb61$var$Mf(a); null !== a;){
                if (c = a[$8e285ac053bcfb61$var$Of]) return c;
                a = $8e285ac053bcfb61$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $8e285ac053bcfb61$var$Cb(a) {
    a = a[$8e285ac053bcfb61$var$Of] || a[$8e285ac053bcfb61$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $8e285ac053bcfb61$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($8e285ac053bcfb61$var$p(33));
}
function $8e285ac053bcfb61$var$Db(a) {
    return a[$8e285ac053bcfb61$var$Pf] || null;
}
var $8e285ac053bcfb61$var$Sf = [], $8e285ac053bcfb61$var$Tf = -1;
function $8e285ac053bcfb61$var$Uf(a) {
    return {
        current: a
    };
}
function $8e285ac053bcfb61$var$E(a) {
    0 > $8e285ac053bcfb61$var$Tf || (a.current = $8e285ac053bcfb61$var$Sf[$8e285ac053bcfb61$var$Tf], $8e285ac053bcfb61$var$Sf[$8e285ac053bcfb61$var$Tf] = null, $8e285ac053bcfb61$var$Tf--);
}
function $8e285ac053bcfb61$var$G(a, b) {
    $8e285ac053bcfb61$var$Tf++;
    $8e285ac053bcfb61$var$Sf[$8e285ac053bcfb61$var$Tf] = a.current;
    a.current = b;
}
var $8e285ac053bcfb61$var$Vf = {}, $8e285ac053bcfb61$var$H = $8e285ac053bcfb61$var$Uf($8e285ac053bcfb61$var$Vf), $8e285ac053bcfb61$var$Wf = $8e285ac053bcfb61$var$Uf(!1), $8e285ac053bcfb61$var$Xf = $8e285ac053bcfb61$var$Vf;
function $8e285ac053bcfb61$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $8e285ac053bcfb61$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $8e285ac053bcfb61$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $8e285ac053bcfb61$var$$f() {
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$Wf);
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$H);
}
function $8e285ac053bcfb61$var$ag(a, b, c) {
    if ($8e285ac053bcfb61$var$H.current !== $8e285ac053bcfb61$var$Vf) throw Error($8e285ac053bcfb61$var$p(168));
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$H, b);
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$Wf, c);
}
function $8e285ac053bcfb61$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($8e285ac053bcfb61$var$p(108, $8e285ac053bcfb61$var$Ra(a) || "Unknown", e));
    return $8e285ac053bcfb61$var$A({}, c, d);
}
function $8e285ac053bcfb61$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $8e285ac053bcfb61$var$Vf;
    $8e285ac053bcfb61$var$Xf = $8e285ac053bcfb61$var$H.current;
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$H, a);
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$Wf, $8e285ac053bcfb61$var$Wf.current);
    return !0;
}
function $8e285ac053bcfb61$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($8e285ac053bcfb61$var$p(169));
    c ? (a = $8e285ac053bcfb61$var$bg(a, b, $8e285ac053bcfb61$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$Wf), $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$H), $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$H, a)) : $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$Wf);
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$Wf, c);
}
var $8e285ac053bcfb61$var$eg = null, $8e285ac053bcfb61$var$fg = !1, $8e285ac053bcfb61$var$gg = !1;
function $8e285ac053bcfb61$var$hg(a) {
    null === $8e285ac053bcfb61$var$eg ? $8e285ac053bcfb61$var$eg = [
        a
    ] : $8e285ac053bcfb61$var$eg.push(a);
}
function $8e285ac053bcfb61$var$ig(a) {
    $8e285ac053bcfb61$var$fg = !0;
    $8e285ac053bcfb61$var$hg(a);
}
function $8e285ac053bcfb61$var$jg() {
    if (!$8e285ac053bcfb61$var$gg && null !== $8e285ac053bcfb61$var$eg) {
        $8e285ac053bcfb61$var$gg = !0;
        var a = 0, b = $8e285ac053bcfb61$var$C;
        try {
            var c = $8e285ac053bcfb61$var$eg;
            for($8e285ac053bcfb61$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $8e285ac053bcfb61$var$eg = null;
            $8e285ac053bcfb61$var$fg = !1;
        } catch (e) {
            throw null !== $8e285ac053bcfb61$var$eg && ($8e285ac053bcfb61$var$eg = $8e285ac053bcfb61$var$eg.slice(a + 1)), $8e285ac053bcfb61$var$ac($8e285ac053bcfb61$var$fc, $8e285ac053bcfb61$var$jg), e;
        } finally{
            $8e285ac053bcfb61$var$C = b, $8e285ac053bcfb61$var$gg = !1;
        }
    }
    return null;
}
var $8e285ac053bcfb61$var$kg = [], $8e285ac053bcfb61$var$lg = 0, $8e285ac053bcfb61$var$mg = null, $8e285ac053bcfb61$var$ng = 0, $8e285ac053bcfb61$var$og = [], $8e285ac053bcfb61$var$pg = 0, $8e285ac053bcfb61$var$qg = null, $8e285ac053bcfb61$var$rg = 1, $8e285ac053bcfb61$var$sg = "";
function $8e285ac053bcfb61$var$tg(a, b) {
    $8e285ac053bcfb61$var$kg[$8e285ac053bcfb61$var$lg++] = $8e285ac053bcfb61$var$ng;
    $8e285ac053bcfb61$var$kg[$8e285ac053bcfb61$var$lg++] = $8e285ac053bcfb61$var$mg;
    $8e285ac053bcfb61$var$mg = a;
    $8e285ac053bcfb61$var$ng = b;
}
function $8e285ac053bcfb61$var$ug(a, b, c) {
    $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg++] = $8e285ac053bcfb61$var$rg;
    $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg++] = $8e285ac053bcfb61$var$sg;
    $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg++] = $8e285ac053bcfb61$var$qg;
    $8e285ac053bcfb61$var$qg = a;
    var d = $8e285ac053bcfb61$var$rg;
    a = $8e285ac053bcfb61$var$sg;
    var e = 32 - $8e285ac053bcfb61$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $8e285ac053bcfb61$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $8e285ac053bcfb61$var$rg = 1 << 32 - $8e285ac053bcfb61$var$oc(b) + e | c << e | d;
        $8e285ac053bcfb61$var$sg = f + a;
    } else $8e285ac053bcfb61$var$rg = 1 << f | c << e | d, $8e285ac053bcfb61$var$sg = a;
}
function $8e285ac053bcfb61$var$vg(a) {
    null !== a.return && ($8e285ac053bcfb61$var$tg(a, 1), $8e285ac053bcfb61$var$ug(a, 1, 0));
}
function $8e285ac053bcfb61$var$wg(a) {
    for(; a === $8e285ac053bcfb61$var$mg;)$8e285ac053bcfb61$var$mg = $8e285ac053bcfb61$var$kg[--$8e285ac053bcfb61$var$lg], $8e285ac053bcfb61$var$kg[$8e285ac053bcfb61$var$lg] = null, $8e285ac053bcfb61$var$ng = $8e285ac053bcfb61$var$kg[--$8e285ac053bcfb61$var$lg], $8e285ac053bcfb61$var$kg[$8e285ac053bcfb61$var$lg] = null;
    for(; a === $8e285ac053bcfb61$var$qg;)$8e285ac053bcfb61$var$qg = $8e285ac053bcfb61$var$og[--$8e285ac053bcfb61$var$pg], $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg] = null, $8e285ac053bcfb61$var$sg = $8e285ac053bcfb61$var$og[--$8e285ac053bcfb61$var$pg], $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg] = null, $8e285ac053bcfb61$var$rg = $8e285ac053bcfb61$var$og[--$8e285ac053bcfb61$var$pg], $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg] = null;
}
var $8e285ac053bcfb61$var$xg = null, $8e285ac053bcfb61$var$yg = null, $8e285ac053bcfb61$var$I = !1, $8e285ac053bcfb61$var$zg = null;
function $8e285ac053bcfb61$var$Ag(a, b) {
    var c = $8e285ac053bcfb61$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $8e285ac053bcfb61$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $8e285ac053bcfb61$var$xg = a, $8e285ac053bcfb61$var$yg = $8e285ac053bcfb61$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $8e285ac053bcfb61$var$xg = a, $8e285ac053bcfb61$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $8e285ac053bcfb61$var$qg ? {
                id: $8e285ac053bcfb61$var$rg,
                overflow: $8e285ac053bcfb61$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $8e285ac053bcfb61$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $8e285ac053bcfb61$var$xg = a, $8e285ac053bcfb61$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $8e285ac053bcfb61$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $8e285ac053bcfb61$var$Eg(a) {
    if ($8e285ac053bcfb61$var$I) {
        var b = $8e285ac053bcfb61$var$yg;
        if (b) {
            var c = b;
            if (!$8e285ac053bcfb61$var$Cg(a, b)) {
                if ($8e285ac053bcfb61$var$Dg(a)) throw Error($8e285ac053bcfb61$var$p(418));
                b = $8e285ac053bcfb61$var$Lf(c.nextSibling);
                var d = $8e285ac053bcfb61$var$xg;
                b && $8e285ac053bcfb61$var$Cg(a, b) ? $8e285ac053bcfb61$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $8e285ac053bcfb61$var$I = !1, $8e285ac053bcfb61$var$xg = a);
            }
        } else {
            if ($8e285ac053bcfb61$var$Dg(a)) throw Error($8e285ac053bcfb61$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $8e285ac053bcfb61$var$I = !1;
            $8e285ac053bcfb61$var$xg = a;
        }
    }
}
function $8e285ac053bcfb61$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $8e285ac053bcfb61$var$xg = a;
}
function $8e285ac053bcfb61$var$Gg(a) {
    if (a !== $8e285ac053bcfb61$var$xg) return !1;
    if (!$8e285ac053bcfb61$var$I) return $8e285ac053bcfb61$var$Fg(a), $8e285ac053bcfb61$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$8e285ac053bcfb61$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $8e285ac053bcfb61$var$yg)) {
        if ($8e285ac053bcfb61$var$Dg(a)) throw $8e285ac053bcfb61$var$Hg(), Error($8e285ac053bcfb61$var$p(418));
        for(; b;)$8e285ac053bcfb61$var$Ag(a, b), b = $8e285ac053bcfb61$var$Lf(b.nextSibling);
    }
    $8e285ac053bcfb61$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($8e285ac053bcfb61$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $8e285ac053bcfb61$var$yg = $8e285ac053bcfb61$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $8e285ac053bcfb61$var$yg = null;
        }
    } else $8e285ac053bcfb61$var$yg = $8e285ac053bcfb61$var$xg ? $8e285ac053bcfb61$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $8e285ac053bcfb61$var$Hg() {
    for(var a = $8e285ac053bcfb61$var$yg; a;)a = $8e285ac053bcfb61$var$Lf(a.nextSibling);
}
function $8e285ac053bcfb61$var$Ig() {
    $8e285ac053bcfb61$var$yg = $8e285ac053bcfb61$var$xg = null;
    $8e285ac053bcfb61$var$I = !1;
}
function $8e285ac053bcfb61$var$Jg(a) {
    null === $8e285ac053bcfb61$var$zg ? $8e285ac053bcfb61$var$zg = [
        a
    ] : $8e285ac053bcfb61$var$zg.push(a);
}
var $8e285ac053bcfb61$var$Kg = $8e285ac053bcfb61$var$ua.ReactCurrentBatchConfig;
function $8e285ac053bcfb61$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($8e285ac053bcfb61$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($8e285ac053bcfb61$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($8e285ac053bcfb61$var$p(284));
        if (!c._owner) throw Error($8e285ac053bcfb61$var$p(290, a));
    }
    return a;
}
function $8e285ac053bcfb61$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($8e285ac053bcfb61$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $8e285ac053bcfb61$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $8e285ac053bcfb61$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $8e285ac053bcfb61$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $8e285ac053bcfb61$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $8e285ac053bcfb61$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $8e285ac053bcfb61$var$Ha && $8e285ac053bcfb61$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $8e285ac053bcfb61$var$Lg(a, b, c), d.return = a, d;
        d = $8e285ac053bcfb61$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $8e285ac053bcfb61$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $8e285ac053bcfb61$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $8e285ac053bcfb61$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $8e285ac053bcfb61$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $8e285ac053bcfb61$var$va:
                    return c = $8e285ac053bcfb61$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $8e285ac053bcfb61$var$Lg(a, null, b), c.return = a, c;
                case $8e285ac053bcfb61$var$wa:
                    return b = $8e285ac053bcfb61$var$Sg(b, a.mode, c), b.return = a, b;
                case $8e285ac053bcfb61$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($8e285ac053bcfb61$var$eb(b) || $8e285ac053bcfb61$var$Ka(b)) return b = $8e285ac053bcfb61$var$Tg(b, a.mode, c, null), b.return = a, b;
            $8e285ac053bcfb61$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $8e285ac053bcfb61$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $8e285ac053bcfb61$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $8e285ac053bcfb61$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($8e285ac053bcfb61$var$eb(c) || $8e285ac053bcfb61$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $8e285ac053bcfb61$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $8e285ac053bcfb61$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $8e285ac053bcfb61$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $8e285ac053bcfb61$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($8e285ac053bcfb61$var$eb(d) || $8e285ac053bcfb61$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $8e285ac053bcfb61$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $8e285ac053bcfb61$var$I && $8e285ac053bcfb61$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $8e285ac053bcfb61$var$I && $8e285ac053bcfb61$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $8e285ac053bcfb61$var$I && $8e285ac053bcfb61$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $8e285ac053bcfb61$var$Ka(h);
        if ("function" !== typeof l) throw Error($8e285ac053bcfb61$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($8e285ac053bcfb61$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $8e285ac053bcfb61$var$I && $8e285ac053bcfb61$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $8e285ac053bcfb61$var$I && $8e285ac053bcfb61$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $8e285ac053bcfb61$var$I && $8e285ac053bcfb61$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $8e285ac053bcfb61$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $8e285ac053bcfb61$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $8e285ac053bcfb61$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $8e285ac053bcfb61$var$Ha && $8e285ac053bcfb61$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $8e285ac053bcfb61$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $8e285ac053bcfb61$var$ya ? (d = $8e285ac053bcfb61$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $8e285ac053bcfb61$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $8e285ac053bcfb61$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $8e285ac053bcfb61$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $8e285ac053bcfb61$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $8e285ac053bcfb61$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($8e285ac053bcfb61$var$eb(f)) return n(a, d, f, h);
            if ($8e285ac053bcfb61$var$Ka(f)) return t(a, d, f, h);
            $8e285ac053bcfb61$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $8e285ac053bcfb61$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $8e285ac053bcfb61$var$Ug = $8e285ac053bcfb61$var$Og(!0), $8e285ac053bcfb61$var$Vg = $8e285ac053bcfb61$var$Og(!1), $8e285ac053bcfb61$var$Wg = $8e285ac053bcfb61$var$Uf(null), $8e285ac053bcfb61$var$Xg = null, $8e285ac053bcfb61$var$Yg = null, $8e285ac053bcfb61$var$Zg = null;
function $8e285ac053bcfb61$var$$g() {
    $8e285ac053bcfb61$var$Zg = $8e285ac053bcfb61$var$Yg = $8e285ac053bcfb61$var$Xg = null;
}
function $8e285ac053bcfb61$var$ah(a) {
    var b = $8e285ac053bcfb61$var$Wg.current;
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$Wg);
    a._currentValue = b;
}
function $8e285ac053bcfb61$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $8e285ac053bcfb61$var$ch(a, b) {
    $8e285ac053bcfb61$var$Xg = a;
    $8e285ac053bcfb61$var$Zg = $8e285ac053bcfb61$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($8e285ac053bcfb61$var$dh = !0), a.firstContext = null);
}
function $8e285ac053bcfb61$var$eh(a) {
    var b = a._currentValue;
    if ($8e285ac053bcfb61$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $8e285ac053bcfb61$var$Yg) {
            if (null === $8e285ac053bcfb61$var$Xg) throw Error($8e285ac053bcfb61$var$p(308));
            $8e285ac053bcfb61$var$Yg = a;
            $8e285ac053bcfb61$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $8e285ac053bcfb61$var$Yg = $8e285ac053bcfb61$var$Yg.next = a;
    }
    return b;
}
var $8e285ac053bcfb61$var$fh = null;
function $8e285ac053bcfb61$var$gh(a) {
    null === $8e285ac053bcfb61$var$fh ? $8e285ac053bcfb61$var$fh = [
        a
    ] : $8e285ac053bcfb61$var$fh.push(a);
}
function $8e285ac053bcfb61$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $8e285ac053bcfb61$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $8e285ac053bcfb61$var$ih(a, d);
}
function $8e285ac053bcfb61$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $8e285ac053bcfb61$var$jh = !1;
function $8e285ac053bcfb61$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $8e285ac053bcfb61$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $8e285ac053bcfb61$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8e285ac053bcfb61$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($8e285ac053bcfb61$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $8e285ac053bcfb61$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $8e285ac053bcfb61$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $8e285ac053bcfb61$var$ih(a, c);
}
function $8e285ac053bcfb61$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8e285ac053bcfb61$var$Cc(a, c);
    }
}
function $8e285ac053bcfb61$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $8e285ac053bcfb61$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $8e285ac053bcfb61$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $8e285ac053bcfb61$var$A({}, q, r);
                            break a;
                        case 2:
                            $8e285ac053bcfb61$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $8e285ac053bcfb61$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $8e285ac053bcfb61$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($8e285ac053bcfb61$var$p(191, e));
            e.call(d);
        }
    }
}
var $8e285ac053bcfb61$var$th = {}, $8e285ac053bcfb61$var$uh = $8e285ac053bcfb61$var$Uf($8e285ac053bcfb61$var$th), $8e285ac053bcfb61$var$vh = $8e285ac053bcfb61$var$Uf($8e285ac053bcfb61$var$th), $8e285ac053bcfb61$var$wh = $8e285ac053bcfb61$var$Uf($8e285ac053bcfb61$var$th);
function $8e285ac053bcfb61$var$xh(a) {
    if (a === $8e285ac053bcfb61$var$th) throw Error($8e285ac053bcfb61$var$p(174));
    return a;
}
function $8e285ac053bcfb61$var$yh(a, b) {
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$wh, b);
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$vh, a);
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$uh, $8e285ac053bcfb61$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $8e285ac053bcfb61$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $8e285ac053bcfb61$var$lb(b, a);
    }
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$uh);
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$uh, b);
}
function $8e285ac053bcfb61$var$zh() {
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$uh);
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$vh);
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$wh);
}
function $8e285ac053bcfb61$var$Ah(a) {
    $8e285ac053bcfb61$var$xh($8e285ac053bcfb61$var$wh.current);
    var b = $8e285ac053bcfb61$var$xh($8e285ac053bcfb61$var$uh.current);
    var c = $8e285ac053bcfb61$var$lb(b, a.type);
    b !== c && ($8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$vh, a), $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$uh, c));
}
function $8e285ac053bcfb61$var$Bh(a) {
    $8e285ac053bcfb61$var$vh.current === a && ($8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$uh), $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$vh));
}
var $8e285ac053bcfb61$var$L = $8e285ac053bcfb61$var$Uf(0);
function $8e285ac053bcfb61$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $8e285ac053bcfb61$var$Dh = [];
function $8e285ac053bcfb61$var$Eh() {
    for(var a = 0; a < $8e285ac053bcfb61$var$Dh.length; a++)$8e285ac053bcfb61$var$Dh[a]._workInProgressVersionPrimary = null;
    $8e285ac053bcfb61$var$Dh.length = 0;
}
var $8e285ac053bcfb61$var$Fh = $8e285ac053bcfb61$var$ua.ReactCurrentDispatcher, $8e285ac053bcfb61$var$Gh = $8e285ac053bcfb61$var$ua.ReactCurrentBatchConfig, $8e285ac053bcfb61$var$Hh = 0, $8e285ac053bcfb61$var$M = null, $8e285ac053bcfb61$var$N = null, $8e285ac053bcfb61$var$O = null, $8e285ac053bcfb61$var$Ih = !1, $8e285ac053bcfb61$var$Jh = !1, $8e285ac053bcfb61$var$Kh = 0, $8e285ac053bcfb61$var$Lh = 0;
function $8e285ac053bcfb61$var$P() {
    throw Error($8e285ac053bcfb61$var$p(321));
}
function $8e285ac053bcfb61$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$8e285ac053bcfb61$var$He(a[c], b[c])) return !1;
    return !0;
}
function $8e285ac053bcfb61$var$Nh(a, b, c, d, e, f) {
    $8e285ac053bcfb61$var$Hh = f;
    $8e285ac053bcfb61$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $8e285ac053bcfb61$var$Fh.current = null === a || null === a.memoizedState ? $8e285ac053bcfb61$var$Oh : $8e285ac053bcfb61$var$Ph;
    a = c(d, e);
    if ($8e285ac053bcfb61$var$Jh) {
        f = 0;
        do {
            $8e285ac053bcfb61$var$Jh = !1;
            $8e285ac053bcfb61$var$Kh = 0;
            if (25 <= f) throw Error($8e285ac053bcfb61$var$p(301));
            f += 1;
            $8e285ac053bcfb61$var$O = $8e285ac053bcfb61$var$N = null;
            b.updateQueue = null;
            $8e285ac053bcfb61$var$Fh.current = $8e285ac053bcfb61$var$Qh;
            a = c(d, e);
        }while ($8e285ac053bcfb61$var$Jh);
    }
    $8e285ac053bcfb61$var$Fh.current = $8e285ac053bcfb61$var$Rh;
    b = null !== $8e285ac053bcfb61$var$N && null !== $8e285ac053bcfb61$var$N.next;
    $8e285ac053bcfb61$var$Hh = 0;
    $8e285ac053bcfb61$var$O = $8e285ac053bcfb61$var$N = $8e285ac053bcfb61$var$M = null;
    $8e285ac053bcfb61$var$Ih = !1;
    if (b) throw Error($8e285ac053bcfb61$var$p(300));
    return a;
}
function $8e285ac053bcfb61$var$Sh() {
    var a = 0 !== $8e285ac053bcfb61$var$Kh;
    $8e285ac053bcfb61$var$Kh = 0;
    return a;
}
function $8e285ac053bcfb61$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8e285ac053bcfb61$var$O ? $8e285ac053bcfb61$var$M.memoizedState = $8e285ac053bcfb61$var$O = a : $8e285ac053bcfb61$var$O = $8e285ac053bcfb61$var$O.next = a;
    return $8e285ac053bcfb61$var$O;
}
function $8e285ac053bcfb61$var$Uh() {
    if (null === $8e285ac053bcfb61$var$N) {
        var a = $8e285ac053bcfb61$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $8e285ac053bcfb61$var$N.next;
    var b = null === $8e285ac053bcfb61$var$O ? $8e285ac053bcfb61$var$M.memoizedState : $8e285ac053bcfb61$var$O.next;
    if (null !== b) $8e285ac053bcfb61$var$O = b, $8e285ac053bcfb61$var$N = a;
    else {
        if (null === a) throw Error($8e285ac053bcfb61$var$p(310));
        $8e285ac053bcfb61$var$N = a;
        a = {
            memoizedState: $8e285ac053bcfb61$var$N.memoizedState,
            baseState: $8e285ac053bcfb61$var$N.baseState,
            baseQueue: $8e285ac053bcfb61$var$N.baseQueue,
            queue: $8e285ac053bcfb61$var$N.queue,
            next: null
        };
        null === $8e285ac053bcfb61$var$O ? $8e285ac053bcfb61$var$M.memoizedState = $8e285ac053bcfb61$var$O = a : $8e285ac053bcfb61$var$O = $8e285ac053bcfb61$var$O.next = a;
    }
    return $8e285ac053bcfb61$var$O;
}
function $8e285ac053bcfb61$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $8e285ac053bcfb61$var$Wh(a) {
    var b = $8e285ac053bcfb61$var$Uh(), c = b.queue;
    if (null === c) throw Error($8e285ac053bcfb61$var$p(311));
    c.lastRenderedReducer = a;
    var d = $8e285ac053bcfb61$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($8e285ac053bcfb61$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $8e285ac053bcfb61$var$M.lanes |= m;
                $8e285ac053bcfb61$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $8e285ac053bcfb61$var$He(d, b.memoizedState) || ($8e285ac053bcfb61$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $8e285ac053bcfb61$var$M.lanes |= f, $8e285ac053bcfb61$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $8e285ac053bcfb61$var$Xh(a) {
    var b = $8e285ac053bcfb61$var$Uh(), c = b.queue;
    if (null === c) throw Error($8e285ac053bcfb61$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $8e285ac053bcfb61$var$He(f, b.memoizedState) || ($8e285ac053bcfb61$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $8e285ac053bcfb61$var$Yh() {}
function $8e285ac053bcfb61$var$Zh(a, b) {
    var c = $8e285ac053bcfb61$var$M, d = $8e285ac053bcfb61$var$Uh(), e = b(), f = !$8e285ac053bcfb61$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $8e285ac053bcfb61$var$dh = !0);
    d = d.queue;
    $8e285ac053bcfb61$var$$h($8e285ac053bcfb61$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $8e285ac053bcfb61$var$O && $8e285ac053bcfb61$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $8e285ac053bcfb61$var$bi(9, $8e285ac053bcfb61$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $8e285ac053bcfb61$var$Q) throw Error($8e285ac053bcfb61$var$p(349));
        0 !== ($8e285ac053bcfb61$var$Hh & 30) || $8e285ac053bcfb61$var$di(c, b, e);
    }
    return e;
}
function $8e285ac053bcfb61$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $8e285ac053bcfb61$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8e285ac053bcfb61$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $8e285ac053bcfb61$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $8e285ac053bcfb61$var$ei(b) && $8e285ac053bcfb61$var$fi(a);
}
function $8e285ac053bcfb61$var$ai(a, b, c) {
    return c(function() {
        $8e285ac053bcfb61$var$ei(b) && $8e285ac053bcfb61$var$fi(a);
    });
}
function $8e285ac053bcfb61$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$8e285ac053bcfb61$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $8e285ac053bcfb61$var$fi(a) {
    var b = $8e285ac053bcfb61$var$ih(a, 1);
    null !== b && $8e285ac053bcfb61$var$gi(b, a, 1, -1);
}
function $8e285ac053bcfb61$var$hi(a) {
    var b = $8e285ac053bcfb61$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8e285ac053bcfb61$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $8e285ac053bcfb61$var$ii.bind(null, $8e285ac053bcfb61$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $8e285ac053bcfb61$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $8e285ac053bcfb61$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8e285ac053bcfb61$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $8e285ac053bcfb61$var$ji() {
    return $8e285ac053bcfb61$var$Uh().memoizedState;
}
function $8e285ac053bcfb61$var$ki(a, b, c, d) {
    var e = $8e285ac053bcfb61$var$Th();
    $8e285ac053bcfb61$var$M.flags |= a;
    e.memoizedState = $8e285ac053bcfb61$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $8e285ac053bcfb61$var$li(a, b, c, d) {
    var e = $8e285ac053bcfb61$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $8e285ac053bcfb61$var$N) {
        var g = $8e285ac053bcfb61$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $8e285ac053bcfb61$var$Mh(d, g.deps)) {
            e.memoizedState = $8e285ac053bcfb61$var$bi(b, c, f, d);
            return;
        }
    }
    $8e285ac053bcfb61$var$M.flags |= a;
    e.memoizedState = $8e285ac053bcfb61$var$bi(1 | b, c, f, d);
}
function $8e285ac053bcfb61$var$mi(a, b) {
    return $8e285ac053bcfb61$var$ki(8390656, 8, a, b);
}
function $8e285ac053bcfb61$var$$h(a, b) {
    return $8e285ac053bcfb61$var$li(2048, 8, a, b);
}
function $8e285ac053bcfb61$var$ni(a, b) {
    return $8e285ac053bcfb61$var$li(4, 2, a, b);
}
function $8e285ac053bcfb61$var$oi(a, b) {
    return $8e285ac053bcfb61$var$li(4, 4, a, b);
}
function $8e285ac053bcfb61$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $8e285ac053bcfb61$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $8e285ac053bcfb61$var$li(4, 4, $8e285ac053bcfb61$var$pi.bind(null, b, a), c);
}
function $8e285ac053bcfb61$var$ri() {}
function $8e285ac053bcfb61$var$si(a, b) {
    var c = $8e285ac053bcfb61$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8e285ac053bcfb61$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8e285ac053bcfb61$var$ti(a, b) {
    var c = $8e285ac053bcfb61$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8e285ac053bcfb61$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8e285ac053bcfb61$var$ui(a, b, c) {
    if (0 === ($8e285ac053bcfb61$var$Hh & 21)) return a.baseState && (a.baseState = !1, $8e285ac053bcfb61$var$dh = !0), a.memoizedState = c;
    $8e285ac053bcfb61$var$He(c, b) || (c = $8e285ac053bcfb61$var$yc(), $8e285ac053bcfb61$var$M.lanes |= c, $8e285ac053bcfb61$var$rh |= c, a.baseState = !0);
    return b;
}
function $8e285ac053bcfb61$var$vi(a, b) {
    var c = $8e285ac053bcfb61$var$C;
    $8e285ac053bcfb61$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $8e285ac053bcfb61$var$Gh.transition;
    $8e285ac053bcfb61$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $8e285ac053bcfb61$var$C = c, $8e285ac053bcfb61$var$Gh.transition = d;
    }
}
function $8e285ac053bcfb61$var$wi() {
    return $8e285ac053bcfb61$var$Uh().memoizedState;
}
function $8e285ac053bcfb61$var$xi(a, b, c) {
    var d = $8e285ac053bcfb61$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8e285ac053bcfb61$var$zi(a)) $8e285ac053bcfb61$var$Ai(b, c);
    else if (c = $8e285ac053bcfb61$var$hh(a, b, c, d), null !== c) {
        var e = $8e285ac053bcfb61$var$R();
        $8e285ac053bcfb61$var$gi(c, a, d, e);
        $8e285ac053bcfb61$var$Bi(c, b, d);
    }
}
function $8e285ac053bcfb61$var$ii(a, b, c) {
    var d = $8e285ac053bcfb61$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8e285ac053bcfb61$var$zi(a)) $8e285ac053bcfb61$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($8e285ac053bcfb61$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $8e285ac053bcfb61$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $8e285ac053bcfb61$var$hh(a, b, e, d);
        null !== c && (e = $8e285ac053bcfb61$var$R(), $8e285ac053bcfb61$var$gi(c, a, d, e), $8e285ac053bcfb61$var$Bi(c, b, d));
    }
}
function $8e285ac053bcfb61$var$zi(a) {
    var b = a.alternate;
    return a === $8e285ac053bcfb61$var$M || null !== b && b === $8e285ac053bcfb61$var$M;
}
function $8e285ac053bcfb61$var$Ai(a, b) {
    $8e285ac053bcfb61$var$Jh = $8e285ac053bcfb61$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $8e285ac053bcfb61$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8e285ac053bcfb61$var$Cc(a, c);
    }
}
var $8e285ac053bcfb61$var$Rh = {
    readContext: $8e285ac053bcfb61$var$eh,
    useCallback: $8e285ac053bcfb61$var$P,
    useContext: $8e285ac053bcfb61$var$P,
    useEffect: $8e285ac053bcfb61$var$P,
    useImperativeHandle: $8e285ac053bcfb61$var$P,
    useInsertionEffect: $8e285ac053bcfb61$var$P,
    useLayoutEffect: $8e285ac053bcfb61$var$P,
    useMemo: $8e285ac053bcfb61$var$P,
    useReducer: $8e285ac053bcfb61$var$P,
    useRef: $8e285ac053bcfb61$var$P,
    useState: $8e285ac053bcfb61$var$P,
    useDebugValue: $8e285ac053bcfb61$var$P,
    useDeferredValue: $8e285ac053bcfb61$var$P,
    useTransition: $8e285ac053bcfb61$var$P,
    useMutableSource: $8e285ac053bcfb61$var$P,
    useSyncExternalStore: $8e285ac053bcfb61$var$P,
    useId: $8e285ac053bcfb61$var$P,
    unstable_isNewReconciler: !1
}, $8e285ac053bcfb61$var$Oh = {
    readContext: $8e285ac053bcfb61$var$eh,
    useCallback: function(a, b) {
        $8e285ac053bcfb61$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $8e285ac053bcfb61$var$eh,
    useEffect: $8e285ac053bcfb61$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $8e285ac053bcfb61$var$ki(4194308, 4, $8e285ac053bcfb61$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $8e285ac053bcfb61$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $8e285ac053bcfb61$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $8e285ac053bcfb61$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $8e285ac053bcfb61$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $8e285ac053bcfb61$var$xi.bind(null, $8e285ac053bcfb61$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $8e285ac053bcfb61$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $8e285ac053bcfb61$var$hi,
    useDebugValue: $8e285ac053bcfb61$var$ri,
    useDeferredValue: function(a) {
        return $8e285ac053bcfb61$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $8e285ac053bcfb61$var$hi(!1), b = a[0];
        a = $8e285ac053bcfb61$var$vi.bind(null, a[1]);
        $8e285ac053bcfb61$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $8e285ac053bcfb61$var$M, e = $8e285ac053bcfb61$var$Th();
        if ($8e285ac053bcfb61$var$I) {
            if (void 0 === c) throw Error($8e285ac053bcfb61$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $8e285ac053bcfb61$var$Q) throw Error($8e285ac053bcfb61$var$p(349));
            0 !== ($8e285ac053bcfb61$var$Hh & 30) || $8e285ac053bcfb61$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $8e285ac053bcfb61$var$mi($8e285ac053bcfb61$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $8e285ac053bcfb61$var$bi(9, $8e285ac053bcfb61$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $8e285ac053bcfb61$var$Th(), b = $8e285ac053bcfb61$var$Q.identifierPrefix;
        if ($8e285ac053bcfb61$var$I) {
            var c = $8e285ac053bcfb61$var$sg;
            var d = $8e285ac053bcfb61$var$rg;
            c = (d & ~(1 << 32 - $8e285ac053bcfb61$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $8e285ac053bcfb61$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $8e285ac053bcfb61$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $8e285ac053bcfb61$var$Ph = {
    readContext: $8e285ac053bcfb61$var$eh,
    useCallback: $8e285ac053bcfb61$var$si,
    useContext: $8e285ac053bcfb61$var$eh,
    useEffect: $8e285ac053bcfb61$var$$h,
    useImperativeHandle: $8e285ac053bcfb61$var$qi,
    useInsertionEffect: $8e285ac053bcfb61$var$ni,
    useLayoutEffect: $8e285ac053bcfb61$var$oi,
    useMemo: $8e285ac053bcfb61$var$ti,
    useReducer: $8e285ac053bcfb61$var$Wh,
    useRef: $8e285ac053bcfb61$var$ji,
    useState: function() {
        return $8e285ac053bcfb61$var$Wh($8e285ac053bcfb61$var$Vh);
    },
    useDebugValue: $8e285ac053bcfb61$var$ri,
    useDeferredValue: function(a) {
        var b = $8e285ac053bcfb61$var$Uh();
        return $8e285ac053bcfb61$var$ui(b, $8e285ac053bcfb61$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8e285ac053bcfb61$var$Wh($8e285ac053bcfb61$var$Vh)[0], b = $8e285ac053bcfb61$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8e285ac053bcfb61$var$Yh,
    useSyncExternalStore: $8e285ac053bcfb61$var$Zh,
    useId: $8e285ac053bcfb61$var$wi,
    unstable_isNewReconciler: !1
}, $8e285ac053bcfb61$var$Qh = {
    readContext: $8e285ac053bcfb61$var$eh,
    useCallback: $8e285ac053bcfb61$var$si,
    useContext: $8e285ac053bcfb61$var$eh,
    useEffect: $8e285ac053bcfb61$var$$h,
    useImperativeHandle: $8e285ac053bcfb61$var$qi,
    useInsertionEffect: $8e285ac053bcfb61$var$ni,
    useLayoutEffect: $8e285ac053bcfb61$var$oi,
    useMemo: $8e285ac053bcfb61$var$ti,
    useReducer: $8e285ac053bcfb61$var$Xh,
    useRef: $8e285ac053bcfb61$var$ji,
    useState: function() {
        return $8e285ac053bcfb61$var$Xh($8e285ac053bcfb61$var$Vh);
    },
    useDebugValue: $8e285ac053bcfb61$var$ri,
    useDeferredValue: function(a) {
        var b = $8e285ac053bcfb61$var$Uh();
        return null === $8e285ac053bcfb61$var$N ? b.memoizedState = a : $8e285ac053bcfb61$var$ui(b, $8e285ac053bcfb61$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8e285ac053bcfb61$var$Xh($8e285ac053bcfb61$var$Vh)[0], b = $8e285ac053bcfb61$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8e285ac053bcfb61$var$Yh,
    useSyncExternalStore: $8e285ac053bcfb61$var$Zh,
    useId: $8e285ac053bcfb61$var$wi,
    unstable_isNewReconciler: !1
};
function $8e285ac053bcfb61$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $8e285ac053bcfb61$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $8e285ac053bcfb61$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8e285ac053bcfb61$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $8e285ac053bcfb61$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $8e285ac053bcfb61$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8e285ac053bcfb61$var$R(), e = $8e285ac053bcfb61$var$yi(a), f = $8e285ac053bcfb61$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8e285ac053bcfb61$var$nh(a, f, e);
        null !== b && ($8e285ac053bcfb61$var$gi(b, a, e, d), $8e285ac053bcfb61$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8e285ac053bcfb61$var$R(), e = $8e285ac053bcfb61$var$yi(a), f = $8e285ac053bcfb61$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8e285ac053bcfb61$var$nh(a, f, e);
        null !== b && ($8e285ac053bcfb61$var$gi(b, a, e, d), $8e285ac053bcfb61$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $8e285ac053bcfb61$var$R(), d = $8e285ac053bcfb61$var$yi(a), e = $8e285ac053bcfb61$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $8e285ac053bcfb61$var$nh(a, e, d);
        null !== b && ($8e285ac053bcfb61$var$gi(b, a, d, c), $8e285ac053bcfb61$var$oh(b, a, d));
    }
};
function $8e285ac053bcfb61$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$8e285ac053bcfb61$var$Ie(c, d) || !$8e285ac053bcfb61$var$Ie(e, f) : !0;
}
function $8e285ac053bcfb61$var$Gi(a, b, c) {
    var d = !1, e = $8e285ac053bcfb61$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $8e285ac053bcfb61$var$eh(f) : (e = $8e285ac053bcfb61$var$Zf(b) ? $8e285ac053bcfb61$var$Xf : $8e285ac053bcfb61$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $8e285ac053bcfb61$var$Yf(a, e) : $8e285ac053bcfb61$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $8e285ac053bcfb61$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $8e285ac053bcfb61$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $8e285ac053bcfb61$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $8e285ac053bcfb61$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $8e285ac053bcfb61$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $8e285ac053bcfb61$var$eh(f) : (f = $8e285ac053bcfb61$var$Zf(b) ? $8e285ac053bcfb61$var$Xf : $8e285ac053bcfb61$var$H.current, e.context = $8e285ac053bcfb61$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($8e285ac053bcfb61$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $8e285ac053bcfb61$var$Ei.enqueueReplaceState(e, e.state, null), $8e285ac053bcfb61$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $8e285ac053bcfb61$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $8e285ac053bcfb61$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $8e285ac053bcfb61$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $8e285ac053bcfb61$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $8e285ac053bcfb61$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $8e285ac053bcfb61$var$Ni(a, b, c) {
    c = $8e285ac053bcfb61$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $8e285ac053bcfb61$var$Oi || ($8e285ac053bcfb61$var$Oi = !0, $8e285ac053bcfb61$var$Pi = d);
        $8e285ac053bcfb61$var$Li(a, b);
    };
    return c;
}
function $8e285ac053bcfb61$var$Qi(a, b, c) {
    c = $8e285ac053bcfb61$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $8e285ac053bcfb61$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $8e285ac053bcfb61$var$Li(a, b);
        "function" !== typeof d && (null === $8e285ac053bcfb61$var$Ri ? $8e285ac053bcfb61$var$Ri = new Set([
            this
        ]) : $8e285ac053bcfb61$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $8e285ac053bcfb61$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $8e285ac053bcfb61$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $8e285ac053bcfb61$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $8e285ac053bcfb61$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $8e285ac053bcfb61$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $8e285ac053bcfb61$var$mh(-1, 1), b.tag = 2, $8e285ac053bcfb61$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $8e285ac053bcfb61$var$Wi = $8e285ac053bcfb61$var$ua.ReactCurrentOwner, $8e285ac053bcfb61$var$dh = !1;
function $8e285ac053bcfb61$var$Xi(a, b, c, d) {
    b.child = null === a ? $8e285ac053bcfb61$var$Vg(b, null, c, d) : $8e285ac053bcfb61$var$Ug(b, a.child, c, d);
}
function $8e285ac053bcfb61$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $8e285ac053bcfb61$var$ch(b, e);
    d = $8e285ac053bcfb61$var$Nh(a, b, c, d, f, e);
    c = $8e285ac053bcfb61$var$Sh();
    if (null !== a && !$8e285ac053bcfb61$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8e285ac053bcfb61$var$Zi(a, b, e);
    $8e285ac053bcfb61$var$I && c && $8e285ac053bcfb61$var$vg(b);
    b.flags |= 1;
    $8e285ac053bcfb61$var$Xi(a, b, d, e);
    return b.child;
}
function $8e285ac053bcfb61$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$8e285ac053bcfb61$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $8e285ac053bcfb61$var$bj(a, b, f, d, e);
        a = $8e285ac053bcfb61$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $8e285ac053bcfb61$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $8e285ac053bcfb61$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $8e285ac053bcfb61$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $8e285ac053bcfb61$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($8e285ac053bcfb61$var$Ie(f, d) && a.ref === b.ref) {
            if ($8e285ac053bcfb61$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($8e285ac053bcfb61$var$dh = !0);
            else return b.lanes = a.lanes, $8e285ac053bcfb61$var$Zi(a, b, e);
        }
    }
    return $8e285ac053bcfb61$var$cj(a, b, c, d, e);
}
function $8e285ac053bcfb61$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$ej, $8e285ac053bcfb61$var$fj), $8e285ac053bcfb61$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$ej, $8e285ac053bcfb61$var$fj), $8e285ac053bcfb61$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$ej, $8e285ac053bcfb61$var$fj);
            $8e285ac053bcfb61$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$ej, $8e285ac053bcfb61$var$fj), $8e285ac053bcfb61$var$fj |= d;
    $8e285ac053bcfb61$var$Xi(a, b, e, c);
    return b.child;
}
function $8e285ac053bcfb61$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $8e285ac053bcfb61$var$cj(a, b, c, d, e) {
    var f = $8e285ac053bcfb61$var$Zf(c) ? $8e285ac053bcfb61$var$Xf : $8e285ac053bcfb61$var$H.current;
    f = $8e285ac053bcfb61$var$Yf(b, f);
    $8e285ac053bcfb61$var$ch(b, e);
    c = $8e285ac053bcfb61$var$Nh(a, b, c, d, f, e);
    d = $8e285ac053bcfb61$var$Sh();
    if (null !== a && !$8e285ac053bcfb61$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8e285ac053bcfb61$var$Zi(a, b, e);
    $8e285ac053bcfb61$var$I && d && $8e285ac053bcfb61$var$vg(b);
    b.flags |= 1;
    $8e285ac053bcfb61$var$Xi(a, b, c, e);
    return b.child;
}
function $8e285ac053bcfb61$var$hj(a, b, c, d, e) {
    if ($8e285ac053bcfb61$var$Zf(c)) {
        var f = !0;
        $8e285ac053bcfb61$var$cg(b);
    } else f = !1;
    $8e285ac053bcfb61$var$ch(b, e);
    if (null === b.stateNode) $8e285ac053bcfb61$var$ij(a, b), $8e285ac053bcfb61$var$Gi(b, c, d), $8e285ac053bcfb61$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $8e285ac053bcfb61$var$eh(l) : (l = $8e285ac053bcfb61$var$Zf(c) ? $8e285ac053bcfb61$var$Xf : $8e285ac053bcfb61$var$H.current, l = $8e285ac053bcfb61$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $8e285ac053bcfb61$var$Hi(b, g, d, l);
        $8e285ac053bcfb61$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $8e285ac053bcfb61$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $8e285ac053bcfb61$var$Wf.current || $8e285ac053bcfb61$var$jh ? ("function" === typeof m && ($8e285ac053bcfb61$var$Di(b, c, m, d), k = b.memoizedState), (h = $8e285ac053bcfb61$var$jh || $8e285ac053bcfb61$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $8e285ac053bcfb61$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $8e285ac053bcfb61$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $8e285ac053bcfb61$var$eh(k) : (k = $8e285ac053bcfb61$var$Zf(c) ? $8e285ac053bcfb61$var$Xf : $8e285ac053bcfb61$var$H.current, k = $8e285ac053bcfb61$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $8e285ac053bcfb61$var$Hi(b, g, d, k);
        $8e285ac053bcfb61$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $8e285ac053bcfb61$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $8e285ac053bcfb61$var$Wf.current || $8e285ac053bcfb61$var$jh ? ("function" === typeof y && ($8e285ac053bcfb61$var$Di(b, c, y, d), n = b.memoizedState), (l = $8e285ac053bcfb61$var$jh || $8e285ac053bcfb61$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $8e285ac053bcfb61$var$jj(a, b, c, d, f, e);
}
function $8e285ac053bcfb61$var$jj(a, b, c, d, e, f) {
    $8e285ac053bcfb61$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $8e285ac053bcfb61$var$dg(b, c, !1), $8e285ac053bcfb61$var$Zi(a, b, f);
    d = b.stateNode;
    $8e285ac053bcfb61$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $8e285ac053bcfb61$var$Ug(b, a.child, null, f), b.child = $8e285ac053bcfb61$var$Ug(b, null, h, f)) : $8e285ac053bcfb61$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $8e285ac053bcfb61$var$dg(b, c, !0);
    return b.child;
}
function $8e285ac053bcfb61$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $8e285ac053bcfb61$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $8e285ac053bcfb61$var$ag(a, b.context, !1);
    $8e285ac053bcfb61$var$yh(a, b.containerInfo);
}
function $8e285ac053bcfb61$var$lj(a, b, c, d, e) {
    $8e285ac053bcfb61$var$Ig();
    $8e285ac053bcfb61$var$Jg(e);
    b.flags |= 256;
    $8e285ac053bcfb61$var$Xi(a, b, c, d);
    return b.child;
}
var $8e285ac053bcfb61$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $8e285ac053bcfb61$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $8e285ac053bcfb61$var$oj(a, b, c) {
    var d = b.pendingProps, e = $8e285ac053bcfb61$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, e & 1);
    if (null === a) {
        $8e285ac053bcfb61$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $8e285ac053bcfb61$var$pj(g, d, 0, null), a = $8e285ac053bcfb61$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $8e285ac053bcfb61$var$nj(c), b.memoizedState = $8e285ac053bcfb61$var$mj, a) : $8e285ac053bcfb61$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $8e285ac053bcfb61$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $8e285ac053bcfb61$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $8e285ac053bcfb61$var$Pg(h, f) : (f = $8e285ac053bcfb61$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $8e285ac053bcfb61$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $8e285ac053bcfb61$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $8e285ac053bcfb61$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $8e285ac053bcfb61$var$qj(a, b) {
    b = $8e285ac053bcfb61$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $8e285ac053bcfb61$var$sj(a, b, c, d) {
    null !== d && $8e285ac053bcfb61$var$Jg(d);
    $8e285ac053bcfb61$var$Ug(b, a.child, null, c);
    a = $8e285ac053bcfb61$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $8e285ac053bcfb61$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $8e285ac053bcfb61$var$Ki(Error($8e285ac053bcfb61$var$p(422))), $8e285ac053bcfb61$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $8e285ac053bcfb61$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $8e285ac053bcfb61$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $8e285ac053bcfb61$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $8e285ac053bcfb61$var$nj(g);
        b.memoizedState = $8e285ac053bcfb61$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $8e285ac053bcfb61$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($8e285ac053bcfb61$var$p(419));
        d = $8e285ac053bcfb61$var$Ki(f, d, void 0);
        return $8e285ac053bcfb61$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($8e285ac053bcfb61$var$dh || h) {
        d = $8e285ac053bcfb61$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $8e285ac053bcfb61$var$ih(a, e), $8e285ac053bcfb61$var$gi(d, a, e, -1));
        }
        $8e285ac053bcfb61$var$tj();
        d = $8e285ac053bcfb61$var$Ki(Error($8e285ac053bcfb61$var$p(421)));
        return $8e285ac053bcfb61$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $8e285ac053bcfb61$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $8e285ac053bcfb61$var$yg = $8e285ac053bcfb61$var$Lf(e.nextSibling);
    $8e285ac053bcfb61$var$xg = b;
    $8e285ac053bcfb61$var$I = !0;
    $8e285ac053bcfb61$var$zg = null;
    null !== a && ($8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg++] = $8e285ac053bcfb61$var$rg, $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg++] = $8e285ac053bcfb61$var$sg, $8e285ac053bcfb61$var$og[$8e285ac053bcfb61$var$pg++] = $8e285ac053bcfb61$var$qg, $8e285ac053bcfb61$var$rg = a.id, $8e285ac053bcfb61$var$sg = a.overflow, $8e285ac053bcfb61$var$qg = b);
    b = $8e285ac053bcfb61$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $8e285ac053bcfb61$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $8e285ac053bcfb61$var$bh(a.return, b, c);
}
function $8e285ac053bcfb61$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $8e285ac053bcfb61$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $8e285ac053bcfb61$var$Xi(a, b, d.children, c);
    d = $8e285ac053bcfb61$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $8e285ac053bcfb61$var$vj(a, c, b);
            else if (19 === a.tag) $8e285ac053bcfb61$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $8e285ac053bcfb61$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $8e285ac053bcfb61$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $8e285ac053bcfb61$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $8e285ac053bcfb61$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $8e285ac053bcfb61$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $8e285ac053bcfb61$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $8e285ac053bcfb61$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $8e285ac053bcfb61$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($8e285ac053bcfb61$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $8e285ac053bcfb61$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $8e285ac053bcfb61$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $8e285ac053bcfb61$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $8e285ac053bcfb61$var$kj(b);
            $8e285ac053bcfb61$var$Ig();
            break;
        case 5:
            $8e285ac053bcfb61$var$Ah(b);
            break;
        case 1:
            $8e285ac053bcfb61$var$Zf(b.type) && $8e285ac053bcfb61$var$cg(b);
            break;
        case 4:
            $8e285ac053bcfb61$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, $8e285ac053bcfb61$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $8e285ac053bcfb61$var$oj(a, b, c);
                $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, $8e285ac053bcfb61$var$L.current & 1);
                a = $8e285ac053bcfb61$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, $8e285ac053bcfb61$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $8e285ac053bcfb61$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, $8e285ac053bcfb61$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $8e285ac053bcfb61$var$dj(a, b, c);
    }
    return $8e285ac053bcfb61$var$Zi(a, b, c);
}
var $8e285ac053bcfb61$var$zj, $8e285ac053bcfb61$var$Aj, $8e285ac053bcfb61$var$Bj, $8e285ac053bcfb61$var$Cj;
$8e285ac053bcfb61$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$8e285ac053bcfb61$var$Aj = function() {};
$8e285ac053bcfb61$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $8e285ac053bcfb61$var$xh($8e285ac053bcfb61$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $8e285ac053bcfb61$var$Ya(a, e);
                d = $8e285ac053bcfb61$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $8e285ac053bcfb61$var$A({}, e, {
                    value: void 0
                });
                d = $8e285ac053bcfb61$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $8e285ac053bcfb61$var$gb(a, e);
                d = $8e285ac053bcfb61$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $8e285ac053bcfb61$var$Bf);
        }
        $8e285ac053bcfb61$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($8e285ac053bcfb61$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($8e285ac053bcfb61$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $8e285ac053bcfb61$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$8e285ac053bcfb61$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $8e285ac053bcfb61$var$Dj(a, b) {
    if (!$8e285ac053bcfb61$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $8e285ac053bcfb61$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $8e285ac053bcfb61$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $8e285ac053bcfb61$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8e285ac053bcfb61$var$S(b), null;
        case 1:
            return $8e285ac053bcfb61$var$Zf(b.type) && $8e285ac053bcfb61$var$$f(), $8e285ac053bcfb61$var$S(b), null;
        case 3:
            d = b.stateNode;
            $8e285ac053bcfb61$var$zh();
            $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$Wf);
            $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$H);
            $8e285ac053bcfb61$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $8e285ac053bcfb61$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $8e285ac053bcfb61$var$zg && ($8e285ac053bcfb61$var$Fj($8e285ac053bcfb61$var$zg), $8e285ac053bcfb61$var$zg = null));
            $8e285ac053bcfb61$var$Aj(a, b);
            $8e285ac053bcfb61$var$S(b);
            return null;
        case 5:
            $8e285ac053bcfb61$var$Bh(b);
            var e = $8e285ac053bcfb61$var$xh($8e285ac053bcfb61$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $8e285ac053bcfb61$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($8e285ac053bcfb61$var$p(166));
                    $8e285ac053bcfb61$var$S(b);
                    return null;
                }
                a = $8e285ac053bcfb61$var$xh($8e285ac053bcfb61$var$uh.current);
                if ($8e285ac053bcfb61$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$8e285ac053bcfb61$var$Of] = b;
                    d[$8e285ac053bcfb61$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $8e285ac053bcfb61$var$D("cancel", d);
                            $8e285ac053bcfb61$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $8e285ac053bcfb61$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $8e285ac053bcfb61$var$lf.length; e++)$8e285ac053bcfb61$var$D($8e285ac053bcfb61$var$lf[e], d);
                            break;
                        case "source":
                            $8e285ac053bcfb61$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $8e285ac053bcfb61$var$D("error", d);
                            $8e285ac053bcfb61$var$D("load", d);
                            break;
                        case "details":
                            $8e285ac053bcfb61$var$D("toggle", d);
                            break;
                        case "input":
                            $8e285ac053bcfb61$var$Za(d, f);
                            $8e285ac053bcfb61$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $8e285ac053bcfb61$var$D("invalid", d);
                            break;
                        case "textarea":
                            $8e285ac053bcfb61$var$hb(d, f), $8e285ac053bcfb61$var$D("invalid", d);
                    }
                    $8e285ac053bcfb61$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $8e285ac053bcfb61$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $8e285ac053bcfb61$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $8e285ac053bcfb61$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $8e285ac053bcfb61$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $8e285ac053bcfb61$var$Va(d);
                            $8e285ac053bcfb61$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $8e285ac053bcfb61$var$Va(d);
                            $8e285ac053bcfb61$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $8e285ac053bcfb61$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $8e285ac053bcfb61$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$8e285ac053bcfb61$var$Of] = b;
                    a[$8e285ac053bcfb61$var$Pf] = d;
                    $8e285ac053bcfb61$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $8e285ac053bcfb61$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $8e285ac053bcfb61$var$D("cancel", a);
                                $8e285ac053bcfb61$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $8e285ac053bcfb61$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $8e285ac053bcfb61$var$lf.length; e++)$8e285ac053bcfb61$var$D($8e285ac053bcfb61$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $8e285ac053bcfb61$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $8e285ac053bcfb61$var$D("error", a);
                                $8e285ac053bcfb61$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $8e285ac053bcfb61$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $8e285ac053bcfb61$var$Za(a, d);
                                e = $8e285ac053bcfb61$var$Ya(a, d);
                                $8e285ac053bcfb61$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $8e285ac053bcfb61$var$A({}, d, {
                                    value: void 0
                                });
                                $8e285ac053bcfb61$var$D("invalid", a);
                                break;
                            case "textarea":
                                $8e285ac053bcfb61$var$hb(a, d);
                                e = $8e285ac053bcfb61$var$gb(a, d);
                                $8e285ac053bcfb61$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $8e285ac053bcfb61$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $8e285ac053bcfb61$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $8e285ac053bcfb61$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $8e285ac053bcfb61$var$ob(a, k) : "number" === typeof k && $8e285ac053bcfb61$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($8e285ac053bcfb61$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $8e285ac053bcfb61$var$D("scroll", a) : null != k && $8e285ac053bcfb61$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $8e285ac053bcfb61$var$Va(a);
                                $8e285ac053bcfb61$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $8e285ac053bcfb61$var$Va(a);
                                $8e285ac053bcfb61$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $8e285ac053bcfb61$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $8e285ac053bcfb61$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $8e285ac053bcfb61$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $8e285ac053bcfb61$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $8e285ac053bcfb61$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $8e285ac053bcfb61$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($8e285ac053bcfb61$var$p(166));
                c = $8e285ac053bcfb61$var$xh($8e285ac053bcfb61$var$wh.current);
                $8e285ac053bcfb61$var$xh($8e285ac053bcfb61$var$uh.current);
                if ($8e285ac053bcfb61$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$8e285ac053bcfb61$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $8e285ac053bcfb61$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $8e285ac053bcfb61$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $8e285ac053bcfb61$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$8e285ac053bcfb61$var$Of] = b, b.stateNode = d;
            }
            $8e285ac053bcfb61$var$S(b);
            return null;
        case 13:
            $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($8e285ac053bcfb61$var$I && null !== $8e285ac053bcfb61$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $8e285ac053bcfb61$var$Hg(), $8e285ac053bcfb61$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $8e285ac053bcfb61$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($8e285ac053bcfb61$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($8e285ac053bcfb61$var$p(317));
                        f[$8e285ac053bcfb61$var$Of] = b;
                    } else $8e285ac053bcfb61$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $8e285ac053bcfb61$var$S(b);
                    f = !1;
                } else null !== $8e285ac053bcfb61$var$zg && ($8e285ac053bcfb61$var$Fj($8e285ac053bcfb61$var$zg), $8e285ac053bcfb61$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($8e285ac053bcfb61$var$L.current & 1) ? 0 === $8e285ac053bcfb61$var$T && ($8e285ac053bcfb61$var$T = 3) : $8e285ac053bcfb61$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $8e285ac053bcfb61$var$S(b);
            return null;
        case 4:
            return $8e285ac053bcfb61$var$zh(), $8e285ac053bcfb61$var$Aj(a, b), null === a && $8e285ac053bcfb61$var$sf(b.stateNode.containerInfo), $8e285ac053bcfb61$var$S(b), null;
        case 10:
            return $8e285ac053bcfb61$var$ah(b.type._context), $8e285ac053bcfb61$var$S(b), null;
        case 17:
            return $8e285ac053bcfb61$var$Zf(b.type) && $8e285ac053bcfb61$var$$f(), $8e285ac053bcfb61$var$S(b), null;
        case 19:
            $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$L);
            f = b.memoizedState;
            if (null === f) return $8e285ac053bcfb61$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $8e285ac053bcfb61$var$Dj(f, !1);
                else {
                    if (0 !== $8e285ac053bcfb61$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $8e285ac053bcfb61$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $8e285ac053bcfb61$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, $8e285ac053bcfb61$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $8e285ac053bcfb61$var$B() > $8e285ac053bcfb61$var$Gj && (b.flags |= 128, d = !0, $8e285ac053bcfb61$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $8e285ac053bcfb61$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $8e285ac053bcfb61$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$8e285ac053bcfb61$var$I) return $8e285ac053bcfb61$var$S(b), null;
                    } else 2 * $8e285ac053bcfb61$var$B() - f.renderingStartTime > $8e285ac053bcfb61$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $8e285ac053bcfb61$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $8e285ac053bcfb61$var$B(), b.sibling = null, c = $8e285ac053bcfb61$var$L.current, $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$L, d ? c & 1 | 2 : c & 1), b;
            $8e285ac053bcfb61$var$S(b);
            return null;
        case 22:
        case 23:
            return $8e285ac053bcfb61$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($8e285ac053bcfb61$var$fj & 1073741824) && ($8e285ac053bcfb61$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $8e285ac053bcfb61$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($8e285ac053bcfb61$var$p(156, b.tag));
}
function $8e285ac053bcfb61$var$Ij(a, b) {
    $8e285ac053bcfb61$var$wg(b);
    switch(b.tag){
        case 1:
            return $8e285ac053bcfb61$var$Zf(b.type) && $8e285ac053bcfb61$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $8e285ac053bcfb61$var$zh(), $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$Wf), $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$H), $8e285ac053bcfb61$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $8e285ac053bcfb61$var$Bh(b), null;
        case 13:
            $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($8e285ac053bcfb61$var$p(340));
                $8e285ac053bcfb61$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$L), null;
        case 4:
            return $8e285ac053bcfb61$var$zh(), null;
        case 10:
            return $8e285ac053bcfb61$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $8e285ac053bcfb61$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $8e285ac053bcfb61$var$Jj = !1, $8e285ac053bcfb61$var$U = !1, $8e285ac053bcfb61$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $8e285ac053bcfb61$var$V = null;
function $8e285ac053bcfb61$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $8e285ac053bcfb61$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $8e285ac053bcfb61$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $8e285ac053bcfb61$var$W(a, b, d);
    }
}
var $8e285ac053bcfb61$var$Nj = !1;
function $8e285ac053bcfb61$var$Oj(a, b) {
    $8e285ac053bcfb61$var$Cf = $8e285ac053bcfb61$var$dd;
    a = $8e285ac053bcfb61$var$Me();
    if ($8e285ac053bcfb61$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $8e285ac053bcfb61$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $8e285ac053bcfb61$var$dd = !1;
    for($8e285ac053bcfb61$var$V = b; null !== $8e285ac053bcfb61$var$V;)if (b = $8e285ac053bcfb61$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $8e285ac053bcfb61$var$V = a;
    else for(; null !== $8e285ac053bcfb61$var$V;){
        b = $8e285ac053bcfb61$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $8e285ac053bcfb61$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($8e285ac053bcfb61$var$p(163));
            }
        } catch (F) {
            $8e285ac053bcfb61$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $8e285ac053bcfb61$var$V = a;
            break;
        }
        $8e285ac053bcfb61$var$V = b.return;
    }
    n = $8e285ac053bcfb61$var$Nj;
    $8e285ac053bcfb61$var$Nj = !1;
    return n;
}
function $8e285ac053bcfb61$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $8e285ac053bcfb61$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $8e285ac053bcfb61$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $8e285ac053bcfb61$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $8e285ac053bcfb61$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $8e285ac053bcfb61$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$8e285ac053bcfb61$var$Of], delete b[$8e285ac053bcfb61$var$Pf], delete b[$8e285ac053bcfb61$var$of], delete b[$8e285ac053bcfb61$var$Qf], delete b[$8e285ac053bcfb61$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $8e285ac053bcfb61$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $8e285ac053bcfb61$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $8e285ac053bcfb61$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $8e285ac053bcfb61$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $8e285ac053bcfb61$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($8e285ac053bcfb61$var$Vj(a, b, c), a = a.sibling; null !== a;)$8e285ac053bcfb61$var$Vj(a, b, c), a = a.sibling;
}
function $8e285ac053bcfb61$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($8e285ac053bcfb61$var$Wj(a, b, c), a = a.sibling; null !== a;)$8e285ac053bcfb61$var$Wj(a, b, c), a = a.sibling;
}
var $8e285ac053bcfb61$var$X = null, $8e285ac053bcfb61$var$Xj = !1;
function $8e285ac053bcfb61$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$8e285ac053bcfb61$var$Zj(a, b, c), c = c.sibling;
}
function $8e285ac053bcfb61$var$Zj(a, b, c) {
    if ($8e285ac053bcfb61$var$lc && "function" === typeof $8e285ac053bcfb61$var$lc.onCommitFiberUnmount) try {
        $8e285ac053bcfb61$var$lc.onCommitFiberUnmount($8e285ac053bcfb61$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $8e285ac053bcfb61$var$U || $8e285ac053bcfb61$var$Lj(c, b);
        case 6:
            var d = $8e285ac053bcfb61$var$X, e = $8e285ac053bcfb61$var$Xj;
            $8e285ac053bcfb61$var$X = null;
            $8e285ac053bcfb61$var$Yj(a, b, c);
            $8e285ac053bcfb61$var$X = d;
            $8e285ac053bcfb61$var$Xj = e;
            null !== $8e285ac053bcfb61$var$X && ($8e285ac053bcfb61$var$Xj ? (a = $8e285ac053bcfb61$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $8e285ac053bcfb61$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $8e285ac053bcfb61$var$X && ($8e285ac053bcfb61$var$Xj ? (a = $8e285ac053bcfb61$var$X, c = c.stateNode, 8 === a.nodeType ? $8e285ac053bcfb61$var$Kf(a.parentNode, c) : 1 === a.nodeType && $8e285ac053bcfb61$var$Kf(a, c), $8e285ac053bcfb61$var$bd(a)) : $8e285ac053bcfb61$var$Kf($8e285ac053bcfb61$var$X, c.stateNode));
            break;
        case 4:
            d = $8e285ac053bcfb61$var$X;
            e = $8e285ac053bcfb61$var$Xj;
            $8e285ac053bcfb61$var$X = c.stateNode.containerInfo;
            $8e285ac053bcfb61$var$Xj = !0;
            $8e285ac053bcfb61$var$Yj(a, b, c);
            $8e285ac053bcfb61$var$X = d;
            $8e285ac053bcfb61$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$8e285ac053bcfb61$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $8e285ac053bcfb61$var$Mj(c, b, g) : 0 !== (f & 4) && $8e285ac053bcfb61$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $8e285ac053bcfb61$var$Yj(a, b, c);
            break;
        case 1:
            if (!$8e285ac053bcfb61$var$U && ($8e285ac053bcfb61$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $8e285ac053bcfb61$var$W(c, b, h);
            }
            $8e285ac053bcfb61$var$Yj(a, b, c);
            break;
        case 21:
            $8e285ac053bcfb61$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($8e285ac053bcfb61$var$U = (d = $8e285ac053bcfb61$var$U) || null !== c.memoizedState, $8e285ac053bcfb61$var$Yj(a, b, c), $8e285ac053bcfb61$var$U = d) : $8e285ac053bcfb61$var$Yj(a, b, c);
            break;
        default:
            $8e285ac053bcfb61$var$Yj(a, b, c);
    }
}
function $8e285ac053bcfb61$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $8e285ac053bcfb61$var$Kj);
        b.forEach(function(b) {
            var d = $8e285ac053bcfb61$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $8e285ac053bcfb61$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $8e285ac053bcfb61$var$X = h.stateNode;
                        $8e285ac053bcfb61$var$Xj = !1;
                        break a;
                    case 3:
                        $8e285ac053bcfb61$var$X = h.stateNode.containerInfo;
                        $8e285ac053bcfb61$var$Xj = !0;
                        break a;
                    case 4:
                        $8e285ac053bcfb61$var$X = h.stateNode.containerInfo;
                        $8e285ac053bcfb61$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $8e285ac053bcfb61$var$X) throw Error($8e285ac053bcfb61$var$p(160));
            $8e285ac053bcfb61$var$Zj(f, g, e);
            $8e285ac053bcfb61$var$X = null;
            $8e285ac053bcfb61$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $8e285ac053bcfb61$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$8e285ac053bcfb61$var$dk(b, a), b = b.sibling;
}
function $8e285ac053bcfb61$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            if (d & 4) {
                try {
                    $8e285ac053bcfb61$var$Pj(3, a, a.return), $8e285ac053bcfb61$var$Qj(3, a);
                } catch (t) {
                    $8e285ac053bcfb61$var$W(a, a.return, t);
                }
                try {
                    $8e285ac053bcfb61$var$Pj(5, a, a.return);
                } catch (t) {
                    $8e285ac053bcfb61$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            d & 512 && null !== c && $8e285ac053bcfb61$var$Lj(c, c.return);
            break;
        case 5:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            d & 512 && null !== c && $8e285ac053bcfb61$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $8e285ac053bcfb61$var$ob(e, "");
                } catch (t) {
                    $8e285ac053bcfb61$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $8e285ac053bcfb61$var$ab(e, f);
                    $8e285ac053bcfb61$var$vb(h, g);
                    var l = $8e285ac053bcfb61$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $8e285ac053bcfb61$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $8e285ac053bcfb61$var$nb(e, q) : "children" === m ? $8e285ac053bcfb61$var$ob(e, q) : $8e285ac053bcfb61$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $8e285ac053bcfb61$var$bb(e, f);
                            break;
                        case "textarea":
                            $8e285ac053bcfb61$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $8e285ac053bcfb61$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $8e285ac053bcfb61$var$fb(e, !!f.multiple, f.defaultValue, !0) : $8e285ac053bcfb61$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$8e285ac053bcfb61$var$Pf] = f;
                } catch (t) {
                    $8e285ac053bcfb61$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($8e285ac053bcfb61$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $8e285ac053bcfb61$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $8e285ac053bcfb61$var$bd(b.containerInfo);
            } catch (t) {
                $8e285ac053bcfb61$var$W(a, a.return, t);
            }
            break;
        case 4:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            break;
        case 13:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($8e285ac053bcfb61$var$fk = $8e285ac053bcfb61$var$B()));
            d & 4 && $8e285ac053bcfb61$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($8e285ac053bcfb61$var$U = (l = $8e285ac053bcfb61$var$U) || m, $8e285ac053bcfb61$var$ck(b, a), $8e285ac053bcfb61$var$U = l) : $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($8e285ac053bcfb61$var$V = a, m = a.child; null !== m;){
                    for(q = $8e285ac053bcfb61$var$V = m; null !== $8e285ac053bcfb61$var$V;){
                        r = $8e285ac053bcfb61$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $8e285ac053bcfb61$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $8e285ac053bcfb61$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $8e285ac053bcfb61$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $8e285ac053bcfb61$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $8e285ac053bcfb61$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $8e285ac053bcfb61$var$V = y) : $8e285ac053bcfb61$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $8e285ac053bcfb61$var$rb("display", g));
                            } catch (t) {
                                $8e285ac053bcfb61$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $8e285ac053bcfb61$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $8e285ac053bcfb61$var$ck(b, a);
            $8e285ac053bcfb61$var$ek(a);
            d & 4 && $8e285ac053bcfb61$var$ak(a);
            break;
        case 21:
            break;
        default:
            $8e285ac053bcfb61$var$ck(b, a), $8e285ac053bcfb61$var$ek(a);
    }
}
function $8e285ac053bcfb61$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($8e285ac053bcfb61$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($8e285ac053bcfb61$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($8e285ac053bcfb61$var$ob(e, ""), d.flags &= -33);
                    var f = $8e285ac053bcfb61$var$Uj(a);
                    $8e285ac053bcfb61$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $8e285ac053bcfb61$var$Uj(a);
                    $8e285ac053bcfb61$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($8e285ac053bcfb61$var$p(161));
            }
        } catch (k) {
            $8e285ac053bcfb61$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $8e285ac053bcfb61$var$hk(a, b, c) {
    $8e285ac053bcfb61$var$V = a;
    $8e285ac053bcfb61$var$ik(a, b, c);
}
function $8e285ac053bcfb61$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $8e285ac053bcfb61$var$V;){
        var e = $8e285ac053bcfb61$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $8e285ac053bcfb61$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $8e285ac053bcfb61$var$U;
                h = $8e285ac053bcfb61$var$Jj;
                var l = $8e285ac053bcfb61$var$U;
                $8e285ac053bcfb61$var$Jj = g;
                if (($8e285ac053bcfb61$var$U = k) && !l) for($8e285ac053bcfb61$var$V = e; null !== $8e285ac053bcfb61$var$V;)g = $8e285ac053bcfb61$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $8e285ac053bcfb61$var$jk(e) : null !== k ? (k.return = g, $8e285ac053bcfb61$var$V = k) : $8e285ac053bcfb61$var$jk(e);
                for(; null !== f;)$8e285ac053bcfb61$var$V = f, $8e285ac053bcfb61$var$ik(f, b, c), f = f.sibling;
                $8e285ac053bcfb61$var$V = e;
                $8e285ac053bcfb61$var$Jj = h;
                $8e285ac053bcfb61$var$U = l;
            }
            $8e285ac053bcfb61$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $8e285ac053bcfb61$var$V = f) : $8e285ac053bcfb61$var$kk(a, b, c);
    }
}
function $8e285ac053bcfb61$var$kk(a) {
    for(; null !== $8e285ac053bcfb61$var$V;){
        var b = $8e285ac053bcfb61$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $8e285ac053bcfb61$var$U || $8e285ac053bcfb61$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$8e285ac053bcfb61$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $8e285ac053bcfb61$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $8e285ac053bcfb61$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $8e285ac053bcfb61$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $8e285ac053bcfb61$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($8e285ac053bcfb61$var$p(163));
                }
                $8e285ac053bcfb61$var$U || b.flags & 512 && $8e285ac053bcfb61$var$Rj(b);
            } catch (r) {
                $8e285ac053bcfb61$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $8e285ac053bcfb61$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8e285ac053bcfb61$var$V = c;
            break;
        }
        $8e285ac053bcfb61$var$V = b.return;
    }
}
function $8e285ac053bcfb61$var$gk(a) {
    for(; null !== $8e285ac053bcfb61$var$V;){
        var b = $8e285ac053bcfb61$var$V;
        if (b === a) {
            $8e285ac053bcfb61$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8e285ac053bcfb61$var$V = c;
            break;
        }
        $8e285ac053bcfb61$var$V = b.return;
    }
}
function $8e285ac053bcfb61$var$jk(a) {
    for(; null !== $8e285ac053bcfb61$var$V;){
        var b = $8e285ac053bcfb61$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $8e285ac053bcfb61$var$Qj(4, b);
                    } catch (k) {
                        $8e285ac053bcfb61$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $8e285ac053bcfb61$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $8e285ac053bcfb61$var$Rj(b);
                    } catch (k) {
                        $8e285ac053bcfb61$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $8e285ac053bcfb61$var$Rj(b);
                    } catch (k) {
                        $8e285ac053bcfb61$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $8e285ac053bcfb61$var$W(b, b.return, k);
        }
        if (b === a) {
            $8e285ac053bcfb61$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $8e285ac053bcfb61$var$V = h;
            break;
        }
        $8e285ac053bcfb61$var$V = b.return;
    }
}
var $8e285ac053bcfb61$var$lk = Math.ceil, $8e285ac053bcfb61$var$mk = $8e285ac053bcfb61$var$ua.ReactCurrentDispatcher, $8e285ac053bcfb61$var$nk = $8e285ac053bcfb61$var$ua.ReactCurrentOwner, $8e285ac053bcfb61$var$ok = $8e285ac053bcfb61$var$ua.ReactCurrentBatchConfig, $8e285ac053bcfb61$var$K = 0, $8e285ac053bcfb61$var$Q = null, $8e285ac053bcfb61$var$Y = null, $8e285ac053bcfb61$var$Z = 0, $8e285ac053bcfb61$var$fj = 0, $8e285ac053bcfb61$var$ej = $8e285ac053bcfb61$var$Uf(0), $8e285ac053bcfb61$var$T = 0, $8e285ac053bcfb61$var$pk = null, $8e285ac053bcfb61$var$rh = 0, $8e285ac053bcfb61$var$qk = 0, $8e285ac053bcfb61$var$rk = 0, $8e285ac053bcfb61$var$sk = null, $8e285ac053bcfb61$var$tk = null, $8e285ac053bcfb61$var$fk = 0, $8e285ac053bcfb61$var$Gj = Infinity, $8e285ac053bcfb61$var$uk = null, $8e285ac053bcfb61$var$Oi = !1, $8e285ac053bcfb61$var$Pi = null, $8e285ac053bcfb61$var$Ri = null, $8e285ac053bcfb61$var$vk = !1, $8e285ac053bcfb61$var$wk = null, $8e285ac053bcfb61$var$xk = 0, $8e285ac053bcfb61$var$yk = 0, $8e285ac053bcfb61$var$zk = null, $8e285ac053bcfb61$var$Ak = -1, $8e285ac053bcfb61$var$Bk = 0;
function $8e285ac053bcfb61$var$R() {
    return 0 !== ($8e285ac053bcfb61$var$K & 6) ? $8e285ac053bcfb61$var$B() : -1 !== $8e285ac053bcfb61$var$Ak ? $8e285ac053bcfb61$var$Ak : $8e285ac053bcfb61$var$Ak = $8e285ac053bcfb61$var$B();
}
function $8e285ac053bcfb61$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($8e285ac053bcfb61$var$K & 2) && 0 !== $8e285ac053bcfb61$var$Z) return $8e285ac053bcfb61$var$Z & -$8e285ac053bcfb61$var$Z;
    if (null !== $8e285ac053bcfb61$var$Kg.transition) return 0 === $8e285ac053bcfb61$var$Bk && ($8e285ac053bcfb61$var$Bk = $8e285ac053bcfb61$var$yc()), $8e285ac053bcfb61$var$Bk;
    a = $8e285ac053bcfb61$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $8e285ac053bcfb61$var$jd(a.type);
    return a;
}
function $8e285ac053bcfb61$var$gi(a, b, c, d) {
    if (50 < $8e285ac053bcfb61$var$yk) throw $8e285ac053bcfb61$var$yk = 0, $8e285ac053bcfb61$var$zk = null, Error($8e285ac053bcfb61$var$p(185));
    $8e285ac053bcfb61$var$Ac(a, c, d);
    if (0 === ($8e285ac053bcfb61$var$K & 2) || a !== $8e285ac053bcfb61$var$Q) a === $8e285ac053bcfb61$var$Q && (0 === ($8e285ac053bcfb61$var$K & 2) && ($8e285ac053bcfb61$var$qk |= c), 4 === $8e285ac053bcfb61$var$T && $8e285ac053bcfb61$var$Ck(a, $8e285ac053bcfb61$var$Z)), $8e285ac053bcfb61$var$Dk(a, d), 1 === c && 0 === $8e285ac053bcfb61$var$K && 0 === (b.mode & 1) && ($8e285ac053bcfb61$var$Gj = $8e285ac053bcfb61$var$B() + 500, $8e285ac053bcfb61$var$fg && $8e285ac053bcfb61$var$jg());
}
function $8e285ac053bcfb61$var$Dk(a, b) {
    var c = a.callbackNode;
    $8e285ac053bcfb61$var$wc(a, b);
    var d = $8e285ac053bcfb61$var$uc(a, a === $8e285ac053bcfb61$var$Q ? $8e285ac053bcfb61$var$Z : 0);
    if (0 === d) null !== c && $8e285ac053bcfb61$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $8e285ac053bcfb61$var$bc(c);
        if (1 === b) 0 === a.tag ? $8e285ac053bcfb61$var$ig($8e285ac053bcfb61$var$Ek.bind(null, a)) : $8e285ac053bcfb61$var$hg($8e285ac053bcfb61$var$Ek.bind(null, a)), $8e285ac053bcfb61$var$Jf(function() {
            0 === ($8e285ac053bcfb61$var$K & 6) && $8e285ac053bcfb61$var$jg();
        }), c = null;
        else {
            switch($8e285ac053bcfb61$var$Dc(d)){
                case 1:
                    c = $8e285ac053bcfb61$var$fc;
                    break;
                case 4:
                    c = $8e285ac053bcfb61$var$gc;
                    break;
                case 16:
                    c = $8e285ac053bcfb61$var$hc;
                    break;
                case 536870912:
                    c = $8e285ac053bcfb61$var$jc;
                    break;
                default:
                    c = $8e285ac053bcfb61$var$hc;
            }
            c = $8e285ac053bcfb61$var$Fk(c, $8e285ac053bcfb61$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $8e285ac053bcfb61$var$Gk(a, b) {
    $8e285ac053bcfb61$var$Ak = -1;
    $8e285ac053bcfb61$var$Bk = 0;
    if (0 !== ($8e285ac053bcfb61$var$K & 6)) throw Error($8e285ac053bcfb61$var$p(327));
    var c = a.callbackNode;
    if ($8e285ac053bcfb61$var$Hk() && a.callbackNode !== c) return null;
    var d = $8e285ac053bcfb61$var$uc(a, a === $8e285ac053bcfb61$var$Q ? $8e285ac053bcfb61$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $8e285ac053bcfb61$var$Ik(a, d);
    else {
        b = d;
        var e = $8e285ac053bcfb61$var$K;
        $8e285ac053bcfb61$var$K |= 2;
        var f = $8e285ac053bcfb61$var$Jk();
        if ($8e285ac053bcfb61$var$Q !== a || $8e285ac053bcfb61$var$Z !== b) $8e285ac053bcfb61$var$uk = null, $8e285ac053bcfb61$var$Gj = $8e285ac053bcfb61$var$B() + 500, $8e285ac053bcfb61$var$Kk(a, b);
        for(;;)try {
            $8e285ac053bcfb61$var$Lk();
            break;
        } catch (h) {
            $8e285ac053bcfb61$var$Mk(a, h);
        }
        $8e285ac053bcfb61$var$$g();
        $8e285ac053bcfb61$var$mk.current = f;
        $8e285ac053bcfb61$var$K = e;
        null !== $8e285ac053bcfb61$var$Y ? b = 0 : ($8e285ac053bcfb61$var$Q = null, $8e285ac053bcfb61$var$Z = 0, b = $8e285ac053bcfb61$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $8e285ac053bcfb61$var$xc(a), 0 !== e && (d = e, b = $8e285ac053bcfb61$var$Nk(a, e)));
        if (1 === b) throw c = $8e285ac053bcfb61$var$pk, $8e285ac053bcfb61$var$Kk(a, 0), $8e285ac053bcfb61$var$Ck(a, d), $8e285ac053bcfb61$var$Dk(a, $8e285ac053bcfb61$var$B()), c;
        if (6 === b) $8e285ac053bcfb61$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$8e285ac053bcfb61$var$Ok(e) && (b = $8e285ac053bcfb61$var$Ik(a, d), 2 === b && (f = $8e285ac053bcfb61$var$xc(a), 0 !== f && (d = f, b = $8e285ac053bcfb61$var$Nk(a, f))), 1 === b)) throw c = $8e285ac053bcfb61$var$pk, $8e285ac053bcfb61$var$Kk(a, 0), $8e285ac053bcfb61$var$Ck(a, d), $8e285ac053bcfb61$var$Dk(a, $8e285ac053bcfb61$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($8e285ac053bcfb61$var$p(345));
                case 2:
                    $8e285ac053bcfb61$var$Pk(a, $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$uk);
                    break;
                case 3:
                    $8e285ac053bcfb61$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $8e285ac053bcfb61$var$fk + 500 - $8e285ac053bcfb61$var$B(), 10 < b)) {
                        if (0 !== $8e285ac053bcfb61$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $8e285ac053bcfb61$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $8e285ac053bcfb61$var$Ff($8e285ac053bcfb61$var$Pk.bind(null, a, $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$uk), b);
                        break;
                    }
                    $8e285ac053bcfb61$var$Pk(a, $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$uk);
                    break;
                case 4:
                    $8e285ac053bcfb61$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $8e285ac053bcfb61$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $8e285ac053bcfb61$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $8e285ac053bcfb61$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $8e285ac053bcfb61$var$Ff($8e285ac053bcfb61$var$Pk.bind(null, a, $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$uk), d);
                        break;
                    }
                    $8e285ac053bcfb61$var$Pk(a, $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$uk);
                    break;
                case 5:
                    $8e285ac053bcfb61$var$Pk(a, $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$uk);
                    break;
                default:
                    throw Error($8e285ac053bcfb61$var$p(329));
            }
        }
    }
    $8e285ac053bcfb61$var$Dk(a, $8e285ac053bcfb61$var$B());
    return a.callbackNode === c ? $8e285ac053bcfb61$var$Gk.bind(null, a) : null;
}
function $8e285ac053bcfb61$var$Nk(a, b) {
    var c = $8e285ac053bcfb61$var$sk;
    a.current.memoizedState.isDehydrated && ($8e285ac053bcfb61$var$Kk(a, b).flags |= 256);
    a = $8e285ac053bcfb61$var$Ik(a, b);
    2 !== a && (b = $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$tk = c, null !== b && $8e285ac053bcfb61$var$Fj(b));
    return a;
}
function $8e285ac053bcfb61$var$Fj(a) {
    null === $8e285ac053bcfb61$var$tk ? $8e285ac053bcfb61$var$tk = a : $8e285ac053bcfb61$var$tk.push.apply($8e285ac053bcfb61$var$tk, a);
}
function $8e285ac053bcfb61$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$8e285ac053bcfb61$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $8e285ac053bcfb61$var$Ck(a, b) {
    b &= ~$8e285ac053bcfb61$var$rk;
    b &= ~$8e285ac053bcfb61$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $8e285ac053bcfb61$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $8e285ac053bcfb61$var$Ek(a) {
    if (0 !== ($8e285ac053bcfb61$var$K & 6)) throw Error($8e285ac053bcfb61$var$p(327));
    $8e285ac053bcfb61$var$Hk();
    var b = $8e285ac053bcfb61$var$uc(a, 0);
    if (0 === (b & 1)) return $8e285ac053bcfb61$var$Dk(a, $8e285ac053bcfb61$var$B()), null;
    var c = $8e285ac053bcfb61$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $8e285ac053bcfb61$var$xc(a);
        0 !== d && (b = d, c = $8e285ac053bcfb61$var$Nk(a, d));
    }
    if (1 === c) throw c = $8e285ac053bcfb61$var$pk, $8e285ac053bcfb61$var$Kk(a, 0), $8e285ac053bcfb61$var$Ck(a, b), $8e285ac053bcfb61$var$Dk(a, $8e285ac053bcfb61$var$B()), c;
    if (6 === c) throw Error($8e285ac053bcfb61$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $8e285ac053bcfb61$var$Pk(a, $8e285ac053bcfb61$var$tk, $8e285ac053bcfb61$var$uk);
    $8e285ac053bcfb61$var$Dk(a, $8e285ac053bcfb61$var$B());
    return null;
}
function $8e285ac053bcfb61$var$Qk(a, b) {
    var c = $8e285ac053bcfb61$var$K;
    $8e285ac053bcfb61$var$K |= 1;
    try {
        return a(b);
    } finally{
        $8e285ac053bcfb61$var$K = c, 0 === $8e285ac053bcfb61$var$K && ($8e285ac053bcfb61$var$Gj = $8e285ac053bcfb61$var$B() + 500, $8e285ac053bcfb61$var$fg && $8e285ac053bcfb61$var$jg());
    }
}
function $8e285ac053bcfb61$var$Rk(a) {
    null !== $8e285ac053bcfb61$var$wk && 0 === $8e285ac053bcfb61$var$wk.tag && 0 === ($8e285ac053bcfb61$var$K & 6) && $8e285ac053bcfb61$var$Hk();
    var b = $8e285ac053bcfb61$var$K;
    $8e285ac053bcfb61$var$K |= 1;
    var c = $8e285ac053bcfb61$var$ok.transition, d = $8e285ac053bcfb61$var$C;
    try {
        if ($8e285ac053bcfb61$var$ok.transition = null, $8e285ac053bcfb61$var$C = 1, a) return a();
    } finally{
        $8e285ac053bcfb61$var$C = d, $8e285ac053bcfb61$var$ok.transition = c, $8e285ac053bcfb61$var$K = b, 0 === ($8e285ac053bcfb61$var$K & 6) && $8e285ac053bcfb61$var$jg();
    }
}
function $8e285ac053bcfb61$var$Hj() {
    $8e285ac053bcfb61$var$fj = $8e285ac053bcfb61$var$ej.current;
    $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$ej);
}
function $8e285ac053bcfb61$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $8e285ac053bcfb61$var$Gf(c));
    if (null !== $8e285ac053bcfb61$var$Y) for(c = $8e285ac053bcfb61$var$Y.return; null !== c;){
        var d = c;
        $8e285ac053bcfb61$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $8e285ac053bcfb61$var$$f();
                break;
            case 3:
                $8e285ac053bcfb61$var$zh();
                $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$Wf);
                $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$H);
                $8e285ac053bcfb61$var$Eh();
                break;
            case 5:
                $8e285ac053bcfb61$var$Bh(d);
                break;
            case 4:
                $8e285ac053bcfb61$var$zh();
                break;
            case 13:
                $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$L);
                break;
            case 19:
                $8e285ac053bcfb61$var$E($8e285ac053bcfb61$var$L);
                break;
            case 10:
                $8e285ac053bcfb61$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $8e285ac053bcfb61$var$Hj();
        }
        c = c.return;
    }
    $8e285ac053bcfb61$var$Q = a;
    $8e285ac053bcfb61$var$Y = a = $8e285ac053bcfb61$var$Pg(a.current, null);
    $8e285ac053bcfb61$var$Z = $8e285ac053bcfb61$var$fj = b;
    $8e285ac053bcfb61$var$T = 0;
    $8e285ac053bcfb61$var$pk = null;
    $8e285ac053bcfb61$var$rk = $8e285ac053bcfb61$var$qk = $8e285ac053bcfb61$var$rh = 0;
    $8e285ac053bcfb61$var$tk = $8e285ac053bcfb61$var$sk = null;
    if (null !== $8e285ac053bcfb61$var$fh) {
        for(b = 0; b < $8e285ac053bcfb61$var$fh.length; b++)if (c = $8e285ac053bcfb61$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $8e285ac053bcfb61$var$fh = null;
    }
    return a;
}
function $8e285ac053bcfb61$var$Mk(a, b) {
    do {
        var c = $8e285ac053bcfb61$var$Y;
        try {
            $8e285ac053bcfb61$var$$g();
            $8e285ac053bcfb61$var$Fh.current = $8e285ac053bcfb61$var$Rh;
            if ($8e285ac053bcfb61$var$Ih) {
                for(var d = $8e285ac053bcfb61$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $8e285ac053bcfb61$var$Ih = !1;
            }
            $8e285ac053bcfb61$var$Hh = 0;
            $8e285ac053bcfb61$var$O = $8e285ac053bcfb61$var$N = $8e285ac053bcfb61$var$M = null;
            $8e285ac053bcfb61$var$Jh = !1;
            $8e285ac053bcfb61$var$Kh = 0;
            $8e285ac053bcfb61$var$nk.current = null;
            if (null === c || null === c.return) {
                $8e285ac053bcfb61$var$T = 1;
                $8e285ac053bcfb61$var$pk = b;
                $8e285ac053bcfb61$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $8e285ac053bcfb61$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $8e285ac053bcfb61$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $8e285ac053bcfb61$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $8e285ac053bcfb61$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $8e285ac053bcfb61$var$Si(f, l, b);
                            $8e285ac053bcfb61$var$tj();
                            break a;
                        }
                        k = Error($8e285ac053bcfb61$var$p(426));
                    }
                } else if ($8e285ac053bcfb61$var$I && h.mode & 1) {
                    var J = $8e285ac053bcfb61$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $8e285ac053bcfb61$var$Vi(J, g, h, f, b);
                        $8e285ac053bcfb61$var$Jg($8e285ac053bcfb61$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $8e285ac053bcfb61$var$Ji(k, h);
                4 !== $8e285ac053bcfb61$var$T && ($8e285ac053bcfb61$var$T = 2);
                null === $8e285ac053bcfb61$var$sk ? $8e285ac053bcfb61$var$sk = [
                    f
                ] : $8e285ac053bcfb61$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $8e285ac053bcfb61$var$Ni(f, k, b);
                            $8e285ac053bcfb61$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $8e285ac053bcfb61$var$Ri || !$8e285ac053bcfb61$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $8e285ac053bcfb61$var$Qi(f, h, b);
                                $8e285ac053bcfb61$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $8e285ac053bcfb61$var$Sk(c);
        } catch (na) {
            b = na;
            $8e285ac053bcfb61$var$Y === c && null !== c && ($8e285ac053bcfb61$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $8e285ac053bcfb61$var$Jk() {
    var a = $8e285ac053bcfb61$var$mk.current;
    $8e285ac053bcfb61$var$mk.current = $8e285ac053bcfb61$var$Rh;
    return null === a ? $8e285ac053bcfb61$var$Rh : a;
}
function $8e285ac053bcfb61$var$tj() {
    if (0 === $8e285ac053bcfb61$var$T || 3 === $8e285ac053bcfb61$var$T || 2 === $8e285ac053bcfb61$var$T) $8e285ac053bcfb61$var$T = 4;
    null === $8e285ac053bcfb61$var$Q || 0 === ($8e285ac053bcfb61$var$rh & 268435455) && 0 === ($8e285ac053bcfb61$var$qk & 268435455) || $8e285ac053bcfb61$var$Ck($8e285ac053bcfb61$var$Q, $8e285ac053bcfb61$var$Z);
}
function $8e285ac053bcfb61$var$Ik(a, b) {
    var c = $8e285ac053bcfb61$var$K;
    $8e285ac053bcfb61$var$K |= 2;
    var d = $8e285ac053bcfb61$var$Jk();
    if ($8e285ac053bcfb61$var$Q !== a || $8e285ac053bcfb61$var$Z !== b) $8e285ac053bcfb61$var$uk = null, $8e285ac053bcfb61$var$Kk(a, b);
    for(;;)try {
        $8e285ac053bcfb61$var$Tk();
        break;
    } catch (e) {
        $8e285ac053bcfb61$var$Mk(a, e);
    }
    $8e285ac053bcfb61$var$$g();
    $8e285ac053bcfb61$var$K = c;
    $8e285ac053bcfb61$var$mk.current = d;
    if (null !== $8e285ac053bcfb61$var$Y) throw Error($8e285ac053bcfb61$var$p(261));
    $8e285ac053bcfb61$var$Q = null;
    $8e285ac053bcfb61$var$Z = 0;
    return $8e285ac053bcfb61$var$T;
}
function $8e285ac053bcfb61$var$Tk() {
    for(; null !== $8e285ac053bcfb61$var$Y;)$8e285ac053bcfb61$var$Uk($8e285ac053bcfb61$var$Y);
}
function $8e285ac053bcfb61$var$Lk() {
    for(; null !== $8e285ac053bcfb61$var$Y && !$8e285ac053bcfb61$var$cc();)$8e285ac053bcfb61$var$Uk($8e285ac053bcfb61$var$Y);
}
function $8e285ac053bcfb61$var$Uk(a) {
    var b = $8e285ac053bcfb61$var$Vk(a.alternate, a, $8e285ac053bcfb61$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $8e285ac053bcfb61$var$Sk(a) : $8e285ac053bcfb61$var$Y = b;
    $8e285ac053bcfb61$var$nk.current = null;
}
function $8e285ac053bcfb61$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $8e285ac053bcfb61$var$Ej(c, b, $8e285ac053bcfb61$var$fj), null !== c) {
                $8e285ac053bcfb61$var$Y = c;
                return;
            }
        } else {
            c = $8e285ac053bcfb61$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $8e285ac053bcfb61$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $8e285ac053bcfb61$var$T = 6;
                $8e285ac053bcfb61$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $8e285ac053bcfb61$var$Y = b;
            return;
        }
        $8e285ac053bcfb61$var$Y = b = a;
    }while (null !== b);
    0 === $8e285ac053bcfb61$var$T && ($8e285ac053bcfb61$var$T = 5);
}
function $8e285ac053bcfb61$var$Pk(a, b, c) {
    var d = $8e285ac053bcfb61$var$C, e = $8e285ac053bcfb61$var$ok.transition;
    try {
        $8e285ac053bcfb61$var$ok.transition = null, $8e285ac053bcfb61$var$C = 1, $8e285ac053bcfb61$var$Wk(a, b, c, d);
    } finally{
        $8e285ac053bcfb61$var$ok.transition = e, $8e285ac053bcfb61$var$C = d;
    }
    return null;
}
function $8e285ac053bcfb61$var$Wk(a, b, c, d) {
    do $8e285ac053bcfb61$var$Hk();
    while (null !== $8e285ac053bcfb61$var$wk);
    if (0 !== ($8e285ac053bcfb61$var$K & 6)) throw Error($8e285ac053bcfb61$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($8e285ac053bcfb61$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $8e285ac053bcfb61$var$Bc(a, f);
    a === $8e285ac053bcfb61$var$Q && ($8e285ac053bcfb61$var$Y = $8e285ac053bcfb61$var$Q = null, $8e285ac053bcfb61$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $8e285ac053bcfb61$var$vk || ($8e285ac053bcfb61$var$vk = !0, $8e285ac053bcfb61$var$Fk($8e285ac053bcfb61$var$hc, function() {
        $8e285ac053bcfb61$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $8e285ac053bcfb61$var$ok.transition;
        $8e285ac053bcfb61$var$ok.transition = null;
        var g = $8e285ac053bcfb61$var$C;
        $8e285ac053bcfb61$var$C = 1;
        var h = $8e285ac053bcfb61$var$K;
        $8e285ac053bcfb61$var$K |= 4;
        $8e285ac053bcfb61$var$nk.current = null;
        $8e285ac053bcfb61$var$Oj(a, c);
        $8e285ac053bcfb61$var$dk(c, a);
        $8e285ac053bcfb61$var$Oe($8e285ac053bcfb61$var$Df);
        $8e285ac053bcfb61$var$dd = !!$8e285ac053bcfb61$var$Cf;
        $8e285ac053bcfb61$var$Df = $8e285ac053bcfb61$var$Cf = null;
        a.current = c;
        $8e285ac053bcfb61$var$hk(c, a, e);
        $8e285ac053bcfb61$var$dc();
        $8e285ac053bcfb61$var$K = h;
        $8e285ac053bcfb61$var$C = g;
        $8e285ac053bcfb61$var$ok.transition = f;
    } else a.current = c;
    $8e285ac053bcfb61$var$vk && ($8e285ac053bcfb61$var$vk = !1, $8e285ac053bcfb61$var$wk = a, $8e285ac053bcfb61$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($8e285ac053bcfb61$var$Ri = null);
    $8e285ac053bcfb61$var$mc(c.stateNode, d);
    $8e285ac053bcfb61$var$Dk(a, $8e285ac053bcfb61$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($8e285ac053bcfb61$var$Oi) throw $8e285ac053bcfb61$var$Oi = !1, a = $8e285ac053bcfb61$var$Pi, $8e285ac053bcfb61$var$Pi = null, a;
    0 !== ($8e285ac053bcfb61$var$xk & 1) && 0 !== a.tag && $8e285ac053bcfb61$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $8e285ac053bcfb61$var$zk ? $8e285ac053bcfb61$var$yk++ : ($8e285ac053bcfb61$var$yk = 0, $8e285ac053bcfb61$var$zk = a) : $8e285ac053bcfb61$var$yk = 0;
    $8e285ac053bcfb61$var$jg();
    return null;
}
function $8e285ac053bcfb61$var$Hk() {
    if (null !== $8e285ac053bcfb61$var$wk) {
        var a = $8e285ac053bcfb61$var$Dc($8e285ac053bcfb61$var$xk), b = $8e285ac053bcfb61$var$ok.transition, c = $8e285ac053bcfb61$var$C;
        try {
            $8e285ac053bcfb61$var$ok.transition = null;
            $8e285ac053bcfb61$var$C = 16 > a ? 16 : a;
            if (null === $8e285ac053bcfb61$var$wk) var d = !1;
            else {
                a = $8e285ac053bcfb61$var$wk;
                $8e285ac053bcfb61$var$wk = null;
                $8e285ac053bcfb61$var$xk = 0;
                if (0 !== ($8e285ac053bcfb61$var$K & 6)) throw Error($8e285ac053bcfb61$var$p(331));
                var e = $8e285ac053bcfb61$var$K;
                $8e285ac053bcfb61$var$K |= 4;
                for($8e285ac053bcfb61$var$V = a.current; null !== $8e285ac053bcfb61$var$V;){
                    var f = $8e285ac053bcfb61$var$V, g = f.child;
                    if (0 !== ($8e285ac053bcfb61$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($8e285ac053bcfb61$var$V = l; null !== $8e285ac053bcfb61$var$V;){
                                    var m = $8e285ac053bcfb61$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $8e285ac053bcfb61$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $8e285ac053bcfb61$var$V = q;
                                    else for(; null !== $8e285ac053bcfb61$var$V;){
                                        m = $8e285ac053bcfb61$var$V;
                                        var r = m.sibling, y = m.return;
                                        $8e285ac053bcfb61$var$Sj(m);
                                        if (m === l) {
                                            $8e285ac053bcfb61$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $8e285ac053bcfb61$var$V = r;
                                            break;
                                        }
                                        $8e285ac053bcfb61$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $8e285ac053bcfb61$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $8e285ac053bcfb61$var$V = g;
                    else b: for(; null !== $8e285ac053bcfb61$var$V;){
                        f = $8e285ac053bcfb61$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $8e285ac053bcfb61$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $8e285ac053bcfb61$var$V = x;
                            break b;
                        }
                        $8e285ac053bcfb61$var$V = f.return;
                    }
                }
                var w = a.current;
                for($8e285ac053bcfb61$var$V = w; null !== $8e285ac053bcfb61$var$V;){
                    g = $8e285ac053bcfb61$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $8e285ac053bcfb61$var$V = u;
                    else b: for(g = w; null !== $8e285ac053bcfb61$var$V;){
                        h = $8e285ac053bcfb61$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $8e285ac053bcfb61$var$Qj(9, h);
                            }
                        } catch (na) {
                            $8e285ac053bcfb61$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $8e285ac053bcfb61$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $8e285ac053bcfb61$var$V = F;
                            break b;
                        }
                        $8e285ac053bcfb61$var$V = h.return;
                    }
                }
                $8e285ac053bcfb61$var$K = e;
                $8e285ac053bcfb61$var$jg();
                if ($8e285ac053bcfb61$var$lc && "function" === typeof $8e285ac053bcfb61$var$lc.onPostCommitFiberRoot) try {
                    $8e285ac053bcfb61$var$lc.onPostCommitFiberRoot($8e285ac053bcfb61$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $8e285ac053bcfb61$var$C = c, $8e285ac053bcfb61$var$ok.transition = b;
        }
    }
    return !1;
}
function $8e285ac053bcfb61$var$Xk(a, b, c) {
    b = $8e285ac053bcfb61$var$Ji(c, b);
    b = $8e285ac053bcfb61$var$Ni(a, b, 1);
    a = $8e285ac053bcfb61$var$nh(a, b, 1);
    b = $8e285ac053bcfb61$var$R();
    null !== a && ($8e285ac053bcfb61$var$Ac(a, 1, b), $8e285ac053bcfb61$var$Dk(a, b));
}
function $8e285ac053bcfb61$var$W(a, b, c) {
    if (3 === a.tag) $8e285ac053bcfb61$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $8e285ac053bcfb61$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $8e285ac053bcfb61$var$Ri || !$8e285ac053bcfb61$var$Ri.has(d))) {
                a = $8e285ac053bcfb61$var$Ji(c, a);
                a = $8e285ac053bcfb61$var$Qi(b, a, 1);
                b = $8e285ac053bcfb61$var$nh(b, a, 1);
                a = $8e285ac053bcfb61$var$R();
                null !== b && ($8e285ac053bcfb61$var$Ac(b, 1, a), $8e285ac053bcfb61$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $8e285ac053bcfb61$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $8e285ac053bcfb61$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $8e285ac053bcfb61$var$Q === a && ($8e285ac053bcfb61$var$Z & c) === c && (4 === $8e285ac053bcfb61$var$T || 3 === $8e285ac053bcfb61$var$T && ($8e285ac053bcfb61$var$Z & 130023424) === $8e285ac053bcfb61$var$Z && 500 > $8e285ac053bcfb61$var$B() - $8e285ac053bcfb61$var$fk ? $8e285ac053bcfb61$var$Kk(a, 0) : $8e285ac053bcfb61$var$rk |= c);
    $8e285ac053bcfb61$var$Dk(a, b);
}
function $8e285ac053bcfb61$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $8e285ac053bcfb61$var$sc, $8e285ac053bcfb61$var$sc <<= 1, 0 === ($8e285ac053bcfb61$var$sc & 130023424) && ($8e285ac053bcfb61$var$sc = 4194304)));
    var c = $8e285ac053bcfb61$var$R();
    a = $8e285ac053bcfb61$var$ih(a, b);
    null !== a && ($8e285ac053bcfb61$var$Ac(a, b, c), $8e285ac053bcfb61$var$Dk(a, c));
}
function $8e285ac053bcfb61$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $8e285ac053bcfb61$var$Yk(a, c);
}
function $8e285ac053bcfb61$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($8e285ac053bcfb61$var$p(314));
    }
    null !== d && d.delete(b);
    $8e285ac053bcfb61$var$Yk(a, c);
}
var $8e285ac053bcfb61$var$Vk;
$8e285ac053bcfb61$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $8e285ac053bcfb61$var$Wf.current) $8e285ac053bcfb61$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $8e285ac053bcfb61$var$dh = !1, $8e285ac053bcfb61$var$yj(a, b, c);
            $8e285ac053bcfb61$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $8e285ac053bcfb61$var$dh = !1, $8e285ac053bcfb61$var$I && 0 !== (b.flags & 1048576) && $8e285ac053bcfb61$var$ug(b, $8e285ac053bcfb61$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $8e285ac053bcfb61$var$ij(a, b);
            a = b.pendingProps;
            var e = $8e285ac053bcfb61$var$Yf(b, $8e285ac053bcfb61$var$H.current);
            $8e285ac053bcfb61$var$ch(b, c);
            e = $8e285ac053bcfb61$var$Nh(null, b, d, a, e, c);
            var f = $8e285ac053bcfb61$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $8e285ac053bcfb61$var$Zf(d) ? (f = !0, $8e285ac053bcfb61$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $8e285ac053bcfb61$var$kh(b), e.updater = $8e285ac053bcfb61$var$Ei, b.stateNode = e, e._reactInternals = b, $8e285ac053bcfb61$var$Ii(b, d, a, c), b = $8e285ac053bcfb61$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $8e285ac053bcfb61$var$I && f && $8e285ac053bcfb61$var$vg(b), $8e285ac053bcfb61$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $8e285ac053bcfb61$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $8e285ac053bcfb61$var$Zk(d);
                a = $8e285ac053bcfb61$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $8e285ac053bcfb61$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $8e285ac053bcfb61$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $8e285ac053bcfb61$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $8e285ac053bcfb61$var$$i(null, b, d, $8e285ac053bcfb61$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($8e285ac053bcfb61$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8e285ac053bcfb61$var$Ci(d, e), $8e285ac053bcfb61$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8e285ac053bcfb61$var$Ci(d, e), $8e285ac053bcfb61$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $8e285ac053bcfb61$var$kj(b);
                if (null === a) throw Error($8e285ac053bcfb61$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $8e285ac053bcfb61$var$lh(a, b);
                $8e285ac053bcfb61$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $8e285ac053bcfb61$var$Ji(Error($8e285ac053bcfb61$var$p(423)), b);
                        b = $8e285ac053bcfb61$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $8e285ac053bcfb61$var$Ji(Error($8e285ac053bcfb61$var$p(424)), b);
                        b = $8e285ac053bcfb61$var$lj(a, b, d, c, e);
                        break a;
                    } else for($8e285ac053bcfb61$var$yg = $8e285ac053bcfb61$var$Lf(b.stateNode.containerInfo.firstChild), $8e285ac053bcfb61$var$xg = b, $8e285ac053bcfb61$var$I = !0, $8e285ac053bcfb61$var$zg = null, c = $8e285ac053bcfb61$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $8e285ac053bcfb61$var$Ig();
                    if (d === e) {
                        b = $8e285ac053bcfb61$var$Zi(a, b, c);
                        break a;
                    }
                    $8e285ac053bcfb61$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $8e285ac053bcfb61$var$Ah(b), null === a && $8e285ac053bcfb61$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $8e285ac053bcfb61$var$Ef(d, e) ? g = null : null !== f && $8e285ac053bcfb61$var$Ef(d, f) && (b.flags |= 32), $8e285ac053bcfb61$var$gj(a, b), $8e285ac053bcfb61$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $8e285ac053bcfb61$var$Eg(b), null;
        case 13:
            return $8e285ac053bcfb61$var$oj(a, b, c);
        case 4:
            return $8e285ac053bcfb61$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $8e285ac053bcfb61$var$Ug(b, null, d, c) : $8e285ac053bcfb61$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8e285ac053bcfb61$var$Ci(d, e), $8e285ac053bcfb61$var$Yi(a, b, d, e, c);
        case 7:
            return $8e285ac053bcfb61$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $8e285ac053bcfb61$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $8e285ac053bcfb61$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $8e285ac053bcfb61$var$G($8e285ac053bcfb61$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($8e285ac053bcfb61$var$He(f.value, g)) {
                        if (f.children === e.children && !$8e285ac053bcfb61$var$Wf.current) {
                            b = $8e285ac053bcfb61$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $8e285ac053bcfb61$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $8e285ac053bcfb61$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($8e285ac053bcfb61$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $8e285ac053bcfb61$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $8e285ac053bcfb61$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $8e285ac053bcfb61$var$ch(b, c), e = $8e285ac053bcfb61$var$eh(e), d = d(e), b.flags |= 1, $8e285ac053bcfb61$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $8e285ac053bcfb61$var$Ci(d, b.pendingProps), e = $8e285ac053bcfb61$var$Ci(d.type, e), $8e285ac053bcfb61$var$$i(a, b, d, e, c);
        case 15:
            return $8e285ac053bcfb61$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8e285ac053bcfb61$var$Ci(d, e), $8e285ac053bcfb61$var$ij(a, b), b.tag = 1, $8e285ac053bcfb61$var$Zf(d) ? (a = !0, $8e285ac053bcfb61$var$cg(b)) : a = !1, $8e285ac053bcfb61$var$ch(b, c), $8e285ac053bcfb61$var$Gi(b, d, e), $8e285ac053bcfb61$var$Ii(b, d, e, c), $8e285ac053bcfb61$var$jj(null, b, d, !0, a, c);
        case 19:
            return $8e285ac053bcfb61$var$xj(a, b, c);
        case 22:
            return $8e285ac053bcfb61$var$dj(a, b, c);
    }
    throw Error($8e285ac053bcfb61$var$p(156, b.tag));
};
function $8e285ac053bcfb61$var$Fk(a, b) {
    return $8e285ac053bcfb61$var$ac(a, b);
}
function $8e285ac053bcfb61$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8e285ac053bcfb61$var$Bg(a, b, c, d) {
    return new $8e285ac053bcfb61$var$$k(a, b, c, d);
}
function $8e285ac053bcfb61$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $8e285ac053bcfb61$var$Zk(a) {
    if ("function" === typeof a) return $8e285ac053bcfb61$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $8e285ac053bcfb61$var$Da) return 11;
        if (a === $8e285ac053bcfb61$var$Ga) return 14;
    }
    return 2;
}
function $8e285ac053bcfb61$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $8e285ac053bcfb61$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $8e285ac053bcfb61$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $8e285ac053bcfb61$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $8e285ac053bcfb61$var$ya:
            return $8e285ac053bcfb61$var$Tg(c.children, e, f, b);
        case $8e285ac053bcfb61$var$za:
            g = 8;
            e |= 8;
            break;
        case $8e285ac053bcfb61$var$Aa:
            return a = $8e285ac053bcfb61$var$Bg(12, c, b, e | 2), a.elementType = $8e285ac053bcfb61$var$Aa, a.lanes = f, a;
        case $8e285ac053bcfb61$var$Ea:
            return a = $8e285ac053bcfb61$var$Bg(13, c, b, e), a.elementType = $8e285ac053bcfb61$var$Ea, a.lanes = f, a;
        case $8e285ac053bcfb61$var$Fa:
            return a = $8e285ac053bcfb61$var$Bg(19, c, b, e), a.elementType = $8e285ac053bcfb61$var$Fa, a.lanes = f, a;
        case $8e285ac053bcfb61$var$Ia:
            return $8e285ac053bcfb61$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $8e285ac053bcfb61$var$Ba:
                    g = 10;
                    break a;
                case $8e285ac053bcfb61$var$Ca:
                    g = 9;
                    break a;
                case $8e285ac053bcfb61$var$Da:
                    g = 11;
                    break a;
                case $8e285ac053bcfb61$var$Ga:
                    g = 14;
                    break a;
                case $8e285ac053bcfb61$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($8e285ac053bcfb61$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $8e285ac053bcfb61$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $8e285ac053bcfb61$var$Tg(a, b, c, d) {
    a = $8e285ac053bcfb61$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $8e285ac053bcfb61$var$pj(a, b, c, d) {
    a = $8e285ac053bcfb61$var$Bg(22, a, d, b);
    a.elementType = $8e285ac053bcfb61$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $8e285ac053bcfb61$var$Qg(a, b, c) {
    a = $8e285ac053bcfb61$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $8e285ac053bcfb61$var$Sg(a, b, c) {
    b = $8e285ac053bcfb61$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $8e285ac053bcfb61$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $8e285ac053bcfb61$var$zc(0);
    this.expirationTimes = $8e285ac053bcfb61$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8e285ac053bcfb61$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $8e285ac053bcfb61$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $8e285ac053bcfb61$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $8e285ac053bcfb61$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $8e285ac053bcfb61$var$kh(f);
    return a;
}
function $8e285ac053bcfb61$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8e285ac053bcfb61$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $8e285ac053bcfb61$var$dl(a) {
    if (!a) return $8e285ac053bcfb61$var$Vf;
    a = a._reactInternals;
    a: {
        if ($8e285ac053bcfb61$var$Vb(a) !== a || 1 !== a.tag) throw Error($8e285ac053bcfb61$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($8e285ac053bcfb61$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($8e285ac053bcfb61$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($8e285ac053bcfb61$var$Zf(c)) return $8e285ac053bcfb61$var$bg(a, c, b);
    }
    return b;
}
function $8e285ac053bcfb61$var$el(a, b, c, d, e, f, g, h, k) {
    a = $8e285ac053bcfb61$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $8e285ac053bcfb61$var$dl(null);
    c = a.current;
    d = $8e285ac053bcfb61$var$R();
    e = $8e285ac053bcfb61$var$yi(c);
    f = $8e285ac053bcfb61$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $8e285ac053bcfb61$var$nh(c, f, e);
    a.current.lanes = e;
    $8e285ac053bcfb61$var$Ac(a, e, d);
    $8e285ac053bcfb61$var$Dk(a, d);
    return a;
}
function $8e285ac053bcfb61$var$fl(a, b, c, d) {
    var e = b.current, f = $8e285ac053bcfb61$var$R(), g = $8e285ac053bcfb61$var$yi(e);
    c = $8e285ac053bcfb61$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $8e285ac053bcfb61$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $8e285ac053bcfb61$var$nh(e, b, g);
    null !== a && ($8e285ac053bcfb61$var$gi(a, e, g, f), $8e285ac053bcfb61$var$oh(a, e, g));
    return g;
}
function $8e285ac053bcfb61$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $8e285ac053bcfb61$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $8e285ac053bcfb61$var$il(a, b) {
    $8e285ac053bcfb61$var$hl(a, b);
    (a = a.alternate) && $8e285ac053bcfb61$var$hl(a, b);
}
function $8e285ac053bcfb61$var$jl() {
    return null;
}
var $8e285ac053bcfb61$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $8e285ac053bcfb61$var$ll(a) {
    this._internalRoot = a;
}
$8e285ac053bcfb61$var$ml.prototype.render = $8e285ac053bcfb61$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($8e285ac053bcfb61$var$p(409));
    $8e285ac053bcfb61$var$fl(a, b, null, null);
};
$8e285ac053bcfb61$var$ml.prototype.unmount = $8e285ac053bcfb61$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $8e285ac053bcfb61$var$Rk(function() {
            $8e285ac053bcfb61$var$fl(null, a, null, null);
        });
        b[$8e285ac053bcfb61$var$uf] = null;
    }
};
function $8e285ac053bcfb61$var$ml(a) {
    this._internalRoot = a;
}
$8e285ac053bcfb61$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $8e285ac053bcfb61$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $8e285ac053bcfb61$var$Qc.length && 0 !== b && b < $8e285ac053bcfb61$var$Qc[c].priority; c++);
        $8e285ac053bcfb61$var$Qc.splice(c, 0, a);
        0 === c && $8e285ac053bcfb61$var$Vc(a);
    }
};
function $8e285ac053bcfb61$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $8e285ac053bcfb61$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $8e285ac053bcfb61$var$pl() {}
function $8e285ac053bcfb61$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $8e285ac053bcfb61$var$gl(g);
                f.call(a);
            };
        }
        var g = $8e285ac053bcfb61$var$el(b, d, a, 0, null, !1, !1, "", $8e285ac053bcfb61$var$pl);
        a._reactRootContainer = g;
        a[$8e285ac053bcfb61$var$uf] = g.current;
        $8e285ac053bcfb61$var$sf(8 === a.nodeType ? a.parentNode : a);
        $8e285ac053bcfb61$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $8e285ac053bcfb61$var$gl(k);
            h.call(a);
        };
    }
    var k = $8e285ac053bcfb61$var$bl(a, 0, !1, null, null, !1, !1, "", $8e285ac053bcfb61$var$pl);
    a._reactRootContainer = k;
    a[$8e285ac053bcfb61$var$uf] = k.current;
    $8e285ac053bcfb61$var$sf(8 === a.nodeType ? a.parentNode : a);
    $8e285ac053bcfb61$var$Rk(function() {
        $8e285ac053bcfb61$var$fl(b, k, c, d);
    });
    return k;
}
function $8e285ac053bcfb61$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $8e285ac053bcfb61$var$gl(g);
                h.call(a);
            };
        }
        $8e285ac053bcfb61$var$fl(b, g, a, e);
    } else g = $8e285ac053bcfb61$var$ql(c, b, a, e, d);
    return $8e285ac053bcfb61$var$gl(g);
}
$8e285ac053bcfb61$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $8e285ac053bcfb61$var$tc(b.pendingLanes);
                0 !== c && ($8e285ac053bcfb61$var$Cc(b, c | 1), $8e285ac053bcfb61$var$Dk(b, $8e285ac053bcfb61$var$B()), 0 === ($8e285ac053bcfb61$var$K & 6) && ($8e285ac053bcfb61$var$Gj = $8e285ac053bcfb61$var$B() + 500, $8e285ac053bcfb61$var$jg()));
            }
            break;
        case 13:
            $8e285ac053bcfb61$var$Rk(function() {
                var b = $8e285ac053bcfb61$var$ih(a, 1);
                if (null !== b) {
                    var c = $8e285ac053bcfb61$var$R();
                    $8e285ac053bcfb61$var$gi(b, a, 1, c);
                }
            }), $8e285ac053bcfb61$var$il(a, 1);
    }
};
$8e285ac053bcfb61$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $8e285ac053bcfb61$var$ih(a, 134217728);
        if (null !== b) {
            var c = $8e285ac053bcfb61$var$R();
            $8e285ac053bcfb61$var$gi(b, a, 134217728, c);
        }
        $8e285ac053bcfb61$var$il(a, 134217728);
    }
};
$8e285ac053bcfb61$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $8e285ac053bcfb61$var$yi(a), c = $8e285ac053bcfb61$var$ih(a, b);
        if (null !== c) {
            var d = $8e285ac053bcfb61$var$R();
            $8e285ac053bcfb61$var$gi(c, a, b, d);
        }
        $8e285ac053bcfb61$var$il(a, b);
    }
};
$8e285ac053bcfb61$var$Hc = function() {
    return $8e285ac053bcfb61$var$C;
};
$8e285ac053bcfb61$var$Ic = function(a, b) {
    var c = $8e285ac053bcfb61$var$C;
    try {
        return $8e285ac053bcfb61$var$C = a, b();
    } finally{
        $8e285ac053bcfb61$var$C = c;
    }
};
$8e285ac053bcfb61$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $8e285ac053bcfb61$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $8e285ac053bcfb61$var$Db(d);
                        if (!e) throw Error($8e285ac053bcfb61$var$p(90));
                        $8e285ac053bcfb61$var$Wa(d);
                        $8e285ac053bcfb61$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $8e285ac053bcfb61$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $8e285ac053bcfb61$var$fb(a, !!c.multiple, b, !1);
    }
};
$8e285ac053bcfb61$var$Gb = $8e285ac053bcfb61$var$Qk;
$8e285ac053bcfb61$var$Hb = $8e285ac053bcfb61$var$Rk;
var $8e285ac053bcfb61$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $8e285ac053bcfb61$var$Cb,
        $8e285ac053bcfb61$var$ue,
        $8e285ac053bcfb61$var$Db,
        $8e285ac053bcfb61$var$Eb,
        $8e285ac053bcfb61$var$Fb,
        $8e285ac053bcfb61$var$Qk
    ]
}, $8e285ac053bcfb61$var$tl = {
    findFiberByHostInstance: $8e285ac053bcfb61$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $8e285ac053bcfb61$var$ul = {
    bundleType: $8e285ac053bcfb61$var$tl.bundleType,
    version: $8e285ac053bcfb61$var$tl.version,
    rendererPackageName: $8e285ac053bcfb61$var$tl.rendererPackageName,
    rendererConfig: $8e285ac053bcfb61$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $8e285ac053bcfb61$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $8e285ac053bcfb61$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $8e285ac053bcfb61$var$tl.findFiberByHostInstance || $8e285ac053bcfb61$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8e285ac053bcfb61$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8e285ac053bcfb61$var$vl.isDisabled && $8e285ac053bcfb61$var$vl.supportsFiber) try {
        $8e285ac053bcfb61$var$kc = $8e285ac053bcfb61$var$vl.inject($8e285ac053bcfb61$var$ul), $8e285ac053bcfb61$var$lc = $8e285ac053bcfb61$var$vl;
    } catch (a) {}
}
$8e285ac053bcfb61$export$ae55be85d98224ed = $8e285ac053bcfb61$var$sl;
$8e285ac053bcfb61$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$8e285ac053bcfb61$var$nl(b)) throw Error($8e285ac053bcfb61$var$p(200));
    return $8e285ac053bcfb61$var$cl(a, b, null, c);
};
$8e285ac053bcfb61$export$882461b6382ed46c = function(a, b) {
    if (!$8e285ac053bcfb61$var$nl(a)) throw Error($8e285ac053bcfb61$var$p(299));
    var c = !1, d = "", e = $8e285ac053bcfb61$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $8e285ac053bcfb61$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$8e285ac053bcfb61$var$uf] = b.current;
    $8e285ac053bcfb61$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $8e285ac053bcfb61$var$ll(b);
};
$8e285ac053bcfb61$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($8e285ac053bcfb61$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($8e285ac053bcfb61$var$p(268, a));
    }
    a = $8e285ac053bcfb61$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$8e285ac053bcfb61$export$cd75ccfd720a3cd4 = function(a) {
    return $8e285ac053bcfb61$var$Rk(a);
};
$8e285ac053bcfb61$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$8e285ac053bcfb61$var$ol(b)) throw Error($8e285ac053bcfb61$var$p(200));
    return $8e285ac053bcfb61$var$rl(null, a, b, !0, c);
};
$8e285ac053bcfb61$export$757ceba2d55c277e = function(a, b, c) {
    if (!$8e285ac053bcfb61$var$nl(a)) throw Error($8e285ac053bcfb61$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $8e285ac053bcfb61$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $8e285ac053bcfb61$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$8e285ac053bcfb61$var$uf] = b.current;
    $8e285ac053bcfb61$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $8e285ac053bcfb61$var$ml(b);
};
$8e285ac053bcfb61$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$8e285ac053bcfb61$var$ol(b)) throw Error($8e285ac053bcfb61$var$p(200));
    return $8e285ac053bcfb61$var$rl(null, a, b, !1, c);
};
$8e285ac053bcfb61$export$502457920280e6be = function(a) {
    if (!$8e285ac053bcfb61$var$ol(a)) throw Error($8e285ac053bcfb61$var$p(40));
    return a._reactRootContainer ? ($8e285ac053bcfb61$var$Rk(function() {
        $8e285ac053bcfb61$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$8e285ac053bcfb61$var$uf] = null;
        });
    }), !0) : !1;
};
$8e285ac053bcfb61$export$c78a37762a8d58e1 = $8e285ac053bcfb61$var$Qk;
$8e285ac053bcfb61$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$8e285ac053bcfb61$var$ol(c)) throw Error($8e285ac053bcfb61$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($8e285ac053bcfb61$var$p(38));
    return $8e285ac053bcfb61$var$rl(a, b, c, !1, d);
};
$8e285ac053bcfb61$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("2m3dj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("99qet"));

});
parcelRegister("99qet", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6a994d897ed01bc4$export$c4744153514ff05d; }, function (v) { return $6a994d897ed01bc4$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6a994d897ed01bc4$export$3e506c1ccc9cc1a7; }, function (v) { return $6a994d897ed01bc4$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6a994d897ed01bc4$export$e26fe2ed2fa76875; }, function (v) { return $6a994d897ed01bc4$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6a994d897ed01bc4$export$502329bbf4b505b1; }, function (v) { return $6a994d897ed01bc4$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6a994d897ed01bc4$export$6e3807111c4874c4; }, function (v) { return $6a994d897ed01bc4$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6a994d897ed01bc4$export$c27134553091fb3a; }, function (v) { return $6a994d897ed01bc4$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6a994d897ed01bc4$export$33ee1acdc04fd2a2; }, function (v) { return $6a994d897ed01bc4$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6a994d897ed01bc4$export$b00a404bbd5edef2; }, function (v) { return $6a994d897ed01bc4$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6a994d897ed01bc4$export$8352ce38b91d0c62; }, function (v) { return $6a994d897ed01bc4$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6a994d897ed01bc4$export$d66a1c1c77bd778b; }, function (v) { return $6a994d897ed01bc4$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6a994d897ed01bc4$export$d3dfb8e4810cb555; }, function (v) { return $6a994d897ed01bc4$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6a994d897ed01bc4$export$839f9183b0465a69; }, function (v) { return $6a994d897ed01bc4$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6a994d897ed01bc4$export$72fdf0e06517287b; }, function (v) { return $6a994d897ed01bc4$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6a994d897ed01bc4$export$4b844e58a3e414b4; }, function (v) { return $6a994d897ed01bc4$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6a994d897ed01bc4$export$816d2913ae6b83b1; }, function (v) { return $6a994d897ed01bc4$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6a994d897ed01bc4$export$61bcfe829111a1d0; }, function (v) { return $6a994d897ed01bc4$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6a994d897ed01bc4$export$7ee8c9beb337bc3f; }, function (v) { return $6a994d897ed01bc4$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6a994d897ed01bc4$export$b5836b71941fa3ed; }, function (v) { return $6a994d897ed01bc4$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6a994d897ed01bc4$export$cf845f2c119da08a; }, function (v) { return $6a994d897ed01bc4$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6a994d897ed01bc4$export$c4744153514ff05d;
var $6a994d897ed01bc4$export$3e506c1ccc9cc1a7;
var $6a994d897ed01bc4$export$e26fe2ed2fa76875;
var $6a994d897ed01bc4$export$502329bbf4b505b1;
var $6a994d897ed01bc4$export$6e3807111c4874c4;
var $6a994d897ed01bc4$export$c27134553091fb3a;
var $6a994d897ed01bc4$export$33ee1acdc04fd2a2;
var $6a994d897ed01bc4$export$b00a404bbd5edef2;
var $6a994d897ed01bc4$export$8352ce38b91d0c62;
var $6a994d897ed01bc4$export$d66a1c1c77bd778b;
var $6a994d897ed01bc4$export$d3dfb8e4810cb555;
var $6a994d897ed01bc4$export$839f9183b0465a69;
var $6a994d897ed01bc4$export$72fdf0e06517287b;
var $6a994d897ed01bc4$export$4b844e58a3e414b4;
var $6a994d897ed01bc4$export$816d2913ae6b83b1;
var $6a994d897ed01bc4$export$61bcfe829111a1d0;
var $6a994d897ed01bc4$export$7ee8c9beb337bc3f;
var $6a994d897ed01bc4$export$b5836b71941fa3ed;
var $6a994d897ed01bc4$export$cf845f2c119da08a;
'use strict';
function $6a994d897ed01bc4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6a994d897ed01bc4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6a994d897ed01bc4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6a994d897ed01bc4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6a994d897ed01bc4$var$g(C, c)) n < e && 0 > $6a994d897ed01bc4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6a994d897ed01bc4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6a994d897ed01bc4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6a994d897ed01bc4$var$l = performance;
    $6a994d897ed01bc4$export$c4744153514ff05d = function() {
        return $6a994d897ed01bc4$var$l.now();
    };
} else {
    var $6a994d897ed01bc4$var$p = Date, $6a994d897ed01bc4$var$q = $6a994d897ed01bc4$var$p.now();
    $6a994d897ed01bc4$export$c4744153514ff05d = function() {
        return $6a994d897ed01bc4$var$p.now() - $6a994d897ed01bc4$var$q;
    };
}
var $6a994d897ed01bc4$var$r = [], $6a994d897ed01bc4$var$t = [], $6a994d897ed01bc4$var$u = 1, $6a994d897ed01bc4$var$v = null, $6a994d897ed01bc4$var$y = 3, $6a994d897ed01bc4$var$z = !1, $6a994d897ed01bc4$var$A = !1, $6a994d897ed01bc4$var$B = !1, $6a994d897ed01bc4$var$D = "function" === typeof setTimeout ? setTimeout : null, $6a994d897ed01bc4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6a994d897ed01bc4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6a994d897ed01bc4$var$G(a) {
    for(var b = $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$t); null !== b;){
        if (null === b.callback) $6a994d897ed01bc4$var$k($6a994d897ed01bc4$var$t);
        else if (b.startTime <= a) $6a994d897ed01bc4$var$k($6a994d897ed01bc4$var$t), b.sortIndex = b.expirationTime, $6a994d897ed01bc4$var$f($6a994d897ed01bc4$var$r, b);
        else break;
        b = $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$t);
    }
}
function $6a994d897ed01bc4$var$H(a) {
    $6a994d897ed01bc4$var$B = !1;
    $6a994d897ed01bc4$var$G(a);
    if (!$6a994d897ed01bc4$var$A) {
        if (null !== $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$r)) $6a994d897ed01bc4$var$A = !0, $6a994d897ed01bc4$var$I($6a994d897ed01bc4$var$J);
        else {
            var b = $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$t);
            null !== b && $6a994d897ed01bc4$var$K($6a994d897ed01bc4$var$H, b.startTime - a);
        }
    }
}
function $6a994d897ed01bc4$var$J(a, b) {
    $6a994d897ed01bc4$var$A = !1;
    $6a994d897ed01bc4$var$B && ($6a994d897ed01bc4$var$B = !1, $6a994d897ed01bc4$var$E($6a994d897ed01bc4$var$L), $6a994d897ed01bc4$var$L = -1);
    $6a994d897ed01bc4$var$z = !0;
    var c = $6a994d897ed01bc4$var$y;
    try {
        $6a994d897ed01bc4$var$G(b);
        for($6a994d897ed01bc4$var$v = $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$r); null !== $6a994d897ed01bc4$var$v && (!($6a994d897ed01bc4$var$v.expirationTime > b) || a && !$6a994d897ed01bc4$var$M());){
            var d = $6a994d897ed01bc4$var$v.callback;
            if ("function" === typeof d) {
                $6a994d897ed01bc4$var$v.callback = null;
                $6a994d897ed01bc4$var$y = $6a994d897ed01bc4$var$v.priorityLevel;
                var e = d($6a994d897ed01bc4$var$v.expirationTime <= b);
                b = $6a994d897ed01bc4$export$c4744153514ff05d();
                "function" === typeof e ? $6a994d897ed01bc4$var$v.callback = e : $6a994d897ed01bc4$var$v === $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$r) && $6a994d897ed01bc4$var$k($6a994d897ed01bc4$var$r);
                $6a994d897ed01bc4$var$G(b);
            } else $6a994d897ed01bc4$var$k($6a994d897ed01bc4$var$r);
            $6a994d897ed01bc4$var$v = $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$r);
        }
        if (null !== $6a994d897ed01bc4$var$v) var w = !0;
        else {
            var m = $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$t);
            null !== m && $6a994d897ed01bc4$var$K($6a994d897ed01bc4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6a994d897ed01bc4$var$v = null, $6a994d897ed01bc4$var$y = c, $6a994d897ed01bc4$var$z = !1;
    }
}
var $6a994d897ed01bc4$var$N = !1, $6a994d897ed01bc4$var$O = null, $6a994d897ed01bc4$var$L = -1, $6a994d897ed01bc4$var$P = 5, $6a994d897ed01bc4$var$Q = -1;
function $6a994d897ed01bc4$var$M() {
    return $6a994d897ed01bc4$export$c4744153514ff05d() - $6a994d897ed01bc4$var$Q < $6a994d897ed01bc4$var$P ? !1 : !0;
}
function $6a994d897ed01bc4$var$R() {
    if (null !== $6a994d897ed01bc4$var$O) {
        var a = $6a994d897ed01bc4$export$c4744153514ff05d();
        $6a994d897ed01bc4$var$Q = a;
        var b = !0;
        try {
            b = $6a994d897ed01bc4$var$O(!0, a);
        } finally{
            b ? $6a994d897ed01bc4$var$S() : ($6a994d897ed01bc4$var$N = !1, $6a994d897ed01bc4$var$O = null);
        }
    } else $6a994d897ed01bc4$var$N = !1;
}
var $6a994d897ed01bc4$var$S;
if ("function" === typeof $6a994d897ed01bc4$var$F) $6a994d897ed01bc4$var$S = function() {
    $6a994d897ed01bc4$var$F($6a994d897ed01bc4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6a994d897ed01bc4$var$T = new MessageChannel, $6a994d897ed01bc4$var$U = $6a994d897ed01bc4$var$T.port2;
    $6a994d897ed01bc4$var$T.port1.onmessage = $6a994d897ed01bc4$var$R;
    $6a994d897ed01bc4$var$S = function() {
        $6a994d897ed01bc4$var$U.postMessage(null);
    };
} else $6a994d897ed01bc4$var$S = function() {
    $6a994d897ed01bc4$var$D($6a994d897ed01bc4$var$R, 0);
};
function $6a994d897ed01bc4$var$I(a) {
    $6a994d897ed01bc4$var$O = a;
    $6a994d897ed01bc4$var$N || ($6a994d897ed01bc4$var$N = !0, $6a994d897ed01bc4$var$S());
}
function $6a994d897ed01bc4$var$K(a, b) {
    $6a994d897ed01bc4$var$L = $6a994d897ed01bc4$var$D(function() {
        a($6a994d897ed01bc4$export$c4744153514ff05d());
    }, b);
}
$6a994d897ed01bc4$export$3e506c1ccc9cc1a7 = 5;
$6a994d897ed01bc4$export$e26fe2ed2fa76875 = 1;
$6a994d897ed01bc4$export$502329bbf4b505b1 = 4;
$6a994d897ed01bc4$export$6e3807111c4874c4 = 3;
$6a994d897ed01bc4$export$c27134553091fb3a = null;
$6a994d897ed01bc4$export$33ee1acdc04fd2a2 = 2;
$6a994d897ed01bc4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6a994d897ed01bc4$export$8352ce38b91d0c62 = function() {
    $6a994d897ed01bc4$var$A || $6a994d897ed01bc4$var$z || ($6a994d897ed01bc4$var$A = !0, $6a994d897ed01bc4$var$I($6a994d897ed01bc4$var$J));
};
$6a994d897ed01bc4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6a994d897ed01bc4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6a994d897ed01bc4$export$d3dfb8e4810cb555 = function() {
    return $6a994d897ed01bc4$var$y;
};
$6a994d897ed01bc4$export$839f9183b0465a69 = function() {
    return $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$r);
};
$6a994d897ed01bc4$export$72fdf0e06517287b = function(a) {
    switch($6a994d897ed01bc4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6a994d897ed01bc4$var$y;
    }
    var c = $6a994d897ed01bc4$var$y;
    $6a994d897ed01bc4$var$y = b;
    try {
        return a();
    } finally{
        $6a994d897ed01bc4$var$y = c;
    }
};
$6a994d897ed01bc4$export$4b844e58a3e414b4 = function() {};
$6a994d897ed01bc4$export$816d2913ae6b83b1 = function() {};
$6a994d897ed01bc4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6a994d897ed01bc4$var$y;
    $6a994d897ed01bc4$var$y = a;
    try {
        return b();
    } finally{
        $6a994d897ed01bc4$var$y = c;
    }
};
$6a994d897ed01bc4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6a994d897ed01bc4$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6a994d897ed01bc4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6a994d897ed01bc4$var$f($6a994d897ed01bc4$var$t, a), null === $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$r) && a === $6a994d897ed01bc4$var$h($6a994d897ed01bc4$var$t) && ($6a994d897ed01bc4$var$B ? ($6a994d897ed01bc4$var$E($6a994d897ed01bc4$var$L), $6a994d897ed01bc4$var$L = -1) : $6a994d897ed01bc4$var$B = !0, $6a994d897ed01bc4$var$K($6a994d897ed01bc4$var$H, c - d))) : (a.sortIndex = e, $6a994d897ed01bc4$var$f($6a994d897ed01bc4$var$r, a), $6a994d897ed01bc4$var$A || $6a994d897ed01bc4$var$z || ($6a994d897ed01bc4$var$A = !0, $6a994d897ed01bc4$var$I($6a994d897ed01bc4$var$J)));
    return a;
};
$6a994d897ed01bc4$export$b5836b71941fa3ed = $6a994d897ed01bc4$var$M;
$6a994d897ed01bc4$export$cf845f2c119da08a = function(a) {
    var b = $6a994d897ed01bc4$var$y;
    return function() {
        var c = $6a994d897ed01bc4$var$y;
        $6a994d897ed01bc4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6a994d897ed01bc4$var$y = c;
        }
    };
};

});



parcelRegister("6nrW6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kFS6R = parcelRequire("kFS6R");
function $4a4a8f9d9be19aa1$var$emptyFunction() {}
function $4a4a8f9d9be19aa1$var$emptyFunctionWithReset() {}
$4a4a8f9d9be19aa1$var$emptyFunctionWithReset.resetWarningCache = $4a4a8f9d9be19aa1$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kFS6R) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4a4a8f9d9be19aa1$var$emptyFunctionWithReset,
        resetWarningCache: $4a4a8f9d9be19aa1$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kFS6R", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f0d19c043fea21cc$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f0d19c043fea21cc$var$ReactPropTypesSecret;

});


parcelRegister("laVoo", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $f6a70d1793834adc$export$2b8d127b894957b9; }, function (v) { return $f6a70d1793834adc$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $f6a70d1793834adc$export$cea3a54a6425200c; }, function (v) { return $f6a70d1793834adc$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $f6a70d1793834adc$export$a7c73072b1a182ae; }, function (v) { return $f6a70d1793834adc$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f6a70d1793834adc$export$9f27bc3417b4524d; }, function (v) { return $f6a70d1793834adc$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f6a70d1793834adc$export$db77ccec0bb4ccac; }, function (v) { return $f6a70d1793834adc$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f6a70d1793834adc$export$8392c0c9d3dcbd35; }, function (v) { return $f6a70d1793834adc$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f6a70d1793834adc$export$ffb0004e005737fa; }, function (v) { return $f6a70d1793834adc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f6a70d1793834adc$export$b624eff549462981; }, function (v) { return $f6a70d1793834adc$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f6a70d1793834adc$export$7897aa7841a5380c; }, function (v) { return $f6a70d1793834adc$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f6a70d1793834adc$export$602eac185826482c; }, function (v) { return $f6a70d1793834adc$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f6a70d1793834adc$export$e2c29f18771995cb; }, function (v) { return $f6a70d1793834adc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f6a70d1793834adc$export$5f8d39834fd61797; }, function (v) { return $f6a70d1793834adc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f6a70d1793834adc$export$74bf444e3cd11ea5; }, function (v) { return $f6a70d1793834adc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f6a70d1793834adc$export$92387174baf9b227; }, function (v) { return $f6a70d1793834adc$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f6a70d1793834adc$export$ec112efeb987d9c6; }, function (v) { return $f6a70d1793834adc$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f6a70d1793834adc$export$b706b080d889d2c9; }, function (v) { return $f6a70d1793834adc$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f6a70d1793834adc$export$5be5a87408f70ddc; }, function (v) { return $f6a70d1793834adc$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f6a70d1793834adc$export$45a5e7f76e0caa8d; }, function (v) { return $f6a70d1793834adc$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f6a70d1793834adc$export$455c2e768291efa6; }, function (v) { return $f6a70d1793834adc$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f6a70d1793834adc$export$9522e17588c12572; }, function (v) { return $f6a70d1793834adc$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f6a70d1793834adc$export$2110ac352bb060b9; }, function (v) { return $f6a70d1793834adc$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f6a70d1793834adc$export$56885ab8b9c456ab; }, function (v) { return $f6a70d1793834adc$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f6a70d1793834adc$export$d927fcb6adf8f9de; }, function (v) { return $f6a70d1793834adc$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f6a70d1793834adc$export$b82d16f27459e05a; }, function (v) { return $f6a70d1793834adc$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f6a70d1793834adc$export$522c17b4f5e123e8; }, function (v) { return $f6a70d1793834adc$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f6a70d1793834adc$export$1aabd8a0274ecfd6; }, function (v) { return $f6a70d1793834adc$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f6a70d1793834adc$export$9b621391a187a31a; }, function (v) { return $f6a70d1793834adc$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f6a70d1793834adc$export$f5bbd400c2f4426f; }, function (v) { return $f6a70d1793834adc$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f6a70d1793834adc$export$2b8d127b894957b9;
var $f6a70d1793834adc$export$cea3a54a6425200c;
var $f6a70d1793834adc$export$a7c73072b1a182ae;
var $f6a70d1793834adc$export$9f27bc3417b4524d;
var $f6a70d1793834adc$export$db77ccec0bb4ccac;
var $f6a70d1793834adc$export$8392c0c9d3dcbd35;
var $f6a70d1793834adc$export$ffb0004e005737fa;
var $f6a70d1793834adc$export$b624eff549462981;
var $f6a70d1793834adc$export$7897aa7841a5380c;
var $f6a70d1793834adc$export$602eac185826482c;
var $f6a70d1793834adc$export$e2c29f18771995cb;
var $f6a70d1793834adc$export$5f8d39834fd61797;
var $f6a70d1793834adc$export$74bf444e3cd11ea5;
var $f6a70d1793834adc$export$92387174baf9b227;
var $f6a70d1793834adc$export$ec112efeb987d9c6;
var $f6a70d1793834adc$export$b706b080d889d2c9;
var $f6a70d1793834adc$export$5be5a87408f70ddc;
var $f6a70d1793834adc$export$45a5e7f76e0caa8d;
var $f6a70d1793834adc$export$455c2e768291efa6;
var $f6a70d1793834adc$export$9522e17588c12572;
var $f6a70d1793834adc$export$2110ac352bb060b9;
var $f6a70d1793834adc$export$56885ab8b9c456ab;
var $f6a70d1793834adc$export$d927fcb6adf8f9de;
var $f6a70d1793834adc$export$b82d16f27459e05a;
var $f6a70d1793834adc$export$522c17b4f5e123e8;
var $f6a70d1793834adc$export$1aabd8a0274ecfd6;
var $f6a70d1793834adc$export$9b621391a187a31a;
var $f6a70d1793834adc$export$f5bbd400c2f4426f;
'use strict';
var $f6a70d1793834adc$var$b = "function" === typeof Symbol && Symbol.for, $f6a70d1793834adc$var$c = $f6a70d1793834adc$var$b ? Symbol.for("react.element") : 60103, $f6a70d1793834adc$var$d = $f6a70d1793834adc$var$b ? Symbol.for("react.portal") : 60106, $f6a70d1793834adc$var$e = $f6a70d1793834adc$var$b ? Symbol.for("react.fragment") : 60107, $f6a70d1793834adc$var$f = $f6a70d1793834adc$var$b ? Symbol.for("react.strict_mode") : 60108, $f6a70d1793834adc$var$g = $f6a70d1793834adc$var$b ? Symbol.for("react.profiler") : 60114, $f6a70d1793834adc$var$h = $f6a70d1793834adc$var$b ? Symbol.for("react.provider") : 60109, $f6a70d1793834adc$var$k = $f6a70d1793834adc$var$b ? Symbol.for("react.context") : 60110, $f6a70d1793834adc$var$l = $f6a70d1793834adc$var$b ? Symbol.for("react.async_mode") : 60111, $f6a70d1793834adc$var$m = $f6a70d1793834adc$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f6a70d1793834adc$var$n = $f6a70d1793834adc$var$b ? Symbol.for("react.forward_ref") : 60112, $f6a70d1793834adc$var$p = $f6a70d1793834adc$var$b ? Symbol.for("react.suspense") : 60113, $f6a70d1793834adc$var$q = $f6a70d1793834adc$var$b ? Symbol.for("react.suspense_list") : 60120, $f6a70d1793834adc$var$r = $f6a70d1793834adc$var$b ? Symbol.for("react.memo") : 60115, $f6a70d1793834adc$var$t = $f6a70d1793834adc$var$b ? Symbol.for("react.lazy") : 60116, $f6a70d1793834adc$var$v = $f6a70d1793834adc$var$b ? Symbol.for("react.block") : 60121, $f6a70d1793834adc$var$w = $f6a70d1793834adc$var$b ? Symbol.for("react.fundamental") : 60117, $f6a70d1793834adc$var$x = $f6a70d1793834adc$var$b ? Symbol.for("react.responder") : 60118, $f6a70d1793834adc$var$y = $f6a70d1793834adc$var$b ? Symbol.for("react.scope") : 60119;
function $f6a70d1793834adc$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f6a70d1793834adc$var$c:
                switch(a = a.type, a){
                    case $f6a70d1793834adc$var$l:
                    case $f6a70d1793834adc$var$m:
                    case $f6a70d1793834adc$var$e:
                    case $f6a70d1793834adc$var$g:
                    case $f6a70d1793834adc$var$f:
                    case $f6a70d1793834adc$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f6a70d1793834adc$var$k:
                            case $f6a70d1793834adc$var$n:
                            case $f6a70d1793834adc$var$t:
                            case $f6a70d1793834adc$var$r:
                            case $f6a70d1793834adc$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f6a70d1793834adc$var$d:
                return u;
        }
    }
}
function $f6a70d1793834adc$var$A(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$m;
}
$f6a70d1793834adc$export$2b8d127b894957b9 = $f6a70d1793834adc$var$l;
$f6a70d1793834adc$export$cea3a54a6425200c = $f6a70d1793834adc$var$m;
$f6a70d1793834adc$export$a7c73072b1a182ae = $f6a70d1793834adc$var$k;
$f6a70d1793834adc$export$9f27bc3417b4524d = $f6a70d1793834adc$var$h;
$f6a70d1793834adc$export$db77ccec0bb4ccac = $f6a70d1793834adc$var$c;
$f6a70d1793834adc$export$8392c0c9d3dcbd35 = $f6a70d1793834adc$var$n;
$f6a70d1793834adc$export$ffb0004e005737fa = $f6a70d1793834adc$var$e;
$f6a70d1793834adc$export$b624eff549462981 = $f6a70d1793834adc$var$t;
$f6a70d1793834adc$export$7897aa7841a5380c = $f6a70d1793834adc$var$r;
$f6a70d1793834adc$export$602eac185826482c = $f6a70d1793834adc$var$d;
$f6a70d1793834adc$export$e2c29f18771995cb = $f6a70d1793834adc$var$g;
$f6a70d1793834adc$export$5f8d39834fd61797 = $f6a70d1793834adc$var$f;
$f6a70d1793834adc$export$74bf444e3cd11ea5 = $f6a70d1793834adc$var$p;
$f6a70d1793834adc$export$92387174baf9b227 = function(a) {
    return $f6a70d1793834adc$var$A(a) || $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$l;
};
$f6a70d1793834adc$export$ec112efeb987d9c6 = $f6a70d1793834adc$var$A;
$f6a70d1793834adc$export$b706b080d889d2c9 = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$k;
};
$f6a70d1793834adc$export$5be5a87408f70ddc = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$h;
};
$f6a70d1793834adc$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f6a70d1793834adc$var$c;
};
$f6a70d1793834adc$export$455c2e768291efa6 = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$n;
};
$f6a70d1793834adc$export$9522e17588c12572 = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$e;
};
$f6a70d1793834adc$export$2110ac352bb060b9 = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$t;
};
$f6a70d1793834adc$export$56885ab8b9c456ab = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$r;
};
$f6a70d1793834adc$export$d927fcb6adf8f9de = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$d;
};
$f6a70d1793834adc$export$b82d16f27459e05a = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$g;
};
$f6a70d1793834adc$export$522c17b4f5e123e8 = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$f;
};
$f6a70d1793834adc$export$1aabd8a0274ecfd6 = function(a) {
    return $f6a70d1793834adc$var$z(a) === $f6a70d1793834adc$var$p;
};
$f6a70d1793834adc$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f6a70d1793834adc$var$e || a === $f6a70d1793834adc$var$m || a === $f6a70d1793834adc$var$g || a === $f6a70d1793834adc$var$f || a === $f6a70d1793834adc$var$p || a === $f6a70d1793834adc$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f6a70d1793834adc$var$t || a.$$typeof === $f6a70d1793834adc$var$r || a.$$typeof === $f6a70d1793834adc$var$h || a.$$typeof === $f6a70d1793834adc$var$k || a.$$typeof === $f6a70d1793834adc$var$n || a.$$typeof === $f6a70d1793834adc$var$w || a.$$typeof === $f6a70d1793834adc$var$x || a.$$typeof === $f6a70d1793834adc$var$y || a.$$typeof === $f6a70d1793834adc$var$v);
};
$f6a70d1793834adc$export$f5bbd400c2f4426f = $f6a70d1793834adc$var$z;

});

parcelRegister("gagb8", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("4l1Xa", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", function () { return useFormikContext; });
$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "useField", function () { return useField; });
$parcel$export(module.exports, "Field", function () { return Field; });
$parcel$export(module.exports, "Form", function () { return Form; });

var $hHu9E = parcelRequire("hHu9E");

var $aCch4 = parcelRequire("aCch4");

var $7GO9G = parcelRequire("7GO9G");

var $igtsr = parcelRequire("igtsr");

var $8Rg0Z = parcelRequire("8Rg0Z");

var $kQLuK = parcelRequire("kQLuK");

var $dfYuL = parcelRequire("dfYuL");

var $678YX = parcelRequire("678YX");

var $5lZKQ = parcelRequire("5lZKQ");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $igtsr.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $igtsr.useContext)(FormikContext);
    !!!formik && (0, $kQLuK.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $igtsr.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $678YX.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $dfYuL.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $678YX.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $dfYuL.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $igtsr.useRef)(props.initialValues);
    var initialErrors = (0, $igtsr.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $igtsr.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $igtsr.useRef)(props.initialStatus);
    var isMounted = (0, $igtsr.useRef)(false);
    var fieldRegistry = (0, $igtsr.useRef)({});
    (0, $igtsr.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $igtsr.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $igtsr.useRef)({
        values: (0, $7GO9G.default)(props.initialValues),
        errors: (0, $7GO9G.default)(props.initialErrors) || emptyErrors,
        touched: (0, $7GO9G.default)(props.initialTouched) || emptyTouched,
        status: (0, $7GO9G.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $igtsr.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $igtsr.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $igtsr.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $igtsr.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $igtsr.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $igtsr.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $hHu9E.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $igtsr.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $igtsr.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $igtsr.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $igtsr.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $igtsr.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $igtsr.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $igtsr.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $igtsr.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $igtsr.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $igtsr.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $igtsr.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $igtsr.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $igtsr.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $igtsr.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $igtsr.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $igtsr.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $igtsr.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $igtsr.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $igtsr.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $igtsr.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $igtsr.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $igtsr.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $igtsr.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $igtsr.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $aCch4.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $aCch4.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $hHu9E.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $hHu9E.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $igtsr.useLayoutEffect) : (0, $igtsr.useEffect);
function useEventCallback(fn) {
    var ref = (0, $igtsr.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $igtsr.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $igtsr.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $kQLuK.default)(false);
    var fieldHelpers = (0, $igtsr.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $igtsr.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $igtsr.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $igtsr.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $igtsr.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $igtsr.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $igtsr.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $igtsr.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $igtsr.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $igtsr.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $igtsr.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($5lZKQ)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $igtsr.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $kQLuK.default)(false);
            return (0, $igtsr.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($5lZKQ)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $7GO9G.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($8Rg0Z)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $igtsr.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $igtsr.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $igtsr.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $igtsr.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $igtsr.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $kQLuK.default)(false);
        !!(component && render) && (0, $kQLuK.default)(false);
        !!(is && children && isFunction(children)) && (0, $kQLuK.default)(false);
        !!(component && children && isFunction(children)) && (0, $kQLuK.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $kQLuK.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $igtsr.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $igtsr.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $igtsr.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $igtsr.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $igtsr.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("hHu9E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce2dd7e239cb5934$export$2e2bcd8739ae039; });
var $ce2dd7e239cb5934$var$isMergeableObject = function isMergeableObject(value) {
    return $ce2dd7e239cb5934$var$isNonNullObject(value) && !$ce2dd7e239cb5934$var$isSpecial(value);
};
function $ce2dd7e239cb5934$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $ce2dd7e239cb5934$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $ce2dd7e239cb5934$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $ce2dd7e239cb5934$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $ce2dd7e239cb5934$var$REACT_ELEMENT_TYPE = $ce2dd7e239cb5934$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $ce2dd7e239cb5934$var$isReactElement(value) {
    return value.$$typeof === $ce2dd7e239cb5934$var$REACT_ELEMENT_TYPE;
}
function $ce2dd7e239cb5934$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $ce2dd7e239cb5934$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $ce2dd7e239cb5934$var$deepmerge($ce2dd7e239cb5934$var$emptyTarget(value), value, options) : value;
}
function $ce2dd7e239cb5934$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $ce2dd7e239cb5934$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $ce2dd7e239cb5934$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $ce2dd7e239cb5934$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $ce2dd7e239cb5934$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $ce2dd7e239cb5934$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $ce2dd7e239cb5934$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $ce2dd7e239cb5934$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $ce2dd7e239cb5934$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $ce2dd7e239cb5934$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $ce2dd7e239cb5934$var$mergeObject(target, source, options);
}
$ce2dd7e239cb5934$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $ce2dd7e239cb5934$var$deepmerge(prev, next, options);
    }, {});
};
var $ce2dd7e239cb5934$var$deepmerge_1 = $ce2dd7e239cb5934$var$deepmerge;
var $ce2dd7e239cb5934$export$2e2bcd8739ae039 = $ce2dd7e239cb5934$var$deepmerge_1;

});

parcelRegister("aCch4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ba6f96aa3964c68$export$2e2bcd8739ae039; });

var $89LaC = parcelRequire("89LaC");

var $lGQMZ = parcelRequire("lGQMZ");

var $4JGW3 = parcelRequire("4JGW3");
/** `Object#toString` result references. */ var $7ba6f96aa3964c68$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $7ba6f96aa3964c68$var$funcProto = Function.prototype, $7ba6f96aa3964c68$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7ba6f96aa3964c68$var$funcToString = $7ba6f96aa3964c68$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7ba6f96aa3964c68$var$hasOwnProperty = $7ba6f96aa3964c68$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $7ba6f96aa3964c68$var$objectCtorString = $7ba6f96aa3964c68$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $7ba6f96aa3964c68$var$isPlainObject(value) {
    if (!(0, $4JGW3.default)(value) || (0, $89LaC.default)(value) != $7ba6f96aa3964c68$var$objectTag) return false;
    var proto = (0, $lGQMZ.default)(value);
    if (proto === null) return true;
    var Ctor = $7ba6f96aa3964c68$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $7ba6f96aa3964c68$var$funcToString.call(Ctor) == $7ba6f96aa3964c68$var$objectCtorString;
}
var $7ba6f96aa3964c68$export$2e2bcd8739ae039 = $7ba6f96aa3964c68$var$isPlainObject;

});
parcelRegister("89LaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f03c10c18dd8aa2$export$2e2bcd8739ae039; });

var $lV3so = parcelRequire("lV3so");

var $1axvK = parcelRequire("1axvK");

var $cR8Ql = parcelRequire("cR8Ql");
/** `Object#toString` result references. */ var $5f03c10c18dd8aa2$var$nullTag = '[object Null]', $5f03c10c18dd8aa2$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $5f03c10c18dd8aa2$var$symToStringTag = (0, $lV3so.default) ? (0, $lV3so.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5f03c10c18dd8aa2$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5f03c10c18dd8aa2$var$undefinedTag : $5f03c10c18dd8aa2$var$nullTag;
    return $5f03c10c18dd8aa2$var$symToStringTag && $5f03c10c18dd8aa2$var$symToStringTag in Object(value) ? (0, $1axvK.default)(value) : (0, $cR8Ql.default)(value);
}
var $5f03c10c18dd8aa2$export$2e2bcd8739ae039 = $5f03c10c18dd8aa2$var$baseGetTag;

});
parcelRegister("lV3so", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $041e382abae67d6b$export$2e2bcd8739ae039; });

var $6b0HP = parcelRequire("6b0HP");
/** Built-in value references. */ var $041e382abae67d6b$var$Symbol = (0, $6b0HP.default).Symbol;
var $041e382abae67d6b$export$2e2bcd8739ae039 = $041e382abae67d6b$var$Symbol;

});
parcelRegister("6b0HP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47f451532c547e59$export$2e2bcd8739ae039; });

var $jvlpt = parcelRequire("jvlpt");
/** Detect free variable `self`. */ var $47f451532c547e59$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $47f451532c547e59$var$root = (0, $jvlpt.default) || $47f451532c547e59$var$freeSelf || Function('return this')();
var $47f451532c547e59$export$2e2bcd8739ae039 = $47f451532c547e59$var$root;

});
parcelRegister("jvlpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e331851c69453b62$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $e331851c69453b62$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $e331851c69453b62$export$2e2bcd8739ae039 = $e331851c69453b62$var$freeGlobal;

});



parcelRegister("1axvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0da0b831c4536e06$export$2e2bcd8739ae039; });

var $lV3so = parcelRequire("lV3so");
/** Used for built-in method references. */ var $0da0b831c4536e06$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0da0b831c4536e06$var$hasOwnProperty = $0da0b831c4536e06$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0da0b831c4536e06$var$nativeObjectToString = $0da0b831c4536e06$var$objectProto.toString;
/** Built-in value references. */ var $0da0b831c4536e06$var$symToStringTag = (0, $lV3so.default) ? (0, $lV3so.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0da0b831c4536e06$var$getRawTag(value) {
    var isOwn = $0da0b831c4536e06$var$hasOwnProperty.call(value, $0da0b831c4536e06$var$symToStringTag), tag = value[$0da0b831c4536e06$var$symToStringTag];
    try {
        value[$0da0b831c4536e06$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $0da0b831c4536e06$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0da0b831c4536e06$var$symToStringTag] = tag;
        else delete value[$0da0b831c4536e06$var$symToStringTag];
    }
    return result;
}
var $0da0b831c4536e06$export$2e2bcd8739ae039 = $0da0b831c4536e06$var$getRawTag;

});

parcelRegister("cR8Ql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c14b592a1f9981$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $95c14b592a1f9981$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $95c14b592a1f9981$var$nativeObjectToString = $95c14b592a1f9981$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $95c14b592a1f9981$var$objectToString(value) {
    return $95c14b592a1f9981$var$nativeObjectToString.call(value);
}
var $95c14b592a1f9981$export$2e2bcd8739ae039 = $95c14b592a1f9981$var$objectToString;

});


parcelRegister("lGQMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fca67807c22a4f16$export$2e2bcd8739ae039; });

var $ky7W8 = parcelRequire("ky7W8");
/** Built-in value references. */ var $fca67807c22a4f16$var$getPrototype = (0, $ky7W8.default)(Object.getPrototypeOf, Object);
var $fca67807c22a4f16$export$2e2bcd8739ae039 = $fca67807c22a4f16$var$getPrototype;

});
parcelRegister("ky7W8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef5d23af515db3c2$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ef5d23af515db3c2$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $ef5d23af515db3c2$export$2e2bcd8739ae039 = $ef5d23af515db3c2$var$overArg;

});


parcelRegister("4JGW3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $372cab7cb3c65b56$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $372cab7cb3c65b56$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $372cab7cb3c65b56$export$2e2bcd8739ae039 = $372cab7cb3c65b56$var$isObjectLike;

});


parcelRegister("7GO9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59935c6b53bb7b90$export$2e2bcd8739ae039; });

var $7BcOh = parcelRequire("7BcOh");
/** Used to compose bitmasks for cloning. */ var $59935c6b53bb7b90$var$CLONE_DEEP_FLAG = 1, $59935c6b53bb7b90$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $59935c6b53bb7b90$var$cloneDeep(value) {
    return (0, $7BcOh.default)(value, $59935c6b53bb7b90$var$CLONE_DEEP_FLAG | $59935c6b53bb7b90$var$CLONE_SYMBOLS_FLAG);
}
var $59935c6b53bb7b90$export$2e2bcd8739ae039 = $59935c6b53bb7b90$var$cloneDeep;

});
parcelRegister("7BcOh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5885ece6ed5044f6$export$2e2bcd8739ae039; });

var $8QLPm = parcelRequire("8QLPm");

var $bRIKu = parcelRequire("bRIKu");

var $fOspi = parcelRequire("fOspi");

var $1K5OC = parcelRequire("1K5OC");

var $F3oQn = parcelRequire("F3oQn");

var $57J06 = parcelRequire("57J06");

var $9XLAP = parcelRequire("9XLAP");

var $e80FB = parcelRequire("e80FB");

var $TRcjr = parcelRequire("TRcjr");

var $icXyf = parcelRequire("icXyf");

var $8780u = parcelRequire("8780u");

var $jjZbM = parcelRequire("jjZbM");

var $5MyLr = parcelRequire("5MyLr");

var $fS48y = parcelRequire("fS48y");

var $kVn2x = parcelRequire("kVn2x");

var $fSMeh = parcelRequire("fSMeh");

var $4eEda = parcelRequire("4eEda");

var $5UPYS = parcelRequire("5UPYS");

var $4T3my = parcelRequire("4T3my");

var $98xv0 = parcelRequire("98xv0");

var $6Fo7W = parcelRequire("6Fo7W");

var $f6GF3 = parcelRequire("f6GF3");
/** Used to compose bitmasks for cloning. */ var $5885ece6ed5044f6$var$CLONE_DEEP_FLAG = 1, $5885ece6ed5044f6$var$CLONE_FLAT_FLAG = 2, $5885ece6ed5044f6$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $5885ece6ed5044f6$var$argsTag = '[object Arguments]', $5885ece6ed5044f6$var$arrayTag = '[object Array]', $5885ece6ed5044f6$var$boolTag = '[object Boolean]', $5885ece6ed5044f6$var$dateTag = '[object Date]', $5885ece6ed5044f6$var$errorTag = '[object Error]', $5885ece6ed5044f6$var$funcTag = '[object Function]', $5885ece6ed5044f6$var$genTag = '[object GeneratorFunction]', $5885ece6ed5044f6$var$mapTag = '[object Map]', $5885ece6ed5044f6$var$numberTag = '[object Number]', $5885ece6ed5044f6$var$objectTag = '[object Object]', $5885ece6ed5044f6$var$regexpTag = '[object RegExp]', $5885ece6ed5044f6$var$setTag = '[object Set]', $5885ece6ed5044f6$var$stringTag = '[object String]', $5885ece6ed5044f6$var$symbolTag = '[object Symbol]', $5885ece6ed5044f6$var$weakMapTag = '[object WeakMap]';
var $5885ece6ed5044f6$var$arrayBufferTag = '[object ArrayBuffer]', $5885ece6ed5044f6$var$dataViewTag = '[object DataView]', $5885ece6ed5044f6$var$float32Tag = '[object Float32Array]', $5885ece6ed5044f6$var$float64Tag = '[object Float64Array]', $5885ece6ed5044f6$var$int8Tag = '[object Int8Array]', $5885ece6ed5044f6$var$int16Tag = '[object Int16Array]', $5885ece6ed5044f6$var$int32Tag = '[object Int32Array]', $5885ece6ed5044f6$var$uint8Tag = '[object Uint8Array]', $5885ece6ed5044f6$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5885ece6ed5044f6$var$uint16Tag = '[object Uint16Array]', $5885ece6ed5044f6$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $5885ece6ed5044f6$var$cloneableTags = {};
$5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$argsTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$arrayTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$arrayBufferTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$dataViewTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$boolTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$dateTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$float32Tag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$float64Tag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$int8Tag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$int16Tag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$int32Tag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$mapTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$numberTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$objectTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$regexpTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$setTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$stringTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$symbolTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$uint8Tag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$uint8ClampedTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$uint16Tag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$uint32Tag] = true;
$5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$errorTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$funcTag] = $5885ece6ed5044f6$var$cloneableTags[$5885ece6ed5044f6$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $5885ece6ed5044f6$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $5885ece6ed5044f6$var$CLONE_DEEP_FLAG, isFlat = bitmask & $5885ece6ed5044f6$var$CLONE_FLAT_FLAG, isFull = bitmask & $5885ece6ed5044f6$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $4T3my.default)(value)) return value;
    var isArr = (0, $fSMeh.default)(value);
    if (isArr) {
        result = (0, $5MyLr.default)(value);
        if (!isDeep) return (0, $9XLAP.default)(value, result);
    } else {
        var tag = (0, $jjZbM.default)(value), isFunc = tag == $5885ece6ed5044f6$var$funcTag || tag == $5885ece6ed5044f6$var$genTag;
        if ((0, $4eEda.default)(value)) return (0, $57J06.default)(value, isDeep);
        if (tag == $5885ece6ed5044f6$var$objectTag || tag == $5885ece6ed5044f6$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $kVn2x.default)(value);
            if (!isDeep) return isFlat ? (0, $TRcjr.default)(value, (0, $F3oQn.default)(result, value)) : (0, $e80FB.default)(value, (0, $1K5OC.default)(result, value));
        } else {
            if (!$5885ece6ed5044f6$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $fS48y.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $8QLPm.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $98xv0.default)(value)) value.forEach(function(subValue) {
        result.add($5885ece6ed5044f6$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5UPYS.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $5885ece6ed5044f6$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $8780u.default) : (0, $icXyf.default) : isFlat ? (0, $f6GF3.default) : (0, $6Fo7W.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $bRIKu.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $fOspi.default)(result, key, $5885ece6ed5044f6$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $5885ece6ed5044f6$export$2e2bcd8739ae039 = $5885ece6ed5044f6$var$baseClone;

});
parcelRegister("8QLPm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67184795cff91796$export$2e2bcd8739ae039; });

var $gGZN4 = parcelRequire("gGZN4");

var $3gWHW = parcelRequire("3gWHW");

var $5ZVoX = parcelRequire("5ZVoX");

var $hAwac = parcelRequire("hAwac");

var $jDXHS = parcelRequire("jDXHS");

var $bKEvX = parcelRequire("bKEvX");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $67184795cff91796$var$Stack(entries) {
    var data = this.__data__ = new (0, $gGZN4.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$67184795cff91796$var$Stack.prototype.clear = (0, $3gWHW.default);
$67184795cff91796$var$Stack.prototype['delete'] = (0, $5ZVoX.default);
$67184795cff91796$var$Stack.prototype.get = (0, $hAwac.default);
$67184795cff91796$var$Stack.prototype.has = (0, $jDXHS.default);
$67184795cff91796$var$Stack.prototype.set = (0, $bKEvX.default);
var $67184795cff91796$export$2e2bcd8739ae039 = $67184795cff91796$var$Stack;

});
parcelRegister("gGZN4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2707fe60076b150$export$2e2bcd8739ae039; });

var $5JaEB = parcelRequire("5JaEB");

var $2VYs8 = parcelRequire("2VYs8");

var $dBcav = parcelRequire("dBcav");

var $abP2V = parcelRequire("abP2V");

var $bH7R9 = parcelRequire("bH7R9");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c2707fe60076b150$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$c2707fe60076b150$var$ListCache.prototype.clear = (0, $5JaEB.default);
$c2707fe60076b150$var$ListCache.prototype['delete'] = (0, $2VYs8.default);
$c2707fe60076b150$var$ListCache.prototype.get = (0, $dBcav.default);
$c2707fe60076b150$var$ListCache.prototype.has = (0, $abP2V.default);
$c2707fe60076b150$var$ListCache.prototype.set = (0, $bH7R9.default);
var $c2707fe60076b150$export$2e2bcd8739ae039 = $c2707fe60076b150$var$ListCache;

});
parcelRegister("5JaEB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42b96b5851bee58c$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $42b96b5851bee58c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $42b96b5851bee58c$export$2e2bcd8739ae039 = $42b96b5851bee58c$var$listCacheClear;

});

parcelRegister("2VYs8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $222fcc51425cbc8d$export$2e2bcd8739ae039; });

var $8lBI0 = parcelRequire("8lBI0");
/** Used for built-in method references. */ var $222fcc51425cbc8d$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $222fcc51425cbc8d$var$splice = $222fcc51425cbc8d$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $222fcc51425cbc8d$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $8lBI0.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $222fcc51425cbc8d$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $222fcc51425cbc8d$export$2e2bcd8739ae039 = $222fcc51425cbc8d$var$listCacheDelete;

});
parcelRegister("8lBI0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $613d8915de0ee8be$export$2e2bcd8739ae039; });

var $4Dk8a = parcelRequire("4Dk8a");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $613d8915de0ee8be$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $4Dk8a.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $613d8915de0ee8be$export$2e2bcd8739ae039 = $613d8915de0ee8be$var$assocIndexOf;

});
parcelRegister("4Dk8a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35fa6b7e67885daf$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $35fa6b7e67885daf$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $35fa6b7e67885daf$export$2e2bcd8739ae039 = $35fa6b7e67885daf$var$eq;

});



parcelRegister("dBcav", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e682b78a4db6658$export$2e2bcd8739ae039; });

var $8lBI0 = parcelRequire("8lBI0");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9e682b78a4db6658$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $8lBI0.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $9e682b78a4db6658$export$2e2bcd8739ae039 = $9e682b78a4db6658$var$listCacheGet;

});

parcelRegister("abP2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76b28727abbd1d83$export$2e2bcd8739ae039; });

var $8lBI0 = parcelRequire("8lBI0");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $76b28727abbd1d83$var$listCacheHas(key) {
    return (0, $8lBI0.default)(this.__data__, key) > -1;
}
var $76b28727abbd1d83$export$2e2bcd8739ae039 = $76b28727abbd1d83$var$listCacheHas;

});

parcelRegister("bH7R9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8839cdf3e60ab224$export$2e2bcd8739ae039; });

var $8lBI0 = parcelRequire("8lBI0");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8839cdf3e60ab224$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $8lBI0.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $8839cdf3e60ab224$export$2e2bcd8739ae039 = $8839cdf3e60ab224$var$listCacheSet;

});


parcelRegister("3gWHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $262067d9aa1bbaaa$export$2e2bcd8739ae039; });

var $gGZN4 = parcelRequire("gGZN4");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $262067d9aa1bbaaa$var$stackClear() {
    this.__data__ = new (0, $gGZN4.default);
    this.size = 0;
}
var $262067d9aa1bbaaa$export$2e2bcd8739ae039 = $262067d9aa1bbaaa$var$stackClear;

});

parcelRegister("5ZVoX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45df2d022a093dc8$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $45df2d022a093dc8$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $45df2d022a093dc8$export$2e2bcd8739ae039 = $45df2d022a093dc8$var$stackDelete;

});

parcelRegister("hAwac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccdebf72bf8cc303$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ccdebf72bf8cc303$var$stackGet(key) {
    return this.__data__.get(key);
}
var $ccdebf72bf8cc303$export$2e2bcd8739ae039 = $ccdebf72bf8cc303$var$stackGet;

});

parcelRegister("jDXHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4cff9594a66ffcd$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e4cff9594a66ffcd$var$stackHas(key) {
    return this.__data__.has(key);
}
var $e4cff9594a66ffcd$export$2e2bcd8739ae039 = $e4cff9594a66ffcd$var$stackHas;

});

parcelRegister("bKEvX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88e36ae73a7fa729$export$2e2bcd8739ae039; });

var $gGZN4 = parcelRequire("gGZN4");

var $eomsk = parcelRequire("eomsk");

var $h2qiz = parcelRequire("h2qiz");
/** Used as the size to enable large array optimizations. */ var $88e36ae73a7fa729$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $88e36ae73a7fa729$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $gGZN4.default)) {
        var pairs = data.__data__;
        if (!(0, $eomsk.default) || pairs.length < $88e36ae73a7fa729$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $h2qiz.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $88e36ae73a7fa729$export$2e2bcd8739ae039 = $88e36ae73a7fa729$var$stackSet;

});
parcelRegister("eomsk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7a4b9da860f3a1b$export$2e2bcd8739ae039; });

var $k1ULd = parcelRequire("k1ULd");

var $6b0HP = parcelRequire("6b0HP");
/* Built-in method references that are verified to be native. */ var $a7a4b9da860f3a1b$var$Map = (0, $k1ULd.default)((0, $6b0HP.default), 'Map');
var $a7a4b9da860f3a1b$export$2e2bcd8739ae039 = $a7a4b9da860f3a1b$var$Map;

});
parcelRegister("k1ULd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e94fee1e9b60ca5d$export$2e2bcd8739ae039; });

var $cInxf = parcelRequire("cInxf");

var $ehRYo = parcelRequire("ehRYo");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e94fee1e9b60ca5d$var$getNative(object, key) {
    var value = (0, $ehRYo.default)(object, key);
    return (0, $cInxf.default)(value) ? value : undefined;
}
var $e94fee1e9b60ca5d$export$2e2bcd8739ae039 = $e94fee1e9b60ca5d$var$getNative;

});
parcelRegister("cInxf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $941bd9b4dd84ed5f$export$2e2bcd8739ae039; });

var $8CdiG = parcelRequire("8CdiG");

var $6Vw9n = parcelRequire("6Vw9n");

var $4T3my = parcelRequire("4T3my");

var $aNze1 = parcelRequire("aNze1");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $941bd9b4dd84ed5f$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $941bd9b4dd84ed5f$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $941bd9b4dd84ed5f$var$funcProto = Function.prototype, $941bd9b4dd84ed5f$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $941bd9b4dd84ed5f$var$funcToString = $941bd9b4dd84ed5f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $941bd9b4dd84ed5f$var$hasOwnProperty = $941bd9b4dd84ed5f$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $941bd9b4dd84ed5f$var$reIsNative = RegExp('^' + $941bd9b4dd84ed5f$var$funcToString.call($941bd9b4dd84ed5f$var$hasOwnProperty).replace($941bd9b4dd84ed5f$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $941bd9b4dd84ed5f$var$baseIsNative(value) {
    if (!(0, $4T3my.default)(value) || (0, $6Vw9n.default)(value)) return false;
    var pattern = (0, $8CdiG.default)(value) ? $941bd9b4dd84ed5f$var$reIsNative : $941bd9b4dd84ed5f$var$reIsHostCtor;
    return pattern.test((0, $aNze1.default)(value));
}
var $941bd9b4dd84ed5f$export$2e2bcd8739ae039 = $941bd9b4dd84ed5f$var$baseIsNative;

});
parcelRegister("8CdiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $645c307e2ac6fb61$export$2e2bcd8739ae039; });

var $89LaC = parcelRequire("89LaC");

var $4T3my = parcelRequire("4T3my");
/** `Object#toString` result references. */ var $645c307e2ac6fb61$var$asyncTag = '[object AsyncFunction]', $645c307e2ac6fb61$var$funcTag = '[object Function]', $645c307e2ac6fb61$var$genTag = '[object GeneratorFunction]', $645c307e2ac6fb61$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $645c307e2ac6fb61$var$isFunction(value) {
    if (!(0, $4T3my.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $89LaC.default)(value);
    return tag == $645c307e2ac6fb61$var$funcTag || tag == $645c307e2ac6fb61$var$genTag || tag == $645c307e2ac6fb61$var$asyncTag || tag == $645c307e2ac6fb61$var$proxyTag;
}
var $645c307e2ac6fb61$export$2e2bcd8739ae039 = $645c307e2ac6fb61$var$isFunction;

});
parcelRegister("4T3my", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38eee845ee0480b8$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $38eee845ee0480b8$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $38eee845ee0480b8$export$2e2bcd8739ae039 = $38eee845ee0480b8$var$isObject;

});


parcelRegister("6Vw9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50b1014c3566ce09$export$2e2bcd8739ae039; });

var $7pFZP = parcelRequire("7pFZP");
/** Used to detect methods masquerading as native. */ var $50b1014c3566ce09$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $7pFZP.default) && (0, $7pFZP.default).keys && (0, $7pFZP.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $50b1014c3566ce09$var$isMasked(func) {
    return !!$50b1014c3566ce09$var$maskSrcKey && $50b1014c3566ce09$var$maskSrcKey in func;
}
var $50b1014c3566ce09$export$2e2bcd8739ae039 = $50b1014c3566ce09$var$isMasked;

});
parcelRegister("7pFZP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $565b71cc900106b9$export$2e2bcd8739ae039; });

var $6b0HP = parcelRequire("6b0HP");
/** Used to detect overreaching core-js shims. */ var $565b71cc900106b9$var$coreJsData = (0, $6b0HP.default)['__core-js_shared__'];
var $565b71cc900106b9$export$2e2bcd8739ae039 = $565b71cc900106b9$var$coreJsData;

});


parcelRegister("aNze1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dc9cdfd068b7a73$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $7dc9cdfd068b7a73$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $7dc9cdfd068b7a73$var$funcToString = $7dc9cdfd068b7a73$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $7dc9cdfd068b7a73$var$toSource(func) {
    if (func != null) {
        try {
            return $7dc9cdfd068b7a73$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $7dc9cdfd068b7a73$export$2e2bcd8739ae039 = $7dc9cdfd068b7a73$var$toSource;

});


parcelRegister("ehRYo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a66c8527567f8985$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a66c8527567f8985$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $a66c8527567f8985$export$2e2bcd8739ae039 = $a66c8527567f8985$var$getValue;

});



parcelRegister("h2qiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c67705e808f1affe$export$2e2bcd8739ae039; });

var $3LnLU = parcelRequire("3LnLU");

var $k0KKp = parcelRequire("k0KKp");

var $7e3gZ = parcelRequire("7e3gZ");

var $fVibQ = parcelRequire("fVibQ");

var $ckEaB = parcelRequire("ckEaB");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c67705e808f1affe$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$c67705e808f1affe$var$MapCache.prototype.clear = (0, $3LnLU.default);
$c67705e808f1affe$var$MapCache.prototype['delete'] = (0, $k0KKp.default);
$c67705e808f1affe$var$MapCache.prototype.get = (0, $7e3gZ.default);
$c67705e808f1affe$var$MapCache.prototype.has = (0, $fVibQ.default);
$c67705e808f1affe$var$MapCache.prototype.set = (0, $ckEaB.default);
var $c67705e808f1affe$export$2e2bcd8739ae039 = $c67705e808f1affe$var$MapCache;

});
parcelRegister("3LnLU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bd83375a4ac189a$export$2e2bcd8739ae039; });

var $ewG0r = parcelRequire("ewG0r");

var $gGZN4 = parcelRequire("gGZN4");

var $eomsk = parcelRequire("eomsk");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $2bd83375a4ac189a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $ewG0r.default),
        'map': new ((0, $eomsk.default) || (0, $gGZN4.default)),
        'string': new (0, $ewG0r.default)
    };
}
var $2bd83375a4ac189a$export$2e2bcd8739ae039 = $2bd83375a4ac189a$var$mapCacheClear;

});
parcelRegister("ewG0r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a934a364feb1c8a7$export$2e2bcd8739ae039; });

var $5pAaQ = parcelRequire("5pAaQ");

var $ebF1H = parcelRequire("ebF1H");

var $jiDpK = parcelRequire("jiDpK");

var $6U74H = parcelRequire("6U74H");

var $81V7L = parcelRequire("81V7L");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a934a364feb1c8a7$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$a934a364feb1c8a7$var$Hash.prototype.clear = (0, $5pAaQ.default);
$a934a364feb1c8a7$var$Hash.prototype['delete'] = (0, $ebF1H.default);
$a934a364feb1c8a7$var$Hash.prototype.get = (0, $jiDpK.default);
$a934a364feb1c8a7$var$Hash.prototype.has = (0, $6U74H.default);
$a934a364feb1c8a7$var$Hash.prototype.set = (0, $81V7L.default);
var $a934a364feb1c8a7$export$2e2bcd8739ae039 = $a934a364feb1c8a7$var$Hash;

});
parcelRegister("5pAaQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f0b58f04e0774b4$export$2e2bcd8739ae039; });

var $hggw2 = parcelRequire("hggw2");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3f0b58f04e0774b4$var$hashClear() {
    this.__data__ = (0, $hggw2.default) ? (0, $hggw2.default)(null) : {};
    this.size = 0;
}
var $3f0b58f04e0774b4$export$2e2bcd8739ae039 = $3f0b58f04e0774b4$var$hashClear;

});
parcelRegister("hggw2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c910bdf6d1c40b1a$export$2e2bcd8739ae039; });

var $k1ULd = parcelRequire("k1ULd");
/* Built-in method references that are verified to be native. */ var $c910bdf6d1c40b1a$var$nativeCreate = (0, $k1ULd.default)(Object, 'create');
var $c910bdf6d1c40b1a$export$2e2bcd8739ae039 = $c910bdf6d1c40b1a$var$nativeCreate;

});


parcelRegister("ebF1H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a541eac3a3613b70$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a541eac3a3613b70$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $a541eac3a3613b70$export$2e2bcd8739ae039 = $a541eac3a3613b70$var$hashDelete;

});

parcelRegister("jiDpK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0ce45994ea55bc3$export$2e2bcd8739ae039; });

var $hggw2 = parcelRequire("hggw2");
/** Used to stand-in for `undefined` hash values. */ var $e0ce45994ea55bc3$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $e0ce45994ea55bc3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e0ce45994ea55bc3$var$hasOwnProperty = $e0ce45994ea55bc3$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e0ce45994ea55bc3$var$hashGet(key) {
    var data = this.__data__;
    if (0, $hggw2.default) {
        var result = data[key];
        return result === $e0ce45994ea55bc3$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e0ce45994ea55bc3$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $e0ce45994ea55bc3$export$2e2bcd8739ae039 = $e0ce45994ea55bc3$var$hashGet;

});

parcelRegister("6U74H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $506d75f27bd65f47$export$2e2bcd8739ae039; });

var $hggw2 = parcelRequire("hggw2");
/** Used for built-in method references. */ var $506d75f27bd65f47$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $506d75f27bd65f47$var$hasOwnProperty = $506d75f27bd65f47$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $506d75f27bd65f47$var$hashHas(key) {
    var data = this.__data__;
    return (0, $hggw2.default) ? data[key] !== undefined : $506d75f27bd65f47$var$hasOwnProperty.call(data, key);
}
var $506d75f27bd65f47$export$2e2bcd8739ae039 = $506d75f27bd65f47$var$hashHas;

});

parcelRegister("81V7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d8aba6340f6dcd5$export$2e2bcd8739ae039; });

var $hggw2 = parcelRequire("hggw2");
/** Used to stand-in for `undefined` hash values. */ var $5d8aba6340f6dcd5$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5d8aba6340f6dcd5$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $hggw2.default) && value === undefined ? $5d8aba6340f6dcd5$var$HASH_UNDEFINED : value;
    return this;
}
var $5d8aba6340f6dcd5$export$2e2bcd8739ae039 = $5d8aba6340f6dcd5$var$hashSet;

});



parcelRegister("k0KKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91811d1c23647aa$export$2e2bcd8739ae039; });

var $d5sq8 = parcelRequire("d5sq8");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e91811d1c23647aa$var$mapCacheDelete(key) {
    var result = (0, $d5sq8.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $e91811d1c23647aa$export$2e2bcd8739ae039 = $e91811d1c23647aa$var$mapCacheDelete;

});
parcelRegister("d5sq8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9871c9b61de8288c$export$2e2bcd8739ae039; });

var $djNf3 = parcelRequire("djNf3");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $9871c9b61de8288c$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $djNf3.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $9871c9b61de8288c$export$2e2bcd8739ae039 = $9871c9b61de8288c$var$getMapData;

});
parcelRegister("djNf3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b233f18420acdfd$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $9b233f18420acdfd$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $9b233f18420acdfd$export$2e2bcd8739ae039 = $9b233f18420acdfd$var$isKeyable;

});



parcelRegister("7e3gZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $542c6126d928d43b$export$2e2bcd8739ae039; });

var $d5sq8 = parcelRequire("d5sq8");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $542c6126d928d43b$var$mapCacheGet(key) {
    return (0, $d5sq8.default)(this, key).get(key);
}
var $542c6126d928d43b$export$2e2bcd8739ae039 = $542c6126d928d43b$var$mapCacheGet;

});

parcelRegister("fVibQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b97a4a0bdc7a5ca1$export$2e2bcd8739ae039; });

var $d5sq8 = parcelRequire("d5sq8");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b97a4a0bdc7a5ca1$var$mapCacheHas(key) {
    return (0, $d5sq8.default)(this, key).has(key);
}
var $b97a4a0bdc7a5ca1$export$2e2bcd8739ae039 = $b97a4a0bdc7a5ca1$var$mapCacheHas;

});

parcelRegister("ckEaB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa6833351d717d1$export$2e2bcd8739ae039; });

var $d5sq8 = parcelRequire("d5sq8");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $8fa6833351d717d1$var$mapCacheSet(key, value) {
    var data = (0, $d5sq8.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $8fa6833351d717d1$export$2e2bcd8739ae039 = $8fa6833351d717d1$var$mapCacheSet;

});




parcelRegister("bRIKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a375b225a42bd01$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $8a375b225a42bd01$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $8a375b225a42bd01$export$2e2bcd8739ae039 = $8a375b225a42bd01$var$arrayEach;

});

parcelRegister("fOspi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8318f94e486ba7b$export$2e2bcd8739ae039; });

var $gV8Jg = parcelRequire("gV8Jg");

var $4Dk8a = parcelRequire("4Dk8a");
/** Used for built-in method references. */ var $b8318f94e486ba7b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b8318f94e486ba7b$var$hasOwnProperty = $b8318f94e486ba7b$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b8318f94e486ba7b$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($b8318f94e486ba7b$var$hasOwnProperty.call(object, key) && (0, $4Dk8a.default)(objValue, value)) || value === undefined && !(key in object)) (0, $gV8Jg.default)(object, key, value);
}
var $b8318f94e486ba7b$export$2e2bcd8739ae039 = $b8318f94e486ba7b$var$assignValue;

});
parcelRegister("gV8Jg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c518bda3e1817505$export$2e2bcd8739ae039; });

var $8VDbq = parcelRequire("8VDbq");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c518bda3e1817505$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $8VDbq.default)) (0, $8VDbq.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $c518bda3e1817505$export$2e2bcd8739ae039 = $c518bda3e1817505$var$baseAssignValue;

});
parcelRegister("8VDbq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68020a97325090d6$export$2e2bcd8739ae039; });

var $k1ULd = parcelRequire("k1ULd");
var $68020a97325090d6$var$defineProperty = function() {
    try {
        var func = (0, $k1ULd.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $68020a97325090d6$export$2e2bcd8739ae039 = $68020a97325090d6$var$defineProperty;

});



parcelRegister("1K5OC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $144e99286c728571$export$2e2bcd8739ae039; });

var $kHBgA = parcelRequire("kHBgA");

var $6Fo7W = parcelRequire("6Fo7W");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $144e99286c728571$var$baseAssign(object, source) {
    return object && (0, $kHBgA.default)(source, (0, $6Fo7W.default)(source), object);
}
var $144e99286c728571$export$2e2bcd8739ae039 = $144e99286c728571$var$baseAssign;

});
parcelRegister("kHBgA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f124bb26d821cb91$export$2e2bcd8739ae039; });

var $fOspi = parcelRequire("fOspi");

var $gV8Jg = parcelRequire("gV8Jg");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $f124bb26d821cb91$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $gV8Jg.default)(object, key, newValue);
        else (0, $fOspi.default)(object, key, newValue);
    }
    return object;
}
var $f124bb26d821cb91$export$2e2bcd8739ae039 = $f124bb26d821cb91$var$copyObject;

});

parcelRegister("6Fo7W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4da9498c02838d8d$export$2e2bcd8739ae039; });

var $01zks = parcelRequire("01zks");

var $8JmU6 = parcelRequire("8JmU6");

var $cwIzW = parcelRequire("cwIzW");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $4da9498c02838d8d$var$keys(object) {
    return (0, $cwIzW.default)(object) ? (0, $01zks.default)(object) : (0, $8JmU6.default)(object);
}
var $4da9498c02838d8d$export$2e2bcd8739ae039 = $4da9498c02838d8d$var$keys;

});
parcelRegister("01zks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $004b7fb22a7334e5$export$2e2bcd8739ae039; });

var $kzzzj = parcelRequire("kzzzj");

var $7xvvS = parcelRequire("7xvvS");

var $fSMeh = parcelRequire("fSMeh");

var $4eEda = parcelRequire("4eEda");

var $9Z42u = parcelRequire("9Z42u");

var $eDOtb = parcelRequire("eDOtb");
/** Used for built-in method references. */ var $004b7fb22a7334e5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $004b7fb22a7334e5$var$hasOwnProperty = $004b7fb22a7334e5$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $004b7fb22a7334e5$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $fSMeh.default)(value), isArg = !isArr && (0, $7xvvS.default)(value), isBuff = !isArr && !isArg && (0, $4eEda.default)(value), isType = !isArr && !isArg && !isBuff && (0, $eDOtb.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $kzzzj.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $004b7fb22a7334e5$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $9Z42u.default)(key, length)))) result.push(key);
    return result;
}
var $004b7fb22a7334e5$export$2e2bcd8739ae039 = $004b7fb22a7334e5$var$arrayLikeKeys;

});
parcelRegister("kzzzj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efa2aab8478c82b3$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $efa2aab8478c82b3$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $efa2aab8478c82b3$export$2e2bcd8739ae039 = $efa2aab8478c82b3$var$baseTimes;

});

parcelRegister("7xvvS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d40f53086f2fc5$export$2e2bcd8739ae039; });

var $1WMp9 = parcelRequire("1WMp9");

var $4JGW3 = parcelRequire("4JGW3");
/** Used for built-in method references. */ var $57d40f53086f2fc5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $57d40f53086f2fc5$var$hasOwnProperty = $57d40f53086f2fc5$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $57d40f53086f2fc5$var$propertyIsEnumerable = $57d40f53086f2fc5$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $57d40f53086f2fc5$var$isArguments = (0, $1WMp9.default)(function() {
    return arguments;
}()) ? (0, $1WMp9.default) : function(value) {
    return (0, $4JGW3.default)(value) && $57d40f53086f2fc5$var$hasOwnProperty.call(value, 'callee') && !$57d40f53086f2fc5$var$propertyIsEnumerable.call(value, 'callee');
};
var $57d40f53086f2fc5$export$2e2bcd8739ae039 = $57d40f53086f2fc5$var$isArguments;

});
parcelRegister("1WMp9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16b0c1649942af96$export$2e2bcd8739ae039; });

var $89LaC = parcelRequire("89LaC");

var $4JGW3 = parcelRequire("4JGW3");
/** `Object#toString` result references. */ var $16b0c1649942af96$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $16b0c1649942af96$var$baseIsArguments(value) {
    return (0, $4JGW3.default)(value) && (0, $89LaC.default)(value) == $16b0c1649942af96$var$argsTag;
}
var $16b0c1649942af96$export$2e2bcd8739ae039 = $16b0c1649942af96$var$baseIsArguments;

});


parcelRegister("fSMeh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9014f80dc4a1d65$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b9014f80dc4a1d65$var$isArray = Array.isArray;
var $b9014f80dc4a1d65$export$2e2bcd8739ae039 = $b9014f80dc4a1d65$var$isArray;

});

parcelRegister("4eEda", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3157a961886b9c7e$export$2e2bcd8739ae039; });

var $6b0HP = parcelRequire("6b0HP");

var $fPB23 = parcelRequire("fPB23");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6b0HP.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $fPB23.default);
var $3157a961886b9c7e$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("fPB23", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b868583956756513$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b868583956756513$var$stubFalse() {
    return false;
}
var $b868583956756513$export$2e2bcd8739ae039 = $b868583956756513$var$stubFalse;

});


parcelRegister("9Z42u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $744cf1abd401134a$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $744cf1abd401134a$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $744cf1abd401134a$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $744cf1abd401134a$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $744cf1abd401134a$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $744cf1abd401134a$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $744cf1abd401134a$export$2e2bcd8739ae039 = $744cf1abd401134a$var$isIndex;

});

parcelRegister("eDOtb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa8bdb6a260fe85d$export$2e2bcd8739ae039; });

var $1Bbxn = parcelRequire("1Bbxn");

var $8Z3lk = parcelRequire("8Z3lk");

var $LTQVD = parcelRequire("LTQVD");
/* Node.js helper references. */ var $aa8bdb6a260fe85d$var$nodeIsTypedArray = (0, $LTQVD.default) && (0, $LTQVD.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $aa8bdb6a260fe85d$var$isTypedArray = $aa8bdb6a260fe85d$var$nodeIsTypedArray ? (0, $8Z3lk.default)($aa8bdb6a260fe85d$var$nodeIsTypedArray) : (0, $1Bbxn.default);
var $aa8bdb6a260fe85d$export$2e2bcd8739ae039 = $aa8bdb6a260fe85d$var$isTypedArray;

});
parcelRegister("1Bbxn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12a23234112f564f$export$2e2bcd8739ae039; });

var $89LaC = parcelRequire("89LaC");

var $3VZFO = parcelRequire("3VZFO");

var $4JGW3 = parcelRequire("4JGW3");
/** `Object#toString` result references. */ var $12a23234112f564f$var$argsTag = '[object Arguments]', $12a23234112f564f$var$arrayTag = '[object Array]', $12a23234112f564f$var$boolTag = '[object Boolean]', $12a23234112f564f$var$dateTag = '[object Date]', $12a23234112f564f$var$errorTag = '[object Error]', $12a23234112f564f$var$funcTag = '[object Function]', $12a23234112f564f$var$mapTag = '[object Map]', $12a23234112f564f$var$numberTag = '[object Number]', $12a23234112f564f$var$objectTag = '[object Object]', $12a23234112f564f$var$regexpTag = '[object RegExp]', $12a23234112f564f$var$setTag = '[object Set]', $12a23234112f564f$var$stringTag = '[object String]', $12a23234112f564f$var$weakMapTag = '[object WeakMap]';
var $12a23234112f564f$var$arrayBufferTag = '[object ArrayBuffer]', $12a23234112f564f$var$dataViewTag = '[object DataView]', $12a23234112f564f$var$float32Tag = '[object Float32Array]', $12a23234112f564f$var$float64Tag = '[object Float64Array]', $12a23234112f564f$var$int8Tag = '[object Int8Array]', $12a23234112f564f$var$int16Tag = '[object Int16Array]', $12a23234112f564f$var$int32Tag = '[object Int32Array]', $12a23234112f564f$var$uint8Tag = '[object Uint8Array]', $12a23234112f564f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $12a23234112f564f$var$uint16Tag = '[object Uint16Array]', $12a23234112f564f$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $12a23234112f564f$var$typedArrayTags = {};
$12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$float32Tag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$float64Tag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$int8Tag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$int16Tag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$int32Tag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$uint8Tag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$uint8ClampedTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$uint16Tag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$uint32Tag] = true;
$12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$argsTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$arrayTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$arrayBufferTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$boolTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$dataViewTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$dateTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$errorTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$funcTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$mapTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$numberTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$objectTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$regexpTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$setTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$stringTag] = $12a23234112f564f$var$typedArrayTags[$12a23234112f564f$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $12a23234112f564f$var$baseIsTypedArray(value) {
    return (0, $4JGW3.default)(value) && (0, $3VZFO.default)(value.length) && !!$12a23234112f564f$var$typedArrayTags[(0, $89LaC.default)(value)];
}
var $12a23234112f564f$export$2e2bcd8739ae039 = $12a23234112f564f$var$baseIsTypedArray;

});
parcelRegister("3VZFO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dd689076f4b4047$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $2dd689076f4b4047$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $2dd689076f4b4047$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $2dd689076f4b4047$var$MAX_SAFE_INTEGER;
}
var $2dd689076f4b4047$export$2e2bcd8739ae039 = $2dd689076f4b4047$var$isLength;

});


parcelRegister("8Z3lk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68a69d1a0773388e$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $68a69d1a0773388e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $68a69d1a0773388e$export$2e2bcd8739ae039 = $68a69d1a0773388e$var$baseUnary;

});

parcelRegister("LTQVD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ffb714d655c4aa$export$2e2bcd8739ae039; });

var $jvlpt = parcelRequire("jvlpt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $jvlpt.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $08ffb714d655c4aa$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("8JmU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b44aee828265f7$export$2e2bcd8739ae039; });

var $6zc6Q = parcelRequire("6zc6Q");

var $MNK83 = parcelRequire("MNK83");
/** Used for built-in method references. */ var $65b44aee828265f7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $65b44aee828265f7$var$hasOwnProperty = $65b44aee828265f7$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $65b44aee828265f7$var$baseKeys(object) {
    if (!(0, $6zc6Q.default)(object)) return (0, $MNK83.default)(object);
    var result = [];
    for(var key in Object(object))if ($65b44aee828265f7$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $65b44aee828265f7$export$2e2bcd8739ae039 = $65b44aee828265f7$var$baseKeys;

});
parcelRegister("6zc6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c7f679c434906c9$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $4c7f679c434906c9$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $4c7f679c434906c9$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $4c7f679c434906c9$var$objectProto;
    return value === proto;
}
var $4c7f679c434906c9$export$2e2bcd8739ae039 = $4c7f679c434906c9$var$isPrototype;

});

parcelRegister("MNK83", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $092b11bc66669a84$export$2e2bcd8739ae039; });

var $ky7W8 = parcelRequire("ky7W8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $092b11bc66669a84$var$nativeKeys = (0, $ky7W8.default)(Object.keys, Object);
var $092b11bc66669a84$export$2e2bcd8739ae039 = $092b11bc66669a84$var$nativeKeys;

});


parcelRegister("cwIzW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91eb0d9baaa55f95$export$2e2bcd8739ae039; });

var $8CdiG = parcelRequire("8CdiG");

var $3VZFO = parcelRequire("3VZFO");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $91eb0d9baaa55f95$var$isArrayLike(value) {
    return value != null && (0, $3VZFO.default)(value.length) && !(0, $8CdiG.default)(value);
}
var $91eb0d9baaa55f95$export$2e2bcd8739ae039 = $91eb0d9baaa55f95$var$isArrayLike;

});



parcelRegister("F3oQn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07b6778f892934c5$export$2e2bcd8739ae039; });

var $kHBgA = parcelRequire("kHBgA");

var $f6GF3 = parcelRequire("f6GF3");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $07b6778f892934c5$var$baseAssignIn(object, source) {
    return object && (0, $kHBgA.default)(source, (0, $f6GF3.default)(source), object);
}
var $07b6778f892934c5$export$2e2bcd8739ae039 = $07b6778f892934c5$var$baseAssignIn;

});
parcelRegister("f6GF3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aff88226f734d9db$export$2e2bcd8739ae039; });

var $01zks = parcelRequire("01zks");

var $d8SLH = parcelRequire("d8SLH");

var $cwIzW = parcelRequire("cwIzW");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $aff88226f734d9db$var$keysIn(object) {
    return (0, $cwIzW.default)(object) ? (0, $01zks.default)(object, true) : (0, $d8SLH.default)(object);
}
var $aff88226f734d9db$export$2e2bcd8739ae039 = $aff88226f734d9db$var$keysIn;

});
parcelRegister("d8SLH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99168193e7fdd5fc$export$2e2bcd8739ae039; });

var $4T3my = parcelRequire("4T3my");

var $6zc6Q = parcelRequire("6zc6Q");

var $3nfcJ = parcelRequire("3nfcJ");
/** Used for built-in method references. */ var $99168193e7fdd5fc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $99168193e7fdd5fc$var$hasOwnProperty = $99168193e7fdd5fc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $99168193e7fdd5fc$var$baseKeysIn(object) {
    if (!(0, $4T3my.default)(object)) return (0, $3nfcJ.default)(object);
    var isProto = (0, $6zc6Q.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$99168193e7fdd5fc$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $99168193e7fdd5fc$export$2e2bcd8739ae039 = $99168193e7fdd5fc$var$baseKeysIn;

});
parcelRegister("3nfcJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274f50562b192b51$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $274f50562b192b51$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $274f50562b192b51$export$2e2bcd8739ae039 = $274f50562b192b51$var$nativeKeysIn;

});




parcelRegister("57J06", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bb08364190e585a$export$2e2bcd8739ae039; });

var $6b0HP = parcelRequire("6b0HP");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6b0HP.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $3bb08364190e585a$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("9XLAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $740e8ac000f61d1e$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $740e8ac000f61d1e$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $740e8ac000f61d1e$export$2e2bcd8739ae039 = $740e8ac000f61d1e$var$copyArray;

});

parcelRegister("e80FB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a492551bd3cba3d1$export$2e2bcd8739ae039; });

var $kHBgA = parcelRequire("kHBgA");

var $69tGV = parcelRequire("69tGV");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $a492551bd3cba3d1$var$copySymbols(source, object) {
    return (0, $kHBgA.default)(source, (0, $69tGV.default)(source), object);
}
var $a492551bd3cba3d1$export$2e2bcd8739ae039 = $a492551bd3cba3d1$var$copySymbols;

});
parcelRegister("69tGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47aa9d72a2506657$export$2e2bcd8739ae039; });

var $iQsM1 = parcelRequire("iQsM1");

var $3uOTM = parcelRequire("3uOTM");
/** Used for built-in method references. */ var $47aa9d72a2506657$var$objectProto = Object.prototype;
/** Built-in value references. */ var $47aa9d72a2506657$var$propertyIsEnumerable = $47aa9d72a2506657$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $47aa9d72a2506657$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $47aa9d72a2506657$var$getSymbols = !$47aa9d72a2506657$var$nativeGetSymbols ? (0, $3uOTM.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $iQsM1.default)($47aa9d72a2506657$var$nativeGetSymbols(object), function(symbol) {
        return $47aa9d72a2506657$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $47aa9d72a2506657$export$2e2bcd8739ae039 = $47aa9d72a2506657$var$getSymbols;

});
parcelRegister("iQsM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db83672410d2cc6c$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $db83672410d2cc6c$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $db83672410d2cc6c$export$2e2bcd8739ae039 = $db83672410d2cc6c$var$arrayFilter;

});

parcelRegister("3uOTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28bba7dcb9b7924d$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $28bba7dcb9b7924d$var$stubArray() {
    return [];
}
var $28bba7dcb9b7924d$export$2e2bcd8739ae039 = $28bba7dcb9b7924d$var$stubArray;

});



parcelRegister("TRcjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a7e671a10f65d0e$export$2e2bcd8739ae039; });

var $kHBgA = parcelRequire("kHBgA");

var $9H0Pe = parcelRequire("9H0Pe");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $0a7e671a10f65d0e$var$copySymbolsIn(source, object) {
    return (0, $kHBgA.default)(source, (0, $9H0Pe.default)(source), object);
}
var $0a7e671a10f65d0e$export$2e2bcd8739ae039 = $0a7e671a10f65d0e$var$copySymbolsIn;

});
parcelRegister("9H0Pe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70e8c51c8ff558e7$export$2e2bcd8739ae039; });

var $5KvxJ = parcelRequire("5KvxJ");

var $lGQMZ = parcelRequire("lGQMZ");

var $69tGV = parcelRequire("69tGV");

var $3uOTM = parcelRequire("3uOTM");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $70e8c51c8ff558e7$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $70e8c51c8ff558e7$var$getSymbolsIn = !$70e8c51c8ff558e7$var$nativeGetSymbols ? (0, $3uOTM.default) : function(object) {
    var result = [];
    while(object){
        (0, $5KvxJ.default)(result, (0, $69tGV.default)(object));
        object = (0, $lGQMZ.default)(object);
    }
    return result;
};
var $70e8c51c8ff558e7$export$2e2bcd8739ae039 = $70e8c51c8ff558e7$var$getSymbolsIn;

});
parcelRegister("5KvxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42f9b76fac59b47a$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $42f9b76fac59b47a$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $42f9b76fac59b47a$export$2e2bcd8739ae039 = $42f9b76fac59b47a$var$arrayPush;

});



parcelRegister("icXyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $036bbc0b07bc121b$export$2e2bcd8739ae039; });

var $9dmKy = parcelRequire("9dmKy");

var $69tGV = parcelRequire("69tGV");

var $6Fo7W = parcelRequire("6Fo7W");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $036bbc0b07bc121b$var$getAllKeys(object) {
    return (0, $9dmKy.default)(object, (0, $6Fo7W.default), (0, $69tGV.default));
}
var $036bbc0b07bc121b$export$2e2bcd8739ae039 = $036bbc0b07bc121b$var$getAllKeys;

});
parcelRegister("9dmKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b56f9967ea46f08$export$2e2bcd8739ae039; });

var $5KvxJ = parcelRequire("5KvxJ");

var $fSMeh = parcelRequire("fSMeh");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6b56f9967ea46f08$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $fSMeh.default)(object) ? result : (0, $5KvxJ.default)(result, symbolsFunc(object));
}
var $6b56f9967ea46f08$export$2e2bcd8739ae039 = $6b56f9967ea46f08$var$baseGetAllKeys;

});


parcelRegister("8780u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e853033909551d7$export$2e2bcd8739ae039; });

var $9dmKy = parcelRequire("9dmKy");

var $9H0Pe = parcelRequire("9H0Pe");

var $f6GF3 = parcelRequire("f6GF3");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5e853033909551d7$var$getAllKeysIn(object) {
    return (0, $9dmKy.default)(object, (0, $f6GF3.default), (0, $9H0Pe.default));
}
var $5e853033909551d7$export$2e2bcd8739ae039 = $5e853033909551d7$var$getAllKeysIn;

});

parcelRegister("jjZbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e10f418881297b59$export$2e2bcd8739ae039; });

var $fGfD9 = parcelRequire("fGfD9");

var $eomsk = parcelRequire("eomsk");

var $7IlQL = parcelRequire("7IlQL");

var $4ohtN = parcelRequire("4ohtN");

var $76Ayb = parcelRequire("76Ayb");

var $89LaC = parcelRequire("89LaC");

var $aNze1 = parcelRequire("aNze1");
/** `Object#toString` result references. */ var $e10f418881297b59$var$mapTag = '[object Map]', $e10f418881297b59$var$objectTag = '[object Object]', $e10f418881297b59$var$promiseTag = '[object Promise]', $e10f418881297b59$var$setTag = '[object Set]', $e10f418881297b59$var$weakMapTag = '[object WeakMap]';
var $e10f418881297b59$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $e10f418881297b59$var$dataViewCtorString = (0, $aNze1.default)((0, $fGfD9.default)), $e10f418881297b59$var$mapCtorString = (0, $aNze1.default)((0, $eomsk.default)), $e10f418881297b59$var$promiseCtorString = (0, $aNze1.default)((0, $7IlQL.default)), $e10f418881297b59$var$setCtorString = (0, $aNze1.default)((0, $4ohtN.default)), $e10f418881297b59$var$weakMapCtorString = (0, $aNze1.default)((0, $76Ayb.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $e10f418881297b59$var$getTag = (0, $89LaC.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $fGfD9.default) && $e10f418881297b59$var$getTag(new (0, $fGfD9.default)(new ArrayBuffer(1))) != $e10f418881297b59$var$dataViewTag || (0, $eomsk.default) && $e10f418881297b59$var$getTag(new (0, $eomsk.default)) != $e10f418881297b59$var$mapTag || (0, $7IlQL.default) && $e10f418881297b59$var$getTag((0, $7IlQL.default).resolve()) != $e10f418881297b59$var$promiseTag || (0, $4ohtN.default) && $e10f418881297b59$var$getTag(new (0, $4ohtN.default)) != $e10f418881297b59$var$setTag || (0, $76Ayb.default) && $e10f418881297b59$var$getTag(new (0, $76Ayb.default)) != $e10f418881297b59$var$weakMapTag) $e10f418881297b59$var$getTag = function(value) {
    var result = (0, $89LaC.default)(value), Ctor = result == $e10f418881297b59$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $aNze1.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $e10f418881297b59$var$dataViewCtorString:
            return $e10f418881297b59$var$dataViewTag;
        case $e10f418881297b59$var$mapCtorString:
            return $e10f418881297b59$var$mapTag;
        case $e10f418881297b59$var$promiseCtorString:
            return $e10f418881297b59$var$promiseTag;
        case $e10f418881297b59$var$setCtorString:
            return $e10f418881297b59$var$setTag;
        case $e10f418881297b59$var$weakMapCtorString:
            return $e10f418881297b59$var$weakMapTag;
    }
    return result;
};
var $e10f418881297b59$export$2e2bcd8739ae039 = $e10f418881297b59$var$getTag;

});
parcelRegister("fGfD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6a6e72452c9d553$export$2e2bcd8739ae039; });

var $k1ULd = parcelRequire("k1ULd");

var $6b0HP = parcelRequire("6b0HP");
/* Built-in method references that are verified to be native. */ var $b6a6e72452c9d553$var$DataView = (0, $k1ULd.default)((0, $6b0HP.default), 'DataView');
var $b6a6e72452c9d553$export$2e2bcd8739ae039 = $b6a6e72452c9d553$var$DataView;

});

parcelRegister("7IlQL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59dd97703e1ecb10$export$2e2bcd8739ae039; });

var $k1ULd = parcelRequire("k1ULd");

var $6b0HP = parcelRequire("6b0HP");
/* Built-in method references that are verified to be native. */ var $59dd97703e1ecb10$var$Promise = (0, $k1ULd.default)((0, $6b0HP.default), 'Promise');
var $59dd97703e1ecb10$export$2e2bcd8739ae039 = $59dd97703e1ecb10$var$Promise;

});

parcelRegister("4ohtN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3326f660d46224eb$export$2e2bcd8739ae039; });

var $k1ULd = parcelRequire("k1ULd");

var $6b0HP = parcelRequire("6b0HP");
/* Built-in method references that are verified to be native. */ var $3326f660d46224eb$var$Set = (0, $k1ULd.default)((0, $6b0HP.default), 'Set');
var $3326f660d46224eb$export$2e2bcd8739ae039 = $3326f660d46224eb$var$Set;

});

parcelRegister("76Ayb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52c572164de2dd1b$export$2e2bcd8739ae039; });

var $k1ULd = parcelRequire("k1ULd");

var $6b0HP = parcelRequire("6b0HP");
/* Built-in method references that are verified to be native. */ var $52c572164de2dd1b$var$WeakMap = (0, $k1ULd.default)((0, $6b0HP.default), 'WeakMap');
var $52c572164de2dd1b$export$2e2bcd8739ae039 = $52c572164de2dd1b$var$WeakMap;

});


parcelRegister("5MyLr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $435c66e7d450ca79$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $435c66e7d450ca79$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $435c66e7d450ca79$var$hasOwnProperty = $435c66e7d450ca79$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $435c66e7d450ca79$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $435c66e7d450ca79$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $435c66e7d450ca79$export$2e2bcd8739ae039 = $435c66e7d450ca79$var$initCloneArray;

});

parcelRegister("fS48y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8df1bacfaed4e72$export$2e2bcd8739ae039; });

var $aC26o = parcelRequire("aC26o");

var $kJApV = parcelRequire("kJApV");

var $7nDL9 = parcelRequire("7nDL9");

var $9aNA5 = parcelRequire("9aNA5");

var $MPD8U = parcelRequire("MPD8U");
/** `Object#toString` result references. */ var $b8df1bacfaed4e72$var$boolTag = '[object Boolean]', $b8df1bacfaed4e72$var$dateTag = '[object Date]', $b8df1bacfaed4e72$var$mapTag = '[object Map]', $b8df1bacfaed4e72$var$numberTag = '[object Number]', $b8df1bacfaed4e72$var$regexpTag = '[object RegExp]', $b8df1bacfaed4e72$var$setTag = '[object Set]', $b8df1bacfaed4e72$var$stringTag = '[object String]', $b8df1bacfaed4e72$var$symbolTag = '[object Symbol]';
var $b8df1bacfaed4e72$var$arrayBufferTag = '[object ArrayBuffer]', $b8df1bacfaed4e72$var$dataViewTag = '[object DataView]', $b8df1bacfaed4e72$var$float32Tag = '[object Float32Array]', $b8df1bacfaed4e72$var$float64Tag = '[object Float64Array]', $b8df1bacfaed4e72$var$int8Tag = '[object Int8Array]', $b8df1bacfaed4e72$var$int16Tag = '[object Int16Array]', $b8df1bacfaed4e72$var$int32Tag = '[object Int32Array]', $b8df1bacfaed4e72$var$uint8Tag = '[object Uint8Array]', $b8df1bacfaed4e72$var$uint8ClampedTag = '[object Uint8ClampedArray]', $b8df1bacfaed4e72$var$uint16Tag = '[object Uint16Array]', $b8df1bacfaed4e72$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $b8df1bacfaed4e72$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $b8df1bacfaed4e72$var$arrayBufferTag:
            return (0, $aC26o.default)(object);
        case $b8df1bacfaed4e72$var$boolTag:
        case $b8df1bacfaed4e72$var$dateTag:
            return new Ctor(+object);
        case $b8df1bacfaed4e72$var$dataViewTag:
            return (0, $kJApV.default)(object, isDeep);
        case $b8df1bacfaed4e72$var$float32Tag:
        case $b8df1bacfaed4e72$var$float64Tag:
        case $b8df1bacfaed4e72$var$int8Tag:
        case $b8df1bacfaed4e72$var$int16Tag:
        case $b8df1bacfaed4e72$var$int32Tag:
        case $b8df1bacfaed4e72$var$uint8Tag:
        case $b8df1bacfaed4e72$var$uint8ClampedTag:
        case $b8df1bacfaed4e72$var$uint16Tag:
        case $b8df1bacfaed4e72$var$uint32Tag:
            return (0, $MPD8U.default)(object, isDeep);
        case $b8df1bacfaed4e72$var$mapTag:
            return new Ctor;
        case $b8df1bacfaed4e72$var$numberTag:
        case $b8df1bacfaed4e72$var$stringTag:
            return new Ctor(object);
        case $b8df1bacfaed4e72$var$regexpTag:
            return (0, $7nDL9.default)(object);
        case $b8df1bacfaed4e72$var$setTag:
            return new Ctor;
        case $b8df1bacfaed4e72$var$symbolTag:
            return (0, $9aNA5.default)(object);
    }
}
var $b8df1bacfaed4e72$export$2e2bcd8739ae039 = $b8df1bacfaed4e72$var$initCloneByTag;

});
parcelRegister("aC26o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b9f156f2196277b$export$2e2bcd8739ae039; });

var $jfexF = parcelRequire("jfexF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $7b9f156f2196277b$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $jfexF.default)(result).set(new (0, $jfexF.default)(arrayBuffer));
    return result;
}
var $7b9f156f2196277b$export$2e2bcd8739ae039 = $7b9f156f2196277b$var$cloneArrayBuffer;

});
parcelRegister("jfexF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e02ab2c0b1d145e4$export$2e2bcd8739ae039; });

var $6b0HP = parcelRequire("6b0HP");
/** Built-in value references. */ var $e02ab2c0b1d145e4$var$Uint8Array = (0, $6b0HP.default).Uint8Array;
var $e02ab2c0b1d145e4$export$2e2bcd8739ae039 = $e02ab2c0b1d145e4$var$Uint8Array;

});


parcelRegister("kJApV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1844248024a8fa4$export$2e2bcd8739ae039; });

var $aC26o = parcelRequire("aC26o");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $f1844248024a8fa4$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $aC26o.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $f1844248024a8fa4$export$2e2bcd8739ae039 = $f1844248024a8fa4$var$cloneDataView;

});

parcelRegister("7nDL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55f985c5bfadeb4d$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $55f985c5bfadeb4d$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $55f985c5bfadeb4d$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $55f985c5bfadeb4d$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $55f985c5bfadeb4d$export$2e2bcd8739ae039 = $55f985c5bfadeb4d$var$cloneRegExp;

});

parcelRegister("9aNA5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6adb8203132d40a4$export$2e2bcd8739ae039; });

var $lV3so = parcelRequire("lV3so");
/** Used to convert symbols to primitives and strings. */ var $6adb8203132d40a4$var$symbolProto = (0, $lV3so.default) ? (0, $lV3so.default).prototype : undefined, $6adb8203132d40a4$var$symbolValueOf = $6adb8203132d40a4$var$symbolProto ? $6adb8203132d40a4$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $6adb8203132d40a4$var$cloneSymbol(symbol) {
    return $6adb8203132d40a4$var$symbolValueOf ? Object($6adb8203132d40a4$var$symbolValueOf.call(symbol)) : {};
}
var $6adb8203132d40a4$export$2e2bcd8739ae039 = $6adb8203132d40a4$var$cloneSymbol;

});

parcelRegister("MPD8U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $092c88849581d209$export$2e2bcd8739ae039; });

var $aC26o = parcelRequire("aC26o");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $092c88849581d209$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $aC26o.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $092c88849581d209$export$2e2bcd8739ae039 = $092c88849581d209$var$cloneTypedArray;

});


parcelRegister("kVn2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3bb00bfa6ba7d73$export$2e2bcd8739ae039; });

var $1dtaV = parcelRequire("1dtaV");

var $lGQMZ = parcelRequire("lGQMZ");

var $6zc6Q = parcelRequire("6zc6Q");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $f3bb00bfa6ba7d73$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $6zc6Q.default)(object) ? (0, $1dtaV.default)((0, $lGQMZ.default)(object)) : {};
}
var $f3bb00bfa6ba7d73$export$2e2bcd8739ae039 = $f3bb00bfa6ba7d73$var$initCloneObject;

});
parcelRegister("1dtaV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e2da2e80e3a09dd$export$2e2bcd8739ae039; });

var $4T3my = parcelRequire("4T3my");
/** Built-in value references. */ var $0e2da2e80e3a09dd$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $0e2da2e80e3a09dd$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $4T3my.default)(proto)) return {};
        if ($0e2da2e80e3a09dd$var$objectCreate) return $0e2da2e80e3a09dd$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $0e2da2e80e3a09dd$export$2e2bcd8739ae039 = $0e2da2e80e3a09dd$var$baseCreate;

});


parcelRegister("5UPYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44ea81046a039c03$export$2e2bcd8739ae039; });

var $9HpHg = parcelRequire("9HpHg");

var $8Z3lk = parcelRequire("8Z3lk");

var $LTQVD = parcelRequire("LTQVD");
/* Node.js helper references. */ var $44ea81046a039c03$var$nodeIsMap = (0, $LTQVD.default) && (0, $LTQVD.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $44ea81046a039c03$var$isMap = $44ea81046a039c03$var$nodeIsMap ? (0, $8Z3lk.default)($44ea81046a039c03$var$nodeIsMap) : (0, $9HpHg.default);
var $44ea81046a039c03$export$2e2bcd8739ae039 = $44ea81046a039c03$var$isMap;

});
parcelRegister("9HpHg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70fc100c817c9412$export$2e2bcd8739ae039; });

var $jjZbM = parcelRequire("jjZbM");

var $4JGW3 = parcelRequire("4JGW3");
/** `Object#toString` result references. */ var $70fc100c817c9412$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $70fc100c817c9412$var$baseIsMap(value) {
    return (0, $4JGW3.default)(value) && (0, $jjZbM.default)(value) == $70fc100c817c9412$var$mapTag;
}
var $70fc100c817c9412$export$2e2bcd8739ae039 = $70fc100c817c9412$var$baseIsMap;

});


parcelRegister("98xv0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a6ed89d2fc45b27$export$2e2bcd8739ae039; });

var $3FNMs = parcelRequire("3FNMs");

var $8Z3lk = parcelRequire("8Z3lk");

var $LTQVD = parcelRequire("LTQVD");
/* Node.js helper references. */ var $6a6ed89d2fc45b27$var$nodeIsSet = (0, $LTQVD.default) && (0, $LTQVD.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $6a6ed89d2fc45b27$var$isSet = $6a6ed89d2fc45b27$var$nodeIsSet ? (0, $8Z3lk.default)($6a6ed89d2fc45b27$var$nodeIsSet) : (0, $3FNMs.default);
var $6a6ed89d2fc45b27$export$2e2bcd8739ae039 = $6a6ed89d2fc45b27$var$isSet;

});
parcelRegister("3FNMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2acbd0d1037650b3$export$2e2bcd8739ae039; });

var $jjZbM = parcelRequire("jjZbM");

var $4JGW3 = parcelRequire("4JGW3");
/** `Object#toString` result references. */ var $2acbd0d1037650b3$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $2acbd0d1037650b3$var$baseIsSet(value) {
    return (0, $4JGW3.default)(value) && (0, $jjZbM.default)(value) == $2acbd0d1037650b3$var$setTag;
}
var $2acbd0d1037650b3$export$2e2bcd8739ae039 = $2acbd0d1037650b3$var$baseIsSet;

});




parcelRegister("8Rg0Z", function(module, exports) {
'use strict';
var $01aa0f42f590ce2e$var$isArray = Array.isArray;
var $01aa0f42f590ce2e$var$keyList = Object.keys;
var $01aa0f42f590ce2e$var$hasProp = Object.prototype.hasOwnProperty;
var $01aa0f42f590ce2e$var$hasElementType = typeof Element !== 'undefined';
function $01aa0f42f590ce2e$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $01aa0f42f590ce2e$var$isArray(a), arrB = $01aa0f42f590ce2e$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$01aa0f42f590ce2e$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $01aa0f42f590ce2e$var$keyList(a);
        length = keys.length;
        if (length !== $01aa0f42f590ce2e$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$01aa0f42f590ce2e$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($01aa0f42f590ce2e$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$01aa0f42f590ce2e$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $01aa0f42f590ce2e$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("kQLuK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2dd8178cae2bee2$export$2e2bcd8739ae039; });
var $f2dd8178cae2bee2$var$isProduction = true;
function $f2dd8178cae2bee2$var$warning(condition, message) {
    if (!$f2dd8178cae2bee2$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $f2dd8178cae2bee2$export$2e2bcd8739ae039 = $f2dd8178cae2bee2$var$warning;

});

parcelRegister("dfYuL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a6b9a2a188ba4c2$export$2e2bcd8739ae039; });

var $7BcOh = parcelRequire("7BcOh");
/** Used to compose bitmasks for cloning. */ var $9a6b9a2a188ba4c2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $9a6b9a2a188ba4c2$var$clone(value) {
    return (0, $7BcOh.default)(value, $9a6b9a2a188ba4c2$var$CLONE_SYMBOLS_FLAG);
}
var $9a6b9a2a188ba4c2$export$2e2bcd8739ae039 = $9a6b9a2a188ba4c2$var$clone;

});

parcelRegister("678YX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $473a5d35239efcca$export$2e2bcd8739ae039; });

var $iStCw = parcelRequire("iStCw");

var $9XLAP = parcelRequire("9XLAP");

var $fSMeh = parcelRequire("fSMeh");

var $9PlPZ = parcelRequire("9PlPZ");

var $gsCwV = parcelRequire("gsCwV");

var $7bSKF = parcelRequire("7bSKF");

var $bFmpb = parcelRequire("bFmpb");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $473a5d35239efcca$var$toPath(value) {
    if ((0, $fSMeh.default)(value)) return (0, $iStCw.default)(value, (0, $7bSKF.default));
    return (0, $9PlPZ.default)(value) ? [
        value
    ] : (0, $9XLAP.default)((0, $gsCwV.default)((0, $bFmpb.default)(value)));
}
var $473a5d35239efcca$export$2e2bcd8739ae039 = $473a5d35239efcca$var$toPath;

});
parcelRegister("iStCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbe43f21c9e2492f$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $dbe43f21c9e2492f$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $dbe43f21c9e2492f$export$2e2bcd8739ae039 = $dbe43f21c9e2492f$var$arrayMap;

});

parcelRegister("9PlPZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7279d0f43a29fe33$export$2e2bcd8739ae039; });

var $89LaC = parcelRequire("89LaC");

var $4JGW3 = parcelRequire("4JGW3");
/** `Object#toString` result references. */ var $7279d0f43a29fe33$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7279d0f43a29fe33$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $4JGW3.default)(value) && (0, $89LaC.default)(value) == $7279d0f43a29fe33$var$symbolTag;
}
var $7279d0f43a29fe33$export$2e2bcd8739ae039 = $7279d0f43a29fe33$var$isSymbol;

});

parcelRegister("gsCwV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfbd262202990f5d$export$2e2bcd8739ae039; });

var $awVG9 = parcelRequire("awVG9");
/** Used to match property names within property paths. */ var $bfbd262202990f5d$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $bfbd262202990f5d$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $bfbd262202990f5d$var$stringToPath = (0, $awVG9.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($bfbd262202990f5d$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($bfbd262202990f5d$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $bfbd262202990f5d$export$2e2bcd8739ae039 = $bfbd262202990f5d$var$stringToPath;

});
parcelRegister("awVG9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aa9a25d8a58d29e$export$2e2bcd8739ae039; });

var $iNqVr = parcelRequire("iNqVr");
/** Used as the maximum memoize cache size. */ var $7aa9a25d8a58d29e$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $7aa9a25d8a58d29e$var$memoizeCapped(func) {
    var result = (0, $iNqVr.default)(func, function(key) {
        if (cache.size === $7aa9a25d8a58d29e$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $7aa9a25d8a58d29e$export$2e2bcd8739ae039 = $7aa9a25d8a58d29e$var$memoizeCapped;

});
parcelRegister("iNqVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daf1b075fa8bd708$export$2e2bcd8739ae039; });

var $h2qiz = parcelRequire("h2qiz");
/** Error message constants. */ var $daf1b075fa8bd708$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $daf1b075fa8bd708$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($daf1b075fa8bd708$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($daf1b075fa8bd708$var$memoize.Cache || (0, $h2qiz.default));
    return memoized;
}
// Expose `MapCache`.
$daf1b075fa8bd708$var$memoize.Cache = (0, $h2qiz.default);
var $daf1b075fa8bd708$export$2e2bcd8739ae039 = $daf1b075fa8bd708$var$memoize;

});



parcelRegister("7bSKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53c4080abe6102a6$export$2e2bcd8739ae039; });

var $9PlPZ = parcelRequire("9PlPZ");
/** Used as references for various `Number` constants. */ var $53c4080abe6102a6$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $53c4080abe6102a6$var$toKey(value) {
    if (typeof value == 'string' || (0, $9PlPZ.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$53c4080abe6102a6$var$INFINITY ? '-0' : result;
}
var $53c4080abe6102a6$export$2e2bcd8739ae039 = $53c4080abe6102a6$var$toKey;

});

parcelRegister("bFmpb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87e4e73c7b03c5b9$export$2e2bcd8739ae039; });

var $5gv2L = parcelRequire("5gv2L");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $87e4e73c7b03c5b9$var$toString(value) {
    return value == null ? '' : (0, $5gv2L.default)(value);
}
var $87e4e73c7b03c5b9$export$2e2bcd8739ae039 = $87e4e73c7b03c5b9$var$toString;

});
parcelRegister("5gv2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d5686f5bc7e22ec$export$2e2bcd8739ae039; });

var $lV3so = parcelRequire("lV3so");

var $iStCw = parcelRequire("iStCw");

var $fSMeh = parcelRequire("fSMeh");

var $9PlPZ = parcelRequire("9PlPZ");
/** Used as references for various `Number` constants. */ var $3d5686f5bc7e22ec$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3d5686f5bc7e22ec$var$symbolProto = (0, $lV3so.default) ? (0, $lV3so.default).prototype : undefined, $3d5686f5bc7e22ec$var$symbolToString = $3d5686f5bc7e22ec$var$symbolProto ? $3d5686f5bc7e22ec$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3d5686f5bc7e22ec$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $fSMeh.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $iStCw.default)(value, $3d5686f5bc7e22ec$var$baseToString) + '';
    if ((0, $9PlPZ.default)(value)) return $3d5686f5bc7e22ec$var$symbolToString ? $3d5686f5bc7e22ec$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3d5686f5bc7e22ec$var$INFINITY ? '-0' : result;
}
var $3d5686f5bc7e22ec$export$2e2bcd8739ae039 = $3d5686f5bc7e22ec$var$baseToString;

});



parcelRegister("5lZKQ", function(module, exports) {
'use strict';

var $2Tyh0 = parcelRequire("2Tyh0");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3e5ed1162c0fadf1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3e5ed1162c0fadf1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3e5ed1162c0fadf1$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3e5ed1162c0fadf1$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3e5ed1162c0fadf1$var$TYPE_STATICS = {};
$3e5ed1162c0fadf1$var$TYPE_STATICS[$2Tyh0.ForwardRef] = $3e5ed1162c0fadf1$var$FORWARD_REF_STATICS;
$3e5ed1162c0fadf1$var$TYPE_STATICS[$2Tyh0.Memo] = $3e5ed1162c0fadf1$var$MEMO_STATICS;
function $3e5ed1162c0fadf1$var$getStatics(component) {
    // React v16.11 and below
    if ($2Tyh0.isMemo(component)) return $3e5ed1162c0fadf1$var$MEMO_STATICS;
     // React v16.12 and above
    return $3e5ed1162c0fadf1$var$TYPE_STATICS[component['$$typeof']] || $3e5ed1162c0fadf1$var$REACT_STATICS;
}
var $3e5ed1162c0fadf1$var$defineProperty = Object.defineProperty;
var $3e5ed1162c0fadf1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3e5ed1162c0fadf1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3e5ed1162c0fadf1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3e5ed1162c0fadf1$var$getPrototypeOf = Object.getPrototypeOf;
var $3e5ed1162c0fadf1$var$objectPrototype = Object.prototype;
function $3e5ed1162c0fadf1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($3e5ed1162c0fadf1$var$objectPrototype) {
            var inheritedComponent = $3e5ed1162c0fadf1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3e5ed1162c0fadf1$var$objectPrototype) $3e5ed1162c0fadf1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3e5ed1162c0fadf1$var$getOwnPropertyNames(sourceComponent);
        if ($3e5ed1162c0fadf1$var$getOwnPropertySymbols) keys = keys.concat($3e5ed1162c0fadf1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3e5ed1162c0fadf1$var$getStatics(targetComponent);
        var sourceStatics = $3e5ed1162c0fadf1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3e5ed1162c0fadf1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3e5ed1162c0fadf1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3e5ed1162c0fadf1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $3e5ed1162c0fadf1$var$hoistNonReactStatics;

});
parcelRegister("2Tyh0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("laVoo"));

});



parcelRegister("2zLWb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSVLink = module.exports.CSVDownload = undefined;

var $7Old4 = parcelRequire("7Old4");
var $1e04090a56e549b5$var$_Download2 = $1e04090a56e549b5$var$_interopRequireDefault($7Old4);

var $2w8hW = parcelRequire("2w8hW");
var $1e04090a56e549b5$var$_Link2 = $1e04090a56e549b5$var$_interopRequireDefault($2w8hW);
function $1e04090a56e549b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1e04090a56e549b5$var$CSVDownload = module.exports.CSVDownload = $1e04090a56e549b5$var$_Download2.default;
var $1e04090a56e549b5$var$CSVLink = module.exports.CSVLink = $1e04090a56e549b5$var$_Link2.default;

});
parcelRegister("7Old4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5afda7ba62ebe8eb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $igtsr = parcelRequire("igtsr");
var $5afda7ba62ebe8eb$var$_react2 = $5afda7ba62ebe8eb$var$_interopRequireDefault($igtsr);

var $g8Mir = parcelRequire("g8Mir");

var $ipW1l = parcelRequire("ipW1l");
function $5afda7ba62ebe8eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5afda7ba62ebe8eb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5afda7ba62ebe8eb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5afda7ba62ebe8eb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5afda7ba62ebe8eb$var$defaultProps = {
    target: '_blank'
};
var $5afda7ba62ebe8eb$var$CSVDownload = function(_React$Component) {
    $5afda7ba62ebe8eb$var$_inherits(CSVDownload, _React$Component);
    function CSVDownload(props) {
        $5afda7ba62ebe8eb$var$_classCallCheck(this, CSVDownload);
        var _this = $5afda7ba62ebe8eb$var$_possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
        _this.state = {};
        return _this;
    }
    $5afda7ba62ebe8eb$var$_createClass(CSVDownload, [
        {
            key: 'buildURI',
            value: function buildURI() {
                return $g8Mir.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF, target = _props.target, specs = _props.specs, replace = _props.replace;
                this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
            }
        },
        {
            key: 'getWindow',
            value: function getWindow() {
                return this.state.page;
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return CSVDownload;
}($5afda7ba62ebe8eb$var$_react2.default.Component);
$5afda7ba62ebe8eb$var$CSVDownload.defaultProps = Object.assign($ipW1l.defaultProps, $5afda7ba62ebe8eb$var$defaultProps);
$5afda7ba62ebe8eb$var$CSVDownload.propTypes = $ipW1l.propTypes;
module.exports.default = $5afda7ba62ebe8eb$var$CSVDownload;

});
parcelRegister("g8Mir", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bc02db636a7fe2a2$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $bc02db636a7fe2a2$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $bc02db636a7fe2a2$var$isSafari = module.exports.isSafari = function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
var $bc02db636a7fe2a2$var$isJsons = module.exports.isJsons = function isJsons(array) {
    return Array.isArray(array) && array.every(function(row) {
        return (typeof row === "undefined" ? "undefined" : $bc02db636a7fe2a2$var$_typeof(row)) === 'object' && !(row instanceof Array);
    });
};
var $bc02db636a7fe2a2$var$isArrays = module.exports.isArrays = function isArrays(array) {
    return Array.isArray(array) && array.every(function(row) {
        return Array.isArray(row);
    });
};
var $bc02db636a7fe2a2$var$jsonsHeaders = module.exports.jsonsHeaders = function jsonsHeaders(array) {
    return Array.from(array.map(function(json) {
        return Object.keys(json);
    }).reduce(function(a, b) {
        return new Set([].concat($bc02db636a7fe2a2$var$_toConsumableArray(a), $bc02db636a7fe2a2$var$_toConsumableArray(b)));
    }, []));
};
var $bc02db636a7fe2a2$var$jsons2arrays = module.exports.jsons2arrays = function jsons2arrays(jsons, headers) {
    headers = headers || $bc02db636a7fe2a2$var$jsonsHeaders(jsons);
    var headerLabels = headers;
    var headerKeys = headers;
    if ($bc02db636a7fe2a2$var$isJsons(headers)) {
        headerLabels = headers.map(function(header) {
            return header.label;
        });
        headerKeys = headers.map(function(header) {
            return header.key;
        });
    }
    var data = jsons.map(function(object) {
        return headerKeys.map(function(header) {
            return $bc02db636a7fe2a2$var$getHeaderValue(header, object);
        });
    });
    return [
        headerLabels
    ].concat($bc02db636a7fe2a2$var$_toConsumableArray(data));
};
var $bc02db636a7fe2a2$var$getHeaderValue = module.exports.getHeaderValue = function getHeaderValue(property, obj) {
    var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function(o, p, i, arr) {
        var value = o[p];
        if (value === undefined || value === null) arr.splice(1);
        else return value;
    }, obj);
    return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
};
var $bc02db636a7fe2a2$var$elementOrEmpty = module.exports.elementOrEmpty = function elementOrEmpty(element) {
    return typeof element === 'undefined' || element === null ? '' : element;
};
var $bc02db636a7fe2a2$var$joiner = module.exports.joiner = function joiner(data) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
    var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
    return data.filter(function(e) {
        return e;
    }).map(function(row) {
        return row.map(function(element) {
            return $bc02db636a7fe2a2$var$elementOrEmpty(element);
        }).map(function(column) {
            return "" + enclosingCharacter + column + enclosingCharacter;
        }).join(separator);
    }).join("\n");
};
var $bc02db636a7fe2a2$var$arrays2csv = module.exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
    return $bc02db636a7fe2a2$var$joiner(headers ? [
        headers
    ].concat($bc02db636a7fe2a2$var$_toConsumableArray(data)) : data, separator, enclosingCharacter);
};
var $bc02db636a7fe2a2$var$jsons2csv = module.exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
    return $bc02db636a7fe2a2$var$joiner($bc02db636a7fe2a2$var$jsons2arrays(data, headers), separator, enclosingCharacter);
};
var $bc02db636a7fe2a2$var$string2csv = module.exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
    return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
};
var $bc02db636a7fe2a2$var$toCSV = module.exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
    if ($bc02db636a7fe2a2$var$isJsons(data)) return $bc02db636a7fe2a2$var$jsons2csv(data, headers, separator, enclosingCharacter);
    if ($bc02db636a7fe2a2$var$isArrays(data)) return $bc02db636a7fe2a2$var$arrays2csv(data, headers, separator, enclosingCharacter);
    if (typeof data === 'string') return $bc02db636a7fe2a2$var$string2csv(data, headers, separator);
    throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};
var $bc02db636a7fe2a2$var$buildURI = module.exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
    var csv = $bc02db636a7fe2a2$var$toCSV(data, headers, separator, enclosingCharacter);
    var type = $bc02db636a7fe2a2$var$isSafari() ? 'application/csv' : 'text/csv';
    var blob = new Blob([
        uFEFF ? "\uFEFF" : '',
        csv
    ], {
        type: type
    });
    var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
    var URL = window.URL || window.webkitURL;
    return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};

});

parcelRegister("ipW1l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropsNotForwarded = module.exports.defaultProps = module.exports.propTypes = undefined;

var $igtsr = parcelRequire("igtsr");
var $d6879183707a4fbd$var$_react2 = $d6879183707a4fbd$var$_interopRequireDefault($igtsr);

var $mYN5V = parcelRequire("mYN5V");
function $d6879183707a4fbd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d6879183707a4fbd$var$propTypes = module.exports.propTypes = {
    data: (0, $mYN5V.oneOfType)([
        $mYN5V.string,
        $mYN5V.array,
        $mYN5V.func
    ]).isRequired,
    headers: $mYN5V.array,
    target: $mYN5V.string,
    separator: $mYN5V.string,
    filename: $mYN5V.string,
    uFEFF: $mYN5V.bool,
    onClick: $mYN5V.func,
    asyncOnClick: $mYN5V.bool,
    enclosingCharacter: $mYN5V.string
};
var $d6879183707a4fbd$var$defaultProps = module.exports.defaultProps = {
    separator: ',',
    filename: 'generatedBy_react-csv.csv',
    uFEFF: true,
    asyncOnClick: false,
    enclosingCharacter: '"'
};
var $d6879183707a4fbd$var$PropsNotForwarded = module.exports.PropsNotForwarded = [
    'data',
    'headers'
];

});
parcelRegister("mYN5V", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $045135fc1cb8fb91$var$ReactIs, $045135fc1cb8fb91$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6nrW6"))();

});



parcelRegister("2w8hW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1d54ffd98fdf7768$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1d54ffd98fdf7768$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $igtsr = parcelRequire("igtsr");
var $1d54ffd98fdf7768$var$_react2 = $1d54ffd98fdf7768$var$_interopRequireDefault($igtsr);

var $g8Mir = parcelRequire("g8Mir");

var $ipW1l = parcelRequire("ipW1l");
function $1d54ffd98fdf7768$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d54ffd98fdf7768$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $1d54ffd98fdf7768$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d54ffd98fdf7768$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1d54ffd98fdf7768$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1d54ffd98fdf7768$var$CSVLink = function(_React$Component) {
    $1d54ffd98fdf7768$var$_inherits(CSVLink, _React$Component);
    function CSVLink(props) {
        $1d54ffd98fdf7768$var$_classCallCheck(this, CSVLink);
        var _this = $1d54ffd98fdf7768$var$_possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
        _this.buildURI = _this.buildURI.bind(_this);
        return _this;
    }
    $1d54ffd98fdf7768$var$_createClass(CSVLink, [
        {
            key: 'buildURI',
            value: function buildURI() {
                return $g8Mir.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: 'handleLegacy',
            value: function handleLegacy(event) {
                var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (window.navigator.msSaveOrOpenBlob) {
                    event.preventDefault();
                    var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, filename = _props.filename, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF;
                    var csvData = isAsync && typeof data === 'function' ? data() : data;
                    var blob = new Blob([
                        uFEFF ? '\uFEFF' : '',
                        (0, $g8Mir.toCSV)(csvData, headers, separator, enclosingCharacter)
                    ]);
                    window.navigator.msSaveBlob(blob, filename);
                    return false;
                }
            }
        },
        {
            key: 'handleAsyncClick',
            value: function handleAsyncClick(event) {
                var _this2 = this;
                var done = function done(proceed) {
                    if (proceed === false) {
                        event.preventDefault();
                        return;
                    }
                    _this2.handleLegacy(event, true);
                };
                this.props.onClick(event, done);
            }
        },
        {
            key: 'handleSyncClick',
            value: function handleSyncClick(event) {
                var stopEvent = this.props.onClick(event) === false;
                if (stopEvent) {
                    event.preventDefault();
                    return;
                }
                this.handleLegacy(event);
            }
        },
        {
            key: 'handleClick',
            value: function handleClick() {
                var _this3 = this;
                return function(event) {
                    if (typeof _this3.props.onClick === 'function') return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
                    _this3.handleLegacy(event);
                };
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, data = _props2.data, headers = _props2.headers, separator = _props2.separator, filename = _props2.filename, uFEFF = _props2.uFEFF, children = _props2.children, onClick = _props2.onClick, asyncOnClick = _props2.asyncOnClick, enclosingCharacter = _props2.enclosingCharacter, rest = $1d54ffd98fdf7768$var$_objectWithoutProperties(_props2, [
                    'data',
                    'headers',
                    'separator',
                    'filename',
                    'uFEFF',
                    'children',
                    'onClick',
                    'asyncOnClick',
                    'enclosingCharacter'
                ]);
                var isNodeEnvironment = typeof window === 'undefined';
                var href = isNodeEnvironment ? '' : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
                return $1d54ffd98fdf7768$var$_react2.default.createElement('a', $1d54ffd98fdf7768$var$_extends({
                    download: filename
                }, rest, {
                    ref: function ref(link) {
                        return _this4.link = link;
                    },
                    target: '_self',
                    href: href,
                    onClick: this.handleClick()
                }), children);
            }
        }
    ]);
    return CSVLink;
}($1d54ffd98fdf7768$var$_react2.default.Component);
$1d54ffd98fdf7768$var$CSVLink.defaultProps = $ipW1l.defaultProps;
$1d54ffd98fdf7768$var$CSVLink.propTypes = $ipW1l.propTypes;
module.exports.default = $1d54ffd98fdf7768$var$CSVLink;

});


parcelRegister("flTbo", function(module, exports) {

module.exports = (parcelRequire("3FJeH"))($parcel$resolve("ghwZp")).then(()=>parcelRequire('k1gfm'));

});
parcelRegister("3FJeH", function(module, exports) {
"use strict";

var $8QiFL = parcelRequire("8QiFL");
module.exports = $8QiFL(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("8QiFL", function(module, exports) {
"use strict";
var $6701aa12bc3a4f1d$var$cachedBundles = {};
var $6701aa12bc3a4f1d$var$cachedPreloads = {};
var $6701aa12bc3a4f1d$var$cachedPrefetches = {};
function $6701aa12bc3a4f1d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $6701aa12bc3a4f1d$var$cachedPreloads;
        case 'prefetch':
            return $6701aa12bc3a4f1d$var$cachedPrefetches;
        default:
            return $6701aa12bc3a4f1d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6701aa12bc3a4f1d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $75583f17f79339ff$exports = {};
$parcel$extendImportMap({
    "44YaE": "default.cc5f8d8a.png",
    "igHb0": "Component_6.3aae473f.png",
    "gN8qh": "payment-method.04b813bd.png",
    "ghwZp": "browser-ponyfill.c3cd3d24.js",
    "ga3ID": "full-logo.2e3970da.png"
});

/**
 * @author Ahmed Serag
 * @date 2019-07-15
 * @description start point of the react application that uses
 * react dom to manipulate the root div.
 * @filename index.tsx
 */ var $ecbd83510a1ff561$exports = {};
'use strict';

$ecbd83510a1ff561$exports = (parcelRequire("g8xkP"));



var $igtsr = parcelRequire("igtsr");
var $b4edf43dc2c2ee5a$export$882461b6382ed46c;
var $b4edf43dc2c2ee5a$export$757ceba2d55c277e;
'use strict';
var $7731928cc933a5ef$exports = {};
'use strict';
function $7731928cc933a5ef$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7731928cc933a5ef$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7731928cc933a5ef$var$checkDCE();

$7731928cc933a5ef$exports = (parcelRequire("ccHvx"));


var $b4edf43dc2c2ee5a$var$i;
$b4edf43dc2c2ee5a$export$882461b6382ed46c = $7731928cc933a5ef$exports.createRoot;
$b4edf43dc2c2ee5a$export$757ceba2d55c277e = $7731928cc933a5ef$exports.hydrateRoot;


function $b28bc5c4fde5f427$export$2e2bcd8739ae039(t, e) {
    return $b28bc5c4fde5f427$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b28bc5c4fde5f427$export$2e2bcd8739ae039(t, e);
}


function $2e83e59386d743bc$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $b28bc5c4fde5f427$export$2e2bcd8739ae039)(t, o);
}



var $igtsr = parcelRequire("igtsr");

var $mYN5V = parcelRequire("mYN5V");
function $24ebcff9d5a3a551$export$2e2bcd8739ae039() {
    return $24ebcff9d5a3a551$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $24ebcff9d5a3a551$export$2e2bcd8739ae039.apply(null, arguments);
}


function $eecc74fb08be1064$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $eecc74fb08be1064$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $eecc74fb08be1064$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $eecc74fb08be1064$var$isAbsolute(to);
    var isFromAbs = from && $eecc74fb08be1064$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $eecc74fb08be1064$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $eecc74fb08be1064$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $eecc74fb08be1064$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $eecc74fb08be1064$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$eecc74fb08be1064$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $eecc74fb08be1064$export$2e2bcd8739ae039 = $eecc74fb08be1064$var$resolvePathname;


function $ac406bb7f98b9fd5$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $ac406bb7f98b9fd5$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $ac406bb7f98b9fd5$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $ac406bb7f98b9fd5$var$valueOf(a);
        var bValue = $ac406bb7f98b9fd5$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $ac406bb7f98b9fd5$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $ac406bb7f98b9fd5$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $ac406bb7f98b9fd5$export$2e2bcd8739ae039 = $ac406bb7f98b9fd5$var$valueEqual;



var $664155500c52c573$var$isProduction = true;
var $664155500c52c573$var$prefix = 'Invariant failed';
function $664155500c52c573$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($664155500c52c573$var$isProduction) throw new Error($664155500c52c573$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($664155500c52c573$var$prefix, ": ").concat(provided) : $664155500c52c573$var$prefix;
    throw new Error(value);
}


function $cfe614f8c1cd4175$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $cfe614f8c1cd4175$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $cfe614f8c1cd4175$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $cfe614f8c1cd4175$var$stripBasename(path, prefix) {
    return $cfe614f8c1cd4175$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $cfe614f8c1cd4175$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $cfe614f8c1cd4175$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $cfe614f8c1cd4175$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $cfe614f8c1cd4175$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $cfe614f8c1cd4175$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $eecc74fb08be1064$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $cfe614f8c1cd4175$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $ac406bb7f98b9fd5$export$2e2bcd8739ae039)(a.state, b.state);
}
function $cfe614f8c1cd4175$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $cfe614f8c1cd4175$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $cfe614f8c1cd4175$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $cfe614f8c1cd4175$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $cfe614f8c1cd4175$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $cfe614f8c1cd4175$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $cfe614f8c1cd4175$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $cfe614f8c1cd4175$var$PopStateEvent = 'popstate';
var $cfe614f8c1cd4175$var$HashChangeEvent = 'hashchange';
function $cfe614f8c1cd4175$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $cfe614f8c1cd4175$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$cfe614f8c1cd4175$var$canUseDOM && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $cfe614f8c1cd4175$var$supportsHistory();
    var needsHashChangeListener = !$cfe614f8c1cd4175$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $cfe614f8c1cd4175$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $cfe614f8c1cd4175$var$stripTrailingSlash($cfe614f8c1cd4175$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $cfe614f8c1cd4175$var$stripBasename(path, basename);
        return $cfe614f8c1cd4175$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $cfe614f8c1cd4175$var$createTransitionManager();
    function setState(nextState) {
        (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($cfe614f8c1cd4175$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($cfe614f8c1cd4175$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($cfe614f8c1cd4175$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $cfe614f8c1cd4175$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $cfe614f8c1cd4175$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $cfe614f8c1cd4175$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($cfe614f8c1cd4175$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($cfe614f8c1cd4175$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($cfe614f8c1cd4175$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($cfe614f8c1cd4175$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $cfe614f8c1cd4175$var$HashChangeEvent$1 = 'hashchange';
var $cfe614f8c1cd4175$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $cfe614f8c1cd4175$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $cfe614f8c1cd4175$var$stripLeadingSlash,
        decodePath: $cfe614f8c1cd4175$var$addLeadingSlash
    },
    slash: {
        encodePath: $cfe614f8c1cd4175$var$addLeadingSlash,
        decodePath: $cfe614f8c1cd4175$var$addLeadingSlash
    }
};
function $cfe614f8c1cd4175$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $cfe614f8c1cd4175$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $cfe614f8c1cd4175$var$pushHashPath(path) {
    window.location.hash = path;
}
function $cfe614f8c1cd4175$var$replaceHashPath(path) {
    window.location.replace($cfe614f8c1cd4175$var$stripHash(window.location.href) + '#' + path);
}
function $cfe614f8c1cd4175$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$cfe614f8c1cd4175$var$canUseDOM && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $cfe614f8c1cd4175$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $cfe614f8c1cd4175$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $cfe614f8c1cd4175$var$stripTrailingSlash($cfe614f8c1cd4175$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $cfe614f8c1cd4175$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($cfe614f8c1cd4175$var$getHashPath());
        if (basename) path = $cfe614f8c1cd4175$var$stripBasename(path, basename);
        return $cfe614f8c1cd4175$export$90c043f1c57770b8(path);
    }
    var transitionManager = $cfe614f8c1cd4175$var$createTransitionManager();
    function setState(nextState) {
        (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $cfe614f8c1cd4175$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $cfe614f8c1cd4175$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $cfe614f8c1cd4175$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($cfe614f8c1cd4175$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($cfe614f8c1cd4175$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $cfe614f8c1cd4175$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $cfe614f8c1cd4175$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $cfe614f8c1cd4175$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $cfe614f8c1cd4175$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $cfe614f8c1cd4175$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $cfe614f8c1cd4175$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $cfe614f8c1cd4175$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $cfe614f8c1cd4175$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $cfe614f8c1cd4175$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($cfe614f8c1cd4175$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $cfe614f8c1cd4175$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $cfe614f8c1cd4175$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $cfe614f8c1cd4175$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $cfe614f8c1cd4175$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($cfe614f8c1cd4175$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($cfe614f8c1cd4175$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($cfe614f8c1cd4175$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $cfe614f8c1cd4175$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $cfe614f8c1cd4175$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $cfe614f8c1cd4175$var$createTransitionManager();
    function setState(nextState) {
        (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $cfe614f8c1cd4175$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $cfe614f8c1cd4175$export$90c043f1c57770b8(entry, undefined, createKey()) : $cfe614f8c1cd4175$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $cfe614f8c1cd4175$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $cfe614f8c1cd4175$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $cfe614f8c1cd4175$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $cfe614f8c1cd4175$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $4d6322dfc8233a7c$exports = {};
var $1999713fc0fb8a32$exports = {};
$1999713fc0fb8a32$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $4d6322dfc8233a7c$exports = $4d6322dfc8233a7c$var$pathToRegexp;
$4d6322dfc8233a7c$exports.parse = $4d6322dfc8233a7c$var$parse;
$4d6322dfc8233a7c$exports.compile = $4d6322dfc8233a7c$var$compile;
$4d6322dfc8233a7c$exports.tokensToFunction = $4d6322dfc8233a7c$var$tokensToFunction;
$4d6322dfc8233a7c$exports.tokensToRegExp = $4d6322dfc8233a7c$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $4d6322dfc8233a7c$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $4d6322dfc8233a7c$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $4d6322dfc8233a7c$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $4d6322dfc8233a7c$var$escapeGroup(pattern) : asterisk ? '.*' : $4d6322dfc8233a7c$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $4d6322dfc8233a7c$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $4d6322dfc8233a7c$var$escapeString(delimiter) + ']+?';
    return $4d6322dfc8233a7c$var$escapeString(prevText) + '|(?:(?!' + $4d6322dfc8233a7c$var$escapeString(prevText) + ')[^' + $4d6322dfc8233a7c$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $4d6322dfc8233a7c$var$compile(str, options) {
    return $4d6322dfc8233a7c$var$tokensToFunction($4d6322dfc8233a7c$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $4d6322dfc8233a7c$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $4d6322dfc8233a7c$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $4d6322dfc8233a7c$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $4d6322dfc8233a7c$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $4d6322dfc8233a7c$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($1999713fc0fb8a32$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $4d6322dfc8233a7c$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $4d6322dfc8233a7c$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $4d6322dfc8233a7c$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $4d6322dfc8233a7c$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $4d6322dfc8233a7c$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $4d6322dfc8233a7c$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $4d6322dfc8233a7c$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $4d6322dfc8233a7c$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($4d6322dfc8233a7c$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $4d6322dfc8233a7c$var$flags(options));
    return $4d6322dfc8233a7c$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $4d6322dfc8233a7c$var$stringToRegexp(path, keys, options) {
    return $4d6322dfc8233a7c$var$tokensToRegExp($4d6322dfc8233a7c$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $4d6322dfc8233a7c$var$tokensToRegExp(tokens, keys, options) {
    if (!$1999713fc0fb8a32$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $4d6322dfc8233a7c$var$escapeString(token);
        else {
            var prefix = $4d6322dfc8233a7c$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $4d6322dfc8233a7c$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $4d6322dfc8233a7c$var$attachKeys(new RegExp('^' + route, $4d6322dfc8233a7c$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $4d6322dfc8233a7c$var$pathToRegexp(path, keys, options) {
    if (!$1999713fc0fb8a32$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $4d6322dfc8233a7c$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($1999713fc0fb8a32$exports(path)) return $4d6322dfc8233a7c$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $4d6322dfc8233a7c$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


parcelRequire("2Tyh0");
function $d92ff26bfbf1e93c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $5lZKQ = parcelRequire("5lZKQ");
var $64a2d600c7194f1d$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $64a2d600c7194f1d$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $64a2d600c7194f1d$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $64a2d600c7194f1d$var$commonjsGlobal[key] = ($64a2d600c7194f1d$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $64a2d600c7194f1d$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $64a2d600c7194f1d$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $64a2d600c7194f1d$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $64a2d600c7194f1d$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $64a2d600c7194f1d$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $64a2d600c7194f1d$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($64a2d600c7194f1d$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $64a2d600c7194f1d$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($mYN5V))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $64a2d600c7194f1d$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $64a2d600c7194f1d$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $64a2d600c7194f1d$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($mYN5V))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $64a2d600c7194f1d$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createContext || $64a2d600c7194f1d$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $64a2d600c7194f1d$var$createNamedContext = function createNamedContext(name) {
    var context = $64a2d600c7194f1d$var$createContext();
    context.displayName = name;
    return context;
};
var $64a2d600c7194f1d$export$c213558b66925821 = /*#__PURE__*/ $64a2d600c7194f1d$var$createNamedContext("Router-History");
var $64a2d600c7194f1d$export$63baa8ccbe60bb07 = /*#__PURE__*/ $64a2d600c7194f1d$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $64a2d600c7194f1d$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $64a2d600c7194f1d$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $cfe614f8c1cd4175$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
var $64a2d600c7194f1d$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $64a2d600c7194f1d$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $64a2d600c7194f1d$var$messageType;
var $64a2d600c7194f1d$var$cache = {};
var $64a2d600c7194f1d$var$cacheLimit = 10000;
var $64a2d600c7194f1d$var$cacheCount = 0;
function $64a2d600c7194f1d$var$compilePath(path) {
    if ($64a2d600c7194f1d$var$cache[path]) return $64a2d600c7194f1d$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($4d6322dfc8233a7c$exports))).compile(path);
    if ($64a2d600c7194f1d$var$cacheCount < $64a2d600c7194f1d$var$cacheLimit) {
        $64a2d600c7194f1d$var$cache[path] = generator;
        $64a2d600c7194f1d$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $64a2d600c7194f1d$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $64a2d600c7194f1d$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $64a2d600c7194f1d$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $cfe614f8c1cd4175$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $64a2d600c7194f1d$export$82476f982757e71e(to, computedMatch.params) : (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, to, {
            pathname: $64a2d600c7194f1d$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $cfe614f8c1cd4175$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $cfe614f8c1cd4175$export$c3e8bb440bd55b18)(prevLocation, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $64a2d600c7194f1d$var$cache$1 = {};
var $64a2d600c7194f1d$var$cacheLimit$1 = 10000;
var $64a2d600c7194f1d$var$cacheCount$1 = 0;
function $64a2d600c7194f1d$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $64a2d600c7194f1d$var$cache$1[cacheKey] || ($64a2d600c7194f1d$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($4d6322dfc8233a7c$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($64a2d600c7194f1d$var$cacheCount$1 < $64a2d600c7194f1d$var$cacheLimit$1) {
        pathCache[path] = result;
        $64a2d600c7194f1d$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $64a2d600c7194f1d$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $64a2d600c7194f1d$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $64a2d600c7194f1d$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Children.count(children) === 0;
}
function $64a2d600c7194f1d$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $64a2d600c7194f1d$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $64a2d600c7194f1d$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $64a2d600c7194f1d$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
function $64a2d600c7194f1d$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $64a2d600c7194f1d$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, location, {
        pathname: $64a2d600c7194f1d$var$addLeadingSlash(basename) + location.pathname
    });
}
function $64a2d600c7194f1d$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $64a2d600c7194f1d$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $64a2d600c7194f1d$var$createURL(location) {
    return typeof location === "string" ? location : (0, $cfe614f8c1cd4175$export$fe53371bee54353d)(location);
}
function $64a2d600c7194f1d$var$staticHandler(methodName) {
    return function() {
        (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
    };
}
function $64a2d600c7194f1d$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $64a2d600c7194f1d$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $64a2d600c7194f1d$var$noop;
        };
        _this.handleBlock = function() {
            return $64a2d600c7194f1d$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $64a2d600c7194f1d$var$addBasename(basename, (0, $cfe614f8c1cd4175$export$90c043f1c57770b8)(location));
        context.url = $64a2d600c7194f1d$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $64a2d600c7194f1d$var$addLeadingSlash(basename + $64a2d600c7194f1d$var$createURL(path));
            },
            action: "POP",
            location: $64a2d600c7194f1d$var$stripBasename(basename, (0, $cfe614f8c1cd4175$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $64a2d600c7194f1d$var$staticHandler("go"),
            goBack: $64a2d600c7194f1d$var$staticHandler("goBack"),
            goForward: $64a2d600c7194f1d$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$55185c17a0fcbe46, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $64a2d600c7194f1d$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $64a2d600c7194f1d$export$81336c211d5ff295(location.pathname, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $64a2d600c7194f1d$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($64a2d600c7194f1d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement(Component, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5lZKQ)))(C, Component);
}
var $64a2d600c7194f1d$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).useContext;
function $64a2d600c7194f1d$export$3420e1dc2c4a518c() {
    return $64a2d600c7194f1d$var$useContext($64a2d600c7194f1d$export$c213558b66925821);
}
function $64a2d600c7194f1d$export$45d76561a5302f2b() {
    return $64a2d600c7194f1d$var$useContext($64a2d600c7194f1d$export$63baa8ccbe60bb07).location;
}
function $64a2d600c7194f1d$export$99eaa27ddbbb95ef() {
    var match = $64a2d600c7194f1d$var$useContext($64a2d600c7194f1d$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $64a2d600c7194f1d$export$632be4bb944c1bc7(path) {
    var location = $64a2d600c7194f1d$export$45d76561a5302f2b();
    var match = $64a2d600c7194f1d$var$useContext($64a2d600c7194f1d$export$63baa8ccbe60bb07).match;
    return path ? $64a2d600c7194f1d$export$81336c211d5ff295(location.pathname, path) : match;
}
var $64a2d600c7194f1d$var$global$1, $64a2d600c7194f1d$var$key, $64a2d600c7194f1d$var$buildNames, $64a2d600c7194f1d$var$initialBuildName, $64a2d600c7194f1d$var$secondaryBuildName;




var $igtsr = parcelRequire("igtsr");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $0e6a7be968c19910$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $cfe614f8c1cd4175$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, $64a2d600c7194f1d$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $0e6a7be968c19910$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $cfe614f8c1cd4175$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, $64a2d600c7194f1d$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component);
var $0e6a7be968c19910$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $0e6a7be968c19910$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $cfe614f8c1cd4175$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $0e6a7be968c19910$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $0e6a7be968c19910$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).forwardRef;
if (typeof $0e6a7be968c19910$var$forwardRef === "undefined") $0e6a7be968c19910$var$forwardRef = $0e6a7be968c19910$var$forwardRefShim;
function $0e6a7be968c19910$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $0e6a7be968c19910$var$LinkAnchor = $0e6a7be968c19910$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$0e6a7be968c19910$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($0e6a7be968c19910$var$forwardRefShim !== $0e6a7be968c19910$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $0e6a7be968c19910$export$a6c7ac8248d6e38a = $0e6a7be968c19910$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $0e6a7be968c19910$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, $64a2d600c7194f1d$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $0e6a7be968c19910$var$normalizeToLocation($0e6a7be968c19910$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $0e6a7be968c19910$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $cfe614f8c1cd4175$export$fe53371bee54353d)(context.location) === (0, $cfe614f8c1cd4175$export$fe53371bee54353d)($0e6a7be968c19910$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($0e6a7be968c19910$var$forwardRefShim !== $0e6a7be968c19910$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement(component, props);
    });
});
var $0e6a7be968c19910$var$toType, $0e6a7be968c19910$var$refType;
var $0e6a7be968c19910$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $0e6a7be968c19910$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).forwardRef;
if (typeof $0e6a7be968c19910$var$forwardRef$1 === "undefined") $0e6a7be968c19910$var$forwardRef$1 = $0e6a7be968c19910$var$forwardRefShim$1;
function $0e6a7be968c19910$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $0e6a7be968c19910$export$b0d92dbee9b5b60d = $0e6a7be968c19910$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, $64a2d600c7194f1d$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $664155500c52c573$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $0e6a7be968c19910$var$normalizeToLocation($0e6a7be968c19910$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $64a2d600c7194f1d$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $0e6a7be968c19910$var$joinClassnames(className, activeClassName);
            style = (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($0e6a7be968c19910$var$forwardRefShim$1 !== $0e6a7be968c19910$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($0e6a7be968c19910$export$a6c7ac8248d6e38a, props);
    });
});
var $0e6a7be968c19910$var$ariaCurrentType;


const $21e140e386fbc24c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $21e140e386fbc24c$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $21e140e386fbc24c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $c87b33a629a5f98d$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $93bf3ab9d1ed6a64$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $93bf3ab9d1ed6a64$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $93bf3ab9d1ed6a64$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $93bf3ab9d1ed6a64$export$cbf60ecb96cbb82f = {
    date: (0, $c87b33a629a5f98d$export$38e44e97ce4dbb7d)({
        formats: $93bf3ab9d1ed6a64$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $c87b33a629a5f98d$export$38e44e97ce4dbb7d)({
        formats: $93bf3ab9d1ed6a64$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $c87b33a629a5f98d$export$38e44e97ce4dbb7d)({
        formats: $93bf3ab9d1ed6a64$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $697e06402041c175$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $697e06402041c175$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$697e06402041c175$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $afee7d950ac2d3a9$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $09422631a2eb228d$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $09422631a2eb228d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $09422631a2eb228d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $09422631a2eb228d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $09422631a2eb228d$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $09422631a2eb228d$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $09422631a2eb228d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $09422631a2eb228d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $09422631a2eb228d$var$ordinalNumber,
    era: (0, $afee7d950ac2d3a9$export$63596d6ee8878b25)({
        values: $09422631a2eb228d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $afee7d950ac2d3a9$export$63596d6ee8878b25)({
        values: $09422631a2eb228d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $afee7d950ac2d3a9$export$63596d6ee8878b25)({
        values: $09422631a2eb228d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $afee7d950ac2d3a9$export$63596d6ee8878b25)({
        values: $09422631a2eb228d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $afee7d950ac2d3a9$export$63596d6ee8878b25)({
        values: $09422631a2eb228d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $09422631a2eb228d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $a1b23721de062710$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $a1b23721de062710$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $a1b23721de062710$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $a1b23721de062710$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $a1b23721de062710$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $855736ecd3d431d4$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $af7888dba6e8ff99$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $af7888dba6e8ff99$var$parseOrdinalNumberPattern = /\d+/i;
const $af7888dba6e8ff99$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $af7888dba6e8ff99$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $af7888dba6e8ff99$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $af7888dba6e8ff99$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $af7888dba6e8ff99$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $af7888dba6e8ff99$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $af7888dba6e8ff99$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $af7888dba6e8ff99$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $af7888dba6e8ff99$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $af7888dba6e8ff99$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $af7888dba6e8ff99$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $855736ecd3d431d4$export$fdaf2fd6d7edde95)({
        matchPattern: $af7888dba6e8ff99$var$matchOrdinalNumberPattern,
        parsePattern: $af7888dba6e8ff99$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $a1b23721de062710$export$1430a0f35710914d)({
        matchPatterns: $af7888dba6e8ff99$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $af7888dba6e8ff99$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $a1b23721de062710$export$1430a0f35710914d)({
        matchPatterns: $af7888dba6e8ff99$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $af7888dba6e8ff99$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $a1b23721de062710$export$1430a0f35710914d)({
        matchPatterns: $af7888dba6e8ff99$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $af7888dba6e8ff99$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $a1b23721de062710$export$1430a0f35710914d)({
        matchPatterns: $af7888dba6e8ff99$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $af7888dba6e8ff99$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $a1b23721de062710$export$1430a0f35710914d)({
        matchPatterns: $af7888dba6e8ff99$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $af7888dba6e8ff99$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $ebb1e9b94c2ad9db$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $21e140e386fbc24c$export$2c14ff85d6318973),
    formatLong: (0, $93bf3ab9d1ed6a64$export$cbf60ecb96cbb82f),
    formatRelative: (0, $697e06402041c175$export$8fbbfd65594f46a0),
    localize: (0, $09422631a2eb228d$export$b3bd0bc58e36cd63),
    match: (0, $af7888dba6e8ff99$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$ebb1e9b94c2ad9db$export$2e2bcd8739ae039 = $ebb1e9b94c2ad9db$export$137380d9ce54f7f;


let $5ff879255cceef79$var$defaultOptions = {};
function $5ff879255cceef79$export$430a3269e24b912e() {
    return $5ff879255cceef79$var$defaultOptions;
}
function $5ff879255cceef79$export$95365be1b0704abc(newOptions) {
    $5ff879255cceef79$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $3db87186a9f4bd75$export$dfd9b671c89acc8e = 7;
const $3db87186a9f4bd75$export$3913210603d8e9ae = 365.2425;
const $3db87186a9f4bd75$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $3db87186a9f4bd75$export$4dec998e48f9c246 = -$3db87186a9f4bd75$export$81caae6e1cc7a622;
const $3db87186a9f4bd75$export$4fad13613e88edc8 = 604800000;
const $3db87186a9f4bd75$export$b76b1809a2898f9a = 86400000;
const $3db87186a9f4bd75$export$91246f0b9bd9beff = 60000;
const $3db87186a9f4bd75$export$7f72910d6dfd237a = 3600000;
const $3db87186a9f4bd75$export$397c2d5776aa9055 = 1000;
const $3db87186a9f4bd75$export$3633035e63cee86a = 525600;
const $3db87186a9f4bd75$export$ab7da2ccd1075c38 = 43200;
const $3db87186a9f4bd75$export$2423174df8cd3cd2 = 1440;
const $3db87186a9f4bd75$export$f2f5ae5a8e2d8f9f = 60;
const $3db87186a9f4bd75$export$3c58128db900d44e = 3;
const $3db87186a9f4bd75$export$80d7e435f744f319 = 12;
const $3db87186a9f4bd75$export$4db7641526e3241f = 4;
const $3db87186a9f4bd75$export$698aec755e92c695 = 3600;
const $3db87186a9f4bd75$export$a77c1a7ebebe2a5a = 60;
const $3db87186a9f4bd75$export$815a9362476d2fe3 = $3db87186a9f4bd75$export$698aec755e92c695 * 24;
const $3db87186a9f4bd75$export$34804a017b31e2fe = $3db87186a9f4bd75$export$815a9362476d2fe3 * 7;
const $3db87186a9f4bd75$export$7271e9e3478110d1 = $3db87186a9f4bd75$export$815a9362476d2fe3 * $3db87186a9f4bd75$export$3913210603d8e9ae;
const $3db87186a9f4bd75$export$8e6600bbdee7dabb = $3db87186a9f4bd75$export$7271e9e3478110d1 / 12;
const $3db87186a9f4bd75$export$be1dccf2de902d31 = $3db87186a9f4bd75$export$8e6600bbdee7dabb * 3;
const $3db87186a9f4bd75$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $a960433738d4e8b2$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $3db87186a9f4bd75$export$2a7b97929c48d47d) in date) return date[0, $3db87186a9f4bd75$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$a960433738d4e8b2$export$2e2bcd8739ae039 = $a960433738d4e8b2$export$ead8a1812b171991;


function $3eee1f7ebbb7c256$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $a960433738d4e8b2$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$3eee1f7ebbb7c256$export$2e2bcd8739ae039 = $3eee1f7ebbb7c256$export$e67a095c620b86fe;


function $06d8a0c3d04b605b$export$113002b5eff6e430(date) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $57652c90c52675bd$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $a960433738d4e8b2$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $57dbb05d87d784b1$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$57dbb05d87d784b1$export$2e2bcd8739ae039 = $57dbb05d87d784b1$export$63fa379ae8a9ba2;


function $2efa7f87d37460af$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $06d8a0c3d04b605b$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $06d8a0c3d04b605b$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $3db87186a9f4bd75$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$2efa7f87d37460af$export$2e2bcd8739ae039 = $2efa7f87d37460af$export$4a02e9c37dab4871;



function $c8148e08909dec9f$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$c8148e08909dec9f$export$2e2bcd8739ae039 = $c8148e08909dec9f$export$f91e89d3d0406102;



function $91e2016da4677cfd$export$d3b42cd8452deec(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $2efa7f87d37460af$export$4a02e9c37dab4871)(_date, (0, $c8148e08909dec9f$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$91e2016da4677cfd$export$2e2bcd8739ae039 = $91e2016da4677cfd$export$d3b42cd8452deec;





function $10fdba42ef8f2c78$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $5ff879255cceef79$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$10fdba42ef8f2c78$export$2e2bcd8739ae039 = $10fdba42ef8f2c78$export$42c81a444fbfb5d4;


function $917d7c36fbb881c1$export$6173213f95a4431e(date, options) {
    return (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$917d7c36fbb881c1$export$2e2bcd8739ae039 = $917d7c36fbb881c1$export$6173213f95a4431e;






function $f53d9190328080a0$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $a960433738d4e8b2$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $917d7c36fbb881c1$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $a960433738d4e8b2$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $917d7c36fbb881c1$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$f53d9190328080a0$export$2e2bcd8739ae039 = $f53d9190328080a0$export$3dbc52535f6f8fcc;



function $cbf7dc07f7e05b43$export$236bdfa374eb69a9(date, options) {
    const year = (0, $f53d9190328080a0$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $917d7c36fbb881c1$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$cbf7dc07f7e05b43$export$2e2bcd8739ae039 = $cbf7dc07f7e05b43$export$236bdfa374eb69a9;



function $661b8d7938fc9bab$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $917d7c36fbb881c1$export$6173213f95a4431e)(_date) - +(0, $cbf7dc07f7e05b43$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $3db87186a9f4bd75$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$661b8d7938fc9bab$export$2e2bcd8739ae039 = $661b8d7938fc9bab$export$7cabdc5698b63e2f;











function $bdb8160eeea7b4d7$export$12d572480ceb6e58(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $5ff879255cceef79$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$bdb8160eeea7b4d7$export$2e2bcd8739ae039 = $bdb8160eeea7b4d7$export$12d572480ceb6e58;



function $de5fa1a63ea4de25$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $5ff879255cceef79$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $bdb8160eeea7b4d7$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$de5fa1a63ea4de25$export$2e2bcd8739ae039 = $de5fa1a63ea4de25$export$bb7b45bb8e74da0f;



function $32bbc44c2faaf1af$export$efe19b760242b2fc(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(_date, options) - +(0, $de5fa1a63ea4de25$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $3db87186a9f4bd75$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$32bbc44c2faaf1af$export$2e2bcd8739ae039 = $32bbc44c2faaf1af$export$efe19b760242b2fc;



function $b164a40913e559cf$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $ba52b8b402ae4c06$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $b164a40913e559cf$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $71cc66dace0c089a$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $71cc66dace0c089a$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $bdb8160eeea7b4d7$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $b164a40913e559cf$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $f53d9190328080a0$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $b164a40913e559cf$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $b164a40913e559cf$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $b164a40913e559cf$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $32bbc44c2faaf1af$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $661b8d7938fc9bab$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $91e2016da4677cfd$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $b164a40913e559cf$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $b164a40913e559cf$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $b164a40913e559cf$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $71cc66dace0c089a$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $71cc66dace0c089a$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $71cc66dace0c089a$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $71cc66dace0c089a$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $71cc66dace0c089a$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $71cc66dace0c089a$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $ba52b8b402ae4c06$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $71cc66dace0c089a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $71cc66dace0c089a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $71cc66dace0c089a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $71cc66dace0c089a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $71cc66dace0c089a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $71cc66dace0c089a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $71cc66dace0c089a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $71cc66dace0c089a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $71cc66dace0c089a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $71cc66dace0c089a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $b164a40913e559cf$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $71cc66dace0c089a$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $b164a40913e559cf$export$c8306e720e213c0f)(minutes, 2);
}
function $71cc66dace0c089a$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $b164a40913e559cf$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $71cc66dace0c089a$var$formatTimezone(offset, delimiter);
}
function $71cc66dace0c089a$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $b164a40913e559cf$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $b164a40913e559cf$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $a26645436b6cda82$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $a26645436b6cda82$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $a26645436b6cda82$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $a26645436b6cda82$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $a26645436b6cda82$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $a26645436b6cda82$var$timeLongFormatter(timePattern, formatLong));
};
const $a26645436b6cda82$export$70cc8fd02856fd58 = {
    p: $a26645436b6cda82$var$timeLongFormatter,
    P: $a26645436b6cda82$var$dateTimeLongFormatter
};


const $f84ff0e8cd167fd6$var$dayOfYearTokenRE = /^D+$/;
const $f84ff0e8cd167fd6$var$weekYearTokenRE = /^Y+$/;
const $f84ff0e8cd167fd6$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $f84ff0e8cd167fd6$export$c6cc36aa33304772(token) {
    return $f84ff0e8cd167fd6$var$dayOfYearTokenRE.test(token);
}
function $f84ff0e8cd167fd6$export$c6b49d6dceb604a1(token) {
    return $f84ff0e8cd167fd6$var$weekYearTokenRE.test(token);
}
function $f84ff0e8cd167fd6$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $f84ff0e8cd167fd6$var$message(token, format, input);
    console.warn(_message);
    if ($f84ff0e8cd167fd6$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $f84ff0e8cd167fd6$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $0aae887686bd5a23$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$0aae887686bd5a23$export$2e2bcd8739ae039 = $0aae887686bd5a23$export$871608497c498473;



function $31ea96f9e7ca8d70$export$1ea939691cdc45b8(date) {
    return !(!(0, $0aae887686bd5a23$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$31ea96f9e7ca8d70$export$2e2bcd8739ae039 = $31ea96f9e7ca8d70$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $7aa2e35e5d01626e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $7aa2e35e5d01626e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $7aa2e35e5d01626e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $7aa2e35e5d01626e$var$doubleQuoteRegExp = /''/g;
const $7aa2e35e5d01626e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7aa2e35e5d01626e$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $5ff879255cceef79$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $ebb1e9b94c2ad9db$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $31ea96f9e7ca8d70$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($7aa2e35e5d01626e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $a26645436b6cda82$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($7aa2e35e5d01626e$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $7aa2e35e5d01626e$var$cleanEscapedString(substring)
        };
        if ((0, $71cc66dace0c089a$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($7aa2e35e5d01626e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $f84ff0e8cd167fd6$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $f84ff0e8cd167fd6$export$c6cc36aa33304772)(token)) (0, $f84ff0e8cd167fd6$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $71cc66dace0c089a$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $7aa2e35e5d01626e$var$cleanEscapedString(input) {
    const matched = input.match($7aa2e35e5d01626e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($7aa2e35e5d01626e$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$7aa2e35e5d01626e$export$2e2bcd8739ae039 = $7aa2e35e5d01626e$export$d9468344d3651243;


function $cb7d93512cb8fc54$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$cb7d93512cb8fc54$export$2e2bcd8739ae039 = $cb7d93512cb8fc54$export$a5a3b454ada2268e;


/**
 * @author Ahmed Serag
 * @date 2021-07-02
 * @description Implementation of Analytics context that
 * holds meta info about the current analytics.
 * @filename analytics-context.ts
 */ 
var $igtsr = parcelRequire("igtsr");
const $93880734d471a57f$export$3cbe56a0cabcff38 = $igtsr.createContext({
    project: null,
    settings: null,
    setProject: null,
    currentPeriod: null,
    updateCurrentPeriod: null,
    comparedPeriod: null,
    updateComparedPeriod: null,
    loadSettings: null,
    appliedFilters: null,
    appliedFiltersSegment: null,
    updateFiltersSegments: null,
    updateAppliedFiltersSegment: null,
    updateAppliedFilters: null,
    updateAppearanceSettings: null,
    addUpdatesListener: null,
    removeUpdatesListener: null,
    updateUrlQueryParams: null,
    updateListingType: null,
    availableFilters: null,
    isCreateANewSegmentOpen: null,
    toggleCreateANewSegment: null,
    availableFiltersSegments: null,
    loadingFiltersSegments: null,
    loadingFilters: null,
    showIntegrationKeysModal: null,
    hideIntegrationKeysModal: null,
    showExceedingOrdersLimitModal: null,
    hideExceedingOrdersLimitModal: null,
    showingExceedingOrdersLimitModal: null,
    isIntegrated: null
});


/**
 * @author Ahmed Serag
 * @date 2019-07-13
 * @description user authentication utilities
 * @filename authenticator.ts
 */ var $3abef3dcb9203e3d$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $3abef3dcb9203e3d$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$3abef3dcb9203e3d$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$3abef3dcb9203e3d$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$3abef3dcb9203e3d$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $3abef3dcb9203e3d$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $3abef3dcb9203e3d$var$DIGIT_REGEX = /^\d+$/, $3abef3dcb9203e3d$var$LEAD_DIGIT_REGEX = /^\d/, $3abef3dcb9203e3d$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $3abef3dcb9203e3d$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $3abef3dcb9203e3d$var$MAX_CACHE_SIZE = 512;
var $3abef3dcb9203e3d$var$pathCache = new $3abef3dcb9203e3d$var$Cache($3abef3dcb9203e3d$var$MAX_CACHE_SIZE), $3abef3dcb9203e3d$var$setCache = new $3abef3dcb9203e3d$var$Cache($3abef3dcb9203e3d$var$MAX_CACHE_SIZE), $3abef3dcb9203e3d$var$getCache = new $3abef3dcb9203e3d$var$Cache($3abef3dcb9203e3d$var$MAX_CACHE_SIZE);
var $3abef3dcb9203e3d$var$config;
$3abef3dcb9203e3d$exports = {
    Cache: $3abef3dcb9203e3d$var$Cache,
    split: $3abef3dcb9203e3d$var$split,
    normalizePath: $3abef3dcb9203e3d$var$normalizePath,
    setter: function(path) {
        var parts = $3abef3dcb9203e3d$var$normalizePath(path);
        return $3abef3dcb9203e3d$var$setCache.get(path) || $3abef3dcb9203e3d$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $3abef3dcb9203e3d$var$normalizePath(path);
        return $3abef3dcb9203e3d$var$getCache.get(path) || $3abef3dcb9203e3d$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($3abef3dcb9203e3d$var$isQuoted(part) || $3abef3dcb9203e3d$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $3abef3dcb9203e3d$var$forEach(Array.isArray(path) ? path : $3abef3dcb9203e3d$var$split(path), cb, thisArg);
    }
};
function $3abef3dcb9203e3d$var$normalizePath(path) {
    return $3abef3dcb9203e3d$var$pathCache.get(path) || $3abef3dcb9203e3d$var$pathCache.set(path, $3abef3dcb9203e3d$var$split(path).map(function(part) {
        return part.replace($3abef3dcb9203e3d$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $3abef3dcb9203e3d$var$split(path) {
    return path.match($3abef3dcb9203e3d$var$SPLIT_REGEX) || [
        ''
    ];
}
function $3abef3dcb9203e3d$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($3abef3dcb9203e3d$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $3abef3dcb9203e3d$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $3abef3dcb9203e3d$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $3abef3dcb9203e3d$var$hasLeadingNumber(part) {
    return part.match($3abef3dcb9203e3d$var$LEAD_DIGIT_REGEX) && !part.match($3abef3dcb9203e3d$var$DIGIT_REGEX);
}
function $3abef3dcb9203e3d$var$hasSpecialChars(part) {
    return $3abef3dcb9203e3d$var$SPEC_CHAR_REGEX.test(part);
}
function $3abef3dcb9203e3d$var$shouldBeQuoted(part) {
    return !$3abef3dcb9203e3d$var$isQuoted(part) && ($3abef3dcb9203e3d$var$hasLeadingNumber(part) || $3abef3dcb9203e3d$var$hasSpecialChars(part));
}


var $51ece5261830ba18$exports = {};
const $51ece5261830ba18$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $51ece5261830ba18$var$words = (str)=>str.match($51ece5261830ba18$var$reWords) || [];
const $51ece5261830ba18$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $51ece5261830ba18$var$join = (str, d)=>$51ece5261830ba18$var$words(str).join(d).toLowerCase();
const $51ece5261830ba18$var$camelCase = (str)=>$51ece5261830ba18$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $51ece5261830ba18$var$pascalCase = (str)=>$51ece5261830ba18$var$upperFirst($51ece5261830ba18$var$camelCase(str));
const $51ece5261830ba18$var$snakeCase = (str)=>$51ece5261830ba18$var$join(str, '_');
const $51ece5261830ba18$var$kebabCase = (str)=>$51ece5261830ba18$var$join(str, '-');
const $51ece5261830ba18$var$sentenceCase = (str)=>$51ece5261830ba18$var$upperFirst($51ece5261830ba18$var$join(str, ' '));
const $51ece5261830ba18$var$titleCase = (str)=>$51ece5261830ba18$var$words(str).map($51ece5261830ba18$var$upperFirst).join(' ');
$51ece5261830ba18$exports = {
    words: $51ece5261830ba18$var$words,
    upperFirst: $51ece5261830ba18$var$upperFirst,
    camelCase: $51ece5261830ba18$var$camelCase,
    pascalCase: $51ece5261830ba18$var$pascalCase,
    snakeCase: $51ece5261830ba18$var$snakeCase,
    kebabCase: $51ece5261830ba18$var$kebabCase,
    sentenceCase: $51ece5261830ba18$var$sentenceCase,
    titleCase: $51ece5261830ba18$var$titleCase
};


var $793c12413a7c555d$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $793c12413a7c555d$exports = function(edges) {
    return $793c12413a7c555d$var$toposort($793c12413a7c555d$var$uniqueNodes(edges), edges);
};
$793c12413a7c555d$exports.array = $793c12413a7c555d$var$toposort;
function $793c12413a7c555d$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $793c12413a7c555d$var$makeOutgoingEdges(edges), nodesHash = $793c12413a7c555d$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $793c12413a7c555d$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $793c12413a7c555d$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $793c12413a7c555d$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $91e1faf1710dcf23$var$toString = Object.prototype.toString;
const $91e1faf1710dcf23$var$errorToString = Error.prototype.toString;
const $91e1faf1710dcf23$var$regExpToString = RegExp.prototype.toString;
const $91e1faf1710dcf23$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $91e1faf1710dcf23$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $91e1faf1710dcf23$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $91e1faf1710dcf23$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $91e1faf1710dcf23$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $91e1faf1710dcf23$var$symbolToString.call(val).replace($91e1faf1710dcf23$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $91e1faf1710dcf23$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $91e1faf1710dcf23$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $91e1faf1710dcf23$var$regExpToString.call(val);
    return null;
}
function $91e1faf1710dcf23$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $91e1faf1710dcf23$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $91e1faf1710dcf23$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $91e1faf1710dcf23$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $91e1faf1710dcf23$var$_Symbol$toStringTag, $91e1faf1710dcf23$var$_Symbol$hasInstance, $91e1faf1710dcf23$var$_Symbol$toStringTag2;
let $91e1faf1710dcf23$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$91e1faf1710dcf23$var$_Symbol$toStringTag = Symbol.toStringTag;
class $91e1faf1710dcf23$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$91e1faf1710dcf23$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $91e1faf1710dcf23$var$toArray(errorOrErrors).forEach((err)=>{
            if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$91e1faf1710dcf23$var$_Symbol$hasInstance = Symbol.hasInstance;
$91e1faf1710dcf23$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $91e1faf1710dcf23$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($91e1faf1710dcf23$var$strReg, (_, key)=>$91e1faf1710dcf23$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $91e1faf1710dcf23$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$91e1faf1710dcf23$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $91e1faf1710dcf23$export$2191b9da168c6cf0);
    }
    static [$91e1faf1710dcf23$var$_Symbol$hasInstance](inst) {
        return $91e1faf1710dcf23$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $91e1faf1710dcf23$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$91e1faf1710dcf23$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$91e1faf1710dcf23$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$91e1faf1710dcf23$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $91e1faf1710dcf23$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $91e1faf1710dcf23$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $91e1faf1710dcf23$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $91e1faf1710dcf23$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $91e1faf1710dcf23$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $91e1faf1710dcf23$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $91e1faf1710dcf23$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$91e1faf1710dcf23$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$91e1faf1710dcf23$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $91e1faf1710dcf23$export$2191b9da168c6cf0.formatError($91e1faf1710dcf23$var$mixed.notType, params);
    }
};
var $91e1faf1710dcf23$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $91e1faf1710dcf23$var$mixed,
    string: $91e1faf1710dcf23$var$string,
    number: $91e1faf1710dcf23$var$number,
    date: $91e1faf1710dcf23$var$date,
    object: $91e1faf1710dcf23$var$object,
    array: $91e1faf1710dcf23$var$array,
    boolean: $91e1faf1710dcf23$var$boolean,
    tuple: $91e1faf1710dcf23$var$tuple
});
const $91e1faf1710dcf23$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $91e1faf1710dcf23$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $91e1faf1710dcf23$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$91e1faf1710dcf23$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $91e1faf1710dcf23$var$prefixes = {
    context: '$',
    value: '.'
};
function $91e1faf1710dcf23$export$eff4d24c3ff7876e(key, options) {
    return new $91e1faf1710dcf23$var$Reference(key, options);
}
class $91e1faf1710dcf23$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $91e1faf1710dcf23$var$prefixes.context;
        this.isValue = this.key[0] === $91e1faf1710dcf23$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $91e1faf1710dcf23$var$prefixes.context : this.isValue ? $91e1faf1710dcf23$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $3abef3dcb9203e3d$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$91e1faf1710dcf23$var$Reference.prototype.__isYupRef = true;
const $91e1faf1710dcf23$var$isAbsent = (value)=>value == null;
function $91e1faf1710dcf23$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $91e1faf1710dcf23$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $91e1faf1710dcf23$export$2191b9da168c6cf0($91e1faf1710dcf23$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $91e1faf1710dcf23$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $91e1faf1710dcf23$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $3abef3dcb9203e3d$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $91e1faf1710dcf23$export$cfedb76369cc7782(obj, path, value, context) {
    return $91e1faf1710dcf23$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $91e1faf1710dcf23$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($91e1faf1710dcf23$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $91e1faf1710dcf23$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $91e1faf1710dcf23$var$clone(src, seen = new Map()) {
    if ($91e1faf1710dcf23$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $91e1faf1710dcf23$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $91e1faf1710dcf23$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($91e1faf1710dcf23$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $91e1faf1710dcf23$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $91e1faf1710dcf23$var$ReferenceSet();
        this._blacklist = new $91e1faf1710dcf23$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($91e1faf1710dcf23$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $91e1faf1710dcf23$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $91e1faf1710dcf23$var$isAbsent(result)) return result;
            let formattedValue = $91e1faf1710dcf23$export$5790025c6e6c2ba6(value);
            let formattedResult = $91e1faf1710dcf23$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $91e1faf1710dcf23$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $91e1faf1710dcf23$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $91e1faf1710dcf23$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $91e1faf1710dcf23$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $91e1faf1710dcf23$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $91e1faf1710dcf23$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $91e1faf1710dcf23$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $91e1faf1710dcf23$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $91e1faf1710dcf23$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $91e1faf1710dcf23$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $91e1faf1710dcf23$var$toArray(keys).map((key)=>new $91e1faf1710dcf23$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $91e1faf1710dcf23$var$Condition(deps, options) : $91e1faf1710dcf23$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $91e1faf1710dcf23$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $91e1faf1710dcf23$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $91e1faf1710dcf23$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $91e1faf1710dcf23$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $91e1faf1710dcf23$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$91e1faf1710dcf23$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$91e1faf1710dcf23$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $91e1faf1710dcf23$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$91e1faf1710dcf23$export$19342e026b58ebb7.prototype[alias] = $91e1faf1710dcf23$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$91e1faf1710dcf23$export$19342e026b58ebb7.prototype[alias] = $91e1faf1710dcf23$export$19342e026b58ebb7.prototype.notOneOf;
const $91e1faf1710dcf23$var$returnsTrue = ()=>true;
function $91e1faf1710dcf23$export$9b30b6294c1449a8(spec) {
    return new $91e1faf1710dcf23$export$1e88358c94ddec71(spec);
}
class $91e1faf1710dcf23$export$1e88358c94ddec71 extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $91e1faf1710dcf23$var$returnsTrue
        }, spec));
    }
}
$91e1faf1710dcf23$export$9b30b6294c1449a8.prototype = $91e1faf1710dcf23$export$1e88358c94ddec71.prototype;
function $91e1faf1710dcf23$export$87b259aa03e3d267() {
    return new $91e1faf1710dcf23$export$c7980688f11e1f49();
}
class $91e1faf1710dcf23$export$c7980688f11e1f49 extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $91e1faf1710dcf23$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $91e1faf1710dcf23$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $91e1faf1710dcf23$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $91e1faf1710dcf23$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$91e1faf1710dcf23$export$87b259aa03e3d267.prototype = $91e1faf1710dcf23$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $91e1faf1710dcf23$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $91e1faf1710dcf23$var$parseIsoDate(date) {
    const struct = $91e1faf1710dcf23$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $91e1faf1710dcf23$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $91e1faf1710dcf23$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $91e1faf1710dcf23$var$toNumber(regexResult[1]),
        month: $91e1faf1710dcf23$var$toNumber(regexResult[2], 1) - 1,
        day: $91e1faf1710dcf23$var$toNumber(regexResult[3], 1),
        hour: $91e1faf1710dcf23$var$toNumber(regexResult[4]),
        minute: $91e1faf1710dcf23$var$toNumber(regexResult[5]),
        second: $91e1faf1710dcf23$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $91e1faf1710dcf23$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $91e1faf1710dcf23$var$toNumber(regexResult[10]),
        minuteOffset: $91e1faf1710dcf23$var$toNumber(regexResult[11])
    };
}
function $91e1faf1710dcf23$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $91e1faf1710dcf23$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $91e1faf1710dcf23$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $91e1faf1710dcf23$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $91e1faf1710dcf23$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $91e1faf1710dcf23$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $91e1faf1710dcf23$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $91e1faf1710dcf23$var$rIsoDateTime = new RegExp(`${$91e1faf1710dcf23$var$yearMonthDay}T${$91e1faf1710dcf23$var$hourMinuteSecond}(\\.\\d+)?${$91e1faf1710dcf23$var$zOrOffset}$`);
let $91e1faf1710dcf23$var$isTrimmed = (value)=>$91e1faf1710dcf23$var$isAbsent(value) || value === value.trim();
let $91e1faf1710dcf23$var$objStringTag = ({}).toString();
function $91e1faf1710dcf23$export$22b082955e083ec3() {
    return new $91e1faf1710dcf23$export$49bf8b2ede5138eb();
}
class $91e1faf1710dcf23$export$49bf8b2ede5138eb extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $91e1faf1710dcf23$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $91e1faf1710dcf23$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $91e1faf1710dcf23$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $91e1faf1710dcf23$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $91e1faf1710dcf23$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $91e1faf1710dcf23$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $91e1faf1710dcf23$var$string.email) {
        return this.matches($91e1faf1710dcf23$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $91e1faf1710dcf23$var$string.url) {
        return this.matches($91e1faf1710dcf23$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $91e1faf1710dcf23$var$string.uuid) {
        return this.matches($91e1faf1710dcf23$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($91e1faf1710dcf23$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $91e1faf1710dcf23$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $91e1faf1710dcf23$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $91e1faf1710dcf23$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $91e1faf1710dcf23$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $91e1faf1710dcf23$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $91e1faf1710dcf23$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $91e1faf1710dcf23$var$isTrimmed
        });
    }
    lowercase(message = $91e1faf1710dcf23$var$string.lowercase) {
        return this.transform((value)=>!$91e1faf1710dcf23$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$91e1faf1710dcf23$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $91e1faf1710dcf23$var$string.uppercase) {
        return this.transform((value)=>!$91e1faf1710dcf23$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$91e1faf1710dcf23$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$91e1faf1710dcf23$export$22b082955e083ec3.prototype = $91e1faf1710dcf23$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $91e1faf1710dcf23$var$isNaN$1 = (value)=>value != +value;
function $91e1faf1710dcf23$export$98e628dec113755e() {
    return new $91e1faf1710dcf23$export$f192ec5e9228ab19();
}
class $91e1faf1710dcf23$export$f192ec5e9228ab19 extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$91e1faf1710dcf23$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $91e1faf1710dcf23$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $91e1faf1710dcf23$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $91e1faf1710dcf23$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $91e1faf1710dcf23$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $91e1faf1710dcf23$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $91e1faf1710dcf23$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $91e1faf1710dcf23$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$91e1faf1710dcf23$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$91e1faf1710dcf23$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$91e1faf1710dcf23$export$98e628dec113755e.prototype = $91e1faf1710dcf23$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $91e1faf1710dcf23$var$invalidDate = new Date('');
let $91e1faf1710dcf23$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $91e1faf1710dcf23$export$324d90190a8b822a() {
    return new $91e1faf1710dcf23$export$18ec3cc5a157503f();
}
class $91e1faf1710dcf23$export$18ec3cc5a157503f extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $91e1faf1710dcf23$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $91e1faf1710dcf23$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $91e1faf1710dcf23$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$91e1faf1710dcf23$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $91e1faf1710dcf23$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $91e1faf1710dcf23$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$91e1faf1710dcf23$export$18ec3cc5a157503f.INVALID_DATE = $91e1faf1710dcf23$var$invalidDate;
$91e1faf1710dcf23$export$324d90190a8b822a.prototype = $91e1faf1710dcf23$export$18ec3cc5a157503f.prototype;
$91e1faf1710dcf23$export$324d90190a8b822a.INVALID_DATE = $91e1faf1710dcf23$var$invalidDate;
// @ts-expect-error
function $91e1faf1710dcf23$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $3abef3dcb9203e3d$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($91e1faf1710dcf23$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($91e1faf1710dcf23$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($793c12413a7c555d$exports))).array(Array.from(nodes), edges).reverse();
}
function $91e1faf1710dcf23$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $91e1faf1710dcf23$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $91e1faf1710dcf23$var$findIndex(keys, a) - $91e1faf1710dcf23$var$findIndex(keys, b);
    };
}
const $91e1faf1710dcf23$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $91e1faf1710dcf23$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $91e1faf1710dcf23$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $91e1faf1710dcf23$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($91e1faf1710dcf23$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $91e1faf1710dcf23$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $3abef3dcb9203e3d$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $3abef3dcb9203e3d$exports.getter)((0, $3abef3dcb9203e3d$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $91e1faf1710dcf23$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $91e1faf1710dcf23$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $91e1faf1710dcf23$var$defaultSort = $91e1faf1710dcf23$var$sortByKeyOrder([]);
function $91e1faf1710dcf23$export$be5493f9613cbbe(spec) {
    return new $91e1faf1710dcf23$export$18b4fc70ec7eccf8(spec);
}
class $91e1faf1710dcf23$export$18b4fc70ec7eccf8 extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $91e1faf1710dcf23$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $91e1faf1710dcf23$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $91e1faf1710dcf23$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$91e1faf1710dcf23$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $91e1faf1710dcf23$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $91e1faf1710dcf23$var$sortFields(shape, excludedEdges);
        next._sortErrors = $91e1faf1710dcf23$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $91e1faf1710dcf23$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $3abef3dcb9203e3d$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($91e1faf1710dcf23$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($91e1faf1710dcf23$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $91e1faf1710dcf23$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $91e1faf1710dcf23$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $91e1faf1710dcf23$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $91e1faf1710dcf23$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $91e1faf1710dcf23$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $51ece5261830ba18$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $51ece5261830ba18$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $51ece5261830ba18$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$91e1faf1710dcf23$export$be5493f9613cbbe.prototype = $91e1faf1710dcf23$export$18b4fc70ec7eccf8.prototype;
function $91e1faf1710dcf23$export$2f23118c22fb2630(type) {
    return new $91e1faf1710dcf23$export$4347112b8447a7d(type);
}
class $91e1faf1710dcf23$export$4347112b8447a7d extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($91e1faf1710dcf23$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$91e1faf1710dcf23$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $91e1faf1710dcf23$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $91e1faf1710dcf23$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $91e1faf1710dcf23$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $91e1faf1710dcf23$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$91e1faf1710dcf23$export$2f23118c22fb2630.prototype = $91e1faf1710dcf23$export$4347112b8447a7d.prototype;
// @ts-ignore
function $91e1faf1710dcf23$export$65e3907585753458(schemas) {
    return new $91e1faf1710dcf23$export$411c3b3687e8ecc8(schemas);
}
class $91e1faf1710dcf23$export$411c3b3687e8ecc8 extends $91e1faf1710dcf23$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($91e1faf1710dcf23$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$91e1faf1710dcf23$export$65e3907585753458.prototype = $91e1faf1710dcf23$export$411c3b3687e8ecc8.prototype;
function $91e1faf1710dcf23$export$488013bae63b21da(builder) {
    return new $91e1faf1710dcf23$export$71117d144d3091c9(builder);
}
function $91e1faf1710dcf23$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $91e1faf1710dcf23$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$91e1faf1710dcf23$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $91e1faf1710dcf23$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $91e1faf1710dcf23$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $91e1faf1710dcf23$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($91e1faf1710dcf23$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $91e1faf1710dcf23$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $91e1faf1710dcf23$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $91e1faf1710dcf23$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$91e1faf1710dcf23$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}


/**
 * @author Ahmed Serag
 * @date 2021-07-13
 * @description implementation of authentication related API calls.
 * @filename authentication.ts
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * @author Ahmed Serag
 * @date 2019-07-16
 * @description implementation of network calls.
 * @filename network.ts
 */ /**
 * @author Ahmed Serag
 * @date 2020-07-21
 * @description declaration of available Error messages in the app.
 * @filename errors.ts
 */ /**
 * set of available errors in the App.
 */ const $88ccace404ab2902$export$4fd720569787ab6f = {
    validation: "Please make sure you are adding valid values.",
    unexpected: "Unexpected Error, please contact support.",
    noNetwork: "No Network connection. Please try again later.",
    createUser: {
        codeAlreadySent: 400
    }
};


class $dd8ae3fd35a35e58$export$95be4ae94445245a {
    /**
   * execute a request to a given url with given options
   *
   * @static
   * @param {string} url url of the request.
   * @param {RequestInit} init set of options sent with the url.
   * @returns {Promise<any>} promise to return the Json response of the request.
   * @memberof Network
   */ static fetch(url, init, addAuth = true) {
        return fetch(url, {
            mode: "cors",
            credentials: "include",
            ...init,
            headers: $dd8ae3fd35a35e58$export$95be4ae94445245a.getHeaders(init.headers, addAuth)
        }).catch((error)=>{
            return Promise.reject(error);
        }).then((response)=>{
            return $dd8ae3fd35a35e58$export$95be4ae94445245a.handleResponseBasedOnStatus(response);
        });
    }
    /**
   * get headers that should be added to the request.
   *
   * @static
   * @param {HeadersInit} [originalHeaders] optional headers to be
   * added/overwrite the default headers.
   * @returns {HeadersInit} headers object that needs to be added to the request.
   * @memberof Network
   */ static getHeaders(originalHeaders, addAuth = true) {
        const CookiesArray = document.cookie.split("=");
        const XSRFCookieIndex = CookiesArray.findIndex((z)=>z === "XSRF-TOKEN");
        const headers = originalHeaders ?? {
            "content-type": "application/json",
            accept: "application/json"
        };
        if (XSRFCookieIndex >= 0 && XSRFCookieIndex < CookiesArray.length) headers["X-XSRF-TOKEN"] = decodeURI(CookiesArray[XSRFCookieIndex + 1]);
        if (addAuth && localStorage.getItem("access_token")) headers["Authorization"] = `Bearer ${localStorage.getItem("access_token")}`;
        return headers;
    }
    /**
   * handle various types of errors from network request based on response status.
   *
   * @static
   * @param {Response} response response from network request
   * @returns {Promise<any>} promise to return an error with a specific message
   * @memberof Network
   */ static handleResponseBasedOnStatus(response) {
        let promise;
        switch(response.status){
            case 200:
            case 201:
                promise = response.json();
                break;
            case 204:
                promise = Promise.resolve();
                break;
            case 409:
                // trying to create a resource that
                // some of it's dependencies aren't available.
                promise = response.json().then((data)=>{
                    return Promise.reject(data);
                });
                break;
            case 422:
                promise = response.json().then((data)=>{
                    return Promise.reject(data && (data.errors || data.message));
                });
                break;
            case 401:
                // localStorage.removeItem(process.env.ACCESS_TOKEN_KEY);
                promise = response.json().then((data)=>{
                    return Promise.reject(data?.data ? data?.data : data?.message);
                });
                break;
            case 400:
                promise = response.json().then((data)=>{
                    return Promise.reject(data.message);
                });
                break;
            default:
                promise = response.json().then((data)=>{
                    return Promise.reject({
                        message: data?.message,
                        status: response.status
                    });
                });
        }
        return promise.catch((error)=>{
            return Promise.reject(error ?? (0, $88ccace404ab2902$export$4fd720569787ab6f).unexpected);
        });
    }
}


/**
 * @author Ahmed Serag
 * @date 2019-07-16
 * @description implementation of endpoints in the api.
 * @filename endpoints.ts
 */ /**
 * set of endpoints in the API.
 */ // eslint-disable-next-line object-curly-newline
const $b2d4fb2efd578b37$export$4a3a00e07ffce8bd = {
    overview: {
        method: "GET",
        path: "/overview"
    },
    orders: {
        method: "GET",
        path: "/orders"
    },
    ordersPerDay: {
        method: "GET",
        path: "/orders-breakdown"
    },
    payments: {
        method: "GET",
        path: "/payments"
    },
    customers: {
        method: "GET",
        path: "/customers"
    },
    customersPerDay: {
        method: "GET",
        path: "/customers-breakdown"
    },
    categories: {
        method: "GET",
        path: "/categories-items"
    },
    categoriesSalesExport: {
        method: "GET",
        path: "/categories-export"
    },
    items: {
        method: "GET",
        path: "/items"
    },
    productSummary: {
        method: "GET",
        path: "/product/summary"
    },
    productRecommendations: {
        method: "GET",
        path: "/product/recommendations"
    },
    relatedProducts: {
        method: "GET",
        path: "/product/bought-with"
    },
    projects: {
        method: "GET",
        path: "/projects"
    },
    categoriesSales: {
        method: "GET",
        path: "/categories-sales"
    },
    categoriesSalesChildren: {
        method: "GET",
        path: "/categories-sales/children"
    },
    stock: {
        method: "GET",
        path: "/stock"
    },
    customersCity: {
        method: "GET",
        path: "/customer-city"
    },
    customersCountry: {
        method: "GET",
        path: "/customer-country"
    },
    customersArea: {
        method: "GET",
        path: "/customer-area"
    },
    requestCSRF: {
        method: "GET",
        path: "/csrf-cookie"
    },
    register: {
        method: "POST",
        path: "/auth/register"
    },
    login: {
        method: "POST",
        path: "/auth/login"
    },
    logout: {
        method: "POST",
        path: "/auth/logout"
    },
    currentUser: {
        method: "GET",
        path: "/auth/current"
    },
    updateSettings: {
        method: "PATCH",
        path: "/project"
    },
    updateGoals: {
        method: "PATCH",
        path: "/goals"
    },
    getSettings: {
        method: "GET",
        path: "/projects"
    },
    support: {
        method: "POST",
        path: "/contact"
    },
    updateName: {
        method: "PATCH",
        path: "/auth/change-name"
    },
    updateEmail: {
        method: "PATCH",
        path: "/auth/change-email"
    },
    updatePassword: {
        method: "POST",
        path: "/auth/change-password"
    },
    brands: {
        method: "GET",
        path: "/brands"
    },
    requestPasswordReset: {
        method: "GET",
        path: "/auth/request-reset-password"
    },
    sendOTP: {
        method: "GET",
        path: "/auth/send-otp"
    },
    resetPassword: {
        method: "GET",
        path: "/auth/reset-password"
    },
    setPassword: {
        method: "PATCH",
        path: "/create-user/set-password"
    },
    brandsItemsSales: {
        method: "GET",
        path: "/brand-items"
    },
    customersSpending: {
        method: "GET",
        path: "/customer-segmentation/revenue"
    },
    customersSpentOrderedMore: {
        method: "GET",
        path: "/customer-segmentation/order"
    },
    changeLanguage: {
        method: "PATCH",
        path: "/change-language"
    },
    getSignature: {
        method: "GET",
        path: "/payment/get-signature"
    },
    getCards: {
        method: "GET",
        path: "/payment/cards"
    },
    setDefaultCard: {
        method: "POST",
        path: "/payment/set-card-default"
    },
    deleteCard: {
        method: "POST",
        path: "/payment/delete-card"
    },
    searchItem: {
        method: "GET",
        path: "/product-listing"
    },
    deleteLogo: {
        method: "DELETE",
        path: "/logo"
    },
    getAbandonedCarts: {
        method: "GET",
        path: "/abandoned-carts"
    },
    mostSearchedTerms: {
        method: "GET",
        path: "/search-terms"
    },
    getAllUsers: {
        method: "GET",
        path: "/user-management/get-users"
    },
    getAllRoles: {
        method: "GET",
        path: "/user-management/get-roles"
    },
    deleteUser: {
        method: "DELETE",
        path: "/user-management/delete-user"
    },
    editUserRole: {
        method: "PATCH",
        path: "/user-management/edit-role"
    },
    addUser: {
        method: "POST",
        path: "/user-management/add-user"
    },
    orderHourlyBreakdown: {
        method: "GET",
        path: "/orders-hour-breakdown"
    },
    getLoyaltyPoints: {
        method: "GET",
        path: "/reward-points/summary"
    },
    getLoyaltyPointsPerDay: {
        method: "GET",
        path: "/reward-points/breakdown"
    },
    exportLoyalPoints: {
        method: "GET",
        path: "/reward-points/export"
    },
    getPromoCodes: {
        method: "GET",
        path: "/promocodes/summary"
    },
    exportPromoCodes: {
        method: "GET",
        path: "/promocodes/export"
    },
    getActivityLogs: {
        method: "GET",
        path: "/activity-log"
    },
    deleteAccount: {
        method: "DELETE",
        path: "/auth/user"
    },
    overviewStockRecommendations: {
        method: "GET",
        path: "/recommendation/stock"
    },
    overviewPromotionRecommendations: {
        method: "GET",
        path: "/recommendation/promotion"
    },
    overviewBundleRecommendations: {
        method: "GET",
        path: "/recommendation/bundle"
    },
    getSpecificPageSummary: {
        method: "GET",
        path: "/ga4/page"
    },
    getAllGA4PagesSummary: {
        method: "GET",
        path: "/ga4/summary"
    },
    setGA4PropertyId: {
        method: "PATCH",
        path: "/ga4/set-property-id"
    },
    deleteGA4PropertyId: {
        method: "PATCH",
        path: "/ga4/delete-property-id"
    },
    enableTwoFactorAuthentication: {
        method: "POST",
        path: "/auth/enable-tfa"
    },
    validateTwoFactorAuthentication: {
        method: "POST",
        path: "/auth/validate-tfa-code"
    },
    disableTwoFactorAuthentication: {
        method: "POST",
        path: "/auth/disable-tfa"
    },
    getPricings: {
        method: "GET",
        path: "/pricing"
    },
    getOrdersSinceLastSubscription: {
        method: "GET",
        path: "/subscriptions/upcoming-subscription"
    },
    ordersRevenueBreakdown: {
        method: "GET",
        path: "/orders-revenue-breakdown"
    },
    unsubscribe: {
        method: "POST",
        path: "/subscriptions/unsubscribe"
    },
    advancedFilters: {
        method: "GET",
        path: "/filters"
    },
    signup: {
        method: "POST",
        path: "/auth/register"
    },
    getProjectKeys: {
        method: "GET",
        path: "/keys"
    },
    changeTier: {
        method: "POST",
        path: "/subscriptions/change-tier"
    },
    subscribe: {
        method: "POST",
        path: "/subscriptions/subscribe"
    },
    getChangeTierInfo: {
        method: "POST",
        path: "/subscriptions/change-tier-info"
    },
    confirmRegistration: {
        method: "GET",
        path: "/auth/confirmation-registration"
    },
    customerSegmentsByType: {
        method: "GET",
        path: "/customer-segmentation/segments"
    },
    createSegment: {
        method: "POST",
        path: "/filters-segments"
    },
    getAllFiltersSegments: {
        method: "GET",
        path: "/filters-segments"
    },
    deleteFiltersSegment: {
        method: "DELETE",
        path: "/filters-segments"
    },
    updateFiltersSegment: {
        method: "PUT",
        path: "/filters-segments"
    },
    getStripeBalance: {
        method: "GET",
        path: "/stripe/balance"
    },
    getCancelledOrdersPercentage: {
        method: "GET",
        path: "/canceled-orders/percentage"
    },
    getTopProductsInCancelledOrders: {
        method: "GET",
        path: "/canceled-orders/top-products"
    },
    getTopCategoriesInCancelledOrders: {
        method: "GET",
        path: "/canceled-orders/top-categories"
    },
    getTopBrandsInCancelledOrders: {
        method: "GET",
        path: "/canceled-orders/top-brands"
    },
    getCancelledOrdersByPaymentMethodPercentage: {
        method: "GET",
        path: "/canceled-orders/percentage/by-payment-method"
    },
    getCancelledOrdersByOrderSourcePercentage: {
        method: "GET",
        path: "/canceled-orders/percentage/by-order-source"
    },
    getCancelledOrdersByFilterSegmentPercentage: {
        method: "GET",
        path: "/canceled-orders/percentage/by-filter-segments"
    },
    getCancelledOrdersBreakdown: {
        method: "GET",
        path: "/canceled-orders/breakdown"
    },
    getCustomersCountBySegment: {
        method: "GET",
        path: "/customers/segment-count"
    }
};


class $de34386d48a688b6$export$d9e3c9dc7eaad0c3 {
    static requestCSRF() {
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(`${"https://backend.analytics-dashboard.ecommbeta.com/sanctum"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).requestCSRF.path}`, {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).requestCSRF.method
        });
    }
    static async login(email, password, otp) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).login.path}`);
        url.searchParams.append("email", email);
        url.searchParams.append("password", password);
        if (otp) url.searchParams.append("otp", otp);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).login.method
        }).then((result)=>{
            const token = result.data["access-token"]?.token;
            localStorage.setItem("access_token", token);
            return result;
        });
    }
    static async logout() {
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).logout.path}`, {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).logout.method
        });
    }
    static currentUser() {
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).currentUser.path}`, {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).currentUser.method
        });
    }
    /**
   * handles sending a request to the server to reset the password.
   * @param email email of the user to send the otp to.
   * @returns
   */ static requestResetPassword(email) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).requestPasswordReset.path}`);
        url.searchParams.append("email", email);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).requestPasswordReset.method
        });
    }
    static validateOTP(email, otp) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).sendOTP.path}`);
        url.searchParams.append("email", email);
        url.searchParams.append("otp", otp);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).sendOTP.method
        });
    }
    /**
   * handles sending the reset password request for the given email
   * @param email
   * @param newPassword
   * @param otp
   * @returns
   */ static resetPassword(email, newPassword, otp) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).resetPassword.path}`);
        url.searchParams.append("email", email);
        url.searchParams.append("password", newPassword);
        url.searchParams.append("otp", otp);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).resetPassword.method
        });
    }
    /**
   * handles sending a request to the server to set the user's password.
   * @param password
   * @param registration_key
   */ static setPassword(password, registration_key) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).setPassword.path}`);
        url.searchParams.append("password", password);
        url.searchParams.append("registration_key", registration_key);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).setPassword.method
        });
    }
    /**
   * handles sending a request to the server to register a new user.
   * @param payload
   */ static signup({ businessName: businessName, email: email, name: name, password: password, platformProvider: platformProvider, storeCategory: storeCategory, storeUrl: storeUrl }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).signup.path}`);
        url.searchParams.append("name", name);
        url.searchParams.append("email", email);
        url.searchParams.append("password", password);
        url.searchParams.append("store", platformProvider);
        url.searchParams.append("store_category", storeCategory);
        url.searchParams.append("project", businessName);
        url.searchParams.append("url", storeUrl);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).signup.method
        });
    }
    /**
   * handles sending token sent to user's email to confirm their registration
   * @param token
   * @returns
   */ static confirmRegistration(token) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).confirmRegistration.path}`);
        url.searchParams.append("registration_key", token);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).confirmRegistration.method
        });
    }
}


/**
 * This regex verifies the following (using positive lookahead):
 * - At least 1 lowercase letter /(?=.*[a-z])/
 * - At least 1 uppercase letter /(?=.*[A-Z])/
 * - At least 1 digit /(?=.*\d)/
 * - At least 1 special character (any character not in the previous classes /(?=.*[^A-Za-z0-9])/
 *
 * And then proceeds to match whatever's passed under these conditions, with
 * minimum length of 8 characters. /([A-Za-z0-9]|[^A-Za-z0-9]){8,}/
 */ const $ce34758010714942$export$1e515f3f466b5f = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])([A-Za-z0-9]|[^A-Za-z0-9]){8,}$/;
const $ce34758010714942$export$820ae0844b3faa33 = /((http(s)?):\/\/)?([(www.)?a-zA-Z0-9@:%.+~#=]{2,256}\.[a-z]{2,6}\b)([-a-zA-Z0-9@:%+.~#?&//=]*)/g;


/**
 * @author Ahmed Serag
 * @Date: 2019-6-13
 * @description Implementation of Common utilities.
 * @filename common.ts
 */ 

function $84d943fac3f3650c$export$5f53493861eef879(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$84d943fac3f3650c$export$2e2bcd8739ae039 = $84d943fac3f3650c$export$5f53493861eef879;


function $938b9f25b96c36ea$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$938b9f25b96c36ea$export$2e2bcd8739ae039 = $938b9f25b96c36ea$export$8b7aa55c66d5569e;


function $1dda55d8fd4fe3e4$export$69be7267a042ecb3(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$1dda55d8fd4fe3e4$export$2e2bcd8739ae039 = $1dda55d8fd4fe3e4$export$69be7267a042ecb3;


function $fe26748688766ab5$export$18c3c6510fb97afc(date) {
    return (0, $a960433738d4e8b2$export$ead8a1812b171991)(date, Date.now());
}
var // Fallback for modularized imports:
$fe26748688766ab5$export$2e2bcd8739ae039 = $fe26748688766ab5$export$18c3c6510fb97afc;


function $e6350463b071cfeb$export$23a16f3c6d143ce9(options) {
    const now = (0, $fe26748688766ab5$export$18c3c6510fb97afc)(options?.in);
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = (0, $fe26748688766ab5$export$18c3c6510fb97afc)(options?.in);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}
var // Fallback for modularized imports:
$e6350463b071cfeb$export$2e2bcd8739ae039 = $e6350463b071cfeb$export$23a16f3c6d143ce9;




function $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$c5c67e18df9fd9dd$export$2e2bcd8739ae039 = $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa;


function $3cd83cbb2ed0e87c$export$70823084e2deb1ea(date, amount, options) {
    return (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$3cd83cbb2ed0e87c$export$2e2bcd8739ae039 = $3cd83cbb2ed0e87c$export$70823084e2deb1ea;




function $74b0f385255d5f67$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$74b0f385255d5f67$export$2e2bcd8739ae039 = $74b0f385255d5f67$export$17c93e242b2d3a22;


function $377f863a28de0454$export$73d1c15a21f9fae5(date, amount, options) {
    return (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(date, -amount, options);
}
var // Fallback for modularized imports:
$377f863a28de0454$export$2e2bcd8739ae039 = $377f863a28de0454$export$73d1c15a21f9fae5;


function $d4cf8e20404fbe10$export$f93b5905241a7cca(date, duration, options) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    const withoutMonths = (0, $377f863a28de0454$export$73d1c15a21f9fae5)(date, months + years * 12, options);
    const withoutDays = (0, $3cd83cbb2ed0e87c$export$70823084e2deb1ea)(withoutMonths, days + weeks * 7, options);
    const minutesToSub = minutes + hours * 60;
    const secondsToSub = seconds + minutesToSub * 60;
    const msToSub = secondsToSub * 1000;
    return (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, +withoutDays - msToSub);
}
var // Fallback for modularized imports:
$d4cf8e20404fbe10$export$2e2bcd8739ae039 = $d4cf8e20404fbe10$export$f93b5905241a7cca;


function $a1e060f7fb7967de$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$a1e060f7fb7967de$export$2e2bcd8739ae039 = $a1e060f7fb7967de$export$3d83eec43f4ea476;


function $7d4b55ba1f18acf4$export$14867687ff6c92e2(date, amount, options) {
    return (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(date, -amount, options);
}
var // Fallback for modularized imports:
$7d4b55ba1f18acf4$export$2e2bcd8739ae039 = $7d4b55ba1f18acf4$export$14867687ff6c92e2;


const $d0d7e7d07316f3a2$var$isString = (obj)=>typeof obj === 'string';
const $d0d7e7d07316f3a2$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $d0d7e7d07316f3a2$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $d0d7e7d07316f3a2$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $d0d7e7d07316f3a2$var$lastOfPathSeparatorRegExp = /###/g;
const $d0d7e7d07316f3a2$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($d0d7e7d07316f3a2$var$lastOfPathSeparatorRegExp, '.') : key;
const $d0d7e7d07316f3a2$var$canNotTraverseDeeper = (object)=>!object || $d0d7e7d07316f3a2$var$isString(object);
const $d0d7e7d07316f3a2$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$d0d7e7d07316f3a2$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($d0d7e7d07316f3a2$var$canNotTraverseDeeper(object)) return {};
        const key = $d0d7e7d07316f3a2$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($d0d7e7d07316f3a2$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $d0d7e7d07316f3a2$var$cleanKey(stack[stackIndex])
    };
};
const $d0d7e7d07316f3a2$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $d0d7e7d07316f3a2$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $d0d7e7d07316f3a2$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $d0d7e7d07316f3a2$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $d0d7e7d07316f3a2$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $d0d7e7d07316f3a2$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $d0d7e7d07316f3a2$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $d0d7e7d07316f3a2$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $d0d7e7d07316f3a2$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $d0d7e7d07316f3a2$var$getPath(data, key);
    if (value !== undefined) return value;
    return $d0d7e7d07316f3a2$var$getPath(defaultData, key);
};
const $d0d7e7d07316f3a2$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($d0d7e7d07316f3a2$var$isString(target[prop]) || target[prop] instanceof String || $d0d7e7d07316f3a2$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $d0d7e7d07316f3a2$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $d0d7e7d07316f3a2$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $d0d7e7d07316f3a2$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $d0d7e7d07316f3a2$var$escape = (data)=>{
    if ($d0d7e7d07316f3a2$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$d0d7e7d07316f3a2$var$_entityMap[s]);
    return data;
};
class $d0d7e7d07316f3a2$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $d0d7e7d07316f3a2$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $d0d7e7d07316f3a2$var$looksLikeObjectPathRegExpCache = new $d0d7e7d07316f3a2$var$RegExpCache(20);
const $d0d7e7d07316f3a2$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $d0d7e7d07316f3a2$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $d0d7e7d07316f3a2$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $d0d7e7d07316f3a2$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $d0d7e7d07316f3a2$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $d0d7e7d07316f3a2$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $d0d7e7d07316f3a2$var$Logger {
    constructor(concreteLogger){
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options1);
    }
    init(concreteLogger) {
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options1.prefix || 'i18next:';
        this.logger = concreteLogger || $d0d7e7d07316f3a2$var$consoleLogger;
        this.options = options1;
        this.debug = options1.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($d0d7e7d07316f3a2$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $d0d7e7d07316f3a2$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options1) {
        options1 = options1 || this.options;
        options1.prefix = options1.prefix || this.prefix;
        return new $d0d7e7d07316f3a2$var$Logger(this.logger, options1);
    }
}
var $d0d7e7d07316f3a2$var$baseLogger = new $d0d7e7d07316f3a2$var$Logger();
class $d0d7e7d07316f3a2$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $d0d7e7d07316f3a2$var$ResourceStore extends $d0d7e7d07316f3a2$var$EventEmitter {
    constructor(data){
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options1.ignoreJSONStructure !== undefined ? options1.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($d0d7e7d07316f3a2$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $d0d7e7d07316f3a2$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$d0d7e7d07316f3a2$var$isString(key)) return result;
        return $d0d7e7d07316f3a2$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options1 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $d0d7e7d07316f3a2$var$setPath(this.data, path, value);
        if (!options1.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($d0d7e7d07316f3a2$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options1 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $d0d7e7d07316f3a2$var$getPath(this.data, path) || {};
        if (!options1.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $d0d7e7d07316f3a2$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $d0d7e7d07316f3a2$var$setPath(this.data, path, pack);
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $d0d7e7d07316f3a2$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options1, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options1, translator) ?? value;
        });
        return value;
    }
};
const $d0d7e7d07316f3a2$var$checkedLoadedFor = {};
const $d0d7e7d07316f3a2$var$shouldHandleAsObject = (res)=>!$d0d7e7d07316f3a2$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $d0d7e7d07316f3a2$var$Translator extends $d0d7e7d07316f3a2$var$EventEmitter {
    constructor(services){
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $d0d7e7d07316f3a2$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $d0d7e7d07316f3a2$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$d0d7e7d07316f3a2$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $d0d7e7d07316f3a2$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $d0d7e7d07316f3a2$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = opt.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$d0d7e7d07316f3a2$var$isString(opt.count);
        const hasDefaultValue = $d0d7e7d07316f3a2$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $d0d7e7d07316f3a2$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($d0d7e7d07316f3a2$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $d0d7e7d07316f3a2$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $d0d7e7d07316f3a2$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $d0d7e7d07316f3a2$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$d0d7e7d07316f3a2$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey?.[0] === args[0] && !opt.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $d0d7e7d07316f3a2$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $d0d7e7d07316f3a2$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys) {
        let opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($d0d7e7d07316f3a2$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$d0d7e7d07316f3a2$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($d0d7e7d07316f3a2$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$d0d7e7d07316f3a2$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $d0d7e7d07316f3a2$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options1);
        return this.resourceStore.getResource(code, ns, key, options1);
    }
    getUsedParamsDetails() {
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options1.replace && !$d0d7e7d07316f3a2$var$isString(options1.replace);
        let data = useOptionsReplaceForData ? options1.replace : options1;
        if (useOptionsReplaceForData && typeof options1.count !== 'undefined') data.count = options1.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options1) {
        const prefix = 'defaultValue';
        for(const option in options1){
            if (Object.prototype.hasOwnProperty.call(options1, option) && prefix === option.substring(0, prefix.length) && undefined !== options1[option]) return true;
        }
        return false;
    }
}
class $d0d7e7d07316f3a2$var$LanguageUtil {
    constructor(options1){
        this.options = options1;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $d0d7e7d07316f3a2$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $d0d7e7d07316f3a2$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $d0d7e7d07316f3a2$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($d0d7e7d07316f3a2$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($d0d7e7d07316f3a2$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($d0d7e7d07316f3a2$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($d0d7e7d07316f3a2$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $d0d7e7d07316f3a2$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $d0d7e7d07316f3a2$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $d0d7e7d07316f3a2$var$PluralResolver {
    constructor(languageUtils){
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options1;
        this.logger = $d0d7e7d07316f3a2$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const cleanedCode = $d0d7e7d07316f3a2$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options1.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $d0d7e7d07316f3a2$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $d0d7e7d07316f3a2$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options1);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code) {
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options1).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$d0d7e7d07316f3a2$var$suffixesOrder[pluralCategory1] - $d0d7e7d07316f3a2$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count) {
        let options1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options1);
        if (rule) return `${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options1);
    }
}
const $d0d7e7d07316f3a2$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $d0d7e7d07316f3a2$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $d0d7e7d07316f3a2$var$isString(key)) {
        path = $d0d7e7d07316f3a2$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $d0d7e7d07316f3a2$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $d0d7e7d07316f3a2$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $d0d7e7d07316f3a2$var$Interpolator {
    constructor(){
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $d0d7e7d07316f3a2$var$baseLogger.create('interpolator');
        this.options = options1;
        this.format = options1?.interpolation?.format || ((value)=>value);
        this.init(options1);
    }
    init() {
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options1.interpolation) options1.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options1.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $d0d7e7d07316f3a2$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $d0d7e7d07316f3a2$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $d0d7e7d07316f3a2$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $d0d7e7d07316f3a2$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $d0d7e7d07316f3a2$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $d0d7e7d07316f3a2$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $d0d7e7d07316f3a2$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options1) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $d0d7e7d07316f3a2$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options1,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($d0d7e7d07316f3a2$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options1,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options1?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options1?.interpolation?.skipOnVariables !== undefined ? options1.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$d0d7e7d07316f3a2$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $d0d7e7d07316f3a2$var$regexSafe(this.escape(val)) : $d0d7e7d07316f3a2$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options1);
                        value = $d0d7e7d07316f3a2$var$isString(temp) ? temp : '';
                    } else if (options1 && Object.prototype.hasOwnProperty.call(options1, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$d0d7e7d07316f3a2$var$isString(value) && !this.useRawValueToEscape) value = $d0d7e7d07316f3a2$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options1
            };
            clonedOptions = clonedOptions.replace && !$d0d7e7d07316f3a2$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$d0d7e7d07316f3a2$var$isString(value)) return value;
            if (!$d0d7e7d07316f3a2$var$isString(value)) value = $d0d7e7d07316f3a2$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options1.lng, {
                    ...options1,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $d0d7e7d07316f3a2$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $d0d7e7d07316f3a2$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options1)=>{
        let optForCache = options1;
        if (options1 && options1.interpolationkey && options1.formatParams && options1.formatParams[options1.interpolationkey] && options1[options1.interpolationkey]) optForCache = {
            ...optForCache,
            [options1.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($d0d7e7d07316f3a2$var$getCleanedCode(lng), options1);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $d0d7e7d07316f3a2$var$Formatter {
    constructor(){
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $d0d7e7d07316f3a2$var$baseLogger.create('formatter');
        this.options = options1;
        this.formats = {
            number: $d0d7e7d07316f3a2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $d0d7e7d07316f3a2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $d0d7e7d07316f3a2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $d0d7e7d07316f3a2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $d0d7e7d07316f3a2$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options1);
    }
    init(services) {
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options1.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $d0d7e7d07316f3a2$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $d0d7e7d07316f3a2$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options1?.formatParams?.[options1.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options1.locale || options1.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options1,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $d0d7e7d07316f3a2$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $d0d7e7d07316f3a2$var$Connector extends $d0d7e7d07316f3a2$var$EventEmitter {
    constructor(backend, store, services){
        let options1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options1;
        this.logger = $d0d7e7d07316f3a2$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options1.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options1.maxRetries >= 0 ? options1.maxRetries : 5;
        this.retryTimeout = options1.retryTimeout >= 1 ? options1.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options1.backend, options1);
    }
    queueLoad(languages, namespaces, options1, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options1.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $d0d7e7d07316f3a2$var$pushPath(q.loaded, [
                lng
            ], ns);
            $d0d7e7d07316f3a2$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($d0d7e7d07316f3a2$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($d0d7e7d07316f3a2$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options1, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options1 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options1,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $d0d7e7d07316f3a2$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($d0d7e7d07316f3a2$var$isString(args[1])) ret.defaultValue = args[1];
            if ($d0d7e7d07316f3a2$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options1 = args[3] || args[2];
                Object.keys(options1).forEach((key)=>{
                    ret[key] = options1[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $d0d7e7d07316f3a2$var$transformOptions = (options1)=>{
    if ($d0d7e7d07316f3a2$var$isString(options1.ns)) options1.ns = [
        options1.ns
    ];
    if ($d0d7e7d07316f3a2$var$isString(options1.fallbackLng)) options1.fallbackLng = [
        options1.fallbackLng
    ];
    if ($d0d7e7d07316f3a2$var$isString(options1.fallbackNS)) options1.fallbackNS = [
        options1.fallbackNS
    ];
    if (options1.supportedLngs?.indexOf?.('cimode') < 0) options1.supportedLngs = options1.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options1.initImmediate === 'boolean') options1.initAsync = options1.initImmediate;
    return options1;
};
const $d0d7e7d07316f3a2$var$noop = ()=>{};
const $d0d7e7d07316f3a2$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $d0d7e7d07316f3a2$var$I18n extends $d0d7e7d07316f3a2$var$EventEmitter {
    constructor(){
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $d0d7e7d07316f3a2$var$transformOptions(options1);
        this.services = {};
        this.logger = $d0d7e7d07316f3a2$var$baseLogger;
        this.modules = {
            external: []
        };
        $d0d7e7d07316f3a2$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options1.isClone) {
            if (!this.options.initAsync) {
                this.init(options1, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options1, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options1 === 'function') {
            callback = options1;
            options1 = {};
        }
        if (options1.defaultNS == null && options1.ns) {
            if ($d0d7e7d07316f3a2$var$isString(options1.ns)) options1.defaultNS = options1.ns;
            else if (options1.ns.indexOf('translation') < 0) options1.defaultNS = options1.ns[0];
        }
        const defOpts = $d0d7e7d07316f3a2$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$d0d7e7d07316f3a2$var$transformOptions(options1)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options1.keySeparator !== undefined) this.options.userDefinedKeySeparator = options1.keySeparator;
        if (options1.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options1.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $d0d7e7d07316f3a2$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $d0d7e7d07316f3a2$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $d0d7e7d07316f3a2$var$Formatter;
            const lu = new $d0d7e7d07316f3a2$var$LanguageUtil(this.options);
            this.store = new $d0d7e7d07316f3a2$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $d0d7e7d07316f3a2$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $d0d7e7d07316f3a2$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $d0d7e7d07316f3a2$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $d0d7e7d07316f3a2$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $d0d7e7d07316f3a2$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $d0d7e7d07316f3a2$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $d0d7e7d07316f3a2$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d0d7e7d07316f3a2$var$noop;
        let usedCallback = callback;
        const usedLng = $d0d7e7d07316f3a2$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $d0d7e7d07316f3a2$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $d0d7e7d07316f3a2$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $d0d7e7d07316f3a2$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $d0d7e7d07316f3a2$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $d0d7e7d07316f3a2$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($d0d7e7d07316f3a2$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let o;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                o = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${o.keyPrefix}${keySeparator}${k}`);
            else resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, o);
        };
        if ($d0d7e7d07316f3a2$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.translator?.translate(...args);
    }
    exists() {
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options1.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options1.precheck) {
            const preResult = options1.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $d0d7e7d07316f3a2$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($d0d7e7d07316f3a2$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $d0d7e7d07316f3a2$var$defer();
        if ($d0d7e7d07316f3a2$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $d0d7e7d07316f3a2$var$LanguageUtil($d0d7e7d07316f3a2$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $d0d7e7d07316f3a2$var$I18n(options1, callback);
    }
    cloneInstance() {
        let options1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d0d7e7d07316f3a2$var$noop;
        const forkResourceStore = options1.forkResourceStore;
        if (forkResourceStore) delete options1.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options1,
            isClone: true
        };
        const clone = new $d0d7e7d07316f3a2$var$I18n(mergedOptions);
        if (options1.debug !== undefined || options1.prefix !== undefined) clone.logger = clone.logger.clone(options1);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $d0d7e7d07316f3a2$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $d0d7e7d07316f3a2$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $d0d7e7d07316f3a2$export$2e2bcd8739ae039 = $d0d7e7d07316f3a2$var$I18n.createInstance();
$d0d7e7d07316f3a2$export$2e2bcd8739ae039.createInstance = $d0d7e7d07316f3a2$var$I18n.createInstance;
const $d0d7e7d07316f3a2$export$99152e8d49ca4e7d = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.createInstance;
const $d0d7e7d07316f3a2$export$147ec2801e896265 = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.dir;
const $d0d7e7d07316f3a2$export$2cd8252107eb640b = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.init;
const $d0d7e7d07316f3a2$export$d3d08d944062d7e = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.loadResources;
const $d0d7e7d07316f3a2$export$a5d9bf5d83fcab09 = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.reloadResources;
const $d0d7e7d07316f3a2$export$1f96ae73734a86cc = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.use;
const $d0d7e7d07316f3a2$export$61465194746e7fd2 = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.changeLanguage;
const $d0d7e7d07316f3a2$export$f90d180fc7da3b3b = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.getFixedT;
const $d0d7e7d07316f3a2$export$625550452a3fa3ec = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.t;
const $d0d7e7d07316f3a2$export$f7e9f41ea797a17 = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.exists;
const $d0d7e7d07316f3a2$export$2b4b218e406d2d00 = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.setDefaultNamespace;
const $d0d7e7d07316f3a2$export$93d9ee97c1ad3f31 = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.hasLoadedNamespace;
const $d0d7e7d07316f3a2$export$83be934b53fff43b = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.loadNamespaces;
const $d0d7e7d07316f3a2$export$8cd7e7a54fa865bc = $d0d7e7d07316f3a2$export$2e2bcd8739ae039.loadLanguages;


var $c0207306db6bb6fa$exports = {};
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else if (0, $c0207306db6bb6fa$exports) $c0207306db6bb6fa$exports = factory();
    else global.numeral = factory();
})($c0207306db6bb6fa$exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = '2.0.6', formats = {}, locales = {}, defaults = {
        currentLocale: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0',
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === 'undefined') value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = '', trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = '', neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) abbr = ' ';
                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }
            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split('.')[0];
                if (numeral._.includes(decimal, '.')) decimal = locale.delimiters.decimal + decimal.split('.')[1];
                else decimal = '';
                if (optDec && Number(decimal.slice(1)) === 0) decimal = '';
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = '0' + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            if (format.indexOf('.') === 0) int = '';
            output = int + decimal + (abbr ? abbr : '');
            if (negP) output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                else if (neg) output = '-' + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== '.') string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                for(abbreviation in abbreviations){
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError('Array.prototype.reduce called on null or undefined');
            if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError('Reduce of empty array with no initial value');
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split('.');
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error('Unknown locale : ' + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === 'string' ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === 'string' ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === 'string' ? format : '0.0';
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + 's'][name]) throw new TypeError(name + ' ' + type + ' already registered.');
        this[type + 's'][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === '') return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') _thousandSep = '\\.';
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + '{2}');
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
    (function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '', output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + 'BPS');
                    output = output.join('');
                } else output = output + space + 'BPS';
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                'B',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB'
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                'B',
                'KiB',
                'MiB',
                'GiB',
                'TiB',
                'PiB',
                'EiB',
                'ZiB',
                'YiB'
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
        numeral.register('format', 'bytes', {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, 'ib') ? binary : decimal, suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '', power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, '');
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register('format', 'currency', {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, '');
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, '');
                    symbols.after = symbols.after.replace(/[\-\)]/, '');
                } else if (value < 0 && !numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '(')) symbols.before = '-' + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case '$':
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case ' ':
                            output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case '$':
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case ' ':
                            output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register('format', 'exponential', {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0', parts = exponential.split('e');
                format = format.replace(/e[\+|\-]{1}0/, '');
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + 'e' + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, 'e-') ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register('format', 'ordinal', {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, ' o') ? ' ' : '';
                // check for space before
                format = format.replace(/\s?o/, '');
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register('format', 'percentage', {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' %') ? ' ' : '', output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + '%');
                    output = output.join('');
                } else output = output + space + '%';
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register('format', 'time', {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(':'), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});


var $0c35e9579b87db20$exports = {};
$0c35e9579b87db20$exports = $parcel$resolve("44YaE");


function $48f673e197675daa$export$f499cc7423602637(value, keys) {
    // first missing key if found
    let missingKey;
    let keyExist = true;
    if (value === undefined || value === null) keyExist = false;
    if (keyExist && keys !== undefined && keys !== null) missingKey = keys.find((key)=>value[key] === null || value[key] === undefined);
    return keyExist && !missingKey;
}
function $48f673e197675daa$export$dd1bc94b04021eeb(value) {
    return value === undefined || value === null || value.length === 0;
}
function $48f673e197675daa$export$ce604b1ac1ac02ff(payload, key = "data") {
    if (!$48f673e197675daa$export$f499cc7423602637(payload)) return Promise.reject();
    // handle the case where the response message is on the message key
    if (!$48f673e197675daa$export$f499cc7423602637(payload[key])) return Promise.reject(payload);
    return Promise.resolve(payload[key]);
}
function $48f673e197675daa$export$f7422a06cf772d2c(payload) {
    if (!$48f673e197675daa$export$f499cc7423602637(payload)) return Promise.reject();
    if (!$48f673e197675daa$export$f499cc7423602637(payload.data)) return Promise.reject(payload);
    return Promise.resolve({
        data: payload.data,
        pagination: payload.pagination
    });
}
function $48f673e197675daa$export$d3da1ecaf1206c58(error) {
    let errors = [];
    switch(typeof error){
        case "string":
            errors.push(error);
            break;
        case "object":
            for(const key in error)errors = [
                ...errors,
                ...$48f673e197675daa$export$d3da1ecaf1206c58(error[key])
            ];
            break;
        default:
            errors.push((0, $88ccace404ab2902$export$4fd720569787ab6f).unexpected);
    }
    return errors;
}
function $48f673e197675daa$export$4640587ffa669919(number) {
    if (!$48f673e197675daa$export$f499cc7423602637(number)) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($c0207306db6bb6fa$exports)))(number).format("0.[00]a");
}
function $48f673e197675daa$export$d4fc9e597530c349(number) {
    if (!$48f673e197675daa$export$f499cc7423602637(number)) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($c0207306db6bb6fa$exports)))(number).format("00");
}
function $48f673e197675daa$export$e656feb5cc3debfe(ignore = [], colors = [
    "#f94144",
    "#f3722c",
    "#f8961e",
    "#f9844a",
    "#f9c74f",
    "#90be6d",
    "#f9c74f",
    "#90be6d",
    "#43aa8b",
    "#4d908e",
    "#577590",
    "#277da1"
]) {
    const colorsToUse = colors.filter((color)=>!ignore.includes(color));
    return colorsToUse[Math.floor(Math.random() * colorsToUse.length)];
}
function $48f673e197675daa$export$714d535c5135f0bb(from, to) {
    if (!$48f673e197675daa$export$f499cc7423602637(from) || !$48f673e197675daa$export$f499cc7423602637(to)) return undefined;
    return `${new Date(from).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
        day: "numeric",
        month: "numeric",
        year: "numeric"
    })} - ${new Date(to).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
        day: "numeric",
        month: "numeric",
        year: "numeric"
    })}`;
}
function $48f673e197675daa$export$578c3eea45ec6232(type, from, to) {
    switch(type){
        case "week":
            return `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("common:sundaySaturday")} ${new Date(from).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                day: "numeric",
                month: "numeric"
            })} - ${new Date(to).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                day: "numeric",
                month: "numeric"
            })}`;
        case "month":
            return ` ${new Date(from).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                month: "short",
                year: "numeric"
            })}`;
        case "year":
            return `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("common:janDec")} ${new Date(from).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                year: "numeric"
            })}`;
        case "previousMonth":
            return `${(0, $377f863a28de0454$export$73d1c15a21f9fae5)(new Date(), 1).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                month: "long"
            })}`;
        case "previousYear":
            return `${new Date().getFullYear() - 1}`;
        default:
            return `${new Date(from).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                day: "numeric",
                month: "numeric",
                year: "numeric"
            })}`;
    }
}
function $48f673e197675daa$export$2a87b451bcc94d58(type) {
    const today = new Date();
    switch(type){
        case "day":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $e6350463b071cfeb$export$23a16f3c6d143ce9)(), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $e6350463b071cfeb$export$23a16f3c6d143ce9)(), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "week":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    weeks: 1
                })), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "month":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    months: 1
                })), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)(new Date(today.getFullYear(), today.getMonth() - 1, today.getDate()), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "previousMonth":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)((0, $377f863a28de0454$export$73d1c15a21f9fae5)(today, 2)), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)((0, $377f863a28de0454$export$73d1c15a21f9fae5)(today, 1)), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "previousYear":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $c8148e08909dec9f$export$f91e89d3d0406102)((0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(today, 2)), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $938b9f25b96c36ea$export$8b7aa55c66d5569e)((0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(today, 2)), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "past7Days":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    days: 14
                }), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    days: 7
                }), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "past30Days":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    days: 60
                }), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    days: 30
                }), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "past90Days":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    days: 180
                }), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    days: 90
                }), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        case "quarter":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    months: 3
                })), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $84d943fac3f3650c$export$5f53493861eef879)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    months: 3
                })), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
        default:
        case "year":
            {
                const from = (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $c8148e08909dec9f$export$f91e89d3d0406102)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(today, {
                    years: 1
                })), "yyyy-LL-dd");
                const to = (0, $7aa2e35e5d01626e$export$d9468344d3651243)(new Date(today.getFullYear() - 1, today.getMonth(), today.getDate()), "yyyy-LL-dd");
                return {
                    from: from,
                    to: to
                };
            }
    }
}
function $48f673e197675daa$export$f10d6a896d4ffbcf(current, previous) {
    const percentage = Math.round((current - previous) / previous * 100);
    return {
        percentage: percentage,
        sign: percentage > 0 ? "increase" : "decrease",
        text: percentage > 0 ? `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("common:increase")}` : `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("common:decrease")}`
    };
}
function $48f673e197675daa$export$e993d5e1f686c8b0(number) {
    if (!$48f673e197675daa$export$f499cc7423602637(number)) return undefined;
    return new Intl.NumberFormat().format(number);
}
function $48f673e197675daa$export$1f49383e7879c367(func, timeout = 500) {
    let timer;
    const debouncedFn = (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
    debouncedFn.cancel = ()=>clearTimeout(timer);
    return debouncedFn;
}
function $48f673e197675daa$export$b325ec6732b039cf(allowedRoles, userRoles) {
    const isPermitted = userRoles.some((role)=>allowedRoles.includes(role)) || allowedRoles.length === 0 || userRoles.length === 0;
    return isPermitted;
}
function $48f673e197675daa$export$805ddaeeece0413e(allowedPlatforms, userPlatform) {
    const isPermitted = allowedPlatforms.includes(userPlatform) || allowedPlatforms.length === 0;
    return isPermitted;
}
function $48f673e197675daa$export$110700823644f4a6(name, value, days, path = "/") {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}`;
}
function $48f673e197675daa$export$4be65e66cfa2648a(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift();
    return undefined;
}
function $48f673e197675daa$export$dc700bc3d778ec04(e) {
    e.currentTarget.src = (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports)));
}
function $48f673e197675daa$export$c472c0059aecb283(date1, date2) {
    const year = date1.getFullYear();
    const month = date1.getMonth();
    const day = date1.getDate();
    const hours = new Date(date2).getHours();
    const minutes = new Date(date2).getMinutes();
    const seconds = new Date(date2).getSeconds();
    return new Date(year, month, day, hours, minutes, seconds);
}


const $bd69b505bf48eca0$export$85b75051ee07828a = (0, $91e1faf1710dcf23$export$22b082955e083ec3)().matches((0, $ce34758010714942$export$1e515f3f466b5f), "Must contain at least one uppercase letter, one lowercase letter, one number and one special character and must be at least 8 characters long");
const $bd69b505bf48eca0$export$f30664844be2d6f1 = $91e1faf1710dcf23$export$be5493f9613cbbe().shape({
    password: $91e1faf1710dcf23$export$22b082955e083ec3().matches((0, $ce34758010714942$export$1e515f3f466b5f), "Must contain at least one uppercase letter, one lowercase letter, one number and one special character and must be at least 8 characters long").required(),
    confirmPassword: $91e1faf1710dcf23$export$22b082955e083ec3().required().oneOf([
        $91e1faf1710dcf23$export$eff4d24c3ff7876e("password")
    ], "password and confirm password do not match")
});
class $bd69b505bf48eca0$export$3d7a1e8452f884f3 {
    static requestCSRF() {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).requestCSRF();
    }
    /**
   * @description login user
   * @param email email of the user
   * @param password password of the user
   * @param otp otp sent if user has enabled 2fa
   */ static login(email, password, otp) {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).login(email, password, otp).then((response)=>{
            return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
        }).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
    static logout() {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).logout().finally(()=>{
            localStorage.removeItem("access_token");
            return Promise.resolve();
        });
    }
    static getCurrentUser() {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).currentUser().then((overviewPayload)=>{
            return overviewPayload;
        }).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
    /**
   *
   * @param email email of the user to send the otp to.
   * @returns
   */ static requestResetPassword(email) {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).requestResetPassword(email).then((response)=>{
            return response;
        }).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
    static sendOtp(email, otp) {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).validateOTP(email, otp).then((response)=>{
            return response;
        }).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
    /**
   *
   * @param email email of the user to reset their password
   * @param newPassword
   * @param otp otp sent previously
   * @returns
   */ static resetPassword(email, newPassword, otp) {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).resetPassword(email, newPassword, otp).then((response)=>{
            return response;
        }).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
    static setPassword(password, registration_key) {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).setPassword(password, registration_key).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
    static signup(payload) {
        const URLRegex = RegExp((0, $ce34758010714942$export$820ae0844b3faa33));
        const storeUrl = `https://${URLRegex.exec(payload.storeUrl)[4]}`;
        const updatedPayload = {
            ...payload,
            storeUrl: storeUrl
        };
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).signup(updatedPayload).then((response)=>{
            return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
        }).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
    static confirmRegistration(token) {
        return (0, $de34386d48a688b6$export$d9e3c9dc7eaad0c3).confirmRegistration(token).then((response)=>{
            return response;
        }).catch((error)=>{
            return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
        });
    }
}


function $9702949453a4f797$export$6ec75f494bbce1c0(name, value) {
    const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    return name + capitalizedValue;
}
function $9702949453a4f797$export$7ef984faa3cd4d76(label, { from: from, to: to, type: type, alias: alias }) {
    const query = new URLSearchParams();
    const typeQueryKey = $9702949453a4f797$export$6ec75f494bbce1c0(label, "type");
    const fromQueryKey = $9702949453a4f797$export$6ec75f494bbce1c0(label, "from");
    const toQueryKey = $9702949453a4f797$export$6ec75f494bbce1c0(label, "to");
    const aliasQueryKey = $9702949453a4f797$export$6ec75f494bbce1c0(label, "alias");
    query.append(typeQueryKey, type);
    query.append(fromQueryKey, from);
    query.append(toQueryKey, to);
    query.append(aliasQueryKey, encodeURIComponent(alias));
    return query.toString();
}
function $9702949453a4f797$export$3c311ccce60fdde(activeTab, listBy) {
    const query = new URLSearchParams();
    if (activeTab) query.append("activeTab", activeTab);
    if (listBy) query.append("listBy", listBy);
    return query.toString();
}
function $9702949453a4f797$export$39b294e5c328223c(label, query) {
    const params = new URLSearchParams(query);
    const from = params.get($9702949453a4f797$export$6ec75f494bbce1c0(label, "from"));
    const to = params.get($9702949453a4f797$export$6ec75f494bbce1c0(label, "to"));
    const alias = params.get($9702949453a4f797$export$6ec75f494bbce1c0(label, "alias"));
    const type = params.get($9702949453a4f797$export$6ec75f494bbce1c0(label, "type"));
    if ([
        type,
        from,
        to,
        alias
    ].includes(null)) return null;
    return {
        type: type,
        from: from,
        to: to,
        alias: decodeURIComponent(alias)
    };
}
function $9702949453a4f797$export$143f1c2f8ea3b4b5(urlArg, filtersArg, segmentFilters = false) {
    const filters = filtersArg || {};
    const url = new URL(urlArg);
    for(const filter in filters){
        if (Array.isArray(filters[filter])) for(const i in filters[filter])url.searchParams.append(`${segmentFilters ? "filters" : "advanced_filters"}[${filter}][${i}]`, filters[filter][i]);
        else {
            for(const nestedFilter in filters[filter])for(const i in filters[filter][nestedFilter])url.searchParams.append(`${segmentFilters ? "filters" : "advanced_filters"}[${filter}][${nestedFilter}][${i}]`, filters[filter][nestedFilter][i]);
        }
    }
    return url;
}
function $9702949453a4f797$export$773215b83aca489({ title: title, project: project, urlArg: urlArg, filtersArg: filtersArg }) {
    const url = $9702949453a4f797$export$143f1c2f8ea3b4b5(urlArg, filtersArg, true);
    url.searchParams.append("title", title);
    url.searchParams.append("project", project);
    return url;
}


/**
 * @author Ahmed Serag
 * @date 2020-12-09
 * @description implementation of Settings related utilities.
 * @filename settings.ts
 */ 
/**
 * @author Ahmed Serag
 * @date 2020-12-07
 * @description implementation of common API calls.
 * @filename common.ts
 */ 

class $9147676993658181$export$a86fab198fa43d2c {
    /**
   * send support request with the input title, message and category in support screen.
   * @param title
   * @param message
   * @param category
   * @returns
   */ static support(title, message, category) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).support.path}`);
        url.searchParams.append("title", title);
        url.searchParams.append("message", message);
        url.searchParams.append("category", category);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).support.method
        });
    }
}





class $bc83ca4e061ee377$export$c72f6eaae7b9adff {
    static get() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getSettings.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getSettings.method
        });
    }
    static update(project, settings) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateSettings.path}`);
        let headers;
        let body;
        const key = encodeURIComponent("logo");
        url.searchParams.append("project", project);
        if (settings.primary_color) url.searchParams.append("primary_color", settings.primary_color.substring(1));
        if (settings.secondary_color) url.searchParams.append("secondary_color", settings.secondary_color.substring(1));
        if (settings.threshold) url.searchParams.append("threshold", settings.threshold);
        if (settings.logo) {
            const value = encodeURIComponent(settings.logo);
            body = `${key}=${value}`;
            headers = {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                accept: "application/x-www-form-urlencoded;charset=UTF-8"
            };
        }
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateSettings.method,
            body: body,
            headers: headers
        });
    }
    /**
   * update current user email with new one.
   *
   * @param {string} email new email to replace the old one
   * @param {string} password current user password
   * @return {*}  {Promise<Payload<void>>} promise to update user email.
   */ static updateEmail(email, password) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateEmail.path}`);
        url.searchParams.set("email", email);
        url.searchParams.set("password", password);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateEmail.method
        });
    }
    /**
   * update current user name with new one.
   *
   * @param {string} name new name to replace the old one
   * @return {*}  {Promise<Payload<void>>} promise to update user name.
   */ static updateName(name) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateName.path}`);
        url.searchParams.set("name", name);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateName.method
        });
    }
    /**
   * update current user password with new one.
   *
   * @param {string} currentPassword existing password.
   * @param {string} newPAssword new password to replace the old one
   * @return {*}  {Promise<Payload<void>>} promise to update user password.
   */ static updatePassword(currentPassword, newPAssword) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updatePassword.path}`);
        url.searchParams.set("old_password", currentPassword);
        url.searchParams.set("new_password", newPAssword);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updatePassword.method
        });
    }
    static updateGoals(project, dailyGoal, weeklyGoal, monthlyGoal, yearlyGoal) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateGoals.path}`);
        url.searchParams.append("project", project);
        if ((0, $48f673e197675daa$export$f499cc7423602637)(dailyGoal)) url.searchParams.set("daily_goal", dailyGoal.toString());
        if ((0, $48f673e197675daa$export$f499cc7423602637)(weeklyGoal)) url.searchParams.set("weekly_goal", weeklyGoal.toString());
        if ((0, $48f673e197675daa$export$f499cc7423602637)(monthlyGoal)) url.searchParams.set("monthly_goal", monthlyGoal.toString());
        if ((0, $48f673e197675daa$export$f499cc7423602637)(yearlyGoal)) url.searchParams.set("yearly_goal", yearlyGoal.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateGoals.method
        });
    }
    /**
   * change current user language.
   *
   * @param {string} lang new language
   * @return {*}  {Promise<Payload<void>>} promise to language.
   */ static changeLanguage(lang) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).changeLanguage.path}`);
        url.searchParams.set("language", lang);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).changeLanguage.method
        });
    }
    /**
   * Get Payfort signature.
   */ static getSignature() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getSignature.path}`);
        url.searchParams.set("sandbox", "0");
        url.searchParams.set("return_url", "https://backend.analytics-dashboard.ecommbeta.com/api/payment/proxy");
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getSignature.method
        });
    }
    /**
   * Get cards.
   */ static getCards() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCards.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCards.method
        });
    }
    /**
   * Set default card.
   * @param {string} id card id
   */ static setDefaultCard(id) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).setDefaultCard.path}`);
        url.searchParams.set("id", id);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).setDefaultCard.method
        });
    }
    /**
   * Delete card.
   * @param {string} id card id
   */ static deleteCard(id) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteCard.path}`);
        url.searchParams.set("id", id);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteCard.method
        });
    }
    /**
   * Delete logo.
   * @param {string} project project
   */ static deleteLogo(project) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteLogo.path}`);
        url.searchParams.append("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteLogo.method
        });
    }
    /**
   * get user's activity logs.
   */ static getActivityLogs() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getActivityLogs.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getActivityLogs.method
        });
    }
    /**
   * Delete account.
   */ static deleteAccount() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteAccount.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteAccount.method
        });
    }
    /**
   * Set GA4 Property ID.
   *
   * @param {string} project
   * @param {string} propertyId current user ga4 propertyId
   * @return {*}  {Promise<Payload<void>>} promise to set ga4 id.
   */ static setGA4PropertyId(project, propertyId) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).setGA4PropertyId.path}`);
        url.searchParams.set("project", project);
        url.searchParams.set("propertyId", propertyId);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).setGA4PropertyId.method
        });
    }
    /**
   * Delete GA4 Property ID.
   *
   * @param {string} project
   * @return {*}  {Promise<Payload<void>>} promise to set ga4 id.
   */ static deleteGA4PropertyId(project) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteGA4PropertyId.path}`);
        url.searchParams.set("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteGA4PropertyId.method
        });
    }
    /**
   * handles sending a request to the server to activate two-factor authentication.
   * @param phoneNumberExt
   * @param phoneNumber
   */ static enableTwoFactorAuthentication(phoneNumberExt, phoneNumber) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).enableTwoFactorAuthentication.path}`);
        url.searchParams.append("phoneNumberExt", phoneNumberExt);
        url.searchParams.append("phoneNumber", phoneNumber);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).enableTwoFactorAuthentication.method
        });
    }
    /**
   * handles validating the two-factor authentication code.
   * @param email
   * @param otp
   */ static validateTwoFactorAuthentication(email, otp) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).validateTwoFactorAuthentication.path}`);
        url.searchParams.append("email", email);
        url.searchParams.append("otp", otp);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).validateTwoFactorAuthentication.method
        });
    }
    /**
   * handles disabling two-factor authentication.
   */ static disableTwoFactorAuthentication() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).disableTwoFactorAuthentication.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).disableTwoFactorAuthentication.method
        });
    }
    /**
   * get plans pricings
   */ static getPricings() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getPricings.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getPricings.method
        });
    }
    /**
   * get orders since last subscription
   */ static getOrdersSinceLastSubscription() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getOrdersSinceLastSubscription.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getOrdersSinceLastSubscription.method
        });
    }
    /**
   * unsubscribe from plan
   */ static unsubscribe() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).unsubscribe.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).unsubscribe.method
        });
    }
    /**
   * get integration keys for the project
   */ static getProjectKeys(project) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getProjectKeys.path}`);
        url.searchParams.append("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getProjectKeys.method
        });
    }
    /**
   * change the tier of the subscription for user
   * @param subscription_tier tier to change to
   */ static changeTier(subscription_tier) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).changeTier.path}`);
        url.searchParams.append("subscription_tier", subscription_tier);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).changeTier.method
        });
    }
    /**
   * subscribe to a plan when user is unsubscribed
   * @param subscription_tier tier to subscribe to
   */ static subscribe(subscription_tier) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).subscribe.path}`);
        url.searchParams.append("subscription_tier", subscription_tier);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).subscribe.method
        });
    }
    /**
   * get the info for the tier changing for user
   * @param subscription_tier tier to change to
   */ static getChangeTierInfo(subscription_tier) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getChangeTierInfo.path}`);
        url.searchParams.append("subscription_tier", subscription_tier);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getChangeTierInfo.method
        });
    }
    /**
   * get stripe balance for user
   */ static getStripeBalance() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getStripeBalance.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getStripeBalance.method
        });
    }
}



const $56fb02d394e3f062$export$ac5b8c5d73131fa7 = (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
    title: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().max(200).required("Support message is required"),
    message: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().max(1000).required("Topic is required")
});
async function $56fb02d394e3f062$export$4a647155031ece() {
    try {
        const response = await (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).get();
        const settings = await (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
        return settings;
    } catch (error) {
        return await Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    }
}
async function $56fb02d394e3f062$export$f558026a994b6051(project, settings) {
    try {
        const updatedSettingsResponsePayload = await (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).update(project, settings);
        const updatedSettingsResponseDate = await (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(updatedSettingsResponsePayload);
        return updatedSettingsResponseDate[0];
    } catch (error) {
        return await Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    }
}
function $56fb02d394e3f062$export$89c50b0313ef816e(title, message, category) {
    return (0, $9147676993658181$export$a86fab198fa43d2c).support(title, message, category).then((response)=>(0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response)).catch((error)=>(0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
}
function $56fb02d394e3f062$export$f481a68bf2db0291(name) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).updateName(name).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$fe9534bbbfa0e81e(email, password) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).updateEmail(email, password).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$e2853351e15b7895(currentPassword, newPassword) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).updatePassword(currentPassword, newPassword).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$a303889ea27be1af(project, dailyGoal, weeklyGoal, monthlyGoal, yearlyGoal) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).updateGoals(project, dailyGoal, weeklyGoal, monthlyGoal, yearlyGoal).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$61465194746e7fd2(lang) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).changeLanguage(lang).then(()=>{
        if (lang === "ar") {
            document.documentElement.setAttribute("dir", "rtl");
            document.documentElement.setAttribute("lang", "ar");
        } else {
            document.documentElement.setAttribute("dir", "ltr");
            document.documentElement.setAttribute("lang", "en");
        }
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
async function $56fb02d394e3f062$export$2f768fec5d73d91a() {
    try {
        const response = await (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getSignature();
        const signature = await (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
        return signature;
    } catch (error) {
        return await Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    }
}
async function $56fb02d394e3f062$export$bc61c71d8347e4d9() {
    try {
        const response = await (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getCards();
        const cards = await (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
        return cards;
    } catch (error) {
        return await Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    }
}
async function $56fb02d394e3f062$export$5b7d59380be0b8b5(id) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).setDefaultCard(id).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
async function $56fb02d394e3f062$export$cbb49d44ad636b27(id) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).deleteCard(id).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
async function $56fb02d394e3f062$export$bba5eb83f5a3091e(project) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).deleteLogo(project).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$613c3f4837bf8ca6() {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getActivityLogs().then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
async function $56fb02d394e3f062$export$45abfc3976589d02() {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).deleteAccount().catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$dd06c8c889613e9a(project, propertyId) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).setGA4PropertyId(project, propertyId).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$79cd7582c7ac6134(project) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).deleteGA4PropertyId(project).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$c95c14b1c454fbc4(phoneNumberExt, phoneNumber) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).enableTwoFactorAuthentication(phoneNumberExt, phoneNumber).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$33074b0d6fb9226e(email, otp) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).validateTwoFactorAuthentication(email, otp).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$64d395d9c1c49d9a() {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).disableTwoFactorAuthentication().catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$feab92affbe26cb8() {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getPricings().catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$8e49c52f79b6b5ed() {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getOrdersSinceLastSubscription().then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$f500693cef883ffd() {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).unsubscribe().catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$8eaa366290b040c4(project) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getProjectKeys(project).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$91259a2a77442e16(subscription_tier) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).changeTier(subscription_tier).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$ec068583843480e7(subscription_tier) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).subscribe(subscription_tier).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$7c1aaa4d7508f827(subscription_tier) {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getChangeTierInfo(subscription_tier).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $56fb02d394e3f062$export$31b809cffbd15b25() {
    return (0, $bc83ca4e061ee377$export$c72f6eaae7b9adff).getStripeBalance().then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}



var $igtsr = parcelRequire("igtsr");
function $e9b961c54aae6d46$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $e9b961c54aae6d46$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $e9b961c54aae6d46$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $e9b961c54aae6d46$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e9b961c54aae6d46$export$2e2bcd8739ae039 = $e9b961c54aae6d46$export$4f5d2d50c9deca37;


"use client";
function $d41f521f78665649$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$d41f521f78665649$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $d41f521f78665649$var$L = (t)=>typeof t == "number" && !isNaN(t), $d41f521f78665649$var$N = (t)=>typeof t == "string", $d41f521f78665649$var$P = (t)=>typeof t == "function", $d41f521f78665649$var$mt = (t)=>$d41f521f78665649$var$N(t) || $d41f521f78665649$var$L(t), $d41f521f78665649$var$B = (t)=>$d41f521f78665649$var$N(t) || $d41f521f78665649$var$P(t) ? t : null, $d41f521f78665649$var$pt = (t, o)=>t === !1 || $d41f521f78665649$var$L(t) && t > 0 ? t : o, $d41f521f78665649$var$z = (t)=>(0, $igtsr.isValidElement)(t) || $d41f521f78665649$var$N(t) || $d41f521f78665649$var$P(t) || $d41f521f78665649$var$L(t);
function $d41f521f78665649$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $d41f521f78665649$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $igtsr.useRef)(0);
        return (0, $igtsr.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $igtsr.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $d41f521f78665649$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Fragment, null, a);
    };
}
function $d41f521f78665649$var$J(t, o) {
    return {
        content: $d41f521f78665649$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $d41f521f78665649$var$tt(t, o, e = !1) {
    return (0, $igtsr.isValidElement)(t) && !$d41f521f78665649$var$N(t.type) ? (0, $igtsr.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $d41f521f78665649$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $d41f521f78665649$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $d41f521f78665649$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $e9b961c54aae6d46$export$2e2bcd8739ae039)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $d41f521f78665649$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $e9b961c54aae6d46$export$2e2bcd8739ae039)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $d41f521f78665649$var$Xt = 1, $d41f521f78665649$var$at = ()=>`${$d41f521f78665649$var$Xt++}`;
function $d41f521f78665649$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($d41f521f78665649$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $d41f521f78665649$var$B(n.className || d.toastClassName),
                progressClassName: $d41f521f78665649$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $d41f521f78665649$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($d41f521f78665649$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $d41f521f78665649$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $d41f521f78665649$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $d41f521f78665649$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $d41f521f78665649$var$I = new Map, $d41f521f78665649$var$F = [], $d41f521f78665649$var$st = new Set, $d41f521f78665649$var$Vt = (t)=>$d41f521f78665649$var$st.forEach((o)=>o(t)), $d41f521f78665649$var$bt = ()=>$d41f521f78665649$var$I.size > 0;
function $d41f521f78665649$var$Qt() {
    $d41f521f78665649$var$F.forEach((t)=>$d41f521f78665649$var$nt(t.content, t.options)), $d41f521f78665649$var$F = [];
}
var $d41f521f78665649$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $d41f521f78665649$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $d41f521f78665649$var$X(t, o) {
    var r;
    if (o) return !!((r = $d41f521f78665649$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $d41f521f78665649$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $d41f521f78665649$var$ht(t) {
    if (!$d41f521f78665649$var$bt()) {
        $d41f521f78665649$var$F = $d41f521f78665649$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $d41f521f78665649$var$mt(t)) $d41f521f78665649$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $d41f521f78665649$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $d41f521f78665649$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $d41f521f78665649$var$Ct = (t = {})=>{
    $d41f521f78665649$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $d41f521f78665649$var$nt(t, o) {
    $d41f521f78665649$var$z(t) && ($d41f521f78665649$var$bt() || $d41f521f78665649$var$F.push({
        content: t,
        options: o
    }), $d41f521f78665649$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $d41f521f78665649$var$xt(t) {
    var o;
    (o = $d41f521f78665649$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $d41f521f78665649$var$rt(t, o) {
    $d41f521f78665649$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $d41f521f78665649$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $d41f521f78665649$var$_t(o, t, $d41f521f78665649$var$Vt);
            $d41f521f78665649$var$I.set(o, r);
            let s = r.observe(e);
            return $d41f521f78665649$var$Qt(), ()=>{
                s(), $d41f521f78665649$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $d41f521f78665649$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $d41f521f78665649$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $d41f521f78665649$var$Pt(t) {
    return $d41f521f78665649$var$st.add(t), ()=>{
        $d41f521f78665649$var$st.delete(t);
    };
}
function $d41f521f78665649$var$Wt(t) {
    return t && ($d41f521f78665649$var$N(t.toastId) || $d41f521f78665649$var$L(t.toastId)) ? t.toastId : $d41f521f78665649$var$at();
}
function $d41f521f78665649$var$U(t, o) {
    return $d41f521f78665649$var$nt(t, o), o.toastId;
}
function $d41f521f78665649$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $d41f521f78665649$var$Wt(o)
    };
}
function $d41f521f78665649$var$Q(t) {
    return (o, e)=>$d41f521f78665649$var$U(o, $d41f521f78665649$var$V(t, e));
}
function $d41f521f78665649$export$b410431fab84fa58(t, o) {
    return $d41f521f78665649$var$U(t, $d41f521f78665649$var$V("default", o));
}
$d41f521f78665649$export$b410431fab84fa58.loading = (t, o)=>$d41f521f78665649$var$U(t, $d41f521f78665649$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $d41f521f78665649$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $d41f521f78665649$var$N(o) ? $d41f521f78665649$export$b410431fab84fa58.loading(o, s) : $d41f521f78665649$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $d41f521f78665649$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $d41f521f78665649$var$N(g) ? {
            render: g
        } : g;
        return l ? $d41f521f78665649$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $d41f521f78665649$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $d41f521f78665649$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$d41f521f78665649$export$b410431fab84fa58.promise = $d41f521f78665649$var$Gt;
$d41f521f78665649$export$b410431fab84fa58.success = $d41f521f78665649$var$Q("success");
$d41f521f78665649$export$b410431fab84fa58.info = $d41f521f78665649$var$Q("info");
$d41f521f78665649$export$b410431fab84fa58.error = $d41f521f78665649$var$Q("error");
$d41f521f78665649$export$b410431fab84fa58.warning = $d41f521f78665649$var$Q("warning");
$d41f521f78665649$export$b410431fab84fa58.warn = $d41f521f78665649$export$b410431fab84fa58.warning;
$d41f521f78665649$export$b410431fab84fa58.dark = (t, o)=>$d41f521f78665649$var$U(t, $d41f521f78665649$var$V("default", {
        theme: "dark",
        ...o
    }));
function $d41f521f78665649$var$qt(t) {
    $d41f521f78665649$var$ht(t);
}
$d41f521f78665649$export$b410431fab84fa58.dismiss = $d41f521f78665649$var$qt;
$d41f521f78665649$export$b410431fab84fa58.clearWaitingQueue = $d41f521f78665649$var$Ct;
$d41f521f78665649$export$b410431fab84fa58.isActive = $d41f521f78665649$var$X;
$d41f521f78665649$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $d41f521f78665649$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $d41f521f78665649$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $d41f521f78665649$var$U(a, l);
    }
};
$d41f521f78665649$export$b410431fab84fa58.done = (t)=>{
    $d41f521f78665649$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$d41f521f78665649$export$b410431fab84fa58.onChange = $d41f521f78665649$var$Pt;
$d41f521f78665649$export$b410431fab84fa58.play = (t)=>$d41f521f78665649$var$rt(!0, t);
$d41f521f78665649$export$b410431fab84fa58.pause = (t)=>$d41f521f78665649$var$rt(!1, t);
function $d41f521f78665649$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $igtsr.useRef)($d41f521f78665649$var$Et(t)).current;
    r(t);
    let s = (a = (0, $igtsr.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $d41f521f78665649$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $d41f521f78665649$var$At(t) {
    let [o, e] = (0, $igtsr.useState)(!1), [r, s] = (0, $igtsr.useState)(!1), l = (0, $igtsr.useRef)(null), a = (0, $igtsr.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $d41f521f78665649$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $igtsr.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $d41f521f78665649$var$Ot = typeof window != "undefined" ? (0, $igtsr.useLayoutEffect) : (0, $igtsr.useEffect);
var $d41f521f78665649$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $d41f521f78665649$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($d41f521f78665649$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $d41f521f78665649$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($d41f521f78665649$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $d41f521f78665649$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($d41f521f78665649$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $d41f521f78665649$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($d41f521f78665649$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $d41f521f78665649$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $d41f521f78665649$export$4f13f83fd8bb1dac = {
    info: $d41f521f78665649$var$so,
    warning: $d41f521f78665649$var$ao,
    success: $d41f521f78665649$var$no,
    error: $d41f521f78665649$var$ro,
    spinner: $d41f521f78665649$var$io
}, $d41f521f78665649$var$lo = (t)=>t in $d41f521f78665649$export$4f13f83fd8bb1dac;
function $d41f521f78665649$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($d41f521f78665649$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $igtsr.isValidElement)(r) ? s = (0, $igtsr.cloneElement)(r, l) : e ? s = $d41f521f78665649$export$4f13f83fd8bb1dac.spinner() : $d41f521f78665649$var$lo(o) && (s = $d41f521f78665649$export$4f13f83fd8bb1dac[o](l))), s;
}
var $d41f521f78665649$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $d41f521f78665649$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $e9b961c54aae6d46$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $d41f521f78665649$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $e9b961c54aae6d46$export$2e2bcd8739ae039)(D, E), ft = $d41f521f78665649$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($d41f521f78665649$var$P(a) ? H = a(j) : (0, $igtsr.isValidElement)(a) ? H = (0, $igtsr.cloneElement)(a, j) : H = $d41f521f78665649$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        className: (0, $e9b961c54aae6d46$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $d41f521f78665649$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($d41f521f78665649$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $d41f521f78665649$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $d41f521f78665649$export$d20e79fdc3899e95 = $d41f521f78665649$export$3ff7dc44d332d222($d41f521f78665649$var$K("bounce", !0)), $d41f521f78665649$export$d8dc01b5c85a37b9 = $d41f521f78665649$export$3ff7dc44d332d222($d41f521f78665649$var$K("slide", !0)), $d41f521f78665649$export$65cfd44a2050f99 = $d41f521f78665649$export$3ff7dc44d332d222($d41f521f78665649$var$K("zoom")), $d41f521f78665649$export$4d2fae537bd90431 = $d41f521f78665649$export$3ff7dc44d332d222($d41f521f78665649$var$K("flip"));
var $d41f521f78665649$var$_o = {
    position: "top-right",
    transition: $d41f521f78665649$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $d41f521f78665649$export$f2815235e76a62b9(t) {
    let o = {
        ...$d41f521f78665649$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $igtsr.useState)(!0), l = (0, $igtsr.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $d41f521f78665649$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $e9b961c54aae6d46$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $d41f521f78665649$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $e9b961c54aae6d46$export$2e2bcd8739ae039)(p, $d41f521f78665649$var$B(T));
    }
    function E() {
        e && (s(!0), $d41f521f78665649$export$b410431fab84fa58.play());
    }
    return $d41f521f78665649$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $igtsr.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $d41f521f78665649$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $d41f521f78665649$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $d41f521f78665649$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($d41f521f78665649$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}


/**
 * @author Karim Shalapy
 * @date 2022-10-02
 * @description Implementation of advanced filters related utilities.
 * @filename advanced-filters.ts
 */ /**
 * @author Karim Shalapy
 * @date 2022-10-02
 * @description Implementation of advanced filters related API calls.
 * @filename advanced-filters.ts
 */ 


class $f5f5a0dfa5d4e340$export$7d5d28de2cc69ff4 {
    static getAvailableFilters(project) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).advancedFilters.path}`);
        url.searchParams.append("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).advancedFilters.method
        });
    }
    /**
   * Creates a new segment
   * @param title title of segment
   * @param project project name
   * @param filtersArg filters to be applied
   * @returns
   */ static createNewSegment({ title: title, project: project, filtersArg: filtersArg }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).createSegment.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$773215b83aca489)({
            urlArg: url,
            title: title,
            project: project,
            filtersArg: filtersArg
        }).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).createSegment.method
        });
    }
    /**
   * get all segments
   * @param project project name
   * @returns
   */ static getAllFiltersSegments(project) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllFiltersSegments.path}`);
        url.searchParams.append("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllFiltersSegments.method
        });
    }
    /**
   * delete a segment by id
   * @param project project name
   * @param id segment id
   * @returns
   */ static deleteFiltersSegment(project, id) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteFiltersSegment.path}/${id}`);
        url.searchParams.append("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteFiltersSegment.method
        });
    }
    /**
   * update a segment by id
   * @param id segment id
   * @returns
   */ static updateFiltersSegment({ project: project, id: id, title: title, filtersArg: filtersArg }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateFiltersSegment.path}/${id}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$773215b83aca489)({
            title: title,
            project: project,
            filtersArg: filtersArg,
            urlArg: url
        }).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).updateFiltersSegment.method
        });
    }
}


const $c67dc4ee9a5156ae$export$900830e035ecc69 = "--*-*--";
const $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8 = "shipping_locations";



function $eadf35cb023988c9$export$5802bcdbb39280f6(project) {
    return (0, $f5f5a0dfa5d4e340$export$7d5d28de2cc69ff4).getAvailableFilters(project).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eadf35cb023988c9$export$716cad129d2949a9(arr) {
    const array = arr || [];
    return array.map((el)=>({
            value: el,
            label: el.split((0, $c67dc4ee9a5156ae$export$900830e035ecc69))[1]
        }));
}
function $eadf35cb023988c9$export$247b78adad87d126(arr) {
    const array = arr || [];
    return array.map((el)=>el.value);
}
function $eadf35cb023988c9$export$a15b0df135c91f7e(filtersArg) {
    const filters = filtersArg || {};
    const keys = Object.keys(filters);
    const flattenedFilters = {};
    keys.forEach((key)=>{
        if (Array.isArray(filters[key])) {
            const item = filters[key];
            flattenedFilters[key] = item.filter(Boolean);
        } else if (typeof filters[key] === "object") {
            const item = filters[key];
            flattenedFilters[key] = [];
            Object.keys(item).forEach((nestedKey)=>{
                flattenedFilters[key] = flattenedFilters[key].concat(item[nestedKey].filter(Boolean).map((value)=>`${nestedKey}${0, $c67dc4ee9a5156ae$export$900830e035ecc69}${value}`));
            });
        }
    });
    return flattenedFilters;
}
function $eadf35cb023988c9$export$aab87de08213fc1d(differentFilters) {
    const filters = differentFilters || this.state.flattenedFilters;
    const keys = Object.keys(filters);
    const unflattenedFilters = {};
    keys.forEach((key)=>{
        if (!filters[key][0]) return;
        const isFlattened = filters[key][0].includes((0, $c67dc4ee9a5156ae$export$900830e035ecc69));
        if (!isFlattened) unflattenedFilters[key] = filters[key].filter(Boolean);
        else {
            unflattenedFilters[key] = {};
            filters[key].forEach((flattenedValue)=>{
                const [nestedKey, value] = flattenedValue.split((0, $c67dc4ee9a5156ae$export$900830e035ecc69));
                unflattenedFilters[key][nestedKey] = (unflattenedFilters[key][nestedKey] || []).concat(value);
            });
        }
    });
    return unflattenedFilters;
}
function $eadf35cb023988c9$export$56efeea303eae211({ title: title, project: project, filtersArg: filtersArg }) {
    const filters = filtersArg || {};
    return (0, $f5f5a0dfa5d4e340$export$7d5d28de2cc69ff4).createNewSegment({
        title: title,
        project: project,
        filtersArg: filters
    }).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eadf35cb023988c9$export$4739a2e98d4ba69f(project) {
    return (0, $f5f5a0dfa5d4e340$export$7d5d28de2cc69ff4).getAllFiltersSegments(project).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eadf35cb023988c9$export$2f68d84b6eb89430(filters) {
    const flattenedFilters = $eadf35cb023988c9$export$a15b0df135c91f7e(filters);
    const filtersKeys = Object.keys(flattenedFilters);
    const filtersValues = Object.values(flattenedFilters);
    const filtersPreview = filtersKeys.map((key, index)=>{
        // show one value for each key and add "+x more" if there are more values
        if (filtersValues[index].length > 1) filtersValues[index].splice(1, filtersValues[index].length - 1, `+${filtersValues[index].length - 1} more`);
        return `${key}: ${filtersValues[index].join(", ")}`;
    });
    // show only the first two filters and add "+x more" if there are more filters
    if (filtersPreview.length > 1) filtersPreview.splice(1, filtersPreview.length - 1, `+${filtersPreview.length - 1} more`);
    return filtersPreview.join(", ");
}
function $eadf35cb023988c9$export$538f3bd007ae3ac5(project, id) {
    return (0, $f5f5a0dfa5d4e340$export$7d5d28de2cc69ff4).deleteFiltersSegment(project, id).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response, "message");
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eadf35cb023988c9$export$8a13e1c9e60c7715({ project: project, id: id, title: title, filtersArg: filtersArg }) {
    return (0, $f5f5a0dfa5d4e340$export$7d5d28de2cc69ff4).updateFiltersSegment({
        project: project,
        id: id,
        title: title,
        filtersArg: filtersArg
    }).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}



/**
 * @author Ahmed Serag
 * @date 2022-05-15
 * @description Implementation of Firebase related utilities.
 * @filename brands.ts
 */ const $e977a5410621f4d7$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $7a5e5653d27b8a06$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $7a5e5653d27b8a06$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $7a5e5653d27b8a06$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $7a5e5653d27b8a06$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $7a5e5653d27b8a06$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7a5e5653d27b8a06$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $7a5e5653d27b8a06$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $7a5e5653d27b8a06$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($7a5e5653d27b8a06$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $7a5e5653d27b8a06$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $7a5e5653d27b8a06$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $7a5e5653d27b8a06$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $7a5e5653d27b8a06$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $7a5e5653d27b8a06$var$stringToByteArray$1(str);
    return $7a5e5653d27b8a06$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $7a5e5653d27b8a06$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $7a5e5653d27b8a06$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $7a5e5653d27b8a06$export$c62426fdd000a97e = function(str) {
    try {
        return $7a5e5653d27b8a06$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $7a5e5653d27b8a06$export$6c40052bed430212(value) {
    return $7a5e5653d27b8a06$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $7a5e5653d27b8a06$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$7a5e5653d27b8a06$var$isValidKey(prop)) continue;
        target[prop] = $7a5e5653d27b8a06$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $7a5e5653d27b8a06$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $7a5e5653d27b8a06$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7a5e5653d27b8a06$var$getDefaultsFromGlobal = ()=>$7a5e5653d27b8a06$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $7a5e5653d27b8a06$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $7a5e5653d27b8a06$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $7a5e5653d27b8a06$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $7a5e5653d27b8a06$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $e977a5410621f4d7$export$6d3c090e66a883b1)() || $7a5e5653d27b8a06$var$getDefaultsFromGlobal() || $7a5e5653d27b8a06$var$getDefaultsFromEnvVariable() || $7a5e5653d27b8a06$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $7a5e5653d27b8a06$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $7a5e5653d27b8a06$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $7a5e5653d27b8a06$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $7a5e5653d27b8a06$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $7a5e5653d27b8a06$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $7a5e5653d27b8a06$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $7a5e5653d27b8a06$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $7a5e5653d27b8a06$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $7a5e5653d27b8a06$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $7a5e5653d27b8a06$export$5b4d24b45140ad90(host) {
    return host.endsWith('.cloudworkstations.dev');
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $7a5e5653d27b8a06$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7a5e5653d27b8a06$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $7a5e5653d27b8a06$export$4b5284a3025a455(JSON.stringify(header)),
        $7a5e5653d27b8a06$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $7a5e5653d27b8a06$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $7a5e5653d27b8a06$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($7a5e5653d27b8a06$var$emulatorStatus))if ($7a5e5653d27b8a06$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $7a5e5653d27b8a06$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $7a5e5653d27b8a06$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $7a5e5653d27b8a06$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$7a5e5653d27b8a06$export$5b4d24b45140ad90(window.location.host) || $7a5e5653d27b8a06$var$emulatorStatus[name] === isRunningEmulator || $7a5e5653d27b8a06$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $7a5e5653d27b8a06$var$previouslyDismissed) return;
    $7a5e5653d27b8a06$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $7a5e5653d27b8a06$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $7a5e5653d27b8a06$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $7a5e5653d27b8a06$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $7a5e5653d27b8a06$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $7a5e5653d27b8a06$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($7a5e5653d27b8a06$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $7a5e5653d27b8a06$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $7a5e5653d27b8a06$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $7a5e5653d27b8a06$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $7a5e5653d27b8a06$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $7a5e5653d27b8a06$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $7a5e5653d27b8a06$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $7a5e5653d27b8a06$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $7a5e5653d27b8a06$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $7a5e5653d27b8a06$export$f2f6a8999f8ebd30() {
    return $7a5e5653d27b8a06$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $7a5e5653d27b8a06$export$7e7b1a9668aaed8() {
    const ua = $7a5e5653d27b8a06$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $7a5e5653d27b8a06$export$202944b2d2824246() {
    return $7a5e5653d27b8a06$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $7a5e5653d27b8a06$export$5d1d834fbbf8bab7() {
    return $7a5e5653d27b8a06$export$588c7fdda06fbb0a.NODE_CLIENT === true || $7a5e5653d27b8a06$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $7a5e5653d27b8a06$export$95df08bae54cb4df() {
    return !$7a5e5653d27b8a06$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $7a5e5653d27b8a06$export$ef10bcfb06572016() {
    return !$7a5e5653d27b8a06$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $7a5e5653d27b8a06$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $7a5e5653d27b8a06$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $7a5e5653d27b8a06$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $7a5e5653d27b8a06$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $7a5e5653d27b8a06$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $7a5e5653d27b8a06$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $7a5e5653d27b8a06$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7a5e5653d27b8a06$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $7a5e5653d27b8a06$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $7a5e5653d27b8a06$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $7a5e5653d27b8a06$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $7a5e5653d27b8a06$var$replaceTemplate(template, data) {
    return template.replace($7a5e5653d27b8a06$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $7a5e5653d27b8a06$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $7a5e5653d27b8a06$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $7a5e5653d27b8a06$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $7a5e5653d27b8a06$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $7a5e5653d27b8a06$export$c5a53ce6a17cf18d($7a5e5653d27b8a06$export$c62426fdd000a97e(parts[0]) || '');
        claims = $7a5e5653d27b8a06$export$c5a53ce6a17cf18d($7a5e5653d27b8a06$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $7a5e5653d27b8a06$export$5f870fcca7ae6a88 = function(token) {
    const claims = $7a5e5653d27b8a06$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $7a5e5653d27b8a06$export$701c661ec91095f2 = function(token) {
    const claims = $7a5e5653d27b8a06$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $7a5e5653d27b8a06$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $7a5e5653d27b8a06$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $7a5e5653d27b8a06$export$fc970ed23da99565 = function(token) {
    const claims = $7a5e5653d27b8a06$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7a5e5653d27b8a06$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $7a5e5653d27b8a06$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $7a5e5653d27b8a06$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $7a5e5653d27b8a06$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $7a5e5653d27b8a06$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($7a5e5653d27b8a06$var$isObject(aProp) && $7a5e5653d27b8a06$var$isObject(bProp)) {
            if (!$7a5e5653d27b8a06$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $7a5e5653d27b8a06$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $7a5e5653d27b8a06$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $7a5e5653d27b8a06$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $7a5e5653d27b8a06$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $7a5e5653d27b8a06$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $7a5e5653d27b8a06$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $7a5e5653d27b8a06$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $7a5e5653d27b8a06$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $7a5e5653d27b8a06$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $7a5e5653d27b8a06$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($7a5e5653d27b8a06$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $7a5e5653d27b8a06$var$noop;
        if (observer.error === undefined) observer.error = $7a5e5653d27b8a06$var$noop;
        if (observer.complete === undefined) observer.complete = $7a5e5653d27b8a06$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $7a5e5653d27b8a06$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $7a5e5653d27b8a06$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $7a5e5653d27b8a06$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $7a5e5653d27b8a06$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $7a5e5653d27b8a06$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $7a5e5653d27b8a06$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($7a5e5653d27b8a06$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $7a5e5653d27b8a06$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($7a5e5653d27b8a06$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $7a5e5653d27b8a06$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($7a5e5653d27b8a06$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $7a5e5653d27b8a06$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $7a5e5653d27b8a06$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $7a5e5653d27b8a06$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $7a5e5653d27b8a06$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $7a5e5653d27b8a06$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $7a5e5653d27b8a06$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $7a5e5653d27b8a06$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $7a5e5653d27b8a06$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $7a5e5653d27b8a06$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $7a5e5653d27b8a06$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $7a5e5653d27b8a06$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($7a5e5653d27b8a06$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $7a5e5653d27b8a06$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $7a5e5653d27b8a06$var$indicator(i);
}
function $7a5e5653d27b8a06$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7a5e5653d27b8a06$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $d4d618502f0d98d6$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $d4d618502f0d98d6$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $7a5e5653d27b8a06$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($d4d618502f0d98d6$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $d4d618502f0d98d6$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $d4d618502f0d98d6$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $d4d618502f0d98d6$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $d4d618502f0d98d6$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $d4d618502f0d98d6$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $d4d618502f0d98d6$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $a8534f819b344ec2$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $a8534f819b344ec2$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($a8534f819b344ec2$export$243e62d78d3b544d || ($a8534f819b344ec2$export$243e62d78d3b544d = {}));
const $a8534f819b344ec2$var$levelStringToEnum = {
    'debug': $a8534f819b344ec2$export$243e62d78d3b544d.DEBUG,
    'verbose': $a8534f819b344ec2$export$243e62d78d3b544d.VERBOSE,
    'info': $a8534f819b344ec2$export$243e62d78d3b544d.INFO,
    'warn': $a8534f819b344ec2$export$243e62d78d3b544d.WARN,
    'error': $a8534f819b344ec2$export$243e62d78d3b544d.ERROR,
    'silent': $a8534f819b344ec2$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $a8534f819b344ec2$var$defaultLogLevel = $a8534f819b344ec2$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $a8534f819b344ec2$var$ConsoleMethod = {
    [$a8534f819b344ec2$export$243e62d78d3b544d.DEBUG]: 'log',
    [$a8534f819b344ec2$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$a8534f819b344ec2$export$243e62d78d3b544d.INFO]: 'info',
    [$a8534f819b344ec2$export$243e62d78d3b544d.WARN]: 'warn',
    [$a8534f819b344ec2$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $a8534f819b344ec2$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $a8534f819b344ec2$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $a8534f819b344ec2$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $a8534f819b344ec2$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $a8534f819b344ec2$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $a8534f819b344ec2$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $a8534f819b344ec2$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $a8534f819b344ec2$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $a8534f819b344ec2$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $a8534f819b344ec2$export$c622e99c0ce7b1c9(level) {
    $a8534f819b344ec2$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $a8534f819b344ec2$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $a8534f819b344ec2$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $a8534f819b344ec2$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $a8534f819b344ec2$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $c291a8d9e7b8b471$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $c291a8d9e7b8b471$var$idbProxyableTypes;
let $c291a8d9e7b8b471$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $c291a8d9e7b8b471$var$getIdbProxyableTypes() {
    return $c291a8d9e7b8b471$var$idbProxyableTypes || ($c291a8d9e7b8b471$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $c291a8d9e7b8b471$var$getCursorAdvanceMethods() {
    return $c291a8d9e7b8b471$var$cursorAdvanceMethods || ($c291a8d9e7b8b471$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $c291a8d9e7b8b471$var$cursorRequestMap = new WeakMap();
const $c291a8d9e7b8b471$var$transactionDoneMap = new WeakMap();
const $c291a8d9e7b8b471$var$transactionStoreNamesMap = new WeakMap();
const $c291a8d9e7b8b471$var$transformCache = new WeakMap();
const $c291a8d9e7b8b471$export$407448d2b89b1813 = new WeakMap();
function $c291a8d9e7b8b471$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($c291a8d9e7b8b471$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $c291a8d9e7b8b471$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $c291a8d9e7b8b471$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $c291a8d9e7b8b471$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($c291a8d9e7b8b471$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $c291a8d9e7b8b471$var$transactionDoneMap.set(tx, done);
}
let $c291a8d9e7b8b471$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $c291a8d9e7b8b471$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $c291a8d9e7b8b471$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $c291a8d9e7b8b471$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $c291a8d9e7b8b471$export$43caf9889c228507(callback) {
    $c291a8d9e7b8b471$var$idbProxyTraps = callback($c291a8d9e7b8b471$var$idbProxyTraps);
}
function $c291a8d9e7b8b471$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($c291a8d9e7b8b471$export$3b14a55fb2447963(this), storeNames, ...args);
        $c291a8d9e7b8b471$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $c291a8d9e7b8b471$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($c291a8d9e7b8b471$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($c291a8d9e7b8b471$export$3b14a55fb2447963(this), args);
        return $c291a8d9e7b8b471$export$efccba1c4a2ef57b($c291a8d9e7b8b471$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $c291a8d9e7b8b471$export$efccba1c4a2ef57b(func.apply($c291a8d9e7b8b471$export$3b14a55fb2447963(this), args));
    };
}
function $c291a8d9e7b8b471$var$transformCachableValue(value) {
    if (typeof value === 'function') return $c291a8d9e7b8b471$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $c291a8d9e7b8b471$var$cacheDonePromiseForTransaction(value);
    if ($c291a8d9e7b8b471$export$23f2a1d2818174ef(value, $c291a8d9e7b8b471$var$getIdbProxyableTypes())) return new Proxy(value, $c291a8d9e7b8b471$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $c291a8d9e7b8b471$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $c291a8d9e7b8b471$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($c291a8d9e7b8b471$var$transformCache.has(value)) return $c291a8d9e7b8b471$var$transformCache.get(value);
    const newValue = $c291a8d9e7b8b471$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $c291a8d9e7b8b471$var$transformCache.set(value, newValue);
        $c291a8d9e7b8b471$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $c291a8d9e7b8b471$export$3b14a55fb2447963 = (value)=>$c291a8d9e7b8b471$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $81a1df7e0637fd87$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $c291a8d9e7b8b471$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $c291a8d9e7b8b471$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $c291a8d9e7b8b471$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $81a1df7e0637fd87$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $c291a8d9e7b8b471$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $81a1df7e0637fd87$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $81a1df7e0637fd87$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $81a1df7e0637fd87$var$cachedMethods = new Map();
function $81a1df7e0637fd87$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($81a1df7e0637fd87$var$cachedMethods.get(prop)) return $81a1df7e0637fd87$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $81a1df7e0637fd87$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $81a1df7e0637fd87$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $81a1df7e0637fd87$var$cachedMethods.set(prop, method);
    return method;
}
(0, $c291a8d9e7b8b471$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$81a1df7e0637fd87$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$81a1df7e0637fd87$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $3c66ef1885bbdcd1$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($3c66ef1885bbdcd1$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $3c66ef1885bbdcd1$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $3c66ef1885bbdcd1$var$name$q = "@firebase/app";
const $3c66ef1885bbdcd1$var$version$1 = "0.13.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3c66ef1885bbdcd1$var$logger = new (0, $a8534f819b344ec2$export$efa9a398d6368992)('@firebase/app');
const $3c66ef1885bbdcd1$var$name$p = "@firebase/app-compat";
const $3c66ef1885bbdcd1$var$name$o = "@firebase/analytics-compat";
const $3c66ef1885bbdcd1$var$name$n = "@firebase/analytics";
const $3c66ef1885bbdcd1$var$name$m = "@firebase/app-check-compat";
const $3c66ef1885bbdcd1$var$name$l = "@firebase/app-check";
const $3c66ef1885bbdcd1$var$name$k = "@firebase/auth";
const $3c66ef1885bbdcd1$var$name$j = "@firebase/auth-compat";
const $3c66ef1885bbdcd1$var$name$i = "@firebase/database";
const $3c66ef1885bbdcd1$var$name$h = "@firebase/data-connect";
const $3c66ef1885bbdcd1$var$name$g = "@firebase/database-compat";
const $3c66ef1885bbdcd1$var$name$f = "@firebase/functions";
const $3c66ef1885bbdcd1$var$name$e = "@firebase/functions-compat";
const $3c66ef1885bbdcd1$var$name$d = "@firebase/installations";
const $3c66ef1885bbdcd1$var$name$c = "@firebase/installations-compat";
const $3c66ef1885bbdcd1$var$name$b = "@firebase/messaging";
const $3c66ef1885bbdcd1$var$name$a = "@firebase/messaging-compat";
const $3c66ef1885bbdcd1$var$name$9 = "@firebase/performance";
const $3c66ef1885bbdcd1$var$name$8 = "@firebase/performance-compat";
const $3c66ef1885bbdcd1$var$name$7 = "@firebase/remote-config";
const $3c66ef1885bbdcd1$var$name$6 = "@firebase/remote-config-compat";
const $3c66ef1885bbdcd1$var$name$5 = "@firebase/storage";
const $3c66ef1885bbdcd1$var$name$4 = "@firebase/storage-compat";
const $3c66ef1885bbdcd1$var$name$3 = "@firebase/firestore";
const $3c66ef1885bbdcd1$var$name$2 = "@firebase/ai";
const $3c66ef1885bbdcd1$var$name$1 = "@firebase/firestore-compat";
const $3c66ef1885bbdcd1$var$name = "firebase";
const $3c66ef1885bbdcd1$var$version = "11.8.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $3c66ef1885bbdcd1$export$9f30fa0c10967f7f = '[DEFAULT]';
const $3c66ef1885bbdcd1$var$PLATFORM_LOG_STRING = {
    [$3c66ef1885bbdcd1$var$name$q]: 'fire-core',
    [$3c66ef1885bbdcd1$var$name$p]: 'fire-core-compat',
    [$3c66ef1885bbdcd1$var$name$n]: 'fire-analytics',
    [$3c66ef1885bbdcd1$var$name$o]: 'fire-analytics-compat',
    [$3c66ef1885bbdcd1$var$name$l]: 'fire-app-check',
    [$3c66ef1885bbdcd1$var$name$m]: 'fire-app-check-compat',
    [$3c66ef1885bbdcd1$var$name$k]: 'fire-auth',
    [$3c66ef1885bbdcd1$var$name$j]: 'fire-auth-compat',
    [$3c66ef1885bbdcd1$var$name$i]: 'fire-rtdb',
    [$3c66ef1885bbdcd1$var$name$h]: 'fire-data-connect',
    [$3c66ef1885bbdcd1$var$name$g]: 'fire-rtdb-compat',
    [$3c66ef1885bbdcd1$var$name$f]: 'fire-fn',
    [$3c66ef1885bbdcd1$var$name$e]: 'fire-fn-compat',
    [$3c66ef1885bbdcd1$var$name$d]: 'fire-iid',
    [$3c66ef1885bbdcd1$var$name$c]: 'fire-iid-compat',
    [$3c66ef1885bbdcd1$var$name$b]: 'fire-fcm',
    [$3c66ef1885bbdcd1$var$name$a]: 'fire-fcm-compat',
    [$3c66ef1885bbdcd1$var$name$9]: 'fire-perf',
    [$3c66ef1885bbdcd1$var$name$8]: 'fire-perf-compat',
    [$3c66ef1885bbdcd1$var$name$7]: 'fire-rc',
    [$3c66ef1885bbdcd1$var$name$6]: 'fire-rc-compat',
    [$3c66ef1885bbdcd1$var$name$5]: 'fire-gcs',
    [$3c66ef1885bbdcd1$var$name$4]: 'fire-gcs-compat',
    [$3c66ef1885bbdcd1$var$name$3]: 'fire-fst',
    [$3c66ef1885bbdcd1$var$name$1]: 'fire-fst-compat',
    [$3c66ef1885bbdcd1$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$3c66ef1885bbdcd1$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $3c66ef1885bbdcd1$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $3c66ef1885bbdcd1$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3c66ef1885bbdcd1$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $3c66ef1885bbdcd1$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($3c66ef1885bbdcd1$export$9566bce3835c0f28.has(componentName)) {
        $3c66ef1885bbdcd1$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $3c66ef1885bbdcd1$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $3c66ef1885bbdcd1$export$b4e3c36c855b14b5.values())$3c66ef1885bbdcd1$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $3c66ef1885bbdcd1$export$fb03ad8d3d5c5f76.values())$3c66ef1885bbdcd1$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $3c66ef1885bbdcd1$export$9f30fa0c10967f7f) {
    $3c66ef1885bbdcd1$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $3c66ef1885bbdcd1$export$3685d89b9c3cdfaf() {
    $3c66ef1885bbdcd1$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3c66ef1885bbdcd1$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $3c66ef1885bbdcd1$var$ERROR_FACTORY = new (0, $7a5e5653d27b8a06$export$3fa6e1b18a3b2d40)('app', 'Firebase', $3c66ef1885bbdcd1$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $3c66ef1885bbdcd1$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $d4d618502f0d98d6$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $3c66ef1885bbdcd1$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $7a5e5653d27b8a06$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $3c66ef1885bbdcd1$var$FirebaseServerAppImpl extends $3c66ef1885bbdcd1$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $3c66ef1885bbdcd1$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $3c66ef1885bbdcd1$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $3c66ef1885bbdcd1$export$d29d5299a7137abc($3c66ef1885bbdcd1$var$name$q, $3c66ef1885bbdcd1$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $3c66ef1885bbdcd1$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $3c66ef1885bbdcd1$export$31499a9cd224b78c = $3c66ef1885bbdcd1$var$version;
function $3c66ef1885bbdcd1$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $3c66ef1885bbdcd1$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $7a5e5653d27b8a06$export$3dfb6827a9f89756)());
    if (!options) throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $3c66ef1885bbdcd1$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $7a5e5653d27b8a06$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $7a5e5653d27b8a06$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $d4d618502f0d98d6$export$436a80eea5d5c0c5)(name);
    for (const component of $3c66ef1885bbdcd1$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $3c66ef1885bbdcd1$var$FirebaseAppImpl(options, config, container);
    $3c66ef1885bbdcd1$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $3c66ef1885bbdcd1$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $7a5e5653d27b8a06$export$4e09c449d6c407f7)() && !(0, $7a5e5653d27b8a06$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = true;
    let appOptions;
    if ($3c66ef1885bbdcd1$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $3c66ef1885bbdcd1$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $d4d618502f0d98d6$export$436a80eea5d5c0c5)(nameString);
    for (const component of $3c66ef1885bbdcd1$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $3c66ef1885bbdcd1$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $3c66ef1885bbdcd1$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $3c66ef1885bbdcd1$export$f9962582c9e66d99(name = $3c66ef1885bbdcd1$export$9f30fa0c10967f7f) {
    const app = $3c66ef1885bbdcd1$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $3c66ef1885bbdcd1$export$9f30fa0c10967f7f && (0, $7a5e5653d27b8a06$export$3dfb6827a9f89756)()) return $3c66ef1885bbdcd1$export$c55cfd413944906d();
    if (!app) throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $3c66ef1885bbdcd1$export$68ddedf7d44b3bdf() {
    return Array.from($3c66ef1885bbdcd1$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $3c66ef1885bbdcd1$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($3c66ef1885bbdcd1$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $3c66ef1885bbdcd1$export$b4e3c36c855b14b5.delete(name);
    } else if ($3c66ef1885bbdcd1$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $3c66ef1885bbdcd1$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $3c66ef1885bbdcd1$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $3c66ef1885bbdcd1$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $3c66ef1885bbdcd1$var$logger.warn(warning.join(' '));
        return;
    }
    $3c66ef1885bbdcd1$export$c930050e7bb63965(new (0, $d4d618502f0d98d6$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $3c66ef1885bbdcd1$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $a8534f819b344ec2$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $3c66ef1885bbdcd1$export$c622e99c0ce7b1c9(logLevel) {
    (0, $a8534f819b344ec2$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3c66ef1885bbdcd1$var$DB_NAME = 'firebase-heartbeat-database';
const $3c66ef1885bbdcd1$var$DB_VERSION = 1;
const $3c66ef1885bbdcd1$var$STORE_NAME = 'firebase-heartbeat-store';
let $3c66ef1885bbdcd1$var$dbPromise = null;
function $3c66ef1885bbdcd1$var$getDbPromise() {
    if (!$3c66ef1885bbdcd1$var$dbPromise) $3c66ef1885bbdcd1$var$dbPromise = (0, $81a1df7e0637fd87$export$ca0ed41b1a2af7e)($3c66ef1885bbdcd1$var$DB_NAME, $3c66ef1885bbdcd1$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($3c66ef1885bbdcd1$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $3c66ef1885bbdcd1$var$dbPromise;
}
async function $3c66ef1885bbdcd1$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $3c66ef1885bbdcd1$var$getDbPromise();
        const tx = db.transaction($3c66ef1885bbdcd1$var$STORE_NAME);
        const result = await tx.objectStore($3c66ef1885bbdcd1$var$STORE_NAME).get($3c66ef1885bbdcd1$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $7a5e5653d27b8a06$export$dd24e9cd51226c56)) $3c66ef1885bbdcd1$var$logger.warn(e.message);
        else {
            const idbGetError = $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $3c66ef1885bbdcd1$var$logger.warn(idbGetError.message);
        }
    }
}
async function $3c66ef1885bbdcd1$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $3c66ef1885bbdcd1$var$getDbPromise();
        const tx = db.transaction($3c66ef1885bbdcd1$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($3c66ef1885bbdcd1$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $3c66ef1885bbdcd1$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $7a5e5653d27b8a06$export$dd24e9cd51226c56)) $3c66ef1885bbdcd1$var$logger.warn(e.message);
        else {
            const idbGetError = $3c66ef1885bbdcd1$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $3c66ef1885bbdcd1$var$logger.warn(idbGetError.message);
        }
    }
}
function $3c66ef1885bbdcd1$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3c66ef1885bbdcd1$var$MAX_HEADER_BYTES = 1024;
const $3c66ef1885bbdcd1$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $3c66ef1885bbdcd1$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $3c66ef1885bbdcd1$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $3c66ef1885bbdcd1$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $3c66ef1885bbdcd1$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $3c66ef1885bbdcd1$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $3c66ef1885bbdcd1$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $3c66ef1885bbdcd1$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $3c66ef1885bbdcd1$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $7a5e5653d27b8a06$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $3c66ef1885bbdcd1$var$logger.warn(e);
            return '';
        }
    }
}
function $3c66ef1885bbdcd1$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $3c66ef1885bbdcd1$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $3c66ef1885bbdcd1$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($3c66ef1885bbdcd1$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($3c66ef1885bbdcd1$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $3c66ef1885bbdcd1$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $7a5e5653d27b8a06$export$3865db50535c2055)()) return false;
        else return (0, $7a5e5653d27b8a06$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $3c66ef1885bbdcd1$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $3c66ef1885bbdcd1$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $3c66ef1885bbdcd1$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $3c66ef1885bbdcd1$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $7a5e5653d27b8a06$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $3c66ef1885bbdcd1$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3c66ef1885bbdcd1$var$registerCoreComponents(variant) {
    $3c66ef1885bbdcd1$export$c930050e7bb63965(new (0, $d4d618502f0d98d6$export$16fa2f45be04daa8)('platform-logger', (container)=>new $3c66ef1885bbdcd1$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $3c66ef1885bbdcd1$export$c930050e7bb63965(new (0, $d4d618502f0d98d6$export$16fa2f45be04daa8)('heartbeat', (container)=>new $3c66ef1885bbdcd1$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $3c66ef1885bbdcd1$export$d29d5299a7137abc($3c66ef1885bbdcd1$var$name$q, $3c66ef1885bbdcd1$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    $3c66ef1885bbdcd1$export$d29d5299a7137abc($3c66ef1885bbdcd1$var$name$q, $3c66ef1885bbdcd1$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $3c66ef1885bbdcd1$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $3c66ef1885bbdcd1$var$registerCoreComponents('');


var $d2f428773eceb5e8$var$name = "firebase";
var $d2f428773eceb5e8$var$version = "11.8.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $3c66ef1885bbdcd1$export$d29d5299a7137abc)($d2f428773eceb5e8$var$name, $d2f428773eceb5e8$var$version, 'app');




/*
 Copyright 2022 Google LLC
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ // Creates the `web-vitals/attribution` import in node-based bundlers.
// This will not be needed when export maps are widely supported.
var $0460d4c5c2c90578$var$t, $0460d4c5c2c90578$var$e, $0460d4c5c2c90578$var$n = function() {
    var t = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, $0460d4c5c2c90578$var$r = function(t) {
    if ("loading" === document.readyState) return "loading";
    var e = $0460d4c5c2c90578$var$n();
    if (e) {
        if (t < e.domInteractive) return "loading";
        if (0 === e.domContentLoadedEventStart || t < e.domContentLoadedEventStart) return "dom-interactive";
        if (0 === e.domComplete || t < e.domComplete) return "dom-content-loaded";
    }
    return "complete";
}, $0460d4c5c2c90578$var$i = function(t) {
    var e = t.nodeName;
    return 1 === t.nodeType ? e.toLowerCase() : e.toUpperCase().replace(/^#/, "");
}, $0460d4c5c2c90578$var$a = function(t, e) {
    var n = "";
    try {
        for(; t && 9 !== t.nodeType;){
            var r = t, a = r.id ? "#" + r.id : $0460d4c5c2c90578$var$i(r) + (r.classList && r.classList.value && r.classList.value.trim() && r.classList.value.trim().length ? "." + r.classList.value.trim().replace(/\s+/g, ".") : "");
            if (n.length + a.length > (e || 100) - 1) return n || a;
            if (n = n ? a + ">" + n : a, r.id) break;
            t = r.parentNode;
        }
    } catch (t) {}
    return n;
}, $0460d4c5c2c90578$var$o = -1, $0460d4c5c2c90578$var$c = function() {
    return $0460d4c5c2c90578$var$o;
}, $0460d4c5c2c90578$var$u = function(t) {
    addEventListener("pageshow", function(e) {
        e.persisted && ($0460d4c5c2c90578$var$o = e.timeStamp, t(e));
    }, !0);
}, $0460d4c5c2c90578$var$s = function() {
    var t = $0460d4c5c2c90578$var$n();
    return t && t.activationStart || 0;
}, $0460d4c5c2c90578$var$f = function(t, e) {
    var r = $0460d4c5c2c90578$var$n(), i = "navigate";
    $0460d4c5c2c90578$var$c() >= 0 ? i = "back-forward-cache" : r && (document.prerendering || $0460d4c5c2c90578$var$s() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : r.type && (i = r.type.replace(/_/g, "-")));
    return {
        name: t,
        value: void 0 === e ? -1 : e,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: i
    };
}, $0460d4c5c2c90578$var$d = function(t, e, n) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(t)) {
            var r = new PerformanceObserver(function(t) {
                Promise.resolve().then(function() {
                    e(t.getEntries());
                });
            });
            return r.observe(Object.assign({
                type: t,
                buffered: !0
            }, n || {})), r;
        }
    } catch (t) {}
}, $0460d4c5c2c90578$var$l = function(t, e, n, r) {
    var i, a;
    return function(o) {
        e.value >= 0 && (o || r) && ((a = e.value - (i || 0)) || void 0 === i) && (i = e.value, e.delta = a, e.rating = function(t, e) {
            return t > e[1] ? "poor" : t > e[0] ? "needs-improvement" : "good";
        }(e.value, n), t(e));
    };
}, $0460d4c5c2c90578$var$m = function(t) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return t();
        });
    });
}, $0460d4c5c2c90578$var$p = function(t) {
    document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && t();
    });
}, $0460d4c5c2c90578$var$v = function(t) {
    var e = !1;
    return function() {
        e || (t(), e = !0);
    };
}, $0460d4c5c2c90578$var$g = -1, $0460d4c5c2c90578$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $0460d4c5c2c90578$var$T = function(t) {
    "hidden" === document.visibilityState && $0460d4c5c2c90578$var$g > -1 && ($0460d4c5c2c90578$var$g = "visibilitychange" === t.type ? t.timeStamp : 0, $0460d4c5c2c90578$var$E());
}, $0460d4c5c2c90578$var$y = function() {
    addEventListener("visibilitychange", $0460d4c5c2c90578$var$T, !0), addEventListener("prerenderingchange", $0460d4c5c2c90578$var$T, !0);
}, $0460d4c5c2c90578$var$E = function() {
    removeEventListener("visibilitychange", $0460d4c5c2c90578$var$T, !0), removeEventListener("prerenderingchange", $0460d4c5c2c90578$var$T, !0);
}, $0460d4c5c2c90578$var$S = function() {
    return $0460d4c5c2c90578$var$g < 0 && ($0460d4c5c2c90578$var$g = $0460d4c5c2c90578$var$h(), $0460d4c5c2c90578$var$y(), $0460d4c5c2c90578$var$u(function() {
        setTimeout(function() {
            $0460d4c5c2c90578$var$g = $0460d4c5c2c90578$var$h(), $0460d4c5c2c90578$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $0460d4c5c2c90578$var$g;
        }
    };
}, $0460d4c5c2c90578$var$b = function(t) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return t();
    }, !0) : t();
}, $0460d4c5c2c90578$export$e610c735b5510cec = [
    1800,
    3e3
], $0460d4c5c2c90578$var$C = function(t, e) {
    e = e || {}, $0460d4c5c2c90578$var$b(function() {
        var n, r = $0460d4c5c2c90578$var$S(), i = $0460d4c5c2c90578$var$f("FCP"), a = $0460d4c5c2c90578$var$d("paint", function(t) {
            t.forEach(function(t) {
                "first-contentful-paint" === t.name && (a.disconnect(), t.startTime < r.firstHiddenTime && (i.value = Math.max(t.startTime - $0460d4c5c2c90578$var$s(), 0), i.entries.push(t), n(!0)));
            });
        });
        a && (n = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$e610c735b5510cec, e.reportAllChanges), $0460d4c5c2c90578$var$u(function(r) {
            i = $0460d4c5c2c90578$var$f("FCP"), n = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$e610c735b5510cec, e.reportAllChanges), $0460d4c5c2c90578$var$m(function() {
                i.value = performance.now() - r.timeStamp, n(!0);
            });
        }));
    });
}, $0460d4c5c2c90578$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $0460d4c5c2c90578$export$a7873055838e5ad8 = function(t, e) {
    !function(t, e) {
        e = e || {}, $0460d4c5c2c90578$var$C($0460d4c5c2c90578$var$v(function() {
            var n, r = $0460d4c5c2c90578$var$f("CLS", 0), i = 0, a = [], o = function(t) {
                t.forEach(function(t) {
                    if (!t.hadRecentInput) {
                        var e = a[0], n = a[a.length - 1];
                        i && t.startTime - n.startTime < 1e3 && t.startTime - e.startTime < 5e3 ? (i += t.value, a.push(t)) : (i = t.value, a = [
                            t
                        ]);
                    }
                }), i > r.value && (r.value = i, r.entries = a, n());
            }, c = $0460d4c5c2c90578$var$d("layout-shift", o);
            c && (n = $0460d4c5c2c90578$var$l(t, r, $0460d4c5c2c90578$export$3f20d8e089ac35b2, e.reportAllChanges), $0460d4c5c2c90578$var$p(function() {
                o(c.takeRecords()), n(!0);
            }), $0460d4c5c2c90578$var$u(function() {
                i = 0, r = $0460d4c5c2c90578$var$f("CLS", 0), n = $0460d4c5c2c90578$var$l(t, r, $0460d4c5c2c90578$export$3f20d8e089ac35b2, e.reportAllChanges), $0460d4c5c2c90578$var$m(function() {
                    return n();
                });
            }), setTimeout(n, 0));
        }));
    }(function(e) {
        var n = function(t) {
            var e, n = {};
            if (t.entries.length) {
                var i = t.entries.reduce(function(t, e) {
                    return t && t.value > e.value ? t : e;
                });
                if (i && i.sources && i.sources.length) {
                    var o = (e = i.sources).find(function(t) {
                        return t.node && 1 === t.node.nodeType;
                    }) || e[0];
                    o && (n = {
                        largestShiftTarget: $0460d4c5c2c90578$var$a(o.node),
                        largestShiftTime: i.startTime,
                        largestShiftValue: i.value,
                        largestShiftSource: o,
                        largestShiftEntry: i,
                        loadState: $0460d4c5c2c90578$var$r(i.startTime)
                    });
                }
            }
            return Object.assign(t, {
                attribution: n
            });
        }(e);
        t(n);
    }, e);
}, $0460d4c5c2c90578$export$fe3c86b74e15d5de = function(t, e) {
    $0460d4c5c2c90578$var$C(function(e) {
        var i = function(t) {
            var e = {
                timeToFirstByte: 0,
                firstByteToFCP: t.value,
                loadState: $0460d4c5c2c90578$var$r($0460d4c5c2c90578$var$c())
            };
            if (t.entries.length) {
                var i = $0460d4c5c2c90578$var$n(), a = t.entries[t.entries.length - 1];
                if (i) {
                    var o = i.activationStart || 0, u = Math.max(0, i.responseStart - o);
                    e = {
                        timeToFirstByte: u,
                        firstByteToFCP: t.value - u,
                        loadState: $0460d4c5c2c90578$var$r(t.entries[0].startTime),
                        navigationEntry: i,
                        fcpEntry: a
                    };
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(i);
    }, e);
}, $0460d4c5c2c90578$var$x = 0, $0460d4c5c2c90578$var$I = 1 / 0, $0460d4c5c2c90578$var$k = 0, $0460d4c5c2c90578$var$A = function(t) {
    t.forEach(function(t) {
        t.interactionId && ($0460d4c5c2c90578$var$I = Math.min($0460d4c5c2c90578$var$I, t.interactionId), $0460d4c5c2c90578$var$k = Math.max($0460d4c5c2c90578$var$k, t.interactionId), $0460d4c5c2c90578$var$x = $0460d4c5c2c90578$var$k ? ($0460d4c5c2c90578$var$k - $0460d4c5c2c90578$var$I) / 7 + 1 : 0);
    });
}, $0460d4c5c2c90578$var$F = function() {
    return $0460d4c5c2c90578$var$t ? $0460d4c5c2c90578$var$x : performance.interactionCount || 0;
}, $0460d4c5c2c90578$var$P = function() {
    "interactionCount" in performance || $0460d4c5c2c90578$var$t || ($0460d4c5c2c90578$var$t = $0460d4c5c2c90578$var$d("event", $0460d4c5c2c90578$var$A, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $0460d4c5c2c90578$var$B = [], $0460d4c5c2c90578$var$O = new Map, $0460d4c5c2c90578$var$R = 0, $0460d4c5c2c90578$var$j = function() {
    var t = Math.min($0460d4c5c2c90578$var$B.length - 1, Math.floor(($0460d4c5c2c90578$var$F() - $0460d4c5c2c90578$var$R) / 50));
    return $0460d4c5c2c90578$var$B[t];
}, $0460d4c5c2c90578$var$q = [], $0460d4c5c2c90578$var$H = function(t) {
    if ($0460d4c5c2c90578$var$q.forEach(function(e) {
        return e(t);
    }), t.interactionId || "first-input" === t.entryType) {
        var e = $0460d4c5c2c90578$var$B[$0460d4c5c2c90578$var$B.length - 1], n = $0460d4c5c2c90578$var$O.get(t.interactionId);
        if (n || $0460d4c5c2c90578$var$B.length < 10 || t.duration > e.latency) {
            if (n) t.duration > n.latency ? (n.entries = [
                t
            ], n.latency = t.duration) : t.duration === n.latency && t.startTime === n.entries[0].startTime && n.entries.push(t);
            else {
                var r = {
                    id: t.interactionId,
                    latency: t.duration,
                    entries: [
                        t
                    ]
                };
                $0460d4c5c2c90578$var$O.set(r.id, r), $0460d4c5c2c90578$var$B.push(r);
            }
            $0460d4c5c2c90578$var$B.sort(function(t, e) {
                return e.latency - t.latency;
            }), $0460d4c5c2c90578$var$B.length > 10 && $0460d4c5c2c90578$var$B.splice(10).forEach(function(t) {
                return $0460d4c5c2c90578$var$O.delete(t.id);
            });
        }
    }
}, $0460d4c5c2c90578$var$N = function(t) {
    var e = self.requestIdleCallback || self.setTimeout, n = -1;
    return t = $0460d4c5c2c90578$var$v(t), "hidden" === document.visibilityState ? t() : (n = e(t), $0460d4c5c2c90578$var$p(t)), n;
}, $0460d4c5c2c90578$export$7f4cb060ded9173c = [
    200,
    500
], $0460d4c5c2c90578$var$z = function(t, e) {
    "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (e = e || {}, $0460d4c5c2c90578$var$b(function() {
        var n;
        $0460d4c5c2c90578$var$P();
        var r, i = $0460d4c5c2c90578$var$f("INP"), a = function(t) {
            $0460d4c5c2c90578$var$N(function() {
                t.forEach($0460d4c5c2c90578$var$H);
                var e = $0460d4c5c2c90578$var$j();
                e && e.latency !== i.value && (i.value = e.latency, i.entries = e.entries, r());
            });
        }, o = $0460d4c5c2c90578$var$d("event", a, {
            durationThreshold: null !== (n = e.durationThreshold) && void 0 !== n ? n : 40
        });
        r = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$7f4cb060ded9173c, e.reportAllChanges), o && (o.observe({
            type: "first-input",
            buffered: !0
        }), $0460d4c5c2c90578$var$p(function() {
            a(o.takeRecords()), r(!0);
        }), $0460d4c5c2c90578$var$u(function() {
            $0460d4c5c2c90578$var$R = $0460d4c5c2c90578$var$F(), $0460d4c5c2c90578$var$B.length = 0, $0460d4c5c2c90578$var$O.clear(), i = $0460d4c5c2c90578$var$f("INP"), r = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$7f4cb060ded9173c, e.reportAllChanges);
        }));
    }));
}, $0460d4c5c2c90578$var$U = [], $0460d4c5c2c90578$var$V = [], $0460d4c5c2c90578$var$_ = 0, $0460d4c5c2c90578$var$G = new WeakMap, $0460d4c5c2c90578$var$J = new Map, $0460d4c5c2c90578$var$K = -1, $0460d4c5c2c90578$var$Q = function(t) {
    $0460d4c5c2c90578$var$U = $0460d4c5c2c90578$var$U.concat(t), $0460d4c5c2c90578$var$X();
}, $0460d4c5c2c90578$var$X = function() {
    $0460d4c5c2c90578$var$K < 0 && ($0460d4c5c2c90578$var$K = $0460d4c5c2c90578$var$N($0460d4c5c2c90578$var$Y));
}, $0460d4c5c2c90578$var$Y = function() {
    $0460d4c5c2c90578$var$J.size > 10 && $0460d4c5c2c90578$var$J.forEach(function(t, e) {
        $0460d4c5c2c90578$var$O.has(e) || $0460d4c5c2c90578$var$J.delete(e);
    });
    var t = $0460d4c5c2c90578$var$B.map(function(t) {
        return $0460d4c5c2c90578$var$G.get(t.entries[0]);
    }), e = $0460d4c5c2c90578$var$V.length - 50;
    $0460d4c5c2c90578$var$V = $0460d4c5c2c90578$var$V.filter(function(n, r) {
        return r >= e || t.includes(n);
    });
    for(var n = new Set, r = 0; r < $0460d4c5c2c90578$var$V.length; r++){
        var i = $0460d4c5c2c90578$var$V[r];
        $0460d4c5c2c90578$var$nt(i.startTime, i.processingEnd).forEach(function(t) {
            n.add(t);
        });
    }
    var a = $0460d4c5c2c90578$var$U.length - 1 - 50;
    $0460d4c5c2c90578$var$U = $0460d4c5c2c90578$var$U.filter(function(t, e) {
        return t.startTime > $0460d4c5c2c90578$var$_ && e > a || n.has(t);
    }), $0460d4c5c2c90578$var$K = -1;
};
$0460d4c5c2c90578$var$q.push(function(t) {
    t.interactionId && t.target && !$0460d4c5c2c90578$var$J.has(t.interactionId) && $0460d4c5c2c90578$var$J.set(t.interactionId, t.target);
}, function(t) {
    var e, n = t.startTime + t.duration;
    $0460d4c5c2c90578$var$_ = Math.max($0460d4c5c2c90578$var$_, t.processingEnd);
    for(var r = $0460d4c5c2c90578$var$V.length - 1; r >= 0; r--){
        var i = $0460d4c5c2c90578$var$V[r];
        if (Math.abs(n - i.renderTime) <= 8) {
            (e = i).startTime = Math.min(t.startTime, e.startTime), e.processingStart = Math.min(t.processingStart, e.processingStart), e.processingEnd = Math.max(t.processingEnd, e.processingEnd), e.entries.push(t);
            break;
        }
    }
    e || (e = {
        startTime: t.startTime,
        processingStart: t.processingStart,
        processingEnd: t.processingEnd,
        renderTime: n,
        entries: [
            t
        ]
    }, $0460d4c5c2c90578$var$V.push(e)), (t.interactionId || "first-input" === t.entryType) && $0460d4c5c2c90578$var$G.set(t, e), $0460d4c5c2c90578$var$X();
});
var $0460d4c5c2c90578$var$Z, $0460d4c5c2c90578$var$$, $0460d4c5c2c90578$var$tt, $0460d4c5c2c90578$var$et, $0460d4c5c2c90578$var$nt = function(t, e) {
    for(var n, r = [], i = 0; n = $0460d4c5c2c90578$var$U[i]; i++)if (!(n.startTime + n.duration < t)) {
        if (n.startTime > e) break;
        r.push(n);
    }
    return r;
}, $0460d4c5c2c90578$export$7df4b36ecaed99e1 = function(t, n) {
    $0460d4c5c2c90578$var$e || ($0460d4c5c2c90578$var$e = $0460d4c5c2c90578$var$d("long-animation-frame", $0460d4c5c2c90578$var$Q)), $0460d4c5c2c90578$var$z(function(e) {
        var n = function(t) {
            var e = t.entries[0], n = $0460d4c5c2c90578$var$G.get(e), i = e.processingStart, o = n.processingEnd, c = n.entries.sort(function(t, e) {
                return t.processingStart - e.processingStart;
            }), u = $0460d4c5c2c90578$var$nt(e.startTime, o), s = t.entries.find(function(t) {
                return t.target;
            }), f = s && s.target || $0460d4c5c2c90578$var$J.get(e.interactionId), d = [
                e.startTime + e.duration,
                o
            ].concat(u.map(function(t) {
                return t.startTime + t.duration;
            })), l = Math.max.apply(Math, d), m = {
                interactionTarget: $0460d4c5c2c90578$var$a(f),
                interactionTargetElement: f,
                interactionType: e.name.startsWith("key") ? "keyboard" : "pointer",
                interactionTime: e.startTime,
                nextPaintTime: l,
                processedEventEntries: c,
                longAnimationFrameEntries: u,
                inputDelay: i - e.startTime,
                processingDuration: o - i,
                presentationDelay: Math.max(l - o, 0),
                loadState: $0460d4c5c2c90578$var$r(e.startTime)
            };
            return Object.assign(t, {
                attribution: m
            });
        }(e);
        t(n);
    }, n);
}, $0460d4c5c2c90578$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $0460d4c5c2c90578$var$at = {}, $0460d4c5c2c90578$export$947b1626ab8d5632 = function(t, e) {
    !function(t, e) {
        e = e || {}, $0460d4c5c2c90578$var$b(function() {
            var n, r = $0460d4c5c2c90578$var$S(), i = $0460d4c5c2c90578$var$f("LCP"), a = function(t) {
                e.reportAllChanges || (t = t.slice(-1)), t.forEach(function(t) {
                    t.startTime < r.firstHiddenTime && (i.value = Math.max(t.startTime - $0460d4c5c2c90578$var$s(), 0), i.entries = [
                        t
                    ], n());
                });
            }, o = $0460d4c5c2c90578$var$d("largest-contentful-paint", a);
            if (o) {
                n = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$948521ca5b0e1b17, e.reportAllChanges);
                var c = $0460d4c5c2c90578$var$v(function() {
                    $0460d4c5c2c90578$var$at[i.id] || (a(o.takeRecords()), o.disconnect(), $0460d4c5c2c90578$var$at[i.id] = !0, n(!0));
                });
                [
                    "keydown",
                    "click"
                ].forEach(function(t) {
                    addEventListener(t, function() {
                        return $0460d4c5c2c90578$var$N(c);
                    }, {
                        once: !0,
                        capture: !0
                    });
                }), $0460d4c5c2c90578$var$p(c), $0460d4c5c2c90578$var$u(function(r) {
                    i = $0460d4c5c2c90578$var$f("LCP"), n = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$948521ca5b0e1b17, e.reportAllChanges), $0460d4c5c2c90578$var$m(function() {
                        i.value = performance.now() - r.timeStamp, $0460d4c5c2c90578$var$at[i.id] = !0, n(!0);
                    });
                });
            }
        });
    }(function(e) {
        var r = function(t) {
            var e = {
                timeToFirstByte: 0,
                resourceLoadDelay: 0,
                resourceLoadDuration: 0,
                elementRenderDelay: t.value
            };
            if (t.entries.length) {
                var r = $0460d4c5c2c90578$var$n();
                if (r) {
                    var i = r.activationStart || 0, o = t.entries[t.entries.length - 1], c = o.url && performance.getEntriesByType("resource").filter(function(t) {
                        return t.name === o.url;
                    })[0], u = Math.max(0, r.responseStart - i), s = Math.max(u, c ? (c.requestStart || c.startTime) - i : 0), f = Math.max(s, c ? c.responseEnd - i : 0), d = Math.max(f, o.startTime - i);
                    e = {
                        element: $0460d4c5c2c90578$var$a(o.element),
                        timeToFirstByte: u,
                        resourceLoadDelay: s - u,
                        resourceLoadDuration: f - s,
                        elementRenderDelay: d - f,
                        navigationEntry: r,
                        lcpEntry: o
                    }, o.url && (e.url = o.url), c && (e.lcpResourceEntry = c);
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(r);
    }, e);
}, $0460d4c5c2c90578$export$65c59ea8064668fc = [
    800,
    1800
], $0460d4c5c2c90578$var$ut = function t(e) {
    document.prerendering ? $0460d4c5c2c90578$var$b(function() {
        return t(e);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return t(e);
    }, !0) : setTimeout(e, 0);
}, $0460d4c5c2c90578$var$st = function(t, e) {
    e = e || {};
    var r = $0460d4c5c2c90578$var$f("TTFB"), i = $0460d4c5c2c90578$var$l(t, r, $0460d4c5c2c90578$export$65c59ea8064668fc, e.reportAllChanges);
    $0460d4c5c2c90578$var$ut(function() {
        var a = $0460d4c5c2c90578$var$n();
        a && (r.value = Math.max(a.responseStart - $0460d4c5c2c90578$var$s(), 0), r.entries = [
            a
        ], i(!0), $0460d4c5c2c90578$var$u(function() {
            r = $0460d4c5c2c90578$var$f("TTFB", 0), (i = $0460d4c5c2c90578$var$l(t, r, $0460d4c5c2c90578$export$65c59ea8064668fc, e.reportAllChanges))(!0);
        }));
    });
}, $0460d4c5c2c90578$export$33a01e6c5f2c7e33 = function(t, e) {
    $0460d4c5c2c90578$var$st(function(e) {
        var n = function(t) {
            var e = {
                waitingDuration: 0,
                cacheDuration: 0,
                dnsDuration: 0,
                connectionDuration: 0,
                requestDuration: 0
            };
            if (t.entries.length) {
                var n = t.entries[0], r = n.activationStart || 0, i = Math.max((n.workerStart || n.fetchStart) - r, 0), a = Math.max(n.domainLookupStart - r, 0), o = Math.max(n.connectStart - r, 0), c = Math.max(n.connectEnd - r, 0);
                e = {
                    waitingDuration: i,
                    cacheDuration: a - i,
                    dnsDuration: o - a,
                    connectionDuration: c - o,
                    requestDuration: t.value - c,
                    navigationEntry: n
                };
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(n);
    }, e);
}, $0460d4c5c2c90578$var$dt = {
    passive: !0,
    capture: !0
}, $0460d4c5c2c90578$var$lt = new Date, $0460d4c5c2c90578$var$mt = function(t, e) {
    $0460d4c5c2c90578$var$Z || ($0460d4c5c2c90578$var$Z = e, $0460d4c5c2c90578$var$$ = t, $0460d4c5c2c90578$var$tt = new Date, $0460d4c5c2c90578$var$gt(removeEventListener), $0460d4c5c2c90578$var$pt());
}, $0460d4c5c2c90578$var$pt = function() {
    if ($0460d4c5c2c90578$var$$ >= 0 && $0460d4c5c2c90578$var$$ < $0460d4c5c2c90578$var$tt - $0460d4c5c2c90578$var$lt) {
        var t = {
            entryType: "first-input",
            name: $0460d4c5c2c90578$var$Z.type,
            target: $0460d4c5c2c90578$var$Z.target,
            cancelable: $0460d4c5c2c90578$var$Z.cancelable,
            startTime: $0460d4c5c2c90578$var$Z.timeStamp,
            processingStart: $0460d4c5c2c90578$var$Z.timeStamp + $0460d4c5c2c90578$var$$
        };
        $0460d4c5c2c90578$var$et.forEach(function(e) {
            e(t);
        }), $0460d4c5c2c90578$var$et = [];
    }
}, $0460d4c5c2c90578$var$vt = function(t) {
    if (t.cancelable) {
        var e = (t.timeStamp > 1e12 ? new Date : performance.now()) - t.timeStamp;
        "pointerdown" == t.type ? function(t, e) {
            var n = function() {
                $0460d4c5c2c90578$var$mt(t, e), i();
            }, r = function() {
                i();
            }, i = function() {
                removeEventListener("pointerup", n, $0460d4c5c2c90578$var$dt), removeEventListener("pointercancel", r, $0460d4c5c2c90578$var$dt);
            };
            addEventListener("pointerup", n, $0460d4c5c2c90578$var$dt), addEventListener("pointercancel", r, $0460d4c5c2c90578$var$dt);
        }(e, t) : $0460d4c5c2c90578$var$mt(e, t);
    }
}, $0460d4c5c2c90578$var$gt = function(t) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(e) {
        return t(e, $0460d4c5c2c90578$var$vt, $0460d4c5c2c90578$var$dt);
    });
}, $0460d4c5c2c90578$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $0460d4c5c2c90578$var$Tt = function(t, e) {
    e = e || {}, $0460d4c5c2c90578$var$b(function() {
        var n, r = $0460d4c5c2c90578$var$S(), i = $0460d4c5c2c90578$var$f("FID"), a = function(t) {
            t.startTime < r.firstHiddenTime && (i.value = t.processingStart - t.startTime, i.entries.push(t), n(!0));
        }, o = function(t) {
            t.forEach(a);
        }, c = $0460d4c5c2c90578$var$d("first-input", o);
        n = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$8f7f3c48ca6fbe34, e.reportAllChanges), c && ($0460d4c5c2c90578$var$p($0460d4c5c2c90578$var$v(function() {
            o(c.takeRecords()), c.disconnect();
        })), $0460d4c5c2c90578$var$u(function() {
            var r;
            i = $0460d4c5c2c90578$var$f("FID"), n = $0460d4c5c2c90578$var$l(t, i, $0460d4c5c2c90578$export$8f7f3c48ca6fbe34, e.reportAllChanges), $0460d4c5c2c90578$var$et = [], $0460d4c5c2c90578$var$$ = -1, $0460d4c5c2c90578$var$Z = null, $0460d4c5c2c90578$var$gt(addEventListener), r = a, $0460d4c5c2c90578$var$et.push(r), $0460d4c5c2c90578$var$pt();
        }));
    });
}, $0460d4c5c2c90578$export$39705a25c49af873 = function(t, e) {
    $0460d4c5c2c90578$var$Tt(function(e) {
        var n = function(t) {
            var e = t.entries[0], n = {
                eventTarget: $0460d4c5c2c90578$var$a(e.target),
                eventType: e.name,
                eventTime: e.startTime,
                eventEntry: e,
                loadState: $0460d4c5c2c90578$var$r(e.startTime)
            };
            return Object.assign(t, {
                attribution: n
            });
        }(e);
        t(n);
    }, e);
};










const $b75ed68f8932af5b$var$name = "@firebase/installations";
const $b75ed68f8932af5b$var$version = "0.6.17";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b75ed68f8932af5b$var$PENDING_TIMEOUT_MS = 10000;
const $b75ed68f8932af5b$var$PACKAGE_VERSION = `w:${$b75ed68f8932af5b$var$version}`;
const $b75ed68f8932af5b$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $b75ed68f8932af5b$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $b75ed68f8932af5b$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $b75ed68f8932af5b$var$SERVICE = 'installations';
const $b75ed68f8932af5b$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b75ed68f8932af5b$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $b75ed68f8932af5b$var$ERROR_FACTORY = new (0, $7a5e5653d27b8a06$export$3fa6e1b18a3b2d40)($b75ed68f8932af5b$var$SERVICE, $b75ed68f8932af5b$var$SERVICE_NAME, $b75ed68f8932af5b$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $b75ed68f8932af5b$var$isServerError(error) {
    return error instanceof (0, $7a5e5653d27b8a06$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b75ed68f8932af5b$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$b75ed68f8932af5b$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $b75ed68f8932af5b$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $b75ed68f8932af5b$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $b75ed68f8932af5b$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $b75ed68f8932af5b$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $b75ed68f8932af5b$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $b75ed68f8932af5b$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $b75ed68f8932af5b$var$getHeaders(appConfig);
    headers.append('Authorization', $b75ed68f8932af5b$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $b75ed68f8932af5b$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $b75ed68f8932af5b$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $b75ed68f8932af5b$var$getAuthorizationHeader(refreshToken) {
    return `${$b75ed68f8932af5b$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b75ed68f8932af5b$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $b75ed68f8932af5b$var$getInstallationsEndpoint(appConfig);
    const headers = $b75ed68f8932af5b$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $b75ed68f8932af5b$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $b75ed68f8932af5b$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $b75ed68f8932af5b$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $b75ed68f8932af5b$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $b75ed68f8932af5b$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $b75ed68f8932af5b$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b75ed68f8932af5b$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b75ed68f8932af5b$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $b75ed68f8932af5b$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $b75ed68f8932af5b$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $b75ed68f8932af5b$var$encode(fidByteArray);
        return $b75ed68f8932af5b$var$VALID_FID_PATTERN.test(fid) ? fid : $b75ed68f8932af5b$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $b75ed68f8932af5b$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $b75ed68f8932af5b$var$encode(fidByteArray) {
    const b64String = $b75ed68f8932af5b$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $b75ed68f8932af5b$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b75ed68f8932af5b$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $b75ed68f8932af5b$var$fidChanged(appConfig, fid) {
    const key = $b75ed68f8932af5b$var$getKey(appConfig);
    $b75ed68f8932af5b$var$callFidChangeCallbacks(key, fid);
    $b75ed68f8932af5b$var$broadcastFidChange(key, fid);
}
function $b75ed68f8932af5b$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $b75ed68f8932af5b$var$getBroadcastChannel();
    const key = $b75ed68f8932af5b$var$getKey(appConfig);
    let callbackSet = $b75ed68f8932af5b$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $b75ed68f8932af5b$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $b75ed68f8932af5b$var$removeCallback(appConfig, callback) {
    const key = $b75ed68f8932af5b$var$getKey(appConfig);
    const callbackSet = $b75ed68f8932af5b$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $b75ed68f8932af5b$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $b75ed68f8932af5b$var$closeBroadcastChannel();
}
function $b75ed68f8932af5b$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $b75ed68f8932af5b$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $b75ed68f8932af5b$var$broadcastFidChange(key, fid) {
    const channel = $b75ed68f8932af5b$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $b75ed68f8932af5b$var$closeBroadcastChannel();
}
let $b75ed68f8932af5b$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $b75ed68f8932af5b$var$getBroadcastChannel() {
    if (!$b75ed68f8932af5b$var$broadcastChannel && 'BroadcastChannel' in self) {
        $b75ed68f8932af5b$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $b75ed68f8932af5b$var$broadcastChannel.onmessage = (e)=>{
            $b75ed68f8932af5b$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $b75ed68f8932af5b$var$broadcastChannel;
}
function $b75ed68f8932af5b$var$closeBroadcastChannel() {
    if ($b75ed68f8932af5b$var$fidChangeCallbacks.size === 0 && $b75ed68f8932af5b$var$broadcastChannel) {
        $b75ed68f8932af5b$var$broadcastChannel.close();
        $b75ed68f8932af5b$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b75ed68f8932af5b$var$DATABASE_NAME = 'firebase-installations-database';
const $b75ed68f8932af5b$var$DATABASE_VERSION = 1;
const $b75ed68f8932af5b$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $b75ed68f8932af5b$var$dbPromise = null;
function $b75ed68f8932af5b$var$getDbPromise() {
    if (!$b75ed68f8932af5b$var$dbPromise) $b75ed68f8932af5b$var$dbPromise = (0, $81a1df7e0637fd87$export$ca0ed41b1a2af7e)($b75ed68f8932af5b$var$DATABASE_NAME, $b75ed68f8932af5b$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($b75ed68f8932af5b$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $b75ed68f8932af5b$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $b75ed68f8932af5b$var$set(appConfig, value) {
    const key = $b75ed68f8932af5b$var$getKey(appConfig);
    const db = await $b75ed68f8932af5b$var$getDbPromise();
    const tx = db.transaction($b75ed68f8932af5b$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($b75ed68f8932af5b$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $b75ed68f8932af5b$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $b75ed68f8932af5b$var$remove(appConfig) {
    const key = $b75ed68f8932af5b$var$getKey(appConfig);
    const db = await $b75ed68f8932af5b$var$getDbPromise();
    const tx = db.transaction($b75ed68f8932af5b$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($b75ed68f8932af5b$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $b75ed68f8932af5b$var$update(appConfig, updateFn) {
    const key = $b75ed68f8932af5b$var$getKey(appConfig);
    const db = await $b75ed68f8932af5b$var$getDbPromise();
    const tx = db.transaction($b75ed68f8932af5b$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($b75ed68f8932af5b$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $b75ed68f8932af5b$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $b75ed68f8932af5b$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $b75ed68f8932af5b$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $b75ed68f8932af5b$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $b75ed68f8932af5b$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $b75ed68f8932af5b$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $b75ed68f8932af5b$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $b75ed68f8932af5b$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $b75ed68f8932af5b$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $b75ed68f8932af5b$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($b75ed68f8932af5b$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $b75ed68f8932af5b$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $b75ed68f8932af5b$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $b75ed68f8932af5b$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $b75ed68f8932af5b$var$createInstallationRequest(installations, installationEntry);
        return $b75ed68f8932af5b$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($b75ed68f8932af5b$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $b75ed68f8932af5b$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $b75ed68f8932af5b$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $b75ed68f8932af5b$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $b75ed68f8932af5b$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $b75ed68f8932af5b$var$sleep(100);
        entry = await $b75ed68f8932af5b$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $b75ed68f8932af5b$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $b75ed68f8932af5b$var$updateInstallationRequest(appConfig) {
    return $b75ed68f8932af5b$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $b75ed68f8932af5b$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $b75ed68f8932af5b$var$clearTimedOutRequest(oldEntry);
    });
}
function $b75ed68f8932af5b$var$clearTimedOutRequest(entry) {
    if ($b75ed68f8932af5b$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $b75ed68f8932af5b$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $b75ed68f8932af5b$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b75ed68f8932af5b$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $b75ed68f8932af5b$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $b75ed68f8932af5b$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $b75ed68f8932af5b$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $b75ed68f8932af5b$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $b75ed68f8932af5b$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $b75ed68f8932af5b$var$getErrorFromResponse('Generate Auth Token', response);
}
function $b75ed68f8932af5b$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$b75ed68f8932af5b$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $b75ed68f8932af5b$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $b75ed68f8932af5b$var$update(installations.appConfig, (oldEntry)=>{
        if (!$b75ed68f8932af5b$var$isEntryRegistered(oldEntry)) throw $b75ed68f8932af5b$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $b75ed68f8932af5b$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $b75ed68f8932af5b$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $b75ed68f8932af5b$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $b75ed68f8932af5b$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $b75ed68f8932af5b$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $b75ed68f8932af5b$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $b75ed68f8932af5b$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $b75ed68f8932af5b$var$sleep(100);
        entry = await $b75ed68f8932af5b$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $b75ed68f8932af5b$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $b75ed68f8932af5b$var$updateAuthTokenRequest(appConfig) {
    return $b75ed68f8932af5b$var$update(appConfig, (oldEntry)=>{
        if (!$b75ed68f8932af5b$var$isEntryRegistered(oldEntry)) throw $b75ed68f8932af5b$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($b75ed68f8932af5b$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $b75ed68f8932af5b$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $b75ed68f8932af5b$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $b75ed68f8932af5b$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($b75ed68f8932af5b$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $b75ed68f8932af5b$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $b75ed68f8932af5b$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $b75ed68f8932af5b$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $b75ed68f8932af5b$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$b75ed68f8932af5b$var$isAuthTokenExpired(authToken);
}
function $b75ed68f8932af5b$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $b75ed68f8932af5b$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $b75ed68f8932af5b$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $b75ed68f8932af5b$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $b75ed68f8932af5b$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $b75ed68f8932af5b$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $b75ed68f8932af5b$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $b75ed68f8932af5b$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $b75ed68f8932af5b$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $b75ed68f8932af5b$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $b75ed68f8932af5b$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $b75ed68f8932af5b$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $b75ed68f8932af5b$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b75ed68f8932af5b$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $b75ed68f8932af5b$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $b75ed68f8932af5b$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $b75ed68f8932af5b$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $b75ed68f8932af5b$var$getErrorFromResponse('Delete Installation', response);
}
function $b75ed68f8932af5b$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$b75ed68f8932af5b$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $b75ed68f8932af5b$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $b75ed68f8932af5b$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $b75ed68f8932af5b$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $b75ed68f8932af5b$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $b75ed68f8932af5b$var$deleteInstallationRequest(appConfig, entry);
                await $b75ed68f8932af5b$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $b75ed68f8932af5b$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $b75ed68f8932af5b$var$addCallback(appConfig, callback);
    return ()=>{
        $b75ed68f8932af5b$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $b75ed68f8932af5b$export$9bfc115e43431ff5(app = (0, $3c66ef1885bbdcd1$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $3c66ef1885bbdcd1$export$fa0d6da0f5838f50)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b75ed68f8932af5b$var$extractAppConfig(app) {
    if (!app || !app.options) throw $b75ed68f8932af5b$var$getMissingValueError('App Configuration');
    if (!app.name) throw $b75ed68f8932af5b$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $b75ed68f8932af5b$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $b75ed68f8932af5b$var$getMissingValueError(valueName) {
    return $b75ed68f8932af5b$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b75ed68f8932af5b$var$INSTALLATIONS_NAME = 'installations';
const $b75ed68f8932af5b$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $b75ed68f8932af5b$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $b75ed68f8932af5b$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $3c66ef1885bbdcd1$export$fa0d6da0f5838f50)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $b75ed68f8932af5b$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $3c66ef1885bbdcd1$export$fa0d6da0f5838f50)(app, $b75ed68f8932af5b$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$b75ed68f8932af5b$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$b75ed68f8932af5b$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $b75ed68f8932af5b$var$registerInstallations() {
    (0, $3c66ef1885bbdcd1$export$c930050e7bb63965)(new (0, $d4d618502f0d98d6$export$16fa2f45be04daa8)($b75ed68f8932af5b$var$INSTALLATIONS_NAME, $b75ed68f8932af5b$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $3c66ef1885bbdcd1$export$c930050e7bb63965)(new (0, $d4d618502f0d98d6$export$16fa2f45be04daa8)($b75ed68f8932af5b$var$INSTALLATIONS_NAME_INTERNAL, $b75ed68f8932af5b$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $b75ed68f8932af5b$var$registerInstallations();
(0, $3c66ef1885bbdcd1$export$d29d5299a7137abc)($b75ed68f8932af5b$var$name, $b75ed68f8932af5b$var$version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
(0, $3c66ef1885bbdcd1$export$d29d5299a7137abc)($b75ed68f8932af5b$var$name, $b75ed68f8932af5b$var$version, 'esm2017');


const $d9288c7c564a224b$var$name = "@firebase/performance";
const $d9288c7c564a224b$var$version = "0.7.6";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9288c7c564a224b$var$SDK_VERSION = $d9288c7c564a224b$var$version;
/** The prefix for start User Timing marks used for creating Traces. */ const $d9288c7c564a224b$var$TRACE_START_MARK_PREFIX = 'FB-PERF-TRACE-START';
/** The prefix for stop User Timing marks used for creating Traces. */ const $d9288c7c564a224b$var$TRACE_STOP_MARK_PREFIX = 'FB-PERF-TRACE-STOP';
/** The prefix for User Timing measure used for creating Traces. */ const $d9288c7c564a224b$var$TRACE_MEASURE_PREFIX = 'FB-PERF-TRACE-MEASURE';
/** The prefix for out of the box page load Trace name. */ const $d9288c7c564a224b$var$OOB_TRACE_PAGE_LOAD_PREFIX = '_wt_';
const $d9288c7c564a224b$var$FIRST_PAINT_COUNTER_NAME = '_fp';
const $d9288c7c564a224b$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME = '_fcp';
const $d9288c7c564a224b$var$FIRST_INPUT_DELAY_COUNTER_NAME = '_fid';
const $d9288c7c564a224b$var$LARGEST_CONTENTFUL_PAINT_METRIC_NAME = '_lcp';
const $d9288c7c564a224b$var$LARGEST_CONTENTFUL_PAINT_ATTRIBUTE_NAME = 'lcp_element';
const $d9288c7c564a224b$var$INTERACTION_TO_NEXT_PAINT_METRIC_NAME = '_inp';
const $d9288c7c564a224b$var$INTERACTION_TO_NEXT_PAINT_ATTRIBUTE_NAME = 'inp_interactionTarget';
const $d9288c7c564a224b$var$CUMULATIVE_LAYOUT_SHIFT_METRIC_NAME = '_cls';
const $d9288c7c564a224b$var$CUMULATIVE_LAYOUT_SHIFT_ATTRIBUTE_NAME = 'cls_largestShiftTarget';
const $d9288c7c564a224b$var$CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
const $d9288c7c564a224b$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
const $d9288c7c564a224b$var$SERVICE = 'performance';
const $d9288c7c564a224b$var$SERVICE_NAME = 'Performance';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9288c7c564a224b$var$ERROR_DESCRIPTION_MAP = {
    ["trace started" /* ErrorCode.TRACE_STARTED_BEFORE */ ]: 'Trace {$traceName} was started before.',
    ["trace stopped" /* ErrorCode.TRACE_STOPPED_BEFORE */ ]: 'Trace {$traceName} is not running.',
    ["nonpositive trace startTime" /* ErrorCode.NONPOSITIVE_TRACE_START_TIME */ ]: 'Trace {$traceName} startTime should be positive.',
    ["nonpositive trace duration" /* ErrorCode.NONPOSITIVE_TRACE_DURATION */ ]: 'Trace {$traceName} duration should be positive.',
    ["no window" /* ErrorCode.NO_WINDOW */ ]: 'Window is not available.',
    ["no app id" /* ErrorCode.NO_APP_ID */ ]: 'App id is not available.',
    ["no project id" /* ErrorCode.NO_PROJECT_ID */ ]: 'Project id is not available.',
    ["no api key" /* ErrorCode.NO_API_KEY */ ]: 'Api key is not available.',
    ["invalid cc log" /* ErrorCode.INVALID_CC_LOG */ ]: 'Attempted to queue invalid cc event',
    ["FB not default" /* ErrorCode.FB_NOT_DEFAULT */ ]: 'Performance can only start when Firebase app instance is the default one.',
    ["RC response not ok" /* ErrorCode.RC_NOT_OK */ ]: 'RC response is not ok',
    ["invalid attribute name" /* ErrorCode.INVALID_ATTRIBUTE_NAME */ ]: 'Attribute name {$attributeName} is invalid.',
    ["invalid attribute value" /* ErrorCode.INVALID_ATTRIBUTE_VALUE */ ]: 'Attribute value {$attributeValue} is invalid.',
    ["invalid custom metric name" /* ErrorCode.INVALID_CUSTOM_METRIC_NAME */ ]: 'Custom metric name {$customMetricName} is invalid',
    ["invalid String merger input" /* ErrorCode.INVALID_STRING_MERGER_PARAMETER */ ]: 'Input for String merger is invalid, contact support team to resolve.',
    ["already initialized" /* ErrorCode.ALREADY_INITIALIZED */ ]: "initializePerformance() has already been called with different options. To avoid this error, call initializePerformance() with the same options as when it was originally called, or call getPerformance() to return the already initialized instance."
};
const $d9288c7c564a224b$var$ERROR_FACTORY = new (0, $7a5e5653d27b8a06$export$3fa6e1b18a3b2d40)($d9288c7c564a224b$var$SERVICE, $d9288c7c564a224b$var$SERVICE_NAME, $d9288c7c564a224b$var$ERROR_DESCRIPTION_MAP);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9288c7c564a224b$var$consoleLogger = new (0, $a8534f819b344ec2$export$efa9a398d6368992)($d9288c7c564a224b$var$SERVICE_NAME);
$d9288c7c564a224b$var$consoleLogger.logLevel = (0, $a8534f819b344ec2$export$243e62d78d3b544d).INFO;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d9288c7c564a224b$var$apiInstance;
let $d9288c7c564a224b$var$windowInstance;
/**
 * This class holds a reference to various browser related objects injected by
 * set methods.
 */ class $d9288c7c564a224b$var$Api {
    constructor(window1){
        this.window = window1;
        if (!window1) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("no window" /* ErrorCode.NO_WINDOW */ );
        this.performance = window1.performance;
        this.PerformanceObserver = window1.PerformanceObserver;
        this.windowLocation = window1.location;
        this.navigator = window1.navigator;
        this.document = window1.document;
        if (this.navigator && this.navigator.cookieEnabled) // If user blocks cookies on the browser, accessing localStorage will
        // throw an exception.
        this.localStorage = window1.localStorage;
        if (window1.perfMetrics && window1.perfMetrics.onFirstInputDelay) this.onFirstInputDelay = window1.perfMetrics.onFirstInputDelay;
        this.onLCP = (0, $0460d4c5c2c90578$export$947b1626ab8d5632);
        this.onINP = (0, $0460d4c5c2c90578$export$7df4b36ecaed99e1);
        this.onCLS = (0, $0460d4c5c2c90578$export$a7873055838e5ad8);
    }
    getUrl() {
        // Do not capture the string query part of url.
        return this.windowLocation.href.split('?')[0];
    }
    mark(name) {
        if (!this.performance || !this.performance.mark) return;
        this.performance.mark(name);
    }
    measure(measureName, mark1, mark2) {
        if (!this.performance || !this.performance.measure) return;
        this.performance.measure(measureName, mark1, mark2);
    }
    getEntriesByType(type) {
        if (!this.performance || !this.performance.getEntriesByType) return [];
        return this.performance.getEntriesByType(type);
    }
    getEntriesByName(name) {
        if (!this.performance || !this.performance.getEntriesByName) return [];
        return this.performance.getEntriesByName(name);
    }
    getTimeOrigin() {
        // Polyfill the time origin with performance.timing.navigationStart.
        return this.performance && (this.performance.timeOrigin || this.performance.timing.navigationStart);
    }
    requiredApisAvailable() {
        if (!fetch || !Promise || !(0, $7a5e5653d27b8a06$export$f172b7eb6cf60599)()) {
            $d9288c7c564a224b$var$consoleLogger.info('Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.');
            return false;
        }
        if (!(0, $7a5e5653d27b8a06$export$3865db50535c2055)()) {
            $d9288c7c564a224b$var$consoleLogger.info('IndexedDB is not supported by current browser');
            return false;
        }
        return true;
    }
    setupObserver(entryType, callback) {
        if (!this.PerformanceObserver) return;
        const observer = new this.PerformanceObserver((list)=>{
            for (const entry of list.getEntries())// `entry` is a PerformanceEntry instance.
            callback(entry);
        });
        // Start observing the entry types you care about.
        observer.observe({
            entryTypes: [
                entryType
            ]
        });
    }
    static getInstance() {
        if ($d9288c7c564a224b$var$apiInstance === undefined) $d9288c7c564a224b$var$apiInstance = new $d9288c7c564a224b$var$Api($d9288c7c564a224b$var$windowInstance);
        return $d9288c7c564a224b$var$apiInstance;
    }
}
function $d9288c7c564a224b$var$setupApi(window1) {
    $d9288c7c564a224b$var$windowInstance = window1;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d9288c7c564a224b$var$iid;
function $d9288c7c564a224b$var$getIidPromise(installationsService) {
    const iidPromise = installationsService.getId();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    iidPromise.then((iidVal)=>{
        $d9288c7c564a224b$var$iid = iidVal;
    });
    return iidPromise;
}
// This method should be used after the iid is retrieved by getIidPromise method.
function $d9288c7c564a224b$var$getIid() {
    return $d9288c7c564a224b$var$iid;
}
function $d9288c7c564a224b$var$getAuthTokenPromise(installationsService) {
    const authTokenPromise = installationsService.getToken();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    authTokenPromise.then((authTokenVal)=>{});
    return authTokenPromise;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d9288c7c564a224b$var$mergeStrings(part1, part2) {
    const sizeDiff = part1.length - part2.length;
    if (sizeDiff < 0 || sizeDiff > 1) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("invalid String merger input" /* ErrorCode.INVALID_STRING_MERGER_PARAMETER */ );
    const resultArray = [];
    for(let i = 0; i < part1.length; i++){
        resultArray.push(part1.charAt(i));
        if (part2.length > i) resultArray.push(part2.charAt(i));
    }
    return resultArray.join('');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d9288c7c564a224b$var$settingsServiceInstance;
class $d9288c7c564a224b$var$SettingsService {
    constructor(){
        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
        this.instrumentationEnabled = true;
        // The variable which controls logging of custom traces.
        this.dataCollectionEnabled = true;
        // Configuration flags set through remote config.
        this.loggingEnabled = false;
        // Sampling rate between 0 and 1.
        this.tracesSamplingRate = 1;
        this.networkRequestsSamplingRate = 1;
        // Address of logging service.
        this.logEndPointUrl = 'https://firebaselogging.googleapis.com/v0cc/log?format=json_proto';
        // Performance event transport endpoint URL which should be compatible with proto3.
        // New Address for transport service, not configurable via Remote Config.
        this.flTransportEndpointUrl = $d9288c7c564a224b$var$mergeStrings('hts/frbslgigp.ogepscmv/ieo/eaylg', 'tp:/ieaeogn-agolai.o/1frlglgc/o');
        this.transportKey = $d9288c7c564a224b$var$mergeStrings('AzSC8r6ReiGqFMyfvgow', 'Iayx0u-XT3vksVM-pIV');
        // Source type for performance event logs.
        this.logSource = 462;
        // Flags which control per session logging of traces and network requests.
        this.logTraceAfterSampling = false;
        this.logNetworkAfterSampling = false;
        // TTL of config retrieved from remote config in hours.
        this.configTimeToLive = 12;
    }
    getFlTransportFullUrl() {
        return this.flTransportEndpointUrl.concat('?key=', this.transportKey);
    }
    static getInstance() {
        if ($d9288c7c564a224b$var$settingsServiceInstance === undefined) $d9288c7c564a224b$var$settingsServiceInstance = new $d9288c7c564a224b$var$SettingsService();
        return $d9288c7c564a224b$var$settingsServiceInstance;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d9288c7c564a224b$var$VisibilityState;
(function(VisibilityState) {
    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
})($d9288c7c564a224b$var$VisibilityState || ($d9288c7c564a224b$var$VisibilityState = {}));
const $d9288c7c564a224b$var$RESERVED_ATTRIBUTE_PREFIXES = [
    'firebase_',
    'google_',
    'ga_'
];
const $d9288c7c564a224b$var$ATTRIBUTE_FORMAT_REGEX = new RegExp('^[a-zA-Z]\\w*$');
const $d9288c7c564a224b$var$MAX_ATTRIBUTE_NAME_LENGTH = 40;
const $d9288c7c564a224b$var$MAX_ATTRIBUTE_VALUE_LENGTH = 100;
function $d9288c7c564a224b$var$getServiceWorkerStatus() {
    const navigator1 = $d9288c7c564a224b$var$Api.getInstance().navigator;
    if (navigator1 === null || navigator1 === void 0 ? void 0 : navigator1.serviceWorker) {
        if (navigator1.serviceWorker.controller) return 2 /* ServiceWorkerStatus.CONTROLLED */ ;
        else return 3 /* ServiceWorkerStatus.UNCONTROLLED */ ;
    } else return 1 /* ServiceWorkerStatus.UNSUPPORTED */ ;
}
function $d9288c7c564a224b$var$getVisibilityState() {
    const document = $d9288c7c564a224b$var$Api.getInstance().document;
    const visibilityState = document.visibilityState;
    switch(visibilityState){
        case 'visible':
            return $d9288c7c564a224b$var$VisibilityState.VISIBLE;
        case 'hidden':
            return $d9288c7c564a224b$var$VisibilityState.HIDDEN;
        default:
            return $d9288c7c564a224b$var$VisibilityState.UNKNOWN;
    }
}
function $d9288c7c564a224b$var$getEffectiveConnectionType() {
    const navigator1 = $d9288c7c564a224b$var$Api.getInstance().navigator;
    const navigatorConnection = navigator1.connection;
    const effectiveType = navigatorConnection && navigatorConnection.effectiveType;
    switch(effectiveType){
        case 'slow-2g':
            return 1 /* EffectiveConnectionType.CONNECTION_SLOW_2G */ ;
        case '2g':
            return 2 /* EffectiveConnectionType.CONNECTION_2G */ ;
        case '3g':
            return 3 /* EffectiveConnectionType.CONNECTION_3G */ ;
        case '4g':
            return 4 /* EffectiveConnectionType.CONNECTION_4G */ ;
        default:
            return 0 /* EffectiveConnectionType.UNKNOWN */ ;
    }
}
function $d9288c7c564a224b$var$isValidCustomAttributeName(name) {
    if (name.length === 0 || name.length > $d9288c7c564a224b$var$MAX_ATTRIBUTE_NAME_LENGTH) return false;
    const matchesReservedPrefix = $d9288c7c564a224b$var$RESERVED_ATTRIBUTE_PREFIXES.some((prefix)=>name.startsWith(prefix));
    return !matchesReservedPrefix && !!name.match($d9288c7c564a224b$var$ATTRIBUTE_FORMAT_REGEX);
}
function $d9288c7c564a224b$var$isValidCustomAttributeValue(value) {
    return value.length !== 0 && value.length <= $d9288c7c564a224b$var$MAX_ATTRIBUTE_VALUE_LENGTH;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d9288c7c564a224b$var$getAppId(firebaseApp) {
    var _a;
    const appId = (_a = firebaseApp.options) === null || _a === void 0 ? void 0 : _a.appId;
    if (!appId) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("no app id" /* ErrorCode.NO_APP_ID */ );
    return appId;
}
function $d9288c7c564a224b$var$getProjectId(firebaseApp) {
    var _a;
    const projectId = (_a = firebaseApp.options) === null || _a === void 0 ? void 0 : _a.projectId;
    if (!projectId) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("no project id" /* ErrorCode.NO_PROJECT_ID */ );
    return projectId;
}
function $d9288c7c564a224b$var$getApiKey(firebaseApp) {
    var _a;
    const apiKey = (_a = firebaseApp.options) === null || _a === void 0 ? void 0 : _a.apiKey;
    if (!apiKey) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("no api key" /* ErrorCode.NO_API_KEY */ );
    return apiKey;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9288c7c564a224b$var$REMOTE_CONFIG_SDK_VERSION = '0.0.1';
// These values will be used if the remote config object is successfully
// retrieved, but the template does not have these fields.
const $d9288c7c564a224b$var$DEFAULT_CONFIGS = {
    loggingEnabled: true
};
const $d9288c7c564a224b$var$FIS_AUTH_PREFIX = 'FIREBASE_INSTALLATIONS_AUTH';
function $d9288c7c564a224b$var$getConfig(performanceController, iid) {
    const config = $d9288c7c564a224b$var$getStoredConfig();
    if (config) {
        $d9288c7c564a224b$var$processConfig(config);
        return Promise.resolve();
    }
    return $d9288c7c564a224b$var$getRemoteConfig(performanceController, iid).then($d9288c7c564a224b$var$processConfig).then((config)=>$d9288c7c564a224b$var$storeConfig(config), /** Do nothing for error, use defaults set in settings service. */ ()=>{});
}
function $d9288c7c564a224b$var$getStoredConfig() {
    const localStorage = $d9288c7c564a224b$var$Api.getInstance().localStorage;
    if (!localStorage) return;
    const expiryString = localStorage.getItem($d9288c7c564a224b$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
    if (!expiryString || !$d9288c7c564a224b$var$configValid(expiryString)) return;
    const configStringified = localStorage.getItem($d9288c7c564a224b$var$CONFIG_LOCAL_STORAGE_KEY);
    if (!configStringified) return;
    try {
        const configResponse = JSON.parse(configStringified);
        return configResponse;
    } catch (_a) {
        return;
    }
}
function $d9288c7c564a224b$var$storeConfig(config) {
    const localStorage = $d9288c7c564a224b$var$Api.getInstance().localStorage;
    if (!config || !localStorage) return;
    localStorage.setItem($d9288c7c564a224b$var$CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
    localStorage.setItem($d9288c7c564a224b$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() + $d9288c7c564a224b$var$SettingsService.getInstance().configTimeToLive * 3600000));
}
const $d9288c7c564a224b$var$COULD_NOT_GET_CONFIG_MSG = 'Could not fetch config, will use default configs';
function $d9288c7c564a224b$var$getRemoteConfig(performanceController, iid) {
    // Perf needs auth token only to retrieve remote config.
    return $d9288c7c564a224b$var$getAuthTokenPromise(performanceController.installations).then((authToken)=>{
        const projectId = $d9288c7c564a224b$var$getProjectId(performanceController.app);
        const apiKey = $d9288c7c564a224b$var$getApiKey(performanceController.app);
        const configEndPoint = `https://firebaseremoteconfig.googleapis.com/v1/projects/${projectId}/namespaces/fireperf:fetch?key=${apiKey}`;
        const request = new Request(configEndPoint, {
            method: 'POST',
            headers: {
                Authorization: `${$d9288c7c564a224b$var$FIS_AUTH_PREFIX} ${authToken}`
            },
            /* eslint-disable camelcase */ body: JSON.stringify({
                app_instance_id: iid,
                app_instance_id_token: authToken,
                app_id: $d9288c7c564a224b$var$getAppId(performanceController.app),
                app_version: $d9288c7c564a224b$var$SDK_VERSION,
                sdk_version: $d9288c7c564a224b$var$REMOTE_CONFIG_SDK_VERSION
            })
        });
        return fetch(request).then((response)=>{
            if (response.ok) return response.json();
            // In case response is not ok. This will be caught by catch.
            throw $d9288c7c564a224b$var$ERROR_FACTORY.create("RC response not ok" /* ErrorCode.RC_NOT_OK */ );
        });
    }).catch(()=>{
        $d9288c7c564a224b$var$consoleLogger.info($d9288c7c564a224b$var$COULD_NOT_GET_CONFIG_MSG);
        return undefined;
    });
}
/**
 * Processes config coming either from calling RC or from local storage.
 * This method only runs if call is successful or config in storage
 * is valid.
 */ function $d9288c7c564a224b$var$processConfig(config) {
    if (!config) return config;
    const settingsServiceInstance = $d9288c7c564a224b$var$SettingsService.getInstance();
    const entries = config.entries || {};
    if (entries.fpr_enabled !== undefined) // TODO: Change the assignment of loggingEnabled once the received type is
    // known.
    settingsServiceInstance.loggingEnabled = String(entries.fpr_enabled) === 'true';
    else // Config retrieved successfully, but there is no fpr_enabled in template.
    // Use secondary configs value.
    settingsServiceInstance.loggingEnabled = $d9288c7c564a224b$var$DEFAULT_CONFIGS.loggingEnabled;
    if (entries.fpr_log_source) settingsServiceInstance.logSource = Number(entries.fpr_log_source);
    else if ($d9288c7c564a224b$var$DEFAULT_CONFIGS.logSource) settingsServiceInstance.logSource = $d9288c7c564a224b$var$DEFAULT_CONFIGS.logSource;
    if (entries.fpr_log_endpoint_url) settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
    else if ($d9288c7c564a224b$var$DEFAULT_CONFIGS.logEndPointUrl) settingsServiceInstance.logEndPointUrl = $d9288c7c564a224b$var$DEFAULT_CONFIGS.logEndPointUrl;
    // Key from Remote Config has to be non-empty string, otherwise use local value.
    if (entries.fpr_log_transport_key) settingsServiceInstance.transportKey = entries.fpr_log_transport_key;
    else if ($d9288c7c564a224b$var$DEFAULT_CONFIGS.transportKey) settingsServiceInstance.transportKey = $d9288c7c564a224b$var$DEFAULT_CONFIGS.transportKey;
    if (entries.fpr_vc_network_request_sampling_rate !== undefined) settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
    else if ($d9288c7c564a224b$var$DEFAULT_CONFIGS.networkRequestsSamplingRate !== undefined) settingsServiceInstance.networkRequestsSamplingRate = $d9288c7c564a224b$var$DEFAULT_CONFIGS.networkRequestsSamplingRate;
    if (entries.fpr_vc_trace_sampling_rate !== undefined) settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
    else if ($d9288c7c564a224b$var$DEFAULT_CONFIGS.tracesSamplingRate !== undefined) settingsServiceInstance.tracesSamplingRate = $d9288c7c564a224b$var$DEFAULT_CONFIGS.tracesSamplingRate;
    // Set the per session trace and network logging flags.
    settingsServiceInstance.logTraceAfterSampling = $d9288c7c564a224b$var$shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
    settingsServiceInstance.logNetworkAfterSampling = $d9288c7c564a224b$var$shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
    return config;
}
function $d9288c7c564a224b$var$configValid(expiry) {
    return Number(expiry) > Date.now();
}
function $d9288c7c564a224b$var$shouldLogAfterSampling(samplingRate) {
    return Math.random() <= samplingRate;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d9288c7c564a224b$var$initializationStatus = 1 /* InitializationStatus.notInitialized */ ;
let $d9288c7c564a224b$var$initializationPromise;
function $d9288c7c564a224b$var$getInitializationPromise(performanceController) {
    $d9288c7c564a224b$var$initializationStatus = 2 /* InitializationStatus.initializationPending */ ;
    $d9288c7c564a224b$var$initializationPromise = $d9288c7c564a224b$var$initializationPromise || $d9288c7c564a224b$var$initializePerf(performanceController);
    return $d9288c7c564a224b$var$initializationPromise;
}
function $d9288c7c564a224b$var$isPerfInitialized() {
    return $d9288c7c564a224b$var$initializationStatus === 3 /* InitializationStatus.initialized */ ;
}
function $d9288c7c564a224b$var$initializePerf(performanceController) {
    return $d9288c7c564a224b$var$getDocumentReadyComplete().then(()=>$d9288c7c564a224b$var$getIidPromise(performanceController.installations)).then((iid)=>$d9288c7c564a224b$var$getConfig(performanceController, iid)).then(()=>$d9288c7c564a224b$var$changeInitializationStatus(), ()=>$d9288c7c564a224b$var$changeInitializationStatus());
}
/**
 * Returns a promise which resolves whenever the document readystate is complete or
 * immediately if it is called after page load complete.
 */ function $d9288c7c564a224b$var$getDocumentReadyComplete() {
    const document = $d9288c7c564a224b$var$Api.getInstance().document;
    return new Promise((resolve)=>{
        if (document && document.readyState !== 'complete') {
            const handler = ()=>{
                if (document.readyState === 'complete') {
                    document.removeEventListener('readystatechange', handler);
                    resolve();
                }
            };
            document.addEventListener('readystatechange', handler);
        } else resolve();
    });
}
function $d9288c7c564a224b$var$changeInitializationStatus() {
    $d9288c7c564a224b$var$initializationStatus = 3 /* InitializationStatus.initialized */ ;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9288c7c564a224b$var$DEFAULT_SEND_INTERVAL_MS = 10000;
const $d9288c7c564a224b$var$INITIAL_SEND_TIME_DELAY_MS = 5500;
const $d9288c7c564a224b$var$MAX_EVENT_COUNT_PER_REQUEST = 1000;
const $d9288c7c564a224b$var$DEFAULT_REMAINING_TRIES = 3;
let $d9288c7c564a224b$var$remainingTries = $d9288c7c564a224b$var$DEFAULT_REMAINING_TRIES;
/* eslint-enable camelcase */ let $d9288c7c564a224b$var$queue = [];
let $d9288c7c564a224b$var$isTransportSetup = false;
function $d9288c7c564a224b$var$setupTransportService() {
    if (!$d9288c7c564a224b$var$isTransportSetup) {
        $d9288c7c564a224b$var$processQueue($d9288c7c564a224b$var$INITIAL_SEND_TIME_DELAY_MS);
        $d9288c7c564a224b$var$isTransportSetup = true;
    }
}
function $d9288c7c564a224b$var$processQueue(timeOffset) {
    setTimeout(()=>{
        // If there is no remainingTries left, stop retrying.
        if ($d9288c7c564a224b$var$remainingTries <= 0) return;
        if ($d9288c7c564a224b$var$queue.length > 0) $d9288c7c564a224b$var$dispatchQueueEvents();
        $d9288c7c564a224b$var$processQueue($d9288c7c564a224b$var$DEFAULT_SEND_INTERVAL_MS);
    }, timeOffset);
}
function $d9288c7c564a224b$var$dispatchQueueEvents() {
    // Extract events up to the maximum cap of single logRequest from top of "official queue".
    // The staged events will be used for current logRequest attempt, remaining events will be kept
    // for next attempt.
    const staged = $d9288c7c564a224b$var$queue.splice(0, $d9288c7c564a224b$var$MAX_EVENT_COUNT_PER_REQUEST);
    /* eslint-disable camelcase */ // We will pass the JSON serialized event to the backend.
    const log_event = staged.map((evt)=>({
            source_extension_json_proto3: evt.message,
            event_time_ms: String(evt.eventTime)
        }));
    const data = {
        request_time_ms: String(Date.now()),
        client_info: {
            client_type: 1,
            js_client_info: {}
        },
        log_source: $d9288c7c564a224b$var$SettingsService.getInstance().logSource,
        log_event: log_event
    };
    /* eslint-enable camelcase */ $d9288c7c564a224b$var$postToFlEndpoint(data).then(()=>{
        $d9288c7c564a224b$var$remainingTries = $d9288c7c564a224b$var$DEFAULT_REMAINING_TRIES;
    }).catch(()=>{
        // If the request fails for some reason, add the events that were attempted
        // back to the primary queue to retry later.
        $d9288c7c564a224b$var$queue = [
            ...staged,
            ...$d9288c7c564a224b$var$queue
        ];
        $d9288c7c564a224b$var$remainingTries--;
        $d9288c7c564a224b$var$consoleLogger.info(`Tries left: ${$d9288c7c564a224b$var$remainingTries}.`);
        $d9288c7c564a224b$var$processQueue($d9288c7c564a224b$var$DEFAULT_SEND_INTERVAL_MS);
    });
}
function $d9288c7c564a224b$var$postToFlEndpoint(data) {
    const flTransportFullUrl = $d9288c7c564a224b$var$SettingsService.getInstance().getFlTransportFullUrl();
    const body = JSON.stringify(data);
    return navigator.sendBeacon && navigator.sendBeacon(flTransportFullUrl, body) ? Promise.resolve() : fetch(flTransportFullUrl, {
        method: 'POST',
        body: body,
        keepalive: true
    }).then();
}
function $d9288c7c564a224b$var$addToQueue(evt) {
    if (!evt.eventTime || !evt.message) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("invalid cc log" /* ErrorCode.INVALID_CC_LOG */ );
    // Add the new event to the queue.
    $d9288c7c564a224b$var$queue = [
        ...$d9288c7c564a224b$var$queue,
        evt
    ];
}
/** Log handler for cc service to send the performance logs to the server. */ function $d9288c7c564a224b$var$transportHandler(// eslint-disable-next-line @typescript-eslint/no-explicit-any
serializer) {
    return (...args)=>{
        const message = serializer(...args);
        $d9288c7c564a224b$var$addToQueue({
            message: message,
            eventTime: Date.now()
        });
    };
}
/**
 * Force flush the queued events. Useful at page unload time to ensure all
 * events are uploaded.
 */ function $d9288c7c564a224b$var$flushQueuedEvents() {
    while($d9288c7c564a224b$var$queue.length > 0)$d9288c7c564a224b$var$dispatchQueueEvents();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d9288c7c564a224b$var$logger;
//
// This method is not called before initialization.
function $d9288c7c564a224b$var$sendLog(resource, resourceType) {
    if (!$d9288c7c564a224b$var$logger) $d9288c7c564a224b$var$logger = {
        send: $d9288c7c564a224b$var$transportHandler($d9288c7c564a224b$var$serializer),
        flush: $d9288c7c564a224b$var$flushQueuedEvents
    };
    $d9288c7c564a224b$var$logger.send(resource, resourceType);
}
function $d9288c7c564a224b$var$logTrace(trace) {
    const settingsService = $d9288c7c564a224b$var$SettingsService.getInstance();
    // Do not log if trace is auto generated and instrumentation is disabled.
    if (!settingsService.instrumentationEnabled && trace.isAuto) return;
    // Do not log if trace is custom and data collection is disabled.
    if (!settingsService.dataCollectionEnabled && !trace.isAuto) return;
    // Do not log if required apis are not available.
    if (!$d9288c7c564a224b$var$Api.getInstance().requiredApisAvailable()) return;
    if ($d9288c7c564a224b$var$isPerfInitialized()) $d9288c7c564a224b$var$sendTraceLog(trace);
    else // Custom traces can be used before the initialization but logging
    // should wait until after.
    $d9288c7c564a224b$var$getInitializationPromise(trace.performanceController).then(()=>$d9288c7c564a224b$var$sendTraceLog(trace), ()=>$d9288c7c564a224b$var$sendTraceLog(trace));
}
function $d9288c7c564a224b$var$flushLogs() {
    if ($d9288c7c564a224b$var$logger) $d9288c7c564a224b$var$logger.flush();
}
function $d9288c7c564a224b$var$sendTraceLog(trace) {
    if (!$d9288c7c564a224b$var$getIid()) return;
    const settingsService = $d9288c7c564a224b$var$SettingsService.getInstance();
    if (!settingsService.loggingEnabled || !settingsService.logTraceAfterSampling) return;
    $d9288c7c564a224b$var$sendLog(trace, 1 /* ResourceType.Trace */ );
}
function $d9288c7c564a224b$var$logNetworkRequest(networkRequest) {
    const settingsService = $d9288c7c564a224b$var$SettingsService.getInstance();
    // Do not log network requests if instrumentation is disabled.
    if (!settingsService.instrumentationEnabled) return;
    // Do not log the js sdk's call to transport service domain to avoid unnecessary cycle.
    // Need to blacklist both old and new endpoints to avoid migration gap.
    const networkRequestUrl = networkRequest.url;
    // Blacklist old log endpoint and new transport endpoint.
    // Because Performance SDK doesn't instrument requests sent from SDK itself.
    const logEndpointUrl = settingsService.logEndPointUrl.split('?')[0];
    const flEndpointUrl = settingsService.flTransportEndpointUrl.split('?')[0];
    if (networkRequestUrl === logEndpointUrl || networkRequestUrl === flEndpointUrl) return;
    if (!settingsService.loggingEnabled || !settingsService.logNetworkAfterSampling) return;
    $d9288c7c564a224b$var$sendLog(networkRequest, 0 /* ResourceType.NetworkRequest */ );
}
function $d9288c7c564a224b$var$serializer(resource, resourceType) {
    if (resourceType === 0 /* ResourceType.NetworkRequest */ ) return $d9288c7c564a224b$var$serializeNetworkRequest(resource);
    return $d9288c7c564a224b$var$serializeTrace(resource);
}
function $d9288c7c564a224b$var$serializeNetworkRequest(networkRequest) {
    const networkRequestMetric = {
        url: networkRequest.url,
        http_method: networkRequest.httpMethod || 0,
        http_response_code: 200,
        response_payload_bytes: networkRequest.responsePayloadBytes,
        client_start_time_us: networkRequest.startTimeUs,
        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
    };
    const perfMetric = {
        application_info: $d9288c7c564a224b$var$getApplicationInfo(networkRequest.performanceController.app),
        network_request_metric: networkRequestMetric
    };
    return JSON.stringify(perfMetric);
}
function $d9288c7c564a224b$var$serializeTrace(trace) {
    const traceMetric = {
        name: trace.name,
        is_auto: trace.isAuto,
        client_start_time_us: trace.startTimeUs,
        duration_us: trace.durationUs
    };
    if (Object.keys(trace.counters).length !== 0) traceMetric.counters = trace.counters;
    const customAttributes = trace.getAttributes();
    if (Object.keys(customAttributes).length !== 0) traceMetric.custom_attributes = customAttributes;
    const perfMetric = {
        application_info: $d9288c7c564a224b$var$getApplicationInfo(trace.performanceController.app),
        trace_metric: traceMetric
    };
    return JSON.stringify(perfMetric);
}
function $d9288c7c564a224b$var$getApplicationInfo(firebaseApp) {
    return {
        google_app_id: $d9288c7c564a224b$var$getAppId(firebaseApp),
        app_instance_id: $d9288c7c564a224b$var$getIid(),
        web_app_info: {
            sdk_version: $d9288c7c564a224b$var$SDK_VERSION,
            page_url: $d9288c7c564a224b$var$Api.getInstance().getUrl(),
            service_worker_status: $d9288c7c564a224b$var$getServiceWorkerStatus(),
            visibility_state: $d9288c7c564a224b$var$getVisibilityState(),
            effective_connection_type: $d9288c7c564a224b$var$getEffectiveConnectionType()
        },
        application_process_state: 0
    };
}
/* eslint-enable camelcase */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d9288c7c564a224b$var$createNetworkRequestEntry(performanceController, entry) {
    const performanceEntry = entry;
    if (!performanceEntry || performanceEntry.responseStart === undefined) return;
    const timeOrigin = $d9288c7c564a224b$var$Api.getInstance().getTimeOrigin();
    const startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
    const timeToResponseInitiatedUs = performanceEntry.responseStart ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000) : undefined;
    const timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
    // Remove the query params from logged network request url.
    const url = performanceEntry.name && performanceEntry.name.split('?')[0];
    const networkRequest = {
        performanceController: performanceController,
        url: url,
        responsePayloadBytes: performanceEntry.transferSize,
        startTimeUs: startTimeUs,
        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
        timeToResponseCompletedUs: timeToResponseCompletedUs
    };
    $d9288c7c564a224b$var$logNetworkRequest(networkRequest);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9288c7c564a224b$var$MAX_METRIC_NAME_LENGTH = 100;
const $d9288c7c564a224b$var$RESERVED_AUTO_PREFIX = '_';
const $d9288c7c564a224b$var$oobMetrics = [
    $d9288c7c564a224b$var$FIRST_PAINT_COUNTER_NAME,
    $d9288c7c564a224b$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
    $d9288c7c564a224b$var$FIRST_INPUT_DELAY_COUNTER_NAME,
    $d9288c7c564a224b$var$LARGEST_CONTENTFUL_PAINT_METRIC_NAME,
    $d9288c7c564a224b$var$CUMULATIVE_LAYOUT_SHIFT_METRIC_NAME,
    $d9288c7c564a224b$var$INTERACTION_TO_NEXT_PAINT_METRIC_NAME
];
/**
 * Returns true if the metric is custom and does not start with reserved prefix, or if
 * the metric is one of out of the box page load trace metrics.
 */ function $d9288c7c564a224b$var$isValidMetricName(name, traceName) {
    if (name.length === 0 || name.length > $d9288c7c564a224b$var$MAX_METRIC_NAME_LENGTH) return false;
    return traceName && traceName.startsWith($d9288c7c564a224b$var$OOB_TRACE_PAGE_LOAD_PREFIX) && $d9288c7c564a224b$var$oobMetrics.indexOf(name) > -1 || !name.startsWith($d9288c7c564a224b$var$RESERVED_AUTO_PREFIX);
}
/**
 * Converts the provided value to an integer value to be used in case of a metric.
 * @param providedValue Provided number value of the metric that needs to be converted to an integer.
 *
 * @returns Converted integer number to be set for the metric.
 */ function $d9288c7c564a224b$var$convertMetricValueToInteger(providedValue) {
    const valueAsInteger = Math.floor(providedValue);
    if (valueAsInteger < providedValue) $d9288c7c564a224b$var$consoleLogger.info(`Metric value should be an Integer, setting the value as : ${valueAsInteger}.`);
    return valueAsInteger;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d9288c7c564a224b$var$Trace {
    /**
     * @param performanceController The performance controller running.
     * @param name The name of the trace.
     * @param isAuto If the trace is auto-instrumented.
     * @param traceMeasureName The name of the measure marker in user timing specification. This field
     * is only set when the trace is built for logging when the user directly uses the user timing
     * api (performance.mark and performance.measure).
     */ constructor(performanceController, name, isAuto = false, traceMeasureName){
        this.performanceController = performanceController;
        this.name = name;
        this.isAuto = isAuto;
        this.state = 1 /* TraceState.UNINITIALIZED */ ;
        this.customAttributes = {};
        this.counters = {};
        this.api = $d9288c7c564a224b$var$Api.getInstance();
        this.randomId = Math.floor(Math.random() * 1000000);
        if (!this.isAuto) {
            this.traceStartMark = `${$d9288c7c564a224b$var$TRACE_START_MARK_PREFIX}-${this.randomId}-${this.name}`;
            this.traceStopMark = `${$d9288c7c564a224b$var$TRACE_STOP_MARK_PREFIX}-${this.randomId}-${this.name}`;
            this.traceMeasure = traceMeasureName || `${$d9288c7c564a224b$var$TRACE_MEASURE_PREFIX}-${this.randomId}-${this.name}`;
            if (traceMeasureName) // For the case of direct user timing traces, no start stop will happen. The measure object
            // is already available.
            this.calculateTraceMetrics();
        }
    }
    /**
     * Starts a trace. The measurement of the duration starts at this point.
     */ start() {
        if (this.state !== 1 /* TraceState.UNINITIALIZED */ ) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("trace started" /* ErrorCode.TRACE_STARTED_BEFORE */ , {
            traceName: this.name
        });
        this.api.mark(this.traceStartMark);
        this.state = 2 /* TraceState.RUNNING */ ;
    }
    /**
     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
     * is logged.
     */ stop() {
        if (this.state !== 2 /* TraceState.RUNNING */ ) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("trace stopped" /* ErrorCode.TRACE_STOPPED_BEFORE */ , {
            traceName: this.name
        });
        this.state = 3 /* TraceState.TERMINATED */ ;
        this.api.mark(this.traceStopMark);
        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
        this.calculateTraceMetrics();
        $d9288c7c564a224b$var$logTrace(this);
    }
    /**
     * Records a trace with predetermined values. If this method is used a trace is created and logged
     * directly. No need to use start and stop methods.
     * @param startTime Trace start time since epoch in millisec
     * @param duration The duration of the trace in millisec
     * @param options An object which can optionally hold maps of custom metrics and custom attributes
     */ record(startTime, duration, options) {
        if (startTime <= 0) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("nonpositive trace startTime" /* ErrorCode.NONPOSITIVE_TRACE_START_TIME */ , {
            traceName: this.name
        });
        if (duration <= 0) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("nonpositive trace duration" /* ErrorCode.NONPOSITIVE_TRACE_DURATION */ , {
            traceName: this.name
        });
        this.durationUs = Math.floor(duration * 1000);
        this.startTimeUs = Math.floor(startTime * 1000);
        if (options && options.attributes) this.customAttributes = Object.assign({}, options.attributes);
        if (options && options.metrics) {
            for (const metricName of Object.keys(options.metrics))if (!isNaN(Number(options.metrics[metricName]))) this.counters[metricName] = Math.floor(Number(options.metrics[metricName]));
        }
        $d9288c7c564a224b$var$logTrace(this);
    }
    /**
     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
     * custom metric if one with the given name does not exist. The value will be floored down to an
     * integer.
     * @param counter Name of the custom metric
     * @param numAsInteger Increment by value
     */ incrementMetric(counter, numAsInteger = 1) {
        if (this.counters[counter] === undefined) this.putMetric(counter, numAsInteger);
        else this.putMetric(counter, this.counters[counter] + numAsInteger);
    }
    /**
     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
     * given name does not exist. The value will be floored down to an integer.
     * @param counter Name of the custom metric
     * @param numAsInteger Set custom metric to this value
     */ putMetric(counter, numAsInteger) {
        if ($d9288c7c564a224b$var$isValidMetricName(counter, this.name)) this.counters[counter] = $d9288c7c564a224b$var$convertMetricValueToInteger(numAsInteger !== null && numAsInteger !== void 0 ? numAsInteger : 0);
        else throw $d9288c7c564a224b$var$ERROR_FACTORY.create("invalid custom metric name" /* ErrorCode.INVALID_CUSTOM_METRIC_NAME */ , {
            customMetricName: counter
        });
    }
    /**
     * Returns the value of the custom metric by that name. If a custom metric with that name does
     * not exist will return zero.
     * @param counter
     */ getMetric(counter) {
        return this.counters[counter] || 0;
    }
    /**
     * Sets a custom attribute of a trace to a certain value.
     * @param attr
     * @param value
     */ putAttribute(attr, value) {
        const isValidName = $d9288c7c564a224b$var$isValidCustomAttributeName(attr);
        const isValidValue = $d9288c7c564a224b$var$isValidCustomAttributeValue(value);
        if (isValidName && isValidValue) {
            this.customAttributes[attr] = value;
            return;
        }
        // Throw appropriate error when the attribute name or value is invalid.
        if (!isValidName) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("invalid attribute name" /* ErrorCode.INVALID_ATTRIBUTE_NAME */ , {
            attributeName: attr
        });
        if (!isValidValue) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("invalid attribute value" /* ErrorCode.INVALID_ATTRIBUTE_VALUE */ , {
            attributeValue: value
        });
    }
    /**
     * Retrieves the value a custom attribute of a trace is set to.
     * @param attr
     */ getAttribute(attr) {
        return this.customAttributes[attr];
    }
    removeAttribute(attr) {
        if (this.customAttributes[attr] === undefined) return;
        delete this.customAttributes[attr];
    }
    getAttributes() {
        return Object.assign({}, this.customAttributes);
    }
    setStartTime(startTime) {
        this.startTimeUs = startTime;
    }
    setDuration(duration) {
        this.durationUs = duration;
    }
    /**
     * Calculates and assigns the duration and start time of the trace using the measure performance
     * entry.
     */ calculateTraceMetrics() {
        const perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
        const perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
        if (perfMeasureEntry) {
            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
        }
    }
    /**
     * @param navigationTimings A single element array which contains the navigationTIming object of
     * the page load
     * @param paintTimings A array which contains paintTiming object of the page load
     * @param firstInputDelay First input delay in millisec
     */ static createOobTrace(performanceController, navigationTimings, paintTimings, webVitalMetrics, firstInputDelay) {
        const route = $d9288c7c564a224b$var$Api.getInstance().getUrl();
        if (!route) return;
        const trace = new $d9288c7c564a224b$var$Trace(performanceController, $d9288c7c564a224b$var$OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
        const timeOriginUs = Math.floor($d9288c7c564a224b$var$Api.getInstance().getTimeOrigin() * 1000);
        trace.setStartTime(timeOriginUs);
        // navigationTimings includes only one element.
        if (navigationTimings && navigationTimings[0]) {
            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
            trace.putMetric('domInteractive', Math.floor(navigationTimings[0].domInteractive * 1000));
            trace.putMetric('domContentLoadedEventEnd', Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
            trace.putMetric('loadEventEnd', Math.floor(navigationTimings[0].loadEventEnd * 1000));
        }
        const FIRST_PAINT = 'first-paint';
        const FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
        if (paintTimings) {
            const firstPaint = paintTimings.find((paintObject)=>paintObject.name === FIRST_PAINT);
            if (firstPaint && firstPaint.startTime) trace.putMetric($d9288c7c564a224b$var$FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
            const firstContentfulPaint = paintTimings.find((paintObject)=>paintObject.name === FIRST_CONTENTFUL_PAINT);
            if (firstContentfulPaint && firstContentfulPaint.startTime) trace.putMetric($d9288c7c564a224b$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
            if (firstInputDelay) trace.putMetric($d9288c7c564a224b$var$FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
        }
        this.addWebVitalMetric(trace, $d9288c7c564a224b$var$LARGEST_CONTENTFUL_PAINT_METRIC_NAME, $d9288c7c564a224b$var$LARGEST_CONTENTFUL_PAINT_ATTRIBUTE_NAME, webVitalMetrics.lcp);
        this.addWebVitalMetric(trace, $d9288c7c564a224b$var$CUMULATIVE_LAYOUT_SHIFT_METRIC_NAME, $d9288c7c564a224b$var$CUMULATIVE_LAYOUT_SHIFT_ATTRIBUTE_NAME, webVitalMetrics.cls);
        this.addWebVitalMetric(trace, $d9288c7c564a224b$var$INTERACTION_TO_NEXT_PAINT_METRIC_NAME, $d9288c7c564a224b$var$INTERACTION_TO_NEXT_PAINT_ATTRIBUTE_NAME, webVitalMetrics.inp);
        // Page load logs are sent at unload time and so should be logged and
        // flushed immediately.
        $d9288c7c564a224b$var$logTrace(trace);
        $d9288c7c564a224b$var$flushLogs();
    }
    static addWebVitalMetric(trace, metricKey, attributeKey, metric) {
        if (metric) {
            trace.putMetric(metricKey, Math.floor(metric.value * 1000));
            if (metric.elementAttribution) trace.putAttribute(attributeKey, metric.elementAttribution);
        }
    }
    static createUserTimingTrace(performanceController, measureName) {
        const trace = new $d9288c7c564a224b$var$Trace(performanceController, measureName, false, measureName);
        $d9288c7c564a224b$var$logTrace(trace);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d9288c7c564a224b$var$webVitalMetrics = {};
let $d9288c7c564a224b$var$sentPageLoadTrace = false;
let $d9288c7c564a224b$var$firstInputDelay;
function $d9288c7c564a224b$var$setupOobResources(performanceController) {
    // Do not initialize unless iid is available.
    if (!$d9288c7c564a224b$var$getIid()) return;
    // The load event might not have fired yet, and that means performance
    // navigation timing object has a duration of 0. The setup should run after
    // all current tasks in js queue.
    setTimeout(()=>$d9288c7c564a224b$var$setupOobTraces(performanceController), 0);
    setTimeout(()=>$d9288c7c564a224b$var$setupNetworkRequests(performanceController), 0);
    setTimeout(()=>$d9288c7c564a224b$var$setupUserTimingTraces(performanceController), 0);
}
function $d9288c7c564a224b$var$setupNetworkRequests(performanceController) {
    const api = $d9288c7c564a224b$var$Api.getInstance();
    const resources = api.getEntriesByType('resource');
    for (const resource of resources)$d9288c7c564a224b$var$createNetworkRequestEntry(performanceController, resource);
    api.setupObserver('resource', (entry)=>$d9288c7c564a224b$var$createNetworkRequestEntry(performanceController, entry));
}
function $d9288c7c564a224b$var$setupOobTraces(performanceController) {
    const api = $d9288c7c564a224b$var$Api.getInstance();
    // Better support for Safari
    if ('onpagehide' in window) api.document.addEventListener('pagehide', ()=>$d9288c7c564a224b$var$sendOobTrace(performanceController));
    else api.document.addEventListener('unload', ()=>$d9288c7c564a224b$var$sendOobTrace(performanceController));
    api.document.addEventListener('visibilitychange', ()=>{
        if (api.document.visibilityState === 'hidden') $d9288c7c564a224b$var$sendOobTrace(performanceController);
    });
    if (api.onFirstInputDelay) api.onFirstInputDelay((fid)=>{
        $d9288c7c564a224b$var$firstInputDelay = fid;
    });
    api.onLCP((metric)=>{
        var _a;
        $d9288c7c564a224b$var$webVitalMetrics.lcp = {
            value: metric.value,
            elementAttribution: (_a = metric.attribution) === null || _a === void 0 ? void 0 : _a.element
        };
    });
    api.onCLS((metric)=>{
        var _a;
        $d9288c7c564a224b$var$webVitalMetrics.cls = {
            value: metric.value,
            elementAttribution: (_a = metric.attribution) === null || _a === void 0 ? void 0 : _a.largestShiftTarget
        };
    });
    api.onINP((metric)=>{
        var _a;
        $d9288c7c564a224b$var$webVitalMetrics.inp = {
            value: metric.value,
            elementAttribution: (_a = metric.attribution) === null || _a === void 0 ? void 0 : _a.interactionTarget
        };
    });
}
function $d9288c7c564a224b$var$setupUserTimingTraces(performanceController) {
    const api = $d9288c7c564a224b$var$Api.getInstance();
    // Run through the measure performance entries collected up to this point.
    const measures = api.getEntriesByType('measure');
    for (const measure of measures)$d9288c7c564a224b$var$createUserTimingTrace(performanceController, measure);
    // Setup an observer to capture the measures from this point on.
    api.setupObserver('measure', (entry)=>$d9288c7c564a224b$var$createUserTimingTrace(performanceController, entry));
}
function $d9288c7c564a224b$var$createUserTimingTrace(performanceController, measure) {
    const measureName = measure.name;
    // Do not create a trace, if the user timing marks and measures are created by
    // the sdk itself.
    if (measureName.substring(0, $d9288c7c564a224b$var$TRACE_MEASURE_PREFIX.length) === $d9288c7c564a224b$var$TRACE_MEASURE_PREFIX) return;
    $d9288c7c564a224b$var$Trace.createUserTimingTrace(performanceController, measureName);
}
function $d9288c7c564a224b$var$sendOobTrace(performanceController) {
    if (!$d9288c7c564a224b$var$sentPageLoadTrace) {
        $d9288c7c564a224b$var$sentPageLoadTrace = true;
        const api = $d9288c7c564a224b$var$Api.getInstance();
        const navigationTimings = api.getEntriesByType('navigation');
        const paintTimings = api.getEntriesByType('paint');
        // On page unload web vitals may be updated so queue the oob trace creation
        // so that these updates have time to be included.
        setTimeout(()=>{
            $d9288c7c564a224b$var$Trace.createOobTrace(performanceController, navigationTimings, paintTimings, $d9288c7c564a224b$var$webVitalMetrics, $d9288c7c564a224b$var$firstInputDelay);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d9288c7c564a224b$var$PerformanceController {
    constructor(app, installations){
        this.app = app;
        this.installations = installations;
        this.initialized = false;
    }
    /**
     * This method *must* be called internally as part of creating a
     * PerformanceController instance.
     *
     * Currently it's not possible to pass the settings object through the
     * constructor using Components, so this method exists to be called with the
     * desired settings, to ensure nothing is collected without the user's
     * consent.
     */ _init(settings) {
        if (this.initialized) return;
        if ((settings === null || settings === void 0 ? void 0 : settings.dataCollectionEnabled) !== undefined) this.dataCollectionEnabled = settings.dataCollectionEnabled;
        if ((settings === null || settings === void 0 ? void 0 : settings.instrumentationEnabled) !== undefined) this.instrumentationEnabled = settings.instrumentationEnabled;
        if ($d9288c7c564a224b$var$Api.getInstance().requiredApisAvailable()) (0, $7a5e5653d27b8a06$export$a8a3018f3d187a4d)().then((isAvailable)=>{
            if (isAvailable) {
                $d9288c7c564a224b$var$setupTransportService();
                $d9288c7c564a224b$var$getInitializationPromise(this).then(()=>$d9288c7c564a224b$var$setupOobResources(this), ()=>$d9288c7c564a224b$var$setupOobResources(this));
                this.initialized = true;
            }
        }).catch((error)=>{
            $d9288c7c564a224b$var$consoleLogger.info(`Environment doesn't support IndexedDB: ${error}`);
        });
        else $d9288c7c564a224b$var$consoleLogger.info('Firebase Performance cannot start if the browser does not support "Fetch" and "Promise", or cookies are disabled.');
    }
    set instrumentationEnabled(val) {
        $d9288c7c564a224b$var$SettingsService.getInstance().instrumentationEnabled = val;
    }
    get instrumentationEnabled() {
        return $d9288c7c564a224b$var$SettingsService.getInstance().instrumentationEnabled;
    }
    set dataCollectionEnabled(val) {
        $d9288c7c564a224b$var$SettingsService.getInstance().dataCollectionEnabled = val;
    }
    get dataCollectionEnabled() {
        return $d9288c7c564a224b$var$SettingsService.getInstance().dataCollectionEnabled;
    }
}
/**
 * The Firebase Performance Monitoring Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ const $d9288c7c564a224b$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * Returns a {@link FirebasePerformance} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @public
 */ function $d9288c7c564a224b$export$28a0276e10aa78d7(app = (0, $3c66ef1885bbdcd1$export$f9962582c9e66d99)()) {
    app = (0, $7a5e5653d27b8a06$export$4befe9b5fa509a1b)(app);
    const provider = (0, $3c66ef1885bbdcd1$export$fa0d6da0f5838f50)(app, 'performance');
    const perfInstance = provider.getImmediate();
    return perfInstance;
}
/**
 * Returns a {@link FirebasePerformance} instance for the given app. Can only be called once.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param settings - Optional settings for the {@link FirebasePerformance} instance.
 * @public
 */ function $d9288c7c564a224b$export$ac14c8f53249566c(app, settings) {
    app = (0, $7a5e5653d27b8a06$export$4befe9b5fa509a1b)(app);
    const provider = (0, $3c66ef1885bbdcd1$export$fa0d6da0f5838f50)(app, 'performance');
    // throw if an instance was already created.
    // It could happen if initializePerformance() is called more than once, or getPerformance() is called first.
    if (provider.isInitialized()) {
        const existingInstance = provider.getImmediate();
        const initialSettings = provider.getOptions();
        if ((0, $7a5e5653d27b8a06$export$9cb4719e2e525b7a)(initialSettings, settings !== null && settings !== void 0 ? settings : {})) return existingInstance;
        else throw $d9288c7c564a224b$var$ERROR_FACTORY.create("already initialized" /* ErrorCode.ALREADY_INITIALIZED */ );
    }
    const perfInstance = provider.initialize({
        options: settings
    });
    return perfInstance;
}
/**
 * Returns a new `PerformanceTrace` instance.
 * @param performance - The {@link FirebasePerformance} instance to use.
 * @param name - The name of the trace.
 * @public
 */ function $d9288c7c564a224b$export$357889f174732d38(performance, name) {
    performance = (0, $7a5e5653d27b8a06$export$4befe9b5fa509a1b)(performance);
    return new $d9288c7c564a224b$var$Trace(performance, name);
}
const $d9288c7c564a224b$var$factory = (container, { options: settings })=>{
    // Dependencies
    const app = container.getProvider('app').getImmediate();
    const installations = container.getProvider('installations-internal').getImmediate();
    if (app.name !== $d9288c7c564a224b$var$DEFAULT_ENTRY_NAME) throw $d9288c7c564a224b$var$ERROR_FACTORY.create("FB not default" /* ErrorCode.FB_NOT_DEFAULT */ );
    if (typeof window === 'undefined') throw $d9288c7c564a224b$var$ERROR_FACTORY.create("no window" /* ErrorCode.NO_WINDOW */ );
    $d9288c7c564a224b$var$setupApi(window);
    const perfInstance = new $d9288c7c564a224b$var$PerformanceController(app, installations);
    perfInstance._init(settings);
    return perfInstance;
};
function $d9288c7c564a224b$var$registerPerformance() {
    (0, $3c66ef1885bbdcd1$export$c930050e7bb63965)(new (0, $d4d618502f0d98d6$export$16fa2f45be04daa8)('performance', $d9288c7c564a224b$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $3c66ef1885bbdcd1$export$d29d5299a7137abc)($d9288c7c564a224b$var$name, $d9288c7c564a224b$var$version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $3c66ef1885bbdcd1$export$d29d5299a7137abc)($d9288c7c564a224b$var$name, $d9288c7c564a224b$var$version, 'esm2017');
}
$d9288c7c564a224b$var$registerPerformance();




// Your web app's Firebase configuration
const $78e42c400dda596b$var$firebaseConfig = {
    apiKey: "AIzaSyDL8cLY67Kzq1Nnd3t13e4rKgK8T0q24fc",
    authDomain: "analytics-dashboard-318810.firebaseapp.com",
    databaseURL: "https://analytics-dashboard-318810-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "analytics-dashboard-318810",
    storageBucket: "analytics-dashboard-318810.appspot.com",
    messagingSenderId: "775666510711",
    appId: "1:775666510711:web:6aa0b8aaa62f38ca150f72"
};
class $78e42c400dda596b$export$447fa9cb0c946c58 {
    /**
   * Initialize the Firebase App.
   */ static initApp() {
        // Initialize Firebase
        this.app = (0, $3c66ef1885bbdcd1$export$c55cfd413944906d)($78e42c400dda596b$var$firebaseConfig);
    }
    /**
   * Get the Performance Monitoring service.
   */ static initPerformance() {
        if (!this.app) this.initApp();
        // Initialize Performance Monitoring and get a reference to the service
        this.performance = (0, $d9288c7c564a224b$export$28a0276e10aa78d7)(this.app);
    }
}



parcelRequire("igtsr");
const $f11264a5073aa658$var$SvgLogo = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 65,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "#FFF",
            fillRule: "evenodd",
            d: "M45.244 29.213a11 11 0 0 0-.38-1.144l16.246-9.444-2.797-4.874-.227-.398-.04.022-16.892 9.821q-.316-.232-.643-.444L50.28 5.716l.043-.079-1.359-.79-1.82-1.056-2.056-1.196-.084.145L34.55 20.972h-.014V.096A32 32 0 0 0 32.06 0C14.352 0 0 14.45 0 32.277c0 15.43 10.752 28.33 25.126 31.52 1.364.28 2.8.5 4.313.65q2.416.248 5.097.249V43.519l10.486 18.287.066.115 1.407-.818 3.109-1.807.72-.42-.029-.05-9.819-17.125q.313-.2.61-.42l16.982 9.87.018.01.103-.176 2.92-5.096-16.272-9.46q.219-.55.383-1.128H64v-6.088zm-21.592 3.482c0-6.148 4.97-11.13 11.104-11.13h.027v6.85h-.027a4.276 4.276 0 0 0-4.27 4.28 4.275 4.275 0 0 0 4.27 4.28h.027v6.851h-.027c-6.133 0-11.104-4.984-11.104-11.131"
        })
    });
var $f11264a5073aa658$export$2e2bcd8739ae039 = $f11264a5073aa658$var$SvgLogo;


/**
 * @author Youssef Tarek
 * @date 2023-02-07
 * @description segment creator for a group of filters.
 * @filename create-segment.tsx
 */ 
/**
 * @author Salma Hefnawy
 * @date 2022-04-13
 * @description implementation of section loader component
 * to be used while loading.
 * @filename section-loader.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


var $igtsr = parcelRequire("igtsr");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $51839a74322b0d52$var$extendStatics = function(d, b) {
    $51839a74322b0d52$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $51839a74322b0d52$var$extendStatics(d, b);
};
function $51839a74322b0d52$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $51839a74322b0d52$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $51839a74322b0d52$export$18ce0697a983be9b = function() {
    $51839a74322b0d52$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $51839a74322b0d52$export$18ce0697a983be9b.apply(this, arguments);
};
function $51839a74322b0d52$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $51839a74322b0d52$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $51839a74322b0d52$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $51839a74322b0d52$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $51839a74322b0d52$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $51839a74322b0d52$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $51839a74322b0d52$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $51839a74322b0d52$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $51839a74322b0d52$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $51839a74322b0d52$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $51839a74322b0d52$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $51839a74322b0d52$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $51839a74322b0d52$export$45d3717a4c69092e(o, m, p);
}
function $51839a74322b0d52$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $51839a74322b0d52$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $51839a74322b0d52$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($51839a74322b0d52$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $51839a74322b0d52$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $51839a74322b0d52$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $51839a74322b0d52$export$10c90e4f7922046c(v) {
    return this instanceof $51839a74322b0d52$export$10c90e4f7922046c ? (this.v = v, this) : new $51839a74322b0d52$export$10c90e4f7922046c(v);
}
function $51839a74322b0d52$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $51839a74322b0d52$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $51839a74322b0d52$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $51839a74322b0d52$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $51839a74322b0d52$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $51839a74322b0d52$export$19a8beecd37a4c45 === "function" ? $51839a74322b0d52$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $51839a74322b0d52$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $51839a74322b0d52$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $51839a74322b0d52$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $51839a74322b0d52$export$45d3717a4c69092e(result, mod, k);
    }
    $51839a74322b0d52$var$__setModuleDefault(result, mod);
    return result;
}
function $51839a74322b0d52$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $51839a74322b0d52$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $51839a74322b0d52$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $51839a74322b0d52$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $51839a74322b0d52$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $51839a74322b0d52$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $51839a74322b0d52$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $51839a74322b0d52$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $51839a74322b0d52$export$2e2bcd8739ae039 = {
    __extends: $51839a74322b0d52$export$a8ba968b8961cb8a,
    __assign: $51839a74322b0d52$export$18ce0697a983be9b,
    __rest: $51839a74322b0d52$export$3c9a16f847548506,
    __decorate: $51839a74322b0d52$export$29e00dfd3077644b,
    __param: $51839a74322b0d52$export$d5ad3fd78186038f,
    __metadata: $51839a74322b0d52$export$f1db080c865becb9,
    __awaiter: $51839a74322b0d52$export$1050f835b63b671e,
    __generator: $51839a74322b0d52$export$67ebef60e6f28a6,
    __createBinding: $51839a74322b0d52$export$45d3717a4c69092e,
    __exportStar: $51839a74322b0d52$export$f33643c0debef087,
    __values: $51839a74322b0d52$export$19a8beecd37a4c45,
    __read: $51839a74322b0d52$export$8d051b38c9118094,
    __spread: $51839a74322b0d52$export$afc72e2116322959,
    __spreadArrays: $51839a74322b0d52$export$6388937ca91ccae8,
    __spreadArray: $51839a74322b0d52$export$1216008129fb82ed,
    __await: $51839a74322b0d52$export$10c90e4f7922046c,
    __asyncGenerator: $51839a74322b0d52$export$e427f37a30a4de9b,
    __asyncDelegator: $51839a74322b0d52$export$bbd80228419bb833,
    __asyncValues: $51839a74322b0d52$export$e3b29a3d6162315f,
    __makeTemplateObject: $51839a74322b0d52$export$4fb47efe1390b86f,
    __importStar: $51839a74322b0d52$export$c21735bcef00d192,
    __importDefault: $51839a74322b0d52$export$da59b14a69baef04,
    __classPrivateFieldGet: $51839a74322b0d52$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $51839a74322b0d52$export$d40a35129aaff81f,
    __classPrivateFieldIn: $51839a74322b0d52$export$81fdc39f203e4e04,
    __addDisposableResource: $51839a74322b0d52$export$88ac25d8e944e405,
    __disposeResources: $51839a74322b0d52$export$8f076105dc360e92
};


function $6a69d9ce47a3f57c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $43c30402ce36f5a8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $43c30402ce36f5a8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6a69d9ce47a3f57c$export$2e2bcd8739ae039)(function(prop) {
    return $43c30402ce36f5a8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $igtsr = parcelRequire("igtsr");
var $5c43fcf22af86af1$exports = {};
//
$5c43fcf22af86af1$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $bf79abfa05a306d2$export$71ad59f2e432cfe8 = "-ms-";
var $bf79abfa05a306d2$export$2c0f367103c8d01c = "-moz-";
var $bf79abfa05a306d2$export$39dfd62a25e0fe93 = "-webkit-";
var $bf79abfa05a306d2$export$a29989082612d0d9 = "comm";
var $bf79abfa05a306d2$export$aa3a2e812ca8570d = "rule";
var $bf79abfa05a306d2$export$527d108ccf083c2b = "decl";
var $bf79abfa05a306d2$export$d3d35020fa5b54f0 = "@page";
var $bf79abfa05a306d2$export$500415a86c544f73 = "@media";
var $bf79abfa05a306d2$export$a763edbf796b780a = "@import";
var $bf79abfa05a306d2$export$2790aeb8b4e5c826 = "@charset";
var $bf79abfa05a306d2$export$1cc683e23b84b133 = "@viewport";
var $bf79abfa05a306d2$export$9447a5efea57e862 = "@supports";
var $bf79abfa05a306d2$export$ef011b4e114b1fba = "@document";
var $bf79abfa05a306d2$export$6aad947bda0f3f46 = "@namespace";
var $bf79abfa05a306d2$export$b44a8529a35fcb60 = "@keyframes";
var $bf79abfa05a306d2$export$2c16de31893252e6 = "@font-face";
var $bf79abfa05a306d2$export$3d846dd52e150c6f = "@counter-style";
var $bf79abfa05a306d2$export$22314bfbb57653fe = "@font-feature-values";
var $bf79abfa05a306d2$export$d773506282b3cfe6 = "@layer";
var $bf79abfa05a306d2$export$1c5a554c78c0cd12 = "@scope";
var $bf79abfa05a306d2$export$2335f513bbd82c6d = Math.abs;
var $bf79abfa05a306d2$export$6788812c4e6611e6 = String.fromCharCode;
var $bf79abfa05a306d2$export$e6e34fd1f2686227 = Object.assign;
function $bf79abfa05a306d2$export$d6af199866bfb566(e, r) {
    return $bf79abfa05a306d2$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $bf79abfa05a306d2$export$a9db5e087081082d(e, 0)) << 2 ^ $bf79abfa05a306d2$export$a9db5e087081082d(e, 1)) << 2 ^ $bf79abfa05a306d2$export$a9db5e087081082d(e, 2)) << 2 ^ $bf79abfa05a306d2$export$a9db5e087081082d(e, 3) : 0;
}
function $bf79abfa05a306d2$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $bf79abfa05a306d2$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $bf79abfa05a306d2$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $bf79abfa05a306d2$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $bf79abfa05a306d2$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $bf79abfa05a306d2$export$36776f635604f274(e) {
    return e.length;
}
function $bf79abfa05a306d2$export$f9084667e487ed46(e) {
    return e.length;
}
function $bf79abfa05a306d2$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $bf79abfa05a306d2$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $bf79abfa05a306d2$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$bf79abfa05a306d2$export$4659b591c19bdf3d(e, r);
    });
}
var $bf79abfa05a306d2$export$53f1d5ea8de3d7c = 1;
var $bf79abfa05a306d2$export$4e0c71f277ca26b3 = 1;
var $bf79abfa05a306d2$export$f24224f1c91d8156 = 0;
var $bf79abfa05a306d2$export$5880b8b5730aff45 = 0;
var $bf79abfa05a306d2$export$c0306caf338ac095 = 0;
var $bf79abfa05a306d2$export$30a86d91af8ff6e6 = "";
function $bf79abfa05a306d2$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $bf79abfa05a306d2$export$53f1d5ea8de3d7c,
        column: $bf79abfa05a306d2$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $bf79abfa05a306d2$export$784d13d8ee351f07(e, r) {
    return $bf79abfa05a306d2$export$e6e34fd1f2686227($bf79abfa05a306d2$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $bf79abfa05a306d2$export$590e8b2c435046d9(e) {
    while(e.root)e = $bf79abfa05a306d2$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $bf79abfa05a306d2$export$10d8903dec122b9d(e, e.siblings);
}
function $bf79abfa05a306d2$export$eba6f6f03b0a92e7() {
    return $bf79abfa05a306d2$export$c0306caf338ac095;
}
function $bf79abfa05a306d2$export$232faf9add678146() {
    $bf79abfa05a306d2$export$c0306caf338ac095 = $bf79abfa05a306d2$export$5880b8b5730aff45 > 0 ? $bf79abfa05a306d2$export$a9db5e087081082d($bf79abfa05a306d2$export$30a86d91af8ff6e6, --$bf79abfa05a306d2$export$5880b8b5730aff45) : 0;
    if ($bf79abfa05a306d2$export$4e0c71f277ca26b3--, $bf79abfa05a306d2$export$c0306caf338ac095 === 10) $bf79abfa05a306d2$export$4e0c71f277ca26b3 = 1, $bf79abfa05a306d2$export$53f1d5ea8de3d7c--;
    return $bf79abfa05a306d2$export$c0306caf338ac095;
}
function $bf79abfa05a306d2$export$48cfd1e771a65c4f() {
    $bf79abfa05a306d2$export$c0306caf338ac095 = $bf79abfa05a306d2$export$5880b8b5730aff45 < $bf79abfa05a306d2$export$f24224f1c91d8156 ? $bf79abfa05a306d2$export$a9db5e087081082d($bf79abfa05a306d2$export$30a86d91af8ff6e6, $bf79abfa05a306d2$export$5880b8b5730aff45++) : 0;
    if ($bf79abfa05a306d2$export$4e0c71f277ca26b3++, $bf79abfa05a306d2$export$c0306caf338ac095 === 10) $bf79abfa05a306d2$export$4e0c71f277ca26b3 = 1, $bf79abfa05a306d2$export$53f1d5ea8de3d7c++;
    return $bf79abfa05a306d2$export$c0306caf338ac095;
}
function $bf79abfa05a306d2$export$4d3fb11e950abb9e() {
    return $bf79abfa05a306d2$export$a9db5e087081082d($bf79abfa05a306d2$export$30a86d91af8ff6e6, $bf79abfa05a306d2$export$5880b8b5730aff45);
}
function $bf79abfa05a306d2$export$e88cb2efb12ae807() {
    return $bf79abfa05a306d2$export$5880b8b5730aff45;
}
function $bf79abfa05a306d2$export$58adb3bec8346d0f(e, r) {
    return $bf79abfa05a306d2$export$2f35ab04d2335697($bf79abfa05a306d2$export$30a86d91af8ff6e6, e, r);
}
function $bf79abfa05a306d2$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $bf79abfa05a306d2$export$2de70f21292aac9e(e) {
    return $bf79abfa05a306d2$export$53f1d5ea8de3d7c = $bf79abfa05a306d2$export$4e0c71f277ca26b3 = 1, $bf79abfa05a306d2$export$f24224f1c91d8156 = $bf79abfa05a306d2$export$36776f635604f274($bf79abfa05a306d2$export$30a86d91af8ff6e6 = e), $bf79abfa05a306d2$export$5880b8b5730aff45 = 0, [];
}
function $bf79abfa05a306d2$export$45918ac1574455b1(e) {
    return $bf79abfa05a306d2$export$30a86d91af8ff6e6 = "", e;
}
function $bf79abfa05a306d2$export$410ac95b9ec204b8(e) {
    return $bf79abfa05a306d2$export$87c2784dc9fc4ab($bf79abfa05a306d2$export$58adb3bec8346d0f($bf79abfa05a306d2$export$5880b8b5730aff45 - 1, $bf79abfa05a306d2$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $bf79abfa05a306d2$export$660b2ee2d4fb4eff(e) {
    return $bf79abfa05a306d2$export$45918ac1574455b1($bf79abfa05a306d2$export$5f8c09e3ae6f64e1($bf79abfa05a306d2$export$2de70f21292aac9e(e)));
}
function $bf79abfa05a306d2$export$7af1228ff777d175(e) {
    while($bf79abfa05a306d2$export$c0306caf338ac095 = $bf79abfa05a306d2$export$4d3fb11e950abb9e())if ($bf79abfa05a306d2$export$c0306caf338ac095 < 33) $bf79abfa05a306d2$export$48cfd1e771a65c4f();
    else break;
    return $bf79abfa05a306d2$export$9e1725a4cfeada27(e) > 2 || $bf79abfa05a306d2$export$9e1725a4cfeada27($bf79abfa05a306d2$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $bf79abfa05a306d2$export$5f8c09e3ae6f64e1(e) {
    while($bf79abfa05a306d2$export$48cfd1e771a65c4f())switch($bf79abfa05a306d2$export$9e1725a4cfeada27($bf79abfa05a306d2$export$c0306caf338ac095)){
        case 0:
            $bf79abfa05a306d2$export$10d8903dec122b9d($bf79abfa05a306d2$export$c2ab62c7bf24634($bf79abfa05a306d2$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $bf79abfa05a306d2$export$10d8903dec122b9d($bf79abfa05a306d2$export$410ac95b9ec204b8($bf79abfa05a306d2$export$c0306caf338ac095), e);
            break;
        default:
            $bf79abfa05a306d2$export$10d8903dec122b9d($bf79abfa05a306d2$export$6788812c4e6611e6($bf79abfa05a306d2$export$c0306caf338ac095), e);
    }
    return e;
}
function $bf79abfa05a306d2$export$955ba06d119e085e(e, r) {
    while(--r && $bf79abfa05a306d2$export$48cfd1e771a65c4f())if ($bf79abfa05a306d2$export$c0306caf338ac095 < 48 || $bf79abfa05a306d2$export$c0306caf338ac095 > 102 || $bf79abfa05a306d2$export$c0306caf338ac095 > 57 && $bf79abfa05a306d2$export$c0306caf338ac095 < 65 || $bf79abfa05a306d2$export$c0306caf338ac095 > 70 && $bf79abfa05a306d2$export$c0306caf338ac095 < 97) break;
    return $bf79abfa05a306d2$export$58adb3bec8346d0f(e, $bf79abfa05a306d2$export$e88cb2efb12ae807() + (r < 6 && $bf79abfa05a306d2$export$4d3fb11e950abb9e() == 32 && $bf79abfa05a306d2$export$48cfd1e771a65c4f() == 32));
}
function $bf79abfa05a306d2$export$c889f2fcc19dbf12(e) {
    while($bf79abfa05a306d2$export$48cfd1e771a65c4f())switch($bf79abfa05a306d2$export$c0306caf338ac095){
        case e:
            return $bf79abfa05a306d2$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $bf79abfa05a306d2$export$c889f2fcc19dbf12($bf79abfa05a306d2$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $bf79abfa05a306d2$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $bf79abfa05a306d2$export$48cfd1e771a65c4f();
            break;
    }
    return $bf79abfa05a306d2$export$5880b8b5730aff45;
}
function $bf79abfa05a306d2$export$4254d4e2b3745c4c(e, r) {
    while($bf79abfa05a306d2$export$48cfd1e771a65c4f())if (e + $bf79abfa05a306d2$export$c0306caf338ac095 === 57) break;
    else if (e + $bf79abfa05a306d2$export$c0306caf338ac095 === 84 && $bf79abfa05a306d2$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $bf79abfa05a306d2$export$58adb3bec8346d0f(r, $bf79abfa05a306d2$export$5880b8b5730aff45 - 1) + "*" + $bf79abfa05a306d2$export$6788812c4e6611e6(e === 47 ? e : $bf79abfa05a306d2$export$48cfd1e771a65c4f());
}
function $bf79abfa05a306d2$export$c2ab62c7bf24634(e) {
    while(!$bf79abfa05a306d2$export$9e1725a4cfeada27($bf79abfa05a306d2$export$4d3fb11e950abb9e()))$bf79abfa05a306d2$export$48cfd1e771a65c4f();
    return $bf79abfa05a306d2$export$58adb3bec8346d0f(e, $bf79abfa05a306d2$export$5880b8b5730aff45);
}
function $bf79abfa05a306d2$export$ef7acd7185315e22(e) {
    return $bf79abfa05a306d2$export$45918ac1574455b1($bf79abfa05a306d2$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $bf79abfa05a306d2$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $bf79abfa05a306d2$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $bf79abfa05a306d2$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $bf79abfa05a306d2$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($bf79abfa05a306d2$export$f8e21b1e77979a08(z += $bf79abfa05a306d2$export$77ad94ebf1c2b9ed($bf79abfa05a306d2$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $bf79abfa05a306d2$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $bf79abfa05a306d2$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $bf79abfa05a306d2$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $bf79abfa05a306d2$export$955ba06d119e085e($bf79abfa05a306d2$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($bf79abfa05a306d2$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $bf79abfa05a306d2$export$10d8903dec122b9d($bf79abfa05a306d2$export$4a34f930e789283c($bf79abfa05a306d2$export$4254d4e2b3745c4c($bf79abfa05a306d2$export$48cfd1e771a65c4f(), $bf79abfa05a306d2$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $bf79abfa05a306d2$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $bf79abfa05a306d2$export$36776f635604f274(z) - l) $bf79abfa05a306d2$export$10d8903dec122b9d(p > 32 ? $bf79abfa05a306d2$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $bf79abfa05a306d2$export$f8483753829ec8f3($bf79abfa05a306d2$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $bf79abfa05a306d2$export$10d8903dec122b9d(j = $bf79abfa05a306d2$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $bf79abfa05a306d2$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $bf79abfa05a306d2$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $bf79abfa05a306d2$export$98e6a39c04603d36(e, j, j, n && $bf79abfa05a306d2$export$10d8903dec122b9d($bf79abfa05a306d2$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $bf79abfa05a306d2$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $bf79abfa05a306d2$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $bf79abfa05a306d2$export$232faf9add678146() == 125) continue;
            }
            switch(z += $bf79abfa05a306d2$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($bf79abfa05a306d2$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($bf79abfa05a306d2$export$4d3fb11e950abb9e() === 45) z += $bf79abfa05a306d2$export$410ac95b9ec204b8($bf79abfa05a306d2$export$48cfd1e771a65c4f());
                    v = $bf79abfa05a306d2$export$4d3fb11e950abb9e(), o = l = $bf79abfa05a306d2$export$36776f635604f274(k = z += $bf79abfa05a306d2$export$c2ab62c7bf24634($bf79abfa05a306d2$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $bf79abfa05a306d2$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $bf79abfa05a306d2$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $bf79abfa05a306d2$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $bf79abfa05a306d2$export$2f35ab04d2335697(e, p + 1, p = $bf79abfa05a306d2$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $bf79abfa05a306d2$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $bf79abfa05a306d2$export$35059013cd4a06db(e, r, a, s === 0 ? $bf79abfa05a306d2$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $bf79abfa05a306d2$export$4a34f930e789283c(e, r, a, c) {
    return $bf79abfa05a306d2$export$35059013cd4a06db(e, r, a, $bf79abfa05a306d2$export$a29989082612d0d9, $bf79abfa05a306d2$export$6788812c4e6611e6($bf79abfa05a306d2$export$eba6f6f03b0a92e7()), $bf79abfa05a306d2$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $bf79abfa05a306d2$export$f8483753829ec8f3(e, r, a, n, c) {
    return $bf79abfa05a306d2$export$35059013cd4a06db(e, r, a, $bf79abfa05a306d2$export$527d108ccf083c2b, $bf79abfa05a306d2$export$2f35ab04d2335697(e, 0, n), $bf79abfa05a306d2$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $bf79abfa05a306d2$export$82e9f45cca5ba907(n, c, s) {
    switch($bf79abfa05a306d2$export$d6af199866bfb566(n, c)){
        case 5103:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $bf79abfa05a306d2$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$2c0f367103c8d01c + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($bf79abfa05a306d2$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "box-$1$2" + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "flex-item-" + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$bf79abfa05a306d2$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "grid-row-" + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "flex-line-pack" + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "box-" + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "-grow", "") + $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $bf79abfa05a306d2$export$39dfd62a25e0fe93 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed($bf79abfa05a306d2$export$77ad94ebf1c2b9ed($bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed($bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "box-pack:$3" + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $bf79abfa05a306d2$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$bf79abfa05a306d2$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "grid-column-align" + $bf79abfa05a306d2$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $bf79abfa05a306d2$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$bf79abfa05a306d2$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$bf79abfa05a306d2$export$f8e21b1e77979a08(s, "span", 0) ? $bf79abfa05a306d2$export$4659b591c19bdf3d(s, /\d+/) : +$bf79abfa05a306d2$export$4659b591c19bdf3d(s, /\d+/) - +$bf79abfa05a306d2$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $bf79abfa05a306d2$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $bf79abfa05a306d2$export$71ad59f2e432cfe8 + $bf79abfa05a306d2$export$77ad94ebf1c2b9ed($bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($bf79abfa05a306d2$export$36776f635604f274(n) - 1 - c > 6) switch($bf79abfa05a306d2$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($bf79abfa05a306d2$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $bf79abfa05a306d2$export$2c0f367103c8d01c + ($bf79abfa05a306d2$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$bf79abfa05a306d2$export$f8e21b1e77979a08(n, "stretch", 0) ? $bf79abfa05a306d2$export$82e9f45cca5ba907($bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $bf79abfa05a306d2$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $bf79abfa05a306d2$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($bf79abfa05a306d2$export$a9db5e087081082d(n, c + 6) === 121) return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, ":", ":" + $bf79abfa05a306d2$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($bf79abfa05a306d2$export$a9db5e087081082d(n, $bf79abfa05a306d2$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $bf79abfa05a306d2$export$39dfd62a25e0fe93 + ($bf79abfa05a306d2$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, ":", ":" + $bf79abfa05a306d2$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $bf79abfa05a306d2$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $bf79abfa05a306d2$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $bf79abfa05a306d2$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $bf79abfa05a306d2$export$a763edbf796b780a:
        case $bf79abfa05a306d2$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $bf79abfa05a306d2$export$a29989082612d0d9:
            return "";
        case $bf79abfa05a306d2$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $bf79abfa05a306d2$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $bf79abfa05a306d2$export$aa3a2e812ca8570d:
            if (!$bf79abfa05a306d2$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $bf79abfa05a306d2$export$36776f635604f274(a = $bf79abfa05a306d2$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $bf79abfa05a306d2$export$5a7767152ae0305f(e) {
    var r = $bf79abfa05a306d2$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $bf79abfa05a306d2$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $bf79abfa05a306d2$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $bf79abfa05a306d2$export$527d108ccf083c2b:
                n.return = $bf79abfa05a306d2$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $bf79abfa05a306d2$export$b44a8529a35fcb60:
                return $bf79abfa05a306d2$export$dfdc1655ccc5b9cb([
                    $bf79abfa05a306d2$export$784d13d8ee351f07(n, {
                        value: $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $bf79abfa05a306d2$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $bf79abfa05a306d2$export$aa3a2e812ca8570d:
                if (n.length) return $bf79abfa05a306d2$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($bf79abfa05a306d2$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $bf79abfa05a306d2$export$590e8b2c435046d9($bf79abfa05a306d2$export$784d13d8ee351f07(n, {
                                props: [
                                    $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $bf79abfa05a306d2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $bf79abfa05a306d2$export$590e8b2c435046d9($bf79abfa05a306d2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $bf79abfa05a306d2$export$e6e34fd1f2686227(n, {
                                props: $bf79abfa05a306d2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $bf79abfa05a306d2$export$590e8b2c435046d9($bf79abfa05a306d2$export$784d13d8ee351f07(n, {
                                props: [
                                    $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $bf79abfa05a306d2$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $bf79abfa05a306d2$export$590e8b2c435046d9($bf79abfa05a306d2$export$784d13d8ee351f07(n, {
                                props: [
                                    $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $bf79abfa05a306d2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $bf79abfa05a306d2$export$590e8b2c435046d9($bf79abfa05a306d2$export$784d13d8ee351f07(n, {
                                props: [
                                    $bf79abfa05a306d2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $bf79abfa05a306d2$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $bf79abfa05a306d2$export$590e8b2c435046d9($bf79abfa05a306d2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $bf79abfa05a306d2$export$e6e34fd1f2686227(n, {
                                props: $bf79abfa05a306d2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $bf79abfa05a306d2$export$76a88f7de6507443(e) {
    switch(e.type){
        case $bf79abfa05a306d2$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $bf79abfa05a306d2$export$1be1fc439b849fdf($bf79abfa05a306d2$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($bf79abfa05a306d2$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $bf79abfa05a306d2$export$2f35ab04d2335697(r, 1, $bf79abfa05a306d2$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $bf79abfa05a306d2$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $bf79abfa05a306d2$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $bf79abfa05a306d2$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $b6970b15c3bb7f60$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $145b618d21a7645e$var$f = "data-styled", $145b618d21a7645e$var$m = "active", $145b618d21a7645e$var$y = "data-styled-version", $145b618d21a7645e$export$83d89fbfd8236492 = "6.1.18", $145b618d21a7645e$var$g = "/*!sc*/\n", $145b618d21a7645e$var$S = "undefined" != typeof window && "undefined" != typeof document, $145b618d21a7645e$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $145b618d21a7645e$var$b = {}, $145b618d21a7645e$var$E = /invalid hook call/i, $145b618d21a7645e$var$N = new Set, $145b618d21a7645e$var$P = function(t, n) {
    var o, s, i, a, e;
}, $145b618d21a7645e$var$_ = Object.freeze([]), $145b618d21a7645e$var$C = Object.freeze({});
function $145b618d21a7645e$var$I(e, t, n) {
    return void 0 === n && (n = $145b618d21a7645e$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $145b618d21a7645e$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $145b618d21a7645e$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $145b618d21a7645e$var$D = /(^-|-$)/g;
function $145b618d21a7645e$var$R(e) {
    return e.replace($145b618d21a7645e$var$O, "-").replace($145b618d21a7645e$var$D, "");
}
var $145b618d21a7645e$var$T = /(a)(d)/gi, $145b618d21a7645e$var$k = 52, $145b618d21a7645e$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $145b618d21a7645e$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $145b618d21a7645e$var$k; t = t / $145b618d21a7645e$var$k | 0)n = $145b618d21a7645e$var$j(t % $145b618d21a7645e$var$k) + n;
    return ($145b618d21a7645e$var$j(t % $145b618d21a7645e$var$k) + n).replace($145b618d21a7645e$var$T, "$1-$2");
}
var $145b618d21a7645e$var$V, $145b618d21a7645e$var$F = 5381, $145b618d21a7645e$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $145b618d21a7645e$var$z = function(e) {
    return $145b618d21a7645e$var$M($145b618d21a7645e$var$F, e);
};
function $145b618d21a7645e$var$$(e) {
    return $145b618d21a7645e$var$x($145b618d21a7645e$var$z(e) >>> 0);
}
function $145b618d21a7645e$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $145b618d21a7645e$var$L(e) {
    return "string" == typeof e && true;
}
var $145b618d21a7645e$var$G = "function" == typeof Symbol && Symbol.for, $145b618d21a7645e$var$Y = $145b618d21a7645e$var$G ? Symbol.for("react.memo") : 60115, $145b618d21a7645e$var$W = $145b618d21a7645e$var$G ? Symbol.for("react.forward_ref") : 60112, $145b618d21a7645e$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $145b618d21a7645e$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $145b618d21a7645e$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $145b618d21a7645e$var$J = (($145b618d21a7645e$var$V = {})[$145b618d21a7645e$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $145b618d21a7645e$var$V[$145b618d21a7645e$var$Y] = $145b618d21a7645e$var$U, $145b618d21a7645e$var$V);
function $145b618d21a7645e$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $145b618d21a7645e$var$Y ? $145b618d21a7645e$var$U : "$$typeof" in e ? $145b618d21a7645e$var$J[e.$$typeof] : $145b618d21a7645e$var$q;
}
var $145b618d21a7645e$var$Z = Object.defineProperty, $145b618d21a7645e$var$K = Object.getOwnPropertyNames, $145b618d21a7645e$var$Q = Object.getOwnPropertySymbols, $145b618d21a7645e$var$ee = Object.getOwnPropertyDescriptor, $145b618d21a7645e$var$te = Object.getPrototypeOf, $145b618d21a7645e$var$ne = Object.prototype;
function $145b618d21a7645e$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($145b618d21a7645e$var$ne) {
            var o = $145b618d21a7645e$var$te(t);
            o && o !== $145b618d21a7645e$var$ne && $145b618d21a7645e$var$oe(e, o, n);
        }
        var r = $145b618d21a7645e$var$K(t);
        $145b618d21a7645e$var$Q && (r = r.concat($145b618d21a7645e$var$Q(t)));
        for(var s = $145b618d21a7645e$var$X(e), i = $145b618d21a7645e$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $145b618d21a7645e$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $145b618d21a7645e$var$ee(t, c);
                try {
                    $145b618d21a7645e$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $145b618d21a7645e$var$re(e) {
    return "function" == typeof e;
}
function $145b618d21a7645e$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $145b618d21a7645e$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $145b618d21a7645e$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $145b618d21a7645e$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $145b618d21a7645e$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$145b618d21a7645e$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $145b618d21a7645e$var$le(e[o], t[o]);
    else if ($145b618d21a7645e$var$ce(t)) for(var o in t)e[o] = $145b618d21a7645e$var$le(e[o], t[o]);
    return e;
}
function $145b618d21a7645e$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $145b618d21a7645e$var$pe = {};
function $145b618d21a7645e$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $145b618d21a7645e$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $145b618d21a7645e$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $145b618d21a7645e$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($145b618d21a7645e$var$g);
        return t;
    }, e;
}(), $145b618d21a7645e$var$me = 1073741824, $145b618d21a7645e$var$ye = new Map, $145b618d21a7645e$var$ve = new Map, $145b618d21a7645e$var$ge = 1, $145b618d21a7645e$var$Se = function(e) {
    if ($145b618d21a7645e$var$ye.has(e)) return $145b618d21a7645e$var$ye.get(e);
    for(; $145b618d21a7645e$var$ve.has($145b618d21a7645e$var$ge);)$145b618d21a7645e$var$ge++;
    var t = $145b618d21a7645e$var$ge++;
    return $145b618d21a7645e$var$ye.set(e, t), $145b618d21a7645e$var$ve.set(t, e), t;
}, $145b618d21a7645e$var$we = function(e, t) {
    $145b618d21a7645e$var$ge = t + 1, $145b618d21a7645e$var$ye.set(e, t), $145b618d21a7645e$var$ve.set(t, e);
}, $145b618d21a7645e$var$be = "style[".concat($145b618d21a7645e$var$f, "][").concat($145b618d21a7645e$var$y, '="').concat($145b618d21a7645e$export$83d89fbfd8236492, '"]'), $145b618d21a7645e$var$Ee = new RegExp("^".concat($145b618d21a7645e$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $145b618d21a7645e$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $145b618d21a7645e$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($145b618d21a7645e$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($145b618d21a7645e$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($145b618d21a7645e$var$we(u, l), $145b618d21a7645e$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $145b618d21a7645e$var$_e = function(e) {
    for(var t = document.querySelectorAll($145b618d21a7645e$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($145b618d21a7645e$var$f) !== $145b618d21a7645e$var$m && ($145b618d21a7645e$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $145b618d21a7645e$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $145b618d21a7645e$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($145b618d21a7645e$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($145b618d21a7645e$var$f, $145b618d21a7645e$var$m), o.setAttribute($145b618d21a7645e$var$y, $145b618d21a7645e$export$83d89fbfd8236492);
    var i = $145b618d21a7645e$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $145b618d21a7645e$var$Ae = function() {
    function e(e) {
        this.element = $145b618d21a7645e$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $145b618d21a7645e$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $145b618d21a7645e$var$Oe = function() {
    function e(e) {
        this.element = $145b618d21a7645e$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $145b618d21a7645e$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $145b618d21a7645e$var$Re = $145b618d21a7645e$var$S, $145b618d21a7645e$var$Te = {
    isServer: !$145b618d21a7645e$var$S,
    useCSSOMInjection: !$145b618d21a7645e$var$w
}, $145b618d21a7645e$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $145b618d21a7645e$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, $145b618d21a7645e$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $145b618d21a7645e$var$S && $145b618d21a7645e$var$Re && ($145b618d21a7645e$var$Re = !1, $145b618d21a7645e$var$_e(this)), $145b618d21a7645e$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $145b618d21a7645e$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($145b618d21a7645e$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($145b618d21a7645e$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $145b618d21a7645e$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $145b618d21a7645e$var$S && $145b618d21a7645e$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $145b618d21a7645e$var$De(n) : t ? new $145b618d21a7645e$var$Ae(n) : new $145b618d21a7645e$var$Oe(n);
        }(this.options), new $145b618d21a7645e$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($145b618d21a7645e$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($145b618d21a7645e$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($145b618d21a7645e$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $145b618d21a7645e$var$je = /&/g, $145b618d21a7645e$var$xe = /^\s*\/\/.*$/gm;
function $145b618d21a7645e$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $145b618d21a7645e$var$Ve(e.children, t)), e;
    });
}
function $145b618d21a7645e$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $145b618d21a7645e$var$C : e, s = r.options, i = void 0 === s ? $145b618d21a7645e$var$C : s, a = r.plugins, c = void 0 === a ? $145b618d21a7645e$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $bf79abfa05a306d2$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($145b618d21a7645e$var$je, n).replace(o, l));
    }), i.prefix && u.push($bf79abfa05a306d2$export$e08c7d021b829b7a), u.push($bf79abfa05a306d2$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($145b618d21a7645e$var$xe, ""), l = $bf79abfa05a306d2$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $145b618d21a7645e$var$Ve(l, i.namespace));
        var p = [];
        return $bf79abfa05a306d2$export$dfdc1655ccc5b9cb(l, $bf79abfa05a306d2$export$5a7767152ae0305f(u.concat($bf79abfa05a306d2$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $145b618d21a7645e$var$he(15), $145b618d21a7645e$var$M(e, t.name);
    }, $145b618d21a7645e$var$F).toString() : "", p;
}
var $145b618d21a7645e$var$Me = new $145b618d21a7645e$var$ke, $145b618d21a7645e$var$ze = $145b618d21a7645e$var$Fe(), $145b618d21a7645e$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $145b618d21a7645e$var$Me,
    stylis: $145b618d21a7645e$var$ze
}), $145b618d21a7645e$export$91317688fc694efa = $145b618d21a7645e$export$8c190ef828af4c86.Consumer, $145b618d21a7645e$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createContext(void 0);
function $145b618d21a7645e$var$Ge() {
    return (0, $igtsr.useContext)($145b618d21a7645e$export$8c190ef828af4c86);
}
function $145b618d21a7645e$export$a473771da2f0ff7c(e) {
    var t = (0, $igtsr.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $145b618d21a7645e$var$Ge().styleSheet, l = (0, $igtsr.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $igtsr.useMemo)(function() {
        return $145b618d21a7645e$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $igtsr.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($5c43fcf22af86af1$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $igtsr.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($145b618d21a7645e$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($145b618d21a7645e$var$Le.Provider, {
        value: u
    }, e.children));
}
var $145b618d21a7645e$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $145b618d21a7645e$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $145b618d21a7645e$var$ue(this, function() {
            throw $145b618d21a7645e$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $145b618d21a7645e$var$ze), this.name + e.hash;
    }, e;
}(), $145b618d21a7645e$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $145b618d21a7645e$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $145b618d21a7645e$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $145b618d21a7645e$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $145b618d21a7645e$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$145b618d21a7645e$var$Ue(i) && (Array.isArray(i) && i.isCss || $145b618d21a7645e$var$re(i) ? r.push("".concat($145b618d21a7645e$var$He(s), ":"), i, ";") : $145b618d21a7645e$var$ce(i) ? r.push.apply(r, (0, $51839a74322b0d52$export$1216008129fb82ed)((0, $51839a74322b0d52$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $145b618d21a7645e$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($145b618d21a7645e$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $b6970b15c3bb7f60$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $145b618d21a7645e$var$Xe(e, t, n, o) {
    if ($145b618d21a7645e$var$Ue(e)) return [];
    if ($145b618d21a7645e$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($145b618d21a7645e$var$re(e)) {
        if (!$145b618d21a7645e$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $145b618d21a7645e$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $145b618d21a7645e$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $145b618d21a7645e$var$ce(e) ? $145b618d21a7645e$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($145b618d21a7645e$var$_, e.map(function(e) {
        return $145b618d21a7645e$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $145b618d21a7645e$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($145b618d21a7645e$var$re(n) && !$145b618d21a7645e$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $145b618d21a7645e$var$Ke = $145b618d21a7645e$var$z($145b618d21a7645e$export$83d89fbfd8236492), $145b618d21a7645e$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $145b618d21a7645e$var$Ze(e), this.componentId = t, this.baseHash = $145b618d21a7645e$var$M($145b618d21a7645e$var$Ke, t), this.baseStyle = n, $145b618d21a7645e$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $145b618d21a7645e$var$ie(o, this.staticRulesId);
            else {
                var r = $145b618d21a7645e$var$ae($145b618d21a7645e$var$Xe(this.rules, e, t, n)), s = $145b618d21a7645e$var$x($145b618d21a7645e$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $145b618d21a7645e$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $145b618d21a7645e$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $145b618d21a7645e$var$ae($145b618d21a7645e$var$Xe(u, e, t, n));
                    a = $145b618d21a7645e$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $145b618d21a7645e$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $145b618d21a7645e$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $145b618d21a7645e$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createContext(void 0), $145b618d21a7645e$export$b631efc24e9d5e2f = $145b618d21a7645e$export$2c657da244d00bd6.Consumer;
function $145b618d21a7645e$export$93d4e7f90805808f() {
    var e = (0, $igtsr.useContext)($145b618d21a7645e$export$2c657da244d00bd6);
    if (!e) throw $145b618d21a7645e$var$he(18);
    return e;
}
function $145b618d21a7645e$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).useContext($145b618d21a7645e$export$2c657da244d00bd6), r = (0, $igtsr.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $145b618d21a7645e$var$he(14);
            if ($145b618d21a7645e$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $145b618d21a7645e$var$he(8);
            return n ? (0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($145b618d21a7645e$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $145b618d21a7645e$var$rt = {}, $145b618d21a7645e$var$st = new Set;
function $145b618d21a7645e$var$it(e, r, s) {
    var i = $145b618d21a7645e$export$7ba318d8d2f06c76(e), a = e, c = !$145b618d21a7645e$var$L(e), p = r.attrs, d = void 0 === p ? $145b618d21a7645e$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $145b618d21a7645e$var$R(e);
        $145b618d21a7645e$var$rt[n] = ($145b618d21a7645e$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($145b618d21a7645e$var$$($145b618d21a7645e$export$83d89fbfd8236492 + n + $145b618d21a7645e$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $145b618d21a7645e$var$L(e) ? "styled.".concat(e) : "Styled(".concat($145b618d21a7645e$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($145b618d21a7645e$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $145b618d21a7645e$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).useContext($145b618d21a7645e$export$2c657da244d00bd6), m = $145b618d21a7645e$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $145b618d21a7645e$var$I(r, f, c) || $145b618d21a7645e$var$C, g = function(e, n, o) {
                for(var r, s = (0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $145b618d21a7645e$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $145b618d21a7645e$var$ie(s[c], a[c]) : "style" === c ? (0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $145b618d21a7645e$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $145b618d21a7645e$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $145b618d21a7645e$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$145b618d21a7645e$var$L(S) && !$145b618d21a7645e$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $igtsr.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $145b618d21a7645e$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$145b618d21a7645e$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $145b618d21a7645e$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $145b618d21a7645e$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $145b618d21a7645e$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $145b618d21a7645e$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $145b618d21a7645e$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($145b618d21a7645e$var$re(t) || $145b618d21a7645e$var$ce(t)) return $145b618d21a7645e$var$ct($145b618d21a7645e$var$Xe($145b618d21a7645e$var$at($145b618d21a7645e$var$_, (0, $51839a74322b0d52$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $145b618d21a7645e$var$Xe(r) : $145b618d21a7645e$var$ct($145b618d21a7645e$var$Xe($145b618d21a7645e$var$at(r, n)));
}
function $145b618d21a7645e$var$ut(n, o, r) {
    if (void 0 === r && (r = $145b618d21a7645e$var$C), !o) throw $145b618d21a7645e$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $145b618d21a7645e$export$dbf350e5966cf602.apply(void 0, (0, $51839a74322b0d52$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $145b618d21a7645e$var$ut(n, o, (0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $145b618d21a7645e$var$ut(n, o, (0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $145b618d21a7645e$var$pt = function(e) {
    return $145b618d21a7645e$var$ut($145b618d21a7645e$var$it, e);
}, $145b618d21a7645e$export$2e2bcd8739ae039 = $145b618d21a7645e$var$pt;
$145b618d21a7645e$var$A.forEach(function(e) {
    $145b618d21a7645e$export$2e2bcd8739ae039[e] = $145b618d21a7645e$var$pt(e);
});
var $145b618d21a7645e$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $145b618d21a7645e$var$Ze(e), $145b618d21a7645e$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($145b618d21a7645e$var$ae($145b618d21a7645e$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $145b618d21a7645e$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $145b618d21a7645e$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $145b618d21a7645e$export$dbf350e5966cf602.apply(void 0, (0, $51839a74322b0d52$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($145b618d21a7645e$var$$(JSON.stringify(i))), c = new $145b618d21a7645e$var$ht(i, a);
    var l = function(e) {
        var t = $145b618d21a7645e$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).useContext($145b618d21a7645e$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $145b618d21a7645e$var$b, o, s);
        else {
            var i = (0, $51839a74322b0d52$export$18ce0697a983be9b)((0, $51839a74322b0d52$export$18ce0697a983be9b)({}, n), {
                theme: $145b618d21a7645e$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).memo(l);
}
function $145b618d21a7645e$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $145b618d21a7645e$var$ae($145b618d21a7645e$export$dbf350e5966cf602.apply(void 0, (0, $51839a74322b0d52$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $145b618d21a7645e$var$$(r);
    return new $145b618d21a7645e$var$We(s, r);
}
function $145b618d21a7645e$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).forwardRef(function(n, r) {
        var s = $145b618d21a7645e$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).useContext($145b618d21a7645e$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement(e, (0, $51839a74322b0d52$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($145b618d21a7645e$var$B(e), ")"), $145b618d21a7645e$var$oe(n, e);
}
var $145b618d21a7645e$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $145b618d21a7645e$var$Ce(), o = $145b618d21a7645e$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($145b618d21a7645e$var$f, '="true"'),
                "".concat($145b618d21a7645e$var$y, '="').concat($145b618d21a7645e$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $145b618d21a7645e$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $145b618d21a7645e$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$145b618d21a7645e$var$f] = "", n[$145b618d21a7645e$var$y] = $145b618d21a7645e$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $145b618d21a7645e$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("style", (0, $51839a74322b0d52$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $145b618d21a7645e$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $145b618d21a7645e$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($145b618d21a7645e$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $145b618d21a7645e$var$he(3);
    }, e;
}(), $145b618d21a7645e$export$5c87cfe6c475f500 = {
    StyleSheet: $145b618d21a7645e$var$ke,
    mainSheet: $145b618d21a7645e$var$Me
};
var $145b618d21a7645e$var$St = "__sc-".concat($145b618d21a7645e$var$f, "__");


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $145b618d21a7645e$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $69daf4809d4ad4d2$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $69daf4809d4ad4d2$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $69daf4809d4ad4d2$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $69daf4809d4ad4d2$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $69daf4809d4ad4d2$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $69daf4809d4ad4d2$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $69daf4809d4ad4d2$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$time = 1.6;
const $69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$anim = (0, $145b618d21a7645e$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$Path = (0, $145b618d21a7645e$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$anim} ${$69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $69daf4809d4ad4d2$export$8009d4483dfda42 = ({ color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $69daf4809d4ad4d2$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $69daf4809d4ad4d2$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: $69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$getPath($69daf4809d4ad4d2$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $69daf4809d4ad4d2$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $69daf4809d4ad4d2$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $69daf4809d4ad4d2$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $69daf4809d4ad4d2$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            version: "1.1",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $69daf4809d4ad4d2$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $69daf4809d4ad4d2$var$$5819da83a926266a$var$spin = (0, $145b618d21a7645e$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $69daf4809d4ad4d2$var$$5819da83a926266a$var$Svg = (0, $145b618d21a7645e$export$2e2bcd8739ae039).svg`
  animation: ${$69daf4809d4ad4d2$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $69daf4809d4ad4d2$var$$5819da83a926266a$var$Polyline = (0, $145b618d21a7645e$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $69daf4809d4ad4d2$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $igtsr.useCallback)(()=>$69daf4809d4ad4d2$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$5819da83a926266a$var$Svg, {
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $69daf4809d4ad4d2$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("defs", {
                    children: (0, $ecbd83510a1ff561$exports.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $69daf4809d4ad4d2$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $69daf4809d4ad4d2$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$dash = (0, $145b618d21a7645e$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$Polygon = (0, $145b618d21a7645e$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$SVG = (0, $145b618d21a7645e$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $69daf4809d4ad4d2$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $69daf4809d4ad4d2$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $69daf4809d4ad4d2$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ecbd83510a1ff561$exports.jsx)($69daf4809d4ad4d2$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $69daf4809d4ad4d2$export$1ed1943372cc63a9 = ({ color: color = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $69daf4809d4ad4d2$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $69daf4809d4ad4d2$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $ecbd83510a1ff561$exports.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ecbd83510a1ff561$exports.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $69daf4809d4ad4d2$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)("defs", {
                children: (0, $ecbd83510a1ff561$exports.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $ecbd83510a1ff561$exports.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $69daf4809d4ad4d2$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $ecbd83510a1ff561$exports.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $69daf4809d4ad4d2$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)("defs", {
                children: (0, $ecbd83510a1ff561$exports.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $69daf4809d4ad4d2$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)("title", {
                children: "Blocks"
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $69daf4809d4ad4d2$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$69daf4809d4ad4d2$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ecbd83510a1ff561$exports.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                children: [
                    (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        children: [
                            (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $ecbd83510a1ff561$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


class $af6cf6d393cc9a5e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    static #_ = this.defaultProps = {
        color: "var(--color-primary)",
        height: 80,
        width: 80
    };
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "section-loader-wrapper",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $69daf4809d4ad4d2$export$4bf83b24a11cff0b), {
                color: this.props.color,
                height: this.props.height,
                width: this.props.width
            })
        });
    }
}





var $gagb8 = parcelRequire("gagb8");

var $igtsr = parcelRequire("igtsr");

var $igtsr = parcelRequire("igtsr");

var $igtsr = parcelRequire("igtsr");
var $005f8522293c9f4e$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $005f8522293c9f4e$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $3962ff0e89a226ec$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $3962ff0e89a226ec$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($005f8522293c9f4e$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3962ff0e89a226ec$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3962ff0e89a226ec$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3962ff0e89a226ec$var$i = /^\s*$/, $3962ff0e89a226ec$var$s = Object.create(null);
function $3962ff0e89a226ec$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($3962ff0e89a226ec$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $3962ff0e89a226ec$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $3962ff0e89a226ec$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($3962ff0e89a226ec$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $3962ff0e89a226ec$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $3962ff0e89a226ec$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $3962ff0e89a226ec$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $3962ff0e89a226ec$var$a("", t);
        }, "");
    }
};
var $3962ff0e89a226ec$export$2e2bcd8739ae039 = $3962ff0e89a226ec$var$c;


const $25b7ae208b559237$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($25b7ae208b559237$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $25b7ae208b559237$var$alreadyWarned = {};
const $25b7ae208b559237$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($25b7ae208b559237$export$844ec244b1367d54(msg) && $25b7ae208b559237$var$alreadyWarned[msg]) return;
    if ($25b7ae208b559237$export$844ec244b1367d54(msg)) $25b7ae208b559237$var$alreadyWarned[msg] = new Date();
    $25b7ae208b559237$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $25b7ae208b559237$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $25b7ae208b559237$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $25b7ae208b559237$var$loadedClb(i18n, cb));
};
const $25b7ae208b559237$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($25b7ae208b559237$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $25b7ae208b559237$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $25b7ae208b559237$var$loadedClb(i18n, cb));
};
const $25b7ae208b559237$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $25b7ae208b559237$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n?.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $25b7ae208b559237$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($25b7ae208b559237$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $25b7ae208b559237$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $25b7ae208b559237$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $c9aef2dea99f579b$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $c9aef2dea99f579b$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $c9aef2dea99f579b$var$unescapeHtmlEntity = (m)=>$c9aef2dea99f579b$var$htmlEntities[m];
const $c9aef2dea99f579b$export$e8bacd2802a88316 = (text)=>text.replace($c9aef2dea99f579b$var$matchHtmlEntity, $c9aef2dea99f579b$var$unescapeHtmlEntity);


let $80b411ff8c33ea01$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $c9aef2dea99f579b$export$e8bacd2802a88316
};
const $80b411ff8c33ea01$export$2e2366488d12e20d = (options = {})=>{
    $80b411ff8c33ea01$var$defaultOptions = {
        ...$80b411ff8c33ea01$var$defaultOptions,
        ...options
    };
};
const $80b411ff8c33ea01$export$212bb2fc580a90a8 = ()=>$80b411ff8c33ea01$var$defaultOptions;


let $51b888bc29fbb941$var$i18nInstance;
const $51b888bc29fbb941$export$a039134f2fc7e0 = (instance)=>{
    $51b888bc29fbb941$var$i18nInstance = instance;
};
const $51b888bc29fbb941$export$64af334f494c2f47 = ()=>$51b888bc29fbb941$var$i18nInstance;


const $a29a29bdd857f889$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $a29a29bdd857f889$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $a29a29bdd857f889$var$getAsArray(children) : children;
};
const $a29a29bdd857f889$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $igtsr.isValidElement));
const $a29a29bdd857f889$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $a29a29bdd857f889$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $a29a29bdd857f889$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $a29a29bdd857f889$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $25b7ae208b559237$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $igtsr.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $25b7ae208b559237$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $a29a29bdd857f889$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $25b7ae208b559237$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $25b7ae208b559237$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $25b7ae208b559237$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $25b7ae208b559237$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $a29a29bdd857f889$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $a29a29bdd857f889$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $25b7ae208b559237$export$844ec244b1367d54)(child)) return;
            if ($a29a29bdd857f889$var$hasChildren(child)) getData($a29a29bdd857f889$var$getChildren(child));
            else if ((0, $25b7ae208b559237$export$a6cdc56e425d0d0a)(child) && !(0, $igtsr.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $3962ff0e89a226ec$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $a29a29bdd857f889$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $a29a29bdd857f889$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $igtsr.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $igtsr.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $igtsr.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $a29a29bdd857f889$var$getAsArray(reactNode);
        const astNodes = $a29a29bdd857f889$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $a29a29bdd857f889$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $igtsr.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $a29a29bdd857f889$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $25b7ae208b559237$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $25b7ae208b559237$export$a6cdc56e425d0d0a)(children) && Object.hasOwnProperty.call(children, node.name);
                if ((0, $25b7ae208b559237$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($a29a29bdd857f889$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $igtsr.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $igtsr.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $25b7ae208b559237$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $igtsr.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $a29a29bdd857f889$var$getAsArray(children || []));
    return $a29a29bdd857f889$var$getChildren(result[0]);
};
const $a29a29bdd857f889$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $igtsr.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $igtsr.createElement)((0, $igtsr.Fragment), null, comp);
    }
    return (0, $igtsr.createElement)(Componentized, {
        key: componentKey
    });
};
const $a29a29bdd857f889$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$a29a29bdd857f889$var$fixComponentProps(c, index, translation));
const $a29a29bdd857f889$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $a29a29bdd857f889$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $a29a29bdd857f889$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $a29a29bdd857f889$var$generateArrayComponents(components, translation);
    if ((0, $25b7ae208b559237$export$a6cdc56e425d0d0a)(components)) return $a29a29bdd857f889$var$generateObjectComponents(components, translation);
    (0, $25b7ae208b559237$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
function $a29a29bdd857f889$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $51b888bc29fbb941$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $25b7ae208b559237$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $80b411ff8c33ea01$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $25b7ae208b559237$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $a29a29bdd857f889$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const generatedComponents = $a29a29bdd857f889$var$generateComponents(components, translation, i18n, i18nKey);
    const content = $a29a29bdd857f889$var$renderNodes(generatedComponents || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $igtsr.createElement)(useAsParent, additionalProps, content) : content;
}



var $igtsr = parcelRequire("igtsr");




const $ed6f062c2e258fb8$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $80b411ff8c33ea01$export$2e2366488d12e20d)(instance.options.react);
        (0, $51b888bc29fbb941$export$a039134f2fc7e0)(instance);
    }
};


const $749c3c4b39937026$export$5603ab5ced17ce64 = (0, $igtsr.createContext)();
class $749c3c4b39937026$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $749c3c4b39937026$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $749c3c4b39937026$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $749c3c4b39937026$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $51b888bc29fbb941$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $1308137f27bb0d02$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $igtsr.useContext)((0, $749c3c4b39937026$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $51b888bc29fbb941$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $a29a29bdd857f889$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $igtsr = parcelRequire("igtsr");


const $663573894e0fb3f8$var$usePrevious = (value, ignore)=>{
    const ref = (0, $igtsr.useRef)();
    (0, $igtsr.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $663573894e0fb3f8$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $663573894e0fb3f8$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $igtsr.useCallback)($663573894e0fb3f8$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $663573894e0fb3f8$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $igtsr.useContext)((0, $749c3c4b39937026$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $51b888bc29fbb941$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $749c3c4b39937026$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $25b7ae208b559237$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $25b7ae208b559237$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $25b7ae208b559237$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $25b7ae208b559237$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, $25b7ae208b559237$export$5b28268982f175ba)(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $80b411ff8c33ea01$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, $25b7ae208b559237$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $25b7ae208b559237$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $663573894e0fb3f8$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$663573894e0fb3f8$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $igtsr.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $663573894e0fb3f8$var$usePrevious(joinedNS);
    const isMounted = (0, $igtsr.useRef)(true);
    (0, $igtsr.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $25b7ae208b559237$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $25b7ae208b559237$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n) bindI18n?.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $igtsr.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $25b7ae208b559237$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $25b7ae208b559237$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $igtsr = parcelRequire("igtsr");


const $66f4ab6003d1e60a$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $663573894e0fb3f8$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $igtsr.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $25b7ae208b559237$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $igtsr.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $igtsr.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $ce1d4a004a816ff1$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $663573894e0fb3f8$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $igtsr = parcelRequire("igtsr");

function $9c79715fbe356973$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $igtsr.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $igtsr.createElement)((0, $749c3c4b39937026$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $igtsr = parcelRequire("igtsr");

var $igtsr = parcelRequire("igtsr");

const $2b3990279d485da4$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $igtsr.useContext)((0, $749c3c4b39937026$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $51b888bc29fbb941$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $47ae054de1b293c6$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $2b3990279d485da4$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $igtsr.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $749c3c4b39937026$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $25b7ae208b559237$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $57127b8eee7e5fec$export$324d90190a8b822a = ()=>'';
const $57127b8eee7e5fec$export$2da9be4cfdb689b1 = ()=>'';
const $57127b8eee7e5fec$export$98e628dec113755e = ()=>'';
const $57127b8eee7e5fec$export$2e6c959c16ff56b8 = ()=>'';
const $57127b8eee7e5fec$export$4e35d5c922a95490 = ()=>'';
const $57127b8eee7e5fec$export$720a3b9db04b7a0f = ()=>'';


function $592359d45a506fad$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $592359d45a506fad$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $592359d45a506fad$export$2e2bcd8739ae039(o);
}



function $0fe0c4d4ef30136d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $592359d45a506fad$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $592359d45a506fad$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $c42178c98ee08482$export$2e2bcd8739ae039(t) {
    var i = (0, $0fe0c4d4ef30136d$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $592359d45a506fad$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $3c5cabeff69d85d2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $c42178c98ee08482$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $566a7e41981971b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $566a7e41981971b5$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $566a7e41981971b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3c5cabeff69d85d2$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $566a7e41981971b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $464477b7d465c238$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $974ad9fd6a347a76$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $377b1a68df1c4a72$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $fa20ee29a2c3aff0$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $377b1a68df1c4a72$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $377b1a68df1c4a72$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $15430c676937cfb3$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $08ee0d51fbf762ec$export$2e2bcd8739ae039(r, e) {
    return (0, $464477b7d465c238$export$2e2bcd8739ae039)(r) || (0, $974ad9fd6a347a76$export$2e2bcd8739ae039)(r, e) || (0, $fa20ee29a2c3aff0$export$2e2bcd8739ae039)(r, e) || (0, $15430c676937cfb3$export$2e2bcd8739ae039)();
}



function $f9358951273870d3$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $igtsr = parcelRequire("igtsr");
var $afa1945330c5db5a$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $afa1945330c5db5a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_ref, $afa1945330c5db5a$var$_excluded);
    var _useState = (0, $igtsr.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $igtsr.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $igtsr.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $igtsr.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $igtsr.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $igtsr.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $igtsr.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $igtsr = parcelRequire("igtsr");


function $e5a950aa97be4049$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $f898a3d1adefff2e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $c42178c98ee08482$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $f898a3d1adefff2e$export$2e2bcd8739ae039(e, r, t) {
    return r && $f898a3d1adefff2e$var$_defineProperties(e.prototype, r), t && $f898a3d1adefff2e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $7a03a4b83e867c11$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $b28bc5c4fde5f427$export$2e2bcd8739ae039)(t, e);
}


function $afddd473afcf022b$export$2e2bcd8739ae039(t) {
    return $afddd473afcf022b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $afddd473afcf022b$export$2e2bcd8739ae039(t);
}


function $841dacecf184ef7f$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($841dacecf184ef7f$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $2179a99969e1c4c8$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $961eea9218ecb9b3$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $592359d45a506fad$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $2179a99969e1c4c8$export$2e2bcd8739ae039)(t);
}


function $a5e435e5efd39e4e$export$2e2bcd8739ae039(t) {
    var r = (0, $841dacecf184ef7f$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $afddd473afcf022b$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $afddd473afcf022b$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $961eea9218ecb9b3$export$2e2bcd8739ae039)(this, e);
    };
}



function $bbee010eaabef28f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $377b1a68df1c4a72$export$2e2bcd8739ae039)(r);
}


function $7a5df2121c7aa163$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $143ec75cfa5f9bba$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $14ee2d317130855d$export$2e2bcd8739ae039(r) {
    return (0, $bbee010eaabef28f$export$2e2bcd8739ae039)(r) || (0, $7a5df2121c7aa163$export$2e2bcd8739ae039)(r) || (0, $fa20ee29a2c3aff0$export$2e2bcd8739ae039)(r) || (0, $143ec75cfa5f9bba$export$2e2bcd8739ae039)();
}



var $igtsr = parcelRequire("igtsr");



var $igtsr = parcelRequire("igtsr");
var $6dfc4312e67563de$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $6dfc4312e67563de$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $6dfc4312e67563de$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $6dfc4312e67563de$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$6dfc4312e67563de$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($6dfc4312e67563de$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $6dfc4312e67563de$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $cb844d64514e426c$export$71ad59f2e432cfe8 = "-ms-";
var $cb844d64514e426c$export$2c0f367103c8d01c = "-moz-";
var $cb844d64514e426c$export$39dfd62a25e0fe93 = "-webkit-";
var $cb844d64514e426c$export$a29989082612d0d9 = "comm";
var $cb844d64514e426c$export$aa3a2e812ca8570d = "rule";
var $cb844d64514e426c$export$527d108ccf083c2b = "decl";
var $cb844d64514e426c$export$d3d35020fa5b54f0 = "@page";
var $cb844d64514e426c$export$500415a86c544f73 = "@media";
var $cb844d64514e426c$export$a763edbf796b780a = "@import";
var $cb844d64514e426c$export$2790aeb8b4e5c826 = "@charset";
var $cb844d64514e426c$export$1cc683e23b84b133 = "@viewport";
var $cb844d64514e426c$export$9447a5efea57e862 = "@supports";
var $cb844d64514e426c$export$ef011b4e114b1fba = "@document";
var $cb844d64514e426c$export$6aad947bda0f3f46 = "@namespace";
var $cb844d64514e426c$export$b44a8529a35fcb60 = "@keyframes";
var $cb844d64514e426c$export$2c16de31893252e6 = "@font-face";
var $cb844d64514e426c$export$3d846dd52e150c6f = "@counter-style";
var $cb844d64514e426c$export$22314bfbb57653fe = "@font-feature-values";
var $cb844d64514e426c$export$d773506282b3cfe6 = "@layer";
var $cb844d64514e426c$export$2335f513bbd82c6d = Math.abs;
var $cb844d64514e426c$export$6788812c4e6611e6 = String.fromCharCode;
var $cb844d64514e426c$export$e6e34fd1f2686227 = Object.assign;
function $cb844d64514e426c$export$d6af199866bfb566(e, r) {
    return $cb844d64514e426c$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $cb844d64514e426c$export$a9db5e087081082d(e, 0)) << 2 ^ $cb844d64514e426c$export$a9db5e087081082d(e, 1)) << 2 ^ $cb844d64514e426c$export$a9db5e087081082d(e, 2)) << 2 ^ $cb844d64514e426c$export$a9db5e087081082d(e, 3) : 0;
}
function $cb844d64514e426c$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $cb844d64514e426c$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $cb844d64514e426c$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $cb844d64514e426c$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $cb844d64514e426c$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $cb844d64514e426c$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $cb844d64514e426c$export$36776f635604f274(e) {
    return e.length;
}
function $cb844d64514e426c$export$f9084667e487ed46(e) {
    return e.length;
}
function $cb844d64514e426c$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $cb844d64514e426c$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $cb844d64514e426c$export$53f1d5ea8de3d7c = 1;
var $cb844d64514e426c$export$4e0c71f277ca26b3 = 1;
var $cb844d64514e426c$export$f24224f1c91d8156 = 0;
var $cb844d64514e426c$export$5880b8b5730aff45 = 0;
var $cb844d64514e426c$export$c0306caf338ac095 = 0;
var $cb844d64514e426c$export$30a86d91af8ff6e6 = "";
function $cb844d64514e426c$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $cb844d64514e426c$export$53f1d5ea8de3d7c,
        column: $cb844d64514e426c$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $cb844d64514e426c$export$784d13d8ee351f07(e, r) {
    return $cb844d64514e426c$export$e6e34fd1f2686227($cb844d64514e426c$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $cb844d64514e426c$export$eba6f6f03b0a92e7() {
    return $cb844d64514e426c$export$c0306caf338ac095;
}
function $cb844d64514e426c$export$232faf9add678146() {
    $cb844d64514e426c$export$c0306caf338ac095 = $cb844d64514e426c$export$5880b8b5730aff45 > 0 ? $cb844d64514e426c$export$a9db5e087081082d($cb844d64514e426c$export$30a86d91af8ff6e6, --$cb844d64514e426c$export$5880b8b5730aff45) : 0;
    if ($cb844d64514e426c$export$4e0c71f277ca26b3--, $cb844d64514e426c$export$c0306caf338ac095 === 10) $cb844d64514e426c$export$4e0c71f277ca26b3 = 1, $cb844d64514e426c$export$53f1d5ea8de3d7c--;
    return $cb844d64514e426c$export$c0306caf338ac095;
}
function $cb844d64514e426c$export$48cfd1e771a65c4f() {
    $cb844d64514e426c$export$c0306caf338ac095 = $cb844d64514e426c$export$5880b8b5730aff45 < $cb844d64514e426c$export$f24224f1c91d8156 ? $cb844d64514e426c$export$a9db5e087081082d($cb844d64514e426c$export$30a86d91af8ff6e6, $cb844d64514e426c$export$5880b8b5730aff45++) : 0;
    if ($cb844d64514e426c$export$4e0c71f277ca26b3++, $cb844d64514e426c$export$c0306caf338ac095 === 10) $cb844d64514e426c$export$4e0c71f277ca26b3 = 1, $cb844d64514e426c$export$53f1d5ea8de3d7c++;
    return $cb844d64514e426c$export$c0306caf338ac095;
}
function $cb844d64514e426c$export$4d3fb11e950abb9e() {
    return $cb844d64514e426c$export$a9db5e087081082d($cb844d64514e426c$export$30a86d91af8ff6e6, $cb844d64514e426c$export$5880b8b5730aff45);
}
function $cb844d64514e426c$export$e88cb2efb12ae807() {
    return $cb844d64514e426c$export$5880b8b5730aff45;
}
function $cb844d64514e426c$export$58adb3bec8346d0f(e, r) {
    return $cb844d64514e426c$export$2f35ab04d2335697($cb844d64514e426c$export$30a86d91af8ff6e6, e, r);
}
function $cb844d64514e426c$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $cb844d64514e426c$export$2de70f21292aac9e(e) {
    return $cb844d64514e426c$export$53f1d5ea8de3d7c = $cb844d64514e426c$export$4e0c71f277ca26b3 = 1, $cb844d64514e426c$export$f24224f1c91d8156 = $cb844d64514e426c$export$36776f635604f274($cb844d64514e426c$export$30a86d91af8ff6e6 = e), $cb844d64514e426c$export$5880b8b5730aff45 = 0, [];
}
function $cb844d64514e426c$export$45918ac1574455b1(e) {
    return $cb844d64514e426c$export$30a86d91af8ff6e6 = "", e;
}
function $cb844d64514e426c$export$410ac95b9ec204b8(e) {
    return $cb844d64514e426c$export$87c2784dc9fc4ab($cb844d64514e426c$export$58adb3bec8346d0f($cb844d64514e426c$export$5880b8b5730aff45 - 1, $cb844d64514e426c$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $cb844d64514e426c$export$660b2ee2d4fb4eff(e) {
    return $cb844d64514e426c$export$45918ac1574455b1($cb844d64514e426c$export$5f8c09e3ae6f64e1($cb844d64514e426c$export$2de70f21292aac9e(e)));
}
function $cb844d64514e426c$export$7af1228ff777d175(e) {
    while($cb844d64514e426c$export$c0306caf338ac095 = $cb844d64514e426c$export$4d3fb11e950abb9e())if ($cb844d64514e426c$export$c0306caf338ac095 < 33) $cb844d64514e426c$export$48cfd1e771a65c4f();
    else break;
    return $cb844d64514e426c$export$9e1725a4cfeada27(e) > 2 || $cb844d64514e426c$export$9e1725a4cfeada27($cb844d64514e426c$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $cb844d64514e426c$export$5f8c09e3ae6f64e1(e) {
    while($cb844d64514e426c$export$48cfd1e771a65c4f())switch($cb844d64514e426c$export$9e1725a4cfeada27($cb844d64514e426c$export$c0306caf338ac095)){
        case 0:
            $cb844d64514e426c$export$10d8903dec122b9d($cb844d64514e426c$export$c2ab62c7bf24634($cb844d64514e426c$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $cb844d64514e426c$export$10d8903dec122b9d($cb844d64514e426c$export$410ac95b9ec204b8($cb844d64514e426c$export$c0306caf338ac095), e);
            break;
        default:
            $cb844d64514e426c$export$10d8903dec122b9d($cb844d64514e426c$export$6788812c4e6611e6($cb844d64514e426c$export$c0306caf338ac095), e);
    }
    return e;
}
function $cb844d64514e426c$export$955ba06d119e085e(e, r) {
    while(--r && $cb844d64514e426c$export$48cfd1e771a65c4f())if ($cb844d64514e426c$export$c0306caf338ac095 < 48 || $cb844d64514e426c$export$c0306caf338ac095 > 102 || $cb844d64514e426c$export$c0306caf338ac095 > 57 && $cb844d64514e426c$export$c0306caf338ac095 < 65 || $cb844d64514e426c$export$c0306caf338ac095 > 70 && $cb844d64514e426c$export$c0306caf338ac095 < 97) break;
    return $cb844d64514e426c$export$58adb3bec8346d0f(e, $cb844d64514e426c$export$e88cb2efb12ae807() + (r < 6 && $cb844d64514e426c$export$4d3fb11e950abb9e() == 32 && $cb844d64514e426c$export$48cfd1e771a65c4f() == 32));
}
function $cb844d64514e426c$export$c889f2fcc19dbf12(e) {
    while($cb844d64514e426c$export$48cfd1e771a65c4f())switch($cb844d64514e426c$export$c0306caf338ac095){
        case e:
            return $cb844d64514e426c$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $cb844d64514e426c$export$c889f2fcc19dbf12($cb844d64514e426c$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $cb844d64514e426c$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $cb844d64514e426c$export$48cfd1e771a65c4f();
            break;
    }
    return $cb844d64514e426c$export$5880b8b5730aff45;
}
function $cb844d64514e426c$export$4254d4e2b3745c4c(e, r) {
    while($cb844d64514e426c$export$48cfd1e771a65c4f())if (e + $cb844d64514e426c$export$c0306caf338ac095 === 57) break;
    else if (e + $cb844d64514e426c$export$c0306caf338ac095 === 84 && $cb844d64514e426c$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $cb844d64514e426c$export$58adb3bec8346d0f(r, $cb844d64514e426c$export$5880b8b5730aff45 - 1) + "*" + $cb844d64514e426c$export$6788812c4e6611e6(e === 47 ? e : $cb844d64514e426c$export$48cfd1e771a65c4f());
}
function $cb844d64514e426c$export$c2ab62c7bf24634(e) {
    while(!$cb844d64514e426c$export$9e1725a4cfeada27($cb844d64514e426c$export$4d3fb11e950abb9e()))$cb844d64514e426c$export$48cfd1e771a65c4f();
    return $cb844d64514e426c$export$58adb3bec8346d0f(e, $cb844d64514e426c$export$5880b8b5730aff45);
}
function $cb844d64514e426c$export$ef7acd7185315e22(e) {
    return $cb844d64514e426c$export$45918ac1574455b1($cb844d64514e426c$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $cb844d64514e426c$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $cb844d64514e426c$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $cb844d64514e426c$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $cb844d64514e426c$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($cb844d64514e426c$export$f8e21b1e77979a08(j += $cb844d64514e426c$export$77ad94ebf1c2b9ed($cb844d64514e426c$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $cb844d64514e426c$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $cb844d64514e426c$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $cb844d64514e426c$export$955ba06d119e085e($cb844d64514e426c$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($cb844d64514e426c$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $cb844d64514e426c$export$10d8903dec122b9d($cb844d64514e426c$export$4a34f930e789283c($cb844d64514e426c$export$4254d4e2b3745c4c($cb844d64514e426c$export$48cfd1e771a65c4f(), $cb844d64514e426c$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $cb844d64514e426c$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $cb844d64514e426c$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $cb844d64514e426c$export$36776f635604f274(j) - l) $cb844d64514e426c$export$10d8903dec122b9d(p > 32 ? $cb844d64514e426c$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $cb844d64514e426c$export$f8483753829ec8f3($cb844d64514e426c$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $cb844d64514e426c$export$10d8903dec122b9d(y = $cb844d64514e426c$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $cb844d64514e426c$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $cb844d64514e426c$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $cb844d64514e426c$export$98e6a39c04603d36(e, y, y, n && $cb844d64514e426c$export$10d8903dec122b9d($cb844d64514e426c$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $cb844d64514e426c$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $cb844d64514e426c$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $cb844d64514e426c$export$232faf9add678146() == 125) continue;
            }
            switch(j += $cb844d64514e426c$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($cb844d64514e426c$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($cb844d64514e426c$export$4d3fb11e950abb9e() === 45) j += $cb844d64514e426c$export$410ac95b9ec204b8($cb844d64514e426c$export$48cfd1e771a65c4f());
                    v = $cb844d64514e426c$export$4d3fb11e950abb9e(), o = l = $cb844d64514e426c$export$36776f635604f274(g = j += $cb844d64514e426c$export$c2ab62c7bf24634($cb844d64514e426c$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $cb844d64514e426c$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $cb844d64514e426c$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $cb844d64514e426c$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $cb844d64514e426c$export$2f35ab04d2335697(e, v + 1, v = $cb844d64514e426c$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $cb844d64514e426c$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $cb844d64514e426c$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $cb844d64514e426c$export$35059013cd4a06db(e, r, a, s === 0 ? $cb844d64514e426c$export$aa3a2e812ca8570d : i, f, o, l);
}
function $cb844d64514e426c$export$4a34f930e789283c(e, r, a) {
    return $cb844d64514e426c$export$35059013cd4a06db(e, r, a, $cb844d64514e426c$export$a29989082612d0d9, $cb844d64514e426c$export$6788812c4e6611e6($cb844d64514e426c$export$eba6f6f03b0a92e7()), $cb844d64514e426c$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $cb844d64514e426c$export$f8483753829ec8f3(e, r, a, n) {
    return $cb844d64514e426c$export$35059013cd4a06db(e, r, a, $cb844d64514e426c$export$527d108ccf083c2b, $cb844d64514e426c$export$2f35ab04d2335697(e, 0, n), $cb844d64514e426c$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $cb844d64514e426c$export$82e9f45cca5ba907(n, c, s) {
    switch($cb844d64514e426c$export$d6af199866bfb566(n, c)){
        case 5103:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $cb844d64514e426c$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$2c0f367103c8d01c + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($cb844d64514e426c$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $cb844d64514e426c$export$39dfd62a25e0fe93 + "box-$1$2" + $cb844d64514e426c$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + "flex-item-" + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$cb844d64514e426c$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $cb844d64514e426c$export$71ad59f2e432cfe8 + "grid-row-" + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + "flex-line-pack" + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + "box-" + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "-grow", "") + $cb844d64514e426c$export$39dfd62a25e0fe93 + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $cb844d64514e426c$export$39dfd62a25e0fe93 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $cb844d64514e426c$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $cb844d64514e426c$export$77ad94ebf1c2b9ed($cb844d64514e426c$export$77ad94ebf1c2b9ed($cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $cb844d64514e426c$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $cb844d64514e426c$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $cb844d64514e426c$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $cb844d64514e426c$export$77ad94ebf1c2b9ed($cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $cb844d64514e426c$export$39dfd62a25e0fe93 + "box-pack:$3" + $cb844d64514e426c$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $cb844d64514e426c$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$cb844d64514e426c$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $cb844d64514e426c$export$71ad59f2e432cfe8 + "grid-column-align" + $cb844d64514e426c$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $cb844d64514e426c$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$cb844d64514e426c$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $cb844d64514e426c$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$cb844d64514e426c$export$f8e21b1e77979a08(s, "span") ? $cb844d64514e426c$export$4659b591c19bdf3d(s, /\d+/) : +$cb844d64514e426c$export$4659b591c19bdf3d(s, /\d+/) - +$cb844d64514e426c$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $cb844d64514e426c$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $cb844d64514e426c$export$71ad59f2e432cfe8 + $cb844d64514e426c$export$77ad94ebf1c2b9ed($cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $cb844d64514e426c$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($cb844d64514e426c$export$36776f635604f274(n) - 1 - c > 6) switch($cb844d64514e426c$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($cb844d64514e426c$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $cb844d64514e426c$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $cb844d64514e426c$export$2c0f367103c8d01c + ($cb844d64514e426c$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$cb844d64514e426c$export$f8e21b1e77979a08(n, "stretch") ? $cb844d64514e426c$export$82e9f45cca5ba907($cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $cb844d64514e426c$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $cb844d64514e426c$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($cb844d64514e426c$export$a9db5e087081082d(n, c + 6) === 121) return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, ":", ":" + $cb844d64514e426c$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($cb844d64514e426c$export$a9db5e087081082d(n, $cb844d64514e426c$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $cb844d64514e426c$export$39dfd62a25e0fe93 + ($cb844d64514e426c$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $cb844d64514e426c$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $cb844d64514e426c$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, ":", ":" + $cb844d64514e426c$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $cb844d64514e426c$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $cb844d64514e426c$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $cb844d64514e426c$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $cb844d64514e426c$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $cb844d64514e426c$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $cb844d64514e426c$export$a763edbf796b780a:
        case $cb844d64514e426c$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $cb844d64514e426c$export$a29989082612d0d9:
            return "";
        case $cb844d64514e426c$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $cb844d64514e426c$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $cb844d64514e426c$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $cb844d64514e426c$export$36776f635604f274(a = $cb844d64514e426c$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $cb844d64514e426c$export$5a7767152ae0305f(e) {
    var r = $cb844d64514e426c$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $cb844d64514e426c$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $cb844d64514e426c$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $cb844d64514e426c$export$527d108ccf083c2b:
                n.return = $cb844d64514e426c$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $cb844d64514e426c$export$b44a8529a35fcb60:
                return $cb844d64514e426c$export$dfdc1655ccc5b9cb([
                    $cb844d64514e426c$export$784d13d8ee351f07(n, {
                        value: $cb844d64514e426c$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $cb844d64514e426c$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $cb844d64514e426c$export$aa3a2e812ca8570d:
                if (n.length) return $cb844d64514e426c$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($cb844d64514e426c$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $cb844d64514e426c$export$dfdc1655ccc5b9cb([
                                $cb844d64514e426c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $cb844d64514e426c$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $cb844d64514e426c$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $cb844d64514e426c$export$dfdc1655ccc5b9cb([
                                $cb844d64514e426c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $cb844d64514e426c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $cb844d64514e426c$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $cb844d64514e426c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $cb844d64514e426c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $cb844d64514e426c$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $cb844d64514e426c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $cb844d64514e426c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $cb844d64514e426c$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $cb844d64514e426c$export$76a88f7de6507443(e) {
    switch(e.type){
        case $cb844d64514e426c$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $cb844d64514e426c$export$1be1fc439b849fdf($cb844d64514e426c$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($cb844d64514e426c$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $cb844d64514e426c$export$2f35ab04d2335697(r, 1, $cb844d64514e426c$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $cb844d64514e426c$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $cb844d64514e426c$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $cb844d64514e426c$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $42d9abb901c3bf7b$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $95ef060a01d0aa14$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $b8a4fe01284b23aa$var$isBrowser = typeof document !== 'undefined';
var $b8a4fe01284b23aa$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cb844d64514e426c$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cb844d64514e426c$export$9e1725a4cfeada27)(character)) break;
        (0, $cb844d64514e426c$export$48cfd1e771a65c4f)();
    }
    return (0, $cb844d64514e426c$export$58adb3bec8346d0f)(begin, (0, $cb844d64514e426c$export$5880b8b5730aff45));
};
var $b8a4fe01284b23aa$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cb844d64514e426c$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cb844d64514e426c$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $b8a4fe01284b23aa$var$identifierWithPointTracking((0, $cb844d64514e426c$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cb844d64514e426c$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cb844d64514e426c$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cb844d64514e426c$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $cb844d64514e426c$export$48cfd1e771a65c4f)());
    return parsed;
};
var $b8a4fe01284b23aa$var$getRules = function getRules(value, points) {
    return (0, $cb844d64514e426c$export$45918ac1574455b1)($b8a4fe01284b23aa$var$toRules((0, $cb844d64514e426c$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $b8a4fe01284b23aa$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $b8a4fe01284b23aa$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$b8a4fe01284b23aa$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $b8a4fe01284b23aa$var$fixedElements.set(element, true);
    var points = [];
    var rules = $b8a4fe01284b23aa$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $b8a4fe01284b23aa$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $b8a4fe01284b23aa$var$prefix(value, length) {
    switch((0, $cb844d64514e426c$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$2c0f367103c8d01c) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + 'box-' + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)((0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)((0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)((0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cb844d64514e426c$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $cb844d64514e426c$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cb844d64514e426c$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $cb844d64514e426c$export$2c0f367103c8d01c) + ((0, $cb844d64514e426c$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cb844d64514e426c$export$f8e21b1e77979a08)(value, 'stretch') ? $b8a4fe01284b23aa$var$prefix((0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cb844d64514e426c$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cb844d64514e426c$export$a9db5e087081082d)(value, (0, $cb844d64514e426c$export$36776f635604f274)(value) - 3 - (~(0, $cb844d64514e426c$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $cb844d64514e426c$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + ((0, $cb844d64514e426c$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cb844d64514e426c$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + value + (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $b8a4fe01284b23aa$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cb844d64514e426c$export$527d108ccf083c2b:
                element["return"] = $b8a4fe01284b23aa$var$prefix(element.value, element.length);
                break;
            case 0, $cb844d64514e426c$export$b44a8529a35fcb60:
                return (0, $cb844d64514e426c$export$dfdc1655ccc5b9cb)([
                    (0, $cb844d64514e426c$export$784d13d8ee351f07)(element, {
                        value: (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $cb844d64514e426c$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $cb844d64514e426c$export$aa3a2e812ca8570d:
                if (element.length) return (0, $cb844d64514e426c$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $cb844d64514e426c$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cb844d64514e426c$export$dfdc1655ccc5b9cb)([
                                (0, $cb844d64514e426c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $cb844d64514e426c$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cb844d64514e426c$export$dfdc1655ccc5b9cb)([
                                (0, $cb844d64514e426c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $cb844d64514e426c$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $cb844d64514e426c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $cb844d64514e426c$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $cb844d64514e426c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $cb844d64514e426c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $cb844d64514e426c$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $b8a4fe01284b23aa$var$getServerStylisCache = $b8a4fe01284b23aa$var$isBrowser ? undefined : (0, $42d9abb901c3bf7b$export$2e2bcd8739ae039)(function() {
    return (0, $95ef060a01d0aa14$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $b8a4fe01284b23aa$var$defaultStylisPlugins = [
    $b8a4fe01284b23aa$var$prefixer
];
var $b8a4fe01284b23aa$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($b8a4fe01284b23aa$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $b8a4fe01284b23aa$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($b8a4fe01284b23aa$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $b8a4fe01284b23aa$var$compat,
        $b8a4fe01284b23aa$var$removeLabel
    ];
    if (!$b8a4fe01284b23aa$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $cb844d64514e426c$export$fac44ee5b035f737),
            (0, $cb844d64514e426c$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $cb844d64514e426c$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $cb844d64514e426c$export$dfdc1655ccc5b9cb)((0, $cb844d64514e426c$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $cb844d64514e426c$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $cb844d64514e426c$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $cb844d64514e426c$export$dfdc1655ccc5b9cb)((0, $cb844d64514e426c$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $b8a4fe01284b23aa$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $6dfc4312e67563de$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





var $5lZKQ = parcelRequire("5lZKQ");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $348e734c4b96d972$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5lZKQ)))(targetComponent, sourceComponent);
};


var $64dcf3236e34bf68$var$isBrowser = typeof document !== 'undefined';
function $64dcf3236e34bf68$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $64dcf3236e34bf68$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $64dcf3236e34bf68$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $64dcf3236e34bf68$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $64dcf3236e34bf68$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$64dcf3236e34bf68$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$64dcf3236e34bf68$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $96076d32e314a648$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $16299a2ec8ecd18a$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $bd3fbbee523d663e$var$isDevelopment = false;
var $bd3fbbee523d663e$var$hyphenateRegex = /[A-Z]|^ms/g;
var $bd3fbbee523d663e$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $bd3fbbee523d663e$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $bd3fbbee523d663e$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $bd3fbbee523d663e$var$processStyleName = /* #__PURE__ */ (0, $95ef060a01d0aa14$export$2e2bcd8739ae039)(function(styleName) {
    return $bd3fbbee523d663e$var$isCustomProperty(styleName) ? styleName : styleName.replace($bd3fbbee523d663e$var$hyphenateRegex, '-$&').toLowerCase();
});
var $bd3fbbee523d663e$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($bd3fbbee523d663e$var$animationRegex, function(match, p1, p2) {
                $bd3fbbee523d663e$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $bd3fbbee523d663e$var$cursor
                };
                return p1;
            });
    }
    if ((0, $16299a2ec8ecd18a$export$2e2bcd8739ae039)[key] !== 1 && !$bd3fbbee523d663e$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $bd3fbbee523d663e$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $bd3fbbee523d663e$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $bd3fbbee523d663e$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $bd3fbbee523d663e$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $bd3fbbee523d663e$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $bd3fbbee523d663e$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $bd3fbbee523d663e$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $bd3fbbee523d663e$var$cursor;
                var result = interpolation(mergedProps);
                $bd3fbbee523d663e$var$cursor = previousCursor;
                return $bd3fbbee523d663e$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $bd3fbbee523d663e$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $bd3fbbee523d663e$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($bd3fbbee523d663e$var$isProcessableValue(asString)) string += $bd3fbbee523d663e$var$processStyleName(key) + ":" + $bd3fbbee523d663e$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $bd3fbbee523d663e$var$isDevelopment) throw new Error($bd3fbbee523d663e$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($bd3fbbee523d663e$var$isProcessableValue(value[_i])) string += $bd3fbbee523d663e$var$processStyleName(key) + ":" + $bd3fbbee523d663e$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $bd3fbbee523d663e$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $bd3fbbee523d663e$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $bd3fbbee523d663e$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $bd3fbbee523d663e$var$cursor;
function $bd3fbbee523d663e$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $bd3fbbee523d663e$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $bd3fbbee523d663e$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $bd3fbbee523d663e$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $bd3fbbee523d663e$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $bd3fbbee523d663e$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $96076d32e314a648$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $bd3fbbee523d663e$var$cursor
    };
}



var $igtsr = parcelRequire("igtsr");
var $d8574a613dfabce4$var$isBrowser = typeof document !== 'undefined';
var $d8574a613dfabce4$var$syncFallback = function syncFallback(create) {
    return create();
};
var $d8574a613dfabce4$var$useInsertionEffect = $igtsr.useInsertionEffect ? $igtsr.useInsertionEffect : false;
var $d8574a613dfabce4$export$db21c7ffa21794e7 = !$d8574a613dfabce4$var$isBrowser ? $d8574a613dfabce4$var$syncFallback : $d8574a613dfabce4$var$useInsertionEffect || $d8574a613dfabce4$var$syncFallback;
var $d8574a613dfabce4$export$811a713a7276cb9d = $d8574a613dfabce4$var$useInsertionEffect || $igtsr.useLayoutEffect;


var $2bdc3d42be222695$export$407448d2b89b1813 = false;
var $2bdc3d42be222695$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $2bdc3d42be222695$var$EmotionCacheContext = /* #__PURE__ */ $igtsr.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $b8a4fe01284b23aa$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $2bdc3d42be222695$export$e7094788287c5e9b = $2bdc3d42be222695$var$EmotionCacheContext.Provider;
var $2bdc3d42be222695$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $igtsr.useContext)($2bdc3d42be222695$var$EmotionCacheContext);
};
var $2bdc3d42be222695$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $igtsr.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $igtsr.useContext)($2bdc3d42be222695$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$2bdc3d42be222695$export$23f2a1d2818174ef) $2bdc3d42be222695$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $igtsr.useContext)($2bdc3d42be222695$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $b8a4fe01284b23aa$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $igtsr.createElement($2bdc3d42be222695$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $2bdc3d42be222695$export$971d5caa766a69d7 = /* #__PURE__ */ $igtsr.createContext({});
var $2bdc3d42be222695$export$3b14a55fb2447963 = function useTheme() {
    return $igtsr.useContext($2bdc3d42be222695$export$971d5caa766a69d7);
};
var $2bdc3d42be222695$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $2bdc3d42be222695$var$createCacheWithTheme = /* #__PURE__ */ (0, $42d9abb901c3bf7b$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $42d9abb901c3bf7b$export$2e2bcd8739ae039)(function(theme) {
        return $2bdc3d42be222695$var$getTheme(outerTheme, theme);
    });
});
var $2bdc3d42be222695$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $igtsr.useContext($2bdc3d42be222695$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $2bdc3d42be222695$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $igtsr.createElement($2bdc3d42be222695$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $2bdc3d42be222695$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $igtsr.forwardRef(function render(props, ref) {
        var theme = $igtsr.useContext($2bdc3d42be222695$export$971d5caa766a69d7);
        return /*#__PURE__*/ $igtsr.createElement(Component, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $348e734c4b96d972$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $2bdc3d42be222695$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $2bdc3d42be222695$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $2bdc3d42be222695$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($2bdc3d42be222695$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$2bdc3d42be222695$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $2bdc3d42be222695$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $64dcf3236e34bf68$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $d8574a613dfabce4$export$db21c7ffa21794e7)(function() {
        return (0, $64dcf3236e34bf68$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$2bdc3d42be222695$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $igtsr.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $2bdc3d42be222695$var$Emotion = /* #__PURE__ */ $2bdc3d42be222695$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$2bdc3d42be222695$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $64dcf3236e34bf68$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bd3fbbee523d663e$export$6321afa313b251b5)(registeredStyles, undefined, $igtsr.useContext($2bdc3d42be222695$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($2bdc3d42be222695$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $2bdc3d42be222695$var$typePropName && !$2bdc3d42be222695$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $igtsr.createElement($igtsr.Fragment, null, /*#__PURE__*/ $igtsr.createElement($2bdc3d42be222695$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $igtsr.createElement(WrappedComponent, newProps));
});
var $2bdc3d42be222695$export$a9c23c6ac3fc3eca = $2bdc3d42be222695$var$Emotion;



var $igtsr = parcelRequire("igtsr");




var $22f7140748a89703$exports = {};
function $22f7140748a89703$var$_extends() {
    return $22f7140748a89703$exports = $22f7140748a89703$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $22f7140748a89703$exports.__esModule = true, $22f7140748a89703$exports["default"] = $22f7140748a89703$exports, $22f7140748a89703$var$_extends.apply(null, arguments);
}
$22f7140748a89703$exports = $22f7140748a89703$var$_extends, $22f7140748a89703$exports.__esModule = true, $22f7140748a89703$exports["default"] = $22f7140748a89703$exports;




parcelRequire("5lZKQ");
var $b0c79da5f77be92b$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $2bdc3d42be222695$export$dda1d9f60106f0e9).call(props, 'css')) return $igtsr.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $2bdc3d42be222695$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $2bdc3d42be222695$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $igtsr.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($b0c79da5f77be92b$export$c8a8987d4410bf2d || ($b0c79da5f77be92b$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b0c79da5f77be92b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $2bdc3d42be222695$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $bd3fbbee523d663e$export$6321afa313b251b5)([
        styles
    ], undefined, $igtsr.useContext((0, $2bdc3d42be222695$export$971d5caa766a69d7)));
    if (!(0, $2bdc3d42be222695$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $igtsr.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $igtsr.useRef();
    (0, $d8574a613dfabce4$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $d8574a613dfabce4$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $64dcf3236e34bf68$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $b0c79da5f77be92b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $bd3fbbee523d663e$export$6321afa313b251b5)(args);
}
function $b0c79da5f77be92b$export$d25ddfdf17c3ad3e() {
    var insertable = $b0c79da5f77be92b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $b0c79da5f77be92b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $b0c79da5f77be92b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $64dcf3236e34bf68$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b0c79da5f77be92b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $d8574a613dfabce4$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $64dcf3236e34bf68$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $2bdc3d42be222695$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $2bdc3d42be222695$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $2bdc3d42be222695$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $igtsr.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $b0c79da5f77be92b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $2bdc3d42be222695$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $2bdc3d42be222695$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $bd3fbbee523d663e$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $64dcf3236e34bf68$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $2bdc3d42be222695$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b0c79da5f77be92b$var$merge(cache.registered, css, $b0c79da5f77be92b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $igtsr.useContext((0, $2bdc3d42be222695$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $igtsr.createElement($igtsr.Fragment, null, /*#__PURE__*/ $igtsr.createElement($b0c79da5f77be92b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});





function $a418dbb6533115da$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $igtsr = parcelRequire("igtsr");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $0c3eeddb1ed27edf$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $0c3eeddb1ed27edf$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $0c3eeddb1ed27edf$export$803cd8101b6c182b = /*#__PURE__*/ $0c3eeddb1ed27edf$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $0c3eeddb1ed27edf$export$27b07d8a310ed8b5[0], side + "-" + $0c3eeddb1ed27edf$export$27b07d8a310ed8b5[1]), []);
const $0c3eeddb1ed27edf$export$96ec731ed4dcb222 = Math.min;
const $0c3eeddb1ed27edf$export$8960430cfd85939f = Math.max;
const $0c3eeddb1ed27edf$export$2077e0241d6afd3c = Math.round;
const $0c3eeddb1ed27edf$export$a3fe094919f356fd = Math.floor;
const $0c3eeddb1ed27edf$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $0c3eeddb1ed27edf$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $0c3eeddb1ed27edf$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $0c3eeddb1ed27edf$export$7d15b64cf5a3a4c4(start, value, end) {
    return $0c3eeddb1ed27edf$export$8960430cfd85939f(start, $0c3eeddb1ed27edf$export$96ec731ed4dcb222(value, end));
}
function $0c3eeddb1ed27edf$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $0c3eeddb1ed27edf$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $0c3eeddb1ed27edf$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $0c3eeddb1ed27edf$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $0c3eeddb1ed27edf$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $0c3eeddb1ed27edf$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($0c3eeddb1ed27edf$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $0c3eeddb1ed27edf$export$2b57e0052a6d6d4c(placement) {
    return $0c3eeddb1ed27edf$export$8a000a963141ac32($0c3eeddb1ed27edf$export$f28e8f882010718a(placement));
}
function $0c3eeddb1ed27edf$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $0c3eeddb1ed27edf$export$f0989780f32bfcda(placement);
    const alignmentAxis = $0c3eeddb1ed27edf$export$2b57e0052a6d6d4c(placement);
    const length = $0c3eeddb1ed27edf$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $0c3eeddb1ed27edf$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $0c3eeddb1ed27edf$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $0c3eeddb1ed27edf$export$496432a3699e50b1(placement) {
    const oppositePlacement = $0c3eeddb1ed27edf$export$9c5e28bad23365fa(placement);
    return [
        $0c3eeddb1ed27edf$export$2b182c584985588b(placement),
        oppositePlacement,
        $0c3eeddb1ed27edf$export$2b182c584985588b(oppositePlacement)
    ];
}
function $0c3eeddb1ed27edf$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$0c3eeddb1ed27edf$var$oppositeAlignmentMap[alignment]);
}
function $0c3eeddb1ed27edf$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $0c3eeddb1ed27edf$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $0c3eeddb1ed27edf$export$f0989780f32bfcda(placement);
    let list = $0c3eeddb1ed27edf$var$getSideList($0c3eeddb1ed27edf$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($0c3eeddb1ed27edf$export$2b182c584985588b));
    }
    return list;
}
function $0c3eeddb1ed27edf$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$0c3eeddb1ed27edf$var$oppositeSideMap[side]);
}
function $0c3eeddb1ed27edf$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $0c3eeddb1ed27edf$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $0c3eeddb1ed27edf$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $0c3eeddb1ed27edf$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $913337730cc02961$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $0c3eeddb1ed27edf$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $0c3eeddb1ed27edf$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $913337730cc02961$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $913337730cc02961$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $913337730cc02961$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $913337730cc02961$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $0c3eeddb1ed27edf$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $0c3eeddb1ed27edf$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $0c3eeddb1ed27edf$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $913337730cc02961$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $0c3eeddb1ed27edf$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $0c3eeddb1ed27edf$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $0c3eeddb1ed27edf$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $0c3eeddb1ed27edf$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $913337730cc02961$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $0c3eeddb1ed27edf$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $913337730cc02961$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $0c3eeddb1ed27edf$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $0c3eeddb1ed27edf$export$803cd8101b6c182b) ? $913337730cc02961$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $913337730cc02961$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $0c3eeddb1ed27edf$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $913337730cc02961$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $0c3eeddb1ed27edf$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $0c3eeddb1ed27edf$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $0c3eeddb1ed27edf$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $913337730cc02961$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $0c3eeddb1ed27edf$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    var _overflowsData$;
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(nextPlacement) : false;
                    const hasInitialMainAxisOverflow = ((_overflowsData$ = overflowsData[0]) == null ? void 0 : _overflowsData$.overflows[0]) > 0;
                    if (!ignoreCrossAxisOverflow || hasInitialMainAxisOverflow) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $913337730cc02961$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $913337730cc02961$var$isAnySideFullyClipped(overflow) {
    return (0, $0c3eeddb1ed27edf$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $913337730cc02961$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $913337730cc02961$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $913337730cc02961$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $913337730cc02961$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $913337730cc02961$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $913337730cc02961$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $913337730cc02961$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $913337730cc02961$var$getBoundingRect(rects) {
    const minX = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $913337730cc02961$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $0c3eeddb1ed27edf$export$ee05aea0aeecbad4)($913337730cc02961$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $913337730cc02961$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $913337730cc02961$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $0c3eeddb1ed27edf$export$ee05aea0aeecbad4)($913337730cc02961$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $0c3eeddb1ed27edf$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $913337730cc02961$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $913337730cc02961$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $913337730cc02961$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $913337730cc02961$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $913337730cc02961$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)((0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $0c3eeddb1ed27edf$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $0c3eeddb1ed27edf$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $0c3eeddb1ed27edf$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $913337730cc02961$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $0c3eeddb1ed27edf$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $913337730cc02961$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(options, state);
            const overflow = await $913337730cc02961$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $0c3eeddb1ed27edf$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $0c3eeddb1ed27edf$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $0c3eeddb1ed27edf$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $76497176d8ac8544$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $76497176d8ac8544$export$651544f548703224(node) {
    if ($76497176d8ac8544$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $76497176d8ac8544$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $76497176d8ac8544$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($76497176d8ac8544$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $76497176d8ac8544$export$8ee0fc9ee280b4ee(value) {
    if (!$76497176d8ac8544$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $76497176d8ac8544$export$38b2d434cce3ea22(value).Node;
}
function $76497176d8ac8544$export$45a5e7f76e0caa8d(value) {
    if (!$76497176d8ac8544$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $76497176d8ac8544$export$38b2d434cce3ea22(value).Element;
}
function $76497176d8ac8544$export$1b3bfaa9684536aa(value) {
    if (!$76497176d8ac8544$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $76497176d8ac8544$export$38b2d434cce3ea22(value).HTMLElement;
}
function $76497176d8ac8544$export$af51f0f06c0f328a(value) {
    if (!$76497176d8ac8544$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $76497176d8ac8544$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $76497176d8ac8544$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $76497176d8ac8544$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $76497176d8ac8544$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($76497176d8ac8544$export$651544f548703224(element));
}
function $76497176d8ac8544$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $76497176d8ac8544$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $76497176d8ac8544$export$78551043582a6a98();
    const css = $76497176d8ac8544$export$45a5e7f76e0caa8d(elementOrCss) ? $76497176d8ac8544$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $76497176d8ac8544$export$940d8225183e1404(element) {
    let currentNode = $76497176d8ac8544$export$4e12058fc4d51d56(element);
    while($76497176d8ac8544$export$1b3bfaa9684536aa(currentNode) && !$76497176d8ac8544$export$d1162fb0b6d4cd51(currentNode)){
        if ($76497176d8ac8544$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($76497176d8ac8544$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $76497176d8ac8544$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $76497176d8ac8544$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $76497176d8ac8544$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($76497176d8ac8544$export$651544f548703224(node));
}
function $76497176d8ac8544$export$3735103072e4a80(element) {
    return $76497176d8ac8544$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $76497176d8ac8544$export$dc8fc79fa2800137(element) {
    if ($76497176d8ac8544$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $76497176d8ac8544$export$4e12058fc4d51d56(node) {
    if ($76497176d8ac8544$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $76497176d8ac8544$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $76497176d8ac8544$export$e495491855dc5418(node);
    return $76497176d8ac8544$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $76497176d8ac8544$export$7cd01a57c8ca906c(node) {
    const parentNode = $76497176d8ac8544$export$4e12058fc4d51d56(node);
    if ($76497176d8ac8544$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($76497176d8ac8544$export$1b3bfaa9684536aa(parentNode) && $76497176d8ac8544$export$989e911fa9af580a(parentNode)) return parentNode;
    return $76497176d8ac8544$export$7cd01a57c8ca906c(parentNode);
}
function $76497176d8ac8544$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $76497176d8ac8544$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $76497176d8ac8544$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $76497176d8ac8544$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $76497176d8ac8544$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $76497176d8ac8544$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $76497176d8ac8544$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $76497176d8ac8544$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $46988e907ff1ddf1$var$getCssDimensions(element) {
    const css = (0, $76497176d8ac8544$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $0c3eeddb1ed27edf$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $0c3eeddb1ed27edf$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $46988e907ff1ddf1$var$unwrapElement(element) {
    return !(0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $46988e907ff1ddf1$var$getScale(element) {
    const domElement = $46988e907ff1ddf1$var$unwrapElement(element);
    if (!(0, $76497176d8ac8544$export$1b3bfaa9684536aa)(domElement)) return (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $46988e907ff1ddf1$var$getCssDimensions(domElement);
    let x = ($ ? (0, $0c3eeddb1ed27edf$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $0c3eeddb1ed27edf$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $46988e907ff1ddf1$var$noOffsets = /*#__PURE__*/ (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(0);
function $46988e907ff1ddf1$var$getVisualOffsets(element) {
    const win = (0, $76497176d8ac8544$export$38b2d434cce3ea22)(element);
    if (!(0, $76497176d8ac8544$export$78551043582a6a98)() || !win.visualViewport) return $46988e907ff1ddf1$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $46988e907ff1ddf1$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $76497176d8ac8544$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $46988e907ff1ddf1$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $46988e907ff1ddf1$var$unwrapElement(element);
    let scale = (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(offsetParent)) scale = $46988e907ff1ddf1$var$getScale(offsetParent);
        } else scale = $46988e907ff1ddf1$var$getScale(element);
    }
    const visualOffsets = $46988e907ff1ddf1$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $46988e907ff1ddf1$var$getVisualOffsets(domElement) : (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $76497176d8ac8544$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $76497176d8ac8544$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $76497176d8ac8544$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $46988e907ff1ddf1$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $76497176d8ac8544$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $76497176d8ac8544$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $76497176d8ac8544$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $0c3eeddb1ed27edf$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $46988e907ff1ddf1$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $76497176d8ac8544$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $46988e907ff1ddf1$var$getBoundingClientRect((0, $76497176d8ac8544$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $46988e907ff1ddf1$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $46988e907ff1ddf1$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $46988e907ff1ddf1$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $76497176d8ac8544$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $76497176d8ac8544$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(1);
    const offsets = (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $76497176d8ac8544$export$651544f548703224)(offsetParent) !== 'body' || (0, $76497176d8ac8544$export$989e911fa9af580a)(documentElement)) scroll = (0, $76497176d8ac8544$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $76497176d8ac8544$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $46988e907ff1ddf1$var$getBoundingClientRect(offsetParent);
            scale = $46988e907ff1ddf1$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $46988e907ff1ddf1$var$getHTMLOffset(documentElement, scroll, true) : (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $46988e907ff1ddf1$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $46988e907ff1ddf1$var$getDocumentRect(element) {
    const html = (0, $76497176d8ac8544$export$e495491855dc5418)(element);
    const scroll = (0, $76497176d8ac8544$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $46988e907ff1ddf1$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $76497176d8ac8544$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $46988e907ff1ddf1$var$getViewportRect(element, strategy) {
    const win = (0, $76497176d8ac8544$export$38b2d434cce3ea22)(element);
    const html = (0, $76497176d8ac8544$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $76497176d8ac8544$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $46988e907ff1ddf1$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $46988e907ff1ddf1$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(element) ? $46988e907ff1ddf1$var$getScale(element) : (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $46988e907ff1ddf1$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $46988e907ff1ddf1$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $46988e907ff1ddf1$var$getDocumentRect((0, $76497176d8ac8544$export$e495491855dc5418)(element));
    else if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $46988e907ff1ddf1$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $46988e907ff1ddf1$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $0c3eeddb1ed27edf$export$ee05aea0aeecbad4)(rect);
}
function $46988e907ff1ddf1$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $76497176d8ac8544$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(parentNode) || (0, $76497176d8ac8544$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $76497176d8ac8544$export$3735103072e4a80)(parentNode).position === 'fixed' || $46988e907ff1ddf1$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $46988e907ff1ddf1$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $76497176d8ac8544$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(el) && (0, $76497176d8ac8544$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $76497176d8ac8544$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $76497176d8ac8544$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(currentNode) && !(0, $76497176d8ac8544$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $76497176d8ac8544$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $76497176d8ac8544$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $76497176d8ac8544$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $46988e907ff1ddf1$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $76497176d8ac8544$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $46988e907ff1ddf1$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $76497176d8ac8544$export$89e651af02346cd4)(element) ? [] : $46988e907ff1ddf1$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $46988e907ff1ddf1$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $46988e907ff1ddf1$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $46988e907ff1ddf1$var$getDimensions(element) {
    const { width: width, height: height } = $46988e907ff1ddf1$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $46988e907ff1ddf1$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $76497176d8ac8544$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $46988e907ff1ddf1$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $46988e907ff1ddf1$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $76497176d8ac8544$export$651544f548703224)(offsetParent) !== 'body' || (0, $76497176d8ac8544$export$989e911fa9af580a)(documentElement)) scroll = (0, $76497176d8ac8544$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $46988e907ff1ddf1$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $46988e907ff1ddf1$var$getHTMLOffset(documentElement, scroll) : (0, $0c3eeddb1ed27edf$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $46988e907ff1ddf1$var$isStaticPositioned(element) {
    return (0, $76497176d8ac8544$export$3735103072e4a80)(element).position === 'static';
}
function $46988e907ff1ddf1$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $76497176d8ac8544$export$1b3bfaa9684536aa)(element) || (0, $76497176d8ac8544$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $76497176d8ac8544$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $46988e907ff1ddf1$var$getOffsetParent(element, polyfill) {
    const win = (0, $76497176d8ac8544$export$38b2d434cce3ea22)(element);
    if ((0, $76497176d8ac8544$export$89e651af02346cd4)(element)) return win;
    if (!(0, $76497176d8ac8544$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $76497176d8ac8544$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $76497176d8ac8544$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$46988e907ff1ddf1$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $76497176d8ac8544$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $46988e907ff1ddf1$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $76497176d8ac8544$export$71535ffaa902797f)(offsetParent) && $46988e907ff1ddf1$var$isStaticPositioned(offsetParent))offsetParent = $46988e907ff1ddf1$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $76497176d8ac8544$export$d1162fb0b6d4cd51)(offsetParent) && $46988e907ff1ddf1$var$isStaticPositioned(offsetParent) && !(0, $76497176d8ac8544$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $76497176d8ac8544$export$940d8225183e1404)(element) || win;
}
const $46988e907ff1ddf1$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $46988e907ff1ddf1$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $46988e907ff1ddf1$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $46988e907ff1ddf1$var$isRTL(element) {
    return (0, $76497176d8ac8544$export$3735103072e4a80)(element).direction === 'rtl';
}
const $46988e907ff1ddf1$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $46988e907ff1ddf1$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $76497176d8ac8544$export$e495491855dc5418,
    getClippingRect: $46988e907ff1ddf1$var$getClippingRect,
    getOffsetParent: $46988e907ff1ddf1$var$getOffsetParent,
    getElementRects: $46988e907ff1ddf1$var$getElementRects,
    getClientRects: $46988e907ff1ddf1$var$getClientRects,
    getDimensions: $46988e907ff1ddf1$var$getDimensions,
    getScale: $46988e907ff1ddf1$var$getScale,
    isElement: $76497176d8ac8544$export$45a5e7f76e0caa8d,
    isRTL: $46988e907ff1ddf1$var$isRTL
};
function $46988e907ff1ddf1$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $46988e907ff1ddf1$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $76497176d8ac8544$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $0c3eeddb1ed27edf$export$a3fe094919f356fd)(top);
        const insetRight = (0, $0c3eeddb1ed27edf$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $0c3eeddb1ed27edf$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $0c3eeddb1ed27edf$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(0, (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$46988e907ff1ddf1$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $46988e907ff1ddf1$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $46988e907ff1ddf1$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $76497176d8ac8544$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $76497176d8ac8544$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $46988e907ff1ddf1$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $46988e907ff1ddf1$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $46988e907ff1ddf1$var$getBoundingClientRect(reference);
        if (prevRefRect && !$46988e907ff1ddf1$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $46988e907ff1ddf1$export$37b6bde19b108ecc = (0, $913337730cc02961$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $46988e907ff1ddf1$export$cc800923e997bb8 = (0, $913337730cc02961$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $46988e907ff1ddf1$export$91fb6ecbd551914 = (0, $913337730cc02961$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $46988e907ff1ddf1$export$fba63a578e423eb = (0, $913337730cc02961$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $46988e907ff1ddf1$export$8a83211c878a3f1f = (0, $913337730cc02961$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $46988e907ff1ddf1$export$346677f925de839c = (0, $913337730cc02961$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $46988e907ff1ddf1$export$fe8985bb6374093c = (0, $913337730cc02961$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $46988e907ff1ddf1$export$f2120bbfa5450bd2 = (0, $913337730cc02961$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $46988e907ff1ddf1$export$18c8ad048e32c7d5 = (0, $913337730cc02961$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $46988e907ff1ddf1$export$7bf07e38f3dc4b69 = (0, $913337730cc02961$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $46988e907ff1ddf1$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $46988e907ff1ddf1$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $913337730cc02961$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $igtsr = parcelRequire("igtsr");
var $6eedb5ae57276ef1$export$2e2bcd8739ae039 = (0, $igtsr.useLayoutEffect);


var $fd2d8f4ba4dfaac6$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $fd2d8f4ba4dfaac6$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $fd2d8f4ba4dfaac6$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $fd2d8f4ba4dfaac6$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($fd2d8f4ba4dfaac6$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $fd2d8f4ba4dfaac6$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($fd2d8f4ba4dfaac6$var$isArray(value)) return value.filter(Boolean);
    if ((0, $592359d45a506fad$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $fd2d8f4ba4dfaac6$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $f9358951273870d3$export$2e2bcd8739ae039)(props, $fd2d8f4ba4dfaac6$var$_excluded$4);
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $fd2d8f4ba4dfaac6$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $fd2d8f4ba4dfaac6$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $fd2d8f4ba4dfaac6$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $fd2d8f4ba4dfaac6$var$normalizedHeight(el) {
    if ($fd2d8f4ba4dfaac6$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $fd2d8f4ba4dfaac6$var$getScrollTop(el) {
    if ($fd2d8f4ba4dfaac6$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $fd2d8f4ba4dfaac6$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($fd2d8f4ba4dfaac6$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $fd2d8f4ba4dfaac6$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $fd2d8f4ba4dfaac6$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $fd2d8f4ba4dfaac6$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $fd2d8f4ba4dfaac6$export$b4171a6734a65d42;
    var start = $fd2d8f4ba4dfaac6$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $fd2d8f4ba4dfaac6$var$easeOutCubic(currentTime, start, change, duration);
        $fd2d8f4ba4dfaac6$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $fd2d8f4ba4dfaac6$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $fd2d8f4ba4dfaac6$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $fd2d8f4ba4dfaac6$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $fd2d8f4ba4dfaac6$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $fd2d8f4ba4dfaac6$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $fd2d8f4ba4dfaac6$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $fd2d8f4ba4dfaac6$var$passiveOptionAccessed = false;
var $fd2d8f4ba4dfaac6$var$options = {
    get passive () {
        return $fd2d8f4ba4dfaac6$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $fd2d8f4ba4dfaac6$var$w = typeof window !== 'undefined' ? window : {};
if ($fd2d8f4ba4dfaac6$var$w.addEventListener && $fd2d8f4ba4dfaac6$var$w.removeEventListener) {
    $fd2d8f4ba4dfaac6$var$w.addEventListener('p', $fd2d8f4ba4dfaac6$export$b4171a6734a65d42, $fd2d8f4ba4dfaac6$var$options);
    $fd2d8f4ba4dfaac6$var$w.removeEventListener('p', $fd2d8f4ba4dfaac6$export$b4171a6734a65d42, false);
}
var $fd2d8f4ba4dfaac6$export$2408f22a0fab9ae5 = $fd2d8f4ba4dfaac6$var$passiveOptionAccessed;
function $fd2d8f4ba4dfaac6$export$3466f893ebf79586(item) {
    return item != null;
}
function $fd2d8f4ba4dfaac6$var$isArray(arg) {
    return Array.isArray(arg);
}
function $fd2d8f4ba4dfaac6$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $fd2d8f4ba4dfaac6$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $fd2d8f4ba4dfaac6$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $fd2d8f4ba4dfaac6$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $fd2d8f4ba4dfaac6$var$_excluded$3 = [
    "children",
    "innerProps"
], $fd2d8f4ba4dfaac6$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $fd2d8f4ba4dfaac6$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $fd2d8f4ba4dfaac6$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $fd2d8f4ba4dfaac6$var$normalizedHeight(scrollParent);
    var scrollTop = $fd2d8f4ba4dfaac6$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $fd2d8f4ba4dfaac6$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $fd2d8f4ba4dfaac6$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $fd2d8f4ba4dfaac6$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $fd2d8f4ba4dfaac6$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $fd2d8f4ba4dfaac6$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $fd2d8f4ba4dfaac6$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $fd2d8f4ba4dfaac6$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $fd2d8f4ba4dfaac6$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $3c5cabeff69d85d2$export$2e2bcd8739ae039)(_objectSpread2, $fd2d8f4ba4dfaac6$var$alignToControl(placement), '100%'), (0, $3c5cabeff69d85d2$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $3c5cabeff69d85d2$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $3c5cabeff69d85d2$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $fd2d8f4ba4dfaac6$var$PortalPlacementContext = /*#__PURE__*/ (0, $igtsr.createContext)(null);
// NOTE: internal only
var $fd2d8f4ba4dfaac6$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $igtsr.useContext)($fd2d8f4ba4dfaac6$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $igtsr.useRef)(null);
    var _useState = (0, $igtsr.useState)(maxMenuHeight), _useState2 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $igtsr.useState)(null), _useState4 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $6eedb5ae57276ef1$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $fd2d8f4ba4dfaac6$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $fd2d8f4ba4dfaac6$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $fd2d8f4ba4dfaac6$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $fd2d8f4ba4dfaac6$var$Menu$1 = $fd2d8f4ba4dfaac6$var$Menu;
// ==============================
// Menu List
// ==============================
var $fd2d8f4ba4dfaac6$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $fd2d8f4ba4dfaac6$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $fd2d8f4ba4dfaac6$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $fd2d8f4ba4dfaac6$export$3b14a55fb2447963 = $fd2d8f4ba4dfaac6$var$noticeCSS;
var $fd2d8f4ba4dfaac6$export$342063e11d6c3cad = $fd2d8f4ba4dfaac6$var$noticeCSS;
var $fd2d8f4ba4dfaac6$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_ref6, $fd2d8f4ba4dfaac6$var$_excluded$3);
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps((0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $fd2d8f4ba4dfaac6$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_ref7, $fd2d8f4ba4dfaac6$var$_excluded2$1);
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps((0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $fd2d8f4ba4dfaac6$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $fd2d8f4ba4dfaac6$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $igtsr.useRef)(null);
    var cleanupRef = (0, $igtsr.useRef)(null);
    var _useState5 = (0, $igtsr.useState)($fd2d8f4ba4dfaac6$var$coercePlacement(menuPlacement)), _useState6 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $igtsr.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $igtsr.useState)(null), _useState8 = (0, $08ee0d51fbf762ec$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $igtsr.useCallback)(function() {
        if (!controlElement) return;
        var rect = $fd2d8f4ba4dfaac6$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $6eedb5ae57276ef1$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $igtsr.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $46988e907ff1ddf1$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $6eedb5ae57276ef1$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $igtsr.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $fd2d8f4ba4dfaac6$var$getStyleProps((0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7731928cc933a5ef$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $fd2d8f4ba4dfaac6$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $fd2d8f4ba4dfaac6$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $fd2d8f4ba4dfaac6$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $fd2d8f4ba4dfaac6$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $fd2d8f4ba4dfaac6$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $fd2d8f4ba4dfaac6$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $fd2d8f4ba4dfaac6$var$_templateObject;
var $fd2d8f4ba4dfaac6$var$_excluded$2 = [
    "size"
], $fd2d8f4ba4dfaac6$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $fd2d8f4ba4dfaac6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $fd2d8f4ba4dfaac6$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $fd2d8f4ba4dfaac6$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_ref, $fd2d8f4ba4dfaac6$var$_excluded$2);
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("svg", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $fd2d8f4ba4dfaac6$var$_ref2
    }, props));
};
var $fd2d8f4ba4dfaac6$var$CrossIcon = function CrossIcon(props) {
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$Svg, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $fd2d8f4ba4dfaac6$var$DownChevron = function DownChevron(props) {
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$Svg, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $fd2d8f4ba4dfaac6$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $fd2d8f4ba4dfaac6$export$f1e1789686576879 = $fd2d8f4ba4dfaac6$var$baseCSS;
var $fd2d8f4ba4dfaac6$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$DownChevron, null));
};
var $fd2d8f4ba4dfaac6$export$407448d2b89b1813 = $fd2d8f4ba4dfaac6$var$baseCSS;
var $fd2d8f4ba4dfaac6$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $fd2d8f4ba4dfaac6$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $fd2d8f4ba4dfaac6$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("span", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, innerProps, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $fd2d8f4ba4dfaac6$var$loadingDotAnimations = (0, $b0c79da5f77be92b$export$d25ddfdf17c3ad3e)($fd2d8f4ba4dfaac6$var$_templateObject || ($fd2d8f4ba4dfaac6$var$_templateObject = (0, $a418dbb6533115da$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $fd2d8f4ba4dfaac6$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $fd2d8f4ba4dfaac6$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $b0c79da5f77be92b$export$dbf350e5966cf602)({
            animation: "".concat($fd2d8f4ba4dfaac6$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $fd2d8f4ba4dfaac6$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_ref7, $fd2d8f4ba4dfaac6$var$_excluded2);
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps((0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $fd2d8f4ba4dfaac6$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $fd2d8f4ba4dfaac6$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $fd2d8f4ba4dfaac6$var$Control$1 = $fd2d8f4ba4dfaac6$var$Control;
var $fd2d8f4ba4dfaac6$var$_excluded$1 = [
    "data"
];
var $fd2d8f4ba4dfaac6$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $fd2d8f4ba4dfaac6$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)(Heading, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", null, children));
};
var $fd2d8f4ba4dfaac6$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $fd2d8f4ba4dfaac6$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $fd2d8f4ba4dfaac6$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_cleanCommonProps, $fd2d8f4ba4dfaac6$var$_excluded$1);
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $fd2d8f4ba4dfaac6$var$Group$1 = $fd2d8f4ba4dfaac6$var$Group;
var $fd2d8f4ba4dfaac6$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $fd2d8f4ba4dfaac6$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $fd2d8f4ba4dfaac6$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $fd2d8f4ba4dfaac6$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $fd2d8f4ba4dfaac6$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $fd2d8f4ba4dfaac6$var$spacingStyle)
};
var $fd2d8f4ba4dfaac6$var$inputStyle = function inputStyle(isHidden) {
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $fd2d8f4ba4dfaac6$var$spacingStyle);
};
var $fd2d8f4ba4dfaac6$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $fd2d8f4ba4dfaac6$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_cleanCommonProps, $fd2d8f4ba4dfaac6$var$_excluded);
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("input", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $fd2d8f4ba4dfaac6$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $fd2d8f4ba4dfaac6$var$Input$1 = $fd2d8f4ba4dfaac6$var$Input;
var $fd2d8f4ba4dfaac6$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $fd2d8f4ba4dfaac6$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $fd2d8f4ba4dfaac6$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $fd2d8f4ba4dfaac6$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $fd2d8f4ba4dfaac6$var$MultiValueContainer = $fd2d8f4ba4dfaac6$var$MultiValueGeneric;
var $fd2d8f4ba4dfaac6$var$MultiValueLabel = $fd2d8f4ba4dfaac6$var$MultiValueGeneric;
function $fd2d8f4ba4dfaac6$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($fd2d8f4ba4dfaac6$var$CrossIcon, {
        size: 14
    }));
}
var $fd2d8f4ba4dfaac6$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $fd2d8f4ba4dfaac6$var$MultiValue$1 = $fd2d8f4ba4dfaac6$var$MultiValue;
var $fd2d8f4ba4dfaac6$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $fd2d8f4ba4dfaac6$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $fd2d8f4ba4dfaac6$var$Option$1 = $fd2d8f4ba4dfaac6$var$Option;
var $fd2d8f4ba4dfaac6$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $fd2d8f4ba4dfaac6$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $fd2d8f4ba4dfaac6$var$Placeholder$1 = $fd2d8f4ba4dfaac6$var$Placeholder;
var $fd2d8f4ba4dfaac6$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $fd2d8f4ba4dfaac6$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $fd2d8f4ba4dfaac6$var$SingleValue$1 = $fd2d8f4ba4dfaac6$var$SingleValue;
var $fd2d8f4ba4dfaac6$export$db3b6bfb95261072 = {
    ClearIndicator: $fd2d8f4ba4dfaac6$var$ClearIndicator,
    Control: $fd2d8f4ba4dfaac6$var$Control$1,
    DropdownIndicator: $fd2d8f4ba4dfaac6$var$DropdownIndicator,
    DownChevron: $fd2d8f4ba4dfaac6$var$DownChevron,
    CrossIcon: $fd2d8f4ba4dfaac6$var$CrossIcon,
    Group: $fd2d8f4ba4dfaac6$var$Group$1,
    GroupHeading: $fd2d8f4ba4dfaac6$var$GroupHeading,
    IndicatorsContainer: $fd2d8f4ba4dfaac6$var$IndicatorsContainer,
    IndicatorSeparator: $fd2d8f4ba4dfaac6$var$IndicatorSeparator,
    Input: $fd2d8f4ba4dfaac6$var$Input$1,
    LoadingIndicator: $fd2d8f4ba4dfaac6$var$LoadingIndicator,
    Menu: $fd2d8f4ba4dfaac6$var$Menu$1,
    MenuList: $fd2d8f4ba4dfaac6$var$MenuList,
    MenuPortal: $fd2d8f4ba4dfaac6$var$MenuPortal,
    LoadingMessage: $fd2d8f4ba4dfaac6$var$LoadingMessage,
    NoOptionsMessage: $fd2d8f4ba4dfaac6$var$NoOptionsMessage,
    MultiValue: $fd2d8f4ba4dfaac6$var$MultiValue$1,
    MultiValueContainer: $fd2d8f4ba4dfaac6$var$MultiValueContainer,
    MultiValueLabel: $fd2d8f4ba4dfaac6$var$MultiValueLabel,
    MultiValueRemove: $fd2d8f4ba4dfaac6$var$MultiValueRemove,
    Option: $fd2d8f4ba4dfaac6$var$Option$1,
    Placeholder: $fd2d8f4ba4dfaac6$var$Placeholder$1,
    SelectContainer: $fd2d8f4ba4dfaac6$var$SelectContainer,
    SingleValue: $fd2d8f4ba4dfaac6$var$SingleValue$1,
    ValueContainer: $fd2d8f4ba4dfaac6$var$ValueContainer
};
var $fd2d8f4ba4dfaac6$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, $fd2d8f4ba4dfaac6$export$db3b6bfb95261072), props.components);
};



var $0fba4524e125f2cd$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $0fba4524e125f2cd$var$isEqual(first, second) {
    if (first === second) return true;
    if ($0fba4524e125f2cd$var$safeIsNaN(first) && $0fba4524e125f2cd$var$safeIsNaN(second)) return true;
    return false;
}
function $0fba4524e125f2cd$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$0fba4524e125f2cd$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $0fba4524e125f2cd$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $0fba4524e125f2cd$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $eb3d1cb3aeb92345$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $eb3d1cb3aeb92345$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $eb3d1cb3aeb92345$var$A11yText = function A11yText(props) {
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("span", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        css: $eb3d1cb3aeb92345$var$_ref
    }, props));
};
var $eb3d1cb3aeb92345$var$A11yText$1 = $eb3d1cb3aeb92345$var$A11yText;
var $eb3d1cb3aeb92345$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $eb3d1cb3aeb92345$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $igtsr.useMemo)(function() {
        return (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, $eb3d1cb3aeb92345$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $igtsr.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $igtsr.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $igtsr.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $igtsr.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)((0, $igtsr.Fragment), null, (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)((0, $igtsr.Fragment), null, (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($eb3d1cb3aeb92345$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)($eb3d1cb3aeb92345$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $eb3d1cb3aeb92345$var$LiveRegion$1 = $eb3d1cb3aeb92345$var$LiveRegion;
var $eb3d1cb3aeb92345$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $eb3d1cb3aeb92345$var$anyDiacritic = new RegExp('[' + $eb3d1cb3aeb92345$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $eb3d1cb3aeb92345$var$diacriticToBase = {};
for(var $eb3d1cb3aeb92345$var$i = 0; $eb3d1cb3aeb92345$var$i < $eb3d1cb3aeb92345$var$diacritics.length; $eb3d1cb3aeb92345$var$i++){
    var $eb3d1cb3aeb92345$var$diacritic = $eb3d1cb3aeb92345$var$diacritics[$eb3d1cb3aeb92345$var$i];
    for(var $eb3d1cb3aeb92345$var$j = 0; $eb3d1cb3aeb92345$var$j < $eb3d1cb3aeb92345$var$diacritic.letters.length; $eb3d1cb3aeb92345$var$j++)$eb3d1cb3aeb92345$var$diacriticToBase[$eb3d1cb3aeb92345$var$diacritic.letters[$eb3d1cb3aeb92345$var$j]] = $eb3d1cb3aeb92345$var$diacritic.base;
}
var $eb3d1cb3aeb92345$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($eb3d1cb3aeb92345$var$anyDiacritic, function(match) {
        return $eb3d1cb3aeb92345$var$diacriticToBase[match];
    });
};
var $eb3d1cb3aeb92345$var$memoizedStripDiacriticsForInput = (0, $0fba4524e125f2cd$export$2e2bcd8739ae039)($eb3d1cb3aeb92345$var$stripDiacritics);
var $eb3d1cb3aeb92345$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $eb3d1cb3aeb92345$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $eb3d1cb3aeb92345$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $eb3d1cb3aeb92345$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $eb3d1cb3aeb92345$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $eb3d1cb3aeb92345$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $eb3d1cb3aeb92345$var$memoizedStripDiacriticsForInput(input);
            candidate = $eb3d1cb3aeb92345$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $eb3d1cb3aeb92345$var$_excluded = [
    "innerRef"
];
function $eb3d1cb3aeb92345$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $f9358951273870d3$export$2e2bcd8739ae039)(_ref, $eb3d1cb3aeb92345$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $fd2d8f4ba4dfaac6$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("input", (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $b0c79da5f77be92b$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $eb3d1cb3aeb92345$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $eb3d1cb3aeb92345$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $igtsr.useRef)(false);
    var isTop = (0, $igtsr.useRef)(false);
    var touchStart = (0, $igtsr.useRef)(0);
    var scrollTarget = (0, $igtsr.useRef)(null);
    var handleEventDelta = (0, $igtsr.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $eb3d1cb3aeb92345$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $igtsr.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $igtsr.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $igtsr.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $igtsr.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $fd2d8f4ba4dfaac6$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $igtsr.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $igtsr.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $eb3d1cb3aeb92345$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $eb3d1cb3aeb92345$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $eb3d1cb3aeb92345$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $eb3d1cb3aeb92345$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $eb3d1cb3aeb92345$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $eb3d1cb3aeb92345$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $eb3d1cb3aeb92345$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $eb3d1cb3aeb92345$var$activeScrollLocks = 0;
var $eb3d1cb3aeb92345$var$listenerOptions = {
    capture: false,
    passive: false
};
function $eb3d1cb3aeb92345$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $igtsr.useRef)({});
    var scrollTarget = (0, $igtsr.useRef)(null);
    var addScrollLock = (0, $igtsr.useCallback)(function(touchScrollTarget) {
        if (!$eb3d1cb3aeb92345$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $eb3d1cb3aeb92345$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $eb3d1cb3aeb92345$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($eb3d1cb3aeb92345$var$LOCK_STYLES).forEach(function(key) {
                var val = $eb3d1cb3aeb92345$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $eb3d1cb3aeb92345$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $eb3d1cb3aeb92345$var$preventTouchMove, $eb3d1cb3aeb92345$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $eb3d1cb3aeb92345$var$preventInertiaScroll, $eb3d1cb3aeb92345$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $eb3d1cb3aeb92345$var$allowTouchMove, $eb3d1cb3aeb92345$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $eb3d1cb3aeb92345$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $igtsr.useCallback)(function(touchScrollTarget) {
        if (!$eb3d1cb3aeb92345$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $eb3d1cb3aeb92345$var$activeScrollLocks = Math.max($eb3d1cb3aeb92345$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $eb3d1cb3aeb92345$var$activeScrollLocks < 1) $eb3d1cb3aeb92345$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $eb3d1cb3aeb92345$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $eb3d1cb3aeb92345$var$preventTouchMove, $eb3d1cb3aeb92345$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $eb3d1cb3aeb92345$var$preventInertiaScroll, $eb3d1cb3aeb92345$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $eb3d1cb3aeb92345$var$allowTouchMove, $eb3d1cb3aeb92345$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $igtsr.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $eb3d1cb3aeb92345$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $eb3d1cb3aeb92345$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $eb3d1cb3aeb92345$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $eb3d1cb3aeb92345$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $eb3d1cb3aeb92345$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $eb3d1cb3aeb92345$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)((0, $igtsr.Fragment), null, lockEnabled && (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("div", {
        onClick: $eb3d1cb3aeb92345$var$blurSelectInput,
        css: $eb3d1cb3aeb92345$var$_ref2$1
    }), children(targetRef));
}
function $eb3d1cb3aeb92345$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $eb3d1cb3aeb92345$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $eb3d1cb3aeb92345$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $b0c79da5f77be92b$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $eb3d1cb3aeb92345$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $eb3d1cb3aeb92345$var$RequiredInput$1 = $eb3d1cb3aeb92345$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $eb3d1cb3aeb92345$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $eb3d1cb3aeb92345$var$isIPhone() {
    return $eb3d1cb3aeb92345$var$testPlatform(/^iPhone/i);
}
function $eb3d1cb3aeb92345$var$isMac() {
    return $eb3d1cb3aeb92345$var$testPlatform(/^Mac/i);
}
function $eb3d1cb3aeb92345$var$isIPad() {
    return $eb3d1cb3aeb92345$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $eb3d1cb3aeb92345$var$isMac() && navigator.maxTouchPoints > 1;
}
function $eb3d1cb3aeb92345$var$isIOS() {
    return $eb3d1cb3aeb92345$var$isIPhone() || $eb3d1cb3aeb92345$var$isIPad();
}
function $eb3d1cb3aeb92345$var$isAppleDevice() {
    return $eb3d1cb3aeb92345$var$isMac() || $eb3d1cb3aeb92345$var$isIOS();
}
var $eb3d1cb3aeb92345$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $eb3d1cb3aeb92345$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $eb3d1cb3aeb92345$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $eb3d1cb3aeb92345$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $eb3d1cb3aeb92345$var$defaultStyles = {
    clearIndicator: (0, $fd2d8f4ba4dfaac6$export$407448d2b89b1813),
    container: (0, $fd2d8f4ba4dfaac6$export$8b22cf2602fb60ce),
    control: (0, $fd2d8f4ba4dfaac6$export$4368d992c4eafac0),
    dropdownIndicator: (0, $fd2d8f4ba4dfaac6$export$f1e1789686576879),
    group: (0, $fd2d8f4ba4dfaac6$export$39b482c5e57630a8),
    groupHeading: (0, $fd2d8f4ba4dfaac6$export$2d1720544b23b823),
    indicatorsContainer: (0, $fd2d8f4ba4dfaac6$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $fd2d8f4ba4dfaac6$export$dda1d9f60106f0e9),
    input: (0, $fd2d8f4ba4dfaac6$export$35e795649ee09318),
    loadingIndicator: (0, $fd2d8f4ba4dfaac6$export$882b5998b3b9117c),
    loadingMessage: (0, $fd2d8f4ba4dfaac6$export$342063e11d6c3cad),
    menu: (0, $fd2d8f4ba4dfaac6$export$953cecd6e717a553),
    menuList: (0, $fd2d8f4ba4dfaac6$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $fd2d8f4ba4dfaac6$export$ae1af26003f05816),
    multiValue: (0, $fd2d8f4ba4dfaac6$export$ffb5f4729a158638),
    multiValueLabel: (0, $fd2d8f4ba4dfaac6$export$9e5f44173e64f162),
    multiValueRemove: (0, $fd2d8f4ba4dfaac6$export$625550452a3fa3ec),
    noOptionsMessage: (0, $fd2d8f4ba4dfaac6$export$3b14a55fb2447963),
    option: (0, $fd2d8f4ba4dfaac6$export$90a7f3efeed30595),
    placeholder: (0, $fd2d8f4ba4dfaac6$export$efccba1c4a2ef57b),
    singleValue: (0, $fd2d8f4ba4dfaac6$export$d141bba7fdc215a3),
    valueContainer: (0, $fd2d8f4ba4dfaac6$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $eb3d1cb3aeb92345$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $eb3d1cb3aeb92345$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $eb3d1cb3aeb92345$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $eb3d1cb3aeb92345$var$baseUnit = 4;
// The minimum height of the control
var $eb3d1cb3aeb92345$var$controlHeight = 38;
// The amount of space between the control and menu */
var $eb3d1cb3aeb92345$var$menuGutter = $eb3d1cb3aeb92345$var$baseUnit * 2;
var $eb3d1cb3aeb92345$var$spacing = {
    baseUnit: $eb3d1cb3aeb92345$var$baseUnit,
    controlHeight: $eb3d1cb3aeb92345$var$controlHeight,
    menuGutter: $eb3d1cb3aeb92345$var$menuGutter
};
var $eb3d1cb3aeb92345$export$4368d992c4eafac0 = {
    borderRadius: $eb3d1cb3aeb92345$var$borderRadius,
    colors: $eb3d1cb3aeb92345$var$colors,
    spacing: $eb3d1cb3aeb92345$var$spacing
};
var $eb3d1cb3aeb92345$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $fd2d8f4ba4dfaac6$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $fd2d8f4ba4dfaac6$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $eb3d1cb3aeb92345$export$db3b6bfb95261072(),
    formatGroupLabel: $eb3d1cb3aeb92345$var$formatGroupLabel,
    getOptionLabel: $eb3d1cb3aeb92345$export$8b22cf2602fb60ce,
    getOptionValue: $eb3d1cb3aeb92345$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $eb3d1cb3aeb92345$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $fd2d8f4ba4dfaac6$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $eb3d1cb3aeb92345$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $eb3d1cb3aeb92345$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $eb3d1cb3aeb92345$var$_isOptionSelected(props, option, selectValue);
    var label = $eb3d1cb3aeb92345$var$getOptionLabel(props, option);
    var value = $eb3d1cb3aeb92345$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $eb3d1cb3aeb92345$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $eb3d1cb3aeb92345$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $eb3d1cb3aeb92345$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $eb3d1cb3aeb92345$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $eb3d1cb3aeb92345$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $fd2d8f4ba4dfaac6$export$3466f893ebf79586));
}
function $eb3d1cb3aeb92345$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $14ee2d317130855d$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $eb3d1cb3aeb92345$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $14ee2d317130855d$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $eb3d1cb3aeb92345$var$buildFocusableOptions(props, selectValue) {
    return $eb3d1cb3aeb92345$var$buildFocusableOptionsFromCategorizedOptions($eb3d1cb3aeb92345$var$buildCategorizedOptions(props, selectValue));
}
function $eb3d1cb3aeb92345$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$eb3d1cb3aeb92345$var$shouldHideSelectedOptions(props) || !isSelected) && $eb3d1cb3aeb92345$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $eb3d1cb3aeb92345$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $eb3d1cb3aeb92345$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $eb3d1cb3aeb92345$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $eb3d1cb3aeb92345$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $eb3d1cb3aeb92345$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $eb3d1cb3aeb92345$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $eb3d1cb3aeb92345$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $eb3d1cb3aeb92345$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $eb3d1cb3aeb92345$var$getOptionValue(props, i) === candidate;
    });
}
function $eb3d1cb3aeb92345$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $eb3d1cb3aeb92345$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $eb3d1cb3aeb92345$var$instanceId = 1;
var $eb3d1cb3aeb92345$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $7a03a4b83e867c11$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a5e435e5efd39e4e$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $e5a950aa97be4049$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $eb3d1cb3aeb92345$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $fd2d8f4ba4dfaac6$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $fd2d8f4ba4dfaac6$export$ef35774e6d314e91)([].concat((0, $14ee2d317130855d$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $fd2d8f4ba4dfaac6$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $fd2d8f4ba4dfaac6$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $fd2d8f4ba4dfaac6$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $fd2d8f4ba4dfaac6$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $fd2d8f4ba4dfaac6$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $eb3d1cb3aeb92345$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $eb3d1cb3aeb92345$var$buildFocusableOptionsWithIds($eb3d1cb3aeb92345$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $fd2d8f4ba4dfaac6$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $eb3d1cb3aeb92345$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $eb3d1cb3aeb92345$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $eb3d1cb3aeb92345$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $fd2d8f4ba4dfaac6$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $eb3d1cb3aeb92345$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $eb3d1cb3aeb92345$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $566a7e41981971b5$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $fd2d8f4ba4dfaac6$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $eb3d1cb3aeb92345$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$eb3d1cb3aeb92345$var$instanceId);
        _this.state.selectValue = (0, $fd2d8f4ba4dfaac6$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $eb3d1cb3aeb92345$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $f898a3d1adefff2e$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $fd2d8f4ba4dfaac6$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $fd2d8f4ba4dfaac6$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $eb3d1cb3aeb92345$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($eb3d1cb3aeb92345$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, $eb3d1cb3aeb92345$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $eb3d1cb3aeb92345$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $eb3d1cb3aeb92345$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $eb3d1cb3aeb92345$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $igtsr.createElement($eb3d1cb3aeb92345$var$DummyInput, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $fd2d8f4ba4dfaac6$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $igtsr.createElement(Input, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $igtsr.createElement(Placeholder, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $igtsr.createElement(MultiValue, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $igtsr.createElement(SingleValue, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $igtsr.createElement(ClearIndicator, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $igtsr.createElement(LoadingIndicator, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $igtsr.createElement(IndicatorSeparator, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $igtsr.createElement(DropdownIndicator, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $igtsr.createElement(Option, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $igtsr.createElement(Group, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $igtsr.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $igtsr.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $igtsr.createElement((0, $fd2d8f4ba4dfaac6$export$3a1a48c8f6ef640e), (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $igtsr.createElement(Menu, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $igtsr.createElement($eb3d1cb3aeb92345$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $igtsr.createElement(MenuList, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $igtsr.createElement(MenuPortal, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $igtsr.createElement($eb3d1cb3aeb92345$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $igtsr.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $igtsr.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $igtsr.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $igtsr.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $igtsr.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $igtsr.createElement($eb3d1cb3aeb92345$var$LiveRegion$1, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $igtsr.createElement(SelectContainer, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $igtsr.createElement(Control, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $igtsr.createElement(ValueContainer, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $igtsr.createElement(IndicatorsContainer, (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $fd2d8f4ba4dfaac6$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $eb3d1cb3aeb92345$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $eb3d1cb3aeb92345$var$buildFocusableOptionsWithIds($eb3d1cb3aeb92345$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $eb3d1cb3aeb92345$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $eb3d1cb3aeb92345$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $eb3d1cb3aeb92345$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $fd2d8f4ba4dfaac6$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)((0, $566a7e41981971b5$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $igtsr.Component));
$eb3d1cb3aeb92345$export$25ce5a424b770e84.defaultProps = $eb3d1cb3aeb92345$export$407448d2b89b1813;





var $904fd4df13b8791f$exports = {};
var $1c3c3eeb627c8061$exports = {};
var $2d45e7d1751976af$exports = {};
var $715dc430e2b383a4$exports = {};
function $715dc430e2b383a4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $715dc430e2b383a4$exports = $715dc430e2b383a4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $715dc430e2b383a4$exports.__esModule = true, $715dc430e2b383a4$exports["default"] = $715dc430e2b383a4$exports, $715dc430e2b383a4$var$_typeof(o);
}
$715dc430e2b383a4$exports = $715dc430e2b383a4$var$_typeof, $715dc430e2b383a4$exports.__esModule = true, $715dc430e2b383a4$exports["default"] = $715dc430e2b383a4$exports;


var $2d45e7d1751976af$var$_typeof = $715dc430e2b383a4$exports.default;
var $f3b7a22dc96b0848$exports = {};

var $f3b7a22dc96b0848$var$_typeof = $715dc430e2b383a4$exports.default;
function $f3b7a22dc96b0848$var$toPrimitive(t, r) {
    if ("object" != $f3b7a22dc96b0848$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f3b7a22dc96b0848$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$f3b7a22dc96b0848$exports = $f3b7a22dc96b0848$var$toPrimitive, $f3b7a22dc96b0848$exports.__esModule = true, $f3b7a22dc96b0848$exports["default"] = $f3b7a22dc96b0848$exports;


function $2d45e7d1751976af$var$toPropertyKey(t) {
    var i = $f3b7a22dc96b0848$exports(t, "string");
    return "symbol" == $2d45e7d1751976af$var$_typeof(i) ? i : i + "";
}
$2d45e7d1751976af$exports = $2d45e7d1751976af$var$toPropertyKey, $2d45e7d1751976af$exports.__esModule = true, $2d45e7d1751976af$exports["default"] = $2d45e7d1751976af$exports;


function $1c3c3eeb627c8061$var$_defineProperty(e, r, t) {
    return (r = $2d45e7d1751976af$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$1c3c3eeb627c8061$exports = $1c3c3eeb627c8061$var$_defineProperty, $1c3c3eeb627c8061$exports.__esModule = true, $1c3c3eeb627c8061$exports["default"] = $1c3c3eeb627c8061$exports;


function $904fd4df13b8791f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $904fd4df13b8791f$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $904fd4df13b8791f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1c3c3eeb627c8061$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $904fd4df13b8791f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$904fd4df13b8791f$exports = $904fd4df13b8791f$var$_objectSpread2, $904fd4df13b8791f$exports.__esModule = true, $904fd4df13b8791f$exports["default"] = $904fd4df13b8791f$exports;


var $3da3a464c4f25a95$exports = {};
var $63cfbe2919279800$exports = {};
function $63cfbe2919279800$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$63cfbe2919279800$exports = $63cfbe2919279800$var$_arrayWithHoles, $63cfbe2919279800$exports.__esModule = true, $63cfbe2919279800$exports["default"] = $63cfbe2919279800$exports;


var $3e9008bf1b19d69e$exports = {};
function $3e9008bf1b19d69e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$3e9008bf1b19d69e$exports = $3e9008bf1b19d69e$var$_iterableToArrayLimit, $3e9008bf1b19d69e$exports.__esModule = true, $3e9008bf1b19d69e$exports["default"] = $3e9008bf1b19d69e$exports;


var $f8ea3661e445e78f$exports = {};
var $0c805c6ab2b20e00$exports = {};
function $0c805c6ab2b20e00$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$0c805c6ab2b20e00$exports = $0c805c6ab2b20e00$var$_arrayLikeToArray, $0c805c6ab2b20e00$exports.__esModule = true, $0c805c6ab2b20e00$exports["default"] = $0c805c6ab2b20e00$exports;


function $f8ea3661e445e78f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0c805c6ab2b20e00$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0c805c6ab2b20e00$exports(r, a) : void 0;
    }
}
$f8ea3661e445e78f$exports = $f8ea3661e445e78f$var$_unsupportedIterableToArray, $f8ea3661e445e78f$exports.__esModule = true, $f8ea3661e445e78f$exports["default"] = $f8ea3661e445e78f$exports;


var $d815b31d20479f77$exports = {};
function $d815b31d20479f77$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$d815b31d20479f77$exports = $d815b31d20479f77$var$_nonIterableRest, $d815b31d20479f77$exports.__esModule = true, $d815b31d20479f77$exports["default"] = $d815b31d20479f77$exports;


function $3da3a464c4f25a95$var$_slicedToArray(r, e) {
    return $63cfbe2919279800$exports(r) || $3e9008bf1b19d69e$exports(r, e) || $f8ea3661e445e78f$exports(r, e) || $d815b31d20479f77$exports();
}
$3da3a464c4f25a95$exports = $3da3a464c4f25a95$var$_slicedToArray, $3da3a464c4f25a95$exports.__esModule = true, $3da3a464c4f25a95$exports["default"] = $3da3a464c4f25a95$exports;


var $3fbab45da8908e5d$exports = {};
var $360cd2883cdf4766$exports = {};
function $360cd2883cdf4766$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$360cd2883cdf4766$exports = $360cd2883cdf4766$var$_objectWithoutPropertiesLoose, $360cd2883cdf4766$exports.__esModule = true, $360cd2883cdf4766$exports["default"] = $360cd2883cdf4766$exports;


function $3fbab45da8908e5d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $360cd2883cdf4766$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$3fbab45da8908e5d$exports = $3fbab45da8908e5d$var$_objectWithoutProperties, $3fbab45da8908e5d$exports.__esModule = true, $3fbab45da8908e5d$exports["default"] = $3fbab45da8908e5d$exports;


var $a5cad964f99fb2c3$exports = {};
function $a5cad964f99fb2c3$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$a5cad964f99fb2c3$exports = $a5cad964f99fb2c3$var$_classCallCheck, $a5cad964f99fb2c3$exports.__esModule = true, $a5cad964f99fb2c3$exports["default"] = $a5cad964f99fb2c3$exports;


var $9c3d0797ba609d31$exports = {};

function $9c3d0797ba609d31$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $2d45e7d1751976af$exports(o.key), o);
    }
}
function $9c3d0797ba609d31$var$_createClass(e, r, t) {
    return r && $9c3d0797ba609d31$var$_defineProperties(e.prototype, r), t && $9c3d0797ba609d31$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$9c3d0797ba609d31$exports = $9c3d0797ba609d31$var$_createClass, $9c3d0797ba609d31$exports.__esModule = true, $9c3d0797ba609d31$exports["default"] = $9c3d0797ba609d31$exports;


var $dc8cc396f821b0a8$exports = {};
var $510b8202c0bdb15c$exports = {};
function $510b8202c0bdb15c$var$_setPrototypeOf(t, e) {
    return $510b8202c0bdb15c$exports = $510b8202c0bdb15c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $510b8202c0bdb15c$exports.__esModule = true, $510b8202c0bdb15c$exports["default"] = $510b8202c0bdb15c$exports, $510b8202c0bdb15c$var$_setPrototypeOf(t, e);
}
$510b8202c0bdb15c$exports = $510b8202c0bdb15c$var$_setPrototypeOf, $510b8202c0bdb15c$exports.__esModule = true, $510b8202c0bdb15c$exports["default"] = $510b8202c0bdb15c$exports;


function $dc8cc396f821b0a8$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $510b8202c0bdb15c$exports(t, e);
}
$dc8cc396f821b0a8$exports = $dc8cc396f821b0a8$var$_inherits, $dc8cc396f821b0a8$exports.__esModule = true, $dc8cc396f821b0a8$exports["default"] = $dc8cc396f821b0a8$exports;


var $3f7874f386257ef2$exports = {};
var $0c39d531e1d2fcb8$exports = {};
function $0c39d531e1d2fcb8$var$_getPrototypeOf(t) {
    return $0c39d531e1d2fcb8$exports = $0c39d531e1d2fcb8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $0c39d531e1d2fcb8$exports.__esModule = true, $0c39d531e1d2fcb8$exports["default"] = $0c39d531e1d2fcb8$exports, $0c39d531e1d2fcb8$var$_getPrototypeOf(t);
}
$0c39d531e1d2fcb8$exports = $0c39d531e1d2fcb8$var$_getPrototypeOf, $0c39d531e1d2fcb8$exports.__esModule = true, $0c39d531e1d2fcb8$exports["default"] = $0c39d531e1d2fcb8$exports;


var $4840a32d143a2f3e$exports = {};
function $4840a32d143a2f3e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4840a32d143a2f3e$exports = $4840a32d143a2f3e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $4840a32d143a2f3e$exports.__esModule = true, $4840a32d143a2f3e$exports["default"] = $4840a32d143a2f3e$exports)();
}
$4840a32d143a2f3e$exports = $4840a32d143a2f3e$var$_isNativeReflectConstruct, $4840a32d143a2f3e$exports.__esModule = true, $4840a32d143a2f3e$exports["default"] = $4840a32d143a2f3e$exports;


var $f7963070e3843713$exports = {};

var $f7963070e3843713$var$_typeof = $715dc430e2b383a4$exports.default;
var $6988b3ddfda8f428$exports = {};
function $6988b3ddfda8f428$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$6988b3ddfda8f428$exports = $6988b3ddfda8f428$var$_assertThisInitialized, $6988b3ddfda8f428$exports.__esModule = true, $6988b3ddfda8f428$exports["default"] = $6988b3ddfda8f428$exports;


function $f7963070e3843713$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $f7963070e3843713$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6988b3ddfda8f428$exports(t);
}
$f7963070e3843713$exports = $f7963070e3843713$var$_possibleConstructorReturn, $f7963070e3843713$exports.__esModule = true, $f7963070e3843713$exports["default"] = $f7963070e3843713$exports;


function $3f7874f386257ef2$var$_createSuper(t) {
    var r = $4840a32d143a2f3e$exports();
    return function() {
        var e, o = $0c39d531e1d2fcb8$exports(t);
        if (r) {
            var s = $0c39d531e1d2fcb8$exports(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $f7963070e3843713$exports(this, e);
    };
}
$3f7874f386257ef2$exports = $3f7874f386257ef2$var$_createSuper, $3f7874f386257ef2$exports.__esModule = true, $3f7874f386257ef2$exports["default"] = $3f7874f386257ef2$exports;


var $38e9cb32b880d505$exports = {};
var $b202f98d427fc71f$exports = {};

function $b202f98d427fc71f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $0c805c6ab2b20e00$exports(r);
}
$b202f98d427fc71f$exports = $b202f98d427fc71f$var$_arrayWithoutHoles, $b202f98d427fc71f$exports.__esModule = true, $b202f98d427fc71f$exports["default"] = $b202f98d427fc71f$exports;


var $5d24f5c3fdb8a34e$exports = {};
function $5d24f5c3fdb8a34e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$5d24f5c3fdb8a34e$exports = $5d24f5c3fdb8a34e$var$_iterableToArray, $5d24f5c3fdb8a34e$exports.__esModule = true, $5d24f5c3fdb8a34e$exports["default"] = $5d24f5c3fdb8a34e$exports;



var $688f0820ebc8f7d8$exports = {};
function $688f0820ebc8f7d8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$688f0820ebc8f7d8$exports = $688f0820ebc8f7d8$var$_nonIterableSpread, $688f0820ebc8f7d8$exports.__esModule = true, $688f0820ebc8f7d8$exports["default"] = $688f0820ebc8f7d8$exports;


function $38e9cb32b880d505$var$_toConsumableArray(r) {
    return $b202f98d427fc71f$exports(r) || $5d24f5c3fdb8a34e$exports(r) || $f8ea3661e445e78f$exports(r) || $688f0820ebc8f7d8$exports();
}
$38e9cb32b880d505$exports = $38e9cb32b880d505$var$_toConsumableArray, $38e9cb32b880d505$exports.__esModule = true, $38e9cb32b880d505$exports["default"] = $38e9cb32b880d505$exports;




var $9b556aec2fa59483$exports = {};
function $9b556aec2fa59483$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$9b556aec2fa59483$exports = $9b556aec2fa59483$var$_taggedTemplateLiteral, $9b556aec2fa59483$exports.__esModule = true, $9b556aec2fa59483$exports["default"] = $9b556aec2fa59483$exports;






var $13b5ae22f3a5f453$var$StateManagedSelect = /*#__PURE__*/ (0, $igtsr.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $afa1945330c5db5a$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $igtsr.createElement((0, $eb3d1cb3aeb92345$export$25ce5a424b770e84), (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $13b5ae22f3a5f453$export$2e2bcd8739ae039 = $13b5ae22f3a5f453$var$StateManagedSelect;
var $13b5ae22f3a5f453$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $igtsr.useMemo)(function() {
        return (0, $b8a4fe01284b23aa$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $igtsr.createElement((0, $2bdc3d42be222695$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};



parcelRequire("igtsr");
const $13960f66e93198e5$var$SvgLeftArrow = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 492 492",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            d: "M198.608 246.104 382.664 62.04c5.068-5.056 7.856-11.816 7.856-19.024 0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476 2.792 354.712 0 347.504 0s-13.964 2.792-19.028 7.864L109.328 227.008c-5.084 5.08-7.868 11.868-7.848 19.084-.02 7.248 2.76 14.028 7.848 19.112l218.944 218.932c5.064 5.072 11.82 7.864 19.032 7.864 7.208 0 13.964-2.792 19.032-7.864l16.124-16.12c10.492-10.492 10.492-27.572 0-38.06z"
        })
    });
var $13960f66e93198e5$export$2e2bcd8739ae039 = $13960f66e93198e5$var$SvgLeftArrow;




/**
 * @author Karim Shalapy
 * @date 2022-10-03
 * @description implementation of the advanced filters search bar dropdown indicator.
 * @filename dropdown-indicator.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


parcelRequire("igtsr");
const $8b68e0e8727d6658$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.777 14.503a.84.84 0 0 1-.003 1.143.74.74 0 0 1-1.079.003l-3.822-4.048c-2.401 1.979-5.874 1.8-8.08-.537-2.39-2.531-2.39-6.635 0-9.166 2.39-2.53 6.264-2.53 8.654 0 2.207 2.337 2.376 6.015.508 8.557zm-5.412-4.585c1.793-1.898 1.793-4.976 0-6.874s-4.698-1.898-6.49 0c-1.793 1.898-1.793 4.976 0 6.874s4.698 1.898 6.49 0"
        })
    });
var $8b68e0e8727d6658$export$2e2bcd8739ae039 = $8b68e0e8727d6658$var$SvgSearch;


class $acbaa279ab43541b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fd2d8f4ba4dfaac6$export$db3b6bfb95261072).DropdownIndicator, {
            ...this.props,
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8b68e0e8727d6658$export$2e2bcd8739ae039), {
                width: 20,
                height: 20
            })
        });
    }
}




var $igtsr = parcelRequire("igtsr");





var $411361d126b96070$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $411361d126b96070$var$isEqual(first, second) {
    if (first === second) return true;
    if ($411361d126b96070$var$safeIsNaN(first) && $411361d126b96070$var$safeIsNaN(second)) return true;
    return false;
}
function $411361d126b96070$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$411361d126b96070$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $411361d126b96070$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $411361d126b96070$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $411361d126b96070$export$2e2bcd8739ae039 = $411361d126b96070$var$memoizeOne;



var $igtsr = parcelRequire("igtsr");

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $37e722b4fadcc3c6$var$hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var $37e722b4fadcc3c6$var$now = $37e722b4fadcc3c6$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $37e722b4fadcc3c6$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $37e722b4fadcc3c6$var$requestTimeout(callback, delay) {
    var start = $37e722b4fadcc3c6$var$now();
    function tick() {
        if ($37e722b4fadcc3c6$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $37e722b4fadcc3c6$var$size = -1; // This utility copied from "dom-helpers" package.
function $37e722b4fadcc3c6$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($37e722b4fadcc3c6$var$size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        $37e722b4fadcc3c6$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $37e722b4fadcc3c6$var$size;
}
var $37e722b4fadcc3c6$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $37e722b4fadcc3c6$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($37e722b4fadcc3c6$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $37e722b4fadcc3c6$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $37e722b4fadcc3c6$var$cachedRTLResult = 'negative';
            else $37e722b4fadcc3c6$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $37e722b4fadcc3c6$var$cachedRTLResult;
    }
    return $37e722b4fadcc3c6$var$cachedRTLResult;
}
var $37e722b4fadcc3c6$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $37e722b4fadcc3c6$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $37e722b4fadcc3c6$var$devWarningsOverscanCount = null;
var $37e722b4fadcc3c6$var$devWarningsOverscanRowsColumnsCount = null;
var $37e722b4fadcc3c6$var$devWarningsTagName = null;
function $37e722b4fadcc3c6$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $2179a99969e1c4c8$export$2e2bcd8739ae039)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $2179a99969e1c4c8$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $411361d126b96070$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $411361d126b96070$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $411361d126b96070$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch($37e722b4fadcc3c6$var$getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $37e722b4fadcc3c6$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $37e722b4fadcc3c6$var$requestTimeout(_this._resetIsScrolling, $37e722b4fadcc3c6$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $37e722b4fadcc3c6$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $37e722b4fadcc3c6$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch($37e722b4fadcc3c6$var$getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $37e722b4fadcc3c6$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $37e722b4fadcc3c6$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $igtsr.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $igtsr.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $igtsr.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $igtsr.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $37e722b4fadcc3c6$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $37e722b4fadcc3c6$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $37e722b4fadcc3c6$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $37e722b4fadcc3c6$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $37e722b4fadcc3c6$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $37e722b4fadcc3c6$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $37e722b4fadcc3c6$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $37e722b4fadcc3c6$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $37e722b4fadcc3c6$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $37e722b4fadcc3c6$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $37e722b4fadcc3c6$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $37e722b4fadcc3c6$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $37e722b4fadcc3c6$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $37e722b4fadcc3c6$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = $37e722b4fadcc3c6$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? $37e722b4fadcc3c6$var$getEstimatedTotalWidth(props, instanceProps) : $37e722b4fadcc3c6$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $37e722b4fadcc3c6$export$32c206c84102e73c = /*#__PURE__*/ $37e722b4fadcc3c6$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $37e722b4fadcc3c6$var$getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $37e722b4fadcc3c6$var$findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $37e722b4fadcc3c6$var$getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $37e722b4fadcc3c6$var$getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $37e722b4fadcc3c6$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $37e722b4fadcc3c6$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $37e722b4fadcc3c6$var$getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $37e722b4fadcc3c6$var$getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $37e722b4fadcc3c6$var$getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $37e722b4fadcc3c6$var$findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $37e722b4fadcc3c6$var$getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $37e722b4fadcc3c6$var$getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $37e722b4fadcc3c6$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $37e722b4fadcc3c6$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $37e722b4fadcc3c6$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $37e722b4fadcc3c6$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $37e722b4fadcc3c6$var$devWarningsDirection = null;
var $37e722b4fadcc3c6$var$devWarningsTagName$1 = null;
function $37e722b4fadcc3c6$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $2e83e59386d743bc$export$2e2bcd8739ae039)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $2179a99969e1c4c8$export$2e2bcd8739ae039)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $2179a99969e1c4c8$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $411361d126b96070$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $411361d126b96070$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $411361d126b96070$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($37e722b4fadcc3c6$var$getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $37e722b4fadcc3c6$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $37e722b4fadcc3c6$var$requestTimeout(_this._resetIsScrolling, $37e722b4fadcc3c6$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $37e722b4fadcc3c6$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === 'vertical') scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $37e722b4fadcc3c6$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $37e722b4fadcc3c6$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($37e722b4fadcc3c6$var$getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $37e722b4fadcc3c6$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $37e722b4fadcc3c6$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $igtsr.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $igtsr.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $24ebcff9d5a3a551$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $igtsr.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $igtsr.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $37e722b4fadcc3c6$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $37e722b4fadcc3c6$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $37e722b4fadcc3c6$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $37e722b4fadcc3c6$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $37e722b4fadcc3c6$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $37e722b4fadcc3c6$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $37e722b4fadcc3c6$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $37e722b4fadcc3c6$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $37e722b4fadcc3c6$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $37e722b4fadcc3c6$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $37e722b4fadcc3c6$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $37e722b4fadcc3c6$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $37e722b4fadcc3c6$export$d8ac3b6b20be856e = /*#__PURE__*/ $37e722b4fadcc3c6$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $37e722b4fadcc3c6$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $37e722b4fadcc3c6$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $37e722b4fadcc3c6$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $37e722b4fadcc3c6$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $37e722b4fadcc3c6$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $37e722b4fadcc3c6$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $37e722b4fadcc3c6$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $37e722b4fadcc3c6$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $37e722b4fadcc3c6$export$f331158cccad7361 = /*#__PURE__*/ $37e722b4fadcc3c6$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $37e722b4fadcc3c6$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $37e722b4fadcc3c6$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $37e722b4fadcc3c6$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $37e722b4fadcc3c6$var$_excluded = [
    "style"
], $37e722b4fadcc3c6$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $37e722b4fadcc3c6$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(prevProps, $37e722b4fadcc3c6$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $d92ff26bfbf1e93c$export$2e2bcd8739ae039)(nextProps, $37e722b4fadcc3c6$var$_excluded2);
    return !$37e722b4fadcc3c6$var$shallowDiffers(prevStyle, nextStyle) && !$37e722b4fadcc3c6$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $37e722b4fadcc3c6$export$aa365c903ed149ff(nextProps, nextState) {
    return !$37e722b4fadcc3c6$export$b141efd0b0fb9174(this.props, nextProps) || $37e722b4fadcc3c6$var$shallowDiffers(this.state, nextState);
}


const $6695ba336f042c4a$var$LIST_ITEM_HEIGHT = 35; // px
class $6695ba336f042c4a$var$MenuList extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        const { children: children, maxHeight: maxHeight, t: t } = this.props;
        const count = Array.isArray(children) ? children.length : 0;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: [
                !count && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fd2d8f4ba4dfaac6$export$db3b6bfb95261072).NoOptionsMessage, {
                    ...this.props,
                    children: t("noOptions")
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $37e722b4fadcc3c6$export$ae9e55e1d8a2f4b7), {
                    height: Math.min(maxHeight, count * $6695ba336f042c4a$var$LIST_ITEM_HEIGHT),
                    itemCount: count,
                    itemSize: $6695ba336f042c4a$var$LIST_ITEM_HEIGHT,
                    width: "100%",
                    children: ({ index: index, style: style })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            style: style,
                            children: children[index]
                        })
                })
            ]
        });
    }
}
var $6695ba336f042c4a$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "filters"
])($6695ba336f042c4a$var$MenuList);


const $789ef595f3f8fe07$var$customTheme = (theme)=>({
        ...theme,
        colors: {
            ...theme.colors,
            primary: "rgba(69, 194, 255, 1)",
            primary25: "rgba(69, 194, 255, 0.1)"
        }
    });
const $789ef595f3f8fe07$var$customStyles = {
    control (provided) {
        const backgroundColor = "hsla(0, 0%, 0%, 0.03)";
        return {
            ...provided,
            borderRadius: 10,
            backgroundColor: backgroundColor
        };
    },
    multiValue (provided) {
        return {
            ...provided,
            padding: "5px 10px",
            borderRadius: "50000px",
            backgroundColor: "hsla(217, 90%, 61%, 0.1)",
            gap: 10
        };
    },
    multiValueRemove (provided) {
        return {
            ...provided,
            borderRadius: "50%",
            backgroundColor: "black",
            color: "white"
        };
    }
};
class $789ef595f3f8fe07$var$CreateSegment extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            segmentName: this.props.segment?.title || "",
            flattenedFilters: {},
            selectedFilters: {},
            id: Date.now().toString()
        };
    }
    componentDidMount() {
        this.updateFiltersState();
        this.context.addUpdatesListener(this.state.id, this.updateFiltersState);
        console.log("hi");
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    getIsAllSelected(key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gagb8)))(this.state.selectedFilters[key], this.state.flattenedFilters[key]);
    }
    updateFiltersState() {
        this.setState({
            flattenedFilters: (0, $eadf35cb023988c9$export$a15b0df135c91f7e)(this.context.availableFilters),
            selectedFilters: (0, $eadf35cb023988c9$export$a15b0df135c91f7e)(this.props.segment === this.context.appliedFiltersSegment ? this.context.appliedFilters : this.props.segment?.filters)
        });
    }
    changeHandler(key, value) {
        if (this.state.selectedFilters[key]?.includes(value)) this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: this.state.selectedFilters[key].filter((storedValue)=>storedValue !== value)
            }
        });
        else this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: (this.state.selectedFilters[key] || []).concat(value)
            }
        });
    }
    selectAll(key) {
        if (this.getIsAllSelected(key)) this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: []
            }
        });
        else this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: this.state.flattenedFilters[key]
            }
        });
    }
    createNewSegmentHandler() {
        (0, $eadf35cb023988c9$export$56efeea303eae211)({
            title: this.state.segmentName,
            filtersArg: this.state.selectedFilters,
            project: this.context.project
        }).then((segment)=>{
            this.props.toggleCreateANewSegment();
            this.context.updateAppliedFiltersSegment(segment);
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Segment created successfully", {
                position: "top-left"
            });
            this.context.updateAppliedFilters(this.state.selectedFilters);
            // add the newly created segment to the list of available segments
            this.context.updateFiltersSegments([
                ...this.context.availableFiltersSegments,
                segment
            ]);
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error[0], {
                position: "top-left"
            });
        });
    }
    updateSegmentHandler() {
        (0, $eadf35cb023988c9$export$8a13e1c9e60c7715)({
            project: this.context.project,
            id: this.props.segment.id,
            filtersArg: this.state.selectedFilters,
            title: this.state.segmentName
        }).then(()=>{
            this.props.toggleCreateANewSegment();
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Segment updated successfully", {
                position: "top-left"
            });
            this.context.updateAppliedFilters(this.state.selectedFilters);
            this.context.updateAppliedFiltersSegment({
                ...this.props.segment,
                title: this.state.segmentName,
                filters: this.state.selectedFilters
            });
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error[0], {
                position: "top-left"
            });
        });
    }
    submitHandler(e) {
        e.preventDefault();
        if (this.props.segment) this.updateSegmentHandler();
        else this.createNewSegmentHandler();
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "create-segment",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("section", {
                className: "create-segment__main",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "create-segment__back",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                className: "button-underlined black",
                                onClick: this.props.toggleCreateANewSegment,
                                type: "button",
                                children: t("back")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                        onSubmit: (e)=>this.submitHandler(e),
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("fieldset", {
                                className: "advanced-filters__fieldset form-field",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("legend", {
                                        children: t("segmentName")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        type: "text",
                                        id: "segmentName",
                                        name: "segmentName",
                                        placeholder: t("enterSegmentName"),
                                        value: this.state.segmentName,
                                        onChange: (e)=>this.setState({
                                                segmentName: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "advanced-filters",
                                children: [
                                    this.context.loadingFilters ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {}) : Object.keys(this.state.flattenedFilters)// MOVE THE `SHIPPING_LOCATIONS_KEY` TO THE LAST INDEX
                                    .sort((a, b)=>{
                                        return a === (0, $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8) ? 1 : b === (0, $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8) ? -1 : 0;
                                    }).map((key)=>{
                                        return key !== (0, $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8) ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("fieldset", {
                                            className: "advanced-filters__fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("legend", {
                                                    children: key === "state" ? t("orderState") : t(key)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "advanced-filters__field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: `select-all-${key}`,
                                                            children: "All"
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            name: `all-${key}`,
                                                            id: `select-all-${key}`,
                                                            checked: this.getIsAllSelected(key),
                                                            onChange: ()=>this.selectAll(key)
                                                        })
                                                    ]
                                                }),
                                                this.state.flattenedFilters[key].map((filter)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "advanced-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                htmlFor: `${key}-${filter}`,
                                                                children: filter
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                name: key,
                                                                id: `${key}-${filter}`,
                                                                value: filter,
                                                                checked: !!this.state.selectedFilters[key]?.includes(filter),
                                                                onChange: ()=>this.changeHandler(key, filter)
                                                            })
                                                        ]
                                                    }, `${key}-${filter}`))
                                            ]
                                        }, key) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("fieldset", {
                                            className: "advanced-filters__fieldset advanced-filters__location-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("legend", {
                                                    children: t(key)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13b5ae22f3a5f453$export$2e2bcd8739ae039), {
                                                    id: `${key}-input-container`,
                                                    inputId: `${key}-input`,
                                                    placeholder: t("searchLocationPlaceholder"),
                                                    theme: $789ef595f3f8fe07$var$customTheme,
                                                    styles: $789ef595f3f8fe07$var$customStyles,
                                                    components: {
                                                        DropdownIndicator: $acbaa279ab43541b$export$2e2bcd8739ae039,
                                                        MenuList: $6695ba336f042c4a$export$2e2bcd8739ae039
                                                    },
                                                    options: (0, $eadf35cb023988c9$export$716cad129d2949a9)(this.state.flattenedFilters[key]),
                                                    value: (0, $eadf35cb023988c9$export$716cad129d2949a9)(this.state.selectedFilters[key]),
                                                    onChange: (val)=>{
                                                        const value = Array.isArray(val) ? val : [
                                                            val
                                                        ];
                                                        this.setState((prev)=>({
                                                                selectedFilters: {
                                                                    ...prev.selectedFilters,
                                                                    [key]: (0, $eadf35cb023988c9$export$247b78adad87d126)(value)
                                                                }
                                                            }));
                                                    },
                                                    isMulti: true,
                                                    isClearable: true
                                                })
                                            ]
                                        }, key);
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "advanced-filters__cta",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                className: "button-underlined  black",
                                                type: "button",
                                                onClick: ()=>this.setState({
                                                        selectedFilters: {}
                                                    }),
                                                children: t("reset", {
                                                    ns: "settings"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                className: "button-primary small black",
                                                type: "submit",
                                                children: this.props.segment ? t("updateSegment") : t("createSegment")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
$789ef595f3f8fe07$var$CreateSegment.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $789ef595f3f8fe07$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "filters"
])($789ef595f3f8fe07$var$CreateSegment);


/**
 * @author Ahmed Serag
 * @date 2019-07-15
 * @description declaration of available routes in the app.
 * @filename routes.ts
 */ /* eslint-disable react/jsx-curly-newline */ /**
 * @author Youssef Tarek
 * @date 2022-03-15
 * @description Abandoned carts screen of the App
 * @filename abandoned-carts.tsx
 */ 


var $igtsr = parcelRequire("igtsr");



var $4l1Xa = parcelRequire("4l1Xa");


/**
 * @author Youssef Tarek
 * @date 2022-03-28
 * @description Implementation of Abandoned Carts related utilities
 * @filename abandoned-carts.ts
 */ /**
 * @author Youssef Tarek
 * @date 2022-03-28
 * @description implementation of Abandoned Carts related API calls.
 * @filename abandoned-carts.ts
 */ 

class $95cdfd10659d4062$export$65d477113131279f {
    static getAbandonedCarts({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAbandonedCarts.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAbandonedCarts.method
        });
    }
}



function $b3d35f81c94dd86a$export$57100c9b4bc4bd8f(payload) {
    return (0, $95cdfd10659d4062$export$65d477113131279f).getAbandonedCarts(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}




var $4l1Xa = parcelRequire("4l1Xa");
/*!
  react-datepicker v8.3.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 

var $igtsr = parcelRequire("igtsr");


function $7e9256537c988851$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$7e9256537c988851$export$2e2bcd8739ae039 = $7e9256537c988851$export$baf757aaf0c95c94;



function $10b3510745eb4a7b$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $7e9256537c988851$export$baf757aaf0c95c94)(date, amount * (0, $3db87186a9f4bd75$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$10b3510745eb4a7b$export$2e2bcd8739ae039 = $10b3510745eb4a7b$export$4a4306ad4fa0e5e6;



function $22f30f6db3721034$export$2287e3d29250119e(date, amount, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    _date.setTime(_date.getTime() + amount * (0, $3db87186a9f4bd75$export$91246f0b9bd9beff));
    return _date;
}
var // Fallback for modularized imports:
$22f30f6db3721034$export$2e2bcd8739ae039 = $22f30f6db3721034$export$2287e3d29250119e;


function $8be8906ab05d096d$export$c252a41d0fbed2ce(date, amount, options) {
    return (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(date, amount * 3, options);
}
var // Fallback for modularized imports:
$8be8906ab05d096d$export$2e2bcd8739ae039 = $8be8906ab05d096d$export$c252a41d0fbed2ce;


function $970cd96a21d4fd03$export$3cb31b0df13be68(date, amount, options) {
    return (0, $7e9256537c988851$export$baf757aaf0c95c94)(date, amount * 1000, options);
}
var // Fallback for modularized imports:
$970cd96a21d4fd03$export$2e2bcd8739ae039 = $970cd96a21d4fd03$export$3cb31b0df13be68;


function $9b66ea05774b3092$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$9b66ea05774b3092$export$2e2bcd8739ae039 = $9b66ea05774b3092$export$ef501a2bb4f3ee6b;


function $23645b8f1c5acc22$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$23645b8f1c5acc22$export$2e2bcd8739ae039 = $23645b8f1c5acc22$export$489984ac7c996389;



function $8de2b2935de63c65$export$de90a4bb31c25221(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}
var // Fallback for modularized imports:
$8de2b2935de63c65$export$2e2bcd8739ae039 = $8de2b2935de63c65$export$de90a4bb31c25221;


function $a178ede58156510d$export$f62ae9fb13958c7a(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const quartersDiff = (0, $8de2b2935de63c65$export$de90a4bb31c25221)(laterDate_) - (0, $8de2b2935de63c65$export$de90a4bb31c25221)(earlierDate_);
    return yearsDiff * 4 + quartersDiff;
}
var // Fallback for modularized imports:
$a178ede58156510d$export$2e2bcd8739ae039 = $a178ede58156510d$export$f62ae9fb13958c7a;


function $8ea362b00a47a9b7$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$8ea362b00a47a9b7$export$2e2bcd8739ae039 = $8ea362b00a47a9b7$export$c06dce8b38891685;



function $0e206fafd570fe71$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const sign = $0e206fafd570fe71$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $2efa7f87d37460af$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($0e206fafd570fe71$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $0e206fafd570fe71$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$0e206fafd570fe71$export$2e2bcd8739ae039 = $0e206fafd570fe71$export$86415ebf4eb36b8c;


function $f92e3fd6ae51bdb5$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$f92e3fd6ae51bdb5$export$2e2bcd8739ae039 = $f92e3fd6ae51bdb5$export$eb9a03f0e9aa6cea;


function $0686a4d407c7043b$export$a2258d9c4118825c(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$0686a4d407c7043b$export$2e2bcd8739ae039 = $0686a4d407c7043b$export$a2258d9c4118825c;



function $a2f45d6e9fc115f1$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $5ff879255cceef79$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$a2f45d6e9fc115f1$export$2e2bcd8739ae039 = $a2f45d6e9fc115f1$export$ef8b6d9133084f4e;


function $31fb3e9fe53f60ea$export$aa350b96d91cd94(date, options) {
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in).getDate();
}
var // Fallback for modularized imports:
$31fb3e9fe53f60ea$export$2e2bcd8739ae039 = $31fb3e9fe53f60ea$export$aa350b96d91cd94;


function $4248408440acfe88$export$1b64bc9c5306ed54(date, options) {
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in).getDay();
}
var // Fallback for modularized imports:
$4248408440acfe88$export$2e2bcd8739ae039 = $4248408440acfe88$export$1b64bc9c5306ed54;


function $29e2039a3da06fd6$export$257b40f71c07d58f(date, options) {
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in).getHours();
}
var // Fallback for modularized imports:
$29e2039a3da06fd6$export$2e2bcd8739ae039 = $29e2039a3da06fd6$export$257b40f71c07d58f;


function $f254ca1d67327c34$export$b7f1bc3ea3ac4145(date, options) {
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in).getMinutes();
}
var // Fallback for modularized imports:
$f254ca1d67327c34$export$2e2bcd8739ae039 = $f254ca1d67327c34$export$b7f1bc3ea3ac4145;


function $de31b03371614c55$export$6ce1b5acc29cb53b(date, options) {
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in).getMonth();
}
var // Fallback for modularized imports:
$de31b03371614c55$export$2e2bcd8739ae039 = $de31b03371614c55$export$6ce1b5acc29cb53b;


function $8ba4d80c4f8124c6$export$5e9417507ff28427(date) {
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date).getSeconds();
}
var // Fallback for modularized imports:
$8ba4d80c4f8124c6$export$2e2bcd8739ae039 = $8ba4d80c4f8124c6$export$5e9417507ff28427;


function $12bf5b0d84b5c63d$export$1428f42a7de81803(date) {
    return +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date);
}
var // Fallback for modularized imports:
$12bf5b0d84b5c63d$export$2e2bcd8739ae039 = $12bf5b0d84b5c63d$export$1428f42a7de81803;


function $064d553b51baf3e9$export$5846dc2d57a5c860(date, options) {
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in).getFullYear();
}
var // Fallback for modularized imports:
$064d553b51baf3e9$export$2e2bcd8739ae039 = $064d553b51baf3e9$export$5846dc2d57a5c860;


function $89f716961fb46e12$export$e4de839670987035(date, dateToCompare) {
    return +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date) > +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$89f716961fb46e12$export$2e2bcd8739ae039 = $89f716961fb46e12$export$e4de839670987035;


function $ec5a63c4588c1c61$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date) < +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$ec5a63c4588c1c61$export$2e2bcd8739ae039 = $ec5a63c4588c1c61$export$5c007e10c6929c95;


function $75fc031f7966174f$export$248d38f6296296c5(leftDate, rightDate) {
    return +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(leftDate) === +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(rightDate);
}
var // Fallback for modularized imports:
$75fc031f7966174f$export$2e2bcd8739ae039 = $75fc031f7966174f$export$248d38f6296296c5;



function $900cc00d4a65f84f$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$900cc00d4a65f84f$export$2e2bcd8739ae039 = $900cc00d4a65f84f$export$ea39ec197993aef0;


function $2ab718cd17362052$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$2ab718cd17362052$export$2e2bcd8739ae039 = $2ab718cd17362052$export$a18c89cbd24170ff;



function $b4c5ff470530ccad$export$5c60e4190867161c(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(dateLeft_) === +(0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(dateRight_);
}
var // Fallback for modularized imports:
$b4c5ff470530ccad$export$2e2bcd8739ae039 = $b4c5ff470530ccad$export$5c60e4190867161c;


function $5d41b97ed555f92b$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $57652c90c52675bd$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$5d41b97ed555f92b$export$2e2bcd8739ae039 = $5d41b97ed555f92b$export$5841f9eb9773f25f;


function $7ae0f7ba0fce2f7b$export$d7deef7a3738e19d(date, interval, options) {
    const time = +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const [startTime, endTime] = [
        +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(interval.start, options?.in),
        +(0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(interval.end, options?.in)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$7ae0f7ba0fce2f7b$export$2e2bcd8739ae039 = $7ae0f7ba0fce2f7b$export$d7deef7a3738e19d;



function $ab8ba948e852157d$export$8960430cfd85939f(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $a960433738d4e8b2$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, $a960433738d4e8b2$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$ab8ba948e852157d$export$2e2bcd8739ae039 = $ab8ba948e852157d$export$8960430cfd85939f;



function $9c2757f1d5701b76$export$96ec731ed4dcb222(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $a960433738d4e8b2$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, $a960433738d4e8b2$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$9c2757f1d5701b76$export$2e2bcd8739ae039 = $9c2757f1d5701b76$export$96ec731ed4dcb222;






function $41c5c6734a0b7e74$export$430a3269e24b912e() {
    return Object.assign({}, (0, $5ff879255cceef79$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$41c5c6734a0b7e74$export$2e2bcd8739ae039 = $41c5c6734a0b7e74$export$430a3269e24b912e;





function $718db982f2459b58$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $718db982f2459b58$var$isConstructor(constructor) ? new constructor(0) : (0, $a960433738d4e8b2$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $718db982f2459b58$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$718db982f2459b58$export$2e2bcd8739ae039 = $718db982f2459b58$export$9cb09a71b7d66923;


const $99e1a98cd29f1544$var$TIMEZONE_UNIT_PRIORITY = 10;
class $99e1a98cd29f1544$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $99e1a98cd29f1544$export$9a09e32dd4990fd5 extends $99e1a98cd29f1544$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $99e1a98cd29f1544$export$8be15fe85ad72f86 extends $99e1a98cd29f1544$export$81d53e3678089a6 {
    priority = $99e1a98cd29f1544$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $a960433738d4e8b2$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $a960433738d4e8b2$export$ead8a1812b171991)(date, (0, $718db982f2459b58$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $57952d953c3b4230$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $99e1a98cd29f1544$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $e229c903b4fef8b3$export$8e5a1d3f85a9688 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $7466a5530055f398$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $7466a5530055f398$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7a6aebda21961ca3$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7a6aebda21961ca3$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7a6aebda21961ca3$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $3db87186a9f4bd75$export$7f72910d6dfd237a) + minutes * (0, $3db87186a9f4bd75$export$91246f0b9bd9beff) + seconds * (0, $3db87186a9f4bd75$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7a6aebda21961ca3$export$d931c43c4608a164(dateString) {
    return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $7a6aebda21961ca3$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7a6aebda21961ca3$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388((0, $7466a5530055f398$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $7a6aebda21961ca3$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7a6aebda21961ca3$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7a6aebda21961ca3$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7a6aebda21961ca3$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $4cb3ddcb5eda1038$export$48d352de7cd4a988 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7a6aebda21961ca3$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $5c36f2a1dc1a8cd6$export$b8ef38dfcf05d5db extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $bdb8160eeea7b4d7$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7a6aebda21961ca3$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}






class $5cb002bb65de4223$export$951d1df011fde06f extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7a6aebda21961ca3$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7a6aebda21961ca3$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $a960433738d4e8b2$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $917d7c36fbb881c1$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $e938dcbde1289855$export$bad9d2ea38e8f1a extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7a6aebda21961ca3$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7a6aebda21961ca3$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $c15a6a10cfe05772$export$5cb0f701186dde1d extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $0d510274e31932c2$export$300c0c2990e20e6d extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $d93e8db39178c56e$export$400dd8b40ef138a3 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $b541df175e4d592d$export$1d7eaa53eaa5deba extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




function $02c98e964deac3a4$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $32bbc44c2faaf1af$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$02c98e964deac3a4$export$2e2bcd8739ae039 = $02c98e964deac3a4$export$4b3066ce4afafd88;






class $191489a4e793e274$export$c4005ffc174e07c0 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)((0, $02c98e964deac3a4$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $febb6b7780561ba0$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $661b8d7938fc9bab$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$febb6b7780561ba0$export$2e2bcd8739ae039 = $febb6b7780561ba0$export$6542bebf6be94082;






class $820bf95f84e59274$export$6fc8dbedd560a6af extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $917d7c36fbb881c1$export$6173213f95a4431e)((0, $febb6b7780561ba0$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $fc8c76362d9c7402$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $fc8c76362d9c7402$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $fc8c76362d9c7402$export$e8d4b28a20981dd2 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7a6aebda21961ca3$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $fc8c76362d9c7402$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $fc8c76362d9c7402$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $047d21927995744a$export$6cfe0d613455f615 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7a6aebda21961ca3$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $11a2335ef0706f74$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $5ff879255cceef79$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$11a2335ef0706f74$export$2e2bcd8739ae039 = $11a2335ef0706f74$export$b04fdcda82decc6c;



class $2b396c751922810a$export$1b03c8b76262f7bd extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $11a2335ef0706f74$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $81d8cd8f2cb31bea$export$44d1c127ab42c480 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $11a2335ef0706f74$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $fbdfb3aa6049501d$export$e447a647caaaec1d extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $11a2335ef0706f74$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $9e5052b463ab39f1$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$9e5052b463ab39f1$export$2e2bcd8739ae039 = $9e5052b463ab39f1$export$c514f4c1a8ed5e9e;



function $1e6fb31215961d27$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $9e5052b463ab39f1$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$1e6fb31215961d27$export$2e2bcd8739ae039 = $1e6fb31215961d27$export$1fd9df65adb0d1aa;




class $ec032cb1f2775597$export$693fb1e525095b2a extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $1e6fb31215961d27$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $5a74f19e35e0a72f$export$8d1e08492351df91 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7a6aebda21961ca3$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $960c02554a9b8342$export$73ca2bd0a17d273 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7a6aebda21961ca3$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $aa2ccfd4ee592f22$export$bb9212adf05373db extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7a6aebda21961ca3$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $009a5a0048fa6e5d$export$8a04050a727a1756 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $29c05bc4eb1c5ab4$export$e56f4dea2c3e56dd extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $bde1c85914f39492$export$cbbe855312f87d77 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $a1ed2aef41345055$export$6008046d2b34b6a5 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $b8f2088626875f20$export$2b52670d9e2be53 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $6e9e978c6fd59ae3$export$94d46d540cf1366a extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7a6aebda21961ca3$export$cc7cc9e2a3ff9388)((0, $7466a5530055f398$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $cd75fab819447f75$export$b8e6f8b2d70893b1 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7a6aebda21961ca3$export$4f84e3a82c7b538)((0, $7a6aebda21961ca3$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $d119ee3c2f02e35b$export$104d901d49fea29b extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $a960433738d4e8b2$export$ead8a1812b171991)(date, date.getTime() - (0, $06d8a0c3d04b605b$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $0a2c0c92873107b3$export$12910e5204b52b9 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7a6aebda21961ca3$export$6497f4c0ecdfba8e)((0, $7466a5530055f398$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $a960433738d4e8b2$export$ead8a1812b171991)(date, date.getTime() - (0, $06d8a0c3d04b605b$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $1c4b9b9caeac807e$export$2cd8bf877a05e96 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $7a6aebda21961ca3$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $a960433738d4e8b2$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $2c8b5ce78c971e95$export$6d8f69c6906d6368 extends (0, $57952d953c3b4230$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $7a6aebda21961ca3$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $a960433738d4e8b2$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $71b2d17bca2cf57b$export$19131010e7fd8373 = {
    G: new (0, $e229c903b4fef8b3$export$8e5a1d3f85a9688)(),
    y: new (0, $4cb3ddcb5eda1038$export$48d352de7cd4a988)(),
    Y: new (0, $5c36f2a1dc1a8cd6$export$b8ef38dfcf05d5db)(),
    R: new (0, $5cb002bb65de4223$export$951d1df011fde06f)(),
    u: new (0, $e938dcbde1289855$export$bad9d2ea38e8f1a)(),
    Q: new (0, $c15a6a10cfe05772$export$5cb0f701186dde1d)(),
    q: new (0, $0d510274e31932c2$export$300c0c2990e20e6d)(),
    M: new (0, $d93e8db39178c56e$export$400dd8b40ef138a3)(),
    L: new (0, $b541df175e4d592d$export$1d7eaa53eaa5deba)(),
    w: new (0, $191489a4e793e274$export$c4005ffc174e07c0)(),
    I: new (0, $820bf95f84e59274$export$6fc8dbedd560a6af)(),
    d: new (0, $fc8c76362d9c7402$export$e8d4b28a20981dd2)(),
    D: new (0, $047d21927995744a$export$6cfe0d613455f615)(),
    E: new (0, $2b396c751922810a$export$1b03c8b76262f7bd)(),
    e: new (0, $81d8cd8f2cb31bea$export$44d1c127ab42c480)(),
    c: new (0, $fbdfb3aa6049501d$export$e447a647caaaec1d)(),
    i: new (0, $ec032cb1f2775597$export$693fb1e525095b2a)(),
    a: new (0, $5a74f19e35e0a72f$export$8d1e08492351df91)(),
    b: new (0, $960c02554a9b8342$export$73ca2bd0a17d273)(),
    B: new (0, $aa2ccfd4ee592f22$export$bb9212adf05373db)(),
    h: new (0, $009a5a0048fa6e5d$export$8a04050a727a1756)(),
    H: new (0, $29c05bc4eb1c5ab4$export$e56f4dea2c3e56dd)(),
    K: new (0, $bde1c85914f39492$export$cbbe855312f87d77)(),
    k: new (0, $a1ed2aef41345055$export$6008046d2b34b6a5)(),
    m: new (0, $b8f2088626875f20$export$2b52670d9e2be53)(),
    s: new (0, $6e9e978c6fd59ae3$export$94d46d540cf1366a)(),
    S: new (0, $cd75fab819447f75$export$b8e6f8b2d70893b1)(),
    X: new (0, $d119ee3c2f02e35b$export$104d901d49fea29b)(),
    x: new (0, $0a2c0c92873107b3$export$12910e5204b52b9)(),
    t: new (0, $1c4b9b9caeac807e$export$2cd8bf877a05e96)(),
    T: new (0, $2c8b5ce78c971e95$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $cb592846cd729ef7$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $cb592846cd729ef7$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $cb592846cd729ef7$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $cb592846cd729ef7$var$doubleQuoteRegExp = /''/g;
const $cb592846cd729ef7$var$notWhitespaceRegExp = /\S/;
const $cb592846cd729ef7$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $cb592846cd729ef7$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $41c5c6734a0b7e74$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $ebb1e9b94c2ad9db$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $99e1a98cd29f1544$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($cb592846cd729ef7$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $a26645436b6cda82$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $a26645436b6cda82$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($cb592846cd729ef7$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $f84ff0e8cd167fd6$export$c6b49d6dceb604a1)(token)) (0, $f84ff0e8cd167fd6$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $f84ff0e8cd167fd6$export$c6cc36aa33304772)(token)) (0, $f84ff0e8cd167fd6$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $71b2d17bca2cf57b$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($cb592846cd729ef7$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $cb592846cd729ef7$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $cb592846cd729ef7$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $cb592846cd729ef7$var$cleanEscapedString(input) {
    return input.match($cb592846cd729ef7$var$escapedStringRegExp)[1].replace($cb592846cd729ef7$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$cb592846cd729ef7$export$2e2bcd8739ae039 = $cb592846cd729ef7$export$98e6a39c04603d36;




function $880a1314338b58f7$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $880a1314338b58f7$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $880a1314338b58f7$var$parseYear(dateStrings.date, additionalDigits);
        date = $880a1314338b58f7$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $880a1314338b58f7$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $880a1314338b58f7$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $880a1314338b58f7$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $880a1314338b58f7$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $880a1314338b58f7$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $880a1314338b58f7$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $880a1314338b58f7$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($880a1314338b58f7$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($880a1314338b58f7$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($880a1314338b58f7$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $880a1314338b58f7$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $880a1314338b58f7$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $880a1314338b58f7$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($880a1314338b58f7$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $880a1314338b58f7$var$parseDateUnit(captures[1]);
    const month = $880a1314338b58f7$var$parseDateUnit(captures[2]) - 1;
    const day = $880a1314338b58f7$var$parseDateUnit(captures[3]);
    const week = $880a1314338b58f7$var$parseDateUnit(captures[4]);
    const dayOfWeek = $880a1314338b58f7$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$880a1314338b58f7$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $880a1314338b58f7$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$880a1314338b58f7$var$validateDate(year, month, day) || !$880a1314338b58f7$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $880a1314338b58f7$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $880a1314338b58f7$var$parseTime(timeString) {
    const captures = timeString.match($880a1314338b58f7$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $880a1314338b58f7$var$parseTimeUnit(captures[1]);
    const minutes = $880a1314338b58f7$var$parseTimeUnit(captures[2]);
    const seconds = $880a1314338b58f7$var$parseTimeUnit(captures[3]);
    if (!$880a1314338b58f7$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $3db87186a9f4bd75$export$7f72910d6dfd237a) + minutes * (0, $3db87186a9f4bd75$export$91246f0b9bd9beff) + seconds * 1000;
}
function $880a1314338b58f7$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $880a1314338b58f7$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($880a1314338b58f7$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$880a1314338b58f7$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $3db87186a9f4bd75$export$7f72910d6dfd237a) + minutes * (0, $3db87186a9f4bd75$export$91246f0b9bd9beff));
}
function $880a1314338b58f7$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $880a1314338b58f7$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $880a1314338b58f7$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $880a1314338b58f7$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($880a1314338b58f7$var$daysInMonths[month] || ($880a1314338b58f7$var$isLeapYearIndex(year) ? 29 : 28));
}
function $880a1314338b58f7$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($880a1314338b58f7$var$isLeapYearIndex(year) ? 366 : 365);
}
function $880a1314338b58f7$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $880a1314338b58f7$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $880a1314338b58f7$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$880a1314338b58f7$export$2e2bcd8739ae039 = $880a1314338b58f7$export$4393d2ccbbedb219;


function $d6ffaacd9c9d24f5$export$f86b797a4659b781(date, hours, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$d6ffaacd9c9d24f5$export$2e2bcd8739ae039 = $d6ffaacd9c9d24f5$export$f86b797a4659b781;


function $9dd62e38f6f7ba31$export$ad569bf1c79ea89d(date, minutes, options) {
    const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    date_.setMinutes(minutes);
    return date_;
}
var // Fallback for modularized imports:
$9dd62e38f6f7ba31$export$2e2bcd8739ae039 = $9dd62e38f6f7ba31$export$ad569bf1c79ea89d;




function $8979b2cad5b30024$export$f645ddd439eb259d(date, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $a960433738d4e8b2$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$8979b2cad5b30024$export$2e2bcd8739ae039 = $8979b2cad5b30024$export$f645ddd439eb259d;



function $abe1c83fecf1276a$export$63264690f8e36790(date, month, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $8979b2cad5b30024$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$abe1c83fecf1276a$export$2e2bcd8739ae039 = $abe1c83fecf1276a$export$63264690f8e36790;



function $a2e940077f21299d$export$8924d1de7efe1755(date, quarter, options) {
    const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    const oldQuarter = Math.trunc(date_.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $abe1c83fecf1276a$export$63264690f8e36790)(date_, date_.getMonth() + diff * 3);
}
var // Fallback for modularized imports:
$a2e940077f21299d$export$2e2bcd8739ae039 = $a2e940077f21299d$export$8924d1de7efe1755;


function $2a9373e0b1ea9533$export$aec44746644cbf43(date, seconds, options) {
    const _date = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    _date.setSeconds(seconds);
    return _date;
}
var // Fallback for modularized imports:
$2a9373e0b1ea9533$export$2e2bcd8739ae039 = $2a9373e0b1ea9533$export$aec44746644cbf43;



function $7e8006cfd4109aed$export$a8408b6c5639cab7(date, year, options) {
    const date_ = (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $a960433738d4e8b2$export$ead8a1812b171991)(options?.in || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$7e8006cfd4109aed$export$2e2bcd8739ae039 = $7e8006cfd4109aed$export$a8408b6c5639cab7;


function $92df7bb0743d0fc6$export$a31bfeeeee80cce6(date, amount, options) {
    return (0, $8be8906ab05d096d$export$c252a41d0fbed2ce)(date, -amount, options);
}
var // Fallback for modularized imports:
$92df7bb0743d0fc6$export$2e2bcd8739ae039 = $92df7bb0743d0fc6$export$a31bfeeeee80cce6;


function $3f0099d21d1e1a6a$export$b4d8ae6376193efb(date, amount, options) {
    return (0, $9b66ea05774b3092$export$ef501a2bb4f3ee6b)(date, -amount, options);
}
var // Fallback for modularized imports:
$3f0099d21d1e1a6a$export$2e2bcd8739ae039 = $3f0099d21d1e1a6a$export$b4d8ae6376193efb;




var $igtsr = parcelRequire("igtsr");

var $f0992af029e4f475$var$index = typeof document !== 'undefined' ? (0, $igtsr.useLayoutEffect) : (0, $igtsr.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f0992af029e4f475$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f0992af029e4f475$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$f0992af029e4f475$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $f0992af029e4f475$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $f0992af029e4f475$var$roundByDPR(element, value) {
    const dpr = $f0992af029e4f475$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $f0992af029e4f475$var$useLatestRef(value) {
    const ref = $igtsr.useRef(value);
    $f0992af029e4f475$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $f0992af029e4f475$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $igtsr.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $igtsr.useState(middleware);
    if (!$f0992af029e4f475$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $igtsr.useState(null);
    const [_floating, _setFloating] = $igtsr.useState(null);
    const setReference = $igtsr.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $igtsr.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $igtsr.useRef(null);
    const floatingRef = $igtsr.useRef(null);
    const dataRef = $igtsr.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $f0992af029e4f475$var$useLatestRef(whileElementsMounted);
    const platformRef = $f0992af029e4f475$var$useLatestRef(platform);
    const openRef = $f0992af029e4f475$var$useLatestRef(open);
    const update = $igtsr.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $46988e907ff1ddf1$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$f0992af029e4f475$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $7731928cc933a5ef$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $f0992af029e4f475$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $igtsr.useRef(false);
    $f0992af029e4f475$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $f0992af029e4f475$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $igtsr.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $igtsr.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $igtsr.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $f0992af029e4f475$var$roundByDPR(elements.floating, data.x);
        const y = $f0992af029e4f475$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$f0992af029e4f475$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $igtsr.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f0992af029e4f475$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $46988e907ff1ddf1$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $46988e907ff1ddf1$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $f0992af029e4f475$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f0992af029e4f475$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f0992af029e4f475$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f0992af029e4f475$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f0992af029e4f475$export$346677f925de839c = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f0992af029e4f475$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f0992af029e4f475$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f0992af029e4f475$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $46988e907ff1ddf1$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f0992af029e4f475$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$f0992af029e4f475$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


var $igtsr = parcelRequire("igtsr");


var $igtsr = parcelRequire("igtsr");

/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $f32196b25074c279$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $f32196b25074c279$var$candidateSelector = /* #__PURE__ */ $f32196b25074c279$var$candidateSelectors.join(',');
var $f32196b25074c279$var$NoElement = typeof Element === 'undefined';
var $f32196b25074c279$var$matches = $f32196b25074c279$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $f32196b25074c279$var$getRootNode = !$f32196b25074c279$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $f32196b25074c279$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $f32196b25074c279$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $f32196b25074c279$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($f32196b25074c279$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($f32196b25074c279$var$candidateSelector));
    if (includeContainer && $f32196b25074c279$var$matches.call(el, $f32196b25074c279$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $f32196b25074c279$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($f32196b25074c279$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $f32196b25074c279$var$matches.call(element, $f32196b25074c279$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$f32196b25074c279$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $f32196b25074c279$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $f32196b25074c279$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $f32196b25074c279$var$isContentEditable(node)) && !$f32196b25074c279$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $f32196b25074c279$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $f32196b25074c279$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$f32196b25074c279$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $f32196b25074c279$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $f32196b25074c279$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $f32196b25074c279$var$isHiddenInput = function isHiddenInput(node) {
    return $f32196b25074c279$var$isInput(node) && node.type === 'hidden';
};
var $f32196b25074c279$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $f32196b25074c279$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $f32196b25074c279$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $f32196b25074c279$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $f32196b25074c279$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $f32196b25074c279$var$isRadio = function isRadio(node) {
    return $f32196b25074c279$var$isInput(node) && node.type === 'radio';
};
var $f32196b25074c279$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $f32196b25074c279$var$isRadio(node) && !$f32196b25074c279$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $f32196b25074c279$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $f32196b25074c279$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $f32196b25074c279$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $f32196b25074c279$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $f32196b25074c279$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $f32196b25074c279$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($f32196b25074c279$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $f32196b25074c279$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $f32196b25074c279$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($f32196b25074c279$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $f32196b25074c279$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $f32196b25074c279$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $f32196b25074c279$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $f32196b25074c279$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $f32196b25074c279$var$isInert(node) || $f32196b25074c279$var$isHiddenInput(node) || $f32196b25074c279$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $f32196b25074c279$var$isDetailsWithSummary(node) || $f32196b25074c279$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $f32196b25074c279$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($f32196b25074c279$var$isNonTabbableRadio(node) || $f32196b25074c279$export$a4672efddb4181b8(node) < 0 || !$f32196b25074c279$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $f32196b25074c279$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $f32196b25074c279$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $f32196b25074c279$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($f32196b25074c279$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $f32196b25074c279$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $f32196b25074c279$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $f32196b25074c279$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $f32196b25074c279$var$isValidShadowRootTabbable
    });
    else candidates = $f32196b25074c279$var$getCandidates(container, options.includeContainer, $f32196b25074c279$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $f32196b25074c279$var$sortByOrder(candidates);
};
var $f32196b25074c279$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $f32196b25074c279$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $f32196b25074c279$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $f32196b25074c279$var$getCandidates(container, options.includeContainer, $f32196b25074c279$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $f32196b25074c279$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($f32196b25074c279$var$matches.call(node, $f32196b25074c279$var$candidateSelector) === false) return false;
    return $f32196b25074c279$var$isNodeMatchingSelectorTabbable(options, node);
};
var $f32196b25074c279$var$focusableCandidateSelector = /* #__PURE__ */ $f32196b25074c279$var$candidateSelectors.concat('iframe').join(',');
var $f32196b25074c279$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($f32196b25074c279$var$matches.call(node, $f32196b25074c279$var$focusableCandidateSelector) === false) return false;
    return $f32196b25074c279$var$isNodeMatchingSelectorFocusable(options, node);
};


// Avoid Chrome DevTools blue warning.
function $5404d435e7bfb958$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $5404d435e7bfb958$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $5404d435e7bfb958$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $5404d435e7bfb958$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($5404d435e7bfb958$export$867a782338812cb4()) || re.test($5404d435e7bfb958$export$7935961ef7719cb0());
}
function $5404d435e7bfb958$export$9ac100e40613ea10() {
    return $5404d435e7bfb958$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $5404d435e7bfb958$export$c8f880a2d81914c4() {
    return $5404d435e7bfb958$export$7935961ef7719cb0().includes('jsdom/');
}
const $5404d435e7bfb958$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $5404d435e7bfb958$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $5404d435e7bfb958$var$ARROW_LEFT = 'ArrowLeft';
const $5404d435e7bfb958$var$ARROW_RIGHT = 'ArrowRight';
const $5404d435e7bfb958$var$ARROW_UP = 'ArrowUp';
const $5404d435e7bfb958$var$ARROW_DOWN = 'ArrowDown';
function $5404d435e7bfb958$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $5404d435e7bfb958$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $76497176d8ac8544$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $5404d435e7bfb958$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $5404d435e7bfb958$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $5404d435e7bfb958$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $5404d435e7bfb958$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $5404d435e7bfb958$export$42ad131c32f0fb8d(element) {
    return (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(element) && element.matches($5404d435e7bfb958$var$TYPEABLE_SELECTOR);
}
function $5404d435e7bfb958$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $5404d435e7bfb958$export$42ad131c32f0fb8d(element);
}
function $5404d435e7bfb958$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $5404d435e7bfb958$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $5404d435e7bfb958$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($5404d435e7bfb958$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $5404d435e7bfb958$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $5404d435e7bfb958$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = onlyOpenChildren ? nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        }) : nodes;
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $5404d435e7bfb958$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $5404d435e7bfb958$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $5404d435e7bfb958$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $5404d435e7bfb958$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $5404d435e7bfb958$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $5404d435e7bfb958$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($5404d435e7bfb958$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $5404d435e7bfb958$export$29bf1b5f2c56cf63(event) {
    if ($5404d435e7bfb958$export$c8f880a2d81914c4()) return false;
    return !$5404d435e7bfb958$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $5404d435e7bfb958$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $5404d435e7bfb958$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $5404d435e7bfb958$export$bb3b3b3acfd7447f = typeof document !== 'undefined' ? (0, $igtsr.useLayoutEffect) : (0, $igtsr.useEffect);
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $5404d435e7bfb958$var$SafeReact = {
    ...$igtsr
};
function $5404d435e7bfb958$export$bcd07ba85a740103(value) {
    const ref = $igtsr.useRef(value);
    $5404d435e7bfb958$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $5404d435e7bfb958$var$useInsertionEffect = $5404d435e7bfb958$var$SafeReact.useInsertionEffect;
const $5404d435e7bfb958$var$useSafeInsertionEffect = $5404d435e7bfb958$var$useInsertionEffect || ((fn)=>fn());
function $5404d435e7bfb958$export$7f54fc3180508a52(callback) {
    const ref = $igtsr.useRef(()=>{});
    $5404d435e7bfb958$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $igtsr.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $5404d435e7bfb958$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $5404d435e7bfb958$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $5404d435e7bfb958$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $5404d435e7bfb958$export$b585558af466e926(listRef, disabledIndices) {
    return $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $5404d435e7bfb958$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $5404d435e7bfb958$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $5404d435e7bfb958$var$ARROW_UP) {
        stop && $5404d435e7bfb958$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($5404d435e7bfb958$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $5404d435e7bfb958$var$ARROW_DOWN) {
        stop && $5404d435e7bfb958$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($5404d435e7bfb958$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $0c3eeddb1ed27edf$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $5404d435e7bfb958$var$ARROW_LEFT : $5404d435e7bfb958$var$ARROW_RIGHT)) {
            stop && $5404d435e7bfb958$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $5404d435e7bfb958$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($5404d435e7bfb958$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $5404d435e7bfb958$var$ARROW_RIGHT : $5404d435e7bfb958$var$ARROW_LEFT)) {
            stop && $5404d435e7bfb958$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $5404d435e7bfb958$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($5404d435e7bfb958$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $0c3eeddb1ed27edf$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($5404d435e7bfb958$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $5404d435e7bfb958$var$ARROW_RIGHT : $5404d435e7bfb958$var$ARROW_LEFT) ? maxIndex : $5404d435e7bfb958$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $5404d435e7bfb958$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $5404d435e7bfb958$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $5404d435e7bfb958$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $5404d435e7bfb958$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const $5404d435e7bfb958$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $5404d435e7bfb958$var$getTabbableIn(container, dir) {
    const list = (0, $f32196b25074c279$export$17100aea90429aa7)(container, $5404d435e7bfb958$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $5404d435e7bfb958$export$da980962bd2147a4($5404d435e7bfb958$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $5404d435e7bfb958$export$28f33206776129a7(referenceElement) {
    return $5404d435e7bfb958$var$getTabbableIn($5404d435e7bfb958$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $5404d435e7bfb958$export$2e5518c3303f364a(referenceElement) {
    return $5404d435e7bfb958$var$getTabbableIn($5404d435e7bfb958$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $5404d435e7bfb958$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$5404d435e7bfb958$export$2344b14b097df817(containerElement, relatedTarget);
}
function $5404d435e7bfb958$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $f32196b25074c279$export$17100aea90429aa7)(container, $5404d435e7bfb958$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $5404d435e7bfb958$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}








/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $d38b9f8cdb785fa6$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $igtsr.useRef(undefined);
    const refEffect = $igtsr.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $igtsr.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $d38b9f8cdb785fa6$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $d38b9f8cdb785fa6$var$FloatingListContext = /*#__PURE__*/ $igtsr.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $d38b9f8cdb785fa6$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $igtsr.useState(()=>new Set());
    const register = $igtsr.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $igtsr.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $igtsr.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($d38b9f8cdb785fa6$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FloatingListContext.Provider, {
        value: $igtsr.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $d38b9f8cdb785fa6$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $igtsr.useContext($d38b9f8cdb785fa6$var$FloatingListContext);
    const [index, setIndex] = $igtsr.useState(null);
    const componentRef = $igtsr.useRef(null);
    const ref = $igtsr.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $igtsr.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $d38b9f8cdb785fa6$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $d38b9f8cdb785fa6$var$ACTIVE_KEY = 'active';
const $d38b9f8cdb785fa6$var$SELECTED_KEY = 'selected';
const $d38b9f8cdb785fa6$var$ARROW_LEFT = 'ArrowLeft';
const $d38b9f8cdb785fa6$var$ARROW_RIGHT = 'ArrowRight';
const $d38b9f8cdb785fa6$var$ARROW_UP = 'ArrowUp';
const $d38b9f8cdb785fa6$var$ARROW_DOWN = 'ArrowDown';
function $d38b9f8cdb785fa6$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $igtsr.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
        ...computedProps
    });
}
const $d38b9f8cdb785fa6$var$CompositeContext = /*#__PURE__*/ $igtsr.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $d38b9f8cdb785fa6$var$horizontalKeys = [
    $d38b9f8cdb785fa6$var$ARROW_LEFT,
    $d38b9f8cdb785fa6$var$ARROW_RIGHT
];
const $d38b9f8cdb785fa6$var$verticalKeys = [
    $d38b9f8cdb785fa6$var$ARROW_UP,
    $d38b9f8cdb785fa6$var$ARROW_DOWN
];
const $d38b9f8cdb785fa6$var$allKeys = [
    ...$d38b9f8cdb785fa6$var$horizontalKeys,
    ...$d38b9f8cdb785fa6$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $d38b9f8cdb785fa6$export$43586241d9db0c6d = /*#__PURE__*/ $igtsr.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $igtsr.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $igtsr.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $igtsr.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$d38b9f8cdb785fa6$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $5404d435e7bfb958$export$53f691ee0acc6058)(elementsRef, disabledIndices);
        const maxIndex = (0, $5404d435e7bfb958$export$b585558af466e926)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $d38b9f8cdb785fa6$var$ARROW_LEFT : $d38b9f8cdb785fa6$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $d38b9f8cdb785fa6$var$ARROW_RIGHT : $d38b9f8cdb785fa6$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $5404d435e7bfb958$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $5404d435e7bfb958$export$446656ed0410fd9)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $5404d435e7bfb958$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $5404d435e7bfb958$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $5404d435e7bfb958$export$50d8709b2ccc23f9)([
                    ...disabledIndices || elementsRef.current.map((_, index)=>(0, $5404d435e7bfb958$export$446656ed0410fd9)(elementsRef, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $5404d435e7bfb958$export$dab2b2ce7761f8e4)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $d38b9f8cdb785fa6$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $d38b9f8cdb785fa6$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $d38b9f8cdb785fa6$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $d38b9f8cdb785fa6$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $d38b9f8cdb785fa6$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $d38b9f8cdb785fa6$var$allKeys : ({
            horizontal: $d38b9f8cdb785fa6$var$horizontalKeys,
            vertical: $d38b9f8cdb785fa6$var$verticalKeys,
            both: $d38b9f8cdb785fa6$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $5404d435e7bfb958$export$3fc3ea4a67cf714)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $5404d435e7bfb958$export$75effb89758ec596)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $d38b9f8cdb785fa6$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $d38b9f8cdb785fa6$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $igtsr.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $igtsr.useContext($d38b9f8cdb785fa6$var$CompositeContext);
    const { ref: ref, index: index } = $d38b9f8cdb785fa6$export$dcdc7ff5149f7d1a();
    const mergedRef = $d38b9f8cdb785fa6$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $d38b9f8cdb785fa6$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $d38b9f8cdb785fa6$var$SafeReact = {
    ...$igtsr
};
let $d38b9f8cdb785fa6$var$serverHandoffComplete = false;
let $d38b9f8cdb785fa6$var$count = 0;
const $d38b9f8cdb785fa6$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $d38b9f8cdb785fa6$var$count++;
function $d38b9f8cdb785fa6$var$useFloatingId() {
    const [id, setId] = $igtsr.useState(()=>$d38b9f8cdb785fa6$var$serverHandoffComplete ? $d38b9f8cdb785fa6$var$genId() : undefined);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (id == null) setId($d38b9f8cdb785fa6$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $igtsr.useEffect(()=>{
        $d38b9f8cdb785fa6$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $d38b9f8cdb785fa6$var$useReactId = $d38b9f8cdb785fa6$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $d38b9f8cdb785fa6$export$f680877a34711e37 = $d38b9f8cdb785fa6$var$useReactId || $d38b9f8cdb785fa6$var$useFloatingId;
let $d38b9f8cdb785fa6$var$devMessageSet;
function $d38b9f8cdb785fa6$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $d38b9f8cdb785fa6$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $d38b9f8cdb785fa6$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $d38b9f8cdb785fa6$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $d38b9f8cdb785fa6$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $d38b9f8cdb785fa6$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $d38b9f8cdb785fa6$export$33511391554732bc = /*#__PURE__*/ $igtsr.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $d38b9f8cdb785fa6$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $igtsr.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        const isRTL = (0, $76497176d8ac8544$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $d38b9f8cdb785fa6$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $d38b9f8cdb785fa6$var$FloatingNodeContext = /*#__PURE__*/ $igtsr.createContext(null);
const $d38b9f8cdb785fa6$var$FloatingTreeContext = /*#__PURE__*/ $igtsr.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $d38b9f8cdb785fa6$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $igtsr.useContext($d38b9f8cdb785fa6$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $d38b9f8cdb785fa6$export$db0c2a7c7a2a4f69 = ()=>$igtsr.useContext($d38b9f8cdb785fa6$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $d38b9f8cdb785fa6$export$9b136e0e758a42f4(customParentId) {
    const id = $d38b9f8cdb785fa6$export$f680877a34711e37();
    const tree = $d38b9f8cdb785fa6$export$db0c2a7c7a2a4f69();
    const reactParentId = $d38b9f8cdb785fa6$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $d38b9f8cdb785fa6$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $d38b9f8cdb785fa6$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FloatingNodeContext.Provider, {
        value: $igtsr.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $d38b9f8cdb785fa6$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $igtsr.useRef([]);
    const addNode = $igtsr.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $igtsr.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $igtsr.useState(()=>$d38b9f8cdb785fa6$var$createEventEmitter());
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FloatingTreeContext.Provider, {
        value: $igtsr.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $d38b9f8cdb785fa6$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $d38b9f8cdb785fa6$var$safePolygonIdentifier = /*#__PURE__*/ $d38b9f8cdb785fa6$var$createAttribute('safe-polygon');
function $d38b9f8cdb785fa6$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $5404d435e7bfb958$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $d38b9f8cdb785fa6$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $d38b9f8cdb785fa6$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $d38b9f8cdb785fa6$export$db0c2a7c7a2a4f69();
    const parentId = $d38b9f8cdb785fa6$export$165209eae06d3488();
    const handleCloseRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(handleClose);
    const delayRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(delay);
    const openRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(open);
    const restMsRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(restMs);
    const pointerTypeRef = $igtsr.useRef();
    const timeoutRef = $igtsr.useRef(-1);
    const handlerRef = $igtsr.useRef();
    const restTimeoutRef = $igtsr.useRef(-1);
    const blockMouseMoveRef = $igtsr.useRef(true);
    const performedPointerEventsMutationRef = $igtsr.useRef(false);
    const unbindMouseMoveRef = $igtsr.useRef(()=>{});
    const restTimeoutPendingRef = $igtsr.useRef(false);
    const isHoverOpen = $igtsr.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $igtsr.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
                $d38b9f8cdb785fa6$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $igtsr.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $igtsr.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $d38b9f8cdb785fa6$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($d38b9f8cdb785fa6$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $igtsr.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $5404d435e7bfb958$export$81cf264172d31e51)(pointerTypeRef.current) || $d38b9f8cdb785fa6$var$getRestMs(restMsRef.current) > 0 && !$d38b9f8cdb785fa6$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $d38b9f8cdb785fa6$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.floating);
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $5404d435e7bfb958$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($d38b9f8cdb785fa6$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $igtsr.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $igtsr.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $5404d435e7bfb958$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || $d38b9f8cdb785fa6$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $d38b9f8cdb785fa6$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $d38b9f8cdb785fa6$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $d38b9f8cdb785fa6$var$NOOP = ()=>{};
const $d38b9f8cdb785fa6$var$FloatingDelayGroupContext = /*#__PURE__*/ $igtsr.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $d38b9f8cdb785fa6$var$NOOP,
    setState: $d38b9f8cdb785fa6$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $d38b9f8cdb785fa6$export$e2411914b150383d = ()=>$igtsr.useContext($d38b9f8cdb785fa6$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $d38b9f8cdb785fa6$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $igtsr.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $igtsr.useRef(null);
    const setCurrentId = $igtsr.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FloatingDelayGroupContext.Provider, {
        value: $igtsr.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $d38b9f8cdb785fa6$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $d38b9f8cdb785fa6$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $d38b9f8cdb785fa6$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (setCurrentId === $d38b9f8cdb785fa6$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $d38b9f8cdb785fa6$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $igtsr.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $d38b9f8cdb785fa6$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $igtsr.useRef(delay);
    const initialDelayRef = $igtsr.useRef(delay);
    const currentIdRef = $igtsr.useRef(null);
    const currentContextRef = $igtsr.useRef(null);
    const timeoutIdRef = $igtsr.useRef(-1);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$NextFloatingDelayGroupContext.Provider, {
        value: $igtsr.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $d38b9f8cdb785fa6$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $igtsr.useContext($d38b9f8cdb785fa6$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $igtsr.useState(false);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $d38b9f8cdb785fa6$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $igtsr.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $d38b9f8cdb785fa6$var$rafId = 0;
function $d38b9f8cdb785fa6$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($d38b9f8cdb785fa6$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $d38b9f8cdb785fa6$var$rafId = requestAnimationFrame(exec);
}
function $d38b9f8cdb785fa6$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $76497176d8ac8544$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $d38b9f8cdb785fa6$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $d38b9f8cdb785fa6$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $d38b9f8cdb785fa6$var$counterMap = /*#__PURE__*/ new WeakMap();
let $d38b9f8cdb785fa6$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $d38b9f8cdb785fa6$var$markerMap = {};
let $d38b9f8cdb785fa6$var$lockCount$1 = 0;
const $d38b9f8cdb785fa6$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $d38b9f8cdb785fa6$var$unwrapHost = (node)=>node && (node.host || $d38b9f8cdb785fa6$var$unwrapHost(node.parentNode));
const $d38b9f8cdb785fa6$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $d38b9f8cdb785fa6$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $d38b9f8cdb785fa6$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $d38b9f8cdb785fa6$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$d38b9f8cdb785fa6$var$markerMap[markerName]) $d38b9f8cdb785fa6$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $d38b9f8cdb785fa6$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $76497176d8ac8544$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const currentCounterValue = $d38b9f8cdb785fa6$var$counterMap.get(node) || 0;
                const counterValue = controlAttribute ? currentCounterValue + 1 : currentCounterValue;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $d38b9f8cdb785fa6$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $d38b9f8cdb785fa6$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $d38b9f8cdb785fa6$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const currentCounterValue = $d38b9f8cdb785fa6$var$counterMap.get(element) || 0;
            const counterValue = controlAttribute ? currentCounterValue - 1 : currentCounterValue;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $d38b9f8cdb785fa6$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$d38b9f8cdb785fa6$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $d38b9f8cdb785fa6$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $d38b9f8cdb785fa6$var$lockCount$1--;
        if (!$d38b9f8cdb785fa6$var$lockCount$1) {
            $d38b9f8cdb785fa6$var$counterMap = new WeakMap();
            $d38b9f8cdb785fa6$var$counterMap = new WeakMap();
            $d38b9f8cdb785fa6$var$uncontrolledElementsSet = new WeakSet();
            $d38b9f8cdb785fa6$var$markerMap = {};
        }
    };
}
function $d38b9f8cdb785fa6$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $d38b9f8cdb785fa6$var$getDocument(avoidElements[0]).body;
    return $d38b9f8cdb785fa6$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $d38b9f8cdb785fa6$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const $d38b9f8cdb785fa6$var$FocusGuard = /*#__PURE__*/ $igtsr.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $igtsr.useState();
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if ((0, $5404d435e7bfb958$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$d38b9f8cdb785fa6$var$createAttribute('focus-guard')]: '',
        style: $d38b9f8cdb785fa6$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $d38b9f8cdb785fa6$var$PortalContext = /*#__PURE__*/ $igtsr.createContext(null);
const $d38b9f8cdb785fa6$var$attr = /*#__PURE__*/ $d38b9f8cdb785fa6$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $d38b9f8cdb785fa6$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $d38b9f8cdb785fa6$export$f680877a34711e37();
    const portalContext = $d38b9f8cdb785fa6$var$usePortalContext();
    const [portalNode, setPortalNode] = $igtsr.useState(null);
    const portalNodeRef = $igtsr.useRef(null);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($d38b9f8cdb785fa6$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($d38b9f8cdb785fa6$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $d38b9f8cdb785fa6$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $d38b9f8cdb785fa6$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $igtsr.useState(null);
    const beforeOutsideRef = $igtsr.useRef(null);
    const afterOutsideRef = $igtsr.useRef(null);
    const beforeInsideRef = $igtsr.useRef(null);
    const afterInsideRef = $igtsr.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $igtsr.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $5404d435e7bfb958$export$6e0c4e272f3faa2)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, $5404d435e7bfb958$export$a65f4028abb17f36) : (0, $5404d435e7bfb958$export$3995dd353b80da11);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $igtsr.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $5404d435e7bfb958$export$a65f4028abb17f36)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)($d38b9f8cdb785fa6$var$PortalContext.Provider, {
        value: $igtsr.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $5404d435e7bfb958$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $5404d435e7bfb958$export$2e5518c3303f364a)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $d38b9f8cdb785fa6$var$HIDDEN_STYLES
            }),
            portalNode && /*#__PURE__*/ $7731928cc933a5ef$exports.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $5404d435e7bfb958$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $5404d435e7bfb958$export$28f33206776129a7)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const $d38b9f8cdb785fa6$var$usePortalContext = ()=>$igtsr.useContext($d38b9f8cdb785fa6$var$PortalContext);
function $d38b9f8cdb785fa6$var$useLiteMergeRefs(refs) {
    return $igtsr.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $d38b9f8cdb785fa6$var$LIST_LIMIT = 20;
let $d38b9f8cdb785fa6$var$previouslyFocusedElements = [];
function $d38b9f8cdb785fa6$var$addPreviouslyFocusedElement(element) {
    $d38b9f8cdb785fa6$var$previouslyFocusedElements = $d38b9f8cdb785fa6$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    if (element && (0, $76497176d8ac8544$export$651544f548703224)(element) !== 'body') {
        $d38b9f8cdb785fa6$var$previouslyFocusedElements.push(element);
        if ($d38b9f8cdb785fa6$var$previouslyFocusedElements.length > $d38b9f8cdb785fa6$var$LIST_LIMIT) $d38b9f8cdb785fa6$var$previouslyFocusedElements = $d38b9f8cdb785fa6$var$previouslyFocusedElements.slice(-20);
    }
}
function $d38b9f8cdb785fa6$var$getPreviouslyFocusedElement() {
    return $d38b9f8cdb785fa6$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
function $d38b9f8cdb785fa6$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $5404d435e7bfb958$export$6324a2bbae6a332f)();
    if ((0, $f32196b25074c279$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $f32196b25074c279$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
function $d38b9f8cdb785fa6$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, $5404d435e7bfb958$export$6324a2bbae6a332f)();
    const focusableElements = (0, $f32196b25074c279$export$ecc6d1fcdff4f700)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $f32196b25074c279$export$bebd5a1431fec25d)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const $d38b9f8cdb785fa6$var$VisuallyHiddenDismiss = /*#__PURE__*/ $igtsr.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $d38b9f8cdb785fa6$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $d38b9f8cdb785fa6$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $5404d435e7bfb958$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $d38b9f8cdb785fa6$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(order);
    const initialFocusRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(initialFocus);
    const returnFocusRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(returnFocus);
    const tree = $d38b9f8cdb785fa6$export$db0c2a7c7a2a4f69();
    const portalContext = $d38b9f8cdb785fa6$var$usePortalContext();
    const startDismissButtonRef = $igtsr.useRef(null);
    const endDismissButtonRef = $igtsr.useRef(null);
    const preventReturnFocusRef = $igtsr.useRef(false);
    const isPointerDownRef = $igtsr.useRef(false);
    const tabbableIndexRef = $igtsr.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $5404d435e7bfb958$export$9b0901b5e9b45fc7)(floating);
    const getTabbableContent = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $f32196b25074c279$export$17100aea90429aa7)(container, (0, $5404d435e7bfb958$export$6324a2bbae6a332f)()) : [];
    });
    const getTabbableElements = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $igtsr.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $5404d435e7bfb958$export$2344b14b097df817)(floatingFocusElement, (0, $5404d435e7bfb958$export$da980962bd2147a4)((0, $5404d435e7bfb958$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $d38b9f8cdb785fa6$var$enqueueFocus(els[els.length - 1]);
                    else $d38b9f8cdb785fa6$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                    $d38b9f8cdb785fa6$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $igtsr.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $igtsr.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $5404d435e7bfb958$export$2344b14b097df817)(domReference, relatedTarget) || (0, $5404d435e7bfb958$export$2344b14b097df817)(floating, relatedTarget) || (0, $5404d435e7bfb958$export$2344b14b097df817)(relatedTarget, floating) || (0, $5404d435e7bfb958$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($d38b9f8cdb785fa6$var$createAttribute('focus-guard')) || tree && ((0, $5404d435e7bfb958$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $5404d435e7bfb958$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $5404d435e7bfb958$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $5404d435e7bfb958$export$5d8eb345316b65c0)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $5404d435e7bfb958$export$9b0901b5e9b45fc7)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $d38b9f8cdb785fa6$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $5404d435e7bfb958$export$da980962bd2147a4)((0, $5404d435e7bfb958$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $5404d435e7bfb958$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $76497176d8ac8544$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $76497176d8ac8544$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $d38b9f8cdb785fa6$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef
    ]);
    const beforeGuardRef = $igtsr.useRef(null);
    const afterGuardRef = $igtsr.useRef(null);
    const mergedBeforeGuardRef = $d38b9f8cdb785fa6$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $d38b9f8cdb785fa6$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $igtsr.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $d38b9f8cdb785fa6$var$createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, $5404d435e7bfb958$export$5d8eb345316b65c0)(tree.nodesRef.current, getNodeId()) : [];
        const ancestorFloatingNodes = tree && !modal ? ancestors.map((node)=>{
            var _node$context6;
            return (_node$context6 = node.context) == null ? void 0 : _node$context6.elements.floating;
        }) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context7;
            return (0, $5404d435e7bfb958$export$259ba5ae38188551)(((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...ancestorFloatingNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $d38b9f8cdb785fa6$var$markOthers(insideElements, !useInert, useInert) : $d38b9f8cdb785fa6$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !(0, $76497176d8ac8544$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $5404d435e7bfb958$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $5404d435e7bfb958$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $d38b9f8cdb785fa6$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $5404d435e7bfb958$export$da980962bd2147a4)(doc);
        $d38b9f8cdb785fa6$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else if ((0, $5404d435e7bfb958$export$60278871457622de)(event) || (0, $5404d435e7bfb958$export$29bf1b5f2c56cf63)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) {
                    preventReturnFocusRef.current = false;
                    preventReturnFocusScroll = true;
                } else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $d38b9f8cdb785fa6$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || $d38b9f8cdb785fa6$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $5404d435e7bfb958$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $5404d435e7bfb958$export$2344b14b097df817)(floating, activeEl) || tree && (0, $5404d435e7bfb958$export$1f1998cc3c6b56fb)(tree.nodesRef.current, getNodeId()).some((node)=>{
                var _node$context8;
                return (0, $5404d435e7bfb958$export$2344b14b097df817)((_node$context8 = node.context) == null ? void 0 : _node$context8.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $d38b9f8cdb785fa6$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $igtsr.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $d38b9f8cdb785fa6$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $d38b9f8cdb785fa6$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $5404d435e7bfb958$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $5404d435e7bfb958$export$28f33206776129a7)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($d38b9f8cdb785fa6$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $d38b9f8cdb785fa6$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $5404d435e7bfb958$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $5404d435e7bfb958$export$2e5518c3303f364a)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $d38b9f8cdb785fa6$var$lockCount = 0;
function $d38b9f8cdb785fa6$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $5404d435e7bfb958$export$867a782338812cb4)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $d38b9f8cdb785fa6$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $d38b9f8cdb785fa6$export$a35954495955337b = /*#__PURE__*/ $igtsr.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!lockScroll) return;
        $d38b9f8cdb785fa6$var$lockCount++;
        if ($d38b9f8cdb785fa6$var$lockCount === 1) $d38b9f8cdb785fa6$var$cleanup = $d38b9f8cdb785fa6$var$enableScrollLock();
        return ()=>{
            $d38b9f8cdb785fa6$var$lockCount--;
            if ($d38b9f8cdb785fa6$var$lockCount === 0) $d38b9f8cdb785fa6$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $d38b9f8cdb785fa6$var$isButtonTarget(event) {
    return (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $d38b9f8cdb785fa6$var$isAnchorTarget(event) {
    return (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'A';
}
function $d38b9f8cdb785fa6$var$isSpaceIgnored(element) {
    return (0, $5404d435e7bfb958$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $d38b9f8cdb785fa6$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $igtsr.useRef();
    const didKeyDownRef = $igtsr.useRef(false);
    const reference = $igtsr.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $5404d435e7bfb958$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $5404d435e7bfb958$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $d38b9f8cdb785fa6$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$d38b9f8cdb785fa6$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($d38b9f8cdb785fa6$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $d38b9f8cdb785fa6$var$isButtonTarget(event) || $d38b9f8cdb785fa6$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $d38b9f8cdb785fa6$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $d38b9f8cdb785fa6$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $d38b9f8cdb785fa6$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $igtsr.useRef(false);
    const cleanupListenerRef = $igtsr.useRef(null);
    const [pointerType, setPointerType] = $igtsr.useState();
    const [reactive, setReactive] = $igtsr.useState([]);
    const setReference = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$d38b9f8cdb785fa6$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($d38b9f8cdb785fa6$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $5404d435e7bfb958$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $igtsr.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $76497176d8ac8544$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event);
            if (!(0, $5404d435e7bfb958$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $d38b9f8cdb785fa6$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $igtsr.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $igtsr.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $igtsr.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $igtsr.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $d38b9f8cdb785fa6$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $d38b9f8cdb785fa6$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $d38b9f8cdb785fa6$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $d38b9f8cdb785fa6$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $d38b9f8cdb785fa6$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $igtsr.useRef(false);
    const endedOrStartedInsideRef = $igtsr.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $d38b9f8cdb785fa6$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $d38b9f8cdb785fa6$var$normalizeProp(capture);
    const isComposingRef = $igtsr.useRef(false);
    const closeOnEscapeKeyDown = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $5404d435e7bfb958$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $5404d435e7bfb958$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $d38b9f8cdb785fa6$var$createAttribute('inert') + "]";
        const markers = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $76497176d8ac8544$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $76497176d8ac8544$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $76497176d8ac8544$export$d1162fb0b6d4cd51)(nextParent) || !(0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(target) && !(0, $5404d435e7bfb958$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $5404d435e7bfb958$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $5404d435e7bfb958$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $76497176d8ac8544$export$1b3bfaa9684536aa)(target) && floating) {
            const lastTraversableNode = (0, $76497176d8ac8544$export$d1162fb0b6d4cd51)(target);
            const style = (0, $76497176d8ac8544$export$3735103072e4a80)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $5404d435e7bfb958$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $5404d435e7bfb958$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $5404d435e7bfb958$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $5404d435e7bfb958$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $5404d435e7bfb958$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $igtsr.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $76497176d8ac8544$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $76497176d8ac8544$export$3b57c1601291186b)(elements.domReference);
            if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $76497176d8ac8544$export$3b57c1601291186b)(elements.floating));
            if (!(0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $76497176d8ac8544$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $igtsr.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $igtsr.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$d38b9f8cdb785fa6$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, 'reference-press');
                },
                ...referencePressEvent !== 'click' && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, 'reference-press');
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $igtsr.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$d38b9f8cdb785fa6$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $d38b9f8cdb785fa6$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $d38b9f8cdb785fa6$export$f680877a34711e37();
    const dataRef = $igtsr.useRef({});
    const [events] = $igtsr.useState(()=>$d38b9f8cdb785fa6$var$createEventEmitter());
    const nested = $d38b9f8cdb785fa6$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $igtsr.useState(elementsProp.reference);
    const onOpenChange = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $igtsr.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $igtsr.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $igtsr.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $d38b9f8cdb785fa6$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $d38b9f8cdb785fa6$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $igtsr.useState(null);
    const [positionReference, _setPositionReference] = $igtsr.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $igtsr.useRef(null);
    const tree = $d38b9f8cdb785fa6$export$db0c2a7c7a2a4f69();
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $f0992af029e4f475$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $igtsr.useCallback((node)=>{
        const computedPositionReference = (0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $igtsr.useCallback((node)=>{
        if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $igtsr.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $igtsr.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $igtsr.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $igtsr.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $d38b9f8cdb785fa6$var$isMacSafari() {
    return (0, $5404d435e7bfb958$export$9ac100e40613ea10)() && (0, $5404d435e7bfb958$export$95df08bae54cb4df)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $d38b9f8cdb785fa6$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $igtsr.useRef(false);
    const timeoutRef = $igtsr.useRef(-1);
    const keyboardModalityRef = $igtsr.useRef(true);
    $igtsr.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $76497176d8ac8544$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $76497176d8ac8544$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $5404d435e7bfb958$export$da980962bd2147a4)((0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($d38b9f8cdb785fa6$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if ($d38b9f8cdb785fa6$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $igtsr.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $igtsr.useEffect(()=>{
        return ()=>{
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $igtsr.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $5404d435e7bfb958$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($d38b9f8cdb785fa6$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $5404d435e7bfb958$export$42ad131c32f0fb8d)(target)) return;
                    } else if (!(0, $5404d435e7bfb958$export$65750043c2fb2f40)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($d38b9f8cdb785fa6$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $5404d435e7bfb958$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $5404d435e7bfb958$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $5404d435e7bfb958$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $d38b9f8cdb785fa6$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$d38b9f8cdb785fa6$var$ACTIVE_KEY]: _, [$d38b9f8cdb785fa6$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$d38b9f8cdb785fa6$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $d38b9f8cdb785fa6$var$ACTIVE_KEY,
                    $d38b9f8cdb785fa6$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $d38b9f8cdb785fa6$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $igtsr.useCallback((userProps)=>$d38b9f8cdb785fa6$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $igtsr.useCallback((userProps)=>$d38b9f8cdb785fa6$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $igtsr.useCallback((userProps)=>$d38b9f8cdb785fa6$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $igtsr.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $d38b9f8cdb785fa6$var$ESCAPE = 'Escape';
function $d38b9f8cdb785fa6$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $d38b9f8cdb785fa6$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $d38b9f8cdb785fa6$var$ARROW_UP || key === $d38b9f8cdb785fa6$var$ARROW_DOWN;
    const horizontal = key === $d38b9f8cdb785fa6$var$ARROW_LEFT || key === $d38b9f8cdb785fa6$var$ARROW_RIGHT;
    return $d38b9f8cdb785fa6$var$doSwitch(orientation, vertical, horizontal);
}
function $d38b9f8cdb785fa6$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $d38b9f8cdb785fa6$var$ARROW_DOWN;
    const horizontal = rtl ? key === $d38b9f8cdb785fa6$var$ARROW_LEFT : key === $d38b9f8cdb785fa6$var$ARROW_RIGHT;
    return $d38b9f8cdb785fa6$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $d38b9f8cdb785fa6$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $d38b9f8cdb785fa6$var$ARROW_LEFT : key === $d38b9f8cdb785fa6$var$ARROW_RIGHT;
    const horizontal = key === $d38b9f8cdb785fa6$var$ARROW_DOWN;
    return $d38b9f8cdb785fa6$var$doSwitch(orientation, vertical, horizontal);
}
function $d38b9f8cdb785fa6$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $d38b9f8cdb785fa6$var$ARROW_RIGHT : key === $d38b9f8cdb785fa6$var$ARROW_LEFT;
    const horizontal = key === $d38b9f8cdb785fa6$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $d38b9f8cdb785fa6$var$ESCAPE;
    return $d38b9f8cdb785fa6$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $d38b9f8cdb785fa6$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $5404d435e7bfb958$export$9b0901b5e9b45fc7)(elements.floating);
    const floatingFocusElementRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(floatingFocusElement);
    const parentId = $d38b9f8cdb785fa6$export$165209eae06d3488();
    const tree = $d38b9f8cdb785fa6$export$db0c2a7c7a2a4f69();
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $5404d435e7bfb958$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $igtsr.useRef(focusItemOnOpen);
    const indexRef = $igtsr.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $igtsr.useRef(null);
    const isPointerModalityRef = $igtsr.useRef(true);
    const previousOnNavigateRef = $igtsr.useRef(onNavigate);
    const previousMountedRef = $igtsr.useRef(!!elements.floating);
    const previousOpenRef = $igtsr.useRef(open);
    const forceSyncFocusRef = $igtsr.useRef(false);
    const forceScrollIntoViewRef = $igtsr.useRef(false);
    const disabledIndicesRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(disabledIndices);
    const latestOpenRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(open);
    const scrollItemIntoViewRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(scrollItemIntoView);
    const selectedIndexRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(selectedIndex);
    const [activeId, setActiveId] = $igtsr.useState();
    const [virtualId, setVirtualId] = $igtsr.useState();
    const focusItem = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $d38b9f8cdb785fa6$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $d38b9f8cdb785fa6$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $5404d435e7bfb958$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current) : (0, $5404d435e7bfb958$export$b585558af466e926)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $5404d435e7bfb958$export$75effb89758ec596)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $5404d435e7bfb958$export$da980962bd2147a4)((0, $5404d435e7bfb958$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $5404d435e7bfb958$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $igtsr.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    forceSyncFocusRef.current = true;
                    forceScrollIntoViewRef.current = false;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    forceSyncFocusRef.current = true;
                    indexRef.current = -1;
                    onNavigate();
                    if (!virtual) {
                        var _floatingFocusElement;
                        (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                            preventScroll: true
                        });
                    }
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $igtsr.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $d38b9f8cdb785fa6$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$d38b9f8cdb785fa6$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $76497176d8ac8544$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $5404d435e7bfb958$export$53f691ee0acc6058)(listRef, disabledIndices);
        const maxIndex = (0, $5404d435e7bfb958$export$b585558af466e926)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $5404d435e7bfb958$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $5404d435e7bfb958$export$446656ed0410fd9)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $5404d435e7bfb958$export$446656ed0410fd9)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $5404d435e7bfb958$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $5404d435e7bfb958$export$50d8709b2ccc23f9)([
                    ...disabledIndices || listRef.current.map((_, index)=>(0, $5404d435e7bfb958$export$446656ed0410fd9)(listRef, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $5404d435e7bfb958$export$dab2b2ce7761f8e4)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $d38b9f8cdb785fa6$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $d38b9f8cdb785fa6$var$ARROW_LEFT : $d38b9f8cdb785fa6$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($d38b9f8cdb785fa6$var$isMainOrientationKey(event.key, orientation)) {
            (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $5404d435e7bfb958$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $d38b9f8cdb785fa6$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($d38b9f8cdb785fa6$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $5404d435e7bfb958$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $5404d435e7bfb958$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $5404d435e7bfb958$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $5404d435e7bfb958$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $5404d435e7bfb958$export$75effb89758ec596)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $igtsr.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $igtsr.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $igtsr.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $5404d435e7bfb958$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $5404d435e7bfb958$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $d38b9f8cdb785fa6$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $d38b9f8cdb785fa6$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $d38b9f8cdb785fa6$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $d38b9f8cdb785fa6$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $5404d435e7bfb958$export$e7e88d43cb97db79)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $d38b9f8cdb785fa6$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = (0, $5404d435e7bfb958$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $d38b9f8cdb785fa6$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $d38b9f8cdb785fa6$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const defaultReferenceId = $d38b9f8cdb785fa6$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $igtsr.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $5404d435e7bfb958$export$9b0901b5e9b45fc7)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $d38b9f8cdb785fa6$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $d38b9f8cdb785fa6$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $igtsr.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $igtsr.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $igtsr.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    'aria-selected': selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $d38b9f8cdb785fa6$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $d38b9f8cdb785fa6$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $d38b9f8cdb785fa6$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $igtsr.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $igtsr.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $d38b9f8cdb785fa6$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $igtsr.useState('unmounted');
    const isMounted = $d38b9f8cdb785fa6$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $7731928cc933a5ef$exports.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $d38b9f8cdb785fa6$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $igtsr.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $igtsr.useState(()=>({
            ...$d38b9f8cdb785fa6$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$d38b9f8cdb785fa6$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $d38b9f8cdb785fa6$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(unstable_initial);
    const openRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(unstable_open);
    const closeRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(unstable_close);
    const commonRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(unstable_common);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        const initialStyles = $d38b9f8cdb785fa6$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $d38b9f8cdb785fa6$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $d38b9f8cdb785fa6$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $d38b9f8cdb785fa6$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($d38b9f8cdb785fa6$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($d38b9f8cdb785fa6$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $d38b9f8cdb785fa6$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $igtsr.useRef(-1);
    const stringRef = $igtsr.useRef('');
    const prevIndexRef = $igtsr.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $igtsr.useRef(null);
    const onMatch = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(unstable_onMatch);
    const onTypingChange = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(unstable_onTypingChange);
    const findMatchRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(findMatch);
    const ignoreKeysRef = (0, $5404d435e7bfb958$export$bcd07ba85a740103)(ignoreKeys);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        if (open) {
            $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $5404d435e7bfb958$export$bb3b3b3acfd7447f)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $5404d435e7bfb958$export$7f54fc3180508a52)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $5404d435e7bfb958$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $d38b9f8cdb785fa6$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $igtsr.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $igtsr.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $d38b9f8cdb785fa6$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $d38b9f8cdb785fa6$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $0c3eeddb1ed27edf$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $f0992af029e4f475$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $46988e907ff1ddf1$export$37b6bde19b108ecc)($d38b9f8cdb785fa6$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $46988e907ff1ddf1$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $0c3eeddb1ed27edf$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $0c3eeddb1ed27edf$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $0c3eeddb1ed27edf$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $7731928cc933a5ef$exports.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $46988e907ff1ddf1$export$37b6bde19b108ecc)($d38b9f8cdb785fa6$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $d38b9f8cdb785fa6$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $5404d435e7bfb958$export$7f54fc3180508a52)(unstable_onChange);
    const controlledScrollingRef = $igtsr.useRef(false);
    const prevScrollTopRef = $igtsr.useRef(null);
    const initialOverflowRef = $igtsr.useRef(null);
    $igtsr.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $7731928cc933a5ef$exports.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $5404d435e7bfb958$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $igtsr.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $7731928cc933a5ef$exports.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $igtsr.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $d38b9f8cdb785fa6$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = onlyOpenChildren ? nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        }) : nodes;
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $d38b9f8cdb785fa6$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $d38b9f8cdb785fa6$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $d38b9f8cdb785fa6$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $d38b9f8cdb785fa6$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $d38b9f8cdb785fa6$var$contains(elements.floating, target);
            const isOverReferenceEl = $d38b9f8cdb785fa6$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $d38b9f8cdb785fa6$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $76497176d8ac8544$export$45a5e7f76e0caa8d)(event.relatedTarget) && $d38b9f8cdb785fa6$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $d38b9f8cdb785fa6$var$getNodeChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($d38b9f8cdb785fa6$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$d38b9f8cdb785fa6$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $44884d0571b9c796$var$_extendStatics = function extendStatics(d, b) {
    $44884d0571b9c796$var$_extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $44884d0571b9c796$var$_extendStatics(d, b);
};
function $44884d0571b9c796$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $44884d0571b9c796$var$_extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $44884d0571b9c796$var$_assign = function __assign() {
    $44884d0571b9c796$var$_assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $44884d0571b9c796$var$_assign.apply(this, arguments);
};
function $44884d0571b9c796$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $44884d0571b9c796$export$946daa762919616e = function(_a) {
    var _b = _a.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a.showTime, showTime = _c === void 0 ? false : _c, className = _a.className, children = _a.children;
    var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        className: className,
        role: "dialog",
        "aria-label": ariaLabel,
        "aria-modal": "true"
    }, children);
};
var $44884d0571b9c796$var$useDetectClickOutside = function(onClickOutside, ignoreClass) {
    var ref = (0, $igtsr.useRef)(null);
    var onClickOutsideRef = (0, $igtsr.useRef)(onClickOutside);
    onClickOutsideRef.current = onClickOutside;
    var handleClickOutside = (0, $igtsr.useCallback)(function(event) {
        var _a;
        var target = event.composed && event.composedPath && event.composedPath().find(function(eventTarget) {
            return eventTarget instanceof Node;
        }) || event.target;
        if (ref.current && !ref.current.contains(target)) {
            if (!(ignoreClass && target instanceof HTMLElement && target.classList.contains(ignoreClass))) (_a = onClickOutsideRef.current) === null || _a === void 0 || _a.call(onClickOutsideRef, event);
        }
    }, [
        ignoreClass
    ]);
    (0, $igtsr.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return ref;
};
var $44884d0571b9c796$var$ClickOutsideWrapper = function(_a) {
    var children = _a.children, onClickOutside = _a.onClickOutside, className = _a.className, containerRef = _a.containerRef, style = _a.style, ignoreClass = _a.ignoreClass;
    var detectRef = $44884d0571b9c796$var$useDetectClickOutside(onClickOutside, ignoreClass);
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
        className: className,
        style: style,
        ref: function(node) {
            detectRef.current = node;
            if (containerRef) containerRef.current = node;
        }
    }, children);
};
var $44884d0571b9c796$var$KeyType;
(function(KeyType) {
    KeyType["ArrowUp"] = "ArrowUp";
    KeyType["ArrowDown"] = "ArrowDown";
    KeyType["ArrowLeft"] = "ArrowLeft";
    KeyType["ArrowRight"] = "ArrowRight";
    KeyType["PageUp"] = "PageUp";
    KeyType["PageDown"] = "PageDown";
    KeyType["Home"] = "Home";
    KeyType["End"] = "End";
    KeyType["Enter"] = "Enter";
    KeyType["Space"] = " ";
    KeyType["Tab"] = "Tab";
    KeyType["Escape"] = "Escape";
    KeyType["Backspace"] = "Backspace";
    KeyType["X"] = "x";
})($44884d0571b9c796$var$KeyType || ($44884d0571b9c796$var$KeyType = {}));
function $44884d0571b9c796$var$getLocaleScope() {
    // Use this cast to avoid messing with users globalThis (like window) and the rest of keys in the globalThis object we don't care about
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope;
}
var $44884d0571b9c796$var$DEFAULT_YEAR_ITEM_NUMBER = 12;
// ** Date Constructors **
function $44884d0571b9c796$var$newDate(value) {
    if (value == null) return new Date();
    var d = typeof value === "string" ? (0, $880a1314338b58f7$export$4393d2ccbbedb219)(value) : (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(value);
    return $44884d0571b9c796$var$isValid(d) ? d : new Date();
}
/**
 * Parses a date.
 *
 * @param value - The string representing the Date in a parsable form, e.g., ISO 1861
 * @param dateFormat - The date format.
 * @param locale - The locale.
 * @param strictParsing - The strict parsing flag.
 * @param refDate - The base date to be passed to date-fns parse() function.
 * @returns - The parsed date or null.
 */ function $44884d0571b9c796$var$parseDate(value, dateFormat, locale, strictParsing, refDate) {
    if (refDate === void 0) refDate = $44884d0571b9c796$var$newDate();
    var localeObject = $44884d0571b9c796$var$getLocaleObject(locale) || $44884d0571b9c796$var$getLocaleObject($44884d0571b9c796$export$f09106e7c6677ec5());
    var formats = Array.isArray(dateFormat) ? dateFormat : [
        dateFormat
    ];
    for(var _i = 0, formats_1 = formats; _i < formats_1.length; _i++){
        var format_1 = formats_1[_i];
        var parsedDate = (0, $cb592846cd729ef7$export$98e6a39c04603d36)(value, format_1, refDate, {
            locale: localeObject,
            useAdditionalWeekYearTokens: true,
            useAdditionalDayOfYearTokens: true
        });
        if ($44884d0571b9c796$var$isValid(parsedDate) && (!strictParsing || value === $44884d0571b9c796$var$formatDate(parsedDate, format_1, locale))) return parsedDate;
    }
    return null;
}
/**
 * Checks if a given date is valid and not before the minimum date.
 * @param date - The date to be checked.
 * @param minDate - The minimum date allowed. If not provided, defaults to "1/1/1800".
 * @returns A boolean value indicating whether the date is valid and not before the minimum date.
 */ function $44884d0571b9c796$var$isValid(date, minDate) {
    /* the fallback date is essential to not break test case
     * `should auto update calendar when the updated date text is after props.minDate`
     * and backward compatibility respectfully
     */ return (0, $31ea96f9e7ca8d70$export$1ea939691cdc45b8)(date) && !(0, $ec5a63c4588c1c61$export$5c007e10c6929c95)(date, new Date("1/1/1800"));
}
// ** Date Formatting **
/**
 * Formats a date.
 *
 * @param date - The date.
 * @param formatStr - The format string.
 * @param locale - The locale.
 * @returns - The formatted date.
 */ function $44884d0571b9c796$var$formatDate(date, formatStr, locale) {
    if (locale === "en") return (0, $7aa2e35e5d01626e$export$d9468344d3651243)(date, formatStr, {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
    var localeObj = locale ? $44884d0571b9c796$var$getLocaleObject(locale) : undefined;
    if (locale && !localeObj) console.warn("A locale object was not found for the provided string [\"".concat(locale, "\"]."));
    localeObj = localeObj || $44884d0571b9c796$var$getLocaleObject($44884d0571b9c796$export$f09106e7c6677ec5());
    return (0, $7aa2e35e5d01626e$export$d9468344d3651243)(date, formatStr, {
        locale: localeObj,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
}
/**
 * Safely formats a date.
 *
 * @param date - The date.
 * @param options - An object containing the dateFormat and locale.
 * @returns - The formatted date or an empty string.
 */ function $44884d0571b9c796$var$safeDateFormat(date, _a) {
    var dateFormat = _a.dateFormat, locale = _a.locale;
    var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat; // Cast to string because it's impossible to get `string | string[] | undefined` here and typescript doesn't know that
    return date && $44884d0571b9c796$var$formatDate(date, formatStr, locale) || "";
}
/**
 * Safely formats a date range.
 *
 * @param startDate - The start date.
 * @param endDate - The end date.
 * @param props - The props.
 * @returns - The formatted date range or an empty string.
 */ function $44884d0571b9c796$var$safeDateRangeFormat(startDate, endDate, props) {
    if (!startDate) return "";
    var formattedStartDate = $44884d0571b9c796$var$safeDateFormat(startDate, props);
    var formattedEndDate = endDate ? $44884d0571b9c796$var$safeDateFormat(endDate, props) : "";
    return "".concat(formattedStartDate, " - ").concat(formattedEndDate);
}
/**
 * Safely formats multiple dates.
 *
 * @param dates - The dates.
 * @param props - The props.
 * @returns - The formatted dates or an empty string.
 */ function $44884d0571b9c796$var$safeMultipleDatesFormat(dates, props) {
    if (!(dates === null || dates === void 0 ? void 0 : dates.length)) return "";
    var formattedFirstDate = dates[0] ? $44884d0571b9c796$var$safeDateFormat(dates[0], props) : "";
    if (dates.length === 1) return formattedFirstDate;
    if (dates.length === 2 && dates[1]) {
        var formattedSecondDate = $44884d0571b9c796$var$safeDateFormat(dates[1], props);
        return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
    }
    var extraDatesCount = dates.length - 1;
    return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
// ** Date Setters **
/**
 * Sets the time for a given date.
 *
 * @param date - The date.
 * @param time - An object containing the hour, minute, and second.
 * @returns - The date with the time set.
 */ function $44884d0571b9c796$var$setTime(date, _a) {
    var _b = _a.hour, hour = _b === void 0 ? 0 : _b, _c = _a.minute, minute = _c === void 0 ? 0 : _c, _d = _a.second, second = _d === void 0 ? 0 : _d;
    return (0, $d6ffaacd9c9d24f5$export$f86b797a4659b781)((0, $9dd62e38f6f7ba31$export$ad569bf1c79ea89d)((0, $2a9373e0b1ea9533$export$aec44746644cbf43)(date, second), minute), hour);
}
/**
 * Gets the week of the year for a given date.
 *
 * @param date - The date.
 * @returns - The week of the year.
 */ function $44884d0571b9c796$var$getWeek(date) {
    return (0, $661b8d7938fc9bab$export$7cabdc5698b63e2f)(date);
}
/**
 * Gets the day of the week code for a given day.
 *
 * @param day - The day.
 * @param locale - The locale.
 * @returns - The day of the week code.
 */ function $44884d0571b9c796$var$getDayOfWeekCode(day, locale) {
    return $44884d0571b9c796$var$formatDate(day, "ddd", locale);
}
// *** Start of ***
/**
 * Gets the start of the day for a given date.
 *
 * @param date - The date.
 * @returns - The start of the day.
 */ function $44884d0571b9c796$var$getStartOfDay(date) {
    return (0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)(date);
}
/**
 * Gets the start of the week for a given date.
 *
 * @param date - The date.
 * @param locale - The locale.
 * @param calendarStartDay - The day the calendar starts on.
 * @returns - The start of the week.
 */ function $44884d0571b9c796$var$getStartOfWeek(date, locale, calendarStartDay) {
    var localeObj = locale ? $44884d0571b9c796$var$getLocaleObject(locale) : $44884d0571b9c796$var$getLocaleObject($44884d0571b9c796$export$f09106e7c6677ec5());
    return (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(date, {
        locale: localeObj,
        weekStartsOn: calendarStartDay
    });
}
/**
 * Gets the start of the month for a given date.
 *
 * @param date - The date.
 * @returns - The start of the month.
 */ function $44884d0571b9c796$var$getStartOfMonth(date) {
    return (0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)(date);
}
/**
 * Gets the start of the year for a given date.
 *
 * @param date - The date.
 * @returns - The start of the year.
 */ function $44884d0571b9c796$var$getStartOfYear(date) {
    return (0, $c8148e08909dec9f$export$f91e89d3d0406102)(date);
}
/**
 * Gets the start of the quarter for a given date.
 *
 * @param date - The date.
 * @returns - The start of the quarter.
 */ function $44884d0571b9c796$var$getStartOfQuarter(date) {
    return (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(date);
}
/**
 * Gets the start of today.
 *
 * @returns - The start of today.
 */ function $44884d0571b9c796$var$getStartOfToday() {
    return (0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)($44884d0571b9c796$var$newDate());
}
// *** End of ***
/**
 * Gets the end of the day for a given date.
 *
 * @param date - The date.
 * @returns - The end of the day.
 */ function $44884d0571b9c796$var$getEndOfDay(date) {
    return (0, $f92e3fd6ae51bdb5$export$eb9a03f0e9aa6cea)(date);
}
/**
 * Gets the end of the week for a given date.
 *
 * @param date - The date.
 * @returns - The end of the week.
 */ function $44884d0571b9c796$var$getEndOfWeek(date) {
    return (0, $a2f45d6e9fc115f1$export$ef8b6d9133084f4e)(date);
}
/**
 * Gets the end of the month for a given date.
 *
 * @param date - The date.
 * @returns - The end of the month.
 */ function $44884d0571b9c796$var$getEndOfMonth(date) {
    return (0, $0686a4d407c7043b$export$a2258d9c4118825c)(date);
}
/**
 * Checks if two dates are in the same year.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same year, false otherwise.
 */ function $44884d0571b9c796$var$isSameYear(date1, date2) {
    if (date1 && date2) return (0, $5d41b97ed555f92b$export$5841f9eb9773f25f)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same month.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same month, false otherwise.
 */ function $44884d0571b9c796$var$isSameMonth(date1, date2) {
    if (date1 && date2) return (0, $2ab718cd17362052$export$a18c89cbd24170ff)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same quarter.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same quarter, false otherwise.
 */ function $44884d0571b9c796$var$isSameQuarter(date1, date2) {
    if (date1 && date2) return (0, $b4c5ff470530ccad$export$5c60e4190867161c)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are on the same day.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are on the same day, false otherwise.
 */ function $44884d0571b9c796$var$isSameDay(date1, date2) {
    if (date1 && date2) return (0, $900cc00d4a65f84f$export$ea39ec197993aef0)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are equal.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are equal, false otherwise.
 */ function $44884d0571b9c796$var$isEqual(date1, date2) {
    if (date1 && date2) return (0, $75fc031f7966174f$export$248d38f6296296c5)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if a day is within a date range.
 *
 * @param day - The day to check.
 * @param startDate - The start date of the range.
 * @param endDate - The end date of the range.
 * @returns - True if the day is within the range, false otherwise.
 */ function $44884d0571b9c796$var$isDayInRange(day, startDate, endDate) {
    var valid;
    var start = (0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)(startDate);
    var end = (0, $f92e3fd6ae51bdb5$export$eb9a03f0e9aa6cea)(endDate);
    try {
        valid = (0, $7ae0f7ba0fce2f7b$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
// ** Date Localization **
/**
 * Registers a locale.
 *
 * @param localeName - The name of the locale.
 * @param localeData - The data of the locale.
 */ function $44884d0571b9c796$export$bab6a7822cc1e2cd(localeName, localeData) {
    var scope = $44884d0571b9c796$var$getLocaleScope();
    if (!scope.__localeData__) scope.__localeData__ = {};
    scope.__localeData__[localeName] = localeData;
}
/**
 * Sets the default locale.
 *
 * @param localeName - The name of the locale.
 */ function $44884d0571b9c796$export$a1a5025df4e9ba34(localeName) {
    var scope = $44884d0571b9c796$var$getLocaleScope();
    scope.__localeId__ = localeName;
}
/**
 * Gets the default locale.
 *
 * @returns - The default locale.
 */ function $44884d0571b9c796$export$f09106e7c6677ec5() {
    var scope = $44884d0571b9c796$var$getLocaleScope();
    return scope.__localeId__;
}
/**
 * Gets the locale object.
 *
 * @param localeSpec - The locale specification.
 * @returns - The locale object.
 */ function $44884d0571b9c796$var$getLocaleObject(localeSpec) {
    if (typeof localeSpec === "string") {
        // Treat it as a locale name registered by registerLocale
        var scope = $44884d0571b9c796$var$getLocaleScope();
        // Null was replaced with undefined to avoid type coercion
        return scope.__localeData__ ? scope.__localeData__[localeSpec] : undefined;
    } else // Treat it as a raw date-fns locale object
    return localeSpec;
}
/**
 * Formats the weekday in a given locale.
 *
 * @param date - The date to format.
 * @param formatFunc - The formatting function.
 * @param locale - The locale to use for formatting.
 * @returns - The formatted weekday.
 */ function $44884d0571b9c796$var$getFormattedWeekdayInLocale(date, formatFunc, locale) {
    return formatFunc($44884d0571b9c796$var$formatDate(date, "EEEE", locale));
}
/**
 * Gets the minimum weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The minimum weekday.
 */ function $44884d0571b9c796$var$getWeekdayMinInLocale(date, locale) {
    return $44884d0571b9c796$var$formatDate(date, "EEEEEE", locale);
}
/**
 * Gets the short weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short weekday.
 */ function $44884d0571b9c796$var$getWeekdayShortInLocale(date, locale) {
    return $44884d0571b9c796$var$formatDate(date, "EEE", locale);
}
/**
 * Gets the month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The month.
 */ function $44884d0571b9c796$var$getMonthInLocale(month, locale) {
    return $44884d0571b9c796$var$formatDate((0, $abe1c83fecf1276a$export$63264690f8e36790)($44884d0571b9c796$var$newDate(), month), "LLLL", locale);
}
/**
 * Gets the short month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short month.
 */ function $44884d0571b9c796$var$getMonthShortInLocale(month, locale) {
    return $44884d0571b9c796$var$formatDate((0, $abe1c83fecf1276a$export$63264690f8e36790)($44884d0571b9c796$var$newDate(), month), "LLL", locale);
}
/**
 * Gets the short quarter in a given locale.
 *
 * @param quarter - The quarter to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short quarter.
 */ function $44884d0571b9c796$var$getQuarterShortInLocale(quarter, locale) {
    return $44884d0571b9c796$var$formatDate((0, $a2e940077f21299d$export$8924d1de7efe1755)($44884d0571b9c796$var$newDate(), quarter), "QQQ", locale);
}
/**
 * Checks if a day is disabled.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is disabled, false otherwise.
 */ function $44884d0571b9c796$var$isDayDisabled(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate;
    return $44884d0571b9c796$var$isOutOfBounds(day, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludeDate) {
        if (excludeDate instanceof Date) return $44884d0571b9c796$var$isSameDay(day, excludeDate);
        else return $44884d0571b9c796$var$isSameDay(day, excludeDate.date);
    }) || excludeDateIntervals && excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $7ae0f7ba0fce2f7b$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || includeDates && !includeDates.some(function(includeDate) {
        return $44884d0571b9c796$var$isSameDay(day, includeDate);
    }) || includeDateIntervals && !includeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $7ae0f7ba0fce2f7b$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || filterDate && !filterDate($44884d0571b9c796$var$newDate(day)) || false;
}
/**
 * Checks if a day is excluded.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is excluded, false otherwise.
 */ function $44884d0571b9c796$var$isDayExcluded(day, _a) {
    var _b = _a === void 0 ? {} : _a, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
    if (excludeDateIntervals && excludeDateIntervals.length > 0) return excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $7ae0f7ba0fce2f7b$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    });
    return excludeDates && excludeDates.some(function(excludeDate) {
        var _a;
        if (excludeDate instanceof Date) return $44884d0571b9c796$var$isSameDay(day, excludeDate);
        else return $44884d0571b9c796$var$isSameDay(day, (_a = excludeDate.date) !== null && _a !== void 0 ? _a : new Date());
    }) || false;
}
function $44884d0571b9c796$var$isMonthDisabled(month, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return $44884d0571b9c796$var$isOutOfBounds(month, {
        minDate: minDate ? (0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)(minDate) : undefined,
        maxDate: maxDate ? (0, $0686a4d407c7043b$export$a2258d9c4118825c)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $44884d0571b9c796$var$isSameMonth(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $44884d0571b9c796$var$isSameMonth(month, includeDate);
    }) || filterDate && !filterDate($44884d0571b9c796$var$newDate(month)) || false;
}
function $44884d0571b9c796$var$isMonthInRange(startDate, endDate, m, day) {
    var startDateYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(startDate);
    var startDateMonth = (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(startDate);
    var endDateYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(endDate);
    var endDateMonth = (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(endDate);
    var dayYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
/**
 * To check if a date's month and year are disabled/excluded
 * @param date Date to check
 * @returns {boolean} true if month and year are disabled/excluded, false otherwise
 */ function $44884d0571b9c796$var$isMonthYearDisabled(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
    return $44884d0571b9c796$var$isOutOfBounds(date, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludedDate) {
        return $44884d0571b9c796$var$isSameMonth(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
    }) || includeDates && !includeDates.some(function(includedDate) {
        return $44884d0571b9c796$var$isSameMonth(includedDate, date);
    }) || false;
}
function $44884d0571b9c796$var$isQuarterDisabled(quarter, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return $44884d0571b9c796$var$isOutOfBounds(quarter, {
        minDate: minDate,
        maxDate: maxDate
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $44884d0571b9c796$var$isSameQuarter(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $44884d0571b9c796$var$isSameQuarter(quarter, includeDate);
    }) || filterDate && !filterDate($44884d0571b9c796$var$newDate(quarter)) || false;
}
function $44884d0571b9c796$var$isYearInRange(year, start, end) {
    if (!start || !end) return false;
    if (!(0, $31ea96f9e7ca8d70$export$1ea939691cdc45b8)(start) || !(0, $31ea96f9e7ca8d70$export$1ea939691cdc45b8)(end)) return false;
    var startYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(start);
    var endYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(end);
    return startYear <= year && endYear >= year;
}
function $44884d0571b9c796$var$isYearDisabled(year, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    var date = new Date(year, 0, 1);
    return $44884d0571b9c796$var$isOutOfBounds(date, {
        minDate: minDate ? (0, $c8148e08909dec9f$export$f91e89d3d0406102)(minDate) : undefined,
        maxDate: maxDate ? (0, $938b9f25b96c36ea$export$8b7aa55c66d5569e)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $44884d0571b9c796$var$isSameYear(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $44884d0571b9c796$var$isSameYear(date, includeDate);
    }) || filterDate && !filterDate($44884d0571b9c796$var$newDate(date)) || false;
}
function $44884d0571b9c796$var$isQuarterInRange(startDate, endDate, q, day) {
    var startDateYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(startDate);
    var startDateQuarter = (0, $8de2b2935de63c65$export$de90a4bb31c25221)(startDate);
    var endDateYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(endDate);
    var endDateQuarter = (0, $8de2b2935de63c65$export$de90a4bb31c25221)(endDate);
    var dayYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateQuarter <= q && q <= endDateQuarter;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
function $44884d0571b9c796$var$isOutOfBounds(day, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, minDate = _c.minDate, maxDate = _c.maxDate;
    return (_b = minDate && (0, $2efa7f87d37460af$export$4a02e9c37dab4871)(day, minDate) < 0 || maxDate && (0, $2efa7f87d37460af$export$4a02e9c37dab4871)(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function $44884d0571b9c796$var$isTimeInList(time, times) {
    return times.some(function(listTime) {
        return (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(listTime) === (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(time) && (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(listTime) === (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(time) && (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(listTime) === (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(time);
    });
}
function $44884d0571b9c796$var$isTimeDisabled(time, _a) {
    var _b = _a === void 0 ? {} : _a, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
    return excludeTimes && $44884d0571b9c796$var$isTimeInList(time, excludeTimes) || includeTimes && !$44884d0571b9c796$var$isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function $44884d0571b9c796$var$isTimeInDisabledRange(time, _a) {
    var minTime = _a.minTime, maxTime = _a.maxTime;
    if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
    var baseTime = $44884d0571b9c796$var$newDate();
    baseTime = (0, $d6ffaacd9c9d24f5$export$f86b797a4659b781)(baseTime, (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(time));
    baseTime = (0, $9dd62e38f6f7ba31$export$ad569bf1c79ea89d)(baseTime, (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(time));
    baseTime = (0, $2a9373e0b1ea9533$export$aec44746644cbf43)(baseTime, (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(time));
    var min = $44884d0571b9c796$var$newDate();
    min = (0, $d6ffaacd9c9d24f5$export$f86b797a4659b781)(min, (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(minTime));
    min = (0, $9dd62e38f6f7ba31$export$ad569bf1c79ea89d)(min, (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(minTime));
    min = (0, $2a9373e0b1ea9533$export$aec44746644cbf43)(min, (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(minTime));
    var max = $44884d0571b9c796$var$newDate();
    max = (0, $d6ffaacd9c9d24f5$export$f86b797a4659b781)(max, (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(maxTime));
    max = (0, $9dd62e38f6f7ba31$export$ad569bf1c79ea89d)(max, (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(maxTime));
    max = (0, $2a9373e0b1ea9533$export$aec44746644cbf43)(max, (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(maxTime));
    var valid;
    try {
        valid = !(0, $7ae0f7ba0fce2f7b$export$d7deef7a3738e19d)(baseTime, {
            start: min,
            end: max
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
function $44884d0571b9c796$var$monthDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousMonth = (0, $377f863a28de0454$export$73d1c15a21f9fae5)(day, 1);
    return minDate && (0, $23645b8f1c5acc22$export$489984ac7c996389)(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $23645b8f1c5acc22$export$489984ac7c996389)(includeDate, previousMonth) > 0;
    }) || false;
}
function $44884d0571b9c796$var$monthDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextMonth = (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(day, 1);
    return maxDate && (0, $23645b8f1c5acc22$export$489984ac7c996389)(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $23645b8f1c5acc22$export$489984ac7c996389)(nextMonth, includeDate) > 0;
    }) || false;
}
function $44884d0571b9c796$var$quarterDisabledBefore(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var firstDateOfYear = (0, $c8148e08909dec9f$export$f91e89d3d0406102)(date);
    var previousQuarter = (0, $92df7bb0743d0fc6$export$a31bfeeeee80cce6)(firstDateOfYear, 1);
    return minDate && (0, $a178ede58156510d$export$f62ae9fb13958c7a)(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $a178ede58156510d$export$f62ae9fb13958c7a)(includeDate, previousQuarter) > 0;
    }) || false;
}
function $44884d0571b9c796$var$quarterDisabledAfter(date, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var lastDateOfYear = (0, $938b9f25b96c36ea$export$8b7aa55c66d5569e)(date);
    var nextQuarter = (0, $8be8906ab05d096d$export$c252a41d0fbed2ce)(lastDateOfYear, 1);
    return maxDate && (0, $a178ede58156510d$export$f62ae9fb13958c7a)(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $a178ede58156510d$export$f62ae9fb13958c7a)(nextQuarter, includeDate) > 0;
    }) || false;
}
function $44884d0571b9c796$var$yearDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousYear = (0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(day, 1);
    return minDate && (0, $8ea362b00a47a9b7$export$c06dce8b38891685)(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $8ea362b00a47a9b7$export$c06dce8b38891685)(includeDate, previousYear) > 0;
    }) || false;
}
function $44884d0571b9c796$var$yearsDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $44884d0571b9c796$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var previousYear = $44884d0571b9c796$var$getStartOfYear((0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(day, yearItemNumber));
    var endPeriod = $44884d0571b9c796$var$getYearsPeriod(previousYear, yearItemNumber).endPeriod;
    var minDateYear = minDate && (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(minDate);
    return minDateYear && minDateYear > endPeriod || false;
}
function $44884d0571b9c796$var$yearDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextYear = (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(day, 1);
    return maxDate && (0, $8ea362b00a47a9b7$export$c06dce8b38891685)(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $8ea362b00a47a9b7$export$c06dce8b38891685)(nextYear, includeDate) > 0;
    }) || false;
}
function $44884d0571b9c796$var$yearsDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $44884d0571b9c796$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var nextYear = (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(day, yearItemNumber);
    var startPeriod = $44884d0571b9c796$var$getYearsPeriod(nextYear, yearItemNumber).startPeriod;
    var maxDateYear = maxDate && (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(maxDate);
    return maxDateYear && maxDateYear < startPeriod || false;
}
function $44884d0571b9c796$var$getEffectiveMinDate(_a) {
    var minDate = _a.minDate, includeDates = _a.includeDates;
    if (includeDates && minDate) {
        var minDates = includeDates.filter(function(includeDate) {
            return (0, $2efa7f87d37460af$export$4a02e9c37dab4871)(includeDate, minDate) >= 0;
        });
        return (0, $9c2757f1d5701b76$export$96ec731ed4dcb222)(minDates);
    } else if (includeDates) return (0, $9c2757f1d5701b76$export$96ec731ed4dcb222)(includeDates);
    else return minDate;
}
function $44884d0571b9c796$var$getEffectiveMaxDate(_a) {
    var maxDate = _a.maxDate, includeDates = _a.includeDates;
    if (includeDates && maxDate) {
        var maxDates = includeDates.filter(function(includeDate) {
            return (0, $2efa7f87d37460af$export$4a02e9c37dab4871)(includeDate, maxDate) <= 0;
        });
        return (0, $ab8ba948e852157d$export$8960430cfd85939f)(maxDates);
    } else if (includeDates) return (0, $ab8ba948e852157d$export$8960430cfd85939f)(includeDates);
    else return maxDate;
}
/**
 * Get a map of highlighted dates with their corresponding classes.
 * @param highlightDates The dates to highlight.
 * @param defaultClassName The default class to use for highlighting.
 * @returns A map with dates as keys and arrays of class names as values.
 */ function $44884d0571b9c796$var$getHighLightDaysMap(highlightDates, defaultClassName) {
    var _a;
    if (highlightDates === void 0) highlightDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for(var i = 0, len = highlightDates.length; i < len; i++){
        var obj = highlightDates[i];
        if ((0, $0aae887686bd5a23$export$871608497c498473)(obj)) {
            var key = $44884d0571b9c796$var$formatDate(obj, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(defaultClassName)) {
                classNamesArr.push(defaultClassName);
                dateClasses.set(key, classNamesArr);
            }
        } else if (typeof obj === "object") {
            var keys = Object.keys(obj);
            var className = (_a = keys[0]) !== null && _a !== void 0 ? _a : "";
            var arrOfDates = obj[className];
            if (typeof className === "string" && Array.isArray(arrOfDates)) for(var k = 0, len_1 = arrOfDates.length; k < len_1; k++){
                var dateK = arrOfDates[k];
                if (dateK) {
                    var key = $44884d0571b9c796$var$formatDate(dateK, "MM.dd.yyyy");
                    var classNamesArr = dateClasses.get(key) || [];
                    if (!classNamesArr.includes(className)) {
                        classNamesArr.push(className);
                        dateClasses.set(key, classNamesArr);
                    }
                }
            }
        }
    }
    return dateClasses;
}
/**
 * Compare the two arrays
 * @param array1 The first array to compare.
 * @param array2 The second array to compare.
 * @returns true, if the passed arrays are equal, false otherwise.
 */ function $44884d0571b9c796$var$arraysAreEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    return array1.every(function(value, index) {
        return value === array2[index];
    });
}
/**
 * Assign the custom class to each date
 * @param holidayDates array of object containing date and name of the holiday
 * @param defaultClassName className to be added.
 * @returns Map containing date as key and array of className and holiday name as value
 */ function $44884d0571b9c796$var$getHolidaysMap(holidayDates, defaultClassName) {
    if (holidayDates === void 0) holidayDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--holidays";
    var dateClasses = new Map();
    holidayDates.forEach(function(holiday) {
        var dateObj = holiday.date, holidayName = holiday.holidayName;
        if (!(0, $0aae887686bd5a23$export$871608497c498473)(dateObj)) return;
        var key = $44884d0571b9c796$var$formatDate(dateObj, "MM.dd.yyyy");
        var classNamesObj = dateClasses.get(key) || {
            className: "",
            holidayNames: []
        };
        if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && $44884d0571b9c796$var$arraysAreEqual(classNamesObj["holidayNames"], [
            holidayName
        ])) return;
        classNamesObj["className"] = defaultClassName;
        var holidayNameArr = classNamesObj["holidayNames"];
        classNamesObj["holidayNames"] = holidayNameArr ? $44884d0571b9c796$var$__spreadArray($44884d0571b9c796$var$__spreadArray([], holidayNameArr, true), [
            holidayName
        ], false) : [
            holidayName
        ];
        dateClasses.set(key, classNamesObj);
    });
    return dateClasses;
}
/**
 * Determines the times to inject after a given start of day, current time, and multiplier.
 * @param startOfDay The start of the day.
 * @param currentTime The current time.
 * @param currentMultiplier The current multiplier.
 * @param intervals The intervals.
 * @param injectedTimes The times to potentially inject.
 * @returns An array of times to inject.
 */ function $44884d0571b9c796$var$timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for(var i = 0; i < l; i++){
        var injectedTime = startOfDay;
        var injectedTimeValue = injectedTimes[i];
        if (injectedTimeValue) {
            injectedTime = (0, $10b3510745eb4a7b$export$4a4306ad4fa0e5e6)(injectedTime, (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(injectedTimeValue));
            injectedTime = (0, $22f30f6db3721034$export$2287e3d29250119e)(injectedTime, (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(injectedTimeValue));
            injectedTime = (0, $970cd96a21d4fd03$export$3cb31b0df13be68)(injectedTime, (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(injectedTimeValue));
        }
        var nextTime = (0, $22f30f6db3721034$export$2287e3d29250119e)(startOfDay, (currentMultiplier + 1) * intervals);
        if ((0, $89f716961fb46e12$export$e4de839670987035)(injectedTime, currentTime) && (0, $ec5a63c4588c1c61$export$5c007e10c6929c95)(injectedTime, nextTime) && injectedTimeValue != undefined) times.push(injectedTimeValue);
    }
    return times;
}
/**
 * Adds a leading zero to a number if it's less than 10.
 * @param i The number to add a leading zero to.
 * @returns The number as a string, with a leading zero if it was less than 10.
 */ function $44884d0571b9c796$var$addZero(i) {
    return i < 10 ? "0".concat(i) : "".concat(i);
}
/**
 * Gets the start and end years for a period.
 * @param date The date to get the period for.
 * @param yearItemNumber The number of years in the period. Defaults to DEFAULT_YEAR_ITEM_NUMBER.
 * @returns An object with the start and end years for the period.
 */ function $44884d0571b9c796$var$getYearsPeriod(date, yearItemNumber) {
    if (yearItemNumber === void 0) yearItemNumber = $44884d0571b9c796$var$DEFAULT_YEAR_ITEM_NUMBER;
    var endPeriod = Math.ceil((0, $064d553b51baf3e9$export$5846dc2d57a5c860)(date) / yearItemNumber) * yearItemNumber;
    var startPeriod = endPeriod - (yearItemNumber - 1);
    return {
        startPeriod: startPeriod,
        endPeriod: endPeriod
    };
}
/**
 * Gets the number of hours in a day.
 * @param d The date to get the number of hours for.
 * @returns The number of hours in the day.
 */ function $44884d0571b9c796$var$getHoursInDay(d) {
    var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
    return Math.round((+startOfTheNextDay - +startOfDay) / 3600000);
}
/**
 * Returns the start of the minute for the given date
 *
 * NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
 * do not make changes unless you know what you're doing
 *
 * See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
 * for more details
 *
 * @param d date
 * @returns start of the minute
 */ function $44884d0571b9c796$var$startOfMinute(d) {
    var seconds = d.getSeconds();
    var milliseconds = d.getMilliseconds();
    return (0, $3eee1f7ebbb7c256$export$e67a095c620b86fe)(d.getTime() - seconds * 1000 - milliseconds);
}
/**
 * Returns whether the given dates are in the same minute
 *
 * This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
 *
 * @param d1
 * @param d2
 * @returns
 */ function $44884d0571b9c796$var$isSameMinute(d1, d2) {
    return $44884d0571b9c796$var$startOfMinute(d1).getTime() === $44884d0571b9c796$var$startOfMinute(d2).getTime();
}
/**
 * Returns a new datetime object representing the input date with midnight time
 * @param date The date to get the midnight time for
 * @returns A new datetime object representing the input date with midnight time
 */ function $44884d0571b9c796$var$getMidnightDate(date) {
    if (!(0, $0aae887686bd5a23$export$871608497c498473)(date)) throw new Error("Invalid date");
    var dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    return dateWithoutTime;
}
/**
 * Is the first date before the second one?
 * @param date The date that should be before the other one to return true
 * @param dateToCompare The date to compare with
 * @returns The first date is before the second date
 *
 * Note:
 *  This function considers the mid-night of the given dates for comparison.
 *  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
 */ function $44884d0571b9c796$var$isDateBefore(date, dateToCompare) {
    if (!(0, $0aae887686bd5a23$export$871608497c498473)(date) || !(0, $0aae887686bd5a23$export$871608497c498473)(dateToCompare)) throw new Error("Invalid date received");
    var midnightDate = $44884d0571b9c796$var$getMidnightDate(date);
    var midnightDateToCompare = $44884d0571b9c796$var$getMidnightDate(dateToCompare);
    return (0, $ec5a63c4588c1c61$export$5c007e10c6929c95)(midnightDate, midnightDateToCompare);
}
/**
 * Checks if the space key was pressed down.
 *
 * @param event - The keyboard event.
 * @returns - Returns true if the space key was pressed down, false otherwise.
 */ function $44884d0571b9c796$var$isSpaceKeyDown(event) {
    return event.key === $44884d0571b9c796$var$KeyType.Space;
}
/**
 * `InputTime` is a React component that manages time input.
 *
 * @component
 * @example
 * <InputTime timeString="12:00" />
 *
 * @param props - The properties that define the `InputTime` component.
 * @param props.onChange - Function that is called when the date changes.
 * @param props.date - The initial date value.
 * @param props.timeString - The initial time string value.
 * @param props.timeInputLabel - The label for the time input.
 * @param props.customTimeInput - An optional custom time input element.
 *
 * @returns The `InputTime` component.
 */ var $44884d0571b9c796$var$InputTime = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(InputTime, _super);
    function InputTime(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        _this.onTimeChange = function(time) {
            var _a, _b;
            _this.setState({
                time: time
            });
            var propDate = _this.props.date;
            var isPropDateValid = propDate instanceof Date && !isNaN(+propDate);
            var date = isPropDateValid ? propDate : new Date();
            if (time === null || time === void 0 ? void 0 : time.includes(":")) {
                var _c = time.split(":"), hours = _c[0], minutes = _c[1];
                date.setHours(Number(hours));
                date.setMinutes(Number(minutes));
            }
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, date);
        };
        _this.renderTimeInput = function() {
            var time = _this.state.time;
            var _a = _this.props, date = _a.date, timeString = _a.timeString, customTimeInput = _a.customTimeInput;
            if (customTimeInput) return (0, $igtsr.cloneElement)(customTimeInput, {
                date: date,
                value: time,
                onChange: _this.onTimeChange
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("input", {
                type: "time",
                className: "react-datepicker-time__input",
                placeholder: "Time",
                name: "time-input",
                ref: _this.inputRef,
                onClick: function() {
                    var _a;
                    (_a = _this.inputRef.current) === null || _a === void 0 || _a.focus();
                },
                required: true,
                value: time,
                onChange: function(event) {
                    _this.onTimeChange(event.target.value || timeString);
                }
            });
        };
        _this.state = {
            time: _this.props.timeString
        };
        return _this;
    }
    InputTime.getDerivedStateFromProps = function(props, state) {
        if (props.timeString !== state.time) return {
            time: props.timeString
        };
        // Return null to indicate no change to state.
        return null;
    };
    InputTime.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__input-time-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker-time__input-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
    };
    return InputTime;
}((0, $igtsr.Component));
/**
 * `Day` is a React component that represents a single day in a date picker.
 * It handles the rendering and interaction of a day.
 *
 * @prop ariaLabelPrefixWhenEnabled - Aria label prefix when the day is enabled.
 * @prop ariaLabelPrefixWhenDisabled - Aria label prefix when the day is disabled.
 * @prop disabledKeyboardNavigation - Whether keyboard navigation is disabled.
 * @prop day - The day to be displayed.
 * @prop dayClassName - Function to customize the CSS class of the day.
 * @prop endDate - The end date in a range.
 * @prop highlightDates - Map of dates to be highlighted.
 * @prop holidays - Map of holiday dates.
 * @prop inline - Whether the date picker is inline.
 * @prop shouldFocusDayInline - Whether the day should be focused when date picker is inline.
 * @prop month - The month the day belongs to.
 * @prop onClick - Click event handler.
 * @prop onMouseEnter - Mouse enter event handler.
 * @prop handleOnKeyDown - Key down event handler.
 * @prop usePointerEvent - Whether to use pointer events.
 * @prop preSelection - The date that is currently selected.
 * @prop selected - The selected date.
 * @prop selectingDate - The date currently being selected.
 * @prop selectsEnd - Whether the day can be the end date in a range.
 * @prop selectsStart - Whether the day can be the start date in a range.
 * @prop selectsRange - Whether the day can be in a range.
 * @prop showWeekPicker - Whether to show week picker.
 * @prop showWeekNumber - Whether to show week numbers.
 * @prop selectsDisabledDaysInRange - Whether to select disabled days in a range.
 * @prop selectsMultiple - Whether to allow multiple date selection.
 * @prop selectedDates - Array of selected dates.
 * @prop startDate - The start date in a range.
 * @prop renderDayContents - Function to customize the rendering of the day's contents.
 * @prop containerRef - Ref for the container.
 * @prop excludeDates - Array of dates to be excluded.
 * @prop calendarStartDay - The start day of the week.
 * @prop locale - The locale object.
 * @prop monthShowsDuplicateDaysEnd - Whether to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Whether to show duplicate days at the start of the month.
 * @prop includeDates - Array of dates to be included.
 * @prop includeDateIntervals - Array of date intervals to be included.
 * @prop minDate - The minimum date that can be selected.
 * @prop maxDate - The maximum date that can be selected.
 *
 * @example
 * ```tsx
 * import React from 'react';
 * import Day from './day';
 *
 * function MyComponent() {
 *   const handleDayClick = (event) => {
 *     console.log('Day clicked', event);
 *   };
 *
 *   const handleDayMouseEnter = (event) => {
 *     console.log('Mouse entered day', event);
 *   };
 *
 *   const renderDayContents = (date) => {
 *     return <div>{date.getDate()}</div>;
 *   };
 *
 *   return (
 *     <Day
 *       day={new Date()}
 *       onClick={handleDayClick}
 *       onMouseEnter={handleDayMouseEnter}
 *       renderDayContents={renderDayContents}
 *     />
 *   );
 * }
 *
 * export default MyComponent;
 * ```
 */ var $44884d0571b9c796$var$Day = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dayEl = (0, $igtsr.createRef)();
        _this.handleClick = function(event) {
            if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
        };
        _this.handleMouseEnter = function(event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $44884d0571b9c796$var$KeyType.Space) {
                event.preventDefault();
                event.key = $44884d0571b9c796$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isSameDay = function(other) {
            return $44884d0571b9c796$var$isSameDay(_this.props.day, other);
        };
        _this.isKeyboardSelected = function() {
            var _a;
            if (_this.props.disabledKeyboardNavigation) return false;
            var isSelectedDate = _this.props.selectsMultiple ? (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            }) : _this.isSameDayOrWeek(_this.props.selected);
            var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
            return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
        };
        _this.isDisabled = function(day) {
            if (day === void 0) day = _this.props.day;
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $44884d0571b9c796$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function() {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $44884d0571b9c796$var$isDayExcluded(_this.props.day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.isStartOfWeek = function() {
            return $44884d0571b9c796$var$isSameDay(_this.props.day, $44884d0571b9c796$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameWeek = function(other) {
            return _this.props.showWeekPicker && $44884d0571b9c796$var$isSameDay(other, $44884d0571b9c796$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameDayOrWeek = function(other) {
            return _this.isSameDay(other) || _this.isSameWeek(other);
        };
        _this.getHighLightedClass = function() {
            var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
            if (!highlightDates) return false;
            // Looking for className in the Map of {'day string, 'className'}
            var dayStr = $44884d0571b9c796$var$formatDate(day, "MM.dd.yyyy");
            return highlightDates.get(dayStr);
        };
        // Function to return the array containing className associated to the date
        _this.getHolidaysClass = function() {
            var _a;
            var _b = _this.props, day = _b.day, holidays = _b.holidays;
            if (!holidays) // For type consistency no other reasons
            return [
                undefined
            ];
            var dayStr = $44884d0571b9c796$var$formatDate(day, "MM.dd.yyyy");
            // Looking for className in the Map of {day string: {className, holidayName}}
            if (holidays.has(dayStr)) return [
                (_a = holidays.get(dayStr)) === null || _a === void 0 ? void 0 : _a.className
            ];
            // For type consistency no other reasons
            return [
                undefined
            ];
        };
        _this.isInRange = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $44884d0571b9c796$var$isDayInRange(day, startDate, endDate);
        };
        _this.isInSelectingRange = function() {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) return false;
            if (selectsStart && endDate && ((0, $ec5a63c4588c1c61$export$5c007e10c6929c95)(selectingDate, endDate) || $44884d0571b9c796$var$isEqual(selectingDate, endDate))) return $44884d0571b9c796$var$isDayInRange(day, selectingDate, endDate);
            if (selectsEnd && startDate && !endDate && ((0, $89f716961fb46e12$export$e4de839670987035)(selectingDate, startDate) || $44884d0571b9c796$var$isEqual(selectingDate, startDate))) return $44884d0571b9c796$var$isDayInRange(day, startDate, selectingDate);
            if (selectsRange && startDate && !endDate && ((0, $89f716961fb46e12$export$e4de839670987035)(selectingDate, startDate) || $44884d0571b9c796$var$isEqual(selectingDate, startDate))) return $44884d0571b9c796$var$isDayInRange(day, startDate, selectingDate);
            return false;
        };
        _this.isSelectingRangeStart = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $44884d0571b9c796$var$isSameDay(day, selectingDate);
            else return $44884d0571b9c796$var$isSameDay(day, startDate);
        };
        _this.isSelectingRangeEnd = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd || selectsRange) return $44884d0571b9c796$var$isSameDay(day, selectingDate);
            else return $44884d0571b9c796$var$isSameDay(day, endDate);
        };
        _this.isRangeStart = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $44884d0571b9c796$var$isSameDay(startDate, day);
        };
        _this.isRangeEnd = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $44884d0571b9c796$var$isSameDay(endDate, day);
        };
        _this.isWeekend = function() {
            var weekday = (0, $4248408440acfe88$export$1b64bc9c5306ed54)(_this.props.day);
            return weekday === 0 || weekday === 6;
        };
        _this.isAfterMonth = function() {
            return _this.props.month !== undefined && (_this.props.month + 1) % 12 === (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(_this.props.day);
        };
        _this.isBeforeMonth = function() {
            return _this.props.month !== undefined && ((0, $de31b03371614c55$export$6ce1b5acc29cb53b)(_this.props.day) + 1) % 12 === _this.props.month;
        };
        _this.isCurrentDay = function() {
            return _this.isSameDay($44884d0571b9c796$var$newDate());
        };
        _this.isSelected = function() {
            var _a;
            if (_this.props.selectsMultiple) return (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            });
            return _this.isSameDayOrWeek(_this.props.selected);
        };
        _this.getClassNames = function(date) {
            var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
            return (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker__day", dayClassName, "react-datepicker__day--" + $44884d0571b9c796$var$getDayOfWeekCode(_this.props.day), {
                "react-datepicker__day--disabled": _this.isDisabled(),
                "react-datepicker__day--excluded": _this.isExcluded(),
                "react-datepicker__day--selected": _this.isSelected(),
                "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
                "react-datepicker__day--range-start": _this.isRangeStart(),
                "react-datepicker__day--range-end": _this.isRangeEnd(),
                "react-datepicker__day--in-range": _this.isInRange(),
                "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
                "react-datepicker__day--today": _this.isCurrentDay(),
                "react-datepicker__day--weekend": _this.isWeekend(),
                "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
            }, _this.getHighLightedClass(), _this.getHolidaysClass());
        };
        _this.getAriaLabel = function() {
            var _a = _this.props, day = _a.day, _b = _a.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
            var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
            return "".concat(prefix, " ").concat($44884d0571b9c796$var$formatDate(day, "PPPP", _this.props.locale));
        };
        // A function to return the holiday's name as title's content
        _this.getTitle = function() {
            var _a = _this.props, day = _a.day, _b = _a.holidays, holidays = _b === void 0 ? new Map() : _b, excludeDates = _a.excludeDates;
            var compareDt = $44884d0571b9c796$var$formatDate(day, "MM.dd.yyyy");
            var titles = [];
            if (holidays.has(compareDt)) titles.push.apply(titles, holidays.get(compareDt).holidayNames);
            if (_this.isExcluded()) titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
                if (excludeDate instanceof Date) return $44884d0571b9c796$var$isSameDay(excludeDate, day);
                return $44884d0571b9c796$var$isSameDay(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
            }).map(function(excludeDate) {
                if (excludeDate instanceof Date) return undefined;
                return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
            }));
            // I'm not sure that this is a right output, but all tests are green
            return titles.join(", ");
        };
        _this.getTabIndex = function() {
            var selectedDay = _this.props.selected;
            var preSelectionDay = _this.props.preSelection;
            var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && $44884d0571b9c796$var$isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
            return tabIndex;
        };
        // various cases when we need to apply focus to the preselected day
        // focus the day on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusDay = function() {
            var _a;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            _this.shouldFocusDay() && ((_a = _this.dayEl.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            }));
        };
        _this.renderDayContents = function() {
            if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
            if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
            return _this.props.renderDayContents ? _this.props.renderDayContents((0, $31fb3e9fe53f60ea$export$aa350b96d91cd94)(_this.props.day), _this.props.day) : (0, $31fb3e9fe53f60ea$export$aa350b96d91cd94)(_this.props.day);
        };
        _this.render = function() {
            return(// TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
            (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                ref: _this.dayEl,
                className: _this.getClassNames(_this.props.day),
                onKeyDown: _this.handleOnKeyDown,
                onClick: _this.handleClick,
                onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                tabIndex: _this.getTabIndex(),
                "aria-label": _this.getAriaLabel(),
                role: "option",
                title: _this.getTitle(),
                "aria-disabled": _this.isDisabled(),
                "aria-current": _this.isCurrentDay() ? "date" : undefined,
                "aria-selected": _this.isSelected() || _this.isInRange()
            }, _this.renderDayContents(), _this.getTitle() !== "" && (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: "overlay"
            }, _this.getTitle())));
        };
        return _this;
    }
    Day.prototype.componentDidMount = function() {
        this.handleFocusDay();
    };
    Day.prototype.componentDidUpdate = function() {
        this.handleFocusDay();
    };
    Day.prototype.shouldFocusDay = function() {
        var shouldFocusDay = false;
        if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
            // there is currently no activeElement and not inline
            if (!document.activeElement || document.activeElement === document.body) shouldFocusDay = true;
            // inline version:
            // do not focus on initial render to prevent autoFocus issue
            // focus after month has changed via keyboard
            if (this.props.inline && !this.props.shouldFocusDayInline) shouldFocusDay = false;
            if (this.isDayActiveElement()) shouldFocusDay = true;
            if (this.isDuplicateDay()) shouldFocusDay = false;
        }
        return shouldFocusDay;
    };
    // the activeElement is in the container, and it is another instance of Day
    Day.prototype.isDayActiveElement = function() {
        var _a, _b, _c;
        return ((_b = (_a = this.props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
    };
    Day.prototype.isDuplicateDay = function() {
        return(//day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth());
    };
    return Day;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$WeekNumber = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(WeekNumber, _super);
    function WeekNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.weekNumberEl = (0, $igtsr.createRef)();
        _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $44884d0571b9c796$var$KeyType.Space) {
                event.preventDefault();
                event.key = $44884d0571b9c796$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$44884d0571b9c796$var$isSameDay(_this.props.date, _this.props.selected) && $44884d0571b9c796$var$isSameDay(_this.props.date, _this.props.preSelection);
        };
        _this.getTabIndex = function() {
            return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || $44884d0571b9c796$var$isSameDay(_this.props.date, _this.props.selected) && $44884d0571b9c796$var$isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
        };
        // various cases when we need to apply focus to the preselected week-number
        // focus the week-number on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusWeekNumber = function(prevProps) {
            var shouldFocusWeekNumber = false;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && $44884d0571b9c796$var$isSameDay(_this.props.date, _this.props.preSelection)) {
                // there is currently no activeElement and not inline
                if (!document.activeElement || document.activeElement === document.body) shouldFocusWeekNumber = true;
                // inline version:
                // do not focus on initial render to prevent autoFocus issue
                // focus after month has changed via keyboard
                if (_this.props.inline && !_this.props.shouldFocusDayInline) shouldFocusWeekNumber = false;
                // the activeElement is in the container, and it is another instance of WeekNumber
                if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) shouldFocusWeekNumber = true;
            }
            shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
                preventScroll: true
            });
        };
        return _this;
    }
    Object.defineProperty(WeekNumber, "defaultProps", {
        get: function() {
            return {
                ariaLabelPrefix: "week "
            };
        },
        enumerable: false,
        configurable: true
    });
    WeekNumber.prototype.componentDidMount = function() {
        this.handleFocusWeekNumber();
    };
    WeekNumber.prototype.componentDidUpdate = function(prevProps) {
        this.handleFocusWeekNumber(prevProps);
    };
    WeekNumber.prototype.render = function() {
        var _a = this.props, weekNumber = _a.weekNumber, isWeekDisabled = _a.isWeekDisabled, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber.defaultProps.ariaLabelPrefix : _b, onClick = _a.onClick;
        var weekNumberClasses = {
            "react-datepicker__week-number": true,
            "react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
            "react-datepicker__week-number--selected": !!onClick && $44884d0571b9c796$var$isSameDay(this.props.date, this.props.selected)
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            ref: this.weekNumberEl,
            className: (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)(weekNumberClasses),
            "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
            onClick: this.handleClick,
            onKeyDown: this.handleOnKeyDown,
            tabIndex: this.getTabIndex()
        }, weekNumber);
    };
    return WeekNumber;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$Week = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDisabled = function(day) {
            return $44884d0571b9c796$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        };
        _this.handleWeekClick = function(day, weekNumber, event) {
            var _a, _b, _c;
            var enabledWeekDay = new Date(day);
            for(var i = 0; i < 7; i++){
                var processingDay = new Date(day);
                processingDay.setDate(processingDay.getDate() + i);
                var isEnabled = !_this.isDisabled(processingDay);
                if (isEnabled) {
                    enabledWeekDay = processingDay;
                    break;
                }
            }
            if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
            if (_this.props.showWeekPicker) _this.handleDayClick(enabledWeekDay, event);
            if ((_a = _this.props.shouldCloseOnSelect) !== null && _a !== void 0 ? _a : Week.defaultProps.shouldCloseOnSelect) (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, false);
        };
        _this.formatWeekNumber = function(date) {
            if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
            return $44884d0571b9c796$var$getWeek(date);
        };
        _this.isWeekDisabled = function() {
            var startOfWeek = _this.startOfWeek();
            var endOfWeek = (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            var processingDate = new Date(startOfWeek);
            while(processingDate <= endOfWeek){
                if (!_this.isDisabled(processingDate)) return false;
                processingDate = (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(processingDate, 1);
            }
            return true;
        };
        _this.renderDays = function() {
            var startOfWeek = _this.startOfWeek();
            var days = [];
            var weekNumber = _this.formatWeekNumber(startOfWeek);
            if (_this.props.showWeekNumber) {
                var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
                days.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$WeekNumber, $44884d0571b9c796$var$_assign({
                    key: "W"
                }, Week.defaultProps, _this.props, {
                    weekNumber: weekNumber,
                    isWeekDisabled: _this.isWeekDisabled(),
                    date: startOfWeek,
                    onClick: onClickAction
                })));
            }
            return days.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Day, $44884d0571b9c796$var$_assign({}, Week.defaultProps, _this.props, {
                    ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
                    ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
                    key: day.valueOf(),
                    day: day,
                    onClick: _this.handleDayClick.bind(_this, day),
                    onMouseEnter: _this.handleDayMouseEnter.bind(_this, day)
                }));
            }));
        };
        _this.startOfWeek = function() {
            return $44884d0571b9c796$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$44884d0571b9c796$var$isSameDay(_this.startOfWeek(), _this.props.selected) && $44884d0571b9c796$var$isSameDay(_this.startOfWeek(), _this.props.preSelection);
        };
        return _this;
    }
    Object.defineProperty(Week, "defaultProps", {
        get: function() {
            return {
                shouldCloseOnSelect: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Week.prototype.render = function() {
        var weekNumberClasses = {
            "react-datepicker__week": true,
            "react-datepicker__week--selected": $44884d0571b9c796$var$isSameDay(this.startOfWeek(), this.props.selected),
            "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)(weekNumberClasses)
        }, this.renderDays());
    };
    return Week;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$_a;
var $44884d0571b9c796$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var $44884d0571b9c796$var$MONTH_COLUMNS_LAYOUT = {
    TWO_COLUMNS: "two_columns",
    THREE_COLUMNS: "three_columns",
    FOUR_COLUMNS: "four_columns"
};
var $44884d0571b9c796$var$MONTH_COLUMNS = ($44884d0571b9c796$var$_a = {}, $44884d0571b9c796$var$_a[$44884d0571b9c796$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
    grid: [
        [
            0,
            1
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            6,
            7
        ],
        [
            8,
            9
        ],
        [
            10,
            11
        ]
    ],
    verticalNavigationOffset: 2
}, $44884d0571b9c796$var$_a[$44884d0571b9c796$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 3
}, $44884d0571b9c796$var$_a[$44884d0571b9c796$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ],
        [
            8,
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 4
}, $44884d0571b9c796$var$_a);
var $44884d0571b9c796$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function $44884d0571b9c796$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
    if (showFourColumnMonthYearPicker) return $44884d0571b9c796$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
    if (showTwoColumnMonthYearPicker) return $44884d0571b9c796$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
    return $44884d0571b9c796$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
/**
 * `Month` is a React component that represents a month in a calendar.
 * It accepts a `MonthProps` object as props which provides various configurations and event handlers.
 *
 * @prop dayClassName - Function to determine the class name for a day.
 * @prop monthClassName - Function to determine the class name for a month.
 * @prop filterDate - Function to filter dates.
 * @prop formatWeekNumber - Function to format the week number.
 * @prop onDayClick - Function to handle day click events.
 * @prop onDayMouseEnter - Function to handle mouse enter events on a day.
 * @prop onMouseLeave - Function to handle mouse leave events.
 * @prop onWeekSelect - Function to handle week selection.
 * @prop setPreSelection - Function to set pre-selection.
 * @prop setOpen - Function to set open state.
 * @prop renderDayContents - Function to render day contents.
 * @prop renderMonthContent - Function to render month content.
 * @prop renderQuarterContent - Function to render quarter content.
 * @prop handleOnKeyDown - Function to handle key down events.
 * @prop handleOnMonthKeyDown - Function to handle key down events on a month.
 * @prop ariaLabelPrefix - Aria label prefix.
 * @prop chooseDayAriaLabelPrefix - Aria label prefix for choosing a day.
 * @prop disabledDayAriaLabelPrefix - Aria label prefix for disabled day.
 * @prop disabledKeyboardNavigation - Flag to disable keyboard navigation.
 * @prop day - The day.
 * @prop endDate - The end date.
 * @prop orderInDisplay - The order in display.
 * @prop excludeDates - Dates to exclude.
 * @prop excludeDateIntervals - Date intervals to exclude.
 * @prop fixedHeight - Flag to set fixed height.
 * @prop highlightDates - Dates to highlight.
 * @prop holidays - Holidays.
 * @prop includeDates - Dates to include.
 * @prop includeDateIntervals - Date intervals to include.
 * @prop inline - Flag to set inline.
 * @prop shouldFocusDayInline - Flag to set focus on day inline.
 * @prop locale - The locale.
 * @prop maxDate - The maximum date.
 * @prop minDate - The minimum date.
 * @prop usePointerEvent - Flag to use pointer event.
 * @prop peekNextMonth - Flag to peek next month.
 * @prop preSelection - The pre-selection.
 * @prop selected - The selected date.
 * @prop selectingDate - The selecting date.
 * @prop calendarStartDay - The calendar start day.
 * @prop selectsEnd - Flag to select end.
 * @prop selectsStart - Flag to select start.
 * @prop selectsRange - Flag to select range.
 * @prop selectsDisabledDaysInRange - Flag to select disabled days in range.
 * @prop selectsMultiple - Flag to select multiple.
 * @prop selectedDates - The selected dates.
 * @prop showWeekNumbers - Flag to show week numbers.
 * @prop startDate - The start date.
 * @prop shouldCloseOnSelect - Flag to close on select.
 * @prop showMonthYearPicker - Flag to show month year picker.
 * @prop showFullMonthYearPicker - Flag to show full month year picker.
 * @prop showTwoColumnMonthYearPicker - Flag to show two column month year picker.
 * @prop showFourColumnMonthYearPicker - Flag to show four column month year picker.
 * @prop showQuarterYearPicker - Flag to show quarter year picker.
 * @prop showWeekPicker - Flag to show week picker.
 * @prop isInputFocused - Flag to set input focus.
 * @prop weekAriaLabelPrefix - Aria label prefix for week.
 * @prop containerRef - The container reference.
 * @prop monthShowsDuplicateDaysEnd - Flag to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Flag to show duplicate days at the start of the month.
 *
 * @example
 * ```tsx
 * function App() {
 *  const handleDayClick = (date) => {
 *     console.log('Day clicked: ', date);
 *   };
 *
 *   const handleDayMouseEnter = (date) => {
 *     console.log('Mouse entered on day: ', date);
 *   };
 *
 *   return (
 *     <div>
 *       <Month
 *         day={new Date()}
 *         endDate={new Date()}
 *         onDayClick={handleDayClick}
 *         onDayMouseEnter={handleDayMouseEnter}
 *         disabledKeyboardNavigation={false}
 *         showWeekNumbers={true}
 *         showMonthYearPicker={false}
 *       />
 *     </div>
 *   );
 * }
 * ```
 */ var $44884d0571b9c796$var$Month = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MONTH_REFS = $44884d0571b9c796$var$__spreadArray([], Array(12), true).map(function() {
            return (0, $igtsr.createRef)();
        });
        _this.QUARTER_REFS = $44884d0571b9c796$var$__spreadArray([], Array(4), true).map(function() {
            return (0, $igtsr.createRef)();
        });
        _this.isDisabled = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $44884d0571b9c796$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $44884d0571b9c796$var$isDayExcluded(day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.handleDayClick = function(day, event) {
            var _a, _b;
            (_b = (_a = _this.props).onDayClick) === null || _b === void 0 || _b.call(_a, day, event, _this.props.orderInDisplay);
        };
        _this.handleDayMouseEnter = function(day) {
            var _a, _b;
            (_b = (_a = _this.props).onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day);
        };
        _this.handleMouseLeave = function() {
            var _a, _b;
            (_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a);
        };
        _this.isRangeStartMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $44884d0571b9c796$var$isSameMonth((0, $abe1c83fecf1276a$export$63264690f8e36790)(day, m), startDate);
        };
        _this.isRangeStartQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $44884d0571b9c796$var$isSameQuarter((0, $a2e940077f21299d$export$8924d1de7efe1755)(day, q), startDate);
        };
        _this.isRangeEndMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $44884d0571b9c796$var$isSameMonth((0, $abe1c83fecf1276a$export$63264690f8e36790)(day, m), endDate);
        };
        _this.isRangeEndQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $44884d0571b9c796$var$isSameQuarter((0, $a2e940077f21299d$export$8924d1de7efe1755)(day, q), endDate);
        };
        _this.isInSelectingRangeMonth = function(m) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $44884d0571b9c796$var$isMonthInRange(selectingDate, endDate, m, day);
            if (selectsEnd && startDate) return $44884d0571b9c796$var$isMonthInRange(startDate, selectingDate, m, day);
            if (selectsRange && startDate && !endDate) return $44884d0571b9c796$var$isMonthInRange(startDate, selectingDate, m, day);
            return false;
        };
        _this.isSelectingMonthRangeStart = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _month = (0, $abe1c83fecf1276a$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $44884d0571b9c796$var$isSameMonth(_month, selectingDate);
            else return $44884d0571b9c796$var$isSameMonth(_month, startDate);
        };
        _this.isSelectingMonthRangeEnd = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _month = (0, $abe1c83fecf1276a$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd || selectsRange) return $44884d0571b9c796$var$isSameMonth(_month, selectingDate);
            else return $44884d0571b9c796$var$isSameMonth(_month, endDate);
        };
        _this.isInSelectingRangeQuarter = function(q) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $44884d0571b9c796$var$isQuarterInRange(selectingDate, endDate, q, day);
            if (selectsEnd && startDate) return $44884d0571b9c796$var$isQuarterInRange(startDate, selectingDate, q, day);
            if (selectsRange && startDate && !endDate) return $44884d0571b9c796$var$isQuarterInRange(startDate, selectingDate, q, day);
            return false;
        };
        _this.isWeekInMonth = function(startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            return $44884d0571b9c796$var$isSameMonth(startOfWeek, day) || $44884d0571b9c796$var$isSameMonth(endOfWeek, day);
        };
        _this.isCurrentMonth = function(day, m) {
            return (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(day) === (0, $064d553b51baf3e9$export$5846dc2d57a5c860)($44884d0571b9c796$var$newDate()) && m === (0, $de31b03371614c55$export$6ce1b5acc29cb53b)($44884d0571b9c796$var$newDate());
        };
        _this.isCurrentQuarter = function(day, q) {
            return (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(day) === (0, $064d553b51baf3e9$export$5846dc2d57a5c860)($44884d0571b9c796$var$newDate()) && q === (0, $8de2b2935de63c65$export$de90a4bb31c25221)($44884d0571b9c796$var$newDate());
        };
        _this.isSelectedMonth = function(day, m, selected) {
            return (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(selected) === m && (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(day) === (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(selected);
        };
        _this.isSelectMonthInList = function(day, m, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedMonth(day, m, selectedDate);
            });
        };
        _this.isSelectedQuarter = function(day, q, selected) {
            return (0, $8de2b2935de63c65$export$de90a4bb31c25221)(day) === q && (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(day) === (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(selected);
        };
        _this.renderWeeks = function() {
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var i = 0;
            var breakAfterNextPush = false;
            var currentWeekStart = $44884d0571b9c796$var$getStartOfWeek($44884d0571b9c796$var$getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
            var isPreSelected = function(preSelection) {
                return _this.props.showWeekPicker ? $44884d0571b9c796$var$getStartOfWeek(preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
            };
            var isSelected = function(selected) {
                return _this.props.showWeekPicker ? $44884d0571b9c796$var$getStartOfWeek(selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
            };
            var selected = _this.props.selected ? isSelected(_this.props.selected) : undefined;
            var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : undefined;
            while(true){
                weeks.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Week, $44884d0571b9c796$var$_assign({}, _this.props, {
                    ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
                    key: i,
                    day: currentWeekStart,
                    month: (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(_this.props.day),
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    selected: selected,
                    preSelection: preSelection,
                    showWeekNumber: _this.props.showWeekNumbers
                })));
                if (breakAfterNextPush) break;
                i++;
                currentWeekStart = (0, $9b66ea05774b3092$export$ef501a2bb4f3ee6b)(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= $44884d0571b9c796$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) breakAfterNextPush = true;
                    else break;
                }
            }
            return weeks;
        };
        _this.onMonthClick = function(event, m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayClick($44884d0571b9c796$var$getStartOfMonth(labelDate), event);
        };
        _this.onMonthMouseEnter = function(m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayMouseEnter($44884d0571b9c796$var$getStartOfMonth(labelDate));
        };
        _this.handleMonthNavigation = function(newMonth, newDate) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.handleKeyboardNavigation = function(event, eventKey, month) {
            var _a;
            var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
            if (!preSelection) return;
            var monthColumnsLayout = $44884d0571b9c796$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
            var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
            var monthsGrid = (_a = $44884d0571b9c796$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.grid;
            var calculateNewDateAndMonth = function(eventKey, date, month) {
                var _a, _b;
                var newCalculatedDate = date;
                var newCalculatedMonth = month;
                switch(eventKey){
                    case $44884d0571b9c796$var$KeyType.ArrowRight:
                        newCalculatedDate = (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(date, $44884d0571b9c796$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 11 ? 0 : month + $44884d0571b9c796$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $44884d0571b9c796$var$KeyType.ArrowLeft:
                        newCalculatedDate = (0, $377f863a28de0454$export$73d1c15a21f9fae5)(date, $44884d0571b9c796$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 0 ? 11 : month - $44884d0571b9c796$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $44884d0571b9c796$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $377f863a28de0454$export$73d1c15a21f9fae5)(date, verticalOffset);
                        newCalculatedMonth = ((_a = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a === void 0 ? void 0 : _a.includes(month)) ? month + 12 - verticalOffset : month - verticalOffset;
                        break;
                    case $44884d0571b9c796$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(date, verticalOffset);
                        newCalculatedMonth = ((_b = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b === void 0 ? void 0 : _b.includes(month)) ? month - 12 + verticalOffset : month + verticalOffset;
                        break;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            var getNewDateAndMonth = function(eventKey, selectedDate, month) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var _a = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month), newCalculatedDate = _a.newCalculatedDate, newCalculatedMonth = _a.newCalculatedMonth;
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newCalculatedDate = selectedDate;
                        newCalculatedMonth = month;
                        break;
                    }
                    // if minDate exists and the new month is before the minimum month, it will try to find the next available month after
                    if (minDate && newCalculatedDate < minDate) {
                        eventKeyCopy = $44884d0571b9c796$var$KeyType.ArrowRight;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    // if maxDate exists and the new month is after the maximum month, it will try to find the next available month before
                    if (maxDate && newCalculatedDate > maxDate) {
                        eventKeyCopy = $44884d0571b9c796$var$KeyType.ArrowLeft;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    if ($44884d0571b9c796$var$isMonthYearDisabled(newCalculatedDate, _this.props)) {
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    } else validDateFound = true;
                    iterations++;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            if (eventKey === $44884d0571b9c796$var$KeyType.Enter) {
                if (!_this.isMonthDisabled(month)) {
                    _this.onMonthClick(event, month);
                    setPreSelection === null || setPreSelection === void 0 || setPreSelection(selected);
                }
                return;
            }
            var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
            switch(eventKey){
                case $44884d0571b9c796$var$KeyType.ArrowRight:
                case $44884d0571b9c796$var$KeyType.ArrowLeft:
                case $44884d0571b9c796$var$KeyType.ArrowUp:
                case $44884d0571b9c796$var$KeyType.ArrowDown:
                    _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
                    break;
            }
        };
        _this.getVerticalOffset = function(monthColumnsLayout) {
            var _a, _b;
            return (_b = (_a = $44884d0571b9c796$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
        };
        _this.onMonthKeyDown = function(event, month) {
            var _a = _this.props, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, handleOnMonthKeyDown = _a.handleOnMonthKeyDown;
            var eventKey = event.key;
            if (eventKey !== $44884d0571b9c796$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!disabledKeyboardNavigation) _this.handleKeyboardNavigation(event, eventKey, month);
            handleOnMonthKeyDown && handleOnMonthKeyDown(event);
        };
        _this.onQuarterClick = function(event, q) {
            var labelDate = (0, $a2e940077f21299d$export$8924d1de7efe1755)(_this.props.day, q);
            if ($44884d0571b9c796$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayClick($44884d0571b9c796$var$getStartOfQuarter(labelDate), event);
        };
        _this.onQuarterMouseEnter = function(q) {
            var labelDate = (0, $a2e940077f21299d$export$8924d1de7efe1755)(_this.props.day, q);
            if ($44884d0571b9c796$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayMouseEnter($44884d0571b9c796$var$getStartOfQuarter(labelDate));
        };
        _this.handleQuarterNavigation = function(newQuarter, newDate) {
            var _a, _b, _c, _d;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.onQuarterKeyDown = function(event, quarter) {
            var _a, _b;
            var eventKey = event.key;
            if (!_this.props.disabledKeyboardNavigation) switch(eventKey){
                case $44884d0571b9c796$var$KeyType.Enter:
                    _this.onQuarterClick(event, quarter);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $44884d0571b9c796$var$KeyType.ArrowRight:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, (0, $8be8906ab05d096d$export$c252a41d0fbed2ce)(_this.props.preSelection, 1));
                    break;
                case $44884d0571b9c796$var$KeyType.ArrowLeft:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, (0, $92df7bb0743d0fc6$export$a31bfeeeee80cce6)(_this.props.preSelection, 1));
                    break;
            }
        };
        _this.isMonthDisabledForLabelDate = function(month) {
            var _a;
            var _b = _this.props, day = _b.day, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
            var labelDate = (0, $abe1c83fecf1276a$export$63264690f8e36790)(day, month);
            return {
                isDisabled: (_a = (minDate || maxDate || excludeDates || includeDates) && $44884d0571b9c796$var$isMonthDisabled(labelDate, _this.props)) !== null && _a !== void 0 ? _a : false,
                labelDate: labelDate
            };
        };
        _this.isMonthDisabled = function(month) {
            var isDisabled = _this.isMonthDisabledForLabelDate(month).isDisabled;
            return isDisabled;
        };
        _this.getMonthClassNames = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, preSelection = _a.preSelection, monthClassName = _a.monthClassName;
            var _monthClassName = monthClassName ? monthClassName((0, $abe1c83fecf1276a$export$63264690f8e36790)(day, m)) : undefined;
            var selection = _this.getSelection();
            return (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
                "react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
                "react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m, selection) : undefined,
                "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m, preSelection) && !_this.isMonthDisabled(m),
                "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
                "react-datepicker__month-text--in-range": startDate && endDate ? $44884d0571b9c796$var$isMonthInRange(startDate, endDate, m, day) : undefined,
                "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
                "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
                "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
                "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
                "react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
            });
        };
        _this.getTabIndex = function(m) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedMonth = (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(_this.props.preSelection);
            var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
            var tabIndex = m === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getQuarterTabIndex = function(q) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedQuarter = (0, $8de2b2935de63c65$export$de90a4bb31c25221)(_this.props.preSelection);
            var isCurrentQuarterDisabled = $44884d0571b9c796$var$isQuarterDisabled(_this.props.day, _this.props);
            var tabIndex = q === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getAriaLabel = function(month) {
            var _a = _this.props, _b = _a.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a.day, locale = _a.locale;
            var labelDate = (0, $abe1c83fecf1276a$export$63264690f8e36790)(day, month);
            var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
            return "".concat(prefix, " ").concat($44884d0571b9c796$var$formatDate(labelDate, "MMMM yyyy", locale));
        };
        _this.getQuarterClassNames = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, selected = _a.selected, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, preSelection = _a.preSelection, disabledKeyboardNavigation = _a.disabledKeyboardNavigation;
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && $44884d0571b9c796$var$isQuarterDisabled((0, $a2e940077f21299d$export$8924d1de7efe1755)(day, q), _this.props);
            return (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
                "react-datepicker__quarter-text--disabled": isDisabled,
                "react-datepicker__quarter-text--selected": selected ? _this.isSelectedQuarter(day, q, selected) : undefined,
                "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q, preSelection) && !isDisabled,
                "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
                "react-datepicker__quarter-text--in-range": startDate && endDate ? $44884d0571b9c796$var$isQuarterInRange(startDate, endDate, q, day) : undefined,
                "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
                "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q),
                "react-datepicker__quarter-text--today": _this.isCurrentQuarter(day, q)
            });
        };
        _this.getMonthContent = function(m) {
            var _a = _this.props, showFullMonthYearPicker = _a.showFullMonthYearPicker, renderMonthContent = _a.renderMonthContent, locale = _a.locale, day = _a.day;
            var shortMonthText = $44884d0571b9c796$var$getMonthShortInLocale(m, locale);
            var fullMonthText = $44884d0571b9c796$var$getMonthInLocale(m, locale);
            if (renderMonthContent) return renderMonthContent(m, shortMonthText, fullMonthText, day);
            return showFullMonthYearPicker ? fullMonthText : shortMonthText;
        };
        _this.getQuarterContent = function(q) {
            var _a;
            var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
            var shortQuarter = $44884d0571b9c796$var$getQuarterShortInLocale(q, locale);
            return (_a = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q, shortQuarter)) !== null && _a !== void 0 ? _a : shortQuarter;
        };
        _this.renderMonths = function() {
            var _a;
            var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
            var monthColumns = (_a = $44884d0571b9c796$var$MONTH_COLUMNS[$44884d0571b9c796$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a === void 0 ? void 0 : _a.grid;
            return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: i
                }, month.map(function(m, j) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                        ref: _this.MONTH_REFS[m],
                        key: j,
                        onClick: function(event) {
                            _this.onMonthClick(event, m);
                        },
                        onKeyDown: function(event) {
                            if ($44884d0571b9c796$var$isSpaceKeyDown(event)) {
                                event.preventDefault();
                                event.key = $44884d0571b9c796$var$KeyType.Enter;
                            }
                            _this.onMonthKeyDown(event, m);
                        },
                        onMouseEnter: !_this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        onPointerEnter: _this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        tabIndex: Number(_this.getTabIndex(m)),
                        className: _this.getMonthClassNames(m),
                        "aria-disabled": _this.isMonthDisabled(m),
                        role: "option",
                        "aria-label": _this.getAriaLabel(m),
                        "aria-current": _this.isCurrentMonth(day, m) ? "date" : undefined,
                        "aria-selected": selected ? _this.isSelectedMonth(day, m, selected) : undefined
                    }, _this.getMonthContent(m));
                }));
            });
        };
        _this.renderQuarters = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected;
            var quarters = [
                1,
                2,
                3,
                4
            ];
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__quarter-wrapper"
            }, quarters.map(function(q, j) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                    key: j,
                    ref: _this.QUARTER_REFS[j],
                    role: "option",
                    onClick: function(event) {
                        _this.onQuarterClick(event, q);
                    },
                    onKeyDown: function(event) {
                        _this.onQuarterKeyDown(event, q);
                    },
                    onMouseEnter: !_this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    onPointerEnter: _this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    className: _this.getQuarterClassNames(q),
                    "aria-selected": selected ? _this.isSelectedQuarter(day, q, selected) : undefined,
                    tabIndex: Number(_this.getQuarterTabIndex(q)),
                    "aria-current": _this.isCurrentQuarter(day, q) ? "date" : undefined
                }, _this.getQuarterContent(q));
            }));
        };
        _this.getClassNames = function() {
            var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, showWeekPicker = _a.showWeekPicker;
            return (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker__month", {
                "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
            }, {
                "react-datepicker__monthPicker": showMonthYearPicker
            }, {
                "react-datepicker__quarterPicker": showQuarterYearPicker
            }, {
                "react-datepicker__weekPicker": showWeekPicker
            });
        };
        return _this;
    }
    Month.prototype.getSelection = function() {
        var _a = this.props, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
        if (selectsMultiple) return selectedDates;
        if (selected) return [
            selected
        ];
        return undefined;
    };
    Month.prototype.render = function() {
        var _a = this.props, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, day = _a.day, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
        var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": "".concat(formattedAriaLabelPrefix).concat($44884d0571b9c796$var$formatDate(day, "MMMM, yyyy", this.props.locale)),
            role: "listbox"
        }, showMonthYearPicker ? this.renderMonths() : showQuarterYearPicker ? this.renderQuarters() : this.renderWeeks());
    };
    return Month;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$MonthDropdownOptions = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(MonthDropdownOptions, _super);
    function MonthDropdownOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isSelectedMonth = function(i) {
            return _this.props.month === i;
        };
        _this.renderOptions = function() {
            return _this.props.monthNames.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                    className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                    key: month,
                    onClick: _this.onChange.bind(_this, i),
                    "aria-selected": _this.isSelectedMonth(i) ? "true" : undefined
                }, _this.isSelectedMonth(i) ? (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", month);
            });
        };
        _this.onChange = function(month) {
            return _this.props.onChange(month);
        };
        _this.handleClickOutside = function() {
            return _this.props.onCancel();
        };
        return _this;
    }
    MonthDropdownOptions.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$ClickOutsideWrapper, {
            className: "react-datepicker__month-dropdown",
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthDropdownOptions;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$MonthDropdown = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(MonthDropdown, _super);
    function MonthDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function(monthNames) {
            return monthNames.map(function(m, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("option", {
                    key: m,
                    value: i
                }, m);
            });
        };
        _this.renderSelectMode = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("select", {
                value: _this.props.month,
                className: "react-datepicker__month-select",
                onChange: function(e) {
                    return _this.onChange(parseInt(e.target.value));
                }
            }, _this.renderSelectOptions(monthNames));
        };
        _this.renderReadView = function(visible, monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, monthNames[_this.props.month]));
        };
        _this.renderDropdown = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$MonthDropdownOptions, $44884d0571b9c796$var$_assign({
                key: "dropdown"
            }, _this.props, {
                monthNames: monthNames,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function(monthNames) {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible, monthNames)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
            return result;
        };
        _this.onChange = function(month) {
            _this.toggleDropdown();
            if (month !== _this.props.month) _this.props.onChange(month);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthDropdown.prototype.render = function() {
        var _this = this;
        var monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? function(m) {
            return $44884d0571b9c796$var$getMonthShortInLocale(m, _this.props.locale);
        } : function(m) {
            return $44884d0571b9c796$var$getMonthInLocale(m, _this.props.locale);
        });
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case "select":
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthDropdown;
}((0, $igtsr.Component));
function $44884d0571b9c796$var$generateMonthYears(minDate, maxDate) {
    var list = [];
    var currDate = $44884d0571b9c796$var$getStartOfMonth(minDate);
    var lastDate = $44884d0571b9c796$var$getStartOfMonth(maxDate);
    while(!(0, $89f716961fb46e12$export$e4de839670987035)(currDate, lastDate)){
        list.push($44884d0571b9c796$var$newDate(currDate));
        currDate = (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(currDate, 1);
    }
    return list;
}
var $44884d0571b9c796$var$MonthYearDropdownOptions = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(MonthYearDropdownOptions, _super);
    function MonthYearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function() {
            return _this.state.monthYearsList.map(function(monthYear) {
                var monthYearPoint = (0, $12bf5b0d84b5c63d$export$1428f42a7de81803)(monthYear);
                var isSameMonthYear = $44884d0571b9c796$var$isSameYear(_this.props.date, monthYear) && $44884d0571b9c796$var$isSameMonth(_this.props.date, monthYear);
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                    className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                    key: monthYearPoint,
                    onClick: _this.onChange.bind(_this, monthYearPoint),
                    "aria-selected": isSameMonthYear ? "true" : undefined
                }, isSameMonthYear ? (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $44884d0571b9c796$var$formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
            });
        };
        _this.onChange = function(monthYear) {
            return _this.props.onChange(monthYear);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.state = {
            monthYearsList: $44884d0571b9c796$var$generateMonthYears(_this.props.minDate, _this.props.maxDate)
        };
        return _this;
    }
    MonthYearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)({
            "react-datepicker__month-year-dropdown": true,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$ClickOutsideWrapper, {
            className: dropdownClass,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$MonthYearDropdown = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(MonthYearDropdown, _super);
    function MonthYearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var currDate = $44884d0571b9c796$var$getStartOfMonth(_this.props.minDate);
            var lastDate = $44884d0571b9c796$var$getStartOfMonth(_this.props.maxDate);
            var options = [];
            while(!(0, $89f716961fb46e12$export$e4de839670987035)(currDate, lastDate)){
                var timePoint = (0, $12bf5b0d84b5c63d$export$1428f42a7de81803)(currDate);
                options.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("option", {
                    key: timePoint,
                    value: timePoint
                }, $44884d0571b9c796$var$formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
                currDate = (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(currDate, 1);
            }
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("select", {
                value: (0, $12bf5b0d84b5c63d$export$1428f42a7de81803)($44884d0571b9c796$var$getStartOfMonth(_this.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            var yearMonth = $44884d0571b9c796$var$formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, yearMonth));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$MonthYearDropdownOptions, $44884d0571b9c796$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(monthYearPoint) {
            _this.toggleDropdown();
            var changedDate = $44884d0571b9c796$var$newDate(monthYearPoint);
            if ($44884d0571b9c796$var$isSameYear(_this.props.date, changedDate) && $44884d0571b9c796$var$isSameMonth(_this.props.date, changedDate)) return;
            _this.props.onChange(changedDate);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthYearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthYearDropdown;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$Time = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null
        };
        _this.scrollToTheSelectedTime = function() {
            requestAnimationFrame(function() {
                var _a, _b, _c;
                if (!_this.list) return;
                _this.list.scrollTop = (_c = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a = _this.header) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
            });
        };
        _this.handleClick = function(time) {
            var _a, _b;
            if ((_this.props.minTime || _this.props.maxTime) && $44884d0571b9c796$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $44884d0571b9c796$var$isTimeDisabled(time, _this.props)) return;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, time);
        };
        _this.isSelectedTime = function(time) {
            return _this.props.selected && $44884d0571b9c796$var$isSameMinute(_this.props.selected, time);
        };
        _this.isDisabledTime = function(time) {
            return (_this.props.minTime || _this.props.maxTime) && $44884d0571b9c796$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $44884d0571b9c796$var$isTimeDisabled(time, _this.props);
        };
        _this.liClasses = function(time) {
            var _a;
            var classes = [
                "react-datepicker__time-list-item",
                _this.props.timeClassName ? _this.props.timeClassName(time) : undefined
            ];
            if (_this.isSelectedTime(time)) classes.push("react-datepicker__time-list-item--selected");
            if (_this.isDisabledTime(time)) classes.push("react-datepicker__time-list-item--disabled");
            //convert this.props.intervals and the relevant time to seconds and check if it it's a clean multiple of the interval
            if (_this.props.injectTimes && ((0, $29e2039a3da06fd6$export$257b40f71c07d58f)(time) * 3600 + (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(time) * 60 + (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(time)) % (((_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals) * 60) !== 0) classes.push("react-datepicker__time-list-item--injected");
            return classes.join(" ");
        };
        _this.handleOnKeyDown = function(event, time) {
            var _a, _b;
            if (event.key === $44884d0571b9c796$var$KeyType.Space) {
                event.preventDefault();
                event.key = $44884d0571b9c796$var$KeyType.Enter;
            }
            if ((event.key === $44884d0571b9c796$var$KeyType.ArrowUp || event.key === $44884d0571b9c796$var$KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
                event.preventDefault();
                event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
            }
            if ((event.key === $44884d0571b9c796$var$KeyType.ArrowDown || event.key === $44884d0571b9c796$var$KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
                event.preventDefault();
                event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
            }
            if (event.key === $44884d0571b9c796$var$KeyType.Enter) _this.handleClick(time);
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.renderTimes = function() {
            var _a;
            var times = [];
            var format = typeof _this.props.format === "string" ? _this.props.format : "p";
            var intervals = (_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals;
            var activeDate = _this.props.selected || _this.props.openToDate || $44884d0571b9c796$var$newDate();
            var base = $44884d0571b9c796$var$getStartOfDay(activeDate);
            var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
            var minutesInDay = 60 * $44884d0571b9c796$var$getHoursInDay(activeDate);
            var multiplier = minutesInDay / intervals;
            for(var i = 0; i < multiplier; i++){
                var currentTime = (0, $22f30f6db3721034$export$2287e3d29250119e)(base, i * intervals);
                times.push(currentTime);
                if (sortedInjectTimes) {
                    var timesToInject = $44884d0571b9c796$var$timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
                    times = times.concat(timesToInject);
                }
            }
            // Determine which time to focus and scroll into view when component mounts
            var timeToFocus = times.reduce(function(prev, time) {
                if (time.getTime() <= activeDate.getTime()) return time;
                return prev;
            }, times[0]);
            return times.map(function(time) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("li", {
                    key: time.valueOf(),
                    onClick: _this.handleClick.bind(_this, time),
                    className: _this.liClasses(time),
                    ref: function(li) {
                        if (time === timeToFocus) _this.centerLi = li;
                    },
                    onKeyDown: function(event) {
                        _this.handleOnKeyDown(event, time);
                    },
                    tabIndex: time === timeToFocus ? 0 : -1,
                    role: "option",
                    "aria-selected": _this.isSelectedTime(time) ? "true" : undefined,
                    "aria-disabled": _this.isDisabledTime(time) ? "true" : undefined
                }, $44884d0571b9c796$var$formatDate(time, format, _this.props.locale));
            });
        };
        _this.renderTimeCaption = function() {
            if (_this.props.showTimeCaption === false) return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Fragment, null);
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function(header) {
                    _this.header = header;
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker-time__header"
            }, _this.props.timeCaption));
        };
        return _this;
    }
    Object.defineProperty(Time, "defaultProps", {
        get: function() {
            return {
                intervals: 30,
                todayButton: null,
                timeCaption: "Time",
                showTimeCaption: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Time.prototype.componentDidMount = function() {
        // code to ensure selected time will always be in focus within time window when it first appears
        this.scrollToTheSelectedTime();
        this.observeDatePickerHeightChanges();
    };
    Time.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
    };
    Time.prototype.observeDatePickerHeightChanges = function() {
        var _this = this;
        var monthRef = this.props.monthRef;
        this.updateContainerHeight();
        if (monthRef) {
            this.resizeObserver = new ResizeObserver(function() {
                _this.updateContainerHeight();
            });
            this.resizeObserver.observe(monthRef);
        }
    };
    Time.prototype.updateContainerHeight = function() {
        if (this.props.monthRef && this.header) this.setState({
            height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
    };
    Time.prototype.render = function() {
        var _this = this;
        var _a;
        var height = this.state.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__time-container ".concat(((_a = this.props.todayButton) !== null && _a !== void 0 ? _a : Time.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
        }, this.renderTimeCaption(), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__time"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__time-box"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function(list) {
                _this.list = list;
            },
            style: height ? {
                height: height
            } : {},
            role: "listbox",
            "aria-label": this.props.timeCaption
        }, this.renderTimes()))));
    };
    Time.calcCenterPosition = function(listHeight, centerLiRef) {
        return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
    };
    return Time;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$VERTICAL_NAVIGATION_OFFSET = 3;
/**
 * `Year` is a component that represents a year in a date picker.
 *
 * @class
 * @param {YearProps} props - The properties that define the `Year` component.
 * @property {VoidFunction} [props.clearSelectingDate] - Function to clear the selected date.
 * @property {Date} [props.date] - The currently selected date.
 * @property {boolean} [props.disabledKeyboardNavigation] - If true, keyboard navigation is disabled.
 * @property {Date} [props.endDate] - The end date in a range selection.
 * @property {(date: Date) => void} props.onDayClick - Function to handle day click events.
 * @property {Date} props.preSelection - The date that is currently in focus.
 * @property {(date: Date) => void} props.setPreSelection - Function to set the pre-selected date.
 * @property {{ [key: string]: any }} props.selected - The selected date(s).
 * @property {boolean} props.inline - If true, the date picker is displayed inline.
 * @property {Date} props.maxDate - The maximum selectable date.
 * @property {Date} props.minDate - The minimum selectable date.
 * @property {boolean} props.usePointerEvent - If true, pointer events are used instead of mouse events.
 * @property {(date: Date) => void} props.onYearMouseEnter - Function to handle mouse enter events on a year.
 * @property {(date: Date) => void} props.onYearMouseLeave - Function to handle mouse leave events on a year.
 */ var $44884d0571b9c796$var$Year = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(Year, _super);
    function Year(props) {
        var _this = _super.call(this, props) || this;
        _this.YEAR_REFS = $44884d0571b9c796$var$__spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
            return (0, $igtsr.createRef)();
        });
        _this.isDisabled = function(date) {
            return $44884d0571b9c796$var$isDayDisabled(date, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function(date) {
            return $44884d0571b9c796$var$isDayExcluded(date, {
                excludeDates: _this.props.excludeDates
            });
        };
        _this.selectingDate = function() {
            var _a;
            return (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
        };
        _this.updateFocusOnPaginate = function(refIndex) {
            var waitForReRender = function() {
                var _a, _b;
                (_b = (_a = _this.YEAR_REFS[refIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 || _b.focus();
            };
            window.requestAnimationFrame(waitForReRender);
        };
        _this.handleYearClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleYearNavigation = function(newYear, newDate) {
            var _a, _b, _c, _d;
            var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
            if (date === undefined || yearItemNumber === undefined) return;
            var startPeriod = $44884d0571b9c796$var$getYearsPeriod(date, yearItemNumber).startPeriod;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            if (newYear - startPeriod < 0) _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
            else if (newYear - startPeriod >= yearItemNumber) _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
            else (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.isSameDay = function(y, other) {
            return $44884d0571b9c796$var$isSameDay(y, other);
        };
        _this.isCurrentYear = function(y) {
            return y === (0, $064d553b51baf3e9$export$5846dc2d57a5c860)($44884d0571b9c796$var$newDate());
        };
        _this.isRangeStart = function(y) {
            return _this.props.startDate && _this.props.endDate && $44884d0571b9c796$var$isSameYear((0, $7e8006cfd4109aed$export$a8408b6c5639cab7)($44884d0571b9c796$var$newDate(), y), _this.props.startDate);
        };
        _this.isRangeEnd = function(y) {
            return _this.props.startDate && _this.props.endDate && $44884d0571b9c796$var$isSameYear((0, $7e8006cfd4109aed$export$a8408b6c5639cab7)($44884d0571b9c796$var$newDate(), y), _this.props.endDate);
        };
        _this.isInRange = function(y) {
            return $44884d0571b9c796$var$isYearInRange(y, _this.props.startDate, _this.props.endDate);
        };
        _this.isInSelectingRange = function(y) {
            var _a = _this.props, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectsRange = _a.selectsRange, startDate = _a.startDate, endDate = _a.endDate;
            if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) return false;
            if (selectsStart && endDate) return $44884d0571b9c796$var$isYearInRange(y, _this.selectingDate(), endDate);
            if (selectsEnd && startDate) return $44884d0571b9c796$var$isYearInRange(y, startDate, _this.selectingDate());
            if (selectsRange && startDate && !endDate) return $44884d0571b9c796$var$isYearInRange(y, startDate, _this.selectingDate());
            return false;
        };
        _this.isSelectingRangeStart = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _year = (0, $7e8006cfd4109aed$export$a8408b6c5639cab7)($44884d0571b9c796$var$newDate(), y);
            if (selectsStart) return $44884d0571b9c796$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $44884d0571b9c796$var$isSameYear(_year, startDate !== null && startDate !== void 0 ? startDate : null);
        };
        _this.isSelectingRangeEnd = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _year = (0, $7e8006cfd4109aed$export$a8408b6c5639cab7)($44884d0571b9c796$var$newDate(), y);
            if (selectsEnd || selectsRange) return $44884d0571b9c796$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $44884d0571b9c796$var$isSameYear(_year, endDate !== null && endDate !== void 0 ? endDate : null);
        };
        _this.isKeyboardSelected = function(y) {
            if (_this.props.date === undefined || _this.props.selected == null || _this.props.preSelection == null) return;
            var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate;
            var date = $44884d0571b9c796$var$getStartOfYear((0, $7e8006cfd4109aed$export$a8408b6c5639cab7)(_this.props.date, y));
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && $44884d0571b9c796$var$isYearDisabled(y, _this.props);
            return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !$44884d0571b9c796$var$isSameDay(date, $44884d0571b9c796$var$getStartOfYear(_this.props.selected)) && $44884d0571b9c796$var$isSameDay(date, $44884d0571b9c796$var$getStartOfYear(_this.props.preSelection)) && !isDisabled;
        };
        _this.isSelectedYear = function(year) {
            var _a = _this.props, selectsMultiple = _a.selectsMultiple, selected = _a.selected, selectedDates = _a.selectedDates;
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return year === (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(date);
            });
            return !selected || year === (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(selected);
        };
        _this.onYearClick = function(event, y) {
            var date = _this.props.date;
            if (date === undefined) return;
            _this.handleYearClick($44884d0571b9c796$var$getStartOfYear((0, $7e8006cfd4109aed$export$a8408b6c5639cab7)(date, y)), event);
        };
        _this.onYearKeyDown = function(event, y) {
            var _a, _b;
            var key = event.key;
            var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
            if (key !== $44884d0571b9c796$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!_this.props.disabledKeyboardNavigation) switch(key){
                case $44884d0571b9c796$var$KeyType.Enter:
                    if (_this.props.selected == null) break;
                    _this.onYearClick(event, y);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $44884d0571b9c796$var$KeyType.ArrowRight:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y + 1, (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(_this.props.preSelection, 1));
                    break;
                case $44884d0571b9c796$var$KeyType.ArrowLeft:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y - 1, (0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(_this.props.preSelection, 1));
                    break;
                case $44884d0571b9c796$var$KeyType.ArrowUp:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var startPeriod = $44884d0571b9c796$var$getYearsPeriod(date, yearItemNumber).startPeriod;
                    var offset = $44884d0571b9c796$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y - offset;
                    if (newYear < startPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y >= startPeriod && y < startPeriod + leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y - offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(_this.props.preSelection, offset));
                    break;
                case $44884d0571b9c796$var$KeyType.ArrowDown:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var endPeriod = $44884d0571b9c796$var$getYearsPeriod(date, yearItemNumber).endPeriod;
                    var offset = $44884d0571b9c796$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y + offset;
                    if (newYear > endPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y <= endPeriod && y > endPeriod - leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y + offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(_this.props.preSelection, offset));
                    break;
            }
            handleOnKeyDown && handleOnKeyDown(event);
        };
        _this.getYearClassNames = function(y) {
            var _a = _this.props, date = _a.date, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, yearClassName = _a.yearClassName;
            return (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker__year-text", "react-datepicker__year-".concat(y), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName((0, $7e8006cfd4109aed$export$a8408b6c5639cab7)(date, y)) : undefined, {
                "react-datepicker__year-text--selected": _this.isSelectedYear(y),
                "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate) && $44884d0571b9c796$var$isYearDisabled(y, _this.props),
                "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
                "react-datepicker__year-text--range-start": _this.isRangeStart(y),
                "react-datepicker__year-text--range-end": _this.isRangeEnd(y),
                "react-datepicker__year-text--in-range": _this.isInRange(y),
                "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
                "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
                "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
                "react-datepicker__year-text--today": _this.isCurrentYear(y)
            });
        };
        _this.getYearTabIndex = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) return "-1";
            var preSelected = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.props.preSelection);
            var isPreSelectedYearDisabled = $44884d0571b9c796$var$isYearDisabled(y, _this.props);
            return y === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
        };
        _this.getYearContent = function(y) {
            return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
        };
        return _this;
    }
    Year.prototype.render = function() {
        var _this = this;
        var yearsList = [];
        var _a = this.props, date = _a.date, yearItemNumber = _a.yearItemNumber, onYearMouseEnter = _a.onYearMouseEnter, onYearMouseLeave = _a.onYearMouseLeave;
        if (date === undefined) return null;
        var _b = $44884d0571b9c796$var$getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
        var _loop_1 = function(y) {
            yearsList.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                ref: this_1.YEAR_REFS[y - startPeriod],
                onClick: function(event) {
                    _this.onYearClick(event, y);
                },
                onKeyDown: function(event) {
                    if ($44884d0571b9c796$var$isSpaceKeyDown(event)) {
                        event.preventDefault();
                        event.key = $44884d0571b9c796$var$KeyType.Enter;
                    }
                    _this.onYearKeyDown(event, y);
                },
                tabIndex: Number(this_1.getYearTabIndex(y)),
                className: this_1.getYearClassNames(y),
                onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onPointerEnter: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                onPointerLeave: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                key: y,
                "aria-current": this_1.isCurrentYear(y) ? "date" : undefined
            }, this_1.getYearContent(y)));
        };
        var this_1 = this;
        for(var y = startPeriod; y <= endPeriod; y++)_loop_1(y);
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__year"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__year-wrapper",
            onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : undefined
        }, yearsList));
    };
    return Year;
}((0, $igtsr.Component));
function $44884d0571b9c796$var$generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for(var i = 0; i < 2 * noOfYear + 1; i++){
        var newYear = year + noOfYear - i;
        var isInRange = true;
        if (minDate) isInRange = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(minDate) <= newYear;
        if (maxDate && isInRange) isInRange = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(maxDate) >= newYear;
        if (isInRange) list.push(newYear);
    }
    return list;
}
var $44884d0571b9c796$var$YearDropdownOptions = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(YearDropdownOptions, _super);
    function YearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function() {
            var selectedYear = _this.props.year;
            var options = _this.state.yearsList.map(function(year) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                    className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: year,
                    onClick: _this.onChange.bind(_this, year),
                    "aria-selected": selectedYear === year ? "true" : undefined
                }, selectedYear === year ? (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", year);
            });
            var minYear = _this.props.minDate ? (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.props.minDate) : null;
            var maxYear = _this.props.maxDate ? (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.props.maxDate) : null;
            if (!maxYear || !_this.state.yearsList.find(function(year) {
                return year === maxYear;
            })) options.unshift((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "upcoming",
                onClick: _this.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
            if (!minYear || !_this.state.yearsList.find(function(year) {
                return year === minYear;
            })) options.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "previous",
                onClick: _this.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
            return options;
        };
        _this.onChange = function(year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.shiftYears = function(amount) {
            var years = _this.state.yearsList.map(function(year) {
                return year + amount;
            });
            _this.setState({
                yearsList: years
            });
        };
        _this.incrementYears = function() {
            return _this.shiftYears(1);
        };
        _this.decrementYears = function() {
            return _this.shiftYears(-1);
        };
        var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
        var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        _this.state = {
            yearsList: $44884d0571b9c796$var$generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
        };
        _this.dropdownRef = (0, $igtsr.createRef)();
        return _this;
    }
    YearDropdownOptions.prototype.componentDidMount = function() {
        var dropdownCurrent = this.dropdownRef.current;
        if (dropdownCurrent) {
            // Get array from HTMLCollection
            var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
            var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
                return childEl.ariaSelected;
            }) : null;
            dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
        }
    };
    YearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)({
            "react-datepicker__year-dropdown": true,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$ClickOutsideWrapper, {
            className: dropdownClass,
            containerRef: this.dropdownRef,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return YearDropdownOptions;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$YearDropdown = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(YearDropdown, _super);
    function YearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var minYear = _this.props.minDate ? (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.props.minDate) : 1900;
            var maxYear = _this.props.maxDate ? (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.props.maxDate) : 2100;
            var options = [];
            for(var i = minYear; i <= maxYear; i++)options.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("option", {
                key: i,
                value: i
            }, i));
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("select", {
                value: _this.props.year,
                className: "react-datepicker__year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: function(event) {
                    return _this.toggleDropdown(event);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, _this.props.year));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$YearDropdownOptions, $44884d0571b9c796$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(year) {
            _this.toggleDropdown();
            if (year === _this.props.year) return;
            _this.props.onChange(year);
        };
        _this.toggleDropdown = function(event) {
            _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            }, function() {
                if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
            });
        };
        _this.handleYearChange = function(date, event) {
            var _a;
            (_a = _this.onSelect) === null || _a === void 0 || _a.call(_this, date, event);
            _this.setOpen();
        };
        _this.onSelect = function(date, event) {
            var _a, _b;
            (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, date, event);
        };
        _this.setOpen = function() {
            var _a, _b;
            (_b = (_a = _this.props).setOpen) === null || _b === void 0 || _b.call(_a, true);
        };
        return _this;
    }
    YearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return YearDropdown;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$DROPDOWN_FOCUS_CLASSNAMES = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
];
var $44884d0571b9c796$var$isDropdownSelect = function(element) {
    var classNames = (element.className || "").split(/\s+/);
    return $44884d0571b9c796$var$DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
        return classNames.indexOf(testClassname) >= 0;
    });
};
var $44884d0571b9c796$var$Calendar = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.monthContainer = undefined;
        _this.handleClickOutside = function(event) {
            _this.props.onClickOutside(event);
        };
        _this.setClickOutsideRef = function() {
            return _this.containerRef.current;
        };
        _this.handleDropdownFocus = function(event) {
            var _a, _b;
            if ($44884d0571b9c796$var$isDropdownSelect(event.target)) (_b = (_a = _this.props).onDropdownFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.getDateInView = function() {
            var _a = _this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
            var minDate = $44884d0571b9c796$var$getEffectiveMinDate(_this.props);
            var maxDate = $44884d0571b9c796$var$getEffectiveMaxDate(_this.props);
            var current = $44884d0571b9c796$var$newDate();
            var initialDate = openToDate || selected || preSelection;
            if (initialDate) return initialDate;
            else {
                if (minDate && (0, $ec5a63c4588c1c61$export$5c007e10c6929c95)(current, minDate)) return minDate;
                else if (maxDate && (0, $89f716961fb46e12$export$e4de839670987035)(current, maxDate)) return maxDate;
            }
            return current;
        };
        _this.increaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.decreaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $377f863a28de0454$export$73d1c15a21f9fae5)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.handleDayClick = function(day, event, monthSelectedIn) {
            _this.props.onSelect(day, event, monthSelectedIn);
            _this.props.setPreSelection && _this.props.setPreSelection(day);
        };
        _this.handleDayMouseEnter = function(day) {
            _this.setState({
                selectingDate: day
            });
            _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
        };
        _this.handleMonthMouseLeave = function() {
            _this.setState({
                selectingDate: undefined
            });
            _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
        };
        _this.handleYearMouseEnter = function(event, year) {
            _this.setState({
                selectingDate: (0, $7e8006cfd4109aed$export$a8408b6c5639cab7)($44884d0571b9c796$var$newDate(), year)
            });
            !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
        };
        _this.handleYearMouseLeave = function(event, year) {
            !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
        };
        _this.handleYearChange = function(date) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).onYearChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(date);
                (_d = (_c = _this.props).setOpen) === null || _d === void 0 || _d.call(_c, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(date);
        };
        _this.getEnabledPreSelectionDateForMonth = function(date) {
            if (!$44884d0571b9c796$var$isDayDisabled(date, _this.props)) return date;
            var startOfMonth = $44884d0571b9c796$var$getStartOfMonth(date);
            var endOfMonth = $44884d0571b9c796$var$getEndOfMonth(date);
            var totalDays = (0, $0e206fafd570fe71$export$86415ebf4eb36b8c)(endOfMonth, startOfMonth);
            var preSelectedDate = null;
            for(var dayIdx = 0; dayIdx <= totalDays; dayIdx++){
                var processingDate = (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(startOfMonth, dayIdx);
                if (!$44884d0571b9c796$var$isDayDisabled(processingDate, _this.props)) {
                    preSelectedDate = processingDate;
                    break;
                }
            }
            return preSelectedDate;
        };
        _this.handleMonthChange = function(date) {
            var _a, _b, _c;
            var enabledPreSelectionDate = (_a = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a !== void 0 ? _a : date;
            _this.handleCustomMonthChange(enabledPreSelectionDate);
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(enabledPreSelectionDate);
                (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
        };
        _this.handleCustomMonthChange = function(date) {
            var _a, _b;
            (_b = (_a = _this.props).onMonthChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
        };
        _this.handleMonthYearChange = function(date) {
            _this.handleYearChange(date);
            _this.handleMonthChange(date);
        };
        _this.changeYear = function(year) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $7e8006cfd4109aed$export$a8408b6c5639cab7)(date, Number(year))
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.changeMonth = function(month) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $abe1c83fecf1276a$export$63264690f8e36790)(date, Number(month))
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.changeMonthYear = function(monthYear) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $7e8006cfd4109aed$export$a8408b6c5639cab7)((0, $abe1c83fecf1276a$export$63264690f8e36790)(date, (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(monthYear)), (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(monthYear))
                };
            }, function() {
                return _this.handleMonthYearChange(_this.state.date);
            });
        };
        _this.header = function(date) {
            if (date === void 0) date = _this.state.date;
            var startOfWeek = $44884d0571b9c796$var$getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
            var dayNames = [];
            if (_this.props.showWeekNumbers) dayNames.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name"
            }, _this.props.weekLabel || "#"));
            return dayNames.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                var weekDayName = _this.formatWeekday(day, _this.props.locale);
                var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : undefined;
                return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                    key: offset,
                    "aria-label": $44884d0571b9c796$var$formatDate(day, "EEEE", _this.props.locale),
                    className: (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName)
                }, weekDayName);
            }));
        };
        _this.formatWeekday = function(day, locale) {
            if (_this.props.formatWeekDay) return $44884d0571b9c796$var$getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
            return _this.props.useWeekdaysShort ? $44884d0571b9c796$var$getWeekdayShortInLocale(day, locale) : $44884d0571b9c796$var$getWeekdayMinInLocale(day, locale);
        };
        _this.decreaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.clearSelectingDate = function() {
            _this.setState({
                selectingDate: undefined
            });
        };
        _this.renderPreviousButton = function() {
            var _a, _b, _c;
            if (_this.props.renderCustomHeader) return;
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            var fromMonthDate = (0, $377f863a28de0454$export$73d1c15a21f9fae5)(_this.state.date, monthSelectedIn);
            var allPrevDaysDisabled;
            switch(true){
                case _this.props.showMonthYearPicker:
                    allPrevDaysDisabled = $44884d0571b9c796$var$yearDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allPrevDaysDisabled = $44884d0571b9c796$var$yearsDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allPrevDaysDisabled = $44884d0571b9c796$var$quarterDisabledBefore(_this.state.date, _this.props);
                    break;
                default:
                    allPrevDaysDisabled = $44884d0571b9c796$var$monthDisabledBefore(fromMonthDate, _this.props);
                    break;
            }
            if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--previous"
            ];
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--previous"
            ];
            var clickHandler = _this.decreaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.decreaseYear;
            if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--previous--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar.defaultProps.previousYearButtonLabel : _f;
            var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel));
        };
        _this.increaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderNextButton = function() {
            var _a;
            if (_this.props.renderCustomHeader) return;
            var allNextDaysDisabled;
            switch(true){
                case _this.props.showMonthYearPicker:
                    allNextDaysDisabled = $44884d0571b9c796$var$yearDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allNextDaysDisabled = $44884d0571b9c796$var$yearsDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allNextDaysDisabled = $44884d0571b9c796$var$quarterDisabledAfter(_this.state.date, _this.props);
                    break;
                default:
                    allNextDaysDisabled = $44884d0571b9c796$var$monthDisabledAfter(_this.state.date, _this.props);
                    break;
            }
            if (!((_a = _this.props.forceShowMonthNavigation) !== null && _a !== void 0 ? _a : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--next"
            ];
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--next"
            ];
            if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
            if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
            var clickHandler = _this.increaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.increaseYear;
            if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--next--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar.defaultProps.nextYearButtonLabel : _d;
            var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel));
        };
        _this.renderCurrentMonth = function(date) {
            if (date === void 0) date = _this.state.date;
            var classes = [
                "react-datepicker__current-month"
            ];
            if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
            if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
            if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("h2", {
                className: classes.join(" ")
            }, $44884d0571b9c796$var$formatDate(date, _this.props.dateFormat, _this.props.locale));
        };
        _this.renderYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$YearDropdown, $44884d0571b9c796$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeYear,
                year: (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.state.date)
            }));
        };
        _this.renderMonthDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$MonthDropdown, $44884d0571b9c796$var$_assign({}, Calendar.defaultProps, _this.props, {
                month: (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(_this.state.date),
                onChange: _this.changeMonth
            }));
        };
        _this.renderMonthYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$MonthYearDropdown, $44884d0571b9c796$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeMonthYear
            }));
        };
        _this.handleTodayButtonClick = function(event) {
            _this.props.onSelect($44884d0571b9c796$var$getStartOfToday(), event);
            _this.props.setPreSelection && _this.props.setPreSelection($44884d0571b9c796$var$getStartOfToday());
        };
        _this.renderTodayButton = function() {
            if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: _this.handleTodayButtonClick
            }, _this.props.todayButton);
        };
        _this.renderDefaultHeader = function(_a) {
            var monthDate = _a.monthDate, i = _a.i;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__header ".concat(_this.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
            }, _this.renderCurrentMonth(monthDate), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
                onFocus: _this.handleDropdownFocus
            }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__day-names"
            }, _this.header(monthDate)));
        };
        _this.renderCustomHeader = function(headerArgs) {
            var _a, _b;
            var monthDate = headerArgs.monthDate, i = headerArgs.i;
            if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) return null;
            var prevMonthButtonDisabled = $44884d0571b9c796$var$monthDisabledBefore(_this.state.date, _this.props);
            var nextMonthButtonDisabled = $44884d0571b9c796$var$monthDisabledAfter(_this.state.date, _this.props);
            var prevYearButtonDisabled = $44884d0571b9c796$var$yearDisabledBefore(_this.state.date, _this.props);
            var nextYearButtonDisabled = $44884d0571b9c796$var$yearDisabledAfter(_this.state.date, _this.props);
            var showDayNames = !_this.props.showMonthYearPicker && !_this.props.showQuarterYearPicker && !_this.props.showYearPicker;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: _this.props.onDropdownFocus
            }, (_b = (_a = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a, $44884d0571b9c796$var$_assign($44884d0571b9c796$var$_assign({}, _this.state), {
                customHeaderCount: i,
                monthDate: monthDate,
                changeMonth: _this.changeMonth,
                changeYear: _this.changeYear,
                decreaseMonth: _this.decreaseMonth,
                increaseMonth: _this.increaseMonth,
                decreaseYear: _this.decreaseYear,
                increaseYear: _this.increaseYear,
                prevMonthButtonDisabled: prevMonthButtonDisabled,
                nextMonthButtonDisabled: nextMonthButtonDisabled,
                prevYearButtonDisabled: prevYearButtonDisabled,
                nextYearButtonDisabled: nextYearButtonDisabled
            })), showDayNames && (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__day-names"
            }, _this.header(monthDate)));
        };
        _this.renderYearHeader = function(_a) {
            var monthDate = _a.monthDate;
            var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? Calendar.defaultProps.yearItemNumber : _c;
            var _d = $44884d0571b9c796$var$getYearsPeriod(monthDate, yearItemNumber), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(monthDate));
        };
        _this.renderHeader = function(_a) {
            var monthDate = _a.monthDate, _b = _a.i, i = _b === void 0 ? 0 : _b;
            var headerArgs = {
                monthDate: monthDate,
                i: i
            };
            switch(true){
                case _this.props.renderCustomHeader !== undefined:
                    return _this.renderCustomHeader(headerArgs);
                case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker:
                    return _this.renderYearHeader(headerArgs);
                default:
                    return _this.renderDefaultHeader(headerArgs);
            }
        };
        _this.renderMonths = function() {
            var _a, _b;
            if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) return;
            var monthList = [];
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(_this.state.date, monthsToSubtract) : (0, $377f863a28de0454$export$73d1c15a21f9fae5)(_this.state.date, monthsToSubtract);
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            for(var i = 0; i < monthsShown; ++i){
                var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
                var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(fromMonthDate, monthsToAdd) : (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(fromMonthDate, monthsToAdd);
                var monthKey = "month-".concat(i);
                var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
                var monthShowsDuplicateDaysStart = i > 0;
                monthList.push((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                    key: monthKey,
                    ref: function(div) {
                        _this.monthContainer = div !== null && div !== void 0 ? div : undefined;
                    },
                    className: "react-datepicker__month-container"
                }, _this.renderHeader({
                    monthDate: monthDate,
                    i: i
                }), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Month, $44884d0571b9c796$var$_assign({}, Calendar.defaultProps, _this.props, {
                    containerRef: _this.containerRef,
                    ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
                    day: monthDate,
                    onDayClick: _this.handleDayClick,
                    handleOnKeyDown: _this.props.handleOnDayKeyDown,
                    handleOnMonthKeyDown: _this.props.handleOnKeyDown,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onMouseLeave: _this.handleMonthMouseLeave,
                    orderInDisplay: i,
                    selectingDate: _this.state.selectingDate,
                    monthShowsDuplicateDaysEnd: monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: monthShowsDuplicateDaysStart
                }))));
            }
            return monthList;
        };
        _this.renderYears = function() {
            if (_this.props.showTimeSelectOnly) return;
            if (_this.props.showYearPicker) return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__year--container"
            }, _this.renderHeader({
                monthDate: _this.state.date
            }), (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Year, $44884d0571b9c796$var$_assign({}, Calendar.defaultProps, _this.props, {
                selectingDate: _this.state.selectingDate,
                date: _this.state.date,
                onDayClick: _this.handleDayClick,
                clearSelectingDate: _this.clearSelectingDate,
                onYearMouseEnter: _this.handleYearMouseEnter,
                onYearMouseLeave: _this.handleYearMouseLeave
            })));
            return;
        };
        _this.renderTimeSection = function() {
            if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Time, $44884d0571b9c796$var$_assign({}, Calendar.defaultProps, _this.props, {
                onChange: _this.props.onTimeChange,
                format: _this.props.timeFormat,
                intervals: _this.props.timeIntervals,
                monthRef: _this.state.monthContainer
            }));
            return;
        };
        _this.renderInputTimeSection = function() {
            var time = _this.props.selected ? new Date(_this.props.selected) : undefined;
            var timeValid = time && $44884d0571b9c796$var$isValid(time) && Boolean(_this.props.selected);
            var timeString = timeValid ? "".concat($44884d0571b9c796$var$addZero(time.getHours()), ":").concat($44884d0571b9c796$var$addZero(time.getMinutes())) : "";
            if (_this.props.showTimeInput) return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$InputTime, $44884d0571b9c796$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: time,
                timeString: timeString,
                onChange: _this.props.onTimeChange
            }));
            return;
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            var _b = $44884d0571b9c796$var$getYearsPeriod(_this.state.date, (_a = _this.props.yearItemNumber) !== null && _a !== void 0 ? _a : Calendar.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
            var ariaLiveMessage;
            if (_this.props.showYearPicker) ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
            else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) ariaLiveMessage = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.state.date);
            else ariaLiveMessage = "".concat($44884d0571b9c796$var$getMonthInLocale((0, $de31b03371614c55$export$6ce1b5acc29cb53b)(_this.state.date), _this.props.locale), " ").concat((0, $064d553b51baf3e9$export$5846dc2d57a5c860)(_this.state.date));
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
        };
        _this.renderChildren = function() {
            if (_this.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__children-container"
            }, _this.props.children);
            return;
        };
        _this.containerRef = (0, $igtsr.createRef)();
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: undefined,
            monthContainer: undefined,
            isRenderAriaLiveMessage: false
        };
        return _this;
    }
    Object.defineProperty(Calendar, "defaultProps", {
        get: function() {
            return {
                monthsShown: 1,
                forceShowMonthNavigation: false,
                timeCaption: "Time",
                previousYearButtonLabel: "Previous Year",
                nextYearButtonLabel: "Next Year",
                previousMonthButtonLabel: "Previous Month",
                nextMonthButtonLabel: "Next Month",
                yearItemNumber: $44884d0571b9c796$var$DEFAULT_YEAR_ITEM_NUMBER
            };
        },
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.componentDidMount = function() {
        var _this = this;
        // monthContainer height is needed in time component
        // to determine the height for the ul in the time component
        // setState here so height is given after final component
        // layout is rendered
        if (this.props.showTimeSelect) this.assignMonthContainer = function() {
            _this.setState({
                monthContainer: _this.monthContainer
            });
        }();
    };
    Calendar.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.preSelection && (!$44884d0571b9c796$var$isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
            var hasMonthChanged_1 = !$44884d0571b9c796$var$isSameMonth(this.state.date, this.props.preSelection);
            this.setState({
                date: this.props.preSelection
            }, function() {
                return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
            });
        } else if (this.props.openToDate && !$44884d0571b9c796$var$isSameDay(this.props.openToDate, prevProps.openToDate)) this.setState({
            date: this.props.openToDate
        });
    };
    Calendar.prototype.render = function() {
        var Container = this.props.container || $44884d0571b9c796$export$946daa762919616e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$ClickOutsideWrapper, {
            onClickOutside: this.handleClickOutside,
            style: {
                display: "contents"
            },
            ignoreClass: this.props.outsideClickIgnoreClass
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            style: {
                display: "contents"
            },
            ref: this.containerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement(Container, {
            className: (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker", this.props.className, {
                "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showTime: this.props.showTimeSelect || this.props.showTimeInput,
            showTimeSelectOnly: this.props.showTimeSelectOnly
        }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
    };
    return Calendar;
}((0, $igtsr.Component));
/**
 * `CalendarIcon` is a React component that renders an icon for a calendar.
 * The icon can be a string representing a CSS class, a React node, or a default SVG icon.
 *
 * @component
 * @prop  icon - The icon to be displayed. This can be a string representing a CSS class or a React node.
 * @prop  className - An optional string representing additional CSS classes to be applied to the icon.
 * @prop  onClick - An optional function to be called when the icon is clicked.
 *
 * @example
 * // To use a CSS class as the icon
 * <CalendarIcon icon="my-icon-class" onClick={myClickHandler} />
 *
 * @example
 * // To use a React node as the icon
 * <CalendarIcon icon={<MyIconComponent />} onClick={myClickHandler} />
 *
 * @returns  The `CalendarIcon` component.
 */ var $44884d0571b9c796$var$CalendarIcon = function(_a) {
    var icon = _a.icon, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
    var defaultClass = "react-datepicker__calendar-icon";
    if (typeof icon === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("i", {
        className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
        "aria-hidden": "true",
        onClick: onClick
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).isValidElement(icon)) {
        // Because we are checking that typeof icon is string first, we can safely cast icon as React.ReactElement on types level and code level
        var iconElement_1 = icon;
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).cloneElement(iconElement_1, {
            className: "".concat(iconElement_1.props.className || "", " ").concat(defaultClass, " ").concat(className),
            onClick: function(event) {
                if (typeof iconElement_1.props.onClick === "function") iconElement_1.props.onClick(event);
                if (typeof onClick === "function") onClick(event);
            }
        });
    }
    // Default SVG Icon
    return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("svg", {
        className: "".concat(defaultClass, " ").concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("path", {
        d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    }));
};
/**
 * `Portal` is a React component that allows you to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * @class
 * @param {PortalProps} props - The properties that define the `Portal` component.
 * @property {React.ReactNode} props.children - The children to be rendered into the `Portal`.
 * @property {string} props.portalId - The id of the DOM node into which the `Portal` will render.
 * @property {ShadowRoot} [props.portalHost] - The DOM node to host the `Portal`.
 */ var $44884d0571b9c796$var$Portal = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalRoot = null;
        _this.el = document.createElement("div");
        return _this;
    }
    Portal.prototype.componentDidMount = function() {
        this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
        if (!this.portalRoot) {
            this.portalRoot = document.createElement("div");
            this.portalRoot.setAttribute("id", this.props.portalId);
            (this.props.portalHost || document.body).appendChild(this.portalRoot);
        }
        this.portalRoot.appendChild(this.el);
    };
    Portal.prototype.componentWillUnmount = function() {
        if (this.portalRoot) this.portalRoot.removeChild(this.el);
    };
    Portal.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7731928cc933a5ef$exports))).createPortal(this.props.children, this.el);
    };
    return Portal;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var $44884d0571b9c796$var$focusableFilter = function(node) {
    if (node instanceof HTMLAnchorElement) return node.tabIndex !== -1;
    return !node.disabled && node.tabIndex !== -1;
};
/**
 * `TabLoop` is a React component that manages tabbing behavior for its children.
 *
 * TabLoop prevents the user from tabbing outside of the popper
 * It creates a tabindex loop so that "Tab" on the last element will focus the first element
 * and "Shift Tab" on the first element will focus the last element
 *
 * @component
 * @example
 * <TabLoop enableTabLoop={true}>
 *   <ChildComponent />
 * </TabLoop>
 *
 * @param props - The properties that define the `TabLoop` component.
 * @param props.children - The child components.
 * @param props.enableTabLoop - Whether to enable the tab loop.
 *
 * @returns The `TabLoop` component.
 */ var $44884d0571b9c796$var$TabLoop = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(TabLoop, _super);
    function TabLoop(props) {
        var _this = _super.call(this, props) || this;
        /**
         * `getTabChildren` is a method of the `TabLoop` class that retrieves all tabbable children of the component.
         *
         * This method uses the `tabbable` library to find all tabbable elements within the `TabLoop` component.
         * It then filters out any elements that are not visible.
         *
         * @returns An array of all tabbable and visible children of the `TabLoop` component.
         */ _this.getTabChildren = function() {
            var _a;
            return Array.prototype.slice.call((_a = _this.tabLoopRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll($44884d0571b9c796$var$focusableElementsSelector), 1, -1).filter($44884d0571b9c796$var$focusableFilter);
        };
        _this.handleFocusStart = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
        };
        _this.handleFocusEnd = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
        };
        _this.tabLoopRef = (0, $igtsr.createRef)();
        return _this;
    }
    TabLoop.prototype.render = function() {
        var _a;
        if (!((_a = this.props.enableTabLoop) !== null && _a !== void 0 ? _a : TabLoop.defaultProps.enableTabLoop)) return this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: 0,
            onFocus: this.handleFocusStart
        }), this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: 0,
            onFocus: this.handleFocusEnd
        }));
    };
    TabLoop.defaultProps = {
        enableTabLoop: true
    };
    return TabLoop;
}((0, $igtsr.Component));
/**
 * `withFloating` is a higher-order component that adds floating behavior to a component.
 *
 * @param Component - The component to enhance.
 *
 * @example
 * const FloatingComponent = withFloating(MyComponent);
 * <FloatingComponent popperModifiers={[]} popperProps={{}} hidePopper={true} />
 *
 * @param popperModifiers - The modifiers to use for the popper.
 * @param popperProps - The props to pass to the popper.
 * @param hidePopper - Whether to hide the popper.
 * @param popperPlacement - The placement of the popper.
 *
 * @returns A new component with floating behavior.
 */ function $44884d0571b9c796$var$withFloating(Component) {
    var WithFloating = function(props) {
        var _a;
        var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
        var arrowRef = (0, $igtsr.useRef)(null);
        var floatingProps = (0, $d38b9f8cdb785fa6$export$4e02a5c1d08bac65)($44884d0571b9c796$var$_assign({
            open: !hidePopper,
            whileElementsMounted: (0, $46988e907ff1ddf1$export$deee3a793edee05f),
            placement: props.popperPlacement,
            middleware: $44884d0571b9c796$var$__spreadArray([
                (0, $f0992af029e4f475$export$8a83211c878a3f1f)({
                    padding: 15
                }),
                (0, $f0992af029e4f475$export$cc800923e997bb8)(10),
                (0, $f0992af029e4f475$export$f2120bbfa5450bd2)({
                    element: arrowRef
                })
            ], (_a = props.popperModifiers) !== null && _a !== void 0 ? _a : [], true)
        }, props.popperProps));
        var componentProps = $44884d0571b9c796$var$_assign($44884d0571b9c796$var$_assign({}, props), {
            hidePopper: hidePopper,
            popperProps: $44884d0571b9c796$var$_assign($44884d0571b9c796$var$_assign({}, floatingProps), {
                arrowRef: arrowRef
            })
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement(Component, $44884d0571b9c796$var$_assign({}, componentProps));
    };
    return WithFloating;
}
// Exported for testing purposes
var $44884d0571b9c796$var$PopperComponent = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(PopperComponent, _super);
    function PopperComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PopperComponent, "defaultProps", {
        get: function() {
            return {
                hidePopper: true
            };
        },
        enumerable: false,
        configurable: true
    });
    PopperComponent.prototype.render = function() {
        var _a = this.props, className = _a.className, wrapperClassName = _a.wrapperClassName, _b = _a.hidePopper, hidePopper = _b === void 0 ? PopperComponent.defaultProps.hidePopper : _b, popperComponent = _a.popperComponent, targetComponent = _a.targetComponent, enableTabLoop = _a.enableTabLoop, popperOnKeyDown = _a.popperOnKeyDown, portalId = _a.portalId, portalHost = _a.portalHost, popperProps = _a.popperProps, showArrow = _a.showArrow;
        var popper = undefined;
        if (!hidePopper) {
            var classes = (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker-popper", className);
            popper = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$TabLoop, {
                enableTabLoop: enableTabLoop
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                ref: popperProps.refs.setFloating,
                style: popperProps.floatingStyles,
                className: classes,
                "data-placement": popperProps.placement,
                onKeyDown: popperOnKeyDown
            }, popperComponent, showArrow && (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, $d38b9f8cdb785fa6$export$33511391554732bc), {
                ref: popperProps.arrowRef,
                context: popperProps.context,
                fill: "currentColor",
                strokeWidth: 1,
                height: 8,
                width: 16,
                style: {
                    transform: "translateY(-1px)"
                },
                className: "react-datepicker__triangle"
            })));
        }
        if (this.props.popperContainer) popper = (0, $igtsr.createElement)(this.props.popperContainer, {}, popper);
        if (portalId && !hidePopper) popper = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Portal, {
            portalId: portalId,
            portalHost: portalHost
        }, popper);
        var wrapperClasses = (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker-wrapper", wrapperClassName);
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            ref: popperProps.refs.setReference,
            className: wrapperClasses
        }, targetComponent), popper);
    };
    return PopperComponent;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$PopperComponent$1 = $44884d0571b9c796$var$withFloating($44884d0571b9c796$var$PopperComponent);
var $44884d0571b9c796$var$outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
// Compares dates year+month combinations
function $44884d0571b9c796$var$hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) return (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(date1) !== (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(date2) || (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(date1) !== (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(date2);
    return date1 !== date2;
}
/**
 * General datepicker component.
 */ var $44884d0571b9c796$var$INPUT_ERR_1 = "Date input not valid.";
var $44884d0571b9c796$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $44884d0571b9c796$var$__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.calendar = null;
        _this.input = null;
        _this.getPreSelection = function() {
            return _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : $44884d0571b9c796$var$newDate();
        };
        // Convert the date from string format to standard Date format
        _this.modifyHolidays = function() {
            var _a;
            return (_a = _this.props.holidays) === null || _a === void 0 ? void 0 : _a.reduce(function(accumulator, holiday) {
                var date = new Date(holiday.date);
                if (!$44884d0571b9c796$var$isValid(date)) return accumulator;
                return $44884d0571b9c796$var$__spreadArray($44884d0571b9c796$var$__spreadArray([], accumulator, true), [
                    $44884d0571b9c796$var$_assign($44884d0571b9c796$var$_assign({}, holiday), {
                        date: date
                    })
                ], false);
            }, []);
        };
        _this.calcInitialState = function() {
            var _a;
            var defaultPreSelection = _this.getPreSelection();
            var minDate = $44884d0571b9c796$var$getEffectiveMinDate(_this.props);
            var maxDate = $44884d0571b9c796$var$getEffectiveMaxDate(_this.props);
            var boundedPreSelection = minDate && (0, $ec5a63c4588c1c61$export$5c007e10c6929c95)(defaultPreSelection, $44884d0571b9c796$var$getStartOfDay(minDate)) ? minDate : maxDate && (0, $89f716961fb46e12$export$e4de839670987035)(defaultPreSelection, $44884d0571b9c796$var$getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
            return {
                open: _this.props.startOpen || false,
                preventFocus: false,
                inputValue: null,
                preSelection: (_a = _this.props.selectsRange ? _this.props.startDate : _this.props.selected) !== null && _a !== void 0 ? _a : boundedPreSelection,
                // transforming highlighted days (perhaps nested array)
                // to flat Map for faster access in day.jsx
                highlightDates: $44884d0571b9c796$var$getHighLightDaysMap(_this.props.highlightDates),
                focused: false,
                // used to focus day in inline version after month has changed, but not on
                // initial render
                shouldFocusDayInline: false,
                isRenderAriaLiveMessage: false,
                wasHidden: false
            };
        };
        _this.resetHiddenStatus = function() {
            _this.setState($44884d0571b9c796$var$_assign($44884d0571b9c796$var$_assign({}, _this.state), {
                wasHidden: false
            }));
        };
        _this.setHiddenStatus = function() {
            _this.setState($44884d0571b9c796$var$_assign($44884d0571b9c796$var$_assign({}, _this.state), {
                wasHidden: true
            }));
        };
        _this.setHiddenStateOnVisibilityHidden = function() {
            if (document.visibilityState !== "hidden") return;
            _this.setHiddenStatus();
        };
        _this.clearPreventFocusTimeout = function() {
            if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
        };
        _this.setFocus = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a, {
                preventScroll: true
            });
        };
        _this.setBlur = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 || _b.call(_a);
            _this.cancelFocusInput();
        };
        _this.deferBlur = function() {
            requestAnimationFrame(function() {
                _this.setBlur();
            });
        };
        _this.setOpen = function(open, skipSetBlur) {
            if (skipSetBlur === void 0) skipSetBlur = false;
            _this.setState({
                open: open,
                preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
                lastPreSelectChange: $44884d0571b9c796$var$PRESELECT_CHANGE_VIA_NAVIGATE
            }, function() {
                if (!open) _this.setState(function(prev) {
                    return {
                        focused: skipSetBlur ? prev.focused : false
                    };
                }, function() {
                    !skipSetBlur && _this.deferBlur();
                    _this.setState({
                        inputValue: null
                    });
                });
            });
        };
        _this.inputOk = function() {
            return (0, $0aae887686bd5a23$export$871608497c498473)(_this.state.preSelection);
        };
        _this.isCalendarOpen = function() {
            return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
        };
        _this.handleFocus = function(event) {
            var _a, _b;
            var isAutoReFocus = _this.state.wasHidden;
            var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
            if (isAutoReFocus) _this.resetHiddenStatus();
            if (!_this.state.preventFocus) {
                (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, event);
                if (isOpenAllowed && !_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
            }
            _this.setState({
                focused: true
            });
        };
        _this.sendFocusBackToInput = function() {
            // Clear previous timeout if it exists
            if (_this.preventFocusTimeout) _this.clearPreventFocusTimeout();
            // close the popper and refocus the input
            // stop the input from auto opening onFocus
            // setFocus to the input
            _this.setState({
                preventFocus: true
            }, function() {
                _this.preventFocusTimeout = setTimeout(function() {
                    _this.setFocus();
                    _this.setState({
                        preventFocus: false
                    });
                });
            });
        };
        _this.cancelFocusInput = function() {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = undefined;
        };
        _this.deferFocusInput = function() {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = setTimeout(function() {
                return _this.setFocus();
            }, 1);
        };
        _this.handleDropdownFocus = function() {
            _this.cancelFocusInput();
        };
        _this.handleBlur = function(event) {
            var _a, _b;
            if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, event);
            if (_this.state.open && _this.props.open === false) _this.setOpen(false);
            _this.setState({
                focused: false
            });
        };
        _this.handleCalendarClickOutside = function(event) {
            var _a, _b;
            if (!_this.props.inline) _this.setOpen(false);
            (_b = (_a = _this.props).onClickOutside) === null || _b === void 0 || _b.call(_a, event);
            if (_this.props.withPortal) event.preventDefault();
        };
        // handleChange is called when user types in the textbox
        _this.handleChange = function() {
            var _a, _b, _c, _d, _e;
            var allArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)allArgs[_i] = arguments[_i];
            var event = allArgs[0];
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw.apply(_this, allArgs);
                if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
            }
            _this.setState({
                inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
                lastPreSelectChange: $44884d0571b9c796$var$PRESELECT_CHANGE_VIA_INPUT
            });
            var _f = _this.props, selectsRange = _f.selectsRange, startDate = _f.startDate, endDate = _f.endDate;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var strictParsing = (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.strictParsing;
            var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
            if (selectsRange) {
                var _g = value.split("-", 2).map(function(val) {
                    return val.trim();
                }), valueStart = _g[0], valueEnd = _g[1];
                var startDateNew = $44884d0571b9c796$var$parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
                var endDateNew = $44884d0571b9c796$var$parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing);
                var startChanged = (startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
                var endChanged = (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
                if (!startChanged && !endChanged) return;
                if (startDateNew && $44884d0571b9c796$var$isDayDisabled(startDateNew, _this.props)) return;
                if (endDateNew && $44884d0571b9c796$var$isDayDisabled(endDateNew, _this.props)) return;
                (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, [
                    startDateNew,
                    endDateNew
                ], event);
            } else {
                // not selectsRange
                var date = $44884d0571b9c796$var$parseDate(value, dateFormat, _this.props.locale, strictParsing, (_e = _this.props.selected) !== null && _e !== void 0 ? _e : undefined);
                // Update selection if either (1) date was successfully parsed, or (2) input field is empty
                if (date || !value) _this.setSelected(date, event, true);
            }
        };
        _this.handleSelect = function(date, event, monthSelectedIn) {
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect) // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.sendFocusBackToInput();
            if (_this.props.onChangeRaw) _this.props.onChangeRaw(event);
            _this.setSelected(date, event, false, monthSelectedIn);
            if (_this.props.showDateSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
            else if (!_this.props.inline) {
                if (!_this.props.selectsRange) _this.setOpen(false);
                var _a = _this.props, startDate = _a.startDate, endDate = _a.endDate;
                if (startDate && !endDate && (_this.props.swapRange || !$44884d0571b9c796$var$isDateBefore(date, startDate))) _this.setOpen(false);
            }
        };
        // setSelected is called either from handleChange (user typed date into textbox and it was parsed) or handleSelect (user selected date from calendar using mouse or keyboard)
        _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
            var _a, _b;
            var changedDate = date;
            // Early return if selected year/month/day is disabled
            if (_this.props.showYearPicker) {
                if (changedDate !== null && $44884d0571b9c796$var$isYearDisabled((0, $064d553b51baf3e9$export$5846dc2d57a5c860)(changedDate), _this.props)) return;
            } else if (_this.props.showMonthYearPicker) {
                if (changedDate !== null && $44884d0571b9c796$var$isMonthDisabled(changedDate, _this.props)) return;
            } else {
                if (changedDate !== null && $44884d0571b9c796$var$isDayDisabled(changedDate, _this.props)) return;
            }
            var _c = _this.props, onChange = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
            if (!$44884d0571b9c796$var$isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
                if (changedDate !== null) {
                    // Preserve previously selected time if only date is currently being changed
                    if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) changedDate = $44884d0571b9c796$var$setTime(changedDate, {
                        hour: (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(_this.props.selected),
                        minute: (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(_this.props.selected),
                        second: (0, $8ba4d80c4f8124c6$export$5e9417507ff28427)(_this.props.selected)
                    });
                    // If minTime is present then set the time to minTime
                    if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
                        if (minTime) changedDate = $44884d0571b9c796$var$setTime(changedDate, {
                            hour: minTime.getHours(),
                            minute: minTime.getMinutes(),
                            second: minTime.getSeconds()
                        });
                    }
                    if (!_this.props.inline) _this.setState({
                        preSelection: changedDate
                    });
                    if (!_this.props.focusSelectedMonth) _this.setState({
                        monthSelectedIn: monthSelectedIn
                    });
                }
                if (selectsRange) {
                    var noRanges = !startDate && !endDate;
                    var hasStartRange = startDate && !endDate;
                    var isRangeFilled = startDate && endDate;
                    if (noRanges) onChange === null || onChange === void 0 || onChange([
                        changedDate,
                        null
                    ], event);
                    else if (hasStartRange) {
                        if (changedDate === null) onChange === null || onChange === void 0 || onChange([
                            null,
                            null
                        ], event);
                        else if ($44884d0571b9c796$var$isDateBefore(changedDate, startDate)) {
                            if (swapRange) onChange === null || onChange === void 0 || onChange([
                                changedDate,
                                startDate
                            ], event);
                            else onChange === null || onChange === void 0 || onChange([
                                changedDate,
                                null
                            ], event);
                        } else onChange === null || onChange === void 0 || onChange([
                            startDate,
                            changedDate
                        ], event);
                    }
                    if (isRangeFilled) onChange === null || onChange === void 0 || onChange([
                        changedDate,
                        null
                    ], event);
                } else if (selectsMultiple) {
                    if (changedDate !== null) {
                        if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) onChange === null || onChange === void 0 || onChange([
                            changedDate
                        ], event);
                        else {
                            var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
                                return $44884d0571b9c796$var$isSameDay(selectedDate, changedDate);
                            });
                            if (isChangedDateAlreadySelected) {
                                var nextDates = selectedDates.filter(function(selectedDate) {
                                    return !$44884d0571b9c796$var$isSameDay(selectedDate, changedDate);
                                });
                                onChange === null || onChange === void 0 || onChange(nextDates, event);
                            } else onChange === null || onChange === void 0 || onChange($44884d0571b9c796$var$__spreadArray($44884d0571b9c796$var$__spreadArray([], selectedDates, true), [
                                changedDate
                            ], false), event);
                        }
                    }
                } else onChange === null || onChange === void 0 || onChange(changedDate, event);
            }
            if (!keepInput) {
                (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, changedDate, event);
                _this.setState({
                    inputValue: null
                });
            }
        };
        // When checking preSelection via min/maxDate, times need to be manipulated via getStartOfDay/getEndOfDay
        _this.setPreSelection = function(date) {
            var hasMinDate = (0, $0aae887686bd5a23$export$871608497c498473)(_this.props.minDate);
            var hasMaxDate = (0, $0aae887686bd5a23$export$871608497c498473)(_this.props.maxDate);
            var isValidDateSelection = true;
            if (date) {
                var dateStartOfDay = $44884d0571b9c796$var$getStartOfDay(date);
                if (hasMinDate && hasMaxDate) // isDayInRange uses getStartOfDay internally, so not necessary to manipulate times here
                isValidDateSelection = $44884d0571b9c796$var$isDayInRange(date, _this.props.minDate, _this.props.maxDate);
                else if (hasMinDate) {
                    var minDateStartOfDay = $44884d0571b9c796$var$getStartOfDay(_this.props.minDate);
                    isValidDateSelection = (0, $89f716961fb46e12$export$e4de839670987035)(date, minDateStartOfDay) || $44884d0571b9c796$var$isEqual(dateStartOfDay, minDateStartOfDay);
                } else if (hasMaxDate) {
                    var maxDateEndOfDay = $44884d0571b9c796$var$getEndOfDay(_this.props.maxDate);
                    isValidDateSelection = (0, $ec5a63c4588c1c61$export$5c007e10c6929c95)(date, maxDateEndOfDay) || $44884d0571b9c796$var$isEqual(dateStartOfDay, maxDateEndOfDay);
                }
            }
            if (isValidDateSelection) _this.setState({
                preSelection: date
            });
        };
        _this.toggleCalendar = function() {
            _this.setOpen(!_this.state.open);
        };
        _this.handleTimeChange = function(time) {
            var _a, _b;
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? time : $44884d0571b9c796$var$setTime(selected, {
                hour: (0, $29e2039a3da06fd6$export$257b40f71c07d58f)(time),
                minute: (0, $f254ca1d67327c34$export$b7f1bc3ea3ac4145)(time)
            });
            _this.setState({
                preSelection: changedDate
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, changedDate);
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
            if (_this.props.showTimeInput) _this.setOpen(true);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            _this.setState({
                inputValue: null
            });
        };
        _this.onInputClick = function() {
            var _a, _b;
            if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
            (_b = (_a = _this.props).onInputClick) === null || _b === void 0 || _b.call(_a);
        };
        _this.onInputKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            var eventKey = event.key;
            if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
                if (eventKey === $44884d0571b9c796$var$KeyType.ArrowDown || eventKey === $44884d0571b9c796$var$KeyType.ArrowUp || eventKey === $44884d0571b9c796$var$KeyType.Enter) (_c = _this.onInputClick) === null || _c === void 0 || _c.call(_this);
                return;
            }
            // if calendar is open, these keys will focus the selected item
            if (_this.state.open) {
                if (eventKey === $44884d0571b9c796$var$KeyType.ArrowDown || eventKey === $44884d0571b9c796$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
                    var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
                    selectedItem instanceof HTMLElement && selectedItem.focus({
                        preventScroll: true
                    });
                    return;
                }
                var copy = $44884d0571b9c796$var$newDate(_this.state.preSelection);
                if (eventKey === $44884d0571b9c796$var$KeyType.Enter) {
                    event.preventDefault();
                    event.target.blur();
                    if (_this.inputOk() && _this.state.lastPreSelectChange === $44884d0571b9c796$var$PRESELECT_CHANGE_VIA_NAVIGATE) {
                        _this.handleSelect(copy, event);
                        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
                    } else _this.setOpen(false);
                } else if (eventKey === $44884d0571b9c796$var$KeyType.Escape) {
                    event.preventDefault();
                    event.target.blur();
                    _this.sendFocusBackToInput();
                    _this.setOpen(false);
                } else if (eventKey === $44884d0571b9c796$var$KeyType.Tab) _this.setOpen(false);
                if (!_this.inputOk()) (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $44884d0571b9c796$var$INPUT_ERR_1
                });
            }
        };
        _this.onPortalKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $44884d0571b9c796$var$KeyType.Escape) {
                event.preventDefault();
                _this.setState({
                    preventFocus: true
                }, function() {
                    _this.setOpen(false);
                    setTimeout(function() {
                        _this.setFocus();
                        _this.setState({
                            preventFocus: false
                        });
                    });
                });
            }
        };
        // keyDown events passed down to day.jsx
        _this.onDayKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            if (disabledKeyboardNavigation) return;
            var eventKey = event.key;
            var isShiftKeyActive = event.shiftKey;
            var copy = $44884d0571b9c796$var$newDate(_this.state.preSelection);
            var calculateNewDate = function(eventKey, date) {
                var newCalculatedDate = date;
                switch(eventKey){
                    case $44884d0571b9c796$var$KeyType.ArrowRight:
                        newCalculatedDate = showWeekPicker ? (0, $9b66ea05774b3092$export$ef501a2bb4f3ee6b)(date, 1) : (0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(date, 1);
                        break;
                    case $44884d0571b9c796$var$KeyType.ArrowLeft:
                        newCalculatedDate = showWeekPicker ? (0, $3f0099d21d1e1a6a$export$b4d8ae6376193efb)(date, 1) : (0, $3cd83cbb2ed0e87c$export$70823084e2deb1ea)(date, 1);
                        break;
                    case $44884d0571b9c796$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $3f0099d21d1e1a6a$export$b4d8ae6376193efb)(date, 1);
                        break;
                    case $44884d0571b9c796$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $9b66ea05774b3092$export$ef501a2bb4f3ee6b)(date, 1);
                        break;
                    case $44884d0571b9c796$var$KeyType.PageUp:
                        newCalculatedDate = isShiftKeyActive ? (0, $7d4b55ba1f18acf4$export$14867687ff6c92e2)(date, 1) : (0, $377f863a28de0454$export$73d1c15a21f9fae5)(date, 1);
                        break;
                    case $44884d0571b9c796$var$KeyType.PageDown:
                        newCalculatedDate = isShiftKeyActive ? (0, $a1e060f7fb7967de$export$3d83eec43f4ea476)(date, 1) : (0, $74b0f385255d5f67$export$17c93e242b2d3a22)(date, 1);
                        break;
                    case $44884d0571b9c796$var$KeyType.Home:
                        newCalculatedDate = $44884d0571b9c796$var$getStartOfWeek(date, locale, calendarStartDay);
                        break;
                    case $44884d0571b9c796$var$KeyType.End:
                        newCalculatedDate = $44884d0571b9c796$var$getEndOfWeek(date);
                        break;
                }
                return newCalculatedDate;
            };
            var getNewDate = function(eventKey, date) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var newSelection = calculateNewDate(eventKey, date);
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newSelection = date;
                        break;
                    }
                    // if minDate exists and the new selection is before the min date, get the nearest date that isn't disabled
                    if (minDate && newSelection < minDate) {
                        eventKeyCopy = $44884d0571b9c796$var$KeyType.ArrowRight;
                        newSelection = $44884d0571b9c796$var$isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : minDate;
                    }
                    // if maxDate exists and the new selection is after the max date, get the nearest date that isn't disabled
                    if (maxDate && newSelection > maxDate) {
                        eventKeyCopy = $44884d0571b9c796$var$KeyType.ArrowLeft;
                        newSelection = $44884d0571b9c796$var$isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : maxDate;
                    }
                    if ($44884d0571b9c796$var$isDayDisabled(newSelection, _this.props)) {
                        // if PageUp and Home is pressed to a disabled date, it will try to find the next available date after
                        if (eventKeyCopy === $44884d0571b9c796$var$KeyType.PageUp || eventKeyCopy === $44884d0571b9c796$var$KeyType.Home) eventKeyCopy = $44884d0571b9c796$var$KeyType.ArrowRight;
                        // if PageDown and End is pressed to a disabled date, it will try to find the next available date before
                        if (eventKeyCopy === $44884d0571b9c796$var$KeyType.PageDown || eventKeyCopy === $44884d0571b9c796$var$KeyType.End) eventKeyCopy = $44884d0571b9c796$var$KeyType.ArrowLeft;
                        newSelection = calculateNewDate(eventKeyCopy, newSelection);
                    } else validDateFound = true;
                    iterations++;
                }
                return newSelection;
            };
            if (eventKey === $44884d0571b9c796$var$KeyType.Enter) {
                event.preventDefault();
                _this.handleSelect(copy, event);
                !shouldCloseOnSelect && _this.setPreSelection(copy);
                return;
            } else if (eventKey === $44884d0571b9c796$var$KeyType.Escape) {
                event.preventDefault();
                _this.setOpen(false);
                if (!_this.inputOk()) (_d = (_c = _this.props).onInputError) === null || _d === void 0 || _d.call(_c, {
                    code: 1,
                    msg: $44884d0571b9c796$var$INPUT_ERR_1
                });
                return;
            }
            var newSelection = null;
            switch(eventKey){
                case $44884d0571b9c796$var$KeyType.ArrowLeft:
                case $44884d0571b9c796$var$KeyType.ArrowRight:
                case $44884d0571b9c796$var$KeyType.ArrowUp:
                case $44884d0571b9c796$var$KeyType.ArrowDown:
                case $44884d0571b9c796$var$KeyType.PageUp:
                case $44884d0571b9c796$var$KeyType.PageDown:
                case $44884d0571b9c796$var$KeyType.Home:
                case $44884d0571b9c796$var$KeyType.End:
                    newSelection = getNewDate(eventKey, copy);
                    break;
            }
            if (!newSelection) {
                (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $44884d0571b9c796$var$INPUT_ERR_1
                });
                return;
            }
            event.preventDefault();
            _this.setState({
                lastPreSelectChange: $44884d0571b9c796$var$PRESELECT_CHANGE_VIA_NAVIGATE
            });
            if (adjustDateOnChange) _this.setSelected(newSelection);
            _this.setPreSelection(newSelection);
            // need to figure out whether month has changed to focus day in inline version
            if (inline) {
                var prevMonth = (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(copy);
                var newMonth = (0, $de31b03371614c55$export$6ce1b5acc29cb53b)(newSelection);
                var prevYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(copy);
                var newYear = (0, $064d553b51baf3e9$export$5846dc2d57a5c860)(newSelection);
                if (prevMonth !== newMonth || prevYear !== newYear) // month has changed
                _this.setState({
                    shouldFocusDayInline: true
                });
                else // month hasn't changed
                _this.setState({
                    shouldFocusDayInline: false
                });
            }
        };
        // handle generic key down events in the popper that do not adjust or select dates
        // ex: while focusing prev and next month buttons
        _this.onPopperKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $44884d0571b9c796$var$KeyType.Escape) {
                event.preventDefault();
                _this.sendFocusBackToInput();
            }
        };
        _this.onClearClick = function(event) {
            if (event) {
                if (event.preventDefault) event.preventDefault();
            }
            _this.sendFocusBackToInput();
            var _a = _this.props, selectsRange = _a.selectsRange, onChange = _a.onChange;
            if (selectsRange) onChange === null || onChange === void 0 || onChange([
                null,
                null
            ], event);
            else onChange === null || onChange === void 0 || onChange(null, event);
            _this.setState({
                inputValue: null
            });
        };
        _this.clear = function() {
            _this.onClearClick();
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
                if (event.target === document || event.target === document.documentElement || event.target === document.body) _this.setOpen(false);
            } else if (typeof _this.props.closeOnScroll === "function") {
                if (_this.props.closeOnScroll(event)) _this.setOpen(false);
            }
        };
        _this.renderCalendar = function() {
            var _a, _b;
            if (!_this.props.inline && !_this.isCalendarOpen()) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Calendar, $44884d0571b9c796$var$_assign({
                showMonthYearDropdown: undefined,
                ref: function(elem) {
                    _this.calendar = elem;
                }
            }, _this.props, _this.state, {
                setOpen: _this.setOpen,
                dateFormat: (_a = _this.props.dateFormatCalendar) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormatCalendar,
                onSelect: _this.handleSelect,
                onClickOutside: _this.handleCalendarClickOutside,
                holidays: $44884d0571b9c796$var$getHolidaysMap(_this.modifyHolidays()),
                outsideClickIgnoreClass: $44884d0571b9c796$var$outsideClickIgnoreClass,
                onDropdownFocus: _this.handleDropdownFocus,
                onTimeChange: _this.handleTimeChange,
                className: _this.props.calendarClassName,
                container: _this.props.calendarContainer,
                handleOnKeyDown: _this.props.onKeyDown,
                handleOnDayKeyDown: _this.onDayKeyDown,
                setPreSelection: _this.setPreSelection,
                dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dropdownMode
            }), _this.props.children);
        };
        _this.renderAriaLiveRegion = function() {
            var _a = _this.props, _b = _a.dateFormat, dateFormat = _b === void 0 ? DatePicker.defaultProps.dateFormat : _b, locale = _a.locale;
            var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
            var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
            var ariaLiveMessage;
            if (_this.props.selectsRange) ariaLiveMessage = "Selected start date: ".concat($44884d0571b9c796$var$safeDateFormat(_this.props.startDate, {
                dateFormat: longDateFormat,
                locale: locale
            }), ". ").concat(_this.props.endDate ? "End date: " + $44884d0571b9c796$var$safeDateFormat(_this.props.endDate, {
                dateFormat: longDateFormat,
                locale: locale
            }) : "");
            else {
                if (_this.props.showTimeSelectOnly) ariaLiveMessage = "Selected time: ".concat($44884d0571b9c796$var$safeDateFormat(_this.props.selected, {
                    dateFormat: dateFormat,
                    locale: locale
                }));
                else if (_this.props.showYearPicker) ariaLiveMessage = "Selected year: ".concat($44884d0571b9c796$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy",
                    locale: locale
                }));
                else if (_this.props.showMonthYearPicker) ariaLiveMessage = "Selected month: ".concat($44884d0571b9c796$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: locale
                }));
                else if (_this.props.showQuarterYearPicker) ariaLiveMessage = "Selected quarter: ".concat($44884d0571b9c796$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: locale
                }));
                else ariaLiveMessage = "Selected date: ".concat($44884d0571b9c796$var$safeDateFormat(_this.props.selected, {
                    dateFormat: longDateFormat,
                    locale: locale
                }));
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, ariaLiveMessage);
        };
        _this.renderDateInput = function() {
            var _a, _b;
            var _c;
            var className = (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)(_this.props.className, (_a = {}, _a[$44884d0571b9c796$var$outsideClickIgnoreClass] = _this.state.open, _a));
            var customInput = _this.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("input", {
                type: "text"
            });
            var customInputRef = _this.props.customInputRef || "ref";
            var _d = _this.props, _e = _d.dateFormat, dateFormat = _e === void 0 ? DatePicker.defaultProps.dateFormat : _e, locale = _d.locale;
            var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : _this.props.selectsRange ? $44884d0571b9c796$var$safeDateRangeFormat(_this.props.startDate, _this.props.endDate, {
                dateFormat: dateFormat,
                locale: locale
            }) : _this.props.selectsMultiple ? $44884d0571b9c796$var$safeMultipleDatesFormat((_c = _this.props.selectedDates) !== null && _c !== void 0 ? _c : [], {
                dateFormat: dateFormat,
                locale: locale
            }) : $44884d0571b9c796$var$safeDateFormat(_this.props.selected, {
                dateFormat: dateFormat,
                locale: locale
            });
            return (0, $igtsr.cloneElement)(customInput, (_b = {}, _b[customInputRef] = function(input) {
                _this.input = input;
            }, _b.value = inputValue, _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b["aria-describedby"] = _this.props.ariaDescribedBy, _b["aria-invalid"] = _this.props.ariaInvalid, _b["aria-labelledby"] = _this.props.ariaLabelledBy, _b["aria-required"] = _this.props.ariaRequired, _b));
        };
        _this.renderClearButton = function() {
            var _a = _this.props, isClearable = _a.isClearable, disabled = _a.disabled, selected = _a.selected, startDate = _a.startDate, endDate = _a.endDate, clearButtonTitle = _a.clearButtonTitle, _b = _a.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a.selectedDates;
            if (isClearable && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("button", {
                type: "button",
                className: (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)("react-datepicker__close-icon", clearButtonClassName, {
                    "react-datepicker__close-icon--disabled": disabled
                }),
                disabled: disabled,
                "aria-label": ariaLabelClose,
                onClick: _this.onClearClick,
                title: clearButtonTitle,
                tabIndex: -1
            });
            else return null;
        };
        _this.state = _this.calcInitialState();
        _this.preventFocusTimeout = undefined;
        return _this;
    }
    Object.defineProperty(DatePicker, "defaultProps", {
        get: function() {
            return {
                allowSameDay: false,
                dateFormat: "MM/dd/yyyy",
                dateFormatCalendar: "LLLL yyyy",
                disabled: false,
                disabledKeyboardNavigation: false,
                dropdownMode: "scroll",
                preventOpenOnFocus: false,
                monthsShown: 1,
                readOnly: false,
                withPortal: false,
                selectsDisabledDaysInRange: false,
                shouldCloseOnSelect: true,
                showTimeSelect: false,
                showTimeInput: false,
                showPreviousMonths: false,
                showMonthYearPicker: false,
                showFullMonthYearPicker: false,
                showTwoColumnMonthYearPicker: false,
                showFourColumnMonthYearPicker: false,
                showYearPicker: false,
                showQuarterYearPicker: false,
                showWeekPicker: false,
                strictParsing: false,
                swapRange: false,
                timeIntervals: 30,
                timeCaption: "Time",
                previousMonthAriaLabel: "Previous Month",
                previousMonthButtonLabel: "Previous Month",
                nextMonthAriaLabel: "Next Month",
                nextMonthButtonLabel: "Next Month",
                previousYearAriaLabel: "Previous Year",
                previousYearButtonLabel: "Previous Year",
                nextYearAriaLabel: "Next Year",
                nextYearButtonLabel: "Next Year",
                timeInputLabel: "Time",
                enableTabLoop: true,
                yearItemNumber: $44884d0571b9c796$var$DEFAULT_YEAR_ITEM_NUMBER,
                focusSelectedMonth: false,
                showPopperArrow: true,
                excludeScrollbar: true,
                customTimeInput: null,
                calendarStartDay: undefined,
                toggleCalendarOnIconClick: false,
                usePointerEvent: false
            };
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.componentDidMount = function() {
        window.addEventListener("scroll", this.onScroll, true);
        document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d;
        if (prevProps.inline && $44884d0571b9c796$var$hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
        if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) this.setState({
            monthSelectedIn: 0
        });
        if (prevProps.highlightDates !== this.props.highlightDates) this.setState({
            highlightDates: $44884d0571b9c796$var$getHighLightDaysMap(this.props.highlightDates)
        });
        if (!prevState.focused && !$44884d0571b9c796$var$isEqual(prevProps.selected, this.props.selected)) this.setState({
            inputValue: null
        });
        if (prevState.open !== this.state.open) {
            if (prevState.open === false && this.state.open === true) (_b = (_a = this.props).onCalendarOpen) === null || _b === void 0 || _b.call(_a);
            if (prevState.open === true && this.state.open === false) (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 || _d.call(_c);
        }
    };
    DatePicker.prototype.componentWillUnmount = function() {
        this.clearPreventFocusTimeout();
        window.removeEventListener("scroll", this.onScroll, true);
        document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.renderInputContainer = function() {
        var _a = this.props, showIcon = _a.showIcon, icon = _a.icon, calendarIconClassname = _a.calendarIconClassname, calendarIconClassName = _a.calendarIconClassName, toggleCalendarOnIconClick = _a.toggleCalendarOnIconClick;
        var open = this.state.open;
        if (calendarIconClassname) console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
            className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
        }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$CalendarIcon, $44884d0571b9c796$var$_assign({
            icon: icon,
            className: (0, $e9b961c54aae6d46$export$4f5d2d50c9deca37)(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside")
        }, toggleCalendarOnIconClick ? {
            onClick: this.toggleCalendar
        } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    };
    DatePicker.prototype.render = function() {
        var calendar = this.renderCalendar();
        if (this.props.inline) return calendar;
        if (this.props.withPortal) {
            var portalContainer = this.state.open ? (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$TabLoop, {
                enableTabLoop: this.props.enableTabLoop
            }, (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", {
                className: "react-datepicker__portal",
                tabIndex: -1,
                onKeyDown: this.onPortalKeyDown
            }, calendar)) : null;
            if (this.state.open && this.props.portalId) portalContainer = (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$Portal, $44884d0571b9c796$var$_assign({
                portalId: this.props.portalId
            }, this.props), portalContainer);
            return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement("div", null, this.renderInputContainer(), portalContainer);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createElement($44884d0571b9c796$var$PopperComponent$1, $44884d0571b9c796$var$_assign({}, this.props, {
            className: this.props.popperClassName,
            hidePopper: !this.isCalendarOpen(),
            targetComponent: this.renderInputContainer(),
            popperComponent: calendar,
            popperOnKeyDown: this.onPopperKeyDown,
            showArrow: this.props.showPopperArrow
        }));
    };
    return DatePicker;
}((0, $igtsr.Component));
var $44884d0571b9c796$var$PRESELECT_CHANGE_VIA_INPUT = "input";
var $44884d0571b9c796$var$PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


const $bc7571e19bc65391$export$34dc4cfa15ead1 = ({ ...props })=>{
    const { setFieldValue: setFieldValue } = (0, $4l1Xa.useFormikContext)();
    const [field] = (0, $4l1Xa.useField)({
        name: props.name
    });
    // Convert timestamp to Date object if needed (for time pickers that store timestamps)
    const selectedValue = field.value === null || field.value === undefined ? null : typeof field.value === "number" ? new Date(field.value) : field.value;
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $44884d0571b9c796$export$2e2bcd8739ae039), {
        ...field,
        ...props,
        selected: selectedValue,
        onChange: (val)=>{
            setFieldValue(field.name, props.showTimeSelectOnly ? val.getTime() : val);
        }
    });
};
var $bc7571e19bc65391$export$2e2bcd8739ae039 = $bc7571e19bc65391$export$34dc4cfa15ead1;



parcelRequire("igtsr");
const $790b8e9658fa8ccc$export$5fda1783bb83f57b = ()=>{
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        enableBackground: "new 0 0 512 512",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m452 40h-24v-40h-40v40h-264v-40h-40v40h-24c-33.084 0-60 26.916-60 60v352c0 33.084 26.916 60 60 60h392c33.084 0 60-26.916 60-60v-352c0-33.084-26.916-60-60-60zm20 412c0 11.028-8.972 20-20 20h-392c-11.028 0-20-8.972-20-20v-264h432zm0-304h-432v-48c0-11.028 8.972-20 20-20h24v40h40v-40h264v40h40v-40h24c11.028 0 20 8.972 20 20z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m76 230h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m156 230h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m236 230h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m316 230h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m396 230h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m76 310h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m156 310h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m236 310h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m316 310h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m76 390h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m156 390h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m236 390h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m316 390h40v40h-40z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m396 310h40v40h-40z"
            })
        ]
    });
};
var $790b8e9658fa8ccc$export$2e2bcd8739ae039 = $790b8e9658fa8ccc$export$5fda1783bb83f57b;



/**
 * @author Youssef Tarek
 * @date 2022-03-08
 * @description page for a specific product
 * @filename product.tsx
 */ 


var $igtsr = parcelRequire("igtsr");




/**
 * @author Ahmed Serag
 * @date 2021-07-02
 * @description Implementation of Stock related utilities.
 * @filename stock.ts
 */ /**
 * @author Ahmed Serag
 * @date 2020-07-02
 * @description implementation of Stock related API calls.
 * @filename stock.ts
 */ 


class $b14126a0a205eb22$export$660483d3947d0ba9 {
    static itemsSales({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).items.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).items.method
        });
    }
    static itemsStock({ project: project, from: from, to: to, threshold: threshold = `10`, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).stock.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        // defaults to 10 in case threshold was provided as an empty string
        url.searchParams.append("threshold", threshold || "10");
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).stock.method
        });
    }
    static productSummary({ project: project, from: from, to: to, sku: sku, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).productSummary.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sku", sku);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).productSummary.method
        });
    }
    static productRecommendations({ project: project, from: from, to: to, sku: sku, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).productRecommendations.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sku", sku);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).productRecommendations.method
        });
    }
    static relatedProducts({ project: project, from: from, to: to, sku: sku, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).relatedProducts.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sku", sku);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).relatedProducts.method
        });
    }
    static searchItem({ project: project, from: from, to: to, search: search, currentPage: currentPage = 1, sort: sort, direction: direction, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).searchItem.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        // defaults to 10 in case threshold was provided as an empty string
        url.searchParams.append("currentPage", currentPage.toString() || "1");
        url.searchParams.append("search", search);
        if (sort) url.searchParams.append("sort", sort);
        if (direction) url.searchParams.append("direction", direction);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).searchItem.method
        });
    }
}



function $bf00c03a6e82e5ca$export$b2e66e41f7ed5c4e(payload) {
    return (0, $b14126a0a205eb22$export$660483d3947d0ba9).itemsSales(payload).then((response)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $bf00c03a6e82e5ca$export$b6d9e63e701f9d03(payload) {
    return (0, $b14126a0a205eb22$export$660483d3947d0ba9).itemsStock(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $bf00c03a6e82e5ca$export$f05bd1f05495ed85(payload) {
    return (0, $b14126a0a205eb22$export$660483d3947d0ba9).productSummary(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $bf00c03a6e82e5ca$export$b739a4c8380ca5f7(payload) {
    return (0, $b14126a0a205eb22$export$660483d3947d0ba9).productRecommendations(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $bf00c03a6e82e5ca$export$1de34354685b56fe(payload) {
    return (0, $b14126a0a205eb22$export$660483d3947d0ba9).relatedProducts(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $bf00c03a6e82e5ca$export$7d5bcb8438aaa31c(payload) {
    return (0, $b14126a0a205eb22$export$660483d3947d0ba9).searchItem(payload).then((response)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}




parcelRequire("igtsr");
const $7a543022dad66670$var$SvgBundle = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M10.248 9.205A5.129 5.129 0 0 1 14.348 1c3.568 0 4.614 4.307 6.152 8.203C22.038 5.307 23.084 1 26.652 1a5.129 5.129 0 0 1 4.08 8.232"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M29.95 36H5.05a3 3 0 0 1-3-3V16.333h30.9V33a3 3 0 0 1-3 3"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M30.898 17.406H4.102a4.102 4.102 0 0 1 0-8.203h26.796a4.102 4.102 0 0 1 0 8.203"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M16.398 9.203h8.203V36h-8.203z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M20.5 9.203h4.102V36H20.5z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M10.248 9.205A5.129 5.129 0 0 1 14.348 1c3.568 0 4.614 4.307 6.152 8.203C22.038 5.307 23.084 1 26.652 1a5.129 5.129 0 0 1 4.08 8.232M32.95 36H8.05a3 3 0 0 1-3-3V17.333h30.9V33a3 3 0 0 1-3 3Z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M33.898 17.406H7.102a4.102 4.102 0 0 1 0-8.203h26.796a4.102 4.102 0 0 1 0 8.203Z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M16.398 9.203h8.203V36h-8.203z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M20.5 9.203h4.102V36H20.5z"
                        })
                    ]
                })
            ]
        })
    });
var $7a543022dad66670$export$2e2bcd8739ae039 = $7a543022dad66670$var$SvgBundle;



parcelRequire("igtsr");
const $4340166cff2eb9b8$var$SvgDiscount = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#000",
            strokeLinecap: "round",
            transform: "matrix(1.5 0 0 1.5 1 1.07)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "m15.706 1.286 7.762 6.513a2 2 0 0 1 .246 2.817L14.53 21.563a2 2 0 0 1-2.817.246L3.95 15.296a2 2 0 0 1-.247-2.818l9.185-10.946a2 2 0 0 1 2.818-.246Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "m7.983 1.63 9.637 3.132a2 2 0 0 1 1.284 2.52l-4.415 13.59a2 2 0 0 1-2.52 1.284l-9.637-3.131a2 2 0 0 1-1.284-2.52l4.415-13.59a2 2 0 0 1 2.52-1.284Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 14.133,
                    height: 18.289,
                    y: 3.996,
                    fill: "#BDF8DF",
                    rx: 2
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#BDF8DF",
                    fillRule: "nonzero",
                    strokeLinejoin: "round",
                    d: "m7.693 7.602.345.7a1 1 0 0 0 .753.547l.773.113a.645.645 0 0 1 .357 1.1l-.559.544a1 1 0 0 0-.288.885l.132.77a.645.645 0 0 1-.935.68l-.691-.364a1 1 0 0 0-.93 0l-.692.364a.645.645 0 0 1-.935-.68l.132-.77a1 1 0 0 0-.288-.885l-.56-.545a.645.645 0 0 1 .358-1.1l.773-.112a1 1 0 0 0 .753-.547l.345-.7a.645.645 0 0 1 1.157 0"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M2.12 16.201h9.976m-7.897 2.078h5.819"
                })
            ]
        })
    });
var $4340166cff2eb9b8$export$2e2bcd8739ae039 = $4340166cff2eb9b8$var$SvgDiscount;



parcelRequire("igtsr");
const $82a0019a94c721c2$var$SvgStock = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 34,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FBFF48",
                    d: "M3 3.917h18.597a3 3 0 0 1 3 3V33a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6.917a3 3 0 0 1 3-3"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FBFF48",
                    d: "M8.717 1h14.646l6.95 6.951v22.132a3 3 0 0 1-3 3H8.718a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M27.597 33a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6.917a3 3 0 0 1 3-3h2.717"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(8.717 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            stroke: "#000",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M3 0h14.646l6.951 6.951v22.132a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            stroke: "#000",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "m17.646 0 6.951 6.951h-6.951z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 3.208,
                            height: 3.208,
                            x: 4.608,
                            y: 10.16,
                            fill: "#000",
                            rx: 0.5
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 3.208,
                            height: 3.208,
                            x: 4.608,
                            y: 16.576,
                            fill: "#000",
                            rx: 0.5
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 3.208,
                            height: 3.208,
                            x: 4.608,
                            y: 22.993,
                            fill: "#000",
                            rx: 0.5
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            stroke: "#000",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M10 11.764h10.033M10 18.181h10.033M10 24.597h10.033"
                        })
                    ]
                })
            ]
        })
    });
var $82a0019a94c721c2$export$2e2bcd8739ae039 = $82a0019a94c721c2$var$SvgStock;



/**
 * @author Karim Shalapy
 * @date 2022-09-29
 * @description implementation of a percentage change UI component
 * @filename percentage-change.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

parcelRequire("igtsr");
const $9ccc23b9f2646314$var$SvgIncrease = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 21,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.818 5.243h8.485v8.485m0-8.485L5.697 15.849"
        })
    });
var $9ccc23b9f2646314$export$2e2bcd8739ae039 = $9ccc23b9f2646314$var$SvgIncrease;



parcelRequire("igtsr");
const $dc83a01475034d9b$var$SvgDecrease = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 21,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.818 15.85h8.485V7.363m0 8.487L5.697 5.242"
        })
    });
var $dc83a01475034d9b$export$2e2bcd8739ae039 = $dc83a01475034d9b$var$SvgDecrease;



class $04ba0179fd07dc0d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    isTherePercentageChange() {
        return this.props.current != null && this.props.previous != null && !Number.isNaN((0, $48f673e197675daa$export$f10d6a896d4ffbcf)(this.props.current, this.props.previous).percentage) && (0, $48f673e197675daa$export$f10d6a896d4ffbcf)(this.props.current, this.props.previous).percentage;
    }
    render() {
        const percentageChange = (0, $48f673e197675daa$export$f10d6a896d4ffbcf)(this.props.current, this.props.previous);
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: this.isTherePercentageChange() ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                className: `percentage-change ${percentageChange.sign}`,
                children: [
                    `${Math.abs(percentageChange.percentage)}%`,
                    percentageChange.sign === "decrease" ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $dc83a01475034d9b$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $9ccc23b9f2646314$export$2e2bcd8739ae039), {})
                ]
            }) : ""
        });
    }
}


class $be69e13341d50da4$var$Product extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loadingProductSummary: true,
            loadingRelatedProducts: true,
            loadingProductRecommendations: true,
            id: Date.now().toString(),
            productSummary: null,
            previousProductSummary: null,
            relatedProducts: [],
            productRecommendations: null
        };
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentDidUpdate(prevProps) {
        if (this.props.productSku !== prevProps.productSku) this.loadData();
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        this.setState({
            loadingProductSummary: true,
            loadingRelatedProducts: true,
            loadingProductRecommendations: true
        });
        let productSummaryPromise = Promise.resolve();
        let relatedProductsPromise = Promise.resolve();
        let productRecommendationsPromise = Promise.resolve();
        let previousProductSummaryPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            productSummaryPromise = (0, $bf00c03a6e82e5ca$export$f05bd1f05495ed85)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                sku: this.props.productSku,
                filters: this.context.appliedFilters
            }).then((productSummary)=>{
                // Todo: this is returned in an array, should be spread
                this.setState({
                    productSummary: productSummary[0]
                });
            }).finally(()=>{
                this.setState({
                    loadingProductSummary: false
                });
            });
            previousProductSummaryPromise = (0, $bf00c03a6e82e5ca$export$f05bd1f05495ed85)({
                project: this.context.project,
                from: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.type).from,
                to: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.type).to,
                sku: this.props.productSku,
                filters: this.context.appliedFilters
            }).then((productSummary)=>{
                this.setState({
                    previousProductSummary: productSummary[0]
                });
            });
            relatedProductsPromise = (0, $bf00c03a6e82e5ca$export$1de34354685b56fe)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                sku: this.props.productSku,
                filters: this.context.appliedFilters
            }).then((relatedProducts)=>{
                this.setState({
                    relatedProducts: relatedProducts
                });
            }).finally(()=>{
                this.setState({
                    loadingRelatedProducts: false
                });
            });
            productRecommendationsPromise = (0, $bf00c03a6e82e5ca$export$b739a4c8380ca5f7)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                sku: this.props.productSku,
                filters: this.context.appliedFilters
            }).then((productRecommendations)=>{
                this.setState({
                    productRecommendations: productRecommendations
                });
            }).finally(()=>{
                this.setState({
                    loadingProductRecommendations: false
                });
            });
        }
        Promise.all([
            productSummaryPromise,
            relatedProductsPromise,
            productRecommendationsPromise,
            previousProductSummaryPromise
        ]).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "product-analytics",
            ref: this.props.exportRef,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card-container",
                    children: [
                        this.state.loadingProductSummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "card product-data",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "card product-data",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "information-card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "product-info",
                                        children: [
                                            this.state.productSummary?.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                src: this.state.productSummary.image_url,
                                                alt: this.state.productSummary.name,
                                                onError: (e)=>{
                                                    (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                                }
                                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                                alt: this.state.productSummary.name
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "product-name",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "title",
                                                        children: this.state.productSummary.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "tooltip",
                                                        children: this.state.productSummary.name
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "product-price",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title ",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.productSummary.price)} ${this.context.settings.currency}`
                                        })
                                    })
                                ]
                            })
                        }),
                        this.state.loadingProductSummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "card product-data",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "card product-sales transparent-card",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "stats-card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "stat",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "label",
                                                children: t("unitsSold")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "title",
                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.productSummary.number_sold)
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                current: this.state.productSummary?.number_sold,
                                                previous: this.state.previousProductSummary?.number_sold
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "stat",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "label",
                                                children: t("totalSalesValue")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "title",
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.productSummary.sales_value)} ${this.context.settings.currency}`
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                current: this.state.productSummary?.sales_value,
                                                previous: this.state.previousProductSummary?.sales_value
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "stat",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "label",
                                                children: t("inStock")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "title",
                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.productSummary.stock)
                                            })
                                        ]
                                    }),
                                    this.state.productSummary.productConversionRate && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "stat",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "label",
                                                children: t("productConversionRate")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "title",
                                                children: `${this.state.productSummary.productConversionRate}%`
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                current: this.state.productSummary?.productConversionRate,
                                                previous: this.state.previousProductSummary?.productConversionRate
                                            })
                                        ]
                                    }),
                                    this.state.productSummary.pageViews && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "stat",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "label",
                                                children: t("pageViews")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "title",
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.productSummary.pageViews)}`
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                current: this.state.productSummary?.pageViews,
                                                previous: this.state.previousProductSummary?.pageViews
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card-container product-lower-cards",
                    children: [
                        this.state.loadingRelatedProducts ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "card paired-products",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card paired-products",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                    className: "card--title",
                                    children: t("productsFrequentlyPaired")
                                }),
                                this.state.relatedProducts.length ? this.state.relatedProducts.map((relatedProduct)=>// eslint-disable-next-line react/jsx-indent
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "paired-product",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "product-info",
                                                children: [
                                                    relatedProduct.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                        src: relatedProduct.image_url,
                                                        alt: relatedProduct.name,
                                                        onError: (e)=>{
                                                            (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                                        }
                                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                                        alt: relatedProduct.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "product-name",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "label",
                                                                children: t("productName")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "name",
                                                                children: relatedProduct.name
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "tooltip",
                                                                children: relatedProduct.name
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "product-frequency",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "label",
                                                        children: t("timesPaired")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "frequency",
                                                        children: relatedProduct.frequency
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "product-details",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                    type: "submit",
                                                    onClick: ()=>{
                                                        this.props.updateProductSku(relatedProduct.sku);
                                                    },
                                                    children: t("viewProduct")
                                                })
                                            })
                                        ]
                                    }, relatedProduct.sku)) : t("noRelatedProducts")
                            ]
                        }),
                        this.state.loadingProductRecommendations ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "card recommendations",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card recommendations transparent-card",
                            children: [
                                this.state.productRecommendations.should_be_promoted && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "discount-banner banner",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "banner-icon",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4340166cff2eb9b8$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "banner-text",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "label",
                                                    children: t("discountedPrice")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "description",
                                                    children: t("applyAnOffer")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                this.state.relatedProducts.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "bundle-banner banner",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "banner-icon",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7a543022dad66670$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "banner-text",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "label",
                                                    children: t("bundle")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "description",
                                                    children: [
                                                        t("addThisProductToBundle"),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "banner-button",
                                                            children: this.state.relatedProducts[0].name
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "stock-banner banner",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "banner-icon",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $82a0019a94c721c2$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "banner-text",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "label",
                                                    children: t("stock")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "description",
                                                    children: [
                                                        t("productIsSellingFast"),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                new Date(this.state.productRecommendations.run_out_date).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                                                                    weekday: "long",
                                                                    day: "numeric",
                                                                    month: "long",
                                                                    year: "numeric"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, this.state.id);
    }
}
$be69e13341d50da4$var$Product.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $be69e13341d50da4$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("product")($be69e13341d50da4$var$Product);


var $fad619c9f6051037$exports = {};

$fad619c9f6051037$exports = (parcelRequire("2zLWb"));


/* eslint-disable react/no-did-update-set-state */ /**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description Orders tab of the App.
 * @filename orders.tsx
 */ 

var $igtsr = parcelRequire("igtsr");
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $960f3c207e4b05ed$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $960f3c207e4b05ed$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $960f3c207e4b05ed$export$bcc6e673dfa14d36(v) {
    return $960f3c207e4b05ed$export$837ba5c449269406($960f3c207e4b05ed$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $960f3c207e4b05ed$export$869b26d4e1bbdb63(v) {
    return $960f3c207e4b05ed$export$837ba5c449269406($960f3c207e4b05ed$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $960f3c207e4b05ed$export$ed9bd8dcaeba14f6(v) {
    return $960f3c207e4b05ed$export$837ba5c449269406($960f3c207e4b05ed$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $960f3c207e4b05ed$export$dbf961a8d278dbef(v) {
    return $960f3c207e4b05ed$export$837ba5c449269406($960f3c207e4b05ed$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $960f3c207e4b05ed$export$aa35ef1f24408ab9(v) {
    return $960f3c207e4b05ed$export$837ba5c449269406($960f3c207e4b05ed$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $960f3c207e4b05ed$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $960f3c207e4b05ed$var$hex = [
    ...'0123456789ABCDEF'
];
const $960f3c207e4b05ed$var$h1 = (b)=>$960f3c207e4b05ed$var$hex[b & 0xF];
const $960f3c207e4b05ed$var$h2 = (b)=>$960f3c207e4b05ed$var$hex[(b & 0xF0) >> 4] + $960f3c207e4b05ed$var$hex[b & 0xF];
const $960f3c207e4b05ed$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $960f3c207e4b05ed$var$isShort = (v)=>$960f3c207e4b05ed$var$eq(v.r) && $960f3c207e4b05ed$var$eq(v.g) && $960f3c207e4b05ed$var$eq(v.b) && $960f3c207e4b05ed$var$eq(v.a);
function $960f3c207e4b05ed$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $960f3c207e4b05ed$var$map$1[str[1]] * 17,
            g: 255 & $960f3c207e4b05ed$var$map$1[str[2]] * 17,
            b: 255 & $960f3c207e4b05ed$var$map$1[str[3]] * 17,
            a: len === 5 ? $960f3c207e4b05ed$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $960f3c207e4b05ed$var$map$1[str[1]] << 4 | $960f3c207e4b05ed$var$map$1[str[2]],
            g: $960f3c207e4b05ed$var$map$1[str[3]] << 4 | $960f3c207e4b05ed$var$map$1[str[4]],
            b: $960f3c207e4b05ed$var$map$1[str[5]] << 4 | $960f3c207e4b05ed$var$map$1[str[6]],
            a: len === 9 ? $960f3c207e4b05ed$var$map$1[str[7]] << 4 | $960f3c207e4b05ed$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $960f3c207e4b05ed$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $960f3c207e4b05ed$export$1b06654353ef9f67(v) {
    var f = $960f3c207e4b05ed$var$isShort(v) ? $960f3c207e4b05ed$var$h1 : $960f3c207e4b05ed$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $960f3c207e4b05ed$var$alpha(v.a, f) : undefined;
}
const $960f3c207e4b05ed$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $960f3c207e4b05ed$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $960f3c207e4b05ed$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $960f3c207e4b05ed$var$hwb2rgbn(h, w, b) {
    const rgb = $960f3c207e4b05ed$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $960f3c207e4b05ed$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $960f3c207e4b05ed$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $960f3c207e4b05ed$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $960f3c207e4b05ed$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($960f3c207e4b05ed$export$ed9bd8dcaeba14f6);
}
function $960f3c207e4b05ed$export$4c15bd42559b811d(h, s, l) {
    return $960f3c207e4b05ed$var$calln($960f3c207e4b05ed$var$hsl2rgbn, h, s, l);
}
function $960f3c207e4b05ed$export$e2710022c70fc9ee(h, w, b) {
    return $960f3c207e4b05ed$var$calln($960f3c207e4b05ed$var$hwb2rgbn, h, w, b);
}
function $960f3c207e4b05ed$export$b785a357c84e4a04(h, s, v) {
    return $960f3c207e4b05ed$var$calln($960f3c207e4b05ed$var$hsv2rgbn, h, s, v);
}
function $960f3c207e4b05ed$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $960f3c207e4b05ed$export$5e91288c399be4f9(str) {
    const m = $960f3c207e4b05ed$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $960f3c207e4b05ed$export$bcc6e673dfa14d36(+m[5]) : $960f3c207e4b05ed$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $960f3c207e4b05ed$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $960f3c207e4b05ed$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $960f3c207e4b05ed$export$b785a357c84e4a04(h, p1, p2);
    else v = $960f3c207e4b05ed$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $960f3c207e4b05ed$export$bb628a54ab399bc9(v, deg) {
    var h = $960f3c207e4b05ed$export$b5ba70b240f8f7f(v);
    h[0] = $960f3c207e4b05ed$var$hue(h[0] + deg);
    h = $960f3c207e4b05ed$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $960f3c207e4b05ed$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $960f3c207e4b05ed$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $960f3c207e4b05ed$export$aa35ef1f24408ab9(a[1]);
    const l = $960f3c207e4b05ed$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$960f3c207e4b05ed$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $960f3c207e4b05ed$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $960f3c207e4b05ed$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $960f3c207e4b05ed$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($960f3c207e4b05ed$var$names$1);
    const tkeys = Object.keys($960f3c207e4b05ed$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $960f3c207e4b05ed$var$map[k]);
        }
        k = parseInt($960f3c207e4b05ed$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $960f3c207e4b05ed$var$names;
function $960f3c207e4b05ed$export$b2f06b640faad956(str) {
    if (!$960f3c207e4b05ed$var$names) {
        $960f3c207e4b05ed$var$names = $960f3c207e4b05ed$var$unpack();
        $960f3c207e4b05ed$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $960f3c207e4b05ed$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $960f3c207e4b05ed$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $960f3c207e4b05ed$export$91aedb20f296e541(str) {
    const m = $960f3c207e4b05ed$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $960f3c207e4b05ed$export$bcc6e673dfa14d36(v) : $960f3c207e4b05ed$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $960f3c207e4b05ed$export$bcc6e673dfa14d36(r) : $960f3c207e4b05ed$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $960f3c207e4b05ed$export$bcc6e673dfa14d36(g) : $960f3c207e4b05ed$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $960f3c207e4b05ed$export$bcc6e673dfa14d36(b) : $960f3c207e4b05ed$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $960f3c207e4b05ed$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$960f3c207e4b05ed$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $960f3c207e4b05ed$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $960f3c207e4b05ed$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $960f3c207e4b05ed$var$interpolate(rgb1, rgb2, t) {
    const r = $960f3c207e4b05ed$var$from($960f3c207e4b05ed$export$dbf961a8d278dbef(rgb1.r));
    const g = $960f3c207e4b05ed$var$from($960f3c207e4b05ed$export$dbf961a8d278dbef(rgb1.g));
    const b = $960f3c207e4b05ed$var$from($960f3c207e4b05ed$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $960f3c207e4b05ed$export$ed9bd8dcaeba14f6($960f3c207e4b05ed$var$to(r + t * ($960f3c207e4b05ed$var$from($960f3c207e4b05ed$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $960f3c207e4b05ed$export$ed9bd8dcaeba14f6($960f3c207e4b05ed$var$to(g + t * ($960f3c207e4b05ed$var$from($960f3c207e4b05ed$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $960f3c207e4b05ed$export$ed9bd8dcaeba14f6($960f3c207e4b05ed$var$to(b + t * ($960f3c207e4b05ed$var$from($960f3c207e4b05ed$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $960f3c207e4b05ed$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $960f3c207e4b05ed$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $960f3c207e4b05ed$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $960f3c207e4b05ed$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $960f3c207e4b05ed$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $960f3c207e4b05ed$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $960f3c207e4b05ed$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $960f3c207e4b05ed$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $960f3c207e4b05ed$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $960f3c207e4b05ed$export$91aedb20f296e541(str);
    return $960f3c207e4b05ed$export$5e91288c399be4f9(str);
}
class $960f3c207e4b05ed$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $960f3c207e4b05ed$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $960f3c207e4b05ed$var$fromObject(input);
        else if (type === 'string') v = $960f3c207e4b05ed$export$625a38b961e8b5e9(input) || $960f3c207e4b05ed$export$b2f06b640faad956(input) || $960f3c207e4b05ed$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $960f3c207e4b05ed$var$clone(this._rgb);
        if (v) v.a = $960f3c207e4b05ed$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $960f3c207e4b05ed$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $960f3c207e4b05ed$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $960f3c207e4b05ed$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $960f3c207e4b05ed$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $960f3c207e4b05ed$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $960f3c207e4b05ed$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $960f3c207e4b05ed$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $960f3c207e4b05ed$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $960f3c207e4b05ed$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $960f3c207e4b05ed$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $960f3c207e4b05ed$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $960f3c207e4b05ed$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $960f3c207e4b05ed$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $960f3c207e4b05ed$export$2e2bcd8739ae039(input) {
    return new $960f3c207e4b05ed$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $70763e7ecc9cc4d3$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $70763e7ecc9cc4d3$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $70763e7ecc9cc4d3$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $70763e7ecc9cc4d3$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $70763e7ecc9cc4d3$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $70763e7ecc9cc4d3$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $70763e7ecc9cc4d3$export$c4ce752e73470fba(value, defaultValue) {
    return $70763e7ecc9cc4d3$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $70763e7ecc9cc4d3$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $70763e7ecc9cc4d3$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $70763e7ecc9cc4d3$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $70763e7ecc9cc4d3$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $70763e7ecc9cc4d3$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($70763e7ecc9cc4d3$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($70763e7ecc9cc4d3$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $70763e7ecc9cc4d3$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $70763e7ecc9cc4d3$export$667d3bf0c5f83305(source) {
    if ($70763e7ecc9cc4d3$export$8b22cf2602fb60ce(source)) return source.map($70763e7ecc9cc4d3$export$667d3bf0c5f83305);
    if ($70763e7ecc9cc4d3$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $70763e7ecc9cc4d3$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $70763e7ecc9cc4d3$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $70763e7ecc9cc4d3$export$317a3d46287192d8(key, target, source, options) {
    if (!$70763e7ecc9cc4d3$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($70763e7ecc9cc4d3$export$23f2a1d2818174ef(tval) && $70763e7ecc9cc4d3$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $70763e7ecc9cc4d3$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $70763e7ecc9cc4d3$export$667d3bf0c5f83305(sval);
}
function $70763e7ecc9cc4d3$export$efca4cbe5dd06740(target, source, options) {
    const sources = $70763e7ecc9cc4d3$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$70763e7ecc9cc4d3$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $70763e7ecc9cc4d3$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$70763e7ecc9cc4d3$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $70763e7ecc9cc4d3$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $70763e7ecc9cc4d3$export$efca4cbe5dd06740(target, source, {
        merger: $70763e7ecc9cc4d3$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $70763e7ecc9cc4d3$export$1ee57be6f6687d2c(key, target, source) {
    if (!$70763e7ecc9cc4d3$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($70763e7ecc9cc4d3$export$23f2a1d2818174ef(tval) && $70763e7ecc9cc4d3$export$23f2a1d2818174ef(sval)) $70763e7ecc9cc4d3$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $70763e7ecc9cc4d3$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $70763e7ecc9cc4d3$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $70763e7ecc9cc4d3$var$_getKeyResolver(key) {
    const keys = $70763e7ecc9cc4d3$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $70763e7ecc9cc4d3$export$2d1720544b23b823(obj, key) {
    const resolver = $70763e7ecc9cc4d3$var$keyResolvers[key] || ($70763e7ecc9cc4d3$var$keyResolvers[key] = $70763e7ecc9cc4d3$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $70763e7ecc9cc4d3$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $70763e7ecc9cc4d3$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $70763e7ecc9cc4d3$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $70763e7ecc9cc4d3$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $70763e7ecc9cc4d3$export$56c0d5a1e737357d = Math.PI;
const $70763e7ecc9cc4d3$export$971d5caa766a69d7 = 2 * $70763e7ecc9cc4d3$export$56c0d5a1e737357d;
const $70763e7ecc9cc4d3$export$2ec5befb9e6c97d4 = $70763e7ecc9cc4d3$export$971d5caa766a69d7 + $70763e7ecc9cc4d3$export$56c0d5a1e737357d;
const $70763e7ecc9cc4d3$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $70763e7ecc9cc4d3$export$39c1cc7c062529d4 = $70763e7ecc9cc4d3$export$56c0d5a1e737357d / 180;
const $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd = $70763e7ecc9cc4d3$export$56c0d5a1e737357d / 2;
const $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88 = $70763e7ecc9cc4d3$export$56c0d5a1e737357d / 4;
const $70763e7ecc9cc4d3$export$c18d01048907ea92 = $70763e7ecc9cc4d3$export$56c0d5a1e737357d * 2 / 3;
const $70763e7ecc9cc4d3$export$faec65b429be379 = Math.log10;
const $70763e7ecc9cc4d3$export$2408f22a0fab9ae5 = Math.sign;
function $70763e7ecc9cc4d3$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $70763e7ecc9cc4d3$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $70763e7ecc9cc4d3$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($70763e7ecc9cc4d3$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $70763e7ecc9cc4d3$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $70763e7ecc9cc4d3$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $70763e7ecc9cc4d3$export$d141bba7fdc215a3(n) {
    return !$70763e7ecc9cc4d3$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $70763e7ecc9cc4d3$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $70763e7ecc9cc4d3$export$625550452a3fa3ec(degrees) {
    return degrees * ($70763e7ecc9cc4d3$export$56c0d5a1e737357d / 180);
}
function $70763e7ecc9cc4d3$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $70763e7ecc9cc4d3$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $70763e7ecc9cc4d3$export$91477dc880baac21(x) {
    if (!$70763e7ecc9cc4d3$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $70763e7ecc9cc4d3$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $70763e7ecc9cc4d3$export$56c0d5a1e737357d) angle += $70763e7ecc9cc4d3$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $70763e7ecc9cc4d3$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $70763e7ecc9cc4d3$export$f074adc9fbd50943(a, b) {
    return (a - b + $70763e7ecc9cc4d3$export$2ec5befb9e6c97d4) % $70763e7ecc9cc4d3$export$971d5caa766a69d7 - $70763e7ecc9cc4d3$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $70763e7ecc9cc4d3$export$3d12bd131bb975d1(a) {
    return (a % $70763e7ecc9cc4d3$export$971d5caa766a69d7 + $70763e7ecc9cc4d3$export$971d5caa766a69d7) % $70763e7ecc9cc4d3$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $70763e7ecc9cc4d3$export$3d12bd131bb975d1(angle);
    const s = $70763e7ecc9cc4d3$export$3d12bd131bb975d1(start);
    const e = $70763e7ecc9cc4d3$export$3d12bd131bb975d1(end);
    const angleToStart = $70763e7ecc9cc4d3$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $70763e7ecc9cc4d3$export$3d12bd131bb975d1(e - a);
    const startToAngle = $70763e7ecc9cc4d3$export$3d12bd131bb975d1(a - s);
    const endToAngle = $70763e7ecc9cc4d3$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $70763e7ecc9cc4d3$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $70763e7ecc9cc4d3$export$71cec2538cb2c617(value) {
    return $70763e7ecc9cc4d3$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $70763e7ecc9cc4d3$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $70763e7ecc9cc4d3$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $70763e7ecc9cc4d3$export$ef35774e6d314e91 = (table, key, value, last)=>$70763e7ecc9cc4d3$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $70763e7ecc9cc4d3$export$ebd11618f299a286 = (table, key, value)=>$70763e7ecc9cc4d3$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $70763e7ecc9cc4d3$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $70763e7ecc9cc4d3$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $70763e7ecc9cc4d3$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $70763e7ecc9cc4d3$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $70763e7ecc9cc4d3$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $70763e7ecc9cc4d3$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $70763e7ecc9cc4d3$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $70763e7ecc9cc4d3$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $70763e7ecc9cc4d3$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $70763e7ecc9cc4d3$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $70763e7ecc9cc4d3$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $70763e7ecc9cc4d3$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $70763e7ecc9cc4d3$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $70763e7ecc9cc4d3$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $70763e7ecc9cc4d3$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $70763e7ecc9cc4d3$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $70763e7ecc9cc4d3$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($70763e7ecc9cc4d3$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $70763e7ecc9cc4d3$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$70763e7ecc9cc4d3$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $70763e7ecc9cc4d3$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($70763e7ecc9cc4d3$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $70763e7ecc9cc4d3$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$70763e7ecc9cc4d3$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $70763e7ecc9cc4d3$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $70763e7ecc9cc4d3$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $70763e7ecc9cc4d3$var$atEdge = (t)=>t === 0 || t === 1;
const $70763e7ecc9cc4d3$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $70763e7ecc9cc4d3$export$971d5caa766a69d7 / p));
const $70763e7ecc9cc4d3$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $70763e7ecc9cc4d3$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $70763e7ecc9cc4d3$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($70763e7ecc9cc4d3$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$70763e7ecc9cc4d3$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$70763e7ecc9cc4d3$var$atEdge(t) ? t : $70763e7ecc9cc4d3$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$70763e7ecc9cc4d3$var$atEdge(t) ? t : $70763e7ecc9cc4d3$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $70763e7ecc9cc4d3$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $70763e7ecc9cc4d3$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $70763e7ecc9cc4d3$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $70763e7ecc9cc4d3$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $70763e7ecc9cc4d3$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $70763e7ecc9cc4d3$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $70763e7ecc9cc4d3$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $70763e7ecc9cc4d3$export$db3b6bfb95261072(value) {
    return $70763e7ecc9cc4d3$export$738ab4df8bf92ae9(value) ? value : new (0, $960f3c207e4b05ed$export$892596cec99bc70e)(value);
}
function $70763e7ecc9cc4d3$export$d377dcb2b61d6c4e(value) {
    return $70763e7ecc9cc4d3$export$738ab4df8bf92ae9(value) ? value : new (0, $960f3c207e4b05ed$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $70763e7ecc9cc4d3$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $70763e7ecc9cc4d3$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $70763e7ecc9cc4d3$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $70763e7ecc9cc4d3$var$colors
        },
        numbers: {
            type: 'number',
            properties: $70763e7ecc9cc4d3$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $70763e7ecc9cc4d3$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $70763e7ecc9cc4d3$var$intlCache = new Map();
function $70763e7ecc9cc4d3$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $70763e7ecc9cc4d3$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $70763e7ecc9cc4d3$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $70763e7ecc9cc4d3$export$ae1af26003f05816(num, locale, options) {
    return $70763e7ecc9cc4d3$var$getNumberFormat(locale, options).format(num);
}
const $70763e7ecc9cc4d3$var$formatters = {
    values (value) {
        return $70763e7ecc9cc4d3$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $70763e7ecc9cc4d3$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $70763e7ecc9cc4d3$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $70763e7ecc9cc4d3$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($70763e7ecc9cc4d3$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $70763e7ecc9cc4d3$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $70763e7ecc9cc4d3$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $70763e7ecc9cc4d3$export$9f4f30ee63539e24 = {
    formatters: $70763e7ecc9cc4d3$var$formatters
};
function $70763e7ecc9cc4d3$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $70763e7ecc9cc4d3$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $70763e7ecc9cc4d3$export$6559d589eb85fbb6 = Object.create(null);
const $70763e7ecc9cc4d3$export$2e2af4578d910ddf = Object.create(null);
function $70763e7ecc9cc4d3$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $70763e7ecc9cc4d3$var$set(root, scope, values) {
    if (typeof scope === 'string') return $70763e7ecc9cc4d3$export$efca4cbe5dd06740($70763e7ecc9cc4d3$var$getScope$1(root, scope), values);
    return $70763e7ecc9cc4d3$export$efca4cbe5dd06740($70763e7ecc9cc4d3$var$getScope$1(root, ''), scope);
}
class $70763e7ecc9cc4d3$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$70763e7ecc9cc4d3$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$70763e7ecc9cc4d3$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$70763e7ecc9cc4d3$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $70763e7ecc9cc4d3$var$set(this, scope, values);
    }
    get(scope) {
        return $70763e7ecc9cc4d3$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $70763e7ecc9cc4d3$var$set($70763e7ecc9cc4d3$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $70763e7ecc9cc4d3$var$set($70763e7ecc9cc4d3$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $70763e7ecc9cc4d3$var$getScope$1(this, scope);
        const targetScopeObject = $70763e7ecc9cc4d3$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($70763e7ecc9cc4d3$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $70763e7ecc9cc4d3$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $70763e7ecc9cc4d3$export$4368d992c4eafac0 = /* #__PURE__ */ new $70763e7ecc9cc4d3$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $70763e7ecc9cc4d3$var$applyAnimationsDefaults,
    $70763e7ecc9cc4d3$var$applyLayoutsDefaults,
    $70763e7ecc9cc4d3$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $70763e7ecc9cc4d3$export$e171bab687b50e0(font) {
    if (!font || $70763e7ecc9cc4d3$export$342063e11d6c3cad(font.size) || $70763e7ecc9cc4d3$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $70763e7ecc9cc4d3$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$70763e7ecc9cc4d3$export$8b22cf2602fb60ce(thing)) longest = $70763e7ecc9cc4d3$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($70763e7ecc9cc4d3$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$70763e7ecc9cc4d3$export$8b22cf2602fb60ce(nestedThing)) longest = $70763e7ecc9cc4d3$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $70763e7ecc9cc4d3$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $70763e7ecc9cc4d3$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $70763e7ecc9cc4d3$export$1fbe638ecf81657e(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $70763e7ecc9cc4d3$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $70763e7ecc9cc4d3$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $70763e7ecc9cc4d3$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $70763e7ecc9cc4d3$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $70763e7ecc9cc4d3$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $70763e7ecc9cc4d3$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $70763e7ecc9cc4d3$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $70763e7ecc9cc4d3$export$56c0d5a1e737357d, rad - $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd, rad + $70763e7ecc9cc4d3$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $70763e7ecc9cc4d3$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $70763e7ecc9cc4d3$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $70763e7ecc9cc4d3$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $70763e7ecc9cc4d3$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $70763e7ecc9cc4d3$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$70763e7ecc9cc4d3$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $70763e7ecc9cc4d3$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $70763e7ecc9cc4d3$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $70763e7ecc9cc4d3$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $70763e7ecc9cc4d3$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $70763e7ecc9cc4d3$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $70763e7ecc9cc4d3$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$70763e7ecc9cc4d3$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $70763e7ecc9cc4d3$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $70763e7ecc9cc4d3$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $70763e7ecc9cc4d3$export$56c0d5a1e737357d, $70763e7ecc9cc4d3$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $70763e7ecc9cc4d3$export$56c0d5a1e737357d, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $70763e7ecc9cc4d3$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $70763e7ecc9cc4d3$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $70763e7ecc9cc4d3$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($70763e7ecc9cc4d3$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $70763e7ecc9cc4d3$var$numberOrZero = (v)=>+v || 0;
function $70763e7ecc9cc4d3$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $70763e7ecc9cc4d3$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $70763e7ecc9cc4d3$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$70763e7ecc9cc4d3$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $70763e7ecc9cc4d3$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $70763e7ecc9cc4d3$export$92108d983e8ee699(value) {
    return $70763e7ecc9cc4d3$export$ab83b03e4111b1d0(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce(value) {
    return $70763e7ecc9cc4d3$export$ab83b03e4111b1d0(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca(value) {
    const obj = $70763e7ecc9cc4d3$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $70763e7ecc9cc4d3$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $70763e7ecc9cc4d3$export$4368d992c4eafac0.font;
    let size = $70763e7ecc9cc4d3$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $70763e7ecc9cc4d3$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($70763e7ecc9cc4d3$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $70763e7ecc9cc4d3$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $70763e7ecc9cc4d3$export$d29e374196577086($70763e7ecc9cc4d3$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $70763e7ecc9cc4d3$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $70763e7ecc9cc4d3$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $70763e7ecc9cc4d3$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $70763e7ecc9cc4d3$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $70763e7ecc9cc4d3$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $70763e7ecc9cc4d3$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $70763e7ecc9cc4d3$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $70763e7ecc9cc4d3$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $70763e7ecc9cc4d3$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$70763e7ecc9cc4d3$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $70763e7ecc9cc4d3$var$_cached(target, prop, ()=>$70763e7ecc9cc4d3$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $70763e7ecc9cc4d3$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $70763e7ecc9cc4d3$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $70763e7ecc9cc4d3$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $70763e7ecc9cc4d3$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$70763e7ecc9cc4d3$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$70763e7ecc9cc4d3$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $70763e7ecc9cc4d3$var$_cached(target, prop, ()=>$70763e7ecc9cc4d3$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $70763e7ecc9cc4d3$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $70763e7ecc9cc4d3$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $70763e7ecc9cc4d3$var$readKey = (prefix, name)=>prefix ? prefix + $70763e7ecc9cc4d3$export$a8550f7dbe79f93a(name) : name;
const $70763e7ecc9cc4d3$var$needsSubResolver = (prop, value)=>$70763e7ecc9cc4d3$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $70763e7ecc9cc4d3$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $70763e7ecc9cc4d3$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($70763e7ecc9cc4d3$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $70763e7ecc9cc4d3$var$_resolveScriptable(prop, value, target, receiver);
    if ($70763e7ecc9cc4d3$export$8b22cf2602fb60ce(value) && value.length) value = $70763e7ecc9cc4d3$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($70763e7ecc9cc4d3$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $70763e7ecc9cc4d3$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $70763e7ecc9cc4d3$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($70763e7ecc9cc4d3$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $70763e7ecc9cc4d3$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $70763e7ecc9cc4d3$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($70763e7ecc9cc4d3$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $70763e7ecc9cc4d3$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($70763e7ecc9cc4d3$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $70763e7ecc9cc4d3$var$resolveFallback(fallback, prop, value) {
    return $70763e7ecc9cc4d3$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $70763e7ecc9cc4d3$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $70763e7ecc9cc4d3$export$2d1720544b23b823(parent, key) : undefined;
function $70763e7ecc9cc4d3$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $70763e7ecc9cc4d3$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $70763e7ecc9cc4d3$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $70763e7ecc9cc4d3$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $70763e7ecc9cc4d3$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $70763e7ecc9cc4d3$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $70763e7ecc9cc4d3$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $70763e7ecc9cc4d3$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$70763e7ecc9cc4d3$var$subGetTarget(resolver, prop, value));
}
function $70763e7ecc9cc4d3$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $70763e7ecc9cc4d3$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $70763e7ecc9cc4d3$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($70763e7ecc9cc4d3$export$8b22cf2602fb60ce(target) && $70763e7ecc9cc4d3$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $70763e7ecc9cc4d3$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $70763e7ecc9cc4d3$var$_resolve($70763e7ecc9cc4d3$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $70763e7ecc9cc4d3$var$needsSubResolver(prop, value) ? $70763e7ecc9cc4d3$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $70763e7ecc9cc4d3$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $70763e7ecc9cc4d3$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $70763e7ecc9cc4d3$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $70763e7ecc9cc4d3$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $70763e7ecc9cc4d3$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($70763e7ecc9cc4d3$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $70763e7ecc9cc4d3$var$EPSILON = Number.EPSILON || 1e-14;
const $70763e7ecc9cc4d3$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $70763e7ecc9cc4d3$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $70763e7ecc9cc4d3$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $70763e7ecc9cc4d3$export$cf2f7c5792f80b46(current, previous);
    const d12 = $70763e7ecc9cc4d3$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $70763e7ecc9cc4d3$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $70763e7ecc9cc4d3$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $70763e7ecc9cc4d3$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($70763e7ecc9cc4d3$export$23ebac1979863676(deltaK[i], 0, $70763e7ecc9cc4d3$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $70763e7ecc9cc4d3$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $70763e7ecc9cc4d3$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $70763e7ecc9cc4d3$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $70763e7ecc9cc4d3$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $70763e7ecc9cc4d3$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $70763e7ecc9cc4d3$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $70763e7ecc9cc4d3$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $70763e7ecc9cc4d3$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $70763e7ecc9cc4d3$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $70763e7ecc9cc4d3$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $70763e7ecc9cc4d3$var$monotoneAdjust(points, deltaK, mK);
    $70763e7ecc9cc4d3$var$monotoneCompute(points, mK, indexAxis);
}
function $70763e7ecc9cc4d3$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $70763e7ecc9cc4d3$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $70763e7ecc9cc4d3$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $70763e7ecc9cc4d3$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $70763e7ecc9cc4d3$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $70763e7ecc9cc4d3$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $70763e7ecc9cc4d3$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $70763e7ecc9cc4d3$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $70763e7ecc9cc4d3$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $70763e7ecc9cc4d3$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $70763e7ecc9cc4d3$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $70763e7ecc9cc4d3$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $70763e7ecc9cc4d3$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $70763e7ecc9cc4d3$export$fef3dfd9bad05307(el, property) {
    return $70763e7ecc9cc4d3$var$getComputedStyle(el).getPropertyValue(property);
}
const $70763e7ecc9cc4d3$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $70763e7ecc9cc4d3$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $70763e7ecc9cc4d3$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $70763e7ecc9cc4d3$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $70763e7ecc9cc4d3$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($70763e7ecc9cc4d3$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $70763e7ecc9cc4d3$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $70763e7ecc9cc4d3$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $70763e7ecc9cc4d3$var$getPositionedStyle(style, 'padding');
    const borders = $70763e7ecc9cc4d3$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $70763e7ecc9cc4d3$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $70763e7ecc9cc4d3$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $70763e7ecc9cc4d3$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $70763e7ecc9cc4d3$var$getComputedStyle(container);
            const containerBorder = $70763e7ecc9cc4d3$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $70763e7ecc9cc4d3$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $70763e7ecc9cc4d3$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $70763e7ecc9cc4d3$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $70763e7ecc9cc4d3$export$53c86fa97d611818,
        maxHeight: maxHeight || $70763e7ecc9cc4d3$export$53c86fa97d611818
    };
}
const $70763e7ecc9cc4d3$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $70763e7ecc9cc4d3$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $70763e7ecc9cc4d3$var$getComputedStyle(canvas);
    const margins = $70763e7ecc9cc4d3$var$getPositionedStyle(style, 'margin');
    const maxWidth = $70763e7ecc9cc4d3$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $70763e7ecc9cc4d3$export$53c86fa97d611818;
    const maxHeight = $70763e7ecc9cc4d3$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $70763e7ecc9cc4d3$export$53c86fa97d611818;
    const containerSize = $70763e7ecc9cc4d3$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $70763e7ecc9cc4d3$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $70763e7ecc9cc4d3$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $70763e7ecc9cc4d3$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $70763e7ecc9cc4d3$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $70763e7ecc9cc4d3$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $70763e7ecc9cc4d3$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $70763e7ecc9cc4d3$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $70763e7ecc9cc4d3$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($70763e7ecc9cc4d3$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $70763e7ecc9cc4d3$export$b4171a6734a65d42(element, property) {
    const value = $70763e7ecc9cc4d3$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $70763e7ecc9cc4d3$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $70763e7ecc9cc4d3$export$d24c54395ce0c509(p1, cp1, t);
    const b = $70763e7ecc9cc4d3$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $70763e7ecc9cc4d3$export$d24c54395ce0c509(cp2, p2, t);
    const d = $70763e7ecc9cc4d3$export$d24c54395ce0c509(a, b, t);
    const e = $70763e7ecc9cc4d3$export$d24c54395ce0c509(b, c, t);
    return $70763e7ecc9cc4d3$export$d24c54395ce0c509(d, e, t);
}
const $70763e7ecc9cc4d3$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $70763e7ecc9cc4d3$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $70763e7ecc9cc4d3$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $70763e7ecc9cc4d3$var$getRightToLeftAdapter(rectX, width) : $70763e7ecc9cc4d3$var$getLeftToRightAdapter();
}
function $70763e7ecc9cc4d3$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $70763e7ecc9cc4d3$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $70763e7ecc9cc4d3$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $70763e7ecc9cc4d3$export$ffb5f4729a158638,
        compare: $70763e7ecc9cc4d3$export$f074adc9fbd50943,
        normalize: $70763e7ecc9cc4d3$export$3d12bd131bb975d1
    };
    return {
        between: $70763e7ecc9cc4d3$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $70763e7ecc9cc4d3$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $70763e7ecc9cc4d3$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $70763e7ecc9cc4d3$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $70763e7ecc9cc4d3$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $70763e7ecc9cc4d3$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $70763e7ecc9cc4d3$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($70763e7ecc9cc4d3$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($70763e7ecc9cc4d3$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $70763e7ecc9cc4d3$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $70763e7ecc9cc4d3$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $70763e7ecc9cc4d3$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $70763e7ecc9cc4d3$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $70763e7ecc9cc4d3$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $70763e7ecc9cc4d3$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $70763e7ecc9cc4d3$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $70763e7ecc9cc4d3$var$splitByStyles(line, $70763e7ecc9cc4d3$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $70763e7ecc9cc4d3$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $70763e7ecc9cc4d3$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $70763e7ecc9cc4d3$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $70763e7ecc9cc4d3$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $70763e7ecc9cc4d3$var$readStyle(segmentOptions.setContext($70763e7ecc9cc4d3$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($70763e7ecc9cc4d3$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $70763e7ecc9cc4d3$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $70763e7ecc9cc4d3$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$70763e7ecc9cc4d3$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $70763e7ecc9cc4d3$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $70763e7ecc9cc4d3$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $70763e7ecc9cc4d3$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $70763e7ecc9cc4d3$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $70763e7ecc9cc4d3$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $70763e7ecc9cc4d3$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $70763e7ecc9cc4d3$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $70763e7ecc9cc4d3$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $faca378e734a26b8$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $70763e7ecc9cc4d3$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $faca378e734a26b8$export$a424a0aa8f687495 = /* #__PURE__ */ new $faca378e734a26b8$var$Animator();
const $faca378e734a26b8$var$transparent = 'transparent';
const $faca378e734a26b8$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $70763e7ecc9cc4d3$export$db3b6bfb95261072)(from || $faca378e734a26b8$var$transparent);
        const c1 = c0.valid && (0, $70763e7ecc9cc4d3$export$db3b6bfb95261072)(to || $faca378e734a26b8$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $faca378e734a26b8$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $70763e7ecc9cc4d3$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $70763e7ecc9cc4d3$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $faca378e734a26b8$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $70763e7ecc9cc4d3$export$f1e1789686576879)[cfg.easing] || (0, $70763e7ecc9cc4d3$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $70763e7ecc9cc4d3$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $70763e7ecc9cc4d3$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $faca378e734a26b8$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $faca378e734a26b8$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $faca378e734a26b8$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $faca378e734a26b8$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $faca378e734a26b8$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $faca378e734a26b8$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $faca378e734a26b8$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $faca378e734a26b8$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $faca378e734a26b8$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $faca378e734a26b8$var$scaleClip(xScale, allowedOverflow);
    const y = $faca378e734a26b8$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $faca378e734a26b8$var$toClip(value) {
    let t, r, b, l;
    if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $faca378e734a26b8$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $faca378e734a26b8$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(value) === (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $faca378e734a26b8$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $faca378e734a26b8$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $faca378e734a26b8$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $faca378e734a26b8$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $faca378e734a26b8$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $faca378e734a26b8$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $faca378e734a26b8$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $faca378e734a26b8$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $faca378e734a26b8$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $faca378e734a26b8$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $faca378e734a26b8$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $faca378e734a26b8$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $faca378e734a26b8$var$createDatasetContext(parent, index) {
    return (0, $70763e7ecc9cc4d3$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $faca378e734a26b8$var$createDataContext(parent, index, element) {
    return (0, $70763e7ecc9cc4d3$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $faca378e734a26b8$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $faca378e734a26b8$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $faca378e734a26b8$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $faca378e734a26b8$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $faca378e734a26b8$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $faca378e734a26b8$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $faca378e734a26b8$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $faca378e734a26b8$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(dataset.xAxisID, $faca378e734a26b8$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(dataset.yAxisID, $faca378e734a26b8$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(dataset.rAxisID, $faca378e734a26b8$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $70763e7ecc9cc4d3$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $faca378e734a26b8$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $faca378e734a26b8$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $70763e7ecc9cc4d3$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $faca378e734a26b8$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $70763e7ecc9cc4d3$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $faca378e734a26b8$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $faca378e734a26b8$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $faca378e734a26b8$var$updateStacks(this, meta._parsed);
            meta._stacked = $faca378e734a26b8$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $faca378e734a26b8$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $70763e7ecc9cc4d3$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $70763e7ecc9cc4d3$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $faca378e734a26b8$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $faca378e734a26b8$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $faca378e734a26b8$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $faca378e734a26b8$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $faca378e734a26b8$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $faca378e734a26b8$var$toClip((0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(this.options.clip, $faca378e734a26b8$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $faca378e734a26b8$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $faca378e734a26b8$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $70763e7ecc9cc4d3$export$dda1d9f60106f0e9)(index);
        if (cached) return $faca378e734a26b8$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($faca378e734a26b8$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $faca378e734a26b8$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $faca378e734a26b8$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($faca378e734a26b8$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$faca378e734a26b8$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $faca378e734a26b8$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $faca378e734a26b8$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $70763e7ecc9cc4d3$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $faca378e734a26b8$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $faca378e734a26b8$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $70763e7ecc9cc4d3$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $faca378e734a26b8$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $faca378e734a26b8$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $faca378e734a26b8$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $faca378e734a26b8$var$parseValue(entry, item, vScale, i) {
    if ((0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(entry)) $faca378e734a26b8$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $faca378e734a26b8$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($faca378e734a26b8$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $faca378e734a26b8$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $faca378e734a26b8$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $faca378e734a26b8$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $faca378e734a26b8$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $faca378e734a26b8$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$faca378e734a26b8$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$faca378e734a26b8$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $faca378e734a26b8$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $faca378e734a26b8$var$swap(edge, a, b);
        edge = $faca378e734a26b8$var$startEnd(edge, b, a);
    } else edge = $faca378e734a26b8$var$startEnd(edge, a, b);
    return edge;
}
function $faca378e734a26b8$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $faca378e734a26b8$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $faca378e734a26b8$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $faca378e734a26b8$export$e97d5dc64e999004 extends $faca378e734a26b8$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $faca378e734a26b8$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $faca378e734a26b8$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $70763e7ecc9cc4d3$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($faca378e734a26b8$var$parseValue((0, $70763e7ecc9cc4d3$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $faca378e734a26b8$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $faca378e734a26b8$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $faca378e734a26b8$var$setBorderSkipped(properties, options, stack, index);
            $faca378e734a26b8$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $faca378e734a26b8$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $faca378e734a26b8$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(value) !== (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $faca378e734a26b8$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $faca378e734a26b8$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $faca378e734a26b8$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $faca378e734a26b8$export$19b5c4773f17abe extends $faca378e734a26b8$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $faca378e734a26b8$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $70763e7ecc9cc4d3$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $70763e7ecc9cc4d3$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d) + (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $faca378e734a26b8$export$e04603e7d8b77172 extends $faca378e734a26b8$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $70763e7ecc9cc4d3$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7);
        let max = -(0, $70763e7ecc9cc4d3$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $70763e7ecc9cc4d3$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $faca378e734a26b8$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $70763e7ecc9cc4d3$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $70763e7ecc9cc4d3$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $faca378e734a26b8$export$3c9b5d28c11cbfd0 extends $faca378e734a26b8$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $70763e7ecc9cc4d3$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $70763e7ecc9cc4d3$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $70763e7ecc9cc4d3$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $faca378e734a26b8$export$2a270b3a0d973c85 extends $faca378e734a26b8$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $70763e7ecc9cc4d3$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $70763e7ecc9cc4d3$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $faca378e734a26b8$export$b21a3f1286706191 extends $faca378e734a26b8$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $faca378e734a26b8$export$48dbc6ac651bf8be extends $faca378e734a26b8$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $70763e7ecc9cc4d3$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $faca378e734a26b8$export$b2f2bae6713db87 extends $faca378e734a26b8$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $70763e7ecc9cc4d3$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $70763e7ecc9cc4d3$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $70763e7ecc9cc4d3$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $faca378e734a26b8$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $faca378e734a26b8$export$e97d5dc64e999004,
    BubbleController: $faca378e734a26b8$export$19b5c4773f17abe,
    DoughnutController: $faca378e734a26b8$export$e04603e7d8b77172,
    LineController: $faca378e734a26b8$export$3c9b5d28c11cbfd0,
    PieController: $faca378e734a26b8$export$b21a3f1286706191,
    PolarAreaController: $faca378e734a26b8$export$2a270b3a0d973c85,
    RadarController: $faca378e734a26b8$export$48dbc6ac651bf8be,
    ScatterController: $faca378e734a26b8$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $faca378e734a26b8$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $faca378e734a26b8$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($faca378e734a26b8$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $faca378e734a26b8$var$abstract();
    }
    parse() {
        return $faca378e734a26b8$var$abstract();
    }
    format() {
        return $faca378e734a26b8$var$abstract();
    }
    add() {
        return $faca378e734a26b8$var$abstract();
    }
    diff() {
        return $faca378e734a26b8$var$abstract();
    }
    startOf() {
        return $faca378e734a26b8$var$abstract();
    }
    endOf() {
        return $faca378e734a26b8$var$abstract();
    }
}
var $faca378e734a26b8$export$f32766ea09ec8bc4 = {
    _date: $faca378e734a26b8$var$DateAdapterBase
};
function $faca378e734a26b8$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $70763e7ecc9cc4d3$export$ebd11618f299a286) : (0, $70763e7ecc9cc4d3$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $faca378e734a26b8$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $faca378e734a26b8$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $faca378e734a26b8$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $faca378e734a26b8$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $70763e7ecc9cc4d3$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $faca378e734a26b8$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $faca378e734a26b8$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $70763e7ecc9cc4d3$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $70763e7ecc9cc4d3$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $faca378e734a26b8$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $faca378e734a26b8$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $faca378e734a26b8$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $faca378e734a26b8$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $faca378e734a26b8$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $faca378e734a26b8$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $faca378e734a26b8$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $faca378e734a26b8$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $faca378e734a26b8$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $faca378e734a26b8$export$a13296960cae0384 = {
    evaluateInteractionItems: $faca378e734a26b8$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $70763e7ecc9cc4d3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $faca378e734a26b8$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $faca378e734a26b8$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $70763e7ecc9cc4d3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $faca378e734a26b8$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $faca378e734a26b8$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $70763e7ecc9cc4d3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $faca378e734a26b8$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $70763e7ecc9cc4d3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $faca378e734a26b8$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $70763e7ecc9cc4d3$export$df995fae86a55f06)(e, chart);
            return $faca378e734a26b8$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $70763e7ecc9cc4d3$export$df995fae86a55f06)(e, chart);
            return $faca378e734a26b8$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $faca378e734a26b8$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $faca378e734a26b8$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $faca378e734a26b8$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$faca378e734a26b8$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $faca378e734a26b8$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $faca378e734a26b8$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $faca378e734a26b8$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$faca378e734a26b8$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $faca378e734a26b8$var$setLayoutDims(layouts, params) {
    const stacks = $faca378e734a26b8$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $faca378e734a26b8$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $faca378e734a26b8$var$wrapBoxes(boxes);
    const fullSize = $faca378e734a26b8$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $faca378e734a26b8$var$sortByWeight($faca378e734a26b8$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $faca378e734a26b8$var$sortByWeight($faca378e734a26b8$var$filterByPosition(layoutBoxes, 'right'));
    const top = $faca378e734a26b8$var$sortByWeight($faca378e734a26b8$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $faca378e734a26b8$var$sortByWeight($faca378e734a26b8$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $faca378e734a26b8$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $faca378e734a26b8$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $faca378e734a26b8$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $faca378e734a26b8$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $faca378e734a26b8$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $faca378e734a26b8$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $faca378e734a26b8$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $faca378e734a26b8$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $faca378e734a26b8$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $faca378e734a26b8$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $faca378e734a26b8$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $faca378e734a26b8$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $faca378e734a26b8$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $faca378e734a26b8$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $faca378e734a26b8$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $faca378e734a26b8$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $faca378e734a26b8$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $70763e7ecc9cc4d3$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $faca378e734a26b8$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $faca378e734a26b8$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $70763e7ecc9cc4d3$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $faca378e734a26b8$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $faca378e734a26b8$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $faca378e734a26b8$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $faca378e734a26b8$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $faca378e734a26b8$var$updateMaxPadding(maxPadding, (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $faca378e734a26b8$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $faca378e734a26b8$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $faca378e734a26b8$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($faca378e734a26b8$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $faca378e734a26b8$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $faca378e734a26b8$var$handleMaxPadding(chartArea);
        $faca378e734a26b8$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $faca378e734a26b8$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $faca378e734a26b8$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $faca378e734a26b8$export$a40a96b24b46cf35 extends $faca378e734a26b8$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $faca378e734a26b8$var$EXPANDO_KEY = '$chartjs';
const $faca378e734a26b8$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $faca378e734a26b8$var$isNullOrEmpty = (value)=>value === null || value === '';
function $faca378e734a26b8$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$faca378e734a26b8$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($faca378e734a26b8$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $70763e7ecc9cc4d3$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($faca378e734a26b8$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $70763e7ecc9cc4d3$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $faca378e734a26b8$var$eventListenerOptions = (0, $70763e7ecc9cc4d3$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $faca378e734a26b8$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $faca378e734a26b8$var$eventListenerOptions);
}
function $faca378e734a26b8$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $faca378e734a26b8$var$eventListenerOptions);
}
function $faca378e734a26b8$var$fromNativeEvent(event, chart) {
    const type = $faca378e734a26b8$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $70763e7ecc9cc4d3$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $faca378e734a26b8$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $faca378e734a26b8$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $faca378e734a26b8$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$faca378e734a26b8$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $faca378e734a26b8$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $faca378e734a26b8$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$faca378e734a26b8$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $faca378e734a26b8$var$drpListeningCharts = new Map();
let $faca378e734a26b8$var$oldDevicePixelRatio = 0;
function $faca378e734a26b8$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $faca378e734a26b8$var$oldDevicePixelRatio) return;
    $faca378e734a26b8$var$oldDevicePixelRatio = dpr;
    $faca378e734a26b8$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $faca378e734a26b8$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$faca378e734a26b8$var$drpListeningCharts.size) window.addEventListener('resize', $faca378e734a26b8$var$onWindowResize);
    $faca378e734a26b8$var$drpListeningCharts.set(chart, resize);
}
function $faca378e734a26b8$var$unlistenDevicePixelRatioChanges(chart) {
    $faca378e734a26b8$var$drpListeningCharts.delete(chart);
    if (!$faca378e734a26b8$var$drpListeningCharts.size) window.removeEventListener('resize', $faca378e734a26b8$var$onWindowResize);
}
function $faca378e734a26b8$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $70763e7ecc9cc4d3$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $70763e7ecc9cc4d3$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $faca378e734a26b8$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $faca378e734a26b8$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $faca378e734a26b8$var$unlistenDevicePixelRatioChanges(chart);
}
function $faca378e734a26b8$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $70763e7ecc9cc4d3$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($faca378e734a26b8$var$fromNativeEvent(event, chart));
    }, chart);
    $faca378e734a26b8$var$addListener(canvas, type, proxy);
    return proxy;
}
class $faca378e734a26b8$export$f02da7f882cf6b2e extends $faca378e734a26b8$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $faca378e734a26b8$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$faca378e734a26b8$var$EXPANDO_KEY]) return false;
        const initial = canvas[$faca378e734a26b8$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$faca378e734a26b8$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $faca378e734a26b8$var$createAttachObserver,
            detach: $faca378e734a26b8$var$createDetachObserver,
            resize: $faca378e734a26b8$var$createResizeObserver
        };
        const handler = handlers[type] || $faca378e734a26b8$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $faca378e734a26b8$var$releaseObserver,
            detach: $faca378e734a26b8$var$releaseObserver,
            resize: $faca378e734a26b8$var$releaseObserver
        };
        const handler = handlers[type] || $faca378e734a26b8$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $70763e7ecc9cc4d3$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $70763e7ecc9cc4d3$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $faca378e734a26b8$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $70763e7ecc9cc4d3$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $faca378e734a26b8$export$a40a96b24b46cf35;
    return $faca378e734a26b8$export$f02da7f882cf6b2e;
}
class $faca378e734a26b8$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $70763e7ecc9cc4d3$export$d141bba7fdc215a3)(this.x) && (0, $70763e7ecc9cc4d3$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $faca378e734a26b8$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $faca378e734a26b8$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $faca378e734a26b8$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $faca378e734a26b8$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $faca378e734a26b8$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $faca378e734a26b8$var$skip(ticks, newTicks, spacing, (0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$faca378e734a26b8$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $faca378e734a26b8$var$skip(ticks, newTicks, spacing, last, (0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $faca378e734a26b8$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $faca378e734a26b8$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $faca378e734a26b8$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $faca378e734a26b8$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $70763e7ecc9cc4d3$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $faca378e734a26b8$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $faca378e734a26b8$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $faca378e734a26b8$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $faca378e734a26b8$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $faca378e734a26b8$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $faca378e734a26b8$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $faca378e734a26b8$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $faca378e734a26b8$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $faca378e734a26b8$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $faca378e734a26b8$var$garbageCollect(caches, length) {
    (0, $70763e7ecc9cc4d3$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $faca378e734a26b8$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $faca378e734a26b8$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $faca378e734a26b8$var$createScaleContext(parent, scale) {
    return (0, $70763e7ecc9cc4d3$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $faca378e734a26b8$var$createTickContext(parent, index, tick) {
    return (0, $70763e7ecc9cc4d3$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $faca378e734a26b8$var$titleAlign(align, position, reverse) {
    let ret = (0, $70763e7ecc9cc4d3$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $faca378e734a26b8$var$reverseAlign(ret);
    return ret;
}
function $faca378e734a26b8$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $faca378e734a26b8$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $faca378e734a26b8$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd) : (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $faca378e734a26b8$export$d60cfc58d3c358b6 extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(min, (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(max, min)),
            max: (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(max, (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $70763e7ecc9cc4d3$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $faca378e734a26b8$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $faca378e734a26b8$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $faca378e734a26b8$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $faca378e734a26b8$var$getTickMarkLength(options.grid) - tickOpts.padding - $faca378e734a26b8$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $70763e7ecc9cc4d3$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $faca378e734a26b8$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $faca378e734a26b8$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $faca378e734a26b8$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $faca378e734a26b8$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $faca378e734a26b8$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(label) && !(0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(label)) {
                width = (0, $70763e7ecc9cc4d3$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(nestedLabel) && !(0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $70763e7ecc9cc4d3$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $faca378e734a26b8$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $70763e7ecc9cc4d3$export$71cec2538cb2c617)(this._alignToPixels ? (0, $70763e7ecc9cc4d3$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $faca378e734a26b8$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $faca378e734a26b8$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $faca378e734a26b8$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $70763e7ecc9cc4d3$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $faca378e734a26b8$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $70763e7ecc9cc4d3$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $faca378e734a26b8$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $70763e7ecc9cc4d3$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $70763e7ecc9cc4d3$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $70763e7ecc9cc4d3$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $70763e7ecc9cc4d3$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $70763e7ecc9cc4d3$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $70763e7ecc9cc4d3$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $70763e7ecc9cc4d3$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(title.font);
        const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $faca378e734a26b8$var$titleArgs(this, offset, position, align);
        (0, $70763e7ecc9cc4d3$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $faca378e734a26b8$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $faca378e734a26b8$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $faca378e734a26b8$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($faca378e734a26b8$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $faca378e734a26b8$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0)[scope]) {
            delete (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $70763e7ecc9cc4d3$export$6559d589eb85fbb6)[id];
        }
    }
}
function $faca378e734a26b8$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $70763e7ecc9cc4d3$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $faca378e734a26b8$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $faca378e734a26b8$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $faca378e734a26b8$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $faca378e734a26b8$var$Registry {
    constructor(){
        this.controllers = new $faca378e734a26b8$var$TypedRegistry($faca378e734a26b8$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $faca378e734a26b8$var$TypedRegistry($faca378e734a26b8$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $faca378e734a26b8$var$TypedRegistry(Object, 'plugins');
        this.scales = new $faca378e734a26b8$var$TypedRegistry($faca378e734a26b8$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $70763e7ecc9cc4d3$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $70763e7ecc9cc4d3$export$a8550f7dbe79f93a)(method);
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $faca378e734a26b8$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $faca378e734a26b8$var$Registry();
class $faca378e734a26b8$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $faca378e734a26b8$var$allPlugins(config);
        return options === false && !all ? [] : $faca378e734a26b8$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $faca378e734a26b8$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($faca378e734a26b8$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($faca378e734a26b8$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $faca378e734a26b8$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $faca378e734a26b8$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $faca378e734a26b8$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $faca378e734a26b8$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $faca378e734a26b8$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $faca378e734a26b8$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $faca378e734a26b8$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $faca378e734a26b8$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $faca378e734a26b8$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $faca378e734a26b8$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $faca378e734a26b8$var$determineAxis(id, ...scaleOptions) {
    if ($faca378e734a26b8$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $faca378e734a26b8$var$axisFromPosition(opts.position) || id.length > 1 && $faca378e734a26b8$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $faca378e734a26b8$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $faca378e734a26b8$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $faca378e734a26b8$var$getAxisFromDataset(id, 'x', boundDs[0]) || $faca378e734a26b8$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $faca378e734a26b8$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $70763e7ecc9cc4d3$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $faca378e734a26b8$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $faca378e734a26b8$var$determineAxis(id, scaleConf, $faca378e734a26b8$var$retrieveAxisFromDatasets(id, config), (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $faca378e734a26b8$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $70763e7ecc9cc4d3$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $faca378e734a26b8$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $70763e7ecc9cc4d3$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $faca378e734a26b8$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $70763e7ecc9cc4d3$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $70763e7ecc9cc4d3$export$555508cbc6add439)(scale, [
            (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).scales[scale.type],
            (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $faca378e734a26b8$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $faca378e734a26b8$var$mergeScaleConfig(config, options);
}
function $faca378e734a26b8$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $faca378e734a26b8$var$initConfig(config) {
    config = config || {};
    config.data = $faca378e734a26b8$var$initData(config.data);
    $faca378e734a26b8$var$initOptions(config);
    return config;
}
const $faca378e734a26b8$var$keyCache = new Map();
const $faca378e734a26b8$var$keysCached = new Set();
function $faca378e734a26b8$var$cachedKeys(cacheKey, generate) {
    let keys = $faca378e734a26b8$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $faca378e734a26b8$var$keyCache.set(cacheKey, keys);
        $faca378e734a26b8$var$keysCached.add(keys);
    }
    return keys;
}
const $faca378e734a26b8$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $70763e7ecc9cc4d3$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $faca378e734a26b8$var$Config {
    constructor(config){
        this._config = $faca378e734a26b8$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $faca378e734a26b8$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $faca378e734a26b8$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $faca378e734a26b8$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $faca378e734a26b8$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $faca378e734a26b8$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $faca378e734a26b8$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$faca378e734a26b8$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$faca378e734a26b8$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$faca378e734a26b8$var$addIfFound(scopes, (0, $70763e7ecc9cc4d3$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$faca378e734a26b8$var$addIfFound(scopes, (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$faca378e734a26b8$var$addIfFound(scopes, (0, $70763e7ecc9cc4d3$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($faca378e734a26b8$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $70763e7ecc9cc4d3$export$6559d589eb85fbb6)[type] || {},
            (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0),
            (0, $70763e7ecc9cc4d3$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $faca378e734a26b8$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($faca378e734a26b8$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $70763e7ecc9cc4d3$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $70763e7ecc9cc4d3$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $faca378e734a26b8$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(context) ? (0, $70763e7ecc9cc4d3$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $faca378e734a26b8$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $70763e7ecc9cc4d3$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $faca378e734a26b8$var$hasFunction = (value)=>(0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $70763e7ecc9cc4d3$export$a93c5207d687da10)(value[key]));
function $faca378e734a26b8$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $70763e7ecc9cc4d3$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $70763e7ecc9cc4d3$export$a93c5207d687da10)(value) || $faca378e734a26b8$var$hasFunction(value)) || indexable && (0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $faca378e734a26b8$var$version = "4.4.9";
const $faca378e734a26b8$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $faca378e734a26b8$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $faca378e734a26b8$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $faca378e734a26b8$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $faca378e734a26b8$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $faca378e734a26b8$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $faca378e734a26b8$var$getCanvas(item) {
    if ((0, $70763e7ecc9cc4d3$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $faca378e734a26b8$var$instances = {};
const $faca378e734a26b8$var$getChart = (key)=>{
    const canvas = $faca378e734a26b8$var$getCanvas(key);
    return Object.values($faca378e734a26b8$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $faca378e734a26b8$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $faca378e734a26b8$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $faca378e734a26b8$export$acaa6426d77a227e {
    static defaults = (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0);
    static instances = $faca378e734a26b8$var$instances;
    static overrides = (0, $70763e7ecc9cc4d3$export$6559d589eb85fbb6);
    static registry = $faca378e734a26b8$export$4bb7493d241fd8a5;
    static version = $faca378e734a26b8$var$version;
    static getChart = $faca378e734a26b8$var$getChart;
    static register(...items) {
        $faca378e734a26b8$export$4bb7493d241fd8a5.add(...items);
        $faca378e734a26b8$var$invalidatePlugins();
    }
    static unregister(...items) {
        $faca378e734a26b8$export$4bb7493d241fd8a5.remove(...items);
        $faca378e734a26b8$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $faca378e734a26b8$var$Config(userConfig);
        const initialCanvas = $faca378e734a26b8$var$getCanvas(item);
        const existingChart = $faca378e734a26b8$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $faca378e734a26b8$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $70763e7ecc9cc4d3$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $faca378e734a26b8$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $70763e7ecc9cc4d3$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $faca378e734a26b8$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $faca378e734a26b8$export$a424a0aa8f687495.listen(this, 'complete', $faca378e734a26b8$var$onAnimationsComplete);
        $faca378e734a26b8$export$a424a0aa8f687495.listen(this, 'progress', $faca378e734a26b8$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $faca378e734a26b8$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $70763e7ecc9cc4d3$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $70763e7ecc9cc4d3$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $faca378e734a26b8$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$faca378e734a26b8$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $70763e7ecc9cc4d3$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $faca378e734a26b8$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $faca378e734a26b8$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $faca378e734a26b8$var$positionIsHorizontal(scaleOptions.position, axis) !== $faca378e734a26b8$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $faca378e734a26b8$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(scales, (scale)=>{
            $faca378e734a26b8$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $faca378e734a26b8$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($faca378e734a26b8$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $faca378e734a26b8$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $faca378e734a26b8$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $faca378e734a26b8$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $faca378e734a26b8$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $70763e7ecc9cc4d3$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($faca378e734a26b8$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this.scales, (scale)=>{
            $faca378e734a26b8$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $70763e7ecc9cc4d3$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $faca378e734a26b8$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $70763e7ecc9cc4d3$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $faca378e734a26b8$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $70763e7ecc9cc4d3$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($faca378e734a26b8$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$faca378e734a26b8$export$a424a0aa8f687495.running(this)) $faca378e734a26b8$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $faca378e734a26b8$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $70763e7ecc9cc4d3$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $70763e7ecc9cc4d3$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $70763e7ecc9cc4d3$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $70763e7ecc9cc4d3$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $faca378e734a26b8$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $70763e7ecc9cc4d3$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $70763e7ecc9cc4d3$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $faca378e734a26b8$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $70763e7ecc9cc4d3$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $faca378e734a26b8$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $70763e7ecc9cc4d3$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $70763e7ecc9cc4d3$export$3b513254972cfc9c)(e);
        const lastEvent = $faca378e734a26b8$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $70763e7ecc9cc4d3$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $faca378e734a26b8$var$invalidatePlugins() {
    return (0, $70763e7ecc9cc4d3$export$d66501df72047452)($faca378e734a26b8$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $faca378e734a26b8$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd), startAngle - (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $faca378e734a26b8$var$toRadiusCorners(value) {
    return (0, $70763e7ecc9cc4d3$export$ab83b03e4111b1d0)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $faca378e734a26b8$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $faca378e734a26b8$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $faca378e734a26b8$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $faca378e734a26b8$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $faca378e734a26b8$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $faca378e734a26b8$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $faca378e734a26b8$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $faca378e734a26b8$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $faca378e734a26b8$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $faca378e734a26b8$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $faca378e734a26b8$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $faca378e734a26b8$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $faca378e734a26b8$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7) || (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7));
    }
    $faca378e734a26b8$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $faca378e734a26b8$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $faca378e734a26b8$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7) || (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7));
    }
    if (inner) $faca378e734a26b8$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $faca378e734a26b8$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $faca378e734a26b8$export$d48203c759d6a1fc extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $70763e7ecc9cc4d3$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $70763e7ecc9cc4d3$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $70763e7ecc9cc4d3$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $faca378e734a26b8$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $faca378e734a26b8$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $faca378e734a26b8$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $faca378e734a26b8$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $faca378e734a26b8$var$getLineMethod(options) {
    if (options.stepped) return 0, $70763e7ecc9cc4d3$export$6554612db691658e;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $70763e7ecc9cc4d3$export$493d36ec626b6698;
    return $faca378e734a26b8$var$lineTo;
}
function $faca378e734a26b8$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $faca378e734a26b8$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $faca378e734a26b8$var$pathVars(points, segment, params);
    const lineMethod = $faca378e734a26b8$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $faca378e734a26b8$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $faca378e734a26b8$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $faca378e734a26b8$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $faca378e734a26b8$var$fastPathSegment : $faca378e734a26b8$var$pathSegment;
}
function $faca378e734a26b8$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $70763e7ecc9cc4d3$export$2f6ca3d3b1f80bf5;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $70763e7ecc9cc4d3$export$8a5498727ef6be21;
    return 0, $70763e7ecc9cc4d3$export$d24c54395ce0c509;
}
function $faca378e734a26b8$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $faca378e734a26b8$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $faca378e734a26b8$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $faca378e734a26b8$var$_getSegmentMethod(line);
    for (const segment of segments){
        $faca378e734a26b8$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $faca378e734a26b8$var$usePath2D = typeof Path2D === 'function';
function $faca378e734a26b8$var$draw(ctx, line, start, count) {
    if ($faca378e734a26b8$var$usePath2D && !line.options.segment) $faca378e734a26b8$var$strokePathWithCache(ctx, line, start, count);
    else $faca378e734a26b8$var$strokePathDirect(ctx, line, start, count);
}
class $faca378e734a26b8$export$55e463fa7bcd3469 extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $70763e7ecc9cc4d3$export$1a82df3d29112e01)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $70763e7ecc9cc4d3$export$306ddfe3a8403e2)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $70763e7ecc9cc4d3$export$7a38258bbe170828)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $faca378e734a26b8$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $faca378e734a26b8$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $faca378e734a26b8$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $faca378e734a26b8$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $faca378e734a26b8$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $faca378e734a26b8$export$bd159b522b230b7a extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $faca378e734a26b8$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $faca378e734a26b8$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $70763e7ecc9cc4d3$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $70763e7ecc9cc4d3$export$1fbe638ecf81657e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $faca378e734a26b8$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $faca378e734a26b8$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(value, min, max);
}
function $faca378e734a26b8$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $70763e7ecc9cc4d3$export$92108d983e8ee699)(value);
    return {
        t: $faca378e734a26b8$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $faca378e734a26b8$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $faca378e734a26b8$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $faca378e734a26b8$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $faca378e734a26b8$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $faca378e734a26b8$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $faca378e734a26b8$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $faca378e734a26b8$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $faca378e734a26b8$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $faca378e734a26b8$var$boundingRects(bar) {
    const bounds = $faca378e734a26b8$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $faca378e734a26b8$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $faca378e734a26b8$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $faca378e734a26b8$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $faca378e734a26b8$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $70763e7ecc9cc4d3$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $70763e7ecc9cc4d3$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $faca378e734a26b8$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $faca378e734a26b8$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $faca378e734a26b8$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $faca378e734a26b8$export$a16ed71bf4b07672 extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $faca378e734a26b8$var$boundingRects(this);
        const addRectPath = $faca378e734a26b8$var$hasRadius(outer.radius) ? (0, $70763e7ecc9cc4d3$export$d66dc83d8cfc8dd) : $faca378e734a26b8$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $faca378e734a26b8$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $faca378e734a26b8$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $faca378e734a26b8$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $faca378e734a26b8$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $faca378e734a26b8$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $faca378e734a26b8$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $faca378e734a26b8$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $faca378e734a26b8$export$d48203c759d6a1fc,
    BarElement: $faca378e734a26b8$export$a16ed71bf4b07672,
    LineElement: $faca378e734a26b8$export$55e463fa7bcd3469,
    PointElement: $faca378e734a26b8$export$bd159b522b230b7a
});
const $faca378e734a26b8$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $faca378e734a26b8$var$BACKGROUND_COLORS = /* #__PURE__ */ $faca378e734a26b8$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $faca378e734a26b8$var$getBorderColor(i) {
    return $faca378e734a26b8$var$BORDER_COLORS[i % $faca378e734a26b8$var$BORDER_COLORS.length];
}
function $faca378e734a26b8$var$getBackgroundColor(i) {
    return $faca378e734a26b8$var$BACKGROUND_COLORS[i % $faca378e734a26b8$var$BACKGROUND_COLORS.length];
}
function $faca378e734a26b8$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $faca378e734a26b8$var$getBorderColor(i);
    dataset.backgroundColor = $faca378e734a26b8$var$getBackgroundColor(i);
    return ++i;
}
function $faca378e734a26b8$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$faca378e734a26b8$var$getBorderColor(i++));
    return i;
}
function $faca378e734a26b8$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$faca378e734a26b8$var$getBackgroundColor(i++));
    return i;
}
function $faca378e734a26b8$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $faca378e734a26b8$export$e04603e7d8b77172) i = $faca378e734a26b8$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $faca378e734a26b8$export$2a270b3a0d973c85) i = $faca378e734a26b8$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $faca378e734a26b8$var$colorizeDefaultDataset(dataset, i);
    };
}
function $faca378e734a26b8$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $faca378e734a26b8$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $faca378e734a26b8$var$containsDefaultColorsDefenitions() {
    return (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $faca378e734a26b8$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $faca378e734a26b8$var$containsColorsDefinitions(datasets) || $faca378e734a26b8$var$containsColorsDefinition(chartOptions) || elements && $faca378e734a26b8$var$containsColorsDefinitions(elements) || $faca378e734a26b8$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $faca378e734a26b8$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $faca378e734a26b8$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $faca378e734a26b8$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(minIndex) && !(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $faca378e734a26b8$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $faca378e734a26b8$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $faca378e734a26b8$var$cleanDecimatedDataset(dataset);
    });
}
function $faca378e734a26b8$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)((0, $70763e7ecc9cc4d3$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)((0, $70763e7ecc9cc4d3$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $faca378e734a26b8$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $faca378e734a26b8$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $70763e7ecc9cc4d3$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $faca378e734a26b8$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $faca378e734a26b8$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $faca378e734a26b8$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $faca378e734a26b8$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $faca378e734a26b8$var$cleanDecimatedData(chart);
    }
};
function $faca378e734a26b8$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $faca378e734a26b8$var$_findSegmentEnd(start, end, points);
        const bounds = $faca378e734a26b8$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $70763e7ecc9cc4d3$export$7a38258bbe170828)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $faca378e734a26b8$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $70763e7ecc9cc4d3$export$28f7fcd39efa255)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $faca378e734a26b8$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $faca378e734a26b8$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $faca378e734a26b8$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $70763e7ecc9cc4d3$export$3d12bd131bb975d1)(start);
        end = (0, $70763e7ecc9cc4d3$export$3d12bd131bb975d1)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $faca378e734a26b8$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $faca378e734a26b8$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $faca378e734a26b8$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $faca378e734a26b8$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $faca378e734a26b8$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $faca378e734a26b8$var$_pointsFromSegments(boundary, line);
    return points.length ? new $faca378e734a26b8$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $faca378e734a26b8$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $faca378e734a26b8$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $faca378e734a26b8$var$_decodeFill(line, index, count) {
    const fill = $faca378e734a26b8$var$parseFillOption(line);
    if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $faca378e734a26b8$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $faca378e734a26b8$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $faca378e734a26b8$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $faca378e734a26b8$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $faca378e734a26b8$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $faca378e734a26b8$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $faca378e734a26b8$var$getLinesBelow(scale, index);
    linesBelow.push($faca378e734a26b8$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$faca378e734a26b8$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $faca378e734a26b8$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $faca378e734a26b8$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $faca378e734a26b8$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $faca378e734a26b8$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $faca378e734a26b8$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $70763e7ecc9cc4d3$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $faca378e734a26b8$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $faca378e734a26b8$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(fill)) return $faca378e734a26b8$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $faca378e734a26b8$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $faca378e734a26b8$var$computeBoundary(source);
    if (boundary instanceof $faca378e734a26b8$var$simpleArc) return boundary;
    return $faca378e734a26b8$var$_createBoundaryLine(boundary, line);
}
function $faca378e734a26b8$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $faca378e734a26b8$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $faca378e734a26b8$var$computeCircularBoundary(source);
    return $faca378e734a26b8$var$computeLinearBoundary(source);
}
function $faca378e734a26b8$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $faca378e734a26b8$var$_getTargetPixel(fill, scale);
    if ((0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $faca378e734a26b8$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $faca378e734a26b8$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $faca378e734a26b8$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $faca378e734a26b8$var$_drawfill(ctx, source, area) {
    const target = $faca378e734a26b8$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $70763e7ecc9cc4d3$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $70763e7ecc9cc4d3$export$8743009a87fcb00f)(ctx, area);
        $faca378e734a26b8$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $70763e7ecc9cc4d3$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $faca378e734a26b8$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $faca378e734a26b8$var$clipVertical(ctx, target, area.top);
        $faca378e734a26b8$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property,
            clip: clip
        });
        ctx.restore();
        ctx.save();
        $faca378e734a26b8$var$clipVertical(ctx, target, area.bottom);
    }
    $faca378e734a26b8$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $faca378e734a26b8$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$faca378e734a26b8$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $faca378e734a26b8$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $faca378e734a26b8$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $faca378e734a26b8$var$clipBounds(ctx, scale, clip, notShape && $faca378e734a26b8$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $faca378e734a26b8$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $faca378e734a26b8$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $faca378e734a26b8$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $faca378e734a26b8$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $faca378e734a26b8$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $faca378e734a26b8$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $faca378e734a26b8$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $faca378e734a26b8$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $faca378e734a26b8$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($faca378e734a26b8$var$_shouldApplyFill(source)) $faca378e734a26b8$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$faca378e734a26b8$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $faca378e734a26b8$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $faca378e734a26b8$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $faca378e734a26b8$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $faca378e734a26b8$var$Legend extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $faca378e734a26b8$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $faca378e734a26b8$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $70763e7ecc9cc4d3$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $70763e7ecc9cc4d3$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $70763e7ecc9cc4d3$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $70763e7ecc9cc4d3$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $faca378e734a26b8$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $70763e7ecc9cc4d3$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $70763e7ecc9cc4d3$export$d66dc83d8cfc8dd)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $70763e7ecc9cc4d3$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $70763e7ecc9cc4d3$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $70763e7ecc9cc4d3$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $faca378e734a26b8$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $70763e7ecc9cc4d3$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $70763e7ecc9cc4d3$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $70763e7ecc9cc4d3$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $70763e7ecc9cc4d3$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $70763e7ecc9cc4d3$export$21579262ef46735b)(x, this.left, this.right) && (0, $70763e7ecc9cc4d3$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $70763e7ecc9cc4d3$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $70763e7ecc9cc4d3$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$faca378e734a26b8$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $faca378e734a26b8$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $faca378e734a26b8$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $faca378e734a26b8$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $faca378e734a26b8$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $faca378e734a26b8$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $faca378e734a26b8$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $faca378e734a26b8$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $faca378e734a26b8$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $faca378e734a26b8$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $faca378e734a26b8$export$ed247974535929c7 = {
    id: 'legend',
    _element: $faca378e734a26b8$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $faca378e734a26b8$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $faca378e734a26b8$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $faca378e734a26b8$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $faca378e734a26b8$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $faca378e734a26b8$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $faca378e734a26b8$var$Title extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $70763e7ecc9cc4d3$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $70763e7ecc9cc4d3$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $70763e7ecc9cc4d3$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $faca378e734a26b8$var$createTitle(chart, titleOpts) {
    const title = new $faca378e734a26b8$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $faca378e734a26b8$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $faca378e734a26b8$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $faca378e734a26b8$export$f99233281efd08a0 = {
    id: 'title',
    _element: $faca378e734a26b8$var$Title,
    start (chart, _args, options) {
        $faca378e734a26b8$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $faca378e734a26b8$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $faca378e734a26b8$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $faca378e734a26b8$var$map = new WeakMap();
var $faca378e734a26b8$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $faca378e734a26b8$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $faca378e734a26b8$export$1ecca0613f5e56d2.configure(chart, title, options);
        $faca378e734a26b8$export$1ecca0613f5e56d2.addBox(chart, title);
        $faca378e734a26b8$var$map.set(chart, title);
    },
    stop (chart) {
        $faca378e734a26b8$export$1ecca0613f5e56d2.removeBox(chart, $faca378e734a26b8$var$map.get(chart));
        $faca378e734a26b8$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $faca378e734a26b8$var$map.get(chart);
        $faca378e734a26b8$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $faca378e734a26b8$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $70763e7ecc9cc4d3$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $faca378e734a26b8$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $faca378e734a26b8$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $faca378e734a26b8$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $faca378e734a26b8$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $70763e7ecc9cc4d3$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $70763e7ecc9cc4d3$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $70763e7ecc9cc4d3$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $70763e7ecc9cc4d3$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $faca378e734a26b8$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $faca378e734a26b8$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $faca378e734a26b8$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($faca378e734a26b8$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $faca378e734a26b8$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $faca378e734a26b8$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $faca378e734a26b8$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $faca378e734a26b8$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $faca378e734a26b8$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $faca378e734a26b8$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce)(cornerRadius);
    let x = $faca378e734a26b8$var$alignX(size, xAlign);
    const y = $faca378e734a26b8$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $faca378e734a26b8$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $faca378e734a26b8$var$getBeforeAfterBodyLines(callback) {
    return $faca378e734a26b8$var$pushOrConcat([], $faca378e734a26b8$var$splitNewlines(callback));
}
function $faca378e734a26b8$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $70763e7ecc9cc4d3$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $faca378e734a26b8$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $faca378e734a26b8$var$defaultCallbacks = {
    beforeTitle: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    beforeBody: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    beforeLabel: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    afterBody: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    beforeFooter: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    footer: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346),
    afterFooter: (0, $70763e7ecc9cc4d3$export$53a70dd1ebbae346)
};
function $faca378e734a26b8$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $faca378e734a26b8$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $faca378e734a26b8$var$Tooltip extends $faca378e734a26b8$export$db77ccec0bb4ccac {
    static positioners = $faca378e734a26b8$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $faca378e734a26b8$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $faca378e734a26b8$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $faca378e734a26b8$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $faca378e734a26b8$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $faca378e734a26b8$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $faca378e734a26b8$var$pushOrConcat(lines, $faca378e734a26b8$var$splitNewlines(beforeTitle));
        lines = $faca378e734a26b8$var$pushOrConcat(lines, $faca378e734a26b8$var$splitNewlines(title));
        lines = $faca378e734a26b8$var$pushOrConcat(lines, $faca378e734a26b8$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $faca378e734a26b8$var$getBeforeAfterBodyLines($faca378e734a26b8$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $faca378e734a26b8$var$overrideCallbacks(callbacks, context);
            $faca378e734a26b8$var$pushOrConcat(bodyItem.before, $faca378e734a26b8$var$splitNewlines($faca378e734a26b8$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $faca378e734a26b8$var$pushOrConcat(bodyItem.lines, $faca378e734a26b8$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $faca378e734a26b8$var$pushOrConcat(bodyItem.after, $faca378e734a26b8$var$splitNewlines($faca378e734a26b8$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $faca378e734a26b8$var$getBeforeAfterBodyLines($faca378e734a26b8$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $faca378e734a26b8$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $faca378e734a26b8$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $faca378e734a26b8$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $faca378e734a26b8$var$pushOrConcat(lines, $faca378e734a26b8$var$splitNewlines(beforeFooter));
        lines = $faca378e734a26b8$var$pushOrConcat(lines, $faca378e734a26b8$var$splitNewlines(footer));
        lines = $faca378e734a26b8$var$pushOrConcat(lines, $faca378e734a26b8$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($faca378e734a26b8$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $faca378e734a26b8$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($faca378e734a26b8$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($faca378e734a26b8$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($faca378e734a26b8$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $faca378e734a26b8$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $faca378e734a26b8$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $faca378e734a26b8$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $faca378e734a26b8$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $70763e7ecc9cc4d3$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $faca378e734a26b8$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.bodyFont);
        const colorX = $faca378e734a26b8$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $70763e7ecc9cc4d3$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $70763e7ecc9cc4d3$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $70763e7ecc9cc4d3$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $70763e7ecc9cc4d3$export$d66dc83d8cfc8dd)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $70763e7ecc9cc4d3$export$d66dc83d8cfc8dd)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $70763e7ecc9cc4d3$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $faca378e734a26b8$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $70763e7ecc9cc4d3$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $70763e7ecc9cc4d3$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $70763e7ecc9cc4d3$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $70763e7ecc9cc4d3$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $faca378e734a26b8$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $faca378e734a26b8$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $faca378e734a26b8$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $faca378e734a26b8$var$determineAlignment(chart, options, positionAndSize);
            const point = $faca378e734a26b8$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $70763e7ecc9cc4d3$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $70763e7ecc9cc4d3$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $70763e7ecc9cc4d3$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $70763e7ecc9cc4d3$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $faca378e734a26b8$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $faca378e734a26b8$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $faca378e734a26b8$var$Tooltip,
    positioners: $faca378e734a26b8$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $faca378e734a26b8$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $faca378e734a26b8$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $faca378e734a26b8$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $faca378e734a26b8$export$c537fa0d021d010b,
    Decimation: $faca378e734a26b8$export$be17f937e9aa7533,
    Filler: $faca378e734a26b8$export$d19ba4d812bed757,
    Legend: $faca378e734a26b8$export$ed247974535929c7,
    SubTitle: $faca378e734a26b8$export$d5c56664638992a4,
    Title: $faca378e734a26b8$export$f99233281efd08a0,
    Tooltip: $faca378e734a26b8$export$28c660c63b792dea
});
const $faca378e734a26b8$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $faca378e734a26b8$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $faca378e734a26b8$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $faca378e734a26b8$var$validIndex = (index, max)=>index === null ? null : (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $faca378e734a26b8$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $faca378e734a26b8$export$29e663ba4d09fe7 extends $faca378e734a26b8$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $faca378e734a26b8$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $faca378e734a26b8$var$findOrAddLabel(labels, raw, (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $faca378e734a26b8$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $faca378e734a26b8$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $faca378e734a26b8$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $70763e7ecc9cc4d3$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $70763e7ecc9cc4d3$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $70763e7ecc9cc4d3$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $70763e7ecc9cc4d3$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $70763e7ecc9cc4d3$export$91477dc880baac21)(spacing), (0, $70763e7ecc9cc4d3$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $70763e7ecc9cc4d3$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $faca378e734a26b8$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $70763e7ecc9cc4d3$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $faca378e734a26b8$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $faca378e734a26b8$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $faca378e734a26b8$var$LinearScaleBase extends $faca378e734a26b8$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $70763e7ecc9cc4d3$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $faca378e734a26b8$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $70763e7ecc9cc4d3$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $70763e7ecc9cc4d3$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $faca378e734a26b8$export$e7f4e5e8656f0b93 extends $faca378e734a26b8$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $70763e7ecc9cc4d3$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $faca378e734a26b8$var$log10Floor = (v)=>Math.floor((0, $70763e7ecc9cc4d3$export$faec65b429be379)(v));
const $faca378e734a26b8$var$changeExponent = (v, m)=>Math.pow(10, $faca378e734a26b8$var$log10Floor(v) + m);
function $faca378e734a26b8$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $faca378e734a26b8$var$log10Floor(tickVal));
    return remain === 1;
}
function $faca378e734a26b8$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $faca378e734a26b8$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $faca378e734a26b8$var$log10Floor(range);
    while($faca378e734a26b8$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($faca378e734a26b8$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $faca378e734a26b8$var$log10Floor(min));
}
function $faca378e734a26b8$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $faca378e734a26b8$var$log10Floor(min);
    let exp = $faca378e734a26b8$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $faca378e734a26b8$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $70763e7ecc9cc4d3$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $faca378e734a26b8$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $faca378e734a26b8$export$85295eaf7cb3ac3e extends $faca378e734a26b8$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $70763e7ecc9cc4d3$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $faca378e734a26b8$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(this._userMin)) this.min = min === $faca378e734a26b8$var$changeExponent(this.min, 0) ? $faca378e734a26b8$var$changeExponent(this.min, -1) : $faca378e734a26b8$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($faca378e734a26b8$var$changeExponent(min, -1));
                setMax($faca378e734a26b8$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($faca378e734a26b8$var$changeExponent(max, -1));
        if (max <= 0) setMax($faca378e734a26b8$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $faca378e734a26b8$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $70763e7ecc9cc4d3$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $70763e7ecc9cc4d3$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $70763e7ecc9cc4d3$export$faec65b429be379)(start);
        this._valueRange = (0, $70763e7ecc9cc4d3$export$faec65b429be379)(this.max) - (0, $70763e7ecc9cc4d3$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $70763e7ecc9cc4d3$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $faca378e734a26b8$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $70763e7ecc9cc4d3$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $faca378e734a26b8$var$measureLabelSize(ctx, font, label) {
    label = (0, $70763e7ecc9cc4d3$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $70763e7ecc9cc4d3$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $faca378e734a26b8$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $faca378e734a26b8$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(opts.font);
        const textSize = $faca378e734a26b8$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $70763e7ecc9cc4d3$export$3d12bd131bb975d1)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $70763e7ecc9cc4d3$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $faca378e734a26b8$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $faca378e734a26b8$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $faca378e734a26b8$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $faca378e734a26b8$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $faca378e734a26b8$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $faca378e734a26b8$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $70763e7ecc9cc4d3$export$3a6d5c9ae78a2c08)((0, $70763e7ecc9cc4d3$export$3d12bd131bb975d1)(pointLabelPosition.angle + (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd))));
    const y = $faca378e734a26b8$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $faca378e734a26b8$var$getTextAlignForAngle(angle);
    const left = $faca378e734a26b8$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $faca378e734a26b8$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $70763e7ecc9cc4d3$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $70763e7ecc9cc4d3$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $70763e7ecc9cc4d3$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $70763e7ecc9cc4d3$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $faca378e734a26b8$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $faca378e734a26b8$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $70763e7ecc9cc4d3$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $faca378e734a26b8$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $faca378e734a26b8$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $faca378e734a26b8$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $faca378e734a26b8$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $faca378e734a26b8$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $faca378e734a26b8$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $70763e7ecc9cc4d3$export$9fa96a7d116ea3ce)(opts.borderRadius);
        const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $70763e7ecc9cc4d3$export$d66dc83d8cfc8dd)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $faca378e734a26b8$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $faca378e734a26b8$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $70763e7ecc9cc4d3$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $faca378e734a26b8$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $faca378e734a26b8$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $faca378e734a26b8$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $faca378e734a26b8$var$createPointLabelContext(parent, index, label) {
    return (0, $70763e7ecc9cc4d3$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $faca378e734a26b8$export$cfafc36d95386d38 extends $faca378e734a26b8$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $70763e7ecc9cc4d3$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)($faca378e734a26b8$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $faca378e734a26b8$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $faca378e734a26b8$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $faca378e734a26b8$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $70763e7ecc9cc4d3$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $70763e7ecc9cc4d3$export$3d12bd131bb975d1)(index * angleMultiplier + (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $faca378e734a26b8$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $70763e7ecc9cc4d3$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $faca378e734a26b8$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $faca378e734a26b8$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $faca378e734a26b8$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $70763e7ecc9cc4d3$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $70763e7ecc9cc4d3$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $70763e7ecc9cc4d3$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $faca378e734a26b8$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $faca378e734a26b8$var$UNITS = /* #__PURE__ */ Object.keys($faca378e734a26b8$var$INTERVALS);
function $faca378e734a26b8$var$sorter(a, b) {
    return a - b;
}
function $faca378e734a26b8$var$parse(scale, input) {
    if ((0, $70763e7ecc9cc4d3$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $70763e7ecc9cc4d3$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $faca378e734a26b8$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $faca378e734a26b8$var$UNITS.length;
    for(let i = $faca378e734a26b8$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $faca378e734a26b8$var$INTERVALS[$faca378e734a26b8$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $faca378e734a26b8$var$UNITS[i];
    }
    return $faca378e734a26b8$var$UNITS[ilen - 1];
}
function $faca378e734a26b8$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $faca378e734a26b8$var$UNITS.length - 1; i >= $faca378e734a26b8$var$UNITS.indexOf(minUnit); i--){
        const unit = $faca378e734a26b8$var$UNITS[i];
        if ($faca378e734a26b8$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $faca378e734a26b8$var$UNITS[minUnit ? $faca378e734a26b8$var$UNITS.indexOf(minUnit) : 0];
}
function $faca378e734a26b8$var$determineMajorUnit(unit) {
    for(let i = $faca378e734a26b8$var$UNITS.indexOf(unit) + 1, ilen = $faca378e734a26b8$var$UNITS.length; i < ilen; ++i){
        if ($faca378e734a26b8$var$INTERVALS[$faca378e734a26b8$var$UNITS[i]].common) return $faca378e734a26b8$var$UNITS[i];
    }
}
function $faca378e734a26b8$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $70763e7ecc9cc4d3$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $faca378e734a26b8$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $faca378e734a26b8$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $faca378e734a26b8$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $faca378e734a26b8$export$a894c72689ff3ec extends $faca378e734a26b8$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $faca378e734a26b8$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $70763e7ecc9cc4d3$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $faca378e734a26b8$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $70763e7ecc9cc4d3$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $70763e7ecc9cc4d3$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $faca378e734a26b8$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $faca378e734a26b8$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $faca378e734a26b8$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $faca378e734a26b8$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $70763e7ecc9cc4d3$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $faca378e734a26b8$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $70763e7ecc9cc4d3$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $70763e7ecc9cc4d3$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$faca378e734a26b8$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $faca378e734a26b8$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($faca378e734a26b8$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $70763e7ecc9cc4d3$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $70763e7ecc9cc4d3$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $faca378e734a26b8$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($faca378e734a26b8$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $70763e7ecc9cc4d3$export$71511d61b312f219)(values.sort($faca378e734a26b8$var$sorter));
    }
}
function $faca378e734a26b8$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $70763e7ecc9cc4d3$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $70763e7ecc9cc4d3$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $faca378e734a26b8$export$85df64a8eb6dc986 extends $faca378e734a26b8$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $faca378e734a26b8$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $faca378e734a26b8$var$interpolate(table, this.min);
        this._tableRange = $faca378e734a26b8$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($faca378e734a26b8$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $faca378e734a26b8$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $faca378e734a26b8$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $faca378e734a26b8$export$29e663ba4d09fe7,
    LinearScale: $faca378e734a26b8$export$e7f4e5e8656f0b93,
    LogarithmicScale: $faca378e734a26b8$export$85295eaf7cb3ac3e,
    RadialLinearScale: $faca378e734a26b8$export$cfafc36d95386d38,
    TimeScale: $faca378e734a26b8$export$a894c72689ff3ec,
    TimeSeriesScale: $faca378e734a26b8$export$85df64a8eb6dc986
});
const $faca378e734a26b8$export$e8959e79e3af550f = [
    $faca378e734a26b8$export$a6506504f799c5d5,
    $faca378e734a26b8$export$7a5d735b2ab6389d,
    $faca378e734a26b8$export$8b3ca321c77fdea6,
    $faca378e734a26b8$export$bcac1c16f1530ec2
];


(0, $faca378e734a26b8$export$acaa6426d77a227e).register(...(0, $faca378e734a26b8$export$e8959e79e3af550f));
var $2a0b6a607b40d664$export$2e2bcd8739ae039 = (0, $faca378e734a26b8$export$acaa6426d77a227e);


/**
 * @author Ahmed Serag
 * @date 2021-07-01
 * @description declaration of months names.
 * @filename months.ts
 */ const $1c57294348bd2fde$export$74a3bb4d7a193c13 = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $1c57294348bd2fde$export$60fa4e0dc8092495 = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $1c57294348bd2fde$export$1153db180e4a0aef = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $1c57294348bd2fde$export$6c6cc5893821293 = [
    "12:00 am",
    "1:00 am",
    "2:00 am",
    "3:00 am",
    "4:00 am",
    "5:00 am",
    "6:00 am",
    "7:00 am",
    "8:00 am",
    "9:00 am",
    "10:00 am",
    "11:00 am",
    "12:00 pm",
    "1:00 pm",
    "2:00 pm",
    "3:00 pm",
    "4:00 pm",
    "5:00 pm",
    "6:00 pm",
    "7:00 pm",
    "8:00 pm",
    "9:00 pm",
    "10:00 pm",
    "11:00 pm"
];
const $1c57294348bd2fde$export$ffc5fba5522ddca0 = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31"
];
const $1c57294348bd2fde$export$488b74618fe1cf39 = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];





function $54c7c3206a2399da$export$95d6ba1825bcad81(canvas, labels, data, yAxisLabel, id, maintainAspectRatio) {
    const ctx = canvas?.getContext("2d");
    const datasets = data.map((stream)=>{
        const gradient = ctx?.createLinearGradient(0, 0, 0, 350);
        gradient.addColorStop(0, stream.borderColor || (0, $48f673e197675daa$export$e656feb5cc3debfe)());
        gradient.addColorStop(1, "rgba(255,205,205,0.09)");
        console.log(maintainAspectRatio);
        return {
            tension: 0.5,
            label: stream.label,
            data: stream.values,
            borderColor: stream.borderColor || (0, $48f673e197675daa$export$e656feb5cc3debfe)(),
            backgroundColor: gradient || (0, $48f673e197675daa$export$e656feb5cc3debfe)(),
            fill: true,
            hoverBackgroundColor: stream.backgroundColor || (0, $48f673e197675daa$export$e656feb5cc3debfe)(),
            title: stream.title
        };
    });
    return new (0, $2a0b6a607b40d664$export$2e2bcd8739ae039)(ctx, {
        type: "line",
        options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 1500,
                onComplete () {
                    const exportGraph = document.getElementById(id);
                    if (exportGraph) {
                        exportGraph.setAttribute("href", this.toBase64Image());
                        exportGraph.download = `${datasets[0].title} ${datasets[0].label}`;
                    }
                }
            },
            interaction: {
                intersect: false
            },
            scales: {
                y: {
                    display: true,
                    title: {
                        display: true,
                        text: yAxisLabel,
                        padding: {
                            top: 30,
                            left: 0,
                            right: 0,
                            bottom: 0
                        }
                    }
                }
            },
            plugins: {
                legend: {
                    display: true,
                    position: "top",
                    labels: {
                        boxWidth: 10,
                        boxHeight: 10,
                        color: "#152C5B",
                        font: {
                            size: 14,
                            family: "Nunito Sans",
                            weight: "600"
                        }
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            return `${context.dataset.title}: ${context.dataset.data[context.dataIndex]}`;
                        }
                    }
                }
            }
        },
        data: {
            labels: labels,
            datasets: datasets
        }
    });
}
function $54c7c3206a2399da$export$1ca62378749a779d(chart, data, label) {
    chart.data.datasets.push({
        tension: 0.5,
        label: label,
        data: data,
        borderColor: (0, $48f673e197675daa$export$e656feb5cc3debfe)()
    });
}
function $54c7c3206a2399da$export$99199eb0d2d4ab39(canvas, labels, data, id) {
    const ctx = canvas?.getContext("2d");
    const datasets = data.map((stream)=>{
        const color = (0, $48f673e197675daa$export$e656feb5cc3debfe)();
        return {
            tension: 0.5,
            label: stream.label,
            data: stream.values,
            borderColor: color,
            backgroundColor: stream.backgroundColor || color,
            borderRadius: 50,
            barThickness: 6,
            title: stream.title
        };
    });
    return new (0, $2a0b6a607b40d664$export$2e2bcd8739ae039)(ctx, {
        type: "bar",
        options: {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                intersect: false
            },
            animation: {
                duration: 1500,
                onComplete () {
                    const exportGraph = document.getElementById(id);
                    if (exportGraph) {
                        exportGraph.setAttribute("href", this.toBase64Image());
                        exportGraph.download = datasets[0].title;
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        callback (value) {
                            if (this.getLabelForValue(value).length > 30) return `${this.getLabelForValue(value).substr(0, 20)}...`;
                            return this.getLabelForValue(value);
                        }
                    }
                }
            },
            plugins: {
                legend: {
                    display: true,
                    position: "right",
                    maxWidth: 200,
                    labels: {
                        boxWidth: 6,
                        color: "#152C5B",
                        usePointStyle: true,
                        font: {
                            size: 14,
                            family: "Nunito Sans",
                            weight: "600"
                        }
                    }
                }
            }
        },
        data: {
            labels: labels,
            datasets: datasets
        }
    });
}
function $54c7c3206a2399da$export$2e2f40d1b5b08307(period) {
    let range;
    const rangeDays = (0, $2efa7f87d37460af$export$4a02e9c37dab4871)(new Date(period.from), new Date(period.to));
    switch(period.type){
        case "year":
            range = (0, $1c57294348bd2fde$export$74a3bb4d7a193c13);
            break;
        case "month":
            range = (0, $1c57294348bd2fde$export$ffc5fba5522ddca0);
            break;
        case "week":
            range = (0, $1c57294348bd2fde$export$60fa4e0dc8092495);
            break;
        case "day":
            range = (0, $1c57294348bd2fde$export$6c6cc5893821293);
            break;
        default:
            range = [];
            for(let i = 0; i <= Math.abs(rangeDays); i += 1)range.push((0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $c5c67e18df9fd9dd$export$dd412b56f1e4d8aa)(new Date(period.from), i), "dd/MM/yy"));
            break;
    }
    return range;
}
function $54c7c3206a2399da$export$1e4cf73d036ae2bd(period, data, operation = "sum") {
    let rangeData = [];
    switch(period.type){
        case "year":
            // eslint-disable-next-line no-case-declarations
            let day = 0;
            for(let i = 0; i < 12; i += 1){
                let sum = 0;
                if (day >= data?.length) break;
                for(let j = 0; j < (0, $1c57294348bd2fde$export$488b74618fe1cf39)[i] && day < data?.length; j += 1)// for percentages it is returned as string from the backend
                sum += parseInt(data[day++].toString(), 10);
                if (operation === "avg") rangeData.push(sum / (0, $1c57294348bd2fde$export$488b74618fe1cf39)[i]);
                else rangeData.push(sum);
            }
            break;
        case "month":
            rangeData = data;
            break;
        case "week":
            rangeData = data;
            break;
        default:
            rangeData = data;
            break;
    }
    return rangeData;
}
function $54c7c3206a2399da$export$2be6799d300366bf(sections) {
    const totalCounts = sections.reduce((prev, cur)=>{
        return prev + Number(cur.count);
    }, 0);
    const OthersThreshold = 0.005;
    const newSections = [];
    const others = {
        count: `0`,
        name: "Other"
    };
    for(const i in sections)if (Number(sections[i].count) < totalCounts * OthersThreshold) others.count = `${Number(sections[i].count) + Number(others.count)}`;
    else newSections.push(sections[i]);
    if (Number(others.count) > 0) newSections.push(others);
    return newSections;
}
function $54c7c3206a2399da$export$b7ab47474c09f557(canvas, sections, title, id, legendPosition = "right", cutout = "75%", radius = "85%", blackThemed = false) {
    const ctx = canvas?.getContext("2d");
    const updatedSections = $54c7c3206a2399da$export$2be6799d300366bf(sections);
    const { labels: labels, data: data, backgroundColor: backgroundColor } = updatedSections.reduce((prev, cur)=>{
        const usedColors = prev.backgroundColor;
        return {
            labels: [
                ...prev.labels,
                cur.name
            ],
            data: [
                ...prev.data,
                cur.count
            ],
            backgroundColor: [
                ...prev.backgroundColor,
                (0, $48f673e197675daa$export$e656feb5cc3debfe)(usedColors)
            ]
        };
    }, {
        labels: [],
        data: [],
        backgroundColor: []
    });
    return new (0, $2a0b6a607b40d664$export$2e2bcd8739ae039)(ctx, {
        type: "doughnut",
        data: {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: backgroundColor,
                    borderRadius: 2,
                    borderWidth: 0
                }
            ]
        },
        options: {
            cutout: cutout,
            radius: radius,
            layout: {
                padding: 0
            },
            animation: {
                duration: 1500,
                onComplete () {
                    const exportGraph = document.getElementById(id);
                    if (exportGraph) {
                        exportGraph.setAttribute("href", this.toBase64Image());
                        exportGraph.download = title;
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                    position: legendPosition,
                    align: "start",
                    labels: {
                        boxWidth: 10,
                        boxHeight: 42,
                        padding: 15,
                        color: blackThemed ? "#fff" : "#000",
                        font: {
                            size: 14,
                            family: "Nunito Sans",
                            weight: "600"
                        }
                    }
                }
            }
        }
    });
}
function $54c7c3206a2399da$export$3a0f8eb7361883bd(data) {
    const maxNumber = Math.max(...data);
    const minNumber = Math.min(...data);
    const updatedData = [];
    for (const i of data)updatedData.push((i - minNumber) / (maxNumber - minNumber) * 100);
    return updatedData;
}
function $54c7c3206a2399da$export$713f87d1c6bdc4f8(data) {
    return data?.map((category)=>{
        return {
            name: category.name || category.brand_name || (0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)("common:unnamed"),
            count: category.sales_value
        };
    }) || [];
}



var $gagb8 = parcelRequire("gagb8");


class $03b0ed136e422f3b$var$DoughnutCard extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString()
        };
        this.ChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
    }
    componentDidMount() {
        if (this.props.items) this.setState({
            chart: (0, $54c7c3206a2399da$export$b7ab47474c09f557)(this.ChartRef.current, this.props.items, this.props.title, this.state.id, this.props.legendPosition, this.props.cutout, this.props.radius, this.props.blackThemed)
        });
    }
    componentDidUpdate(prevProps) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gagb8)))(prevProps?.items, this.props.items) || !this.props.items) return null;
        if (this.state.chart) this.state.chart.destroy();
        this.setState({
            chart: (0, $54c7c3206a2399da$export$b7ab47474c09f557)(this.ChartRef.current, this.props.items, this.props.title, this.state.id, this.props.legendPosition, this.props.cutout, this.props.radius, this.props.blackThemed)
        });
        return null;
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card transparent-card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                        className: "card--title",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: `card-graph--title ${this.props.blackThemed && "font-white"}`,
                            children: [
                                this.props.title,
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: `duration ${this.props.blackThemed && "font-white"}`,
                                    children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.props.currentPeriod?.type, this.props.currentPeriod?.from, this.props.currentPeriod?.to)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "doughnut-card__container",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("canvas", {
                                id: this.state.id,
                                ref: this.ChartRef,
                                className: "orders-overview__doughnut-canvas"
                            }),
                            this.props.totalOrders && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "doughnut-card__inner-text",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "font-bold",
                                        children: (0, $48f673e197675daa$export$4640587ffa669919)(this.props.totalOrders)
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        children: t("orders:totalOrders")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
var $03b0ed136e422f3b$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("common")($03b0ed136e422f3b$var$DoughnutCard);


/**
 * @author Youssef Tarek
 * @date 2022-03-05
 * @description show tables with headers in the app
 * @filename table-view.tsx
 */ 

var $igtsr = parcelRequire("igtsr");




parcelRequire("igtsr");
const $c30324781d53e2c6$var$SvgDownArrow = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 330 330",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            d: "M325.607 79.393c-5.857-5.857-15.355-5.858-21.213.001l-139.39 139.393L25.607 79.393c-5.857-5.857-15.355-5.858-21.213.001-5.858 5.858-5.858 15.355 0 21.213l150.004 150a15 15 0 0 0 21.212-.001l149.996-150c5.859-5.857 5.859-15.355.001-21.213"
        })
    });
var $c30324781d53e2c6$export$2e2bcd8739ae039 = $c30324781d53e2c6$var$SvgDownArrow;





class $1561231f0d47a06c$var$TableView extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    getTableHeaders() {
        let headers = [];
        switch(this.props.type){
            case "products-analytics":
            case "promotions-recommendation":
            case "bundle-recommendation":
                headers = [
                    "product",
                    "unitsSold",
                    "totalSalesValue"
                ];
                if (this.props.type === "bundle-recommendation") headers.push("bundleWith");
                else if (this.props.type === "products-analytics") headers.push("currentStock");
                break;
            case "abandoned-carts":
                headers = [
                    "product",
                    "abandonedCarts"
                ];
                break;
            case "promocodes":
            case "allPromoCodes":
                headers = [
                    "name",
                    "launchDate",
                    "expiryDate",
                    "numberOfTimesUsed"
                ];
                if (this.props.type === "allPromoCodes") headers.push("totalDiscount", "totalRevenue");
                break;
            case "pages-reports":
                headers = [
                    "page",
                    "pageLink",
                    "averageEngagement",
                    "totalPageViews"
                ];
                break;
            case "session-list":
                headers = [
                    "source/meduium",
                    "landingPage",
                    "averageEngagement",
                    "totalPageViews"
                ];
                break;
            case "categories-sales-list":
            case "brands-items-sales-list":
            case "categories-children-sales-list":
            case "brands-sales-list":
            case "byCountry":
            case "byCity":
            case "byArea":
                headers = [
                    "totalSalesValue",
                    "unitsSold"
                ];
                if (this.props.type === "brands-sales-list") headers.unshift("brand");
                else if (this.props.type === "categories-sales-list") headers.unshift("category");
                else if (this.props.type === "categories-children-sales-list") {
                    headers.unshift("subCategory");
                    headers.push("products");
                } else if (this.props.type === "brands-items-sales-list") {
                    headers.unshift("product");
                    headers.push("stock");
                } else if (this.props.type === "byCountry") headers.unshift("country");
                else if (this.props.type === "byCity") headers.unshift("city");
                else if (this.props.type === "byArea") headers.unshift("area");
                break;
            case "byPaymentMethod":
            case "byOrderSource":
            case "byFilterSegments":
                headers = [
                    "cancellationPercentage"
                ];
                if (this.props.type === "byPaymentMethod") headers.unshift("paymentMethod");
                else if (this.props.type === "byOrderSource") headers.unshift("orderSource");
                else if (this.props.type === "byFilterSegments") headers.unshift("filterSegment");
                if (this.props.expanded) headers.push("numberOfOrders");
                break;
            case "top-products-cancelled-orders":
            case "top-categories-cancelled-orders":
            case "top-brands-cancelled-orders":
                headers = [
                    "nrOfCancelledOrders"
                ];
                if (this.props.type === "top-products-cancelled-orders") headers.unshift("product");
                else if (this.props.type === "top-categories-cancelled-orders") headers.unshift("category");
                else if (this.props.type === "top-brands-cancelled-orders") headers.unshift("brand");
                break;
            default:
                headers = [];
        }
        return headers;
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            role: "table",
            className: `table ${this.props.loading ? "table--loading" : ""}`,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    role: "row",
                    className: `table-headers ${this.props.withNavigation ? "with-navigation" : ""}`,
                    children: this.getTableHeaders().map((header, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            role: "columnheader",
                            className: "table-head",
                            children: t(header)
                        }, index))
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    role: "rowgroup",
                    className: "table-body",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ul", {
                        children: [
                            (this.props.type === "abandoned-carts" || this.props.type === "products-analytics" || this.props.type === "bundle-recommendation" || this.props.type === "promotions-recommendation") && this.props.products.map((item)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "cell",
                                            className: "item-image",
                                            children: [
                                                item.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: item.image_url,
                                                    alt: item.name,
                                                    onError: (e)=>{
                                                        (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                                    }
                                                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                                    alt: item.name
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    role: "cell",
                                                    className: "item-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "item-name",
                                                            children: item.name || t("unnamed")
                                                        }),
                                                        item.sku && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "item-sku",
                                                            children: `sku: ${item.sku}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "tooltip",
                                                            children: item.name || t("unnamed")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item-data",
                                            children: [
                                                (this.props.type === "products-analytics" || this.props.type === "bundle-recommendation" || this.props.type === "promotions-recommendation") && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            role: "cell",
                                                            className: "item-sold",
                                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.number_sold)} ${t("sold")}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            role: "cell",
                                                            className: "item-sales-value",
                                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.sales_value)} ${this.context.settings.currency}`
                                                        })
                                                    ]
                                                }),
                                                this.props.type === "products-analytics" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        role: "cell",
                                                        className: "item-current-stock",
                                                        children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.stock)} ${t("inStock")}`
                                                    })
                                                }),
                                                this.props.type === "abandoned-carts" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        role: "cell",
                                                        className: "abandoned-carts-number",
                                                        children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.frequency)}`
                                                    })
                                                }),
                                                this.props.type === "bundle-recommendation" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    role: "cell",
                                                    className: "item-more-details item-bundle",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                            type: "submit",
                                                            onClick: ()=>this.props.updateProductSku(item.bundle_product_sku),
                                                            children: item.bundle_product_name
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "tooltip",
                                                            children: item.bundle_product_name
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-more-details",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                type: "submit",
                                                onClick: ()=>this.props.updateProductSku(item.sku),
                                                children: [
                                                    t("viewProductDetails"),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                        className: "right-arrow"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, item.name);
                            }),
                            this.props.type === "promocodes" && this.props.promocodes.map((promocode)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "cell",
                                            className: "promocode-name",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                    children: promocode.coupon_code
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "tooltip",
                                                    children: promocode.coupon_code
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `active-status ${promocode.is_active || promocode.is_active === null ? "active" : "inactive"}`,
                                                    children: promocode.is_active || promocode.is_active === null ? t("active") : t("inactive")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "launch-date",
                                            children: promocode.from_date ? new Date(promocode.from_date).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric"
                                            }) : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "expiry-date",
                                            children: promocode.to_date ? new Date(promocode.to_date).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric"
                                            }) : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "number-used",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(promocode.number_used)} ${t("times")}`
                                        })
                                    ]
                                }, promocode.coupon_code);
                            }),
                            this.props.type === "allPromoCodes" && this.props.promocodes.map((promocode)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "cell",
                                            className: "promocode-name",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                    children: promocode.coupon_code
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "tooltip",
                                                    children: promocode.coupon_code
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "launch-date",
                                            children: promocode.from_date ? new Date(promocode.from_date).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric"
                                            }) : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "expiry-date",
                                            children: promocode.to_date ? new Date(promocode.to_date).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric"
                                            }) : "-"
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "number-used",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(promocode.number_used)} ${t("times")}`
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "number-used",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(promocode.discount)} ${this.context.settings.currency}`
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "number-used",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(promocode.sales_value)} ${this.context.settings.currency}`
                                        })
                                    ]
                                }, promocode.coupon_code);
                            }),
                            this.props.type === "pages-reports" && this.props.pagesReports.map((pagesReport, index)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                children: pagesReport.pageName
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item item-link item-name",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                href: pagesReport.pagePath,
                                                children: pagesReport.pagePath
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                children: pagesReport.averageEngagementTime
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                role: "cell",
                                                className: "item-sold",
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(pagesReport.pageViews)} ${t("views")}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-more-details",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                type: "submit",
                                                onClick: ()=>this.props.updatePageTitle(pagesReport.pageName),
                                                children: [
                                                    t("viewPage"),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                        className: "right-arrow"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, index);
                            }),
                            this.props.type === "session-list" && this.props.sessionSourceMediumList.map((session, index)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                children: session.sessionSourceMedium
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item item-name item-link",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                href: session.landingPage,
                                                children: session.landingPage
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                children: session.averageEngagementTime
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                role: "cell",
                                                className: "item-sold",
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(session.pageViews)} ${t("views")}`
                                            })
                                        })
                                    ]
                                }, index);
                            }),
                            (this.props.type === "categories-sales-list" || this.props.type === "brands-items-sales-list" || this.props.type === "categories-children-sales-list" || this.props.type === "brands-sales-list") && this.props.products.map((item)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: `table-row ${this.props.withNavigation ? "with-navigation" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "cell",
                                            className: "item-image",
                                            children: [
                                                item.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: item.image_url,
                                                    alt: item.name || t("unnamed"),
                                                    onError: (e)=>{
                                                        (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                                    }
                                                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                                    alt: item.name || t("unnamed")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    role: "cell",
                                                    className: "item-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "item-name",
                                                            children: item.name || t("unnamed")
                                                        }),
                                                        item.sku && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "item-sku",
                                                            children: `sku: ${item.sku}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "tooltip",
                                                            children: item.name || t("unnamed")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-sales-value",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.sales_value)} ${this.context.settings.currency}`
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-sold",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.number_sold)} ${t("sold")}`
                                        }),
                                        this.props.type === "categories-children-sales-list" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-sold",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.unique_products_sold)} ${t("items", {
                                                ns: "stock"
                                            })}`
                                        }),
                                        this.props.type === "brands-items-sales-list" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-sold",
                                            children: item.stock ? `${(0, $48f673e197675daa$export$4640587ffa669919)(item.stock)} ${t("units")}` : t("outOfStock", {
                                                ns: "stock"
                                            })
                                        }),
                                        this.props.withNavigation && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-more-details",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "submit",
                                                onClick: ()=>{
                                                    return this.props.updateProductSku(item.name);
                                                },
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                    className: "right-arrow"
                                                })
                                            })
                                        })
                                    ]
                                }, item.name || t("unnamed"));
                            }),
                            (this.props.type === "byCountry" || this.props.type === "byCity" || this.props.type === "byArea") && this.props.products?.map((item, index)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: this.props.type === "byCountry" ? item.country : this.props.type === "byCity" ? item.city : item.area
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item-sales-value",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.sales_value)} ${this.context.settings.currency}`
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item-sold",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.count)} ${t("sold")}`
                                        })
                                    ]
                                }, index);
                            }),
                            [
                                "byPaymentMethod",
                                "byOrderSource",
                                "byFilterSegments"
                            ].includes(this.props.type) && this.props.products?.map((item, index)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "item",
                                            children: this.props.type === "byPaymentMethod" ? item.payment_method : this.props.type === "byOrderSource" ? item.order_source : item.title
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "cancellation-percentage",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: `${item.cancelation_percentage || "0"} %`
                                            })
                                        }),
                                        this.props.expanded && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "number-of-orders",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(item.canceled_orders_count) || "0"}`
                                            })
                                        })
                                    ]
                                }, index);
                            }),
                            [
                                "top-products-cancelled-orders",
                                "top-brands-cancelled-orders",
                                "top-categories-cancelled-orders"
                            ].includes(this.props.type) && this.props.products?.map((item, index)=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "table-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "cell",
                                            className: "item-image",
                                            children: [
                                                item.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: item.image_url,
                                                    alt: item.name || t("unnamed"),
                                                    onError: (e)=>{
                                                        (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                                    }
                                                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                                    alt: item.name || t("unnamed")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    role: "cell",
                                                    className: "item-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "item-name",
                                                            children: item.name || t("unnamed")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "tooltip",
                                                            children: item.name || t("unnamed")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "cell",
                                            className: "cancellation-percentage",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: `${item.canceled_orders_count}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            role: "cell",
                                            className: "item-more-details",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "submit",
                                                onClick: ()=>{
                                                    if (this.props.type === "top-products-cancelled-orders") return this.props.updateProductSku(item.sku);
                                                    return this.props.updateProductSku(item.name);
                                                },
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                    className: "right-arrow"
                                                })
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    })
                }),
                this.props.loading && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
$1561231f0d47a06c$var$TableView.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $1561231f0d47a06c$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "common",
    "product",
    "stock",
    "orders"
])($1561231f0d47a06c$var$TableView);


/**
 * @author Raghda Wessam
 * @date 2020-08-10
 * @description implementation of loader component
 * to be used while loading.
 * @filename loader.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

class $cd4c5170d0017b62$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "loader-wrapper",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $69daf4809d4ad4d2$export$83d2259ec538613b), {
                color: "var(--black)",
                height: 100,
                width: 100,
                visible: true
            })
        });
    }
}


/**
 * @author Ahmed Serag
 * @date 2021-07-03
 * @description header component
 * @filename header.tsx
 */ 


function $510cadbed0d498cf$export$444d742fd5a45a57(options) {
    return (0, $57dbb05d87d784b1$export$63fa379ae8a9ba2)(Date.now(), options);
}
var // Fallback for modularized imports:
$510cadbed0d498cf$export$2e2bcd8739ae039 = $510cadbed0d498cf$export$444d742fd5a45a57;



var $igtsr = parcelRequire("igtsr");
/**
 * @author Ahmed Serag
 * @date 2021-07-01
 * @description Implementation of Orders related utilities.
 * @filename orders.ts
 */ /**
 * @author Ahmed Serag
 * @date 2020-07-20
 * @description implementation of Order related API calls.
 * @filename order.ts
 */ /**
 * @author Ahmed Serag
 * @date 2021-07-01
 * @description declaration of overview interface.
 * @filename overview.ts
 */ var $5142459688621f32$export$fdccc7ccdeecb4a2 = /*#__PURE__*/ function(SortByValueMinimal) {
    SortByValueMinimal["SalesValue"] = "sales_value";
    SortByValueMinimal["NumberSold"] = "number_sold";
    return SortByValueMinimal;
}({});
var $5142459688621f32$export$374f3ebff8a4cc33 = /*#__PURE__*/ function(SortByValue) {
    SortByValue["Name"] = "name";
    SortByValue["SalesValue"] = "sales_value";
    SortByValue["NumberSold"] = "number_sold";
    SortByValue["Stock"] = "stock";
    return SortByValue;
}({});
var $5142459688621f32$export$966c0722699349a0 = /*#__PURE__*/ function(SortByDirection) {
    SortByDirection["Asc"] = "asc";
    SortByDirection["Desc"] = "desc";
    return SortByDirection;
}({});





class $c9f9898d791b0c4a$export$d6101cb40935bdea {
    static overview({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overview.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overview.method
        });
    }
    static ordersDetails({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).orders.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).orders.method
        });
    }
    static paymentMethods({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).payments.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).payments.method
        });
    }
    static numberOfOrdersPerDay({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).ordersPerDay.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).ordersPerDay.method
        });
    }
    static listProjects() {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).projects.path}`);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).projects.method
        });
    }
    static ordersHourlyBreakdown({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).orderHourlyBreakdown.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).orderHourlyBreakdown.method
        });
    }
    static ordersRevenueBreakdown({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).ordersRevenueBreakdown.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).ordersRevenueBreakdown.method
        });
    }
    static customersPerCity({ project: project, from: from, to: to, sort: sort = "sales_value", direction: direction = (0, $5142459688621f32$export$966c0722699349a0).Desc, currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {}, exported: exported = 0 }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersCity.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sort", sort);
        url.searchParams.append("direction", direction);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        url.searchParams.append("export", exported.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersCity.method
        });
    }
    static customersPerCountry({ project: project, from: from, to: to, sort: sort = "sales_value", direction: direction = (0, $5142459688621f32$export$966c0722699349a0).Desc, currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {}, exported: exported = 0 }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersCountry.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sort", sort);
        url.searchParams.append("direction", direction);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        url.searchParams.append("export", exported.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersCountry.method
        });
    }
    static customersPerArea({ project: project, from: from, to: to, sort: sort = "sales_value", direction: direction = (0, $5142459688621f32$export$966c0722699349a0).Desc, currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {}, exported: exported = 0 }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersArea.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sort", sort);
        url.searchParams.append("direction", direction);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        url.searchParams.append("export", exported.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersArea.method
        });
    }
    static cancelledOrdersPercentage({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersPercentage.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersPercentage.method
        });
    }
    static topProductsInCancelledOrders({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getTopProductsInCancelledOrders.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getTopProductsInCancelledOrders.method
        });
    }
    static topCategoriesInCancelledOrders({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getTopCategoriesInCancelledOrders.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getTopCategoriesInCancelledOrders.method
        });
    }
    static topBrandsInCancelledOrders({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getTopBrandsInCancelledOrders.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getTopBrandsInCancelledOrders.method
        });
    }
    static cancelledOrdersByPaymentMethodPercentage({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersByPaymentMethodPercentage.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersByPaymentMethodPercentage.method
        });
    }
    static cancelledOrdersByOrderSourcePercentage({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersByOrderSourcePercentage.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersByOrderSourcePercentage.method
        });
    }
    static cancelledOrdersByFilterSegmentsPercentage({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersByFilterSegmentPercentage.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersByFilterSegmentPercentage.method
        });
    }
    static cancelledOrdersBreakdown({ project: project, from: from, to: to }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersBreakdown.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCancelledOrdersBreakdown.method
        });
    }
}



function $aa865fdbda79f268$export$db367fc7ac51da69(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).overview(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload).then((overview)=>{
            return overview;
        });
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$4afcfbb1824571e4() {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).listProjects().then((projectsPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(projectsPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$3f406deb15ba6ad2(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).numberOfOrdersPerDay(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$2a0eb9aacf34a4b3(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).ordersDetails(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload).then((overview)=>{
            return overview;
        });
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$b93f9c07fd1de645(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).paymentMethods(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$6dd139bbcfda88b9(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).ordersHourlyBreakdown(payload).then((ordersHourlyBreakdownPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(ordersHourlyBreakdownPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$d9722900fc0ca476(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).ordersRevenueBreakdown(payload).then((ordersRevenueBreakdownPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(ordersRevenueBreakdownPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$33caffa594a0a8(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).customersPerCity(payload).then((response)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$d89efeec23b81b37(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).customersPerCountry(payload).then((response)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$e9b6f6d23cffe91c(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).customersPerArea(payload).then((response)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$4327c75daa3aacd9(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).cancelledOrdersPercentage(payload).then((cancelledOrdersPercentagePayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(cancelledOrdersPercentagePayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$4b802536ca4fc7b6(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).topProductsInCancelledOrders(payload).then((topProductsInCancelledOrdersPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(topProductsInCancelledOrdersPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$6d8f73d45bbb92d(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).topCategoriesInCancelledOrders(payload).then((topCategoriesInCancelledOrdersPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(topCategoriesInCancelledOrdersPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$a153853d3f475278(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).topBrandsInCancelledOrders(payload).then((topBrandsInCancelledOrdersPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(topBrandsInCancelledOrdersPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$bfc8e8bfa3488370(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).cancelledOrdersByPaymentMethodPercentage(payload).then((cancelledOrdersByPaymentMethodPercentagePayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(cancelledOrdersByPaymentMethodPercentagePayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$e8efceaeace66db5(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).cancelledOrdersByOrderSourcePercentage(payload).then((cancelledOrdersByOrderSourcePercentagePayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(cancelledOrdersByOrderSourcePercentagePayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$20d01e9b52b96f59(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).cancelledOrdersByFilterSegmentsPercentage(payload).then((cancelledOrdersByFilterSegmentsPercentagePayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(cancelledOrdersByFilterSegmentsPercentagePayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $aa865fdbda79f268$export$8d7aa544ec03a87f(payload) {
    return (0, $c9f9898d791b0c4a$export$d6101cb40935bdea).cancelledOrdersBreakdown(payload).then((cancelledOrdersBreakdownPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(cancelledOrdersBreakdownPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}








parcelRequire("igtsr");
const $e25f94a544086a7c$var$SvgMore = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 13,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M31 1.5H1m30 10H16"
        })
    });
var $e25f94a544086a7c$export$2e2bcd8739ae039 = $e25f94a544086a7c$var$SvgMore;



parcelRequire("igtsr");
const $e6dbf2eeb7b411d9$var$SvgPrivacy = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13pt",
        height: "13pt",
        viewBox: "-25 0 512 512.001",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M448.246 76.563c-74.504 0-172.531-25.141-207.473-71.72-4.648-5.66-13.003-6.476-18.664-1.827a13 13 0 0 0-1.828 1.828C185.336 51.418 87.31 76.563 12.81 76.563 5.734 76.563 0 82.296 0 89.37v166.49C0 396.687 122.293 481.586 227.012 511.5c2.297.668 4.734.668 7.031 0 104.719-29.914 227.012-114.813 227.012-255.64V89.37c0-7.074-5.735-12.808-12.809-12.808zm-12.808 179.296c0 125.02-109.56 201.66-204.91 230.004C135.175 457.52 25.612 380.88 25.612 255.86V101.953C99.641 99.45 187.18 75.586 230.527 31.988 273.88 75.586 361.414 99.45 435.441 101.95v153.91zm0 0"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M179.3 204.633v25.613h-12.808c-7.074 0-12.808 5.734-12.808 12.809v102.453c0 7.074 5.734 12.808 12.808 12.808h128.07c7.075 0 12.81-5.734 12.81-12.808V243.055c0-7.075-5.735-12.809-12.81-12.809h-12.808v-25.613c0-28.293-22.934-51.227-51.227-51.227s-51.226 22.934-51.226 51.227zm102.454 128.07H179.3V255.86h102.453zm-25.613-128.07v25.613h-51.227v-25.613c0-14.145 11.465-25.613 25.613-25.613 14.145 0 25.614 11.468 25.614 25.613m0 0"
            })
        ]
    });
var $e6dbf2eeb7b411d9$export$2e2bcd8739ae039 = $e6dbf2eeb7b411d9$var$SvgPrivacy;



parcelRequire("igtsr");
const $c271c0d3a6e32fd5$var$SvgTerms = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13pt",
        height: "13pt",
        viewBox: "-11 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M166.281 98.637H76.758c-8.285 0-15 6.715-15 15s6.715 15 15 15h89.523c8.281 0 15-6.715 15-15s-6.719-15-15-15m0 60.003H76.758c-8.285 0-15 6.715-15 15s6.715 15 15 15h89.523c8.281 0 15-6.714 15-15s-6.719-15-15-15m0 60.005H76.758c-8.285 0-15 6.714-15 15s6.715 15 15 15h89.523c8.281 0 15-6.715 15-15s-6.719-15-15-15m0 60.003H76.758c-8.285 0-15 6.715-15 15s6.715 15 15 15h89.523c8.281 0 15-6.714 15-15s-6.719-15-15-15m0 61.008H76.758c-8.285 0-15 6.719-15 15 0 8.285 6.715 15 15 15h89.523c8.281 0 15-6.715 15-15 0-8.281-6.719-15-15-15m50.375-211.019h89.524c8.285 0 15-6.715 15-15s-6.715-15-15-15h-89.524c-8.281 0-15 6.715-15 15s6.719 15 15 15m0 60.003h89.524c8.285 0 15-6.714 15-15s-6.715-15-15-15h-89.524c-8.281 0-15 6.715-15 15s6.719 15 15 15m58.117 45.005c0-8.286-6.714-15-15-15h-43.117c-8.281 0-15 6.714-15 15s6.719 15 15 15h43.117c8.286 0 15-6.715 15-15m142.098 112.343c-6.46-5.183-15.898-4.148-21.086 2.313l-38.633 48.164-23.918-17.328c-6.707-4.864-16.09-3.364-20.949 3.343-4.86 6.711-3.36 16.09 3.348 20.95l35.48 25.707a14.96 14.96 0 0 0 8.793 2.855 14.97 14.97 0 0 0 11.707-5.617l47.575-59.3c5.183-6.462 4.148-15.903-2.317-21.087m0 0"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M454.785 299.941c-19.539-19.882-44.644-32.414-71.848-36.105V60.41c0-33.308-27.101-60.41-60.41-60.41H60.414C27.102 0 0 27.102 0 60.41v347.473c0 33.312 27.102 60.414 60.41 60.414h210.817C294.949 496.164 329.059 512 365.96 512c68.691 0 124.574-55.922 124.574-124.66 0-32.906-12.695-63.945-35.75-87.399zM30 407.883V60.41C30 43.645 43.645 30 60.414 30h262.113c16.77 0 30.41 13.645 30.41 30.41v202.95c-62.593 6.535-111.55 59.64-111.55 123.98 0 17.832 3.718 35.074 10.851 50.953H60.414c-16.77 0-30.414-13.64-30.414-30.41M365.96 482c-29.956 0-57.495-13.754-75.562-37.73-12.437-16.512-19.015-36.196-19.015-56.93 0-52.195 42.43-94.66 94.578-94.66q.74.002 1.48.015l.23.004c24.895.442 48.235 10.48 65.72 28.27 17.504 17.808 27.144 41.383 27.144 66.37 0 52.196-42.426 94.661-94.574 94.661zm0 0"
            })
        ]
    });
var $c271c0d3a6e32fd5$export$2e2bcd8739ae039 = $c271c0d3a6e32fd5$var$SvgTerms;



parcelRequire("igtsr");
const $4123d0e4579e95f2$var$SvgSettings = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "m32.57 15.72-3.35-1a11.7 11.7 0 0 0-.95-2.33l1.64-3.07a.61.61 0 0 0-.11-.72l-2.39-2.4a.61.61 0 0 0-.72-.11l-3.05 1.63a11.6 11.6 0 0 0-2.36-1l-1-3.31a.61.61 0 0 0-.59-.41h-3.38a.61.61 0 0 0-.58.43l-1 3.3a11.6 11.6 0 0 0-2.38 1l-3-1.62a.61.61 0 0 0-.72.11L6.2 8.59a.61.61 0 0 0-.11.72l1.62 3a11.6 11.6 0 0 0-1 2.37l-3.31 1a.61.61 0 0 0-.43.58v3.38a.61.61 0 0 0 .43.58l3.33 1a11.6 11.6 0 0 0 1 2.33l-1.64 3.14a.61.61 0 0 0 .11.72l2.39 2.39a.61.61 0 0 0 .72.11l3.09-1.65a11.7 11.7 0 0 0 2.3.94l1 3.37a.61.61 0 0 0 .58.43h3.38a.61.61 0 0 0 .58-.43l1-3.38a11.6 11.6 0 0 0 2.28-.94l3.11 1.66a.61.61 0 0 0 .72-.11l2.39-2.39a.61.61 0 0 0 .11-.72l-1.66-3.1a11.6 11.6 0 0 0 .95-2.29l3.37-1a.61.61 0 0 0 .43-.58v-3.41a.61.61 0 0 0-.37-.59M18 23.5a5.5 5.5 0 1 1 5.5-5.5 5.5 5.5 0 0 1-5.5 5.5",
                className: "settings_svg__clr-i-solid settings_svg__clr-i-solid-path-1"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                fill: "none",
                d: "M0 0h36v36H0z"
            })
        ]
    });
var $4123d0e4579e95f2$export$2e2bcd8739ae039 = $4123d0e4579e95f2$var$SvgSettings;



parcelRequire("igtsr");
const $be17a47d65173ecb$var$SvgContact = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M8.976 1c3.852 0 6.976 3.206 6.976 7.16s-3.124 7.16-6.976 7.16a6.8 6.8 0 0 1-2.881-.637L3.04 15.91l.744-2.968A7.24 7.24 0 0 1 2 8.16C2 4.206 5.123 1 8.976 1M7.271 3.998c.823-.342 1.764-.484 2.595-.088.755.36 1.224 1.085 1.262 1.938.044 1.01-.522 1.908-1.287 2.49a.87.87 0 0 0-.266.403c-.053.159.003.32 0 .485a.76.76 0 0 1-.763.753.76.76 0 0 1-.734-.784c.007-.366-.045-.584.077-.95.165-.497.402-.795.79-1.138.36-.274.707-.706.685-1.191a.68.68 0 0 0-.393-.609c-.438-.208-.969-.062-1.393.117-.89.376-1.47-1.054-.573-1.426m1.465 6.76c.51 0 .921.424.921.946a.933.933 0 0 1-.92.946.933.933 0 0 1-.922-.946c0-.522.412-.945.921-.945Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M9.685 16.236a5.61 5.61 0 0 0 5.924.75l2.506 1.009-.61-2.437a5.94 5.94 0 0 0 1.465-3.925c0-1.867-.848-3.53-2.17-4.606q.076.555.077 1.133c0 4.233-3.161 7.708-7.192 8.076"
                })
            ]
        })
    });
var $be17a47d65173ecb$export$2e2bcd8739ae039 = $be17a47d65173ecb$var$SvgContact;



parcelRequire("igtsr");
const $972a7966b6ed69eb$var$SvgLogout = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            d: "m11.965 8.93-2.429 2.428a.605.605 0 0 1-.858 0 .607.607 0 0 1 0-.859l1.392-1.392H4.25a.607.607 0 1 1 0-1.214h5.82L8.678 6.5a.607.607 0 1 1 .858-.859l2.429 2.429a.607.607 0 0 1 0 .858Zm-4.072 6.856H1.82a.61.61 0 0 1-.607-.607V1.82c0-.335.272-.607.607-.607h6.072a.607.607 0 1 0 0-1.214H1.82A1.823 1.823 0 0 0 0 1.821V15.18C0 16.183.817 17 1.821 17h6.072a.607.607 0 1 0 0-1.214"
        })
    });
var $972a7966b6ed69eb$export$2e2bcd8739ae039 = $972a7966b6ed69eb$var$SvgLogout;







/**
 * @author Karim Shalapy
 * @date 2022-10-02
 * @description implementation of the advanced filters dropdown form UI component
 * @filename index.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


var $gagb8 = parcelRequire("gagb8");








const $d6d36930066a98a7$var$customTheme = (theme)=>({
        ...theme,
        colors: {
            ...theme.colors,
            primary: "rgba(69, 194, 255, 1)",
            primary25: "rgba(69, 194, 255, 0.1)"
        }
    });
const $d6d36930066a98a7$var$customStyles = {
    control (provided) {
        const backgroundColor = "hsla(0, 0%, 0%, 0.03)";
        return {
            ...provided,
            borderRadius: 10,
            backgroundColor: backgroundColor
        };
    },
    multiValue (provided) {
        return {
            ...provided,
            padding: "5px 10px",
            borderRadius: "50000px",
            backgroundColor: "hsla(217, 90%, 61%, 0.1)",
            gap: 10
        };
    },
    multiValueRemove (provided) {
        return {
            ...provided,
            borderRadius: "50%",
            backgroundColor: "black",
            color: "white"
        };
    }
};
class $d6d36930066a98a7$var$AdvancedFilters extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            flattenedFilters: {},
            selectedFilters: {},
            id: Date.now().toString()
        };
        this.updateFiltersState = this.updateFiltersState.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.getIsAllSelected = this.getIsAllSelected.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }
    componentDidMount() {
        this.updateFiltersState();
        this.context.addUpdatesListener(this.state.id, this.updateFiltersState);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    getIsAllSelected(key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gagb8)))(this.state.selectedFilters[key], this.state.flattenedFilters[key]);
    }
    updateFiltersState() {
        this.setState({
            flattenedFilters: (0, $eadf35cb023988c9$export$a15b0df135c91f7e)(this.context.availableFilters),
            selectedFilters: (0, $eadf35cb023988c9$export$a15b0df135c91f7e)(this.context.appliedFilters)
        });
    }
    changeHandler(key, value) {
        if (this.state.selectedFilters[key]?.includes(value)) this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: this.state.selectedFilters[key].filter((storedValue)=>storedValue !== value)
            }
        });
        else this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: (this.state.selectedFilters[key] || []).concat(value)
            }
        });
    }
    selectAll(key) {
        if (this.getIsAllSelected(key)) this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: []
            }
        });
        else this.setState({
            selectedFilters: {
                ...this.state.selectedFilters,
                [key]: this.state.flattenedFilters[key]
            }
        });
    }
    submitHandler(e) {
        e.preventDefault();
        this.props.clickHandler("advancedFiltersMenu");
        this.context.updateAppliedFilters((0, $eadf35cb023988c9$export$aab87de08213fc1d)(this.state.selectedFilters));
        this.context.updateAppliedFiltersSegment(null);
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: `dropdown-container ${this.props.disableAdvancedFilters && "disabled"}`,
            onClick: (e)=>{
                this.updateFiltersState();
                this.props.clickHandler("advancedFiltersMenu", e);
            },
            children: [
                t("advancedFilters"),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                    className: "dropdown-icon"
                }),
                this.props.isActive && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "dropdown-menu auto-width",
                    onClick: (e)=>e.stopPropagation(),
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                        className: "advanced-filters",
                        onSubmit: (e)=>this.submitHandler(e),
                        children: [
                            this.context.loadingFilters ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {}) : Object.keys(this.state.flattenedFilters)// MOVE THE `SHIPPING_LOCATIONS_KEY` TO THE LAST INDEX
                            .sort((a, b)=>{
                                return a === (0, $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8) ? 1 : b === (0, $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8) ? -1 : 0;
                            }).map((key)=>{
                                return key !== (0, $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8) ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("fieldset", {
                                    className: "advanced-filters__fieldset",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("legend", {
                                            children: key === "state" ? t("orderState") : t(key)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "advanced-filters__field",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                    htmlFor: `select-all-${key}`,
                                                    children: "All"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    name: `all-${key}`,
                                                    id: `select-all-${key}`,
                                                    checked: this.getIsAllSelected(key),
                                                    onChange: ()=>this.selectAll(key)
                                                })
                                            ]
                                        }),
                                        this.state.flattenedFilters[key].map((filter)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "advanced-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: `${key}-${filter}`,
                                                        children: filter
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        name: key,
                                                        id: `${key}-${filter}`,
                                                        value: filter,
                                                        checked: !!this.state.selectedFilters[key]?.includes(filter),
                                                        onChange: ()=>this.changeHandler(key, filter)
                                                    })
                                                ]
                                            }, `${key}-${filter}`))
                                    ]
                                }, key) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("fieldset", {
                                    className: "advanced-filters__fieldset advanced-filters__location-field",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("legend", {
                                            children: t(key)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13b5ae22f3a5f453$export$2e2bcd8739ae039), {
                                            id: `${key}-input-container`,
                                            inputId: `${key}-input`,
                                            placeholder: t("searchLocationPlaceholder"),
                                            theme: $d6d36930066a98a7$var$customTheme,
                                            styles: $d6d36930066a98a7$var$customStyles,
                                            components: {
                                                DropdownIndicator: $acbaa279ab43541b$export$2e2bcd8739ae039,
                                                MenuList: $6695ba336f042c4a$export$2e2bcd8739ae039
                                            },
                                            options: (0, $eadf35cb023988c9$export$716cad129d2949a9)(this.state.flattenedFilters[key]),
                                            value: (0, $eadf35cb023988c9$export$716cad129d2949a9)(this.state.selectedFilters[key]),
                                            onChange: (val)=>{
                                                const value = Array.isArray(val) ? val : [
                                                    val
                                                ];
                                                this.setState((prev)=>({
                                                        selectedFilters: {
                                                            ...prev.selectedFilters,
                                                            [key]: (0, $eadf35cb023988c9$export$247b78adad87d126)(value)
                                                        }
                                                    }));
                                            },
                                            isMulti: true,
                                            isClearable: true
                                        })
                                    ]
                                }, key);
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "advanced-filters__cta",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        className: "button-underlined  black",
                                        type: "button",
                                        onClick: ()=>this.setState({
                                                selectedFilters: {}
                                            }),
                                        children: t("reset", {
                                            ns: "settings"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        className: "button-primary small black",
                                        type: "submit",
                                        children: t("showResults")
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}
$d6d36930066a98a7$var$AdvancedFilters.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $d6d36930066a98a7$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "filters",
    "settings"
])($d6d36930066a98a7$var$AdvancedFilters);


/**
 * @author Karim Shalapy
 * @date 2022-10-03
 * @description implementation of the applied filters indicator.
 * @filename applied-filters.tsx
 */ 

var $igtsr = parcelRequire("igtsr");





parcelRequire("igtsr");
const $6e34be24cf1b489c$var$SvgClose = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 512,
        height: 512,
        viewBox: "0 0 64 64",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "currentColor",
            d: "M4.59 59.41a2 2 0 0 0 2.83 0L32 34.83l24.59 24.58a2 2 0 0 0 2.83-2.83L34.83 32 59.41 7.41a2 2 0 0 0-2.83-2.83L32 29.17 7.41 4.59a2 2 0 0 0-2.82 2.82L29.17 32 4.59 56.59a2 2 0 0 0 0 2.82"
        })
    });
var $6e34be24cf1b489c$export$2e2bcd8739ae039 = $6e34be24cf1b489c$var$SvgClose;


class $1dbaf3f30495fd63$var$AppliedFilters extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString(),
            appliedFilters: {}
        };
        this.updateFiltersState = this.updateFiltersState.bind(this);
    }
    componentDidMount() {
        this.updateFiltersState();
        this.context.addUpdatesListener(this.state.id, this.updateFiltersState);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.appliedFilters !== this.props.appliedFilters) this.updateFiltersState();
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    updateFiltersState() {
        if (this.context.appliedFiltersSegment) this.setState({
            appliedFilters: (0, $eadf35cb023988c9$export$a15b0df135c91f7e)(this.context.appliedFiltersSegment.filters)
        });
        this.setState({
            appliedFilters: (0, $eadf35cb023988c9$export$a15b0df135c91f7e)(this.context.appliedFilters)
        });
    }
    render() {
        const { t: t } = this.props;
        const keys = Object.keys(this.state.appliedFilters);
        return keys.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "applied-filters",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                    className: "applied-filters__title",
                    children: t("appliedFilters")
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "applied-filters__container",
                    children: [
                        keys.reduce((accum, key)=>{
                            const isLocation = key === (0, $c67dc4ee9a5156ae$export$11ebcefcc7caa2c8);
                            return accum.concat(this.state.appliedFilters[key].map((item)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                    type: "button",
                                    className: "applied-filter",
                                    onClick: ()=>{
                                        this.context.updateAppliedFilters((0, $eadf35cb023988c9$export$aab87de08213fc1d)({
                                            ...this.state.appliedFilters,
                                            [key]: this.state.appliedFilters[key].filter((appliedItem)=>item !== appliedItem)
                                        }));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "applied-filter__label",
                                            children: isLocation ? item.split((0, $c67dc4ee9a5156ae$export$900830e035ecc69))[1] : item
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $6e34be24cf1b489c$export$2e2bcd8739ae039), {
                                            width: 10,
                                            height: 10,
                                            className: "applied-filter__icon"
                                        })
                                    ]
                                }, `${key}-${item}-applied`)));
                        }, []),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                            className: "button-underlined  black",
                            type: "button",
                            onClick: ()=>{
                                this.context.updateAppliedFilters({});
                                this.context.updateAppliedFiltersSegment(null);
                            },
                            children: t("clearAll")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "segment-button",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "plus-icon",
                                    children: "+"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                    className: "button-underlined black",
                                    type: "button",
                                    onClick: ()=>this.context.toggleCreateANewSegment(),
                                    children: this.context.appliedFiltersSegment ? t("editSegment") : t("createANewSegment")
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : null;
    }
}
$1dbaf3f30495fd63$var$AppliedFilters.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $1dbaf3f30495fd63$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "filters"
])($1dbaf3f30495fd63$var$AppliedFilters);


/**
 * @author Youssef Tarek
 * @date 2023-02-14
 * @description dropdown to show filters segment in the header
 * @filename filters-segments-dropdown.tsx
 */ 

var $igtsr = parcelRequire("igtsr");





parcelRequire("igtsr");
const $2742632e86fe22d3$var$SvgDeleteIcon = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "#F05253",
            fillRule: "evenodd",
            d: "M7.813 8.063v10.156c0 .673.545 1.219 1.218 1.219h7.313c.673 0 1.218-.546 1.218-1.22V8.063h-9.75Zm6.5-1.844v-.406A.813.813 0 0 0 13.5 5h-1.625a.813.813 0 0 0-.813.813v.406H7.406A.406.406 0 0 0 7 6.625v.406c0 .225.182.406.406.406h10.563a.406.406 0 0 0 .406-.406v-.406a.406.406 0 0 0-.406-.406z"
        })
    });
var $2742632e86fe22d3$export$2e2bcd8739ae039 = $2742632e86fe22d3$var$SvgDeleteIcon;



parcelRequire("igtsr");
const $89143256da30e053$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#1792ff",
                    d: "M5.527 19.458a.517.517 0 0 0 .655.655l3.936-1.318L17.914 11l.796-.796 1.147-1.147a.966.966 0 0 0 0-1.367l-1.908-1.907a.966.966 0 0 0-1.366 0L15.436 6.93l-.796.796-7.795 7.795z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#fff",
                    strokeWidth: 0.7,
                    d: "m14.5 7.5 4 4m-12 3 4 4"
                })
            ]
        })
    });
var $89143256da30e053$export$2e2bcd8739ae039 = $89143256da30e053$var$SvgEdit;




class $2562181e51ac4f4d$var$FiltersSegmentsDropdown extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString()
        };
    }
    deleteSegment(id) {
        (0, $eadf35cb023988c9$export$538f3bd007ae3ac5)(this.context.project, id).then(()=>{
            this.context.updateFiltersSegments(this.context.availableFiltersSegments.filter((segment)=>segment.id !== id));
            (0, $d41f521f78665649$export$b410431fab84fa58).success(this.props.t("segmentDeletedSuccessfully"));
        }).catch(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(this.props.t("errorDeletingSegment"));
        });
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: `dropdown-container ${this.props.disableAdvancedFilters && "disabled"}`,
            onClick: (e)=>{
                this.props.clickHandler("filtersSegmentsMenu", e);
            },
            children: [
                this.context.appliedFiltersSegment ? this.context.appliedFiltersSegment.title : t("segments"),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                    className: "dropdown-icon"
                }),
                this.props.isActive && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "dropdown-menu width-max-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: this.context.loadingFilters ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "filters-segments",
                                children: this.context.availableFiltersSegments.map((segment)=>{
                                    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "filters-segment",
                                        onClick: ()=>{
                                            this.context.updateAppliedFilters(segment.filters);
                                            this.context.updateAppliedFiltersSegment(segment);
                                            this.props.clickHandler("filtersSegmentsMenu");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "filters-segment__info",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "filters-segment__title",
                                                        children: segment.title
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "filters-segment__details",
                                                        children: (0, $eadf35cb023988c9$export$2f68d84b6eb89430)(segment.filters)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "filters-segment__actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        className: "action-button",
                                                        type: "button",
                                                        onClick: ()=>{
                                                            this.deleteSegment(segment.id);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2742632e86fe22d3$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        className: "action-button",
                                                        type: "button",
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            this.context.toggleCreateANewSegment(segment);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $89143256da30e053$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }, segment.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "segment-button",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "plus-icon",
                                        children: "+"
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        className: "button-underlined black",
                                        type: "button",
                                        onClick: ()=>this.context.toggleCreateANewSegment(),
                                        children: t("createANewSegment")
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}
$2562181e51ac4f4d$var$FiltersSegmentsDropdown.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $2562181e51ac4f4d$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("filters")($2562181e51ac4f4d$var$FiltersSegmentsDropdown);


class $406539e821b77e4d$var$Header extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    static #_ = this.defaultProps = {
        showPeriod: true
    };
    constructor(props){
        super(props);
        this.state = {
            projectsMenu: false,
            currentPeriodMenu: false,
            comparedPeriodMenu: false,
            settingsMenu: false,
            advancedFiltersMenu: false,
            activeMenu: "",
            projects: [],
            customStartDate: new Date(),
            customComparedStartDate: new Date()
        };
        this.onSelectComparedPeriod = this.onSelectComparedPeriod.bind(this);
        this.onSelectPeriod = this.onSelectPeriod.bind(this);
    }
    componentDidMount() {
        (0, $aa865fdbda79f268$export$4afcfbb1824571e4)().then((projects)=>{
            this.setState({
                projects: projects
            });
        });
        // close the menu when clicking outside
        window.addEventListener("click", ()=>this.setActiveMenu(""));
    }
    componentWillUnmount() {
        window.removeEventListener("click", ()=>this.setActiveMenu(""));
    }
    onSelectPeriod(alias, type, from, to) {
        if (from && to) this.context.updateCurrentPeriod({
            alias: alias,
            type: type,
            from: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(from, "yyyy-MM-dd"),
            to: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(to, "yyyy-MM-dd")
        });
        this.setState({
            showCustomDate: from && to ? false : this.state.showCustomDate,
            currentPeriodMenu: from && to ? false : this.state.currentPeriodMenu,
            customStartDate: from,
            customEndDate: to
        });
    }
    onSelectComparedPeriod(alias, type, from, to) {
        if (from && to) this.context.updateComparedPeriod({
            alias: alias,
            type: type,
            from: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(from, "yyyy-MM-dd"),
            to: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(to, "yyyy-MM-dd")
        });
        if (!from && !to) this.context.updateComparedPeriod(null);
        this.setState({
            showComparedCustomDate: from && to ? false : this.state.showComparedCustomDate,
            comparedPeriodMenu: from && to ? false : this.state.comparedPeriodMenu,
            customComparedStartDate: from,
            customComparedEndDate: to
        });
    }
    /**
   * get the initials of the user
   * check if they have a last name and consequently get its initial
   * @returns users Initials
   */ getUserInitials() {
        return `${this.context?.user?.name[0]}${this.context?.user?.name.indexOf(" ") !== -1 ? this.context?.user?.name[this.context?.user?.name.indexOf(" ") + 1] : ""}`;
    }
    /**
   * set active menu for header component
   * menus are: projectsMenu, currentPeriodMenu, comparedPeriodMenu,
   * settingsMenu, and advancedFiltersMenu
   * @param menu menu to be active
   */ setActiveMenu(menu, e) {
        if (e) e.stopPropagation();
        if (menu === this.state.activeMenu) this.setState({
            activeMenu: ""
        });
        else this.setState({
            activeMenu: menu
        });
    }
    /**
   * check if menu is active
   * @param selectedMenu menu to be checked
   */ isActiveMenu(selectedMenu) {
        return this.state.activeMenu === selectedMenu;
    }
    /**
   * check if the current period is active
   * @param period period to be checked
   */ isActivePeriod(period) {
        return this.context.currentPeriod.alias === period;
    }
    render() {
        const { t: t } = this.props;
        const date = new Date();
        const currentYearQuery = date.getFullYear();
        const currentYear = date.toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric"
        });
        const previousYearQuery = currentYearQuery - 1;
        date.setFullYear(date.getFullYear() - 1);
        const previousYear = date.toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric"
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "page-header",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "page-header-container",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "title",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    children: new Date().toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                                        weekday: "long",
                                        day: "numeric",
                                        month: "long",
                                        year: "numeric"
                                    })
                                }),
                                this.props.title
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "page-header--profile",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "dropdown-container--profile",
                                onClick: (e)=>{
                                    this.setActiveMenu("settingsMenu", e);
                                },
                                children: [
                                    this.context?.settings?.logo && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "dropdown-logo__container",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                            src: `${"https://backend.analytics-dashboard.ecommbeta.com/"}${this.context?.settings?.logo}`,
                                            alt: "logo",
                                            className: "dropdown-logo__image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "dropdown-profile__image",
                                        children: this.getUserInitials()
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        className: "dropdown-profile__name",
                                        children: this.context?.user?.name
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $e25f94a544086a7c$export$2e2bcd8739ae039), {
                                        className: "dropdown-icon"
                                    }),
                                    this.isActiveMenu("settingsMenu") && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "dropdown-menu",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "dropdown-item",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                                                    to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).settings.path,
                                                    className: "dropdown-item-link",
                                                    onClick: ()=>{
                                                        this.context.updateSideBarOpened(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4123d0e4579e95f2$export$2e2bcd8739ae039), {
                                                            className: "settings-icon"
                                                        }),
                                                        t("settings")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "dropdown-item",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                                                    to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).support.path,
                                                    className: "dropdown-item-link",
                                                    onClick: ()=>{
                                                        this.context.updateSideBarOpened(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $be17a47d65173ecb$export$2e2bcd8739ae039), {
                                                            className: "support-icon"
                                                        }),
                                                        t("support")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "dropdown-item",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                                                    to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Login.path,
                                                    className: "dropdown-item-link logout",
                                                    onClick: ()=>{
                                                        (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).logout();
                                                        this.context.updateUser(null);
                                                        this.context.updateSideBarOpened(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $972a7966b6ed69eb$export$2e2bcd8739ae039), {}),
                                                        t("logout")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "dropdown-item",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("a", {
                                                    className: "dropdown-item-link logout",
                                                    href: `${"https://backend.analytics-dashboard.ecommbeta.com/"}uploads/privacy-${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language}.html`,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $e6dbf2eeb7b411d9$export$2e2bcd8739ae039), {}),
                                                        t("privacyPolicy")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "dropdown-item",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("a", {
                                                    className: "dropdown-item-link logout",
                                                    href: `${"https://backend.analytics-dashboard.ecommbeta.com/"}uploads/terms-${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language}.html`,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c271c0d3a6e32fd5$export$2e2bcd8739ae039), {}),
                                                        t("termsAndConditions")
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                this.props.showPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "operations",
                            children: [
                                this.state.projects.length > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "dropdown-container",
                                    onClick: (e)=>{
                                        this.setActiveMenu("projectsMenu", e);
                                    },
                                    children: [
                                        this.context.project ?? "Select project",
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                            className: "dropdown-icon"
                                        }),
                                        this.isActiveMenu("projectsMenu") && this.state.projects && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "dropdown-menu",
                                            children: this.state.projects.map((project)=>{
                                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        this.context.setProject(project.code);
                                                    },
                                                    children: project.code
                                                }, project.code);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $d6d36930066a98a7$export$2e2bcd8739ae039), {
                                    clickHandler: (menu, e)=>this.setActiveMenu(menu, e),
                                    isActive: this.isActiveMenu("advancedFiltersMenu"),
                                    disableAdvancedFilters: this.props.disableAdvancedFilters
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2562181e51ac4f4d$export$2e2bcd8739ae039), {
                                    clickHandler: (menu, e)=>this.setActiveMenu(menu, e),
                                    isActive: this.isActiveMenu("filtersSegmentsMenu"),
                                    disableSegments: this.props.disableAdvancedFilters
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: `dropdown-container ${this.props.disableDateFilters && "disabled"}`,
                                    children: [
                                        t(this.context.currentPeriod?.alias),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                            className: "dropdown-icon",
                                            enableBackground: "new 0 0 330 330",
                                            onClick: (e)=>{
                                                this.setActiveMenu("currentPeriodMenu", e);
                                            }
                                        }),
                                        this.isActiveMenu("currentPeriodMenu") && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "dropdown-menu",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("day") ? "active" : ""}`,
                                                    // make selected period today with alias "today"
                                                    onClick: ()=>{
                                                        this.onSelectPeriod("today", "day", (0, $510cadbed0d498cf$export$444d742fd5a45a57)(), (0, $510cadbed0d498cf$export$444d742fd5a45a57)());
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("today")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("week") ? "active" : ""}`,
                                                    /* make selected period this week with alias "thisWeek"
                       the week period is calculated from the start of the week
                       to the current date */ onClick: ()=>{
                                                        this.onSelectPeriod("thisWeek", "week", (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)(new Date()), new Date());
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("thisWeek")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("month") ? "active" : ""}`,
                                                    /* make selected period this month with alias "thisMonth"
                        the month period is calculated from the start of the month
                        to the current date */ onClick: ()=>{
                                                        this.onSelectPeriod("thisMonth", "month", (0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)(new Date()), new Date());
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("thisMonth")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("year") ? "active" : ""}`,
                                                    /* make selected period this year with alias "thisYear"
                        the year period is calculated from the start of the year
                        to the current date */ onClick: ()=>{
                                                        this.onSelectPeriod("thisYear", "year", (0, $c8148e08909dec9f$export$f91e89d3d0406102)(new Date()), new Date());
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("thisYear")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("previousMonth") ? "active" : ""}`,
                                                    /* make selected period previous month with alias "previousMonth"
                        the previous month period is calculated from the start of the previous month
                        to the end of the previous month */ onClick: ()=>{
                                                        const startOfPreviousMonth = (0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            months: 1
                                                        }));
                                                        const endOfPreviousMonth = (0, $0686a4d407c7043b$export$a2258d9c4118825c)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            months: 1
                                                        }));
                                                        this.onSelectPeriod("previousMonth", "previousMonth", startOfPreviousMonth, endOfPreviousMonth);
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: `${t("previousMonth")}
                      (${(0, $377f863a28de0454$export$73d1c15a21f9fae5)(new Date(), 1).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-US" : "ar-EG", {
                                                        month: "long"
                                                    })})`
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("previousYear") ? "active" : ""}`,
                                                    /* make selected period previous year with alias "previousYear"
                        the previous year period is calculated from the start of the previous year
                        to the end of the previous year */ onClick: ()=>{
                                                        const startOfPreviousYear = (0, $c8148e08909dec9f$export$f91e89d3d0406102)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            years: 1
                                                        }));
                                                        const endOfPreviousYear = (0, $938b9f25b96c36ea$export$8b7aa55c66d5569e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            years: 1
                                                        }));
                                                        this.onSelectPeriod("previousYear", "previousYear", startOfPreviousYear, endOfPreviousYear);
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: `${t("previousYear")} (${new Date().getFullYear() - 1})`
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("past7Days") ? "active" : ""}`,
                                                    /* make selected period the past 7 days with alias "past7Days"
                        the past 7 days period is calculated from 7 days before current date
                        till current date */ onClick: ()=>{
                                                        this.onSelectPeriod("past7Days", "past7Days", (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            days: 7
                                                        }), new Date());
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("past7Days")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("past30Days") ? "active" : ""}`,
                                                    /* make selected period the past 30 days with alias "past30Days"
                        the past 30 days period is calculated from 30 days before current date
                        till current date */ onClick: ()=>{
                                                        this.onSelectPeriod("past30Days", "past30Days", (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            days: 30
                                                        }), new Date());
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("past30Days")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("past90Days") ? "active" : ""}`,
                                                    /* make selected period the past 90 days with alias "past90Days"
                        the past 90 days period is calculated from 90 days before current date
                        till current date */ onClick: ()=>{
                                                        this.onSelectPeriod("past90Days", "past90Days", (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            days: 90
                                                        }), new Date());
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("past90Days")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("firstQuarter") ? "active" : ""}`,
                                                    /* make selected period the first quarter with alias "firstQuarter"
                        the first quarter period is the first 3 months of the year */ onClick: ()=>{
                                                        const firstQuarter = new Date(new Date().getFullYear(), 0, 1);
                                                        this.onSelectPeriod("firstQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(firstQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(firstQuarter));
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("firstQuarter")
                                                }),
                                                (0, $8de2b2935de63c65$export$de90a4bb31c25221)(new Date()) >= 2 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("secondQuarter") ? "active" : ""}`,
                                                    /* make selected period the second quarter with alias "secondQuarter"
                        the second quarter period is the second 3 months (April, May, June)
                         of the year */ onClick: ()=>{
                                                        const secondQuarter = new Date(new Date().getFullYear(), 3, 1);
                                                        this.onSelectPeriod("secondQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(secondQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(secondQuarter));
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("secondQuarter")
                                                }),
                                                (0, $8de2b2935de63c65$export$de90a4bb31c25221)(new Date()) >= 3 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("thirdQuarter") ? "active" : ""}`,
                                                    /* make selected period the third quarter with alias "thirdQuarter"
                        the third quarter period is the third 3 months (July, August, September)
                        of the year */ onClick: ()=>{
                                                        const thirdQuarter = new Date(new Date().getFullYear(), 6, 1);
                                                        this.onSelectPeriod("thirdQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(thirdQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(thirdQuarter));
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("thirdQuarter")
                                                }),
                                                (0, $8de2b2935de63c65$export$de90a4bb31c25221)(new Date()) >= 4 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.isActivePeriod("fourthQuarter") ? "active" : ""}`,
                                                    /* make selected period the fourth quarter with alias "fourthQuarter"
                        the fourth quarter period is the fourth 3 months
                        (October, November, December) of the year */ onClick: ()=>{
                                                        const fourthQuarter = new Date(new Date().getFullYear(), 9, 1);
                                                        this.onSelectPeriod("fourthQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(fourthQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(fourthQuarter));
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("fourthQuarter")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: `item ${this.isActivePeriod("custom") ? "active" : ""}`,
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        this.setState({
                                                            showCustomDate: true
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "custom",
                                                            children: [
                                                                t("custom"),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
                                                                    className: `custom-icon ${this.state.showCustomDate ? "open-icon" : ""}`,
                                                                    enableBackground: "new 0 0 330 330",
                                                                    viewBox: "0 0 330 330",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                                                        d: "m325.607 79.393c-5.857-5.857-15.355-5.858-21.213.001l-139.39 139.393-139.397-139.394c-5.857-5.857-15.355-5.858-21.213.001-5.858 5.858-5.858 15.355 0 21.213l150.004 150c2.813 2.813 6.628 4.393 10.606 4.393s7.794-1.581 10.606-4.394l149.996-150c5.859-5.857 5.859-15.355.001-21.213z"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        this.state.showCustomDate && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $44884d0571b9c796$export$2e2bcd8739ae039), {
                                                            onChange: (dates)=>{
                                                                const [start, end] = dates;
                                                                this.onSelectPeriod((0, $48f673e197675daa$export$714d535c5135f0bb)(start, end), "custom", start, end);
                                                                this.onSelectComparedPeriod(null, null, null, null);
                                                            },
                                                            selected: this.state.customStartDate ?? undefined,
                                                            startDate: this.state.customStartDate ?? undefined,
                                                            endDate: this.state.customEndDate ?? undefined,
                                                            selectsRange: true,
                                                            inline: true,
                                                            closeOnScroll: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: `dropdown-container ${(this.props.disableComparing || this.props.disableDateFilters) && "disabled"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "secondary",
                                            children: t("comparedTo")
                                        }),
                                        " ",
                                        // show the corresponding quarter to the compared quarter alias
                                        // the alias is in the form of "previous[First|..]Quarter"
                                        // so we transform it to the form "[first|..]Quarter"
                                        this.context.comparedPeriod ? this.context.comparedPeriod?.type === "quarter" ? this.context.comparedPeriod?.alias.startsWith("previous") ? `${t(`${this.context.comparedPeriod?.alias.match(/First|Second|Third|Fourth/)[0].toLowerCase()}Quarter`)} ${previousYear}` : `${t(this.context.comparedPeriod.alias)} ${currentYear}` : t(this.context.comparedPeriod.alias) : t("none"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                            className: "dropdown-icon",
                                            enableBackground: "new 0 0 330 330",
                                            onClick: (e)=>{
                                                this.setActiveMenu("comparedPeriodMenu", e);
                                            }
                                        }),
                                        this.isActiveMenu("comparedPeriodMenu") && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "dropdown-menu",
                                            children: [
                                                this.context.currentPeriod.type === "day" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "yesterday" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                this.onSelectComparedPeriod("yesterday", "day", (0, $e6350463b071cfeb$export$23a16f3c6d143ce9)(), (0, $e6350463b071cfeb$export$23a16f3c6d143ce9)());
                                                            },
                                                            children: t("yesterday")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "sameDayPreviousWeek" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const sameDayPreviousWeek = (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    weeks: 1
                                                                });
                                                                this.onSelectComparedPeriod("sameDayPreviousWeek", "day", sameDayPreviousWeek, sameDayPreviousWeek);
                                                            },
                                                            children: t("sameDayPreviousWeek")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "sameDayPreviousMonth" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const sameDayPreviousMonth = (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    months: 1
                                                                });
                                                                this.onSelectComparedPeriod("sameDayPreviousMonth", "day", sameDayPreviousMonth, sameDayPreviousMonth);
                                                            },
                                                            children: t("sameDayPreviousMonth")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "sameDayPreviousYear" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const sameDayPreviousYear = (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    years: 1
                                                                });
                                                                this.onSelectComparedPeriod("sameDayPreviousYear", "day", sameDayPreviousYear, sameDayPreviousYear);
                                                            },
                                                            children: t("sameDayPreviousYear")
                                                        })
                                                    ]
                                                }),
                                                this.context.currentPeriod.type === "week" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "previousWeek" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                this.onSelectComparedPeriod("previousWeek", "week", (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    weeks: 1
                                                                })), (0, $a2f45d6e9fc115f1$export$ef8b6d9133084f4e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    weeks: 1
                                                                })));
                                                            },
                                                            children: t("previousWeek")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "sameWeekPreviousMonth" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                this.onSelectComparedPeriod("sameWeekPreviousMonth", "week", (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    months: 1
                                                                })), (0, $a2f45d6e9fc115f1$export$ef8b6d9133084f4e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    months: 1
                                                                })));
                                                            },
                                                            children: t("sameWeekPreviousMonth")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "sameWeekPreviousYear" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                this.onSelectComparedPeriod("sameWeekPreviousYear", "week", (0, $10fdba42ef8f2c78$export$42c81a444fbfb5d4)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    years: 1
                                                                })), (0, $a2f45d6e9fc115f1$export$ef8b6d9133084f4e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    years: 1
                                                                })));
                                                            },
                                                            children: t("sameWeekPreviousYear")
                                                        })
                                                    ]
                                                }),
                                                this.context?.currentPeriod?.type === "month" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "previousMonth" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                this.onSelectComparedPeriod("previousMonth", "month", (0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    months: 1
                                                                })), (0, $0686a4d407c7043b$export$a2258d9c4118825c)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    months: 1
                                                                })));
                                                            },
                                                            children: t("previousMonth")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "samePeriodPreviousMonth" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                this.onSelectComparedPeriod("samePeriodPreviousMonth", "month", (0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    months: 1
                                                                })), (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    months: 1
                                                                }));
                                                            },
                                                            children: t("samePeriodPreviousMonth")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "samePeriodPreviousYear" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                this.onSelectComparedPeriod("samePeriodPreviousYear", "month", (0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    years: 1
                                                                })), (0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                                    years: 1
                                                                }));
                                                            },
                                                            children: t("samePeriodPreviousYear")
                                                        })
                                                    ]
                                                }),
                                                this.context?.currentPeriod?.type === "year" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: `item ${this.context.comparedPeriod?.type === "year" ? "active" : ""}`,
                                                    onClick: ()=>{
                                                        this.onSelectComparedPeriod("previousYear", "year", (0, $c8148e08909dec9f$export$f91e89d3d0406102)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            years: 1
                                                        })), (0, $938b9f25b96c36ea$export$8b7aa55c66d5569e)((0, $d4cf8e20404fbe10$export$f93b5905241a7cca)(new Date(), {
                                                            years: 1
                                                        })));
                                                    },
                                                    children: t("previousYear")
                                                }),
                                                this.context?.currentPeriod?.type === "quarter" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                                    children: [
                                                        (0, $8de2b2935de63c65$export$de90a4bb31c25221)(new Date()) > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "firstQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const firstQuarter = new Date(currentYearQuery, 0, 1);
                                                                this.onSelectComparedPeriod("firstQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(firstQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(firstQuarter));
                                                            },
                                                            children: `${t("firstQuarter")} ${currentYear}`
                                                        }),
                                                        (0, $8de2b2935de63c65$export$de90a4bb31c25221)(new Date()) > 2 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "secondQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const secondQuarter = new Date(currentYearQuery, 3, 1);
                                                                this.onSelectComparedPeriod("secondQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(secondQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(secondQuarter));
                                                            },
                                                            children: `${t("secondQuarter")} ${currentYear}`
                                                        }),
                                                        (0, $8de2b2935de63c65$export$de90a4bb31c25221)(new Date()) > 3 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "thirdQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const thirdQuarter = new Date(currentYearQuery, 6, 1);
                                                                this.onSelectComparedPeriod("thirdQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(thirdQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(thirdQuarter));
                                                            },
                                                            children: `${t("thirdQuarter")} ${currentYear}`
                                                        }),
                                                        (0, $8de2b2935de63c65$export$de90a4bb31c25221)(new Date()) > 4 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "fourthQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const fourthQuarter = new Date(currentYearQuery, 9, 1);
                                                                this.onSelectComparedPeriod("fourthQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(fourthQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(fourthQuarter));
                                                            },
                                                            children: `${t("fourthQuarter")} ${currentYear}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "previousFirstQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const previousFirstQuarter = new Date(previousYearQuery, 0, 1);
                                                                this.onSelectComparedPeriod("previousFirstQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(previousFirstQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(previousFirstQuarter));
                                                            },
                                                            children: `${t("firstQuarter")} ${previousYear}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "previousSecondQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const previousSecondQuarter = new Date(previousYearQuery, 3, 1);
                                                                this.onSelectComparedPeriod("previousSecondQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(previousSecondQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(previousSecondQuarter));
                                                            },
                                                            children: `${t("secondQuarter")} ${previousYear}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "previousThirdQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const previousThirdQuarter = new Date(previousYearQuery, 6, 1);
                                                                this.onSelectComparedPeriod("previousThirdQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(previousThirdQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(previousThirdQuarter));
                                                            },
                                                            children: `${t("thirdQuarter")} ${previousYear}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: `item ${this.context.comparedPeriod?.alias === "previousFourthQuarter" ? "active" : ""}`,
                                                            onClick: ()=>{
                                                                const previousFourthQuarter = new Date(previousYearQuery, 9, 1);
                                                                this.onSelectComparedPeriod("previousFourthQuarter", "quarter", (0, $1dda55d8fd4fe3e4$export$69be7267a042ecb3)(previousFourthQuarter), (0, $84d943fac3f3650c$export$5f53493861eef879)(previousFourthQuarter));
                                                            },
                                                            children: `${t("fourthQuarter")} ${previousYear}`
                                                        })
                                                    ]
                                                }),
                                                this.context?.currentPeriod?.type === "custom" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: `item ${this.context.comparedPeriod?.type === "custom" ? "active" : ""}`,
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        this.setState({
                                                            showComparedCustomDate: true
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "custom",
                                                            children: [
                                                                t("custom"),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
                                                                    className: `custom-icon ${this.state.showComparedCustomDate ? "open-icon" : ""}`,
                                                                    enableBackground: "new 0 0 330 330",
                                                                    viewBox: "0 0 330 330",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                                                        d: "m325.607 79.393c-5.857-5.857-15.355-5.858-21.213.001l-139.39 139.393-139.397-139.394c-5.857-5.857-15.355-5.858-21.213.001-5.858 5.858-5.858 15.355 0 21.213l150.004 150c2.813 2.813 6.628 4.393 10.606 4.393s7.794-1.581 10.606-4.394l149.996-150c5.859-5.857 5.859-15.355.001-21.213z"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        this.state.showComparedCustomDate && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $44884d0571b9c796$export$2e2bcd8739ae039), {
                                                            onChange: (dates)=>{
                                                                const [start, end] = dates;
                                                                this.onSelectComparedPeriod((0, $48f673e197675daa$export$714d535c5135f0bb)(start, end), "custom", start, end);
                                                            },
                                                            selected: this.state.customComparedStartDate ?? undefined,
                                                            startDate: this.state.customComparedStartDate ?? undefined,
                                                            endDate: this.state.customComparedEndDate ?? undefined,
                                                            selectsRange: true,
                                                            inline: true,
                                                            closeOnScroll: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        this.onSelectComparedPeriod(null, null, null, null);
                                                    },
                                                    children: t("none")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1dbaf3f30495fd63$export$2e2bcd8739ae039), {
                            appliedFilters: (0, $eadf35cb023988c9$export$a15b0df135c91f7e)(this.context?.appliedFilters)
                        })
                    ]
                })
            ]
        });
    }
}
$406539e821b77e4d$var$Header.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $406539e821b77e4d$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("common")($406539e821b77e4d$var$Header);




parcelRequire("igtsr");
const $ba8f30705abc5d40$var$SvgClock = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 512,
        height: 512,
        viewBox: "0 0 443.294 443.294",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M221.647 0C99.433 0 0 99.433 0 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647S343.861 0 221.647 0m0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z"
            })
        ]
    });
var $ba8f30705abc5d40$export$2e2bcd8739ae039 = $ba8f30705abc5d40$var$SvgClock;


class $4080123389697987$var$AbandonedCarts extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.exportAbandonedCartsRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportAbandonedCartsProductRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            loading: false,
            id: Date.now().toString(),
            productSku: "",
            formError: "",
            durationRange: "",
            startDate: new Date(),
            startTime: new Date(),
            endDate: new Date(),
            endTime: new Date()
        };
        this.loadData = this.loadData.bind(this);
        this.updateProductSku = this.updateProductSku.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Abandoned Carts";
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    handleSubmit(values, setSubmitting) {
        // Convert time values to Date objects if they're timestamps (from time pickers)
        const startTimeDate = typeof values.startTime === "number" ? new Date(values.startTime) : values.startTime;
        const endTimeDate = typeof values.endTime === "number" ? new Date(values.endTime) : values.endTime;
        const startDate = (0, $48f673e197675daa$export$c472c0059aecb283)(values.startDate, startTimeDate);
        const endDate = (0, $48f673e197675daa$export$c472c0059aecb283)(values.endDate, endTimeDate);
        if (startDate >= endDate) {
            this.setState({
                formError: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("abandoned-carts:formError")
            });
            setSubmitting(false);
        } else if (startDate >= new Date() || endDate >= new Date()) {
            this.setState({
                formError: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("abandoned-carts:futureDateError")
            });
            setSubmitting(false);
        } else {
            this.setState({
                loading: true
            });
            this.setState({
                formError: ""
            });
            this.setState({
                startDate: values.startDate,
                startTime: startTimeDate,
                endDate: values.endDate,
                endTime: endTimeDate
            });
            let abandonedCartsPromise = Promise.resolve();
            if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
                "project"
            ])) {
                abandonedCartsPromise = (0, $b3d35f81c94dd86a$export$57100c9b4bc4bd8f)({
                    project: this.context.project,
                    from: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(startDate, "yyyy-MM-dd HH:mm:ss"),
                    to: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(endDate, "yyyy-MM-dd HH:mm:ss")
                }).then((abandonedCarts)=>{
                    this.setState({
                        abandonedCarts: abandonedCarts
                    });
                });
                this.setState({
                    durationRange: `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("abandoned-carts:from")}: ${(0, $7aa2e35e5d01626e$export$d9468344d3651243)(startDate, "yyyy-MM-dd HH:mm:ss")} ${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("abandoned-carts:to")}: ${(0, $7aa2e35e5d01626e$export$d9468344d3651243)(endDate, "yyyy-MM-dd HH:mm:ss")}`
                });
            }
            Promise.all([
                abandonedCartsPromise
            ]).then(()=>{
                this.setState({
                    loading: false
                });
            }).catch((error)=>{
                this.setState({
                    loading: false
                });
                (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
            });
        }
    }
    // get abandoned carts from a week ago
    loadData() {
        this.setState({
            loading: true
        });
        const lastWeek = new Date(Date.now() - 604800000);
        const now = new Date();
        this.setState({
            startDate: lastWeek,
            startTime: lastWeek,
            endDate: now,
            endTime: now
        });
        let abandonedCartsPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project"
        ])) abandonedCartsPromise = (0, $b3d35f81c94dd86a$export$57100c9b4bc4bd8f)({
            project: this.context.project,
            from: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(lastWeek, "yyyy-MM-dd HH:mm:ss"),
            to: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(now, "yyyy-MM-dd HH:mm:ss")
        }).then((abandonedCarts)=>{
            this.setState({
                abandonedCarts: abandonedCarts
            });
        });
        Promise.all([
            abandonedCartsPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
            this.setState({
                durationRange: `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("abandoned-carts:from")}: ${(0, $7aa2e35e5d01626e$export$d9468344d3651243)(lastWeek, "yyyy-MM-dd HH:mm:ss")} ${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("abandoned-carts:to")}: ${(0, $7aa2e35e5d01626e$export$d9468344d3651243)(now, "yyyy-MM-dd HH:mm:ss")}`
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    updateProductSku(productSku) {
        this.setState({
            productSku: productSku
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "abandoned-carts",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("abandonedCarts"),
                    disableAdvancedFilters: true,
                    disableComparing: true,
                    exportRef: this.state.productSku ? this.exportAbandonedCartsProductRef : this.exportAbandonedCartsRef
                }),
                this.state.productSku ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                            className: "products-button--back",
                            type: "button",
                            onClick: ()=>{
                                this.setState({
                                    productSku: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                t("backToList")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $be69e13341d50da4$export$2e2bcd8739ae039), {
                            productSku: this.state.productSku,
                            updateProductSku: this.updateProductSku,
                            exportRef: this.exportAbandonedCartsProductRef
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    ref: this.exportAbandonedCartsRef,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "grid",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card abandoned-carts--card",
                                children: [
                                    Object.keys(this.context.appliedFilters).length > 0 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "disclaimer",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            children: t("abandonedCartsAppliedFiltersDisclaimer")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                        className: "card--title flex align-center",
                                        children: [
                                            t("abandonmentDuration"),
                                            " ",
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "duration",
                                                children: this.state.durationRange
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                                        enableReinitialize: true,
                                        initialValues: {
                                            startDate: this.state.startDate || new Date(),
                                            startTime: this.state.startTime || new Date(),
                                            endDate: this.state.endDate || new Date(),
                                            endTime: this.state.endTime || new Date()
                                        },
                                        onSubmit: (values, { setSubmitting: setSubmitting })=>{
                                            this.handleSubmit(values, setSubmitting);
                                        },
                                        children: (props)=>{
                                            const { values: values, isSubmitting: isSubmitting } = props;
                                            return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                                className: "abandoned-carts__form",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                className: "abandoned-carts__form-label",
                                                                children: t("from")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "abandoned-carts__form-fields",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                        className: "abandoned-carts__form-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                htmlFor: "",
                                                                                children: t("date")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "abandoned-carts__form-field-input",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $bc7571e19bc65391$export$2e2bcd8739ae039), {
                                                                                        name: "startDate",
                                                                                        dateFormat: "d MMMM yyyy",
                                                                                        startDate: values.startDate,
                                                                                        endDate: values.endDate,
                                                                                        maxDate: new Date()
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $790b8e9658fa8ccc$export$2e2bcd8739ae039), {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                        className: "abandoned-carts__form-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                htmlFor: "",
                                                                                children: t("time")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "abandoned-carts__form-field-input",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $bc7571e19bc65391$export$2e2bcd8739ae039), {
                                                                                        name: "startTime",
                                                                                        showTimeSelect: true,
                                                                                        showTimeSelectOnly: true,
                                                                                        dateFormat: "h:mm aa",
                                                                                        className: "time-input"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ba8f30705abc5d40$export$2e2bcd8739ae039), {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                className: "abandoned-carts__form-label",
                                                                children: t("to")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "abandoned-carts__form-fields",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                        className: "abandoned-carts__form-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                htmlFor: "",
                                                                                children: t("date")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "abandoned-carts__form-field-input",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $bc7571e19bc65391$export$2e2bcd8739ae039), {
                                                                                        name: "endDate",
                                                                                        dateFormat: "d MMMM yyyy",
                                                                                        startDate: values.startDate,
                                                                                        endDate: values.endDate,
                                                                                        minDate: values.startDate,
                                                                                        maxDate: new Date()
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $790b8e9658fa8ccc$export$2e2bcd8739ae039), {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                        className: "abandoned-carts__form-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                htmlFor: "",
                                                                                children: t("time")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "abandoned-carts__form-field-input",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $bc7571e19bc65391$export$2e2bcd8739ae039), {
                                                                                        name: "endTime",
                                                                                        showTimeSelect: true,
                                                                                        showTimeSelectOnly: true,
                                                                                        dateFormat: "h:mm aa",
                                                                                        className: "time-input"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ba8f30705abc5d40$export$2e2bcd8739ae039), {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                        className: "abandoned-carts__form-error",
                                                        children: this.state.formError
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        className: "button--main black",
                                                        type: "submit",
                                                        disabled: isSubmitting,
                                                        children: t("apply")
                                                    })
                                                ]
                                            });
                                        }
                                    }),
                                    this.state.abandonedCarts ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "abandoned-carts--card-info",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "",
                                                        children: t("totalAbandonedCarts")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                        children: this.state.abandonedCarts.guest_cart_count + this.state.abandonedCarts.user_cart_count
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "",
                                                        children: t("userCarts")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                        children: this.state.abandonedCarts.user_cart_count
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                children: this.state.abandonedCarts?.user_list && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                                    data: this.state.abandonedCarts?.user_list,
                                                    filename: "abandoned-carts-users-list.csv",
                                                    className: "export-list-button ml-auto",
                                                    target: "_blank",
                                                    children: t("exportList")
                                                })
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            this.state.abandonedCarts ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "card overview-card",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                                className: "card--title flex align-center",
                                                children: [
                                                    t("Users Abandoned Carts"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "duration",
                                                        children: this.state.durationRange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "overview-items",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "header",
                                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.abandonedCarts?.user_cart_count)
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "title",
                                                            children: t("abandonedCarts")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "card abandoned-carts--products",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                                className: "card--title",
                                                children: [
                                                    t("productsList"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "duration",
                                                        children: this.state.durationRange
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "abandoned-carts-products-table",
                                                children: this.state.abandonedCarts?.product_list && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                                    products: this.state.abandonedCarts?.product_list,
                                                    type: "abandoned-carts",
                                                    updateProductSku: this.updateProductSku
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "abandoned-carts--doughnut-card",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                                            title: t("abandonedCartsStatistics"),
                                            items: [
                                                {
                                                    name: [
                                                        `${t("guests")}`,
                                                        `${Math.round(this.state.abandonedCarts?.guest_cart_count / (this.state.abandonedCarts?.guest_cart_count + this.state.abandonedCarts?.user_cart_count) * 100)}% . ${this.state.abandonedCarts?.guest_cart_count} ${t("abandonedCart")}`
                                                    ],
                                                    count: `${this.state.abandonedCarts?.guest_cart_count}` ?? "0"
                                                },
                                                {
                                                    name: [
                                                        `${t("users")}`,
                                                        `${Math.round(this.state.abandonedCarts?.user_cart_count / (this.state.abandonedCarts?.guest_cart_count + this.state.abandonedCarts?.user_cart_count) * 100)}% . ${this.state.abandonedCarts?.user_cart_count} ${t("abandonedCart")}`
                                                    ],
                                                    count: `${this.state.abandonedCarts?.user_cart_count}` ?? "0"
                                                }
                                            ],
                                            currentPeriod: this.context.currentPeriod,
                                            radius: "100",
                                            blackThemed: true,
                                            legendPosition: "bottom"
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            ]
        });
    }
}
$4080123389697987$var$AbandonedCarts.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $4080123389697987$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("abandoned-carts")($4080123389697987$var$AbandonedCarts);


/**
 * @author Youssef Tarek
 * @date 2021-12-04
 * @description Account information of the user
 * @filename account-information.tsx
 */ 


var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");


class $5d4d217f9c00c96f$export$e8923eab9ed2919e extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            editingEmail: false,
            editingPassword: false
        };
        this.updateAccountName = this.updateAccountName.bind(this);
    }
    componentDidMount() {
        // set page title
        document.title = "Account Settings";
    }
    updateAccountName(_values, formikHelpers) {
        if (this.context.user?.name === _values.name) return;
        // TODO: Update account name
        formikHelpers.setSubmitting(false);
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "account-information",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                        className: "card--title",
                        children: "Account Settings"
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                        onSubmit: this.updateAccountName,
                        initialValues: {
                            name: this.context.user?.name
                        },
                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                            name: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().max(200).required("Name is required")
                        }),
                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                className: "card--section",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "name",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "name",
                                                        children: "Full Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        id: "topic",
                                                        placeholder: "enter message topic",
                                                        name: "name",
                                                        type: "text",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "submit",
                                        className: "button save",
                                        disabled: formikBag.isSubmitting,
                                        children: "Update Name"
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "card--section",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                className: "label",
                                htmlFor: "email",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "flex account-information--email justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "title",
                                        children: this.context.user.email
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: "/changeEmail",
                                        className: "link",
                                        children: "Change Email"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                className: "label my-10",
                                htmlFor: "password",
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "flex account-information--password justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "title",
                                        children: "********"
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: "/changePassword",
                                        className: "link",
                                        children: "Change Password"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
$5d4d217f9c00c96f$export$e8923eab9ed2919e.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);


/**
 * @author Ahmed Serag
 * @date 2021-06-09
 * @description Categories tab in the app.
 * @filename categories.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

/**
 * @author Ahmed Serag
 * @date 2021-07-02
 * @description Implementation of Categories related utilities.
 * @filename categories.ts
 */ /**
 * @author Ahmed Serag
 * @date 2021-07-02
 * @description implementation of category related API calls.
 * @filename category.ts
 */ 



class $eae8d3e9f5ae2dfd$export$3a8840c5b2ecf003 {
    static CategoriesPercentages({ project: project, from: from, to: to, sort: sort = "sales_value", filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categories.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sort", sort);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categories.method
        });
    }
    static categoriesSales({ project: project, from: from, to: to, search: search = "", sort: sort = "sales_value", direction: direction = (0, $5142459688621f32$export$966c0722699349a0).Desc, currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categoriesSales.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("search", search);
        url.searchParams.append("sort", sort);
        url.searchParams.append("direction", direction);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categoriesSales.method
        });
    }
    static categoriesSalesChildren({ project: project, from: from, to: to, parentName: parentName, sort: sort = "sales_value", direction: direction = (0, $5142459688621f32$export$966c0722699349a0).Desc, search: search = "", currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categoriesSalesChildren.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("parentName", parentName);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("search", search);
        url.searchParams.append("sort", sort);
        url.searchParams.append("direction", direction);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categoriesSalesChildren.method
        });
    }
    static categoriesSalesExport({ project: project, from: from, to: to, sort: sort = "sales_value", filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categoriesSalesExport.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("sort", sort);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).categoriesSalesExport.method
        });
    }
}



function $63979a364d2860b9$export$7a0f33e8df10bd94(payload) {
    return (0, $eae8d3e9f5ae2dfd$export$3a8840c5b2ecf003).CategoriesPercentages(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $63979a364d2860b9$export$9293d67ae9a139c(payload) {
    return (0, $eae8d3e9f5ae2dfd$export$3a8840c5b2ecf003).categoriesSales(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $63979a364d2860b9$export$1cfac77223a58c64(payload) {
    return (0, $eae8d3e9f5ae2dfd$export$3a8840c5b2ecf003).categoriesSalesChildren(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $63979a364d2860b9$export$d3d5342ecda9a5a6(payload) {
    return (0, $eae8d3e9f5ae2dfd$export$3a8840c5b2ecf003).categoriesSalesExport(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $63979a364d2860b9$export$14df6de534cb7e3b(categorySales) {
    const result = {
        number_sold: 0,
        sales_value: 0
    };
    categorySales.forEach((sale)=>{
        result.number_sold += sale.number_sold;
        result.sales_value += sale.sales_value;
    });
    return result;
}











var $igtsr = parcelRequire("igtsr");







/* eslint-disable react/no-did-update-set-state */ /**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description Orders tab of the App.
 * @filename orders.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


var $gagb8 = parcelRequire("gagb8");


class $42465bb5f1bfa64f$var$CollectionCard extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        const tabsKeys = Object.keys(this.props.tabs);
        this.state = {
            id: Date.now().toString(),
            activeTab: tabsKeys[0],
            activeFragment: 0
        };
        this.ChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.loadChart = this.loadChart.bind(this);
    }
    componentDidMount() {
        if (this.props.tabs[this.state.activeTab].items) this.setState({
            chart: (0, $54c7c3206a2399da$export$99199eb0d2d4ab39)(this.ChartRef.current, this.getBarChartData().barChartLabels, this.getBarChartData().barChartData, this.state.id)
        });
    }
    componentDidUpdate(prevProps) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gagb8)))(prevProps.tabs[this.state.activeTab].items, this.props.tabs[this.state.activeTab].items) || !this.props.tabs[this.state.activeTab].items) return null;
        this.loadChart();
        return null;
    }
    getBarChartData() {
        const totalChartData = this.props.tabs[this.state.activeTab].items;
        let chartData = totalChartData;
        const chartItemsMaxLength = 10;
        // Paginate chart data if there are more than chart items max length
        if (totalChartData.length > chartItemsMaxLength) chartData = totalChartData.slice(this.state.activeFragment * chartItemsMaxLength, this.state.activeFragment * chartItemsMaxLength + chartItemsMaxLength);
        const barChartLabels = chartData.map((val)=>val.name);
        const barChartValues = chartData.map((val)=>{
            return Number(val.count);
        });
        const barChartData = [
            {
                values: barChartValues,
                label: this.props.tabs[this.state.activeTab].title,
                title: this.props.title
            }
        ];
        return {
            barChartLabels: barChartLabels,
            barChartData: barChartData
        };
    }
    loadChart() {
        if (this.state.chart) this.state.chart.destroy();
        const chartData = this.getBarChartData();
        this.setState({
            chart: (0, $54c7c3206a2399da$export$99199eb0d2d4ab39)(this.ChartRef.current, chartData.barChartLabels, chartData.barChartData, this.state.id)
        });
    }
    render() {
        const { t: t } = this.props;
        const tabsKeys = Object.keys(this.props.tabs);
        const totalChartData = this.props.tabs[this.state.activeTab]?.items;
        const fragments = totalChartData && Math.ceil(totalChartData.length / 10);
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                        className: "card--title card-graph--title",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            children: [
                                this.props.title,
                                this.props.duration && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    className: "duration",
                                    children: [
                                        "(",
                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.props.currentPeriod?.type, this.props.currentPeriod?.from, this.props.currentPeriod?.to),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    this.props.subtitle && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h3", {
                        className: "card--subtitle",
                        children: [
                            "***",
                            this.props.subtitle,
                            "***"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card-tabs",
                        children: tabsKeys.map((key)=>{
                            return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: `tab${this.state.activeTab === key ? " active" : ""}`,
                                onClick: ()=>{
                                    if (this.state.activeTab !== key) this.setState({
                                        activeTab: key,
                                        activeFragment: 0
                                    }, ()=>{
                                        this.loadChart();
                                    });
                                },
                                children: key
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("hr", {}),
                    fragments > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "card-pagination",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: `pagination-item${this.state.activeFragment === 0 ? " disabled" : ""}`,
                                onClick: ()=>{
                                    if (this.state.activeFragment !== 0) this.setState({
                                        activeFragment: this.state.activeFragment - 1
                                    }, ()=>{
                                        this.loadChart();
                                    });
                                },
                                children: t("previous")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: `pagination-item${this.state.activeFragment === fragments - 1 ? " disabled" : ""}`,
                                onClick: ()=>{
                                    if (this.state.activeFragment !== fragments - 1) this.setState({
                                        activeFragment: this.state.activeFragment + 1
                                    }, ()=>{
                                        this.loadChart();
                                    });
                                },
                                children: t("next")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "bar-chart__container",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("canvas", {
                            id: this.state.id,
                            ref: this.ChartRef
                        })
                    })
                ]
            })
        });
    }
}
var $42465bb5f1bfa64f$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("common")($42465bb5f1bfa64f$var$CollectionCard);


/**
 * @author Youssef Tarek
 * @date 2022-03-23
 * @description implementation of pagination component
 * @filename Pagination.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

class $2a34a2a81f7d40cf$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            pagination: []
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.pagination.length !== nextProps.totalPageCount) return {
            pagination: [
                ...Array(nextProps.totalPageCount).keys()
            ].map((i)=>i + 1)
        };
        return null;
    }
    /**
   * check whether the page number should be shown or not;
   * depending on the current page, the total number of pages,
   * and the number of specified neighboring pages
   * @param pageNumber
   * @returns
   */ isPageNumberShown(pageNumber) {
        if (pageNumber <= 1 || // show first page
        pageNumber >= this.props.totalPageCount || // show last page
        pageNumber >= this.props.currentPage - this.props.pageNeighbors && // show the previous page
        pageNumber <= this.props.currentPage + this.props.pageNeighbors // show next page
        ) return true;
        return false;
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "pagination",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>{
                        this.props.changePageHandler(this.props.currentPage - 1);
                    },
                    disabled: this.props.currentPage === 1,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                        className: "left-arrow arrow"
                    })
                }),
                this.state.pagination.map((number)=>{
                    if (this.isPageNumberShown(number)) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                        className: `page-number ${number === this.props.currentPage && "active"}`,
                        onClick: (e)=>{
                            this.props.changePageHandler(parseInt(e.target.textContent, 10));
                        },
                        children: number
                    }, number);
                    if (number === 2 || number === this.props.totalPageCount - 1) // display breaks only after first page and before last page
                    // and avoid showing breaks instead of all the not showing numbers
                    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                        className: "page-number break",
                        children: ".."
                    }, number);
                    return null;
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>{
                        this.props.changePageHandler(this.props.currentPage + 1);
                    },
                    disabled: this.props.currentPage === this.props.totalPageCount,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                        className: "right-arrow arrow"
                    })
                })
            ]
        });
    }
}


/**
 * @author Karim Shalapy
 * @date 2020-09-27
 * @description implementation of a form containing a search input and a sort dropdown
 * @filename sort-search.tsx
 */ 

var $igtsr = parcelRequire("igtsr");





class $56815f93a4fad611$var$SortSearch extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props), this.debouncedSearchHandler = (0, $48f673e197675daa$export$1f49383e7879c367)(this.props.searchHandler.bind(this));
        this.state = {
            productSortingMenu: false,
            searchInput: ""
        };
        this.getSortDisplayText = this.getSortDisplayText.bind(this);
    }
    getSortDisplayText(sort, direction) {
        const sortDisplayText = this.props.t(sort);
        if (sort === "name") return `${sortDisplayText} (${direction === "asc" ? this.props.t("a-z") : this.props.t("z-a")})`;
        return `${sortDisplayText} (${direction === "asc" ? this.props.t("lowToHigh") : this.props.t("highToLow")})`;
    }
    render() {
        const { t: t } = this.props;
        const sortEnum = this.props.mode === "minimal" ? (0, $5142459688621f32$export$fdccc7ccdeecb4a2) : (0, $5142459688621f32$export$374f3ebff8a4cc33);
        const directions = Object.values((0, $5142459688621f32$export$966c0722699349a0));
        const sortByWithDirection = [];
        // Add the default sort in the beginning
        sortByWithDirection.push({
            displayText: this.props.t("default")
        });
        // Push in the `sortByWithDirection` all the sort enum values with the two directions.
        Object.values(sortEnum).forEach((sortBy)=>{
            directions.forEach((direction)=>{
                sortByWithDirection.push({
                    direction: direction,
                    sortBy: sortBy,
                    displayText: this.getSortDisplayText(sortBy, direction)
                });
            });
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
            className: "products-search",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8b68e0e8727d6658$export$2e2bcd8739ae039), {
                    className: "search-icon"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                    type: "text",
                    className: "search-input",
                    placeholder: t("searchPlaceholder"),
                    value: this.state.searchInput,
                    onChange: (e)=>{
                        const searchInput = e.target.value;
                        this.setState({
                            searchInput: searchInput
                        });
                        this.debouncedSearchHandler(searchInput);
                    }
                }),
                !!this.state.searchInput && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                    type: "reset",
                    className: "clear-icon",
                    value: "+",
                    onClick: ()=>{
                        this.debouncedSearchHandler.cancel();
                        this.setState({
                            searchInput: ""
                        });
                        this.props.searchHandler("");
                    }
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "dropdown-container",
                    role: "listbox",
                    "aria-expanded": this.state.productSortingMenu,
                    "aria-label": t("sortBy"),
                    tabIndex: 0,
                    onClick: ()=>{
                        this.setState({
                            productSortingMenu: !this.state.productSortingMenu
                        });
                    },
                    children: [
                        t("sortBy"),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                            className: "dropdown-container__sort",
                            children: this.props.sortBy && this.props.direction ? this.getSortDisplayText(this.props.sortBy, this.props.direction) : ""
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                            className: "dropdown-icon"
                        }),
                        this.state.productSortingMenu && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                            className: "dropdown-menu",
                            children: sortByWithDirection.map((item, i)=>{
                                if (item.direction && item.sortBy) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    role: "option",
                                    "aria-selected": this.props.direction === item.direction && this.props.sortBy === item.sortBy,
                                    "aria-label": item.displayText,
                                    className: "item",
                                    onClick: ()=>{
                                        this.props.sortHandler(item.sortBy, item.direction);
                                    },
                                    children: item.displayText
                                }, `${item.sortBy}-${item.direction}-${i}`);
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    role: "option",
                                    "aria-selected": !this.props.sortBy && !this.props.direction,
                                    "aria-label": item.displayText,
                                    className: "item",
                                    onClick: ()=>{
                                        this.props.sortHandler();
                                    },
                                    children: item.displayText
                                }, `default-${i}`);
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$56815f93a4fad611$var$SortSearch.defaultProps = {
    mode: "full"
};
var $56815f93a4fad611$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("sort-search")($56815f93a4fad611$var$SortSearch);


class $28d19387d4420476$var$CategoriesSales extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            comparedLoading: true,
            categoriesSales: [],
            id: Date.now().toString(),
            currentPage: 1,
            comparedCurrentPage: 1,
            totalPages: 1,
            comparedTotalPages: 1,
            searchQuery: ""
        };
        this.updateSearchQuery = this.updateSearchQuery.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.loadAllData = this.loadAllData.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.updateComparedCurrentPage = this.updateComparedCurrentPage.bind(this);
        this.loadCategoriesSales = this.loadCategoriesSales.bind(this);
        this.loadComparedCategoriesSales = this.loadComparedCategoriesSales.bind(this);
    }
    componentDidMount() {
        this.loadAllData();
        this.context.addUpdatesListener(this.state.id, this.loadAllData);
    }
    componentDidUpdate(_, prevState) {
        const sortChanged = prevState.sortBy !== this.state.sortBy || prevState.sortDirection !== this.state.sortDirection;
        const searchChanged = prevState.searchQuery !== this.state.searchQuery;
        if (prevState.currentPage !== this.state.currentPage || searchChanged || sortChanged) this.loadCategoriesSales().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
        if (prevState.comparedCurrentPage !== this.state.comparedCurrentPage || searchChanged || sortChanged) this.loadComparedCategoriesSales().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.setState({
                comparedLoading: false
            });
        });
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    updateSearchQuery(searchQuery) {
        this.setState({
            searchQuery: searchQuery,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateSort(sortBy, sortDirection) {
        if (!sortBy || !sortDirection) {
            this.setState({
                sortBy: undefined,
                sortDirection: undefined,
                currentPage: 1,
                comparedCurrentPage: 1
            });
            return;
        }
        this.setState({
            sortBy: sortBy,
            sortDirection: sortDirection,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateCurrentPage(currentPage) {
        this.setState({
            currentPage: currentPage
        });
    }
    updateComparedCurrentPage(comparedCurrentPage) {
        this.setState({
            comparedCurrentPage: comparedCurrentPage
        });
    }
    loadCategoriesSales() {
        this.setState({
            loading: true
        });
        let categoriesSalesPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) categoriesSalesPromise = (0, $63979a364d2860b9$export$9293d67ae9a139c)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            currentPage: this.state.currentPage,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                categoriesSales: res.data,
                loading: false,
                totalPages: res.pagination.totalPageCount
            });
        });
        return categoriesSalesPromise;
    }
    loadComparedCategoriesSales() {
        this.setState({
            comparedLoading: true
        });
        let comparedCategoriesSalesPromise = Promise.resolve();
        if (this.context.comparedPeriod) comparedCategoriesSalesPromise = (0, $63979a364d2860b9$export$9293d67ae9a139c)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            currentPage: this.state.comparedCurrentPage,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                comparedCategoriesSales: res.data,
                comparedLoading: false,
                comparedTotalPages: res.pagination.totalPageCount || 1
            });
        });
        else this.setState({
            comparedCategoriesSales: null,
            comparedLoading: false
        });
        return comparedCategoriesSalesPromise;
    }
    loadAllData() {
        const categoriesSalesPromise = this.loadCategoriesSales();
        const comparedCategoriesSalesPromise = this.loadComparedCategoriesSales();
        Promise.all([
            categoriesSalesPromise,
            comparedCategoriesSalesPromise
        ]).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.setState({
                loading: false,
                comparedLoading: false
            });
        });
    }
    render() {
        const { t: t } = this.props;
        const allCategoriesData = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.categoriesSales);
        const tabs = {
            [t("allCategories")]: {
                title: `${t("allCategories")}`,
                items: allCategoriesData
            }
        };
        const allComparedCategoriesData = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.comparedCategoriesSales);
        const comparedTabs = {
            [t("allCategories")]: {
                title: `${t("allCategories")}`,
                items: allComparedCategoriesData
            }
        };
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "card-container",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "span-2",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $56815f93a4fad611$export$2e2bcd8739ae039), {
                        searchHandler: this.updateSearchQuery,
                        sortHandler: this.updateSort,
                        sortBy: this.state.sortBy,
                        direction: this.state.sortDirection,
                        mode: "minimal"
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: this.context.comparedPeriod ? "" : "span-2 centered",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("categoriesSales"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod?.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "sales-table categories-sales-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.categoriesSales || [],
                                        updateProductSku: this.props.updateCategoryName,
                                        type: "categories-sales-list",
                                        loading: this.state.loading,
                                        withNavigation: true
                                    })
                                }),
                                !this.state.loading && this.state.searchQuery && !this.state.categoriesSales.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    children: t("noSearchResult", {
                                        ns: "common"
                                    })
                                })
                            ]
                        }),
                        this.state.totalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                            totalPageCount: this.state.totalPages,
                            currentPage: this.state.currentPage,
                            pageNeighbors: 1,
                            changePageHandler: this.updateCurrentPage
                        })
                    ]
                }),
                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("categoriesSales"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "sales-table categories-sales-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.comparedCategoriesSales || [],
                                        updateProductSku: this.props.updateCategoryName,
                                        type: "categories-sales-list",
                                        loading: this.state.comparedLoading,
                                        withNavigation: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    children: !this.state.comparedLoading && this.state.searchQuery && !this.state.comparedCategoriesSales.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        children: t("noSearchResult", {
                                            ns: "common"
                                        })
                                    })
                                })
                            ]
                        }),
                        this.state.comparedTotalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                            totalPageCount: this.state.comparedTotalPages,
                            currentPage: this.state.comparedCurrentPage,
                            pageNeighbors: 1,
                            changePageHandler: this.updateComparedCurrentPage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    ref: this.props.exportRef,
                    className: `card ${this.context.comparedPeriod ? "" : "span-2 centered"}`,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                        title: t("categorySales"),
                        tabs: tabs,
                        duration: true,
                        currentPeriod: this.context.currentPeriod
                    })
                }),
                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "card",
                    ref: this.props.exportRef,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                        title: t("comparedCategoryBreakdown"),
                        tabs: comparedTabs,
                        duration: true,
                        currentPeriod: this.context.comparedPeriod
                    })
                })
            ]
        });
    }
}
$28d19387d4420476$var$CategoriesSales.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $28d19387d4420476$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "categories",
    "common"
])($28d19387d4420476$var$CategoriesSales);



/* eslint-disable react/no-did-update-set-state */ /**
 * @author Sarah Nouh
 * @date 2021-01-01
 * @description Represents the content of any top selling table in the app
 * @filename table-content.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


class $a178670604cb32d7$export$c3762807d12c1ef5 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    static #_ = this.defaultProps = {
        salesValue: "",
        currency: "",
        stock: "",
        isCompare: true
    };
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
            className: "category table-row",
            children: [
                this.props.rowItem.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                    src: this.props.rowItem.image_url,
                    alt: this.props.rowItem.name,
                    onError: (e)=>{
                        (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                    }
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                    alt: this.props.rowItem.name
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "row-id",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "row-id__number",
                            children: (0, $48f673e197675daa$export$d4fc9e597530c349)(this.props.itemIndex + 1)
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "row-id__title",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "item-name",
                                    children: this.props.rowItem.name
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "tooltip",
                                    children: this.props.rowItem.name
                                })
                            ]
                        }),
                        this.props.rowItem.sku && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                            className: "item-sku",
                            children: `sku: ${this.props.rowItem.sku}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: `percentage ${!this.props.isCompare && "no-compare"}`,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "percentage__value",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    children: `${this.props.percentageValue}%`
                                }),
                                this.props.type === "categories" ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    children: this.props.listBy === "sales_value" ? `${this.props.salesValue} ${this.props.currency}` : `${(0, $48f673e197675daa$export$4640587ffa669919)(this.props.rowItem.number_sold)} sold`
                                }) : null,
                                this.props.type === "stock" ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.props.rowItem.number_of_items)} sold . ${this.props.salesValue} ${this.props.currency}`
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                className: `filling ${this.props.percentageValue >= 100 ? "full" : null}`,
                                style: {
                                    width: `${this.props.percentageValue}%`
                                }
                            })
                        }),
                        this.props.type === "stock" ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "percentage__stock",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                children: `${this.props.stock} in stock`
                            })
                        }) : null
                    ]
                })
            ]
        }, this.props.rowItem.name);
    }
}


/**
 * @author Karim Shalapy
 * @date 2022-09-21
 * @description page for a specific category details
 * @filename categories-details.tsx
 */ 


var $igtsr = parcelRequire("igtsr");












class $0ba10f359e696966$var$CategoryDetails extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loadingCategorySummary: true,
            loadingComparedCategorySummary: true,
            loadingCategoryChildren: true,
            loadingComparedCategoryChildren: true,
            id: Date.now().toString(),
            categoryChildrenSales: null,
            comparedCategoryChildrenSales: null,
            categorySummary: null,
            previousCategorySummary: null,
            comparedCategorySummary: null,
            currentPage: 1,
            comparedCurrentPage: 1,
            totalPages: 1,
            comparedTotalPages: 1,
            searchQuery: ""
        };
        this.updateSearchQuery = this.updateSearchQuery.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.loadAllData = this.loadAllData.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.updateComparedCurrentPage = this.updateComparedCurrentPage.bind(this);
        this.loadCategoryChildren = this.loadCategoryChildren.bind(this);
        this.loadPreviousCategorySummary = this.loadPreviousCategorySummary.bind(this);
        this.loadComparedCategoryChildren = this.loadComparedCategoryChildren.bind(this);
    }
    componentDidMount() {
        this.loadAllData();
        this.context.addUpdatesListener(this.state.id, this.loadAllData);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.categoryName !== prevProps.categoryName) this.loadAllData();
        else {
            const sortChanged = prevState.sortBy !== this.state.sortBy || prevState.sortDirection !== this.state.sortDirection;
            const searchChanged = prevState.searchQuery !== this.state.searchQuery;
            if (prevState.currentPage !== this.state.currentPage || sortChanged || searchChanged) this.loadCategoryChildren().catch((error)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
            }).finally(()=>{
                this.setState({
                    loadingCategoryChildren: false
                });
            });
            if (prevState.comparedCurrentPage !== this.state.comparedCurrentPage || sortChanged || searchChanged) this.loadComparedCategoryChildren().catch((error)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
            }).finally(()=>{
                this.setState({
                    loadingComparedCategoryChildren: false
                });
            });
        }
    }
    updateSearchQuery(searchQuery) {
        this.setState({
            searchQuery: searchQuery,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateSort(sortBy, sortDirection) {
        if (!sortBy || !sortDirection) {
            this.setState({
                sortBy: undefined,
                sortDirection: undefined,
                currentPage: 1,
                comparedCurrentPage: 1
            });
            return;
        }
        this.setState({
            sortBy: sortBy,
            sortDirection: sortDirection,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateCurrentPage(currentPage) {
        this.setState({
            currentPage: currentPage
        });
    }
    updateComparedCurrentPage(comparedCurrentPage) {
        this.setState({
            comparedCurrentPage: comparedCurrentPage
        });
    }
    loadCategoryChildren() {
        this.setState({
            loadingCategoryChildren: true
        });
        let categoryChildrenSales = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) categoryChildrenSales = (0, $63979a364d2860b9$export$1cfac77223a58c64)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            parentName: this.props.categoryName,
            currentPage: this.state.currentPage,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                categoryChildrenSales: res.data.subcategories,
                categorySummary: {
                    name: res.data.name,
                    image_url: res.data.image_url,
                    sales_value: res.data.sales_value,
                    number_sold: res.data.number_sold,
                    subcategory_count: res.data.subcategory_count
                },
                loadingCategoryChildren: false,
                totalPages: res.pagination.totalPageCount || 1
            });
        });
        return categoryChildrenSales;
    }
    loadPreviousCategorySummary() {
        this.setState({
            loadingCategorySummary: true
        });
        let previousCategorySummaryPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) previousCategorySummaryPromise = (0, $63979a364d2860b9$export$1cfac77223a58c64)({
            project: this.context.project,
            from: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.from).from,
            to: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.to).to,
            parentName: this.props.categoryName,
            currentPage: this.state.currentPage,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                previousCategorySummary: {
                    name: res.data.name,
                    image_url: res.data.image_url,
                    sales_value: res.data.sales_value,
                    number_sold: res.data.number_sold,
                    subcategory_count: res.data.subcategory_count
                },
                loadingCategorySummary: false
            });
        });
        return previousCategorySummaryPromise;
    }
    loadComparedCategoryChildren() {
        this.setState({
            loadingComparedCategoryChildren: true
        });
        let comparedCategoryChildrenSales = Promise.resolve();
        if (this.context.comparedPeriod) comparedCategoryChildrenSales = (0, $63979a364d2860b9$export$1cfac77223a58c64)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            parentName: this.props.categoryName,
            currentPage: this.state.comparedCurrentPage,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                comparedCategoryChildrenSales: res.data.subcategories,
                comparedCategorySummary: {
                    name: res.data.name,
                    image_url: res.data.image_url,
                    sales_value: res.data.sales_value,
                    number_sold: res.data.number_sold,
                    subcategory_count: res.data.subcategory_count
                },
                loadingComparedCategorySummary: false,
                loadingComparedCategoryChildren: false,
                comparedTotalPages: res.pagination.totalPageCount || 1
            });
        });
        return comparedCategoryChildrenSales;
    }
    loadAllData() {
        const categoryChildrenSales = this.loadCategoryChildren();
        const previousCategorySummary = this.loadPreviousCategorySummary();
        const comparedCategoryChildrenSales = this.loadComparedCategoryChildren();
        Promise.all([
            categoryChildrenSales,
            previousCategorySummary,
            comparedCategoryChildrenSales
        ]).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        }).finally(()=>{
            this.setState({
                loadingCategoryChildren: false,
                loadingCategorySummary: false,
                loadingComparedCategorySummary: false
            });
        });
    }
    render() {
        const { t: t } = this.props;
        const allCategoriesData = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.categoryChildrenSales);
        const allComparedCategoriesData = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.comparedCategoryChildrenSales);
        const tabs = {
            [t(this.props.categoryName)]: {
                title: `${t(this.props.categoryName)}`,
                items: allCategoriesData
            }
        };
        const comparedTabs = {
            [t(this.props.categoryName)]: {
                title: `${t(this.props.categoryName)}`,
                items: allComparedCategoriesData
            }
        };
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "product-analytics",
            ref: this.props.exportRef,
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card-container",
                children: [
                    this.state.loadingCategorySummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "information-card",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "product-info",
                                children: [
                                    this.state.categorySummary?.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                        src: this.state.categorySummary?.image_url,
                                        alt: this.state.categorySummary?.name,
                                        onError: (e)=>{
                                            (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                        }
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                        alt: this.state.categorySummary?.name
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "product-name",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "title",
                                                children: this.state.categorySummary?.name
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "tooltip",
                                                children: this.state.categorySummary?.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "product-count",
                                        children: [
                                            (0, $48f673e197675daa$export$4640587ffa669919)(this.state.categorySummary?.subcategory_count),
                                            " ",
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: t("subcategories")
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {}),
                    this.state.loadingCategorySummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "product-sales",
                        children: [
                            this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                className: "card--title",
                                children: [
                                    t(this.context.currentPeriod.alias, {
                                        ns: "common"
                                    }),
                                    " (",
                                    new Date(this.context.currentPeriod.to).getFullYear(),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "card product-sales transparent-card",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "stats-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("unitsSold")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.categorySummary?.number_sold)
                                                }),
                                                !this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                    current: this.state.categorySummary?.number_sold,
                                                    previous: this.state.previousCategorySummary?.number_sold
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("totalSalesValue")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.categorySummary?.sales_value)} ${this.context.settings.currency}`
                                                }),
                                                !this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                    current: this.state.categorySummary?.sales_value,
                                                    previous: this.state.previousCategorySummary?.sales_value
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    this.context.comparedPeriod && (this.state.loadingComparedCategorySummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "product-sales",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                className: "card--title",
                                children: [
                                    t(this.context.comparedPeriod.alias, {
                                        ns: "common"
                                    }),
                                    " (",
                                    new Date(this.context.comparedPeriod.to).getFullYear(),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "card product-sales transparent-card",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "stats-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("unitsSold", {
                                                        ns: "product"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedCategorySummary?.number_sold)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("totalSalesValue", {
                                                        ns: "product"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedCategorySummary?.sales_value)} ${this.context.settings.currency}`
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "span-2",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $56815f93a4fad611$export$2e2bcd8739ae039), {
                            searchHandler: this.updateSearchQuery,
                            sortHandler: this.updateSort,
                            sortBy: this.state.sortBy,
                            direction: this.state.sortDirection,
                            mode: "minimal"
                        })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: this.context.comparedPeriod ? "" : "span-2 centered",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                        className: "card--title",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            children: [
                                                t("subcategoriesSales"),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "duration",
                                                    children: [
                                                        "(",
                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "sales-table categories-sales-table big",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                            products: this.state.categoryChildrenSales || [],
                                            loading: this.state.loadingCategoryChildren,
                                            type: "categories-children-sales-list"
                                        })
                                    }),
                                    !this.state.loadingCategoryChildren && this.state.searchQuery && !this.state.categoryChildrenSales.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        children: t("noSearchResult", {
                                            ns: "common"
                                        })
                                    })
                                ]
                            }),
                            this.state.totalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.totalPages,
                                currentPage: this.state.currentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updateCurrentPage
                            })
                        ]
                    }),
                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                        className: "card--title",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            children: [
                                                t("subcategoriesSales"),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "duration",
                                                    children: [
                                                        "(",
                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "sales-table categories-sales-table big",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                            products: this.state.comparedCategoryChildrenSales || [],
                                            loading: this.state.loadingComparedCategoryChildren,
                                            type: "categories-children-sales-list"
                                        })
                                    }),
                                    !this.state.loadingComparedCategoryChildren && this.state.searchQuery && !this.state.comparedCategoryChildrenSales.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        children: t("noSearchResult", {
                                            ns: "common"
                                        })
                                    })
                                ]
                            }),
                            this.state.comparedTotalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.comparedTotalPages,
                                currentPage: this.state.comparedCurrentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updateComparedCurrentPage
                            })
                        ]
                    }),
                    this.state.categoryChildrenSales && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: `card ${this.context.comparedPeriod ? "" : "span-2 centered"}`,
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                            tabs: tabs,
                            title: t(this.props.categoryName)
                        })
                    }),
                    this.state.comparedCategoryChildrenSales && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                            tabs: comparedTabs,
                            title: t(this.props.categoryName)
                        })
                    })
                ]
            })
        }, this.state.id);
    }
}
$0ba10f359e696966$var$CategoryDetails.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $0ba10f359e696966$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "categories",
    "common"
])($0ba10f359e696966$var$CategoryDetails);


class $aeedc61284241a45$var$Categories extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.exportTopCategoriesRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportCategoriesSalesRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportCategoryDetailsSalesRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        const query = window.location.search;
        const params = new URLSearchParams(query);
        this.state = {
            activeTab: params.get("activeTab") ?? "top_selling_categories",
            loading: true,
            categories: [],
            categoriesSalesExport: [],
            id: Date.now().toString(),
            selectedCategory: ""
        };
        this.loadData = this.loadData.bind(this);
        this.updateSelectedCategory = this.updateSelectedCategory.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams(this.state.activeTab, this.context.listBy);
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Categories";
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab) {
            this.context.updateUrlQueryParams(this.state.activeTab, this.context.listBy);
            // set page title
            switch(this.state.activeTab){
                case "top_selling_categories":
                    document.title = "Categories";
                    break;
                case "categories_sales":
                    document.title = "Categories Sales";
                    break;
                default:
                    document.title = "Categories";
                    break;
            }
        }
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    updateSelectedCategory(categoryName) {
        this.setState({
            selectedCategory: categoryName
        });
    }
    loadData() {
        this.setState({
            loading: true
        });
        let categoriesPromise = Promise.resolve();
        let categoriesSalesExportPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            categoriesPromise = (0, $63979a364d2860b9$export$7a0f33e8df10bd94)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                sort: this.context.listBy,
                filters: this.context.appliedFilters
            }).then((categories)=>{
                this.setState({
                    categories: categories
                });
            });
            categoriesSalesExportPromise = (0, $63979a364d2860b9$export$d3d5342ecda9a5a6)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                sort: this.context.listBy,
                filters: this.context.appliedFilters
            }).then((categoriesSalesExport)=>{
                this.setState({
                    categoriesSalesExport: categoriesSalesExport
                });
            });
        }
        let comparedCategoriesPromise = Promise.resolve();
        let comparedCategoriesSalesExportPromise = Promise.resolve();
        if (this.context.comparedPeriod) {
            comparedCategoriesPromise = (0, $63979a364d2860b9$export$7a0f33e8df10bd94)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                sort: this.context.listBy,
                filters: this.context.appliedFilters
            }).then((comparedCategories)=>{
                this.setState({
                    comparedCategories: comparedCategories
                });
            });
            comparedCategoriesSalesExportPromise = (0, $63979a364d2860b9$export$d3d5342ecda9a5a6)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                sort: this.context.listBy,
                filters: this.context.appliedFilters
            }).then((comparedCategoriesSalesExport)=>{
                this.setState({
                    comparedCategoriesSalesExport: comparedCategoriesSalesExport
                });
            });
        } else this.setState({
            comparedCategories: undefined,
            comparedCategoriesSalesExport: undefined
        });
        Promise.all([
            categoriesPromise,
            comparedCategoriesPromise,
            categoriesSalesExportPromise,
            comparedCategoriesSalesExportPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                loading: false
            });
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "categories",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("categories"),
                    exportRef: this.state.activeTab === "top_selling_categories" ? this.exportTopCategoriesRef : this.exportCategoriesSalesRef
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "tabs",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "top_selling_categories" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "top_selling_categories") {
                                    this.setState({
                                        activeTab: "top_selling_categories"
                                    });
                                    (0, $9702949453a4f797$export$3c311ccce60fdde)(this.state.activeTab, this.context.listBy);
                                }
                            },
                            children: t("topSellingCategories")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "categories_sales" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "categories_sales") {
                                    this.setState({
                                        activeTab: "categories_sales"
                                    });
                                    (0, $9702949453a4f797$export$3c311ccce60fdde)(this.state.activeTab, this.context.listBy);
                                }
                            },
                            children: t("categoriesSales")
                        })
                    ]
                }),
                this.state.activeTab === "top_selling_categories" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "toggler",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: `toggle ${this.context.listBy === "sales_value" ? "active" : ""}`,
                                    onClick: ()=>{
                                        // update to the new listing type in the context and the new data will be fetched
                                        if (this.context.listBy !== "sales_value") this.context.updateListingType(this.state.activeTab, "sales_value");
                                    },
                                    children: t("salesValue")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: `toggle ${this.context.listBy === "number_sold" ? "active" : ""}`,
                                    onClick: ()=>{
                                        if (this.context.listBy !== "number_sold") this.context.updateListingType(this.state.activeTab, "number_sold");
                                    },
                                    children: t("numberSold")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            ref: this.exportTopCategoriesRef,
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: this.context.comparedPeriod ? "card-container" : "flex justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "card categories--table",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "categories--body",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "card--title",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            children: [
                                                                t("topSellingCategories"),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                                    className: "duration",
                                                                    children: [
                                                                        "(",
                                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        this.state.categoriesSalesExport?.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                                            data: this.state.categoriesSalesExport,
                                                            filename: `categories_sales breakdown from:${this.context.currentPeriod?.from}-to:${this.context.currentPeriod?.to}.csv`,
                                                            className: "export-list-button",
                                                            target: "_blank",
                                                            children: t("exportList")
                                                        }) : null
                                                    ]
                                                }),
                                                this.state.categories?.map((category, index)=>{
                                                    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a178670604cb32d7$export$c3762807d12c1ef5), {
                                                        rowItem: category,
                                                        type: "categories",
                                                        itemIndex: index,
                                                        salesValue: (0, $48f673e197675daa$export$4640587ffa669919)(category.sales_value),
                                                        currency: this.context.settings.currency,
                                                        percentageValue: category.percentage,
                                                        isCompare: !!this.context.comparedPeriod,
                                                        listBy: this.context.listBy
                                                    }, index);
                                                })
                                            ]
                                        })
                                    }),
                                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "card categories--table",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "categories--body",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "card--title",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            children: [
                                                                t("topSellingCategories"),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                                    className: "duration",
                                                                    children: [
                                                                        "(",
                                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        this.state.comparedCategoriesSalesExport?.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                                            data: this.state.comparedCategoriesSalesExport,
                                                            filename: `categories_sales breakdown from:${this.context.comparedPeriod?.from}-to:${this.context.comparedPeriod?.to}.csv`,
                                                            className: "export-list-button",
                                                            target: "_blank",
                                                            children: t("exportList")
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                                    children: this.state.comparedCategories?.map((category, index)=>{
                                                        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a178670604cb32d7$export$c3762807d12c1ef5), {
                                                            type: "categories",
                                                            rowItem: category,
                                                            salesValue: (0, $48f673e197675daa$export$4640587ffa669919)(category.sales_value),
                                                            currency: this.context.settings.currency,
                                                            itemIndex: index,
                                                            percentageValue: category.percentage,
                                                            listBy: this.context.listBy
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                this.state.activeTab === "categories_sales" && (this.state.selectedCategory ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                            className: "products-button--back",
                            type: "button",
                            onClick: ()=>{
                                this.setState({
                                    selectedCategory: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                t("backToList")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0ba10f359e696966$export$2e2bcd8739ae039), {
                            categoryName: this.state.selectedCategory,
                            updateCategoryName: this.updateSelectedCategory,
                            exportRef: this.exportCategoryDetailsSalesRef
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $28d19387d4420476$export$2e2bcd8739ae039), {
                    updateCategoryName: this.updateSelectedCategory,
                    exportRef: this.exportCategoriesSalesRef
                }))
            ]
        });
    }
}
$aeedc61284241a45$var$Categories.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $aeedc61284241a45$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("categories")($aeedc61284241a45$var$Categories);


/**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description customers tab of the App.
 * @filename customers.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


var $7bd2ba507819a70f$export$eb3485a690c2f0b8 = /*#__PURE__*/ function(UserRole) {
    UserRole["admin"] = "admin";
    UserRole["management"] = "management";
    UserRole["marketing"] = "marketing";
    UserRole["operations"] = "operations";
    return UserRole;
}({});
var $7bd2ba507819a70f$export$613603fcbf711065 = /*#__PURE__*/ function(UserPlatform) {
    UserPlatform["magento"] = "magento";
    UserPlatform["woocommerce"] = "woocommerce";
    return UserPlatform;
}({});



/**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description customers tab of the App.
 * @filename customers.tsx
 */ 





var $igtsr = parcelRequire("igtsr");





parcelRequire("igtsr");
const $db463a54a8c7995f$var$SvgTotalCustomers = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M-295-288h1366v768H-295z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(-30 -133)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 252.7,
                            height: 289,
                            fill: "#FFF",
                            stroke: "#9DA4C2",
                            strokeOpacity: 0.164,
                            rx: 10
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                            transform: "translate(30 133.5)",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                    fillRule: "nonzero",
                                    d: "M4.32 7.68h3.36A4.32 4.32 0 0 1 12 12H0a4.32 4.32 0 0 1 4.32-4.32"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                                    cx: 6,
                                    cy: 4.08,
                                    r: 2.88,
                                    opacity: 0.299
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $db463a54a8c7995f$export$2e2bcd8739ae039 = $db463a54a8c7995f$var$SvgTotalCustomers;




/**
 * @author Ahmed Serag
 * @date 2021-07-02
 * @description Implementation of Customers related utilities.
 * @filename customers.ts
 */ /**
 * @author Ahmed Serag
 * @date 2020-07-20
 * @description implementation of Customer related API calls.
 * @filename customer.ts
 */ 


class $8b9dd4161659d235$export$aa093906ffb6389d {
    static CustomersOverview({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customers.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customers.method
        });
    }
    static numberOfCustomersPerDay({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersPerDay.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).ordersPerDay.method
        });
    }
    static customersSpending({ project: project, from: from, to: to, filters: filters = {}, with_list: with_list = 0 }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersSpending.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("with_list", with_list.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersSpending.method
        });
    }
    static customersSpentMore({ project: project, from: from, to: to, order_value: order_value, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersSpentOrderedMore.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("order_value", order_value);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersSpentOrderedMore.method
        });
    }
    static customersOrderedMore({ project: project, from: from, to: to, frequency: frequency, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersSpentOrderedMore.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("frequency", frequency);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customersSpentOrderedMore.method
        });
    }
    /**
   * get list and total count of a customer segment according to type
   * @param project
   * @param from
   * @param to
   * @param filters
   * @param segment
   * @returns
   */ static customerSegmentsByType({ project: project, from: from, to: to, filters: filters = {}, segment: segment }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customerSegmentsByType.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("segment", segment.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).customerSegmentsByType.method
        });
    }
}



function $eb4017638650c249$export$ea22d7cbe968734d(payload) {
    return (0, $8b9dd4161659d235$export$aa093906ffb6389d).numberOfCustomersPerDay(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eb4017638650c249$export$8002a62c2cd3a96(payload) {
    return (0, $8b9dd4161659d235$export$aa093906ffb6389d).CustomersOverview(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload).then((overview)=>{
            return overview;
        });
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eb4017638650c249$export$bf70b51d5d308625(payload) {
    return (0, $8b9dd4161659d235$export$aa093906ffb6389d).customersSpending(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eb4017638650c249$export$1b343b8ec856387f(payload) {
    return (0, $8b9dd4161659d235$export$aa093906ffb6389d).customersSpentMore(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eb4017638650c249$export$3babc6057f027b0b(payload) {
    return (0, $8b9dd4161659d235$export$aa093906ffb6389d).customersOrderedMore(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $eb4017638650c249$export$a807b835c6d8b08d(payload) {
    return (0, $8b9dd4161659d235$export$aa093906ffb6389d).customerSegmentsByType(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}


class $455dc6603e408162$var$CustomersOverview extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props), /* the allowed segment types using there localization keys
  the segment types are mapped to their indices such as
  0 -> allUsers
  1 -> newUsers
  2 -> newCustomers
  3 -> returningCustomers
  4-> newUsersWithNoOrders */ this.customerSegmentTypes = [
            "allUsers",
            "newUsers",
            "newCustomers",
            "returningCustomers",
            "newUsersWithNoOrders"
        ];
        this.ChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            loading: true,
            customerSegmentType: 3,
            customerSegmentTypeMenu: false,
            customerSegmentTypeLoading: true,
            id: Date.now().toString()
        };
        this.loadData = this.loadData.bind(this);
        this.toggleCustomerSegmentTypeMenu = this.toggleCustomerSegmentTypeMenu.bind(this);
        this.getCustomerSegmentsByType = this.getCustomerSegmentsByType.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Customers Overview";
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    getCustomerSegmentsByType() {
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            this.setState({
                customerSegmentTypeLoading: true
            });
            (0, $eb4017638650c249$export$a807b835c6d8b08d)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters,
                segment: this.state.customerSegmentType
            }).then((data)=>{
                this.setState({
                    segmentList: data.list,
                    segmentTotalCount: data.total_count,
                    customerSegmentTypeLoading: false
                });
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
        }
    }
    loadData() {
        this.setState({
            loading: true
        });
        const datasets = [];
        const chart = this.state.chart;
        let customersOverviewPromise = Promise.resolve();
        let customersPerDayPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            customersOverviewPromise = (0, $eb4017638650c249$export$8002a62c2cd3a96)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((overview)=>{
                this.setState({
                    ...overview
                });
                this.getCustomerSegmentsByType();
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
            customersPerDayPromise = (0, $eb4017638650c249$export$ea22d7cbe968734d)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((customersPerDay)=>{
                datasets.push({
                    label: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:newCustomers"),
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.currentPeriod, customersPerDay.new_customer_count, "sum"),
                    backgroundColor: "#3DD2CE",
                    title: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:monthlyBreakdown")
                });
                datasets.push({
                    label: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:returnCustomers"),
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.currentPeriod, customersPerDay.returning_customer_count, "sum"),
                    backgroundColor: "#1792FF",
                    title: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:monthlyBreakdown")
                });
                this.setState({
                    customersPerDay: customersPerDay
                });
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
        }
        let comparedCustomersOverviewPromise = Promise.resolve();
        let comparedCustomersPerDayPromise = Promise.resolve();
        if (this.context.comparedPeriod) {
            comparedCustomersOverviewPromise = (0, $eb4017638650c249$export$8002a62c2cd3a96)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedCustomersOverview)=>{
                this.setState({
                    comparedCustomersOverview: comparedCustomersOverview
                });
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
            comparedCustomersPerDayPromise = (0, $eb4017638650c249$export$ea22d7cbe968734d)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedCustomersPerDay)=>{
                datasets.push({
                    label: "compared new customers",
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.comparedPeriod, comparedCustomersPerDay.new_customer_count, "sum"),
                    title: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:monthlyBreakdown")
                });
                datasets.push({
                    label: "compared returning customers",
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.comparedPeriod, comparedCustomersPerDay.returning_customer_count, "sum"),
                    title: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:monthlyBreakdown")
                });
                this.setState({
                    comparedCustomersPerDay: comparedCustomersPerDay
                });
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
        } else this.setState({
            comparedCustomersOverview: null,
            comparedCustomersPerDay: null
        });
        Promise.all([
            customersOverviewPromise,
            customersPerDayPromise,
            comparedCustomersOverviewPromise,
            comparedCustomersPerDayPromise
        ]).then(()=>{
            this.setState({
                loading: false
            }, ()=>{
                // Only create chart after state update and canvas is mounted
                if (this.ChartRef.current) {
                    // Destroy old chart if exists
                    if (this.state.chart) this.state.chart.destroy();
                    // Create new chart
                    const newChart = (0, $54c7c3206a2399da$export$99199eb0d2d4ab39)(this.ChartRef.current, (0, $54c7c3206a2399da$export$2e2f40d1b5b08307)(this.context.currentPeriod), datasets, this.state.id);
                    // Save it in state so you can destroy it next time
                    this.setState({
                        chart: newChart
                    });
                }
            });
        });
    }
    toggleCustomerSegmentTypeMenu() {
        this.setState({
            customerSegmentTypeMenu: !this.state.customerSegmentTypeMenu
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            ref: this.props.exportRef,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card overview-card transparent-card",
                    children: [
                        Object.keys(this.context.appliedFilters).length > 0 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "disclaimer",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                children: t("customersAppliedFiltersDisclaimer")
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                            className: "card--title",
                            children: [
                                t("customers"),
                                " ",
                                t(this.context.currentPeriod.alias),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    className: "duration",
                                    children: [
                                        "(",
                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "overview-items",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "tooltip",
                                            children: t("newCustomersDisclaimer")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.new_customer_count)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("newCustomers")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "tooltip",
                                            children: t("newUsersDisclaimer")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.new_users_count)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("newUsers")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "tooltip",
                                            children: t("returningCustomersDisclaimer")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.returning_customer_count)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("returnCustomers")
                                        })
                                    ]
                                }),
                                this.state.guest_customer_count > 0 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.guest_customer_count)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("guestCustomers")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "tooltip",
                                            children: t("totalCustomersDisclaimer")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.total_customers)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalCustomersAllTime")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "tooltip",
                                            children: t("totalUsersDisclaimer")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.total_users)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalUsersAllTime")
                                        })
                                    ]
                                })
                            ]
                        }),
                        this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("customers"),
                                        " ",
                                        t(this.context.comparedPeriod?.alias),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod.from, this.context.comparedPeriod.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "overview-items",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.comparedCustomersOverview?.new_customer_count)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("newCustomers")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.state.comparedCustomersOverview?.returning_customer_count)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("returnCustomers")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title card-graph--title",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                children: [
                                    t("monthlyBreakdown"),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                        className: "duration",
                                        children: [
                                            "(",
                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "bar-chart__container",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("canvas", {
                                ref: this.ChartRef,
                                id: this.state.id
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "calculators",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                className: "card--title",
                                children: t("exportCustomerList")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card--section",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "dropdown-container",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "secondary",
                                                children: t("customerType")
                                            }),
                                            t(this.customerSegmentTypes[this.state.customerSegmentType]),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                className: "dropdown-icon",
                                                enableBackground: "new 0 0 330 330",
                                                onClick: this.toggleCustomerSegmentTypeMenu
                                            }),
                                            this.state.customerSegmentTypeMenu && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "dropdown-menu",
                                                children: this.customerSegmentTypes.map((segment, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: `item ${this.state.customerSegmentType === index ? "active" : ""}`,
                                                        onClick: ()=>{
                                                            this.setState({
                                                                customerSegmentType: index
                                                            });
                                                            this.toggleCustomerSegmentTypeMenu();
                                                        },
                                                        children: t(segment)
                                                    }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "submit",
                                        className: "button save",
                                        onClick: this.getCustomerSegmentsByType,
                                        children: t("apply")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dl", {
                                className: "quartile-card__list",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $db463a54a8c7995f$export$2e2bcd8739ae039), {}),
                                            " ",
                                            t("totalCustomers")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                        children: this.state.customerSegmentTypeLoading ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {}) : (0, $48f673e197675daa$export$4640587ffa669919)(this.state.segmentTotalCount)
                                    })
                                ]
                            }),
                            this.state.segmentList && !this.state.customerSegmentTypeLoading ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                data: this.state.segmentList,
                                filename: `${t(this.customerSegmentTypes[this.state.customerSegmentType])}.csv`,
                                className: "export-list-button",
                                target: "_blank",
                                children: t("exportList")
                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            ]
        });
    }
}
$455dc6603e408162$var$CustomersOverview.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $455dc6603e408162$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("customers")($455dc6603e408162$var$CustomersOverview);


/**
 * @author Ahmed Elshantaly
 * @date 2022-01-17
 * @description customers spending tab.
 * @filename customers-spending.tsx
 */ 

var $igtsr = parcelRequire("igtsr");




var $4l1Xa = parcelRequire("4l1Xa");


/**
 * @author Ahmed Elshantaly
 * @date 2022-01-18
 * @description declaration of customers spending interface.
 * @filename customers-spending.ts
 */ var $3e9221e7d9610964$export$73b7a15fdd8b4f5c = /*#__PURE__*/ function(Quartiles) {
    Quartiles["Quartile1"] = "Quartile 1";
    Quartiles["Quartile2"] = "Quartile 2";
    Quartiles["Quartile3"] = "Quartile 3";
    Quartiles["Quartile4"] = "Quartile 4";
    return Quartiles;
}({});







parcelRequire("igtsr");
const $b62697973d7279dd$var$SvgArrowUp = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M-295-317h1366v768H-295z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(-30 -162)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 252.7,
                            height: 289,
                            fill: "#FFF",
                            stroke: "#9DA4C2",
                            strokeOpacity: 0.164,
                            rx: 10
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M34.32 169.7h3.36v3.32a1 1 0 0 1-1 1h-1.36a1 1 0 0 1-1-1z",
                            opacity: 0.299
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "m36.749 163.827 3.3 3.73a1 1 0 0 1-.749 1.663h-6.6a1 1 0 0 1-.75-1.663l3.301-3.73a1 1 0 0 1 1.498 0"
                        })
                    ]
                })
            ]
        })
    });
var $b62697973d7279dd$export$2e2bcd8739ae039 = $b62697973d7279dd$var$SvgArrowUp;



parcelRequire("igtsr");
const $8226bb9dd73cbae7$var$SvgArrowDown = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M-295-347h1366v768H-295z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(-30 -192)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 252.7,
                            height: 289,
                            fill: "#FFF",
                            stroke: "#9DA4C2",
                            strokeOpacity: 0.164,
                            rx: 10
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M34.32 196.8h3.36v-3.32a1 1 0 0 0-1-1h-1.36a1 1 0 0 0-1 1z",
                            opacity: 0.299
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "m36.749 202.673 3.3-3.73a1 1 0 0 0-.749-1.663h-6.6a1 1 0 0 0-.75 1.663l3.301 3.73a1 1 0 0 0 1.498 0"
                        })
                    ]
                })
            ]
        })
    });
var $8226bb9dd73cbae7$export$2e2bcd8739ae039 = $8226bb9dd73cbae7$var$SvgArrowDown;



class $ca02a7743031abf8$var$CustomersSpending extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            id: Date.now().toString(),
            orderedMoreInitialNumber: 2,
            sectionLoader: false
        };
        this.loadData = this.loadData.bind(this);
        this.getCustomerSpendingList = this.getCustomerSpendingList.bind(this);
        this.updateSpentMore = this.updateSpentMore.bind(this);
        this.updateOrderedMore = this.updateOrderedMore.bind(this);
        this.getSpentMore = this.getSpentMore.bind(this);
        this.getOrderedMore = this.getOrderedMore.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Customers Spending";
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    getCustomerSpendingList() {
        this.setState({
            sectionLoader: true
        });
        let customersSpendingListPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            customersSpendingListPromise = (0, $eb4017638650c249$export$bf70b51d5d308625)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters,
                with_list: 1
            }).then((quartiles)=>{
                this.setState({
                    quartiles: [
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile1],
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile2],
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile3],
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile4]
                    ]
                });
                this.setState({
                    maxSpending: this.state.quartiles.reduce((prev, current)=>{
                        return prev.average > current.average ? prev : current;
                    }).average,
                    minSpending: this.state.quartiles.reduce((prev, current)=>{
                        return prev.average < current.average ? prev : current;
                    }).average,
                    spentMoreInitialNumber: Math.ceil(this.state.quartiles[1].average)
                });
                this.getSpentMore(String(this.state.spentMoreInitialNumber));
                this.getOrderedMore(String(this.state.orderedMoreInitialNumber));
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
            Promise.all([
                customersSpendingListPromise
            ]).then(()=>{
                this.setState({
                    sectionLoader: false
                });
            });
        }
    }
    getSpentMore(money) {
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) (0, $eb4017638650c249$export$1b343b8ec856387f)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            order_value: String(money),
            filters: this.context.appliedFilters
        }).then((value)=>{
            this.setState({
                spentMoreTotal: value.count,
                spentMoreMax: value.maximum,
                spentMoreList: value.list
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        });
    }
    getOrderedMore(orders) {
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) (0, $eb4017638650c249$export$3babc6057f027b0b)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            frequency: String(orders),
            filters: this.context.appliedFilters
        }).then((value)=>{
            this.setState({
                orderedMoreTotal: value.count,
                orderedMoreMax: value.maximum,
                orderedMoreList: value.list
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        });
    }
    loadData() {
        this.setState({
            loading: true
        });
        let customersSpendingPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            customersSpendingPromise = (0, $eb4017638650c249$export$bf70b51d5d308625)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((quartiles)=>{
                this.setState({
                    quartiles: [
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile1],
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile2],
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile3],
                        quartiles[(0, $3e9221e7d9610964$export$73b7a15fdd8b4f5c).Quartile4]
                    ]
                });
                this.setState({
                    maxSpending: this.state.quartiles.reduce((prev, current)=>{
                        return prev.average > current.average ? prev : current;
                    }).average,
                    minSpending: this.state.quartiles.reduce((prev, current)=>{
                        return prev.average < current.average ? prev : current;
                    }).average,
                    spentMoreInitialNumber: Math.ceil(this.state.quartiles[1].average)
                });
                this.getSpentMore(String(this.state.spentMoreInitialNumber));
                this.getOrderedMore(String(this.state.orderedMoreInitialNumber));
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
            Promise.all([
                customersSpendingPromise
            ]).then(()=>{
                this.setState({
                    loading: false
                });
            });
        }
        this.getCustomerSpendingList();
    }
    updateSpentMore(values, formikHelpers) {
        this.setState({
            spentMoreInitialNumber: values.amountOfMoney
        });
        this.getSpentMore(String(values.amountOfMoney));
        formikHelpers.setSubmitting(false);
    }
    updateOrderedMore(values, formikHelpers) {
        this.setState({
            orderedMoreInitialNumber: values.numberOfOrders
        });
        this.getOrderedMore(String(values.numberOfOrders));
        formikHelpers.setSubmitting(false);
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            ref: this.props.exportRef,
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "customers-spending",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "customers-spending__quartiles",
                        children: this.state.quartiles.map((quartile, index)=>{
                            return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card quartile-card ",
                                children: [
                                    this.state.minSpending === quartile.average && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        className: "quartile-card__ribbon",
                                        children: t("lowestSpending")
                                    }),
                                    this.state.maxSpending === quartile.average && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        className: "quartile-card__ribbon",
                                        children: t("highestSpending")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                        className: "card--title",
                                        children: [
                                            t("quartile"),
                                            " ",
                                            index + 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                                        className: "quartile-card__average",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(quartile.average)
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "quartile-card__average-currency",
                                                children: this.context.settings.currency
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "quartile-card__average-text",
                                                children: t("avgSpending")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dl", {
                                        className: "quartile-card__list",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $db463a54a8c7995f$export$2e2bcd8739ae039), {}),
                                                    " ",
                                                    t("totalCustomers")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(quartile.number)
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $b62697973d7279dd$export$2e2bcd8739ae039), {}),
                                                    " ",
                                                    t("maxOrderValue")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(quartile.maximum)}
                      ${this.context.settings.currency}`
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8226bb9dd73cbae7$export$2e2bcd8739ae039), {}),
                                                    " ",
                                                    t("minOrderValue")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(quartile.minimum)}
                      ${this.context.settings.currency}`
                                            })
                                        ]
                                    }),
                                    this.state.sectionLoader ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                        width: 40,
                                        height: 40
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                        data: this.state.quartiles[index].list,
                                        filename: `quartile-${index + 1}.csv`,
                                        className: "export-list-button",
                                        target: "_blank",
                                        children: t("exportList")
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "customers-spending__calculators",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                                        onSubmit: this.updateSpentMore,
                                        initialValues: {
                                            amountOfMoney: this.state.spentMoreInitialNumber
                                        },
                                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                                            amountOfMoney: (0, $91e1faf1710dcf23$export$98e628dec113755e)().positive().integer().required("Number is required")
                                        }),
                                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                                className: "card--section",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                        name: "amountOfMoney",
                                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "form-field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                        htmlFor: "amountOfMoney",
                                                                        children: t("customersWhoSpentMoreThan")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                                id: "amount-of-money",
                                                                                name: "amountOfMoney",
                                                                                type: "number",
                                                                                ...field,
                                                                                value: field.value ?? ""
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                                children: `${this.context.settings.currency} ${t(this.context.currentPeriod.alias)}`
                                                                            })
                                                                        ]
                                                                    }),
                                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                        className: "error",
                                                                        children: meta.error
                                                                    })
                                                                ]
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        type: "submit",
                                                        className: "button save",
                                                        disabled: formikBag.isSubmitting,
                                                        children: t("apply")
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dl", {
                                        className: "quartile-card__list",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $db463a54a8c7995f$export$2e2bcd8739ae039), {}),
                                                    " ",
                                                    t("totalCustomers")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.spentMoreTotal)
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8226bb9dd73cbae7$export$2e2bcd8739ae039), {}),
                                                    t("maxAmountSpentByCustomer")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.spentMoreMax)}
                  ${this.context.settings.currency}`
                                            })
                                        ]
                                    }),
                                    this.state.spentMoreList && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                        data: this.state.spentMoreList,
                                        filename: `customers-spent-more-than-${this.state.spentMoreInitialNumber}.csv`,
                                        className: "export-list-button",
                                        target: "_blank",
                                        children: t("exportList")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                                        onSubmit: this.updateOrderedMore,
                                        initialValues: {
                                            numberOfOrders: this.state.orderedMoreInitialNumber
                                        },
                                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                                            numberOfOrders: (0, $91e1faf1710dcf23$export$98e628dec113755e)().positive().integer().required("Number is required")
                                        }),
                                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                                className: "card--section",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                        name: "numberOfOrders",
                                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "form-field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                        htmlFor: "numberOfOrders",
                                                                        children: t("customersWhoOrderedMoreThan")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                                id: "number-of-orders",
                                                                                name: "numberOfOrders",
                                                                                type: "number",
                                                                                ...field,
                                                                                value: field.value ?? ""
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                                                children: [
                                                                                    " ",
                                                                                    `${t("ordersIn")} ${t(this.context.currentPeriod.alias)}`
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                        className: "error",
                                                                        children: meta.error
                                                                    })
                                                                ]
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        type: "submit",
                                                        className: "button save",
                                                        disabled: formikBag.isSubmitting,
                                                        children: t("apply")
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dl", {
                                        className: "quartile-card__list",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $db463a54a8c7995f$export$2e2bcd8739ae039), {}),
                                                    " ",
                                                    t("totalCustomers")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.orderedMoreTotal)
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8226bb9dd73cbae7$export$2e2bcd8739ae039), {}),
                                                    t("maxNumberOfOrdersMadeByCustomer")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dd", {
                                                children: [
                                                    (0, $48f673e197675daa$export$4640587ffa669919)(this.state.orderedMoreMax),
                                                    " Orders"
                                                ]
                                            })
                                        ]
                                    }),
                                    this.state.orderedMoreList && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                        data: this.state.orderedMoreList,
                                        filename: `customers-ordered-more-than-${this.state.orderedMoreInitialNumber}.csv`,
                                        className: "export-list-button",
                                        target: "_blank",
                                        children: t("exportList")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
$ca02a7743031abf8$var$CustomersSpending.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $ca02a7743031abf8$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("customers")($ca02a7743031abf8$var$CustomersSpending);




var $igtsr = parcelRequire("igtsr");


/**
 * Renders children if user has permission to access them per their list of
 * roles and a list of required roles. Admins have permission regardless.
 */ const $19d768f45b7e36ad$var$PermissionsFilter = ({ allowedRoles: allowedRoles = [], allowedPlatforms: allowedPlatforms = [], children: children })=>{
    const { user: user, settings: settings } = (0, $igtsr.useContext)((0, $93880734d471a57f$export$3cbe56a0cabcff38));
    if (!(0, $48f673e197675daa$export$b325ec6732b039cf)(allowedRoles, user?.roles)) return null;
    if (!(0, $48f673e197675daa$export$805ddaeeece0413e)(allowedPlatforms, settings?.platform)) return null;
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
        children: children
    });
};
$19d768f45b7e36ad$var$PermissionsFilter.defaultProps = {
    allowedRoles: [],
    allowedPlatforms: []
};
var $19d768f45b7e36ad$export$2e2bcd8739ae039 = $19d768f45b7e36ad$var$PermissionsFilter;


class $81c0ede2a51bcaf7$var$Customers extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        const query = window.location.search;
        const params = new URLSearchParams(query);
        this.ChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportCustomersRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportCustomersSpendingRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            activeTab: params.get("activeTab") ?? "customers_overview",
            id: Date.now().toString()
        };
    }
    componentDidMount() {
        this.context.updateUrlQueryParams(this.state.activeTab);
        // set page title
        document.title = "Customers";
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab) this.context.updateUrlQueryParams(this.state.activeTab);
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "customers",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("customers"),
                    exportRef: this.state.activeTab === "customers_overview" ? this.exportCustomersRef : this.exportCustomersSpendingRef
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "tabs",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "customers_overview" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "customers_overview") this.setState({
                                    activeTab: "customers_overview"
                                });
                            },
                            children: t("customersOverview")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $19d768f45b7e36ad$export$2e2bcd8739ae039), {
                            allowedRoles: [
                                (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).marketing,
                                (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).management,
                                (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).admin
                            ],
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: `tab ${this.state.activeTab === "spending" ? " active" : ""}`,
                                onClick: ()=>{
                                    if (this.state.activeTab !== "spending") this.setState({
                                        activeTab: "spending"
                                    });
                                },
                                children: "Spending"
                            })
                        })
                    ]
                }),
                this.state.activeTab === "customers_overview" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $455dc6603e408162$export$2e2bcd8739ae039), {
                    exportRef: this.exportCustomersRef
                }),
                this.state.activeTab === "spending" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $19d768f45b7e36ad$export$2e2bcd8739ae039), {
                    allowedRoles: [
                        (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).marketing,
                        (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).management,
                        (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).admin
                    ],
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ca02a7743031abf8$export$2e2bcd8739ae039), {
                        exportRef: this.exportCustomersSpendingRef
                    })
                })
            ]
        });
    }
}
$81c0ede2a51bcaf7$var$Customers.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $81c0ede2a51bcaf7$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("customers")($81c0ede2a51bcaf7$var$Customers);


/**
 * @author Salma Hefnawy
 * @date 2022-03-28
 * @description user behavior of the App.
 * @filename user-behavior.tsx
 */ 

var $igtsr = parcelRequire("igtsr");





/**
 * @author Salma Hefnawy
 * @date 2022-03-28
 * @description search term tab of the App.
 * @filename search-term.tsx
 */ 

var $igtsr = parcelRequire("igtsr");




/**
 * @author Salma Hefnawy
 * @date 2022-03-28
 * @description implementation of User behavior related utilities.
 * @filename user-behavior.ts
 */ /**
 * @author Salma Hefnawy
 * @date 2022-03-28
 * @description implementation of User behavior related API calls.
 * @filename user-behavior.ts
 */ 


class $38e3f73ef29fbb92$export$72adbdc70d6887e7 {
    static mostSearchedTerms(project) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).mostSearchedTerms.path}`);
        url.searchParams.append("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).searchItem.method
        });
    }
    static getLoyaltyPoints({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getLoyaltyPoints.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getLoyaltyPoints.method
        });
    }
    static getLoyaltyPointsPerDay({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getLoyaltyPointsPerDay.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getLoyaltyPointsPerDay.method
        });
    }
    static exportLoyalPoints(project, percentage) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).exportLoyalPoints.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("percentage", percentage);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).exportLoyalPoints.method
        });
    }
    static getPromoCodes({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getPromoCodes.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getPromoCodes.method
        });
    }
    static exportPromoCodes({ project: project, from: from, to: to, currentPage: currentPage, pageSize: pageSize, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).exportPromoCodes.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        if (currentPage && pageSize) {
            url.searchParams.append("currentPage", currentPage.toString());
            url.searchParams.append("pageSize", pageSize.toString());
        }
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).exportPromoCodes.method
        });
    }
    static exportPromoCodesPaginated({ project: project, from: from, to: to, currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).exportPromoCodes.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).exportPromoCodes.method
        });
    }
    static getAllGA4PagesSummary({ project: project, from: from, to: to, currentPage: currentPage, pageSize: pageSize, sort: sort, direction: direction, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllGA4PagesSummary.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        if (currentPage && pageSize) {
            url.searchParams.append("currentPage", currentPage.toString());
            url.searchParams.append("pageSize", pageSize.toString());
        }
        if (sort && direction) {
            url.searchParams.append("sort", sort);
            url.searchParams.append("direction", direction);
        }
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllGA4PagesSummary.method
        });
    }
    static getSpecificPageSummary({ project: project, from: from, to: to, pageTitle: pageTitle, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getSpecificPageSummary.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("pageTitle", pageTitle);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getSpecificPageSummary.method
        });
    }
}



function $41b4a37f2cb2a113$export$5514180cf75f223d(project) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).mostSearchedTerms(project).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$28e4db8d84fa06d8(payload) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).getLoyaltyPoints(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$a1c39fe339f10a82(payload) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).getLoyaltyPointsPerDay(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$551f1811e6f092a8(project, percentage) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).exportLoyalPoints(project, percentage).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$f5207f99a662b60(payload) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).getPromoCodes(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$6dc7acfa0392d8f6(payload) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).exportPromoCodes(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$659ebc1c48f12ee1(payload) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).exportPromoCodesPaginated(payload).then((response)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$e9cb9cac58dc5310(payload) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).getAllGA4PagesSummary(payload).then((response)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $41b4a37f2cb2a113$export$4afa9cbfb469c319(payload) {
    return (0, $38e3f73ef29fbb92$export$72adbdc70d6887e7).getSpecificPageSummary(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}



class $928fbafb6e340774$var$SearchTerms extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString(),
            loading: false,
            searchedTerms: null
        };
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        this.setState({
            loading: true
        });
        let searchedTermsPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project"
        ])) searchedTermsPromise = (0, $41b4a37f2cb2a113$export$5514180cf75f223d)(this.context.project).then((searchedTerms)=>{
            this.setState({
                searchedTerms: searchedTerms
            });
        });
        Promise.all([
            searchedTermsPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    renderedSearchItems() {
        return this.state.searchedTerms?.most_searched_terms?.map((mostSearchedTerm, index)=>{
            return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "table__body-row",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                        children: mostSearchedTerm.search_term
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                        children: mostSearchedTerm.frequency
                    })
                ]
            }, index);
        });
    }
    renderedNoResultsSearchItems() {
        return this.state.searchedTerms?.most_searched_no_result_terms?.map((mostSearchedTerm, index)=>{
            return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "table__body-row",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                        children: mostSearchedTerm.search_term
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                        children: mostSearchedTerm.frequency
                    })
                ]
            }, index);
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: [
                Object.keys(this.context.appliedFilters).length > 0 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "disclaimer",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                        children: t("searchTermsAppliedFiltersDisclaimer")
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card-container search-terms",
                    ref: this.props.exportRef,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h1", {
                                    className: "card--title",
                                    children: [
                                        t("mostSearchedTerms"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "table table--two-columns",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "table__head",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                                    children: t("terms")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                                    children: t("frequency")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "table__body",
                                            children: this.renderedSearchItems()
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h1", {
                                    className: "card--title",
                                    children: [
                                        t("noResultsTitle"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "search-terms__no-results",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                            className: "search-terms__no-results-count",
                                            children: this.state.searchedTerms?.no_result_search_count
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                            className: "search-terms__no-results-text",
                                            children: t("noResults")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h1", {
                                    className: "card--title",
                                    children: [
                                        t("mostSearchedTermsNoResults"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "table table--two-columns",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "table__head",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                                    children: t("terms")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                                    children: t("frequency")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "table__body",
                                            children: this.renderedNoResultsSearchItems()
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$928fbafb6e340774$var$SearchTerms.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $928fbafb6e340774$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($928fbafb6e340774$var$SearchTerms);


/**
 * @author Salma Hefnawy
 * @date 2022-05-17
 * @description loyalty program tab of the App.
 * @filename loyalty-program.tsx
 */ 

var $igtsr = parcelRequire("igtsr");




var $4l1Xa = parcelRequire("4l1Xa");






/**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description BreakdownChart tab of the App.
 * @filename overview.tsx
 */ 

var $igtsr = parcelRequire("igtsr");






/**
 * @author Ahmed Serag
 * @date 2021-07-01
 * @description declaration of orders details interface.
 * @filename orders details.ts
 */ var $3c4bd740ffbbd825$export$60fa4e0dc8092495 = /*#__PURE__*/ function(WeekDays) {
    WeekDays["SUNDAY"] = "Sunday";
    WeekDays["MONDAY"] = "Monday";
    WeekDays["TUESDAY"] = "Tuesday";
    WeekDays["WEDNESDAY"] = "Wednesday";
    WeekDays["THURSDAY"] = "Thursday";
    WeekDays["FRIDAY"] = "Friday";
    WeekDays["SATURDAYS"] = "Saturday";
    return WeekDays;
}({});


class $7c79e7a583126a6d$var$BreakdownChart extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.ChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            dataPerDay: null,
            loading: true,
            activeDay: (0, $3c4bd740ffbbd825$export$60fa4e0dc8092495).SUNDAY,
            id: `${Date.now().toString()}-BreakdownChart`
        };
        this.loadData = this.loadData.bind(this);
        this.loadChart = this.loadChart.bind(this);
    }
    componentDidMount() {
        if (this.props.getDataPerDay) {
            this.loadData();
            this.context.addUpdatesListener(this.state.id, this.loadData);
        } else this.loadChart();
    }
    componentWillUnmount() {
        if (this.state.chart) this.state.chart.destroy();
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        let chart = this.state.chart;
        const datasets = [];
        const currDate = new Date();
        const prevDate = new Date(new Date().setFullYear(currDate.getFullYear() - 1));
        const currentYear = currDate.toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric"
        });
        const previousYear = prevDate.toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric"
        });
        let DataPerDayPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) DataPerDayPromise = this.props.getDataPerDay({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            filters: this.context.appliedFilters
        }).then((dataPerDay)=>{
            if (this.context.comparedPeriod?.type === "quarter") {
                // to get the total data for quarter
                const totalData = dataPerDay.reduce((prevValue, currValue)=>prevValue + currValue, 0);
                this.setState({
                    totalData: totalData
                });
            } else {
                datasets.push({
                    label: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`common:${this.context.currentPeriod.alias}`),
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.currentPeriod, dataPerDay),
                    backgroundColor: "#44EBA6",
                    borderColor: "#44EBA6",
                    title: this.props.chartTitle
                });
                this.setState({
                    dataPerDay: dataPerDay
                });
            }
        });
        let PreviousDataPerDayPromise = Promise.resolve();
        if (this.context.comparedPeriod) PreviousDataPerDayPromise = this.props.getDataPerDay({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            filters: this.context.appliedFilters
        }).then((dataPerDay)=>{
            if (this.context.comparedPeriod.type === "quarter") {
                const comparedTotalData = dataPerDay.reduce((prevValue, currValue)=>prevValue + currValue, 0);
                this.setState({
                    comparedTotalData: comparedTotalData
                });
            } else {
                datasets.push({
                    label: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`common:${this.context.comparedPeriod.alias}`),
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.comparedPeriod, dataPerDay),
                    title: this.props.chartTitle
                });
                this.setState({
                    dataPerDay: dataPerDay
                });
            }
        });
        else this.setState({
            comparedDataPerDay: null
        });
        Promise.all([
            DataPerDayPromise,
            PreviousDataPerDayPromise
        ]).then(()=>{
            if (chart) chart.destroy();
            if (this.context.comparedPeriod?.type === "quarter") chart = (0, $54c7c3206a2399da$export$99199eb0d2d4ab39)(this.ChartRef.current, [
                (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`common:${this.context.currentPeriod.alias}`),
                // TODO adjust comparing quarters translations
                this.context.comparedPeriod?.alias.startsWith("previous") ? `${(0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)(`common:${this.context.comparedPeriod?.alias.match(/First|Second|Third|Fourth/)[0].toLowerCase()}Quarter`)} ${previousYear}` : `${(0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)(`common:${this.context.comparedPeriod.alias}`)} ${currentYear}`
            ], [
                {
                    label: this.props.chartLabel,
                    values: [
                        this.state.totalData,
                        this.state.comparedTotalData
                    ],
                    title: this.props.chartTitle
                }
            ], this.state.id);
            else chart = (0, $54c7c3206a2399da$export$95d6ba1825bcad81)(this.ChartRef.current, (0, $54c7c3206a2399da$export$2e2f40d1b5b08307)(this.context.currentPeriod), datasets, this.props.chartLabel, this.state.id);
            this.setState({
                loading: false,
                chart: chart
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            // eslint-disable-next-line no-console
            console.error(error);
        // TODO handle error loading the chart
        });
    }
    /**
   * Draws the chart when the day is changed
   * @param activeDay Name of the day to be graphed
   */ loadChart() {
        if (this.state.chart) this.state.chart.destroy();
        let chart = this.state.chart;
        const datasets = [];
        datasets.push({
            label: this.props.chartLabel,
            values: this.props.hourlyBreakdown ? this.props.hourlyBreakdown[this.state.activeDay] : this.props.dataPerDay,
            backgroundColor: "#44EBA6",
            borderColor: "#44EBA6",
            title: this.props.chartTitle
        });
        chart = (0, $54c7c3206a2399da$export$95d6ba1825bcad81)(this.ChartRef.current, this.props.hourlyBreakdown ? (0, $1c57294348bd2fde$export$6c6cc5893821293) : (0, $54c7c3206a2399da$export$2e2f40d1b5b08307)(this.context.currentPeriod), datasets, this.props.chartLabel, this.state.id, // maintainAspectRatio to give the hourly breakdown graph full width
        true);
        this.setState({
            loading: false,
            chart: chart
        });
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "card orders-card",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                    className: "card--title card-graph--title",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            children: [
                                this.props.chartTitle,
                                " ",
                                this.props.getDataPerDay && (0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)(`common:${this.context.currentPeriod.alias}`)
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                            className: "duration",
                            children: [
                                "(",
                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "card--options",
                    children: // don't show days if currenPeriod is today
                    this.props.hourlyBreakdown && this.context.currentPeriod.alias !== "today" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                        children: (0, $1c57294348bd2fde$export$1153db180e4a0aef).map((weekDay)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: `day option ${weekDay === this.state.activeDay ? "active" : ""}`,
                                onClick: (e)=>{
                                    this.setState({
                                        activeDay: e.target.innerText
                                    });
                                    this.loadChart(e.target.innerText);
                                },
                                children: weekDay
                            }, weekDay))
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "line-chart__container line-chart__full-width",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("canvas", {
                        ref: this.ChartRef,
                        id: this.state.id
                    })
                })
            ]
        });
    }
}
$7c79e7a583126a6d$var$BreakdownChart.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $7c79e7a583126a6d$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("common")($7c79e7a583126a6d$var$BreakdownChart);




class $e4fe20ee183ad597$var$LoyaltyProgram extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString(),
            loading: true,
            loadingLoyaltyCalculator: false
        };
        this.loadData = this.loadData.bind(this);
        this.updateLoyaltyPoints = this.updateLoyaltyPoints.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    updateLoyaltyPoints(values, formikHelpers) {
        this.setState({
            loadingLoyaltyCalculator: true
        });
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) (0, $41b4a37f2cb2a113$export$551f1811e6f092a8)(this.context.project, String(values.percentage)).then((exportedLoyaltyPoints)=>{
            this.setState({
                exportedLoyaltyPoints: exportedLoyaltyPoints,
                initialLoyaltyPercentage: values.percentage
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }).finally(()=>{
            formikHelpers.setSubmitting(false);
            this.setState({
                loadingLoyaltyCalculator: false
            });
        });
    }
    loadData() {
        this.setState({
            loading: true
        });
        let loyaltyPointsPromise = Promise.resolve();
        let comparedLoyaltyPointsPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) loyaltyPointsPromise = (0, $41b4a37f2cb2a113$export$28e4db8d84fa06d8)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            filters: this.context.appliedFilters
        }).then((loyaltyPoints)=>{
            this.setState({
                ...loyaltyPoints
            });
        });
        if (this.context.comparedPeriod) comparedLoyaltyPointsPromise = (0, $41b4a37f2cb2a113$export$28e4db8d84fa06d8)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            filters: this.context.appliedFilters
        }).then((comparedLoyaltyPoints)=>{
            this.setState({
                comparedLoyaltyPoints: comparedLoyaltyPoints
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        });
        else this.setState({
            comparedLoyaltyPoints: null
        });
        Promise.all([
            loyaltyPointsPromise,
            comparedLoyaltyPointsPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "loyalty-program",
            ref: this.props.exportRef,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card transparent-card overview-card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                            className: "card--title",
                            children: [
                                t("loyaltyPoints"),
                                " ",
                                t(this.context.currentPeriod.alias),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    className: "duration",
                                    children: [
                                        "(",
                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "overview-items",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.reward_points_redeemed)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("pointsRedeemed")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.reward_points_redeemed_value)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalPointsValue")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.total_reward_points_in_wallets)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalPointsWallet")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.total_orders_with_reward_points_redeemed)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("ordersWithPointsUsed")
                                        })
                                    ]
                                })
                            ]
                        }),
                        this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("loyaltyPoints"),
                                        " - ",
                                        t(this.context.comparedPeriod?.alias)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "overview-items",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedLoyaltyPoints?.reward_points_redeemed)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("pointsRedeemed")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedLoyaltyPoints?.reward_points_redeemed_value)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("totalPointsValue")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedLoyaltyPoints?.total_reward_points_in_wallets)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("totalPointsWallet")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedLoyaltyPoints?.total_orders_with_reward_points_redeemed)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("ordersWithPointsUsed")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card-container",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7c79e7a583126a6d$export$2e2bcd8739ae039), {
                            getDataPerDay: (0, $41b4a37f2cb2a113$export$a1c39fe339f10a82),
                            chartLabel: t("points"),
                            chartTitle: t("spentLoyaltyPoints")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "customers-spending__calculators loyalty-program__calculators",
                            children: this.state.loadingLoyaltyCalculator ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "card",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                                        onSubmit: this.updateLoyaltyPoints,
                                        initialValues: {
                                            percentage: this.state.initialLoyaltyPercentage ?? 0
                                        },
                                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                                            percentage: (0, $91e1faf1710dcf23$export$98e628dec113755e)().positive().integer().max(100).required("Number is required")
                                        }),
                                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                                className: "card--section",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                        name: "percentage",
                                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "form-field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                        htmlFor: "percentage",
                                                                        children: t("topLoyaltyPoints")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                                id: "percentage",
                                                                                name: "percentage",
                                                                                type: "number",
                                                                                ...field,
                                                                                value: field.value ?? ""
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                                children: t("percentageOfUsers")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                        className: "error",
                                                                        children: meta.error
                                                                    })
                                                                ]
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        type: "submit",
                                                        className: "button save",
                                                        disabled: formikBag.isSubmitting,
                                                        children: t("apply")
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dl", {
                                        className: "quartile-card__list",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $db463a54a8c7995f$export$2e2bcd8739ae039), {}),
                                                    " ",
                                                    t("totalCustomers")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                children: this.state.exportedLoyaltyPoints?.count ? (0, $48f673e197675daa$export$4640587ffa669919)(this.state.exportedLoyaltyPoints?.count) : "0"
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dt", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8226bb9dd73cbae7$export$2e2bcd8739ae039), {}),
                                                    t("maxPoints")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dd", {
                                                children: [
                                                    this.state.exportedLoyaltyPoints?.maximum ? (0, $48f673e197675daa$export$4640587ffa669919)(this.state.exportedLoyaltyPoints?.maximum) : "N/A",
                                                    " ",
                                                    t("points")
                                                ]
                                            })
                                        ]
                                    }),
                                    this.state.exportedLoyaltyPoints && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                        data: this.state.exportedLoyaltyPoints.list,
                                        filename: "loyalty-points.csv",
                                        className: "export-list-button",
                                        target: "_blank",
                                        children: t("exportList")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$e4fe20ee183ad597$var$LoyaltyProgram.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $e4fe20ee183ad597$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($e4fe20ee183ad597$var$LoyaltyProgram);


/**
 * @author Youssef Tarek
 * @date 2022-05-24
 * @description promo code tab of the App.
 * @filename promo-codes.tsx
 */ 


var $igtsr = parcelRequire("igtsr");








class $668d3dc287e8b431$var$Promocodes extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString(),
            loading: true,
            promoCodesSummary: null,
            exportedPromoCodes: null,
            promoCodesTotalCount: 0,
            comparedPromoCodesTotalCount: 0,
            comparedPromoCodesSummary: null,
            comparedExportedPromoCodes: null
        };
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    /**
   * get the number of active promocodes
   * @param promocodes
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
    getActivePromoCodesCount(promocodes) {
        return promocodes.filter((promo)=>promo.is_active === 1 || promo.is_active === null).length;
    }
    loadData() {
        this.setState({
            loading: true
        });
        let promoCodesSummaryPromise = Promise.resolve();
        let exportedPromoCodesPromise = Promise.resolve();
        let comparedPromoCodesSummaryPromise = Promise.resolve();
        let comparedExportedPromoCodesPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project"
        ])) {
            promoCodesSummaryPromise = (0, $41b4a37f2cb2a113$export$f5207f99a662b60)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((promoCodesSummary)=>{
                this.setState({
                    promoCodesSummary: promoCodesSummary
                });
            });
            exportedPromoCodesPromise = (0, $41b4a37f2cb2a113$export$6dc7acfa0392d8f6)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((exportedPromoCodes)=>{
                this.setState({
                    exportedPromoCodes: exportedPromoCodes,
                    promoCodesTotalCount: this.getActivePromoCodesCount(exportedPromoCodes)
                });
                this.props.updateExportedPromoCodes(exportedPromoCodes);
            });
        }
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "comparedPeriod"
        ])) {
            comparedPromoCodesSummaryPromise = (0, $41b4a37f2cb2a113$export$f5207f99a662b60)({
                project: this.context.project,
                from: this.context.comparedPeriod?.from,
                to: this.context.comparedPeriod?.to,
                filters: this.context.appliedFilters
            }).then((comparedPromoCodesSummary)=>{
                this.setState({
                    comparedPromoCodesSummary: comparedPromoCodesSummary
                });
            });
            comparedExportedPromoCodesPromise = (0, $41b4a37f2cb2a113$export$6dc7acfa0392d8f6)({
                project: this.context.project,
                from: this.context.comparedPeriod?.from,
                to: this.context.comparedPeriod?.to,
                filters: this.context.appliedFilters
            }).then((comparedExportedPromoCodes)=>{
                this.setState({
                    comparedExportedPromoCodes: comparedExportedPromoCodes,
                    comparedPromoCodesTotalCount: this.getActivePromoCodesCount(comparedExportedPromoCodes)
                });
                this.props.updateExportedPromoCodes(comparedExportedPromoCodes);
            });
        }
        Promise.all([
            promoCodesSummaryPromise,
            exportedPromoCodesPromise,
            comparedPromoCodesSummaryPromise,
            comparedExportedPromoCodesPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "promo-code",
            ref: this.props.exportRef,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card transparent-card overview-card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                            className: "card--title",
                            children: [
                                t("promocodes"),
                                " ",
                                (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`common:${this.context.currentPeriod.alias}`),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    className: "duration",
                                    children: [
                                        "(",
                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "overview-items",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.promoCodesSummary.number_of_orders_with_promocode)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("ordersUsedPromocodes")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                (0, $48f673e197675daa$export$4640587ffa669919)(this.state.promoCodesSummary.percentage_of_orders_with_promocode),
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("ofOrdersUsedPromocodes")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                (0, $48f673e197675daa$export$4640587ffa669919)(this.state.promoCodesSummary.sales_value),
                                                " ",
                                                this.context.settings.currency
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalRevenueOfOrdersWithPromocode")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                (0, $48f673e197675daa$export$4640587ffa669919)(this.state.promoCodesSummary.discount),
                                                " ",
                                                this.context.settings.currency
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalDiscountAmount")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card transparent-card overview-card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                            className: "card--title",
                            children: [
                                t("promocodes"),
                                " ",
                                (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`common:${this.context.comparedPeriod?.alias}`),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    className: "duration",
                                    children: [
                                        "(",
                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "overview-items",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPromoCodesSummary?.number_of_orders_with_promocode)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("ordersUsedPromocodes")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPromoCodesSummary?.percentage_of_orders_with_promocode),
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("ofOrdersUsedPromocodes")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPromoCodesSummary?.sales_value),
                                                " ",
                                                this.context.settings.currency
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalRevenueOfOrdersWithPromocode")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPromoCodesSummary?.discount),
                                                " ",
                                                this.context.settings.currency
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalDiscountAmount")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card-container",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card overview-card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title card--export",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            children: [
                                                t("activePromocodes"),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "duration",
                                                    children: [
                                                        "(",
                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        this.state.exportedPromoCodes.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                            data: this.state.exportedPromoCodes,
                                            filename: `promocodes-from:${this.context.currentPeriod.from}-to:${this.context.currentPeriod.to}.csv`,
                                            className: "export-list-button",
                                            target: "_blank",
                                            children: t("exportList")
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "overview-items",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.promoCodesTotalCount)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("promocodes")
                                                })
                                            ]
                                        }),
                                        this.state.exportedPromoCodes.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            className: "item",
                                            type: "button",
                                            onClick: ()=>{
                                                this.props.updateShowAllPromosState(true);
                                            },
                                            children: t("viewAllPromoCodes")
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card overview-card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title card--export",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            children: [
                                                t("activePromocodes"),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "duration",
                                                    children: [
                                                        "(",
                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        this.state.comparedExportedPromoCodes?.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                            data: this.state.comparedExportedPromoCodes,
                                            filename: `promocodes-from:${this.context.comparedPeriod?.from}-to:${this.context.comparedPeriod?.to}.csv`,
                                            className: "export-list-button",
                                            target: "_blank",
                                            children: t("exportList")
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "overview-items",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "item",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "header",
                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPromoCodesTotalCount)
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "title",
                                                children: t("promocodes")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                            className: "card--title",
                            children: [
                                t("topUsedPromocodes"),
                                " ",
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    className: "duration",
                                    children: [
                                        "(",
                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "top-promocodes-table",
                            children: this.state.exportedPromoCodes && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                promocodes: this.state.exportedPromoCodes.slice(0, 9),
                                type: "promocodes"
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$668d3dc287e8b431$var$Promocodes.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $668d3dc287e8b431$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($668d3dc287e8b431$var$Promocodes);


/**
 * @author Youssef Tarek
 * @date 2022-05-24
 * @description promo code tab of the App.
 * @filename promo-codes.tsx
 */ 


var $igtsr = parcelRequire("igtsr");








class $4e990fa1655d1650$var$AllPromoCodes extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString(),
            loading: true,
            exportedPromoCodes: null,
            currentPage: 1
        };
        this.loadData = this.loadData.bind(this);
        this.changePageHandler = this.changePageHandler.bind(this);
    }
    componentDidMount() {
        this.loadData(this.state.currentPage);
        this.context.updateUrlQueryParams();
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData(currentPage) {
        this.setState({
            loading: true
        });
        let exportedPromoCodesPromise = Promise.resolve();
        const pageSize = 10;
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project"
        ])) exportedPromoCodesPromise = (0, $41b4a37f2cb2a113$export$659ebc1c48f12ee1)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            currentPage: currentPage,
            pageSize: pageSize,
            filters: this.context.appliedFilters
        }).then((exportedPromoCodes)=>{
            this.setState({
                exportedPromoCodes: exportedPromoCodes,
                totalPageCount: Math.ceil(exportedPromoCodes.pagination.totalCount / pageSize),
                currentPage: exportedPromoCodes.pagination.currentPage
            });
        });
        Promise.all([
            exportedPromoCodesPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    changePageHandler(currentPage) {
        this.setState({
            currentPage: currentPage
        });
        this.loadData(currentPage);
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "card promo-codes__card",
            ref: this.props.exportRef,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                    className: "card--title",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            children: [
                                t("allPromoCodes"),
                                " ",
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    className: "duration",
                                    children: [
                                        "(",
                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        this.props.unpaginatedExportedPromoCodes.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                            data: this.props.unpaginatedExportedPromoCodes,
                            filename: `promocodes-from:${this.context.currentPeriod.from}-to:${this.context.currentPeriod.to}.csv`,
                            className: "export-list-button",
                            target: "_blank",
                            children: t("exportList")
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "promo-code",
                    ref: this.props.exportRef,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "all-promo-codes-table",
                        children: [
                            this.state.exportedPromoCodes && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                promocodes: this.state.exportedPromoCodes.data,
                                type: "allPromoCodes"
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "page-navigator",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                    totalPageCount: this.state.totalPageCount,
                                    currentPage: this.state.currentPage,
                                    pageNeighbors: 1,
                                    changePageHandler: this.changePageHandler
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
}
$4e990fa1655d1650$var$AllPromoCodes.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $4e990fa1655d1650$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($4e990fa1655d1650$var$AllPromoCodes);



/**
 * @author Ahmed Serag
 * @date 2022-07-17
 * @description page views tab in user behavior.
 * @filename page-views.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


/**
 * @author Salma Hefnawy
 * @date 2022-06-08
 * @description page report.
 * @filename page-report.tsx
 */ 


var $igtsr = parcelRequire("igtsr");





/**
 * @author Ahmed Serag
 * @date 2022-07-19
 * @description Page Views Chart component of page views page.
 * @filename page-views-chart.tsx
 */ 

var $igtsr = parcelRequire("igtsr");








class $758dbd3c0e244661$var$PageViewsCharts extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.ChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.NormalizedChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            dataPerDay: null,
            loading: true,
            activeDay: (0, $3c4bd740ffbbd825$export$60fa4e0dc8092495).SUNDAY,
            id: `page-views-chart-${Date.now().toString()}`
        };
        this.loadChart = this.loadChart.bind(this);
    }
    componentDidMount() {
        this.loadChart();
        this.loadNormalizedChart();
    }
    componentWillUnmount() {
        if (this.state.chart) this.state.chart.destroy();
        if (this.state.normalizedChart) this.state.normalizedChart.destroy();
    }
    loadData() {
        const datasets = [];
        let ordersPerDayPromise = Promise.resolve(null);
        let customersPerDayPromise = Promise.resolve(null);
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            ordersPerDayPromise = (0, $aa865fdbda79f268$export$3f406deb15ba6ad2)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((dataPerDay)=>{
                if (this.context.comparedPeriod?.type === "quarter") {
                    // to get the total data for quarter
                    const totalData = dataPerDay.reduce((prevValue, currValue)=>prevValue + currValue, 0);
                    this.setState({
                        totalData: totalData
                    });
                } else datasets.push({
                    label: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`common:orders`),
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.currentPeriod, dataPerDay),
                    title: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`common:orders`)
                });
            });
            customersPerDayPromise = (0, $eb4017638650c249$export$ea22d7cbe968734d)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((customersPerDay)=>{
                datasets.push({
                    label: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:newCustomers"),
                    values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.currentPeriod, customersPerDay.new_customer_count, "sum"),
                    backgroundColor: "#3DD2CE",
                    title: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("customers:newCustomers")
                });
            });
        }
        return Promise.all([
            ordersPerDayPromise,
            customersPerDayPromise
        ]).then(()=>datasets);
    }
    /**
   * Draws the chart when the day is changed
   * @param activeDay Name of the day to be graphed
   */ async loadChart() {
        if (this.state.chart) this.state.chart.destroy();
        // Chart loaded custom data - orders.
        const chartData = await this.loadData();
        let chart = this.state.chart;
        const datasets = [
            ...chartData
        ];
        datasets.push({
            label: (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t(`user-behavior:views`),
            values: (0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.currentPeriod, this.props.dataPerDay),
            backgroundColor: "#A260F0",
            borderColor: "#A260F0",
            title: (0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)("user-behavior:views")
        });
        chart = (0, $54c7c3206a2399da$export$95d6ba1825bcad81)(this.ChartRef.current, (0, $54c7c3206a2399da$export$2e2f40d1b5b08307)(this.context.currentPeriod), datasets, (0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)("user-behavior:views"), this.state.id, // maintainAspectRatio to give the hourly breakdown graph full width
        true);
        this.setState({
            loading: false,
            chart: chart
        });
    }
    async loadNormalizedChart() {
        if (this.state.normalizedChart) this.state.normalizedChart.destroy();
        const chartData = await this.loadData();
        let chart = this.state.normalizedChart;
        const datasets = chartData.map((data)=>{
            return {
                label: data.label,
                values: (0, $54c7c3206a2399da$export$3a0f8eb7361883bd)(data.values),
                backgroundColor: data.backgroundColor,
                borderColor: data.borderColor,
                title: ""
            };
        });
        datasets.push({
            label: (0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)("user-behavior:views"),
            values: (0, $54c7c3206a2399da$export$3a0f8eb7361883bd)((0, $54c7c3206a2399da$export$1e4cf73d036ae2bd)(this.context.currentPeriod, this.props.dataPerDay)),
            backgroundColor: "#A260F0",
            borderColor: "#A260F0",
            title: ""
        });
        chart = (0, $54c7c3206a2399da$export$95d6ba1825bcad81)(this.NormalizedChartRef.current, (0, $54c7c3206a2399da$export$2e2f40d1b5b08307)(this.context.currentPeriod), datasets, "normalized scale", `growth-${this.state.id}`, // maintainAspectRatio to give the hourly breakdown graph full width
        true);
        this.setState({
            loading: false,
            normalizedChart: chart
        });
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card orders-card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                            className: "card--title card-graph--title",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    children: [
                                        (0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)("user-behavior:pageViewsChartTitle"),
                                        " ",
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "card--options"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "line-chart__container",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("canvas", {
                                ref: this.ChartRef,
                                id: this.state.id
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card orders-card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title card-graph--title",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                children: [
                                    (0, $d0d7e7d07316f3a2$export$625550452a3fa3ec)("user-behavior:normalizedPageViews"),
                                    " ",
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                        className: "duration",
                                        children: [
                                            "(",
                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "line-chart__container",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("canvas", {
                                ref: this.NormalizedChartRef,
                                id: `growth-${this.state.id}`
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$758dbd3c0e244661$var$PageViewsCharts.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $758dbd3c0e244661$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($758dbd3c0e244661$var$PageViewsCharts);


class $925f54fbea6dd490$var$PageReport extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: `Page-report-${Date.now().toString()}`,
            loading: false,
            pageReport: null,
            specificPageSummary: null
        };
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        this.setState({
            loading: true
        });
        let pageReportSummaryPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project"
        ])) pageReportSummaryPromise = (0, $41b4a37f2cb2a113$export$4afa9cbfb469c319)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            pageTitle: this.props.pageTitle,
            filters: this.context.appliedFilters
        }).then((pageSummary)=>{
            this.setState({
                specificPageSummary: pageSummary,
                pageReport: pageSummary.pageReport[0]
            });
        });
        let comparedPageReportSummaryPromise = Promise.resolve();
        if (this.context.comparedPeriod) comparedPageReportSummaryPromise = (0, $41b4a37f2cb2a113$export$4afa9cbfb469c319)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            pageTitle: this.props.pageTitle,
            filters: this.context.appliedFilters
        }).then((pageSummary)=>{
            this.setState({
                comparedSpecificPageSummary: pageSummary,
                comparedPageReport: pageSummary.pageReport[0]
            });
        });
        Promise.all([
            pageReportSummaryPromise,
            comparedPageReportSummaryPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "page-views specific-page-view",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "page-view-info",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "page-view-info--data",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    className: "label",
                                    children: t("pageName")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    className: "desc",
                                    children: this.state.pageReport?.pageName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "page-view-info--data",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    className: "label",
                                    children: t("pageLink")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                    href: `//${this.state.pageReport?.pagePath}`,
                                    className: "desc",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: this.state.pageReport?.pagePath
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card-container",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card overview-card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                    className: "card--title",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        children: [
                                            t("pageViews"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                className: "duration",
                                                children: [
                                                    "(",
                                                    (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "overview-items",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.pageReport?.pageViews)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("totalPageViews")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.pageReport?.averageViewsPerDay)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("averageViewsPerDay")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: this.state.pageReport?.averageEngagementTime
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("averageEngagementTime")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                            className: "card--title",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                children: [
                                                    t("pageViews"),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                        className: "duration",
                                                        children: [
                                                            "(",
                                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod.from, this.context.comparedPeriod.to),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "overview-items",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "header",
                                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPageReport?.pageViews)
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "title",
                                                            children: t("totalPageViews")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "header",
                                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPageReport?.averageViewsPerDay)
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "title",
                                                            children: t("averageViewsPerDay")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "header",
                                                            children: this.state.comparedPageReport?.averageEngagementTime
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "title",
                                                            children: t("averageEngagementTime")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card overview-card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                    className: "card--title",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        children: [
                                            t("customerStatistics"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                className: "duration",
                                                children: [
                                                    "(",
                                                    (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "overview-items",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.specificPageSummary?.newCustomers)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("customersTotal")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.specificPageSummary?.totalOrders)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("ordersTotal")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                            className: "card--title",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                children: [
                                                    t("customerStatistics"),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                        className: "duration",
                                                        children: [
                                                            "(",
                                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod.from, this.context.comparedPeriod.to),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "overview-items",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "header",
                                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedSpecificPageSummary?.newCustomers)
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "title",
                                                            children: t("customersTotal")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "header",
                                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedSpecificPageSummary?.totalOrders)
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "title",
                                                            children: t("ordersTotal")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "card-container card-container--graph",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $758dbd3c0e244661$export$2e2bcd8739ae039), {
                        dataPerDay: this.state.specificPageSummary?.viewsBreakdown
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                children: [
                                    t("topSource/mediums"),
                                    " ",
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                        className: "duration",
                                        children: [
                                            "(",
                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "page-view__table",
                            children: this.state.specificPageSummary?.sessionSourceMediumList && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                role: "table",
                                className: "table",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        role: "row",
                                        className: "table-headers",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("source/medium")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("landingPage")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("averageEngagement")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("totalPageViews")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        role: "rowgroup",
                                        className: "table-body",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                            children: this.state.specificPageSummary?.sessionSourceMediumList.map((session, index)=>{
                                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                    className: "table-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                children: session.sessionSourceMedium
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item item-name item-link",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                                href: session.landingPage,
                                                                children: session.landingPage
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                children: session.averageEngagementTime
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                role: "cell",
                                                                className: "item-sold",
                                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(session.pageViews)} ${t("views")}`
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                children: [
                                    t("topSource/mediums"),
                                    " ",
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                        className: "duration",
                                        children: [
                                            "(",
                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod.from, this.context.comparedPeriod.to),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "page-views__table",
                            children: this.state.comparedSpecificPageSummary?.sessionSourceMediumList && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                role: "table",
                                className: "table",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        role: "row",
                                        className: "table-headers",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("source/medium")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("landingPage")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("averageEngagement")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                role: "columnheader",
                                                className: "table-head",
                                                children: t("totalPageViews")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        role: "rowgroup",
                                        className: "table-body",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                            children: this.state.comparedSpecificPageSummary?.sessionSourceMediumList.map((session, index)=>{
                                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                    className: "table-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                children: session.sessionSourceMedium
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item item-name item-link",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                                href: session.landingPage,
                                                                children: session.landingPage
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                children: session.averageEngagementTime
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            role: "cell",
                                                            className: "item",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                role: "cell",
                                                                className: "item-sold",
                                                                children: `${(0, $48f673e197675daa$export$4640587ffa669919)(session.pageViews)} ${t("views")}`
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$925f54fbea6dd490$var$PageReport.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $925f54fbea6dd490$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($925f54fbea6dd490$var$PageReport);


/**
 * @author Salma Hefnawy
 * @date 2022-06-07
 * @description page views tab of the App.
 * @filename page-views.tsx
 */ 


var $igtsr = parcelRequire("igtsr");




/**
 * @author Salma Hefnawy
 * @date 2022-03-28
 * @description declaration of user behavior interface.
 * @filename user-behavior.ts
 */ var $bd586dc79e4551d2$export$32383f57b34c9dd3 = /*#__PURE__*/ function(GA4SortByValue) {
    GA4SortByValue["PageViews"] = "pageViews";
    GA4SortByValue["AverageEngagementTime"] = "averageEngagementTime";
    return GA4SortByValue;
}({});
var $bd586dc79e4551d2$export$3f1135e49ddd846e = /*#__PURE__*/ function(GA4SortByDirection) {
    GA4SortByDirection["Asc"] = "asc";
    GA4SortByDirection["Desc"] = "desc";
    return GA4SortByDirection;
}({});





class $a67e99e9518b1deb$var$PageViewsOverview extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props), this.dropdownFilters = [
            {
                text: "default",
                onClickFunction: (e)=>{
                    this.sortPageViews(e, (0, $bd586dc79e4551d2$export$32383f57b34c9dd3).PageViews, (0, $bd586dc79e4551d2$export$3f1135e49ddd846e).Desc);
                }
            },
            {
                text: "page views (low to high)",
                onClickFunction: (e)=>{
                    this.sortPageViews(e, (0, $bd586dc79e4551d2$export$32383f57b34c9dd3).PageViews, (0, $bd586dc79e4551d2$export$3f1135e49ddd846e).Asc);
                }
            },
            {
                text: "page views (high to low)",
                onClickFunction: (e)=>{
                    this.sortPageViews(e, (0, $bd586dc79e4551d2$export$32383f57b34c9dd3).PageViews, (0, $bd586dc79e4551d2$export$3f1135e49ddd846e).Desc);
                }
            },
            {
                text: "average engagement time (low to high)",
                onClickFunction: (e)=>{
                    this.sortPageViews(e, (0, $bd586dc79e4551d2$export$32383f57b34c9dd3).AverageEngagementTime, (0, $bd586dc79e4551d2$export$3f1135e49ddd846e).Asc);
                }
            },
            {
                text: "average engagement time (high to low)",
                onClickFunction: (e)=>{
                    this.sortPageViews(e, (0, $bd586dc79e4551d2$export$32383f57b34c9dd3).AverageEngagementTime, (0, $bd586dc79e4551d2$export$3f1135e49ddd846e).Desc);
                }
            }
        ];
        this.state = {
            id: `page-views-overview-${Date.now().toString()}`,
            loading: true,
            currentPage: 1,
            comparedCurrentPage: 1,
            pageViewsSummary: null,
            sort: "",
            direction: "",
            pageViewsSortingMenu: false,
            sortedByTextValue: ""
        };
        this.loadData = this.loadData.bind(this);
        this.changePageHandler = this.changePageHandler.bind(this);
        this.sortPageViews = this.sortPageViews.bind(this);
    }
    componentDidMount() {
        this.loadData(this.state.currentPage);
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    // load the the data depending on the sort filter
    getSortResults(sort, direction) {
        this.setState({
            loading: true
        });
        const pageSize = 10;
        let pageViewsSummaryPromise = Promise.resolve();
        pageViewsSummaryPromise = (0, $41b4a37f2cb2a113$export$e9cb9cac58dc5310)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            currentPage: this.state.currentPage,
            pageSize: pageSize,
            sort: sort,
            direction: direction,
            filters: this.context.appliedFilters
        }).then((sortResults)=>{
            this.setState({
                pageViewsSummary: sortResults.data,
                totalPageCount: Math.ceil(sortResults.pagination.totalCount / pageSize),
                currentPage: sortResults.pagination.currentPage,
                loading: false
            });
        });
        Promise.all([
            pageViewsSummaryPromise
        ]);
    }
    loadData(currentPage) {
        this.setState({
            loading: true
        });
        let pageViewsSummaryPromise = Promise.resolve();
        const pageSize = 10;
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project"
        ])) pageViewsSummaryPromise = (0, $41b4a37f2cb2a113$export$e9cb9cac58dc5310)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            currentPage: currentPage || this.state.currentPage,
            pageSize: pageSize,
            filters: this.context.appliedFilters
        }).then((allPagesSummary)=>{
            this.setState({
                pageViewsSummary: allPagesSummary.data,
                totalPageCount: Math.ceil(allPagesSummary.pagination.totalCount / pageSize),
                currentPage: allPagesSummary.pagination.currentPage
            });
        });
        let comparedPageViewsSummaryPromise = Promise.resolve();
        if (this.context.comparedPeriod) comparedPageViewsSummaryPromise = (0, $41b4a37f2cb2a113$export$e9cb9cac58dc5310)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            currentPage: currentPage || this.state.currentPage,
            pageSize: pageSize,
            filters: this.context.appliedFilters
        }).then((allPagesSummary)=>{
            this.setState({
                comparedPageViewsSummary: allPagesSummary.data,
                comparedTotalPageCount: Math.ceil(allPagesSummary.pagination.totalCount / pageSize),
                comparedCurrentPage: allPagesSummary.pagination.currentPage
            });
        });
        Promise.all([
            pageViewsSummaryPromise,
            comparedPageViewsSummaryPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    changePageHandler(currentPage) {
        this.setState({
            currentPage: currentPage
        }, ()=>{
            this.loadData(currentPage);
        });
    }
    sortPageViews(e, sort, direction) {
        const input = e.target;
        this.setState({
            sortedByTextValue: input.innerText,
            sort: sort,
            direction: direction
        });
        this.getSortResults(sort, direction);
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "page-views",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card overview-card transparent-card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                children: [
                                    t("General Statistics"),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                        className: "duration",
                                        children: [
                                            "(",
                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "overview-items overview-grid-fit-items",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                this.state.pageViewsSummary?.ordersConversionRate,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("ordersConversionRate")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "header",
                                            children: [
                                                this.state.pageViewsSummary?.registrationsConversionRate,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("registrationsConversionRate")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.pageViewsSummary?.totalOrders)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalOrders")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.pageViewsSummary?.newCustomersWithOrders)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("ordersFromNewUsers")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.pageViewsSummary?.newCustomers)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("newUserRegistrations")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.pageViewsSummary?.totalUsers)
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "title",
                                            children: t("totalUniqueUsers")
                                        })
                                    ]
                                })
                            ]
                        }),
                        this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                    className: "card--title",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        children: [
                                            t("General Statistics"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                className: "duration",
                                                children: [
                                                    "(",
                                                    (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod.from, this.context.comparedPeriod.to),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "overview-items",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPageViewsSummary?.totalOrders)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("totalOrders")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPageViewsSummary?.newCustomersWithOrders)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("ordersFromNewUsers")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedPageViewsSummary?.newCustomers)
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("newUserRegistrations")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "dropdown-container",
                    onClick: ()=>{
                        this.setState({
                            pageViewsSortingMenu: !this.state.pageViewsSortingMenu
                        });
                    },
                    children: [
                        "Sort By",
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                            className: "dropdown-container__sort",
                            children: this.state.sortedByTextValue
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                            className: "dropdown-icon"
                        }),
                        this.state.pageViewsSortingMenu && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                            className: "dropdown-menu",
                            children: this.dropdownFilters.map((filter, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "item",
                                    onClick: (e)=>{
                                        filter.onClickFunction(e);
                                    },
                                    children: filter.text
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                children: [
                                    t("pages"),
                                    " ",
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                        className: "duration",
                                        children: [
                                            "(",
                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "page-views__table",
                            children: [
                                this.state.pageViewsSummary && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    role: "table",
                                    className: "table",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "row",
                                            className: "table-headers",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("page")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("pageLink")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("averageEngagement")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("totalPageViews")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "rowgroup",
                                            className: "table-body",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                                children: this.state.pageViewsSummary.pagesReport.map((pagesReport, index)=>{
                                                    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                    children: pagesReport.pageName
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item item-link item-name",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                                    href: `//${pagesReport.pagePath}`,
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    children: pagesReport.pagePath
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                    children: pagesReport.averageEngagementTime
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    role: "cell",
                                                                    className: "item-sold",
                                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(pagesReport.pageViews)} ${t("views")}`
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                role: "cell",
                                                                className: "item-more-details",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                                    type: "submit",
                                                                    onClick: ()=>{
                                                                        this.props.loadPage(pagesReport.pageName);
                                                                    },
                                                                    children: [
                                                                        t("viewPage"),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                                            className: "right-arrow"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "page-navigator",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                        totalPageCount: this.state.totalPageCount,
                                        currentPage: this.state.currentPage,
                                        pageNeighbors: 1,
                                        changePageHandler: this.changePageHandler
                                    })
                                })
                            ]
                        })
                    ]
                }),
                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                children: [
                                    t("pages"),
                                    " ",
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                        className: "duration",
                                        children: [
                                            "(",
                                            (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod.from, this.context.comparedPeriod.to),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "page-views__table",
                            children: [
                                this.state.comparedPageViewsSummary && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    role: "table",
                                    className: "table",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "row",
                                            className: "table-headers",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("page")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("pageLink")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("averageEngagement")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    role: "columnheader",
                                                    className: "table-head",
                                                    children: t("totalPageViews")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            role: "rowgroup",
                                            className: "table-body",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                                children: this.state.comparedPageViewsSummary.pagesReport.map((pagesReport, index)=>{
                                                    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                    children: pagesReport.pageName
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item item-link item-name",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                                    href: `//${pagesReport.pagePath}`,
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    children: pagesReport.pagePath
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                    children: pagesReport.averageEngagementTime
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                role: "cell",
                                                                className: "item",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    role: "cell",
                                                                    className: "item-sold",
                                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(pagesReport.pageViews)} ${t("views")}`
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                role: "cell",
                                                                className: "item-more-details",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                                    type: "submit",
                                                                    onClick: ()=>{
                                                                        this.props.loadPage(pagesReport.pageName);
                                                                    },
                                                                    children: [
                                                                        t("viewPage"),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                                            className: "right-arrow"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "page-navigator",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                        totalPageCount: this.state.comparedTotalPageCount,
                                        currentPage: this.state.comparedCurrentPage,
                                        pageNeighbors: 1,
                                        changePageHandler: this.changePageHandler
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$a67e99e9518b1deb$var$PageViewsOverview.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $a67e99e9518b1deb$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($a67e99e9518b1deb$var$PageViewsOverview);


class $aed67f0b980b6c01$var$PageViews extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: this.state.activePageTitle ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                        className: "products-button--back",
                        type: "button",
                        onClick: ()=>{
                            this.setState({
                                activePageTitle: null
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                            t("backToPagesList")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $925f54fbea6dd490$export$2e2bcd8739ae039), {
                        pageTitle: this.state.activePageTitle
                    })
                ]
            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a67e99e9518b1deb$export$2e2bcd8739ae039), {
                loadPage: (pageTitle)=>{
                    this.setState({
                        activePageTitle: pageTitle
                    });
                }
            })
        });
    }
}
var $aed67f0b980b6c01$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($aed67f0b980b6c01$var$PageViews);


class $bcf2052b9f2f3f03$var$UserBehavior extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        const query = window.location.search;
        const params = new URLSearchParams(query);
        this.exportUserBehaviorRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            activeTab: params.get("activeTab") ?? this.context?.settings.platform === "magento" ? "search_terms" : "promo_codes",
            id: Date.now().toString(),
            showAllPromos: false,
            pageTitle: ""
        };
        this.updateShowAllPromosState = this.updateShowAllPromosState.bind(this);
        this.updateExportedPromoCodes = this.updateExportedPromoCodes.bind(this);
        this.updatePageTitle = this.updatePageTitle.bind(this);
    }
    componentDidMount() {
        // set page title
        document.title = "User Behavior";
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab) {
            this.context.updateUrlQueryParams(this.state.activeTab);
            // set page title according to the active tab
            switch(this.state.activeTab){
                case "search_terms":
                    document.title = "Search Terms";
                    break;
                case "loyalty_program":
                    document.title = "Loyalty Program";
                    break;
                case "promo_codes":
                    document.title = "Promocodes";
                    break;
                case "page_views":
                    document.title = "Page Views";
                    break;
                default:
                    document.title = "User Behavior";
                    break;
            }
        }
    }
    updateShowAllPromosState(showPromosState) {
        this.setState({
            showAllPromos: showPromosState
        });
    }
    updateExportedPromoCodes(exportedPromoCodes) {
        this.setState({
            exportedPromoCodes: exportedPromoCodes
        });
    }
    updatePageTitle(pageTitle) {
        this.setState({
            pageTitle: pageTitle
        });
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "customers",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("userBehavior"),
                    exportRef: this.exportUserBehaviorRef,
                    disableDateFilters: this.state.activeTab === "search_terms",
                    disableAdvancedFilters: this.state.activeTab === "search_terms"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "tabs",
                    children: [
                        this.context.settings.platform !== "woocommerce" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "search_terms" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "search_terms") this.setState({
                                    activeTab: "search_terms"
                                });
                            },
                            children: t("searchTerms")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "promo_codes" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "promo_codes") this.setState({
                                    activeTab: "promo_codes"
                                });
                            },
                            children: t("promocodes")
                        }),
                        this.context.settings?.edition !== "community" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "loyalty_program" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "loyalty_program") this.setState({
                                    activeTab: "loyalty_program"
                                });
                            },
                            children: t("loyaltyProgram")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "page_views" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "page_views") this.setState({
                                    activeTab: "page_views"
                                });
                            },
                            children: t("pageViews")
                        })
                    ]
                }),
                this.state.activeTab === "search_terms" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $928fbafb6e340774$export$2e2bcd8739ae039), {
                    exportRef: this.exportUserBehaviorRef
                }),
                this.state.activeTab === "loyalty_program" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $e4fe20ee183ad597$export$2e2bcd8739ae039), {
                    exportRef: this.exportUserBehaviorRef
                }),
                this.state.activeTab === "promo_codes" && (!this.state.showAllPromos ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $668d3dc287e8b431$export$2e2bcd8739ae039), {
                    exportRef: this.exportUserBehaviorRef,
                    updateShowAllPromosState: this.updateShowAllPromosState,
                    updateExportedPromoCodes: this.updateExportedPromoCodes
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                            className: "products-button--back",
                            type: "button",
                            onClick: ()=>{
                                this.setState({
                                    showAllPromos: false
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                t("backToPagesList")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4e990fa1655d1650$export$2e2bcd8739ae039), {
                            exportRef: this.exportUserBehaviorRef,
                            unpaginatedExportedPromoCodes: this.state.exportedPromoCodes
                        })
                    ]
                })),
                this.state.activeTab === "page_views" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: this.context.settings.ga4_property_id ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $aed67f0b980b6c01$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "page-views page-views__empty",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                children: t("GA4NotIntegrated")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                                className: "button save",
                                to: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).settings.path}/integration`,
                                children: t("integrateGA4")
                            })
                        ]
                    })
                })
            ]
        });
    }
}
$bcf2052b9f2f3f03$var$UserBehavior.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $bcf2052b9f2f3f03$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("user-behavior")($bcf2052b9f2f3f03$var$UserBehavior);


/**
 * @author Ahmed Serag
 * @date 2019-07-15
 * @description login page.
 * @filename index.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

var $4l1Xa = parcelRequire("4l1Xa");






var $7a2c23ebf6bb4208$exports = {};
$7a2c23ebf6bb4208$exports = $parcel$resolve("igHb0");


/**
 * @author Youssef Tarek
 * @date 2022-07-04
 * @description Otp box component
 * @filename otp-box.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $5773a4f9b57f21e2$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4\\d{4}",
                    [
                        5
                    ]
                ]
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "690\\d{6}|[356]\\d{5}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5[024-68]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7\\d{8}"
                ]
            ]
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268",
            [
                0,
                [
                    "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"
                ]
            ]
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264",
            [
                0,
                [
                    "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"
                ]
            ]
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[78][2-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"
                ]
            ]
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-79]\\d{7}"
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1",
            0,
            0,
            [
                0,
                [
                    "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"
                ]
            ]
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684",
            [
                0,
                [
                    "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"
                ]
            ]
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                        "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
                    [
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13
                    ]
                ]
            ]
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            [
                0,
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"
                ]
            ]
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"
                ]
            ]
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246",
            [
                0,
                [
                    "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"
                ]
            ]
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4[5-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "64[0-2]\\d{5}|(?:29|[67][125-9])\\d{6}"
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441",
            [
                0,
                [
                    "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"
                ]
            ]
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:22[89]|[78]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?",
            0,
            0,
            0,
            [
                0,
                [
                    "[67]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]",
            [
                0,
                [
                    "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"
                ]
            ]
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37|86)",
                        "300|4(?:0(?:0|20)|370|864)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2",
            0,
            0,
            [
                0,
                [
                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                    [
                        10,
                        11
                    ]
                ]
            ]
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242",
            [
                0,
                [
                    "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"
                ]
            ]
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[67]|77)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:321|7[1-8]\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6[0-35-7]\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                0,
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}",
                    [
                        7,
                        9
                    ]
                ]
            ]
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[024-7]\\d{6}"
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6[89]|7[235-9])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "0[157]\\d{8}"
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[578]\\d{4}"
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            [
                0,
                [
                    "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                    [
                        11
                    ]
                ]
            ],
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?",
            0,
            0,
            0,
            [
                0,
                [
                    "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5\\d|6[2-4])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:36|5[1-389]|9\\d)\\d{5}"
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]",
            [
                0,
                [
                    "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"
                ]
            ]
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                0,
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:10|[4-79]\\d)\\d{5}"
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}",
                    [
                        10,
                        11
                    ]
                ]
            ]
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "77\\d{6}"
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767",
            [
                0,
                [
                    "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"
                ]
            ]
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9",
            [
                0,
                [
                    "8[024]9[2-9]\\d{6}"
                ]
            ]
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                    [
                        7,
                        8
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1[0-25]\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]",
            [
                0,
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}"
                ]
            ]
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:17[1-3]|7\\d\\d)\\d{4}"
                ]
            ]
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"
                ]
            ]
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            [
                0,
                [
                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[56]\\d{4}"
                ]
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[27][1-9]|5\\d|9[16])\\d{4}"
                ]
            ]
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"
                ]
            ]
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1",
            0,
            0,
            [
                0,
                [
                    "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"
                ]
            ]
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473",
            [
                0,
                [
                    "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"
                ]
            ]
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"
                ]
            ]
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"
                ]
            ]
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                0,
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[245]\\d{5}"
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[23679]\\d|4[015]|5[0-489])\\d{5}"
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6[0-356]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:222|55\\d)\\d{6}"
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671",
            [
                0,
                [
                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"
                ]
            ]
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:5\\d|6[569]|77)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}"
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:[26][0-5]|4[0-28]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3]|78[0-5])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[37-9]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[34]\\d|55)\\d{6}"
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[257]0|3[01])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[1-35-9]\\d{7,10}",
                    [
                        9,
                        10,
                        11,
                        12
                    ]
                ]
            ]
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8(?:22|[35-9]\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24",
            [
                0,
                [
                    "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"
                ]
            ]
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "38\\d{5}"
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[3-9]\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"
                ]
            ],
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                0,
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876",
            [
                0,
                [
                    "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"
                ]
            ]
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[78][0-25-9]|9\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1",
            0,
            0,
            [
                0,
                [
                    "[7-9]0[1-9]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                    [
                        8,
                        9
                    ]
                ]
            ]
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[34]\\d{6}"
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869",
            [
                0,
                [
                    "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"
                ]
            ]
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "19[1-3]\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?",
            0,
            0,
            0,
            [
                0,
                [
                    "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345",
            [
                0,
                [
                    "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"
                ]
            ]
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            [
                0,
                [
                    "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "787\\d{4}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3]))\\d{5}"
                ]
            ]
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758",
            [
                0,
                [
                    "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"
                ]
            ]
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0",
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"
                ]
            ]
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[0-25-8]\\d|4[0-4])\\d{6}"
                ]
            ]
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
                    [
                        7,
                        9
                    ]
                ]
            ]
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[56]\\d{7}"
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]",
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{7}"
                ]
            ]
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-6]\\d{7}"
                ]
            ]
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"
                ]
            ]
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "562\\d{5}|(?:6\\d|7[16-9])\\d{6}"
                ]
            ]
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1",
            0,
            0,
            [
                0,
                [
                    "3[2-47-9]\\d{7}"
                ]
            ]
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:23|54)5|329|45[35-8])\\d{4}"
                ]
            ]
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"
                ]
            ]
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}"
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                    [
                        7,
                        8,
                        9,
                        10
                    ]
                ]
            ]
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670",
            [
                0,
                [
                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"
                ]
            ]
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:69[67]\\d\\d|7091[0-3])\\d{4}"
                ]
            ]
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[2-4][0-46-9]\\d{6}"
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664",
            [
                0,
                [
                    "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"
                ]
            ]
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-6]|3[013]))\\d{5}",
                    [
                        8
                    ]
                ]
            ],
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:46[46]|[79]\\d\\d)\\d{4}",
                    [
                        7
                    ]
                ]
            ],
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"
                ]
            ],
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[2-79]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:60|8[1245])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[579]\\d|8[0-79])\\d{4}"
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:23|7[0467]|[89]\\d)\\d{6}"
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1",
            0,
            0,
            [
                0,
                [
                    "(?:14|3[58])\\d{4}"
                ]
            ]
        ],
        "NG": [
            "234",
            "009",
            "(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
            [
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6[1-58]|970\\d)\\d{7}",
                    [
                        9,
                        11
                    ]
                ]
            ]
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]",
            [
                0,
                [
                    "(?:4[015-8]|9\\d)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "NR": [
            "674",
            "00",
            "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[56]|888[1-9])\\d{3}"
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                    [
                        8,
                        9,
                        10
                    ]
                ]
            ],
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                    [
                        7,
                        8
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9\\d{8}",
                    [
                        9
                    ]
                ]
            ],
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "8[7-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7\\d|8[1-38])\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"
                ]
            ]
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939",
            [
                0,
                [
                    "(?:787|939)[2-9]\\d{6}"
                ]
            ]
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "5[69]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[136]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[35-7]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                    [
                        9
                    ]
                ]
            ],
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6(?:[0-689]|7\\d)\\d{6,7}",
                    [
                        8,
                        9,
                        10
                    ]
                ]
            ]
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            [
                0,
                [
                    "9\\d{9}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[237-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "2[125-8]\\d{5}"
                ]
            ],
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1[0-2]|9[0-3569])\\d{7}"
                ]
            ]
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[02369]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "897[01]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-6])|9[0-8]\\d)\\d{5}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]",
            [
                0,
                [
                    "[56]\\d{4}",
                    [
                        5
                    ]
                ]
            ]
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79",
            [
                0,
                [
                    "(?:4[015-8]|9\\d)\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"
                ]
            ]
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1",
            0,
            0,
            [
                0,
                [
                    "6[16]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                    [
                        7,
                        8,
                        9
                    ]
                ]
            ]
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d|90)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[124-7]|8[1-9])\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:12|9[1257-9])\\d{7}"
                ]
            ]
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[67]\\d{7}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721",
            [
                0,
                [
                    "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"
                ]
            ]
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-9]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[6-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649",
            [
                0,
                [
                    "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"
                ]
            ]
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[69]\\d|77|8[56])\\d{6}"
                ]
            ],
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[0-29]|9[0-36-9])\\d{6}"
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"
                ]
            ],
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[2-4]\\d{2,5}"
                ]
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[2-8]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6\\d|71)\\d{6}"
                ]
            ],
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868",
            [
                0,
                [
                    "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"
                ]
            ]
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[01]\\d|90)\\d{4}",
                    [
                        6,
                        7
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                    [
                        9
                    ]
                ]
            ],
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:6[125-9]|7[13-9])\\d{7}"
                ]
            ]
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
                    [
                        9
                    ]
                ]
            ],
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[089])\\d{6}"
                ]
            ]
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "9[1-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ],
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698",
            [
                0,
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ]
            ]
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784",
            [
                0,
                [
                    "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"
                ]
            ]
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4(?:1[24-8]|2[246])\\d{7}"
                ]
            ]
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284",
            [
                0,
                [
                    "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"
                ]
            ]
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340",
            [
                0,
                [
                    "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"
                ]
            ]
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[58]\\d|7[013-7])\\d{5}",
                    [
                        7
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:72|8[23])\\d{4}",
                    [
                        6
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
                    [
                        7,
                        10
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "4[3-9]\\d{6}",
                    [
                        8
                    ]
                ]
            ]
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7[01378]\\d{7}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ]
            ]
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[59][5-8]|7[5-9])\\d{7}"
                ]
            ]
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "7(?:[1278]\\d|3[1-9])\\d{6}",
                    [
                        9
                    ]
                ]
            ]
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $7b181f8e94b9e93d$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $5773a4f9b57f21e2$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $657bdb05e46e21e5$var$objectConstructor = {}.constructor;
function $657bdb05e46e21e5$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $657bdb05e46e21e5$var$objectConstructor;
}


function $39acf5220d9ed0f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39acf5220d9ed0f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $39acf5220d9ed0f5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $39acf5220d9ed0f5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $39acf5220d9ed0f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $39acf5220d9ed0f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39acf5220d9ed0f5$var$_slicedToArray(arr, i) {
    return $39acf5220d9ed0f5$var$_arrayWithHoles(arr) || $39acf5220d9ed0f5$var$_iterableToArrayLimit(arr, i) || $39acf5220d9ed0f5$var$_unsupportedIterableToArray(arr, i) || $39acf5220d9ed0f5$var$_nonIterableRest();
}
function $39acf5220d9ed0f5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39acf5220d9ed0f5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $39acf5220d9ed0f5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $39acf5220d9ed0f5$var$_arrayLikeToArray(o, minLen);
}
function $39acf5220d9ed0f5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $39acf5220d9ed0f5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $39acf5220d9ed0f5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $39acf5220d9ed0f5$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $39acf5220d9ed0f5$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $39acf5220d9ed0f5$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $657bdb05e46e21e5$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $7398a06dd74c1348$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $7398a06dd74c1348$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $7398a06dd74c1348$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $7398a06dd74c1348$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $7398a06dd74c1348$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $7398a06dd74c1348$var$SLASHES = "\uFF0F/";
var $7398a06dd74c1348$var$DOTS = "\uFF0E.";
var $7398a06dd74c1348$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $7398a06dd74c1348$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $7398a06dd74c1348$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $7398a06dd74c1348$export$7f01587e28f9194 = "".concat($7398a06dd74c1348$var$DASHES).concat($7398a06dd74c1348$var$SLASHES).concat($7398a06dd74c1348$var$DOTS).concat($7398a06dd74c1348$export$20542845033f576e).concat($7398a06dd74c1348$var$BRACKETS).concat($7398a06dd74c1348$var$TILDES);
var $7398a06dd74c1348$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $c7a01e53e70ad153$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c7a01e53e70ad153$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c7a01e53e70ad153$var$_typeof(obj);
}
function $c7a01e53e70ad153$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c7a01e53e70ad153$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c7a01e53e70ad153$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c7a01e53e70ad153$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c7a01e53e70ad153$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c7a01e53e70ad153$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c7a01e53e70ad153$var$_setPrototypeOf(subClass, superClass);
}
function $c7a01e53e70ad153$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c7a01e53e70ad153$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c7a01e53e70ad153$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c7a01e53e70ad153$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c7a01e53e70ad153$var$_possibleConstructorReturn(this, result);
    };
}
function $c7a01e53e70ad153$var$_possibleConstructorReturn(self, call) {
    if (call && ($c7a01e53e70ad153$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c7a01e53e70ad153$var$_assertThisInitialized(self);
}
function $c7a01e53e70ad153$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c7a01e53e70ad153$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $c7a01e53e70ad153$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$c7a01e53e70ad153$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $c7a01e53e70ad153$var$_construct(Class, arguments, $c7a01e53e70ad153$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $c7a01e53e70ad153$var$_setPrototypeOf(Wrapper, Class);
    };
    return $c7a01e53e70ad153$var$_wrapNativeSuper(Class);
}
function $c7a01e53e70ad153$var$_construct(Parent, args, Class) {
    if ($c7a01e53e70ad153$var$_isNativeReflectConstruct()) $c7a01e53e70ad153$var$_construct = Reflect.construct;
    else $c7a01e53e70ad153$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $c7a01e53e70ad153$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $c7a01e53e70ad153$var$_construct.apply(null, arguments);
}
function $c7a01e53e70ad153$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c7a01e53e70ad153$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $c7a01e53e70ad153$var$_setPrototypeOf(o, p) {
    $c7a01e53e70ad153$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c7a01e53e70ad153$var$_setPrototypeOf(o, p);
}
function $c7a01e53e70ad153$var$_getPrototypeOf(o) {
    $c7a01e53e70ad153$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c7a01e53e70ad153$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $c7a01e53e70ad153$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $c7a01e53e70ad153$var$_inherits(ParseError, _Error);
    var _super = $c7a01e53e70ad153$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $c7a01e53e70ad153$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($c7a01e53e70ad153$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $c7a01e53e70ad153$var$_createClass(ParseError);
}(/*#__PURE__*/ $c7a01e53e70ad153$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $139f41920448d547$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $2fc55058025056f8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2fc55058025056f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2fc55058025056f8$var$_typeof(obj);
}
function $2fc55058025056f8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2fc55058025056f8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2fc55058025056f8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2fc55058025056f8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2fc55058025056f8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $2fc55058025056f8$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $2fc55058025056f8$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $2fc55058025056f8$var$V4 = '1.7.35';
var $2fc55058025056f8$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $2fc55058025056f8$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $2fc55058025056f8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $2fc55058025056f8$var$_classCallCheck(this, Metadata);
        $2fc55058025056f8$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $2fc55058025056f8$var$setVersion.call(this, metadata);
    }
    $2fc55058025056f8$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $2fc55058025056f8$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $2fc55058025056f8$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $2fc55058025056f8$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $2fc55058025056f8$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $2fc55058025056f8$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $2fc55058025056f8$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $2fc55058025056f8$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $2fc55058025056f8$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $2fc55058025056f8$var$getType(this.types(), _type2)) return new $2fc55058025056f8$var$Type($2fc55058025056f8$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $2fc55058025056f8$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $2fc55058025056f8$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $2fc55058025056f8$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $2fc55058025056f8$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $2fc55058025056f8$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$2fc55058025056f8$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $2fc55058025056f8$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $2fc55058025056f8$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $2fc55058025056f8$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $2fc55058025056f8$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $2fc55058025056f8$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $2fc55058025056f8$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $657bdb05e46e21e5$export$2e2bcd8739ae039)(metadata) || !(0, $657bdb05e46e21e5$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $657bdb05e46e21e5$export$2e2bcd8739ae039)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $2fc55058025056f8$var$typeOf(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $2fc55058025056f8$var$typeOf = function typeOf(_) {
    return $2fc55058025056f8$var$_typeof(_);
};
function $2fc55058025056f8$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $2fc55058025056f8$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $2fc55058025056f8$var$DEFAULT_EXT_PREFIX;
}
function $2fc55058025056f8$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $2fc55058025056f8$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $2fc55058025056f8$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $2fc55058025056f8$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $139f41920448d547$export$2e2bcd8739ae039)(version, $2fc55058025056f8$var$V3) === -1) this.v2 = true;
        else if ((0, $139f41920448d547$export$2e2bcd8739ae039)(version, $2fc55058025056f8$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $37d38f12f86040f0$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $37d38f12f86040f0$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $7398a06dd74c1348$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $37d38f12f86040f0$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $37d38f12f86040f0$var$RFC3966_EXTN_PREFIX + $37d38f12f86040f0$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $37d38f12f86040f0$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $37d38f12f86040f0$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $37d38f12f86040f0$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $37d38f12f86040f0$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $37d38f12f86040f0$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $e6463f9b783bd896$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $7398a06dd74c1348$export$852d1d4a47329634) + ']{' + (0, $7398a06dd74c1348$export$cd8355bcbe13154) + '}'; //
var $e6463f9b783bd896$export$a77dd7471651eee = '[' + (0, $7398a06dd74c1348$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $7398a06dd74c1348$export$7f01587e28f9194) + ']*' + '[' + (0, $7398a06dd74c1348$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $7398a06dd74c1348$export$7f01587e28f9194) + (0, $7398a06dd74c1348$export$852d1d4a47329634) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $e6463f9b783bd896$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $7398a06dd74c1348$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $7398a06dd74c1348$export$7f01587e28f9194) + ']*' + '[' + (0, $7398a06dd74c1348$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $e6463f9b783bd896$export$a2d12a04749c087d = $e6463f9b783bd896$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $37d38f12f86040f0$export$2e2bcd8739ae039)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $e6463f9b783bd896$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $e6463f9b783bd896$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $e6463f9b783bd896$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $e6463f9b783bd896$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $7398a06dd74c1348$export$cd8355bcbe13154) && $e6463f9b783bd896$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $e6463f9b783bd896$export$4c3f76c95c05197c(number) {
    return $e6463f9b783bd896$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $653ed950650d928a$var$EXTN_PATTERN = new RegExp('(?:' + (0, $37d38f12f86040f0$export$2e2bcd8739ae039)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $653ed950650d928a$export$2e2bcd8739ae039(number) {
    var start = number.search($653ed950650d928a$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($653ed950650d928a$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $fcd2946d0b310896$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fcd2946d0b310896$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fcd2946d0b310896$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fcd2946d0b310896$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fcd2946d0b310896$var$_arrayLikeToArray(o, minLen);
}
function $fcd2946d0b310896$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $fcd2946d0b310896$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $fcd2946d0b310896$export$1d16fddea1437169(character) {
    return $fcd2946d0b310896$export$2848f3d68c08fe69[character];
}
function $fcd2946d0b310896$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $fcd2946d0b310896$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $fcd2946d0b310896$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $a3a40a82586e2c0b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a3a40a82586e2c0b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a3a40a82586e2c0b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a3a40a82586e2c0b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a3a40a82586e2c0b$var$_arrayLikeToArray(o, minLen);
}
function $a3a40a82586e2c0b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a3a40a82586e2c0b$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $a3a40a82586e2c0b$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $a3a40a82586e2c0b$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $a3a40a82586e2c0b$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === 'function') emitEvent('end');
            return;
        }
        return '+';
    } // Allow digits.
    return (0, $fcd2946d0b310896$export$1d16fddea1437169)(character);
}




function $a78b61360d2bad2d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a78b61360d2bad2d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a78b61360d2bad2d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a78b61360d2bad2d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a78b61360d2bad2d$var$_arrayLikeToArray(o, minLen);
}
function $a78b61360d2bad2d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a78b61360d2bad2d$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $a78b61360d2bad2d$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $f1a71024cce2f81b$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $f1a71024cce2f81b$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $f1a71024cce2f81b$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $f1a71024cce2f81b$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $a78b61360d2bad2d$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $6f0e7ed251c3d37b$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $6f0e7ed251c3d37b$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $6f0e7ed251c3d37b$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $f1a71024cce2f81b$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $772b5279cba92398$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}




function $5678cf7e43a1a189$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5678cf7e43a1a189$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5678cf7e43a1a189$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5678cf7e43a1a189$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5678cf7e43a1a189$var$_arrayLikeToArray(o, minLen);
}
function $5678cf7e43a1a189$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5678cf7e43a1a189$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $5678cf7e43a1a189$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($5678cf7e43a1a189$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($5678cf7e43a1a189$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $5678cf7e43a1a189$var$_createForOfIteratorHelperLoose($5678cf7e43a1a189$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($5678cf7e43a1a189$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $5678cf7e43a1a189$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $f777cbbf995bd87d$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $5678cf7e43a1a189$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $ba46b3e1df44c26d$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $ba46b3e1df44c26d$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $ba46b3e1df44c26d$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




var $3d285b0c9d97361a$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $7398a06dd74c1348$export$852d1d4a47329634) + '])');
function $3d285b0c9d97361a$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($3d285b0c9d97361a$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $1d5d3b5d20018c52$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $f84088cae421a6f3$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $1d5d3b5d20018c52$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$f84088cae421a6f3$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$f84088cae421a6f3$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $f84088cae421a6f3$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $f84088cae421a6f3$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $f1a71024cce2f81b$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $c786dfa2a0e84055$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $2fc55058025056f8$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $f84088cae421a6f3$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $f84088cae421a6f3$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $772b5279cba92398$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $f1a71024cce2f81b$export$2e2bcd8739ae039)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $15dc1d3756e6d5d9$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $3d285b0c9d97361a$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $c786dfa2a0e84055$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $7398a06dd74c1348$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }





function $214136ef1af8cd07$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $7398a06dd74c1348$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $6a0bb59600486059$export$4f32ad1c51a7a6be = /(\$\d)/;
function $6a0bb59600486059$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($6a0bb59600486059$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $214136ef1af8cd07$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $d5f04ed690fb4f3e$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $d5f04ed690fb4f3e$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($d5f04ed690fb4f3e$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $eb53b81159c407f5$var$_slicedToArray(arr, i) {
    return $eb53b81159c407f5$var$_arrayWithHoles(arr) || $eb53b81159c407f5$var$_iterableToArrayLimit(arr, i) || $eb53b81159c407f5$var$_unsupportedIterableToArray(arr, i) || $eb53b81159c407f5$var$_nonIterableRest();
}
function $eb53b81159c407f5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eb53b81159c407f5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $eb53b81159c407f5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $eb53b81159c407f5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $eb53b81159c407f5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eb53b81159c407f5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eb53b81159c407f5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eb53b81159c407f5$var$_arrayLikeToArray(o, minLen);
}
function $eb53b81159c407f5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eb53b81159c407f5$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $eb53b81159c407f5$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $eb53b81159c407f5$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $e6463f9b783bd896$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $eb53b81159c407f5$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}


function $48f7fc7b2bf55324$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $48f7fc7b2bf55324$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $48f7fc7b2bf55324$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $48f7fc7b2bf55324$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $48f7fc7b2bf55324$var$_arrayLikeToArray(o, minLen);
}
function $48f7fc7b2bf55324$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $48f7fc7b2bf55324$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $48f7fc7b2bf55324$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $48f7fc7b2bf55324$var$ownKeys(Object(source), !0).forEach(function(key) {
            $48f7fc7b2bf55324$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $48f7fc7b2bf55324$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $48f7fc7b2bf55324$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $48f7fc7b2bf55324$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $48f7fc7b2bf55324$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $48f7fc7b2bf55324$var$_objectSpread($48f7fc7b2bf55324$var$_objectSpread({}, $48f7fc7b2bf55324$var$DEFAULT_OPTIONS), options);
    else options = $48f7fc7b2bf55324$var$DEFAULT_OPTIONS;
    metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $48f7fc7b2bf55324$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $48f7fc7b2bf55324$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $48f7fc7b2bf55324$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $48f7fc7b2bf55324$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $eb53b81159c407f5$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $48f7fc7b2bf55324$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $48f7fc7b2bf55324$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $48f7fc7b2bf55324$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $48f7fc7b2bf55324$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $6a0bb59600486059$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $48f7fc7b2bf55324$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $48f7fc7b2bf55324$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $48f7fc7b2bf55324$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $48f7fc7b2bf55324$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $2fc55058025056f8$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $48f7fc7b2bf55324$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $d5f04ed690fb4f3e$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($48f7fc7b2bf55324$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}


function $024e9937924e6262$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $024e9937924e6262$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $024e9937924e6262$var$ownKeys(Object(source), !0).forEach(function(key) {
            $024e9937924e6262$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $024e9937924e6262$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $024e9937924e6262$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $024e9937924e6262$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $024e9937924e6262$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $024e9937924e6262$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $024e9937924e6262$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $024e9937924e6262$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $024e9937924e6262$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $024e9937924e6262$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $024e9937924e6262$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError('First argument is required');
        if (typeof countryOrCountryCallingCode !== 'string') throw new TypeError('First argument must be a string');
         // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (typeof countryOrCountryCallingCode === 'string') {
            if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) throw new TypeError('`metadata` argument not passed');
            if ((0, $657bdb05e46e21e5$export$2e2bcd8739ae039)(nationalNumber) && (0, $657bdb05e46e21e5$export$2e2bcd8739ae039)(nationalNumber.countries)) {
                metadata = nationalNumber;
                var e164Number = countryOrCountryCallingCode;
                if (!$024e9937924e6262$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
                var _extractCountryCallin = (0, $15dc1d3756e6d5d9$export$2e2bcd8739ae039)(e164Number, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                nationalNumber = number;
                countryOrCountryCallingCode = _countryCallingCode;
                if (!nationalNumber) throw new Error('Invalid `number` argument passed: too short');
            }
        } // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError('`nationalNumber` argument is required');
        if (typeof nationalNumber !== 'string') throw new TypeError('`nationalNumber` argument must be a string');
         // Validate `metadata` argument.
        (0, $2fc55058025056f8$export$a0b100d4662a8795)(metadata); // Initialize properties.
        var _getCountryAndCountry = $024e9937924e6262$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $024e9937924e6262$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $ba46b3e1df44c26d$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $6f0e7ed251c3d37b$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $f777cbbf995bd87d$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $5678cf7e43a1a189$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $48f7fc7b2bf55324$export$2e2bcd8739ae039)(this, _format, options ? $024e9937924e6262$var$_objectSpread($024e9937924e6262$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $024e9937924e6262$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $024e9937924e6262$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($024e9937924e6262$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($024e9937924e6262$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $024e9937924e6262$var$E164_NUMBER_REGEXP = /^\+\d+$/;








function $a1fa0c300716d67f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a1fa0c300716d67f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a1fa0c300716d67f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a1fa0c300716d67f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a1fa0c300716d67f$var$_arrayLikeToArray(o, minLen);
}
function $a1fa0c300716d67f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a1fa0c300716d67f$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $a1fa0c300716d67f$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $5678cf7e43a1a189$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $3541edf9969290b3$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $3541edf9969290b3$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($3541edf9969290b3$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $a1fa0c300716d67f$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $71294df21aebac3f$export$1ddc7eed78155f68 = '+';
var $71294df21aebac3f$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $71294df21aebac3f$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $7398a06dd74c1348$export$852d1d4a47329634) + ']' + '|' + $71294df21aebac3f$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $71294df21aebac3f$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $71294df21aebac3f$export$1ddc7eed78155f68 + $71294df21aebac3f$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $7398a06dd74c1348$export$852d1d4a47329634) + ']' + $71294df21aebac3f$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $71294df21aebac3f$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($71294df21aebac3f$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $71294df21aebac3f$var$ALPHANUM_ = (0, $7398a06dd74c1348$export$852d1d4a47329634);
var $71294df21aebac3f$var$RFC3966_DOMAINLABEL_ = '[' + $71294df21aebac3f$var$ALPHANUM_ + ']+((\\-)*[' + $71294df21aebac3f$var$ALPHANUM_ + '])*';
var $71294df21aebac3f$var$VALID_ALPHA_ = 'a-zA-Z';
var $71294df21aebac3f$var$RFC3966_TOPLABEL_ = '[' + $71294df21aebac3f$var$VALID_ALPHA_ + ']+((\\-)*[' + $71294df21aebac3f$var$ALPHANUM_ + '])*';
var $71294df21aebac3f$var$RFC3966_DOMAINNAME_ = '^(' + $71294df21aebac3f$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $71294df21aebac3f$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $71294df21aebac3f$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($71294df21aebac3f$var$RFC3966_DOMAINNAME_, 'g');
var $71294df21aebac3f$export$70d485ce3f6de783 = 'tel:';
var $71294df21aebac3f$export$f6d5879d582c3a27 = ';phone-context=';
var $71294df21aebac3f$export$9e356e12edb00a81 = ';isub=';
function $71294df21aebac3f$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($71294df21aebac3f$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $71294df21aebac3f$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $71294df21aebac3f$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $71294df21aebac3f$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $71294df21aebac3f$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $dbc0f95465ed6024$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $71294df21aebac3f$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $71294df21aebac3f$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $71294df21aebac3f$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $71294df21aebac3f$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $71294df21aebac3f$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $71294df21aebac3f$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $71294df21aebac3f$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $5684d77dd54aeda8$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $5684d77dd54aeda8$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $7398a06dd74c1348$export$207c99ccf3902df8) + (0, $7398a06dd74c1348$export$852d1d4a47329634) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $5684d77dd54aeda8$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $7398a06dd74c1348$export$852d1d4a47329634) + '#' + ']+$');
var $5684d77dd54aeda8$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $5684d77dd54aeda8$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $2fc55058025056f8$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $5684d77dd54aeda8$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $5684d77dd54aeda8$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $7398a06dd74c1348$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $7398a06dd74c1348$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $024e9937924e6262$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $772b5279cba92398$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $5684d77dd54aeda8$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $6f0e7ed251c3d37b$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $5684d77dd54aeda8$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $5684d77dd54aeda8$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($5684d77dd54aeda8$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($5684d77dd54aeda8$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $5684d77dd54aeda8$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $dbc0f95465ed6024$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $5684d77dd54aeda8$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $e6463f9b783bd896$export$2e2bcd8739ae039)(number)) {
        if ((0, $e6463f9b783bd896$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $653ed950650d928a$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $5684d77dd54aeda8$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $5684d77dd54aeda8$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $15dc1d3756e6d5d9$export$2e2bcd8739ae039)((0, $a3a40a82586e2c0b$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($5684d77dd54aeda8$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $2fc55058025056f8$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $f84088cae421a6f3$export$2e2bcd8739ae039)((0, $a3a40a82586e2c0b$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $3541edf9969290b3$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $9d20ac0549c6b8cf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9d20ac0549c6b8cf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9d20ac0549c6b8cf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9d20ac0549c6b8cf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9d20ac0549c6b8cf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9d20ac0549c6b8cf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9d20ac0549c6b8cf$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $5684d77dd54aeda8$export$2e2bcd8739ae039)(text, $9d20ac0549c6b8cf$var$_objectSpread($9d20ac0549c6b8cf$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $32212af67f45c061$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $32212af67f45c061$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $32212af67f45c061$var$ownKeys(Object(source), !0).forEach(function(key) {
            $32212af67f45c061$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $32212af67f45c061$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $32212af67f45c061$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $32212af67f45c061$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $2fc55058025056f8$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $32212af67f45c061$var$_objectSpread($32212af67f45c061$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $9d20ac0549c6b8cf$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $c7a01e53e70ad153$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $930138555e4b4743$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $39acf5220d9ed0f5$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $32212af67f45c061$export$2e2bcd8739ae039)(text, options, metadata);
}


function $4b46a49f8b3ed4a7$export$da44e4eaa54bc82e() {
    return (0, $7b181f8e94b9e93d$export$2e2bcd8739ae039)((0, $930138555e4b4743$export$2e2bcd8739ae039), arguments);
}


class $2dfe8ea3dd197f6b$var$OtpBox extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props), this.currentOtPIndex = 0, this.timer = null, // to reset the state when resend is clicked
        this.initialState = {
            otp: new Array(6).fill(""),
            activeIndex: 0,
            timer: 59,
            resend: false
        }, this.handleKeyDown = (e, index)=>{
            this.currentOtPIndex = index;
            if (e.key === "Backspace") this.setState({
                activeIndex: index - 1
            });
        };
        this.state = {
            otp: new Array(6).fill(""),
            activeIndex: 0,
            timer: 59,
            resend: false
        };
        this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.resendOTP = this.resendOTP.bind(this);
    }
    componentDidMount() {
        this.startTimer();
    }
    componentDidUpdate() {
        if (this.state.activeIndex <= 5) this.inputRef.current?.focus();
        if (this.state.timer === 0) {
            this.setState({
                resend: true,
                timer: 59
            });
            clearInterval(this.timer);
        }
    }
    /**
   * validates that the user input is a number,
   * if it is updates the otp state with the current value
   * and the active index
   * @param element the input element
   * @returns
   */ handleChange(element) {
        if (Number.isNaN(Number(element.value))) return false;
        this.setState({
            otp: [
                ...this.state.otp.map((otpValue, otpIndex)=>{
                    if (otpIndex === this.currentOtPIndex) return element.value;
                    return otpValue;
                })
            ]
        });
        // this means that a backspace was entered
        if (!element.value) this.setState({
            activeIndex: this.currentOtPIndex - 1
        });
        else this.setState({
            activeIndex: this.currentOtPIndex + 1
        });
        return 1;
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.props.validate2FA) this.props.validate2FA(this.props.email, this.state.otp.join(""));
        if (this.props.loginWithOtp) this.props.loginWithOtp(this.props.email, this.props.password, this.state.otp.join(""));
    }
    startTimer() {
        this.setState({
            timer: 59
        });
        this.timer = setInterval(()=>{
            this.setState({
                timer: this.state.timer - 1
            });
        }, 1000);
    }
    resendOTP() {
        if (this.props.enable2FA) this.props.enable2FA(this.props.countryCallingCode, this.props.phone, false);
        if (this.props.loginWithOtp) this.props.loginWithOtp(this.props.email, this.props.password, "");
        this.startTimer();
        this.setState({
            ...this.initialState
        });
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "otp-box",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "otp-box__card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "otp-box__header",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "otp-box__title",
                                children: this.props.title
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                type: "button",
                                className: "otp-box__close-button",
                                onClick: this.props.toggleOtpBox,
                                children: "+"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "otp-box__content",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "otp-box__text",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        children: `${t("aCodeWasSentToTheNumber")} `
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        children: ` ${(0, $4b46a49f8b3ed4a7$export$da44e4eaa54bc82e)(`+${this.props.phone}`).formatInternational()}`
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        children: `, ${t("enterTheCodeBelow")}`
                                    })
                                ]
                            }),
                            this.props.enable2FA && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "opt-box__wrong-number",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        children: `${t("notYourNumber")}?`
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "button",
                                        className: "otp-box__change-button",
                                        onClick: this.props.toggleOtpBox,
                                        children: `${t("change")}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                        className: "otp-box__form-box",
                        onSubmit: (e)=>{
                            this.handleSubmit(e);
                        },
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "otp-box__inputs-container",
                                children: this.state.otp.map((otp, index)=>{
                                    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        ref: index === this.state.activeIndex ? this.inputRef : null,
                                        type: "text",
                                        inputMode: "numeric",
                                        autoComplete: "one-time-code",
                                        className: `otp-box__input ${this.props.errorMessage && "otp-box__error"} `,
                                        maxLength: 1,
                                        value: otp,
                                        onChange: (e)=>{
                                            this.handleChange(e.target);
                                        },
                                        onFocus: (e)=>{
                                            e.target.select();
                                        },
                                        onKeyDown: (e)=>{
                                            this.handleKeyDown(e, index);
                                        }
                                    }, index);
                                })
                            }),
                            this.props.errorMessage && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "otp-box__error-message",
                                children: this.props.errorMessage
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                type: "submit",
                                className: "button submit-btn",
                                disabled: this.state.otp.includes(""),
                                children: `${t("confirm")}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "otp-box__resend",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                            type: "button",
                            className: "otp-box__resend-button",
                            disabled: !this.state.resend,
                            onClick: this.resendOTP,
                            children: this.state.resend ? t("resend") : `${t("resendIn")} 00:${this.state.timer.toLocaleString("en-US", {
                                minimumIntegerDigits: 2
                            })}`
                        })
                    })
                ]
            })
        });
    }
}
var $2dfe8ea3dd197f6b$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("common")($2dfe8ea3dd197f6b$var$OtpBox);




var $igtsr = parcelRequire("igtsr");

parcelRequire("igtsr");
const $e867fa34c6533ee8$var$SvgShowPassword = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "currentColor",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M30.87 15.49C27.81 10.2 22.11 6.92 16 6.92S4.19 10.2 1.13 15.49c-.17.31-.17.69 0 1 3.06 5.3 8.76 8.59 14.87 8.59s11.81-3.29 14.87-8.59c.17-.31.17-.69 0-1M16 22.25c-3.45 0-6.25-2.8-6.25-6.25s2.8-6.25 6.25-6.25 6.25 2.8 6.25 6.25-2.8 6.25-6.25 6.25"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 16,
                    cy: 16,
                    r: 4.25
                })
            ]
        })
    });
var $e867fa34c6533ee8$export$2e2bcd8739ae039 = $e867fa34c6533ee8$var$SvgShowPassword;



parcelRequire("igtsr");
const $7742e8d5fe4040a9$var$SvgHidePassword = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "currentColor",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M436.193 169.626a453 453 0 0 0-16.589-13.59l-64.701 64.701A104.6 104.6 0 0 1 361 256c0 57.897-47.103 105-105 105a104.5 104.5 0 0 1-35.263-6.098l-48.558 48.558C200.535 415.092 228.66 421 256 421c32.657 0 66.432-8.396 100.384-24.955 26.662-13.005 53.514-31.063 79.809-53.671 44.455-38.226 71.841-76.024 72.984-77.615a15 15 0 0 0 0-17.518c-1.144-1.591-28.529-39.389-72.984-77.615"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M256 331c41.355 0 75-33.645 75-75 0-3.598-.27-7.134-.763-10.598l-84.835 84.835c3.465.493 7 .763 10.598.763M507.607 4.394c-5.857-5.857-15.355-5.857-21.213 0L368.546 122.242a305 305 0 0 0-12.162-6.286C322.432 99.396 288.657 91 256 91s-66.432 8.396-100.384 24.955c-26.662 13.005-53.514 31.063-79.809 53.671-44.454 38.226-71.84 76.024-72.984 77.615a15 15 0 0 0 0 17.518c1.144 1.591 28.529 39.39 72.984 77.615 13.623 11.713 27.396 22.192 41.214 31.391L4.394 486.394c-5.858 5.857-5.858 15.355 0 21.213C7.323 510.535 11.161 512 15 512s7.678-1.465 10.606-4.394l482-482c5.859-5.857 5.859-15.355.001-21.212M151 256c0-57.897 47.103-105 105-105 23.551 0 45.315 7.794 62.85 20.938l-21.52 21.52C285.471 185.594 271.265 181 256 181c-41.355 0-75 33.645-75 75 0 15.264 4.594 29.47 12.458 41.33l-21.52 21.52C158.794 301.315 151 279.551 151 256"
                })
            ]
        })
    });
var $7742e8d5fe4040a9$export$2e2bcd8739ae039 = $7742e8d5fe4040a9$var$SvgHidePassword;


class $ef1cf8d12cf69249$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    static #_ = this.defaultProps = {
        containerClassName: "",
        errorMsg: "",
        tooltip: ""
    };
    constructor(props){
        super(props);
        this.state = {};
        this.inputElRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.toggleShowPassword = this.toggleShowPassword.bind(this);
    }
    toggleShowPassword() {
        this.inputElRef.current?.focus();
        this.setState((prev)=>({
                innerType: prev.innerType ? undefined : "text"
            }));
    }
    render() {
        const { type: type = "text", id: id, label: label, required: required, disabled: disabled, containerClassName: containerClassName, errorMsg: errorMsg, placeholder: placeholder, ...rest } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: `custom-input-container ${containerClassName || ""}`,
            "aria-invalid": errorMsg ? true : undefined,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                    htmlFor: id,
                    children: label + (required ? "*" : "")
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                    ...rest,
                    ref: this.inputElRef,
                    id: id,
                    type: this.state.innerType || type,
                    required: required,
                    placeholder: placeholder || label.toString(),
                    disabled: disabled,
                    "aria-disabled": disabled,
                    "aria-invalid": errorMsg ? true : undefined
                }),
                !!errorMsg && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                    className: "error",
                    children: errorMsg
                }),
                type === "password" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                    type: "button",
                    className: "show-password-button",
                    onClick: this.toggleShowPassword,
                    disabled: disabled,
                    "aria-disabled": disabled,
                    children: this.state.innerType ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7742e8d5fe4040a9$export$2e2bcd8739ae039), {
                        role: "img",
                        "aria-label": "Hide Password"
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $e867fa34c6533ee8$export$2e2bcd8739ae039), {
                        role: "img",
                        "aria-label": "Show Password"
                    })
                }),
                this.props.tooltip && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "tooltip",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                        children: this.props.tooltip
                    })
                })
            ]
        });
    }
}



class $cfc09e83450c85b1$export$21a94553ffa41578 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            email: "",
            password: "",
            showOtpBox: false,
            errorMessage: ""
        };
        this.toggleOtpBox = this.toggleOtpBox.bind(this);
        this.submitLogin = this.submitLogin.bind(this);
        this.loginWithOtp = this.loginWithOtp.bind(this);
    }
    componentDidMount() {
        // set page title
        document.title = "Login";
    }
    /**
   * show/hide the OTP box
   */ toggleOtpBox() {
        this.setState((prevState)=>({
                showOtpBox: !prevState.showOtpBox
            }));
    }
    submitLogin(values) {
        return (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).login(values.email, values.password).then((result)=>{
            this.context.updateUser(result.user);
            return Promise.resolve(result);
        }).catch((error)=>{
            /* after logging in if user was blocked there will be a message
        that user has been blocked so if the error message returned from backend
        contained "blocked" we show a message that user is blocked */ if (error[0].includes("blocked")) {
                (0, $d41f521f78665649$export$b410431fab84fa58).error(error[0]);
                return Promise.reject();
            }
            /* if user has 2FA enabled the error message for the login will be
        an array that contains the phone number extension (country code)
        and the phone number which we then use to which we send the otp fo the user */ if (error.length === 2) {
                this.setState({
                    phoneExt: error[0],
                    phoneNumber: error[1]
                });
                this.toggleOtpBox();
            }
            const errorsArr = Array.isArray(error) ? error : [
                error
            ];
            errorsArr.forEach((err)=>(0, $d41f521f78665649$export$b410431fab84fa58).error(err));
            return Promise.reject();
        });
    }
    /**
   * @description user login with otp
   * @param email user's email
   * @param password user's password
   * @param otp otp sent to user's phone
   */ loginWithOtp(email, password, otp) {
        (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).login(email, password, otp).then((result)=>{
            this.context.updateUser(result.user);
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
            if (error.length === 1) this.setState({
                errorMessage: error
            });
        });
    }
    render() {
        if (this.context.user) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$2d8d895a0a0f636e), {
            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Overview.path
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "form-container",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "auth-wrapper",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7a2c23ebf6bb4208$exports))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                        onSubmit: this.submitLogin,
                        initialValues: {
                            email: "",
                            password: ""
                        },
                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                            email: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required("Email is required"),
                            password: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required("Password is required")
                        }),
                        validateOnMount: true,
                        children: ({ isValid: isValid, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                className: "auth__form",
                                noValidate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                        className: "auth__title",
                                        children: "Dashboard Sign In"
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "email",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "form-field",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                                    type: "email",
                                                    id: "email",
                                                    label: "Email",
                                                    autoComplete: "email",
                                                    errorMsg: meta.touched && meta.error ? meta.error : "",
                                                    disabled: isSubmitting,
                                                    ...field,
                                                    onChange: (e)=>{
                                                        this.setState({
                                                            email: e.target.value
                                                        });
                                                        field.onChange(e);
                                                    },
                                                    required: true
                                                })
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "password",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                                        type: "password",
                                                        id: "password",
                                                        label: "Password",
                                                        autoComplete: "password",
                                                        errorMsg: meta.touched && meta.error ? meta.error : "",
                                                        disabled: isSubmitting,
                                                        ...field,
                                                        onChange: (e)=>{
                                                            this.setState({
                                                                password: e.target.value
                                                            });
                                                            field.onChange(e);
                                                        },
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                                                        to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).ForgotPassword.path,
                                                        className: "auth__info-text",
                                                        children: "Forgot Password?"
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "auth__cta-container",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "submit",
                                            className: "auth-button",
                                            "aria-label": "Sign in",
                                            disabled: !isValid || isSubmitting,
                                            "aria-disabled": !isValid || isSubmitting,
                                            children: isSubmitting ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                                width: 30,
                                                height: 20,
                                                color: "var(--disabled-button-font-color)"
                                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: "Sign in"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                                        className: "auth__info-text",
                                        children: [
                                            "Don't have an account?",
                                            " ",
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                                to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Signup.path,
                                                children: "Sign up"
                                            })
                                        ]
                                    })
                                ]
                            })
                    }),
                    this.state.showOtpBox && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2dfe8ea3dd197f6b$export$2e2bcd8739ae039), {
                        title: "Two-Factor Authentication",
                        toggleOtpBox: this.toggleOtpBox,
                        phone: `${this.state.phoneExt}${this.state.phoneNumber}`,
                        email: this.state.email,
                        password: this.state.password,
                        loginWithOtp: this.loginWithOtp,
                        errorMessage: this.state.errorMessage
                    })
                ]
            })
        });
    }
}
$cfc09e83450c85b1$export$21a94553ffa41578.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);


/**
 * @author Karim Shalapy
 * @date 2019-10-11
 * @description signup page.
 * @filename index.tsx
 */ 

var $igtsr = parcelRequire("igtsr");







/**
 * @author Youssef Tarek
 * @date 2023-03-01
 * @description signup form component
 * @filename signup-form.tsx
 */ 

var $igtsr = parcelRequire("igtsr");





var $4l1Xa = parcelRequire("4l1Xa");



const $b5211f6efa889328$var$STORE_CATEGORIES = [
    {
        label: "Electronics",
        value: "Electronics"
    },
    {
        label: "Fashion & Apparel",
        value: "Fashion & Apparel"
    },
    {
        label: "Household Goods",
        value: "Household Goods"
    },
    {
        label: "Entertainment",
        value: "Entertainment"
    },
    {
        label: "Sports",
        value: "Sports"
    },
    {
        label: "Food & Beverage",
        value: "Food & Beverage"
    },
    {
        label: "Grocery",
        value: "Grocery"
    },
    {
        label: "Other",
        value: "Other"
    }
];
const $b5211f6efa889328$var$PLATFORM_PROVIDERS = [
    {
        label: "Magento",
        value: "magento"
    },
    {
        label: "WooCommerce",
        value: "woocommerce"
    },
    {
        label: "Shopify - coming soon",
        value: "shopify"
    }
];
const $b5211f6efa889328$var$customSelectMenuTheme = (theme)=>({
        ...theme,
        colors: {
            ...theme.colors,
            primary: "var(--black)",
            primary50: "var(--grey-150)",
            primary25: "var(--grey-100)",
            neutral20: "var(--color-not-focused)"
        }
    });
const $b5211f6efa889328$var$customSelectMenuStyles = (isInvalid)=>({
        control (provided, state) {
            return {
                ...provided,
                borderRadius: "6px",
                maxWidth: "500px",
                marginBottom: "10px",
                cursor: "pointer",
                "&:hover": {
                    borderColor: "var(--color-not-focused)"
                },
                ...isInvalid ? {
                    borderColor: "var(--color-not-focused-error)",
                    "&:hover": {
                        borderColor: "var(--color-not-focused-error)"
                    },
                    ...state.isFocused ? {
                        boxShadow: `0 0 0 1px var(--color-focused-error)`
                    } : {}
                } : {},
                ...state.isDisabled ? {
                    backgroundColor: "transparent",
                    borderColor: "var(--color-not-focused)",
                    opacity: "0.4",
                    pointerEvents: "all",
                    cursor: "not-allowed",
                    "&:hover": {}
                } : {}
            };
        },
        valueContainer (provided) {
            return {
                ...provided,
                paddingInlineStart: "10px",
                paddingBlock: "0",
                fontSize: "14px"
            };
        },
        input (provided) {
            return {
                ...provided,
                margin: 0
            };
        },
        menu (provided) {
            return {
                ...provided,
                zIndex: 10
            };
        },
        option (provided, state) {
            return {
                ...provided,
                color: state.isDisabled ? "var(--disabled-button-font-color)" : state.isSelected ? "var(--white)" : "var(--color-focused)",
                cursor: state.isDisabled ? "not-allowed" : "default"
            };
        }
    });
class $b5211f6efa889328$var$SignupForm extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            providersFocused: false,
            categoriesFocused: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
            onSubmit: this.props.submitHandler,
            initialValues: {
                name: "",
                email: "",
                password: "",
                confirmPassword: "",
                businessName: "",
                storeUrl: "",
                platformProvider: "",
                storeCategory: ""
            },
            validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                name: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().max(200, ({ max: max })=>`Maximum allowed number of characters is ${max}`).required("Name is required"),
                email: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().email("Please Input a proper Email").required("Email is required"),
                password: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().min(8, ({ min: min })=>`Password must be at least ${min} characters`).max(255, ({ max: max })=>`Password can't be more than ${max} characters`).matches(/^(?=.*[A-Z])(?=.*[!@#$%^&*+=-])(?=.*[0-9])(?=.*[a-z]).+$/g, "Must contain number, lowercase, uppercase, special character").required("Password is required"),
                confirmPassword: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required("Confirm password is required").oneOf([
                    $91e1faf1710dcf23$export$eff4d24c3ff7876e("password")
                ], "Password and Confirm Password do not match"),
                businessName: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required("Business name is required"),
                storeUrl: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().max(255, ({ max: max })=>`URL can't be more than ${max} characters`).matches((0, $ce34758010714942$export$820ae0844b3faa33), "Please input a valid URL").required("URL is required"),
                platformProvider: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().equals($b5211f6efa889328$var$PLATFORM_PROVIDERS.slice(0, 2).map((item)=>item.value), "Not supported yet.").required("Platform Provider is required"),
                storeCategory: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().equals($b5211f6efa889328$var$STORE_CATEGORIES.map((item)=>item.value), "Please choose a proper category.")
            }),
            validateOnMount: true,
            children: ({ isValid: isValid, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                            className: "auth__title",
                            children: "Dashboard Sign Up"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "name",
                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "form-field",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                        type: "text",
                                        id: "name-signup",
                                        label: "Full Name",
                                        errorMsg: meta.touched && meta.error ? meta.error : "",
                                        autoComplete: "name",
                                        disabled: isSubmitting,
                                        required: true,
                                        ...field
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "email",
                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "form-field",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                        type: "email",
                                        id: "email-signup",
                                        label: "Email",
                                        autoComplete: "email",
                                        errorMsg: meta.touched && meta.error ? meta.error : "",
                                        disabled: isSubmitting,
                                        required: true,
                                        ...field
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "businessName",
                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "form-field",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                        type: "text",
                                        id: "business-name-signup",
                                        label: "Business Name",
                                        autoComplete: "organization",
                                        disabled: isSubmitting,
                                        errorMsg: meta.touched && meta.error ? meta.error : "",
                                        required: true,
                                        ...field
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "storeUrl",
                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "form-field",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                        type: "text",
                                        id: "store-url-signup",
                                        label: "Store Admin Base Domain URL",
                                        autoComplete: "url",
                                        disabled: isSubmitting,
                                        errorMsg: meta.touched && meta.error ? meta.error : "",
                                        tooltip: "This is the base url for your store's admin dashboard that you use to manage your store",
                                        required: true,
                                        ...field
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "platformProvider",
                            children: ({ field: field, meta: meta, form: form })=>{
                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "custom-input-container is-selected form-field",
                                    "aria-invalid": !!(meta.touched && meta.error),
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                            htmlFor: "provider-signup",
                                            className: this.state.providersFocused ? "is-focused" : "",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: isSubmitting ? "disabled" : "",
                                                children: "Ecommerce Platform Provider*"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13b5ae22f3a5f453$export$2e2bcd8739ae039), {
                                            id: "provider-signup",
                                            name: field.name,
                                            placeholder: "Select a platform provider...",
                                            isDisabled: isSubmitting,
                                            theme: $b5211f6efa889328$var$customSelectMenuTheme,
                                            styles: $b5211f6efa889328$var$customSelectMenuStyles(!!(meta.touched && meta.error)),
                                            options: $b5211f6efa889328$var$PLATFORM_PROVIDERS,
                                            isOptionDisabled: (option)=>option.value === $b5211f6efa889328$var$PLATFORM_PROVIDERS[2].value,
                                            onFocus: ()=>{
                                                this.setState({
                                                    providersFocused: true
                                                });
                                            },
                                            onBlur: ()=>{
                                                this.setState({
                                                    providersFocused: false
                                                });
                                                form.setTouched({
                                                    ...form.touched,
                                                    [field.name]: true
                                                });
                                            },
                                            value: $b5211f6efa889328$var$PLATFORM_PROVIDERS.find((option)=>option.value === field.value),
                                            onChange: (option)=>{
                                                form.setFieldValue(field.name, option?.value || "");
                                            },
                                            isClearable: true
                                        }),
                                        meta.touched && meta.error ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                            className: `error ${this.state.providersFocused ? "is-focused" : ""}`,
                                            children: meta.error
                                        }) : null
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "storeCategory",
                            children: ({ field: field, meta: meta, form: form })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "custom-input-container form-field is-selected",
                                    "aria-invalid": !!(meta.touched && meta.error),
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                            htmlFor: "category-signup",
                                            className: this.state.categoriesFocused ? "is-focused" : "",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: isSubmitting ? "disabled" : "",
                                                children: "Store Category"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13b5ae22f3a5f453$export$2e2bcd8739ae039), {
                                            id: "category-signup",
                                            name: field.name,
                                            placeholder: "Select your store category...",
                                            isDisabled: isSubmitting,
                                            theme: $b5211f6efa889328$var$customSelectMenuTheme,
                                            styles: $b5211f6efa889328$var$customSelectMenuStyles(!!(meta.touched && meta.error)),
                                            options: $b5211f6efa889328$var$STORE_CATEGORIES,
                                            onFocus: ()=>{
                                                this.setState({
                                                    categoriesFocused: true
                                                });
                                            },
                                            onBlur: ()=>{
                                                this.setState({
                                                    categoriesFocused: false
                                                });
                                                form.setTouched({
                                                    ...form.touched,
                                                    [field.name]: true
                                                });
                                            },
                                            value: $b5211f6efa889328$var$STORE_CATEGORIES.find((option)=>option.value === field.value),
                                            onChange: (option)=>{
                                                form.setFieldValue(field.name, option?.value || "");
                                            },
                                            isClearable: true
                                        }),
                                        meta.touched && meta.error ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                            className: `error ${this.state.categoriesFocused ? "is-focused" : ""}`,
                                            children: meta.error
                                        }) : null
                                    ]
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "password",
                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "form-field",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                        type: "password",
                                        id: "password-signup",
                                        label: "Password",
                                        autoComplete: "new-password",
                                        errorMsg: meta.touched && meta.error ? meta.error : "",
                                        disabled: isSubmitting,
                                        required: true,
                                        ...field
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                            name: "confirmPassword",
                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "form-field",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                        type: "password",
                                        id: "confirm-password-signup",
                                        label: "Confirm Password",
                                        errorMsg: meta.touched && meta.error ? meta.error : "",
                                        disabled: isSubmitting,
                                        required: true,
                                        ...field
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                            type: "submit",
                            className: "auth-button",
                            "aria-label": "Sign up",
                            disabled: !isValid || isSubmitting || this.props.isSubmit,
                            "aria-disabled": !isValid || isSubmitting,
                            children: isSubmitting ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                width: 30,
                                height: 20,
                                color: "var(--disabled-button-font-color)"
                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                children: "Sign up"
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                            className: "auth__info-text",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                children: [
                                    "Already have an account?",
                                    " ",
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Login.path,
                                        children: "Sign in"
                                    })
                                ]
                            })
                        })
                    ]
                })
        });
    }
}
var $b5211f6efa889328$export$2e2bcd8739ae039 = $b5211f6efa889328$var$SignupForm;


class $85f2a9ce0bb9f125$var$Signup extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            customerEmail: "",
            isSubmit: false
        };
        this.submitHandler = this.submitHandler.bind(this);
    }
    submitHandler(values) {
        return (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).signup({
            ...values
        }).then(()=>{
            this.setState({
                isSubmit: true,
                customerEmail: values.email
            });
            return Promise.resolve();
        }).catch((error)=>{
            const errorsArr = Array.isArray(error) ? error : [
                error
            ];
            errorsArr.forEach((err)=>(0, $d41f521f78665649$export$b410431fab84fa58).error(err));
            return Promise.reject();
        });
    }
    render() {
        if (this.context.user) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$2d8d895a0a0f636e), {
            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Overview.path
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: this.state.isSubmit ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                className: "py-60 background-white",
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("stripe-pricing-table", {
                    "pricing-table-id": "prctbl_1MkpsuLCWM76QLbOVncdM6y7",
                    "publishable-key": "pk_live_51MU5snLCWM76QLbOj9GUN15thjKtV5ZXfl803ZloW6FIBw0XdCvfdUpMRQY9qqptbyJbH8pemxqweOcN1od9W4Cc00HmfKZY0J",
                    "customer-email": this.state.customerEmail
                })
            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "auth-wrapper",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7a2c23ebf6bb4208$exports))),
                        alt: ""
                    }),
                    !this.state.isSubmit && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $b5211f6efa889328$export$2e2bcd8739ae039), {
                        submitHandler: this.submitHandler,
                        isSubmit: this.state.isSubmit
                    })
                ]
            })
        });
    }
}
$85f2a9ce0bb9f125$var$Signup.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $85f2a9ce0bb9f125$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "common"
])($85f2a9ce0bb9f125$var$Signup);


/**
 * @author Ahmed Serag
 * @date 2019-07-15
 * @description login page.
 * @filename index.tsx
 */ 

var $igtsr = parcelRequire("igtsr");








var $4l1Xa = parcelRequire("4l1Xa");


class $e9f53849e30eee0d$export$b597ee422a3143dc extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        // input refs used for the 6 otp number values we have
        // needed to toggle focus between the inputs
        this.inputRefs = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef(),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef(),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef(),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef(),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef(),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef()
        ];
        this.state = {
            email: "",
            showOTP: false,
            otpValue: "",
            enableSubmit: false,
            showResetPasswordForm: false,
            isSendingOtp: false,
            newPassword: null,
            confirmPassword: null
        };
        this.sendResetPasswordRequest = this.sendResetPasswordRequest.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSendOtp = this.handleSendOtp.bind(this);
        this.handleResetPassword = this.handleResetPassword.bind(this);
        this.sendResetPasswordRequest = this.sendResetPasswordRequest.bind(this);
    }
    /**
   * handles updating state with otp value
   * and toggling inputs focus
   * @param event input change event
   * @param itemIndex index of the input that changed
   */ handleInputChange(event, itemIndex) {
        let newValue = this.state.otpValue;
        newValue = newValue.slice(0, itemIndex) + event.target.value + newValue.slice(itemIndex + 1);
        this.setState({
            otpValue: newValue
        });
        // if theres a next input to focus on -> focus on it
        if (itemIndex + 1 < 6 && event.target.value) {
            this.inputRefs[itemIndex].current.blur();
            this.inputRefs[itemIndex + 1].current.focus();
        } else // else otp if fully entered -> enable submit
        this.setState({
            enableSubmit: true
        });
    }
    /**
   * handles submitting the otp entered by the user to validate it
   * @param event form submit event
   */ handleSendOtp(event) {
        event.preventDefault();
        this.setState({
            isSendingOtp: true
        });
        (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).sendOtp(this.state.email, this.state.otpValue).then((result)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
            this.setState({
                showResetPasswordForm: true,
                showOTP: false
            });
        }).catch((error)=>{
            const errorsArr = Array.isArray(error) ? error : [
                error
            ];
            errorsArr.forEach((err)=>(0, $d41f521f78665649$export$b410431fab84fa58).error(err));
            return Promise.reject();
        }).finally(()=>{
            this.setState({
                isSendingOtp: false
            });
        });
    }
    /**
   * handles submitting the new password entered by the user to reset it
   */ handleResetPassword() {
        return (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).resetPassword(this.state.email, this.state.newPassword, this.state.otpValue).then((result)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
            this.props.history.push((0, $402ff3f88b55a2c2$export$cd891b82501bb412).Login.path);
            return Promise.resolve(result);
        }).catch((error)=>{
            const errorsArr = Array.isArray(error) ? error : [
                error
            ];
            errorsArr.forEach((err)=>(0, $d41f521f78665649$export$b410431fab84fa58).error(err));
            return Promise.reject();
        });
    }
    /**
   * handles the submit event of the  requesting reset password form
   * and toggles the view to show the otp form
   * @param event form submit event
   */ sendResetPasswordRequest() {
        return (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).requestResetPassword(this.state.email).then((result)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
            this.setState({
                showOTP: true
            });
            return Promise.resolve(result);
        }).catch((error)=>{
            const errorsArr = Array.isArray(error) ? error : [
                error
            ];
            errorsArr.forEach((err)=>(0, $d41f521f78665649$export$b410431fab84fa58).error(err));
            return Promise.reject();
        });
    }
    render() {
        if (this.context.user) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$2d8d895a0a0f636e), {
            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Overview.path
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "auth-wrapper",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7a2c23ebf6bb4208$exports))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "forgot-password",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                            className: "auth__title",
                            children: "Forgot Password"
                        }),
                        !this.state.showOTP && !this.state.showResetPasswordForm && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                            onSubmit: this.sendResetPasswordRequest,
                            initialValues: {
                                email: ""
                            },
                            validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                                email: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().email("Please Input a proper Email").required("Email is required")
                            }),
                            validateOnMount: true,
                            children: ({ isValid: isValid, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                    noValidate: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "email",
                                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                                    label: "Email",
                                                    type: "email",
                                                    id: "email",
                                                    errorMsg: meta.touched && meta.error ? meta.error : "",
                                                    disabled: isSubmitting,
                                                    ...field,
                                                    onChange: (e)=>{
                                                        this.setState({
                                                            email: e.target.value
                                                        });
                                                        field.onChange(e);
                                                    }
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            className: "black big square",
                                            type: "submit",
                                            disabled: !isValid || isSubmitting,
                                            "aria-disabled": !isValid || isSubmitting,
                                            children: isSubmitting ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                                width: 30,
                                                height: 20,
                                                color: "var(--disabled-button-font-color)"
                                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: "Send Email"
                                            })
                                        })
                                    ]
                                })
                        }),
                        this.state.showOTP && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                            onSubmit: (event)=>{
                                this.handleSendOtp(event);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "input-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                            htmlFor: "otp",
                                            children: "Enter the OTP received"
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "values-container",
                                            children: [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5
                                            ].map((item)=>{
                                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                    type: "number",
                                                    ref: this.inputRefs[item],
                                                    className: "otp-value",
                                                    onChange: (event)=>{
                                                        this.handleInputChange(event, item);
                                                    },
                                                    max: "9"
                                                }, item);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                    className: "black big square",
                                    type: "submit",
                                    disabled: !this.state.enableSubmit || this.state.isSendingOtp,
                                    children: this.state.isSendingOtp ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                        width: 30,
                                        height: 20,
                                        color: "var(--disabled-button-font-color)"
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        children: "Send OTP"
                                    })
                                })
                            ]
                        }),
                        this.state.showResetPasswordForm && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                            onSubmit: this.handleResetPassword,
                            initialValues: {
                                newPassword: "",
                                newPasswordRe: ""
                            },
                            validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                                newPassword: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().min(8, ({ min: min })=>`Password must be at least ${min} characters`).max(255, ({ max: max })=>`Password can't be more than ${max} characters`).matches(/^(?=.*[A-Z])(?=.*[!@#$%^&*+=-])(?=.*[0-9])(?=.*[a-z]).+$/g, "Must contain number, lowercase, uppercase, special character").required("New password is required"),
                                newPasswordRe: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().min(8, ({ min: min })=>`Password must be at least ${min} characters`).max(255, ({ max: max })=>`Password can't be more than ${max} characters`).matches(/^(?=.*[A-Z])(?=.*[!@#$%^&*+=-])(?=.*[0-9])(?=.*[a-z]).+$/g, "Must contain number, lowercase, uppercase, special character").oneOf([
                                    (0, $91e1faf1710dcf23$export$eff4d24c3ff7876e)("newPassword"),
                                    null
                                ], "Passwords must match").required("Confirming password is required.")
                            }),
                            validateOnMount: true,
                            children: ({ isValid: isValid, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "newPassword",
                                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                                    label: "New Password",
                                                    type: "password",
                                                    id: "new-password",
                                                    autoComplete: "new-password",
                                                    errorMsg: meta.touched && meta.error ? meta.error : "",
                                                    disabled: isSubmitting,
                                                    ...field,
                                                    onChange: (e)=>{
                                                        this.setState({
                                                            newPassword: e.target.value
                                                        });
                                                        field.onChange(e);
                                                    },
                                                    required: true
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "newPasswordRe",
                                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ef1cf8d12cf69249$export$2e2bcd8739ae039), {
                                                    label: "Confirm New Password",
                                                    type: "password",
                                                    id: "new-password-re",
                                                    autoComplete: "new-password",
                                                    errorMsg: meta.touched && meta.error ? meta.error : "",
                                                    disabled: isSubmitting,
                                                    ...field,
                                                    onChange: (e)=>{
                                                        this.setState({
                                                            confirmPassword: e.target.value
                                                        });
                                                        field.onChange(e);
                                                    },
                                                    required: true
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "submit",
                                            className: "black big square",
                                            disabled: !isValid || isSubmitting,
                                            "aria-disabled": !isValid || isSubmitting,
                                            children: isSubmitting ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                                width: 30,
                                                height: 20,
                                                color: "var(--disabled-button-font-color)"
                                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: "Reset Password"
                                            })
                                        })
                                    ]
                                })
                        })
                    ]
                })
            ]
        });
    }
}
$e9f53849e30eee0d$export$b597ee422a3143dc.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);


/**
 * @author Salma Hefnawy
 * @date 2019-04-05
 * @description set password page.
 * @filename set-password.tsx
 */ 

var $igtsr = parcelRequire("igtsr");



var $4l1Xa = parcelRequire("4l1Xa");




parcelRequire("igtsr");
const $c1945e3e8c493a79$var$SvgPatternpad = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 549,
        height: 768,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f8f9fd",
                    d: "M0 0h548.571v768H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#e8eaf3",
                    d: "M0 0h109.714v109.714H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f4f5fa",
                    d: "M0 0c0 60.594 49.12 109.714 109.714 109.714V0"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#a3b6dd",
                    d: "M109.714 0H219.43v109.714H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#325db2",
                    d: "M109.714 109.714c60.594 0 109.715-49.12 109.715-109.714H109.714"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#a0a7c4",
                    d: "M219.429 0h109.714v109.714H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#dbddea",
                    d: "M219.429 0c60.593 0 109.714 49.12 109.714 109.714zc0 60.594 49.12 109.714 109.714 109.714"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#2755ae",
                    d: "M329.143 0h109.714v109.714H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#436bb9",
                    d: "M329.143 109.714c60.593 0 109.714-49.12 109.714-109.714H329.143"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#dcdfeb",
                    d: "M438.857 0h109.714v109.714H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#d5ddf0",
                    d: "M438.857 0h109.714v109.714H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#7f9acf",
                    d: "M0 109.714h109.714V219.43H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#8ca4d4",
                    d: "M0 109.714h109.714V219.43H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#e5eaf6",
                    d: "M109.714 109.714H219.43V219.43H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#3d66b7",
                    d: "M109.714 219.429c0-60.594 49.121-109.715 109.715-109.715L109.714 219.43c60.594 0 109.715-49.121 109.715-109.715"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#3661b4",
                    d: "M219.429 109.714h109.714V219.43H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#ccd0e1",
                    d: "M219.429 219.429c0-60.594 49.12-109.715 109.714-109.715L219.429 219.43c60.593 0 109.714-49.121 109.714-109.715"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#89a2d3",
                    d: "M329.143 109.714h109.714V219.43H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#859fd2",
                    d: "M329.143 109.714h109.714V219.43z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#c5c9dc",
                    d: "M438.857 109.714h109.714V219.43H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f7f8fc",
                    d: "M438.857 109.714h109.714V219.43H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#3863b5",
                    d: "M0 219.429h109.714v109.714H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#eaecf4",
                    d: "M0 219.429h109.714v109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f6f7fc",
                    d: "M109.714 219.429H219.43v109.714H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#c2c6da",
                    d: "M109.714 219.429c60.594 0 109.715 49.12 109.715 109.714zc0 60.593 49.121 109.714 109.715 109.714"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#e4e9f5",
                    d: "M219.429 219.429h109.714v109.714H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#ecedf5",
                    d: "M219.429 329.143c0-60.594 49.12-109.714 109.714-109.714v109.714"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#b3b9d0",
                    d: "M329.143 219.429h109.714v109.714H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f6f7fc",
                    d: "M329.143 329.143c60.593 0 109.714-49.12 109.714-109.714H329.143"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#b0b6cf",
                    d: "M438.857 219.429h109.714v109.714H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#95acd8",
                    d: "M438.857 219.429h109.714v109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#bfcce7",
                    d: "M0 329.143h109.714v109.714H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#e6ebf6",
                    d: "M0 329.143h109.714v109.714H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#e1e3ee",
                    d: "M109.714 329.143H219.43v109.714H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#daddea",
                    d: "M109.714 438.857c0-60.593 49.121-109.714 109.715-109.714v109.714"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#a7adc8",
                    d: "M219.429 329.143h109.714v109.714H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#dee5f3",
                    d: "M219.429 438.857c0-60.593 49.12-109.714 109.714-109.714v109.714"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#dde4f3",
                    d: "M329.143 329.143h109.714v109.714H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#476eba",
                    d: "M329.143 329.143h109.714v109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#bdc2d7",
                    d: "M438.857 329.143h109.714v109.714H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#587bc1",
                    d: "M438.857 329.143h109.714v109.714H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f4f5fb",
                    d: "M0 438.857h109.714v109.714H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#3762b4",
                    d: "M0 438.857h109.714v109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#bccae6",
                    d: "M109.714 438.857H219.43v109.714H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#e9edf7",
                    d: "M219.429 438.857v109.714H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#c1c6d9",
                    d: "M219.429 438.857h109.714v109.714H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#c5cadc",
                    d: "M329.143 438.857v109.714H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#d5d8e6",
                    d: "M329.143 438.857h109.714v109.714H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#6989c7",
                    d: "M329.143 438.857h109.714v109.714H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#1f4eab",
                    d: "M438.857 438.857h109.714v109.714H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#aeb4cd",
                    d: "M438.857 548.571c0-60.593 49.12-109.714 109.714-109.714v109.714"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#3963b5",
                    d: "M0 548.571h109.714v109.715H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f6f7fc",
                    d: "M0 548.571h109.714v109.715z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#e4eaf6",
                    d: "M109.714 548.571H219.43v109.715H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#a0a7c4",
                    d: "M109.714 548.571H219.43v109.715z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#b9c7e5",
                    d: "M219.429 548.571h109.714v109.715H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#bfc4d8",
                    d: "M219.429 548.571h109.714v109.715H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#f4f5fb",
                    d: "M329.143 548.571h109.714v109.715H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#d6dae7",
                    d: "M329.143 548.571h109.714v109.715H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#c8d4eb",
                    d: "M438.857 548.571h109.714v109.715H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#b6bcd3",
                    d: "M438.857 548.571h109.714v109.715H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#c4c9dc",
                    d: "M0 658.286h109.714V768H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#0b3fa4",
                    d: "M0 658.286h109.714V768H0z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#9db1db",
                    d: "M109.714 658.286H219.43V768H109.714z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#c8d3eb",
                    d: "M109.714 658.286H219.43V768z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#446cb9",
                    d: "M219.429 658.286h109.714V768H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#7491cb",
                    d: "M219.429 658.286 329.143 768H219.429z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#a0a7c4",
                    d: "M329.143 658.286h109.714V768H329.143z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#d0d4e3",
                    d: "M329.143 658.286c60.593 0 109.714 49.12 109.714 109.714H329.143"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#869fd2",
                    d: "M438.857 658.286h109.714V768H438.857z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#bcc1d6",
                    d: "M438.857 658.286c0 60.593 49.12 109.714 109.714 109.714V658.286"
                })
            ]
        })
    });
var $c1945e3e8c493a79$export$2e2bcd8739ae039 = $c1945e3e8c493a79$var$SvgPatternpad;




class $4c4791664d19d3b5$export$e91361436c2780bd extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            showPassword: false,
            showConfirmPassword: false
        };
        this.handleSetPassword = this.handleSetPassword.bind(this);
    }
    handleSetPassword(values) {
        const { search: search } = this.props.history.location;
        const query = new URLSearchParams(search);
        const token = query.get("token");
        (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).setPassword(values.confirmPassword, token).then((result)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
            this.props.history.push((0, $402ff3f88b55a2c2$export$cd891b82501bb412).Login.path);
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        if (this.context.user) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$2d8d895a0a0f636e), {
            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Overview.path
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "login-wrapper",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c1945e3e8c493a79$export$2e2bcd8739ae039), {
                    className: "pattern"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "login",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "title",
                            children: "Set Password"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                            isInitialValid: false,
                            validationSchema: (0, $bd69b505bf48eca0$export$f30664844be2d6f1),
                            onSubmit: (values)=>{
                                this.handleSetPassword(values);
                            },
                            initialValues: {
                                password: "",
                                confirmPassword: ""
                            },
                            children: ({ errors: errors, touched: touched, isValid: isValid })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "input-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                    htmlFor: "password",
                                                    children: "password"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                    type: this.state.showPassword ? "text" : "password",
                                                    name: "password",
                                                    placeholder: "Enter Password"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "button--clear show-password--set",
                                                    onClick: ()=>{
                                                        this.setState({
                                                            showPassword: !this.state.showPassword
                                                        });
                                                    },
                                                    children: this.state.showPassword ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $e867fa34c6533ee8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7742e8d5fe4040a9$export$2e2bcd8739ae039), {})
                                                }),
                                                errors.password && touched.password ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "login__error",
                                                    children: errors.password
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "input-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                    htmlFor: "confirmPassword",
                                                    children: "confirm password"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                    type: this.state.showConfirmPassword ? "text" : "password",
                                                    name: "confirmPassword",
                                                    placeholder: "Confirm Password"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "button--clear show-password--set",
                                                    onClick: ()=>{
                                                        this.setState({
                                                            showConfirmPassword: !this.state.showConfirmPassword
                                                        });
                                                    },
                                                    children: this.state.showConfirmPassword ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $e867fa34c6533ee8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7742e8d5fe4040a9$export$2e2bcd8739ae039), {})
                                                }),
                                                errors.confirmPassword && touched.confirmPassword ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "login__error",
                                                    children: errors.confirmPassword
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "actions-wrapper",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "submit",
                                                disabled: !isValid,
                                                children: "save"
                                            })
                                        })
                                    ]
                                })
                        })
                    ]
                })
            ]
        });
    }
}
$4c4791664d19d3b5$export$e91361436c2780bd.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);


/**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description Orders tab of the App.
 * @filename orders.tsx
 */ 

var $igtsr = parcelRequire("igtsr");







/**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description Orders tab of the App.
 * @filename orders.tsx
 */ 

var $igtsr = parcelRequire("igtsr");








class $afa8a86a2e912322$var$PaymentMethods extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            id: Date.now().toString()
        };
        this.ChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.ComparedChartRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        this.setState({
            loading: true
        });
        let paymentMethodsOverview = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) paymentMethodsOverview = (0, $aa865fdbda79f268$export$b93f9c07fd1de645)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            filters: this.context.appliedFilters
        }).then((paymentMethods)=>{
            const totalOrders = paymentMethods.reduce((total, paymentMethod)=>total + Number(paymentMethod.count), 0);
            this.setState({
                paymentMethods: paymentMethods.map((paymentMethod)=>{
                    return {
                        name: [
                            `${paymentMethod.name}`,
                            `${Math.round(Number(paymentMethod.count) / totalOrders * 100)}% . ${paymentMethod.count} ${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("orders:orders")}`,
                            `${(0, $48f673e197675daa$export$4640587ffa669919)(paymentMethod.sales_value)} ${this.context.settings.currency}`
                        ],
                        count: paymentMethod.count
                    };
                })
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        });
        let comparedPaymentMethodsOverview = Promise.resolve();
        if (this.context.comparedPeriod) comparedPaymentMethodsOverview = (0, $aa865fdbda79f268$export$b93f9c07fd1de645)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            filters: this.context.appliedFilters
        }).then((comparedPaymentMethods)=>{
            const comparedTotalOrders = comparedPaymentMethods.reduce((total, paymentMethod)=>total + Number(paymentMethod.count), 0);
            this.setState({
                comparedPaymentMethods: comparedPaymentMethods.map((paymentMethod)=>{
                    return {
                        name: [
                            `${paymentMethod.name}`,
                            `${Math.round(Number(paymentMethod.count) / comparedTotalOrders * 100)}% . ${paymentMethod.count} ${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("orders:orders")}`,
                            `${(0, $48f673e197675daa$export$4640587ffa669919)(paymentMethod.sales_value)} ${this.context.settings.currency}`
                        ],
                        count: paymentMethod.count
                    };
                })
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        });
        else this.setState({
            comparedPaymentMethods: undefined
        });
        Promise.all([
            paymentMethodsOverview,
            comparedPaymentMethodsOverview
        ]).then(()=>{
            this.setState({
                loading: false
            });
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            ref: this.props.exportRef,
            className: this.context.comparedPeriod ? "card-container" : "flex justify-center",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "pie-chart-only-page",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                        title: t("paymentMethodsStatistics"),
                        items: this.state.paymentMethods,
                        currentPeriod: this.context?.currentPeriod,
                        blackThemed: true
                    })
                }),
                this.context?.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "pie-chart-only-page",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                        title: t("paymentMethodsStatistics"),
                        items: this.state.comparedPaymentMethods,
                        currentPeriod: this.context?.comparedPeriod,
                        blackThemed: true
                    })
                })
            ]
        });
    }
}
$afa8a86a2e912322$var$PaymentMethods.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $afa8a86a2e912322$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("orders")($afa8a86a2e912322$var$PaymentMethods);






var $igtsr = parcelRequire("igtsr");








class $477fbc57b42c06fa$var$ShippingLocations extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            sectionLoader: true,
            comparedSectionLoader: true,
            comparedLoading: true,
            activeOption: "byCountry",
            comparedActiveOption: "byCountry",
            currentPage: 1,
            totalPages: 1,
            comparedCurrentPage: 1,
            comparedTotalPages: 1,
            id: Date.now().toString()
        };
        this.loadData = this.loadData.bind(this);
        this.updatedCurrentPage = this.updatedCurrentPage.bind(this);
        this.updateComparedCurrentPage = this.updateComparedCurrentPage.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentDidUpdate(prevProps, prevState) {
        // when the tab is changed e.g from city to area, let the current page be 1
        if (prevState.activeOption !== this.state.activeOption) this.setState({
            currentPage: 1,
            loading: true
        });
        // when the page number is changed send a request with the requested page
        if (prevState.currentPage !== this.state.currentPage) this.handleChange(this.state.activeOption);
        // when the tab for comparison card is changed, let the current page be 1
        if (prevState.comparedActiveOption !== this.state.comparedActiveOption) this.setState({
            comparedCurrentPage: 1,
            comparedLoading: true
        });
        // when the page number is changed send a request with the requested page
        if (prevState.comparedCurrentPage !== this.state.comparedCurrentPage) this.handleComparedChange(this.state.comparedActiveOption);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    handleChange(metric) {
        this.setState({
            loading: true,
            sectionLoader: true
        });
        if (metric === "byCountry") this.getCustomersPerCountryHandler();
        else if (metric === "byCity") this.getCustomersPerCityHandler();
        else this.getCustomersPerAreaHandler();
    }
    handleComparedChange(metric) {
        this.setState({
            comparedLoading: true,
            comparedSectionLoader: true
        });
        if (metric === "byCountry") this.getComparedCustomersPerCountryHandler();
        else if (metric === "byCity") this.getComparedCustomersPerCityHandler();
        else this.getComparedCustomersPerAreaHandler();
    }
    getCustomersPerCityHandler() {
        const customersPerCityPromise = (0, $aa865fdbda79f268$export$33caffa594a0a8)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            currentPage: this.state.currentPage
        }).then((city)=>{
            this.setState({
                displayedData: city.data,
                totalPages: city.pagination.totalPageCount || 1,
                loading: false
            });
        });
        this.getCustomersListHandler((0, $aa865fdbda79f268$export$33caffa594a0a8), this.context.currentPeriod.from, this.context.currentPeriod.to);
        Promise.resolve(customersPerCityPromise);
    }
    getCustomersPerCountryHandler() {
        const customersPerCountryPromise = (0, $aa865fdbda79f268$export$d89efeec23b81b37)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            currentPage: this.state.currentPage
        }).then((country)=>{
            this.setState({
                displayedData: country.data,
                totalPages: country.pagination.totalPageCount || 1,
                loading: false
            });
        });
        this.getCustomersListHandler((0, $aa865fdbda79f268$export$d89efeec23b81b37), this.context.currentPeriod.from, this.context.currentPeriod.to);
        Promise.resolve(customersPerCountryPromise);
    }
    getCustomersPerAreaHandler() {
        const customersPerAreaPromise = (0, $aa865fdbda79f268$export$e9b6f6d23cffe91c)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            currentPage: this.state.currentPage
        }).then((area)=>{
            this.setState({
                displayedData: area.data,
                totalPages: area.pagination.totalPageCount || 1,
                loading: false
            });
        });
        this.getCustomersListHandler((0, $aa865fdbda79f268$export$e9b6f6d23cffe91c), this.context.currentPeriod.from, this.context.currentPeriod.to);
        Promise.resolve(customersPerAreaPromise);
    }
    getComparedCustomersPerCityHandler() {
        const customersPerCityPromise = (0, $aa865fdbda79f268$export$33caffa594a0a8)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            currentPage: this.state.comparedCurrentPage
        }).then((city)=>{
            this.setState({
                comparedDisplayedData: city.data,
                comparedTotalPages: city.pagination.totalPageCount || 1,
                comparedLoading: false
            });
        });
        this.getCustomersListHandler((0, $aa865fdbda79f268$export$33caffa594a0a8), this.context.comparedPeriod.from, this.context.comparedPeriod.to, true);
        Promise.resolve(customersPerCityPromise);
    }
    getComparedCustomersPerCountryHandler() {
        const customersPerCountryPromise = (0, $aa865fdbda79f268$export$d89efeec23b81b37)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            currentPage: this.state.comparedCurrentPage
        }).then((country)=>{
            this.setState({
                comparedDisplayedData: country.data,
                comparedTotalPages: country.pagination.totalPageCount || 1,
                comparedLoading: false
            });
        });
        this.getCustomersListHandler((0, $aa865fdbda79f268$export$d89efeec23b81b37), this.context.comparedPeriod.from, this.context.comparedPeriod.to, true);
        Promise.resolve(customersPerCountryPromise);
    }
    getComparedCustomersPerAreaHandler() {
        const customersPerAreaPromise = (0, $aa865fdbda79f268$export$e9b6f6d23cffe91c)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            currentPage: this.state.comparedCurrentPage
        }).then((area)=>{
            this.setState({
                comparedDisplayedData: area.data,
                comparedTotalPages: area.pagination.totalPageCount || 1,
                comparedLoading: false
            });
        });
        this.getCustomersListHandler((0, $aa865fdbda79f268$export$e9b6f6d23cffe91c), this.context.comparedPeriod.from, this.context.comparedPeriod.to, true);
        Promise.resolve(customersPerAreaPromise);
    }
    getCustomersListHandler(getCustomersList, from, to, isComparingPeriod) {
        const customersListPromise = getCustomersList({
            project: this.context.project,
            from: from,
            to: to,
            exported: 1
        }).then((response)=>{
            if (isComparingPeriod) this.setState({
                comparedListData: response.data,
                comparedSectionLoader: false
            });
            else this.setState({
                ListData: response.data,
                sectionLoader: false
            });
            Promise.resolve(customersListPromise);
        });
    }
    updatedCurrentPage(currentPage) {
        this.setState({
            currentPage: currentPage
        });
    }
    updateComparedCurrentPage(comparedCurrentPage) {
        this.setState({
            comparedCurrentPage: comparedCurrentPage
        });
    }
    loadData() {
        this.setState({
            loading: true,
            comparedLoading: true
        });
        this.getCustomersPerCountryHandler();
        if (this.context.comparedPeriod) this.getComparedCustomersPerCountryHandler();
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            ref: this.props.exportRef,
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: this.context.comparedPeriod ? "card-container" : "flex justify-center",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                className: "card--title",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        children: [
                                            t("locationBreakdown"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "duration",
                                                children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                            })
                                        ]
                                    }),
                                    this.state.sectionLoader ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                        width: 40,
                                        height: 40
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                        data: this.state.ListData,
                                        filename: `location-breakdown-from:${this.context.currentPeriod.from}-to:${this.context.currentPeriod.to}.csv`,
                                        className: "export-list-button",
                                        target: "_blank",
                                        children: t("exportList")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card--options",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: `option ${this.state.activeOption === "byCountry" ? "active" : ""}`,
                                        title: "byCountry",
                                        onClick: (e)=>{
                                            this.setState({
                                                activeOption: e.target.title
                                            });
                                            this.handleChange(e.target.title);
                                        },
                                        children: t("byCountry")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: `option ${this.state.activeOption === "byCity" ? "active" : ""}`,
                                        title: "byCity",
                                        onClick: (e)=>{
                                            this.setState({
                                                activeOption: e.target.title
                                            });
                                            this.handleChange(e.target.title);
                                        },
                                        children: t("byCity")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: `option ${this.state.activeOption === "byArea" ? "active" : ""}`,
                                        title: "byArea",
                                        onClick: (e)=>{
                                            this.setState({
                                                activeOption: e.target.title
                                            });
                                            this.handleChange(e.target.title);
                                        },
                                        children: t("byArea")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "locations-table",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                    loading: this.state.loading,
                                    type: this.state.activeOption,
                                    products: this.state.displayedData
                                })
                            }),
                            this.state.totalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.totalPages,
                                currentPage: this.state.currentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updatedCurrentPage
                            })
                        ]
                    }),
                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                className: "card--title",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        children: [
                                            t("locationBreakdown"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "duration",
                                                children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod.from, this.context.comparedPeriod.to)
                                            })
                                        ]
                                    }),
                                    this.state.comparedSectionLoader ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {
                                        width: 40,
                                        height: 40
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                        data: this.state.comparedListData,
                                        filename: `location-breakdown-from:${this.context.comparedPeriod.from}-to:${this.context.comparedPeriod.to}.csv`,
                                        className: "export-list-button",
                                        target: "_blank",
                                        children: t("exportList")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card--options",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: `option ${this.state.comparedActiveOption === "byCountry" ? "active" : ""}`,
                                        title: "byCountry",
                                        onClick: (e)=>{
                                            this.setState({
                                                comparedActiveOption: e.target.title
                                            });
                                            this.handleComparedChange(e.target.title);
                                        },
                                        children: t("byCountry")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: `option ${this.state.comparedActiveOption === "byCity" ? "active" : ""}`,
                                        title: "byCity",
                                        onClick: (e)=>{
                                            this.setState({
                                                comparedActiveOption: e.target.title
                                            });
                                            this.handleComparedChange(e.target.title);
                                        },
                                        children: t("byCity")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: `option ${this.state.comparedActiveOption === "byArea" ? "active" : ""}`,
                                        title: "byArea",
                                        onClick: (e)=>{
                                            this.setState({
                                                comparedActiveOption: e.target.title
                                            });
                                            this.handleComparedChange(e.target.title);
                                        },
                                        children: t("byArea")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "locations-table",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                    loading: this.state.comparedLoading,
                                    type: this.state.comparedActiveOption,
                                    products: this.state.comparedDisplayedData
                                })
                            }),
                            this.state.comparedTotalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.comparedTotalPages,
                                currentPage: this.state.comparedCurrentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updateComparedCurrentPage
                            })
                        ]
                    })
                ]
            })
        });
    }
}
$477fbc57b42c06fa$var$ShippingLocations.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $477fbc57b42c06fa$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("orders")($477fbc57b42c06fa$var$ShippingLocations);


/**
 * @author Youssef Tarek
 * @date 2023-04-09
 * @description Cancelled Orders Layout
 * @filename cancelled-orders.tsx
 */ 




var $igtsr = parcelRequire("igtsr");







var $igtsr = parcelRequire("igtsr");

parcelRequire("igtsr");
const $95510cfa45146bf4$var$SvgError = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                cx: 256,
                cy: 256,
                rx: 256,
                ry: 255.832
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M376.821 337.177 337.23 376.77 135.225 174.773l39.592-39.593z"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                d: "M376.824 174.82 174.827 376.824l-39.593-39.592L337.23 135.228z"
            })
        ]
    });
var $95510cfa45146bf4$export$2e2bcd8739ae039 = $95510cfa45146bf4$var$SvgError;


class $ac6f248f87489dcd$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        });
        // eslint-disable-next-line no-console
        console.error(error.toString(), info.componentStack);
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "error-boundary",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $95510cfa45146bf4$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                    children: "Something went wrong"
                })
            ]
        });
        return this.props.children;
    }
}
var $ac6f248f87489dcd$export$2e2bcd8739ae039 = $ac6f248f87489dcd$var$ErrorBoundary;



/**
 * @author Karim Shalapy
 * @date 2022-09-25
 * @description page for a specific brand item sales details
 * @filename brands-details.tsx
 */ 


var $igtsr = parcelRequire("igtsr");




/**
 * @author Youssef Tarek
 * @date 2022-01-09
 * @description Implementation of Brands related utilities.
 * @filename brands.ts
 */ /**
 * @author Youssef Tarek
 * @date 2022-01-02
 * @description implementation of brand related API calls.
 * @filename brand.ts
 */ 



class $a2f3cdaf5842ddda$export$75d5b518c51e7fd6 {
    static brandsTopSelling({ project: project, from: from, to: to, search: search = "", sort: sort = "sales_value", direction: direction = (0, $5142459688621f32$export$966c0722699349a0).Desc, currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).brands.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("search", search);
        url.searchParams.append("sort", sort);
        url.searchParams.append("direction", direction);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).brands.method
        });
    }
    static brandsItemsSales({ project: project, from: from, to: to, brand: brand, search: search = "", sort: sort = "sales_value", direction: direction = (0, $5142459688621f32$export$966c0722699349a0).Desc, currentPage: currentPage = 1, pageSize: pageSize = 10, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).brandsItemsSales.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        url.searchParams.append("brand", brand);
        url.searchParams.append("search", search);
        url.searchParams.append("sort", sort);
        url.searchParams.append("direction", direction);
        url.searchParams.append("currentPage", currentPage.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).brandsItemsSales.method
        });
    }
}



function $7e7a33cc33ce5113$export$b4742ff7ccdcdcf0(payload) {
    return (0, $a2f3cdaf5842ddda$export$75d5b518c51e7fd6).brandsTopSelling(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $7e7a33cc33ce5113$export$4dd0456aa7543cea(payload) {
    return (0, $a2f3cdaf5842ddda$export$75d5b518c51e7fd6).brandsItemsSales(payload).then((overviewPayload)=>{
        return (0, $48f673e197675daa$export$f7422a06cf772d2c)(overviewPayload);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}









class $173473fffb4dc975$var$BrandDetails extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loadingBrandSummary: true,
            loadingComparedBrandSummary: true,
            loadingBrandItems: true,
            loadingComparedBrandItems: true,
            id: Date.now().toString(),
            brandItemsSales: null,
            comparedBrandItemsSales: null,
            brandSummary: null,
            comparedBrandSummary: null,
            previousBrandSummary: null,
            currentPage: 1,
            totalPages: 1,
            comparedCurrentPage: 1,
            comparedTotalPages: 1,
            searchQuery: ""
        };
        this.updateSearchQuery = this.updateSearchQuery.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.loadAllData = this.loadAllData.bind(this);
        this.loadBrandItems = this.loadBrandItems.bind(this);
        this.loadComparedBrandItems = this.loadComparedBrandItems.bind(this);
        this.loadPreviousBrandSummary = this.loadPreviousBrandSummary.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.updateComparedCurrentPage = this.updateComparedCurrentPage.bind(this);
    }
    componentDidMount() {
        this.loadAllData();
        this.context.addUpdatesListener(this.state.id, this.loadAllData);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.brandName !== prevProps.brandName) this.loadAllData();
        else {
            const sortChanged = prevState.sortBy !== this.state.sortBy || prevState.sortDirection !== this.state.sortDirection;
            const searchChanged = prevState.searchQuery !== this.state.searchQuery;
            if (prevState.currentPage !== this.state.currentPage || sortChanged || searchChanged) this.loadBrandItems().catch((error)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
            }).finally(()=>{
                this.setState({
                    loadingBrandItems: false
                });
            });
            if (prevState.comparedCurrentPage !== this.state.comparedCurrentPage || sortChanged || searchChanged) this.loadComparedBrandItems().catch((error)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
            }).finally(()=>{
                this.setState({
                    loadingComparedBrandItems: false
                });
            });
        }
    }
    updateSearchQuery(searchQuery) {
        this.setState({
            searchQuery: searchQuery,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateSort(sortBy, sortDirection) {
        if (!sortBy || !sortDirection) {
            this.setState({
                sortBy: undefined,
                sortDirection: undefined,
                currentPage: 1,
                comparedCurrentPage: 1
            });
            return;
        }
        this.setState({
            sortBy: sortBy,
            sortDirection: sortDirection,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateCurrentPage(currentPage) {
        this.setState({
            currentPage: currentPage
        });
    }
    updateComparedCurrentPage(comparedCurrentPage) {
        this.setState({
            comparedCurrentPage: comparedCurrentPage
        });
    }
    loadBrandItems() {
        this.setState({
            loadingBrandItems: true
        });
        let brandItemsSales = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) brandItemsSales = (0, $7e7a33cc33ce5113$export$4dd0456aa7543cea)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            brand: this.props.brandName,
            currentPage: this.state.currentPage,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                brandItemsSales: res.data.products,
                brandSummary: {
                    name: res.data.name,
                    image_url: res.data.image_url,
                    sales_value: res.data.sales_value,
                    number_sold: res.data.number_sold,
                    products_count: res.data.products_count
                },
                loadingBrandItems: false,
                totalPages: res.pagination.totalPageCount || 1
            });
        });
        return brandItemsSales;
    }
    loadComparedBrandItems() {
        this.setState({
            loadingComparedBrandItems: true
        });
        let comparedBrandItemsSales = Promise.resolve();
        if (this.context.comparedPeriod) comparedBrandItemsSales = (0, $7e7a33cc33ce5113$export$4dd0456aa7543cea)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            brand: this.props.brandName,
            currentPage: this.state.comparedCurrentPage,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                comparedBrandItemsSales: res.data.products,
                comparedBrandSummary: {
                    name: res.data.name,
                    image_url: res.data.image_url,
                    sales_value: res.data.sales_value,
                    number_sold: res.data.number_sold,
                    products_count: res.data.products_count
                },
                loadingComparedBrandItems: false,
                loadingComparedBrandSummary: false,
                comparedTotalPages: res.pagination.totalPageCount || 1
            });
        });
        return comparedBrandItemsSales;
    }
    loadPreviousBrandSummary() {
        this.setState({
            loadingBrandSummary: true
        });
        let previousBrandSummaryPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) previousBrandSummaryPromise = (0, $7e7a33cc33ce5113$export$4dd0456aa7543cea)({
            project: this.context.project,
            from: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.type).from,
            to: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.type).to,
            brand: this.props.brandName,
            currentPage: this.state.currentPage,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                previousBrandSummary: {
                    name: res.data.name,
                    image_url: res.data.image_url,
                    sales_value: res.data.sales_value,
                    number_sold: res.data.number_sold,
                    products_count: res.data.products_count
                },
                loadingBrandSummary: false
            });
        });
        return previousBrandSummaryPromise;
    }
    loadAllData() {
        const brandItemsSalesPromise = this.loadBrandItems();
        const comparedBrandItemsSalesPromise = this.loadComparedBrandItems();
        const previousBrandSummaryPromise = this.loadPreviousBrandSummary();
        Promise.all([
            brandItemsSalesPromise,
            previousBrandSummaryPromise,
            comparedBrandItemsSalesPromise
        ]).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        }).finally(()=>{
            this.setState({
                loadingBrandItems: false,
                loadingComparedBrandItems: false,
                loadingBrandSummary: false,
                loadingComparedBrandSummary: false
            });
        });
    }
    render() {
        const { t: t } = this.props;
        const allBrandsData = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.brandItemsSales);
        const allComparedBrandsData = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.comparedBrandItemsSales);
        const tabs = {
            [t(this.props.brandName)]: {
                title: `${t(this.props.brandName)}`,
                items: allBrandsData
            }
        };
        const comparedTabs = {
            [t(this.props.brandName)]: {
                title: `${t(this.props.brandName)}`,
                items: allComparedBrandsData
            }
        };
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "product-analytics",
            ref: this.props.exportRef,
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card-container",
                children: [
                    this.state.loadingBrandSummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "information-card",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "product-info",
                                children: [
                                    this.state.brandSummary?.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                        src: this.state.brandSummary?.image_url,
                                        alt: this.state.brandSummary?.name,
                                        onError: (e)=>{
                                            (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                        }
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                        alt: this.state.brandSummary?.name
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "product-name",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "title",
                                                children: this.state.brandSummary?.name
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                className: "tooltip",
                                                children: this.state.brandSummary?.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "product-count",
                                        children: [
                                            (0, $48f673e197675daa$export$4640587ffa669919)(this.state.brandSummary?.products_count),
                                            " ",
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: t("products", {
                                                    ns: "product"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {}),
                    this.state.loadingBrandSummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "product-sales",
                        children: [
                            this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                className: "card--title",
                                children: [
                                    t(this.context.currentPeriod.alias, {
                                        ns: "common"
                                    }),
                                    " (",
                                    new Date(this.context.currentPeriod.to).getFullYear(),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "card product-sales transparent-card",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "stats-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("unitsSold", {
                                                        ns: "product"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.brandSummary?.number_sold)
                                                }),
                                                !this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                    current: this.state.brandSummary?.number_sold,
                                                    previous: this.state.previousBrandSummary?.number_sold
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("totalSalesValue", {
                                                        ns: "product"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.brandSummary?.sales_value)} ${this.context.settings.currency}`
                                                }),
                                                !this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                    current: this.state.brandSummary?.sales_value,
                                                    previous: this.state.previousBrandSummary?.sales_value
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    this.context.comparedPeriod && (this.state.loadingComparedBrandSummary ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card product-data",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "product-sales",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                className: "card--title",
                                children: [
                                    t(this.context.comparedPeriod.alias, {
                                        ns: "common"
                                    }),
                                    " (",
                                    new Date(this.context.comparedPeriod.to).getFullYear(),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "card product-sales transparent-card",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "stats-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("unitsSold", {
                                                        ns: "product"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedBrandSummary?.number_sold)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "stat",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "label",
                                                    children: t("totalSalesValue", {
                                                        ns: "product"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedBrandSummary?.sales_value)} ${this.context.settings.currency}`
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "span-2",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $56815f93a4fad611$export$2e2bcd8739ae039), {
                            searchHandler: this.updateSearchQuery,
                            sortHandler: this.updateSort,
                            sortBy: this.state.sortBy,
                            direction: this.state.sortDirection,
                            mode: "minimal"
                        })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: this.context.comparedPeriod ? "" : "span-2 centered",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                        className: "card--title",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            children: [
                                                t("brandItemsSales"),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "duration",
                                                    children: [
                                                        "(",
                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "sales-table categories-sales-table big",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                            products: this.state.brandItemsSales || [],
                                            type: "brands-items-sales-list",
                                            loading: this.state.loadingBrandItems
                                        })
                                    }),
                                    !this.state.loadingBrandItems && this.state.searchQuery && !this.state.brandItemsSales.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        children: t("noSearchResult", {
                                            ns: "common"
                                        })
                                    })
                                ]
                            }),
                            this.state.totalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.totalPages,
                                currentPage: this.state.currentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updateCurrentPage
                            })
                        ]
                    }),
                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                        className: "card--title",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            children: [
                                                t("brandItemsSales"),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                    className: "duration",
                                                    children: [
                                                        "(",
                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "sales-table categories-sales-table big",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                            products: this.state.comparedBrandItemsSales || [],
                                            type: "brands-items-sales-list",
                                            loading: this.state.loadingComparedBrandItems
                                        })
                                    }),
                                    !this.state.loadingComparedBrandItems && this.state.searchQuery && !this.state.brandItemsSales.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        children: t("noSearchResult", {
                                            ns: "common"
                                        })
                                    })
                                ]
                            }),
                            this.state.comparedTotalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.comparedTotalPages,
                                currentPage: this.state.comparedCurrentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updateComparedCurrentPage
                            })
                        ]
                    }),
                    this.state.brandItemsSales && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: `card ${this.context.comparedPeriod ? "" : "span-2 centered"}`,
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                            tabs: tabs,
                            title: t(this.props.brandName)
                        })
                    }),
                    this.state.comparedBrandItemsSales && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                            tabs: comparedTabs,
                            title: t(this.props.brandName)
                        })
                    })
                ]
            })
        }, this.state.id);
    }
}
$173473fffb4dc975$var$BrandDetails.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $173473fffb4dc975$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "brands",
    "product",
    "common"
])($173473fffb4dc975$var$BrandDetails);





class $dcc0ef23fa4781cc$var$CancelledOrders extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: Date.now().toString(),
            loading: true,
            cancelledOrdersPercentage: null,
            topProductsInCancelledOrders: [],
            topCategoriesInCancelledOrders: [],
            topBrandsInCancelledOrders: [],
            byPaymentMethodPercentage: [],
            byFilterSegmentsPercentage: [],
            byOrderSourcePercentage: [],
            cancelledOrdersBreakdown: [],
            productSku: "",
            categoryName: "",
            brandName: "",
            viewAll: ""
        };
        this.loadData = this.loadData.bind(this);
        this.updateProductSku = this.updateProductSku.bind(this);
        this.updateCategoryName = this.updateCategoryName.bind(this);
        this.updateBrandName = this.updateBrandName.bind(this);
        this.setViewAll = this.setViewAll.bind(this);
        this.getProductsByType = this.getProductsByType.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    setViewAll(viewAll) {
        this.setState({
            viewAll: viewAll
        });
    }
    // get the products to be displayed in the expanded table
    // according to the type of the table we want to expand
    getProductsByType() {
        if (this.state.viewAll === "byPaymentMethod") return this.state.byPaymentMethodPercentage;
        if (this.state.viewAll === "byOrderSource") return this.state.byOrderSourcePercentage;
        if (this.state.viewAll === "byFilterSegments") return this.state.byFilterSegmentsPercentage;
        return null;
    }
    loadData() {
        this.setState({
            loading: true
        });
        let cancelledOrdersPercentagePromise = Promise.resolve();
        cancelledOrdersPercentagePromise = (0, $aa865fdbda79f268$export$4327c75daa3aacd9)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((cancelledOrdersPercentage)=>{
            this.setState({
                cancelledOrdersPercentage: cancelledOrdersPercentage
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        let topProductsInCancelledOrdersPromise = Promise.resolve();
        topProductsInCancelledOrdersPromise = (0, $aa865fdbda79f268$export$4b802536ca4fc7b6)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((topProductsInCancelledOrders)=>{
            this.setState({
                topProductsInCancelledOrders: topProductsInCancelledOrders
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        let topCategoriesInCancelledOrdersPromise = Promise.resolve();
        topCategoriesInCancelledOrdersPromise = (0, $aa865fdbda79f268$export$6d8f73d45bbb92d)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((topCategoriesInCancelledOrders)=>{
            this.setState({
                topCategoriesInCancelledOrders: topCategoriesInCancelledOrders
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        let topBrandsInCancelledOrdersPromise = Promise.resolve();
        topBrandsInCancelledOrdersPromise = (0, $aa865fdbda79f268$export$a153853d3f475278)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((topBrandsInCancelledOrders)=>{
            this.setState({
                topBrandsInCancelledOrders: topBrandsInCancelledOrders
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        let byPaymentMethodPercentagePromise = Promise.resolve();
        byPaymentMethodPercentagePromise = (0, $aa865fdbda79f268$export$bfc8e8bfa3488370)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((byPaymentMethodPercentage)=>{
            this.setState({
                byPaymentMethodPercentage: byPaymentMethodPercentage
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        let byOrderSourcePercentagePromise = Promise.resolve();
        byOrderSourcePercentagePromise = (0, $aa865fdbda79f268$export$e8efceaeace66db5)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((byOrderSourcePercentage)=>{
            this.setState({
                byOrderSourcePercentage: byOrderSourcePercentage
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        let byFilterSegmentsPercentagePromise = Promise.resolve();
        byFilterSegmentsPercentagePromise = (0, $aa865fdbda79f268$export$20d01e9b52b96f59)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((byFilterSegmentsPercentage)=>{
            this.setState({
                byFilterSegmentsPercentage: byFilterSegmentsPercentage
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        let cancelledOrdersBreakdownPromise = Promise.resolve();
        cancelledOrdersBreakdownPromise = (0, $aa865fdbda79f268$export$8d7aa544ec03a87f)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to
        }).then((cancelledOrdersBreakdown)=>{
            this.setState({
                cancelledOrdersBreakdown: cancelledOrdersBreakdown
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        Promise.all([
            cancelledOrdersPercentagePromise,
            topProductsInCancelledOrdersPromise,
            topCategoriesInCancelledOrdersPromise,
            topBrandsInCancelledOrdersPromise,
            byPaymentMethodPercentagePromise,
            byOrderSourcePercentagePromise,
            byFilterSegmentsPercentagePromise,
            cancelledOrdersBreakdownPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        });
    }
    updateProductSku(productSku) {
        this.setState({
            productSku: productSku
        });
    }
    updateCategoryName(categoryName) {
        this.setState({
            categoryName: categoryName
        });
    }
    updateBrandName(brandName) {
        this.setState({
            brandName: brandName
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        if (this.state.productSku) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                    className: "products-button--back",
                    type: "button",
                    onClick: ()=>{
                        this.updateProductSku("");
                    },
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                        t("backToList")
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ac6f248f87489dcd$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $be69e13341d50da4$export$2e2bcd8739ae039), {
                        productSku: this.state.productSku,
                        updateProductSku: this.updateProductSku
                    })
                })
            ]
        });
        if (this.state.categoryName) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                    className: "products-button--back",
                    type: "button",
                    onClick: ()=>{
                        this.updateCategoryName("");
                    },
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                        t("backToList")
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0ba10f359e696966$export$2e2bcd8739ae039), {
                    categoryName: this.state.categoryName,
                    updateCategoryName: this.updateCategoryName
                })
            ]
        });
        if (this.state.brandName) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                    className: "products-button--back",
                    type: "button",
                    onClick: ()=>{
                        this.updateBrandName("");
                    },
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                        t("backToList")
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $173473fffb4dc975$export$2e2bcd8739ae039), {
                    brandName: this.state.brandName,
                    updateBrandName: this.updateBrandName
                })
            ]
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "cancelled-orders",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("section", {
                    className: "cancelled-orders__overview",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card overview-card transparent-card",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "overview-items",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item area-a",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h4", {
                                            className: "title",
                                            children: t("totalCancelledOrders")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.cancelledOrdersPercentage.canceled_orders_count)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "item area-c",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h4", {
                                            className: "title",
                                            children: t("cancellationPercentage")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "header",
                                            children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.cancelledOrdersPercentage.canceled_orders_percentage)} %`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "area-b",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7c79e7a583126a6d$export$2e2bcd8739ae039), {
                                        chartLabel: t("cancelledOrders"),
                                        chartTitle: t("cancelledOrders"),
                                        getDataPerDay: (0, $aa865fdbda79f268$export$8d7aa544ec03a87f)
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "percentage-cards-container",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card flex-col",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("paymentMethod"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "duration",
                                            children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "cancellation-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.byPaymentMethodPercentage.slice(0, 3),
                                        type: "byPaymentMethod"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                    type: "button",
                                    className: "button-underlined black",
                                    onClick: ()=>this.setViewAll("byPaymentMethod"),
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            children: t("viewAll")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                            className: "right-arrow"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card flex-col",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("orderSource"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "duration",
                                            children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "cancellation-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.byOrderSourcePercentage.slice(0, 3),
                                        type: "byOrderSource"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                    type: "button",
                                    className: "button-underlined black",
                                    onClick: ()=>this.setViewAll("byOrderSource"),
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            children: t("viewAll")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                            className: "right-arrow"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card flex-col",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("filterSegments"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "duration",
                                            children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "cancellation-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.byFilterSegmentsPercentage.slice(0, 3),
                                        type: "byFilterSegments"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                    type: "button",
                                    className: "button-underlined black",
                                    onClick: ()=>this.setViewAll("byFilterSegments"),
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            children: t("viewAll")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                            className: "right-arrow"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "top-cards-container",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("topProductsInCancelledOrders"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "duration",
                                            children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "cancellation-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.topProductsInCancelledOrders.slice(0, 3),
                                        type: "top-products-cancelled-orders",
                                        updateProductSku: this.updateProductSku
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("topCategoriesInCancelledOrders"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "duration",
                                            children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "cancellation-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.topCategoriesInCancelledOrders.slice(0, 3),
                                        type: "top-categories-cancelled-orders",
                                        updateProductSku: this.updateCategoryName
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("topBrandsInCancelledOrders"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "duration",
                                            children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "cancellation-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.topBrandsInCancelledOrders.slice(0, 3),
                                        type: "top-brands-cancelled-orders",
                                        updateProductSku: this.updateBrandName
                                    })
                                })
                            ]
                        })
                    ]
                }),
                this.state.viewAll && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "create-segment",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("section", {
                        className: "create-segment__main",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "create-segment__back",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        className: "button-underlined black",
                                        onClick: ()=>this.setState({
                                                viewAll: ""
                                            }),
                                        type: "button",
                                        children: t("backToCancellationReport")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card--title",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h3", {
                                        children: `${t("cancellation")} ${t(this.state.viewAll)}`
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "duration",
                                        children: (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "cancellation-table",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                    type: this.state.viewAll,
                                    expanded: true,
                                    products: this.getProductsByType()
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
}
$dcc0ef23fa4781cc$var$CancelledOrders.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $dcc0ef23fa4781cc$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("orders")($dcc0ef23fa4781cc$var$CancelledOrders);


class $6712b680f81e5080$var$Orders extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.exportOrdersRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportOrderPaymentsRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportOrdersDeliveryRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        const query = window.location.search;
        const params = new URLSearchParams(query);
        this.state = {
            loading: true,
            activeTab: params.get("activeTab") ?? "orders_overview",
            id: Date.now().toString()
        };
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams(this.state.activeTab);
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Orders Overview";
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab) {
            this.context.updateUrlQueryParams(this.state.activeTab);
            // set page title according to the active tab
            switch(this.state.activeTab){
                case "orders_overview":
                    document.title = "Orders Overview";
                    break;
                case "payment_method":
                    document.title = "Payment Methods";
                    break;
                case "delivery_method":
                    document.title = "Delivery Methods";
                    break;
                case "shipping_locations":
                    document.title = "Shipping Locations";
                    break;
                default:
                    document.title = "Orders Overview";
                    break;
            }
        }
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        this.setState({
            loading: true
        });
        let ordersDetailsPromise = Promise.resolve();
        let paymentMethodsOverview = Promise.resolve();
        let ordersHourlyBreakdownPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            ordersDetailsPromise = (0, $aa865fdbda79f268$export$2a0eb9aacf34a4b3)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((ordersOverview)=>{
                this.setState({
                    ...ordersOverview,
                    totalOrders: ordersOverview.canceled_order_count + ordersOverview.complete_order_count + ordersOverview.pending_order_count,
                    totalOrdersDelivery: ordersOverview.delivery + ordersOverview.pickup
                });
            }).catch((err)=>{
                // eslint-disable-next-line no-console
                console.error(err);
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
            paymentMethodsOverview = (0, $aa865fdbda79f268$export$b93f9c07fd1de645)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((paymentMethods)=>{
                this.setState({
                    paymentMethods: paymentMethods
                });
            }).catch((err)=>{
                // eslint-disable-next-line no-console
                console.error(err);
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
        }
        ordersHourlyBreakdownPromise = (0, $aa865fdbda79f268$export$6dd139bbcfda88b9)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            filters: this.context.appliedFilters
        }).then((ordersHourlyBreakdown)=>{
            this.setState({
                ordersHourlyBreakdown: ordersHourlyBreakdown
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        });
        let comparedDetailsPromise = Promise.resolve();
        let comparedPaymentMethodsOverview = Promise.resolve();
        let comparedOrdersHourlyBreakdownPromise = Promise.resolve();
        if (this.context.comparedPeriod) {
            comparedDetailsPromise = (0, $aa865fdbda79f268$export$2a0eb9aacf34a4b3)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((ordersOverview)=>{
                this.setState({
                    comparedOverview: {
                        ...ordersOverview,
                        totalOrders: ordersOverview.canceled_order_count + ordersOverview.complete_order_count + ordersOverview.pending_order_count,
                        totalOrdersDelivery: ordersOverview.delivery + ordersOverview.pickup
                    }
                });
            }).catch((err)=>{
                // eslint-disable-next-line no-console
                console.error(err);
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
            comparedPaymentMethodsOverview = (0, $aa865fdbda79f268$export$b93f9c07fd1de645)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedPaymentMethods)=>{
                this.setState({
                    comparedPaymentMethods: comparedPaymentMethods
                });
            }).catch((err)=>{
                // eslint-disable-next-line no-console
                console.error(err);
            // TODO handle error loading the chart
            });
            comparedOrdersHourlyBreakdownPromise = (0, $aa865fdbda79f268$export$6dd139bbcfda88b9)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedOrdersHourlyBreakdown)=>{
                this.setState({
                    comparedOrdersHourlyBreakdown: comparedOrdersHourlyBreakdown
                });
            }).catch((err)=>{
                // eslint-disable-next-line no-console
                console.error(err);
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
        } else this.setState({
            comparedOverview: undefined,
            comparedPaymentMethods: undefined,
            comparedOrdersHourlyBreakdown: undefined
        });
        Promise.all([
            ordersDetailsPromise,
            paymentMethodsOverview,
            ordersHourlyBreakdownPromise,
            comparedDetailsPromise,
            comparedPaymentMethodsOverview,
            comparedOrdersHourlyBreakdownPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        });
    }
    // eslint-disable-next-line class-methods-use-this
    generateDoughnutChartItemText(name, count, total, orders) {
        const percentage = Math.round(count / total * 100);
        return [
            name,
            `${percentage}% . ${count} ${orders}`
        ];
    }
    // eslint-disable-next-line class-methods-use-this
    generateDoughnutChartItemCount(count) {
        return count ?? "0";
    }
    render() {
        const { t: t } = this.props;
        const orderStatusDoughnutCardItems = [
            {
                name: this.generateDoughnutChartItemText(t("completed"), this.state.complete_order_count, this.state.totalOrders, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.complete_order_count)
            },
            {
                name: this.generateDoughnutChartItemText(t("pending"), this.state.pending_order_count, this.state.totalOrders, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.pending_order_count)
            },
            {
                name: this.generateDoughnutChartItemText(t("cancelled"), this.state.canceled_order_count, this.state.totalOrders, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.canceled_order_count)
            }
        ];
        const comparedOrderStatusDoughnutCardItems = [
            {
                name: this.generateDoughnutChartItemText(t("completed"), this.state.comparedOverview?.complete_order_count, this.state.comparedOverview?.totalOrders, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.comparedOverview?.complete_order_count)
            },
            {
                name: this.generateDoughnutChartItemText(t("pending"), this.state.comparedOverview?.pending_order_count, this.state.comparedOverview?.totalOrders, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.comparedOverview?.pending_order_count)
            },
            {
                name: this.generateDoughnutChartItemText(t("cancelled"), this.state.comparedOverview?.canceled_order_count, this.state.comparedOverview?.totalOrders, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.comparedOverview?.canceled_order_count)
            }
        ];
        const deliveryMethodsDoughnutCardItems = [
            {
                name: this.generateDoughnutChartItemText(t("pickup"), this.state.pickup, this.state.totalOrdersDelivery, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.pickup)
            },
            {
                name: this.generateDoughnutChartItemText(t("homeDelivery"), this.state.delivery, this.state.totalOrdersDelivery, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.delivery)
            }
        ];
        const comparedDeliveryMethodsDoughnutCardItems = [
            {
                name: this.generateDoughnutChartItemText(t("pickup"), this.state.comparedOverview?.pickup, this.state.comparedOverview?.totalOrdersDelivery, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.comparedOverview?.pickup)
            },
            {
                name: this.generateDoughnutChartItemText(t("homeDelivery"), this.state.comparedOverview?.delivery, this.state.comparedOverview?.totalOrdersDelivery, t("orders")),
                count: this.generateDoughnutChartItemCount(this.state.comparedOverview?.delivery)
            }
        ];
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "orders",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("orders"),
                    exportRef: this.state.activeTab === "orders_overview" ? this.exportOrdersRef : this.state.activeTab === "payment_method" ? this.exportOrderPaymentsRef : this.state.activeTab === "delivery_method" ? this.exportOrdersDeliveryRef : this.exportShippingLocationsRef
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "tabs",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "orders_overview" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "orders_overview") this.setState({
                                    activeTab: "orders_overview"
                                });
                            },
                            children: t("ordersOverview")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "shipping_locations" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "shipping_locations") this.setState({
                                    activeTab: "shipping_locations"
                                });
                            },
                            children: t("shippingLocations")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "payment_method" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "payment_method") this.setState({
                                    activeTab: "payment_method"
                                });
                            },
                            children: t("paymentMethod")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "delivery_method" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "delivery_method") this.setState({
                                    activeTab: "delivery_method"
                                });
                            },
                            children: t("deliveryMethod")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "cancelled_orders" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "cancelled_orders") this.setState({
                                    activeTab: "cancelled_orders"
                                });
                            },
                            children: t("cancelledOrders")
                        })
                    ]
                }),
                this.state.activeTab === "orders_overview" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    ref: this.exportOrdersRef,
                    className: `orders-overview ${this.context.comparedPeriod && "compared-orders-overview"}`,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card overview-card transparent-card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "overview-items",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("completedOrders")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.complete_order_count)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("pendingOrders")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.pending_order_count)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("cancelledOrders")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.canceled_order_count)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("avgOrderValue")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.avg_value_per_order)} ${this.context.settings.currency}`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "title",
                                                    children: t("avgBasketSize")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                    className: "header",
                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.avg_basket_size)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "overview-items",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "title",
                                                        children: t("completedOrders")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "header",
                                                        children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedOverview?.complete_order_count)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "title",
                                                        children: t("pendingOrders")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "header",
                                                        children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedOverview?.pending_order_count)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "title",
                                                        children: t("avgOrderValue")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "header",
                                                        children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedOverview?.avg_value_per_order)} ${this.context.settings.currency}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "title",
                                                        children: t("cancelledOrders")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "header",
                                                        children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedOverview?.canceled_order_count)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "orders-overview__orders-per-day",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7c79e7a583126a6d$export$2e2bcd8739ae039), {
                                getDataPerDay: (0, $aa865fdbda79f268$export$3f406deb15ba6ad2),
                                chartLabel: t("common:numberOfOrders"),
                                chartTitle: t("common:orders")
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "orders-overview__order-status",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                                title: t("orderStatus"),
                                items: orderStatusDoughnutCardItems,
                                currentPeriod: this.context.currentPeriod,
                                legendPosition: "bottom",
                                cutout: "95%",
                                radius: "120",
                                blackThemed: true,
                                totalOrders: this.state.totalOrders
                            })
                        }),
                        this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "orders-overview__compared-order-status",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                                title: t("orderStatus"),
                                items: comparedOrderStatusDoughnutCardItems,
                                currentPeriod: this.context.comparedPeriod,
                                legendPosition: "bottom",
                                cutout: "95%",
                                radius: "120",
                                blackThemed: true,
                                totalOrders: this.state.comparedOverview?.totalOrders
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "orders-overview__orders-hourly",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7c79e7a583126a6d$export$2e2bcd8739ae039), {
                                chartLabel: t("orders"),
                                chartTitle: t("averageOrdersPerHour"),
                                hourlyBreakdown: this.state.ordersHourlyBreakdown
                            })
                        })
                    ]
                }),
                this.state.activeTab === "payment_method" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $afa8a86a2e912322$export$2e2bcd8739ae039), {
                    exportRef: this.exportOrderPaymentsRef
                }),
                this.state.activeTab === "delivery_method" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    ref: this.exportOrdersDeliveryRef,
                    className: this.context.comparedPeriod ? "card-container" : "flex justify-center",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "pie-chart-only-page",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                                title: t("deliveryMethodsStatistics"),
                                items: deliveryMethodsDoughnutCardItems,
                                currentPeriod: this.context.currentPeriod,
                                blackThemed: true
                            })
                        }),
                        this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "pie-chart-only-page",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                                title: t("deliveryMethodsStatistics"),
                                items: comparedDeliveryMethodsDoughnutCardItems,
                                currentPeriod: this.context.comparedPeriod,
                                blackThemed: true
                            })
                        })
                    ]
                }),
                this.state.activeTab === "shipping_locations" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $477fbc57b42c06fa$export$2e2bcd8739ae039), {
                    exportRef: this.exportShippingLocationsRef
                }),
                this.state.activeTab === "cancelled_orders" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $dcc0ef23fa4781cc$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
$6712b680f81e5080$var$Orders.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $6712b680f81e5080$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "orders",
    "common"
])($6712b680f81e5080$var$Orders);


/**
 * @author Ahmed Serag
 * @date 2019-06-09
 * @description Overview tab of the App.
 * @filename overview.tsx
 */ 


var $igtsr = parcelRequire("igtsr");








var $3fc3977bdd9a18ff$exports = {};
$3fc3977bdd9a18ff$exports = $parcel$resolve("gN8qh");



parcelRequire("igtsr");
const $bade14c54fb8461b$var$SvgRevenue = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(0 1)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 28.343,
                    height: 34.706,
                    fill: "#DAF3FF",
                    rx: 5
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M31.343 27.17v2.536a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h18.343a5 5 0 0 1 5 5v13.227"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "m9.734 18.437 5.637-5.637 2.24 2.24 6.051-5.473"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M18.152 9.324h5.726v5.726M9.734 23.657h7.438"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "m27.577 28.865 2.045-2.045 5.112 5.112a1.446 1.446 0 0 1-2.045 2.045z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 25.873,
                    cy: 24.873,
                    r: 7.52,
                    fill: "#45C2FF"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "m34.015 29.213 2.72 2.72a1.446 1.446 0 0 1-2.046 2.044l-2.794-2.794"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 27.873,
                    cy: 24.873,
                    r: 7.52,
                    stroke: "#000"
                })
            ]
        })
    });
var $bade14c54fb8461b$export$2e2bcd8739ae039 = $bade14c54fb8461b$var$SvgRevenue;



parcelRequire("igtsr");
const $7b1fee97567218d4$var$SvgOrders = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(0 1)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#DAF3FF",
                    d: "M2 0h31a2 2 0 0 1 2 2v6.167H0V2a2 2 0 0 1 2-2m.333 8.167h30.334V30a5 5 0 0 1-5 5H7.333a5 5 0 0 1-5-5z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    d: "M5 0h31a2 2 0 0 1 2 2v6.167H3V2a2 2 0 0 1 2-2Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M29.444 35h-19.11a5 5 0 0 1-5-5V8.167h30.333V21.9"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M9.167 8.167H18.5v9.598a.5.5 0 0 1-.765.424l-3.372-2.108a1 1 0 0 0-1.06 0L9.932 18.19a.5.5 0 0 1-.765-.424z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M11.167 8.167H20.5v9.598a.5.5 0 0 1-.765.424l-3.372-2.108a1 1 0 0 0-1.06 0l-3.371 2.108a.5.5 0 0 1-.765-.424z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 28.417,
                    cy: 27.417,
                    r: 7.583,
                    fill: "#45C2FF"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 30.417,
                    cy: 27.417,
                    r: 7.583,
                    stroke: "#000"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#000",
                    d: "M33.769 25.01a.59.59 0 0 1 0 .838l-3.975 3.975a.593.593 0 0 1-.838 0l-1.892-1.892a.592.592 0 1 1 .838-.838l1.473 1.473 3.556-3.556a.593.593 0 0 1 .838 0"
                })
            ]
        })
    });
var $7b1fee97567218d4$export$2e2bcd8739ae039 = $7b1fee97567218d4$var$SvgOrders;



parcelRequire("igtsr");
const $ed4dbd6bff9e6fe9$var$SvgCustomers = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 38,
        height: 36,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M29.262 15.597A5.74 5.74 0 0 1 35 21.334v6.922a2 2 0 0 1-2 2h-7.475a2 2 0 0 1-2-2v-6.922a5.74 5.74 0 0 1 5.737-5.737m-23.524 0a5.74 5.74 0 0 1 5.737 5.737v6.922a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6.922a5.74 5.74 0 0 1 5.738-5.737"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(25.983 5.59)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 5.041,
                            cy: 3.586,
                            r: 3.586
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M0 13.494a5.74 5.74 0 0 1 11.017 2.25v6.922a2 2 0 0 1-2 2H2.566"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(2 5.59)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 5.499,
                            cy: 3.586,
                            r: 3.586
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M5.738 10.007a5.74 5.74 0 0 1 5.737 5.737v6.922a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6.922a5.74 5.74 0 0 1 5.738-5.737Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(7.033 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#FFF",
                            stroke: "#000",
                            strokeLinejoin: "round",
                            d: "M12.18 15.17a9.18 9.18 0 0 1 9.18 9.18v7.181a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7.18a9.18 9.18 0 0 1 9.18-9.18Z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 9.18,
                            cy: 5.738,
                            r: 5.738,
                            fill: "#DAF3FF"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#DAF3FF",
                            d: "M9.18 15.17a9.18 9.18 0 0 1 9.18 9.18v7.181a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7.18a9.18 9.18 0 0 1 9.18-9.18Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(10.033 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 9.18,
                            cy: 5.738,
                            r: 5.738
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M9.18 15.17a9.18 9.18 0 0 1 9.18 9.18v7.181a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7.18a9.18 9.18 0 0 1 9.18-9.18Z"
                        })
                    ]
                })
            ]
        })
    });
var $ed4dbd6bff9e6fe9$export$2e2bcd8739ae039 = $ed4dbd6bff9e6fe9$var$SvgCustomers;


/**
 * @author Ahmed Serag
 * @date 2019-12-13
 * @description not found layout.
 * @filename not-found.tsx
 */ 

var $igtsr = parcelRequire("igtsr");







parcelRequire("igtsr");
const $a1eac55324389f55$var$SvgSetGoals = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    fill: "#000",
                    fillRule: "nonzero",
                    stroke: "#FFF",
                    transform: "translate(1 3.377)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M10.812 0c5.97 0 10.811 4.84 10.811 10.812 0 5.97-4.84 10.811-10.811 10.811S0 16.783 0 10.812 4.84 0 10.812 0Zm0 3.88a6.931 6.931 0 1 0 0 13.863 6.931 6.931 0 0 0 0-13.862Z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 10.812,
                            cy: 10.812,
                            r: 3.036
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#FFF",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M23.447 2.522 11.78 14.188"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    fillRule: "nonzero",
                    d: "M23.657 2.312 23.202.567a.757.757 0 0 0-1.267-.345l-1.95 1.95a.76.76 0 0 0-.195.737l.708 2.562 3.16-3.16Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    fillRule: "nonzero",
                    d: "m23.657 2.312 1.745.454a.757.757 0 0 1 .345 1.268l-1.95 1.95a.76.76 0 0 1-.737.195l-2.562-.708 3.16-3.16Z"
                })
            ]
        })
    });
var $a1eac55324389f55$export$2e2bcd8739ae039 = $a1eac55324389f55$var$SvgSetGoals;


/**
 * @author Youssef Tarek
 * @date 2022-08-18
 * @description circular progress bar for goal achievements.
 * @filename circular-progress-bar.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

class $4c82e3225d4f6987$var$CircularProgressBar extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        const strokeDashOffset = 100 - this.props.progress;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "circular-progress-bar",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
                    className: "circle-container",
                    viewBox: "2 -2 28 36",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            className: "circle-container__background",
                            r: "16",
                            cx: "16",
                            cy: "16"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            className: "circle-container__progress",
                            r: "16",
                            cx: "16",
                            cy: "16",
                            style: {
                                strokeDashoffset: strokeDashOffset
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "circle-container__text goal",
                    children: [
                        (0, $48f673e197675daa$export$e993d5e1f686c8b0)(this.props.progress),
                        "%"
                    ]
                })
            ]
        });
    }
}
var $4c82e3225d4f6987$export$2e2bcd8739ae039 = $4c82e3225d4f6987$var$CircularProgressBar;


/**
 * React Component that renders the goal achievement card.
 *
 * @extends {React.Component}
 */ class $1340dce1cf6e04ee$var$GoalAchievementCard extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    static getPeriodDescription(periodType) {
        if (periodType === "year") return `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("overview:annual")}`;
        if (periodType === "month") return `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("overview:monthly")}`;
        if (periodType === "week") return `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("overview:weekly")}`;
        if (periodType === "day") return `${(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).t("overview:daily")}`;
        return "";
    }
    static getProgressColor(percentage) {
        if (percentage >= 100) return "rgba(56, 204, 170) ";
        if (percentage <= 70) return `rgba(255, ${0 + percentage * 2}, 0)`;
        return `rgba(${255 - percentage * 2}, 195, 0)`;
    }
    render() {
        const { t: t } = this.props;
        let ordersCompletedPercentage = 0;
        let periodGoal = 0;
        if (this.context.currentPeriod.type === "custom") return "";
        if (this.context.currentPeriod.type === "year" && this.context.settings?.yearly_goal) {
            periodGoal = this.context.settings.yearly_goal;
            ordersCompletedPercentage = this.props.totalRevenue / periodGoal * 100;
        }
        if (this.context.currentPeriod.type === "month" && this.context.settings?.monthly_goal) {
            periodGoal = this.context.settings.monthly_goal;
            ordersCompletedPercentage = this.props.totalRevenue / periodGoal * 100;
        }
        if (this.context.currentPeriod.type === "week" && this.context.settings?.weekly_goal) {
            periodGoal = this.context.settings.weekly_goal;
            ordersCompletedPercentage = this.props.totalRevenue / periodGoal * 100;
        }
        if (this.context.currentPeriod.type === "day" && this.context.settings?.daily_goal) {
            periodGoal = this.context.settings.daily_goal;
            ordersCompletedPercentage = this.props.totalRevenue / periodGoal * 100;
        }
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "card goal-achievement-card",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                    className: "card--title",
                    children: [
                        $1340dce1cf6e04ee$var$GoalAchievementCard.getPeriodDescription(this.context.currentPeriod?.type),
                        " ",
                        t("goalAchievement")
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card--body",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "numbers",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "numbers--progress",
                                    children: [
                                        (0, $48f673e197675daa$export$e993d5e1f686c8b0)(Math.round(this.props.totalRevenue)),
                                        "/",
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            children: (0, $48f673e197675daa$export$e993d5e1f686c8b0)(periodGoal)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "footer",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a1eac55324389f55$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                            to: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).settings.path}/data-settings`,
                                            children: t("setGoals")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4c82e3225d4f6987$export$2e2bcd8739ae039), {
                            progress: ordersCompletedPercentage <= 100 ? Number(ordersCompletedPercentage.toFixed(0)) : 100
                        })
                    ]
                })
            ]
        });
    }
}
$1340dce1cf6e04ee$var$GoalAchievementCard.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $1340dce1cf6e04ee$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("overview")($1340dce1cf6e04ee$var$GoalAchievementCard);






/**
 * @author Ahmed Serag
 * @date 2019-12-13
 * @description not found layout.
 * @filename not-found.tsx
 */ 

var $igtsr = parcelRequire("igtsr");








/**
 * @author Salma Hefnawy
 * @date 20222-06-05
 * @description declaration of overview recommendations interface.
 * @filename recommendations.ts
 */ var $dc442a448cf56ab3$export$b042134994044ee2 = /*#__PURE__*/ function(RecommendationsType) {
    RecommendationsType["STOCK"] = "stock";
    RecommendationsType["BUNDLE"] = "bundle";
    RecommendationsType["PROMOTION"] = "promotion";
    return RecommendationsType;
}({});


/**
 * React Component that renders overview recommendations card.
 *
 * @extends {React.Component}
 */ class $429f5bcf1ddd57ae$var$OverviewRecommendations extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "card overview-card transparent-card m-0",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "recommendations",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "stock-banner banner",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "banner-icon",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $82a0019a94c721c2$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "banner-text",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "title",
                                        children: t("stockingRecommendation")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "description",
                                        children: t("stockingRecommendationsDesc")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: {
                                            pathname: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).recommendationsList.path}/stock`,
                                            state: {
                                                recommendationType: (0, $dc442a448cf56ab3$export$b042134994044ee2).STOCK
                                            }
                                        },
                                        children: [
                                            t("viewList"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                className: "right-arrow"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "bundle-banner banner",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "banner-icon",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7a543022dad66670$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "banner-text",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "title",
                                        children: t("bundleRecommendation")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "description",
                                        children: t("bundleRecommendationsDesc")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: {
                                            pathname: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).recommendationsList.path}/bundle`,
                                            state: {
                                                recommendationType: (0, $dc442a448cf56ab3$export$b042134994044ee2).BUNDLE
                                            }
                                        },
                                        children: [
                                            t("viewRecommendations"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                className: "right-arrow"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "discount-banner banner",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "banner-icon",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4340166cff2eb9b8$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "banner-text",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "title",
                                        children: t("promotionsRecommendation")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "description",
                                        children: t("seasonalityRecommendationsDesc")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: {
                                            pathname: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).recommendationsList.path}/promotion`,
                                            state: {
                                                recommendationType: (0, $dc442a448cf56ab3$export$b042134994044ee2).PROMOTION
                                            },
                                            search: `?type=${(0, $dc442a448cf56ab3$export$b042134994044ee2).PROMOTION}`
                                        },
                                        children: [
                                            t("viewList"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                className: "right-arrow"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
$429f5bcf1ddd57ae$var$OverviewRecommendations.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $429f5bcf1ddd57ae$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("overview")($429f5bcf1ddd57ae$var$OverviewRecommendations);


class $7ed6706ebe97772f$var$Overview extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.exportRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            overview: null,
            previousOverview: null,
            loading: true,
            id: Date.now().toString()
        };
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams();
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Overview";
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    /**
   * show > 1000% if percentage is that high
   * @param percentageChange
   * @returns what to be shown in percentage change stat
   */ // eslint-disable-next-line class-methods-use-this
    getPercentageChangeNumber(percentageChange) {
        if (Math.abs(percentageChange.percentage) >= 1000) return "> 1000";
        return Math.abs(percentageChange.percentage);
    }
    /**  initializes overview for current period,
  pervious overview for the pervious period,
  compared overview for compared period
  */ loadData() {
        let overviewPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) overviewPromise = (0, $aa865fdbda79f268$export$db367fc7ac51da69)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            filters: this.context.appliedFilters
        }).then((overview)=>{
            this.setState({
                overview: overview
            });
        });
        let previousOverviewPromise = Promise.resolve();
        previousOverviewPromise = (0, $aa865fdbda79f268$export$db367fc7ac51da69)({
            project: this.context.project,
            from: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.type).from,
            to: (0, $48f673e197675daa$export$2a87b451bcc94d58)(this.context.currentPeriod.type).to,
            filters: this.context.appliedFilters
        }).then((previousOverview)=>{
            this.setState({
                previousOverview: previousOverview
            });
        });
        let comparedOverviewPromise = Promise.resolve();
        if (this.context.comparedPeriod) comparedOverviewPromise = (0, $aa865fdbda79f268$export$db367fc7ac51da69)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            filters: this.context.appliedFilters
        }).then((comparedOverview)=>{
            this.setState({
                comparedOverview: comparedOverview
            });
        });
        else this.setState({
            comparedOverview: null
        });
        Promise.all([
            overviewPromise,
            previousOverviewPromise,
            comparedOverviewPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        const { t: t } = this.props;
        const currDate = new Date();
        const prevDate = new Date(new Date().setFullYear(currDate.getFullYear() - 1));
        const currentYear = currDate.toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric"
        });
        const previousYear = prevDate.toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric"
        });
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        // TODO Provide the rest of the metrics
        // let topSales = 0;
        // let grossSales = 0;
        // let netSales = 0;
        // if (this.state.overview) {
        //   topSales =
        //     this.state.overview?.total_revenues +
        //     Math.abs(this.state.overview?.coupons);
        //   grossSales =
        //     topSales -
        //     Math.abs(this.state.overview?.taxes) -
        //     Math.abs(this.state.overview?.shipping);
        //   netSales =
        //     grossSales -
        //     Math.abs(this.state.overview?.returns) -
        //     Math.abs(this.state.overview?.coupons);
        // }
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "overview",
            ref: this.exportRef,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("dashboardOverview"),
                    exportRef: this.exportRef
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "overview-header",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "card overview-card transparent-card",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "overview-items gap-30",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "overview-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "item-data-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "tooltip",
                                                        children: t("totalRevenueDisclaimer")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $bade14c54fb8461b$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "item-data",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "title",
                                                                children: t("totalRevenue")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "header",
                                                                children: ` ${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.overview?.total_revenues)} 
                      ${this.context.settings.currency}`
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                current: this.state.overview?.total_revenues,
                                                previous: this.state.previousOverview?.total_revenues
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).orders.path,
                                        className: "overview-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "item-data-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "tooltip",
                                                        children: t("totalOrdersDisclaimer")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7b1fee97567218d4$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "item-data",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "title",
                                                                children: t("totalOrders")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "header",
                                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.overview?.total_orders)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                current: this.state.overview?.total_orders,
                                                previous: this.state.previousOverview?.total_orders
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).customers.path,
                                        className: "overview-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "item-data-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "tooltip",
                                                        children: t("totalCustomersDisclaimer")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ed4dbd6bff9e6fe9$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "item-data",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "title",
                                                                children: t("totalCustomers")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "header",
                                                                children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.overview?.customer_count)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $04ba0179fd07dc0d$export$2e2bcd8739ae039), {
                                                current: this.state.overview?.customer_count,
                                                previous: this.state.previousOverview?.customer_count
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1340dce1cf6e04ee$export$2e2bcd8739ae039), {
                                        totalRevenue: this.state.overview?.total_revenues
                                    })
                                ]
                            }),
                            this.state.comparedOverview && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                        className: "card--title mt-40",
                                        children: this.context.comparedPeriod?.type === "quarter" ? this.context.comparedPeriod?.alias.startsWith("previous") ? `${t(`${this.context.comparedPeriod?.alias.match(/First|Second|Third|Fourth/)[0].toLowerCase()}Quarter`)} ${previousYear}` : `${t(this.context.comparedPeriod?.alias)} ${currentYear}` : t(this.context.comparedPeriod?.alias)
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "overview-items gap-30",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "overview-item light-blue",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item-data-with-icon",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $bade14c54fb8461b$export$2e2bcd8739ae039), {}),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "item-data",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "header",
                                                                    children: `${(0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedOverview?.total_revenues)} ${this.context.settings.currency}`
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "title",
                                                                    children: t("totalRevenue")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "overview-item light-violet",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item-data-with-icon",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7b1fee97567218d4$export$2e2bcd8739ae039), {}),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "item-data",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "header",
                                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedOverview?.total_orders)
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "title",
                                                                    children: t("totalOrders")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "overview-item light-yellow",
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "item-data-with-icon",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ed4dbd6bff9e6fe9$export$2e2bcd8739ae039), {}),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "item-data",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "header",
                                                                    children: (0, $48f673e197675daa$export$4640587ffa669919)(this.state.comparedOverview?.customer_count)
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "title",
                                                                    children: t("newCustomers")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $429f5bcf1ddd57ae$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "cards-row",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card features-card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            children: t("featured")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod.from, this.context.currentPeriod.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "feature",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "feature--subtitle",
                                            children: t("topPerformingProduct")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "feature--data",
                                            children: [
                                                this.state.overview?.top_performing_product?.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: this.state.overview?.top_performing_product?.image_url,
                                                    alt: this.state.overview?.top_performing_product?.name,
                                                    onError: (e)=>{
                                                        (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                                    }
                                                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                                    alt: this.state.overview?.top_performing_product?.name
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "feature--name",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            children: this.state.overview?.top_performing_product?.name
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                            className: "feature--sku",
                                                            children: `sku: ${this.state.overview?.top_performing_product?.sku}`
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "feature",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "feature--subtitle",
                                            children: t("topPerformingCategory")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "feature--data",
                                            children: [
                                                this.state.overview?.top_performing_category?.image_url ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: this.state.overview?.top_performing_category?.image_url,
                                                    alt: this.state.overview?.top_performing_category?.name,
                                                    onError: (e)=>{
                                                        (0, $48f673e197675daa$export$dc700bc3d778ec04)(e);
                                                    }
                                                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0c35e9579b87db20$exports))),
                                                    alt: this.state.overview?.top_performing_category?.name
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "feature--name",
                                                    children: this.state.overview?.top_performing_category?.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "feature",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "feature--subtitle",
                                            children: t("topUsedPaymentMethod")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "feature--data",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3fc3977bdd9a18ff$exports))),
                                                    alt: "paymentMethodIcon"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "feature--name",
                                                    children: this.state.overview?.top_used_payment_method
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "cards-row--orders-card",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $7c79e7a583126a6d$export$2e2bcd8739ae039), {
                                getDataPerDay: (0, $aa865fdbda79f268$export$d9722900fc0ca476),
                                chartLabel: t("common:revenue"),
                                chartTitle: t("common:totalRevenue")
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$7ed6706ebe97772f$var$Overview.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $7ed6706ebe97772f$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("overview")($7ed6706ebe97772f$var$Overview);


/**
 * @author Ahmed Serag
 * @date 2021-12-05
 * @description settings nav-bar
 * @filename settings-nav-bar.tsx
 */ 

var $igtsr = parcelRequire("igtsr");






parcelRequire("igtsr");
const $74eb3074dad86f13$var$SvgIntegration = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 37,
        height: 34,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(.364 .66)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 14.026,
                    height: 14.026,
                    fill: "#DAF3FF",
                    rx: 2
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 14.026,
                    height: 14.026,
                    x: 2.338,
                    stroke: "#000",
                    strokeLinecap: "round",
                    rx: 2
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 14.026,
                    height: 14.026,
                    x: 19.636,
                    y: 18.701,
                    fill: "#45C2FF",
                    rx: 7.013
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 14.026,
                    height: 14.026,
                    x: 21.974,
                    y: 18.701,
                    stroke: "#000",
                    strokeLinecap: "round",
                    rx: 7.013
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M16.491 6.864h8.156a4 4 0 0 1 4 4v4.416h0"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "m32.241 12.26-3.786 3.786-3.786-3.787"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M21.955 26.331H13.8a4 4 0 0 1-4-4v-4.415h0"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "m6.205 20.936 3.787-3.786 3.786 3.786"
                        })
                    ]
                })
            ]
        })
    });
var $74eb3074dad86f13$export$2e2bcd8739ae039 = $74eb3074dad86f13$var$SvgIntegration;



parcelRequire("igtsr");
const $12e3c11a015c84ba$var$SvgUserManagement = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 37,
        height: 38,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(0 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#FFF",
                            stroke: "#000",
                            strokeLinejoin: "round",
                            d: "M13.087 16.287h.057c5.443 0 9.856 4.413 9.856 9.857V34a2 2 0 0 1-2 2H5.23a2 2 0 0 1-2-2v-7.856c0-5.444 4.413-9.857 9.857-9.857Z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                            cx: 9.885,
                            cy: 6.16,
                            fill: "#DAF3FF",
                            rx: 6.178,
                            ry: 6.16
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#DAF3FF",
                            d: "M9.856 16.287h.057c5.444 0 9.857 4.413 9.857 9.857V34a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7.856c0-5.444 4.413-9.857 9.856-9.857"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(3.23 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                            cx: 9.885,
                            cy: 6.16,
                            rx: 6.178,
                            ry: 6.16
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M9.856 16.287h.057c5.444 0 9.857 4.413 9.857 9.857V34a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7.856c0-5.444 4.413-9.857 9.856-9.857Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    d: "M27.99 13.435a.75.75 0 0 1 .734.607l.37 1.904a.22.22 0 0 0 .148.166 7.15 7.15 0 0 1 2.682 1.551.22.22 0 0 0 .218.045l1.835-.633a.75.75 0 0 1 .894.333l.934 1.62c.18.31.114.706-.158.94L34.18 21.24a.22.22 0 0 0-.07.21 7.2 7.2 0 0 1 0 3.1.22.22 0 0 0 .07.21l1.466 1.271a.75.75 0 0 1 .158.942l-.935 1.62a.75.75 0 0 1-.893.332l-1.836-.633a.22.22 0 0 0-.217.045 7.15 7.15 0 0 1-2.682 1.552.22.22 0 0 0-.148.165l-.37 1.905a.75.75 0 0 1-.735.606H26.12a.75.75 0 0 1-.735-.607l-.37-1.904a.22.22 0 0 0-.147-.166 7.15 7.15 0 0 1-2.682-1.551.22.22 0 0 0-.218-.046l-1.836.634a.75.75 0 0 1-.893-.333l-.934-1.62a.75.75 0 0 1 .158-.941l1.466-1.271a.22.22 0 0 0 .07-.211 7.2 7.2 0 0 1 0-3.098.22.22 0 0 0-.07-.211l-1.466-1.272a.75.75 0 0 1-.158-.94l.934-1.62a.75.75 0 0 1 .894-.333l1.835.633a.22.22 0 0 0 .218-.045 7.15 7.15 0 0 1 2.682-1.552.22.22 0 0 0 .147-.165l.37-1.905a.75.75 0 0 1 .735-.606zm-.935 6.013A3.556 3.556 0 0 0 23.503 23a3.556 3.556 0 0 0 3.552 3.552A3.556 3.556 0 0 0 30.607 23a3.556 3.556 0 0 0-3.552-3.552"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M26.49 13.435a.75.75 0 0 1 .734.607l.37 1.904a.22.22 0 0 0 .148.166 7.15 7.15 0 0 1 2.682 1.551.22.22 0 0 0 .218.045l1.835-.633a.75.75 0 0 1 .894.333l.934 1.62c.18.31.114.706-.158.94L32.68 21.24a.22.22 0 0 0-.07.21 7.2 7.2 0 0 1 0 3.1.22.22 0 0 0 .07.21l1.466 1.271a.75.75 0 0 1 .158.942l-.935 1.62a.75.75 0 0 1-.893.332l-1.836-.633a.22.22 0 0 0-.217.045 7.15 7.15 0 0 1-2.682 1.552.22.22 0 0 0-.148.165l-.37 1.905a.75.75 0 0 1-.735.606H24.62a.75.75 0 0 1-.735-.607l-.37-1.904a.22.22 0 0 0-.147-.166 7.15 7.15 0 0 1-2.682-1.551.22.22 0 0 0-.218-.046l-1.836.634a.75.75 0 0 1-.893-.333l-.934-1.62a.75.75 0 0 1 .158-.941l1.466-1.271a.22.22 0 0 0 .07-.211 7.2 7.2 0 0 1 0-3.098.22.22 0 0 0-.07-.211l-1.466-1.272a.75.75 0 0 1-.158-.94l.934-1.62a.75.75 0 0 1 .894-.333l1.835.633a.22.22 0 0 0 .218-.045 7.15 7.15 0 0 1 2.682-1.552.22.22 0 0 0 .147-.165l.37-1.905a.75.75 0 0 1 .735-.606zm-.935 6.013A3.556 3.556 0 0 0 22.003 23a3.556 3.556 0 0 0 3.552 3.552A3.556 3.556 0 0 0 29.107 23a3.556 3.556 0 0 0-3.552-3.552"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    fill: "#000",
                    fillRule: "nonzero",
                    stroke: "#000",
                    strokeWidth: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "m35.431 25.703-1.368-1.187a7.6 7.6 0 0 0 0-3.032l1.368-1.187c.43-.371.535-.997.25-1.487l-.934-1.62a1.18 1.18 0 0 0-1.412-.526l-1.714.591a7.6 7.6 0 0 0-2.624-1.518l-.346-1.778A1.185 1.185 0 0 0 27.49 13h-1.87c-.565 0-1.054.403-1.161.958l-.346 1.78a7.6 7.6 0 0 0-2.624 1.517l-1.715-.591a1.18 1.18 0 0 0-1.411.526l-.934 1.62c-.285.49-.18 1.116.249 1.487l1.369 1.187a7.6 7.6 0 0 0 0 3.032l-1.369 1.187c-.43.371-.534.997-.25 1.487l.934 1.62c.282.49.876.711 1.412.526l1.715-.591a7.6 7.6 0 0 0 2.624 1.518l.345 1.778c.108.556.597.959 1.162.959h1.87c.565 0 1.054-.403 1.161-.958l.346-1.78a7.6 7.6 0 0 0 2.624-1.517l1.714.591a1.184 1.184 0 0 0 1.412-.526l.934-1.62c.285-.49.18-1.116-.25-1.487Zm-.126 1.27-.935 1.62a.75.75 0 0 1-.893.332l-1.836-.633a.22.22 0 0 0-.217.045 7.15 7.15 0 0 1-2.682 1.552.22.22 0 0 0-.148.165l-.37 1.905a.75.75 0 0 1-.735.606H25.62a.75.75 0 0 1-.735-.607l-.37-1.904a.22.22 0 0 0-.147-.166 7.15 7.15 0 0 1-2.682-1.551.22.22 0 0 0-.218-.046l-1.836.634a.75.75 0 0 1-.893-.333l-.934-1.62a.75.75 0 0 1 .158-.941l1.466-1.271a.22.22 0 0 0 .07-.211 7.2 7.2 0 0 1 0-3.098.22.22 0 0 0-.07-.211l-1.466-1.272a.75.75 0 0 1-.158-.94l.934-1.62a.75.75 0 0 1 .894-.333l1.835.633a.22.22 0 0 0 .218-.045 7.15 7.15 0 0 1 2.682-1.552.22.22 0 0 0 .147-.165l.37-1.905a.75.75 0 0 1 .735-.606h1.87a.75.75 0 0 1 .734.607l.37 1.904a.22.22 0 0 0 .148.166 7.15 7.15 0 0 1 2.682 1.551.22.22 0 0 0 .218.045l1.835-.633a.75.75 0 0 1 .894.333l.934 1.62c.18.31.114.706-.158.94L33.68 21.24a.22.22 0 0 0-.07.21 7.2 7.2 0 0 1 0 3.1.22.22 0 0 0 .07.21l1.466 1.271a.75.75 0 0 1 .158.942Z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M26.555 19.448A3.556 3.556 0 0 0 23.003 23a3.556 3.556 0 0 0 3.552 3.552A3.556 3.556 0 0 0 30.107 23a3.556 3.556 0 0 0-3.552-3.552Zm0 6.67A3.12 3.12 0 0 1 23.437 23a3.12 3.12 0 0 1 3.118-3.118A3.12 3.12 0 0 1 29.672 23a3.12 3.12 0 0 1-3.117 3.118Z"
                        })
                    ]
                })
            ]
        })
    });
var $12e3c11a015c84ba$export$2e2bcd8739ae039 = $12e3c11a015c84ba$var$SvgUserManagement;



parcelRequire("igtsr");
const $bafd45c1aa13d5c6$var$SvgAccountSettings = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 38,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(.533 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#FFF",
                            stroke: "#000",
                            strokeLinejoin: "round",
                            d: "M13.077 16.287c5.444 0 9.856 4.413 9.856 9.857V34a2 2 0 0 1-2 2H5.221a2 2 0 0 1-2-2v-7.856c0-5.444 4.413-9.857 9.856-9.857Z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 9.856,
                            cy: 6.16,
                            r: 6.16,
                            fill: "#DAF3FF"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#45C2FF",
                            d: "M9.856 16.287c5.444 0 9.857 4.413 9.857 9.857V34a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7.856c0-5.444 4.413-9.857 9.856-9.857"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(3.754 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 9.856,
                            cy: 6.16,
                            r: 6.16
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M9.856 16.287c5.444 0 9.857 4.413 9.857 9.857V34a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7.856c0-5.444 4.413-9.857 9.856-9.857Z"
                        })
                    ]
                })
            ]
        })
    });
var $bafd45c1aa13d5c6$export$2e2bcd8739ae039 = $bafd45c1aa13d5c6$var$SvgAccountSettings;



parcelRequire("igtsr");
const $12d2afba1c6aa335$var$SvgAppearanceSettings = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 35,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(0 .391)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M12.045.098 30.24 6.01a2 2 0 0 1 1.284 2.52L23.51 33.197a2 2 0 0 1-2.52 1.284l-.017-.004a2 2 0 0 0 1.936-1.999V6.695a2 2 0 0 0-2-2H8.448l1.077-3.312a2 2 0 0 1 2.52-1.285"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 22.909,
                    height: 29.782,
                    x: 2.5,
                    y: 5.268,
                    fill: "#FFF",
                    rx: 2
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 22.909,
                    height: 29.782,
                    y: 5.268,
                    fill: "#DAF3FF",
                    rx: 2
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 22.909,
                    height: 29.782,
                    x: 2.864,
                    y: 5.268,
                    stroke: "#000",
                    strokeLinecap: "round",
                    rx: 2
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    d: "m14.908.671 18.195 5.912a2 2 0 0 1 1.284 2.52L26.373 33.77a2 2 0 0 1-2.52 1.284l-.017-.004a2 2 0 0 0 1.937-1.999h0V7.268a2 2 0 0 0-2-2h0H11.31l1.077-3.313a2 2 0 0 1 2.52-1.284Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "m15.203 11.735.658 1.403a1 1 0 0 0 .754.563l1.507.23a1 1 0 0 1 .564 1.687L17.534 16.8a1 1 0 0 0-.271.86l.27 1.65a.982.982 0 0 1-1.445 1.017l-1.286-.71a1 1 0 0 0-.968 0l-1.286.71a.982.982 0 0 1-1.444-1.017l.27-1.65a1 1 0 0 0-.272-.86L9.95 15.62a1 1 0 0 1 .565-1.688l1.506-.23a1 1 0 0 0 .754-.563l.658-1.403a.978.978 0 0 1 1.77 0Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    d: "M6.3 25.314h16.036m-12.6 2.291H18.9"
                })
            ]
        })
    });
var $12d2afba1c6aa335$export$2e2bcd8739ae039 = $12d2afba1c6aa335$var$SvgAppearanceSettings;



parcelRequire("igtsr");
const $f1ca3658389e6c8c$var$SvgPaymentAndSubscriptions = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 35,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#DAF3FF",
                    d: "M8.717 1h14.646l6.95 6.951v22.132a3 3 0 0 1-3 3H8.718a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M12.217 1h14.646l6.95 6.951v22.132a3 3 0 0 1-3 3H12.218a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M22.717 8.813q-.501-1.313-1.5-1.313c-1 0-1.5.875-1.5 1.313s0 1.75 1.5 2.187m-1.5 2.188q.5 1.312 1.5 1.312c1 0 1.5-.875 1.5-1.313s0-1.75-1.5-2.187m0-3.5v-1m0 9v-1M26.863 1l6.95 6.951h-6.95zM14 25.5l15.25.097M14 20.6l15.25.097"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M5.718 3.916 5.717 4v26.083a3 3 0 0 0 3 3h15.878l-.003.093A3 3 0 0 1 21.597 36H3a3 3 0 0 1-3-3V6.917a3 3 0 0 1 3-3h2.718Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M9.218 3.916 9.217 4v26.083a3 3 0 0 0 3 3h15.878l-.003.093A3 3 0 0 1 25.097 36H6.5a3 3 0 0 1-3-3V6.917a3 3 0 0 1 3-3h2.718Z"
                })
            ]
        })
    });
var $f1ca3658389e6c8c$export$2e2bcd8739ae039 = $f1ca3658389e6c8c$var$SvgPaymentAndSubscriptions;



parcelRequire("igtsr");
const $857aff21304449ff$var$SvgDataSettings = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 38,
        height: 37,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#DAF3FF",
                    d: "M32.59 19.27c0 9.27-7.266 16.787-16.228 16.787S.133 28.541.133 19.269c0-8.732 6.445-15.907 14.682-16.712v16.712Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#45C2FF",
                    d: "M18.765 1c7.908 0 14.319 6.632 14.319 14.813H18.27V1.009Q18.515 1 18.764 1Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M35.059 19.27c0 9.27-7.266 16.787-16.229 16.787S2.602 28.541 2.602 19.269c0-8.732 6.444-15.907 14.681-16.712v16.712Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#000",
                    d: "M22.22 1c7.91 0 14.32 6.632 14.32 14.813h-15.8V1.078q.73-.077 1.48-.078Z"
                })
            ]
        })
    });
var $857aff21304449ff$export$2e2bcd8739ae039 = $857aff21304449ff$var$SvgDataSettings;


/**
 * @author Youssef Tarek
 * @date 2021-12-04
 * @description Account information of the user
 * @filename account-information.tsx
 */ 


var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");








var $97068fe16ca9e12e$exports = {};

$97068fe16ca9e12e$exports = function(e) {
    var t = {};
    function r(n) {
        if (t[n]) return t[n].exports;
        var a = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, r.t = function(e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var a in e)r.d(n, a, (function(t) {
            return e[t];
        }).bind(null, a));
        return n;
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 9);
}([
    function(e, t) {
        e.exports = (parcelRequire("igtsr"));
    },
    function(e, t, r) {
        var n;
        /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
            "use strict";
            var r = {}.hasOwnProperty;
            function a() {
                for(var e = [], t = 0; t < arguments.length; t++){
                    var n = arguments[t];
                    if (n) {
                        var o = typeof n;
                        if ("string" === o || "number" === o) e.push(n);
                        else if (Array.isArray(n) && n.length) {
                            var i = a.apply(null, n);
                            i && e.push(i);
                        } else if ("object" === o) for(var u in n)r.call(n, u) && n[u] && e.push(u);
                    }
                }
                return e.join(" ");
            }
            e.exports ? (a.default = a, e.exports = a) : void 0 === (n = (function() {
                return a;
            }).apply(t, [])) || (e.exports = n);
        }();
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t && t && t.Object === Object && t, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = s.Symbol, d = f ? f.prototype : void 0, p = d ? d.toString : void 0;
            function h(e) {
                if ("string" == typeof e) return e;
                if (y(e)) return p ? p.call(e) : "";
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function y(e) {
                return "symbol" == typeof e || function(e) {
                    return !!e && "object" == typeof e;
                }(e) && "[object Symbol]" == l.call(e);
            }
            function b(e) {
                return e ? (e = function(e) {
                    if ("number" == typeof e) return e;
                    if (y(e)) return NaN;
                    if (m(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = m(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(r, "");
                    var u = a.test(e);
                    return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
                }(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
            }
            e.exports = function(e, t, r) {
                var n, a, o, i;
                return e = null == (n = e) ? "" : h(n), a = function(e) {
                    var t = b(e), r = t % 1;
                    return t == t ? r ? t - r : t : 0;
                }(r), o = 0, i = e.length, a == a && (void 0 !== i && (a = a <= i ? a : i), void 0 !== o && (a = a >= o ? a : o)), r = a, t = h(t), e.slice(r, r + t.length) == t;
            };
        }).call(this, r(3));
    },
    function(e, t) {
        var r;
        r = function() {
            return this;
        }();
        try {
            r = r || new Function("return this")();
        } catch (e) {
            "object" == typeof window && (r = window);
        }
        e.exports = r;
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\[object .+?Constructor\]$/, n = "object" == typeof t && t && t.Object === Object && t, a = "object" == typeof self && self && self.Object === Object && self, o = n || a || Function("return this")();
            var i, u = Array.prototype, c = Function.prototype, s = Object.prototype, l = o["__core-js_shared__"], f = (i = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "")) ? "Symbol(src)_1." + i : "", d = c.toString, p = s.hasOwnProperty, h = s.toString, m = RegExp("^" + d.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), y = u.splice, b = x(o, "Map"), g = x(Object, "create");
            function v(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function C(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function _(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function w(e, t) {
                for(var r, n, a = e.length; a--;)if ((r = e[a][0]) === (n = t) || r != r && n != n) return a;
                return -1;
            }
            function S(e) {
                var t;
                return !(!O(e) || (t = e, f && f in t)) && ((function(e) {
                    var t = O(e) ? h.call(e) : "";
                    return "[object Function]" == t || "[object GeneratorFunction]" == t;
                })(e) || function(e) {
                    var t = !1;
                    if (null != e && "function" != typeof e.toString) try {
                        t = !!(e + "");
                    } catch (e) {}
                    return t;
                }(e) ? m : r).test(function(e) {
                    if (null != e) {
                        try {
                            return d.call(e);
                        } catch (e) {}
                        try {
                            return e + "";
                        } catch (e) {}
                    }
                    return "";
                }(e));
            }
            function j(e, t) {
                var r, n, a = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
            }
            function x(e, t) {
                var r = function(e, t) {
                    return null == e ? void 0 : e[t];
                }(e, t);
                return S(r) ? r : void 0;
            }
            function N(e, t) {
                if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                var r = function() {
                    var n = arguments, a = t ? t.apply(this, n) : n[0], o = r.cache;
                    if (o.has(a)) return o.get(a);
                    var i = e.apply(this, n);
                    return r.cache = o.set(a, i), i;
                };
                return r.cache = new (N.Cache || _), r;
            }
            function O(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            v.prototype.clear = function() {
                this.__data__ = g ? g(null) : {};
            }, v.prototype.delete = function(e) {
                return this.has(e) && delete this.__data__[e];
            }, v.prototype.get = function(e) {
                var t = this.__data__;
                if (g) {
                    var r = t[e];
                    return "__lodash_hash_undefined__" === r ? void 0 : r;
                }
                return p.call(t, e) ? t[e] : void 0;
            }, v.prototype.has = function(e) {
                var t = this.__data__;
                return g ? void 0 !== t[e] : p.call(t, e);
            }, v.prototype.set = function(e, t) {
                return this.__data__[e] = g && void 0 === t ? "__lodash_hash_undefined__" : t, this;
            }, C.prototype.clear = function() {
                this.__data__ = [];
            }, C.prototype.delete = function(e) {
                var t = this.__data__, r = w(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : y.call(t, r, 1), !0);
            }, C.prototype.get = function(e) {
                var t = this.__data__, r = w(t, e);
                return r < 0 ? void 0 : t[r][1];
            }, C.prototype.has = function(e) {
                return w(this.__data__, e) > -1;
            }, C.prototype.set = function(e, t) {
                var r = this.__data__, n = w(r, e);
                return n < 0 ? r.push([
                    e,
                    t
                ]) : r[n][1] = t, this;
            }, _.prototype.clear = function() {
                this.__data__ = {
                    hash: new v,
                    map: new (b || C),
                    string: new v
                };
            }, _.prototype.delete = function(e) {
                return j(this, e).delete(e);
            }, _.prototype.get = function(e) {
                return j(this, e).get(e);
            }, _.prototype.has = function(e) {
                return j(this, e).has(e);
            }, _.prototype.set = function(e, t) {
                return j(this, e).set(e, t), this;
            }, N.Cache = _, e.exports = N;
        }).call(this, r(3));
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t && t && t.Object === Object && t, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = Math.max, d = Math.min, p = function() {
                return s.Date.now();
            };
            function h(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function m(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == l.call(e);
                }(e)) return NaN;
                if (h(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = h(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(r, "");
                var u = a.test(e);
                return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var n, a, o, i, u, c, s = 0, l = !1, y = !1, b = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function g(t) {
                    var r = n, o = a;
                    return n = a = void 0, s = t, i = e.apply(o, r);
                }
                function v(e) {
                    return s = e, u = setTimeout(_, t), l ? g(e) : i;
                }
                function C(e) {
                    var r = e - c;
                    return void 0 === c || r >= t || r < 0 || y && e - s >= o;
                }
                function _() {
                    var e = p();
                    if (C(e)) return w(e);
                    u = setTimeout(_, function(e) {
                        var r = t - (e - c);
                        return y ? d(r, o - (e - s)) : r;
                    }(e));
                }
                function w(e) {
                    return u = void 0, b && n ? g(e) : (n = a = void 0, i);
                }
                function S() {
                    var e = p(), r = C(e);
                    if (n = arguments, a = this, c = e, r) {
                        if (void 0 === u) return v(c);
                        if (y) return u = setTimeout(_, t), g(c);
                    }
                    return void 0 === u && (u = setTimeout(_, t)), i;
                }
                return t = m(t) || 0, h(r) && (l = !!r.leading, o = (y = "maxWait" in r) ? f(m(r.maxWait) || 0, t) : o, b = "trailing" in r ? !!r.trailing : b), S.cancel = function() {
                    void 0 !== u && clearTimeout(u), s = 0, n = c = a = u = void 0;
                }, S.flush = function() {
                    return void 0 === u ? i : w(p());
                }, S;
            };
        }).call(this, r(3));
    },
    function(e, t, r) {
        (function(e, r) {
            var n = "[object Arguments]", a = "[object Map]", o = "[object Object]", i = "[object Set]", u = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/, s = /^\./, l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, f = /\\(\\)?/g, d = /^\[object .+?Constructor\]$/, p = /^(?:0|[1-9]\d*)$/, h = {};
            h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h[n] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h["[object Function]"] = h[a] = h["[object Number]"] = h[o] = h["[object RegExp]"] = h[i] = h["[object String]"] = h["[object WeakMap]"] = !1;
            var m = "object" == typeof e && e && e.Object === Object && e, y = "object" == typeof self && self && self.Object === Object && self, b = m || y || Function("return this")(), g = t && !t.nodeType && t, v = g && "object" == typeof r && r && !r.nodeType && r, C = v && v.exports === g && m.process, _ = function() {
                try {
                    return C && C.binding("util");
                } catch (e) {}
            }(), w = _ && _.isTypedArray;
            function S(e, t, r, n) {
                var a = -1, o = e ? e.length : 0;
                for(n && o && (r = e[++a]); ++a < o;)r = t(r, e[a], a, e);
                return r;
            }
            function j(e, t) {
                for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                return !1;
            }
            function x(e, t, r, n, a) {
                return a(e, function(e, a, o) {
                    r = n ? (n = !1, e) : t(r, e, a, o);
                }), r;
            }
            function N(e) {
                var t = !1;
                if (null != e && "function" != typeof e.toString) try {
                    t = !!(e + "");
                } catch (e) {}
                return t;
            }
            function O(e) {
                var t = -1, r = Array(e.size);
                return e.forEach(function(e, n) {
                    r[++t] = [
                        n,
                        e
                    ];
                }), r;
            }
            function k(e) {
                var t = -1, r = Array(e.size);
                return e.forEach(function(e) {
                    r[++t] = e;
                }), r;
            }
            var E, T, I, A = Array.prototype, D = Function.prototype, P = Object.prototype, F = b["__core-js_shared__"], M = (E = /[^.]+$/.exec(F && F.keys && F.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", R = D.toString, L = P.hasOwnProperty, z = P.toString, B = RegExp("^" + R.call(L).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), G = b.Symbol, $ = b.Uint8Array, V = P.propertyIsEnumerable, K = A.splice, U = (T = Object.keys, I = Object, function(e) {
                return T(I(e));
            }), q = Ne(b, "DataView"), H = Ne(b, "Map"), W = Ne(b, "Promise"), J = Ne(b, "Set"), Z = Ne(b, "WeakMap"), Q = Ne(Object, "create"), Y = Pe(q), X = Pe(H), ee = Pe(W), te = Pe(J), re = Pe(Z), ne = G ? G.prototype : void 0, ae = ne ? ne.valueOf : void 0, oe = ne ? ne.toString : void 0;
            function ie(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function ue(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function ce(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function se(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.__data__ = new ce; ++t < r;)this.add(e[t]);
            }
            function le(e) {
                this.__data__ = new ue(e);
            }
            function fe(e, t) {
                var r = Le(e) || Re(e) ? function(e, t) {
                    for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                    return n;
                }(e.length, String) : [], n = r.length, a = !!n;
                for(var o in e)!t && !L.call(e, o) || a && ("length" == o || ke(o, n)) || r.push(o);
                return r;
            }
            function de(e, t) {
                for(var r = e.length; r--;)if (Me(e[r][0], t)) return r;
                return -1;
            }
            ie.prototype.clear = function() {
                this.__data__ = Q ? Q(null) : {};
            }, ie.prototype.delete = function(e) {
                return this.has(e) && delete this.__data__[e];
            }, ie.prototype.get = function(e) {
                var t = this.__data__;
                if (Q) {
                    var r = t[e];
                    return "__lodash_hash_undefined__" === r ? void 0 : r;
                }
                return L.call(t, e) ? t[e] : void 0;
            }, ie.prototype.has = function(e) {
                var t = this.__data__;
                return Q ? void 0 !== t[e] : L.call(t, e);
            }, ie.prototype.set = function(e, t) {
                return this.__data__[e] = Q && void 0 === t ? "__lodash_hash_undefined__" : t, this;
            }, ue.prototype.clear = function() {
                this.__data__ = [];
            }, ue.prototype.delete = function(e) {
                var t = this.__data__, r = de(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : K.call(t, r, 1), !0);
            }, ue.prototype.get = function(e) {
                var t = this.__data__, r = de(t, e);
                return r < 0 ? void 0 : t[r][1];
            }, ue.prototype.has = function(e) {
                return de(this.__data__, e) > -1;
            }, ue.prototype.set = function(e, t) {
                var r = this.__data__, n = de(r, e);
                return n < 0 ? r.push([
                    e,
                    t
                ]) : r[n][1] = t, this;
            }, ce.prototype.clear = function() {
                this.__data__ = {
                    hash: new ie,
                    map: new (H || ue),
                    string: new ie
                };
            }, ce.prototype.delete = function(e) {
                return xe(this, e).delete(e);
            }, ce.prototype.get = function(e) {
                return xe(this, e).get(e);
            }, ce.prototype.has = function(e) {
                return xe(this, e).has(e);
            }, ce.prototype.set = function(e, t) {
                return xe(this, e).set(e, t), this;
            }, se.prototype.add = se.prototype.push = function(e) {
                return this.__data__.set(e, "__lodash_hash_undefined__"), this;
            }, se.prototype.has = function(e) {
                return this.__data__.has(e);
            }, le.prototype.clear = function() {
                this.__data__ = new ue;
            }, le.prototype.delete = function(e) {
                return this.__data__.delete(e);
            }, le.prototype.get = function(e) {
                return this.__data__.get(e);
            }, le.prototype.has = function(e) {
                return this.__data__.has(e);
            }, le.prototype.set = function(e, t) {
                var r = this.__data__;
                if (r instanceof ue) {
                    var n = r.__data__;
                    if (!H || n.length < 199) return n.push([
                        e,
                        t
                    ]), this;
                    r = this.__data__ = new ce(n);
                }
                return r.set(e, t), this;
            };
            var pe, he, me = (pe = function(e, t) {
                return e && ye(e, t, qe);
            }, function(e, t) {
                if (null == e) return e;
                if (!ze(e)) return pe(e, t);
                for(var r = e.length, n = he ? r : -1, a = Object(e); (he ? n-- : ++n < r) && !1 !== t(a[n], n, a););
                return e;
            }), ye = function(e) {
                return function(t, r, n) {
                    for(var a = -1, o = Object(t), i = n(t), u = i.length; u--;){
                        var c = i[e ? u : ++a];
                        if (!1 === r(o[c], c, o)) break;
                    }
                    return t;
                };
            }();
            function be(e, t) {
                for(var r = 0, n = (t = Ee(t, e) ? [
                    t
                ] : Se(t)).length; null != e && r < n;)e = e[De(t[r++])];
                return r && r == n ? e : void 0;
            }
            function ge(e, t) {
                return null != e && t in Object(e);
            }
            function ve(e, t, r, u, c) {
                return e === t || (null == e || null == t || !$e(e) && !Ve(t) ? e != e && t != t : function(e, t, r, u, c, s) {
                    var l = Le(e), f = Le(t), d = "[object Array]", p = "[object Array]";
                    l || (d = (d = Oe(e)) == n ? o : d);
                    f || (p = (p = Oe(t)) == n ? o : p);
                    var h = d == o && !N(e), m = p == o && !N(t), y = d == p;
                    if (y && !h) return s || (s = new le), l || Ue(e) ? je(e, t, r, u, c, s) : function(e, t, r, n, o, u, c) {
                        switch(r){
                            case "[object DataView]":
                                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                e = e.buffer, t = t.buffer;
                            case "[object ArrayBuffer]":
                                return !(e.byteLength != t.byteLength || !n(new $(e), new $(t)));
                            case "[object Boolean]":
                            case "[object Date]":
                            case "[object Number]":
                                return Me(+e, +t);
                            case "[object Error]":
                                return e.name == t.name && e.message == t.message;
                            case "[object RegExp]":
                            case "[object String]":
                                return e == t + "";
                            case a:
                                var s = O;
                            case i:
                                var l = 2 & u;
                                if (s || (s = k), e.size != t.size && !l) return !1;
                                var f = c.get(e);
                                if (f) return f == t;
                                u |= 1, c.set(e, t);
                                var d = je(s(e), s(t), n, o, u, c);
                                return c.delete(e), d;
                            case "[object Symbol]":
                                if (ae) return ae.call(e) == ae.call(t);
                        }
                        return !1;
                    }(e, t, d, r, u, c, s);
                    if (!(2 & c)) {
                        var b = h && L.call(e, "__wrapped__"), g = m && L.call(t, "__wrapped__");
                        if (b || g) {
                            var v = b ? e.value() : e, C = g ? t.value() : t;
                            return s || (s = new le), r(v, C, u, c, s);
                        }
                    }
                    if (!y) return !1;
                    return s || (s = new le), function(e, t, r, n, a, o) {
                        var i = 2 & a, u = qe(e), c = u.length, s = qe(t).length;
                        if (c != s && !i) return !1;
                        var l = c;
                        for(; l--;){
                            var f = u[l];
                            if (!(i ? f in t : L.call(t, f))) return !1;
                        }
                        var d = o.get(e);
                        if (d && o.get(t)) return d == t;
                        var p = !0;
                        o.set(e, t), o.set(t, e);
                        var h = i;
                        for(; ++l < c;){
                            f = u[l];
                            var m = e[f], y = t[f];
                            if (n) var b = i ? n(y, m, f, t, e, o) : n(m, y, f, e, t, o);
                            if (!(void 0 === b ? m === y || r(m, y, n, a, o) : b)) {
                                p = !1;
                                break;
                            }
                            h || (h = "constructor" == f);
                        }
                        if (p && !h) {
                            var g = e.constructor, v = t.constructor;
                            g == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof v && v instanceof v || (p = !1);
                        }
                        return o.delete(e), o.delete(t), p;
                    }(e, t, r, u, c, s);
                }(e, t, ve, r, u, c));
            }
            function Ce(e) {
                return !(!$e(e) || function(e) {
                    return !!M && M in e;
                }(e)) && (Be(e) || N(e) ? B : d).test(Pe(e));
            }
            function _e(e) {
                var t, r;
                return "function" == typeof e ? e : null == e ? He : "object" == typeof e ? Le(e) ? function(e, t) {
                    if (Ee(e) && Te(t)) return Ie(De(e), t);
                    return function(r) {
                        var n = function(e, t, r) {
                            var n = null == e ? void 0 : be(e, t);
                            return void 0 === n ? r : n;
                        }(r, e);
                        return void 0 === n && n === t ? function(e, t) {
                            return null != e && function(e, t, r) {
                                t = Ee(t, e) ? [
                                    t
                                ] : Se(t);
                                var n, a = -1, o = t.length;
                                for(; ++a < o;){
                                    var i = De(t[a]);
                                    if (!(n = null != e && r(e, i))) break;
                                    e = e[i];
                                }
                                if (n) return n;
                                return !!(o = e ? e.length : 0) && Ge(o) && ke(i, o) && (Le(e) || Re(e));
                            }(e, t, ge);
                        }(r, e) : ve(t, n, void 0, 3);
                    };
                }(e[0], e[1]) : function(e) {
                    var t = function(e) {
                        var t = qe(e), r = t.length;
                        for(; r--;){
                            var n = t[r], a = e[n];
                            t[r] = [
                                n,
                                a,
                                Te(a)
                            ];
                        }
                        return t;
                    }(e);
                    if (1 == t.length && t[0][2]) return Ie(t[0][0], t[0][1]);
                    return function(r) {
                        return r === e || function(e, t, r, n) {
                            var a = r.length, o = a, i = !n;
                            if (null == e) return !o;
                            for(e = Object(e); a--;){
                                var u = r[a];
                                if (i && u[2] ? u[1] !== e[u[0]] : !(u[0] in e)) return !1;
                            }
                            for(; ++a < o;){
                                var c = (u = r[a])[0], s = e[c], l = u[1];
                                if (i && u[2]) {
                                    if (void 0 === s && !(c in e)) return !1;
                                } else {
                                    var f = new le;
                                    if (n) var d = n(s, l, c, e, t, f);
                                    if (!(void 0 === d ? ve(l, s, n, 3, f) : d)) return !1;
                                }
                            }
                            return !0;
                        }(r, e, t);
                    };
                }(e) : Ee(t = e) ? (r = De(t), function(e) {
                    return null == e ? void 0 : e[r];
                }) : function(e) {
                    return function(t) {
                        return be(t, e);
                    };
                }(t);
            }
            function we(e) {
                if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || P, t !== n) return U(e);
                var t, r, n, a = [];
                for(var o in Object(e))L.call(e, o) && "constructor" != o && a.push(o);
                return a;
            }
            function Se(e) {
                return Le(e) ? e : Ae(e);
            }
            function je(e, t, r, n, a, o) {
                var i = 2 & a, u = e.length, c = t.length;
                if (u != c && !(i && c > u)) return !1;
                var s = o.get(e);
                if (s && o.get(t)) return s == t;
                var l = -1, f = !0, d = 1 & a ? new se : void 0;
                for(o.set(e, t), o.set(t, e); ++l < u;){
                    var p = e[l], h = t[l];
                    if (n) var m = i ? n(h, p, l, t, e, o) : n(p, h, l, e, t, o);
                    if (void 0 !== m) {
                        if (m) continue;
                        f = !1;
                        break;
                    }
                    if (d) {
                        if (!j(t, function(e, t) {
                            if (!d.has(t) && (p === e || r(p, e, n, a, o))) return d.add(t);
                        })) {
                            f = !1;
                            break;
                        }
                    } else if (p !== h && !r(p, h, n, a, o)) {
                        f = !1;
                        break;
                    }
                }
                return o.delete(e), o.delete(t), f;
            }
            function xe(e, t) {
                var r, n, a = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
            }
            function Ne(e, t) {
                var r = function(e, t) {
                    return null == e ? void 0 : e[t];
                }(e, t);
                return Ce(r) ? r : void 0;
            }
            var Oe = function(e) {
                return z.call(e);
            };
            function ke(e, t) {
                return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || p.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function Ee(e, t) {
                if (Le(e)) return !1;
                var r = typeof e;
                return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Ke(e)) || c.test(e) || !u.test(e) || null != t && e in Object(t);
            }
            function Te(e) {
                return e == e && !$e(e);
            }
            function Ie(e, t) {
                return function(r) {
                    return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                };
            }
            (q && "[object DataView]" != Oe(new q(new ArrayBuffer(1))) || H && Oe(new H) != a || W && "[object Promise]" != Oe(W.resolve()) || J && Oe(new J) != i || Z && "[object WeakMap]" != Oe(new Z)) && (Oe = function(e) {
                var t = z.call(e), r = t == o ? e.constructor : void 0, n = r ? Pe(r) : void 0;
                if (n) switch(n){
                    case Y:
                        return "[object DataView]";
                    case X:
                        return a;
                    case ee:
                        return "[object Promise]";
                    case te:
                        return i;
                    case re:
                        return "[object WeakMap]";
                }
                return t;
            });
            var Ae = Fe(function(e) {
                var t;
                e = null == (t = e) ? "" : function(e) {
                    if ("string" == typeof e) return e;
                    if (Ke(e)) return oe ? oe.call(e) : "";
                    var t = e + "";
                    return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }(t);
                var r = [];
                return s.test(e) && r.push(""), e.replace(l, function(e, t, n, a) {
                    r.push(n ? a.replace(f, "$1") : t || e);
                }), r;
            });
            function De(e) {
                if ("string" == typeof e || Ke(e)) return e;
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function Pe(e) {
                if (null != e) {
                    try {
                        return R.call(e);
                    } catch (e) {}
                    try {
                        return e + "";
                    } catch (e) {}
                }
                return "";
            }
            function Fe(e, t) {
                if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                var r = function() {
                    var n = arguments, a = t ? t.apply(this, n) : n[0], o = r.cache;
                    if (o.has(a)) return o.get(a);
                    var i = e.apply(this, n);
                    return r.cache = o.set(a, i), i;
                };
                return r.cache = new (Fe.Cache || ce), r;
            }
            function Me(e, t) {
                return e === t || e != e && t != t;
            }
            function Re(e) {
                return function(e) {
                    return Ve(e) && ze(e);
                }(e) && L.call(e, "callee") && (!V.call(e, "callee") || z.call(e) == n);
            }
            Fe.Cache = ce;
            var Le = Array.isArray;
            function ze(e) {
                return null != e && Ge(e.length) && !Be(e);
            }
            function Be(e) {
                var t = $e(e) ? z.call(e) : "";
                return "[object Function]" == t || "[object GeneratorFunction]" == t;
            }
            function Ge(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
            }
            function $e(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function Ve(e) {
                return !!e && "object" == typeof e;
            }
            function Ke(e) {
                return "symbol" == typeof e || Ve(e) && "[object Symbol]" == z.call(e);
            }
            var Ue = w ? function(e) {
                return function(t) {
                    return e(t);
                };
            }(w) : function(e) {
                return Ve(e) && Ge(e.length) && !!h[z.call(e)];
            };
            function qe(e) {
                return ze(e) ? fe(e) : we(e);
            }
            function He(e) {
                return e;
            }
            r.exports = function(e, t, r) {
                var n = Le(e) ? S : x, a = arguments.length < 3;
                return n(e, _e(t), r, a, me);
            };
        }).call(this, r(3), r(7)(e));
    },
    function(e, t) {
        e.exports = function(e) {
            return e.webpackPolyfill || (e.deprecate = function() {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
                enumerable: !0,
                get: function() {
                    return e.l;
                }
            }), Object.defineProperty(e, "id", {
                enumerable: !0,
                get: function() {
                    return e.i;
                }
            }), e.webpackPolyfill = 1), e;
        };
    },
    function(e, t) {
        String.prototype.padEnd || (String.prototype.padEnd = function(e, t) {
            return e >>= 0, t = String(void 0 !== t ? t : " "), this.length > e ? String(this) : ((e -= this.length) > t.length && (t += t.repeat(e / t.length)), String(this) + t.slice(0, e));
        });
    },
    function(e, t, r) {
        "use strict";
        function n(e, t, r) {
            return t in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function a(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }
        function o(e) {
            return function(e) {
                if (Array.isArray(e)) {
                    for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                    return r;
                }
            }(e) || a(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance");
            }();
        }
        function i(e) {
            if (Array.isArray(e)) return e;
        }
        function u() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
        function c(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function s(e, t) {
            for(var r = 0; r < t.length; r++){
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function l(e) {
            return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function f(e) {
            return (f = "function" == typeof Symbol && "symbol" === l(Symbol.iterator) ? function(e) {
                return l(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : l(e);
            })(e);
        }
        function d(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function p(e) {
            return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function h(e, t) {
            return (h = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        r.r(t);
        var m = r(0), y = r.n(m), b = r(5), g = r.n(b), v = r(4), C = r.n(v), _ = r(6), w = r.n(_), S = r(2), j = r.n(S), x = r(1), N = r.n(x);
        r(8);
        function O(e, t) {
            return i(e) || function(e, t) {
                var r = [], n = !0, a = !1, o = void 0;
                try {
                    for(var i, u = e[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                } catch (e) {
                    a = !0, o = e;
                } finally{
                    try {
                        n || null == u.return || u.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return r;
            }(e, t) || u();
        }
        var k = [
            [
                "Afghanistan",
                [
                    "asia"
                ],
                "af",
                "93"
            ],
            [
                "Albania",
                [
                    "europe"
                ],
                "al",
                "355"
            ],
            [
                "Algeria",
                [
                    "africa",
                    "north-africa"
                ],
                "dz",
                "213"
            ],
            [
                "Andorra",
                [
                    "europe"
                ],
                "ad",
                "376"
            ],
            [
                "Angola",
                [
                    "africa"
                ],
                "ao",
                "244"
            ],
            [
                "Antigua and Barbuda",
                [
                    "america",
                    "carribean"
                ],
                "ag",
                "1268"
            ],
            [
                "Argentina",
                [
                    "america",
                    "south-america"
                ],
                "ar",
                "54",
                "(..) ........",
                0,
                [
                    "11",
                    "221",
                    "223",
                    "261",
                    "264",
                    "2652",
                    "280",
                    "2905",
                    "291",
                    "2920",
                    "2966",
                    "299",
                    "341",
                    "342",
                    "343",
                    "351",
                    "376",
                    "379",
                    "381",
                    "3833",
                    "385",
                    "387",
                    "388"
                ]
            ],
            [
                "Armenia",
                [
                    "asia",
                    "ex-ussr"
                ],
                "am",
                "374",
                ".. ......"
            ],
            [
                "Aruba",
                [
                    "america",
                    "carribean"
                ],
                "aw",
                "297"
            ],
            [
                "Australia",
                [
                    "oceania"
                ],
                "au",
                "61",
                "(..) .... ....",
                0,
                [
                    "2",
                    "3",
                    "4",
                    "7",
                    "8",
                    "02",
                    "03",
                    "04",
                    "07",
                    "08"
                ]
            ],
            [
                "Austria",
                [
                    "europe",
                    "eu-union"
                ],
                "at",
                "43"
            ],
            [
                "Azerbaijan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "az",
                "994",
                "(..) ... .. .."
            ],
            [
                "Bahamas",
                [
                    "america",
                    "carribean"
                ],
                "bs",
                "1242"
            ],
            [
                "Bahrain",
                [
                    "middle-east"
                ],
                "bh",
                "973"
            ],
            [
                "Bangladesh",
                [
                    "asia"
                ],
                "bd",
                "880"
            ],
            [
                "Barbados",
                [
                    "america",
                    "carribean"
                ],
                "bb",
                "1246"
            ],
            [
                "Belarus",
                [
                    "europe",
                    "ex-ussr"
                ],
                "by",
                "375",
                "(..) ... .. .."
            ],
            [
                "Belgium",
                [
                    "europe",
                    "eu-union"
                ],
                "be",
                "32",
                "... .. .. .."
            ],
            [
                "Belize",
                [
                    "america",
                    "central-america"
                ],
                "bz",
                "501"
            ],
            [
                "Benin",
                [
                    "africa"
                ],
                "bj",
                "229"
            ],
            [
                "Bhutan",
                [
                    "asia"
                ],
                "bt",
                "975"
            ],
            [
                "Bolivia",
                [
                    "america",
                    "south-america"
                ],
                "bo",
                "591"
            ],
            [
                "Bosnia and Herzegovina",
                [
                    "europe",
                    "ex-yugos"
                ],
                "ba",
                "387"
            ],
            [
                "Botswana",
                [
                    "africa"
                ],
                "bw",
                "267"
            ],
            [
                "Brazil",
                [
                    "america",
                    "south-america"
                ],
                "br",
                "55",
                "(..) ........."
            ],
            [
                "British Indian Ocean Territory",
                [
                    "asia"
                ],
                "io",
                "246"
            ],
            [
                "Brunei",
                [
                    "asia"
                ],
                "bn",
                "673"
            ],
            [
                "Bulgaria",
                [
                    "europe",
                    "eu-union"
                ],
                "bg",
                "359"
            ],
            [
                "Burkina Faso",
                [
                    "africa"
                ],
                "bf",
                "226"
            ],
            [
                "Burundi",
                [
                    "africa"
                ],
                "bi",
                "257"
            ],
            [
                "Cambodia",
                [
                    "asia"
                ],
                "kh",
                "855"
            ],
            [
                "Cameroon",
                [
                    "africa"
                ],
                "cm",
                "237"
            ],
            [
                "Canada",
                [
                    "america",
                    "north-america"
                ],
                "ca",
                "1",
                "(...) ...-....",
                1,
                [
                    "204",
                    "226",
                    "236",
                    "249",
                    "250",
                    "289",
                    "306",
                    "343",
                    "365",
                    "387",
                    "403",
                    "416",
                    "418",
                    "431",
                    "437",
                    "438",
                    "450",
                    "506",
                    "514",
                    "519",
                    "548",
                    "579",
                    "581",
                    "587",
                    "604",
                    "613",
                    "639",
                    "647",
                    "672",
                    "705",
                    "709",
                    "742",
                    "778",
                    "780",
                    "782",
                    "807",
                    "819",
                    "825",
                    "867",
                    "873",
                    "902",
                    "905"
                ]
            ],
            [
                "Cape Verde",
                [
                    "africa"
                ],
                "cv",
                "238"
            ],
            [
                "Caribbean Netherlands",
                [
                    "america",
                    "carribean"
                ],
                "bq",
                "599",
                "",
                1
            ],
            [
                "Central African Republic",
                [
                    "africa"
                ],
                "cf",
                "236"
            ],
            [
                "Chad",
                [
                    "africa"
                ],
                "td",
                "235"
            ],
            [
                "Chile",
                [
                    "america",
                    "south-america"
                ],
                "cl",
                "56"
            ],
            [
                "China",
                [
                    "asia"
                ],
                "cn",
                "86",
                "..-........."
            ],
            [
                "Colombia",
                [
                    "america",
                    "south-america"
                ],
                "co",
                "57",
                "... ... ...."
            ],
            [
                "Comoros",
                [
                    "africa"
                ],
                "km",
                "269"
            ],
            [
                "Congo",
                [
                    "africa"
                ],
                "cd",
                "243"
            ],
            [
                "Congo",
                [
                    "africa"
                ],
                "cg",
                "242"
            ],
            [
                "Costa Rica",
                [
                    "america",
                    "central-america"
                ],
                "cr",
                "506",
                "....-...."
            ],
            [
                "C\xf4te d\u2019Ivoire",
                [
                    "africa"
                ],
                "ci",
                "225",
                ".. .. .. .."
            ],
            [
                "Croatia",
                [
                    "europe",
                    "eu-union",
                    "ex-yugos"
                ],
                "hr",
                "385"
            ],
            [
                "Cuba",
                [
                    "america",
                    "carribean"
                ],
                "cu",
                "53"
            ],
            [
                "Cura\xe7ao",
                [
                    "america",
                    "carribean"
                ],
                "cw",
                "599",
                "",
                0
            ],
            [
                "Cyprus",
                [
                    "europe",
                    "eu-union"
                ],
                "cy",
                "357",
                ".. ......"
            ],
            [
                "Czech Republic",
                [
                    "europe",
                    "eu-union"
                ],
                "cz",
                "420",
                "... ... ..."
            ],
            [
                "Denmark",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "dk",
                "45",
                ".. .. .. .."
            ],
            [
                "Djibouti",
                [
                    "africa"
                ],
                "dj",
                "253"
            ],
            [
                "Dominica",
                [
                    "america",
                    "carribean"
                ],
                "dm",
                "1767"
            ],
            [
                "Dominican Republic",
                [
                    "america",
                    "carribean"
                ],
                "do",
                "1",
                "",
                2,
                [
                    "809",
                    "829",
                    "849"
                ]
            ],
            [
                "Ecuador",
                [
                    "america",
                    "south-america"
                ],
                "ec",
                "593"
            ],
            [
                "Egypt",
                [
                    "africa",
                    "north-africa"
                ],
                "eg",
                "20"
            ],
            [
                "El Salvador",
                [
                    "america",
                    "central-america"
                ],
                "sv",
                "503",
                "....-...."
            ],
            [
                "Equatorial Guinea",
                [
                    "africa"
                ],
                "gq",
                "240"
            ],
            [
                "Eritrea",
                [
                    "africa"
                ],
                "er",
                "291"
            ],
            [
                "Estonia",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "ee",
                "372",
                ".... ......"
            ],
            [
                "Ethiopia",
                [
                    "africa"
                ],
                "et",
                "251"
            ],
            [
                "Fiji",
                [
                    "oceania"
                ],
                "fj",
                "679"
            ],
            [
                "Finland",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "fi",
                "358",
                ".. ... .. .."
            ],
            [
                "France",
                [
                    "europe",
                    "eu-union"
                ],
                "fr",
                "33",
                ". .. .. .. .."
            ],
            [
                "French Guiana",
                [
                    "america",
                    "south-america"
                ],
                "gf",
                "594"
            ],
            [
                "French Polynesia",
                [
                    "oceania"
                ],
                "pf",
                "689"
            ],
            [
                "Gabon",
                [
                    "africa"
                ],
                "ga",
                "241"
            ],
            [
                "Gambia",
                [
                    "africa"
                ],
                "gm",
                "220"
            ],
            [
                "Georgia",
                [
                    "asia",
                    "ex-ussr"
                ],
                "ge",
                "995"
            ],
            [
                "Germany",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "de",
                "49",
                ".... ........"
            ],
            [
                "Ghana",
                [
                    "africa"
                ],
                "gh",
                "233"
            ],
            [
                "Greece",
                [
                    "europe",
                    "eu-union"
                ],
                "gr",
                "30"
            ],
            [
                "Grenada",
                [
                    "america",
                    "carribean"
                ],
                "gd",
                "1473"
            ],
            [
                "Guadeloupe",
                [
                    "america",
                    "carribean"
                ],
                "gp",
                "590",
                "",
                0
            ],
            [
                "Guam",
                [
                    "oceania"
                ],
                "gu",
                "1671"
            ],
            [
                "Guatemala",
                [
                    "america",
                    "central-america"
                ],
                "gt",
                "502",
                "....-...."
            ],
            [
                "Guinea",
                [
                    "africa"
                ],
                "gn",
                "224"
            ],
            [
                "Guinea-Bissau",
                [
                    "africa"
                ],
                "gw",
                "245"
            ],
            [
                "Guyana",
                [
                    "america",
                    "south-america"
                ],
                "gy",
                "592"
            ],
            [
                "Haiti",
                [
                    "america",
                    "carribean"
                ],
                "ht",
                "509",
                "....-...."
            ],
            [
                "Honduras",
                [
                    "america",
                    "central-america"
                ],
                "hn",
                "504"
            ],
            [
                "Hong Kong",
                [
                    "asia"
                ],
                "hk",
                "852",
                ".... ...."
            ],
            [
                "Hungary",
                [
                    "europe",
                    "eu-union"
                ],
                "hu",
                "36"
            ],
            [
                "Iceland",
                [
                    "europe"
                ],
                "is",
                "354",
                "... ...."
            ],
            [
                "India",
                [
                    "asia"
                ],
                "in",
                "91",
                ".....-....."
            ],
            [
                "Indonesia",
                [
                    "asia"
                ],
                "id",
                "62"
            ],
            [
                "Iran",
                [
                    "middle-east"
                ],
                "ir",
                "98",
                "... ... ...."
            ],
            [
                "Iraq",
                [
                    "middle-east"
                ],
                "iq",
                "964"
            ],
            [
                "Ireland",
                [
                    "europe",
                    "eu-union"
                ],
                "ie",
                "353",
                ".. ......."
            ],
            [
                "Israel",
                [
                    "middle-east"
                ],
                "il",
                "972",
                "... ... ...."
            ],
            [
                "Italy",
                [
                    "europe",
                    "eu-union"
                ],
                "it",
                "39",
                "... .......",
                0
            ],
            [
                "Jamaica",
                [
                    "america",
                    "carribean"
                ],
                "jm",
                "1876"
            ],
            [
                "Japan",
                [
                    "asia"
                ],
                "jp",
                "81",
                ".. .... ...."
            ],
            [
                "Jordan",
                [
                    "middle-east"
                ],
                "jo",
                "962"
            ],
            [
                "Kazakhstan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "kz",
                "7",
                "... ...-..-..",
                1,
                [
                    "310",
                    "311",
                    "312",
                    "313",
                    "315",
                    "318",
                    "321",
                    "324",
                    "325",
                    "326",
                    "327",
                    "336",
                    "7172",
                    "73622"
                ]
            ],
            [
                "Kenya",
                [
                    "africa"
                ],
                "ke",
                "254"
            ],
            [
                "Kiribati",
                [
                    "oceania"
                ],
                "ki",
                "686"
            ],
            [
                "Kosovo",
                [
                    "europe",
                    "ex-yugos"
                ],
                "xk",
                "383"
            ],
            [
                "Kuwait",
                [
                    "middle-east"
                ],
                "kw",
                "965"
            ],
            [
                "Kyrgyzstan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "kg",
                "996",
                "... ... ..."
            ],
            [
                "Laos",
                [
                    "asia"
                ],
                "la",
                "856"
            ],
            [
                "Latvia",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "lv",
                "371",
                ".. ... ..."
            ],
            [
                "Lebanon",
                [
                    "middle-east"
                ],
                "lb",
                "961"
            ],
            [
                "Lesotho",
                [
                    "africa"
                ],
                "ls",
                "266"
            ],
            [
                "Liberia",
                [
                    "africa"
                ],
                "lr",
                "231"
            ],
            [
                "Libya",
                [
                    "africa",
                    "north-africa"
                ],
                "ly",
                "218"
            ],
            [
                "Liechtenstein",
                [
                    "europe"
                ],
                "li",
                "423"
            ],
            [
                "Lithuania",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "lt",
                "370"
            ],
            [
                "Luxembourg",
                [
                    "europe",
                    "eu-union"
                ],
                "lu",
                "352"
            ],
            [
                "Macau",
                [
                    "asia"
                ],
                "mo",
                "853"
            ],
            [
                "Macedonia",
                [
                    "europe",
                    "ex-yugos"
                ],
                "mk",
                "389"
            ],
            [
                "Madagascar",
                [
                    "africa"
                ],
                "mg",
                "261"
            ],
            [
                "Malawi",
                [
                    "africa"
                ],
                "mw",
                "265"
            ],
            [
                "Malaysia",
                [
                    "asia"
                ],
                "my",
                "60",
                "..-....-...."
            ],
            [
                "Maldives",
                [
                    "asia"
                ],
                "mv",
                "960"
            ],
            [
                "Mali",
                [
                    "africa"
                ],
                "ml",
                "223"
            ],
            [
                "Malta",
                [
                    "europe",
                    "eu-union"
                ],
                "mt",
                "356"
            ],
            [
                "Marshall Islands",
                [
                    "oceania"
                ],
                "mh",
                "692"
            ],
            [
                "Martinique",
                [
                    "america",
                    "carribean"
                ],
                "mq",
                "596"
            ],
            [
                "Mauritania",
                [
                    "africa"
                ],
                "mr",
                "222"
            ],
            [
                "Mauritius",
                [
                    "africa"
                ],
                "mu",
                "230"
            ],
            [
                "Mexico",
                [
                    "america",
                    "central-america"
                ],
                "mx",
                "52",
                "... ... ....",
                0,
                [
                    "55",
                    "81",
                    "33",
                    "656",
                    "664",
                    "998",
                    "774",
                    "229"
                ]
            ],
            [
                "Micronesia",
                [
                    "oceania"
                ],
                "fm",
                "691"
            ],
            [
                "Moldova",
                [
                    "europe"
                ],
                "md",
                "373",
                "(..) ..-..-.."
            ],
            [
                "Monaco",
                [
                    "europe"
                ],
                "mc",
                "377"
            ],
            [
                "Mongolia",
                [
                    "asia"
                ],
                "mn",
                "976"
            ],
            [
                "Montenegro",
                [
                    "europe",
                    "ex-yugos"
                ],
                "me",
                "382"
            ],
            [
                "Morocco",
                [
                    "africa",
                    "north-africa"
                ],
                "ma",
                "212"
            ],
            [
                "Mozambique",
                [
                    "africa"
                ],
                "mz",
                "258"
            ],
            [
                "Myanmar",
                [
                    "asia"
                ],
                "mm",
                "95"
            ],
            [
                "Namibia",
                [
                    "africa"
                ],
                "na",
                "264"
            ],
            [
                "Nauru",
                [
                    "africa"
                ],
                "nr",
                "674"
            ],
            [
                "Nepal",
                [
                    "asia"
                ],
                "np",
                "977"
            ],
            [
                "Netherlands",
                [
                    "europe",
                    "eu-union"
                ],
                "nl",
                "31",
                ".. ........"
            ],
            [
                "New Caledonia",
                [
                    "oceania"
                ],
                "nc",
                "687"
            ],
            [
                "New Zealand",
                [
                    "oceania"
                ],
                "nz",
                "64",
                "...-...-...."
            ],
            [
                "Nicaragua",
                [
                    "america",
                    "central-america"
                ],
                "ni",
                "505"
            ],
            [
                "Niger",
                [
                    "africa"
                ],
                "ne",
                "227"
            ],
            [
                "Nigeria",
                [
                    "africa"
                ],
                "ng",
                "234"
            ],
            [
                "North Korea",
                [
                    "asia"
                ],
                "kp",
                "850"
            ],
            [
                "Norway",
                [
                    "europe",
                    "baltic"
                ],
                "no",
                "47",
                "... .. ..."
            ],
            [
                "Oman",
                [
                    "middle-east"
                ],
                "om",
                "968"
            ],
            [
                "Pakistan",
                [
                    "asia"
                ],
                "pk",
                "92",
                "...-......."
            ],
            [
                "Palau",
                [
                    "oceania"
                ],
                "pw",
                "680"
            ],
            [
                "Palestine",
                [
                    "middle-east"
                ],
                "ps",
                "970"
            ],
            [
                "Panama",
                [
                    "america",
                    "central-america"
                ],
                "pa",
                "507"
            ],
            [
                "Papua New Guinea",
                [
                    "oceania"
                ],
                "pg",
                "675"
            ],
            [
                "Paraguay",
                [
                    "america",
                    "south-america"
                ],
                "py",
                "595"
            ],
            [
                "Peru",
                [
                    "america",
                    "south-america"
                ],
                "pe",
                "51"
            ],
            [
                "Philippines",
                [
                    "asia"
                ],
                "ph",
                "63",
                ".... ......."
            ],
            [
                "Poland",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "pl",
                "48",
                "...-...-..."
            ],
            [
                "Portugal",
                [
                    "europe",
                    "eu-union"
                ],
                "pt",
                "351"
            ],
            [
                "Puerto Rico",
                [
                    "america",
                    "carribean"
                ],
                "pr",
                "1",
                "",
                3,
                [
                    "787",
                    "939"
                ]
            ],
            [
                "Qatar",
                [
                    "middle-east"
                ],
                "qa",
                "974"
            ],
            [
                "R\xe9union",
                [
                    "africa"
                ],
                "re",
                "262"
            ],
            [
                "Romania",
                [
                    "europe",
                    "eu-union"
                ],
                "ro",
                "40"
            ],
            [
                "Russia",
                [
                    "europe",
                    "asia",
                    "ex-ussr",
                    "baltic"
                ],
                "ru",
                "7",
                "(...) ...-..-..",
                0
            ],
            [
                "Rwanda",
                [
                    "africa"
                ],
                "rw",
                "250"
            ],
            [
                "Saint Kitts and Nevis",
                [
                    "america",
                    "carribean"
                ],
                "kn",
                "1869"
            ],
            [
                "Saint Lucia",
                [
                    "america",
                    "carribean"
                ],
                "lc",
                "1758"
            ],
            [
                "Saint Vincent and the Grenadines",
                [
                    "america",
                    "carribean"
                ],
                "vc",
                "1784"
            ],
            [
                "Samoa",
                [
                    "oceania"
                ],
                "ws",
                "685"
            ],
            [
                "San Marino",
                [
                    "europe"
                ],
                "sm",
                "378"
            ],
            [
                "S\xe3o Tom\xe9 and Pr\xedncipe",
                [
                    "africa"
                ],
                "st",
                "239"
            ],
            [
                "Saudi Arabia",
                [
                    "middle-east"
                ],
                "sa",
                "966"
            ],
            [
                "Senegal",
                [
                    "africa"
                ],
                "sn",
                "221"
            ],
            [
                "Serbia",
                [
                    "europe",
                    "ex-yugos"
                ],
                "rs",
                "381"
            ],
            [
                "Seychelles",
                [
                    "africa"
                ],
                "sc",
                "248"
            ],
            [
                "Sierra Leone",
                [
                    "africa"
                ],
                "sl",
                "232"
            ],
            [
                "Singapore",
                [
                    "asia"
                ],
                "sg",
                "65",
                "....-...."
            ],
            [
                "Slovakia",
                [
                    "europe",
                    "eu-union"
                ],
                "sk",
                "421"
            ],
            [
                "Slovenia",
                [
                    "europe",
                    "eu-union",
                    "ex-yugos"
                ],
                "si",
                "386"
            ],
            [
                "Solomon Islands",
                [
                    "oceania"
                ],
                "sb",
                "677"
            ],
            [
                "Somalia",
                [
                    "africa"
                ],
                "so",
                "252"
            ],
            [
                "South Africa",
                [
                    "africa"
                ],
                "za",
                "27"
            ],
            [
                "South Korea",
                [
                    "asia"
                ],
                "kr",
                "82",
                "... .... ...."
            ],
            [
                "South Sudan",
                [
                    "africa",
                    "north-africa"
                ],
                "ss",
                "211"
            ],
            [
                "Spain",
                [
                    "europe",
                    "eu-union"
                ],
                "es",
                "34",
                "... ... ..."
            ],
            [
                "Sri Lanka",
                [
                    "asia"
                ],
                "lk",
                "94"
            ],
            [
                "Sudan",
                [
                    "africa"
                ],
                "sd",
                "249"
            ],
            [
                "Suriname",
                [
                    "america",
                    "south-america"
                ],
                "sr",
                "597"
            ],
            [
                "Swaziland",
                [
                    "africa"
                ],
                "sz",
                "268"
            ],
            [
                "Sweden",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "se",
                "46",
                "(...) ...-..."
            ],
            [
                "Switzerland",
                [
                    "europe"
                ],
                "ch",
                "41",
                ".. ... .. .."
            ],
            [
                "Syria",
                [
                    "middle-east"
                ],
                "sy",
                "963"
            ],
            [
                "Taiwan",
                [
                    "asia"
                ],
                "tw",
                "886"
            ],
            [
                "Tajikistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "tj",
                "992"
            ],
            [
                "Tanzania",
                [
                    "africa"
                ],
                "tz",
                "255"
            ],
            [
                "Thailand",
                [
                    "asia"
                ],
                "th",
                "66"
            ],
            [
                "Timor-Leste",
                [
                    "asia"
                ],
                "tl",
                "670"
            ],
            [
                "Togo",
                [
                    "africa"
                ],
                "tg",
                "228"
            ],
            [
                "Tonga",
                [
                    "oceania"
                ],
                "to",
                "676"
            ],
            [
                "Trinidad and Tobago",
                [
                    "america",
                    "carribean"
                ],
                "tt",
                "1868"
            ],
            [
                "Tunisia",
                [
                    "africa",
                    "north-africa"
                ],
                "tn",
                "216"
            ],
            [
                "Turkey",
                [
                    "europe"
                ],
                "tr",
                "90",
                "... ... .. .."
            ],
            [
                "Turkmenistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "tm",
                "993"
            ],
            [
                "Tuvalu",
                [
                    "asia"
                ],
                "tv",
                "688"
            ],
            [
                "Uganda",
                [
                    "africa"
                ],
                "ug",
                "256"
            ],
            [
                "Ukraine",
                [
                    "europe",
                    "ex-ussr"
                ],
                "ua",
                "380",
                "(..) ... .. .."
            ],
            [
                "United Arab Emirates",
                [
                    "middle-east"
                ],
                "ae",
                "971"
            ],
            [
                "United Kingdom",
                [
                    "europe",
                    "eu-union"
                ],
                "gb",
                "44",
                ".... ......"
            ],
            [
                "United States",
                [
                    "america",
                    "north-america"
                ],
                "us",
                "1",
                "(...) ...-....",
                0,
                [
                    "907",
                    "205",
                    "251",
                    "256",
                    "334",
                    "479",
                    "501",
                    "870",
                    "480",
                    "520",
                    "602",
                    "623",
                    "928",
                    "209",
                    "213",
                    "310",
                    "323",
                    "408",
                    "415",
                    "510",
                    "530",
                    "559",
                    "562",
                    "619",
                    "626",
                    "650",
                    "661",
                    "707",
                    "714",
                    "760",
                    "805",
                    "818",
                    "831",
                    "858",
                    "909",
                    "916",
                    "925",
                    "949",
                    "951",
                    "303",
                    "719",
                    "970",
                    "203",
                    "860",
                    "202",
                    "302",
                    "239",
                    "305",
                    "321",
                    "352",
                    "386",
                    "407",
                    "561",
                    "727",
                    "772",
                    "813",
                    "850",
                    "863",
                    "904",
                    "941",
                    "954",
                    "229",
                    "404",
                    "478",
                    "706",
                    "770",
                    "912",
                    "808",
                    "319",
                    "515",
                    "563",
                    "641",
                    "712",
                    "208",
                    "217",
                    "309",
                    "312",
                    "618",
                    "630",
                    "708",
                    "773",
                    "815",
                    "847",
                    "219",
                    "260",
                    "317",
                    "574",
                    "765",
                    "812",
                    "316",
                    "620",
                    "785",
                    "913",
                    "270",
                    "502",
                    "606",
                    "859",
                    "225",
                    "318",
                    "337",
                    "504",
                    "985",
                    "413",
                    "508",
                    "617",
                    "781",
                    "978",
                    "301",
                    "410",
                    "207",
                    "231",
                    "248",
                    "269",
                    "313",
                    "517",
                    "586",
                    "616",
                    "734",
                    "810",
                    "906",
                    "989",
                    "218",
                    "320",
                    "507",
                    "612",
                    "651",
                    "763",
                    "952",
                    "314",
                    "417",
                    "573",
                    "636",
                    "660",
                    "816",
                    "228",
                    "601",
                    "662",
                    "406",
                    "252",
                    "336",
                    "704",
                    "828",
                    "910",
                    "919",
                    "701",
                    "308",
                    "402",
                    "603",
                    "201",
                    "609",
                    "732",
                    "856",
                    "908",
                    "973",
                    "505",
                    "575",
                    "702",
                    "775",
                    "212",
                    "315",
                    "516",
                    "518",
                    "585",
                    "607",
                    "631",
                    "716",
                    "718",
                    "845",
                    "914",
                    "216",
                    "330",
                    "419",
                    "440",
                    "513",
                    "614",
                    "740",
                    "937",
                    "405",
                    "580",
                    "918",
                    "503",
                    "541",
                    "215",
                    "412",
                    "570",
                    "610",
                    "717",
                    "724",
                    "814",
                    "401",
                    "803",
                    "843",
                    "864",
                    "605",
                    "423",
                    "615",
                    "731",
                    "865",
                    "901",
                    "931",
                    "210",
                    "214",
                    "254",
                    "281",
                    "325",
                    "361",
                    "409",
                    "432",
                    "512",
                    "713",
                    "806",
                    "817",
                    "830",
                    "903",
                    "915",
                    "936",
                    "940",
                    "956",
                    "972",
                    "979",
                    "435",
                    "801",
                    "276",
                    "434",
                    "540",
                    "703",
                    "757",
                    "804",
                    "802",
                    "206",
                    "253",
                    "360",
                    "425",
                    "509",
                    "262",
                    "414",
                    "608",
                    "715",
                    "920",
                    "304",
                    "307"
                ]
            ],
            [
                "Uruguay",
                [
                    "america",
                    "south-america"
                ],
                "uy",
                "598"
            ],
            [
                "Uzbekistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "uz",
                "998",
                ".. ... .. .."
            ],
            [
                "Vanuatu",
                [
                    "oceania"
                ],
                "vu",
                "678"
            ],
            [
                "Vatican City",
                [
                    "europe"
                ],
                "va",
                "39",
                ".. .... ....",
                1
            ],
            [
                "Venezuela",
                [
                    "america",
                    "south-america"
                ],
                "ve",
                "58"
            ],
            [
                "Vietnam",
                [
                    "asia"
                ],
                "vn",
                "84"
            ],
            [
                "Yemen",
                [
                    "middle-east"
                ],
                "ye",
                "967"
            ],
            [
                "Zambia",
                [
                    "africa"
                ],
                "zm",
                "260"
            ],
            [
                "Zimbabwe",
                [
                    "africa"
                ],
                "zw",
                "263"
            ]
        ], E = [
            [
                "American Samoa",
                [
                    "oceania"
                ],
                "as",
                "1684"
            ],
            [
                "Anguilla",
                [
                    "america",
                    "carribean"
                ],
                "ai",
                "1264"
            ],
            [
                "Bermuda",
                [
                    "america",
                    "north-america"
                ],
                "bm",
                "1441"
            ],
            [
                "British Virgin Islands",
                [
                    "america",
                    "carribean"
                ],
                "vg",
                "1284"
            ],
            [
                "Cayman Islands",
                [
                    "america",
                    "carribean"
                ],
                "ky",
                "1345"
            ],
            [
                "Cook Islands",
                [
                    "oceania"
                ],
                "ck",
                "682"
            ],
            [
                "Falkland Islands",
                [
                    "america",
                    "south-america"
                ],
                "fk",
                "500"
            ],
            [
                "Faroe Islands",
                [
                    "europe"
                ],
                "fo",
                "298"
            ],
            [
                "Gibraltar",
                [
                    "europe"
                ],
                "gi",
                "350"
            ],
            [
                "Greenland",
                [
                    "america"
                ],
                "gl",
                "299"
            ],
            [
                "Jersey",
                [
                    "europe",
                    "eu-union"
                ],
                "je",
                "44",
                ".... ......"
            ],
            [
                "Montserrat",
                [
                    "america",
                    "carribean"
                ],
                "ms",
                "1664"
            ],
            [
                "Niue",
                [
                    "asia"
                ],
                "nu",
                "683"
            ],
            [
                "Norfolk Island",
                [
                    "oceania"
                ],
                "nf",
                "672"
            ],
            [
                "Northern Mariana Islands",
                [
                    "oceania"
                ],
                "mp",
                "1670"
            ],
            [
                "Saint Barth\xe9lemy",
                [
                    "america",
                    "carribean"
                ],
                "bl",
                "590",
                "",
                1
            ],
            [
                "Saint Helena",
                [
                    "africa"
                ],
                "sh",
                "290"
            ],
            [
                "Saint Martin",
                [
                    "america",
                    "carribean"
                ],
                "mf",
                "590",
                "",
                2
            ],
            [
                "Saint Pierre and Miquelon",
                [
                    "america",
                    "north-america"
                ],
                "pm",
                "508"
            ],
            [
                "Sint Maarten",
                [
                    "america",
                    "carribean"
                ],
                "sx",
                "1721"
            ],
            [
                "Tokelau",
                [
                    "oceania"
                ],
                "tk",
                "690"
            ],
            [
                "Turks and Caicos Islands",
                [
                    "america",
                    "carribean"
                ],
                "tc",
                "1649"
            ],
            [
                "U.S. Virgin Islands",
                [
                    "america",
                    "carribean"
                ],
                "vi",
                "1340"
            ],
            [
                "Wallis and Futuna",
                [
                    "oceania"
                ],
                "wf",
                "681"
            ]
        ];
        function T(e, t, r, n, a) {
            return !r || a ? e + "".padEnd(t.length, ".") + " " + n : e + "".padEnd(t.length, ".") + " " + r;
        }
        function I(e, t, r, a, i) {
            var u, c, s = [];
            return c = !0 === t, [
                (u = []).concat.apply(u, o(e.map(function(e) {
                    var o = {
                        name: e[0],
                        regions: e[1],
                        iso2: e[2],
                        countryCode: e[3],
                        dialCode: e[3],
                        format: T(r, e[3], e[4], a, i),
                        priority: e[5] || 0
                    }, u = [];
                    return e[6] && e[6].map(function(t) {
                        var r = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {}, a = Object.keys(r);
                                "function" == typeof Object.getOwnPropertySymbols && (a = a.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
                                    return Object.getOwnPropertyDescriptor(r, e).enumerable;
                                }))), a.forEach(function(t) {
                                    n(e, t, r[t]);
                                });
                            }
                            return e;
                        }({}, o);
                        r.dialCode = e[3] + t, r.isAreaCode = !0, r.areaCodeLength = t.length, u.push(r);
                    }), u.length > 0 ? (o.mainCode = !0, c || "Array" === t.constructor.name && t.includes(e[2]) ? (o.hasAreaCodes = !0, [
                        o
                    ].concat(u)) : (s = s.concat(u), [
                        o
                    ])) : [
                        o
                    ];
                }))),
                s
            ];
        }
        function A(e, t, r, n) {
            if (null !== r) {
                var a = Object.keys(r), o = Object.values(r);
                a.forEach(function(r, a) {
                    if (n) return e.push([
                        r,
                        o[a]
                    ]);
                    var i = e.findIndex(function(e) {
                        return e[0] === r;
                    });
                    if (-1 === i) {
                        var u = [
                            r
                        ];
                        u[t] = o[a], e.push(u);
                    } else e[i][t] = o[a];
                });
            }
        }
        function D(e, t) {
            return 0 === t.length ? e : e.map(function(e) {
                var r = t.findIndex(function(t) {
                    return t[0] === e[2];
                });
                if (-1 === r) return e;
                var n = t[r];
                return n[1] && (e[4] = n[1]), n[3] && (e[5] = n[3]), n[2] && (e[6] = n[2]), e;
            });
        }
        var P = function e(t, r, n, a, i, u, s, l, f, d, p, h, m, y) {
            c(this, e), this.filterRegions = function(e, t) {
                if ("string" == typeof e) {
                    var r = e;
                    return t.filter(function(e) {
                        return e.regions.some(function(e) {
                            return e === r;
                        });
                    });
                }
                return t.filter(function(t) {
                    return e.map(function(e) {
                        return t.regions.some(function(t) {
                            return t === e;
                        });
                    }).some(function(e) {
                        return e;
                    });
                });
            }, this.sortTerritories = function(e, t) {
                var r = [].concat(o(e), o(t));
                return r.sort(function(e, t) {
                    return e.name < t.name ? -1 : e.name > t.name ? 1 : 0;
                }), r;
            }, this.getFilteredCountryList = function(e, t, r) {
                return 0 === e.length ? t : r ? e.map(function(e) {
                    var r = t.find(function(t) {
                        return t.iso2 === e;
                    });
                    if (r) return r;
                }).filter(function(e) {
                    return e;
                }) : t.filter(function(t) {
                    return e.some(function(e) {
                        return e === t.iso2;
                    });
                });
            }, this.localizeCountries = function(e, t, r) {
                for(var n = 0; n < e.length; n++)void 0 !== t[e[n].iso2] ? e[n].localName = t[e[n].iso2] : void 0 !== t[e[n].name] && (e[n].localName = t[e[n].name]);
                return r || e.sort(function(e, t) {
                    return e.localName < t.localName ? -1 : e.localName > t.localName ? 1 : 0;
                }), e;
            }, this.getCustomAreas = function(e, t) {
                for(var r = [], n = 0; n < t.length; n++){
                    var a = JSON.parse(JSON.stringify(e));
                    a.dialCode += t[n], r.push(a);
                }
                return r;
            }, this.excludeCountries = function(e, t) {
                return 0 === t.length ? e : e.filter(function(e) {
                    return !t.includes(e.iso2);
                });
            };
            var b = function(_e1, t, r) {
                var n = [];
                return A(n, 1, _e1, !0), A(n, 3, t), A(n, 2, r), n;
            }(l, f, d), g = D(JSON.parse(JSON.stringify(k)), b), v = D(JSON.parse(JSON.stringify(E)), b), C = O(I(g, t, h, m, y), 2), _ = C[0], w = C[1];
            if (r) {
                var S = O(I(v, t, h, m, y), 2), j = S[0];
                S[1];
                _ = this.sortTerritories(j, _);
            }
            n && (_ = this.filterRegions(n, _)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(a, _, s.includes("onlyCountries")), u), p, s.includes("onlyCountries")), this.preferredCountries = 0 === i.length ? [] : this.localizeCountries(this.getFilteredCountryList(i, _, s.includes("preferredCountries")), p, s.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(a, w), u);
        }, F = function(e) {
            function t(e) {
                var r;
                c(this, t), (r = function(e, t) {
                    return !t || "object" !== f(t) && "function" != typeof t ? d(e) : t;
                }(this, p(t).call(this, e))).getProbableCandidate = C()(function(e) {
                    return e && 0 !== e.length ? r.state.onlyCountries.filter(function(t) {
                        return j()(t.name.toLowerCase(), e.toLowerCase());
                    }, d(d(r)))[0] : null;
                }), r.guessSelectedCountry = C()(function(e, t, n, a) {
                    var o;
                    if (!1 === r.props.enableAreaCodes && (a.some(function(t) {
                        if (j()(e, t.dialCode)) return n.some(function(e) {
                            if (t.iso2 === e.iso2 && e.mainCode) return o = e, !0;
                        }), !0;
                    }), o)) return o;
                    var i = n.find(function(e) {
                        return e.iso2 == t;
                    });
                    if ("" === e.trim()) return i;
                    var u = n.reduce(function(t, r) {
                        if (j()(e, r.dialCode)) {
                            if (r.dialCode.length > t.dialCode.length) return r;
                            if (r.dialCode.length === t.dialCode.length && r.priority < t.priority) return r;
                        }
                        return t;
                    }, {
                        dialCode: "",
                        priority: 10001
                    }, d(d(r)));
                    return u.name ? u : i;
                }), r.updateCountry = function(e) {
                    var t, n = r.state.onlyCountries;
                    (t = e.indexOf(0) >= "0" && e.indexOf(0) <= "9" ? n.find(function(t) {
                        return t.dialCode == +e;
                    }) : n.find(function(t) {
                        return t.iso2 == e;
                    })) && t.dialCode && r.setState({
                        selectedCountry: t,
                        formattedNumber: r.props.disableCountryCode ? "" : r.formatNumber(t.dialCode, t)
                    });
                }, r.scrollTo = function(e, t) {
                    if (e) {
                        var n = r.dropdownRef;
                        if (n && document.body) {
                            var a = n.offsetHeight, o = n.getBoundingClientRect().top + document.body.scrollTop, i = o + a, u = e, c = u.getBoundingClientRect(), s = u.offsetHeight, l = c.top + document.body.scrollTop, f = l + s, d = l - o + n.scrollTop, p = a / 2 - s / 2;
                            if (r.props.enableSearch ? l < o + 32 : l < o) t && (d -= p), n.scrollTop = d;
                            else if (f > i) {
                                t && (d += p);
                                var h = a - s;
                                n.scrollTop = d - h;
                            }
                        }
                    }
                }, r.scrollToTop = function() {
                    var e = r.dropdownRef;
                    e && document.body && (e.scrollTop = 0);
                }, r.formatNumber = function(e, t) {
                    if (!t) return e;
                    var n, o = t.format, c = r.props, s = c.disableCountryCode, l = c.enableAreaCodeStretch, f = c.enableLongNumbers, d = c.autoFormat;
                    if (s ? ((n = o.split(" ")).shift(), n = n.join(" ")) : l && t.isAreaCode ? ((n = o.split(" "))[1] = n[1].replace(/\.+/, "".padEnd(t.areaCodeLength, ".")), n = n.join(" ")) : n = o, !e || 0 === e.length) return s ? "" : r.props.prefix;
                    if (e && e.length < 2 || !n || !d) return s ? e : r.props.prefix + e;
                    var p, h = w()(n, function(e, t) {
                        if (0 === e.remainingText.length) return e;
                        if ("." !== t) return {
                            formattedText: e.formattedText + t,
                            remainingText: e.remainingText
                        };
                        var r, n = i(r = e.remainingText) || a(r) || u(), o = n[0], c = n.slice(1);
                        return {
                            formattedText: e.formattedText + o,
                            remainingText: c
                        };
                    }, {
                        formattedText: "",
                        remainingText: e.split("")
                    });
                    return (p = f ? h.formattedText + h.remainingText.join("") : h.formattedText).includes("(") && !p.includes(")") && (p += ")"), p;
                }, r.cursorToEnd = function() {
                    var e = r.numberInputRef;
                    if (document.activeElement === e) {
                        e.focus();
                        var t = e.value.length;
                        ")" === e.value.charAt(t - 1) && (t -= 1), e.setSelectionRange(t, t);
                    }
                }, r.getElement = function(e) {
                    return r["flag_no_".concat(e)];
                }, r.getCountryData = function() {
                    return r.state.selectedCountry ? {
                        name: r.state.selectedCountry.name || "",
                        dialCode: r.state.selectedCountry.dialCode || "",
                        countryCode: r.state.selectedCountry.iso2 || "",
                        format: r.state.selectedCountry.format || ""
                    } : {};
                }, r.handleFlagDropdownClick = function(e) {
                    if (e.preventDefault(), r.state.showDropdown || !r.props.disabled) {
                        var t = r.state, n = t.preferredCountries, a = t.onlyCountries, o = t.selectedCountry, i = r.concatPreferredCountries(n, a).findIndex(function(e) {
                            return e.dialCode === o.dialCode && e.iso2 === o.iso2;
                        });
                        r.setState({
                            showDropdown: !r.state.showDropdown,
                            highlightCountryIndex: i
                        }, function() {
                            r.state.showDropdown && r.scrollTo(r.getElement(r.state.highlightCountryIndex));
                        });
                    }
                }, r.handleInput = function(e) {
                    var t = e.target.value, n = r.props, a = n.prefix, o = n.onChange, i = r.props.disableCountryCode ? "" : a, u = r.state.selectedCountry, c = r.state.freezeSelection;
                    if (!r.props.countryCodeEditable) {
                        var s = a + (u.hasAreaCodes ? r.state.onlyCountries.find(function(e) {
                            return e.iso2 === u.iso2 && e.mainCode;
                        }).dialCode : u.dialCode);
                        if (t.slice(0, s.length) !== s) return;
                    }
                    if (t === a) return o && o("", r.getCountryData(), e, ""), r.setState({
                        formattedNumber: ""
                    });
                    if (t.replace(/\D/g, "").length > 15) {
                        if (!1 === r.props.enableLongNumbers) return;
                        if ("number" == typeof r.props.enableLongNumbers && t.replace(/\D/g, "").length > r.props.enableLongNumbers) return;
                    }
                    if (t !== r.state.formattedNumber) {
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var l = r.props.country, f = r.state, d = f.onlyCountries, p = f.selectedCountry, h = f.hiddenAreaCodes;
                        if (o && e.persist(), t.length > 0) {
                            var m = t.replace(/\D/g, "");
                            (!r.state.freezeSelection || p && p.dialCode.length > m.length) && (u = r.props.disableCountryGuess ? p : r.guessSelectedCountry(m.substring(0, 6), l, d, h) || p, c = !1), i = r.formatNumber(m, u), u = u.dialCode ? u : p;
                        }
                        var y = e.target.selectionStart, b = e.target.selectionStart, g = r.state.formattedNumber, v = i.length - g.length;
                        r.setState({
                            formattedNumber: i,
                            freezeSelection: c,
                            selectedCountry: u
                        }, function() {
                            v > 0 && (b -= v), ")" == i.charAt(i.length - 1) ? r.numberInputRef.setSelectionRange(i.length - 1, i.length - 1) : b > 0 && g.length >= i.length ? r.numberInputRef.setSelectionRange(b, b) : y < g.length && r.numberInputRef.setSelectionRange(y, y), o && o(i.replace(/[^0-9]+/g, ""), r.getCountryData(), e, i);
                        });
                    }
                }, r.handleInputClick = function(e) {
                    r.setState({
                        showDropdown: !1
                    }), r.props.onClick && r.props.onClick(e, r.getCountryData());
                }, r.handleDoubleClick = function(e) {
                    var t = e.target.value.length;
                    e.target.setSelectionRange(0, t);
                }, r.handleFlagItemClick = function(e, t) {
                    var n = r.state.selectedCountry, a = r.state.onlyCountries.find(function(t) {
                        return t == e;
                    });
                    if (a) {
                        var o = r.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), i = o.length > 1 ? o.replace(n.dialCode, a.dialCode) : a.dialCode, u = r.formatNumber(i.replace(/\D/g, ""), a);
                        r.setState({
                            showDropdown: !1,
                            selectedCountry: a,
                            freezeSelection: !0,
                            formattedNumber: u,
                            searchValue: ""
                        }, function() {
                            r.cursorToEnd(), r.props.onChange && r.props.onChange(u.replace(/[^0-9]+/g, ""), r.getCountryData(), t, u);
                        });
                    }
                }, r.handleInputFocus = function(e) {
                    r.numberInputRef && r.numberInputRef.value === r.props.prefix && r.state.selectedCountry && !r.props.disableCountryCode && r.setState({
                        formattedNumber: r.props.prefix + r.state.selectedCountry.dialCode
                    }, function() {
                        r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
                    }), r.setState({
                        placeholder: ""
                    }), r.props.onFocus && r.props.onFocus(e, r.getCountryData()), r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
                }, r.handleInputBlur = function(e) {
                    e.target.value || r.setState({
                        placeholder: r.props.placeholder
                    }), r.props.onBlur && r.props.onBlur(e, r.getCountryData());
                }, r.handleInputCopy = function(e) {
                    if (r.props.copyNumbersOnly) {
                        var t = window.getSelection().toString().replace(/[^0-9]+/g, "");
                        e.clipboardData.setData("text/plain", t), e.preventDefault();
                    }
                }, r.getHighlightCountryIndex = function(e) {
                    var t = r.state.highlightCountryIndex + e;
                    return t < 0 || t >= r.state.onlyCountries.length + r.state.preferredCountries.length ? t - e : r.props.enableSearch && t > r.getSearchFilteredCountries().length ? 0 : t;
                }, r.searchCountry = function() {
                    var e = r.getProbableCandidate(r.state.queryString) || r.state.onlyCountries[0], t = r.state.onlyCountries.findIndex(function(t) {
                        return t == e;
                    }) + r.state.preferredCountries.length;
                    r.scrollTo(r.getElement(t), !0), r.setState({
                        queryString: "",
                        highlightCountryIndex: t
                    });
                }, r.handleKeydown = function(e) {
                    var t = r.props.keys, n = e.target.className;
                    if (n.includes("selected-flag") && e.which === t.ENTER && !r.state.showDropdown) return r.handleFlagDropdownClick(e);
                    if (n.includes("form-control") && (e.which === t.ENTER || e.which === t.ESC)) return e.target.blur();
                    if (r.state.showDropdown && !r.props.disabled && (!n.includes("search-box") || e.which === t.UP || e.which === t.DOWN || e.which === t.ENTER || e.which === t.ESC && "" === e.target.value)) {
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var a = function(e) {
                            r.setState({
                                highlightCountryIndex: r.getHighlightCountryIndex(e)
                            }, function() {
                                r.scrollTo(r.getElement(r.state.highlightCountryIndex), !0);
                            });
                        };
                        switch(e.which){
                            case t.DOWN:
                                a(1);
                                break;
                            case t.UP:
                                a(-1);
                                break;
                            case t.ENTER:
                                r.props.enableSearch ? r.handleFlagItemClick(r.getSearchFilteredCountries()[r.state.highlightCountryIndex] || r.getSearchFilteredCountries()[0], e) : r.handleFlagItemClick([].concat(o(r.state.preferredCountries), o(r.state.onlyCountries))[r.state.highlightCountryIndex], e);
                                break;
                            case t.ESC:
                            case t.TAB:
                                r.setState({
                                    showDropdown: !1
                                }, r.cursorToEnd);
                                break;
                            default:
                                (e.which >= t.A && e.which <= t.Z || e.which === t.SPACE) && r.setState({
                                    queryString: r.state.queryString + String.fromCharCode(e.which)
                                }, r.state.debouncedQueryStingSearcher);
                        }
                    }
                }, r.handleInputKeyDown = function(e) {
                    var t = r.props, n = t.keys, a = t.onEnterKeyPress, o = t.onKeyDown;
                    e.which === n.ENTER && a && a(e), o && o(e);
                }, r.handleClickOutside = function(e) {
                    r.dropdownRef && !r.dropdownContainerRef.contains(e.target) && r.state.showDropdown && r.setState({
                        showDropdown: !1
                    });
                }, r.handleSearchChange = function(e) {
                    var t = e.currentTarget.value, n = r.state, a = n.preferredCountries, o = n.selectedCountry, i = 0;
                    if ("" === t && o) {
                        var u = r.state.onlyCountries;
                        i = r.concatPreferredCountries(a, u).findIndex(function(e) {
                            return e == o;
                        }), setTimeout(function() {
                            return r.scrollTo(r.getElement(i));
                        }, 100);
                    }
                    r.setState({
                        searchValue: t,
                        highlightCountryIndex: i
                    });
                }, r.concatPreferredCountries = function(e, t) {
                    return e.length > 0 ? o(new Set(e.concat(t))) : t;
                }, r.getDropdownCountryName = function(e) {
                    return e.localName || e.name;
                }, r.getSearchFilteredCountries = function() {
                    var e = r.state, t = e.preferredCountries, n = e.onlyCountries, a = e.searchValue, i = r.props.enableSearch, u = r.concatPreferredCountries(t, n), c = a.trim().toLowerCase().replace("+", "");
                    if (i && c) {
                        if (/^\d+$/.test(c)) return u.filter(function(e) {
                            var t = e.dialCode;
                            return [
                                "".concat(t)
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        });
                        var s = u.filter(function(e) {
                            var t = e.iso2;
                            return [
                                "".concat(t)
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        }), l = u.filter(function(e) {
                            var t = e.name, r = e.localName;
                            e.iso2;
                            return [
                                "".concat(t),
                                "".concat(r || "")
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        });
                        return r.scrollToTop(), o(new Set([].concat(s, l)));
                    }
                    return u;
                }, r.getCountryDropdownList = function() {
                    var e = r.state, t = e.preferredCountries, a = e.highlightCountryIndex, o = e.showDropdown, i = e.searchValue, u = r.props, c = u.disableDropdown, s = u.prefix, l = r.props, f = l.enableSearch, d = l.searchNotFound, p = l.disableSearchIcon, h = l.searchClass, m = l.searchStyle, b = l.searchPlaceholder, g = l.autocompleteSearch, v = r.getSearchFilteredCountries().map(function(e, t) {
                        var n = a === t, o = N()({
                            country: !0,
                            preferred: "us" === e.iso2 || "gb" === e.iso2,
                            active: "us" === e.iso2,
                            highlight: n
                        }), i = "flag ".concat(e.iso2);
                        return y.a.createElement("li", Object.assign({
                            ref: function(e) {
                                return r["flag_no_".concat(t)] = e;
                            },
                            key: "flag_no_".concat(t),
                            "data-flag-key": "flag_no_".concat(t),
                            className: o,
                            "data-dial-code": "1",
                            tabIndex: c ? "-1" : "0",
                            "data-country-code": e.iso2,
                            onClick: function(t) {
                                return r.handleFlagItemClick(e, t);
                            },
                            role: "option"
                        }, n ? {
                            "aria-selected": !0
                        } : {}), y.a.createElement("div", {
                            className: i
                        }), y.a.createElement("span", {
                            className: "country-name"
                        }, r.getDropdownCountryName(e)), y.a.createElement("span", {
                            className: "dial-code"
                        }, e.format ? r.formatNumber(e.dialCode, e) : s + e.dialCode));
                    }), C = y.a.createElement("li", {
                        key: "dashes",
                        className: "divider"
                    });
                    t.length > 0 && (!f || f && !i.trim()) && v.splice(t.length, 0, C);
                    var _ = N()(n({
                        "country-list": !0,
                        hide: !o
                    }, r.props.dropdownClass, !0));
                    return y.a.createElement("ul", {
                        ref: function(e) {
                            return !f && e && e.focus(), r.dropdownRef = e;
                        },
                        className: _,
                        style: r.props.dropdownStyle,
                        role: "listbox",
                        tabIndex: "0"
                    }, f && y.a.createElement("li", {
                        className: N()(n({
                            search: !0
                        }, h, h))
                    }, !p && y.a.createElement("span", {
                        className: N()(n({
                            "search-emoji": !0
                        }, "".concat(h, "-emoji"), h)),
                        role: "img",
                        "aria-label": "Magnifying glass"
                    }, "\uD83D\uDD0E"), y.a.createElement("input", {
                        className: N()(n({
                            "search-box": !0
                        }, "".concat(h, "-box"), h)),
                        style: m,
                        type: "search",
                        placeholder: b,
                        autoFocus: !0,
                        autoComplete: g ? "on" : "off",
                        value: i,
                        onChange: r.handleSearchChange
                    })), v.length > 0 ? v : y.a.createElement("li", {
                        className: "no-entries-message"
                    }, y.a.createElement("span", null, d)));
                };
                var s, l = new P(e.enableAreaCodes, e.enableTerritories, e.regions, e.onlyCountries, e.preferredCountries, e.excludeCountries, e.preserveOrder, e.masks, e.priority, e.areaCodes, e.localization, e.prefix, e.defaultMask, e.alwaysDefaultMask), h = l.onlyCountries, m = l.preferredCountries, b = l.hiddenAreaCodes, v = e.value ? e.value.replace(/\D/g, "") : "";
                s = e.disableInitialCountryGuess ? 0 : v.length > 1 ? r.guessSelectedCountry(v.substring(0, 6), e.country, h, b) || 0 : e.country && h.find(function(t) {
                    return t.iso2 == e.country;
                }) || 0;
                var _, S = v.length < 2 && s && !j()(v, s.dialCode) ? s.dialCode : "";
                _ = "" === v && 0 === s ? "" : r.formatNumber((e.disableCountryCode ? "" : S) + v, s.name ? s : void 0);
                var x = h.findIndex(function(e) {
                    return e == s;
                });
                return r.state = {
                    showDropdown: e.showDropdown,
                    formattedNumber: _,
                    onlyCountries: h,
                    preferredCountries: m,
                    hiddenAreaCodes: b,
                    selectedCountry: s,
                    highlightCountryIndex: x,
                    queryString: "",
                    freezeSelection: !1,
                    debouncedQueryStingSearcher: g()(r.searchCountry, 250),
                    searchValue: ""
                }, r;
            }
            var r, l, m;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && h(e, t);
            }(t, e), r = t, l = [
                {
                    key: "componentDidMount",
                    value: function() {
                        document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function(e, t, r) {
                        e.country !== this.props.country ? this.updateCountry(this.props.country) : e.value !== this.props.value && this.updateFormattedNumber(this.props.value);
                    }
                },
                {
                    key: "updateFormattedNumber",
                    value: function(e) {
                        if (null === e) return this.setState({
                            selectedCountry: 0,
                            formattedNumber: ""
                        });
                        var t = this.state, r = t.onlyCountries, n = t.selectedCountry, a = t.hiddenAreaCodes, o = this.props, i = o.country, u = o.prefix;
                        if ("" === e) return this.setState({
                            selectedCountry: n,
                            formattedNumber: ""
                        });
                        var c, s, l = e.replace(/\D/g, "");
                        if (n && j()(e, u + n.dialCode)) s = this.formatNumber(l, n), this.setState({
                            formattedNumber: s
                        });
                        else {
                            var f = (c = this.props.disableCountryGuess ? n : this.guessSelectedCountry(l.substring(0, 6), i, r, a) || n) && j()(l, u + c.dialCode) ? c.dialCode : "";
                            s = this.formatNumber((this.props.disableCountryCode ? "" : f) + l, c || void 0), this.setState({
                                selectedCountry: c,
                                formattedNumber: s
                            });
                        }
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e, t, r, a = this, o = this.state, i = o.onlyCountries, u = o.selectedCountry, c = o.showDropdown, s = o.formattedNumber, l = o.hiddenAreaCodes, f = this.props, d = f.disableDropdown, p = f.renderStringAsFlag, h = f.isValid, m = f.defaultErrorMessage, b = f.specialLabel;
                        if ("boolean" == typeof h) t = h;
                        else {
                            var g = h(s.replace(/\D/g, ""), u, i, l);
                            "boolean" == typeof g ? !1 === (t = g) && (r = m) : (t = !1, r = g);
                        }
                        var v = N()((n(e = {}, this.props.containerClass, !0), n(e, "react-tel-input", !0), e)), C = N()({
                            arrow: !0,
                            up: c
                        }), _ = N()(n({
                            "form-control": !0,
                            "invalid-number": !t,
                            open: c
                        }, this.props.inputClass, !0)), w = N()({
                            "selected-flag": !0,
                            open: c
                        }), S = N()(n({
                            "flag-dropdown": !0,
                            "invalid-number": !t,
                            open: c
                        }, this.props.buttonClass, !0)), j = "flag ".concat(u && u.iso2);
                        return y.a.createElement("div", {
                            className: "".concat(v, " ").concat(this.props.className),
                            style: this.props.style || this.props.containerStyle,
                            onKeyDown: this.handleKeydown
                        }, b && y.a.createElement("div", {
                            className: "special-label"
                        }, b), r && y.a.createElement("div", {
                            className: "invalid-number-message"
                        }, r), y.a.createElement("input", Object.assign({
                            className: _,
                            style: this.props.inputStyle,
                            onChange: this.handleInput,
                            onClick: this.handleInputClick,
                            onDoubleClick: this.handleDoubleClick,
                            onFocus: this.handleInputFocus,
                            onBlur: this.handleInputBlur,
                            onCopy: this.handleInputCopy,
                            value: s,
                            onKeyDown: this.handleInputKeyDown,
                            placeholder: this.props.placeholder,
                            disabled: this.props.disabled,
                            type: "tel"
                        }, this.props.inputProps, {
                            ref: function(e) {
                                a.numberInputRef = e, "function" == typeof a.props.inputProps.ref ? a.props.inputProps.ref(e) : "object" == typeof a.props.inputProps.ref && (a.props.inputProps.ref.current = e);
                            }
                        })), y.a.createElement("div", {
                            className: S,
                            style: this.props.buttonStyle,
                            ref: function(e) {
                                return a.dropdownContainerRef = e;
                            }
                        }, p ? y.a.createElement("div", {
                            className: w
                        }, p) : y.a.createElement("div", {
                            onClick: d ? void 0 : this.handleFlagDropdownClick,
                            className: w,
                            title: u ? "".concat(u.localName || u.name, ": + ").concat(u.dialCode) : "",
                            tabIndex: d ? "-1" : "0",
                            role: "button",
                            "aria-haspopup": "listbox",
                            "aria-expanded": !!c || void 0
                        }, y.a.createElement("div", {
                            className: j
                        }, !d && y.a.createElement("div", {
                            className: C
                        }))), c && this.getCountryDropdownList()));
                    }
                }
            ], s(r.prototype, l), m && s(r, m), t;
        }(y.a.Component);
        F.defaultProps = {
            country: "",
            value: "",
            onlyCountries: [],
            preferredCountries: [],
            excludeCountries: [],
            placeholder: "1 (702) 123-4567",
            searchPlaceholder: "search",
            searchNotFound: "No entries to show",
            flagsImagePath: "./flags.png",
            disabled: !1,
            containerStyle: {},
            inputStyle: {},
            buttonStyle: {},
            dropdownStyle: {},
            searchStyle: {},
            containerClass: "",
            inputClass: "",
            buttonClass: "",
            dropdownClass: "",
            searchClass: "",
            className: "",
            autoFormat: !0,
            enableAreaCodes: !1,
            enableTerritories: !1,
            disableCountryCode: !1,
            disableDropdown: !1,
            enableLongNumbers: !1,
            countryCodeEditable: !0,
            enableSearch: !1,
            disableSearchIcon: !1,
            disableInitialCountryGuess: !1,
            disableCountryGuess: !1,
            regions: "",
            inputProps: {},
            localization: {},
            masks: null,
            priority: null,
            areaCodes: null,
            preserveOrder: [],
            defaultMask: "... ... ... ... ..",
            alwaysDefaultMask: !1,
            prefix: "+",
            copyNumbersOnly: !0,
            renderStringAsFlag: "",
            autocompleteSearch: !1,
            jumpCursorToEnd: !0,
            enableAreaCodeStretch: !1,
            enableClickOutside: !0,
            showDropdown: !1,
            isValid: !0,
            defaultErrorMessage: "",
            specialLabel: "Phone",
            onEnterKeyPress: null,
            keys: {
                UP: 38,
                DOWN: 40,
                RIGHT: 39,
                LEFT: 37,
                ENTER: 13,
                ESC: 27,
                PLUS: 43,
                A: 65,
                Z: 90,
                SPACE: 32,
                TAB: 9
            }
        };
        t.default = F;
    }
]);





function $cb32818ebee9e72c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cb32818ebee9e72c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cb32818ebee9e72c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cb32818ebee9e72c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cb32818ebee9e72c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cb32818ebee9e72c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cb32818ebee9e72c$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $39acf5220d9ed0f5$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $cb32818ebee9e72c$var$_objectSpread($cb32818ebee9e72c$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $32212af67f45c061$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}


function $169548c2ec7a131a$export$992e2df24bec72ba() {
    return (0, $7b181f8e94b9e93d$export$2e2bcd8739ae039)((0, $cb32818ebee9e72c$export$2e2bcd8739ae039), arguments);
}




function $3809e789bbbdcac9$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $39acf5220d9ed0f5$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $9d20ac0549c6b8cf$export$2e2bcd8739ae039)(text, options, metadata);
}


function $c59d0463d2106497$export$176bb591929cc9a8() {
    return (0, $7b181f8e94b9e93d$export$2e2bcd8739ae039)((0, $3809e789bbbdcac9$export$2e2bcd8739ae039), arguments);
}


/**
 * @author Youssef Tarek
 * @date 2021-12-04
 * @description Account information of the user
 * @filename account-information.tsx
 */ 

var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");






/**
 * @author Ahmed Serag
 * @date 2021-12-11
 * @description implementation of password input component
 * @filename password input.tsx
 */ 

var $igtsr = parcelRequire("igtsr");

class $3d59c8bb1ae714ed$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            showPassword: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "password-input-wrapper",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                    ...this.props,
                    className: "password-input",
                    type: this.state.showPassword ? "text" : "password"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $e867fa34c6533ee8$export$2e2bcd8739ae039), {
                    className: "password-input-icon",
                    onClick: ()=>{
                        this.setState({
                            showPassword: !this.state.showPassword
                        });
                    }
                })
            ]
        });
    }
}


class $4c99ddac5865694e$var$EditPassword extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.updateAccountPassword = this.updateAccountPassword.bind(this);
    }
    // eslint-disable-next-line class-methods-use-this
    updateAccountPassword(values, formikHelpers) {
        if (values.currentPassword === values.newPassword) {
            formikHelpers.setSubmitting(false);
            return;
        }
        // TODO: Update account name
        formikHelpers.setSubmitting(false);
        (0, $56fb02d394e3f062$export$e2853351e15b7895)(values.currentPassword, values.newPassword).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Password updated successfully");
            formikHelpers.setSubmitting(false);
            this.props.onFinish();
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error?.message);
        });
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "account-settings",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                        className: "card--title",
                        children: t("editPassword")
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                        onSubmit: this.updateAccountPassword,
                        initialValues: {
                            currentPassword: "",
                            newPassword: ""
                        },
                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                            currentPassword: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required("Current password is required"),
                            newPassword: (0, $bd69b505bf48eca0$export$85b75051ee07828a).required("Password is required"),
                            confirmPassword: $91e1faf1710dcf23$export$22b082955e083ec3().required("Confirm password is required").oneOf([
                                $91e1faf1710dcf23$export$eff4d24c3ff7876e("newPassword")
                            ], "password and confirm password do not match")
                        }),
                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                className: "card--section",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "currentPassword",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "currentPassword",
                                                        children: t("currentPassword")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $3d59c8bb1ae714ed$export$2e2bcd8739ae039), {
                                                        placeholder: "Enter your current password",
                                                        name: "currentPassword",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "newPassword",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "newPassword",
                                                        children: t("password")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $3d59c8bb1ae714ed$export$2e2bcd8739ae039), {
                                                        placeholder: t("passwordPlaceholder"),
                                                        name: "newPassword",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "confirmPassword",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "confirmPassword",
                                                        children: t("confirmPassword")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $3d59c8bb1ae714ed$export$2e2bcd8739ae039), {
                                                        placeholder: t("confirmPasswordPlaceholder"),
                                                        name: "confirmPassword",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "action-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "submit",
                                                className: "button save",
                                                disabled: formikBag.isSubmitting,
                                                children: t("saveChanges")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                className: "button-outline",
                                                type: "button",
                                                onClick: ()=>this.props.onFinish(),
                                                children: t("cancel")
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                ]
            })
        });
    }
}
$4c99ddac5865694e$var$EditPassword.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $4c99ddac5865694e$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($4c99ddac5865694e$var$EditPassword);



parcelRequire("igtsr");

const $1aff520041650bb7$export$2b77a92f1a5ad772 = ({ handleClose: handleClose, showModal: showModal, children: children, sideModal: sideModal })=>{
    const showHideClassName = showModal ? "modal display-block" : "modal display-none";
    const showSideModal = sideModal && "modal--side";
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
        className: `${showHideClassName} ${showSideModal}`,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("section", {
            className: "modal-main",
            children: [
                children,
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                    type: "button",
                    className: "button--clear modal__close-button",
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $6e34be24cf1b489c$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};



/**
 * @author Youssef Tarek
 * @date 2022-06-27
 * @description ios-like toggle switch
 * @filename toggle-switch.tsx
 */ 

var $igtsr = parcelRequire("igtsr");
class $dcd8ac62491e382f$export$fb4216da1f591b95 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    dir: "ltr",
                    className: "toggle-switch small-switch",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                            type: "checkbox",
                            name: this.props.name,
                            className: "toggle-switch-checkbox",
                            id: this.props.id,
                            checked: this.props.checked,
                            onChange: (e)=>this.props.onChange(e.target.checked)
                        }),
                        this.props.id ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("label", {
                            className: "toggle-switch-label clearfix",
                            htmlFor: this.props.id,
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "toggle-switch-inner"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "toggle-switch-switch"
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                    htmlFor: this.props.id,
                    className: "toggle-switch--label",
                    children: this.props.name
                })
            ]
        });
    }
}




class $660f7a2e11ceb83a$var$AccountSettings extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            showDeleteModal: false,
            showLogsModal: false,
            accountLogs: null,
            loadingAccountLogs: false,
            enable2FA: false,
            phone: "",
            country: "",
            countryCallingCode: "",
            showOtpBox: false
        };
        this.updateAccountName = this.updateAccountName.bind(this);
        this.toggleLanguage = this.toggleLanguage.bind(this);
        this.handleDownloadAccountLogs = this.handleDownloadAccountLogs.bind(this);
        this.hideLogsModal = this.hideLogsModal.bind(this);
        this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
        this.hideDeleteModal = this.hideDeleteModal.bind(this);
        this.toggleEnable2FA = this.toggleEnable2FA.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.toggleOtpBox = this.toggleOtpBox.bind(this);
        this.validate2FA = this.validate2FA.bind(this);
    }
    // give the enable 2FA toggler the right value
    componentDidMount() {
        this.setState({
            enable2FA: !!this.context.user.tfa_enabled
        });
    }
    handleDownloadAccountLogs() {
        this.setState({
            loadingAccountLogs: true
        });
        (0, $56fb02d394e3f062$export$613c3f4837bf8ca6)().then((accountLogs)=>{
            this.setState({
                accountLogs: accountLogs
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.setState({
                loadingAccountLogs: false
            });
        });
    }
    handleDeleteAccount() {
        (0, $56fb02d394e3f062$export$45abfc3976589d02)().then((result)=>{
            (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).logout();
            this.context.updateUser(null);
            this.props.history.push((0, $402ff3f88b55a2c2$export$cd891b82501bb412).Login.path);
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.hideDeleteModal();
        });
    }
    /**
   * validate the entered phone number against its country code,
   * update the state with these as well as the dialling code
   * @param phone the phone number to be validated
   * @param country the country name as a code
   */ handlePhoneChange(phone, country) {
        if ((0, $169548c2ec7a131a$export$992e2df24bec72ba)(phone, country.countryCode.toUpperCase())) this.setState({
            phone: phone,
            country: country.countryCode.toUpperCase(),
            countryCallingCode: country.dialCode
        });
        else this.setState({
            phone: ""
        });
    }
    updateAccountName(values, formikHelpers) {
        if (this.context.user?.name === values.name) {
            formikHelpers.setSubmitting(false);
            return Promise.resolve();
        }
        return (0, $56fb02d394e3f062$export$f481a68bf2db0291)(values.name).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Account name updated successfully");
            this.context.updateUser({
                ...this.context.user,
                name: values.name
            });
            formikHelpers.setSubmitting(false);
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Error updating account name");
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err?.message);
            formikHelpers.setSubmitting(false);
        });
    }
    toggleLanguage() {
        const lang = this.context.user.language === "ar" ? "en" : "ar";
        return (0, $56fb02d394e3f062$export$61465194746e7fd2)(lang).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Language updated successfully");
            (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).changeLanguage(lang);
            this.context.updateUser({
                ...this.context.user,
                language: lang
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Error updating language");
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err?.message);
        });
    }
    showDeleteModal() {
        this.setState({
            showDeleteModal: true
        });
    }
    hideDeleteModal() {
        this.setState({
            showDeleteModal: false
        });
    }
    showLogsModal() {
        this.setState({
            showLogsModal: true
        });
    }
    hideLogsModal() {
        this.setState({
            showLogsModal: false
        });
    }
    /**
   * toggle the whether we are the state of enabling 2FA
   * according to the toggle switch.
   * disable 2FA if it is already enabled
   * @param checked the value of the toggle switch
   */ toggleEnable2FA(checked) {
        this.setState({
            enable2FA: checked
        });
        if (this.context.user.tfa_enabled && !checked) this.disable2FA();
    }
    /**
   * show/hide the OTP box
   */ toggleOtpBox() {
        this.setState((prevState)=>({
                showOtpBox: !prevState.showOtpBox
            }));
    }
    /**
   *
   * @param phoneNumberExt the country dialling code
   * @param phoneNumber phone number without the dialling code
   * @param toggleBox a flag to show/hide the OTP box which to be used if we want to resend the otp
   */ enable2FA(phoneNumberExt, phoneNumber, toggleBox = true) {
        (0, $56fb02d394e3f062$export$c95c14b1c454fbc4)(phoneNumberExt, phoneNumber).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("OTP sent successfully");
            if (toggleBox) this.toggleOtpBox();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Error enabling 2FA");
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err?.message);
        });
    }
    /**
   * validates the the otp and assign the mobile number to the user
   * @param email the email address to be used for 2FA
   * @param otp the sent otp
   */ validate2FA(email, otp) {
        (0, $56fb02d394e3f062$export$33074b0d6fb9226e)(email, otp).then(()=>{
            this.context.updateUser({
                ...this.context.user,
                tfa_enabled: 1,
                phone_number: this.state.phone.slice(this.state.countryCallingCode.length),
                phone_number_ext: this.state.countryCallingCode
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).success("2FA validated successfully");
            this.toggleOtpBox();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Error validating 2FA");
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err?.message);
        });
    }
    /**
   * disable 2FA for the user
   */ disable2FA() {
        (0, $56fb02d394e3f062$export$64d395d9c1c49d9a)().then(()=>{
            this.context.updateUser({
                ...this.context.user,
                tfa_enabled: 0,
                phone_number: null,
                phone_number_ext: null
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).success("2FA disabled successfully");
            this.setState({
                enable2FA: false
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Error disabling 2FA");
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err?.message);
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.editingPassword) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4c99ddac5865694e$export$2e2bcd8739ae039), {
            onFinish: ()=>{
                (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).logout();
                this.context.updateUser(null);
                this.context.updateSideBarOpened(false);
                this.props.history.push((0, $402ff3f88b55a2c2$export$cd891b82501bb412).Login.path);
            }
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "account-settings",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: t("accountSettings")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                            onSubmit: this.updateAccountName,
                            initialValues: {
                                name: this.context.user?.name
                            },
                            validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                                name: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().max(200).required("Name is required")
                            }),
                            children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                    className: "card--section",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "name",
                                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "form-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: "name",
                                                            children: t("fullName")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                            id: "topic",
                                                            placeholder: "enter message topic",
                                                            name: "name",
                                                            type: "text",
                                                            ...field,
                                                            value: field.value ?? ""
                                                        }),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: "error",
                                                            children: meta.error
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "submit",
                                            className: "button save",
                                            disabled: formikBag.isSubmitting,
                                            children: t("updateName")
                                        })
                                    ]
                                })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card--section",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "listing",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "listing__title",
                                            children: t("email")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "listing__item",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "title",
                                                children: this.context.user.email
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "listing",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "listing__title",
                                            children: t("password")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "listing__item",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "title",
                                                    children: "********"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "link",
                                                    onClick: ()=>this.setState({
                                                            editingPassword: true
                                                        }),
                                                    children: t("editPassword")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "listing disabled",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("form", {
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $dcd8ac62491e382f$export$fb4216da1f591b95), {
                                                // checked={this.state.enable2FA}
                                                checked: false,
                                                // onChange={this.toggleEnable2FA}
                                                onChange: ()=>{},
                                                id: "enable2FA",
                                                name: t("enableTwoFactorAuthentication")
                                            })
                                        }),
                                        this.state.enable2FA && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                                            children: this.context.user.tfa_enabled ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "my-10",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "listing__title",
                                                        children: `${t("phoneNumber")}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "title",
                                                        children: `${(0, $c59d0463d2106497$export$176bb591929cc9a8)(`+${this.context.user.phone_number_ext}${this.context.user.phone_number}`).formatInternational()}`
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                                                className: "inputs-container",
                                                onSubmit: (e)=>{
                                                    e.preventDefault();
                                                    this.enable2FA(this.state.countryCallingCode, this.state.phone.slice(this.state.countryCallingCode.length));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "my-10",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                className: "listing__title",
                                                                children: `${t("phoneNumber")}`
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($97068fe16ca9e12e$exports))), {
                                                                country: "eg",
                                                                specialLabel: "",
                                                                countryCodeEditable: false,
                                                                onChange: (phone, country)=>{
                                                                    this.handlePhoneChange(phone, country);
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        type: "submit",
                                                        className: "button submit-btn",
                                                        disabled: !this.state.phone,
                                                        children: `${t("verify")}`
                                                    })
                                                ]
                                            })
                                        }),
                                        this.state.showOtpBox && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2dfe8ea3dd197f6b$export$2e2bcd8739ae039), {
                                            title: t("verifyYourNumber"),
                                            toggleOtpBox: this.toggleOtpBox,
                                            phone: this.state.phone,
                                            countryCallingCode: this.state.countryCallingCode,
                                            country: this.state.country,
                                            validate2FA: this.validate2FA,
                                            email: this.context.user.email,
                                            enable2FA: this.enable2FA
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "card--section",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "listing",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "listing__title",
                                        children: t("language")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "listing__item",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                className: "title",
                                                children: this.context.user.language === "ar" ? "\u0627\u0644\u0639\u0631\u0628\u064A\u0629" : "English"
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "button",
                                                className: "link",
                                                onClick: ()=>this.toggleLanguage(),
                                                children: this.context.user.language === "ar" ? "Change to English" : "\u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0625\u0644\u0649 \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        !this.context.user.is_admin && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "card--section",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "listing listing--logs",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                children: t("myActivity")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "listing__item",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                        className: "listing__item-paragraph",
                                                        children: t("myActivityDescription")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        type: "submit",
                                                        className: "button save",
                                                        onClick: ()=>{
                                                            this.handleDownloadAccountLogs();
                                                            this.showLogsModal();
                                                        },
                                                        children: t("requestMyActivity")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "card--section",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "listing",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                            className: "listing__item listing__item--delete",
                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "button",
                                                className: "link",
                                                onClick: ()=>this.showDeleteModal(),
                                                children: t("deleteMyAccount")
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1aff520041650bb7$export$2b77a92f1a5ad772), {
                    showModal: this.state.showDeleteModal,
                    handleClose: ()=>this.hideDeleteModal(),
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "settings__modal",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                className: "settings__modal-title",
                                children: t("deleteAccountConfirmationTitle")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                className: "settings__modal-description",
                                children: t("deleteAccountDescription")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "settings__modal-actions",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "button",
                                        className: "button--main button--delete",
                                        onClick: this.handleDeleteAccount,
                                        children: t("delete")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "button",
                                        className: "button-outline",
                                        onClick: ()=>this.hideDeleteModal(),
                                        children: t("cancel")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1aff520041650bb7$export$2b77a92f1a5ad772), {
                    showModal: this.state.showLogsModal,
                    handleClose: ()=>this.hideLogsModal(),
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "settings__modal",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                className: "settings__modal-title",
                                children: t("requestMyActivity")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                className: "settings__modal-description",
                                children: t("requestMyActivityDescription")
                            }),
                            this.state.loadingAccountLogs ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "settings__modal-actions",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "button",
                                        className: "button--main button--download",
                                        children: this.state.accountLogs && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                            data: this.state.accountLogs,
                                            filename: "loyalty-points.csv",
                                            className: "export-list-button",
                                            target: "_blank",
                                            onClick: this.hideLogsModal,
                                            children: t("downloadFile")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "button",
                                        className: "button-outline",
                                        onClick: ()=>this.hideLogsModal(),
                                        children: t("cancel")
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}
$660f7a2e11ceb83a$var$AccountSettings.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $660f7a2e11ceb83a$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($660f7a2e11ceb83a$var$AccountSettings);






var $igtsr = parcelRequire("igtsr");


/**
 * @author Salma Hefnawy
 * @date 2021-03-17
 * @description implementation of converting file to base64
 * @filename get-base64.ts
 */ function $723f679cfdb4a815$export$fefac22278f31950(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = (error)=>reject(error);
    });
}





var $f421af1f995d2058$exports = {};
"use strict";
Object.defineProperty($f421af1f995d2058$exports, "__esModule", {
    value: true
});
function $f421af1f995d2058$var$composeRefs() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    if (refs.length === 2) return $f421af1f995d2058$var$composeTwoRefs(refs[0], refs[1]) || null;
    var composedRef = refs.slice(1).reduce(function(semiCombinedRef, refToInclude) {
        return $f421af1f995d2058$var$composeTwoRefs(semiCombinedRef, refToInclude);
    }, refs[0]);
    return composedRef || null;
}
$f421af1f995d2058$exports.default = $f421af1f995d2058$var$composeRefs;
var $f421af1f995d2058$var$composedRefCache = new WeakMap();
function $f421af1f995d2058$var$composeTwoRefs(ref1, ref2) {
    if (ref1 && ref2) {
        var ref1Cache = $f421af1f995d2058$var$composedRefCache.get(ref1) || new WeakMap();
        $f421af1f995d2058$var$composedRefCache.set(ref1, ref1Cache);
        var composedRef = ref1Cache.get(ref2) || function(instance) {
            $f421af1f995d2058$var$updateRef(ref1, instance);
            $f421af1f995d2058$var$updateRef(ref2, instance);
        };
        ref1Cache.set(ref2, composedRef);
        return composedRef;
    }
    if (!ref1) return ref2;
    else return ref1;
}
function $f421af1f995d2058$var$updateRef(ref, instance) {
    if (typeof ref === 'function') ref(instance);
    else ref.current = instance;
}



var $igtsr = parcelRequire("igtsr");
const $b5044cd6af15b4ab$export$9012acaf449cdfcb = /*#__PURE__*/ (0, $igtsr.forwardRef)((props, ref)=>{
    const selectorRef = (0, $igtsr.useRef)();
    const openSelectorOnClick = (0, $igtsr.useCallback)(()=>{
        selectorRef.current.click();
    }, []);
    const openSelectorOnKeyUp = (0, $igtsr.useCallback)((ev)=>{
        if (ev.code === "Enter" || ev.code === "Space") selectorRef.current.click();
    }, []);
    return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
        role: "button",
        onClick: openSelectorOnClick,
        onKeyUp: openSelectorOnKeyUp,
        tabIndex: 0,
        className: "color-selector",
        "aria-label": "Select a color",
        children: [
            `${props?.value}`.toUpperCase(),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                type: "color",
                ref: (0, (/*@__PURE__*/$parcel$interopDefault($f421af1f995d2058$exports)))(selectorRef, ref),
                tabIndex: -1,
                ...props
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
                viewBox: "0 0 100 100",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: "50",
                    cy: "50",
                    r: "50",
                    fill: `${props?.value}`
                })
            })
        ]
    });
});



class $23ec71b40c7bb925$var$AppearanceSettings extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            dirty: {},
            loading: false,
            id: "settings-update",
            logoPreview: false
        };
        this.updatePrimaryColor = this.updatePrimaryColor.bind(this);
        this.save = this.save.bind(this);
        this.reset = this.reset.bind(this);
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        if (this.context.settings) this.setState({
            dirty: {
                ...this.context.settings
            }
        });
    }
    updatePrimaryColor(ev) {
        if (!this.state.dirty) return;
        this.setState({
            dirty: {
                ...this.state.dirty,
                primary_color: ev.target.value
            }
        });
    }
    save(ev) {
        ev.preventDefault();
        if (JSON.stringify(this.context.settings) === JSON.stringify(this.state.dirty)) return;
        if (!this.state.dirty.logo) (0, $56fb02d394e3f062$export$bba5eb83f5a3091e)(this.context.project).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("logo deleted successfully");
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
        (0, $56fb02d394e3f062$export$f558026a994b6051)(this.context.project, this.state.dirty).then((settings)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Settings updated successfully");
            this.context.updateAppearanceSettings(settings);
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            // eslint-disable-next-line no-console
            console.error(error);
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Failed to load project settings");
        });
    }
    reset() {
        this.setState({
            dirty: {
                ...this.context.settings
            }
        });
    }
    render() {
        const { t: t } = this.props;
        const dirty = JSON.stringify(this.context.settings) !== JSON.stringify(this.state.dirty);
        const logoInput = document.querySelector("#logo");
        const backendUrl = "https://backend.analytics-dashboard.ecommbeta.com/api".split("/admin")[0];
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "settings",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                className: "card",
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                    onSubmit: this.save,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: t("appearanceSettings")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                            className: "note",
                            children: t("appearanceSettingsDescription")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "settings__image-container",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                    className: "label",
                                    children: t("logo")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "settings__image",
                                    children: [
                                        this.state.dirty.logo || this.state.logoPreview ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "settings__image-preview",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "settings__image-preview--delete",
                                                    onClick: ()=>{
                                                        logoInput.value = "";
                                                        this.setState({
                                                            dirty: {
                                                                ...this.state.dirty,
                                                                logo: ""
                                                            },
                                                            logoPreview: false
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $6e34be24cf1b489c$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                                    src: this.state.dirty.logo && !this.state.logoPreview ? `${backendUrl}/${this.state.dirty.logo}` : this.state.dirty.logo,
                                                    alt: t("logo")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("label", {
                                            className: "settings__image-text",
                                            children: [
                                                t("uploadImage"),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("small", {
                                                    children: t("maxMB")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                            name: "logo",
                                            type: "file",
                                            id: "logo",
                                            className: "settings__image-input",
                                            accept: "image/x-png,image/gif,image/jpeg",
                                            onChange: (e)=>{
                                                if (e.target.files) (0, $723f679cfdb4a815$export$fefac22278f31950)(e.target.files[0]).then((file)=>{
                                                    this.setState({
                                                        dirty: {
                                                            ...this.state.dirty,
                                                            logo: file
                                                        },
                                                        logoPreview: true
                                                    });
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                            className: "label",
                            htmlFor: "color",
                            children: t("primaryColor")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $b5044cd6af15b4ab$export$9012acaf449cdfcb), {
                            id: "color",
                            onChange: this.updatePrimaryColor,
                            value: this.state?.dirty?.primary_color || "#0137A0"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "action-buttons",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                    type: "submit",
                                    className: "button save",
                                    disabled: !dirty,
                                    children: t("saveChanges")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                    type: "button",
                                    className: "button cancel",
                                    onClick: this.reset,
                                    disabled: !dirty,
                                    children: t("reset")
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
}
$23ec71b40c7bb925$var$AppearanceSettings.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $23ec71b40c7bb925$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($23ec71b40c7bb925$var$AppearanceSettings);





var $igtsr = parcelRequire("igtsr");



parcelRequire("igtsr");
const $fd7c4d9fa842da01$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "#1792ff",
            fillRule: "evenodd",
            d: "M5.5 5.5v-.613c0-1.138.128-1.787.482-2.448A3.5 3.5 0 0 1 7.439.982C8.1.628 8.75.5 9.887.5h6.158c1.205 0 1.847.124 2.516.482a3.5 3.5 0 0 1 1.457 1.457c.358.67.482 1.311.482 2.516v6.158c0 1.138-.128 1.787-.482 2.448a3.5 3.5 0 0 1-1.457 1.457c-.661.354-1.31.482-2.448.482H15.5v.545c0 1.205-.124 1.847-.482 2.516a3.5 3.5 0 0 1-1.457 1.457c-.67.358-1.311.482-2.516.482h-6.09c-1.205 0-1.847-.124-2.516-.482a3.5 3.5 0 0 1-1.457-1.457C.624 17.89.5 17.25.5 16.045v-6.09c0-1.205.124-1.847.482-2.516a3.5 3.5 0 0 1 1.457-1.457C3.11 5.624 3.75 5.5 4.955 5.5zm1.25-.625h3.806c1.506 0 2.309.155 3.145.602A4.4 4.4 0 0 1 15.523 7.3c.447.836.602 1.639.602 3.145v3.806h.767c.948 0 1.268-.063 1.585-.233.237-.126.414-.303.54-.54.17-.317.233-.637.233-1.585V4.194c0-1.035-.06-1.35-.233-1.67a1.28 1.28 0 0 0-.54-.541c-.322-.172-.636-.233-1.67-.233h-7.7c-.948 0-1.268.063-1.585.233a1.28 1.28 0 0 0-.54.54c-.17.317-.233.637-.233 1.585z"
        })
    });
var $fd7c4d9fa842da01$export$2e2bcd8739ae039 = $fd7c4d9fa842da01$var$SvgCopy;



parcelRequire("igtsr");
const $cdef7bef60caf81d$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 8,
                    cy: 8,
                    r: 8,
                    fill: "#9da4c2"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("text", {
                    fill: "#fff",
                    fontFamily: "Poppins-Medium, Poppins",
                    fontSize: 12,
                    fontWeight: 400,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("tspan", {
                        x: 6.416,
                        y: 13,
                        children: "i"
                    })
                })
            ]
        })
    });
var $cdef7bef60caf81d$export$2e2bcd8739ae039 = $cdef7bef60caf81d$var$SvgInfo;






class $b66cd56f79de1ac0$var$IntegrationSettings extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            setIdLoading: false,
            id: "settings-update",
            isCopied: false,
            showInfoContainer: false,
            showPropertyIdInput: true,
            propertyId: ""
        };
        this.updatePropertyId = this.updatePropertyId.bind(this);
        this.deletePropertyId = this.deletePropertyId.bind(this);
        this.copyTextToClipboard = this.copyTextToClipboard.bind(this);
        this.loadData = this.loadData.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        if (this.context.settings.ga4_property_id) this.setState({
            showPropertyIdInput: false,
            propertyId: this.context.settings.ga4_property_id
        });
    }
    updatePropertyId(e, propertyId) {
        const { t: t } = this.props;
        this.setState({
            setIdLoading: true
        });
        e.preventDefault();
        if (/\D/.test(propertyId)) {
            (0, $d41f521f78665649$export$b410431fab84fa58).error(t("numbersValidation"));
            return;
        }
        if (this.context.project) (0, $56fb02d394e3f062$export$dd06c8c889613e9a)(this.context.project, propertyId).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(t("idSetSuccessfully"));
            this.context.setProject(this.context.project);
            this.setState({
                propertyId: propertyId
            });
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error.message);
        }).finally(()=>{
            this.setState({
                showPropertyIdInput: false,
                setIdLoading: false
            });
        });
    }
    deletePropertyId() {
        const { t: t } = this.props;
        this.setState({
            setIdLoading: true
        });
        if (this.context.project) (0, $56fb02d394e3f062$export$79cd7582c7ac6134)(this.context.project).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(t("idSetSuccessfully"));
            this.setState({
                showPropertyIdInput: true,
                propertyId: ""
            });
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error.message);
        }).finally(()=>{
            this.setState({
                setIdLoading: false
            });
        });
    }
    copyTextToClipboard(text, timeout = 2000) {
        this.setState({
            isCopied: true
        });
        navigator.clipboard.writeText(text);
        setTimeout(()=>{
            this.setState({
                isCopied: false
            });
        }, timeout);
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "settings",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                className: "card",
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "settings-ga4",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: t("Integration")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                            className: "note",
                            children: t("integrationSettingsDescription")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                            src: "https://upload.wikimedia.org/wikipedia/commons/8/89/Logo_Google_Analytics.svg",
                            className: "settings-ga4__image",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ol", {
                            className: "settings-ga4__main-list",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "settings-ga4__main-list-item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "settings-ga4__main-list-item--title",
                                            children: t("enterYourID")
                                        }),
                                        this.state.setIdLoading ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {}) : !this.state.showPropertyIdInput ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "settings-ga4__main-list-item--id",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                                    children: t("googleAnalyticsPropertyID")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "property-id",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                            className: "property-id",
                                                            children: this.state.propertyId
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "property-id__buttons",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                                    className: "property-id--delete button--clear",
                                                                    type: "button",
                                                                    onClick: this.deletePropertyId,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2742632e86fe22d3$export$2e2bcd8739ae039), {}),
                                                                        t("removeIntegration")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                                    className: "property-id--edit  button--clear",
                                                                    type: "button",
                                                                    onClick: ()=>{
                                                                        this.setState({
                                                                            showPropertyIdInput: true
                                                                        });
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $89143256da30e053$export$2e2bcd8739ae039), {}),
                                                                        t("editID")
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                                            className: "inputs-container settings-ga4__main-list-item--form",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "input-wrapper",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: "ga4-id",
                                                            children: t("googleAnalyticsPropertyID")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                            type: "text",
                                                            name: "ga4-id",
                                                            id: "ga4-id",
                                                            placeholder: "Ex.: 153293282",
                                                            value: this.state.propertyId,
                                                            onChange: (e)=>{
                                                                this.setState({
                                                                    propertyId: e.target.value
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "info-svg button--clear",
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    showInfoContainer: !this.state.showInfoContainer
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cdef7bef60caf81d$export$2e2bcd8739ae039), {})
                                                        }),
                                                        this.state.showInfoContainer && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "info-container",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                                                                    children: [
                                                                        t("idInfoDesc"),
                                                                        "."
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    href: "https://www.datadrivenu.com/ga4-measurement-id/#:~:text=You%20can%20find%20your%20GA4,or%20in%20Google%20Tag%20Manager.",
                                                                    children: t("whereThat")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                    className: "submit-btn",
                                                    type: "submit",
                                                    disabled: !this.state.propertyId,
                                                    onClick: (e)=>{
                                                        this.updatePropertyId(e, this.state.propertyId);
                                                    },
                                                    children: t("saveText")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                    className: "settings-ga4__main-list-item",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "settings-ga4__main-list-item--title",
                                            children: t("authorizeGoogleAnalytics")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "settings-ga4__steps",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                    children: t("completeSteps")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ol", {
                                                    className: "settings-ga4__sub-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                            className: "settings-ga4__sub-list-item",
                                                            children: t("goGA4AdminPanel")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                            className: "settings-ga4__sub-list-item",
                                                            children: t("clickPropertyAccess")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                            className: "settings-ga4__sub-list-item settings-ga4__sub-list-item--flex",
                                                            children: [
                                                                t("authorizeEmail"),
                                                                ":",
                                                                " ",
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "settings-ga4__sub-list-item--email",
                                                                    children: "starting-account-ejcgei3vz415@quickstart-1653326575843.iam.gserviceaccount.com"
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                    className: "settings-ga4__sub-list-item--copy",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fd7c4d9fa842da01$export$2e2bcd8739ae039), {}),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                                            type: "button",
                                                                            className: "button--clear",
                                                                            onClick: ()=>{
                                                                                // method used to copy text in clipboard
                                                                                this.copyTextToClipboard(this.context.user?.email);
                                                                            },
                                                                            children: this.state.isCopied ? t("copied") : t("copy")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                            className: "settings-ga4__sub-list-item",
                                                            children: t("clickSave")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
}
$b66cd56f79de1ac0$var$IntegrationSettings.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $b66cd56f79de1ac0$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($b66cd56f79de1ac0$var$IntegrationSettings);


/**
 * @author Ahmed Serag
 * @date 2021-12-05
 * @description settings nav-bar
 * @filename settings-nav-bar.tsx
 */ 

var $igtsr = parcelRequire("igtsr");
class $9d1822deacea1a5a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "settings-nav-bar",
            children: this.props.tabs.map((tab, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                    className: `settings-nav-bar--item ${tab.active ? "active" : ""}`,
                    onClick: tab.onSelectTab,
                    type: "button",
                    children: [
                        tab.icon,
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "settings-nav-bar--item__content",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h3", {
                                    className: "settings-nav-bar--item__label",
                                    children: tab.label
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    className: "settings-nav-bar--item__description",
                                    children: tab.description
                                })
                            ]
                        })
                    ]
                }, index))
        });
    }
}


/**
 * @author Ahmed Serag
 * @date 2021-12-04
 * @description Account information of the user
 * @filename account-information.tsx
 */ 



var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");



class $48fe584aac91d9b2$var$DataSettings extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {};
        this.updateDataSettings = this.updateDataSettings.bind(this);
    }
    // eslint-disable-next-line class-methods-use-this
    updateDataSettings(values, formikHelpers) {
        let updateThresholdPromise = Promise.resolve();
        let updateGoalsPromise = Promise.resolve();
        if (this.context.settings?.threshold !== values.threshold) updateThresholdPromise = (0, $56fb02d394e3f062$export$f558026a994b6051)(this.context.project, {
            threshold: values.threshold
        });
        if (this.context.settings?.daily_goal !== values.dailyGoal || this.context.settings?.weekly_goal !== values.weeklyGoal || this.context.settings?.monthly_goal !== values.monthlyGoal || this.context.settings?.yearly_goal !== values.yearlyGoal) updateGoalsPromise = (0, $56fb02d394e3f062$export$a303889ea27be1af)(this.context.project, values.dailyGoal || 0, values.weeklyGoal || 0, values.monthlyGoal || 0, values.yearlyGoal || 0);
        Promise.all([
            updateThresholdPromise,
            updateGoalsPromise
        ]).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Data settings updated successfully");
            this.context.updateSettings({
                ...this.context.settings,
                threshold: values.threshold,
                daily_goal: values.dailyGoal,
                weekly_goal: values.weeklyGoal,
                monthly_goal: values.monthlyGoal,
                yearly_goal: values.yearlyGoal
            });
            formikHelpers.setSubmitting(false);
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Failed to update data settings");
            // eslint-disable-next-line no-console
            console.error(error);
            formikHelpers.setSubmitting(false);
        });
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "data-settings",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                        className: "card--title",
                        children: t("dataSettings")
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                        onSubmit: this.updateDataSettings,
                        enableReinitialize: true,
                        initialValues: {
                            threshold: this.context.settings?.threshold,
                            dailyGoal: this.context.settings?.daily_goal,
                            weeklyGoal: this.context.settings?.weekly_goal,
                            monthlyGoal: this.context.settings?.monthly_goal,
                            yearlyGoal: this.context.settings?.yearly_goal
                        },
                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                            threshold: (0, $91e1faf1710dcf23$export$98e628dec113755e)().min(1, `${t("lowInStockWarning")}`),
                            dailyGoal: (0, $91e1faf1710dcf23$export$98e628dec113755e)().min(1, `${t("dailyGoalWarning")}`),
                            weeklyGoal: (0, $91e1faf1710dcf23$export$98e628dec113755e)().min(1, `${t("weeklyGoalWarning")}`),
                            monthlyGoal: (0, $91e1faf1710dcf23$export$98e628dec113755e)().min(1, `${t("monthlyGoalWarning")}`),
                            yearlyGoal: (0, $91e1faf1710dcf23$export$98e628dec113755e)().min(1, `${t("yearlyGoalWarning")}`)
                        }),
                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "card--section",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "threshold",
                                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "form-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: "threshold",
                                                            children: t("lowInStock")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                            placeholder: "0.0",
                                                            name: "threshold",
                                                            type: "text",
                                                            ...field,
                                                            value: field.value ?? "0"
                                                        }),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: "error",
                                                            children: meta.error
                                                        })
                                                    ]
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "card--section",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                name: "dailyGoal",
                                                children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                htmlFor: "dailyGoal",
                                                                children: t("dailyOrdersValueGoal")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                placeholder: "0.0",
                                                                name: "dailyGoal",
                                                                type: "text",
                                                                ...field,
                                                                value: field.value ?? 0
                                                            }),
                                                            meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                className: "error",
                                                                children: meta.error
                                                            })
                                                        ]
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                name: "weeklyGoal",
                                                children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                htmlFor: "weeklyGoal",
                                                                children: t("weeklyOrdersValueGoal")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                placeholder: "0.0",
                                                                name: "weeklyGoal",
                                                                type: "text",
                                                                ...field,
                                                                value: field.value ?? 0
                                                            }),
                                                            meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                className: "error",
                                                                children: meta.error
                                                            })
                                                        ]
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                name: "monthlyGoal",
                                                children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                htmlFor: "monthlyGoal",
                                                                children: t("monthlyOrdersValueGoal")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                placeholder: "0.0",
                                                                name: "monthlyGoal",
                                                                type: "text",
                                                                ...field,
                                                                value: field.value ?? 0
                                                            }),
                                                            meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                className: "error",
                                                                children: meta.error
                                                            })
                                                        ]
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                name: "yearlyGoal",
                                                children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "form-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                htmlFor: "name",
                                                                children: t("annualOrdersValueGoal")
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                placeholder: "0.0",
                                                                name: "yearlyGoal",
                                                                type: "text",
                                                                ...field,
                                                                value: field.value ?? 0
                                                            }),
                                                            meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                className: "error",
                                                                children: meta.error
                                                            })
                                                        ]
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "action-buttons",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        type: "submit",
                                                        className: "button save",
                                                        disabled: formikBag.isSubmitting,
                                                        children: t("saveChanges")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        className: "button-outline",
                                                        type: "button",
                                                        onClick: ()=>formikBag.resetForm(),
                                                        children: t("cancel")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                ]
            })
        });
    }
}
$48fe584aac91d9b2$var$DataSettings.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $48fe584aac91d9b2$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($48fe584aac91d9b2$var$DataSettings);





var $igtsr = parcelRequire("igtsr");


/**
 * @author Salma Hefnawy
 * @date 2022-04-06
 * @description implementation of User management related utilities.
 * @filename user-management.ts
 */ /**
 * @author Salma Hefnawy
 * @date 2022-04-06
 * @description implementation of User management related API calls.
 * @filename user-management.ts
 */ 

class $14f3ca0faa7e905a$export$8372ed2fbac2c87d {
    static getAllUsers() {
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllUsers.path}`, {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllUsers.method
        });
    }
    static getAllRoles() {
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllRoles.path}`, {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getAllRoles.method
        });
    }
    /**
   * Delete user.
   * @param {string} id id
   */ static deleteUser(id) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteUser.path}`);
        url.searchParams.append("id", id);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).deleteUser.method
        });
    }
    /**
   * Edit user role.
   * @param {string} id
   * @param {string} role
   */ static editUserRole(id, role) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).editUserRole.path}`);
        url.searchParams.append("id", id);
        url.searchParams.append("role", role);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).editUserRole.method
        });
    }
    /**
   * Add user role.
   * @param {string} name
   * @param {string} email
   * @param {string} role
   */ static addUser(name, email, role) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).addUser.path}`);
        url.searchParams.append("name", name);
        url.searchParams.append("email", email);
        url.searchParams.append("role", role);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).addUser.method
        });
    }
}



function $ebde8a7c66f56ed6$export$69093b9c569a5b5b() {
    return (0, $14f3ca0faa7e905a$export$8372ed2fbac2c87d).getAllUsers().then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $ebde8a7c66f56ed6$export$b853a0ab771d622c() {
    return (0, $14f3ca0faa7e905a$export$8372ed2fbac2c87d).getAllRoles().then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
async function $ebde8a7c66f56ed6$export$7d0f10f273c0438a(id) {
    return (0, $14f3ca0faa7e905a$export$8372ed2fbac2c87d).deleteUser(id).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
async function $ebde8a7c66f56ed6$export$e2d248ad5f50b880(id, role) {
    return (0, $14f3ca0faa7e905a$export$8372ed2fbac2c87d).editUserRole(id, role).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
async function $ebde8a7c66f56ed6$export$7ee7664ce5ce7d6(name, email, role) {
    return (0, $14f3ca0faa7e905a$export$8372ed2fbac2c87d).addUser(name, email, role).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}






parcelRequire("igtsr");
const $1a623ffa594b14d7$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            d: "M492 236H276V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v216H20c-11.046 0-20 8.954-20 20s8.954 20 20 20h216v216c0 11.046 8.954 20 20 20s20-8.954 20-20V276h216c11.046 0 20-8.954 20-20s-8.954-20-20-20"
        })
    });
var $1a623ffa594b14d7$export$2e2bcd8739ae039 = $1a623ffa594b14d7$var$SvgPlus;


/**
 * @author Salma Hefnawy
 * @date 2021-04-03
 * @description add user component
 * @filename add-user.tsx
 */ 

var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");







class $42b4e493ab4e8d3c$var$AddUser extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            rolesMenu: false,
            loading: false
        };
        this.handleAddUser = this.handleAddUser.bind(this);
    }
    handleAddUser(values) {
        (0, $ebde8a7c66f56ed6$export$7ee7664ce5ce7d6)(values.name, values.email, values.role).then((result)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
            this.props.onSubmit();
            this.props.onFinish();
        }).catch((errors)=>{
            errors.forEach((error)=>(0, $d41f521f78665649$export$b410431fab84fa58).error(error));
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "settings settings--user-management",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {})
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "settings settings--user-management",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                        className: "card--title",
                        children: t("addUser")
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                        onSubmit: (values)=>this.handleAddUser(values),
                        initialValues: {
                            name: "",
                            email: "",
                            role: ""
                        },
                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                            name: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required(t("requiredName")).min(3, t("min3Characters")),
                            email: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().email(t("validEmail")).required(t("requiredEmail")),
                            role: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required()
                        }),
                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                className: "card--section",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "name",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "name",
                                                        children: t("userName")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        placeholder: t("enterUserName"),
                                                        name: "name",
                                                        type: "text",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "email",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "email",
                                                        children: t("email")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        placeholder: t("enterNewEmail"),
                                                        name: "email",
                                                        type: "text",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "role",
                                        children: ({ meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "role",
                                                        children: t("role")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "form-field",
                                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "dropdown-container",
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    rolesMenu: !this.state.rolesMenu
                                                                });
                                                            },
                                                            children: [
                                                                formikBag.values.role.length ? formikBag.values.role : "select",
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                                    className: "dropdown-icon"
                                                                }),
                                                                this.state.rolesMenu && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                                                    className: "dropdown-menu",
                                                                    children: this.props.roles?.map((role, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                                            className: "item",
                                                                            onClick: ()=>{
                                                                                formikBag.setFieldValue("role", role);
                                                                            },
                                                                            children: role
                                                                        }, index))
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "action-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "submit",
                                                className: "button save",
                                                disabled: !(formikBag.isValid && formikBag.dirty),
                                                children: t("saveChanges")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                className: "button-outline",
                                                type: "button",
                                                onClick: ()=>this.props.onFinish(),
                                                children: t("cancel")
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                ]
            })
        });
    }
}
$42b4e493ab4e8d3c$var$AddUser.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $42b4e493ab4e8d3c$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($42b4e493ab4e8d3c$var$AddUser);



class $8d5da7ac046e8423$var$UserManagement extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props), this.showModal = ()=>{
            this.setState({
                showModal: true
            });
        }, this.hideModal = ()=>{
            this.setState({
                showModal: false
            });
        };
        this.state = {
            loading: false,
            id: Date.now().toString(),
            rolesMenu: false,
            addUser: false,
            showModal: false,
            users: [],
            roles: [],
            userId: ""
        };
        this.loadData = this.loadData.bind(this);
        this.handleEditUserRole = this.handleEditUserRole.bind(this);
        this.handleDeleteUser = this.handleDeleteUser.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        this.loadData();
    }
    handleEditUserRole(id, role) {
        this.setState({
            loading: true
        });
        (0, $ebde8a7c66f56ed6$export$e2d248ad5f50b880)(id, role).then((result)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
            this.loadData();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                loading: false
            });
        });
    }
    handleDeleteUser(id) {
        this.setState({
            loading: true
        });
        (0, $ebde8a7c66f56ed6$export$7d0f10f273c0438a)(id).then((result)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success(result.message);
            this.loadData();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                loading: false
            });
        }).finally(()=>{
            this.hideModal();
        });
    }
    loadData() {
        this.setState({
            loading: true
        });
        let getUsersPromise = Promise.resolve();
        let getRolesPromise = Promise.resolve();
        getUsersPromise = (0, $ebde8a7c66f56ed6$export$69093b9c569a5b5b)().then((users)=>{
            this.setState({
                users: users
            });
        });
        getRolesPromise = (0, $ebde8a7c66f56ed6$export$b853a0ab771d622c)().then((roles)=>{
            this.setState({
                roles: roles
            });
        });
        Promise.all([
            getUsersPromise,
            getRolesPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "settings settings--user-management",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {})
        });
        if (this.state.addUser) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42b4e493ab4e8d3c$export$2e2bcd8739ae039), {
            onFinish: ()=>this.setState({
                    addUser: false
                }),
            onSubmit: ()=>this.loadData(),
            roles: this.state.roles
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "settings settings--user-management",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card__heading",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                            className: "card--title",
                                            children: t("userManagement")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                            className: "note",
                                            children: t("manageUsersAndRoles")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                    type: "button",
                                    className: "button--main",
                                    onClick: ()=>this.setState({
                                            addUser: true
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1a623ffa594b14d7$export$2e2bcd8739ae039), {}),
                                        t("addUser")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "table table--four-columns",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "table__head",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                            children: t("userName")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                            children: t("email")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                            children: t("role")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "table__body",
                                    children: this.state.users?.map((user)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dl", {
                                            className: "table__body-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "table__head--responsive",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dt", {
                                                            children: t("userName")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                            children: user.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "table__head--responsive",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dt", {
                                                            children: t("email")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dd", {
                                                            className: "email",
                                                            children: user.email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "table__head--responsive",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("dt", {
                                                            children: t("role")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("dd", {
                                                            className: "dropdown-container",
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    rolesMenu: !this.state.rolesMenu,
                                                                    userId: user.id
                                                                });
                                                            },
                                                            children: [
                                                                user.roles[0],
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                                    className: "dropdown-icon"
                                                                }),
                                                                this.state.userId === user.id && this.state.rolesMenu && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                                                    className: "dropdown-menu",
                                                                    children: this.state.roles?.map((role, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                                            className: "item",
                                                                            onClick: ()=>{
                                                                                this.handleEditUserRole(user.id, role);
                                                                            },
                                                                            children: role
                                                                        }, index))
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "button--clear button__delete",
                                                    onClick: ()=>{
                                                        this.showModal();
                                                        this.setState({
                                                            userId: user.id
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2742632e86fe22d3$export$2e2bcd8739ae039), {}),
                                                        t("deleteUser")
                                                    ]
                                                })
                                            ]
                                        }, user.id))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1aff520041650bb7$export$2b77a92f1a5ad772), {
                    showModal: this.state.showModal,
                    handleClose: this.hideModal,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "settings__modal",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                className: "settings__modal-title",
                                children: t("deleteConfirmationTitle")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "settings__modal-actions",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "button",
                                        className: "button--main button--delete",
                                        onClick: ()=>{
                                            this.handleDeleteUser(this.state.userId);
                                        },
                                        children: t("delete")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                        type: "button",
                                        className: "button-outline",
                                        onClick: this.hideModal,
                                        children: t("cancel")
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}
$8d5da7ac046e8423$var$UserManagement.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $8d5da7ac046e8423$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($8d5da7ac046e8423$var$UserManagement);


/**
 * @author Youssef Tarek
 * @date 2022-10-11
 * @description ecommerce platform integration
 * @filename index.tsx
 */ 


var $igtsr = parcelRequire("igtsr");




class $1f6b206917060609$var$IntegrationKeysSettings extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            id: "project-keys",
            isApiKeyCopied: false,
            isEncryptionKeyCopied: false
        };
    }
    componentDidMount() {
        this.loadData();
        this.context.hideIntegrationKeysModal();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    /**
   * add the respective steps for integrating each platform with onesight
   * @param platform third party platform
   * @param t
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
    getPlatformSteps(platform, t) {
        switch(platform){
            case "magento":
                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                            children: [
                                `${t("downloadMagentoExtension")}: `,
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                    className: "external-link",
                                    href: "https://marketplace.magento.com/robusta-studio-analytics.html",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Onesight Analytics"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ol", {
                            className: "settings-integration-keys__sub-list",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("goToMagentoAdminPanel")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("goToStores")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("goToConfiguration")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("goToRobustaAnalytics")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("pasteYourKeys")
                                })
                            ]
                        })
                    ]
                });
            case "woocommerce":
                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                            children: [
                                `${t("downloadWoocommerceExtension")}: `,
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                    className: "external-link",
                                    href: "https://wordpress.org/plugins/onesight-integration-for-woocommerce/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Onesight Integration for WooCommerce"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ol", {
                            className: "settings-integration-keys__sub-list",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("goToWordpressAdminPanel")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("goToPlugins")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("selectAddNew")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("installOnesight")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                    className: "settings-integration-keys__sub-list-item",
                                    children: t("pasteYourKeys")
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    }
    loadData() {
        (0, $56fb02d394e3f062$export$8eaa366290b040c4)(this.context?.project).then((response)=>{
            this.setState({
                apiKey: response.api_key,
                encryptionKey: response.encryption_key,
                loading: false
            });
        });
    }
    /**
   *
   * @param text the keys to be put in the clipboard
   * @param copiedInput this indicates the state to show which key was copied
   * @param timeout to show that key has been copied for 2 seconds
   */ copyTextToClipboard(text, copiedInput, timeout = 2000) {
        this.setState({
            [copiedInput]: true
        });
        navigator.clipboard.writeText(text);
        setTimeout(()=>{
            this.setState({
                [copiedInput]: false
            });
        }, timeout);
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "settings",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                className: "card",
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "settings-integration-keys",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: t("integrationKeys")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                            className: "note",
                            children: t("integrationKeysDescription")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                            className: "input-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                    htmlFor: "apiKey",
                                    children: t("apiIntegrationKey")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "input-with-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                            type: "password",
                                            name: "apiKey",
                                            id: "apiKey",
                                            value: this.state.apiKey,
                                            readOnly: true
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                            type: "button",
                                            className: "button--clear",
                                            onClick: ()=>{
                                                this.copyTextToClipboard(this.state.apiKey, "isApiKeyCopied");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fd7c4d9fa842da01$export$2e2bcd8739ae039), {}),
                                                this.state.isApiKeyCopied ? t("copied") : t("copy")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "input-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                    htmlFor: "encryptionKey",
                                    children: t("encryptionIntegrationKey")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "input-with-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                            type: "password",
                                            name: "encryptionKey",
                                            id: "encryptionKey",
                                            value: this.state.encryptionKey,
                                            readOnly: true
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                            type: "button",
                                            className: "button--clear",
                                            onClick: ()=>{
                                                this.copyTextToClipboard(this.state.encryptionKey, "isEncryptionKeyCopied");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fd7c4d9fa842da01$export$2e2bcd8739ae039), {}),
                                                this.state.isEncryptionKeyCopied ? t("copied") : t("copy")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "settings-integration-keys__steps",
                            children: this.getPlatformSteps(this.context?.settings?.platform, t)
                        })
                    ]
                })
            })
        });
    }
}
$1f6b206917060609$var$IntegrationKeysSettings.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $1f6b206917060609$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($1f6b206917060609$var$IntegrationKeysSettings);


/**
 * @author Sarah Nouh
 * @date 2022-01-04
 * @description settings payment and subscriptions tab content
 * @filename payments-and-subscriptiontsx
 */ 

var $igtsr = parcelRequire("igtsr");
function $17879b2ff0735ff0$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



function $966cae97e2c42088$export$b5147a91dc40ddb7(laterDate, earlierDate, options) {
    const diff = (0, $0e206fafd570fe71$export$86415ebf4eb36b8c)(laterDate, earlierDate, options) / 7;
    return (0, $17879b2ff0735ff0$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$966cae97e2c42088$export$2e2bcd8739ae039 = $966cae97e2c42088$export$b5147a91dc40ddb7;









const $1df9c1f8c087c308$export$bd97b31331cfd83 = [
    {
        title: "Basic",
        price: "Free",
        featruesList: [
            "Overview Reports",
            "Orders Reports",
            "Customers Reports",
            "Categories' Reports",
            "Products' Reports",
            "Comparing Pre-defined Time Periods"
        ]
    },
    {
        title: "Premium",
        price: "150EGP",
        featruesList: [
            "Overview Reports",
            "Orders Reports",
            "Customers Reports",
            "Categories' Reports",
            "Products' Reports",
            "Comparing Pre-defined Time Periods",
            "Comparing Custom Time Periods",
            "Exporting as a CSV",
            "Email Notifications"
        ]
    },
    {
        title: "Professional",
        price: "200EGP",
        featruesList: [
            "Overview Reports",
            "Orders Reports",
            "Customers Reports",
            "Categories' Reports",
            "Products' Reports",
            "Comparing Pre-defined Time Periods",
            "Comparing Custom Time Periods",
            "Exporting as a CSV",
            "Email Notifications",
            "Google Analytics Integration",
            "Product Insights"
        ]
    }
];
const $1df9c1f8c087c308$export$179cfa63dd43ef6f = [
    "twoweekstrial",
    "sixweekstrial",
    "starter",
    "pro",
    "premium"
];
const $1df9c1f8c087c308$export$9fa04d42e5fe01b1 = {
    starter: {
        description: "starterDesc",
        features: [
            "standardSupport"
        ]
    },
    pro: {
        description: "proDesc",
        features: [
            "standardSupport"
        ]
    },
    premium: {
        description: "premiumDesc",
        features: [
            "dedicatedSupport"
        ]
    }
};


/* eslint-disable class-methods-use-this */ /**
 * @author Ahmed Elshantaly
 * @date 2022-02-13
 * @description Payment method form
 * @filename payment-method-form.tsx
 */ 

var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");






const $595794282561c14f$var$postURL = "https://checkout.PayFort.com/FortAPI/paymentPage";
class $595794282561c14f$var$PaymentMethodForm extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    // Format expiry date to YYMM format as required by Payfort
    static formatExpiryDate(date) {
        const formatedDate = date.split("/");
        return formatedDate.length === 2 ? `${formatedDate[1]}${formatedDate[0]}` : date;
    }
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            access_code: "",
            language: "",
            merchant_identifier: "",
            merchant_reference: "",
            return_url: "",
            service_command: "",
            signature: "",
            remember_me: "YES"
        };
        this.FormRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.addPaymentMethod = this.addPaymentMethod.bind(this);
        this.loadSignature = this.loadSignature.bind(this);
    }
    componentDidMount() {
        this.loadSignature();
        this.context.hideIntegrationKeysModal();
    }
    loadSignature() {
        (0, $56fb02d394e3f062$export$2f768fec5d73d91a)().then((signature)=>{
            this.setState({
                ...signature,
                loading: false
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                loading: false
            });
        });
    }
    addPaymentMethod(values, formikHelpers) {
        const formElements = this.FormRef.current.elements;
        // remove spaces between numbers before form submission
        formElements.card_number.value = formElements.card_number.value.replace(/\s/g, "");
        formElements.expiry_date.value = $595794282561c14f$var$PaymentMethodForm.formatExpiryDate(formElements.expiry_date.value);
        this.FormRef.current.submit();
        this.setState({
            loading: true
        });
        formikHelpers.resetForm();
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "account-settings",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                        className: "card--title",
                        children: t("addCardInformation")
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                        onSubmit: this.addPaymentMethod,
                        initialValues: {
                            card_number: "",
                            card_holder_name: "",
                            expiry_date: "",
                            card_security_code: "",
                            access_code: this.state.access_code,
                            language: this.state.language,
                            merchant_identifier: this.state.merchant_identifier,
                            merchant_reference: this.state.merchant_reference,
                            return_url: this.state.return_url,
                            service_command: this.state.service_command,
                            signature: this.state.signature,
                            remember_me: this.state.remember_me
                        },
                        validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                            card_number: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().length(19, t("cardNumberError")).required(t("requiredField")),
                            card_holder_name: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required(t("requiredField")),
                            expiry_date: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().length(5, t("cardExpiryDateError")).required(t("requiredField")),
                            card_security_code: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().length(3, t("cardCVVError")).required(t("requiredField"))
                        }),
                        children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                ref: this.FormRef,
                                className: "card--section",
                                method: "post",
                                action: $595794282561c14f$var$postURL,
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "access_code",
                                        type: "hidden",
                                        value: this.state.access_code
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "signature",
                                        type: "hidden",
                                        value: this.state.signature
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "service_command",
                                        type: "hidden",
                                        value: this.state.service_command
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "merchant_identifier",
                                        type: "hidden",
                                        value: this.state.merchant_identifier
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "merchant_reference",
                                        type: "hidden",
                                        value: this.state.merchant_reference
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "language",
                                        type: "hidden",
                                        value: this.state.language
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "return_url",
                                        type: "hidden",
                                        value: this.state.return_url
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                        name: "remember_me",
                                        type: "hidden",
                                        value: this.state.remember_me
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "card_number",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "card_number",
                                                        children: t("cardNumber")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        placeholder: "XXXX XXXX XXXX XXXX",
                                                        name: "card_number",
                                                        type: "tel",
                                                        maxLength: "19",
                                                        pattern: "[0-9\\s]{13,19}",
                                                        ...field,
                                                        value: field.value.replace(/\s/g, "").replace(/(\d{4})/g, "$1 ").trim() ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "card_holder_name",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "card_holder_name",
                                                        children: t("cardName")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        placeholder: t("cardName"),
                                                        name: "card_holder_name",
                                                        type: "text",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "expiry_date",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "expiry_date",
                                                        children: t("cardExpiryDate")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        placeholder: "XX/XX",
                                                        name: "expiry_date",
                                                        type: "tel",
                                                        maxLength: "5",
                                                        ...field,
                                                        value: field.value.replace(/^([1-9]\/|[2-9])$/g, "0$1/" // 3 > 03/
                                                        ).replace(/^(0[1-9]|1[0-2])$/g, "$1/" // 11 > 11/
                                                        ).replace(/^1([3-9])$/g, "01/$1" // 13 > 01/3
                                                        ).replace(/^0\/|0+$/g, "0" // 0/ > 0 and 00 > 0
                                                        ).replace(/[^\d|^/]*/g, "" // To allow only digits and `/`
                                                        ).replace(/\/\//g, "/" // Prevent entering more than 1 `/`
                                                        ) ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                        name: "card_security_code",
                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                        htmlFor: "card_security_code",
                                                        children: t("cardCVV")
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                        placeholder: "XXX",
                                                        name: "card_security_code",
                                                        type: "tel",
                                                        maxLength: "3",
                                                        ...field,
                                                        value: field.value ?? ""
                                                    }),
                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                        className: "error",
                                                        children: meta.error
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "action-buttons",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                type: "submit",
                                                className: "button save",
                                                disabled: formikBag.isSubmitting,
                                                children: t("save")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                className: "button-outline",
                                                type: "button",
                                                onClick: ()=>this.props.onFinish(),
                                                children: t("cancel")
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                ]
            })
        });
    }
}
$595794282561c14f$var$PaymentMethodForm.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $595794282561c14f$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($595794282561c14f$var$PaymentMethodForm);


/**
 * @author Sarah Nouh
 * @date 2022-01-09
 * @description subscription plans options page
 * @filename plans.tsx
 */ 

var $igtsr = parcelRequire("igtsr");





parcelRequire("igtsr");
const $c2537cce3b8bc9b3$var$SvgFeatureCheck = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 16,
        height: 16,
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    id: "feature-check_svg__a",
                    d: "M4 8.43H.999a1 1 0 0 1-.999-1v.988c0-.552.443-1 .999-1H3l-.076-6.417A.99.99 0 0 1 3.912 0h-1a1.01 1.01 0 0 1 1.012 1L4 7.42z"
                })
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        fill: "#F8F9FD",
                        d: "M-564-375H802v898H-564z"
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        transform: "translate(-50 -265)",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                                width: 822,
                                height: 738,
                                fill: "#FFF",
                                stroke: "#9DA4C2",
                                strokeOpacity: 0.164,
                                rx: 10
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                                transform: "translate(30 155)",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                                        width: 186,
                                        height: 183,
                                        stroke: "#EFF0F6",
                                        rx: 10
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                                        transform: "translate(20 110)",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 7,
                                                fill: "#38CCAA"
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("use", {
                                                xlinkHref: "#feature-check_svg__a",
                                                fill: "#FFF",
                                                transform: "rotate(45 1.274 13.167)"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $c2537cce3b8bc9b3$export$2e2bcd8739ae039 = $c2537cce3b8bc9b3$var$SvgFeatureCheck;





parcelRequire("igtsr");
const $2d5264652076e70a$var$SvgCancel = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 30 30",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                        id: "cancel_svg__a",
                        width: 432,
                        height: 274,
                        x: 0,
                        y: 0,
                        rx: 10
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        id: "cancel_svg__c",
                        d: "M8.571 8.571v5.836a.595.595 0 0 1-.608.593h-.926a.61.61 0 0 1-.608-.593V8.57H.593A.595.595 0 0 1 0 7.963v-.926c0-.336.276-.608.593-.608H6.43V.593c0-.327.262-.593.608-.593h.926c.336 0 .608.276.608.593V6.43h5.836c.327 0 .593.262.593.608v.926a.61.61 0 0 1-.593.608z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        fill: "#FFF",
                        d: "M-839-289H527v768H-839z"
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        fill: "#FFF",
                        stroke: "#E5EAEE",
                        d: "M-189.5-10.654h484v37.375h-484z"
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        fill: "#212121",
                        d: "M-839-289H528v934H-839z",
                        opacity: 0.2
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        transform: "translate(-372 -32)",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("use", {
                                xlinkHref: "#cancel_svg__a",
                                fill: "#000",
                                filter: "url('b0be4eae40b0efc9')"
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("use", {
                                xlinkHref: "#cancel_svg__a",
                                fill: "#FFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        fill: "#1792FF",
                        transform: "translate(3 3)",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                                cx: 12,
                                cy: 12,
                                r: 12,
                                opacity: 0.299
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("use", {
                                xlinkHref: "#cancel_svg__c",
                                transform: "rotate(45 4.318 15.182)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $2d5264652076e70a$export$2e2bcd8739ae039 = $2d5264652076e70a$var$SvgCancel;




/**
 * @author Youssef Tarek
 * @date 2022-10-23
 * @description component to show a plan
 * @filename plan.tsx
 */ 

var $igtsr = parcelRequire("igtsr");



class $6ef7419ec47ba5ff$var$Plan extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
            className: `${this.props.active ? "plans-list__item selected" : "plans-list__item"} ${this.props.selected && "chosen"}`,
            onClick: this.props.onSelect,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                    className: "title",
                    children: this.props.tier
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                    className: "price",
                    children: [
                        `${this.props.currency} ${this.props.price}`,
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                            className: "price__period",
                            children: ` / ${t("month")}`
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                            className: "description",
                            children: this.props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                    className: "feature-list",
                    children: this.props.features.map((feature, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                            className: "feature-list__item",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c2537cce3b8bc9b3$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    children: t(feature)
                                })
                            ]
                        }, index))
                })
            ]
        });
    }
}
$6ef7419ec47ba5ff$var$Plan.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $6ef7419ec47ba5ff$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($6ef7419ec47ba5ff$var$Plan);


class $6136693c1fc98d94$var$SubscriptionPlans extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            pricings: [],
            selectedPlan: "",
            showChangeTierModal: false,
            changeTierInfo: null,
            isButtonDisabled: false
        };
        this.loadData = this.loadData.bind(this);
        this.changeTierHandler = this.changeTierHandler.bind(this);
        this.showChangeTierModal = this.showChangeTierModal.bind(this);
        this.hideChangeTierModal = this.hideChangeTierModal.bind(this);
        this.confirmChangeTier = this.confirmChangeTier.bind(this);
        this.choosePlanHandler = this.choosePlanHandler.bind(this);
        this.selectPlan = this.selectPlan.bind(this);
    }
    componentDidMount() {
        this.loadData();
    }
    // eslint-disable-next-line class-methods-use-this
    showPricing(pricing, t) {
        if (pricing.max_orders) return `${t("upTo")} ${pricing.max_orders} ${t("orders")}`;
        return `${t("unlimited")} ${t("orders")}`;
    }
    loadData() {
        this.setState({
            loading: true
        });
        (0, $56fb02d394e3f062$export$feab92affbe26cb8)().then((pricings)=>{
            this.setState({
                pricings: pricings.data
            });
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
    }
    choosePlanHandler(t) {
        if (this.state.selectedPlan === "sixWeeksTrial") {
            this.props.toggleChangePlan();
            this.props.toggleAddPaymentMethod();
        }
        // TODO: add condition for trial tier
        if (this.context.settings.subscription_tier === "unsubscribed") {
            this.setState({
                isButtonDisabled: true
            });
            (0, $56fb02d394e3f062$export$ec068583843480e7)(this.state.selectedPlan).then(()=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).success(t("subscriptionPlanChanged"));
            }).catch((err)=>{
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err[0]);
            }).finally(()=>{
                this.setState({
                    isButtonDisabled: false
                });
            });
        } else this.changeTierHandler();
    }
    changeTierHandler() {
        if (this.props.defaultCard) (0, $56fb02d394e3f062$export$7c1aaa4d7508f827)(this.state.selectedPlan).then((changeTierInfo)=>{
            this.setState({
                changeTierInfo: changeTierInfo
            });
            this.showChangeTierModal();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err[0]);
        });
        else {
            this.props.toggleAddPaymentMethod();
            this.props.toggleChangePlan();
        }
    }
    confirmChangeTier(t) {
        (0, $56fb02d394e3f062$export$91259a2a77442e16)(this.state.selectedPlan).then(()=>{
            this.hideChangeTierModal();
            (0, $d41f521f78665649$export$b410431fab84fa58).success(t("upcomingSubscriptionPlanChanged"));
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
    }
    showChangeTierModal() {
        this.setState({
            showChangeTierModal: true
        });
    }
    hideChangeTierModal() {
        this.setState({
            showChangeTierModal: false
        });
    }
    selectPlan(plan) {
        this.setState({
            selectedPlan: plan
        });
    }
    render() {
        const { t: t } = this.props;
        const isTrial = this.context.settings.subscription_tier === "trial";
        const isSixWeekTrial = isTrial && this.props.defaultCard;
        const isTwoWeekTrial = isTrial && !this.props.defaultCard;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "payment",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                    className: "payment--button-back",
                    type: "button",
                    onClick: this.props.toggleChangePlan,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                        t("backToPaymentAndSubscriptions")
                    ]
                }),
                this.context.settings.is_old_subscription ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                            className: "card--title",
                            children: t("changePlan")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "payment-card",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    className: "payment-card__subtitle",
                                    children: t("chooseTheBestPlanForYourService")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ul", {
                                    className: "plans-list",
                                    children: [
                                        isTrial && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                            children: [
                                                isTwoWeekTrial && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                    className: this.context.settings.subscription_tier === "trial" && !this.props.defaultCard ? "plans-list__item selected" : "plans-list__item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                            className: "title",
                                                            children: t("twoWeeksTrial")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                            className: "price",
                                                            children: t("free")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ul", {
                                                            className: "feature-list",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                                    className: "feature-list__item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c2537cce3b8bc9b3$export$2e2bcd8739ae039), {}),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                            children: t("accessAllFeatures")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                                    className: "feature-list__item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2d5264652076e70a$export$2e2bcd8739ae039), {
                                                                            className: "feature-list__cancel-icon"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                            children: t("noCreditCardRequired")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                    className: `${isSixWeekTrial ? "plans-list__item selected" : "plans-list__item"} ${this.state.selectedPlan === "sixWeeksTrial" && "chosen"}`,
                                                    onClick: ()=>{
                                                        if (isTwoWeekTrial) this.setState({
                                                            selectedPlan: "sixWeeksTrial"
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                            className: "title",
                                                            children: t("sixWeeksTrial")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                            className: "price",
                                                            children: t("free")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ul", {
                                                            className: "feature-list",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                                    className: "feature-list__item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c2537cce3b8bc9b3$export$2e2bcd8739ae039), {}),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                            children: t("accessAllFeatures")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("li", {
                                                                    className: "feature-list__item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c2537cce3b8bc9b3$export$2e2bcd8739ae039), {}),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                                            children: t("creditCardRequired")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        this.state.pricings.map((plan)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $6ef7419ec47ba5ff$export$2e2bcd8739ae039), {
                                                maxOrders: plan.max_orders,
                                                price: plan.price,
                                                maxUsers: plan.max_users,
                                                description: t((0, $1df9c1f8c087c308$export$9fa04d42e5fe01b1)[plan.tier].description),
                                                tier: plan.tier.toUpperCase(),
                                                currency: plan.currency,
                                                active: this.context.settings.subscription_tier === plan.tier,
                                                selected: this.state.selectedPlan === plan.tier,
                                                onSelect: ()=>this.selectPlan(plan.tier),
                                                features: [
                                                    plan.max_orders ? `${t("upTo")} ${plan.max_orders} ${t("orders")} / ${t("month")}` : t("unlimitedOrdersForever"),
                                                    t("allReportsAndFeaturesAccess"),
                                                    plan.max_users ? `${t("upTo")} ${plan.max_users} ${t("users")} / ${t("month")}` : t("unlimitedUsers"),
                                                    ...(0, $1df9c1f8c087c308$export$9fa04d42e5fe01b1)[plan.tier].features
                                                ]
                                            }, plan.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                            type: "submit",
                            disabled: !this.state.selectedPlan || this.state.isButtonDisabled,
                            onClick: ()=>{
                                this.choosePlanHandler(t);
                            },
                            children: t("choosePlan")
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: this.context.settings.subscription_tier === "unsubscribed" ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("stripe-pricing-table", {
                        "pricing-table-id": "prctbl_1Mkq21LCWM76QLbOFna3cWih",
                        "publishable-key": "pk_live_51MU5snLCWM76QLbOj9GUN15thjKtV5ZXfl803ZloW6FIBw0XdCvfdUpMRQY9qqptbyJbH8pemxqweOcN1od9W4Cc00HmfKZY0J"
                    }) : null
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1aff520041650bb7$export$2b77a92f1a5ad772), {
                    showModal: this.state.showChangeTierModal,
                    handleClose: this.hideChangeTierModal,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "settings__modal",
                        children: this.state.changeTierInfo ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                    className: "settings__modal-title",
                                    children: t("changeYourPlan")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                    className: "settings__modal-description",
                                    children: `${t("youWillBeCharged")} ${this.state.changeTierInfo?.amount_owed} $ ${t("now")} ${t("andThePackageAutomaticallyRenews")} ${this.state.changeTierInfo?.monthly_payment_amount} $`
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "settings__modal-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "button",
                                            className: "button--main button--delete button--link",
                                            onClick: ()=>this.confirmChangeTier(t),
                                            children: t("changePlan")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "button",
                                            className: "button-outline",
                                            onClick: ()=>this.hideChangeTierModal(),
                                            children: t("cancel")
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {})
                    })
                })
            ]
        });
    }
}
$6136693c1fc98d94$var$SubscriptionPlans.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $6136693c1fc98d94$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($6136693c1fc98d94$var$SubscriptionPlans);


/* eslint-disable class-methods-use-this */ /**
 * @author Ahmed Elshantaly
 * @date 2022-02-14
 * @description Payment method card
 * @filename payment-method.tsx
 */ 

var $igtsr = parcelRequire("igtsr");



parcelRequire("igtsr");
const $82f0f9ef37830bec$var$SvgMastercard = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 36,
        height: 25,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FF5F00",
                    d: "M13 4.213h10v15H13z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#EB001B",
                    d: "M14.223 11.499C14.22 8.584 15.613 5.83 18 4.03 13.945.97 8.123 1.416 4.624 5.055c-3.499 3.64-3.499 9.25 0 12.89S13.945 22.03 18 18.969c-2.387-1.8-3.78-4.555-3.777-7.47"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#F79E1B",
                    d: "M33.23 19.213v-.828h.167v-.172H33v.172h.157v.828zm.77 0v-1h-.12l-.14.714-.14-.714h-.12v1h.087v-.757l.13.65h.09l.13-.65v.757zm0-7.712c0 3.637-2.162 6.955-5.567 8.544S20.976 21.216 18 18.968c2.385-1.8 3.778-4.554 3.778-7.468S20.385 5.832 18 4.032c2.976-2.248 7.027-2.666 10.433-1.077C31.838 4.545 34 7.862 34 11.499z"
                })
            ]
        })
    });
var $82f0f9ef37830bec$export$2e2bcd8739ae039 = $82f0f9ef37830bec$var$SvgMastercard;



parcelRequire("igtsr");
const $1b6a9f085262f658$var$SvgVisa = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 141.732 141.732",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                fill: "#2566af",
                d: "M62.935 89.571h-9.733l6.083-37.384h9.734zM45.014 52.187 35.735 77.9l-1.098-5.537.001.002-3.275-16.812s-.396-3.366-4.617-3.366h-15.34l-.18.633s4.691.976 10.181 4.273l8.456 32.479h10.141l15.485-37.385zm76.555 37.384h8.937l-7.792-37.385h-7.824c-3.613 0-4.493 2.786-4.493 2.786L95.881 89.571h10.146l2.029-5.553h12.373zm-10.71-13.224 5.114-13.99 2.877 13.99zm-14.217-15.17 1.389-8.028s-4.286-1.63-8.754-1.63c-4.83 0-16.3 2.111-16.3 12.376 0 9.658 13.462 9.778 13.462 14.851s-12.075 4.164-16.06.965l-1.447 8.394s4.346 2.111 10.986 2.111c6.642 0 16.662-3.439 16.662-12.799 0-9.72-13.583-10.625-13.583-14.851.001-4.227 9.48-3.684 13.645-1.389"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                fill: "#e6a540",
                d: "m34.638 72.364-3.275-16.812s-.396-3.366-4.617-3.366h-15.34l-.18.633s7.373 1.528 14.445 7.253c6.762 5.472 8.967 12.292 8.967 12.292"
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                fill: "none",
                d: "M0 0h141.732v141.732H0z"
            })
        ]
    });
var $1b6a9f085262f658$export$2e2bcd8739ae039 = $1b6a9f085262f658$var$SvgVisa;




class $6f997e7e35a9d7b0$var$PaymentMethod extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.handleDeleteCard = this.handleDeleteCard.bind(this);
        this.handleMakeDefault = this.handleMakeDefault.bind(this);
        this.formatExpiryDate = this.formatExpiryDate.bind(this);
    }
    handleDeleteCard() {
        (0, $56fb02d394e3f062$export$cbb49d44ad636b27)(this.props.id).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Card deleted successfully");
            this.props.onFinish();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
    }
    handleMakeDefault() {
        (0, $56fb02d394e3f062$export$5b7d59380be0b8b5)(this.props.id).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Card is set as default");
            this.props.onFinish();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
    }
    // Format expiry date to MM/YY f
    formatExpiryDate(date) {
        const formatedDate = date.split("");
        return `${formatedDate[2]}${formatedDate[3]}/${formatedDate[0]}${formatedDate[1]}`;
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "payment-method",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "payment-method__info",
                    children: [
                        this.props.cardType.toLowerCase() === "mastercard" ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $82f0f9ef37830bec$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1b6a9f085262f658$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    children: `${this.props.cardType.toLowerCase()} ${t("endingWith")} ${this.props.cardEndingWith.substr(-4)}`
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                    children: [
                                        t("expiry"),
                                        " ",
                                        this.formatExpiryDate(this.props.expiryDate)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "payment-method__actions",
                    children: [
                        !this.props.default && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                            type: "button",
                            className: "edit",
                            onClick: this.handleMakeDefault,
                            children: t("makeDefault")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                            type: "button",
                            className: "delete",
                            onClick: this.handleDeleteCard,
                            children: t("deleteCard")
                        })
                    ]
                })
            ]
        });
    }
}
$6f997e7e35a9d7b0$var$PaymentMethod.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $6f997e7e35a9d7b0$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($6f997e7e35a9d7b0$var$PaymentMethod);


// subscription plans to know their order
const $a4061a036711a45a$var$subscriptionPlans = [
    "unsubscribed",
    "trial",
    "starter",
    "pro",
    "premium"
];
class $a4061a036711a45a$var$PaymentsAndSubscriptions extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            addPaymentMethod: false,
            changePlan: false,
            loading: true,
            otherCards: []
        };
        this.loadSubscriptionData = this.loadSubscriptionData.bind(this);
        this.paymentMethodChangeHandler = this.paymentMethodChangeHandler.bind(this);
        this.toggleChangePlan = this.toggleChangePlan.bind(this);
        this.toggleAddPaymentMethod = this.toggleAddPaymentMethod.bind(this);
    }
    componentDidMount() {
        /* because of the latency that happens between server to server responses, the updated data
      is not saved in the server by the time we are redirected from the payment service
      so we have to wait to ensure that the data is updated in the backend */ this.timeout = setTimeout(this.loadSubscriptionData, 3500);
        const query = window.location.search;
        const params = new URLSearchParams(query);
        const wantedPlan = params.get("plan");
        const addingCardStatus = params.get("success");
        if (wantedPlan && /*
        The next line we had to set the queryPlan type to never because typescript throws
        an error because the argument of the includes method is a string and the array is
        readonly of a subset of the string. This is not logical because it will return
        false if it's not included, so we set the type to never to bypass it.
       */ (0, $1df9c1f8c087c308$export$179cfa63dd43ef6f).includes(wantedPlan) && !addingCardStatus) this.setState({
            addPaymentMethod: true
        });
        else if (addingCardStatus === "0") (0, $d41f521f78665649$export$b410431fab84fa58).error("Card has been declined");
        else if (addingCardStatus === "1") {
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Card has been added successfully");
            /* since the waiting time from the payment service is not predicted or consistent
       so we check if the data is updated until we get the confirmation
       we need this update for the renewal date which is mainly changed when we add
       a credit card for the first time */ if (this.context.settings.subscription_tier === "trial" && !this.state.defaultCard) {
                const interval = setInterval(()=>{
                    this.loadSubscriptionData();
                    if ((0, $966cae97e2c42088$export$b5147a91dc40ddb7)(new Date(this.context.settings.trial_ends_at), new Date(this.context.settings.created_at)) >= 6) clearInterval(interval);
                }, 6000);
            }
        }
        // check if we are redirected from exceeding orders limit modal
        if (this.context.showingExceedingOrdersLimitModal) {
            this.toggleChangePlan();
            this.context.hideExceedingOrdersLimitModal();
        }
    }
    componentWillUnmount() {
        clearTimeout(this.timeout);
    }
    // eslint-disable-next-line class-methods-use-this
    handleUnsubscribe() {
        (0, $56fb02d394e3f062$export$f500693cef883ffd)().then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("You have successfully unsubscribed");
        }).catch(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error("something went wrong");
        });
    }
    /**
   * return tier name according to subscription plan
   * if subscription tier is "trial" then automatically it's a "2 week trial"
   * but if the user adds their credit card it automatically becomes "6 week trial"
   * @returns tier name
   */ getTier() {
        if (this.context.settings.subscription_tier) return this.context.settings.subscription_tier.toUpperCase();
        if ((0, $966cae97e2c42088$export$b5147a91dc40ddb7)(new Date(this.context.settings.trial_ends_at), new Date(this.context.settings.created_at)) >= 6) return "6 Weeks Free Trial";
        return "2 Weeks Free Trial";
    }
    /**
   * return the renewal date in the desired format
   * @returns renewal date according to the application's language
   */ getRenewalDate(t) {
        // if a user upgrades within a trial period
        if (this.context.settings.subscription_tier === "trial" && this.context.settings.upcoming_tier !== "unsubscribed") return `${t("trialEndsAt")} ${new Date(this.context.settings.trial_ends_at).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric",
            month: "long",
            day: "numeric"
        })} ${t("andYouWillBeAutomaticallyUpgradedTo")} ${this.context.settings.upcoming_tier}`;
        // if the user cancels the subscription, whether in trial or not
        if (this.context.settings.upcoming_tier === "unsubscribed") return `${t("yourPlanWillBeCancelledOn")} ${new Date(this.context.settings.expiry || this.context.settings.trial_ends_at).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric",
            month: "long",
            day: "numeric"
        })}`;
        // if a user downgrades their subscription package from a larger package to a smaller package
        if ($a4061a036711a45a$var$subscriptionPlans.indexOf(this.context.settings.subscription_tier) > $a4061a036711a45a$var$subscriptionPlans.indexOf(this.context.settings.upcoming_tier)) return `${t("yourRenewalDateWillBeOn")} ${new Date(this.context.settings.expiry || this.context.settings.trial_ends_at).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric",
            month: "long",
            day: "numeric"
        })} ${t("andYouWillBeAutomaticallyDowngradedTo")} ${this.context.settings.upcoming_tier}`;
        return `${t("yourRenewalDateWillBeOn")} ${new Date(this.context.settings.expiry).toLocaleDateString((0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).language === "en" ? "en-us" : "ar-eg", {
            year: "numeric",
            month: "long",
            day: "numeric"
        })}`;
    }
    loadSubscriptionData() {
        this.setState({
            loading: true
        });
        this.context?.loadSettings();
        (0, $56fb02d394e3f062$export$bc61c71d8347e4d9)().then((cards)=>{
            if (cards.length) this.setState({
                otherCards: cards.filter((c)=>!c.is_default),
                defaultCard: cards.find((c)=>c.is_default)
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
        (0, $56fb02d394e3f062$export$31b809cffbd15b25)().then((stripeBalance)=>{
            this.setState({
                stripeBalance: stripeBalance
            });
        });
    }
    paymentMethodChangeHandler() {
        this.setState({
            defaultCard: null,
            otherCards: []
        });
        this.loadSubscriptionData();
    }
    toggleChangePlan() {
        this.setState({
            changePlan: !this.state.changePlan
        });
    }
    toggleAddPaymentMethod() {
        this.setState({
            addPaymentMethod: !this.state.addPaymentMethod
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: [
                !this.state.addPaymentMethod && !this.state.changePlan && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "payment",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                className: "card--title",
                                children: t("paymentsSubscriptions")
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "payment-card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        className: "payment-card__subtitle",
                                        children: t("currentPlan")
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        className: "payment-card__plan",
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                        className: "font-bold",
                                                        children: this.getTier()
                                                    }),
                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                        className: "payment-card__data",
                                                        children: this.getRenewalDate(t)
                                                    }),
                                                    this.state.stripeBalance?.balance ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                                                        className: "payment-card__data",
                                                        children: [
                                                            `${t("yourCurrentBalanceIs")} ${this.state.stripeBalance?.balance} ${this.state.stripeBalance?.currency} `,
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("small", {
                                                                className: "text-grey block",
                                                                children: t("balanceDisclaimer")
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                className: "payment-card__options",
                                                children: [
                                                    this.context.settings.subscription_tier !== "unsubscribed" && !this.context.settings.is_old_subscription ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                        className: "external-link",
                                                        href: `${"https://billing.stripe.com/p/login/3csg0l7lE76Ede8eUU"}?prefilled_email=${encodeURIComponent(this.context.user.email)}`,
                                                        rel: "noreferrer",
                                                        children: t("manageYourSubscription")
                                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "edit",
                                                        onClick: ()=>this.setState({
                                                                changePlan: true
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $89143256da30e053$export$2e2bcd8739ae039), {}),
                                                            " ",
                                                            t("changePlan")
                                                        ]
                                                    }),
                                                    this.context.settings.subscription_tier !== "trial" && this.context.settings.upcoming_tier !== "unsubscribed" && this.context.settings.is_old_subscription ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "cancel-subscription",
                                                        onClick: this.handleUnsubscribe,
                                                        children: t("cancelSubscription")
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            this.context.settings.is_old_subscription ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "payment-details",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                        className: "card--title",
                                        children: t("paymentDetails")
                                    }),
                                    this.state.defaultCard && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                className: "payment-details__subtitle",
                                                children: t("defaultPaymentMethod")
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $6f997e7e35a9d7b0$export$2e2bcd8739ae039), {
                                                id: String(this.state.defaultCard.id),
                                                cardEndingWith: this.state.defaultCard.card_number,
                                                expiryDate: this.state.defaultCard.expiry_date,
                                                cardType: this.state.defaultCard.payment_option,
                                                default: true,
                                                onFinish: ()=>this.paymentMethodChangeHandler()
                                            })
                                        ]
                                    }),
                                    this.state.otherCards.length > 0 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        className: "payment-details__subtitle",
                                        children: t("otherPaymentMethods")
                                    }),
                                    this.state.otherCards.length > 0 && this.state.otherCards.map((c)=>{
                                        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $6f997e7e35a9d7b0$export$2e2bcd8739ae039), {
                                            id: String(c.id),
                                            cardEndingWith: c.card_number,
                                            expiryDate: c.expiry_date,
                                            cardType: c.payment_option,
                                            onFinish: ()=>this.paymentMethodChangeHandler()
                                        }, c.id);
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                        type: "button",
                                        className: "button-outline my-10",
                                        onClick: ()=>this.setState({
                                                addPaymentMethod: true
                                            }),
                                        children: [
                                            "+ ",
                                            t("addPaymentMethod")
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                }),
                this.state.addPaymentMethod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $595794282561c14f$export$2e2bcd8739ae039), {
                    onFinish: ()=>{
                        this.setState({
                            addPaymentMethod: false
                        });
                    }
                }),
                this.state.changePlan && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $6136693c1fc98d94$export$2e2bcd8739ae039), {
                    toggleChangePlan: this.toggleChangePlan,
                    toggleAddPaymentMethod: this.toggleAddPaymentMethod,
                    defaultCard: this.state.defaultCard
                })
            ]
        });
    }
}
$a4061a036711a45a$var$PaymentsAndSubscriptions.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $a4061a036711a45a$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($a4061a036711a45a$var$PaymentsAndSubscriptions);


class $a3a0c9545363f5eb$var$Settings extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    static #_ = /**
   * path to settings page in the url
   */ this.PATH = "/settings";
    static #_2 = /**
   * map of available routes in the app to their locations in the url.
   */ this.ROUTES_TABS = {
        // Add Available Routes with it's Components and other details
        AccountSettings: {
            component: (0, $660f7a2e11ceb83a$export$2e2bcd8739ae039),
            path: `${$a3a0c9545363f5eb$var$Settings.PATH}`,
            exact: true,
            public: false,
            details: {
                icon: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $bafd45c1aa13d5c6$export$2e2bcd8739ae039), {}),
                label: "accountSettings",
                description: "settings:managePersonalInformation"
            },
            roles: []
        },
        PaymentAndSubscription: {
            component: (0, $a4061a036711a45a$export$2e2bcd8739ae039),
            path: `${$a3a0c9545363f5eb$var$Settings.PATH}/payment-and-subscription`,
            exact: true,
            public: false,
            details: {
                icon: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $f1ca3658389e6c8c$export$2e2bcd8739ae039), {}),
                label: "settings:paymentSettings",
                description: "settings:managePaymentDetails"
            },
            roles: [
                (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).admin
            ]
        },
        DataSettings: {
            component: (0, $48fe584aac91d9b2$export$2e2bcd8739ae039),
            path: `${$a3a0c9545363f5eb$var$Settings.PATH}/data-settings`,
            exact: true,
            public: false,
            details: {
                icon: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $857aff21304449ff$export$2e2bcd8739ae039), {}),
                label: "settings:dataSettings",
                description: "settings:setStockSettingsOrderGoals"
            },
            roles: []
        },
        AppearanceSettings: {
            component: (0, $23ec71b40c7bb925$export$2e2bcd8739ae039),
            path: `${$a3a0c9545363f5eb$var$Settings.PATH}/appearance-settings`,
            exact: true,
            public: false,
            details: {
                icon: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $12d2afba1c6aa335$export$2e2bcd8739ae039), {}),
                label: "settings:appearanceSettings",
                description: "settings:customizeColorsAddLogo"
            },
            roles: [
                (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).admin,
                (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).management
            ]
        },
        UserManagement: {
            component: (0, $8d5da7ac046e8423$export$2e2bcd8739ae039),
            path: `${$a3a0c9545363f5eb$var$Settings.PATH}/user-management`,
            exact: true,
            public: false,
            details: {
                icon: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $12e3c11a015c84ba$export$2e2bcd8739ae039), {}),
                label: "userManagement",
                description: "settings:ManageUsersAndRoles"
            },
            roles: [
                (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).admin
            ]
        },
        Integration: {
            component: (0, $b66cd56f79de1ac0$export$2e2bcd8739ae039),
            path: `${$a3a0c9545363f5eb$var$Settings.PATH}/integration`,
            exact: true,
            public: false,
            details: {
                icon: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $74eb3074dad86f13$export$2e2bcd8739ae039), {}),
                label: "GA4Integration",
                description: "settings:authorizeGoogleAnalytics"
            },
            roles: []
        },
        EcommerceIntgeration: {
            component: (0, $1f6b206917060609$export$2e2bcd8739ae039),
            path: `${$a3a0c9545363f5eb$var$Settings.PATH}/integration-keys`,
            exact: true,
            public: false,
            details: {
                icon: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $74eb3074dad86f13$export$2e2bcd8739ae039), {}),
                label: "integrationKeys",
                description: "settings:platformIntegrationKeys"
            },
            roles: []
        }
    };
    componentDidMount() {
        // set page title
        document.title = "Settings";
    }
    render() {
        const { t: t } = this.props;
        const ROUTES = [];
        const TABS = [];
        const AvailableTabs = Object.keys($a3a0c9545363f5eb$var$Settings.ROUTES_TABS);
        for (const tab of AvailableTabs){
            // show tab only if the user is permitted according to his role
            const userHasPermission = (0, $48f673e197675daa$export$b325ec6732b039cf)($a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].roles, this.context.user.roles);
            // deny access to user management tab if user is super admin
            const userManagementTabAccessRight = !(this.context.user.is_admin && $a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].details.label === "userManagement");
            if (userHasPermission && userManagementTabAccessRight) {
                ROUTES.push(/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$e7b0ac011bb776c6), {
                    path: $a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].path,
                    exact: $a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].exact,
                    component: $a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].component
                }, tab));
                TABS.push({
                    label: t($a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].details.label),
                    description: t($a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].details.description),
                    icon: $a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].details.icon,
                    active: $a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].path === this.props.location.pathname,
                    onSelectTab: ()=>{
                        if ($a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].path !== this.props.location.pathname) this.props.history.push($a3a0c9545363f5eb$var$Settings.ROUTES_TABS[tab].path);
                    }
                });
            }
        }
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "settings",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("settings"),
                    showPeriod: false
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "settings-container",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $9d1822deacea1a5a$export$2e2bcd8739ae039), {
                            tabs: TABS
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$b5d5cf8927ab7262), {
                            children: ROUTES
                        })
                    ]
                })
            ]
        });
    }
}
$a3a0c9545363f5eb$var$Settings.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $a3a0c9545363f5eb$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("settings")($a3a0c9545363f5eb$var$Settings);


/**
 * @author Ahmed Serag
 * @date 2021-06-09
 * @description Stock tab in the app.
 * @filename stock.tsx
 */ 


var $igtsr = parcelRequire("igtsr");

















class $f6e85a1b1d037c58$var$StockClass extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props), this.debouncedSearchResults = (0, $48f673e197675daa$export$1f49383e7879c367)(this.getSearchResults.bind(this));
        this.exportTopProductsRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportProductsAnalyticsRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportProductsStockRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportProductPageRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        const query = window.location.search;
        const params = new URLSearchParams(query);
        this.state = {
            activeTab: params.get("activeTab") ?? "top_selling",
            itemsSales: [],
            itemsStock: {
                inStock: 0,
                lowStock: 0,
                outOfStock: 0
            },
            loading: true,
            id: Date.now().toString(),
            totalSales: 0,
            comparedItemsTotalSales: 0,
            totalStock: 0,
            totalComparisonStock: 0,
            productSku: "",
            isSearching: false,
            searchInput: "",
            productSortingMenu: false,
            sortedByTextValue: "",
            sort: "",
            direction: ""
        };
        this.loadData = this.loadData.bind(this);
        this.updateProductSku = this.updateProductSku.bind(this);
        this.changePageHandler = this.changePageHandler.bind(this);
        this.searchHandler = this.searchHandler.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams(this.state.activeTab);
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Stock";
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab) {
            this.context.updateUrlQueryParams(this.state.activeTab);
            // set page title according to the active tab
            switch(this.state.activeTab){
                case "top_selling":
                    document.title = "Top Selling Products";
                    break;
                case "product_stock":
                    document.title = "Products Stock";
                    break;
                case "products_analytics":
                    document.title = "Products Analytics";
                    break;
                default:
                    document.title = "Stock";
            }
        }
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    getSearchResults(searchQuery, searchPage, sort, direction) {
        let searchItemsPromise = Promise.resolve();
        searchItemsPromise = (0, $bf00c03a6e82e5ca$export$7d5bcb8438aaa31c)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            search: searchQuery,
            currentPage: searchPage,
            sort: sort,
            direction: direction,
            filters: this.context.appliedFilters
        }).then((searchResults)=>{
            this.setState({
                searchItems: searchResults.data,
                totalPageCount: searchResults.pagination.totalPageCount,
                currentPage: searchResults.pagination.currentPage
            });
        });
        Promise.all([
            searchItemsPromise
        ]);
    }
    changePageHandler(currentPage) {
        this.setState({
            currentPage: currentPage
        });
        this.getSearchResults(this.state.searchInput, currentPage, this.state.sort, this.state.direction);
    }
    /**
   * send search request for the input every 3 characters or every 0.5 seconds
   * of not typing
   * @param searchQuery
   */ searchHandler(searchQuery) {
        this.setState({
            isSearching: true,
            searchInput: searchQuery
        });
        if (!searchQuery) // if search input is empty then show all products
        this.setState({
            isSearching: false
        });
        if (searchQuery.length % 3 === 0) // show search results after 3 seconds
        this.getSearchResults(searchQuery, "", this.state.sort, this.state.direction);
        else // show search results after not typing for 0.5 seconds
        this.debouncedSearchResults(searchQuery, "", this.state.sort, this.state.direction);
    }
    loadData() {
        this.setState({
            loading: true
        });
        let itemsSalesPromise = Promise.resolve();
        let itemsStockPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) {
            itemsSalesPromise = (0, $bf00c03a6e82e5ca$export$b2e66e41f7ed5c4e)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((itemsSales)=>{
                this.setState({
                    itemsSales: itemsSales.data,
                    totalSales: itemsSales.pagination.totalAmount
                });
            });
            itemsStockPromise = (0, $bf00c03a6e82e5ca$export$b6d9e63e701f9d03)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                threshold: this.context.settings?.threshold,
                filters: this.context.appliedFilters
            }).then((itemsStock)=>{
                const totalStock = itemsStock.inStock + itemsStock.lowStock + itemsStock.outOfStock;
                this.setState({
                    itemsStock: itemsStock,
                    totalStock: totalStock
                });
            });
        }
        let comparedItemsSalesPromise = Promise.resolve();
        let comparedItemsStockPromise = Promise.resolve();
        if (this.context.comparedPeriod) {
            comparedItemsSalesPromise = (0, $bf00c03a6e82e5ca$export$b2e66e41f7ed5c4e)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedItemsSales)=>{
                this.setState({
                    comparedItemsSales: comparedItemsSales.data,
                    comparedItemsTotalSales: comparedItemsSales.pagination.totalAmount
                });
            });
            // fetching compared items stock after timeout
            // to avoid the backend from blocking concurrent requests
            setTimeout(()=>{
                comparedItemsStockPromise = (0, $bf00c03a6e82e5ca$export$b6d9e63e701f9d03)({
                    project: this.context.project,
                    from: this.context.comparedPeriod.from,
                    to: this.context.comparedPeriod.to,
                    threshold: this.context.settings?.threshold,
                    filters: this.context.appliedFilters
                }).then((comparedItemsStock)=>{
                    const totalComparisonStock = comparedItemsStock.inStock + comparedItemsStock.lowStock + comparedItemsStock.outOfStock;
                    this.setState({
                        comparedItemsStock: comparedItemsStock,
                        totalComparisonStock: totalComparisonStock
                    });
                });
            }, 2500);
        } else this.setState({
            comparedItemsSales: undefined
        });
        this.getSearchResults(this.state.searchInput, this.state.currentPage, this.state.sort, this.state.direction);
        Promise.all([
            itemsSalesPromise,
            comparedItemsSalesPromise,
            itemsStockPromise,
            comparedItemsStockPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            this.setState({
                loading: false
            });
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    updateProductSku(productSku) {
        this.setState({
            productSku: productSku
        });
    }
    sortProducts(e, sort, direction) {
        const input = e.target;
        this.setState({
            sortedByTextValue: input.innerText,
            sort: sort,
            direction: direction
        });
        this.getSearchResults("", "", sort, direction);
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "stock",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("productStock"),
                    exportRef: this.state.activeTab === "top_selling" ? this.exportTopProductsRef : this.state.activeTab === "products_analytics" && this.state.productSku ? this.exportProductPageRef : this.state.activeTab === "products_analytics" ? this.exportProductsAnalyticsRef : this.exportProductsStockRef
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "tabs",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "top_selling" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "top_selling") this.setState({
                                    activeTab: "top_selling"
                                });
                            },
                            children: t("topSellingProducts")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "products_analytics" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "products_analytics") {
                                    this.setState({
                                        activeTab: "products_analytics"
                                    });
                                    this.getSearchResults(this.state.searchInput, "", this.state.sort, this.state.direction);
                                }
                            },
                            children: t("productsAnalytics")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "product_stock" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "product_stock") this.setState({
                                    activeTab: "product_stock"
                                });
                            },
                            children: t("productStock")
                        })
                    ]
                }),
                this.state.activeTab === "top_selling" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    ref: this.exportTopProductsRef,
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: this.context.comparedPeriod ? "card-container" : "flex justify-center",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "card stock--table",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "stock--body",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                            className: "card--title",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    children: [
                                                        t("topSellingProducts"),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                            className: "duration",
                                                            children: [
                                                                "(",
                                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod?.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                this.state.itemsSales.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                                    data: this.state.itemsSales,
                                                    filename: `items_sales breakdown from:${this.context.currentPeriod?.from}-to:${this.context.currentPeriod?.to}.csv`,
                                                    className: "export-list-button",
                                                    target: "_blank",
                                                    children: t("exportList")
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                            children: this.state.itemsSales.map((item, index)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a178670604cb32d7$export$c3762807d12c1ef5), {
                                                    type: "stock",
                                                    rowItem: {
                                                        image_url: item.image_url,
                                                        number_of_items: item.number_sold,
                                                        name: item.name,
                                                        sku: item.sku
                                                    },
                                                    salesValue: (0, $48f673e197675daa$export$4640587ffa669919)(item.sales_value),
                                                    stock: (0, $48f673e197675daa$export$4640587ffa669919)(item.stock),
                                                    itemIndex: index,
                                                    currency: this.context.settings.currency,
                                                    percentageValue: Math.round(item.sales_value / this.state.totalSales * 100),
                                                    isCompare: !!this.context.comparedPeriod
                                                }, index))
                                        })
                                    ]
                                })
                            }),
                            this.context.comparedPeriod && this.state.comparedItemsSales && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "card stock--table",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "stock--body",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                            className: "card--title",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    children: [
                                                        t("topSellingProducts"),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                            className: "duration",
                                                            children: [
                                                                "(",
                                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                this.state.comparedItemsSales.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                                    data: this.state.comparedItemsSales,
                                                    filename: `items_sales breakdown from:${this.context.comparedPeriod?.from}-to:${this.context.comparedPeriod?.to}.csv`,
                                                    className: "export-list-button",
                                                    target: "_blank",
                                                    children: t("exportList")
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                            children: this.state.comparedItemsSales?.map((item, index)=>{
                                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a178670604cb32d7$export$c3762807d12c1ef5), {
                                                    type: "stock",
                                                    rowItem: {
                                                        image_url: item.image_url,
                                                        number_of_items: item.number_sold,
                                                        name: item.name,
                                                        sku: item.sku
                                                    },
                                                    salesValue: (0, $48f673e197675daa$export$4640587ffa669919)(item.sales_value),
                                                    stock: (0, $48f673e197675daa$export$4640587ffa669919)(item.stock),
                                                    currency: this.context.settings.currency,
                                                    itemIndex: index,
                                                    percentageValue: Math.round(item.sales_value / this.state.comparedItemsTotalSales * 100)
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                this.state.activeTab === "products_analytics" && (this.state.productSku ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                            className: "products-button--back",
                            type: "button",
                            onClick: ()=>{
                                this.setState({
                                    productSku: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                t("backToList")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ac6f248f87489dcd$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $be69e13341d50da4$export$2e2bcd8739ae039), {
                                productSku: this.state.productSku,
                                updateProductSku: this.updateProductSku,
                                exportRef: this.exportProductPageRef
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    ref: this.exportProductsAnalyticsRef,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("form", {
                            className: "products-search",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8b68e0e8727d6658$export$2e2bcd8739ae039), {
                                    className: "search-icon"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                    type: "text",
                                    className: "search-input",
                                    placeholder: t("searchPlaceholder"),
                                    value: this.state.searchInput,
                                    onChange: (e)=>{
                                        this.searchHandler(e.target.value);
                                    }
                                }),
                                this.state.isSearching && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                    type: "reset",
                                    className: "clear-icon",
                                    value: "+",
                                    onClick: ()=>{
                                        this.setState({
                                            isSearching: false,
                                            searchInput: ""
                                        });
                                        this.getSearchResults("");
                                    }
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "dropdown-container",
                                    onClick: ()=>{
                                        this.setState({
                                            productSortingMenu: !this.state.productSortingMenu
                                        });
                                    },
                                    children: [
                                        "Sort by",
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                            className: "dropdown-container__sort",
                                            children: this.state.sortedByTextValue
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                            className: "dropdown-icon"
                                        }),
                                        this.state.productSortingMenu && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ul", {
                                            className: "dropdown-menu",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e);
                                                    },
                                                    children: "default"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).Name, (0, $5142459688621f32$export$966c0722699349a0).Asc);
                                                    },
                                                    children: "product name (A-Z)"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).Name, (0, $5142459688621f32$export$966c0722699349a0).Desc);
                                                    },
                                                    children: "product name (Z-A)"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).NumberSold, (0, $5142459688621f32$export$966c0722699349a0).Asc);
                                                    },
                                                    children: "quantity sold (low to high)"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).NumberSold, (0, $5142459688621f32$export$966c0722699349a0).Desc);
                                                    },
                                                    children: "quantity sold (high to low)"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).SalesValue, (0, $5142459688621f32$export$966c0722699349a0).Asc);
                                                    },
                                                    children: "sales value (low to high)"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).SalesValue, (0, $5142459688621f32$export$966c0722699349a0).Desc);
                                                    },
                                                    children: "sales value (high to low)"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).Stock, (0, $5142459688621f32$export$966c0722699349a0).Asc);
                                                    },
                                                    children: "current stock (low to high)"
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                    className: "item",
                                                    onClick: (e)=>{
                                                        this.sortProducts(e, (0, $5142459688621f32$export$374f3ebff8a4cc33).Stock, (0, $5142459688621f32$export$966c0722699349a0).Desc);
                                                    },
                                                    children: "current stock (high to low)"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card product-analytics",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("productsAnalytics"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod?.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "products-analytics-table",
                                    children: this.state.searchItems ? this.state.searchItems.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.searchItems,
                                        updateProductSku: this.updateProductSku,
                                        type: "products-analytics"
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "not-found",
                                        children: `${t("noSearchResultsAreYouSureYouHaveThisProduct")}`
                                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                        children: [
                                            this.getSearchResults(this.state.searchInput, "", this.state.sort, this.state.direction),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "page-navigator",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.totalPageCount,
                                currentPage: this.state.currentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.changePageHandler
                            })
                        })
                    ]
                })),
                this.state.activeTab === "product_stock" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    ref: this.exportProductsStockRef,
                    className: this.context.comparedPeriod ? "card-container" : "flex justify-center",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "pie-chart-only-page",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                                title: t("productStock"),
                                items: [
                                    {
                                        name: [
                                            `${t("inStock")}`,
                                            `${this.state.itemsStock?.inStock} ${t("items")} . ${Math.round(this.state.itemsStock?.inStock / this.state.totalStock * 100)}%`
                                        ],
                                        count: `${this.state.itemsStock?.inStock}`
                                    },
                                    {
                                        name: [
                                            `${t("outOfStock")}`,
                                            `${this.state.itemsStock?.outOfStock} ${t("items")} . ${Math.round(this.state.itemsStock?.outOfStock / this.state.totalStock * 100)}%`
                                        ],
                                        count: `${this.state.itemsStock?.outOfStock}`
                                    },
                                    {
                                        name: [
                                            `${t("lowStock")}`,
                                            `${this.state.itemsStock?.lowStock} ${t("items")} . ${Math.round(this.state.itemsStock?.lowStock / this.state.totalStock * 100)}%`
                                        ],
                                        count: `${this.state.itemsStock?.lowStock}`
                                    }
                                ],
                                currentPeriod: this.context.currentPeriod,
                                blackThemed: true
                            })
                        }),
                        this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "pie-chart-only-page",
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $03b0ed136e422f3b$export$2e2bcd8739ae039), {
                                title: t("productStock"),
                                items: [
                                    {
                                        name: [
                                            `${t("inStock")}`,
                                            `${this.state.comparedItemsStock?.inStock} ${t("items")} . ${Math.round(this.state.comparedItemsStock?.inStock / this.state.totalComparisonStock * 100)}%`
                                        ],
                                        count: `${this.state.comparedItemsStock?.inStock}`
                                    },
                                    {
                                        name: [
                                            `${t("outOfStock")}`,
                                            `${this.state.comparedItemsStock?.outOfStock} ${t("items")} . ${Math.round(this.state.comparedItemsStock?.outOfStock / this.state.totalComparisonStock * 100)}%`
                                        ],
                                        count: `${this.state.comparedItemsStock?.outOfStock}`
                                    },
                                    {
                                        name: [
                                            `${t("lowStock")}`,
                                            `${this.state.comparedItemsStock?.lowStock} ${t("items")} . ${Math.round(this.state.comparedItemsStock?.lowStock / this.state.totalComparisonStock * 100)}%`
                                        ],
                                        count: `${this.state.comparedItemsStock?.lowStock}`
                                    }
                                ],
                                currentPeriod: this.context.comparedPeriod,
                                blackThemed: true
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$f6e85a1b1d037c58$var$StockClass.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
const $f6e85a1b1d037c58$export$660483d3947d0ba9 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("stock")($f6e85a1b1d037c58$var$StockClass);



/**
 * @author Ahmed Serag
 * @date 2019-12-09
 * @description support layout
 * @filename support.tsx
 */ 

var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");





/**
 * React Component that renders Not-found Layout.
 *
 * @export
 * @class NotFound
 * @extends {React.Component}
 */ class $235b3fb709341b44$var$SupportClass extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    static sendSupportMessage(values, formikHelpers) {
        (0, $56fb02d394e3f062$export$89c50b0313ef816e)(values.title, values.message, values.category).then(()=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).success("Your message has been sent successfully");
            formikHelpers.resetForm();
        }).catch((err)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err.message);
        });
    }
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            categoryMenu: false,
            selectedCategory: "I found a bug"
        };
    }
    componentDidMount() {
        // set page title
        document.title = "Support";
    }
    categoryChangeHandler(e, setFieldValue) {
        this.setState({
            selectedCategory: e.target.innerText,
            categoryMenu: false
        });
        // this is the aria-label of the selected category to be sent to backend
        setFieldValue("category", e.target.attributes["aria-label"].value);
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "Support",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("support"),
                    showPeriod: false
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "card sales-card",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                            className: "card--title",
                            children: t("sendMessage")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                            validationSchema: (0, $56fb02d394e3f062$export$ac5b8c5d73131fa7),
                            initialValues: {
                                title: "",
                                message: "",
                                category: this.state.selectedCategory
                            },
                            isInitialValid: false,
                            onSubmit: $235b3fb709341b44$var$SupportClass.sendSupportMessage,
                            children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                                    className: "card--section",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "title",
                                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "form-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: "title",
                                                            children: t("title")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                            id: "title",
                                                            placeholder: t("titlePlaceholder"),
                                                            name: "title",
                                                            type: "text",
                                                            ...field,
                                                            value: field.value ?? ""
                                                        }),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: "error",
                                                            children: meta.error
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "category",
                                            setFieldValue: true,
                                            children: ({ meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "form-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: "category",
                                                            children: t("category")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "dropdown-container",
                                                            role: "listbox",
                                                            "aria-expanded": this.state.categoryMenu,
                                                            "aria-label": t("category"),
                                                            tabIndex: 0,
                                                            onClick: ()=>{
                                                                this.setState({
                                                                    categoryMenu: !this.state.categoryMenu
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                    className: "dropdown-container__sort",
                                                                    children: this.state.selectedCategory
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c30324781d53e2c6$export$2e2bcd8739ae039), {
                                                                    className: "dropdown-icon"
                                                                }),
                                                                this.state.categoryMenu && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ul", {
                                                                    className: "dropdown-menu",
                                                                    role: "listbox",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                                            role: "option",
                                                                            "aria-selected": !this.state.selectedCategory,
                                                                            "aria-label": "I found a bug",
                                                                            className: "item",
                                                                            onClick: (e)=>{
                                                                                this.categoryChangeHandler(e, formikBag.setFieldValue);
                                                                            },
                                                                            children: t("iFoundABug")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                                            role: "option",
                                                                            "aria-selected": !this.state.selectedCategory,
                                                                            "aria-label": "My data isn't getting updated",
                                                                            className: "item",
                                                                            onClick: (e)=>{
                                                                                this.categoryChangeHandler(e, formikBag.setFieldValue);
                                                                            },
                                                                            children: t("myDataIsntGettingUpdated")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                                            role: "option",
                                                                            "aria-selected": !this.state.selectedCategory,
                                                                            "aria-label": "Refund Request",
                                                                            className: "item",
                                                                            onClick: (e)=>{
                                                                                this.categoryChangeHandler(e, formikBag.setFieldValue);
                                                                            },
                                                                            children: t("refundRequest")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                                            role: "option",
                                                                            "aria-selected": !this.state.selectedCategory,
                                                                            "aria-label": "Feature suggestion",
                                                                            className: "item",
                                                                            onClick: (e)=>{
                                                                                this.categoryChangeHandler(e, formikBag.setFieldValue);
                                                                            },
                                                                            children: t("featureSuggestion")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                                            role: "option",
                                                                            "aria-selected": !this.state.selectedCategory,
                                                                            "aria-label": "General/other",
                                                                            className: "item",
                                                                            onClick: (e)=>{
                                                                                this.categoryChangeHandler(e, formikBag.setFieldValue);
                                                                            },
                                                                            children: t("general/other")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: "error",
                                                            children: meta.error
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "message",
                                            children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "form-field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: "message",
                                                            children: t("message")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("textarea", {
                                                            id: "message",
                                                            name: "message",
                                                            placeholder: t("messagePlaceholder"),
                                                            type: "text",
                                                            rows: "8",
                                                            ...field,
                                                            value: field.value ?? ""
                                                        }),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: "error",
                                                            children: meta.error
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "submit",
                                            disabled: formikBag.isSubmitting,
                                            children: t("send")
                                        })
                                    ]
                                })
                        })
                    ]
                })
            ]
        });
    }
}
const $235b3fb709341b44$export$c7a1df07a9ed91ad = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("support")($235b3fb709341b44$var$SupportClass);


/**
 * @author Salma Hefnawy
 * @date 2022-06-05
 * @description recommendations list.
 * @filename recommendations-list.tsx
 */ 

var $igtsr = parcelRequire("igtsr");




/**
 * @author Salma Hefnawy
 * @date 2022-06-05
 * @description Implementation of Recommendations related utilities.
 * @filename recommendations.ts
 */ /**
 * @author Salma Hefnawy
 * @date 2022-06-05
 * @description implementation of Recommendations related API calls.
 * @filename recommendations.ts
 */ 


class $04de5e19683613ae$export$ebd86fc7badb9a5d {
    static overviewStockRecommendations({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overviewStockRecommendations.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overviewStockRecommendations.method
        });
    }
    static overviewPromotionRecommendations({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overviewPromotionRecommendations.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overviewPromotionRecommendations.method
        });
    }
    static overviewBundleRecommendations({ project: project, from: from, to: to, filters: filters = {} }) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overviewBundleRecommendations.path}`);
        url.searchParams.append("project", project);
        url.searchParams.append("from", from);
        url.searchParams.append("to", to);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch((0, $9702949453a4f797$export$143f1c2f8ea3b4b5)(url, filters).toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).overviewBundleRecommendations.method
        });
    }
}



function $7e5c33f2bc8d332f$export$8836c29c9f282918(payload) {
    return (0, $04de5e19683613ae$export$ebd86fc7badb9a5d).overviewStockRecommendations(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $7e5c33f2bc8d332f$export$9aac1d8ea09f2cc1(payload) {
    return (0, $04de5e19683613ae$export$ebd86fc7badb9a5d).overviewPromotionRecommendations(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}
function $7e5c33f2bc8d332f$export$7dc0cfc984da5c73(payload) {
    return (0, $04de5e19683613ae$export$ebd86fc7badb9a5d).overviewBundleRecommendations(payload).then((response)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(response);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}









/**
 * React Component that renders the Recommendations List.
 *
 * @extends {React.Component}
 */ class $2344f62f9223018b$var$RecommendationsList extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.exportRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            loading: true,
            id: Date.now().toString(),
            recommendationType: (0, $dc442a448cf56ab3$export$b042134994044ee2).STOCK,
            stockRecommendations: null,
            comparedStockRecommendations: null
        };
        this.loadData = this.loadData.bind(this);
        this.updateProductSku = this.updateProductSku.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
        this.context.updateUrlQueryParams();
        // set page title
        document.title = "Recommendation List";
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    /**  initializes overview for recommendations according to viewed list
   */ loadData() {
        /**  get recommendation type from view list in the overview page
     */ const { location: location } = this.props;
        // to get the current recommendation list state
        const recommendationType = location.pathname.split("/").pop();
        /**  set overview recommendations from api according to chosen type
     */ let overviewRecommendationPromise = Promise.resolve();
        let comparedOverviewRecommendationPromise = Promise.resolve();
        this.setState({
            loading: true
        });
        if (recommendationType === (0, $dc442a448cf56ab3$export$b042134994044ee2).BUNDLE) {
            if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
                "project",
                "currentPeriod"
            ])) overviewRecommendationPromise = (0, $7e5c33f2bc8d332f$export$7dc0cfc984da5c73)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((bundleRecommendations)=>{
                this.setState({
                    bundleRecommendations: bundleRecommendations
                });
            });
            if (this.context.comparedPeriod) comparedOverviewRecommendationPromise = (0, $7e5c33f2bc8d332f$export$7dc0cfc984da5c73)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedBundleRecommendations)=>{
                this.setState({
                    comparedBundleRecommendations: comparedBundleRecommendations
                });
            });
            this.setState({
                recommendationType: recommendationType
            });
        } else if (recommendationType === (0, $dc442a448cf56ab3$export$b042134994044ee2).PROMOTION) {
            if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
                "project",
                "currentPeriod"
            ])) overviewRecommendationPromise = (0, $7e5c33f2bc8d332f$export$9aac1d8ea09f2cc1)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((promotionRecommendations)=>{
                this.setState({
                    promotionRecommendations: promotionRecommendations
                });
            });
            if (this.context.comparedPeriod) comparedOverviewRecommendationPromise = (0, $7e5c33f2bc8d332f$export$9aac1d8ea09f2cc1)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedPromotionRecommendations)=>{
                this.setState({
                    comparedPromotionRecommendations: comparedPromotionRecommendations
                });
            });
            this.setState({
                recommendationType: recommendationType
            });
        } else {
            if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
                "project",
                "currentPeriod"
            ])) overviewRecommendationPromise = (0, $7e5c33f2bc8d332f$export$8836c29c9f282918)({
                project: this.context.project,
                from: this.context.currentPeriod.from,
                to: this.context.currentPeriod.to,
                filters: this.context.appliedFilters
            }).then((stockRecommendations)=>{
                this.setState({
                    stockRecommendations: stockRecommendations
                });
            });
            if (this.context.comparedPeriod) comparedOverviewRecommendationPromise = (0, $7e5c33f2bc8d332f$export$8836c29c9f282918)({
                project: this.context.project,
                from: this.context.comparedPeriod.from,
                to: this.context.comparedPeriod.to,
                filters: this.context.appliedFilters
            }).then((comparedStockRecommendations)=>{
                this.setState({
                    comparedStockRecommendations: comparedStockRecommendations
                });
            });
        }
        Promise.all([
            overviewRecommendationPromise,
            comparedOverviewRecommendationPromise
        ]).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
    }
    updateProductSku(productSku) {
        this.setState({
            productSku: productSku
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "recommendations",
            ref: this.exportRef,
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("recommendations"),
                    exportRef: this.exportRef
                }),
                this.state.productSku ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                            className: "products-button--back",
                            type: "button",
                            onClick: ()=>{
                                this.setState({
                                    productSku: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                t("backToRecommendations")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ac6f248f87489dcd$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $be69e13341d50da4$export$2e2bcd8739ae039), {
                                productSku: this.state.productSku,
                                updateProductSku: this.updateProductSku,
                                exportRef: this.exportRef
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        this.state.stockRecommendations && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card product-analytics",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("stockingRecommendationsProductsList"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod?.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "recommendations-table products-analytics-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.stockRecommendations,
                                        updateProductSku: this.updateProductSku,
                                        type: "products-analytics"
                                    })
                                })
                            ]
                        }),
                        this.state.comparedStockRecommendations && this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card product-analytics",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("stockingRecommendationsProductsList"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "recommendations-table products-analytics-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.comparedStockRecommendations,
                                        updateProductSku: this.updateProductSku,
                                        type: "products-analytics"
                                    })
                                })
                            ]
                        }),
                        this.state.bundleRecommendations && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card product-analytics",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("bundleRecommendationsProductsList"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod?.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "recommendations-table products-analytics-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.bundleRecommendations,
                                        updateProductSku: this.updateProductSku,
                                        type: "bundle-recommendation"
                                    })
                                })
                            ]
                        }),
                        this.state.comparedBundleRecommendations && this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card product-analytics",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("bundleRecommendationsProductsList"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "recommendations-table products-analytics-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.comparedBundleRecommendations,
                                        updateProductSku: this.updateProductSku,
                                        type: "bundle-recommendation"
                                    })
                                })
                            ]
                        }),
                        this.state.promotionRecommendations && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card product-analytics",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("promotionRecommendationsProductsList"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod?.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "promotions-recommendations-table products-analytics-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.promotionRecommendations,
                                        updateProductSku: this.updateProductSku,
                                        type: "promotions-recommendation"
                                    })
                                })
                            ]
                        }),
                        this.state.comparedPromotionRecommendations && this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "card product-analytics",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                    className: "card--title",
                                    children: [
                                        t("promotionRecommendationsProductsList"),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                            className: "duration",
                                            children: [
                                                "(",
                                                (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "promotions-recommendations-table recommendations-table products-analytics-table",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                        products: this.state.comparedPromotionRecommendations,
                                        updateProductSku: this.updateProductSku,
                                        type: "promotions-recommendation"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$2344f62f9223018b$var$RecommendationsList.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $2344f62f9223018b$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("overview")($2344f62f9223018b$var$RecommendationsList);


/**
 * @author Salma Hefnawy
 * @date 2022-03-28
 * @description user behavior of the App.
 * @filename user-behavior.tsx
 */ 

var $igtsr = parcelRequire("igtsr");


/**
 * @author Salma Hefnawy
 * @date 2021-04-03
 * @description add user component
 * @filename add-user.tsx
 */ 

var $4l1Xa = parcelRequire("4l1Xa");

var $igtsr = parcelRequire("igtsr");








parcelRequire("igtsr");
const $8cb823fa4065e211$var$SvgNoCustomers = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 22,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("g", {
                    fill: "#45c2ff",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        d: "M19.772 9.577a3.877 3.877 0 0 1 3.877 3.877v3.741a2 2 0 0 1-2 2h-3.754a2 2 0 0 1-2-2v-3.741a3.877 3.877 0 0 1 3.877-3.877M3.877 9.577a3.877 3.877 0 0 1 3.877 3.877v3.741a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3.741a3.877 3.877 0 0 1 3.877-3.877"
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(17.556 3.012)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                            cx: 3.406,
                            cy: 2.353,
                            rx: 2.423,
                            ry: 2.353
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M0 8.853c.591-1.345 1.966-2.288 3.567-2.288 2.141 0 3.877 1.686 3.877 3.765v4.541c0 .725-.605 1.313-1.351 1.313h-4.36"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(1.351 3.012)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                            cx: 3.715,
                            cy: 2.353,
                            rx: 2.423,
                            ry: 2.353
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M3.877 6.565a3.877 3.877 0 0 1 3.877 3.877v3.742a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3.742a3.877 3.877 0 0 1 3.877-3.877z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#fff",
                    stroke: "#000",
                    strokeLinejoin: "round",
                    d: "M12.802 9.953h.36a6.023 6.023 0 0 1 6.023 6.024V20a2 2 0 0 1-2 2H8.779a2 2 0 0 1-2-2v-4.023a6.023 6.023 0 0 1 6.023-6.024z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    fill: "#daf3ff",
                    transform: "translate(4.752)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                            cx: 6.203,
                            cy: 3.765,
                            rx: 3.877,
                            ry: 3.765
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M6.023 9.953h.36a6.023 6.023 0 0 1 6.023 6.024V20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4.023a6.023 6.023 0 0 1 6.023-6.024"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    stroke: "#000",
                    strokeLinejoin: "round",
                    transform: "translate(6.779)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                            cx: 6.203,
                            cy: 3.765,
                            rx: 3.877,
                            ry: 3.765
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M6.023 9.953h.36a6.023 6.023 0 0 1 6.023 6.024V20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4.023a6.023 6.023 0 0 1 6.023-6.024z"
                        })
                    ]
                })
            ]
        })
    });
var $8cb823fa4065e211$export$2e2bcd8739ae039 = $8cb823fa4065e211$var$SvgNoCustomers;



/**
 * @author Ahmed Serag
 * @date 2021-07-02
 * @description Implementation of Customers related utilities.
 * @filename customers.ts
 */ /**
 * @author Ahmed Serag
 * @date 2020-07-20
 * @description implementation of Customer related API calls.
 * @filename customer.ts
 */ 

class $831f87121602553d$export$a14eff1703dc02e1 {
    static getCustomersCountBySegment(project, recievers) {
        const url = new URL(`${"https://backend.analytics-dashboard.ecommbeta.com/api"}${(0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCustomersCountBySegment.path}`);
        url.searchParams.append("project", project);
        return (0, $dd8ae3fd35a35e58$export$95be4ae94445245a).fetch(url.toString(), {
            method: (0, $b2d4fb2efd578b37$export$4a3a00e07ffce8bd).getCustomersCountBySegment.method,
            body: JSON.stringify(recievers)
        });
    }
}



function $68cee50c50cfe743$export$e675d8687671de83(project, recievers) {
    return (0, $831f87121602553d$export$a14eff1703dc02e1).getCustomersCountBySegment(project, recievers).then((userCount)=>{
        return (0, $48f673e197675daa$export$ce604b1ac1ac02ff)(userCount);
    }).catch((error)=>{
        return Promise.reject((0, $48f673e197675daa$export$d3da1ecaf1206c58)(error));
    });
}



class $3a895d6043829205$var$AddCampaignDetails extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            isCreateANewSegmentOpen: false,
            loading: false,
            availableFiltersSegments: [],
            loadingFiltersSegments: false,
            addCustomerAttributes: false,
            id: Date.now().toString()
        };
        // this.handleAddCampaignDetails = this.handleAddCampaignDetails.bind(this);
        this.loadData = this.loadData.bind(this);
        this.toggleCreateANewSegment = this.toggleCreateANewSegment.bind(this);
        this.showAddCustomerAttributesModal = this.showAddCustomerAttributesModal.bind(this);
        this.hideAddCustomerAttributesModal = this.hideAddCustomerAttributesModal.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.addUpdatesListener(this.state.id, this.loadData);
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.recievers !== this.state.recievers) {
            console.log(this.state.recievers);
            //   this.setState({ loading: true });
            (0, $68cee50c50cfe743$export$e675d8687671de83)(this.context.project, this.state.recievers).then((res)=>{
                console.log(res);
            }).catch((err)=>{
                console.error(err);
                (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            });
        // .finally(() => {
        //   this.setState({
        //     loading: false,
        //   });
        // });
        }
    }
    toggleCreateANewSegment(filtersSegment) {
        this.setState({
            isCreateANewSegmentOpen: !this.state.isCreateANewSegmentOpen,
            editingSegment: filtersSegment
        });
    }
    loadData() {
        this.setState({
            loading: true
        });
        (0, $68cee50c50cfe743$export$e675d8687671de83)(this.context.project).then((res)=>{
            this.setState({
                customersCount: res.users_count
            });
            console.log(res);
        }).catch((err)=>{
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
    }
    //   handleAddCampaignDetails(values: AddCampaignDetailsInput) {
    // AddCampaignDetails(values.name, values.email, values.role)
    //   .then((result) => {
    //     toast.success(result.message);
    //     this.props.onSubmit();
    //     this.props.onFinish();
    //   })
    //   .catch((errors) => {
    //     errors.forEach((error: string) => toast.error(error));
    //   });
    //   }
    showAddCustomerAttributesModal() {
        this.setState({
            addCustomerAttributes: true
        });
    }
    hideAddCustomerAttributesModal() {
        this.setState({
            addCustomerAttributes: false
        });
    }
    render() {
        const { t: t } = this.props;
        const segmentsOptions = this.context.availableFiltersSegments.map((segment)=>{
            return {
                value: segment.id,
                label: segment.title
            };
        });
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "campaign-details",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {})
        });
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "campaign-details",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Formik), {
                    onSubmit: (values)=>console.log(values),
                    initialValues: {
                        campaignName: "",
                        recievers: "all-customers",
                        customersSegment: "",
                        customerSpending: "",
                        customerSpendingAmount: ""
                    },
                    validationSchema: (0, $91e1faf1710dcf23$export$be5493f9613cbbe)().shape({
                        campaignName: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required(t("settings:requiredName")).min(3, t("settings:min3Characters")),
                        campaignSubject: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required(t("settings:requiredSubject")).min(3, t("settings:min3Characters")),
                        recievers: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().required(),
                        storeCategory: (0, $91e1faf1710dcf23$export$22b082955e083ec3)().equals(segmentsOptions.map((item)=>item.value), "Please choose a proper segment.")
                    }),
                    children: (formikBag)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $4l1Xa.Form), {
                            className: "card--section",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                    name: "campaignName",
                                    children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                    htmlFor: "campaignName",
                                                    children: t("campaignName")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                    placeholder: t("enterCampaignName"),
                                                    name: "campaignName",
                                                    type: "text",
                                                    ...field,
                                                    value: field.value ?? ""
                                                }),
                                                meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "error",
                                                    children: meta.error
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                    name: "campaignSubject",
                                    children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "form-field form-field--subject",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                    htmlFor: "campaignSubject",
                                                    children: t("campaignSubject")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                    placeholder: t("entercampaignSubject"),
                                                    name: "campaignSubject",
                                                    type: "text",
                                                    ...field,
                                                    value: field.value ?? ""
                                                }),
                                                meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                    className: "error",
                                                    children: meta.error
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "spacer"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                            id: "radio-group",
                                            children: t("recievers")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            role: "group",
                                            "aria-labelledby": "radio-group",
                                            className: "campaign-details__radio-group",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                            type: "radio",
                                                            name: "recievers",
                                                            value: "all-customers"
                                                        }),
                                                        t("allCustomers")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                            type: "radio",
                                                            name: "recievers",
                                                            value: "customers-segment"
                                                        }),
                                                        t("customerSegment")
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                formikBag.values.recievers === "customers-segment" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                            name: "customersSegment",
                                            children: ({ field: field, meta: meta, form: form })=>{
                                                return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "campaign-details__select-field form-field",
                                                    "aria-invalid": !!(meta.touched && meta.error),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                            htmlFor: "customersSegment",
                                                            children: t("customerSegment")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13b5ae22f3a5f453$export$2e2bcd8739ae039), {
                                                            id: "customersSegment",
                                                            name: field.name,
                                                            placeholder: t("customerSegmentPlaceHolder"),
                                                            classNames: {
                                                                control: (state)=>{
                                                                    if (state.isFocused) return "campaign-details__select-focused";
                                                                    return "campaign-details__select";
                                                                }
                                                            },
                                                            options: segmentsOptions,
                                                            value: segmentsOptions.find((option)=>option.value === field.value),
                                                            onChange: (option)=>{
                                                                form.setFieldValue(field.name, option?.value || "");
                                                                this.setState({
                                                                    recievers: {
                                                                        filter_segment_id: option.value.toString()
                                                                    }
                                                                });
                                                            },
                                                            isClearable: true
                                                        }),
                                                        meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: "error",
                                                            children: meta.error
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "button",
                                            className: "button-underlined black modal-button--show",
                                            onClick: ()=>{
                                                this.setState({
                                                    isCreateANewSegmentOpen: true
                                                });
                                            },
                                            children: t("Create a New Segment")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "campaign-details__attributes form-field",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                    htmlFor: "customersAttributes",
                                                    children: t("Add User Attributes")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "button-underlined black modal-button--show",
                                                    onClick: ()=>{
                                                        this.showAddCustomerAttributesModal();
                                                    },
                                                    children: t("Add User Attributes")
                                                }),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1aff520041650bb7$export$2b77a92f1a5ad772), {
                                                    showModal: this.state.addCustomerAttributes,
                                                    handleClose: ()=>this.hideAddCustomerAttributesModal(),
                                                    sideModal: true,
                                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                        className: "campaign-details__attributes-modal",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "create-segment__back",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                                        className: "button-underlined black",
                                                                        onClick: this.hideAddCustomerAttributesModal,
                                                                        type: "button",
                                                                        children: t("back")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                                                children: [
                                                                    " ",
                                                                    t("Add User Attributes")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "campaign-details__attribute",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                                        name: "customerSpending",
                                                                        children: ({ field: field, meta: meta, form: form })=>{
                                                                            return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "campaign-details__select-field form-field",
                                                                                "aria-invalid": !!(meta.touched && meta.error),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h3", {
                                                                                        children: t("Customer Spending Attribute")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                        htmlFor: "customerSpending",
                                                                                        children: t("customertype")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13b5ae22f3a5f453$export$2e2bcd8739ae039), {
                                                                                        id: "customerSpending",
                                                                                        name: field.name,
                                                                                        placeholder: t("customerSegmentPlaceHolder"),
                                                                                        classNames: {
                                                                                            control: (state)=>{
                                                                                                if (state.isFocused) return "campaign-details__select-focused";
                                                                                                return "campaign-details__select";
                                                                                            }
                                                                                        },
                                                                                        options: segmentsOptions,
                                                                                        value: segmentsOptions.find((option)=>option.value === field.value),
                                                                                        onChange: (option)=>{
                                                                                            form.setFieldValue(field.name, option?.value || "");
                                                                                        },
                                                                                        isClearable: true
                                                                                    }),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                                        className: "error",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                                        name: "customerSpendingAmount",
                                                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "form-field",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                        htmlFor: "customerSpendingAmount",
                                                                                        children: t("Amount")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                                        placeholder: t("entercustomerSpendingAmount"),
                                                                                        name: "customerSpendingAmount",
                                                                                        type: "number",
                                                                                        min: "0",
                                                                                        ...field,
                                                                                        value: field.value ? field.value.toString() : ""
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                                        children: t("egp")
                                                                                    }),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                                        className: "error",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                className: "spacer"
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "campaign-details__attribute",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                                        name: "customerOrdersFrequency",
                                                                        children: ({ field: field, meta: meta, form: form })=>{
                                                                            return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "campaign-details__select-field form-field",
                                                                                "aria-invalid": !!(meta.touched && meta.error),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h3", {
                                                                                        children: t("Customer OrdersFrequency Attribute")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                        htmlFor: "customerOrdersFrequency",
                                                                                        children: t("customertype")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13b5ae22f3a5f453$export$2e2bcd8739ae039), {
                                                                                        id: "customerOrdersFrequency",
                                                                                        name: field.name,
                                                                                        placeholder: t("customerSegmentPlaceHolder"),
                                                                                        classNames: {
                                                                                            control: (state)=>{
                                                                                                if (state.isFocused) return "campaign-details__select-focused";
                                                                                                return "campaign-details__select";
                                                                                            }
                                                                                        },
                                                                                        options: segmentsOptions,
                                                                                        value: segmentsOptions.find((option)=>option.value === field.value),
                                                                                        onChange: (option)=>{
                                                                                            form.setFieldValue(field.name, option?.value || "");
                                                                                        },
                                                                                        isClearable: true
                                                                                    }),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                                        className: "error",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4l1Xa.Field), {
                                                                        name: "customerOrdersFrequencyAmount",
                                                                        children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                                className: "form-field",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("label", {
                                                                                        htmlFor: "customerOrdersFrequencyAmount",
                                                                                        children: t("Amount")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("input", {
                                                                                        placeholder: t("enterCustomerOrdersFrequencyAmount"),
                                                                                        name: "customerOrdersFrequencyAmount",
                                                                                        type: "number",
                                                                                        min: "0",
                                                                                        ...field,
                                                                                        value: field.value ? field.value.toString() : ""
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                                                                        children: t("egp")
                                                                                    }),
                                                                                    meta.touched && meta.error && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                                                        className: "error",
                                                                                        children: meta.error
                                                                                    })
                                                                                ]
                                                                            })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                                className: "action-buttons",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "button save black",
                                                                        children: t("save")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                                        className: "button-underlined black",
                                                                        type: "button",
                                                                        onClick: this.hideAddCustomerAttributesModal,
                                                                        children: t("cancel")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "campaign-details__count form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8cb823fa4065e211$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h3", {
                                                    children: t("Number of customers")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                            children: this.state.customersCount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                    className: "action-buttons",
                                    children: [
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            type: "submit",
                                            className: "button save black",
                                            disabled: !(formikBag.isValid && formikBag.dirty),
                                            children: t("saveAddContent")
                                        }),
                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                            className: "button-underlined black",
                                            type: "button",
                                            children: t("draft")
                                        })
                                    ]
                                })
                            ]
                        })
                }),
                this.state.isCreateANewSegmentOpen && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $789ef595f3f8fe07$export$2e2bcd8739ae039), {
                    toggleCreateANewSegment: this.toggleCreateANewSegment,
                    segment: this.state.editingSegment
                })
            ]
        });
    }
}
$3a895d6043829205$var$AddCampaignDetails.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $3a895d6043829205$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "marketing-campaigns",
    "settings"
])($3a895d6043829205$var$AddCampaignDetails);




class $a8c68036492f5b99$var$CreateCampaign extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        // const query = window.location.search;
        // const params = new URLSearchParams(query);
        this.exportCreateCampaignRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.state = {
            activeTab: "campaign_details",
            id: Date.now().toString(),
            showAllPromos: false,
            pageTitle: ""
        };
        this.updateShowAllPromosState = this.updateShowAllPromosState.bind(this);
        this.updateExportedPromoCodes = this.updateExportedPromoCodes.bind(this);
        this.updatePageTitle = this.updatePageTitle.bind(this);
    }
    componentDidMount() {
        // set page title
        document.title = "Campaign Details";
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab) {
            this.context.updateUrlQueryParams(this.state.activeTab);
            // set page title according to the active tab
            switch(this.state.activeTab){
                case "campaign_details":
                    document.title = "Campaign Details";
                    break;
                case "add_content":
                    document.title = "Add Content";
                    break;
                case "edit_template":
                    document.title = "Edit Template";
                    break;
                default:
                    document.title = "Campaign Details";
                    break;
            }
        }
    }
    updateShowAllPromosState(showPromosState) {
        this.setState({
            showAllPromos: showPromosState
        });
    }
    updateExportedPromoCodes(exportedPromoCodes) {
        this.setState({
            exportedPromoCodes: exportedPromoCodes
        });
    }
    updatePageTitle(pageTitle) {
        this.setState({
            pageTitle: pageTitle
        });
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "create-campaign",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("marketingCampaign"),
                    showPeriod: false,
                    exportRef: this.exportCreateCampaignRef,
                    disableDateFilters: this.state.activeTab === "campaign_details",
                    disableAdvancedFilters: this.state.activeTab === "campaign_details"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                    children: t("createEmailManualCampaign")
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("ol", {
                    className: "tabs",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                            className: `tab ${this.state.activeTab === "campaign_details" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "campaign_details") this.setState({
                                    activeTab: "campaign_details"
                                });
                            },
                            children: t("campaignDetails")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "spacer"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                            className: `tab ${this.state.activeTab === "add_content" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "add_content") this.setState({
                                    activeTab: "add_content"
                                });
                            },
                            children: t("addContent")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: "spacer"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                            className: `tab ${this.state.activeTab === "edit_template" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "edit_template") this.setState({
                                    activeTab: "edit_template"
                                });
                            },
                            children: t("editTemplate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "create-campaign__content",
                    children: [
                        this.state.activeTab === "campaign_details" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $3a895d6043829205$export$2e2bcd8739ae039), {}),
                        this.state.activeTab === "add_content" && (!this.state.showAllPromos ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                            children: "hi"
                        }) : // <Promocodes
                        //   exportRef={this.exportCreateCampaignRef}
                        //   updateShowAllPromosState={this.updateShowAllPromosState}
                        //   updateExportedPromoCodes={this.updateExportedPromoCodes}
                        // />
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                                className: "products-button--back",
                                type: "button",
                                onClick: ()=>{
                                    this.setState({
                                        showAllPromos: false
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                    t("backToPagesList")
                                ]
                            })
                        })),
                        this.state.activeTab === "edit_template" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                children: "hi"
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$a8c68036492f5b99$var$CreateCampaign.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $a8c68036492f5b99$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("marketing-campaigns")($a8c68036492f5b99$var$CreateCampaign);



/**
 * @author Youssef Tarek
 * @date 2023-01-11
 * @description confirming registration redirection screen
 * @filename confirm-registration.tsx
 */ 

var $igtsr = parcelRequire("igtsr");





class $0c7eb25603ee15e6$export$73d3587e70c88d79 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            token: "",
            loading: true
        };
    }
    componentDidMount() {
        this.setState({
            loading: true
        });
        const query = window.location.search;
        const params = new URLSearchParams(query);
        const token = params.get("token");
        this.setState({
            token: token
        });
        (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).confirmRegistration(token).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "auth-wrapper",
                children: [
                    this.state.loading ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "text-size-20",
                                children: "We're setting up your playground, this might take up to 30 seconds, don't worry!"
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                className: "auth-wrapper__loader",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $af6cf6d393cc9a5e$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "flex-col align-center gap-10 text-size-20",
                        children: [
                            "Thank you for verifying your email, let's start playing!",
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                type: "button",
                                className: "button black big mt-40",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: "button--link",
                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: "Login"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7a2c23ebf6bb4208$exports))),
                        className: "side-img",
                        alt: ""
                    })
                ]
            })
        });
    }
}


/**
 * @author Youssef Tarek
 * @date 2022-01-09
 * @description Brands tab in the app
 */ 

var $igtsr = parcelRequire("igtsr");










/**
 * @author Youssef Tarek
 * @date 2022-01-10
 * @description Brands items sales in Brands tab in the app
 */ 

var $igtsr = parcelRequire("igtsr");










class $14ff1a087fb01486$var$BrandsItemsSales extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            comparedLoading: true,
            brands: [],
            id: Date.now().toString(),
            currentPage: 1,
            comparedCurrentPage: 1,
            totalPages: 1,
            comparedTotalPages: 1,
            searchQuery: ""
        };
        // TODO bind class methods
        this.updateSearchQuery = this.updateSearchQuery.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.loadAllData = this.loadAllData.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.updateComparedCurrentPage = this.updateComparedCurrentPage.bind(this);
        this.loadBrands = this.loadBrands.bind(this);
        this.loadComparedBrands = this.loadComparedBrands.bind(this);
    }
    componentDidMount() {
        this.loadAllData();
        this.context.addUpdatesListener(this.state.id, this.loadAllData);
    }
    componentDidUpdate(_, prevState) {
        const sortChanged = prevState.sortBy !== this.state.sortBy || prevState.sortDirection !== this.state.sortDirection;
        const searchChanged = prevState.searchQuery !== this.state.searchQuery;
        if (prevState.currentPage !== this.state.currentPage || searchChanged || sortChanged) this.loadBrands().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                loading: false
            });
        });
        if (prevState.comparedCurrentPage !== this.state.comparedCurrentPage || searchChanged || sortChanged) this.loadComparedBrands().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                comparedLoading: false
            });
        });
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    updateSearchQuery(searchQuery) {
        this.setState({
            searchQuery: searchQuery,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateSort(sortBy, sortDirection) {
        if (!sortBy || !sortDirection) {
            this.setState({
                sortBy: undefined,
                sortDirection: undefined,
                currentPage: 1,
                comparedCurrentPage: 1
            });
            return;
        }
        this.setState({
            sortBy: sortBy,
            sortDirection: sortDirection,
            currentPage: 1,
            comparedCurrentPage: 1
        });
    }
    updateCurrentPage(currentPage) {
        this.setState({
            currentPage: currentPage
        });
    }
    updateComparedCurrentPage(comparedCurrentPage) {
        this.setState({
            comparedCurrentPage: comparedCurrentPage
        });
    }
    loadBrands() {
        this.setState({
            loading: true
        });
        let brandsPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) brandsPromise = (0, $7e7a33cc33ce5113$export$b4742ff7ccdcdcf0)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            currentPage: this.state.currentPage,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                brands: res.data,
                totalPages: res.pagination.totalPageCount || 1,
                loading: false
            });
        });
        return brandsPromise;
    }
    loadComparedBrands() {
        this.setState({
            comparedLoading: true
        });
        let comparedBrandsPromise = Promise.resolve();
        if (this.context.comparedPeriod) comparedBrandsPromise = (0, $7e7a33cc33ce5113$export$b4742ff7ccdcdcf0)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            sort: this.state.sortBy,
            direction: this.state.sortDirection,
            search: this.state.searchQuery,
            currentPage: this.state.comparedCurrentPage,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                comparedBrands: res.data,
                comparedTotalPages: res.pagination.totalPageCount || 1,
                comparedLoading: false
            });
        });
        return comparedBrandsPromise;
    }
    loadAllData() {
        const brandsPromise = this.loadBrands();
        const comparedBrandsPromise = this.loadComparedBrands();
        Promise.all([
            brandsPromise,
            comparedBrandsPromise
        ]).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                loading: false,
                comparedLoading: false
            });
        });
    }
    render() {
        const { t: t } = this.props;
        const brandsCounts = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.brands);
        const comparedBrandsCounts = (0, $54c7c3206a2399da$export$713f87d1c6bdc4f8)(this.state.comparedBrands);
        const tabs = {
            [t("allBrands")]: {
                title: `${t("allBrands")}`,
                items: brandsCounts
            }
        };
        const comparedTabs = {
            [t("allBrands")]: {
                title: `${t("allBrands")}`,
                items: comparedBrandsCounts
            }
        };
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $ecbd83510a1ff561$exports.Fragment), {
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "card-container",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "span-2",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $56815f93a4fad611$export$2e2bcd8739ae039), {
                            searchHandler: this.updateSearchQuery,
                            sortHandler: this.updateSort,
                            sortBy: this.state.sortBy,
                            direction: this.state.sortDirection,
                            mode: "minimal"
                        })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: this.context.comparedPeriod ? "" : "span-2 centered",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                        className: "card--title",
                                        children: [
                                            t("brandsSales"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                className: "duration",
                                                children: [
                                                    "(",
                                                    (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod?.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "sales-table categories-sales-table",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                            products: this.state.brands.map((item)=>({
                                                    ...item,
                                                    name: item.brand_name,
                                                    image_url: item.brand_image_url
                                                })) || [],
                                            updateProductSku: this.props.updateSelectedBrand,
                                            type: "brands-sales-list",
                                            loading: this.state.loading,
                                            withNavigation: true
                                        })
                                    }),
                                    !this.state.loading && this.state.searchQuery && !this.state.brands.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        children: t("noSearchResult", {
                                            ns: "common"
                                        })
                                    })
                                ]
                            }),
                            this.state.totalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.totalPages,
                                currentPage: this.state.currentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updateCurrentPage
                            })
                        ]
                    }),
                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                        className: "card--title",
                                        children: [
                                            t("brandsSales"),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                className: "duration",
                                                children: [
                                                    "(",
                                                    (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod?.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "sales-table categories-sales-table",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1561231f0d47a06c$export$2e2bcd8739ae039), {
                                            products: this.state.comparedBrands?.map((item)=>({
                                                    ...item,
                                                    name: item.brand_name,
                                                    image_url: item.brand_image_url
                                                })) || [],
                                            updateProductSku: this.props.updateSelectedBrand,
                                            type: "brands-sales-list",
                                            loading: this.state.comparedLoading,
                                            withNavigation: true
                                        })
                                    }),
                                    !this.state.comparedLoading && this.state.searchQuery && !this.state.comparedBrands.length && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                        children: t("noSearchResult", {
                                            ns: "common"
                                        })
                                    })
                                ]
                            }),
                            this.state.comparedTotalPages > 1 && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $2a34a2a81f7d40cf$export$2e2bcd8739ae039), {
                                totalPageCount: this.state.comparedTotalPages,
                                currentPage: this.state.comparedCurrentPage,
                                pageNeighbors: 1,
                                changePageHandler: this.updateComparedCurrentPage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: `card ${this.context.comparedPeriod ? "" : "span-2 centered"}`,
                        ref: this.props.exportRef,
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                            title: t("brandsBreakdown"),
                            duration: true,
                            currentPeriod: this.context.currentPeriod,
                            tabs: tabs
                        })
                    }),
                    this.state.comparedBrands && this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                        className: "card",
                        ref: this.props.exportRef,
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42465bb5f1bfa64f$export$2e2bcd8739ae039), {
                            title: t("comparedBrandsBreakdown"),
                            tabs: comparedTabs,
                            duration: true,
                            currentPeriod: this.context.comparedPeriod
                        })
                    })
                ]
            })
        });
    }
}
$14ff1a087fb01486$var$BrandsItemsSales.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $14ff1a087fb01486$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)([
    "brands",
    "common"
])($14ff1a087fb01486$var$BrandsItemsSales);



class $a2c5280d16199275$var$Brands extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.exportTopBrandsRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportBrandsSalesRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        this.exportBrandDetailsSalesRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).createRef();
        const query = window.location.search;
        const params = new URLSearchParams(query);
        this.state = {
            activeTab: params.get("activeTab") ?? "top_selling_brands",
            loading: true,
            totalSales: 0,
            brands: [],
            id: Date.now().toString(),
            selectedBrand: ""
        };
        this.loadData = this.loadData.bind(this);
        this.updateSelectedBrand = this.updateSelectedBrand.bind(this);
    }
    componentDidMount() {
        this.loadData();
        this.context.updateUrlQueryParams(this.state.activeTab, this.context.listBy);
        this.context.addUpdatesListener(this.state.id, this.loadData);
        // set page title
        document.title = "Brands";
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeTab !== this.state.activeTab) {
            this.context.updateUrlQueryParams(this.state.activeTab, this.context.listBy);
            // set page title according to the active tab
            switch(this.state.activeTab){
                case "top_selling_brands":
                    document.title = "Brands";
                    break;
                case "brands_sales":
                    document.title = "Brands Sales";
                    break;
                default:
                    document.title = "Brands";
                    break;
            }
        }
    }
    componentWillUnmount() {
        this.context.removeUpdatesListener(this.state.id);
    }
    loadData() {
        this.setState({
            loading: true
        });
        let brandsPromise = Promise.resolve();
        if ((0, $48f673e197675daa$export$f499cc7423602637)(this.context, [
            "project",
            "currentPeriod"
        ])) brandsPromise = (0, $7e7a33cc33ce5113$export$b4742ff7ccdcdcf0)({
            project: this.context.project,
            from: this.context.currentPeriod.from,
            to: this.context.currentPeriod.to,
            sort: this.context.listBy,
            currentPage: 1,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                brands: res.data,
                totalSales: res.data.reduce((total, sale)=>total + sale.sales_value, 0)
            });
        });
        let comparedBrandsPromise = Promise.resolve();
        if (this.context.comparedPeriod) comparedBrandsPromise = (0, $7e7a33cc33ce5113$export$b4742ff7ccdcdcf0)({
            project: this.context.project,
            from: this.context.comparedPeriod.from,
            to: this.context.comparedPeriod.to,
            sort: this.context.listBy,
            currentPage: 1,
            filters: this.context.appliedFilters
        }).then((res)=>{
            this.setState({
                comparedBrands: res.data,
                comparedTotalSales: res.data.reduce((total, sale)=>total + sale.sales_value, 0)
            });
        });
        Promise.all([
            brandsPromise,
            comparedBrandsPromise
        ]).then(()=>{
            this.setState({
                loading: false
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
            this.setState({
                loading: false
            });
        });
    }
    updateSelectedBrand(selectedBrand) {
        this.setState({
            selectedBrand: selectedBrand
        });
    }
    render() {
        const { t: t } = this.props;
        if (this.state.loading) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: "brands",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $406539e821b77e4d$export$2e2bcd8739ae039), {
                    title: t("brands"),
                    exportRef: this.state.activeTab === "top_selling_brands" ? this.exportTopBrandsRef : this.exportBrandsSalesRef
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "tabs",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "top_selling_brands" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "top_selling_brands") this.setState({
                                    activeTab: "top_selling_brands"
                                });
                            },
                            children: t("topSellingBrands")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            className: `tab ${this.state.activeTab === "brands_sales" ? " active" : ""}`,
                            onClick: ()=>{
                                if (this.state.activeTab !== "brands_sales") this.setState({
                                    activeTab: "brands_sales"
                                });
                            },
                            children: t("brandsSales")
                        })
                    ]
                }),
                this.state.activeTab === "top_selling_brands" && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                            className: "toggler",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: `toggle ${this.context.listBy === "sales_value" ? "active" : ""}`,
                                    onClick: ()=>{
                                        if (this.context.listBy !== "sales_value") this.context.updateListingType(this.state.activeTab, "sales_value");
                                    },
                                    children: t("salesValue")
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                    className: `toggle ${this.context.listBy === "number_sold" ? "active" : ""}`,
                                    onClick: ()=>{
                                        if (this.context.listBy !== "number_sold") this.context.updateListingType(this.state.activeTab, "number_sold");
                                    },
                                    children: t("numberSold")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                            ref: this.exportTopBrandsRef,
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: this.context.comparedPeriod ? "card-container" : "flex justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "card brands--table",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "brands--body",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                                    className: "card--title",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            children: [
                                                                t("topSellingBrands"),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                                    className: "duration",
                                                                    children: [
                                                                        "(",
                                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.currentPeriod.type, this.context.currentPeriod?.from, this.context.currentPeriod?.to),
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        this.state.brands.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                                            data: this.state.brands,
                                                            filename: `brands_sales breakdown from:${this.context.currentPeriod?.from}-to:${this.context.currentPeriod?.to}.csv`,
                                                            className: "export-list-button",
                                                            target: "_blank",
                                                            children: t("exportList")
                                                        }) : null
                                                    ]
                                                }),
                                                this.state.brands?.map((brand, index)=>{
                                                    if (index < 10) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a178670604cb32d7$export$c3762807d12c1ef5), {
                                                        rowItem: {
                                                            image_url: brand.brand_image_url,
                                                            number_of_items: brand.sales_value,
                                                            name: brand.brand_name || t("unnamed")
                                                        },
                                                        itemIndex: index,
                                                        percentageValue: Math.ceil(brand.sales_value / this.state.totalSales * 100),
                                                        isCompare: !!this.context.comparedPeriod
                                                    }, index);
                                                    return null;
                                                })
                                            ]
                                        })
                                    }),
                                    this.context.comparedPeriod && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "card brands--table",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                            className: "brands--body",
                                            children: [
                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("h2", {
                                                    className: "card--title",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            children: [
                                                                t("topSellingBrands"),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("span", {
                                                                    className: "duration",
                                                                    children: [
                                                                        "(",
                                                                        (0, $48f673e197675daa$export$578c3eea45ec6232)(this.context.comparedPeriod.type, this.context.comparedPeriod?.from, this.context.comparedPeriod?.to),
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        this.state.comparedBrands?.length ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $fad619c9f6051037$exports.CSVLink), {
                                                            data: this.state.comparedBrands,
                                                            filename: `brands_sales breakdown from:${this.context.comparedPeriod?.from}-to:${this.context.comparedPeriod?.to}.csv`,
                                                            className: "export-list-button",
                                                            target: "_blank",
                                                            children: t("exportList")
                                                        }) : null
                                                    ]
                                                }),
                                                this.state.comparedBrands?.map((brand, index)=>{
                                                    if (index < 10) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $a178670604cb32d7$export$c3762807d12c1ef5), {
                                                        rowItem: {
                                                            image_url: brand.brand_image_url,
                                                            number_of_items: brand.sales_value,
                                                            name: brand.brand_name || t("unnamed")
                                                        },
                                                        itemIndex: index,
                                                        percentageValue: Math.ceil(brand.sales_value / this.state.comparedTotalSales * 100)
                                                    }, index);
                                                    return null;
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                this.state.activeTab === "brands_sales" && (this.state.selectedBrand ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                            className: "products-button--back",
                            type: "button",
                            onClick: ()=>{
                                this.setState({
                                    selectedBrand: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $13960f66e93198e5$export$2e2bcd8739ae039), {}),
                                t("backToList")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $173473fffb4dc975$export$2e2bcd8739ae039), {
                            brandName: this.state.selectedBrand,
                            updateBrandName: this.updateSelectedBrand,
                            exportRef: this.exportBrandDetailsSalesRef
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $14ff1a087fb01486$export$2e2bcd8739ae039), {
                    exportRef: this.exportBrandsSalesRef,
                    updateSelectedBrand: this.updateSelectedBrand
                }))
            ]
        });
    }
}
$a2c5280d16199275$var$Brands.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $a2c5280d16199275$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("brands")($a2c5280d16199275$var$Brands);



const $402ff3f88b55a2c2$export$cd891b82501bb412 = {
    // Add Available Routes with it's Components and other details
    Login: {
        path: "/login",
        component: (0, $cfc09e83450c85b1$export$21a94553ffa41578),
        public: true,
        roles: [],
        platform: [],
        scrollDown: false
    },
    Signup: {
        path: "/signup",
        component: (0, $85f2a9ce0bb9f125$export$2e2bcd8739ae039),
        public: true,
        roles: [],
        platform: [],
        scrollDown: false
    },
    ForgotPassword: {
        path: "/forgot-password",
        component: (0, $e9f53849e30eee0d$export$b597ee422a3143dc),
        public: true,
        roles: [],
        platform: [],
        scrollDown: false
    },
    SetPassword: {
        path: "/set-password",
        component: (0, $4c4791664d19d3b5$export$e91361436c2780bd),
        public: true,
        roles: [],
        platform: [],
        scrollDown: false
    },
    Home: {
        component: (0, $cfc09e83450c85b1$export$21a94553ffa41578),
        path: "/",
        exact: true,
        public: true,
        roles: [],
        platform: [],
        scrollDown: false
    },
    Overview: {
        component: (0, $7ed6706ebe97772f$export$2e2bcd8739ae039),
        path: "/overview",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: true
    },
    orders: {
        component: (0, $6712b680f81e5080$export$2e2bcd8739ae039),
        path: "/orders",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: true
    },
    customers: {
        component: (0, $81c0ede2a51bcaf7$export$2e2bcd8739ae039),
        path: "/customers",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    categories: {
        component: (0, $aeedc61284241a45$export$2e2bcd8739ae039),
        path: "/categories",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    brands: {
        component: (0, $a2c5280d16199275$export$2e2bcd8739ae039),
        path: "/brands",
        exact: true,
        public: false,
        roles: [],
        platform: [
            (0, $7bd2ba507819a70f$export$613603fcbf711065).magento
        ],
        scrollDown: false
    },
    stock: {
        component: (0, $f6e85a1b1d037c58$export$660483d3947d0ba9),
        path: "/stock",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    settings: {
        component: (0, $a3a0c9545363f5eb$export$2e2bcd8739ae039),
        path: "/settings",
        exact: false,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    accountInformation: {
        component: (0, $5d4d217f9c00c96f$export$e8923eab9ed2919e),
        path: "/account-information",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    abandonedCarts: {
        component: (0, $4080123389697987$export$2e2bcd8739ae039),
        path: "/abandoned-carts",
        exact: true,
        public: false,
        roles: [
            (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).marketing,
            (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).management,
            (0, $7bd2ba507819a70f$export$eb3485a690c2f0b8).admin
        ],
        platform: [
            (0, $7bd2ba507819a70f$export$613603fcbf711065).magento
        ],
        scrollDown: false
    },
    support: {
        component: (0, $235b3fb709341b44$export$c7a1df07a9ed91ad),
        path: "/support",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    product: {
        component: (0, $be69e13341d50da4$export$2e2bcd8739ae039),
        path: "/product-analytics",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    userBehavior: {
        component: (0, $bcf2052b9f2f3f03$export$2e2bcd8739ae039),
        path: "/user-behavior",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    AllPromoCodes: {
        component: (0, $4e990fa1655d1650$export$2e2bcd8739ae039),
        path: "/user-behavior/all-promo-codes",
        exact: true,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    recommendationsList: {
        component: (0, $2344f62f9223018b$export$2e2bcd8739ae039),
        path: "/recommendations-list",
        exact: false,
        public: false,
        roles: [],
        platform: [],
        scrollDown: false
    },
    confirmRegistration: {
        component: (0, $0c7eb25603ee15e6$export$73d3587e70c88d79),
        path: "/confirm-registration",
        exact: true,
        public: true,
        roles: [],
        platform: [],
        scrollDown: false
    },
    createCampaignn: {
        component: (0, $a8c68036492f5b99$export$2e2bcd8739ae039),
        path: "/create-campaign",
        exact: true,
        public: true,
        roles: [],
        scrollDown: false
    }
};


/**
 * @author Ahmed Serag
 * @date 2021-06-08
 * @description side navbar component
 * @filename side-navbar.tsx
 */ 



var $igtsr = parcelRequire("igtsr");



parcelRequire("igtsr");
const $583d2cdf4a1b6876$var$SvgDoubleArrows = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 14,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#FFF",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m1 1 6 6-6 6M9 1l6 6-6 6"
        })
    });
var $583d2cdf4a1b6876$export$2e2bcd8739ae039 = $583d2cdf4a1b6876$var$SvgDoubleArrows;




parcelRequire("igtsr");
const $42f7033982e9b584$var$SvgOverview = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 27,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#FFF",
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 20.245,
                    height: 24.79,
                    fill: "#000",
                    rx: 5
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "m4.81 13.169 4.027-4.026 1.6 1.6 4.322-3.91"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M10.823 6.66h4.09v4.09M4.81 16.898h5.313"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 17.766,
                    cy: 17.766,
                    r: 5.371,
                    fill: "#FFF"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "m18.983 20.618 1.461-1.461 3.652 3.652a1.033 1.033 0 1 1-1.46 1.46z"
                })
            ]
        })
    });
var $42f7033982e9b584$export$2e2bcd8739ae039 = $42f7033982e9b584$var$SvgOverview;



parcelRequire("igtsr");
const $4505dfd3c5c691af$var$SvgOrder = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 27,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#FFF",
                    strokeLinejoin: "round",
                    d: "M2 0h21a2 2 0 0 1 2 2v3.833H0V2a2 2 0 0 1 2-2Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#000",
                    stroke: "#FFF",
                    d: "M1.667 5.833h21.666V20a5 5 0 0 1-5 5H6.667a5 5 0 0 1-5-5z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    stroke: "#FFF",
                    d: "M5.833 5.833H12.5v6.598a.5.5 0 0 1-.765.424l-2.038-1.274a1 1 0 0 0-1.06 0l-2.039 1.274a.5.5 0 0 1-.765-.424z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                    cx: 19.583,
                    cy: 19.583,
                    r: 5.417,
                    fill: "#FFF",
                    stroke: "#FFF"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#000",
                    d: "M21.978 17.865a.423.423 0 0 1 0 .598l-2.84 2.84a.423.423 0 0 1-.598 0l-1.35-1.353a.423.423 0 1 1 .598-.599l1.053 1.052 2.54-2.54a.423.423 0 0 1 .598 0Z"
                })
            ]
        })
    });
var $4505dfd3c5c691af$export$2e2bcd8739ae039 = $4505dfd3c5c691af$var$SvgOrder;



parcelRequire("igtsr");
const $b5f15d3afb8236c4$var$SvgCustomer = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 26,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#FFF",
            strokeLinejoin: "round",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(17.803 4.279)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 3.928,
                            cy: 2.561,
                            r: 2.561
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#FFF",
                            d: "M4.098 7.148a4.1 4.1 0 0 1 4.099 4.098v4.373a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4.373a4.1 4.1 0 0 1 4.098-4.098Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(1 4.279)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 3.928,
                            cy: 2.561,
                            r: 2.561
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#FFF",
                            d: "M4.098 7.148a4.1 4.1 0 0 1 4.099 4.098v4.373a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4.373a4.1 4.1 0 0 1 4.098-4.098Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    fill: "#000",
                    transform: "translate(6.738 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                            cx: 6.557,
                            cy: 4.098,
                            r: 4.098
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M6.557 10.836a6.557 6.557 0 0 1 6.558 6.557v4.558a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4.558a6.557 6.557 0 0 1 6.557-6.557Z"
                        })
                    ]
                })
            ]
        })
    });
var $b5f15d3afb8236c4$export$2e2bcd8739ae039 = $b5f15d3afb8236c4$var$SvgCustomer;



parcelRequire("igtsr");
const $20c7c72030f3917e$var$SvgCategory = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 27,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#FFF",
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 10.667,
                    height: 15.667,
                    fill: "#000",
                    rx: 5
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 10.667,
                    height: 15.667,
                    x: 14.333,
                    y: 9.333,
                    fill: "#000",
                    rx: 5
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 10.667,
                    height: 5.667,
                    x: 14.333,
                    fill: "#FFF",
                    rx: 2.833
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 10.667,
                    height: 5.667,
                    y: 19.333,
                    fill: "#FFF",
                    rx: 2.833
                })
            ]
        })
    });
var $20c7c72030f3917e$export$2e2bcd8739ae039 = $20c7c72030f3917e$var$SvgCategory;



parcelRequire("igtsr");
const $5e5b21f0ebe3a6f8$var$SvgProduct = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 27,
        viewBox: "0 0 24 27",
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#FFF",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    d: "M4 3.083h11.57a3 3 0 0 1 3 3V23a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6.083a3 3 0 0 1 3-3"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(5.083 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#000",
                            d: "M3 0h9.604l4.965 4.965v14.952a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#FFF",
                            d: "m12.604 0 4.965 4.965h-4.965z"
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 2.292,
                            height: 2.292,
                            x: 3.292,
                            y: 7.257,
                            fill: "#FFF",
                            rx: 0.5
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 2.292,
                            height: 2.292,
                            x: 3.292,
                            y: 11.84,
                            fill: "#FFF",
                            rx: 0.5
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                            width: 2.292,
                            height: 2.292,
                            x: 3.292,
                            y: 16.424,
                            fill: "#FFF",
                            rx: 0.5
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            d: "M7.143 8.403h7.167m-7.167 4.583h7.167m-7.167 4.583h7.167"
                        })
                    ]
                })
            ]
        })
    });
var $5e5b21f0ebe3a6f8$export$2e2bcd8739ae039 = $5e5b21f0ebe3a6f8$var$SvgProduct;



parcelRequire("igtsr");
const $b483e947d8727d45$var$SvgBrands = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 25,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#FFF",
            strokeLinecap: "round",
            transform: "translate(1 1.07)",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "m15.706 1.286 7.762 6.513a2 2 0 0 1 .246 2.817L14.53 21.563a2 2 0 0 1-2.817.246L3.95 15.296a2 2 0 0 1-.247-2.818l9.185-10.946a2 2 0 0 1 2.818-.246Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    d: "m7.983 1.63 9.637 3.132a2 2 0 0 1 1.284 2.52l-4.415 13.59a2 2 0 0 1-2.52 1.284l-9.637-3.131a2 2 0 0 1-1.284-2.52l4.415-13.59a2 2 0 0 1 2.52-1.284Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("rect", {
                    width: 14.133,
                    height: 18.289,
                    y: 3.996,
                    fill: "#000",
                    rx: 2
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    fillRule: "nonzero",
                    strokeLinejoin: "round",
                    d: "m7.693 7.602.345.7a1 1 0 0 0 .753.547l.773.113a.645.645 0 0 1 .357 1.1l-.559.544a1 1 0 0 0-.288.885l.132.77a.645.645 0 0 1-.935.68l-.691-.364a1 1 0 0 0-.93 0l-.692.364a.645.645 0 0 1-.935-.68l.132-.77a1 1 0 0 0-.288-.885l-.56-.545a.645.645 0 0 1 .358-1.1l.773-.112a1 1 0 0 0 .753-.547l.345-.7a.645.645 0 0 1 1.157 0"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    d: "M2.12 16.201h9.976m-7.897 2.078h5.819"
                })
            ]
        })
    });
var $b483e947d8727d45$export$2e2bcd8739ae039 = $b483e947d8727d45$var$SvgBrands;



parcelRequire("igtsr");
const $8598efdea2e0e397$var$SvgAbandonedCarts = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 27,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#FFF",
                    strokeLinejoin: "round",
                    d: "M21.435 21.196a2.405 2.405 0 0 0-2.41 2.4A2.405 2.405 0 0 0 21.43 26a2.405 2.405 0 0 0 2.41-2.4v-.002a2.407 2.407 0 0 0-2.405-2.402Z"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    stroke: "#FFF",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M1.241 3.452h3.404a.28.28 0 0 1 .28.247l2.486 12.843a3.1 3.1 0 0 0 3.053 2.613h11.665a3.08 3.08 0 0 0 3.025-2.46l1.825-9.077a1.12 1.12 0 0 0-1.099-1.331H5.56"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                    transform: "translate(11.01 1)",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                            cx: 5.499,
                            cy: 5.5,
                            fill: "#FFF",
                            stroke: "#FFF",
                            rx: 5.499,
                            ry: 5.5
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                            fill: "#000",
                            fillRule: "nonzero",
                            d: "m7.364 4.278-1.212 1.21 1.212 1.209a.46.46 0 1 1-.652.651L5.5 6.138l-1.213 1.21a.46.46 0 0 1-.652-.651l1.212-1.21-1.212-1.209a.46.46 0 0 1 0-.651c.18-.18.472-.18.652 0L5.5 4.837l1.212-1.21c.18-.18.473-.18.653 0a.46.46 0 0 1 0 .651Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                    fill: "#FFF",
                    fillRule: "nonzero",
                    stroke: "#FFF",
                    strokeLinejoin: "round",
                    d: "M13.831 23.495a2.405 2.405 0 0 0-2.413-2.296 2.404 2.404 0 0 0-2.308 2.497A2.405 2.405 0 0 0 11.474 26h.058a2.404 2.404 0 0 0 2.3-2.505Z"
                })
            ]
        })
    });
var $8598efdea2e0e397$export$2e2bcd8739ae039 = $8598efdea2e0e397$var$SvgAbandonedCarts;



parcelRequire("igtsr");
const $603e163bd90578af$var$SvgUserBehavior = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 27,
        ...props,
        children: [
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                        id: "user-behavior_svg__b",
                        cx: 9,
                        cy: 9,
                        r: 9
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        id: "user-behavior_svg__a",
                        d: "M0 0h25v25H0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(0 .593)",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                        stroke: "#FFF",
                        strokeLinejoin: "round",
                        transform: "translate(1.01)",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                                cx: 9,
                                cy: 9,
                                r: 9
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                fill: "#000",
                                d: "m16.536 14.282 5.497 5.497a2.03 2.03 0 0 1-2.872 2.871l-5.635-5.635q1.222-.726 1.785-1.237.564-.511 1.225-1.496Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("g", {
                        stroke: "#FFF",
                        strokeLinejoin: "round",
                        mask: "url('f2bf220e8dd0976c')",
                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("g", {
                            transform: "translate(5 3.407)",
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ellipse", {
                                    cx: 5,
                                    cy: 2.5,
                                    fill: "#FFF",
                                    rx: 2.533,
                                    ry: 2.5
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                                    fill: "#000",
                                    d: "M4.935 7.403h.13A4.935 4.935 0 0 1 10 12.338v2.935a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.935a4.935 4.935 0 0 1 4.935-4.935Z"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("circle", {
                        cx: 10.01,
                        cy: 9,
                        r: 9,
                        stroke: "#FFF",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        stroke: "#FFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "m0 24.407 10.566-10.593 2.39 2.003 11.26-12.41"
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
                        stroke: "#FFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M20.252 3.22h4.124v4.124"
                    })
                ]
            })
        ]
    });
var $603e163bd90578af$export$2e2bcd8739ae039 = $603e163bd90578af$var$SvgUserBehavior;



class $40aea095ad5d0bec$var$SideNavbar extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    constructor(props){
        super(props);
        this.state = {
            settingsMenu: false
        };
    }
    render() {
        const { t: t } = this.props;
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
            className: `side-navbar ${this.context.sideBarOpened ? "side-navbar--opened" : ""} ${this.context.sideNavBarCollapsed ? "side-navbar--collapsed" : ""}`,
            children: [
                this.context.sideBarOpened && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                    type: "button",
                    className: "side-navbar--exit",
                    onClick: ()=>{
                        this.context.updateSideBarOpened(false);
                    },
                    children: "x"
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                    className: "logo",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $f11264a5073aa658$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                    className: "nav-items",
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Overview.path,
                            className: "item",
                            onClick: ()=>{
                                this.context.updateSideBarOpened(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $42f7033982e9b584$export$2e2bcd8739ae039), {
                                    className: "nav-icon"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "sidenav--label",
                                    children: t("overview")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).orders.path,
                            className: "item",
                            onClick: ()=>{
                                this.context.updateSideBarOpened(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $4505dfd3c5c691af$export$2e2bcd8739ae039), {
                                    className: "nav-icon"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "sidenav--label",
                                    children: t("orders")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).customers.path,
                            className: "item",
                            onClick: ()=>{
                                this.context.updateSideBarOpened(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $b5f15d3afb8236c4$export$2e2bcd8739ae039), {
                                    className: "nav-icon"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "sidenav--label",
                                    children: t("customers")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).categories.path,
                            className: "item",
                            onClick: ()=>{
                                this.context.updateSideBarOpened(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $20c7c72030f3917e$export$2e2bcd8739ae039), {
                                    className: "nav-icon"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "sidenav--label",
                                    children: t("categories")
                                })
                            ]
                        }),
                        this.context.settings.is_internal ? /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $19d768f45b7e36ad$export$2e2bcd8739ae039), {
                            allowedPlatforms: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).brands.platform,
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                                to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).brands.path,
                                className: "item",
                                onClick: ()=>{
                                    this.context.updateSideBarOpened(false);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $b483e947d8727d45$export$2e2bcd8739ae039), {
                                        className: "nav-icon"
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "sidenav--label",
                                        children: t("brands")
                                    })
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).stock.path,
                            className: "item",
                            onClick: ()=>{
                                this.context.updateSideBarOpened(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $5e5b21f0ebe3a6f8$export$2e2bcd8739ae039), {
                                    className: "nav-icon"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "sidenav--label",
                                    children: t("productStock")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $19d768f45b7e36ad$export$2e2bcd8739ae039), {
                            allowedRoles: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).abandonedCarts.roles,
                            allowedPlatforms: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).abandonedCarts.platform,
                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                                to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).abandonedCarts.path,
                                className: "item",
                                onClick: ()=>{
                                    this.context.updateSideBarOpened(false);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $8598efdea2e0e397$export$2e2bcd8739ae039), {
                                        className: "nav-icon"
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                        className: "sidenav--label",
                                        children: t("abandonedCarts")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$b0d92dbee9b5b60d), {
                            to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).userBehavior.path,
                            className: "item",
                            onClick: ()=>{
                                this.context.updateSideBarOpened(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $603e163bd90578af$export$2e2bcd8739ae039), {
                                    className: "nav-icon"
                                }),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                                    className: "sidenav--label",
                                    children: t("userBehavior")
                                })
                            ]
                        })
                    ]
                }),
                !this.context.sideBarOpened && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("button", {
                    className: "hide-button",
                    type: "button",
                    onClick: this.context.toggleSideNavBarCollapsed,
                    children: [
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("span", {
                            children: this.context.sideNavBarCollapsed ? t("view") : t("hide")
                        }),
                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $583d2cdf4a1b6876$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        });
    }
}
$40aea095ad5d0bec$var$SideNavbar.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $40aea095ad5d0bec$export$2e2bcd8739ae039 = (0, $66f4ab6003d1e60a$export$2dcb0053efd21124)("common")($40aea095ad5d0bec$var$SideNavbar);





function $7373832010cbad41$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7373832010cbad41$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7373832010cbad41$var$_typeof(o);
}
var $7373832010cbad41$var$arr = [];
var $7373832010cbad41$var$each = $7373832010cbad41$var$arr.forEach;
var $7373832010cbad41$var$slice = $7373832010cbad41$var$arr.slice;
function $7373832010cbad41$export$ebe90cb607ad99e(obj) {
    $7373832010cbad41$var$each.call($7373832010cbad41$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $7373832010cbad41$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $7373832010cbad41$var$_typeof(XMLHttpRequest)) === 'object';
}
function $7373832010cbad41$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $7373832010cbad41$export$1625492ec82002b9(maybePromise) {
    if ($7373832010cbad41$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



function $461ddbc92dca4e30$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $461ddbc92dca4e30$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $461ddbc92dca4e30$var$ownKeys(Object(t), !0).forEach(function(r) {
            $461ddbc92dca4e30$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $461ddbc92dca4e30$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $461ddbc92dca4e30$var$_defineProperty(e, r, t) {
    return (r = $461ddbc92dca4e30$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $461ddbc92dca4e30$var$_toPropertyKey(t) {
    var i = $461ddbc92dca4e30$var$_toPrimitive(t, "string");
    return "symbol" == $461ddbc92dca4e30$var$_typeof(i) ? i : i + "";
}
function $461ddbc92dca4e30$var$_toPrimitive(t, r) {
    if ("object" != $461ddbc92dca4e30$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $461ddbc92dca4e30$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $461ddbc92dca4e30$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $461ddbc92dca4e30$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $461ddbc92dca4e30$var$_typeof(o);
}
var $461ddbc92dca4e30$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $461ddbc92dca4e30$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $461ddbc92dca4e30$var$fetchApi = window.fetch;
var $461ddbc92dca4e30$var$XmlHttpRequestApi;
if ((0, $7373832010cbad41$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $461ddbc92dca4e30$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $461ddbc92dca4e30$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $461ddbc92dca4e30$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $461ddbc92dca4e30$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $461ddbc92dca4e30$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $461ddbc92dca4e30$var$fetchApi !== 'function') $461ddbc92dca4e30$var$fetchApi = undefined;

if (!$461ddbc92dca4e30$var$fetchApi && !$461ddbc92dca4e30$var$XmlHttpRequestApi && !$461ddbc92dca4e30$var$ActiveXObjectApi) try {
    (parcelRequire("flTbo")).then(function(mod) {
        $461ddbc92dca4e30$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $461ddbc92dca4e30$var$addQueryString = function addQueryString(url, params) {
    if (params && $461ddbc92dca4e30$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $461ddbc92dca4e30$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $461ddbc92dca4e30$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $461ddbc92dca4e30$var$omitFetchOptions = false;
var $461ddbc92dca4e30$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $461ddbc92dca4e30$var$addQueryString(url, options.queryStringParams);
    var headers = $461ddbc92dca4e30$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $461ddbc92dca4e30$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $461ddbc92dca4e30$var$omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $461ddbc92dca4e30$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $461ddbc92dca4e30$var$fetchIt(url, fetchOptions, callback, altFetch);
            $461ddbc92dca4e30$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $461ddbc92dca4e30$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $461ddbc92dca4e30$var$_typeof(payload) === 'object') payload = $461ddbc92dca4e30$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $461ddbc92dca4e30$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $461ddbc92dca4e30$var$XmlHttpRequestApi ? new $461ddbc92dca4e30$var$XmlHttpRequestApi() : new $461ddbc92dca4e30$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $461ddbc92dca4e30$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($461ddbc92dca4e30$var$fetchApi && url.indexOf('file:') !== 0) return $461ddbc92dca4e30$var$requestWithFetch(options, url, payload, callback);
    if ((0, $7373832010cbad41$export$87022daa49baf612)() || typeof ActiveXObject === 'function') return $461ddbc92dca4e30$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $461ddbc92dca4e30$export$2e2bcd8739ae039 = $461ddbc92dca4e30$var$request;


function $892add794b5723c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $892add794b5723c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $892add794b5723c7$var$_typeof(o);
}
function $892add794b5723c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $892add794b5723c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $892add794b5723c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $892add794b5723c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $892add794b5723c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $892add794b5723c7$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $892add794b5723c7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $892add794b5723c7$var$_toPropertyKey(o.key), o);
    }
}
function $892add794b5723c7$var$_createClass(e, r, t) {
    return r && $892add794b5723c7$var$_defineProperties(e.prototype, r), t && $892add794b5723c7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $892add794b5723c7$var$_defineProperty(e, r, t) {
    return (r = $892add794b5723c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $892add794b5723c7$var$_toPropertyKey(t) {
    var i = $892add794b5723c7$var$_toPrimitive(t, "string");
    return "symbol" == $892add794b5723c7$var$_typeof(i) ? i : i + "";
}
function $892add794b5723c7$var$_toPrimitive(t, r) {
    if ("object" != $892add794b5723c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $892add794b5723c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $892add794b5723c7$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $892add794b5723c7$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $461ddbc92dca4e30$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $892add794b5723c7$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $892add794b5723c7$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $892add794b5723c7$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $892add794b5723c7$var$_objectSpread($892add794b5723c7$var$_objectSpread($892add794b5723c7$var$_objectSpread({}, $892add794b5723c7$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($892add794b5723c7$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $7373832010cbad41$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + url + ': ' + err.message, true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$892add794b5723c7$var$Backend.type = 'backend';
var $892add794b5723c7$export$2e2bcd8739ae039 = $892add794b5723c7$var$Backend;


(0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039).use((0, $ed6f062c2e258fb8$export$ae7e14d40d89f296)).use((0, $892add794b5723c7$export$2e2bcd8739ae039)).init({
    supportedLngs: [
        "en",
        "ar"
    ],
    // Allows "en-US" and "en-UK" to be implcitly supported when "en"
    // is supported
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    },
    debug: false
});
var $4402d286da3fd0cc$export$2e2bcd8739ae039 = (0, $d0d7e7d07316f3a2$export$2e2bcd8739ae039);



parcelRequire("igtsr");
const $810710fa63e54a18$var$SvgMenu = (props)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        ...props,
        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("path", {
            d: "M41 14H7a2 2 0 0 1 0-4h34a2 2 0 0 1 0 4m0 12H7a2 2 0 0 1 0-4h34a2 2 0 0 1 0 4m0 12H7a2 2 0 0 1 0-4h34a2 2 0 0 1 0 4"
        })
    });
var $810710fa63e54a18$export$2e2bcd8739ae039 = $810710fa63e54a18$var$SvgMenu;


/**
 * @author Salma Hefnawy
 * @date 2020-06-07
 * @description implementation of scroll down indicator component
 * @filename scroll-down.tsx
 */ 


var $igtsr = parcelRequire("igtsr");
class $c0aaff7847fd6a72$var$ScrollDownIndicator extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    componentDidMount() {
        /**
     * add and remove scroll down indicator according to scroll position
     */ const scrollDown = document.getElementById("scroll-down");
        // const root = document.getElementById("main-section");
        if (scrollDown && scrollDown.nextElementSibling) console.log(scrollDown?.nextElementSibling, scrollDown?.nextElementSibling?.clientHeight, scrollDown?.nextElementSibling?.scrollHeight);
        window.onscroll = ()=>{
            const currentScrollPos = window.scrollY;
            if (scrollDown) {
                if (currentScrollPos >= 50) scrollDown.classList.add("scroll-down--hide");
                else scrollDown.classList.remove("scroll-down--hide");
            }
        };
    }
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: "scroll-down",
            id: "scroll-down"
        });
    }
}
$c0aaff7847fd6a72$var$ScrollDownIndicator.contextType = (0, $93880734d471a57f$export$3cbe56a0cabcff38);
var $c0aaff7847fd6a72$export$2e2bcd8739ae039 = $c0aaff7847fd6a72$var$ScrollDownIndicator;



const $47f8abebfe0e3584$export$c834b5751a21e486 = "https://www.onesight.ai";
const $47f8abebfe0e3584$export$fff30d0537d9a74f = [
    {
        label: "Home",
        url: $47f8abebfe0e3584$export$c834b5751a21e486
    },
    {
        label: "Pricing",
        url: `${$47f8abebfe0e3584$export$c834b5751a21e486}/pricing`
    },
    {
        label: "Features",
        url: `${$47f8abebfe0e3584$export$c834b5751a21e486}/features`
    },
    {
        label: "Contact",
        url: `${$47f8abebfe0e3584$export$c834b5751a21e486}/contact`
    },
    {
        label: "About",
        url: `${$47f8abebfe0e3584$export$c834b5751a21e486}/about`
    }
];
const $47f8abebfe0e3584$export$e922dc05073ac087 = [
    {
        label: "Terms & Conditions",
        url: `${$47f8abebfe0e3584$export$c834b5751a21e486}/utility-pages/terms`
    },
    {
        label: "Privacy Policy",
        url: `${$47f8abebfe0e3584$export$c834b5751a21e486}/utility-pages/privacy`
    },
    {
        label: "Refund Policy",
        url: `${$47f8abebfe0e3584$export$c834b5751a21e486}/utility-pages/refundpolicy`
    }
];



var $igtsr = parcelRequire("igtsr");
var $c050d04f1660d6c5$exports = {};
$c050d04f1660d6c5$exports = $parcel$resolve("ga3ID");


class $eb257170efcdddc9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("header", {
            className: "public-website__header",
            children: [
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                    href: (0, $47f8abebfe0e3584$export$c834b5751a21e486),
                    className: "public-website__header__logo",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c050d04f1660d6c5$exports))),
                        alt: "logo"
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("nav", {
                    className: "public-website__header__nav",
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                        children: (0, $47f8abebfe0e3584$export$fff30d0537d9a74f).map((item)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                    href: item.url,
                                    children: item.label
                                })
                            }, item.label))
                    })
                }),
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                    href: `${(0, $47f8abebfe0e3584$export$c834b5751a21e486)}/pricing`,
                    className: "public-website__header__button",
                    children: "Get Started For Free"
                })
            ]
        });
    }
}





var $igtsr = parcelRequire("igtsr");

class $9c6daf615c3e9102$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($igtsr))).Component {
    render() {
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("footer", {
            className: "public-website__footer",
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                className: "public-website__footer__wrapper",
                children: [
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                        className: "public-website__footer__content",
                        children: [
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                href: (0, $47f8abebfe0e3584$export$c834b5751a21e486),
                                className: "public-website__footer__logo",
                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c050d04f1660d6c5$exports))),
                                    alt: "logo"
                                })
                            }),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("nav", {
                                className: "public-website__footer__nav",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                                children: "Menu"
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                                children: (0, $47f8abebfe0e3584$export$fff30d0537d9a74f).map((item)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                            href: item.url,
                                                            children: item.label
                                                        })
                                                    }, item.label))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h2", {
                                                children: "Utility Pages"
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("ul", {
                                                children: (0, $47f8abebfe0e3584$export$e922dc05073ac087).map((item)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("a", {
                                                            href: item.url,
                                                            children: item.label
                                                        })
                                                    }, item.label))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("small", {
                        children: "Copyright \xa9 Onesight"
                    })
                ]
            })
        });
    }
}



/**
 * the Start point of the project.
 *
 * @class App
 * @extends {React.Component<{}, AppState>}
 */ class $0f970435ead841e3$var$App extends $igtsr.Component {
    constructor(props){
        super(props);
        const query = window.location.search;
        const params = new URLSearchParams(query);
        this.state = {
            project: null,
            currentPeriod: {
                alias: "thisMonth",
                from: (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)(new Date()), "yyyy-MM-dd"),
                to: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(new Date(), "yyyy-MM-dd"),
                type: "month"
            },
            comparedPeriod: null,
            periodsChangesCallbacks: {},
            loadingUser: true,
            sideBarOpened: false,
            sideNavBarCollapsed: false,
            listBy: params.get("listBy") ?? "sales_value",
            appliedFilters: {},
            availableFilters: {},
            availableFiltersSegments: [],
            loadingFiltersSegments: true,
            isCreateANewSegmentOpen: false,
            loadingFilters: true,
            showIntegrationKeysModal: false,
            showingExceedingOrdersLimitModal: false,
            ordersSinceLastSubscription: null
        };
        this.updateUser = this.updateUser.bind(this);
        this.updateProject = this.updateProject.bind(this);
        this.loadSettings = this.loadSettings.bind(this);
        this.loadAvailableFilters = this.loadAvailableFilters.bind(this);
        this.checkOrdersLimitHandler = this.checkOrdersLimitHandler.bind(this);
        this.getOrdersSinceLastSubscription = this.getOrdersSinceLastSubscription.bind(this);
        this.checkOrdersLimit = this.checkOrdersLimit.bind(this);
        this.updateSettings = this.updateSettings.bind(this);
        this.updateAppearanceSettings = this.updateAppearanceSettings.bind(this);
        this.updateComparedPeriod = this.updateComparedPeriod.bind(this);
        this.updateCurrentPeriod = this.updateCurrentPeriod.bind(this);
        this.addUpdatesListener = this.addUpdatesListener.bind(this);
        this.removeUpdatesListener = this.removeUpdatesListener.bind(this);
        this.fireUpdatesCallbacks = this.fireUpdatesCallbacks.bind(this);
        this.updateSideBarOpened = this.updateSideBarOpened.bind(this);
        this.toggleSideNavBarCollapsed = this.toggleSideNavBarCollapsed.bind(this);
        this.updateUrlQueryParams = this.updateUrlQueryParams.bind(this);
        this.updateAppliedFilters = this.updateAppliedFilters.bind(this);
        this.loadFiltersFromQueryParams = this.loadFiltersFromQueryParams.bind(this);
        this.updateListingType = this.updateListingType.bind(this);
        this.showIntegrationKeysModal = this.showIntegrationKeysModal.bind(this);
        this.hideIntegrationKeysModal = this.hideIntegrationKeysModal.bind(this);
        this.showExceedingOrdersLimitModal = this.showExceedingOrdersLimitModal.bind(this);
        this.hideExceedingOrdersLimitModal = this.hideExceedingOrdersLimitModal.bind(this);
        this.loadAvailableFiltersSegments = this.loadAvailableFiltersSegments.bind(this);
        this.toggleCreateANewSegment = this.toggleCreateANewSegment.bind(this);
        this.updateFiltersSegments = this.updateFiltersSegments.bind(this);
        this.updateAppliedFiltersSegment = this.updateAppliedFiltersSegment.bind(this);
    }
    componentDidMount() {
        let promise = (0, $bd69b505bf48eca0$export$3d7a1e8452f884f3).getCurrentUser().then((user)=>{
            return new Promise((resolve)=>{
                this.setState({
                    user: user
                }, ()=>resolve());
            });
        }).catch(()=>{
            console.log("I'm not sure why we aren't handling this!");
        });
        promise = promise.then(()=>{
            return this.loadSettings();
        });
        promise = promise.then(()=>{
            return this.loadAvailableFilters();
        });
        promise = promise.then(()=>{
            return this.loadAvailableFiltersSegments();
        });
        promise = promise.then(()=>{
            return this.loadFiltersFromQueryParams();
        });
        promise.finally(()=>{
            this.setState({
                loadingUser: false,
                loadingFilters: false
            });
        });
    }
    getOrdersSinceLastSubscription() {
        return (0, $56fb02d394e3f062$export$8e49c52f79b6b5ed)().then((ordersSinceLastSubscription)=>{
            this.setState({
                ordersSinceLastSubscription: ordersSinceLastSubscription
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error(err);
            (0, $d41f521f78665649$export$b410431fab84fa58).error(err);
        });
    }
    checkOrdersLimitHandler() {
        this.getOrdersSinceLastSubscription().then(()=>{
            this.checkOrdersLimit();
        });
    }
    checkOrdersLimit() {
        if (this.state.ordersSinceLastSubscription?.max_orders && this.state.ordersSinceLastSubscription?.orders_count > this.state.ordersSinceLastSubscription?.max_orders) this.showExceedingOrdersLimitModal();
    }
    loadSettings() {
        return (0, $56fb02d394e3f062$export$4a647155031ece)().then((settings)=>{
            const projectSettings = settings.find((setting)=>setting.code === this.state.project);
            if (projectSettings) {
                // DEBUG: check if project hasn't been integrated through super admin
                if (!projectSettings.currency && !projectSettings.edition && projectSettings.timezone_diff === "0") this.showIntegrationKeysModal();
                return this.updateSettings(projectSettings);
            }
            return new Promise((resolve)=>{
                this.setState({
                    project: settings[0].code
                }, ()=>{
                    resolve(this.updateSettings(settings[0]));
                });
                // check if user has not finished integration upon login
                if (!this.state.settings?.currency && !this.state.settings?.edition && this.state.settings?.timezone_diff === "0") this.showIntegrationKeysModal();
                this.checkOrdersLimitHandler();
            });
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
            (0, $d41f521f78665649$export$b410431fab84fa58).error("Failed to load project settings");
            return Promise.resolve(error);
        });
    }
    loadAvailableFilters() {
        this.setState({
            loadingFilters: true
        });
        (0, $eadf35cb023988c9$export$5802bcdbb39280f6)(this.state.project).then((availableFilters)=>{
            this.setState({
                availableFilters: availableFilters
            });
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        }).finally(()=>{
            this.setState({
                loadingFilters: false
            });
        });
    }
    loadAvailableFiltersSegments() {
        this.setState({
            loadingFiltersSegments: true
        });
        (0, $eadf35cb023988c9$export$4739a2e98d4ba69f)(this.state.project).then((availableFiltersSegments)=>{
            this.setState({
                availableFiltersSegments: availableFiltersSegments
            });
        }).catch((error)=>{
            (0, $d41f521f78665649$export$b410431fab84fa58).error(error);
        }).finally(()=>{
            this.setState({
                loadingFiltersSegments: false
            });
        });
    }
    updateFiltersSegments(filtersSegments) {
        this.setState({
            availableFiltersSegments: filtersSegments
        });
    }
    updateAppliedFiltersSegment(filtersSegment) {
        this.setState({
            appliedFiltersSegment: filtersSegment
        });
    }
    updateSettings(settings) {
        const updatedSettings = {
            ...settings,
            primary_color: settings.primary_color.indexOf("#") === 0 ? settings.primary_color : `#${settings.primary_color}`,
            logo: settings.logo
        };
        return new Promise((resolve)=>{
            this.setState({
                settings: updatedSettings
            }, ()=>{
                if (this.state.user.language) (0, $56fb02d394e3f062$export$61465194746e7fd2)(this.state.user.language).then(()=>{
                    (0, $4402d286da3fd0cc$export$2e2bcd8739ae039).changeLanguage(this.state.user.language);
                });
                // TODO update the primary color of the app
                // document.documentElement.style.setProperty(
                //   "--color-primary",
                //   updatedSettings?.primary_color
                // );
                if (this.state.user.language === "ar") {
                    document.documentElement.setAttribute("dir", "rtl");
                    document.documentElement.setAttribute("lang", "ar");
                } else {
                    document.documentElement.setAttribute("dir", "ltr");
                    document.documentElement.setAttribute("lang", "en");
                }
                this.fireUpdatesCallbacks();
                resolve();
            });
        });
    }
    updateAppliedFilters(advancedFilters) {
        this.setState({
            appliedFilters: advancedFilters
        }, ()=>{
            this.updateUrlQueryParams();
            this.fireUpdatesCallbacks();
            this.loadAvailableFiltersSegments();
        });
    }
    /**
   * handles updating the appearance settings (primary color and low stock threshold)
   * @param {SettingsInterface} settings
   * @returns {void}
   */ updateAppearanceSettings(settings) {
        this.setState({
            settings: {
                ...this.state.settings,
                primary_color: `#${settings.primary_color}`,
                logo: settings.logo
            }
        });
    }
    updateUrlQueryParams(activeTab, listBy) {
        const basePath = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        const currentPeriodQuery = (0, $9702949453a4f797$export$7ef984faa3cd4d76)("currentPeriod", this.state.currentPeriod);
        const comparedPeriodQuery = this.state.comparedPeriod ? `&${(0, $9702949453a4f797$export$7ef984faa3cd4d76)("comparedPeriod", this.state.comparedPeriod)}` : "";
        const activeTabsQuery = activeTab || listBy ? `&${(0, $9702949453a4f797$export$3c311ccce60fdde)(activeTab, listBy)}` : "";
        const advancedFiltersQuery = Object.keys(this.state.appliedFilters).length ? `&advancedFilters=${JSON.stringify(this.state.appliedFilters)}` : "";
        const finalPath = `${basePath}?${currentPeriodQuery}${comparedPeriodQuery}${activeTabsQuery}${advancedFiltersQuery}`;
        window.history.replaceState({
            path: finalPath
        }, "", finalPath);
    }
    loadFiltersFromQueryParams() {
        const query = window.location.search;
        const comparedPeriod = (0, $9702949453a4f797$export$39b294e5c328223c)("comparedPeriod", query);
        const currentPeriod = (0, $9702949453a4f797$export$39b294e5c328223c)("currentPeriod", query) ?? {
            alias: "thisMonth",
            from: (0, $7aa2e35e5d01626e$export$d9468344d3651243)((0, $cb7d93512cb8fc54$export$a5a3b454ada2268e)(new Date()), "yyyy-MM-dd"),
            to: (0, $7aa2e35e5d01626e$export$d9468344d3651243)(new Date(), "yyyy-MM-dd"),
            type: "month"
        };
        const filtersJSON = new URLSearchParams(query).get("advancedFilters");
        const filters = filtersJSON ? JSON.parse(filtersJSON) : {};
        this.setState({
            comparedPeriod: comparedPeriod,
            currentPeriod: currentPeriod,
            appliedFilters: filters
        }, this.fireUpdatesCallbacks);
    }
    updateUser(user) {
        this.setState({
            user: user,
            project: undefined,
            loadingUser: user ? true : this.state.loadingUser
        }, ()=>{
            if (user) {
                (0, $56fb02d394e3f062$export$61465194746e7fd2)(user.language).then(()=>{
                    (0, $4402d286da3fd0cc$export$2e2bcd8739ae039).changeLanguage(user.language);
                });
                this.loadSettings().then(()=>{
                    this.setState({
                        loadingUser: false
                    });
                });
            }
        });
    }
    updateSideBarOpened(opened) {
        this.setState({
            sideBarOpened: opened
        });
    }
    toggleSideNavBarCollapsed() {
        this.setState({
            sideNavBarCollapsed: !this.state.sideNavBarCollapsed
        });
    }
    updateProject(project) {
        this.setState({
            project: project,
            appliedFilters: {}
        }, ()=>{
            this.loadSettings();
            this.loadAvailableFilters();
            this.loadAvailableFiltersSegments();
            this.updateUrlQueryParams();
            this.fireUpdatesCallbacks();
        });
    }
    updateCurrentPeriod(period) {
        if (period?.from !== this.state.currentPeriod?.from || period?.to !== this.state.currentPeriod?.to || period.alias !== this.state.currentPeriod.alias) this.setState({
            currentPeriod: period
        }, ()=>{
            this.updateUrlQueryParams();
            this.fireUpdatesCallbacks();
        });
    }
    updateComparedPeriod(period) {
        if (period?.from !== this.state.comparedPeriod?.from || period?.to !== this.state.comparedPeriod?.to) this.setState({
            comparedPeriod: period
        }, ()=>{
            this.updateUrlQueryParams();
            this.fireUpdatesCallbacks();
        });
    }
    /**
   * handles updating the listing type whether
   * it is by number of items sold or sales value
   * @param {Listings} listType
   * @returns {void}
   */ updateListingType(activeTab, listType) {
        if (listType !== this.state.listBy) this.setState({
            listBy: listType
        }, ()=>{
            this.updateUrlQueryParams(activeTab, listType);
            this.fireUpdatesCallbacks();
        });
    }
    addUpdatesListener(id, callback) {
        this.setState((state)=>({
                periodsChangesCallbacks: {
                    ...state.periodsChangesCallbacks,
                    [id]: callback
                }
            }));
    }
    removeUpdatesListener(id) {
        const periodsChangesCallbacks = this.state.periodsChangesCallbacks;
        delete periodsChangesCallbacks[id];
        this.setState({
            periodsChangesCallbacks: periodsChangesCallbacks
        });
    }
    fireUpdatesCallbacks() {
        for(const callbackId in this.state.periodsChangesCallbacks)if (this.state.periodsChangesCallbacks[callbackId]) this.state.periodsChangesCallbacks[callbackId]();
    }
    hideIntegrationKeysModal() {
        this.setState({
            showIntegrationKeysModal: false
        });
        (0, $48f673e197675daa$export$110700823644f4a6)("hideIntegrationKeysModal", "true", 1);
    }
    showIntegrationKeysModal() {
        if (!(0, $48f673e197675daa$export$4be65e66cfa2648a)("hideIntegrationKeysModal")) this.setState({
            showIntegrationKeysModal: true
        });
    }
    showExceedingOrdersLimitModal() {
        this.setState({
            showingExceedingOrdersLimitModal: true
        });
    }
    hideExceedingOrdersLimitModal() {
        this.setState({
            showingExceedingOrdersLimitModal: false
        });
    }
    toggleCreateANewSegment(filtersSegment) {
        this.setState({
            isCreateANewSegmentOpen: !this.state.isCreateANewSegmentOpen,
            // handling a case when user is editing a segment that is not applied
            editingSegment: filtersSegment || this.state.appliedFiltersSegment
        });
    }
    render() {
        if (this.state.loadingUser) return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {});
        const availableRoutes = Object.keys((0, $402ff3f88b55a2c2$export$cd891b82501bb412)).reduce((prev, cur)=>{
            const noUserFound = !this.state.loadingUser && !this.state.user && !(0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].public;
            // user denied access to route according to his role
            const userNotPermitted = this.state.user && !(0, $48f673e197675daa$export$b325ec6732b039cf)((0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].roles, this.state.user.roles);
            if (noUserFound || userNotPermitted) return prev;
            const Component = (0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].component;
            return [
                ...prev,
                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$e7b0ac011bb776c6), {
                    path: (0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].path,
                    exact: (0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].exact,
                    render: (renderProps)=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                            children: [
                                (0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].scrollDown && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $c0aaff7847fd6a72$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)(Component, {
                                    ...renderProps,
                                    ...(0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].props
                                })
                            ]
                        })
                }, (0, $402ff3f88b55a2c2$export$cd891b82501bb412)[cur].path)
            ];
        }, []);
        return /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
            className: this.state.user && `${this.state.sideNavBarCollapsed ? "main-screen-collapsed" : "main-screen"}`,
            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($igtsr.Suspense, {
                fallback: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $cd4c5170d0017b62$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $93880734d471a57f$export$3cbe56a0cabcff38).Provider, {
                    value: {
                        comparedPeriod: this.state.comparedPeriod,
                        currentPeriod: this.state.currentPeriod,
                        project: this.state.project,
                        user: this.state.user,
                        loadingUser: this.state.loadingUser,
                        sideBarOpened: this.state.sideBarOpened,
                        sideNavBarCollapsed: this.state.sideNavBarCollapsed,
                        settings: this.state.settings,
                        listBy: this.state.listBy,
                        appliedFilters: this.state.appliedFilters,
                        availableFilters: this.state.availableFilters,
                        availableFiltersSegments: this.state.availableFiltersSegments,
                        appliedFiltersSegment: this.state.appliedFiltersSegment,
                        loadingFiltersSegments: this.state.loadingFiltersSegments,
                        isCreateANewSegmentOpen: this.state.isCreateANewSegmentOpen,
                        loadingFilters: this.state.loadingFilters,
                        toggleCreateANewSegment: this.toggleCreateANewSegment,
                        updateSideBarOpened: this.updateSideBarOpened,
                        toggleSideNavBarCollapsed: this.toggleSideNavBarCollapsed,
                        updateUser: this.updateUser,
                        setProject: this.updateProject,
                        updateComparedPeriod: this.updateComparedPeriod,
                        updateFiltersSegments: this.updateFiltersSegments,
                        updateAppliedFiltersSegment: this.updateAppliedFiltersSegment,
                        updateCurrentPeriod: this.updateCurrentPeriod,
                        addUpdatesListener: this.addUpdatesListener,
                        removeUpdatesListener: this.removeUpdatesListener,
                        updateSettings: this.updateSettings,
                        updateAppearanceSettings: this.updateAppearanceSettings,
                        updateUrlQueryParams: this.updateUrlQueryParams,
                        updateListingType: this.updateListingType,
                        updateAppliedFilters: this.updateAppliedFilters,
                        showIntegrationKeysModal: this.showIntegrationKeysModal,
                        hideIntegrationKeysModal: this.hideIntegrationKeysModal,
                        showExceedingOrdersLimitModal: this.showExceedingOrdersLimitModal,
                        hideExceedingOrdersLimitModal: this.hideExceedingOrdersLimitModal,
                        loadSettings: this.loadSettings,
                        showingExceedingOrdersLimitModal: this.state.showingExceedingOrdersLimitModal,
                        isIntegrated: !this.state.settings?.currency && !this.state.settings?.edition && !this.state.settings?.timezone_diff
                    },
                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $0e6a7be968c19910$export$9ba4e89fdfa1fc54), {
                        children: [
                            this.state.user && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$e7b0ac011bb776c6), {
                                component: (0, $40aea095ad5d0bec$export$2e2bcd8739ae039)
                            }, "side-navbar"),
                            this.state.user && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: "responsive-navbar",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "burger-menu-icon",
                                        onClick: ()=>{
                                            this.setState({
                                                sideBarOpened: true
                                            });
                                        },
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $810710fa63e54a18$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                        className: "logo",
                                        children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $f11264a5073aa658$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            !this.state.user && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $eb257170efcdddc9$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                className: this.state.user && "main-section",
                                id: "main-section",
                                children: [
                                    /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $64a2d600c7194f1d$export$b5d5cf8927ab7262), {
                                        children: [
                                            availableRoutes,
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$e7b0ac011bb776c6), {
                                                render: ()=>/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $64a2d600c7194f1d$export$2d8d895a0a0f636e), {
                                                        to: (0, $402ff3f88b55a2c2$export$cd891b82501bb412).Home.path
                                                    })
                                            })
                                        ]
                                    }),
                                    this.state.user && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1aff520041650bb7$export$2b77a92f1a5ad772), {
                                                showModal: this.state.showIntegrationKeysModal,
                                                handleClose: ()=>this.hideIntegrationKeysModal(),
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "settings__modal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("h1", {
                                                            className: "settings__modal-title",
                                                            children: (0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("common:finishYourIntegration")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                            className: "settings__modal-description",
                                                            children: `${(0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("common:finishYourIntegrationDescription")}${this.state.settings?.platform} ${(0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("common:adminDashboard")}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                            className: "settings__modal-actions flex gap-10",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "button--main button--delete button--link",
                                                                    onClick: this.hideIntegrationKeysModal,
                                                                    children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                                                        to: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).settings.path}/integration-keys`,
                                                                        children: (0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("settings:integrationKeys")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "button-outline",
                                                                    onClick: ()=>this.hideIntegrationKeysModal(),
                                                                    children: (0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("common:cancel")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("p", {
                                                            className: "modal__disclaimer",
                                                            children: [
                                                                `${(0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("common:alreadyFinishedIntegration")} `,
                                                                /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                                                    to: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).support.path}`,
                                                                    onClick: this.hideIntegrationKeysModal,
                                                                    className: "external-link",
                                                                    children: `${(0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("common:contactUs")}`
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $1aff520041650bb7$export$2b77a92f1a5ad772), {
                                                showModal: this.state.showingExceedingOrdersLimitModal,
                                                handleClose: ()=>this.hideExceedingOrdersLimitModal(),
                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)("div", {
                                                    className: "settings__modal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("p", {
                                                            className: "settings__modal-description",
                                                            children: (0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("common:youExceededOrdersLimitDescription")
                                                        }),
                                                        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("div", {
                                                            className: "settings__modal-actions",
                                                            children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "button--main button--delete button--link",
                                                                children: /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $0e6a7be968c19910$export$a6c7ac8248d6e38a), {
                                                                    to: `${(0, $402ff3f88b55a2c2$export$cd891b82501bb412).settings.path}/payment-and-subscription`,
                                                                    children: (0, $4402d286da3fd0cc$export$2e2bcd8739ae039).t("settings:paymentsSubscriptions")
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            this.state.isCreateANewSegmentOpen && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $789ef595f3f8fe07$export$2e2bcd8739ae039), {
                                                toggleCreateANewSegment: this.toggleCreateANewSegment,
                                                segment: this.state.editingSegment
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !this.state.user && /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $9c6daf615c3e9102$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        });
    }
}
const $0f970435ead841e3$var$rootDiv = document.getElementById("root");
const $0f970435ead841e3$var$app = (0, $b4edf43dc2c2ee5a$export$882461b6382ed46c)($0f970435ead841e3$var$rootDiv);
$0f970435ead841e3$var$app.render(/*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsxs)((0, $ecbd83510a1ff561$exports.Fragment), {
    children: [
        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)($0f970435ead841e3$var$App, {}),
        /*#__PURE__*/ (0, $ecbd83510a1ff561$exports.jsx)((0, $d41f521f78665649$export$f2815235e76a62b9), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            newestOnTop: true,
            closeOnClick: true,
            rtl: false,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
            theme: "colored"
        })
    ]
}));
// initialize the Firebase performance service.
(0, $78e42c400dda596b$export$447fa9cb0c946c58).initPerformance();

})();
//# sourceMappingURL=html.9a25a993.js.map
